export const CURRENCY_CODE_BY_NUMBER = new Map(
  Object.entries({
    971: 'AFN',
    8: 'ALL',
    978: 'EUR',
    12: 'DZD',
    973: 'AOA',
    951: 'XCD',
    682: 'SAR',
    32: 'ARS',
    51: 'AMD',
    533: 'AWG',
    36: 'AUD',
    944: 'AZN',
    44: 'BSD',
    50: 'BDT',
    52: 'BBD',
    48: 'BHD',
    84: 'BZD',
    952: 'XOF',
    60: 'BMD',
    974: 'BYR',
    104: 'MMK',
    68: 'BOB',
    984: 'BOV',
    840: 'USD',
    977: 'BAM',
    72: 'BWP',
    986: 'BRL',
    96: 'BND',
    975: 'BGN',
    108: 'BIF',
    64: 'BTN',
    356: 'INR',
    132: 'CVE',
    116: 'KHR',
    950: 'XAF',
    124: 'CAD',
    990: 'CLF',
    152: 'CLP',
    156: 'CNY',
    170: 'COP',
    970: 'COU',
    174: 'KMF',
    976: 'CDF',
    188: 'CRC',
    191: 'HRK',
    931: 'CUC',
    192: 'CUP',
    532: 'ANG',
    208: 'DKK',
    818: 'EGP',
    222: 'SVC',
    784: 'AED',
    232: 'ERN',
    997: 'USN',
    230: 'ETB',
    242: 'FJD',
    608: 'PHP',
    960: 'XDR',
    270: 'GMD',
    981: 'GEL',
    936: 'GHS',
    292: 'GIP',
    320: 'GTQ',
    826: 'GBP',
    324: 'GNF',
    328: 'GYD',
    332: 'HTG',
    340: 'HNL',
    344: 'HKD',
    348: 'HUF',
    360: 'IDR',
    368: 'IQD',
    578: 'NOK',
    352: 'ISK',
    136: 'KYD',
    554: 'NZD',
    238: 'FKP',
    90: 'SBD',
    376: 'ILS',
    388: 'JMD',
    392: 'JPY',
    400: 'JOD',
    398: 'KZT',
    404: 'KES',
    417: 'KGS',
    414: 'KWD',
    426: 'LSL',
    710: 'ZAR',
    430: 'LRD',
    434: 'LYD',
    756: 'CHF',
    422: 'LBP',
    446: 'MOP',
    807: 'MKD',
    969: 'MGA',
    458: 'MYR',
    454: 'MWK',
    462: 'MVR',
    504: 'MAD',
    480: 'MUR',
    478: 'MRO',
    496: 'MNT',
    943: 'MZN',
    484: 'MXN',
    979: 'MXV',
    516: 'NAD',
    524: 'NPR',
    558: 'NIO',
    566: 'NGN',
    512: 'OMR',
    965: 'XUA',
    586: 'PKR',
    590: 'PAB',
    598: 'PGK',
    600: 'PYG',
    604: 'PEN',
    953: 'XPF',
    985: 'PLN',
    634: 'QAR',
    418: 'LAK',
    937: 'VEF',
    203: 'CZK',
    410: 'KRW',
    498: 'MDL',
    408: 'KPW',
    214: 'DOP',
    364: 'IRR',
    834: 'TZS',
    760: 'SYP',
    646: 'RWF',
    946: 'RON',
    643: 'RUB',
    882: 'WST',
    678: 'STD',
    654: 'SHP',
    941: 'RSD',
    690: 'SCR',
    694: 'SLL',
    702: 'SGD',
    994: 'XSU',
    706: 'SOS',
    144: 'LKR',
    748: 'SZL',
    938: 'SDG',
    728: 'SSP',
    752: 'SEK',
    947: 'CHE',
    948: 'CHW',
    968: 'SRD',
    764: 'THB',
    901: 'TWD',
    972: 'TJS',
    776: 'TOP',
    780: 'TTD',
    934: 'TMT',
    949: 'TRY',
    788: 'TND',
    800: 'UGX',
    980: 'UAH',
    940: 'UYI',
    858: 'UYU',
    860: 'UZS',
    548: 'VUV',
    704: 'VND',
    886: 'YER',
    262: 'DJF',
    967: 'ZMW',
    932: 'ZWL',
  })
);

export enum CurrencyCode {
  AED = 'United Arab Emirates Dirham',
  AFN = 'Afghanistan Afghani',
  ALL = 'Albania Lek',
  AMD = 'Armenia Dram',
  ANG = 'Netherlands Antilles Guilder',
  AOA = 'Angola Kwanza',
  ARS = 'Argentina Peso',
  AUD = 'Australia Dollar',
  AWG = 'Aruba Guilder',
  AZN = 'Azerbaijan New Manat',
  BAM = 'Bosnia and Herzegovina Convertible Marka',
  BBD = 'Barbados Dollar',
  BDT = 'Bangladesh Taka',
  BGN = 'Bulgaria Lev',
  BHD = 'Bahrain Dinar',
  BIF = 'Burundi Franc',
  BMD = 'Bermuda Dollar',
  BND = 'Brunei Darussalam Dollar',
  BOB = 'Bolivia Bolíviano',
  BRL = 'Brazil Real',
  BSD = 'Bahamas Dollar',
  BTN = 'Bhutan Ngultrum',
  BWP = 'Botswana Pula',
  BYR = 'Belarus Ruble',
  BZD = 'Belize Dollar',
  CAD = 'Canada Dollar',
  CDF = 'Congo/Kinshasa Franc',
  CHF = 'Switzerland Franc',
  CLP = 'Chile Peso',
  CNY = 'China Yuan Renminbi',
  COP = 'Colombia Peso',
  CRC = 'Costa Rica Colon',
  CUC = 'Cuba Convertible Peso',
  CUP = 'Cuba Peso',
  CVE = 'Cape Verde Escudo',
  CZK = 'Czech Republic Koruna',
  DJF = 'Djibouti Franc',
  DKK = 'Denmark Krone',
  DOP = 'Dominican Republic Peso',
  DZD = 'Algeria Dinar',
  EGP = 'Egypt Pound',
  ERN = 'Eritrea Nakfa',
  ETB = 'Ethiopia Birr',
  EUR = 'Euro Member Countries',
  FJD = 'Fiji Dollar',
  FKP = 'Falkland Islands  = Malvinas Pound',
  GBP = 'United Kingdom Pound',
  GEL = 'Georgia Lari',
  GGP = 'Guernsey Pound',
  GHS = 'Ghana Cedi',
  GIP = 'Gibraltar Pound',
  GMD = 'Gambia Dalasi',
  GNF = 'Guinea Franc',
  GTQ = 'Guatemala Quetzal',
  GYD = 'Guyana Dollar',
  HKD = 'Hong Kong Dollar',
  HNL = 'Honduras Lempira',
  HRK = 'Croatia Kuna',
  HTG = 'Haiti Gourde',
  HUF = 'Hungary Forint',
  IDR = 'Indonesia Rupiah',
  ILS = 'Israel Shekel',
  IMP = 'Isle of Man Pound',
  INR = 'India Rupee',
  IQD = 'Iraq Dinar',
  IRR = 'Iran Rial',
  ISK = 'Iceland Krona',
  JEP = 'Jersey Pound',
  JMD = 'Jamaica Dollar',
  JOD = 'Jordan Dinar',
  JPY = 'Japan Yen',
  KES = 'Kenya Shilling',
  KGS = 'Kyrgyzstan Som',
  KHR = 'Cambodia Riel',
  KMF = 'Comoros Franc',
  KPW = 'Korea  = North Won',
  KRW = 'Korea  = South Won',
  KWD = 'Kuwait Dinar',
  KYD = 'Cayman Islands Dollar',
  KZT = 'Kazakhstan Tenge',
  LAK = 'Laos Kip',
  LBP = 'Lebanon Pound',
  LKR = 'Sri Lanka Rupee',
  LRD = 'Liberia Dollar',
  LSL = 'Lesotho Loti',
  LYD = 'Libya Dinar',
  MAD = 'Morocco Dirham',
  MDL = 'Moldova Leu',
  MGA = 'Madagascar Ariary',
  MKD = 'Macedonia Denar',
  MMK = 'Myanmar  = Burma Kyat',
  MNT = 'Mongolia Tughrik',
  MOP = 'Macau Pataca',
  MRO = 'Mauritania Ouguiya',
  MUR = 'Mauritius Rupee',
  MVR = 'Maldives  = Maldive Islands Rufiyaa',
  MWK = 'Malawi Kwacha',
  MXN = 'Mexico Peso',
  MYR = 'Malaysia Ringgit',
  MZN = 'Mozambique Metical',
  NAD = 'Namibia Dollar',
  NGN = 'Nigeria Naira',
  NIO = 'Nicaragua Cordoba',
  NOK = 'Norway Krone',
  NPR = 'Nepal Rupee',
  NZD = 'New Zealand Dollar',
  OMR = 'Oman Rial',
  PAB = 'Panama Balboa',
  PEN = 'Peru Sol',
  PGK = 'Papua New Guinea Kina',
  PHP = 'Philippines Peso',
  PKR = 'Pakistan Rupee',
  PLN = 'Poland Zloty',
  PYG = 'Paraguay Guarani',
  QAR = 'Qatar Riyal',
  RON = 'Romania New Leu',
  RSD = 'Serbia Dinar',
  RUB = 'Russia Ruble',
  RWF = 'Rwanda Franc',
  SAR = 'Saudi Arabia Riyal',
  SBD = 'Solomon Islands Dollar',
  SCR = 'Seychelles Rupee',
  SDG = 'Sudan Pound',
  SEK = 'Sweden Krona',
  SGD = 'Singapore Dollar',
  SHP = 'Saint Helena Pound',
  SLL = 'Sierra Leone Leone',
  SOS = 'Somalia Shilling',
  SPL = 'Seborga Luigino',
  SRD = 'Suriname Dollar',
  STD = 'São Tomé and Príncipe Dobra',
  SVC = 'El Salvador Colon',
  SYP = 'Syria Pound',
  SZL = 'Swaziland Lilangeni',
  THB = 'Thailand Baht',
  TJS = 'Tajikistan Somoni',
  TMT = 'Turkmenistan Manat',
  TND = 'Tunisia Dinar',
  TOP = "Tonga Pa'anga",
  TRY = 'Turkey Lira',
  TTD = 'Trinidad and Tobago Dollar',
  TVD = 'Tuvalu Dollar',
  TWD = 'Taiwan New Dollar',
  TZS = 'Tanzania Shilling',
  UAH = 'Ukraine Hryvnia',
  UGX = 'Uganda Shilling',
  USD = 'United States Dollar',
  UYU = 'Uruguay Peso',
  UZS = 'Uzbekistan Som',
  VEF = 'Venezuela Bolivar',
  VND = 'Viet Nam Dong',
  VUV = 'Vanuatu Vatu',
  WST = 'Samoa Tala',
  XAF = 'Communauté Financière Africaine  = BEAC CFA Franc BEAC',
  XCD = 'East Caribbean Dollar',
  XDR = 'International Monetary Fund  = IMF Special Drawing Rights',
  XOF = 'Communauté Financière Africaine  = BCEAO Franc',
  XPF = 'Comptoirs Français du Pacifique  = CFP Franc',
  YER = 'Yemen Rial',
  ZAR = 'South Africa Rand',
  ZMW = 'Zambia Kwacha',
  ZWD = 'Zimbabwe Dollar',
}

export const EXCLUDED_COUNTRIES = [
  'AFG',
  'ALB',
  'DZA',
  'AND',
  'AGO',
  'ATG',
  'ARM',
  'AUT',
  'AZE',
  'BHS',
  'BHR',
  'BGD',
  'BRB',
  'BLR',
  'BEL',
  'BLZ',
  'BEN',
  'BTN',
  'BIH',
  'BWA',
  'BRN',
  'BGR',
  'BFA',
  'BDI',
  'CIV',
  'HRV',
  'CYP',
  'CZE',
  'DNK',
  'DJI',
  'DMA',
  'TLS',
  'EGY',
  'GNQ',
  'ERI',
  'EST',
  'SWZ',
  'ETH',
  'FJI',
  'FIN',
  'GAB',
  'GMB',
  'GEO',
  'GHA',
  'GRC',
  'GRD',
  'GIN',
  'GNB',
  'GUY',
  'HTI',
  'HUN',
  'ISL',
  'IDN',
  'IRN',
  'IRQ',
  'IRL',
  'ISR',
  'JAM',
  'JOR',
  'KAZ',
  'KEN',
  'KIR',
  'PRK',
  'KWT',
  'KGZ',
  'LAO',
  'LVA',
  'LBN',
  'LSO',
  'LBR',
  'LBY',
  'LIE',
  'LTU',
  'LUX',
  'MKD',
  'MDG',
  'MWI',
  'MYS',
  'MDV',
  'MLI',
  'MLT',
  'MHL',
  'MRT',
  'MUS',
  'FSM',
  'MDA',
  'MCO',
  'MNG',
  'MNE',
  'MAR',
  'MOZ',
  'MMR',
  'NAM',
  'NRU',
  'NPL',
  'NLD',
  'NZL',
  'NER',
  'NGA',
  'NOR',
  'OMN',
  'PAK',
  'PLW',
  'PNG',
  'PHL',
  'POL',
  'QAT',
  'ROU',
  'RUS',
  'RWA',
  'KNA',
  'LCA',
  'VCT',
  'WSM',
  'SMR',
  'STP',
  'SAU',
  'SEN',
  'SRB',
  'SYC',
  'SLE',
  'SGP',
  'SVK',
  'SVN',
  'SLB',
  'SOM',
  'ZAF',
  'SSD',
  'LKA',
  'SDN',
  'SSD',
  'SUR',
  'SWE',
  'CHE',
  'SYR',
  'TWN',
  'TJK',
  'TZA',
  'THA',
  'TGO',
  'TON',
  'TTO',
  'TUN',
  'TKM',
  'TUV',
  'UGA',
  'UKR',
  'ARE',
  'UZB',
  'VUT',
  'VNM',
  'YEM',
  'ZMB',
  'ZWE',
];

export const CARD_STATE_TO_HUMAN_TEXT = {
  CREATED: 'Creada',
  ACTIVE: 'Activa',
  SUSPENDED: 'Suspendida',
  BLOCKED: 'Bloqueada',
  EMBOSSED: 'Embozada',
  STOLEN: 'Robada',
  UNNAMED: 'Innominada'
};

export const CARD_TYPE_TO_HUMAN_TEXT = {
  VIRTUAL: 'Virtual',
  PHYSICAL: 'Fisica',
};

export const USAGE_LIMITS_STATES = {
  'ALLOWED': 'Permitido',
  'REJECTED': 'Rechazado',
  'UNDEFINED': ' Indefinido',
  'FORBIDDEN': 'Prohibido'
}

export const CARD_STATE_REASONS_TO_HUMAN_TEXT = {
  CARD_HOLDER_INTERNAL_REASON: 'Razon interna de titular',
  ISSUER_INTERNAL_REASON: 'Razon interna de issuer',
  FRAUDULENT: 'Fraude',
  STOLEN: 'Robo',
  ACTIVE: 'Activa',
};

export enum RealmRoles {
  BalanceRead = 'balance.read',
  BalanceFundingWrite = 'balance-funding.write',
  BalanceSettlementRead = 'balance-settlement.read',
  CardsAllRead = 'cards-all.read',
  CardsAllWrite = 'cards-all.write',
  CardHolderAllRead = 'cardholder-all.read',
  CardHolderAllWrite = 'cardholder-all.write',
  ExporterAllRead = 'exporter-all.read',
  CurrencyExchangeAllRead = 'currency-exchange-all.read',
  CurrencyExchangeAllWrite = 'currency-exchange-all.write',
  UsersAllRead = 'view-users',
  UsersAllWrite = 'manage-users',
  GroupsAllRead = 'view-groups',
  GroupsAllWrite = 'query-groups',
  ContactCenter = 'contact_center.read',
  RiskManagement = 'risk_managment.read',
  IssuerImpersonate = 'issuer_impersonate.read',
  CardsUnnamedRead = 'cards-unnamed.read',
  CardsUnnamedWrite = 'cards-unnamed.write',
  BulkLoadWrite = 'bulk_load.write',
  BulkLoadRead = 'bulk_load.read',
  CardProductRead = 'card_product.read',
  CardProductWrite = 'card_product.write',
  CardAffinityGroupRead = 'affinity-group.read',
  CardAffinityGroupWrite = 'affinity-group.write',
  CardInformationRead = "cards-information.read",
  UsageLimitsRead = "usage-limits.read",
  UsageLimitsWrite = "usage-limits.write",
  TransactionAdjustmentRead = "transaction-adjustment.read",
  TransactionAdjustmentWrite = "transaction-adjustment.write",
  TransactionClaimsRead = "transaction-claim.read",
  TransactionClaimsWrite = "transaction-claim.write",
  TransactionClaimsManagement = "transaction-management.write",
  DashboardRead = "dashboard.read"
}

export const StatesByCountry = {
  ARG: {
    'AR-B': 'Buenos Aires',
    'AR-C': 'Capital Federal',
    'AR-K': 'Catamarca',
    'AR-H': 'Chaco',
    'AR-U': 'Chubut',
    'AR-W': 'Corrientes',
    'AR-X': 'Córdoba',
    'AR-E': 'Entre Ríos',
    'AR-P': 'Formosa',
    'AR-Y': 'Jujuy',
    'AR-L': 'La Pampa',
    'AR-F': 'La Rioja',
    'AR-M': 'Mendoza',
    'AR-N': 'Misiones',
    'AR-Q': 'Neuquén',
    'AR-R': 'Río Negro',
    'AR-A': 'Salta',
    'AR-J': 'San Juan',
    'AR-D': 'San Luis',
    'AR-Z': 'Santa Cruz',
    'AR-S': 'Santa Fe',
    'AR-G': 'Santiago del Estero',
    'AR-V': 'Tierra del Fuego',
    'AR-T': 'Tucumán',
  },
  AUS: {
    'AU-ACT': 'Aust Capit Territory',
    'AU-NSW': 'New South Wales',
    'AU-NT': 'Northern Territory',
    'AU-QLD': 'Queensland',
    'AU-SA': 'South Australia',
    'AU-TAS': 'Tasmania',
    'AU-VIC': 'Victoria',
    'AU-WA': 'Western Australia',
  },
  BOL: {
    'BO-B': 'Beni',
    'BO-H': 'Chuquisaca',
    'BO-C': 'Cochabamba',
    'BO-L': 'La Paz',
    'BO-O': 'Oruro',
    'BO-N': 'Pando',
    'BO-P': 'Potosí',
    'BO-S': 'Santa Cruz',
    'BO-T': 'Tarija',
  },
  BRA: {
    'BR-AC': 'Acre',
    'BR-AL': 'Alagoas',
    'BR-AP': 'Amapá',
    'BR-AM': 'Amazonas',
    'BR-BA': 'Bahia',
    'BR-CE': 'Ceará',
    'BR-DF': 'Distrito Federal',
    'BR-ES': 'Espírito Santo',
    'BR-GO': 'Goiás',
    'BR-MA': 'Maranhão',
    'BR-MT': 'Mato Grosso',
    'BR-MS': 'Mato Grosso do Sul',
    'BR-MG': 'Minas Gerais',
    'BR-PR': 'Paraná',
    'BR-PB': 'Paraíba',
    'BR-PA': 'Pará',
    'BR-PE': 'Pernambuco',
    'BR-PI': 'Piauí',
    'BR-RN': 'Rio Grande do Norte',
    'BR-RS': 'Rio Grande do Sul',
    'BR-RJ': 'Rio de Janeiro',
    'BR-RO': 'Rondônia',
    'BR-RR': 'Roraima',
    'BR-SC': 'Santa Catarina',
    'BR-SE': 'Sergipe',
    'BR-SP': 'São Paulo',
    'BR-TO': 'Tocantins',
  },
  CAN: {
    'CA-AB': 'Alberta',
    'CA-BC': 'British Columbia',
    'CA-MB': 'Manitoba',
    'CA-NB': 'New Brunswick',
    'CA-NL': 'Newfoundland and Lab',
    'CA-NT': 'Northwest Territorie',
    'CA-NS': 'Nova Scotia',
    'CA-NU': 'Nunavut',
    'CA-ON': 'Ontario',
    'CA-PE': 'Prince Edward Island',
    'CA-QC': 'Quebec',
    'CA-YT': 'Yukon',
  },
  CHL: {
    'CL-AI': 'Aysén',
    'CL-AN': 'Antofagasta',
    'CL-AP': 'Arica y Parinacota',
    'CL-AT': 'Atacama',
    'CL-BI': 'Biobío',
    'CL-CO': 'Coquimbo',
    'CL-AR': 'La Araucanía',
    'CL-LI': "Libertador B. O'Higgins",
    'CL-LL': 'Los Lagos',
    'CL-LR': 'Los Ríos',
    'CL-MA': 'Magallanes',
    'CL-ML': 'Maule',
    'CL-RM': 'RM (Metropolitana)',
    'CL-TA': 'Tarapacá',
    'CL-VS': 'Valparaíso',
    'CL-NB': 'Ñuble',
  },
  CHN: {
    'CN-AH': 'Anhui',
    'CN-BJ': 'Beijing',
    'CN-CQ': 'Chongqing',
    'CN-FJ': 'Fujian',
    'CN-GS': 'Gansu',
    'CN-GD': 'Guangdong',
    'CN-GX': 'Guangxi',
    'CN-GZ': 'Guizhou',
    'CN-HI': 'Hainan',
    'CN-HE': 'Hebei',
    'CN-HL': 'Heilongjiang',
    'CN-HA': 'Henan',
    'CN-HB': 'Hubei',
    'CN-HN': 'Hunan',
    'CN-NM': 'Inner Mongolia',
    'CN-JS': 'Jiangsu',
    'CN-JX': 'Jiangxi',
    'CN-JL': 'Jilin',
    'CN-LN': 'Liaoning',
    'CN-NX': 'Ningxia',
    'CN-QH': 'Qinghai',
    'CN-SN': 'Shaanxi',
    'CN-SD': 'Shandong',
    'CN-SH': 'Shanghai',
    'CN-SX': 'Shanxi',
    'CN-SC': 'Sichuan',
    'CN-TJ': 'Tianjin',
    'CN-XJ': 'Xinjiang',
    'CN-XZ': 'Xizang',
    'CN-YN': 'Yunnan',
    'CN-ZJ': 'Zhejiang',
  },
  COL: {
    'CO-AMA': 'Amazonas',
    'CO-ANT': 'Antioquia',
    'CO-ARA': 'Arauca',
    'CO-ATL': 'Atlantico',
    'CO-DC': 'Bogotá D.C.',
    'CO-BOL': 'Bolivar',
    'CO-BOY': 'Boyaca',
    'CO-CAL': 'Caldas',
    'CO-CAQ': 'Caqueta',
    'CO-CAS': 'Casanare',
    'CO-CAU': 'Cauca',
    'CO-CES': 'Cesar',
    'CO-CHO': 'Choco',
    'CO-CUN': 'Cundinamarca',
    'CO-COR': 'Córdoba',
    'CO-GUA': 'Guainía',
    'CO-LAG': 'Guajira',
    'CO-GUV': 'Guaviare',
    'CO-HUI': 'Huila',
    'CO-MAG': 'Magdalena',
    'CO-MET': 'Meta',
    'CO-NAR': 'Nariño',
    'CO-NSA': 'Norte De Santander',
    'CO-PUT': 'Putumayo',
    'CO-QUI': 'Quindio',
    'CO-RIS': 'Risaralda',
    'CO-SAP': 'San Andres y Providencia',
    'CO-SAN': 'Santander',
    'CO-SUC': 'Sucre',
    'CO-TOL': 'Tolima',
    'CO-VAC': 'Valle Del Cauca',
    'CO-VAU': 'Vaupes',
    'CO-VID': 'Vichada',
  },
  CRI: {
    'CR-A': 'Alajuela',
    'CR-C': 'Cartago',
    'CR-G': 'Guanacaste',
    'CR-H': 'Heredia',
    'CR-L': 'Limón',
    'CR-P': 'Puntarenas',
    'CR-SJ': 'San José',
  },
  CUB: {
    'CU-15': 'Artemisa',
    'CU-09': 'Camagüey',
    'CU-08': 'Ciego de Ávila',
    'CU-06': 'Cienfuegos',
    'CU-12': 'Granma',
    'CU-14': 'Guantánamo',
    'CU-11': 'Holguín',
    'CU-99': 'Isla de la Juventud',
    'CU-02': 'La Habana',
    'CU-10': 'Las Tunas',
    'CU-04': 'Matanzas',
    'CU-16': 'Mayabeque',
    'CU-01': 'Pinar del Río',
    'CU-07': 'Sancti Spíritus',
    'CU-13': 'Santiago de Cuba',
    'CU-05': 'Villa Clara',
  },
  ECU: {
    'EC-A': 'Azuay',
    'EC-B': 'Bolívar',
    'EC-C': 'Carchi',
    'EC-F': 'Cañar',
    'EC-H': 'Chimborazo',
    'EC-X': 'Cotopaxi',
    'EC-O': 'El Oro',
    'EC-E': 'Esmeraldas',
    'EC-W': 'Galápagos',
    'EC-YQ': 'Guayaquil',
    'EC-G': 'Guayas',
    'EC-I': 'Imbabura',
    'EC-L': 'Loja',
    'EC-R': 'Los Ríos',
    'EC-M': 'Manabí',
    'EC-S': 'Morona Santiago',
    'EC-N': 'Napo',
    'EC-D': 'Orellana',
    'EC-Y': 'Pastaza',
    'EC-P': 'Pichincha ( Quito )',
    'EC-Q': 'Quito',
    'EC-SE': 'Santa Elena',
    'EC-SD': 'Santo Domingo de los Tsáchilas',
    'EC-U': 'Sucumbíos',
    'EC-T': 'Tungurahua',
    'EC-Z': 'Zamora Chinchipe',
  },
  SLV: {
    'SV-AH': 'Ahuachapán',
    'SV-CA': 'Cabañas',
    'SV-CH': 'Chalatenango',
    'SV-CU': 'Cuscatlán',
    'SV-LI': 'La Libertad',
    'SV-PA': 'La Paz',
    'SV-UN': 'La Unión',
    'SV-MO': 'Morazán',
    'SV-SM': 'San Miguel',
    'SV-SS': 'San Salvador',
    'SV-SV': 'San Vicente',
    'SV-SA': 'Santa Ana',
    'SV-SO': 'Sonsonate',
    'SV-US': 'Usulután',
  },
  FRA: {
    'FR-PAC': 'Prov-Alpes-Côte-d’Az',
    'FR-BFC': 'Bourgogne-Franche-Co',
    'FR-01': 'Ain',
    'FR-02': 'Aisne',
    'FR-03': 'Allier',
    'FR-04': 'Alpes-de-Haute-Prov',
    'FR-05': 'Hautes-Alpes',
    'FR-06': 'Alpes-Maritimes',
    'FR-07': 'Ardèche',
    'FR-08': 'Ardennes',
    'FR-09': 'Ariège',
    'FR-10': 'Aube',
    'FR-11': 'Aude',
    'FR-12': 'Aveyron',
    'FR-13': 'Bouches-du-Rhône',
    'FR-14': 'Calvados',
    'FR-15': 'Cantal',
    'FR-16': 'Charente',
    'FR-17': 'Charente-Maritime',
    'FR-18': 'Cher',
    'FR-19': 'Corrèze',
    'FR-21': "Côte-d'Or",
    'FR-22': "Côtes-d'Armor",
    'FR-23': 'Creuse',
    'FR-24': 'Dordogne',
    'FR-25': 'Doubs',
    'FR-26': 'Drôme',
    'FR-27': 'Eure',
    'FR-28': 'Eure-et-Loir',
    'FR-29': 'Finistère',
    'FR-30': 'Gard',
    'FR-31': 'Haute-Garonne',
    'FR-32': 'Gers',
    'FR-33': 'Gironde',
    'FR-34': 'Hérault',
    'FR-35': 'Ille-et-Vilaine',
    'FR-36': 'Indre',
    'FR-37': 'Indre-et-Loire',
    'FR-38': 'Isère',
    'FR-39': 'Jura',
    'FR-40': 'Landes',
    'FR-41': 'Loir-et-Cher',
    'FR-42': 'Loire',
    'FR-43': 'Haute-Loire',
    'FR-44': 'Loire-Atlantique',
    'FR-45': 'Loiret',
    'FR-46': 'Lot',
    'FR-47': 'Lot-et-Garonne',
    'FR-48': 'Lozère',
    'FR-49': 'Maine-et-Loire',
    'FR-50': 'Manche',
    'FR-51': 'Marne',
    'FR-52': 'Haute-Marne',
    'FR-53': 'Mayenne',
    'FR-54': 'Meurthe-et-Moselle',
    'FR-55': 'Meuse',
    'FR-56': 'Morbihan',
    'FR-57': 'Moselle',
    'FR-58': 'Nièvre',
    'FR-59': 'Nord',
    'FR-60': 'Oise',
    'FR-61': 'Orne',
    'FR-62': 'Pas-de-Calais',
    'FR-63': 'Puy-de-Dôme',
    'FR-64': 'Pyrénées-Atlantiques',
    'FR-65': 'Hautes-Pyrénées',
    'FR-66': 'Pyrénées-Orientales',
    'FR-67': 'Bas-Rhin',
    'FR-68': 'Haut-Rhin',
    'FR-69': 'Rhône',
    'FR-70': 'Haute-Saône',
    'FR-71': 'Saône-et-Loire',
    'FR-72': 'Sarthe',
    'FR-73': 'Savoie',
    'FR-74': 'Haute-Savoie',
    'FR-75': 'Paris',
    'FR-76': 'Seine-Maritime',
    'FR-77': 'Seine-et-Marne',
    'FR-78': 'Yvelines',
    'FR-79': 'Deux-Sèvres',
    'FR-80': 'Somme',
    'FR-81': 'Tarn',
    'FR-82': 'Tarn-et-Garonne',
    'FR-83': 'Var',
    'FR-84': 'Vaucluse',
    'FR-85': 'Vendée',
    'FR-86': 'Vienne',
    'FR-87': 'Haute-Vienne',
    'FR-88': 'Vosges',
    'FR-89': 'Yonne',
    'FR-90': 'Territoire de Belf',
    'FR-91': 'Essonne',
    'FR-92': 'Hauts-de-Seine',
    'FR-93': 'Seine-Saint-Denis',
    'FR-94': 'Val-de-Marne',
    'FR-ARA': 'Auvergne-Rhône-Alpes',
    'FR-BL': 'Saint-Barthélemy',
    'FR-BRE': 'Bretagne',
    'FR-COR': 'Corse',
    'FR-CVL': 'Centre-Val de Loire',
    'FR-GES': 'Grand-Est',
    'FR-GF': 'Guyane',
    'FR-HDF': 'Hauts-de-France',
    'FR-IDF': 'Île-de-France',
    'FR-NAQ': 'Nouvelle-Aquitaine',
    'FR-NOR': 'Normandie',
    'FR-OCC': 'Occitanie',
    'FR-95': "Val-d'Oise",
  },
  DEU: {
    'DE-NW': 'North Rhine West',
    'DE-BW': 'Baden-Wurtemberg',
    'DE-BY': 'Baviera',
    'DE-BB': 'Brandeburgo',
    'DE-HB': 'Bremen',
    'DE-HH': 'Hamburgo',
    'DE-HE': 'Hesse',
    'DE-NI': 'Lower Saxony',
    'DE-MV': 'Mecklenburg-Vorpo',
    'DE-RP': 'Rhineland-Palatinate',
    'DE-SL': 'Saarland',
    'DE-SN': 'Saxony',
    'DE-ST': 'Sajonia-Anhalt',
    'DE-SH': 'Schleswig-Holstein',
    'DE-TH': 'Thuringia',
  },
  GBR: {
    'GB-ENG': 'England',
    'GB-NIR': 'Northern Ireland',
    'GB-SCT': 'Scotland',
    'GB-WLS': 'Wales',
  },
  GTM: {
    'GT-AV': 'Alta Verapaz',
    'GT-BV': 'Baja Verapaz',
    'GT-CM': 'Chimaltenango',
    'GT-CQ': 'Chiquimula',
    'GT-PR': 'El Progreso',
    'GT-ES': 'Escuintla',
    'GT-GU': 'Guatemala',
    'GT-HU': 'Huehuetenango',
    'GT-IZ': 'Izabal',
    'GT-JA': 'Jalapa',
    'GT-JU': 'Jutiapa',
    'GT-PE': 'Petén',
    'GT-QZ': 'Quetzaltenango',
    'GT-QC': 'Quiché',
    'GT-RE': 'Retalhuleu',
    'GT-SA': 'Sacatepéquez',
    'GT-SM': 'San Marcos',
    'GT-SR': 'Santa Rosa',
    'GT-SO': 'Sololá',
    'GT-SU': 'Suchitepéquez',
    'GT-TO': 'Totonicapán',
    'GT-ZA': 'Zacapa',
  },
  HND: {
    'HN-AT': 'Atlántida',
    'HN-CH': 'Choluteca',
    'HN-CL': 'Colón',
    'HN-CM': 'Comayagua',
    'HN-CP': 'Copán',
    'HN-CR': 'Cortés',
    'HN-EP': 'El Paraíso',
    'HN-FM': 'Francisco Morazán',
    'HN-GD': 'Gracias a Dios',
    'HN-IN': 'Intibucá',
    'HN-IB': 'Islas de la Bahía',
    'HN-LP': 'La Paz',
    'HN-LE': 'Lempira',
    'HN-OC': 'Ocotepeque',
    'HN-OL': 'Olancho',
    'HN-SB': 'Santa Bárbara',
    'HN-VA': 'Valle',
    'HN-YO': 'Yoro',
  },
  HKG: {
    'HK-HK': 'Hong Kong',
  },
  IND: {
    'IN-AP': 'Andhra Pradesh',
    'IN-AR': 'Arunachal Pradesh',
    'IN-AS': 'Assam',
    'IN-BR': 'Bihar',
    'IN-CH': 'Chandigarh',
    'IN-CT': 'Chhattisgarh',
    'IN-DN': 'Dadra And Nagar Haveli',
    'IN-DL': 'Delhi',
    'IN-GA': 'Goa',
    'IN-GJ': 'Gujarat',
    'IN-HR': 'Haryana',
    'IN-HP': 'Himachal Pradesh',
    'IN-AN': 'Andaman And Nicobar Islands',
    'IN-JK': 'Jammu And Kashmir',
    'IN-JH': 'Jharkhand',
    'IN-KA': 'Karnataka',
    'IN-KL': 'Kerala',
    'IN-MP': 'Madhya Pradesh',
    'IN-MH': 'Maharashtra',
    'IN-MN': 'Manipur',
    'IN-ML': 'Meghalaya',
    'IN-MZ': 'Mizoram',
    'IN-NL': 'Nagaland',
    'IN-OR': 'Odisha',
    'IN-PY': 'Puducherry',
    'IN-PB': 'Punjab',
    'IN-RJ': 'Rajasthan',
    'IN-TN': 'Tamil Nadu',
    'IN-TG': 'Telangana',
    'IN-TR': 'Tripura',
    'IN-UP': 'Uttar Pradesh',
    'IN-UT': 'Uttarakhand',
    'IN-WB': 'West Bengal',
  },
  ITA: {
    'IT-AG': 'Agrigento',
    'IT-AL': 'Alessandria',
    'IT-AN': 'Ancona',
    'IT-AO': 'Aosta',
    'IT-AR': 'Arezzo',
    'IT-AP': 'Ascoli Piceno',
    'IT-AT': 'Asti',
    'IT-AV': 'Avellino',
    'IT-BA': 'Bari',
    'IT-BL': 'Belluno',
    'IT-BN': 'Benevento',
    'IT-BI': 'Biella',
    'IT-BO': 'Bolonia',
    'IT-BZ': 'Bolzano',
    'IT-BS': 'Brescia',
    'IT-BR': 'Brindisi',
    'IT-BG': 'Bérgamo',
    'IT-CA': 'Cagliari',
    'IT-CL': 'Caltanissetta',
    'IT-CB': 'Campobasso',
    'IT-CI': 'Carbonia-Iglesias',
    'IT-CE': 'Caserta',
    'IT-CT': 'Catania',
    'IT-CZ': 'Catanzaro',
    'IT-CH': 'Chieti',
    'IT-CO': 'Como',
    'IT-CS': 'Cosenza',
    'IT-CR': 'Cremona',
    'IT-KR': 'Crotone',
    'IT-CN': 'Cuneo',
    'IT-EN': 'Enna',
    'IT-FM': 'Fermo',
    'IT-FE': 'Ferrara',
    'IT-FI': 'Florencia',
    'IT-FG': 'Foggia',
    'IT-FO': 'Forlí-Cesena',
    'IT-FR': 'Frosinone',
    'IT-GO': 'Gorizia',
    'IT-GR': 'Grosseto',
    'IT-GE': 'Génova',
    'IT-IM': 'Imperia',
    'IT-IS': 'Isernia',
    'IT-AQ': "L'Aquila",
    'IT-SP': 'La Spezia',
    'IT-LT': 'Latina',
    'IT-LE': 'Lecce',
    'IT-LC': 'Lecco',
    'IT-LI': 'Livorno',
    'IT-LO': 'Lodi',
    'IT-LU': 'Lucca',
    'IT-MC': 'Macerata',
    'IT-MN': 'Mantua',
    'IT-MS': 'Massa-Carrara',
    'IT-MT': 'Matera',
    'IT-VS': 'Medio Campidano',
    'IT-ME': 'Mesina',
    'IT-MI': 'Milán',
    'IT-MO': 'Módena',
    'IT-NO': 'Novara',
    'IT-NU': 'Nuoro',
    'IT-NA': 'Nápoles',
    'IT-OG': 'Ogliastra',
    'IT-OT': 'Olbia-Tempio',
    'IT-OR': 'Oristano',
    'IT-PD': 'Padua',
    'IT-PA': 'Palermo',
    'IT-PR': 'Parma',
    'IT-PV': 'Pavía',
    'IT-PG': 'Perugia',
    'IT-PS': 'Pesaro y Urbino',
    'IT-PE': 'Pescara',
    'IT-PC': 'Piacenza',
    'IT-PI': 'Pisa',
    'IT-PT': 'Pistoia',
    'IT-PN': 'Pordenone',
    'IT-PZ': 'Potenza',
    'IT-PO': 'Prato',
    'IT-RG': 'Ragusa',
    'IT-RE': 'Reggio Emilia',
    'IT-RC': 'Regio de Calabria',
    'IT-RI': 'Rieti',
    'IT-RM': 'Roma',
    'IT-RO': 'Rovigo',
    'IT-RA': 'Rávena',
    'IT-RN': 'Rímini',
    'IT-SA': 'Salerno',
    'IT-SV': 'Savona',
    'IT-SI': 'Siena',
    'IT-SR': 'Siracusa',
    'IT-SO': 'Sondrio',
    'IT-SS': 'Sácer',
    'IT-TA': 'Tarento',
    'IT-TE': 'Teramo',
    'IT-TR': 'Terni',
    'IT-TP': 'Trapani',
    'IT-TN': 'Trento',
    'IT-TV': 'Treviso',
    'IT-TS': 'Trieste',
    'IT-TO': 'Turín',
    'IT-UD': 'Udine',
    'IT-VA': 'Varese',
    'IT-VE': 'Venecia',
    'IT-VB': 'Verbano-Cusio-Ossola',
    'IT-VC': 'Vercelli',
    'IT-VR': 'Verona',
    'IT-VV': 'Vibo Valentia',
    'IT-VI': 'Vicenza',
    'IT-VT': 'Viterbo',
  },
  JPN: {
    'JP-23': 'Aichi',
    'JP-05': 'Akita',
    'JP-02': 'Aomori',
    'JP-12': 'Chiba',
    'JP-38': 'Ehime',
    'JP-18': 'Fukui',
    'JP-40': 'Fukuoka',
    'JP-07': 'Fukushima',
    'JP-21': 'Gifu',
    'JP-10': 'Gunma',
    'JP-34': 'Hiroshima',
    'JP-01': 'Hokkaidō',
    'JP-28': 'Hyōgo',
    'JP-08': 'Ibaraki',
    'JP-17': 'Ishikawa',
    'JP-03': 'Iwate',
    'JP-37': 'Kagawa',
    'JP-46': 'Kagoshima',
    'JP-14': 'Kanagawa',
    'JP-26': 'Kioto',
    'JP-43': 'Kumamoto',
    'JP-39': 'Kōchi',
    'JP-24': 'Mie',
    'JP-04': 'Miyagi',
    'JP-45': 'Miyazaki',
    'JP-20': 'Nagano',
    'JP-42': 'Nagasaki',
    'JP-29': 'Nara',
    'JP-15': 'Niigata',
    'JP-33': 'Okayama',
    'JP-47': 'Okinawa',
    'JP-27': 'Osaka',
    'JP-41': 'Saga',
    'JP-11': 'Saitama',
    'JP-25': 'Shiga',
    'JP-32': 'Shimane',
    'JP-22': 'Shizuoka',
    'JP-09': 'Tochigi',
    'JP-36': 'Tokushima',
    'JP-31': 'Tottori',
    'JP-16': 'Toyama',
    'JP-13': 'Tōkyō',
    'JP-30': 'Wakayama',
    'JP-06': 'Yamagata',
    'JP-35': 'Yamaguchi',
    'JP-19': 'Yamanashi',
    'JP-44': 'Ōita',
  },
  MEX: {
    'MX-AGU': 'Aguascalientes',
    'MX-BCN': 'Baja California',
    'MX-BCS': 'Baja California Sur',
    'MX-CAM': 'Campeche',
    'MX-CHP': 'Chiapas',
    'MX-CHH': 'Chihuahua',
    'MX-COA': 'Coahuila',
    'MX-COL': 'Colima',
    'MX-DIF': 'Distrito Federal',
    'MX-DUR': 'Durango',
    'MX-MEX': 'Estado De México',
    'MX-GUA': 'Guanajuato',
    'MX-GRO': 'Guerrero',
    'MX-HID': 'Hidalgo',
    'MX-JAL': 'Jalisco',
    'MX-MIC': 'Michoacán',
    'MX-MOR': 'Morelos',
    'MX-NAY': 'Nayarit',
    'MX-NLE': 'Nuevo León',
    'MX-OAX': 'Oaxaca',
    'MX-PUE': 'Puebla',
    'MX-QUE': 'Querétaro',
    'MX-ROO': 'Quintana Roo',
    'MX-SLP': 'San Luis Potosí',
    'MX-SIN': 'Sinaloa',
    'MX-SON': 'Sonora',
    'MX-TAB': 'Tabasco',
    'MX-TAM': 'Tamaulipas',
    'MX-TLA': 'Tlaxcala',
    'MX-VER': 'Veracruz',
    'MX-YUC': 'Yucatán',
    'MX-ZAC': 'Zacatecas',
  },
  NIC: {
    'NI-AN': 'Atlántico Norte',
    'NI-AS': 'Atlántico Sur',
    'NI-BO': 'Boaco',
    'NI-CA': 'Carazo',
    'NI-CI': 'Chinandega',
    'NI-CO': 'Chontales',
    'NI-ES': 'Estelí',
    'NI-GR': 'Granada',
    'NI-JI': 'Jinotega',
    'NI-LE': 'León',
    'NI-MD': 'Madriz',
    'NI-MN': 'Managua',
    'NI-MS': 'Masaya',
    'NI-MT': 'Matagalpa',
    'NI-NS': 'Nueva Segovia',
    'NI-RI': 'Rivas',
    'NI-SJ': 'Río San Juan',
  },
  PAN: {
    'PA-1': 'Bocas del Toro',
    'PA-4': 'Chiriquí',
    'PA-2': 'Coclé',
    'PA-3': 'Colón',
    'PA-5': 'Darién',
    'PA-EM': 'Emberá',
    'PA-6': 'Herrera',
    'PA-7': 'Los Santos',
    'PA-NB': 'Ngöbe-Buglé',
    'PA-8': 'Panamá',
    'PA-KY': 'San Blas',
    'PA-9': 'Veraguas',
  },
  PRY: {
    'PY-16': 'Alto Paraguay',
    'PY-10': 'Alto Paraná',
    'PY-13': 'Amambay',
    'PY-ASU': 'Asunción D.C.',
    'PY-19': 'Boquerón',
    'PY-5': 'Caaguazú',
    'PY-6': 'Caazapá',
    'PY-14': 'Canindeyú',
    'PY-11': 'Central',
    'PY-1': 'Concepción',
    'PY-3': 'Cordillera',
    'PY-4': 'Guairá',
    'PY-7': 'Itapúa',
    'PY-8': 'Misiones',
    'PY-9': 'Paraguarí',
    'PY-15': 'Presidente Hayes',
    'PY-2': 'San Pedro',
    'PY-12': 'Ñeembucú',
  },
  PER: {
    'PE-AMA': 'Amazonas',
    'PE-ANC': 'Ancash',
    'PE-APU': 'Apurimac',
    'PE-ARE': 'Arequipa',
    'PE-AYA': 'Ayacucho',
    'PE-CAJ': 'Cajamarca',
    'PE-CUS': 'Cusco',
    'PE-HUV': 'Huancavelica',
    'PE-HUC': 'Huanuco',
    'PE-ICA': 'Ica',
    'PE-JUN': 'Junin',
    'PE-LAL': 'La Libertad',
    'PE-LAM': 'Lambayeque',
    'PE-LMA': 'Lima Metropolitana',
    'PE-LIM': 'Lima Provincias',
    'PE-LOR': 'Loreto',
    'PE-MDD': 'Madre De Dios',
    'PE-MOQ': 'Moquegua',
    'PE-PAS': 'Pasco',
    'PE-PIU': 'Piura',
    'PE-PUN': 'Puno',
    'PE-SAM': 'San Martin',
    'PE-TAC': 'Tacna',
    'PE-TUM': 'Tumbes',
    'PE-UCA': 'Ucayali',
  },
  PRT: {
    'PT-01': 'Aveiro',
    'PT-02': 'Beja',
    'PT-03': 'Braga',
    'PT-04': 'Bragança',
    'PT-05': 'Castelo Branco',
    'PT-06': 'Coimbra',
    'PT-08': 'Faro',
    'PT-09': 'Guarda',
    'PT-30': 'Ilha da Madeira',
    'PT-20': 'Ilhas dos Açores',
    'PT-10': 'Leiria',
    'PT-11': 'Lisboa',
    'PT-12': 'Portalegre',
    'PT-13': 'Porto',
    'PT-14': 'Santarém',
    'PT-15': 'Setúbal',
    'PT-16': 'Viana do Castelo',
    'PT-17': 'Vila Real',
    'PT-18': 'Viseu',
    'PT-07': 'Évora',
  },
  DOM: {
    'DO-02': 'Azua',
    'DO-03': 'Baoruco',
    'DO-04': 'Barahona',
    'DO-05': 'Dajabón',
    'DO-01': 'Distrito Nacional',
    'DO-06': 'Duarte',
    'DO-08': 'El Seibo',
    'DO-07': 'Elías Piña',
    'DO-09': 'Espaillat',
    'DO-30': 'Hato Mayor',
    'DO-10': 'Independencia',
    'DO-11': 'La Altagracia',
    'DO-12': 'La Romana',
    'DO-13': 'La Vega',
    'DO-14': 'María Trinidad Sánchez',
    'DO-28': 'Monseñor Nouel',
    'DO-29': 'Monte Plata',
    'DO-15': 'Montecristi',
    'DO-16': 'Pedernales',
    'DO-17': 'Peravia',
    'DO-18': 'Puerto Plata',
    'DO-19': 'Salcedo',
    'DO-20': 'Samaná',
    'DO-21': 'San Cristóbal',
    'DO-31': 'San José de Ocoa',
    'DO-22': 'San Juan',
    'DO-23': 'San Pedro de Macorís',
    'DO-25': 'Santiago',
    'DO-26': 'Santiago Rodríguez',
    'DO-32': 'Santo Domingo',
    'DO-24': 'Sánchez Ramírez',
    'DO-27': 'Valverde',
  },
  KOR: {
    'KR-26': 'Busan',
    'KR-27': 'Daegu',
    'KR-30': 'Daejeon',
    'KR-42': 'Gangwon',
    'KR-29': 'Gwangju',
    'KR-41': 'Gyeonggi',
    'KR-28': 'Incheon',
    'KR-49': 'Jeju',
    'KR-43': 'North Chungcheong',
    'KR-47': 'North Gyeongsang',
    'KR-45': 'North Jeolla',
    'KR-50': 'Sejong',
    'KR-11': 'Seoul',
    'KR-44': 'South Chungcheong',
    'KR-48': 'South Gyeongsang',
    'KR-46': 'South Jeolla',
    'KR-31': 'Ulsan',
  },
  ESP: {
    'ES-AB': 'Albacete',
    'ES-A': 'Alicante',
    'ES-AL': 'Almería',
    'ES-O': 'Asturias',
    'ES-BA': 'Badajoz',
    'ES-PM': 'Baleares',
    'ES-B': 'Barcelona',
    'ES-BI': 'Bizkaia',
    'ES-BU': 'Burgos',
    'ES-S': 'Cantabria',
    'ES-CS': 'Castellón',
    'ES-CR': 'Ciudad Real',
    'ES-CU': 'Cuenca',
    'ES-CC': 'Cáceres',
    'ES-CA': 'Cádiz',
    'ES-CO': 'Córdoba',
    'ES-GI': 'Gerona',
    'ES-SS': 'Gipuzkoa',
    'ES-GR': 'Granada',
    'ES-GU': 'Guadalajara',
    'ES-H': 'Huelva',
    'ES-HU': 'Huesca',
    'ES-J': 'Jaén',
    'ES-C': 'La Coruña',
    'ES-LO': 'La Rioja',
    'ES-GC': 'Las Palmas',
    'ES-LE': 'León',
    'ES-LU': 'Lugo',
    'ES-L': 'Lérida',
    'ES-M': 'Madrid',
    'ES-MU': 'Murcia',
    'ES-MA': 'Málaga',
    'ES-NA': 'Navarra',
    'ES-OR': 'Orense',
    'ES-P': 'Palencia',
    'ES-PO': 'Pontevedra',
    'ES-SA': 'Salamanca',
    'ES-TF': 'Santa Cruz de Tenerife',
    'ES-SG': 'Segovia',
    'ES-SE': 'Sevilla',
    'ES-SO': 'Soria',
    'ES-T': 'Tarragona',
    'ES-TE': 'Teruel',
    'ES-TO': 'Toledo',
    'ES-V': 'Valencia',
    'ES-VA': 'Valladolid',
    'ES-ZA': 'Zamora',
    'ES-Z': 'Zaragoza',
    'ES-VI': 'Álava',
    'ES-AV': 'Ávila',
  },
  TUR: {
    'TR-01': 'Adana',
    'TR-02': 'Adıyaman',
    'TR-03': 'Afyonkarahisar',
    'TR-68': 'Aksaray',
    'TR-05': 'Amasya',
    'TR-06': 'Ankara',
    'TR-07': 'Antalya',
    'TR-75': 'Ardahan',
    'TR-08': 'Artvin',
    'TR-09': 'Aydın',
    'TR-04': 'Ağrı',
    'TR-10': 'Balıkesir',
    'TR-74': 'Bartın',
    'TR-72': 'Batman',
    'TR-69': 'Bayburt',
    'TR-11': 'Bilecik',
    'TR-12': 'Bingöl',
    'TR-13': 'Bitlis',
    'TR-14': 'Bolu',
    'TR-15': 'Burdur',
    'TR-16': 'Bursa',
    'TR-20': 'Denizli',
    'TR-21': 'Diyarbakır',
    'TR-81': 'Düzce',
    'TR-22': 'Edirne',
    'TR-23': 'Elazığ',
    'TR-24': 'Erzincan',
    'TR-25': 'Erzurum',
    'TR-26': 'Eskişehir',
    'TR-35': 'Esmirna',
    'TR-34': 'Estambul',
    'TR-27': 'Gaziantep',
    'TR-28': 'Giresun',
    'TR-29': 'Gümüşhane',
    'TR-30': 'Hakkâri',
    'TR-31': 'Hatay',
    'TR-32': 'Isparta',
    'TR-76': 'Iğdır',
    'TR-46': 'Kahramanmaraş',
    'TR-78': 'Karabük',
    'TR-70': 'Karaman',
    'TR-36': 'Kars',
    'TR-37': 'Kastamonu',
    'TR-38': 'Kayseri',
    'TR-79': 'Kilis',
    'TR-39': 'Kirklareli',
    'TR-41': 'Kocaeli',
    'TR-42': 'Konya',
    'TR-43': 'Kütahya',
    'TR-71': 'Kırıkkale',
    'TR-40': 'Kırşehir',
    'TR-44': 'Malatya',
    'TR-45': 'Manisa',
    'TR-47': 'Mardin',
    'TR-33': 'Mersin',
    'TR-49': 'Mus',
    'TR-48': 'Muğla',
    'TR-50': 'Nevsehir',
    'TR-51': 'Niğde',
    'TR-52': 'Ordu',
    'TR-80': 'Osmaniye',
    'TR-53': 'Rize',
    'TR-54': 'Sakarya',
    'TR-55': 'Samsun',
    'TR-56': 'Siirt',
    'TR-57': 'Sinope',
    'TR-58': 'Sivas',
    'TR-59': 'Tekirdağ',
    'TR-60': 'Tokat',
    'TR-61': 'Trebisonda',
    'TR-62': 'Tunceli',
    'TR-64': 'Uşak',
    'TR-65': 'Van',
    'TR-77': 'Yalova',
    'TR-66': 'Yozgat',
    'TR-67': 'Zonguldak',
    'TR-17': 'Çanakkale',
    'TR-18': 'Çankiri',
    'TR-19': 'Çorum',
    'TR-63': 'Şanlıurfa',
    'TR-73': 'Şırnak',
  },
  USA: {
    'US-AL': 'Alabama',
    'US-AK': 'Alaska',
    'US-AZ': 'Arizona',
    'US-AR': 'Arkansas',
    'US-CA': 'California',
    'US-CO': 'Colorado',
    'US-CT': 'Connecticut',
    'US-DE': 'Delaware',
    'US-DC': 'District of Columbia',
    'US-FL': 'Florida',
    'US-GA': 'Georgia',
    'US-HI': 'Hawaii',
    'US-ID': 'Idaho',
    'US-IL': 'Illinois',
    'US-IN': 'Indiana',
    'US-IA': 'Iowa',
    'US-KS': 'Kansas',
    'US-KY': 'Kentucky',
    'US-LA': 'Louisiana',
    'US-ME': 'Maine',
    'US-MD': 'Maryland',
    'US-MA': 'Massachusetts',
    'US-MI': 'Michigan',
    'US-MN': 'Minnesota',
    'US-MS': 'Mississippi',
    'US-MO': 'Missouri',
    'US-MT': 'Montana',
    'US-NE': 'Nebraska',
    'US-NV': 'Nevada',
    'US-NH': 'New Hampshire',
    'US-NJ': 'New Jersey',
    'US-NM': 'New Mexico',
    'US-NY': 'New York',
    'US-NC': 'North Carolina',
    'US-ND': 'North Dakota',
    'US-OH': 'Ohio',
    'US-OK': 'Oklahoma',
    'US-OR': 'Oregon',
    'US-PA': 'Pennsylvania',
    'US-PR': 'Puerto Rico',
    'US-RI': 'Rhode Island',
    'US-SC': 'South Carolina',
    'US-SD': 'South Dakota',
    'US-TN': 'Tennessee',
    'US-TX': 'Texas',
    'US-UT': 'Utah',
    'US-VT': 'Vermont',
    'US-VI': 'Virgin Islands',
    'US-VA': 'Virginia',
    'US-WA': 'Washington',
    'US-WV': 'West Virginia',
    'US-WI': 'Wisconsin',
    'US-WY': 'Wyoming',
  },
  URY: {
    'UY-AR': 'Artigas',
    'UY-CA': 'Canelones',
    'UY-CL': 'Cerro Largo',
    'UY-CO': 'Colonia',
    'UY-DU': 'Durazno',
    'UY-FS': 'Flores',
    'UY-FD': 'Florida',
    'UY-LA': 'Lavalleja',
    'UY-MA': 'Maldonado',
    'UY-MO': 'Montevideo',
    'UY-PA': 'Paysandú',
    'UY-RV': 'Rivera',
    'UY-RO': 'Rocha',
    'UY-RN': 'Río Negro',
    'UY-SA': 'Salto',
    'UY-SJ': 'San José',
    'UY-SO': 'Soriano',
    'UY-TA': 'Tacuarembó',
    'UY-TT': 'Treinta y Tres',
  },
  VEN: {
    'VE-Z': 'Amazonas',
    'VE-B': 'Anzoátegui',
    'VE-C': 'Apure',
    'VE-D': 'Aragua',
    'VE-E': 'Barinas',
    'VE-F': 'Bolívar',
    'VE-G': 'Carabobo',
    'VE-H': 'Cojedes',
    'VE-Y': 'Delta Amacuro',
    'VE-W': 'Depend. Federales',
    'VE-A': 'Distrito Capital',
    'VE-I': 'Falcón',
    'VE-J': 'Guárico',
    'VE-K': 'Lara',
    'VE-M': 'Miranda',
    'VE-N': 'Monagas',
    'VE-L': 'Mérida',
    'VE-O': 'Nueva Esparta',
    'VE-P': 'Portuguesa',
    'VE-R': 'Sucre',
    'VE-T': 'Trujillo',
    'VE-S': 'Táchira',
    'VE-X': 'Vargas',
    'VE-U': 'Yaracuy',
    'VE-V': 'Zulia',
  },
};

export const CitiesByStateByCountry = {
  ARG: {
    'AR-B': [
      'El Descanso',
      'Villa Santos Tesei',
      'Hurlingham',
      'William C. Morris',
      'El Arbolito',
      'Los Barriles',
      'Colonia La Perla',
      'Sarasa',
      'Pearson',
      'Colon',
      'Kilometro 404',
      'Villa Cacique',
      'El Sauce',
      'Barker',
      'Benito Juarez',
      'Coronel Rodolfo Bunge',
      'Lopez',
      'San Antonio',
      'El Luchador',
      'La Tinta',
      'Tedin Uriburu',
      'Cruce Muñoz',
      'Villa Alfredo Fortabat',
      'Cuartel Ii - Aeropuerto',
      'Espigas',
      'Recalde',
      'Campo Elssiry',
      'El Porvenir',
      'Sierras Bayas',
      'Olavarria',
      'Chacras De Pibuel',
      'Virgen De La Loma',
      'San Pedro',
      'Calera Avellaneda',
      'El Mirador',
      'San Quilco',
      'Colonia San Miguel',
      'Sierra Chica',
      'Las Piedritas',
      'Villa La Serrania',
      'Iturregui',
      'Villa Monica',
      'Blancagrande',
      'Cerro Sotuyo',
      'Colonia Hinojo',
      'Mapis',
      'Campo Belgrano',
      'Villa Arrieta',
      'Blanca Chica',
      'San Gregorio',
      'Rocha',
      'Hinojo',
      'Colonia Nievas',
      'La Parda',
      'San Jacinto',
      'La Providencia',
      'Santa Luisa',
      'Pourtale',
      'La Moderna',
      'La Carmelita',
      'Los Chilenos',
      'Campo Striebeck',
      'Adrogue',
      'Jose Marmol',
      'San Jose',
      'Rafael Calzada',
      'Claypole',
      'Ministro Rivadavia',
      'Burzaco',
      'Malvinas Argentinas',
      'Glew',
      'Longchamps',
      'Don Orione',
      'San Francisco Solano',
      'Tortuguitas',
      'Del Viso',
      'Jose C. Paz',
      'La Vigia',
      'La Vuelta',
      'Roberto Cano',
      'Santa Felisa',
      'La Soledad',
      'La Caldera',
      'Los Indios',
      'La Concepcion',
      'La Rojera',
      'La Beba',
      'Barrio Las Margaritas',
      'Las Carabelas',
      'Las Polvaredas',
      'La Vuelta Chica',
      'Hunter',
      'Villa Manuel Pomar',
      'La Tigra',
      'Rojas',
      'Estacion Sol De Mayo',
      'Rafael Obligado',
      'Villa Parque Cecir',
      'La Verde',
      'San Basilio',
      'Calle Angosta',
      'Newton',
      'San Martin',
      'Chas',
      'General Belgrano',
      'Gorchs',
      'Colonia El Salado',
      'Ruta 5 Km 132',
      'Suipacha',
      'General Rivas',
      'Los Cardales',
      'Cuartel Viii',
      'Estacion La Negra',
      'La Dulce',
      'Cuartel Ix',
      'Cuartel Iv',
      'Garrido',
      'Lavalle',
      'El Eden',
      'La Loma',
      'Pieres',
      'El Moro',
      'La Guitarra',
      'Napaleofu',
      'La Alianza',
      'Santa Maria',
      'El Pampero',
      'Puerta Del Diablo',
      'La Floresta',
      'Arenas Verdes',
      'La Malacara',
      'San Pascual',
      'Dos Naciones',
      'San Manuel',
      'Las Toscas',
      'Las Nutrias',
      'Lahore',
      'Tome Y Traiga',
      'Loberia',
      'El Lenguaraz',
      'La Bodega',
      'Tamangueyu',
      'Licenciado Matienzo',
      'Moromar',
      'Cañada Seca',
      'San Genaro',
      'Los Laureles',
      'Massey',
      'Estancia El Meridiano',
      'General Villegas',
      'Colonia La Belita',
      'La Josefa',
      'Gondra',
      'Villa Ciclon',
      'Moores',
      'Campos Fria',
      'Pichincha',
      'Drabble',
      'El Recao',
      'Escuela Agraria',
      'Fortin Republica',
      'La Margarita',
      'Estacion Millaco',
      'Villa Saboya',
      'El Dia',
      'Cuartel Ii',
      'Coronel Charlone',
      'Piedritas',
      'Villa Sauze',
      'La Catalina',
      'Santa Eleodora',
      'Tamberos Unidos',
      'Los Angeles',
      'Emilio V. Bunge',
      'Banderalo',
      'Volta',
      'Campesinos Unidos',
      'Santa Regina',
      'La Tradicion',
      'Canning',
      'Luis Guillon',
      '9 De Abril',
      'Monte Grande',
      'El Jaguel',
      'Los Cerrillos',
      'Funke',
      'San Miguel Del Monte',
      'La Elina',
      'Abbott',
      'El Rosario',
      'El Siasgo',
      'Zenon Videla Dorna',
      'Goyeneche',
      'San Marcelo',
      'El Dorado',
      'La Costa',
      'Mahon',
      'Tres Lomas',
      'El Pantanoso',
      'San Silverio',
      'Los Cardos',
      'Balcarce',
      'La Sara',
      'El Gliptodonte',
      'Tres Esquinas',
      'Aleluya',
      'Bosch',
      'Colonia Balcarce',
      'San Simon',
      'Bella Vista',
      'El Capricho',
      'Juan Vicenty',
      'El Volcan',
      'Esq De Lahitte',
      'Cuartel Iii',
      'Los Pinos',
      'Ramos Otero',
      'La Esperanza',
      'Cinco Cerros',
      'El Parque',
      'La Paloma',
      'Estacion La Alborada',
      'Llanos',
      'San Agustin',
      'Cabaña San Juan',
      'La Delia',
      'Villa Laguna La Brava',
      'San Alberto',
      'El Vigilante',
      'El Cerro',
      'El Verano',
      'La Adela',
      'Puerta Del Abra',
      'La Lata',
      'Guernica',
      'Barrio America Unida',
      'La Central',
      'Cuartel Vii',
      'Kenny',
      'La Criolla',
      'Escobedo',
      'Tatay',
      'Cuartel Vi',
      'Tres Sargentos',
      'Pueblo Gouin',
      'Carmen De Areco',
      'Ex-Santamarina',
      'Cuartel I',
      'San Fermin',
      'Cochico',
      'La Florida',
      'La Flora',
      'Saturno',
      'Fortin Paunero',
      'La Legua',
      'Garre',
      'Guamini',
      'Arroyo Venado',
      'Fatralo',
      'Casey',
      'Victorino De La Plaza',
      'El Gauchito',
      'Laguna Alsina',
      'La Cuadrada',
      'La Nevada',
      'La Atrevida',
      'Alamos',
      'Casbas',
      'La Maria',
      'La Indiana',
      'La Tablada',
      'San Patricio',
      'Membrillar',
      'Las Cañas',
      'Chacabuco',
      'Coliqueo',
      'Ingeniero Silveyra',
      'Rawson',
      'Ruta Nacional 7 Km 205',
      'Medanos Blancos',
      'Castilla',
      'O Higgins',
      'El Tejado',
      'Circunscripcion I Serie H',
      'Sauce Verde',
      'San Vicente',
      'La Victoria',
      'Cucha Cucha',
      'Camet',
      'Santa Isabel',
      'Sierra De Los Padres',
      'Barrio Santa  Paula',
      'Laguna De Los Padres',
      'Estacion Camet',
      'La Brava',
      'Barrio El Casal',
      'Colonia Barragan',
      'Estacion Chapadmalal',
      'Loma Alta',
      'La Peregrina',
      'Las Dos Marias',
      'Mar Del Plata',
      'Quintas De Peralta Ramos',
      'Barrio La Gloria',
      'Chapadmalal',
      'Las Hermanas',
      'Barrio El Coyunco',
      'El Siglo',
      'Barrio Colinas Verdes',
      'Barrio El Boqueron',
      'Batan',
      'El Marquesado',
      'Punta Mogotes',
      'Villa Astolfi',
      'Maquinista F. Savio (Oeste)',
      'Los Cachorros',
      'Roberto De Vicenzo',
      'La Lonja',
      'Fatima',
      'Manzone',
      'Pilar',
      'Barrio Parque Almirante Irizar',
      'Manzanares',
      'Santa Teresa',
      'Zelaya',
      'Presidente Derqui',
      'Villa Rosa',
      'Club De Campo Larena - Los Quinchos',
      'Dos Hermanos',
      'Colonia General Pinto',
      'Los Callejones',
      'Dussaud',
      'Villa Francia',
      'El Peregrino',
      'Santa Angela',
      'General Pinto',
      'Villa Roth',
      'Germania',
      'Pazos Kanki',
      'Perisee',
      'Gunther',
      'Colonia San Ricardo',
      'Florida',
      'La Lucila',
      'Munro',
      'Olivos',
      'Villa Adelina',
      'Villa Martelli',
      'Florida Oeste',
      'Vicente Lopez',
      'Carapachay',
      'Lonkoy',
      'El Modelo',
      'Los Zorzales',
      'Trelles',
      'Medaland',
      'La Felicidad',
      'General Juan Madariaga',
      'Invernadas',
      'Barrio Kennedy',
      'Colonia Tio Domingo',
      'Juan Chico',
      'El Cardalito',
      'Santa La Victoria',
      'Santa Yola',
      'Macedo',
      'Nueva Granada',
      'Del Carril',
      'Emiliano Reynoso',
      'Saladillo Norte',
      'San Blas',
      'Damas De La Misericordia',
      'Acuña',
      'Alvarez De Toledo',
      'Los Guaycos',
      'La Campana',
      'Cazon',
      'San Benito',
      'La Garita',
      'El Arenal Del Carmen',
      'Polvaredas',
      'El Naranjo',
      'La Fortuna',
      'Maria Antonieta',
      'Renaco',
      'El Puente',
      'Atucha',
      'El Mangrullo',
      'Blaquier',
      'La Argentina',
      'La Blanqueada',
      'Campo Vela',
      'La Barrancosa',
      'Saladillo',
      'Chosoico-Algarro',
      'Lejarraga',
      'Colonia San Enrique',
      'Argerich',
      'Los Acebos',
      'Colonia Craico',
      'El Alba',
      'Salina Las Barrancas',
      'Juan Couste',
      'Colonia Lejarreta',
      'Lote 39',
      'Isla Verde',
      'El Chara',
      'Santa Catalina',
      'Teniente Origone',
      'Pedro Luro',
      'Las Mascotas',
      'La Selva',
      'Mayor Buratovich',
      'Hilario Ascasubi',
      'Colonia Rincon De La Espuela',
      'Nicolas Levalle',
      'Colonia La Merced',
      'El Zorro',
      'Country Los Medanos',
      'El Fortin',
      'Monte Paquete',
      'Medanos',
      'La Mascota',
      'La Julita',
      'Colonia Mastrangelo',
      'El Reducto',
      'Los Alfalfares',
      'Los Surgentes',
      'Montes De Oca',
      'Las Isletas',
      'Colonia San Adolfo',
      'Colonia Espie',
      'La Carlota',
      'Villa Sarita',
      'La Estrella',
      'Las Flores',
      'Las Canaletas',
      'Villa Jardin',
      'El Espinillo',
      'Almacen De Basso',
      'Santa Lucia',
      'Del Pardo',
      'Villa Leandra',
      'Obligado',
      'Los Mataderos',
      'Colegiales',
      'Rio Tala',
      'La Tosquera',
      'Tablas',
      'El Centro',
      'Gobernador Castro',
      'Pueblo Doyle',
      'El Cantabrico',
      'Beladrich',
      'El Ideal',
      'Ingeniero Moneta',
      'La Celina',
      'La Bolsa',
      'La Buena Moza',
      'La Matilde',
      'Bajo Tala',
      'El Caleu',
      'La Veronica',
      'Santa Rosa',
      'Santa Fortuna',
      'San Juan',
      'La Union',
      'San Bernardo',
      'La P0Sta',
      'Labarden',
      'La Quinua',
      'Las Acacias',
      'General Guido',
      'Acassuso',
      'San Isidro',
      'Boulogne Sur Mer',
      'Beccar',
      'Martinez',
      'Islas',
      'General Pacheco',
      'Don Torcuato Este',
      'Dique Lujan',
      'Los Troncos Del Talar',
      'Rincon De Milberg',
      'Ricardo Rojas',
      'Tigre',
      'Don Torcuato Oeste',
      'El Talar',
      'Benavidez',
      'Tres Bocas',
      'Almacen Arosa',
      'Abethur',
      'Las Tortugas',
      'El Manantial',
      'Los Altos Verdes',
      'La Reduccion',
      'La India Muerta',
      'El Triangulo',
      'Centro Guerrero',
      'La California',
      'El Callejon',
      'La Corina',
      'Cerro De La Gloria (Canal 15)',
      'El Araza',
      'Los Molles',
      'La Salada',
      'Castelli',
      'San Cayetano',
      'Ochandio',
      'La Gama',
      'Colonia Rivadavia',
      'Vagnoli',
      'El Pino',
      'El Carretero',
      'Cristiano Muerto',
      'El Indio',
      'Balneario San Cayetano',
      'Valeria Del Mar',
      'Carilo',
      'Ostende',
      'Pinamar',
      'Las Tunas',
      'Berutti',
      'Nueva Castilla',
      'Francisco De Vitoria',
      'Trenque Lauquen',
      'El Correntino',
      'Colonia Martin Fierro',
      'Girodias',
      'San Eduardo',
      'Las Guasquitas',
      'Elvira',
      'Francisco Magnano',
      'Primera Junta',
      'Maya',
      'Mari Lauquen',
      'Colonia Manuel 1°',
      'Corazzi',
      'La Atalaya',
      'Tronge',
      'Colonia El Mate',
      'Lertora',
      'Duhau',
      'La Zanja',
      'La Candelaria',
      'La Carreta',
      '30 De Agosto',
      'Colonia Santa Ana',
      'Los Chañares',
      'Aparicio',
      'Las Cortaderas',
      'El Perdido',
      'Los Juncos',
      'Zubiarre',
      'La Aurora',
      'El Calfiao',
      'La Ruta',
      'Nicolas Descalzi',
      'Centro Urquiza',
      'Faro',
      'El Lucero',
      'La Gloria',
      'Coronel Dorrego',
      'Loma Chata',
      'Gil',
      'San Roman',
      'Oriente',
      'Calvo',
      'Balneario Marisol',
      'Irene',
      'La Luna',
      'Dique N° 1',
      'Ensenada',
      'Punta Lara',
      'Villa Catela',
      'Isla Santiago (Oeste)',
      'Villa Grisolia',
      'Pla',
      'Coronel Segui',
      'Larrea',
      'Baudrix',
      'Villa Maria',
      'Alberti',
      'Mechita',
      'Presidente Quintana',
      'Villa Ortiz',
      'El Recuerdo',
      'Cuartel V',
      'Lomas De Zamora',
      'Banfield',
      'Llavallol',
      'Villa Fiorito',
      'Temperley',
      'Villa Centenario',
      'Turdera',
      'Barrio Los Pioneros',
      'Lomas Del Rio Lujan',
      'El Morejon',
      'Estacion Esperimental Delta Del Parana',
      'Blondeau',
      'Chacras Del Rio Lujan',
      'Alto Los Cardales',
      'La Granja',
      'Campana',
      'Isla Talavera',
      'San Jose De Otamendi',
      'Miramar',
      'La Ballenera',
      'Estancia La Toto',
      'Comandante Nicanor Otamendi',
      'Mechongue',
      'La Reforma',
      'La Eufemia',
      'Mar Del Sur',
      'Centinela Del Mar',
      'Aeropuerto Internacional Ezeiza',
      'Jose Maria Ezeiza',
      'Tristan Suarez',
      'Carlos Spegazzini',
      'Campo De Mayo',
      'Muñiz',
      'San Miguel',
      'La Porota',
      'Colonia Lapin',
      'Delfin Huergo',
      'Leubuco',
      'Villa Margarita',
      'La Conquista',
      'La Sal',
      'Estacion La Concepcion',
      'Colonia San Miguel Arcangel',
      'San Marcos',
      'Arturo Vatteone',
      'Thames',
      'Colonia Leven',
      'Avestruz',
      'Masalle',
      'Tres Lagunas',
      'La Pala',
      'Santa Anita',
      'Rivera',
      'Canonigo Gorriti',
      'Esteban Agustin Gascon',
      'Arano',
      'Espartillar',
      'Carhue',
      'Lago Epecuen',
      'Yutuyaco',
      'Maza',
      'El Cortapie',
      'Dufaur',
      'Las Encadenadas',
      'Los Cerritos',
      'Las Lomas',
      'Arroyo Corto',
      'La Norma',
      'Abra Del Hinojo',
      'Las Marias',
      'Alta Vista',
      'Saavedra',
      'Espartillar (E)',
      'Goyena',
      'La Colonia Nueva',
      'Colonia San Pedro',
      'Pigue',
      'Colonia San Martin',
      'San Francisco',
      'La Hispano Argentina',
      'El Poleo',
      'Los Fachinales',
      'Mauleon',
      'La Sortija',
      'Juan E. Barra',
      'La Emma',
      'Alzaga',
      'Adolfo Gonzales Chaves',
      'Vasquez',
      'Santa Clara',
      'Chapar',
      'De La Garma',
      'Loma Hermosa',
      'Martin Coronado',
      'Santos Lugares',
      '11 De Septiembre',
      'Ciudadela',
      'Villa Bosch (Est. Juan Maria Bosch)',
      'Pablo Podesta',
      'Jose Ingenieros',
      'Caseros',
      'El Libertador',
      'Churruca',
      'Remedios De Escalada',
      'Villa Raffo',
      'Saenz Peña',
      'Ciudad Jardin Lomas Del Palomar',
      'La Valerosa',
      'Azcuenaga',
      'Solis',
      'Villa San Alberto',
      'Campo Vazquez',
      'Villa Espil',
      'El Condor',
      'Los Manueles',
      'La Primavera',
      'San Andres De Giles',
      'Tuyuti',
      'La Amalia',
      'Culullu',
      'Heavy',
      'Franklin',
      'Villa Ruiz',
      'Salliquelo',
      'Quenuma',
      'Posada De Los Lagos',
      'Coronel Brandsen',
      'Jeppener',
      'Club De Campo Las Malvinas',
      'La Parada',
      'Campo Portu',
      'Barrio Los Bosquecitos',
      'Barrio Parque Las Acacias',
      'Oliden',
      'Barrio Las Golondrinas',
      'Campos De Roca',
      'Gobernador Obligado',
      'Ruta 29 Km 2',
      'Altamirano',
      'La Posada',
      'Buchanan',
      'Barrio El Mirador',
      'El Chaja',
      'La Pepita',
      'Gomez',
      'Samborombon',
      'Monte Hermoso',
      'Balneario Sauce Grande',
      'Puelches',
      'Colonia 17',
      'Los Agrarios',
      'Colonia Moreno',
      'Ingeniero Thompson',
      'La Grande Del Sud',
      'Pehuelches',
      'San Antonio De Padua',
      'Libertad',
      'Merlo',
      'Mariano Acosta',
      'Pontevedra',
      'Bernal Oeste',
      'Don Bosco',
      'Bernal',
      'Quilmes Oeste',
      'Villa La Florida',
      'Ezpeleta Oeste',
      'Ezpeleta',
      'Quilmes',
      'Campo Toyos',
      'La Oriental',
      'Colonia San Luis',
      'Agustina',
      'Campo Maipu',
      'Blandengues',
      'Campo Camiccia',
      'Balneario Laguna De Gomez',
      'Agustin Roca',
      'A. Roca',
      'Junin',
      'La Agraria',
      'Las Mercedes',
      'Saforcada',
      'Fortin Tiburcio',
      'Campo La Cruz',
      'Cerrito Colorado',
      'Rincon Del Carpincho',
      'Morse',
      'Laplacette',
      'Campo Balestraset',
      'Estacion Pereyra',
      'Guillermo Enrique Hudson',
      'Pereyra',
      'El Pato',
      'Juan Maria Gutierrez',
      'Ranelagh',
      'Villa España',
      'Platanos',
      'Berazategui',
      'Berazategui Oeste',
      'Carlos Tomas Sourigues',
      'Bragado',
      'Olascoaga',
      'Asamblea',
      'El Mataco',
      'Santo Domingo',
      'Rauch Nuevo',
      'La Blanqueda',
      'La Limpia',
      'Maximo Fernandez',
      'Comodoro Py',
      'Campo De Riano',
      'Warnes',
      'Irala',
      'General O Brien',
      'Rauch Viejo',
      'Vieytes',
      'La Clelia',
      'Magdalena',
      'Atalaya',
      'Campo Ferro',
      'Roberto J. Payro',
      'Gutierrez',
      'Los Naranjos',
      'Julio Arditi',
      'Jose Ferrari',
      'General Mansilla',
      'Vergara',
      'El Destino',
      'Unidad Penal Magdalena',
      'Malagamba',
      'La Matraca',
      'Henderson',
      'Coraceros',
      'Campo Moncani',
      'Maria Lucila',
      'Bersee',
      'Herrera Vegas',
      'Colonia La Beba',
      'El Barrancoso',
      'El Tauro',
      'Estancia El Molino',
      'Estancia Balbuena',
      'Carmen De Patagones',
      'Colonia Los Alamos',
      'Zona Rural De Jose B Casas',
      'Juan A. Pradere',
      'Bahia San Blas',
      'Colonia La Delfina',
      'Meridiano V',
      'Colonia Migliori',
      'Colonia El Guanaco',
      'Colonia 7 De Marzo',
      'Estancia San Luis',
      'Villalonga',
      'Colonia La Graciela',
      'Stroeder',
      'Colonia El Molino',
      'Emilio Lamarca',
      'Jose B. Casas',
      'Cardenal Cagliero',
      'Igarzabal',
      'Colonia Barga',
      'Colonia San Francisco',
      'Villa Lynch',
      'Kilometro 900',
      'Lanus Este',
      'Valentin Alsina',
      'Remedios De Escalada De San Martin',
      'Monte Chingolo',
      'Gerli',
      'Lanus Oeste',
      'El Solito',
      'Barrio Lomas Altas',
      'Los Jagñeles',
      'La Juanita',
      'Don Cipriano',
      'Libres Del Sud',
      'Villa Parque Girado',
      'La Horqueta',
      'Cuatro De Febrero',
      '9 De Julio',
      'Vivero Nacional',
      'Chascomus',
      'Laguna Vitel',
      'Estancia El Coati',
      'El Recreo',
      'La Corona',
      'Gandara',
      'San Nicanor',
      'Valle Santa Anta',
      'Barrio San Cayetano',
      'Comandante Giribone',
      'Estancia San Ceferino',
      'Adela',
      'El Bote',
      'Juancho',
      'Manantiales',
      'El Mirasol',
      'Los Troncos',
      'Agote',
      'Mercedes',
      'Cuartel Xvi',
      'Cuartel Xv',
      'Cuartel Xii',
      'San Jorge',
      'Tomas Jofre',
      'Gowland',
      'Cuartel Xix',
      'Puricelli',
      'Goldney',
      'Mira Pampa',
      'Villa Sena',
      'Fortin Olavarria',
      'Estancia La Haydee',
      'Cerrito',
      'Condarco',
      'Roosevelt',
      'Rodeo Chico',
      'Colonia El Balde',
      'Gonzalez Moreno',
      'Valentin Gomez',
      'San Mauricio',
      'Sundblad',
      'Sansinena',
      'America',
      'El Pensamiento',
      'Stegmann',
      'Coronel Falcon',
      'Lartigau',
      'Chelforo',
      'Estacion Las Lomas',
      'Reserva',
      'El Gavilan',
      'Las Mostazas',
      'La Noria',
      'Coronel Pringles',
      'Krabbe',
      'Pillahuinco',
      'Don Alfredo',
      'La Virginia',
      'Laguna Del Molle',
      'Ojo De Agua',
      'San Felipe',
      'El Divisorio',
      'Indio Rico',
      'La Alfalfa',
      'La Colorada',
      'La Luisa',
      'Arroyo De Luna',
      'Capitan Sarmiento',
      'Villa Coronel Jose M. Zapiola',
      'Villa Maria Irene De Los Remedios De Escalada',
      'Villa Parque Presidente Figueroa Alcorta',
      'Villa Godoy Cruz',
      'Villa Gregoria Matorras',
      'Billinghurst',
      'Villa Ballester',
      'Villa Yapeyu',
      'Villa General Eugenio Necochea',
      'Villa Parque San Lorenzo',
      'Villa General Jose Tomas Guido',
      'Villa Ayacucho',
      'Villa Granaderos De San Martin',
      'Villa Jose Leon Suarez',
      'Villa Marques Alejandro Maria De Aguado',
      'Villa Bernardo Monteagudo',
      'Villa General Juan G. Las Heras',
      'Villa Libertad',
      'Villa Maipu',
      'Villa General Antonio J. De Sucre',
      'Villa Chacabuco',
      'Villa San Andres',
      'Ciudad Del Libertador General San Martin',
      'Villa Juan Martin De Pueyrredon',
      'Ciudad Jardin El Libertador',
      'Barrio Parque General San Martin',
      'Perez Millan',
      'Villa Ramallo',
      'Ramallo',
      'Zino',
      'La Independencia',
      'Marelli',
      'Los Toldos',
      'El Jupiter',
      'El Tonelero',
      'San Carlos',
      'El Paraiso',
      'La Feria',
      'Manantiales Chicos',
      'Las Bahamas',
      'Herrera',
      'Villa General Savio',
      'Real Audiencia',
      'El 80',
      'Hinojales',
      'Camaron Chico',
      'Las Lechuzas',
      'Chapalauquen',
      'Casalins',
      'Pila',
      'El Venado',
      'Demaria',
      'Las Chilcas',
      'El Sarten',
      'El Alegre',
      'El Trigo',
      'Plaza Montero',
      'Doctor Domingo Harosteguy',
      'Pago De Oro',
      'Est La Graciela',
      'Santa Ines',
      'Pardo',
      'La Colonia',
      'El Mosquito',
      'El Tropezon',
      'Vilela',
      'El Toro',
      'Piammisteguy',
      'El Despunte',
      'Estrugamou',
      'El Gualicho',
      'La Capilla',
      'Coronel Boerr',
      'La Cubana',
      'Sol De Mayo',
      'Rosas',
      'La Angelita',
      'Claraz',
      'Las Calaveras',
      'La Magnolia',
      'Semillero Buck',
      'Campomar',
      'Mojon Del Palo',
      'Necochea',
      'Juan N. Fernandez',
      'La Lita',
      'Calangueyu',
      'La Negra',
      'Ramon Santamarina',
      'Nicanor Olivera',
      'La Galia',
      'Costa Bonita',
      'Villa Zagala',
      'El Tigre',
      'Quequen',
      'Lumb',
      'Energia',
      'San Jose (Villa Diego)',
      'El Palomar',
      'San Cala',
      'Barrio Ruta 24 Km. 10',
      'La Choza',
      'C.C. Bosque Real',
      'Cruce Rutas 6 Y 24',
      'Hospital Sommer',
      'Barrio Ruta 24 Kilometro 10',
      'General Rodriguez',
      'Barrio Morabo',
      'De Arias',
      'Azul',
      'Arroyo De Los Huesos',
      'Mataderos',
      'La Mantequeria',
      'Ariel',
      'La Pequeña',
      'Los 4 Caminos',
      'Pablo Acosta',
      'Siempre Amigos',
      'Shaw',
      'El Destierro',
      'Miramonte',
      '16 De Julio',
      'La Protegida',
      'La Sofia',
      'Cachari',
      'Martin Fierro',
      'Vicente Pereda',
      'Manantiales De Pereda',
      'Campo Mireztky',
      'La Isabelita',
      'La Chumbeada',
      'Nieves',
      'Villa Laza',
      'Chillar',
      'Las Rosas',
      'Parish',
      'Barrio El Taladro',
      'Estancia La Primavera',
      'Gobernador Udaondo',
      'Villa Vissir',
      'Uribelarrea',
      'Alejandro Petion',
      'Los Alamos',
      'La Tapie',
      'El Deslinde',
      'Las Palmitas',
      'La Leonor',
      'Cañuelas',
      'Barrio Belgrano',
      'Vicente Casares',
      'Maximo Paz',
      'La Dorita',
      'Colonia Santa Maria',
      'Colonia Mauricio',
      'Mauricio Hirsch',
      'Ordoqui',
      'Moctezuma',
      'Santo Tomas',
      'Bellocq',
      'Cadret',
      'Las Chacras',
      'El Billar',
      'Centenario',
      'Carlos Casares',
      'Hortensia',
      'Smith',
      'Colonia La Piedra',
      'El Septimo',
      'Gobernador Arias',
      'Villa Riccio',
      'La Clemencia',
      'Villa Esperanza',
      'La Alicia',
      'Villa Campi',
      'Erezcano',
      'Villa Canto',
      'General Rojo',
      'San Nicolas De Los Arroyos',
      'Campos Salles',
      'La Emilia',
      'Conesa',
      'Santa Elvira',
      'Laguna Los Difuntos',
      'Las Armas',
      'Yamahuida',
      'Segurola',
      'Monsalvo',
      'Maipu',
      'Santa Teresita',
      'Ingeniero Pablo Nogues',
      'Area De Promocion El Triangulo',
      'Ingeniero Adolfo Sourdeaux',
      'Grand Bourg',
      'Los Polvorines',
      'Villa De Mayo',
      'Magdala',
      'Francisco Madero',
      'Las Juanitas',
      'El Cruce',
      'El Recado',
      'Ancon',
      'Juan Jose Paso',
      'Gnecco',
      'Inocencio Sosa',
      'El Agro',
      'Pedro Gamen',
      'Mones Cazon',
      'Capitan Castro',
      'Pehuajo',
      'Colonia Carlos Arias',
      'El Ranchito',
      'Asturias',
      'Conde Cazon',
      'Nueva Plata',
      'Abel',
      'Cuartel Segundo',
      'Alvarez',
      'San Esteban',
      'Curuchet',
      'El Ombu',
      'Campo Arechaval',
      'Domselaar',
      'Alejandro Korn',
      'Mariano Benitez',
      'Rancagua',
      'Gornatti',
      'La Violeta',
      'Acevedo',
      'Arroyo Del Medio',
      'La Vanguardia',
      'Estancia San Rafael',
      'Tambo Nuevo',
      'Francisco Ayerza',
      'Campo Buena Vista',
      'Fontezuela',
      'Manuel Ocampo',
      'Campo Urrutia',
      'Villa Angelica',
      'Maguirre',
      'Guerrico',
      'Pinzon',
      'Camino A La Violeta Km 4',
      'Arroyo Dulce',
      'La Magdalena',
      'Mariano H.  Alfonzo',
      'Juan Anchorena',
      'Ortiz Basualdo',
      'Pergamino',
      'Juan A. De La  Peña',
      'Campo Roth',
      'Villa San Jose',
      'Manantiales Grandes',
      'Campo Urquiza',
      'Moreno',
      'Paso Del Rey',
      'La Reja',
      'Trujui',
      'Francisco Alvarez',
      'Punta Alta',
      'B.N.I.M Baterias',
      'Campo Escudero',
      'Pago Chico',
      'Balneario Pehuen Co',
      'Coronel Rosales',
      'Villa General Arias',
      'Campo San Vicente',
      'Bajo Hondo',
      'Las Oscuras',
      'Villa Del Mar',
      'Calderon',
      'Balsa',
      'La Dorotea',
      'Santa Marta',
      'La Esmeralda',
      'Pasicott',
      'Carlos Salas',
      'El Morito',
      'Los Aromitos',
      'Coronel Martinez De Hoz',
      'El Triunfo',
      'Arenaza',
      'La Concordia',
      'La Pergaminera',
      'Lincoln',
      '13 De Abril',
      'Estacion San Juan',
      'Roberts',
      'Triunvirato',
      'Acceso Ricaldi',
      'Bermudez',
      'Estacion La Union',
      'Bayauca',
      'Pasteur',
      'Vigilancia',
      'Media Luna',
      'Porvenir',
      'Estacion La Chacra',
      'Salale',
      'Los Andes',
      'Ancalo',
      'Nueva Suiza',
      'Florentino Ameghino',
      'Cuarto Luna',
      'Estacion La Isleta',
      'Eduardo Costa',
      'El Rincon',
      'La Rinconada',
      'Monasterio',
      'La Josefina',
      'La Belen',
      'Atilio Pessagno',
      'Manuel J. Cobo - Lezama',
      'Castelar',
      'Haedo',
      'Moron',
      'Villa Sarmiento',
      'Belen De Escobar',
      'Garin',
      'El Cazador',
      'Loma Verde',
      'Ingeniero Maschwitz',
      'Seccion Islas',
      'Matheu',
      'Maquinista F. Savio Este',
      'Los Talas',
      'Berisso',
      'Barrio El Carmen (Este)',
      'Villa Argñello',
      'Villa Nueva',
      'Villa Zula',
      'Villa Progreso',
      'Villa Porteña',
      'Isla Paulino',
      'Barrio Banco Provincia',
      'Villa Independencia',
      'Barrio Universitario',
      'La Hermosura',
      'Villa Dolores',
      'Villa San Carlos',
      'Villa Lynch Pueyrredon',
      'San Emilio',
      'La Protectora',
      'Paula',
      'La Merced',
      'Campo Creado',
      'El Sombrerito',
      'Unidad Penal De Urdampilleta',
      'La Carolina',
      'Urdampilleta',
      'El Cabildo',
      'La Vizcaina',
      '30 De Diciembre',
      'San Carlos De Bolivar',
      'Juan F. Ibarra',
      'San Luis',
      'Pirovano',
      'Campo Lando',
      'Avellaneda',
      'Boscabel',
      'San Andres',
      'Vallimanca',
      'Villa Sanz',
      'El 43',
      'Marsiglio',
      'Campo Capecce',
      'Mariano Unzue',
      'Hale',
      'Los 4 Vientos',
      'Parada Orlando',
      'Chenaut',
      'Capilla Del Señor',
      'Parada Robles',
      'Etchegoyen',
      'Estacion La Lata',
      'Ruta 193 Km 28,5',
      'La Rosada',
      'Gobernador Andonaegui',
      'Arroyo De La Cruz',
      'Diego Gaynor',
      'El Remanso',
      'Carlos Lemee',
      'Pavon',
      'Acceso A Gobernador Andonaegui',
      'El Chiripa',
      'Los Flamencos',
      'Los Aromos',
      'Fortin Esperanza',
      'Los Chucaros',
      'Colonia S S Del Valle',
      'El Peludo',
      'La Maria Luisa',
      'Emma',
      'General Alvear',
      'El Parche',
      'La Morocha',
      'El Tabare',
      'Villa Serrana La Gruta',
      'Sombra De Toro',
      'La Querencia',
      'Fortin Chaco',
      'Fuerte Argentino',
      'Tornquist',
      'El Pilar',
      'La Esther',
      'Navidad',
      'Sauce Chico',
      'Rodolfo Funke',
      'Berraondo',
      'Saldungaray',
      'Tres Picos',
      'Choique',
      'Estomba',
      'Pelicura',
      'Chasico',
      'Nueva Roma',
      'Dique Paso Piedras',
      'Villa Ventana',
      'Sierra De La Ventana',
      'Barrio Saavedra',
      'Ruta 9 Km 103',
      'Lima',
      'Escalada',
      'Isla Botija',
      'La Pesqueria',
      'Country Club El Casco',
      'Las Cuatro Esquinas',
      'El Tatu',
      'Zarate',
      'Las Palmas',
      'Vedia',
      'Trigales',
      'Alberdi Viejo',
      'El Retiro',
      'La Permanente',
      'La Clarita',
      'Estacion Las Balas',
      'Juan Bautista Alberdi',
      'Campo Mendizabal',
      'Leandro N. Alem',
      'Fortin Acha',
      'Barrio Granaderos',
      'Cañada De Roca',
      'Lezica Y Torrezuri',
      'Carlos Keen',
      'Sucre',
      'Olivera',
      'Alastuey',
      'Jose Maria Jauregui',
      'Open Door',
      'Lujan',
      'Torres',
      'Villa Flandria Norte (Pueblo Nuevo)',
      'Club De Campo Los Puentes',
      'San Eladio',
      'Polo De Lujan',
      'Cortines',
      'Barrio Las Casuarinas',
      'Pueblo Nuevo',
      'Country Club Las Praderas',
      'Las Lilas',
      'Villa Flandria Sur (Est. Jauregui)',
      'Aguas Verdes',
      'Las Toninas',
      'Mar Del Tuyu',
      'Mar De Ajo Norte',
      'Lucila Del Mar',
      'San Clemente Del Tuyu',
      'Mar De Ajo',
      'Alegre',
      'Villanueva',
      'Falcone',
      'La Cañada',
      'Barrio Rio Salado',
      'La Posta',
      'Villa Martinez',
      'La Chancleta',
      'Kilometro 70',
      'Dantas',
      'De La Llave',
      'La Tahona Nueva',
      'Los Merinos',
      'Ranchos',
      'La Andorra',
      'Loma Partida',
      'Chapaleofu',
      'El Escondite',
      'Miranda',
      'El Chalar',
      'Santa Adela',
      'El Bonete',
      'Rauch',
      'Los Mellizos',
      'Colonia Langueyu',
      'Durazno Chico',
      'La Dormida',
      'Las Negras',
      'Los Galpones',
      'Boca De Tigre',
      'Martin Colman',
      'Loma Negra',
      'Los Copetes',
      'Indacochea',
      'Pasaje El Palomar',
      'Gorostiaga',
      'Benitez',
      'Palemon Huergo',
      'San Sebastian',
      'Seccion Primera Quintas',
      'Puente Lago',
      'Ramon Biaus',
      'Witte',
      'La Rica',
      'La Armonia',
      'Emilio Ayarza',
      'De Luca',
      'Chivilcoy',
      'Henry Bell',
      'Campo De Bardengo',
      'Moquehua',
      'Picheuta',
      'Campo Zacardi',
      'Rio Carabelas',
      'Arroyo Pay Carabi',
      'Carupa',
      'Islas Del Delta',
      'Victoria',
      'Arroyo Durazno',
      'Arroyo Las Cañas',
      'San Fernando',
      'Arroyo Borches',
      '2° Seccion De Islas',
      'Virreyes',
      'La Barquita',
      'Parana Mini',
      'Isalas De San Fernando',
      '3° Seccion De Islas',
      'Villa Alsina',
      'Saenz Valiente',
      'La Tortuga',
      'Baradero',
      'Cañada De Los Toros',
      'Isla Los Laureles',
      'La Bellaca',
      'Colonia Suiza',
      'El Caballito Chico',
      'Irineo Portela',
      'El Caballito',
      'El Martillo',
      'Santa Coloma',
      'Camino A Villa Alsina',
      'Vuelta De Los Pastos',
      'Cañada Grande',
      'Barrios Lisandro De La Torre Y Santa Marta',
      'Alambrado De Fierro',
      'Marcos Paz',
      'Barrio Santa Rosa',
      'Villa Gobernador Udaondo',
      'Ituzaingo Sur',
      'Ituzaingo Centro',
      'La Anita',
      'Barrio Los Hornos',
      'Campo Egli',
      'Campo Tozzi',
      'Ruta Provincial 41 Km 168',
      'El Balcon',
      'Jose Santos Arevalo',
      'Laguna De Lobos',
      'Salvador Maria',
      'Las Garzas',
      'Lobos',
      'Antonio Delgado',
      'Zapiola',
      'Antonio Carboni',
      'El Hinojo',
      'El Faisan',
      'Santos Unzue',
      'Patricios',
      'Gerente Cilley',
      'Campo Lisazo',
      'Cambaceres',
      'El Tejar',
      'Fauzon',
      'Galo Llorente',
      'Marcelino Ugarte',
      '12 De Octubre',
      'Bacacay',
      'Corbett',
      'Norumbega',
      'Alfredo Demarchi',
      'Morea',
      'Las Piedras',
      'Mulcahy',
      'Los Paraisos',
      'Dudignac',
      'Manuel B. Gonnet',
      'El Jabali',
      'El Espartillar',
      'Villa General Fournier',
      'Kilometro 234',
      'El Socavon',
      'Carlos Maria Naon',
      'Colonia La Rural',
      'La Hormiga',
      'Alferez San Martin',
      'Villa Olga',
      'Cochrane',
      'Grñnbein',
      'Los Mirasoles',
      'Villa Espora',
      'Ingeniero White',
      'Villa Elisa',
      'Puerto Galvan',
      'Villa Bordeau',
      'Posta Rolando',
      'Bahia Blanca',
      'Cabildo',
      'General Daniel Cerri',
      'La Carrindanga',
      'Aldea Romana',
      'Estacion Los Ingleses',
      'General Lavalle',
      'La Isolina',
      'Las Violetas',
      'Cabrera',
      'La Huertita',
      'La Copeta',
      'Colonia Las Margaritas',
      'Santa Rita',
      'La Larga',
      'Enrique Lavalle',
      'Arbolito',
      'San Alfredo',
      'Andant',
      'Louge',
      'Mouras',
      'La Manuela',
      'Coronel Marcelino Freyre',
      'Masurel',
      'Arboledas',
      'Daireaux',
      'Salazar',
      'La Linda',
      'La Prosperidad',
      'Luro',
      'Encina',
      'Esteban De Luca',
      'Justet',
      'La Trocha',
      'Tres Algarrobos',
      'Drysdale',
      'Colonia Sere',
      'Timote',
      'Husares',
      'Campo Merlo',
      'Hereford',
      'Curaru',
      'La Diana',
      'Carlos Tejedor',
      'Timote Chico',
      'Tapiales',
      'Ciudad Evita',
      'Gregorio De Laferrere',
      'Ramos Mejia',
      'Aldo Bonzi',
      'Virrey Del Pino',
      'Villa Luzuriaga',
      'Isidro Casanova',
      'Rafael Castillo',
      'Villa Eduardo Madero',
      'San Justo',
      '20 De Junio',
      'Gonzalez Catan',
      'Lomas Del Mirador',
      'Puesto Colorado',
      'Pueblitos',
      'Panelo',
      'Santiago Garbarini',
      'Lucas Monteverde',
      'El Mate',
      'Norberto De La Riestra',
      'Solache',
      'Gobernador Ugarte',
      'San Ramon',
      'Araujo',
      'Anderson',
      'Mamaguita',
      'Ernestina',
      'Valdes',
      'La Tribu Chica',
      'Del Valle',
      'Agustin Mosconi',
      'Fortin Mulitas',
      'El Clavo',
      'Huetel',
      'Villa Marta',
      'San Enrique',
      'La Llosa Y El Mate',
      'La Cantora',
      'La Palma',
      'El Chimborazo',
      '25 De Mayo',
      'El Sosiego',
      'Pedernales',
      'Martin Berraondo',
      'Area Cinturon Ecologico',
      'Sarandi',
      'Wilde',
      'Crucesita',
      'Piñeyro',
      'Dock Sud',
      'Villa Dominico',
      'El Amanecer',
      'Arroyo Burgos',
      'La Branqueada',
      'El Nacional',
      'Monte Lavalle',
      'Las Saritas',
      'La Nelida',
      'Viña',
      'Todd',
      'Arrecifes',
      'El Contador',
      'Brisas Alegres',
      'Laprida',
      'Tres Cardos',
      'Voluntad',
      'Colonia Artalejos',
      'Santa Elena',
      'Pueblo San Jorge',
      'Achalay',
      'La Florentina',
      'La Rotonda',
      'Los Jacintos',
      'Arce Hermanos',
      'Sabbi',
      'Velloso',
      'Crotto',
      'El Combate',
      'El Tuyuti',
      'Campodonico',
      'Yerbas',
      'El Castellano',
      'Eufemio Uballes',
      'Altona',
      'Quintas De Tapalque',
      'Tapalque',
      'Covello',
      'Felipe Sola',
      'Estela',
      'Rivadeo',
      'La Rosalia',
      'Viboras',
      'Bordenave',
      'Villa Castelar',
      'El Cardal',
      'San German',
      'General Rondeau',
      '17 De Agosto',
      'Arroyo Seco',
      'Villa Iris',
      'Puan',
      'Azopardo',
      'Tres Cuervos',
      'Darregueira',
      'Lopez Lecube',
      'Ruta Nacional 5 Km 502',
      'La Pua',
      'Estacion La Cautiva',
      'Pellegrini',
      'De Bary',
      'Bocayuva',
      'Colonia Sarmiento',
      'Zona Rural De Pellegrini',
      'Las Tres Marias',
      'Monte Del Tordillo',
      'Dolores',
      'Las Margaritas',
      'Los Sauquitos',
      'La Vasca',
      'Est. Panelo',
      'Al Ver Veras',
      'Dos Talas',
      'Sevigne',
      'Lomas De Salomon',
      'Loma De Roldan',
      'Ascension',
      'Estacion Arenales',
      'Ferre',
      'Arribeños',
      'La Trinidad',
      'General Arenales',
      'Campo Alvear',
      'La Pinta',
      'Ham',
      'Desvio Km 95',
      'Colonia Las Mercedes',
      'Delgado',
      'Santa Ana',
      'Robles',
      'Lozano',
      'Magnasco',
      'La Fe',
      'Granja Blanca',
      'Speratti',
      'Marre',
      'Villars',
      'General Hornos',
      'General Las Heras',
      'Plomer',
      'Enrique Fynn',
      'La Delfina',
      'Achaval',
      'Zavalia',
      'Baigorrita',
      'Los Bosques',
      'La Carmen',
      'Quirno Costa',
      'Los Huesos',
      'Chancay',
      'El Monasterio',
      'Los Dos Amigos',
      'Vagues',
      'Puente Castex',
      'San Antonio De Areco',
      'Camino De Yameo',
      'Villa Lia',
      'Duggan',
      'Crisol',
      'San Pablo',
      'La Invencible',
      'Campo Blanco',
      'Salto',
      'Ines Indart',
      'Gahan',
      'Tacuari',
      'El Haras',
      'Las Mulas',
      'Colonia El Rincon',
      'Berdier',
      'Monroe',
      'La Isabel',
      'La Lechuza',
      'Jose Juan Almeyra',
      'La Rapida',
      'Anasagasti',
      'Ingeniero Williams',
      'Los Vasquitos',
      'Navarro',
      'Gonzalez Risos',
      'Los Pozos',
      'Las Marianas',
      'Ringuelet',
      'Los Nogales',
      'Kilometro 83',
      'Ruta Nacional 200 Km 96',
      'Villa Moll',
      'Barrio Ruta Sol',
      'La Plata',
      'Barrio Las Quintas',
      'Villa Elvira',
      'Jose Hernandez',
      'Country Club El Rodeo',
      'Transradio',
      'City Bell',
      'Arana',
      'Tolosa',
      'Lomas De Copello',
      'Villa Montoro',
      'Rufino De Elizalde',
      'Jose Melchor Romero',
      'La Cumbre',
      'Barrio El Carmen (Oeste)',
      'Arturo Segui',
      'Joaquin Gorina',
      'Isla Martin Garcia',
      'Los Hornos',
      'Ignacio Correas',
      'Lisandro Olmos',
      'Villa Garibaldi',
      'Abasto',
      'Villa Parque Sicardi',
      'Barrio Las Malvinas',
      'Poblet',
      'Esquina Negra',
      'Angel Etcheverry',
      'Barrio Gambier',
      'Alvarez Jonte',
      'La Viruta',
      'Estancia San Ramon',
      'Base Aeronaval De Punta Indio',
      'Chirramberro',
      'Veronica',
      'Las Tahonas',
      'Lujan Del Rio',
      'Punta Piedras',
      'Punta Indio',
      'Monte Veloz',
      'Rancho Barreto',
      'Colonia Tornquist',
      'Pipinas',
      'Micaela Cascallares',
      'Lin Calel',
      'Hueso Clavado',
      'Dunamar',
      'La Constancia',
      'La Polonia',
      'Ruta 3 Km 489',
      'Puente Carucho',
      'La Manga',
      'Balneario Orense',
      'Copetonas',
      'Tres Arroyos',
      'Reta',
      'Ruta 3 Km 490',
      'Orense',
      'Claromeco',
      'Puente Submarino Peral',
      'San Mayol',
      'Villa Rodriguez',
      'Colonia San Juan De Bellocq',
      'Las Vaquerias',
      'San Francisco De Bellocq',
      'General La Madrid',
      'Raulet',
      'Las Bandurrias',
      'Pontaut',
      'La Colina',
      'Libano',
      'Las Nenas',
      'Lastra',
      'Las Martinetas',
      'Estancia Don Pedro',
      'Villa La Arcadia',
      'El 27',
      'San Anselmo',
      'Estancia Lolen',
      'Ombu',
      'La Uruguaya',
      'Pasman',
      'Las Golondrinas',
      'La Ventura',
      'Cascadas',
      'DOrbigny',
      'Huanguelen',
      'Zentena',
      'Paso De Los Chilenos',
      'Santa Trinidad',
      'La Remonta',
      'Coronel Suarez',
      'Cura Malal',
      'Peralta',
      'El Relincho',
      'Villa Gesell',
      'Mar Azul',
      'Mar De Las Pampas',
      'San Lorenzo',
      'La Vasconia',
      'Los Mimbres',
      'Pinar De La Sierra',
      'Las Numancias',
      'La Porteña',
      'Tandil',
      'Haras General Lavalle',
      'La Pastora',
      'Base Aerea Tandil',
      'La Pacifica',
      'Colonia Mariano Moreno',
      'Fulton',
      'El Solcito',
      'De La Canal',
      'Azucena',
      'Gardey',
      'Maria Ignacia',
      'El Centinela',
      'Iraola',
      'El Carmen',
      'El Gallo',
      'Florencio Varela',
      'Villa Santa Rosa',
      'Gobernador Julio A. Costa',
      'Villa Brown',
      'Villa San Luis',
      'Bosques',
      'Ingeniero Juan Allan',
      'Estanislao Severo Zeballos',
      'Villa Vatteone',
      'General Piran',
      'La Baliza',
      'Vivorata',
      'Camet Norte',
      'Ruta 11 Km 480',
      'Mar Chiquita',
      'Santa Clara Del Mar',
      'Nahuel Ruca',
      'Esquina Arguas',
      'Frente Mar',
      'La Tehuelche',
      'Ruta 11 Km 475',
      'La Caleta',
      'La Aldea',
      'Ruta 55 Km 135',
      'Atlantida',
      'Playa Dorada',
      'Mar De Cobo',
      'Coronel Vidal',
      'Calfucura',
      'Juan Bautista',
      'La Sultana',
      'El Hinojal',
      'Fair',
      'Langueyu',
      'La Llegada',
      'Estacion Navas',
      'Loma De Sanders',
      'San Pastor',
      'Udaquiola',
      'Otegui',
      'La Belgica',
      'Estancia Langueyu',
      'San Ignacio',
      'Esquina Larumbe',
      'San Laureano',
      'El Cheforo',
      'Pozo Del Fuego',
      'El Boqueron',
      'Solanet',
      'Las Pajas',
      'Ayacucho',
      'Cangallo',
      'Chacras De Balestra',
      'Las Lagunas',
      'Estacion Juncalito',
      'La Corvina',
      'El Monte',
      'El Medano',
      'Las Viboras',
      'General Conesa',
      'Villa Roch',
      'Carlos Beguerie',
      'La Paz Chica',
      'La Paz',
      'El Gramillal',
      'Roque Perez',
      'Paso San Juan',
      'El Pajon',
      'Juan Atucha',
      'Juan Tronconi',
      'San Martin Del Dulce',
      'El Sexto',
      'Los Medanos',
      'Santiago Larre',
      'Villa Celina',
      'Nordelta',
      'Parque Leloir',
      'Ituzaingo',
    ],
    'AR-C': [
      'Mataderos',
      'Parque Avellaneda',
      'Liniers',
      'Caballito',
      'San Cristobal',
      'Balvanera',
      'Parque Chacabuco',
      'Flores',
      'Villa Urquiza',
      'Villa Pueyrredon',
      'Coghlan',
      'Saavedra',
      'Villa Santa Rita',
      'Villa General Mitre',
      'Villa Del Parque',
      'Villa Devoto',
      'Palermo',
      'Floresta',
      'Villa Real',
      'Villa Luro',
      'Versalles',
      'Velez Sarsfield',
      'Monte Castro',
      'Colegiales',
      'Nuñez',
      'Belgrano',
      'Recoleta',
      'Boedo',
      'Almagro',
      'Parque Chas',
      'Villa Ortuzar',
      'Villa Crespo',
      'Chacarita',
      'Agronomia',
      'Paternal',
      'Retiro',
      'Monserrat',
      'San Nicolas',
      'Puerto Madero',
      'Constitucion',
      'San Telmo',
      'Villa Soldati',
      'Villa Riachuelo',
      'Villa Lugano',
      'Boca',
      'Barracas',
      'Nueva Pompeya',
      'Parque Patricios',
    ],
    'AR-K': [
      'La Falda De San Antonio',
      'El Hueco',
      'La Tercena',
      'La Carrera',
      'Pomancillo',
      'Villa Las Pirquitas',
      'Collagasta',
      'San Jose',
      'Pomancillo Oeste',
      'Pomancillo Este',
      'San Antonio',
      'Alto El Bolson',
      'Las Cuevas',
      'Corral Blanco',
      'Laguna Blanca',
      'Barranca Larga',
      'Villa Vil',
      'Las Juntas',
      'La Salvia',
      'El Rodeo',
      'La Soledad',
      'Lampacito',
      'El Recreo',
      'Fuerte Quemado',
      'Santa Maria',
      'Caspichango',
      'El Cajon',
      'La Ovejeria',
      'El Puesto',
      'Las Mojarras',
      'El Cerrito',
      'Loro Huasi',
      'Recreo',
      'Ovejeria',
      'Quiros',
      'Ancastillo',
      'Palo Parado',
      'Anjuli',
      'El Vallecito',
      'La Renovacion',
      'Las Esquinas',
      'Caballa',
      'La Barranquita',
      'Puerta De Cordoba',
      'Pozancones',
      'La Cerrillada',
      'Pampa Pozo',
      'El Tala',
      'Baviano',
      'La Albigasta',
      'Rio Chico',
      'Santa Rosa',
      'Las Iguanas',
      'Estacion Kilometro 1017',
      'Las Palmitas',
      'La Parada',
      'Icaño',
      'Las Toscas',
      'Las Tejas',
      'Balde De La Pampa',
      'Poman',
      'El Pajonal',
      'Los Cienagos',
      'Iloga',
      'Los Pozos',
      'El Pantanillo',
      'El Sauce',
      'Vilisman',
      'El Alto',
      'Rio De Avila',
      'Tintigasta',
      'Los Alamos',
      'Los Corrales',
      'La Huerta',
      'Sauce Huacho',
      'Oyola',
      'Bella Vista',
      'Infanzon',
      'Guayamba',
      'Los Pedraza',
      'Alto De Las Juntas',
      'Aconquija',
      'El Lindero',
      'La Mesada',
      'Las Pampitas',
      'Agua De Las Palomas',
      'Buena Vista',
      'El Pucara',
      'El Espinillo',
      'Condor Huasi',
      'Punta Del Agua',
      'Rio Potrero',
      'El Alamito',
      'Los Bazan',
      'Los Angeles Norte',
      'Colonia Del Valle',
      'Puesto De Rua',
      'La Paraguaya',
      'Huillapima',
      'Los Chañaritos',
      'Los Angeles Sur',
      'Sisi Huasi',
      'El Bañado',
      'Los Pocitos',
      'Colonia Nueva Coneta',
      'San Pablo',
      'Coneta',
      'Miraflores',
      'El Portezuelo',
      'Antapoca',
      'Los Arbolitos',
      'San Isidro',
      'Santa Cruz',
      'Agua Colorada',
      'Pozo Del Mistol',
      'Villa Dolores',
      'Sumalao',
      'Polcos',
      'Huaycama',
      'La Puntilla',
      'Talamayo',
      'La Represa',
      'Barrio Artaza',
      'Huaco',
      'Belen',
      'Las Lomas',
      'Luna Aguada',
      'Ampujaco',
      'El Pozo',
      'Los Molles',
      'San Francisco',
      'Los Mogotes',
      'El Comedero',
      'El Mojon',
      'La Majada',
      'Ipizca',
      'Amana',
      'Concepcion',
      'La Falda',
      'Navaguin',
      'Ancasti',
      'Anquincila',
      'Potrero De Los Cordoba',
      'El Huayco',
      'La Candelaria',
      'Casa Armada',
      'Tacana',
      'Rinco De Ipizca',
      'Yerba Buena',
      'El Talita',
      'El Quebrachal',
      'La Estancita',
      'Los Bulacios',
      'El Taco',
      'Pozo Lindo',
      'San Pedro',
      'Trampasacha',
      'Telaritos',
      'Capayan',
      'El Milagro',
      'El Quemado',
      'Carranza',
      'Las Animas',
      'La Libertad',
      'El Carrizal',
      'Balde De La Punta',
      'San Martin',
      'Adolfo E. Carranza',
      'Puesto Nuevo',
      'Las Palmas',
      'Las Breas',
      'Chumbicha',
      'La Higuera',
      'Tierra Verde',
      'Las Lajas',
      'Villa De Balcozna',
      'Palo Labrado',
      'Sumampa',
      'La Merced',
      'Monte Potrero',
      'El Bastidor',
      'La Viña',
      'Villa Collantes',
      'Santa Barbara',
      'El Rosario',
      'Amadores',
      'Barro Negro',
      'La Bajada',
      'San Fernando',
      'San Fernando Norte',
      'El Eje',
      'El Durazno',
      'Campo De Las Calivas',
      'Puerta De Corral Quemado',
      'El Tolar',
      'Loconte',
      'Jacipunco',
      'San Nicolas',
      'Portillo Chico',
      'La Antigua',
      'Esquiu',
      'San Agustin',
      'Rio De La Dorada',
      'Palo Cruz',
      'El Chaguaral',
      'La Suerte',
      'Santo Domingo',
      'El Aybal',
      'El Bosquecillo',
      'Pozo De La Orilla',
      'Santa Lucia',
      'La Quinta',
      'Maria Elena',
      'Estacion Kilometro 969',
      'El Cercado',
      'La Zanja',
      'Rio Del Mistolito',
      'Ramblones',
      'El Divisadero',
      'La Horqueta',
      'Garay',
      'La Dorada',
      'San Salvador',
      'Las Flores',
      'Palo Cruz De Abajo',
      'San Rafael',
      'Palo Santo',
      'El Dique',
      'El Clerigo',
      'San Bernardo',
      'El Mistolito',
      'Casa De Piedra',
      'La Guardia',
      'El Quimilo',
      'Santa Marta',
      'El Jumeal',
      'El Moreno',
      'La Horqueta De Arriba',
      'San Lorenzo',
      'San Miguel',
      'Las Tunas',
      'Dos Pocitos',
      'Pozo Del Bajo',
      'Las Cañas',
      'Puesto Del Medio',
      'Las Higueritas',
      'Lavalle',
      'Salauca',
      'Bañado De Ovanta',
      'Cortaderas',
      'Pozo Del Campo',
      'Ampolla',
      'Alta Gracia',
      'Campo Alegre',
      'El Quebrachito',
      'La Isla',
      'Banda De Lucero',
      'Cachiyuyo',
      'Costa De Reyes',
      'Los Balverdis',
      'La Aguadita',
      'Vinquis',
      'Tinogasta',
      'Villa Lujan',
      'El Salado',
      'El Pueblito',
      'Copacabana',
      'Anillaco',
      'Villa San Roque',
      'Rio Colorado',
      'Cerro Negro',
      'Cordobita',
      'Los Palacios',
      'Las Chacras',
      'Los Robledos',
      'Puerta Grande',
      'Los Altos',
      'El Abra',
      'Los Troncos',
      'Alijilan',
      'Manantiales',
      'Monte Redondo',
      'Cuchinoque',
      'Chaquiago',
      'Amanao',
      'Andalgala',
      'La Aguada',
      'Mina Capillitas',
      'El Colegio',
      'Barranca Molle',
      'Vis Vis',
      'Agua Verde',
      'El Potrero',
      'Choya',
      'San Fernando Del Valle De Catamarca',
      'La Calera',
      'La Gruta',
      'Villa San Jose',
      'Londres',
      'Colpes',
      'Isla Larga',
      'La Puerta',
      'La Puerta Sud',
      'Pozo De Piedra',
      'La Estancia',
      'Piedra Larga',
      'Las Vallas',
      'Las Barrancas',
      'Las Granadillas',
      'La Toma',
      'La Aguada De La Toma',
      'Papa Chacra',
      'Huasi Cienaga',
      'Culampaja',
      'Cuesta De Vicuña Pampa',
      'Zarcito',
      'La Cuesta',
      'Minas De Culampaja',
      'Corral Quemado',
      'Rodeo Gervan',
      'San Jose Villa',
      'La Hoyada',
      'San Jose Banda',
      'Chañar Punco',
      'San Jose Norte',
      'Los Saltos',
      'Palo Seco',
      'Paloma Yaco',
      'Medanitos',
      'Quebrada De Jujuy',
      'El Desmonte',
      'Yapes',
      'Famabalasto',
      'Ampajango',
      'La Loma',
      'Casa Del Campo',
      'El Volcan',
      'Agua Amarilla',
      'La Quebrada',
      'Entre Rios',
      'Punta De Balasto',
      'Famatanca',
      'Andalhuala',
      'El Tesoro',
      'Pajanguillo',
      'Los Cerrillos',
      'Rio De Las Casas Viejas',
      'Los Talas',
      'Las Chacritas',
      'Los Castillos',
      'Chuchucaruana',
      'Humaya',
      'Singuil',
      'Los Varela',
      'El Bolson',
      'Las Quinuas',
      'Antofallita',
      'Antofagasta De La Sierra',
      'El Peñon',
      'Los Nacimientos',
      'Incahuasi',
      'Antofalla',
      'La Cienaga Redonda',
      'Carachi Pampa',
      'Mutquin',
      'Colana',
      'Apoyaco',
      'La Perla',
      'Zapicruz',
      'Guanaco Yaco',
      'Las Casitas',
      'El Potrero De Saujil',
      'Rincon',
      'Sijan',
      'Pipanaco',
      'Tucumanao',
      'Saujil',
      'Maderera San Antonio',
      'Joyango',
      'San Jose De Colpes',
      'Chistin',
      'Puerta De San Jose',
      'La Cienaga De Abajo',
      'La Cienaga De Arriba',
      'La Cienaga',
      'Asampay',
      'Hualfin',
      'Rio De Las Cuevas',
      'Quebrada De Hualfin',
      'Farallon Negro',
      'La Tuna',
      'Albigasta',
      'Achalco',
      'Los Morteros',
      'Los Osores',
      'Ayapaso',
      'Tapso',
      'Puerta De Molle Yaco',
      'Cienaga Grande',
      'Rio Grande',
      'Las Papas',
      'La Chilca',
      'Corral De Piedra',
      'La Banda',
      'Fiambala',
      'Palo Blanco',
      'El Retiro',
      'La Puerta De Taton',
      'Casa De Alto',
      'Antinaco',
      'Taton',
      'Chuquisaca',
      'Agua Negra',
      'La Ramadita',
      'Pampa Blanca',
    ],
    'AR-H': [
      'La Escondida',
      'Kilometro 548',
      'Colonia El Cacique Lloron',
      'Legua 41',
      'Gancedo',
      'La Bolsa',
      'Pampa La Porteña',
      'Corzuela Norte',
      'San Antonio',
      'Colonia Juan Lavalle',
      'Pampa Zappa',
      'Colonia San Lorenzo',
      'Campo Canton',
      'Pampa Alsina',
      'Corzuela',
      'Enrique Urien',
      'La Viruela',
      'La Manuela',
      'La Carlota',
      'El Palmar',
      'Guemes',
      'La Armonia',
      'El Quebracho',
      'Lote 126',
      'El Descanso',
      'La Gringa',
      'Los Cienagos',
      '4 De Febrero',
      'Los Pereyras',
      'Torre Del Mirador',
      'Monte Caseros',
      'Pozo El Zapallar',
      'El Mojo',
      'Cruce Peñaloza',
      'Las Margaritas',
      'Rosales',
      'Central Norte',
      'Pozo De La Pava',
      'Las Cuatro Bocas',
      'El Milagro',
      'Los Placeres',
      'Pozo De La Mula',
      'Manantiales',
      'La Esmeralda',
      'Pozo Del Negro',
      'Balbuena',
      'Miraflores',
      'El Retiro',
      'Campo La China',
      'La Media Luna',
      '1° De Mayo',
      'Paso De La Cruz',
      'Lote 76',
      'Santa Victoria',
      'Palo Marcado',
      'Techat',
      'Lote 71',
      'Las Puertas',
      'Pozo La Gringa',
      'El Cañon',
      'Las Hacheras',
      'Los Quirquinchos',
      'Yapeyu',
      'La Cheogue',
      'Nueva Union',
      'Bajada Alta',
      'El Algarrobo',
      'Bajo Hondo',
      'El Quebracho Baleado',
      'San Lorenzo',
      'Los Rosales',
      'El Espinillo',
      'Nueva Pompeya',
      'Lapachito',
      'Colonias Unidas',
      'Colonia Aborigen Chaco',
      'Colonia Aborigen',
      'Puerto Eva Peron',
      'La Estela',
      'Coronel Du Graty',
      'El Cabure',
      'Los Fortines',
      'Colonia La Avanzada',
      'Campo Ugarte',
      'Las Golondrinas Norte',
      'Colonia La Colorada',
      'Golondrinas Sur',
      'Selvas Del Rio De Oro',
      'Campo Antonieli',
      'Loma Florida',
      'La Eduvigis',
      'La Blanca',
      'La Textil',
      'Reserva Fiscal',
      'Lote 51',
      'Lote 18',
      'Barranqueras',
      'Colonia Suriz',
      'Laguna Blanca',
      'La Clotilde',
      'Colonia General Urquiza',
      'Colonia N. Avellan',
      'El Tabacal',
      'Colonia Jose Marmol',
      'Pueblo Clodomiro Diaz',
      'Colonia La Chaqueña',
      'Colonia Pegouriel',
      'Meson De Fierro',
      'Lote 11',
      'Lote 88',
      'El Pastoril',
      'Colonia Juan Jose Paso',
      'Lote 20',
      'Villa Angela',
      'Colonia Pastoril',
      'Colonia Brandsen Sur',
      'Colonia Brandsen Norte',
      'Guayaibi',
      'Colonia Hipolito Vieytes',
      'Colonia Santa Elena',
      'Presidencia De La Plaza',
      'Cuatro Arboles',
      'Fortin Aguilar',
      'Lote 19',
      'Villa Berthet',
      'Lote 15',
      'Lote 5',
      'Lote 21',
      'Lote 17',
      'Colonia San Miguel',
      'Margarita Belen',
      'Costa Ine',
      'Colonia Amadeo',
      'La Leonesa',
      'Quia',
      'Rincon De Luna',
      'Maipu',
      'Rincon Del Zorro',
      'Lapacho',
      'Colonia Benitez',
      'Barrio De Los Pescadores',
      'Puente San Pedro',
      'Campo Rossi',
      'Isla Antequera',
      'Tres Horquetas',
      'Lote 1',
      'Laguna Limpia',
      'Campo Philipon',
      'Makalle',
      'Napenay',
      'Lote 27',
      'Itin',
      'El Ñandubay',
      'Colonia Tañigo Ii',
      'El Jacaranda',
      'Lote 14',
      'Lote 40',
      'Tañigo',
      'Colonia Puerta Del Leon Sur',
      'Colonia Jacaranda Ii',
      'Colonia Campo Hermoso',
      'El Tizon',
      'Lote 33',
      'Hermoso Campo',
      'Colonia Puerta Del Leon',
      'Estacion General Obligado',
      'Villa Jalon',
      'Kilometro 519',
      'Puerto Tirol',
      'Unitan',
      'La Lucinda',
      'Campo Medina',
      'Presidencia Roca',
      'Campo Nuevo',
      'Pampa Chica',
      'El Palmar Chico',
      'Pato Real',
      'Pampa Nardelli',
      'El 42',
      'Rio Muerto',
      'El Boqueron',
      'Las Gomas',
      'Colonia Velez Sarsfield',
      'Estacion Kilometro 884',
      'Pampa Palangana',
      'Pampa Laglaive',
      'Lote 12 Chico',
      'El 50',
      'La Llave',
      '2 De Abril',
      'El Martillo',
      'Toundaian',
      'Pampa Del Gallo',
      'Estacion Kilometro 841',
      'Lote 10',
      'Tres Isletas',
      'Caba Ñaro',
      'La Peligrosa',
      'Colonia Tacuruzal',
      'Pampa Sena',
      'Pampa Ghan',
      'La Matanza',
      'El Aguacerito',
      'La Curva',
      'El Monte Quemado Chico',
      'El Quemado Grande',
      'Colonia Pampa Alelal',
      'El 45',
      'Pampa Aguara',
      'La Rinconada',
      'Campo Winter',
      'Campo La Aurora',
      'El Sombrerito',
      'Colonia San Isidro',
      'Lote 540',
      'Campo Pitteri',
      'Puerto Zapallar',
      'Tres Banderas',
      'La Palmira',
      'El Lunar',
      'Colonia Zapallar Norte',
      'Puesto Expedicion',
      'Lote 92',
      'Colonia Oeste',
      'Costa Guaycuru',
      'General Jose De San Martin',
      'Legua 131',
      'Campo Roffo',
      'Lote 532',
      'Buena Vista',
      'Siete Arboles',
      'El Correntoso',
      'Colonia Esperanza',
      'Campo Blanco',
      'Campo Araoz',
      'Laguna Lobo',
      'El Fiscalito',
      'Colonia Alcala',
      'Colonia San Francisco',
      'Lote 551',
      'Villa Jardin',
      'Rincon Del Rio De Oro',
      'Los Palmares',
      'Colonia Baranda',
      'Resistencia',
      'La Querencia',
      'Colonia Tacuari',
      'El Salado',
      'Colonia General Arenales',
      'Lote 24',
      'Pampa Ombu',
      'Lote 39',
      'Colonia La Tambora',
      'El Rincon',
      'Pampa Verde',
      'Paso Del Oso',
      'Los Blanquizales',
      'Colonia Tres Palmas',
      'Colonia Uriburu',
      'La Lomita',
      'Colonia La Lola',
      'La Esperanza',
      'Colonia Blas Parera',
      'Pampa Bandera',
      'Pueblo Viejo',
      'Lote 38',
      'Colonia Gualtieri',
      'Santa Marta',
      'Lote 22',
      'Campo Riaño',
      'El Totoral',
      'Machagai',
      'Napalpi',
      'Colonia General Lamadrid',
      'Loma Alta',
      'La Dorila',
      'Paralelo 28',
      'El Saladillo',
      'Colonia Palmira',
      'Las Mercedes',
      'Kilometro 34',
      'Basail',
      'Playa Ford',
      'Arbol Solo',
      'Estancia Don Ovidio',
      'Cote Lai',
      'Estancia El 38',
      'Nueva York',
      'Santa Rita',
      'La Sara',
      'Lote 34',
      'San Luis',
      'El Indio',
      'El Lebreton',
      'Chaco Pora',
      'Urundel',
      'La Pinta',
      'Castelli',
      'Santa Lucia',
      'El Valle',
      'San Jose',
      '9 De Julio',
      'El Quinto',
      'Los Magos',
      'Las Carpas',
      'Madre De Dios',
      'San Martin',
      'La Ilusion',
      'Sol De Mayo',
      'Lujan',
      'La Aguada',
      'Santa Agueda',
      'Los Tobas',
      'Taco Pozo',
      'El Paraiso',
      'Alta Esperanza',
      'Santa Elena',
      'La Providencia',
      'San Agustin',
      'La China',
      'La Paloma',
      'Libertad',
      'Pozo Hondo',
      'El Brasil',
      'La Argentina',
      'San Telmo',
      'Los Tigres',
      'Las Flores',
      'Primavera',
      'Santa Cruz',
      'Kilometro 27',
      'El Pintado',
      'El Rosillo',
      'Ojo De Agua',
      'Puerto Vilelas',
      'El Naranjito',
      'Isla Soto',
      'Santa Rosa',
      'La Tranquilidad',
      'Las Delicias',
      'Palo Blanco',
      'Los Frentones',
      'Cuatro Bocas',
      'El Arenal',
      'Pampa Quimili',
      'Colonia Welbers Sur',
      'Campo Marcelino Ugarte',
      'General Capdevila',
      'Pampa Juanita',
      'La Ralera',
      'El Silencio',
      'Lote 30',
      'Concepcion Del Bermejo',
      'Pampa Virgen',
      'Pampa Cuvalo',
      'Pampa El Mangrullo',
      'Pampa Grande',
      'Colonia Pampa Union',
      'Colonia Pampa Bolsa Sur',
      'Pampa Pereyra',
      'La Entrerriana',
      'Colonia La Florida',
      'Ciervo Petiso',
      'Vicentini',
      'Fontana',
      'Villa Oro',
      'Palmar Norte',
      'Colonia Bravo',
      'Colonia San Antonio',
      'Pampa Galvan',
      'Pampa Gonzalez',
      'Pinedo Viejo',
      'Las Leonas',
      'Pampa Dorotier',
      'Pampa Schmidt',
      'General Pinedo',
      'La Picada',
      'Pampa Landriel',
      'Campo Grande',
      'Nueva Poblacion',
      'Alto Alegre',
      'Paso De Los Libres',
      'General Roca',
      'Pozo Del Sapo',
      'Pozo El Toba',
      'Laguna Araujo',
      'La Salvacion',
      'El Palo Santo 2',
      'Pozo Del Mataco',
      'La Ensenada',
      'San Juancito',
      'Montevideo',
      'La Flojera',
      'La Fidelidad',
      'El Triunfo',
      'Santa Maria',
      'M. Kolbas',
      'Santo Domingo',
      'El Palo Santo',
      'Pozo De Los Suris',
      'Pozo Del Gato',
      'Santo Tomas',
      'Pozo Del Gris',
      'El Polenon',
      'La Entrada',
      'Los Madrejones',
      'El Recreo',
      'Palo Flojal',
      'La Nacion',
      'Bajos De Alvarado',
      'La Mesada',
      'California',
      'El Atento',
      'La Fortuna',
      'La Barraca',
      'Pozo Del Salado',
      'Pozo La Osca',
      'Las Blancas',
      'Fuerte Esperanza',
      'Nuevo',
      'Lote 3',
      'Lote 25',
      'Lote 23',
      'Samuhu',
      'Lote 8',
      'Lote 4',
      'Colonia El Toba',
      'La Chiquita Norte',
      'Presidencia Roque Saenz Pena',
      'Pampa Galpon',
      'Lote Xvii',
      'Pampa Gamba',
      'Pampa Alegria',
      'Colonia Cerveza Helada',
      'Pampa Loca',
      'Colonia Pampa Alegria',
      'Colonia Bajo Hondo Chico',
      'Bajo Hondo Grande',
      'La Pobladora',
      'La Mascota',
      'Colonia Bajo Hondo',
      'Colonia Napenay',
      'Ensanche Norte',
      'Colonia Sarmiento',
      'Colonia Rivadavia',
      'El Toroltay',
      'Zaparinqui',
      'El Juramento',
      'Pampa Los Bedogni',
      'Simbolar',
      'El Ñandu',
      'Campo Florido',
      'Pampa Tolosa Chica',
      'Pampa Nueva',
      'La Gloria',
      'Pozo Colorado',
      'Pampa San Martin',
      'Monte Redondo',
      'Campo Bedogni',
      'Campo De Mayo',
      'El Rincon Dichoso',
      'El Cuarenta Y Cuatro',
      'La Soledad',
      'Las Vertientes',
      'Pampa Almiron',
      'Puerta Negra',
      'Juan Jose Castelli',
      'La Geronima',
      'Pampa Tolosa',
      'Miramar',
      'Los Milagros',
      'El Destierro',
      'Colonia Monte Quemado',
      'Pampa Castro',
      'La Selva',
      'El Escondido',
      'Monte Quemado',
      'Pozo De La Tuna',
      'Olla Quebrada',
      'El Telasco',
      'Colonia La Florida Grande',
      'El Paraisal',
      'San Manuel',
      'La Nueva Union',
      'La Mora',
      'Rio Muerto Cruz',
      'La Indiana',
      'Campo Del Alto',
      'Pozo Del Bayo',
      'Pozo Del Toro',
      'La Florida',
      'Viboras Blancas',
      'San Vicente',
      'Costa Rica',
      'Pampa La Cruz',
      'Tolderias',
      'Las Maravillas',
      'El Gramillar',
      'El Asustado',
      'Bella Vista',
      'Paso Sosa',
      'Alberdi',
      'Los Potreros',
      'El Corredero',
      'El Colchon',
      'Las Palomas',
      'El Algarrobal',
      'El Estanque',
      'Pampa Machete',
      'El Palomo',
      'El Zanjon',
      'La Union',
      'Santa Carmen',
      'Las Tunillas',
      'El Progreso',
      'Colonia Cruce Viejo',
      'La Choza',
      'Colonia Popular',
      'Arroyo Saladillo',
      'Puerto Bastiani',
      'Lote 149',
      'La Sabana',
      'Haumonia',
      'Horquilla',
      'Kilometro 25',
      'Charadai',
      'Rio Tapenaga',
      'Estancia Las Unidas',
      'Quijano',
      'La Verde',
      'Colonia El 54',
      'Makalle Viejo',
      'Salto De La Vieja',
      'Tres Ceibos',
      'La Pastoril',
      'Legua  54',
      'Lote 6',
      'Lote 7',
      'Capitan Solari',
      'Campo Novo',
      'Colonia Mixta',
      'Campo Quijano',
      'Kilometro 575',
      'Estancia La Fortuna',
      'Mongay',
      'Limita',
      'Las Palmas',
      'La Isla',
      'El Puerto',
      'Cancha Larga',
      'Lote 9',
      'Colonia La Dificultad',
      'Pajaro Blanco',
      'Las Garcitas',
      'Campo Del Blanco',
      'Indio Muerto',
      'Colonia El Cacique',
      'Colonia Elisa',
      'Ingeniero Barbet',
      'Colonia Mariano Sarratea',
      'Lote 13',
      'Lote 29',
      'Avia Terai',
      'Pampa La Desatinada',
      'Pampa Del Infierno',
      'Pampa Hermosa',
      'Colonia General Lavalle',
      'Pampa Sommer',
      'Pampa Barrera',
      'Pampa Paez',
      'Pampa Avila',
      'Charata',
      'Pampa Cabrera',
      'Pampa Moreno',
      'Pampa Cejas',
      'El Fisco',
      'Tres Estacas',
      'Colonia General Necochea',
      'Pampa Roldan',
      'Pampa Del Cielo',
      'Las Tolderias',
      'Laguna Del Sargento',
      'Pampa Matadero',
      'India Muerta',
      '2 De Mayo',
      'Los Cerritos',
      'Pampa Leguizamon',
      'Pampa Brugnoli',
      'El Triangulo',
      'Recoveco',
      'Pampa Del Zorro',
      'El Estero',
      'El Puca',
      'Pampa Gomez',
      'Las Breñas',
      'Pampa Suarez',
      'La Esterlina',
      'Curva De Novoa',
      'Pampa Sandi',
      'Lote Norassi',
      'Los Arenales',
      'Pampa Mitre',
      'Las Piedritas',
      'Pampa Carnevale',
      'Pampa Ipora Guazu',
      'Santa Justina',
      'Colonia El Urunday',
      'Las Ajenas',
      'Campo Las Puertas',
      'Colonia Campo Del Banco',
      'Colonia Jacaranda Sur',
      'Santa Sylvina',
      'Tartagal',
      'Los Barriles',
      'La Zanja',
      'El Cebilar',
      'Wichi',
      'El Colorado',
      'La Estacion',
      'Campo Noguera',
      'Molle Marcado',
      'Pozo Del Tala',
      'Tres Pozos',
      'El Quebrachal',
      'El Timbo',
      'Bajo Verde',
      'El Ballado',
      'Pozo Del Anta',
      'Vinalito',
      'Lagunita',
      'Laguna Ayarde',
      'Pozo El Gallo',
      'Pozo Del Cincuenta',
      'Bolsa Grande',
      'General Mitre',
      'Pozo Del Tigre',
      'Corralito',
      'Fortin Belgrano',
      'El Sauzal',
      'Pozo Cercado',
      'La Invernada',
      'La Costosa',
      'Pozo La Brea',
      'El Sauzalito',
      'Pozo Largo',
      'Diez De Mayo',
      'Fortin Lavalle',
      'Puerto Lavalle',
      'Colonia El Alazan',
      'Berlin',
      'Villa Rio Bermejito',
      'El Cruce',
      'Tres Mojones Oeste',
      'Tres Mojones Este',
      'Venados Grandes',
      'Estancia El Aguaray',
      'Colonia Cabeza De Tigre',
      'Chorotis',
      'Tres Mojones',
      'El Atajito',
      'Isla Del Cerrito',
      'Lote Fiscal 16',
      'Guaycuru',
      'Las Rosas',
      'Cabral Cue',
      'San Carlos',
      'General Vedia',
      'Tacuari',
      'La Cuchilla',
      'Lote 12',
      'La Tigra',
      'Colonia Domingo Matheu',
      'La Sirena',
      'San Bernardo',
      'Kilometro 62',
      'Pampa Oculta',
      'Campo Largo',
      'Lote 49',
      'Fortin Las Chuñas',
      'Lote 50',
      'Cuarta Legua',
      'Campo Alemany',
      'La Leonor',
      'Colonia Tres Lagunas',
      'Lote Agricola 82',
      'Tres Lagunas',
      'Fortin Brown',
      'Colonia El Ciervo',
      'La Loma',
      'Campo Los Toros',
      'Las Chuñas',
      'Colonia Ombu',
      'Lote 96',
      'El Salvaje',
      'Pampa Del Indio',
      'El Tacuruzal',
      'Santos Lugares',
      'Las Bravas',
      'Quitilipi',
      'La Tambora',
      'Villa El Palmar',
      'Colonia El Paraisal',
      'Reserva Ferrocarril',
      'Estacion La Chiquita',
      'Cacique Dominga',
      'Pampa Legua Cuatro',
      'Colonia General Paz',
      'Campo Feldman',
      'Bajo Hondo Chico',
      'Pampa Esperanza',
      'Puerto Bermejo Nuevo',
      'Puerto Bermejo Viejo',
      'Colonia San Eduardo',
      'Colonia Mirasol',
    ],
    'AR-U': [
      'Carrenleufu',
      'Lago Blanco',
      '28 De Julio',
      'Campamento Villegas',
      'El Rincon',
      'El Blanco',
      'El Cajon',
      'Cholila',
      'Villa Lago Rivadavia',
      'Aldea Apeleg',
      'Lago Rosario',
      'Trevelin',
      'Los Cipreses',
      'Aldea Escolar',
      'Colonia 16 De Octubre',
      'Epuyen',
      'El Coihue',
      'Lago Epuyen',
      'Reserva Area Protegida El Doradillo',
      'Quinta El Mirador',
      'Puerto Madryn',
      'Gualjaina',
      'Frontera De Rio Pico',
      'Paso Del Sapo',
      'Cushamen Centro',
      'Barrio Gasoducto',
      'Barrio Militar - Aeropuerto Militar',
      'Barrio Restinga Ali',
      'Barrio Manantial Rosales',
      'Barrio Castelli',
      'Astra',
      'Barrio Caleta Cordova',
      'Barrio Ciudadela',
      'Comodoro Rivadavia',
      'Barrio Prospero Palazzo',
      'Barrio Güemes',
      'Km. 11 - Cuarteles',
      'Diadema Argentina',
      'Barrio Laprida',
      'Barrio Rodriguez Peña',
      'Barrio Villa S.U.P.E.',
      'Barrio Saavedra',
      'Km. 8 - Don Bosco',
      'Barrio Sarmiento',
      'Acceso Norte',
      'Barrio Caleta Olivares',
      'Km. 5 - Presidente Ortiz',
      'Km. 3 - General Mosconi',
      'Barrio 25 De Mayo',
      'Gobernador Costa',
      'Rio Mayo',
      'Alto Rio Mayo',
      'Playa Magagna',
      'Rawson',
      'Playa Union',
      'Camarones',
      'Chacay Oeste',
      'Talagapa',
      'Chacay Este',
      'Mallin Grande',
      'Chasico',
      'Buenos Aires Chico',
      'El Maiten',
      'Cabo Raso',
      'Malaspina',
      'Garayalde',
      'Los Altares',
      'Facundo',
      'Rada Tilly',
      'Bryn Gwyn',
      'Gaiman',
      'La Angostura',
      'El Hoyo',
      'Pampa Del Castillo',
      'Bahia Bustamante',
      'Holdich',
      'El Trebol',
      'Rio Chico',
      'El Tordillo',
      'Dolavon',
      'Tecka',
      'Trelew',
      'Loma Grande',
      'Drofa Gabets',
      'Drofa Dulog',
      'Fofo Cahuel',
      'El Portezuelo',
      'El Mirador',
      'El Turbio',
      'El Mayoco',
      'Leleque',
      'Costa De Chubut',
      'Lago Fontana',
      'Alto Rio Senguer',
      'Sarmiento',
      'Chacras De Sarmiento',
      'Pio Pio',
      'Cerro Condor',
      'Canquel',
      'Toro Hosco',
      'El Pajarito',
      'El Sombrero',
      'Las Plumas',
      'Florentino Ameghino',
      'Dique Florentino Ameghino',
      'Carhue Niyeo',
      'Taquetren',
      'Colelache',
      'Rio Pico',
      'Bajo Del Gualicho',
      'Punta Delgada',
      'El Riacho San Jose',
      'Arroyo Verde',
      'Punta Norte',
      'Aldea Epulef',
      'Colan Conhue',
      'Bajada Del Diablo',
      'Zanjon Madre',
      'El Mirasol',
      'Alto De Las Plumas',
      'Entre Rios',
      'Las Golondrinas',
      'La Isla',
      'Cerro Radal',
      'Lago Puelo',
      'Aldea Beleiro',
      'Nueva Lubecka',
      'El Molle',
      'Paso De Indios',
      'Pampa De Agnia',
      'Costa Del Gualjaina',
      'Piedra Parada',
      'Buen Pasto',
      'Villa Futalaufquen',
      'Esquel',
      'Rio Percey',
      'Nahuel Pan',
      'Gan Gan',
      'Pampa Negra',
      'Los Manantiales',
      'Gastre',
      'Doctor Ricardo Rojas',
      'Cerro Centinela',
      'Yala Laubat',
      'Blancuntre',
      'Lagunita Salada',
      'El Escorial',
      'El Corcovado Sur',
      'Corcovado',
      'Los Tamariscos',
      'Paso Moreno',
      'Pastos Blancos',
      'Puerto Piramide',
      'Jose De San Martin',
      'Telsen',
    ],
    'AR-W': [
      'Lavalle',
      'Puerto Viejo',
      'La Loma',
      'Rincon De Santa Lucia',
      'Rincon De Soto',
      'El Sombrero',
      'La Marta',
      'San Gregorio',
      'San Isidro',
      'Paso San Juan',
      'Paso Los Angeles',
      'Isla Talar',
      'La Cucucha',
      'Buena Esperanza',
      'Stella Maris',
      'San Martin',
      'El Quebracho',
      'Estancia Santa Rita',
      'Campo Morato',
      'San Antonio',
      'Rincon Del Pago',
      'Invernada',
      'Pago De Los Deseos',
      'Colonia 3 De Abril',
      'Colonia Carolina',
      'Colonia Isabel Victoria',
      'Villa Olivari',
      'Colonia Pando',
      'Colonia Cecilio Echeverria',
      'Cazadores Correntinos',
      'Algarrobal',
      'Cerna',
      'Costa Santa Lucia',
      '9 De Julio',
      'Colonia Juan Ramon Vidal',
      'Cavia Cue',
      'Costa Chica',
      'Tres Cruces',
      'Medio',
      'Empedrado Limpio',
      'Indio Muerto',
      'Costa Grande',
      'Lagunita',
      'Espinallar',
      'Paso Lovera',
      'Albardones',
      'Ramones',
      'Oratorio',
      'Santos Lugares',
      'Arroyo Ponton',
      'Campo Grande',
      'Aguirre Cue',
      'Lomas De Galarza',
      'El Pollo',
      'Peichoto Cue',
      'Maloyas',
      'Chañar',
      'Esquivel Cue',
      'Cerrudo Cue',
      'Colonia Llano',
      'San Luis Del Palmar',
      'Tacuaral',
      'Monte Grande',
      'Puerto Tala',
      'Estacion Torrent',
      'Pelon Arroyo',
      'Estacion Manuel Derqui',
      'Paso Quintana',
      'Arroyo Solis',
      'Arroyo El Sombrero',
      'El Pollo Este',
      'Costa De Empedrado',
      'Colonia Sanz',
      'San Juancito',
      'Rincon Del Madregon',
      'San Lorencito',
      'Ocanto Cue',
      'Empedrado',
      'Santa Rosa',
      'Colonia Brougnes',
      'Pehuajo',
      'Rincon Del Sombrero',
      'Colonia Imparciales',
      'Villa San Isidro',
      'Rincon De Empedrado',
      'Lomas De Empedrado',
      'Real Cue',
      'Ahoma Sur',
      'Bernachea',
      'El Carrizal',
      'San Jose',
      'Salinas Grande',
      'Campo Vallejos',
      'Laguna Sirena',
      'Gobernador Juan E. Martinez',
      'Colonia Gobernador Gallino',
      'Casualidad',
      'Palermo',
      'Monte Florido',
      'El Bonete',
      'Ensenadita',
      'Riachuelo San Jose',
      'Ensenada Grande',
      'Puerto Gonzalez',
      'San Cosme',
      'Santo Domingo',
      'Rincon De Luna',
      'Los Lapachos',
      'Loma Alta',
      'Concepcion',
      'Pairiri',
      'Yuqueri',
      'Carambola',
      'Yajarave',
      'Paso Lucero',
      'Espinillos',
      'Arroyo Caabi',
      'Batel',
      'Rodeo Pora',
      'Paso Batalla',
      'Paso Itu',
      'Las Palmitas',
      'Pancho Cue',
      'Alvear',
      'Altamira',
      'Aguapey',
      'Pirayu',
      'Arroyo Mendez',
      'Santa Ana',
      'Santa Isabel',
      'Frontera',
      'Colonia Juan Pujol',
      'Timboy',
      'Puisoye',
      'Palmar Grande',
      'Fernandez',
      'Colonia San Gregorio',
      'Colonia Buena Vista',
      'Colonia Mocoreta',
      'Piedritas',
      'Mocoreta',
      'Colonia San Andres',
      'Colonia San Martin',
      'Ayala Cue',
      'La Flecha',
      'Villa San Ramon',
      'Capillita',
      'Cerrito',
      'Loma Villanueva',
      'Timbo Cora',
      'Talaty',
      'Villanueva',
      'Paso Florentin',
      'El Zapallo',
      'Nuestra Señora Del Rosario De Caa Cati',
      'Yacarey',
      'Santa Rita',
      'Rincon Guazu',
      'Guayu',
      'Villa La Palmira',
      'Itati',
      'Scorza Cue',
      'Estancia San Benito',
      'El Abra',
      'Colonia General Ferre',
      'Cruz De Los Milagros',
      'Cebollas',
      'Lomas Este',
      'Carrizal Norte',
      'Lomas Norte',
      'Lomas Sur',
      'Muchas Islas',
      'Las Garzas',
      'Colonia Progreso',
      'Isla Alta',
      'Raices Norte',
      'Bella Vista',
      'Juan Diaz',
      'Desmochado',
      'Rincon Santa Maria',
      'Buena Vista',
      'Puerto Valle',
      'Isla Apipe Chico',
      'Caa Carai',
      'Libertad',
      'Ituzaingo',
      'Paso Moreno',
      'Tabay',
      'El Pindo',
      'Santa Teresita',
      'El Progreso',
      'San Juan',
      'Tapebicua',
      'Santa Librada',
      'Los Flotadores',
      'Chacras Norte',
      'El Carmen',
      'Sarandi',
      'Santa Barbara',
      'Santa Catalina',
      'La Floresta',
      'Tranquera Cadena',
      'El Rosario',
      'Esquina',
      'Guayquiraro',
      'Campo Pernizza',
      'La Dorita',
      'Campo La Emilia',
      'El Cerro',
      'San Fernando',
      'Picada Amara',
      'Malvinas Sur',
      'Malvinas Norte',
      'Arroyo Soro',
      'Rincon De Sarandi',
      'Paso Hu',
      'Santa Maria',
      'Inga',
      'Tres Mojones',
      'Campo Romero',
      'Abra Guazu',
      'Villa Rosa',
      'Colonia Bonzon',
      'Colonia 2 De Abril',
      'Pedro R. Fernandez',
      'Estacion Santiago Alcorta',
      'Kilometro 137',
      'Ibahay',
      'Angostura',
      'Arerungua',
      'Ita Ibate',
      'Ayui',
      'Linconia',
      'Los Andes',
      'Bonpland',
      'Colonia Carlos Pellegrini',
      'Camba Trapo',
      'Estancia Ovecha Raty',
      'Colonia San Justo',
      'Estancia San Vicente',
      'La Criolla',
      'San Alonso',
      'Jesus Cue',
      'Los Arroyos',
      'Las Marias',
      'Espinillo',
      'El Altillo',
      'Cailar Cue',
      'Gobernador Igr.Valentin Virasoro',
      'Caabi Poi',
      'Monte Caseros',
      'Parada Labougle',
      'Tacuabe',
      'Paso Vallejos',
      'Campo General Avalos',
      'Itacumbu',
      'Dos Vias',
      'Fortuna',
      'Puerto Ceibo',
      'Desaguadero',
      'Ingenio Primer Correntino',
      'Riachuelo Bardeci',
      'Ibate Pora',
      'Las Flores',
      'Santa Rosa (Rural)',
      'La Selva',
      'San Agustin',
      'Colonia Caiman',
      'Aquino',
      'Batara',
      'La Mansion',
      'Saladas',
      'Pago Arias',
      'San Francisco',
      'Pago Alegre',
      'Lomas',
      'Angua Costa Santa Lucia',
      'Casuarinas',
      'Arroyito',
      'Angua',
      'Colonia Oficial Sargento Juan B. Cabral',
      'Paso Naranjito',
      'Rincon De Vences',
      'Maloyitas',
      'Lomas De Vallejos',
      'Pasito',
      'Los Vences',
      'Costa Sud Maloyas',
      'Rincon De Zalazar',
      'Villa Libertad',
      'Rosado Grande',
      'Colonia La Elisa',
      'Colonia Laurel',
      'Arroyo Paraiso',
      'Santa Angelica',
      'Lujan',
      'San Roque',
      'Estancia Buena Vista',
      'Arroyo Gonzalez',
      'Yazuca',
      'La Maria',
      'San Lorenzo',
      'Arroyo Ceibal',
      'Rincon De Ambrosio',
      'Rincon De San Lorenzo',
      'Punta Ifran',
      'Yatayti Calle',
      'Costa Batel',
      'Puente Batel',
      'Paso Lopez',
      'El Cerrito',
      'Ombucito',
      'La Florida',
      'Nueva Esperanza',
      'Bañado Yatay',
      'Quiyati',
      'Las Palmas',
      'San Salvador',
      'Paso De Los Libres',
      'Palmar',
      'La Amelia',
      'San Joaquin',
      'Remanso',
      'Aguape',
      'Yapeyu',
      'Mariano I. Loza',
      'Malezal',
      'Perugorria',
      'Paso Tala',
      'Vaca Paso',
      'La Lata',
      'Aguay',
      'Arroyo Seco',
      'Palmitas',
      'Oscuro',
      'Chavarria',
      'Tacuaritas',
      'Saenz Valiente',
      'Colonia Buen Retiro',
      'Juan Pujol',
      'Tres Bocas',
      'Arroyo Mota',
      'Colonia San Francisco',
      'Yatay',
      'Estancia La Cautiva',
      'Vaca Cua',
      'Maria Carape',
      'Arroyo Marote',
      'Pago Largo',
      'Curuzu Cuatia',
      'Pedro Diaz Colodrero',
      'Baibiene',
      'Paso De Las Piedras',
      'El Chañar',
      'Colonia Pairiri',
      'Maria Chica',
      'Estancia San Juan',
      'Avalos',
      'Emilio R. Coni',
      'Tierra Colorada',
      'Tres Bocas Del Yatay',
      'Arroyo Portillo',
      'Garay',
      'El Ceibo',
      'Tunitas',
      'Rincon De Tunas',
      'Capitan Joaquin Madariaga',
      'Urrutia',
      'Colonia Liebig S',
      'La Cachuera',
      'Las Lomas',
      'Kilometro 517',
      'Playadito',
      'Dos Hermanas',
      'Naranjito',
      'Timbocito',
      'Toro Ratay',
      'La Concepcion',
      'Estancia Santa Clara',
      'Maria Luisa',
      'Rincon Del Ombu',
      'Boqueron',
      'Rincon Tranquera General',
      'Paso Pucheta',
      'Rincon Del Socorro',
      'Pay Ubre Chico',
      'Callejon',
      'Irupe',
      'Rincon De Yaguary',
      'Tunita',
      'San Dionisio',
      'Uguay',
      'Ita Cora',
      'Mercedes',
      'Santa Juana',
      'Guayaibi',
      'Arroyo Grande',
      'Aguaceritos',
      'Ramada Paso',
      'Rincon Yurubi',
      'Santa Elvira',
      'Tatacua',
      'Colonia Tatacua',
      'Cuay Grande',
      'Los Bretes',
      'Virocay',
      'Santo Tome',
      'Gomez Cue',
      'Cuay Chico',
      'San Gabriel',
      'Coronel Desiderio Sosa',
      'Estancia San Pedro',
      'Gambai',
      'Galarza',
      'Estacion Caza Pava',
      'Atalaya',
      'Colonia Gobernador Ruiz',
      'Laurel',
      'Hormiguero',
      'Mbocaya',
      'Santa Sixta',
      'Colonia Madariaga',
      'Curuzu Laurel',
      'San Nicolas',
      'San Miguel',
      'Silvero Cue',
      'Roque Cue',
      'Estancia Dos Hermanas',
      'Santa Lucia',
      'La Bolsa',
      'Villa Aquino',
      'Colonia Martinez',
      'Colonia San Jose',
      'Villa Cordoba',
      'Parada Pucheta',
      'Paso Ledesma',
      'Los Pinos',
      'Valencia',
      'Yahape',
      'Beron De Astrada',
      'Tatare',
      'Isla Sola',
      'Punta Marucha',
      'San Pedro',
      'Colonia Pucheta',
      'Soledad',
      'San Jorge',
      'Isla La Josefina',
      'Estancia Don Raul',
      'Villa Leonor',
      'Rincon De Gomez',
      'Los Ceibos',
      'El Transito',
      'Punta Batel',
      'Maruchas',
      'Las Mercedes',
      'Manantiales',
      'Paranacito',
      'Batel Araujo',
      'Goya',
      'Colonia Elenita',
      'Pto. Boca',
      'Estancia Rincon De Luna',
      'San Ramon',
      'Santillan',
      'Villa Lujan',
      'Pago Redondo',
      'Colonia Mercedes Cossio',
      'Colonia Porvenir',
      'Maruchitas',
      'Mora',
      'Colonia Timbo',
      'Laguna Pucu',
      'Cocalito',
      'Colonia Sauce',
      'Isla El Talar',
      'Corrientes',
      'Pirayui',
      'Paso Martinez',
      'Laguna Paiva',
      'Laguna Soto',
      'Laguna Brava',
      'La Costa',
      'Las Chispas',
      'Jose Rafael Gomez',
      'Veloso',
      'Chacras',
      'Santa Teresa',
      'Isipoyu',
      'Costa San Lorenzo',
      'Mburucuya',
      'Punta Grande',
      'Blanco Cue',
      'La Yerba',
      'Paso Aguirre',
      'Estingana',
      'Guaviravi',
      'Los Eucaliptos',
      'Paso Bermudez',
      'Rincon Del Sauce',
      'Arroyo Horqueta',
      'Sauce',
      'Francisco Gomez',
      'Rincon De Animas',
      'La Estrella',
      'Ovejita',
      'Punta De Oro',
      'San Carlos',
      'Monte Hermoso',
      'Costa Rio Parana',
      'El Rincon',
      'Paso De La Patria',
      'Costa Toledo',
      'Puerto Araza',
      'Riachuelo',
      'San Cayetano',
      'San Juan Tadeo',
      'Colonia Libertad',
      'Parada Acuña',
      'Estacion Libertad',
      'Barranqueritas',
      'San Juan Loma',
      'Loreto',
      'Arroyo Balmaceda',
      'Bastidores',
      'Estancia San Carlos',
      'Tres Cerros',
      'Alen Cue',
      'El Orejano',
      'El Chaquito',
      'La Horqueta',
      'Costa Guaviravi',
      'Horqueta De Guaviravi',
      'Yacare',
      'Isoqui',
      'La Cruz',
      'San Eduardo',
      'Capita Mini',
      'Cuenca',
      'Felipe Yofre',
      'Garruchos',
      'Colonia Union',
      'San Horacio',
      'Coronel Abraham Schweizer',
      'Libertador',
      'Paso Lallana',
      'Pueblo Libertador',
      'Laguna Ita',
      'Paso Cejas',
      'Las Cuchillas',
      'La Rinconada',
      'Campo Bordon',
      'Arrocera Papelha',
      'La Casualidad',
      'Herlitzka',
      'Rincon De Navarro',
      'Rincon De Meza',
      'Laguna Negra',
      'Estancia Garabata',
      'Riachuelito',
      'Lomas De Gonzalez',
      'Lomas De Aguirre',
      'Rincon De La Merced',
    ],
    'AR-X': [
      'Las Chacras',
      'Los Cadillos',
      'Villa Quilino',
      'Quilino',
      'Mogotes Asperos',
      'Ojo De Agua',
      'Estancia De Guadalupe',
      'San Felipe',
      'Tres Lomas',
      'La Argentina',
      'Laborde',
      'Bell Ville',
      'Colonia Compiani',
      'San Roque',
      'Cerro Pelado',
      'Amboy',
      'El Mojon',
      'El Guanaco',
      'La Maza',
      'Santa Catalina',
      'La Piedra Blanca',
      'Agua De Oro',
      'Pozo De Molina',
      'Pozo Del Simbol',
      'El Jordan',
      'La Barranca',
      'Pozo De Las Ollas',
      'Punta Del Monte',
      'La Victoria',
      'San Miguel',
      'Alto De Fierro',
      'Santa Isabel',
      'La Penca',
      'San Antonio',
      'La Victoria Oeste',
      'Campo Grande',
      'La Victoria (E)',
      'Salsacate',
      'Villa Viso',
      'Casa Blanca',
      'Taninga',
      'Pueblo Viejo',
      'San Eusebio',
      'Las Lagunitas',
      'La Tigra',
      'Colonia La Verde',
      'Colonia Marcos Sastre',
      'Campo Los Corralitos',
      'Colonia El Dorado',
      'Campo Los Algarrobos',
      'Colonia La Concordia',
      'San Meliton',
      'Cayuqueo',
      'Campo Costa',
      'Colonia La Union',
      'La Herradura',
      'San Severo',
      'Campo Santa Rita',
      'Colonia 10 De Mayo',
      'Colonia El Balquin',
      'Colonia El Piquillin',
      'Colonia Corral Del Bajo',
      'Campo Las Chacras',
      'Cuatro Caminos',
      'Potro Muerto',
      'El Ucle',
      'Corral Del Bajo',
      'Campo Vionnet',
      'Colonia Pico Chaco',
      'Ramon J. Carcano',
      'Colonia La Lola',
      'Colonia La Celina',
      'Colonia El Descanso',
      'Cnia Norte',
      'Colonia Esperanza',
      'Colonia Corral De Guardia',
      'Campo Santa Elena',
      'Colonia La Leoncita',
      'Campo San Elias',
      'Campo La Luisita',
      'Campo Los Galgos',
      'Campo Crespo-P/Ballesters',
      'Campo Yanzi',
      'Colonia Santa Rita',
      'Luca',
      'Leones',
      'El Vergel',
      'Estacion Colonia Tirolesa',
      'El Quebrachal',
      'Colonia Los Algarrobos',
      'La Corina',
      'Colonia Rio Chico',
      'Colonia Tirolesa',
      'Santa Elena',
      'La Puerta',
      'Lozada',
      'Salsipuedes',
      'La Estancita',
      'El Pueblito',
      'Pintos',
      'El Rosario',
      'La Cumbre',
      'San Ignacio (Loteo Velez Crespo)',
      'Santa Monica',
      'Santa Rosa De Calamuchita',
      'Arroyo Seco',
      'Los Chañaritos',
      'Los Talares',
      'La Rancherita',
      'Villa Huidobro',
      'Manfredi',
      'Cuesta Blanca',
      'Dean Funes',
      'Villa Del Prado',
      'Cavanagh',
      'Buena Vista',
      'San Geronimo',
      'Las Peñas',
      'Campo Scarafiocca',
      'Colonia Garzon',
      'Campo El Chilo',
      'Campo Fioretta',
      'Capilla Garzon',
      'Campo Perotti',
      'Colonia Lola',
      'Campo Caprivi',
      'Las Petacas',
      'Campo Las Selvas',
      'Campo San Alfredo',
      'Campo Macagno',
      'Campo Rossi',
      'Campo Bertoglio',
      'Cuesta Del Rio',
      'Colonia Bella Vista',
      'Campo Nigro Sur',
      'Campo Janon',
      'Campo Nigro Norte',
      'Campo La Rosa',
      'Colonia Santa Catalina',
      'Campo Del Bel',
      'Campo Marengo',
      'Puente Las Selvas',
      'Colonia Los Tamarindos',
      'Campo Boaglio',
      'Campo Battiston',
      'San Esteban',
      'Saldan',
      'Ticino',
      'Isla Verde',
      'Sinsacate',
      'Carnerillo',
      'Cerro Colorado',
      'Los Zorros',
      'Arroyo Los Patos',
      'Toro Pujio',
      'Alejo Ledesma',
      'Monte Maiz',
      'Guatimozin',
      'Onagoity',
      'Villa Santa Eugenia',
      'Alpa Corral',
      'Las Junturas',
      'El Brete',
      'El Simbolar',
      'El Tropiezo',
      'Piquillin',
      'Caminiaga',
      'Cañada Del Sauce',
      'Tala Cruz',
      'Los Charcos',
      'Alto De Los Quebrachos',
      'La Rinconada',
      'Los Eucaliptos',
      'El Zapallar',
      'Estancia Marull',
      'Campo Alegre',
      'El Crispin',
      'General Roca',
      'Colonia V. Aguero',
      'Colonia Vicente Aguero',
      'Transito',
      'Villa Del Transito',
      'Lutti',
      'Los Vallecitos',
      'Carahuasi',
      'El Espinillo',
      'Las Acequias',
      'Villa Oeste',
      'Villa Nueva',
      'San Pedro Norte',
      'La Laguna',
      'Barrio Santa Isabel',
      'Capilla Del Monte',
      'Pampayasta Norte',
      'Campo Asinari',
      'San Pedro De Gutemberg',
      'Gutemberg',
      'General Fotheringham',
      'Porteña',
      'Kilometro 691',
      'Montecristo',
      'Media Luna Sur',
      'Capitan General Bernardo O`Higgins',
      'Las Toscas',
      'San Rafael',
      'Santa Maria',
      'Balde De La Mora',
      'La Linea',
      'San Vicente',
      'La Reduccion',
      'El Cadillo',
      'Villa Cura Brochero',
      'Chancani',
      'Las Palmas',
      'El Potrero',
      'Jaime Peter',
      'Chuña',
      'Colonia Barge',
      'Castro Urdiales',
      'Rosales',
      'Las Gramillas',
      'Capilla Del Carmen',
      'El Durazno',
      'Rio Del Durazno',
      'Villa Yacanto',
      'Cañada De Machado',
      'Bengolea',
      'La Quinta',
      'El Rastreador',
      'Villa Tronquils',
      'Las Caleras',
      'Tosquitas',
      'Pueblo Italiano',
      'El Salto',
      'Los Hoyos',
      'Santo Domingo',
      'La Costa',
      'Cañada De Luque',
      'Estacion Luxardo',
      'Plaza Luxardo',
      'Cabalango',
      'Las Vertientes',
      'Laguna Larga',
      'Arroyo Cabral',
      'Mattaldi',
      'La Pampa',
      'Charras',
      'Pilar',
      'Jesus Maria',
      'Oncativo',
      'Plaza Videla',
      'Colonia Videla',
      'San Joaquin',
      'Villa Pastora',
      'Ciudad De Los Niños',
      'Parque Norte',
      '1 De Agosto',
      'Juarez Celman',
      'Villa Los Llanos',
      'Villa El Fachinal - Parque Norte - Guiña',
      'Almirante Brown',
      'Guiñazu Norte',
      'Pedro E. Vivas',
      'Kilometro 658',
      'Las Saladas',
      'La Carbonada',
      'Campo Buena Esperanza',
      'San Antonio Norte',
      'Bajo Grande',
      'Bajo Chico',
      'Socavones',
      'Rio Del Medio',
      'Cosme Sur',
      'La Maria Virginia',
      'La Acequiecita',
      'Tres Pozos Sud',
      'Cosme Norte',
      'Los Tajamares',
      'Rosario Del Saladillo',
      'Puesto De Fierro',
      'Los Troncos',
      'Los Guindos',
      'El Alcalde',
      'Campo Ramallo',
      'El Bagual',
      'Pozo De La Loma',
      'Paso Del Sauce',
      'La Colorada',
      'Bajo Hondo',
      'Nueva Andalucia',
      'Puesto De Afuera',
      'Capilla De Dolores',
      'Monte Del Rosario',
      'Barranca Colorada',
      'Colonia El Fortin',
      'Las Acacias',
      'Colonia San Rafael',
      'Los Castaños',
      'El Quebracho',
      'Las Averias',
      'Buey Muerto',
      'La Vuelta',
      'Chacras Norte',
      'Puesto Pucheta',
      'Las Heras',
      'Isla Larga',
      'Chacras Sur',
      'Colonia La Argentina',
      'Esperanza',
      'El Carrizal',
      'Los Alvarez',
      'Las Bandurrias',
      'Las Palmitas',
      'Pozo De La Esquina',
      'El Manantial Sur',
      'Boca Del Rio',
      'Inriville',
      'El Tio',
      'Los Cisnes',
      'Campo Agñero',
      'Villa Ascasubi',
      'Campo Caffaratti',
      'Campo Picatto',
      'Santa Rosa De Rio Primero',
      'Oliva',
      'Ordoñez',
      'Villa Carlos Paz',
      'Santa Cruz Del Lago',
      'Despeñaderos',
      'General Cabrera',
      'General Baldissera',
      'Colonia Iturraspe',
      'El Alto',
      'Anisacate',
      'Costa Azul',
      'Embalse',
      'Saira',
      'Chilibroste',
      'Matorrales',
      'Colonia El Acequion',
      'Alto Alegre',
      'Campo Santa Teresa',
      'Coronel Baigorria',
      'Marull',
      'Capilla Vieja',
      'Falda De Los Reartes',
      'Villa General Belgrano',
      'Cerro Hermoso',
      'Las Higueras',
      'Villa Sarmiento',
      'La Playosa',
      'La Playa',
      'Lucio V. Mansilla',
      'Talaini',
      'Colonia Bismarck',
      'Adelia Maria',
      'Wenceslao Escalante',
      'Rio Segundo',
      'Villa El Tala',
      'Monsalvo',
      'La Cascada',
      'Villa Alpina',
      'Cerro Champaqui',
      'Arroyo San Antonio',
      'El Cano',
      'Sol De Mayo',
      'La Dormida',
      'Atos Pampa',
      'Colonia Las Pichanas',
      'Las Varas',
      'Chajan',
      'Cosquin',
      'Olaen',
      'Quebrada De Luna',
      'Bosque Alegre',
      'Puesto Ramallo',
      'La Paquita',
      'Las Isletillas',
      'Cintra',
      'Cassaffousth',
      'Campo Minetti',
      'Campo Scaramuzza',
      'Campo Los Matorrales',
      'Oratorio De Peralta',
      'Colonia Norte',
      'Colonia Dos Hermanas',
      'Campo Carolini',
      'La Lagunilla',
      'Campo Martolino',
      'Campo La Sirena',
      'Costa Del Carmen',
      'La Ramada',
      'Campo El Polvorin',
      'Colonia Adela',
      'A. De Alvarez N° 1',
      'Costa Alegre',
      'Arroyo De Alvarez Nro 2',
      'Colonia San Jose De Aguas Coloradas',
      'Campo Los Tres Arboles',
      'Corral De Arroyo',
      'Campo Baudin',
      'La Represa',
      'Campo Daniele',
      'San Jose',
      'Campo Fichetti',
      'Campo La Ramada',
      'Campo La Angelina',
      'Paso De Velez',
      'Pozo De Las Yeguas',
      'Campo Marchand',
      'Campo Yañez',
      'La Isla',
      'La Ribera',
      'Rincon Viejo',
      'Lagunilla',
      'Campo Falco',
      'Campo El Taco',
      'Santa Maria De Punilla',
      'Mallin',
      'Villa San Jose',
      'Simbolar',
      'Assunta',
      'Rincon',
      'Villa Lago Azul',
      'Villa Santa Cruz Del Lago',
      'General Deheza',
      'Villa La Bolsa',
      'Los Hornillos',
      'Dos Arroyos',
      'El Pantanillo',
      'Berrotaran',
      'Los Romeros',
      'Conlara',
      'Los Gigantes',
      'Puesto Pedernera',
      'Rio Tiu Mayu',
      'Pampayasta Sur',
      'Villa Rossi',
      'Luque',
      'Agua Del Molle',
      'Copacabana',
      'Monte Ralo',
      'Coronel Moldes',
      'Villa Giardino',
      'Villa Gutierrez',
      'Morrison',
      'La Posta',
      'Las Perdices',
      'Elena',
      'James Craik',
      'Colonia Rocha',
      'Colonia Stabile',
      'Modestino Pizarro',
      'El Campito',
      'La Nacional',
      'Colonia White',
      'Pegasano',
      'Colonia Los Ceibos',
      'Estacion Lecueder',
      'Campo San Juan',
      'Estancia La Colorada',
      'De La Serna',
      'Estancia La Vanguardia',
      'Ingeniero Malmen',
      'Villa Moderna',
      'El Pampero',
      'Estancia La Pacifica',
      'Los Alfalfares',
      'Colonia La Juanita',
      'Estancia La Margarita',
      'Campo La Adela',
      'Carrilobo',
      'Corral Quemado',
      'Villa Parque Siquiman',
      'Ucacha',
      'Mi Granja',
      'El Barreal',
      'San Martin',
      'Pozo Nuevo',
      'Rayo Cortado',
      'Charbonier',
      'Las Rabonas',
      'Agua De Ramon',
      'Piedrita Blanca',
      'El Chacho',
      'Cruz Del Eje',
      'Rio Hondo',
      'La Gloria',
      'La Ventana',
      'Mina Clavero',
      'Giulo Cesare',
      'Puente Del Cura',
      'San Francisco',
      'Plaza San Francisco',
      'Capilla De Siton',
      'Los Cedros',
      'Corralito',
      'Rio Primero',
      'Obispo Trejo',
      'Camilo Aldao',
      'Zuri Pozo',
      'Dominguito',
      'Bañado De Soto',
      'Rafael Garcia',
      'Campo Novarino',
      'Colonia Molles',
      'Colonia El Overo',
      'Campo Las Lonjas',
      'Campo Santa Florinda',
      'Colonia Maizales-Leones',
      'Colonia Los Vascos',
      'Colonia Ermila',
      'Campo Laborde',
      'La Carolina',
      'Colonia Armando',
      'Colonia El Chaja',
      'Colonia Garibaldi',
      'Campo Evangelist',
      'Campo Nata',
      'Campo La Albina',
      'Colonia Calchaqui',
      'Colonia Carlos Casado',
      'Campo Gaucho Nuevo',
      'Colonia Luis Velez',
      'Colonia Regernsburger',
      'Barrio La Fortuna',
      'Campo Carlitos',
      'Colonia Jerusalen',
      'Campo Gerbaudo',
      'Colonia Veinticinco',
      'Campo El Zorro',
      'Colonia Mackey',
      'Balnearia',
      'Colonia Almada',
      'Las Bajadas',
      'Soconcho',
      'Paso Del Durazno',
      'Los Pozos',
      'Las Playas',
      'Suco',
      'Pacheco De Melo',
      'Pincen',
      'Calchin Oeste',
      'Miramar',
      'Villa Amancay',
      'Rio Grande',
      'Panaholma',
      'Pozo Del Tigre',
      'General Paz',
      'Idiazabal',
      'Colonia Santa Maria',
      'Colonia Prosperidad',
      'Pueblo Comechingones',
      'Villa San Esteban',
      'Villa Los Patos',
      'El Perchel',
      'Paloma Pozo',
      'Cienaga De Britos',
      'Tres Arboles',
      'Canteras Quilpo',
      'Canteras De Quilpo',
      'Las Ollas',
      'La Brea',
      'Represa De Morales',
      'El Duraznal',
      'El Puestito',
      'Pichanas',
      'El Barrialito',
      'Los Escalones',
      'Santa Ana',
      'Piedras Anchas',
      'Oro Grueso',
      'El Rincon',
      'Los Leones',
      'Tabaquillo',
      'El Saladito',
      'Bajo Lindo',
      'Majada De Santiago',
      'Mandala',
      'Iglesia Vieja',
      'Mesa De Mariano',
      'Las Tapias',
      'Huanchillas',
      'Tancacha',
      'Italo',
      'Rio Bamba',
      'Esquina',
      'Rangel',
      'Tres Esquinas',
      'Punta Del Agua',
      'Ranqueles',
      'Marcos Juarez',
      'Saturnino Maria Laspiur',
      'Alejandro Roca',
      'Villa La Rivera',
      'Villa Quillinzo',
      'La Aguadita',
      'El Barrial',
      'Pinas',
      'Cerro Bola',
      'Los Morteritos',
      'Media Naranja',
      'Puesto Del Gallo',
      'Paso Viejo',
      'Negro Huasi',
      'Las Cañadas',
      'Santiago Temple',
      'Juan Bautista Alberdi',
      'Bajo De Corrales',
      'Ambul',
      'Alto Grande',
      'El Mirador',
      'Altos De Chipion',
      'Rodeo Viejo',
      'La Aguada',
      'Las Albahacas',
      'Villa Parque Santa Ana',
      'Mi Valle',
      'Campos Del Virrey',
      'Arroyo Algodon',
      'San Marcos',
      'Seeber',
      'Huerta Grande',
      'Eufrasio Loza',
      'San Ignacio',
      'Santa Magdalena',
      'Santa Eufemia',
      'San Francisco Del Chañar',
      'Los Cerrillos',
      'Viamonte',
      'Colonia Monte De Los Gauchos',
      'Monte De Los Gauchos',
      'La Carlota',
      'Colonia Valtelina',
      'Cruz Alta',
      'Chazon',
      'Rio De Bustos',
      'Villa Tulumba',
      'Las Juntas',
      'La Majadilla',
      'Colonia San Bartolome',
      'El Eje De Candelaria',
      'Villa Candelaria Norte',
      'San Luis',
      'Falda Del Carmen',
      'Barrio Las Quintas',
      'Valle Alegre',
      'Tuclame',
      'Bella Vista',
      'Villa De Soto',
      'Los Molles',
      'Alto Resbaloso - El Barrial',
      'Villa De Las Rosas',
      'Rodeo De Piedra',
      'Quebrada De Los Pozos',
      'El Valle',
      'Villa La Viña',
      'Laboulaye',
      'San Roque Del Lago',
      'Bialet Masse',
      'La Cautiva',
      'San Pedro',
      'San Sebastian',
      'El Bordo',
      'Los Callejones',
      'General Levalle',
      'R. De La Cruz Oeste',
      'Cerro San Lorenzo',
      'Huerta Vieja',
      'Rio De Los Sauces',
      'Villa San Lorenzo',
      'Campo Bara',
      'Campo Ojo De Agua',
      'Hernando',
      'Colonia Las Cuatro Esquinas',
      'Pozo Del Molle',
      'San Ernesto',
      'Las Cortaderas',
      'Campo La Calera',
      'Chañaritos',
      'La Barranquita',
      'San Bernardo',
      'Campo La Aguada',
      'La Gilda',
      'Campo Los Jagueles Sud',
      'Santa Flora',
      'Colonia La Madera',
      'El Potosi',
      'Colonia El Carmen',
      'General Soler',
      'Campo Zanon',
      'Colonia La Tercera',
      'Campo De La Torre',
      'Rio Seco',
      'Colonia 25 De Mayo',
      'La Esperanza',
      'Carolina',
      'Colonia El Toro',
      'Laguna Seca',
      'Colonia La Providencia',
      'Colonia Orcavi',
      'Campo Leofu',
      'Campo Martinelli',
      'Las Gamas',
      'Colonia La Pinta',
      'Villa Herminia',
      'Puerta Colorada',
      'Colonia La Escondida',
      'Bayada Nueva',
      'La Sara',
      'Los Jagñeles',
      'Costa Del Tambo',
      'La Invernada',
      'Puente Los Molles',
      'Colonia Santa Rosa',
      'Campo Santa Maria',
      'Tegua',
      'Tres Pozos',
      'Colonia La Pichona',
      'Espinillo',
      'Estacion Achiras',
      'Espinillal',
      'Colonia La Nueva',
      'Santa Rita',
      'Colonia Nueva Sampacho',
      'Vuelta De La Cañada',
      'Laguna Oscura',
      'Campo Esnaola',
      'Las Ensenadas',
      'Cuatro Vientos',
      'San Ambrosio',
      'La Brianza',
      'Las Cinco Esquinas',
      'Paunero',
      'San Bartolome',
      'La Primavera',
      'La Higuera',
      'Villa Corazon De Maria',
      'Malvinas Argentinas',
      'La Cumbrecita',
      'Villa Berna',
      'El Potrerillo',
      'Alta Gracia',
      'La Donosa',
      'Villa Buena Esperanza',
      'Noetinger',
      'San Tiburcio',
      'Las Jarillas',
      'La Tablada',
      'Piedritas Rosadas',
      'Las Oscuras',
      'La Guanaca',
      'La Mudana',
      'Los Quebrachitos',
      'La Sierrita',
      'El Quemado',
      'Balde De La Orilla',
      'La Patria',
      'Mogigasta',
      'Los Medanitos',
      'Colonia Anita',
      'Plaza De Mercedes',
      'Alcira',
      'Santa Teresa',
      'Colonia Caroya',
      'Villa Del Rosario',
      'Colonia Dos Hermanos Norte',
      'Colonia Monte Grande',
      'Colonia Miramar',
      'Colonia Las Palmeras',
      'Colonia General Deheza',
      'La Colonial',
      'Campo Callerio',
      'Colonia 10 De Julio',
      'Colonia El Sauce',
      'Colonia Beiro Este',
      'Colonia Freyre Noreste',
      'Colonia Maunier Norte',
      'Colonia Palo Labrado',
      'Colonia Madreselva',
      'Campo Las Viboras',
      'Colonia Maunier Centro',
      'Arroyo De Los Leones',
      'Campo Lopez',
      'Colonia El Milagro Oeste',
      'Campo La Salada',
      'Colonia Frontera Sur',
      'El Porvenir',
      'El Desquite',
      'Colonia La Trinchera',
      'La Quemada-Transito',
      'Las Cañitas',
      'Colonia Milessi',
      'Colonia Nueva Francia',
      'Colonia Ceferina',
      'Arroyo De Alvarez',
      'Campo Los Porteños',
      'Pampa Del Mercado',
      'Colonia Eugenia',
      'Colonia Maunier Sur',
      'Colonia Monte Tala',
      'Playa Grande',
      'Trinchera',
      'Campo 25 De Mayo',
      'Colonia El Trabajo',
      'Campo Lavalle',
      'Abra Del Manzano',
      'Colonia Freyre Noroeste',
      'Colonia Severina',
      'Jeronimo Cortes',
      'Colonia Frontera Norte',
      'Colonia El Milagro Este',
      'Colonia Lavarello',
      'Santa Rosa',
      'Frontera Norte',
      'Colonia Dos Hermanos',
      'Campo Los Terceranos',
      'Campo Los Zorros',
      'Colonia Amalia',
      'Colonia La Taperita',
      'Las Delicias',
      'La Cortadera',
      'Colonia Unidad',
      'Cabituyo',
      'Estacion Kilometro 581',
      'El Pino',
      'Puerta Los Montes',
      'Campo La Soledad',
      'Colonia Nueva Udine',
      'Loma De Los Indios',
      'Colonia Coyunda',
      'Colonia Beiro Norte',
      'La Toscanita',
      'Plaza Bruno',
      'Colonia Las Lomas',
      'Pozo Salado',
      'Pozo Del Mortero',
      'Chalacea',
      'Pozo Del Moro',
      'Sacanta',
      'Mayu Sumaj',
      'Villa Maria',
      'Villa Albertina',
      'Los Sauces',
      'San Marcos Sierra',
      'La Banda',
      'La Constancia',
      'San Javier Y Yacanto',
      'Country San Isidro',
      'La Morada',
      'Villa Allende',
      'Country Chacras De La Villa',
      'San Fernando',
      'Nicolas Bruzzone',
      'La Cruz',
      'Dique Chico',
      'Malena',
      'Serrano',
      'San Clemente',
      'Paso De La Pampa',
      'Colonia Marina',
      'Campo La Chantada',
      'Campo Mayol',
      'Colonia La Legua',
      'Colonia Dolores',
      'Colonia Alto Verde',
      'Barreto',
      'Colonia Campo Albano',
      'La Cremeria',
      'Colonia Maipu',
      'Campo La Zulema',
      'Manantiales',
      'Colonia Maria Angelina',
      'Colonia Santo Toma',
      'Olmos',
      'Campo Anchorena',
      'Colonia Santa Clara',
      'Colonia La Florida',
      'Pavin',
      'Colonia La Monona',
      'Colonia Las Merceditas',
      'Colonia Granja La Celina',
      'Colonia San Jose',
      'Colonia Santa Paula',
      'Villa Concepcion Del Tio',
      'Colonia Bremen',
      'El Manzano',
      'Canteras El Sauce',
      'Villa Elisa',
      'Campo La Redencion',
      'Villa Los Aromos',
      'Villa Flor Serrana',
      'Tanti',
      'Rio Cuarto',
      'La Esquina',
      'Colonia M. Juarez Celman',
      'Los Surgentes',
      'Tala Huasi',
      'San Basilio',
      'Impira',
      'Sagrada Familia',
      'Diego De Rojas',
      'Candelaria Sur',
      'Ninte',
      'Campo Columbo',
      'Los Algarrobitos',
      'Las Astillas',
      'Piedras Grandes',
      'La Falda',
      'Pascanas',
      'Sebastian Elcano',
      'La Poblacion',
      'San Carlos Minas',
      'Sauce De Los Quevedos',
      'Agua Del Crespin',
      'Los Barriales',
      'Ninalquin',
      'Las Corzuelas',
      'Unquillo',
      'Canals',
      'Isleta Cabral',
      'La Margarita',
      'Pedania Yucat',
      'Campo La Alejandra',
      'Ana Zumaran',
      'Santa Victoria',
      'Las Mojarras',
      'Campo Los Prados',
      'Campo El Chato',
      'Saladillo',
      'Colazo',
      'San Isidro',
      'Los Hormigueros',
      'Colonia Maria Godeken',
      'Colonia Italiana',
      'Campo Murphy',
      'Colonia Sick',
      'Parque Calmayo',
      'Hipolito Bouchard',
      'San Huberto',
      'El Huayco',
      'Las Calles',
      'Ascochinga',
      'La Granja',
      'Los Reartes',
      'Guanaco Muerto',
      'El Abra',
      'Cachi Yaco',
      'El Pantano',
      'La Plaza',
      'Loma Blanca',
      'La Providencia',
      'El Cachi',
      'Monte Buey',
      'Villa Del Parque (Villa Rumipal)',
      'Solar De Los Molinos',
      'Villa Ciudad Parque Los Reartes (3Ñ Seccion)',
      'Villa Ciudad Parques Los Reartes (1Ñ Seccion)',
      'Villa Ciudad Parque Los Reartes',
      'Villa De Pocho',
      'Los Manantiales',
      'La Guarida',
      'La Paz',
      'El Manantial',
      'Los Mates',
      'Quebracho Ladeado',
      'Loma Bola',
      'Cruz Caña',
      'Caseros Este',
      'La Arabia',
      'La Arcadia',
      'Toledo',
      'Kilometro 15',
      'La Estancia',
      'Chañar Viejo',
      'Barrio Villa Del Parque',
      'Villa Ciudad De America',
      'San Ignacio (Loteo San Javier)',
      'Caseros Centro',
      'Potrero Del Estado',
      'Alto Del Durazno',
      'Bouwer',
      'San Lorenzo',
      'Las Maravillas',
      'La Cesira',
      'Piedras Blancas',
      'El Diquecito',
      'La Calera',
      'Casa Bamba',
      'La Mesada',
      'Dumesnil',
      'Serrezuela',
      'Las Abras',
      'El Quicho',
      'Cachiyuyo',
      'El Dieciseis',
      'San Agustin',
      'Devoto',
      'Silvio Pellico',
      'Ballesteros',
      'Etruria',
      'Justiniano Posse',
      'Alicia',
      'Washington',
      'San Jose De La Dormida',
      'Alto De Flores',
      'Aldea Santa Maria',
      'Villa Reduccion',
      'El Baldecito',
      'Piedra Pintada',
      'Villa Dolores',
      'Las Encrucijadas',
      'La Serranita',
      'Los Molinos',
      'Villa San Miguel',
      'Barrio Nuevo Rio Ceballos',
      'Pajas Blancas',
      'Rio Ceballos',
      'El Arañado',
      'Cañada De Rio Pinto',
      'El Sauce',
      'Alto Sierra',
      'La Bismutina',
      'Guasapampa',
      'Nono',
      'Cienaga De Allende',
      'Los Algarrobos',
      'La Majada',
      'La Francia',
      'El Callejon Norte',
      'Rio Tercero',
      'Campo Gioda',
      'Los Potreros',
      'Quebracho Herrado',
      'Piedra Blanca',
      'Altautina',
      'Pachango',
      'Tasna',
      'Lagunas Verdes',
      'Quebracho Solo',
      'La Cocha',
      'Villa Rafael Benegas',
      'Santa Teresita',
      'El Volcan',
      'La Concepcion',
      'Mussi',
      'El Poniente',
      'Los Cerros',
      'Los Espinillos',
      'Segunda Usina',
      'Costasacate',
      'Colonia San Eugenio',
      'Ruiz Diaz De Guzman',
      'Vivero',
      'Fray Cayetano Rodriguez',
      'Estancia La Emilia',
      'Campo Ampurdan',
      'Colonia Fabrica N° 3',
      'Colonia Santa Ana',
      'Colonia El Guanaco',
      'Colonia Santa Cristina',
      'Guardia Vieja',
      'Colonia San Miguel',
      'Salguero',
      'Las Tres Colonias Unidas',
      'Est. El Paraiso',
      'Colonia El Arbol',
      'La Amalia',
      'Colonia El Noy',
      'Laguna Del Monte',
      'Arroyito',
      'La Curva',
      'El Fuertecito',
      'Laguna De Ansenuza',
      'Lomas Del Trozo',
      'La Para',
      'La Candelaria',
      'Cruz De Caña',
      'Chañaritos N° 2',
      'Tala Cañada',
      'Rumi Huasi',
      'Cienaga Del Coro',
      'Piedras Amontonadas',
      'La Mesilla',
      'Sauce Grande',
      'Rara Fortuna',
      'Valle De Anisacate',
      'Olaeta',
      'San Antonio De Arredondo',
      'Chuña Huasi',
      'Rodeito',
      'San Antonio De Litin',
      'Puesto De Castro',
      'Monte Leña',
      'Casa Grande',
      'Villa Valeria',
      'Huinca Renanco',
      'El Vence',
      'Las Arrias',
      'El Pedacito',
      'Villa Del Totoral',
      'El Rodeo',
      'Cordoba',
      'La Floresta',
      'Villa La Quebrada',
      'Villa Esquiu',
      'El Gateado',
      'Coronel Olmedo',
      'Jardin Arenales',
      'Los Quebrachos',
      'La Boca Del Rio',
      'Jose De La Quintana',
      'Villa San Isidro - Jose De La Quintana',
      'Freyre',
      'Sampacho',
      'Mendiolaza',
      'La Tordilla',
      'Rodeo Grande',
      'Tosno',
      'El Fortin',
      'San Jorge',
      'Macha',
      'Puesto Del Rosario',
      'Los Cometierra',
      'La Tuna',
      'Belen',
      'San Salvador',
      'Los Chañares',
      'Colonia Hogar',
      'Barranca Yaco',
      'San Pellegrino',
      'Mula Muerta',
      'Puesto San Jose',
      'Est. San Juan',
      'La Estrechura',
      'Ausonia',
      'Sanabria',
      'Las Varillas',
      'Leguizamon',
      'Pasco',
      'Morteros',
      'Media Luna Norte',
      'Tinoco',
      'Dalmacio Velez',
      'Chucul',
      'Valle Hermoso',
      'Diaz',
      'Capilla De Los Remedios',
      'Benjamin Gould',
      'Achiras',
      'Colonia San Pedro',
      'Colonia Pueyrredon',
      'Vicuña Mackenna',
      'Potrero De Garay',
      'Golpe De Agua',
      'Arias',
      'Villa Cerro Azul',
      'Calchin',
      'Los Cocos',
      'El Corcovado - El Torreon',
      'Villa Rumipal',
      'Estancia Vieja',
      'La Palestina',
      'Cotagaita',
      'Brinckmann',
      'Olivares De San Nicolas',
      'Esquina Del Alambre',
      'Colonia Romana',
      'Campo El Cabure',
      'Chacras De Tio Pujio',
      'Tio Pujio',
      'Granja La Margarita',
      'Pedania Yucat P/Tio Pujio',
      'Villa Fontana',
      'Punta Del Arroyo',
      'El Tostado',
      'Almafuerte',
      'Churqui Cañada',
      'Corral De Bustos',
      'San Carlos',
      'El Tuscal',
      'Las Masitas',
      'La Toma',
      'Chipitin',
      'Pozo Solo',
      'Totoralejos',
      'Santa Cruz',
      'Alto Verde',
      'Puesto Viejo',
      'Inti Huasi',
      'La Angostura',
      'Puesto De Cejas',
      'Cañada Del Tala',
      'Los Alamos',
      'Villa Colimba',
      'La Cieneguita',
      'Cruz Mojada',
      'Ongamira',
      'Villa Alicia',
      'Las Manzanas',
      'Las Tuscas',
      'Sauce Chiquito',
      'Estancia San Miguel',
      'Puesto Nuevo',
      'La Botija',
      'Bajo Alegre',
      'La Cantera',
      'Los Ruices',
      'Todos Los Santos',
      'Huascha',
      'San Pedro De Toyos',
      'Los Tartagos',
      'Arbol Blanco',
      'El Molino',
      'Ischilin',
      'Ischilin Viejo',
      'Los Mistoles',
      'Villa De Maria',
      'Atahona',
      'La Paisanita',
      'Sarmiento',
      'Agua De Las Piedras',
      'Los Condores',
      'Banda Sud',
      'Del Campillo',
      'Colonia Vignaud',
      'Sauce Arriba',
      'Villa Del Dique',
      'El Portezuelo',
      'Luyaba',
      'Guanaco Boleado',
      'La Travesia',
      'Travesia',
      'Villa El Chacay',
      'Timon Cruz',
      'Maquinista Gallini',
      'Agua Hedionda',
      'San Jose De Las Salinas',
      'Isla De San Antonio',
      'Melo',
      'Ballesteros Sur',
      'Avellaneda',
      'Juan Garcia',
      'El Estanque',
      'Villa Rio Icho Cruz',
      'Causana',
      'Malagueño',
      'Falda Del Cañete',
      'Villa Sierras De Oro',
      'Tierra Alta',
      'San Nicolas',
      'La Perla',
      'Tejas Tres',
      'Barrio Gilbert (1° De Mayo)',
      'Milenica',
      'Yocsina',
      'Punta De Agua',
      'Bulnes',
      'La Batea',
      'Villa Santa Rita',
    ],
    'AR-E': [
      'Los Conquistadores',
      'General Galarza',
      'San Ramirez',
      'Nueva Vizcaya',
      'Enrique Carbo',
      'Alarcon',
      'General Racedo',
      'Colonia La Sarita',
      'Rincon Lucas Sud',
      'Colonia Pereira',
      'Colonia San Anselmo',
      'Molino Doll',
      'Colonia Oficial 16',
      'Colonia Ayman',
      'Banderitas',
      'Colonia La Berta',
      'Colonia San Lorenzo',
      'Colonia La Marta',
      'Diego Lopez',
      'Colonia La Lata',
      'Colonia Santa Lucia',
      'Colonia Oficial 18',
      'Las Mulitas',
      'Arroyo Sepultura',
      'Arroyo Las Lechiguanas',
      'Pastor Britos',
      'Rincon Del Gato',
      'Perdices',
      'Distrito Perdices',
      'Ñancay',
      'La Providencia',
      'Colonia El Saucesito',
      'Crucesitas',
      'Oro Verde',
      'Arroyo Corralito',
      'Aldea Santa Rosa',
      'Arroyo Grande',
      'Colonia Oficial N° 5',
      'Colonia San Martin',
      'Estancia La Silvia',
      'Colonia Sagastume',
      'Colonia San Ramon',
      'San Cipriano',
      'Las Achiras',
      'Los Ceibos',
      'Distrito Chilcas',
      'Distrito Hinojal',
      'Rincon Del Doll',
      'Montoya',
      'Colonia Adivinos',
      'El Chajari',
      'Colonia Puente Del Gualeg',
      'Colonia Las Pepas',
      'Colonia Santa Rosa',
      'San Miguel',
      'Colonia Nueva San Miguel',
      'Punta Del Monte',
      'Distrito Tala',
      'Colonia Reffino',
      'Estacion Yuqueri',
      'Loma Limpia',
      'El Gato',
      'Colonia Oficial Nº 13',
      'Gonzalez Calderon',
      'Las Toscas',
      'Crucesitas Tercera',
      'Distrito Costa Uruguay Sur',
      'Monte Redondo',
      'Las Tunas',
      'Sauce Sud',
      'La Juanita',
      'La Jaula',
      'Colonia Ensayo',
      'Colonia Santa Eloisa',
      'Villa Del Rosario',
      'Aldea San Juan',
      'Colonia El Clavo',
      'Altamirano Sur',
      'Sosa',
      'Colonia La Gloria',
      'Colonia La Paz',
      'Colonia Perfeccion',
      'Concepcion Del Uruguay',
      'Arroyo Urquiza',
      'Talita',
      'Colonia Santa Ana',
      'Distrito Molino',
      'General Almada',
      'Febre',
      'Distrito Montoya',
      'Colonia La Perla',
      'Colonia Santa Margarita',
      'Colonia Cañada Grande',
      'San Victor',
      'Estacion Palo A Pique',
      'Colonia San Miguel',
      'Pueblo Cazes',
      'Las Piedras',
      'Parana',
      'Villa Uranga',
      'Bajada Grande',
      'General Campos',
      'Paso Bravo',
      'Laguna Benitez',
      'Villa Urquiza',
      'Los Aromos',
      'La Balsa',
      'La Argentina',
      'Distrito Ceibas',
      'El Empalme',
      'El Saladero',
      'El Sauce',
      'Arroyo Hondo',
      'Esquina',
      'Colonia Rivadavia',
      'Villaguay',
      'Estacion Palavecino',
      'Costa Las Masitas',
      'Gualeyancito',
      'Distrito Pehuajo Sud',
      'Distrito Pehuajo Norte',
      'Tres Esquinas',
      'Colonia Stauber',
      'Colonia Las Piedras',
      'Colonia Italiana',
      'Estancia El Refugio',
      'Pedernal',
      'Colonia Santa Isabel',
      'Jubileo',
      'Santa Ana',
      'Colonia Ensanche Sauce',
      'Colonia Las Flores',
      'Irazusta',
      'Colonia 25 De Mayo',
      'Alcaraz',
      'Barragan',
      'El Cimarron',
      'Aldea San Isidro',
      'Antelo',
      'Colonia San Ernesto',
      'Colonia Puntas Del Gualeguaychu',
      'Rincon Del Villaguay',
      'Colonia Espindola',
      'Villaguay Este',
      'Colonia San Jorge',
      'Colonia La Geronima',
      'Colonia La Rosada',
      'Colonia San Vicente',
      'Picada Berón',
      'El Yeso',
      'El Carmen',
      'El Guayabo',
      'El Achiral',
      'Lucas Norte',
      'El Curupi',
      'Distrito Costa De Nogoya',
      'Puerta De Crespo',
      'Aldea Andreoli',
      'Miñones',
      'Cuatro Bocas',
      'Colonia Belgrano',
      'Hernandarias',
      'Puerto Viboras',
      'Cerrito',
      'Pueblo Moreno',
      'Pueblo General Paz',
      'Colonia Walter Moss',
      'Colonia La Armonia',
      'Tabossi',
      'Paso Blanco',
      'Mojones Norte',
      'El Palenque',
      'Colonia Crespo',
      'Carmona',
      'Colonia San Juan',
      'Colonia La Esperanza',
      'Colonia La Llave',
      'Algarrobitos',
      'Campo Micheloud',
      'Colonia Oficial 21',
      'Villa Adela',
      'Camba Paso',
      'Benito Legeren',
      'Las Tejas',
      'Villa Zorraquin',
      'Concordia',
      'Dos Hermanas',
      'Las Mercedes',
      'Colonia 3 De Febrero',
      'Colonia Taboada',
      'Campo Jourbet',
      'Pueblo Brugo',
      'Colonia La Joya',
      'Libaros',
      'Estacion Escriña',
      'Hocker',
      'Las Pajitas',
      'Estacion Raices',
      'Distrito Raices',
      'Colonia Oficial 2',
      'Cuchilla Redonda',
      'Distrito Cuchilla Redonda',
      'Urdinarrain',
      'Colonia La Florida',
      'Barrancas Coloradas',
      'El Pueblito',
      'Colonia Oficial 17',
      'Colonia Santa Maria',
      'Fortuna',
      'Colonia Viraro',
      'Aldea Eigenfeld',
      'Ceibas',
      'Guayaquil',
      'Colonia Argentina',
      'Paso De Las Piedras',
      'Aldea Valle Maria',
      'Aldea San Francisco',
      'Colonia San Salvador',
      'San Salvador',
      'Santa Anita',
      'Colonia Tuyuti',
      'Villa Fontana',
      'Colonia Avellaneda',
      'Nogoya',
      'El Redomon',
      'Paso Del Gallo',
      'La Querencia',
      'Colonia Urquiza',
      'Yaros',
      'Gualeguaychu',
      'Puerto Unzue',
      'Sarandi',
      'Gualeyan',
      'Villa Paranacito',
      'Arroyo Brazo Chico',
      'Arroyo Merlo',
      'Brazo Largo',
      'Arroyo Santos Grande',
      'Arroyo Negro',
      'Sagastume',
      'Distrito Isletas',
      'Isletas',
      'Lucas Gonzalez',
      'Aldea San Simon',
      'Las Guachas',
      'Sauce Norte',
      'Atencio',
      'La Te',
      'San Jose De Feliciano',
      'Gobernador Echague',
      'Colonia Sauce Norte',
      'Estacion Don Gonzalo',
      'Ramblones',
      'Carpinchori',
      'La Calandria',
      'Villa San Marcial',
      'Colonia Nueva Itati',
      'Colonia La Blanquita',
      'Laguna Larga',
      'Colonia Condor',
      'Zenon Roca',
      'Lucas Sud',
      'Colonia Nueva Alemania',
      'Colonia San Gregorio',
      'Colonia Berro',
      'Colonia La Chunga',
      'Colonia La Mora',
      'Mojones Sur',
      'El Tigre',
      'Los Tases',
      'Sauce Medio',
      'San Benito',
      'Paso De La Arena',
      'Costa De Mulas',
      'Mulas Grandes',
      'Pueblo General Belgrano',
      'Don Cristobal',
      'Puerto Algarrobo',
      'Colonia San Luis',
      'Paso Potrillo',
      'La Clarita',
      'Colonia San Pascual',
      'Colonia San Justo',
      'Diamante',
      'Strobel',
      'Estacion Lazo',
      'La Verbena',
      'Viboras',
      'Pueblo Nuevo',
      'Basavilbaso',
      'Aldea Spatzenkutter',
      'El Cerro',
      'Colonia Celina',
      'Colonia Santa Juana',
      'Colonia Oficial 25',
      'Xx De Setiembre',
      'Ingeniero Miguel Sajaroff',
      'Colonia Santa Elena-Coloniabaylina',
      'El Corcovado',
      'Colonia Avigdor',
      'Capivara',
      'Las Gurisas',
      'Basualdo',
      'La Esmeralda',
      'Rincon De Mesa',
      'Nueva Escocia',
      'El Ramblon',
      'Quebracho',
      'Colonia San Emilio',
      'Colonia Santafesina',
      'Campo Massine',
      'Segui',
      'Colonia Cadel',
      'San Pedro',
      'El Carumbe',
      'Conscripto Bernardi',
      'Tezanos Pinto',
      'General Guemes',
      'Rincon Santa Maria',
      'Villa San Justo',
      'Piloto Avila',
      'La Paz',
      'Aldea Salto',
      'Viale',
      'Aldea Grapschental',
      'Pueblo Bellocq',
      'Colonia La Gama',
      'Colonia Mansilla',
      'Gobernador Mansilla',
      'Campos Sanchez',
      'Piedras Blancas',
      'Campo Rebechi',
      'La Ollita',
      'Raices Oeste',
      'El Tropezon',
      'Aldea Diaz',
      'Cantina Bonaldo',
      'El Malagueño',
      'Colonia La Matilde',
      'Villa Elisa',
      'Colonia Vazquez',
      'Colonia El Carmen',
      'Colonia Gobernador Crespo',
      'Colonia Merou',
      'Colonia Peña',
      'San Ramon',
      'Colonia El Trompo',
      'Mandisovi',
      'Hasenkamp',
      'Espinillo',
      'Sir Leonard',
      'Colonia Nueva Montevideo',
      'Rocamora',
      'Estancia La Estrella',
      'Colonia Almada',
      'Colonia J. Fink',
      'Distrito Chañar',
      'Moreira',
      'Arroyo Chañar',
      'Carrasco',
      'Aldea San Antonio',
      'Paso Medina',
      'El Chañar',
      'Molino Publico',
      'La Selva',
      'Estaquitas',
      'Colonia Buena Vista',
      'El Talita',
      'Macia',
      'Estacion La Hierra',
      'Guardamonte',
      'Aldea Brasilera',
      'Paraje La Virgen',
      'Villa Mantero',
      'Colonia Barreros',
      'Isla Juanico',
      'Colonia Lucienville',
      'Distrito Moscas',
      'Colonia Genacito',
      'Las Delicias',
      'El Rincon',
      'Sauce Sur',
      'Federal',
      'Colonia Santa Luisa',
      'La Picada',
      'Faustino M. Parera',
      'Colonia Gobernador Basavilbaso',
      'La Tacuara',
      'Laguna Del Pescado',
      'Aranguren',
      'Colonia Algarrobitos',
      'Algarrobitos Segundo',
      'El Quebracho',
      'Medanos',
      'Campo Mujica',
      'Maria Grande',
      'Estacion Camps',
      'Durazno',
      'El Guineo',
      'Altamirano Norte',
      'Colonia General Urquiza',
      'Colonia El Pantanoso',
      '1 De Mayo',
      'Rincon De Nogoya',
      'Puerto Esquina',
      'Los Cerros',
      'Villa Libertador San Martin',
      'Estacion Puiggari',
      'Costa Grande',
      'San Jaime De La Frontera',
      'Colonia Oficial 9',
      'Colonia Alvear',
      'Aldea Protestante',
      'Paso De Alonso',
      'Gualeguay',
      'Puerto Ruiz',
      'Villa Alvarez',
      'Distrito Yeso',
      'Chacabuco',
      'El Chimango',
      'Puerto Constanza',
      'Estacion Libertador General San Martin',
      'Puerto Perazzo',
      'Ibicuy',
      'Sauce Montrull',
      'Colonia Santa Teresita',
      'Pronunciamiento',
      'General Ramirez',
      'Rosario Del Tala',
      'Santa Margarita Del Gena',
      'Colonia Santa Zelmira',
      'Herrera',
      'Campo La Virginia',
      'Colonia Rincon Del Gena',
      'Estancia Los Paraisos',
      'Campo Parera',
      'Hernandez',
      'Distrito Sauce Al Norte',
      'Arroyo Obispo',
      'Distrito Pueblo Primero',
      'Distrito Raices Al Sud',
      'Pueblo Liebig S',
      'La Encierra',
      'El Gramillal',
      'Crespo',
      'Loma Negra',
      'Los Charruas',
      'Las Moscas',
      'Campo Furlan',
      'Aldea Santa Maria',
      'Antonio Tomas',
      'Aldea San Rafael',
      'Campo Ziegler',
      'Colonia San Pedro',
      'San Gustavo',
      'Campo Lacoraza',
      'Haras General Urquiza',
      'Distrito Cle',
      'Cuatro Manos',
      'Distrito Vizcacha',
      'La Cuadra',
      'Distrito Albardon',
      'Distrito Sauce',
      'Tres Bocas',
      'Colonia El Paraiso',
      'Aldea Santa Celia',
      'Arroyo Baru',
      'Colonia Izquierdo',
      'Distrito Costa Uruguay Norte',
      'Betbeder',
      'Villa Clara',
      'Colonia General Roca',
      'Pueblo Ferre',
      'Estacion Yerua',
      'El Ombu',
      'El Brillante',
      'San Jose',
      'Perucho Verna',
      'El Colorado',
      'Aldea Maria Luisa',
      'General Alvear',
      'Colonia Hugues',
      'Colonia Paso Paysandu',
      'Colon',
      'Calabacilla',
      'Colonia Yerua',
      'Estancia Grande',
      'Puerto Las Cuevas',
      'Distrito Doll',
      'Campo Vasalle',
      'Aldea Asuncion',
      'Distrito Jacinta',
      'Distrito Cuchilla',
      'Estacion Estacas',
      'Curtiembre',
      'Pueblo General San Martin',
      'Colonia Sedna',
      'Santa Elena',
      'Distrito Feliciano',
      'Estancia San Juan',
      'Estacas',
      'El Salado',
      'Los Talas',
      'Montiel',
      'Colonia Maximo Castro',
      'Est. El Tigre',
      'Paso Telegrafo',
      'Estancia Santa Ines',
      'El Solar',
      'Colonia San Carlos',
      'Colonia Bertozi',
      'Colonia La Providencia',
      'Colonia Los Sauces',
      'Bovril',
      'Larroque',
      'Las Tres Esquinas',
      'Laurencena',
      'Paso De La Laguna',
      'Colonia Desparramados',
      'Chajari',
      'Colonia Villa Libertad',
      'Clodomiro Ledesma',
      'Colonia Ayui',
      'Arroyo Del Medio',
      'La Rosada',
      'Puerto Yerua',
      'Estancia Centella',
      'El Potrero',
      'Distrito Potrero',
      'Campichuelo',
      'Colonia Elia',
      'Sauce Pinto',
      'Colonia Mandisovi',
      'Colonia Alemana',
      'El Pingo',
      'La Colmena',
      'Ubajay',
      'Arroyo Concepcion',
      'Distrito Sexto',
      'Colonia San Antonio',
      'Sauce De Luna',
      'Villa Gobernador Luis F. Etchevehere',
      'Gilbert',
      'Carrizal',
      'Distrito Corrales',
      'Distrito Quebrachitos',
      'Villa Libertad',
      'Pajonal',
      'La Criolla',
      'San Bonifacio',
      'Lago Grande',
      'Colonia San Huberto',
      'Hambis',
      'Villa Dominguez',
      'Campo Tafarel',
      'Primera Seccion De Islas',
      'Arroyo Piaggio',
      'Arroyo Barrancoso',
      'La Invernada',
      'Tercera Seccion De Islas',
      'Charigue',
      'Las Cuatro Bocas',
      'Boca De Las Piedras',
      'Isla El Pillo',
      'Victoria',
      'Colonia Flores',
      'Federacion',
      'Salto Grande',
      'Colonia Ensanche',
      'Colonia El Bizcocho',
      'Aldea San Miguel',
      'Campo Garcia',
      'Caseros',
      'Colonia Mabragaña',
      'Colonia Palmar Yatay',
      'Colonia San Francisco',
      'Aldea San Gregorio',
      'Sumaca',
      'Colonia Las Mercedes',
      'Estacion Juan Jorge',
      'Estacion Arroyo Cle',
      'Olegario Victor Andrade',
      'Gobernador Sola',
    ],
    'AR-P': [
      'San Antonio',
      'Isla Oca',
      'Colonia Formosa',
      'La Colonia',
      'Formosa',
      'Posta Cambio Zalazar',
      'Las Bolivianas',
      'Rio Muerto',
      'Campo Del Medio',
      'La Linea',
      'El Remanso',
      'Pescado Negro',
      'Las Avispas',
      'Ahi Veremos',
      'Aibal El Silencio',
      'La Laguna',
      'Las Maravillas',
      'Vaca Perdida',
      'El Quemado',
      'Paso De Los Tobas',
      'La Palmita',
      'Lamadrid',
      'Alto Alegre',
      'El Cavado',
      'La Tusca',
      'El Retiro',
      'El Colorado',
      'La Paz',
      'Lagunita',
      'El Corralito',
      'Laguna Yacare',
      'Los Yuchanes',
      'La Puerta',
      'Bajo Verde',
      'El Lecheron',
      'La Palizada',
      'El Despunte',
      'Sombrero Negro',
      'La Soledad',
      'El Quimil',
      'El Castor',
      'El Palo Santo',
      'Corralito',
      'La Mocha',
      'Los Pocitos',
      'Tres Yuchan',
      'El Escondido',
      'Fortin Pilcomayo',
      'La Primavera',
      'La Rinconada',
      'La Represa',
      'El Churcalito',
      'El Paraguayo Muerto',
      'Las Palmitas',
      'Las Vidalitas',
      'Pozo Ramon',
      'Pozo El Escondido',
      'El Bajo',
      'El Paraiso',
      'El Yacare',
      'Las Banderitas',
      'El Aibalito',
      'Santa Isabel',
      'El Azotado',
      'El Solitario',
      'La Union',
      'La Madrugada',
      'San Cayetano',
      'Isla Garcia',
      'El Simbolar',
      'El Bragado',
      'El Cajon',
      'Sumayen',
      'Santa Rosa',
      'San Camilo',
      'Matias Gulacsi',
      'La Iguana',
      'San Isidro',
      'Los Claveles',
      'Guadalcazar',
      'Palos Blancos',
      'Pozo Sargento',
      'La Zanja',
      'Fortin Pilcomayo Nuevo',
      'El Bordo Santo',
      'Bajo Hondo',
      'El Cuchillo',
      'El Alambrado',
      'El Lindero',
      'Los Galpones',
      'Palma Sola',
      'Praline',
      'Isla Chica',
      'Campo Azul',
      'Poncho Quemado',
      'El Coleto',
      'Las Flores',
      'Tres Pozos',
      'La Libertad',
      'San Cristobal',
      'Puerto Cabo Irigoyen',
      'Pozo De Molina',
      'Los Cieneguitos',
      'El Naranjo',
      'La Esquina',
      'Laguna Tres Paces',
      'Palo Marcado',
      'El Chañaral',
      'Santa Rita',
      'El Churcal',
      'Media Luna',
      'La Esperanza',
      'Ibarreta',
      'Algarrobo',
      'Jose Maria Paz',
      'Boqueron',
      'Colonia Bouvier',
      'Tranquerita',
      'El Recodo',
      'Colonia Sudamericana',
      'Marca M',
      'Ceibo Trece',
      'San Francisco',
      'Sol De Mayo',
      'Polvorin',
      'Martin Fierro',
      'Virasol',
      'Lucero Cue',
      'Isla Puen',
      'Isla Leona',
      'Presidente Avellaneda',
      'Costa Alegre',
      'Colonia Sarmiento',
      'Colonia Los Santafesinos',
      'Loma Hermosa',
      'Aurora',
      'Isla Yobai Guazu',
      'Nueva Morada',
      'Buey Muerto',
      'Colonia San Juan',
      'Rodeo Tapiti',
      'Colonia La Primavera',
      'Paso Angelito',
      'Esperanza',
      'Isla Apando',
      'Riacho',
      'Soledad',
      'Punta Guia',
      'Vista Alegre',
      'Loma Tuyutu',
      'Juan G. Bazan',
      'Estanislao Del Campo',
      'Estacion Bouchard',
      'Villa Kilometro 213',
      'Buena Vista',
      'San Francisco De Laishi',
      'Laguna Gallo',
      'San Martin I',
      'El Mistolar',
      'La Florencia',
      'Las Calaveras',
      'El Picaso',
      'El Trebol',
      'La Ensenada',
      'Quebracho Coto',
      'Campo La Cruz',
      'El Milagro',
      'Vaca Muerta',
      'Tres Palmitas',
      'Teniente General Rosendo M. Fraga',
      'Bolsa Del Palomo',
      'Pozo El Yacare',
      'El Palmar',
      'La Entrada',
      'El Rosillo',
      'Agua Verde',
      'La Extranjera',
      'Pozo De La Yegua',
      'El Totoral',
      'Monte Rico',
      'El Potrerito',
      'Campo Bandera',
      'Campo Grande',
      'Isla Verde',
      'El Violin',
      'La Junta',
      'Comunidad Aborigen Wichi Fwinafwas',
      'Santa Teresa',
      'Pozo De Los Patos',
      'Las Lolas',
      'Mojon De Fierro',
      'Tres Lagunas',
      'Pueyrredon',
      'Riacho Negro',
      'El Recreo',
      'Colonia Pastoril',
      'Colonia San Isidro',
      'Candia',
      'Colonia San Antonio',
      'Colonia El Dorado',
      'Hertelendy',
      'Paso Polenta',
      'Posta Del Salado',
      'Guayacanty',
      'Esterito',
      'Colonia Laguna Gobernador',
      'Tres Mojones',
      'La Playa',
      'Colonia El Naranjito',
      'Cogorno',
      'Riacho Lindo',
      'El Cerrito',
      'Colonia Cano',
      'El Mbigua',
      'Kilometro 100',
      'Potrero De Los Caballos',
      'El Angelito',
      'Puerta Mision',
      'Presidente Yrigoyen',
      'Isla Banco Ortellado',
      'Maglietti',
      'Colonia Yatay',
      'La Luisa',
      'Kilometro 117',
      'San Hilario',
      'Villa Escolar',
      'Porton Negro',
      'Mision Tacaagle',
      'Palo Santo',
      'Siete Palmas',
      'Riacho He-He',
      'Puerto Irigoyen',
      'El Potrillo',
      'Banco Payagua',
      'General Mosconi',
      'Las Mercedes',
      'Santa Maria',
      'Las Palmas',
      'Colonia Tres Marias',
      'Loma Clavel',
      'El Triangulo',
      'San Alberto',
      'San Nicolas',
      'Zanin',
      'Francesa Cue',
      'La Aurora',
      'Agua Dulce',
      'Colonia Presidente Uriburu',
      'Santa Elena',
      'Santa Catalina',
      'Tres Esquinas',
      'La Querencia',
      'Puente San Hilario',
      'San Juan',
      'Colonia Presidente Yrigoyen',
      'San Luis',
      'El Ombu',
      'Colonia Ituzaingo',
      'Maria Luisa',
      'El Perdido',
      'Isla 25 De Mayo',
      'San Martin',
      'Guaycolec',
      'San Carlos',
      'San Pedro',
      'El Peligro',
      'Yaguarete',
      'Colonia Dalmacia',
      'San Felipe',
      'Banco La Emilia',
      'Tatane',
      'Pozo De Maza',
      'Villa General Guemes',
      'Villa Del Carmen',
      'Colonia Aborigen La Bomba',
      'Lote 27',
      'La Pantalla',
      'Las Lomitas',
      'Mariano Boedo',
      'Ingeniero Guillermo N. Juarez',
      'Pozo Del Tigre',
      'Gran Guardia',
      'San Martin Ii',
      'Puerto Pilcomayo',
      'Clorinda',
      'Bella Vista',
      'Loma Senes',
      'Colonia 15',
      'Campo Alegre',
      'Colonia Rigonato',
      'Campo San Rafael',
      'Loma Del Quebranto',
      'Colonia Roda',
      '9 De Julio',
      'Lote 219',
      'La Tomasa',
      'Monte Lindo',
      'San Jose',
      'Campo Hardy',
      'Colonia 5 De Octubre',
      'La Lomita',
      'La Picadita',
      'El Piquete',
      'La Sarita',
      'Colonia El Comienzo',
      'Colonia Santa Cruz',
      'Kilometro 224',
      'Colonia La Disciplina',
      'Feldman',
      'El Resguardo',
      'Casco Cue',
      'El Quebranto',
      'Colonia El Alba',
      'El Saladillo',
      'Agente Leguizamon',
      'La Carolina',
      'Colonia Pampa Villanueva',
      'La Dora',
      'Colonia Loma Senes',
      'Zorrilla Cue',
      'Colonia El Desaguadero',
      'Princich',
      'Franchi',
      'El Algarrobo',
      'La Sirena',
      'Colonia Las Lomitas',
      'Mercedes Cue',
      'Colonia El Zapallito',
      'Acosta',
      'Costa Riacho Alazan',
      'El Ibagay',
      'Santa Ana',
      'Colonia El Olvido',
      'Centro Forestal Pirane',
      'Potrero Oculto',
      'Potrero Norte',
      'El Gato',
      'Colonia Itati',
      'La Victoria',
      'Colonia El Palmar',
      'Colonia El Progreso',
      'El Salado',
      'Lote 9',
      'Copo Blanco',
      'Murua',
      'Colonia La Union',
      'La Floresta',
      'Kilometro 210',
      'Monte Quemado',
      'El Indio',
      'Kilometro 142',
      'Colonia Esperanza',
      'La Loma',
      'El Bosquecillo',
      'El Poi',
      'Colonia Weitzel',
      'Lote 11',
      'Soldado Edmundo Sosa',
      'Lote 108 Ladrilleria',
      'Colonia El Chaja',
      'Isla Toldo',
      'El Coati',
      'Lote 17-Legua A',
      'Racedo Escobar',
      'Colonia El Rincon',
      'Villa General Manuel Belgrano',
      'Subteniente Perin',
      'Pirane',
      'Pozo Del Mortero',
      'Colonia 20 De Junio',
      'El Desemboque',
      'Colonia Laka-Wichi',
      'El Sauce',
      'Colonia Santa Rosa',
      'El Tordillo',
      'Colonia San Jose',
      'El Leon',
      'Loma San Pablo',
      'El Algarrobal',
      'San Ramon',
      'El Divisadero',
      'Los Inmigrantes',
      'El Cabure',
      'El Cruce',
      'Colonia Tajerey',
      'Campo Del Cielo',
      'El Bellaco',
      'Colonia San Roque',
      'San Julian',
      'La Felicidad',
      'Magallanes',
      'Monte Alegre',
      'Colonia Las Choyas',
      'El Relevo',
      'La Palma',
      'El Ceibal',
      'Los Tres Reyes',
      'Colonia El Catorce',
      'Las Horquetas',
      'El Gallego',
      'Riacho De Oro',
      'Colonia Isla Sola',
      'Colonia Reconquista',
      'El Estanque',
      'Colonia 14 De Mayo',
      'El Martillo',
      'Ovejero',
      'La Sorpresa',
      'El Oculto',
      'San Lorenzo',
      'El Aguara',
      'El Cacuy',
      'Cacique Coquero',
      'La Invernada',
      'Pozo Verde',
      'Los Jubilados',
      'Tierra Blanca',
      'Colonia Juanita',
      'Colonia Ceferino Namuncura',
      'Colonia Ensanche Norte',
      'La Rafaela',
      'Lago Verde',
      'Rojas',
      'Ranero Cue',
      'Laqtasatanyie (Km14)',
      'Colonia Dante Sandrelli',
      'Campo Azcurra',
      'Kilometro 15',
      'Colonia El Pavao',
      'El Timbo',
      'Colonia La Preferida',
      'La Estrella',
      'Laguna Aceval',
      'El Quebracho',
      'San Simon',
      'Colonia San Pedro',
      'El Traslado',
      'La Cierva',
      'Campo Tres Pozos',
      'Los Laureles',
      'Maestra Blanca Gomez',
      'San Miguel',
      'La Porfia',
      'Miranda',
      'Colonia Napenay',
      'Mansilla',
      'Pozo Hondo',
      'Rincon Florido',
      'Pozo Redondo',
      'Los Colorados',
      'La Providencia',
      'Urbana Vieja',
      'Colonia Union Escuela',
      'Santo Domingo',
      'Los Suspiros',
      'Punta De Agua',
      'Pozo De Los Chanchos',
      'El Cogoik',
      'Las Mochas',
      'Isleta',
      'Puerto Lavalle',
      'Campo De Aviacion',
      'El Porvenir',
      'El Descanso',
      'Villa Marin',
      'El Tartagal',
      'La Media Luna',
      'General Urquiza',
      'Colonia Tatane',
      'Colonia San Pablo',
      'La Pampa',
      'Colonia Alto Alegre',
      'Villa General Urquiza',
      'Colonia El Silencio',
      'Kilometro 503',
      'Pozo Largo',
      'El Mirador',
      'Colonia El Ensanche',
      'Comunidad Lote 21',
      'Teniente Brown',
      'Colonia Siete Quebrachos',
      'Primavera',
      'Crucero General Belgrano',
      'Chico Dowagan',
      'Pozo De Los Milicos',
      'Lote 20 Rural',
      'Pozo Del Ciervo',
      'Paso Naite',
      'Laguna Naick-Neck',
      'General Lucio V Mansilla',
      'Colonia Campo Villafañe',
      'Fortin Sargento 1Ñ Leyes',
      'Laguna Yema',
      'Bartolome De Las Casas',
      'Comunidad Aborigen Bartolome De Las Casas',
      'Fortin Cabo 1Ñ Lugones',
      'Laguna Blanca',
      'Comandante Fontana',
      'El Matadero',
      'Los Chiriguanos',
      'Herradura',
      'Vidal',
      'Colonia Aborigen',
      'Puesto Ramona',
      'Julio Cue',
      'Villa Rural',
      'Salvacion',
      'Isla Azul',
      'San Rafael',
      'Villa Maria',
      'Laguna Toro',
      'Candelaria',
      'Villa Hermosa',
      'Toldo Cue',
      'Colonia El Ceibo',
      'Loma Zapatu',
      'Punta Pora',
      'Rincon Grande',
      'San Blas',
      'Apayerey',
      'La Elida',
      'Casualidad',
      'Leon',
      'Loro Cue',
      'San Benito',
      'San Pablo',
      'San Jorge',
      'Villa Real',
      'Flor De Tuna',
      'Colonia 25 De Mayo',
      'Timbo',
      'El Pombero',
      'Las Vertientes',
      'Pozo Caballo',
      'El Tucumancito',
      'Pozo Cercado',
      'El Alazan',
      'Mision San Andres',
      'El Breal',
      'El Chivil',
      'El Palmarcito',
      'Comunidad 7 De Junio',
      'Las Delicias',
      'El Tronquito',
      'Barrio El Favorito',
      'Palo Seco',
      'Rio Seco',
      'Las Cañitas',
      'El Rosario',
      'Isla De Luna',
      'Pozo Del Oso',
      'Cañada Rica Ii',
      'El Sol',
      'Maria Cristina',
      'Villa Devoto',
      'Tres Palmas',
      'Comunidad Wichi Barrio El Colorado',
      'El Tabique',
      'Pozo Charata',
      'Lote 1',
      'El Silencio',
      'Lote 8',
      'El Rosado',
      'Campo Del Acha',
      'La Tigra',
      'Comunidad Aborigen Wichi',
      'La Perdiz',
      'Pozo La Chiva',
      'El Molino',
      'La Brea',
      'Palmar Largo',
      'La Horqueta',
      'Comunidad Wichi Oblitaj',
      'El Espinillo',
    ],
    'AR-Y': [
      'San Francisco De Alfarcito',
      'Santa Ana De La Puna',
      'Tusaquillas',
      'Santa Ana',
      'Trancas',
      'Rinconadillas',
      'Salado',
      'Abdon Castro Tolay',
      'Santuario De Tres Pozos',
      'Tolarito',
      'Colonia San Jose',
      'Alonso',
      'Volcan De Yacoraite',
      'Yacoraite',
      'Huacalera',
      'Carcel',
      'Punta Corral',
      'Coiruro',
      'Agua Bendita',
      'Tumbaya',
      'Tumbaya Grande',
      'Bermejito',
      'Libertad',
      'Calilegua',
      'Miraflores',
      'El Puesto',
      'La Esperanza',
      'Parapeti',
      'San Antonio',
      'San Juancito',
      'Severino',
      'El Cadillal',
      'El Chamical',
      'Las Pampitas',
      'Perico',
      'Coronel Arias',
      'Barrio La Union',
      'La Posta',
      'Bordo La Isla',
      'Arroyo Del Medio',
      'Ojo De Agua',
      'Santa Cornelia',
      'Real De Los Toros',
      'Las Delicias',
      'Palma Sola',
      'Villa Montes',
      'Isla Chica',
      'San Rafael',
      'Paicone',
      'Cienega',
      'San Juan De Oro',
      'Lagunillas De Farallon',
      'Misarrumi',
      'San Juan De Oros',
      'San Juan Y Misa Rumi',
      'Cusi Cusi',
      'San Jose De Chijra',
      'Termas De Reyes',
      'San Salvador De Jujuy',
      'Guerrero',
      'La Almona',
      'Reyes',
      'Juan Galan',
      'Tilquiza',
      'Cochagosta',
      'Rio Grande',
      'Quera',
      'Agua De Castilla',
      'Quebraleña',
      'Abralaite',
      'Agua Blanca',
      'Bella Vista',
      'Manantial',
      'Palmitas',
      'Rio Blanco',
      'Paulina',
      'Pueblo Ledesma',
      'Agua Negra',
      'Libertador General San Martin',
      'Santa Rosa',
      'Molle Punco',
      'Pozo Bravo',
      'Puerta De Lipan',
      'Saladillo',
      'Colorados',
      'Cienaga',
      'Puerta De Colorados',
      'San Juan De Pozo Colora',
      'Aguadita',
      'Cienaga Grande',
      'Purmamarca',
      'Tres Morros',
      'Piedras Blancas',
      'Tunalito',
      'El Moreno',
      'Pozo Colorado',
      'Estancia Grande',
      'Caspala',
      'Tilcara',
      'Loma Larga',
      'Alfarcito',
      'El Perchel',
      'Huichaira',
      'Abra Mayo',
      'Juella',
      'Duraznos',
      'Yaquispampa',
      'Yala De Monte Carmelo',
      'Molulo',
      'La Banda',
      'Piedritas',
      'Don Emilio',
      'Palos Blancos',
      'Rosario De Rio Grande',
      'Medanitos',
      'Catua',
      'San Francisco',
      'Alto Calilegua',
      'San Isidro',
      'Fleming',
      'Aguas Calientes',
      'Las Pichanas',
      'Pila Pardo',
      'San Juan De Quillaques',
      'Potrero',
      'Jama',
      'Mina Providencia',
      'Olaroz Chico',
      'Loma Blanca',
      'Salar De Jama',
      'Coranzuli',
      'El Toro',
      'Olaroz Grande',
      'Vizcarra',
      'El Portillo',
      'Casa Puca',
      'La Poma',
      'Casa Grande',
      'El Aguilar',
      'Loteo Navea',
      'Los Alisos',
      'Pueblo Viejo',
      'Nuestra Señora Del Rosario',
      'La Toma',
      'El Ceibal',
      'Cerro Negro',
      'El Condor',
      'Escobar',
      'Llulluchayoc',
      'Corral Blanco',
      'Caimancito',
      'Urundel',
      'Dique La Cienaga',
      'Avalos',
      'El Carmen',
      'El Sunchal',
      'San Lucas',
      'Pampichuela',
      'Santa Barbara',
      'Puerta Verde',
      'Villa Carolina',
      'Rodeito',
      'Lavayen',
      'Villa Las Rosas',
      'El Mollar',
      'El Quemado',
      'Arrayanal',
      'La Manga',
      'Ovejeria',
      'Cholacor',
      'Yavi Chico',
      'San Jose',
      'Casti',
      'Chalcamayoc',
      'Quirquinchos',
      'Larcas',
      'La Cienega',
      'La Palca',
      'San Leon',
      'Villa Maria',
      'Hornillos',
      'La Cruz',
      'El Angosto',
      'Timon Cruz',
      'Pizcuno',
      'Merco',
      'Vizcacheras',
      'Mina Eureka',
      'El Filo',
      'Oratorio',
      'Santa Catalina',
      'Toro Muerto',
      'Valle Colorado',
      'Pampa Blanca',
      'Pampa Vieja',
      'Barrios',
      'Cerro Colorado',
      'Esquina Grande',
      'Cangrejos',
      'Cangrejillos',
      'Barrio El Milagro',
      'Alto Verde',
      'Monterrico',
      'San Vicente',
      'Los Lapachos',
      'Tastas',
      'Maimara',
      'El Fuerte',
      'La Mendieta',
      'Sauzal',
      'San Bernardo',
      'Volcan',
      'Barcena',
      'Chilcayoc',
      'Queta',
      'Casabindo',
      'Rumi Cruz',
      'Sauzalito',
      'Tambillos',
      'Pasajes',
      'Quinilican',
      'Rachaite',
      'Miraflores De La Candelaria',
      'Encrucijada',
      'Agua Chica',
      'Agua Caliente De La Puna',
      'Sayate',
      'Cochinoca',
      'Abra Pampa',
      'Tabladitas',
      'Doncellas',
      'San Pedro',
      'Arroyo Colorado',
      'Palo Hachado',
      'El Acheral',
      'San Juan De Dios',
      'Vinalito',
      'Santa Rita',
      'Agua Salada',
      'La Lucrecia',
      'Chucalezna',
      'Cianzo',
      'Queragua',
      'Valiazo',
      'Capla',
      'San Roque',
      'Coraya',
      'Uquia',
      'Chorrillos',
      'Aparzo',
      'Ocumazo',
      'Ovara',
      'Chorcan',
      'Varas',
      'Pucara',
      'Palca De Varas',
      'Coctaca',
      'Palca De Aparzo',
      'Hornaditas',
      'Humahuaca',
      'Rodero',
      'Calete',
      'Ronque',
      'Tres Cruces',
      'Juranco',
      'Tipal',
      'Valle Grande',
      'Puesto Del Marquez',
      'Macho Cruz',
      'La Redonda',
      'Arbolito Nuevo',
      'Liviara',
      'Lopiara',
      'Ramallo',
      'Nuevo Pirquitas',
      'Mina Pirquitas',
      'Orosmayo',
      'Salitre',
      'Coyaguaima',
      'Puente Lavayen',
      'Sauce Guacho',
      'Santa Clara',
      'La Cienaga',
      'Sansana',
      'Sansana Norte',
      'La Quiaca',
      'Tafna',
      'Mina 9 De Octubre',
      'Carahunco',
      'Las Escaleras',
      'Palpala',
      'El Remate',
      'El Brete',
      'Centro Forestal',
      'El Algarrobal',
      'El Pongo',
      'Los Blancos',
      'El Cucho',
      'Lecheronal',
      'Retiro',
      'La Quinta',
      'El Palmar',
      'El Piquete',
      'La Aguada',
      'Piedra Negra',
      'Sol De Mayo',
      'Mina Belgica',
      'Rodeo',
      'Cerrillos',
      'La Intermedia',
      'Chocoite',
      'Abra Colorada',
      'Pumahuasi',
      'Pulpera',
      'Punta Del Agua',
      'Pozuelos',
      'Guayatayoc',
      'Mina Pan De Azucar',
      'Rinconada',
      'Santo Domingo',
      'Casa Colorada',
      'Laguna Larga',
      'Ramadas',
      'Nazareno',
      'Carahuasi',
      'San Pablo De Reyes',
      'Tiraxi Grande',
      'Las Capillas',
      'Leon',
      'Ocloyas',
      'Lozano',
      'Jaire',
      'Duraznal',
      'Yerba Buena',
      'Despensa',
      'Los Nogales',
      'Tiraxi',
      'Yala',
      'Tesorero',
      'Payo',
      'Bananal',
      'Yuto',
      'El Talar',
      'Manantiales',
      'Puesto Viejo',
      'Negra Muerta',
      'Casillas',
      'Azul Pampa',
      'Miyuyoc',
      'La Cueva',
      'Hipolito Yrigoyen',
      'Condor',
      'El Porvenir',
      'Sijes',
      'Puesto Sey',
      'Huancar',
      'Pastos Chicos',
      'Olacapato',
      'Susques',
      'Casira',
      'Calahoyo',
      'Cieneguillas',
      'Puesto Grande',
      'Yoscaba',
      'Rodeo Chico',
      'Puesto Chico',
      'Fraile Pintado',
      'La Bajada',
      'San Borjas',
      'Chalican',
      'Maiz Negro',
      'Tortugas',
    ],
    'AR-L': [
      'Lihuel Calel',
      'Puelches',
      'Chacharramendi',
      'Valle Daza',
      'Ojeda',
      'Alta Italia',
      'Potrillo Oscuro',
      'Barrancas Coloradas',
      'Santa Rosa',
      'Cachirulo',
      'El Tropezon',
      'Toay',
      'Damian Maisonave',
      'Puelen',
      'Mauricio Mayer',
      'Colonia Ines Y Carlota',
      'Realico',
      'Colonia El Destino',
      'Winifreda',
      'Parera',
      'Limay Mahuida',
      'Quetrequen',
      'Miguel Cane',
      'Bernardo Larroude',
      'Bernasconi',
      'Sarah',
      'Intendente Alvear',
      'Lonquimay',
      'Speluzzi',
      'General San Martin',
      'Luan Toro',
      'Pichi Huinca',
      'Las Piedritas',
      'Falucho',
      'Ingeniero Foster',
      'La Maruja',
      'Loboco',
      'Cuchillo Co',
      'Abramo',
      'Hucal',
      'Rancul',
      'Chamaico',
      'Alpachiri',
      'Urdane',
      'Estancia La Natural',
      'Quemu Quemu',
      'La Puma',
      'Atreuco',
      'Macachin',
      'Estancia El Pampero',
      'Colonia El Provenir',
      'Monte Nievas',
      'Anzoategui',
      'Gaviotas',
      'La Adela',
      'Dorila',
      'Algarrobo Del Aguila',
      'Remeco',
      'Guatrache',
      'Estancia Ruca Pire',
      'Trenel',
      'Estancia El Tigre',
      'Estancia La Fama',
      'Caleufu',
      'Agua De Torres',
      'Chosmalal',
      'La Humada',
      'El Durazno',
      'Carro Quemado',
      'Colonia Los Toros',
      'Santa Teresa',
      'Adolfo Van Praet',
      'Colonia Santa Maria',
      'Colonia Chapalco',
      'Naico',
      'Ataliva Roca',
      'General Acha',
      'El Carancho',
      'El Veraneo',
      'Utracan',
      'Epu Pel',
      'Unanue',
      'Gamay',
      'Estancia Santa Aurelia',
      'General Pico',
      'Trebolares',
      'Estancia El Puma',
      'El Tala',
      'Ingeniero Luiggi',
      'Relmo',
      'Victorica',
      'Ivanowsky',
      'Catrilo',
      'Colonia La Carlota',
      'Arata',
      'Villa San Roque',
      'Los Hornos',
      'Mariano Miro',
      'Coronel Hilario Lagos',
      'La Reforma',
      'Gobernador Duval',
      'Huelen',
      'Colonia Baron',
      'Colonia San Jose',
      'Embajador Martini',
      'Colonia San Juan',
      'General Manuel J. Campos',
      'La Loma',
      'Miguel Riglos',
      'Colonia San Miguel',
      'Cereales',
      'Loventue',
      'Conhelo',
      'Tomas M. Anchorena',
      'Rolon',
      'Hidalgo',
      'Telen',
      'Villa Mirasol',
      'Eduardo Castex',
      'Colonia La Raquel',
      'Boeuf',
      'Casa De Piedra',
      'Vertiz',
      'Anguil',
      'Uriburu',
      'La Gloria',
      'Agustoni',
      'Arbol Solo',
      'Medanos Negros',
      'Santa Isabel',
      'Colonia La Pastoril',
      '25 De Mayo',
      'Gobernador Ayala',
      'Colonia El Sauzal',
      'Colonia Chica',
      'Quehue',
      'Rucanelo',
      'Teniente General Emilio Mitre',
      'Ceballos',
      'Peru',
      'Cotita',
      'Colonia La Colorada Chica',
      'Colonia San Rosario',
      'Jacinto Arauz',
      'Metileo',
      'Doblas',
    ],
    'AR-F': [
      'La Escalera',
      'La Torrecita',
      'Huaco',
      'Villa Sanagasta',
      'Arauco',
      'Aimogasta',
      'Udpinango',
      'La Cauchita',
      'Tinocan',
      'La Cimbrita',
      'Termas De Santa Teresita',
      'San Antonio',
      'Estacion Mazan',
      'Villa Mazan',
      'Bañado De Los Pantanos',
      'Machigasta',
      'La Canchita',
      'Las Flores',
      'Polco',
      'El Garabato',
      'Santa Rita De La Zanja',
      'Villa Carmela',
      'Santa Lucia',
      'Base Chamical',
      'Esquina Del Norte',
      'Chamical',
      'La Resistencia',
      'El Retamo',
      'Pozo Redondo',
      'Pozo De La Vaca',
      'La Aguadita',
      'Rosillo Muerto',
      'Chulo',
      'El Quebrachal',
      'El Carmen',
      'Bella Vista',
      'Las Talas',
      'Los Baldes',
      'Los Bordos',
      'El Mollar',
      'Las Amoladeras',
      'Bajo De Lucas',
      'Santa Barbara',
      'La Cortada',
      'La Serena',
      'San Rafael',
      'Los Aguirres',
      'Pozo Del Medio',
      'La Colonia',
      'Mollaco',
      'Milagro',
      'El Quemado',
      'San Ramon',
      'Las Cortaderas',
      'San Jose',
      'San Roque',
      'La Maravilla',
      'Aguadita De Los Peralta',
      'La Represa',
      'Olpas',
      'Rio Grande',
      'San Cristobal',
      'La Barrera',
      'Agua Colorada',
      'El Cerco',
      'La Banderita',
      'La Dorada',
      'Santa Rita De Catuna',
      'La Ripiedra',
      'La Maruja',
      'El Fraile',
      'Los Tellos',
      'Ambil',
      'Colonia Ortiz De Ocampo',
      'El Barranco',
      'Los Barrialitos',
      'Torrecitas',
      'La Isla',
      'La Playa',
      'Los Mistoles',
      'Esquina Grande',
      'Balde Salado',
      'San Pedro',
      'Los Robles',
      'Andolucas',
      'Shaqui',
      'Alpasinche',
      'Cuipan',
      'Tuyubil',
      'El Retiro',
      'Chaupihuasi',
      'Salicas',
      'San Blas',
      'Amuschina',
      'Suriyaco',
      'La Huerta',
      'Santa Cruz',
      'El Virque',
      'Cortaderas',
      'El Simbolar',
      'Castro Barros',
      'El Bordo',
      'Bajo Hondo',
      'La Aguada',
      'Monte Grande',
      'Monte Negro',
      'San Isidro',
      'El Consuelo',
      'Tala Verde',
      'Nepes',
      'Colonia El Cisco',
      'Talva',
      'Loma Blanca',
      'Olta',
      'Esquina Del Sud',
      'S.De Las Higueras',
      'Chañar',
      'Miraflores',
      'Loma Alta',
      'Corral Del Negro',
      'Sierra De Los Quinteros',
      'La Florida',
      'Mascasin',
      'La Jarilla',
      'La Laguna',
      'El Totoral',
      'El Tala',
      'Abra Verde',
      'El Rodeo',
      'Casas Viejas',
      'El Potrerillo',
      'El Divisadero',
      'Las Toscas',
      'Valle Hermoso',
      'El Rosario',
      'Villa Casana',
      'Real Del Cadillo',
      'Los Lagarcitos',
      'La Calera',
      'Rodeo Grande',
      'La Consulta',
      'Santa Rita',
      'El Barrial',
      'Chelcos',
      'Agua De Aguirre',
      'La Callana',
      'Los Oros',
      'Agua Blanca',
      'El Cardon',
      'Chepes',
      'Alto Bayo',
      'Agua De La Piedra',
      'Desiderio Tello',
      'El Zampal',
      'Malligasta',
      'Las Higueritas',
      'San Miguel',
      'Santa Florentina',
      'Guanchin',
      'Miranda',
      'Sañogasta',
      'Colonia Vichigasta',
      'Colonia Malligasta',
      'Anguinan',
      'Vichigasta',
      'Nonogasta',
      'Chilecito',
      'Colonia Anguinan',
      'Tilimuqui',
      'Los Sarmientos',
      'San Nicolas',
      'Colonia Catinzaco',
      'La Puntilla',
      'La Cienaga',
      'Boca De La Quebrada',
      'El Horno',
      'Potrero Grande',
      'La Armonia',
      'Casa Pintada',
      'Distrito Pueblo',
      'La Banda',
      'Villa San Jose De Vinchina',
      'Jague',
      'Angulos',
      'Plaza Vieja',
      'Campanas',
      'Santo Domingo',
      'Famatina',
      'Bajo Carrizal',
      'Alto Carrizal',
      'Pituil',
      'La Cuadra',
      'Antinaco',
      'El Jumeal',
      'Barrio De Galli',
      'Chañarmuyo',
      'Talamuyuna',
      'San Juan',
      'Colonia Frutihorticola',
      'La Lata',
      'Carrizal',
      'Cebollar',
      'Las Higuerillas',
      'El Duraznillo',
      'El Barreal',
      'Puerto Alegre',
      'El Sunchal',
      'El Quebracho',
      'San Nicolas Del Recreo',
      'La Rioja',
      'La Ramadita',
      'San Bernardo',
      'La Antigua',
      'Bazan',
      'Saladillo',
      'Las Catas',
      'Anchico',
      'El Cantadero',
      'La Lancha',
      'San Lorenzo',
      'Sierra Brava',
      'Trampa Del Tigre',
      'Estancia San Jose',
      'Ampata',
      'La Cañada',
      'Pozo De La Yegua',
      'Villa Castelli',
      'Rivadavia',
      'El Condado',
      'Parecitas',
      'Villa Union',
      'Anchumbil',
      'El Chuschin',
      'Piedra Pintada',
      'La Brea',
      'Mina Delina',
      'Los Tambillos',
      'El Molle',
      'Villa Esther',
      'Las Cuevas',
      'Guandacol',
      'Santa Clara',
      'Los Patillos',
      'Paso San Isidro',
      'Aicuña',
      'El Fuerte',
      'El Zapallar',
      'Los Nacimientos',
      'Los Palacios',
      'Pagancillo',
      'Banda Florida',
      'Santa Maria',
      'El Porongo',
      'Nacate',
      'Unquillal',
      'La Chimenea',
      'El Retamal',
      'Casangate',
      'Loma Larga',
      'Tosquea',
      'Portezuelo',
      'Solca',
      'El Chorro',
      'Quebrada Del Vallecito',
      'Los Barreales',
      'Salana',
      'Los Algarrobos',
      'Las Barrancas',
      'Puluchan',
      'Malanzan',
      'Tuani',
      'Tres Cruces',
      'Balde De Amaya',
      'Atiles',
      'El Potrero',
      'La Suspension',
      'Tres De Mayo',
      'La Porfia',
      'Isla Del Tigre',
      'Siempre Verde',
      'El Balde De La Viuda',
      'La Lomita',
      'Las Malvinas',
      'Villa Nidia',
      'El Abra',
      'El Cadillo',
      'Kilometro 14',
      'Villa Luisa',
      'La Industria',
      'El Mosquito',
      'El Calden',
      'La Chilca',
      'Puesto Los Cornejos',
      'La Represita',
      'Las Ventanitas',
      'Ulapes',
      'Aguayo',
      'El Medanito',
      'Algarrobo Grande',
      'Corral De Isaac',
      'Cuatro Esquinas',
      'La Reserva',
      'Puesto Dichoso',
      'Entre Rios',
      'Santa Elena',
      'La Lilia',
      'El Buen Retiro',
      'San Solano',
      'Virgen Del Valle',
      'Nueva Esperanza',
      'Patquia Viejo',
      'La Mesada',
      'Amana',
      'La Torre',
      'Patquia',
      'Los Colorados',
      'Paganzo',
      'Aguango',
      'Represa De La Punta',
      'Los Baldecitos',
      'Balde San Isidro',
      'El Chiflon',
      'Santa Vera Cruz',
      'Pinchas',
      'Ismiango',
      'Anjullon',
      'Los Molinos',
      'Aminga',
      'Chuquis',
      'Anillaco',
      'Las Lomitas',
      'Punta De Los Llanos',
      'Las Aguaditas',
      'Aguadita De Los Valdeces',
      'Alcazar',
      'Tama',
      'Bajo Verde',
      'Tasquin',
      'Chila',
      'Colozocan',
      'El Monte',
      'Tuizon',
      'Santa Teresa',
      'Pacatala',
    ],
    'AR-M': [
      'El Manzano',
      'Las Chacras',
      'Malargue',
      'La Junta',
      'Luanco',
      'Las Leñas',
      'El Chacay',
      'Agua Escondida',
      'Minacar',
      'El Infiernillo',
      'Los Carrizales',
      'El Vatro',
      'Rincon Chico',
      'La Salinilla',
      'El Alambrado',
      'Calmuco',
      'Llano Blanco',
      'Pata Mora',
      'Rio Grande',
      'Los Corrales',
      'El Carapacho',
      'La Valenciana',
      'Los Molles',
      'La Jaula',
      'Capiz',
      'San Carlos',
      'Pareditas',
      'Chilecito',
      'El Parral',
      'Piedras Blancas',
      'Tres Esquinas',
      'La Consulta',
      'Barrio El Cepillo',
      'Paso De Las Carretas',
      'Eugenio Bustos',
      'El Capacho',
      'Barrio Carrasco',
      'Los Alamitos',
      'Villa El Chacon',
      'Barrio Chivilcoy',
      'El Divisadero',
      'Buen Orden',
      'Montecaseros',
      'Barrio La Estacion',
      'Chapanay',
      'Barrio Ntra. Sra. De Fatima',
      'Tres Porteñas',
      'Chivilcoy',
      'Barrio Los Charabones',
      'Alto Verde',
      'Ciudad De San Martin',
      'El Ramblon',
      'Barrio Emanuel',
      'Villa Centenario',
      'El Espino',
      'Palmira',
      'Nueva California',
      'Alto Salvador',
      'Colonia Lambare',
      'Villa Antigua',
      'Cruz Del Yugo',
      'Desaguadero',
      'Chamuscao',
      'Maquinista Levet',
      'Las Chacritas',
      'El Campamento',
      'La Gloriosa',
      'Cadetes De Chile',
      'La Menta',
      'La Paz',
      'El Lechucito',
      'Las Lagunitas',
      'La Asuncion',
      'El 15',
      'Las Violetas',
      'El Carmen',
      'Arroyito',
      'El Plumero',
      'Ingeniero Gustavo Andre',
      'Villa Tulumaya',
      'El Retamo',
      'Estacion Kilometro 976',
      'Barrio La Pega',
      'Barrio Los Olivos',
      'El Retiro',
      'Barrio Virgen Del Rosario',
      'San Miguel',
      'Barrio La Esperanza',
      '3 De Mayo',
      'Costa De Araujo',
      'Barrio Lagunas De Bartoluzzi',
      'El Forzudo',
      'La Polvosa',
      'San Francisco',
      'Los Sauces',
      'El Paramillo',
      'Jocoli',
      'Barrio Alto Del Olvido',
      'Barrio Jocoli Ii',
      'Barrio Los Jarilleros',
      'Lagunita',
      'La Holanda',
      'Jocoli Viejo',
      'Capilla Del Rosario',
      'El Vergel',
      'Barrio La Palmera',
      'Colonia Sur',
      'La Angelina',
      'Moron Viejo',
      'La Dormida',
      'Barrio 12 De Octubre',
      'Moron Chico',
      'La Bandera',
      'Gobernador Civit',
      'Parrales Mendocinos',
      'Las Catitas',
      'Balde Nuevo',
      'La Cienaguita',
      'Lomas Blancas',
      'El Algarrobo',
      'Santa Rosa',
      'San Pedro',
      'Villa Cabecera',
      'La Costa',
      'Barrio Molina Cabrera',
      'Balde De Piedra',
      'Barrio Maria Auxiliadora',
      'Talquenca',
      'Los Lotes',
      'La Josefa',
      'Catitas Viejas',
      'Colonia San Jorge',
      'Banderita',
      'Los Compartos',
      'Poste De Fierro',
      'El Ceibo',
      'Cochico',
      'La Marzolina',
      'General Alvear',
      'La Escandinava',
      'La Montilla',
      'El Juncalito',
      'Corral De Lorca',
      'La California',
      'La Mora',
      'Goico',
      'Canalejas',
      'Ovejeria',
      'Carmensa',
      'Kilometro 884',
      'Los Campamentos',
      'Bowen',
      'Uspallata',
      'La Union',
      'La Cieneguita',
      'El Zapallar',
      'Hornito Del Gringo',
      'Puente Del Inca',
      'Las Heras',
      'El Challao',
      'Capdevila',
      'Villavicencio',
      'La Hullera',
      'El Puestito',
      'Guido',
      'Las Cortaderas',
      'El Plumerillo',
      'El Algarrobal',
      'Panquehua',
      'Espejo',
      'Polvaredas',
      'Blanco Encalada',
      'La Casa Del Tigre',
      'Punta De Vacas',
      'El Resguardo',
      'Los Penitentes',
      'Las Cuevas',
      'Salagasta',
      'Sierras De Encalada',
      'El Borbollon',
      'Santa Elena',
      '6A. Seccion',
      '3A. Seccion',
      '8A. Seccion',
      '5A. Seccion',
      '1A. Seccion',
      '2A. Seccion',
      '11A. Seccion',
      '10A. Seccion',
      '7A. Seccion',
      '9A. Seccion',
      '4A. Seccion',
      'Bermejo',
      'Rodeo De La Cruz',
      'Dorrego',
      'Jesus Nazareno',
      'Colonia Segovia',
      'General Belgrano',
      'Guaymallen',
      'El Sauce',
      'La Primavera',
      'Los Corralitos',
      'Buena Nueva',
      'Pedro Molina',
      'Villa Nueva',
      'Kilometro 11 (Guaymallen)',
      'San Francisco Del Monte',
      'Puente De Hierro',
      'Las Cañas',
      'San Jose',
      'Presidente Sarmiento',
      'Villa Marini',
      'Las Tortugas',
      'Villa Hipodromo',
      'Godoy Cruz',
      'Gobernador Benegas',
      'Los Alamos',
      'Barrancas',
      'El Pedregal',
      'Isla Grande',
      'Colonia Jara',
      'Russell',
      'Lunlunta',
      'Colonia Bombal',
      'Coquimbito',
      'General Ortega',
      'Villa Teresa',
      'Barrio Jesus De Nazaret',
      'Colonia Irigoyen',
      'General Gutierrez',
      'El Paraiso',
      'Luzuriaga',
      'Villa Seca',
      'Santa Blanca',
      'San Roque',
      'Rodeo Del Medio',
      'Maipu',
      'Isla Chica',
      'Fray Luis Beltran',
      'Cruz De Piedra',
      'Gualtallary',
      'Zapata',
      'Tupungato',
      'Ancon',
      'El Peral',
      'Cordon Del Plata',
      'Ojo De Agua',
      'Barrio Belgrano Norte',
      'El Zampalito',
      'Santa Clara',
      'La Arboleda',
      'Villa Bastias',
      'El Zampal',
      'La Carrera',
      'Estancia Palma',
      'Estancia Las Cuevas',
      'Villa El Refugio',
      'Mayor Drummond',
      'Potrerillos',
      'El Carrizal',
      'Valle Del Sol',
      'La Puntilla',
      'Barrio Adina I Y Ii',
      'Anchoris',
      'Las Vegas',
      'Los Manantiales',
      'Costa Flores',
      'Nueva Colonia',
      'Lujan De Cuyo',
      'Perdriel',
      'El Salto',
      'La Picada',
      'Ugarteche',
      'Cacheuta',
      'Chacras De Coria',
      'Vistalba',
      'Carrodilla',
      'El Carmelo',
      'Agrelo',
      'Barrio Perdriel Iv',
      'Las Compuertas',
      'Las Carditas',
      'La Remonta',
      'Agua Amarga',
      'Colonia Las Rosas',
      'La Riojita',
      'Campo Los Andes',
      'San Pablo',
      'El Totoral',
      'Barrio San Cayetano',
      'Las Pintadas',
      'Tunuyan',
      'Vista Flores',
      'Barrio Rivadavia',
      'Medrano',
      'La Libertad',
      'Barrio Cooperativa Los Campamentos',
      'Santa Maria De Oro',
      'La Florida',
      'La Esperanza',
      'Andrade',
      'Costa Anzorena',
      'Reduccion De Abajo',
      'Cuadro Ortega',
      'Rivadavia',
      'La Central',
      'El Mirador',
      'Mundo Nuevo',
      'Los Arboles',
      'Phillips',
      'Junin',
      'Algarrobo Grande',
      'Rodriguez Peña',
      'Los Barriales',
      'Ingeniero Giagnoni',
      'La Colonia',
      'Salto De Las Rosas',
      'Barrio Echeverria',
      'Villa Atuel',
      'Cuadro Nacional',
      'San Rafael',
      'El Cerrito',
      'Los Claveles',
      'Las Aguaditas',
      'Los Sifones',
      'Resolana',
      'La Tosca',
      'Aristides Villanueva',
      'Barrio Primavera',
      'Los Pejes',
      'Colonia El Usillal',
      'Rama Caida',
      'Santa Teresa',
      'Real Del Padre',
      'La Horqueta',
      'El Sosneado',
      'Rincon Del Indio',
      'Los Reyunos',
      'Piedra De Afilar',
      'La Guevarina',
      'Cuadro Bombal',
      'Colonia Colomer',
      'Colonia Gelman',
      'La Tombina',
      'El Nihuil',
      'Las Malvinas',
      'Colonia Jauregui',
      'Colonia Rusa',
      'Guadales',
      'Colonia Elena',
      '25 De Mayo',
      'Monte Coman',
      'La Vasconia',
      'La Pichana',
      'El Escorial',
      'Barrio El Nevado',
      'Capitan Montoya',
      'El Vidalino',
      'Cuesta De Los Terneros',
      'Barrio Empleados De Comercio',
      'Pedro Vargas',
      'Barrio Las Rosas',
      'La Llave Nueva',
      'Barrio Intendencia',
      'Punta Del Agua',
      'La Llave Sur',
      'Jaime Prats',
      'Goudge',
      'El Vencedor',
      'Colonia Lopez',
      'La Llave',
      'Soitue',
      'Los Tableros',
      'El Tropezon',
      'Barrio Campos El Toledano',
      'Pobre Diablo',
      'La Nora',
      'Villa Atuel Norte',
    ],
    'AR-N': [
      '3 De Mayo',
      'Garuhape',
      'San Miguel',
      'Puerto Garuhape',
      'Pozo Azul',
      'Nuestra Señora De Itati',
      'Duran',
      'Tres Vecinos',
      'Forestal (San Antonio)',
      'Salto Encantado',
      'Tres Capones',
      'Las Tunas',
      'Sierrita San Jos',
      'Taranco',
      'San Jose',
      'Colonia San Jose',
      'Pindapoy',
      'Puerto España',
      'General Urquiza',
      'El Destierro',
      'Barrio Tungoil',
      'Puerto Nuevo',
      'Puerto Gisela',
      'Seguin',
      'Campo Viera',
      'Yaza',
      'Panambi',
      'Mojon Grande',
      'Cerro Cora',
      'Villa Venecia',
      'La Invernada',
      'Las Quemadas',
      'Bella Vista',
      'Azara',
      'Colonia Apostoles',
      'Rincon De Azara',
      'Capon Bonito',
      'Villa Marttos',
      'Obera',
      'Picada Vieja',
      'Guayabera',
      'Tres Esquinas',
      'Villa Barreyro',
      'El Salto',
      'Puerto San Isidro',
      'Barra Concepcion',
      'San Isidro',
      'Concepcion De La Sierra',
      'Puerto San Lucas',
      'Cien Hectareas',
      'El Tigre',
      'Parejha',
      'Cuatro Bocas',
      'Colonia Victoria',
      'Profundidad',
      'Tacuaruzu',
      '9 De Julio Kilometro 20',
      'Valle Hermoso',
      'Mariano Moreno',
      '9 De Julio',
      'Pueblo Nuevo',
      'Aguaray Guazu',
      'Puerto Mado',
      'Maria Magdalena',
      'Nueva Delicia',
      'Yacutinga',
      'Pastoreo',
      'Gobernador Roca',
      'Roca Chica',
      'Olegario V. Andrade',
      'Colonia Alemana',
      'Picada Galitziana',
      'Villa Bonita',
      'Yerbal Viejo',
      'Picada Guaraipo',
      'Barrio Escuela 633',
      'Picada Internaci',
      'Villa Union',
      'Campo Ramon',
      'Colonia Guaraypo',
      'Laharrague',
      'Bario Ita',
      'Puerto Laharrague',
      'Guatambu',
      'Barrio Guatambu',
      'Barrio Cuatro Bocas',
      'Montecarlo',
      'Monteagudo',
      'Pepiri Mini',
      'Martin Gñemes',
      'Colonia Primavera',
      'El Soberbio',
      'La Bonita',
      'Andresito (El Soberbio)',
      'Fray Luis Beltran',
      'Picada Guarani',
      'El Boton (El Soberbio)',
      'Nueva (El Soberbio)',
      'Arroyo Bonito (El Soberbio)',
      'Fortin Mborore',
      'Puerto Peninsula',
      'Puerto Canoas',
      'Puerto Iguazu',
      'Villa Alta',
      'Cataratas Del Iguazu',
      'Yryapu',
      'Bonpland',
      'San Javier',
      'Rincon Del Guerrero',
      'Invernada Grande',
      'Picada San Javier',
      'Los Galpones',
      'Picada Sud',
      'Picada Africana',
      'Leandro N. Alem',
      'El Porvenir',
      'Nemesio Parma',
      'Posadas',
      'Colonia Martires',
      'Martires',
      'El Barrerito',
      'Santa Rita',
      'La Uva',
      'San Francisco De Asis',
      'Coronel Pringles',
      'Barra Bonita',
      'Alba Posse',
      'Colonia Acaragua',
      'Dos Arroyos',
      'Alberdi',
      'Picada Yacutinga',
      'Almafuerte',
      'Corpus',
      'Santiago De Liniers',
      'Picada Belgrano',
      'Cerro Azul',
      'Picada Polaca',
      'Los Indios',
      'Picada Vasca',
      'General Alvear',
      'Arroyo Pastora',
      'Loreto',
      'Flora',
      'Puerto Tabay',
      'Oasis',
      'Villa Libertador General San Martin',
      'Colonia Sol De May',
      'Jardin America',
      'Picada Flor',
      'Picada El Molino',
      'Las Mercedes',
      'El Pacifico (San Vicente)',
      'Puerto Argentino (San Vicente)',
      'Guiray',
      'Picada Sulma (San Vicente)',
      'Picada Mojon Grande (San Vicente)',
      'Colonia Florida',
      'El Socorro',
      'San Vicente',
      'El Lucero (San Vicente)',
      'Fracran',
      'Santa Ines',
      'Barrio Nuevo Garupa',
      'Garupa',
      'San Juan De La Sierra',
      'Santa Maria',
      'La Corita',
      'Cascabel',
      'Arroyo Santa Maria',
      'Cerro Martires',
      'Puerto Naranjito',
      'Colonia Naranjito',
      'Colonia Polana',
      'Villa Urrutia',
      'El Alcazar',
      '1 De Mayo',
      'Kilometro 17 (Ruta 8)',
      'Campo Grande',
      'Jose Luis',
      'Barrio Del Lago',
      'Candelaria',
      'Aldea Aborigen',
      'Aparicio Cue',
      'Invernada',
      'Villa Emma',
      'San Ignacio',
      'San Rafael',
      'Teyu Cuare',
      'Domingo Savio',
      'Arroyo Del Medio',
      'Fachinal',
      'San Andres',
      'El Palmital',
      'Colonia Aurora',
      'Puerto Londero',
      'Chafariz',
      'Alicia Baja',
      'Las Limas',
      'Colonia Alicia',
      'Aparecida',
      'San Carlos',
      'Colonia El Progreso',
      'Flor De Mayo',
      'Colonia Alicia Alta',
      '25 De Mayo',
      'Picada Malvinas',
      'El Saltito',
      'La Yerba',
      'Torta Quemada',
      'Libertad',
      'Alborada',
      'Picada Rio Uruguay',
      'Tamandua',
      'Colonia Oro Verde',
      'San Alberto',
      'Puerto Rico',
      'Mbopicua',
      'Capioviciño',
      'Gobernador Lopez',
      'El Chaton',
      'La Fortaleza',
      'Puerto Santa Ana',
      'Santa Ana',
      'Aldea Guapoy',
      'Puerto Errecaborde',
      'Puerto Libertad',
      'Tirica',
      'Villa Cooperativa',
      'Piray Kilometro 18',
      'Puerto Piray',
      'Colonia Santa Teresa',
      'Villa Parodi',
      'Guarani',
      'Villa Sommer',
      'Picada Yapeyu',
      'Taruma',
      'Puerto Caraguatay',
      'Monte Quemado',
      'Avellaneda',
      'Puerto Avellaneda',
      'Caraguatay',
      'El Bonito',
      'Tacuara',
      'Santo Pipo',
      'Puerto Wanda',
      'Tupi Cua',
      'El Susto',
      'Wanda',
      'Puerto Leoni',
      'Villa Akerman',
      'Colonia Flora',
      'Puerto Mineral',
      'Hipolito Yrigoyen',
      'Helvecia',
      'Robillard Cue (Puerto Esperanza)',
      'Puerto Segundo',
      'Esperanza',
      'Celman',
      'Picada Filandesa',
      'San Martin',
      'San Gotardo',
      'Capiovi',
      'Invernada Chica',
      'Invernada De Itacaruare',
      'Itacaruare',
      'La Arrocera',
      'Villa Roulet',
      'Eldorado',
      'Puerto Pinares',
      'Paraiso',
      'Cruce Caballero',
      'Picada Maria Auxiliadora',
      'San Pedro',
      'Alegria',
      'Gentile',
      'Palmera Boca',
      'Villa Don Bosco',
      'Santa Rosa',
      'Bello Horizonte',
      'Rio Yaboty',
      'Piñalito Sur',
      'Tobuna',
      'Macaca',
      'Nueva Esperanza (Bernardo Irigoyen)',
      'Aster',
      'Las Minas',
      'Cerro Siete (San Antonio)',
      'Azopardo',
      'San Antonio',
      'Piñalito Norte',
      'El Central (San Antonio)',
      'Paraje 130',
      'Campo Alegre',
      'Saracura (San Antonio)',
      'Barbacua (San Antonio)',
      'Chico Alferez',
      'Florentino Ameghino',
      'Puerto Rosario',
      'Puerto Andresito',
      'Deseado',
      'Caburei',
      'Integracion',
      '28 De Diciembre',
      'Puerto Deseado',
      'Comandante Andresito',
      'Caballero (San Antonio)',
      'Peninsula',
      'Soberania',
      '11 De Septiembre',
      'Arroyo Verd',
      'Mavalle Pindayti',
      'Cuña Piru',
      'Picada Propaganda',
      'Tres Arroyos',
      'Las Yerbas',
      'Cuña Piru I',
      'Araza',
      'El Cruce Pindayti',
      'Aristobulo Del Valle',
      'Ruiz De Montoya',
      'Picada Sueca',
      'Villa Libertad',
      'Colonia Finlandesa',
      'Caa - Yari',
      'Estacion Apostoles',
      'Apostoles',
      'El Paraiso',
      'Barrio Rural',
      'El Cruce',
      'La Capilla',
      'Barrio Escuela 461',
      'Los Helechos',
      'Bajo Pepiri',
      'Dos Hermanas',
      'Bernardo De Irigoyen',
      'Facundo Quiroga',
      'Laguna Azul',
      'Juan Manuel De Rosas',
      'Nucleo Ii',
      'El Porton',
      'Dos De Mayo Nucleo I',
      'Pueblo Illia',
      'Cascuda',
      'Indumar',
      'Colonia Milagro',
      'Dos De Mayo Nucleo Ii',
      'Dos De Mayo Nucleo Iii',
      'Nucleo I',
      'Cainguas',
      'Saltito Ii',
      'Mborore',
      'Panambi Kilometro 8',
      'Panambi Kilometro 15',
    ],
    'AR-Q': [
      'Vista Alegre Norte',
      'Vista Alegre Sur',
      'Barrio Ruca Luhe',
      'Pilo Lil',
      'Guañacos',
      'Lago Meliquina',
      'Senillosa',
      'Aguada Toledo',
      'Arroyito',
      'China Muerta',
      'Aquihueco',
      'Tricao Malal',
      'Cancha Huinganco',
      'Campana Mahuida',
      'Loncopue',
      'Neuquen',
      'Colonia Valentina',
      'El Chenque',
      'Pantanitos',
      'Piedra Del Aguila',
      'Auca Mahuida',
      'Cayanta',
      'Los Carrizos',
      'Villa Del Nahueve',
      'Bella Vista',
      'Añelo',
      'El Manzano',
      'Huinganco',
      'Butalon Norte',
      'Charra Ruca',
      'Cumelen',
      'Correntoso',
      'Villa La Angostura',
      'Chimehuin',
      'Quechuquina',
      'Auquinco',
      'Trompul (Rai)',
      'Chapelco',
      'Lago Hermoso',
      'Estancia Santa Lucia',
      'Isla Victoria',
      'Nahuel Huapi',
      'La Lipela',
      'Huemul',
      'Santa Maria',
      'Espejo',
      'Sauzal Bonito',
      'Tierras Blancas',
      'Lileo',
      'Los Miches',
      'Agua Del Overo',
      'Belisle',
      'Casa De Piedra',
      'Bajada De Los Molles',
      'El Rincon',
      'Catatun',
      'Chacayco',
      'Catan Lil',
      'La Negra',
      'Lapa',
      'Media Luna',
      'Las Cortaderas',
      'Costa Del Catan Lil',
      'Espinazo Del Zorro',
      'Los Remolinos',
      'El Salitral',
      'El Sauce',
      'La Picaza',
      'Buta Ranquil',
      'Aguada Chacayco',
      'Laguna Auquinco',
      'Ranquil Vega',
      'Carri Lil',
      'Rahue',
      'Quillen',
      'Abra Ancha',
      'Currumil Quillen',
      'Haras Pulmari',
      'Quilca',
      'Lonco Mula',
      'Taquimilan',
      'Taquimilan Arriba',
      'Chacaico',
      'Taquimilan Centro',
      'Ranquilco',
      'La Greda',
      'Rahueco',
      'Tres Chorros',
      'Hualcupen',
      'Colipilli Abajo',
      'Ranquilon',
      'Lonco Luan',
      'Villa Pehuenia',
      'Villa Union',
      'Moquehue',
      'Plottier',
      'Puente Picun Leufu',
      'Cochico',
      'Lonco Vaca',
      'Coyuco',
      'Bajada Vieja',
      'Bajada Del Agrio',
      'Agrio Del Medio',
      'Los Chihuidos',
      'Ramon M. Castro',
      'Santo Domingo',
      'Paso Aguerre',
      'Malleo',
      'Atreuco Arriba',
      'Paimun',
      'Confluencia Del Malleo',
      'Los Helechos',
      'Nahuel Mape Arriba',
      'San Cabao',
      'Huilqui Menuco',
      'Aucapan Abajo',
      'Costa Del Malleo',
      'Atreuco (Rai)',
      'Nahuel Mapi Abajo',
      'Invernada Vieja',
      'Varvarco',
      'Colomichico',
      'Las Ovejas',
      'Centenario',
      '11 De Octubre',
      'Mariano Moreno',
      'Covunco Centro',
      'Los Hornos',
      'Barrancas',
      'Agua Caliente',
      'Rincon De Los Sauces',
      'Leuto Caballo',
      'Tilhue',
      'La Salada',
      'Arroyo Blanco',
      'Los Molles',
      'Chapua',
      'Junin De Los Andes',
      'La Rinconada',
      'Cerro De Los Pinos',
      'Pampa Del Malleo',
      'Lolog',
      'Lago Lolog',
      'San Martin De Los Andes',
      'Puente Blanco',
      'Mallin Del Toro',
      'Huncal',
      'Huarenchenque',
      'Pichaihue',
      'Cajon De Almaza',
      'Quintuco',
      'Covunco Arriba',
      'Aguada Del Lucero',
      'Los Catutos',
      'Mallin Del Muerto',
      'Zapala',
      'La Matansilla',
      'Manzano Amargo',
      'Pichi Neuquen',
      'Challaco',
      'Mari Menuco',
      'Loma De La Lata',
      'Cutral Co',
      'Chacras De Monte Hermoso',
      'Plaza Huincul',
      'Villa Traful',
      'Caviahue',
      'Copahue',
      'Aguada San Roque',
      'Quili Malal',
      'La Patagonia',
      'Octavio Pico',
      'Santo Tomas',
      'Covunco Abajo',
      'Laguna Blanca',
      'La Amarga',
      'Laguna Miranda',
      'Paso De Los Indios',
      'Carro Quebrado',
      'Codihue',
      'Pino Hachado',
      'Mallin Quemado',
      'La Patria',
      'Pino Solo',
      'Primeros Pinos',
      'Mallin Del Rubio',
      'Los Alazanes',
      'Mallin De Los Caballos',
      'El Chocon',
      'Villa El Chocon',
      'San Patricio Del Chañar',
      'Limay Centro',
      'Chorriaca',
      'Coihueco',
      'Trahuncura',
      'Andacollo',
      'La Primavera',
      'Huaraco',
      'El Cholar',
      'Chos Malal',
      'Saihueque Cacique',
      'Alumine',
      'Chacra 8',
      'San Demetrio',
      'La Buitrera',
      'Las Lajas',
      'Caepe Malal',
      'El Alamito',
      'Chacay Melehue/El Alamito',
      'Villa Del Curi Leuvu',
      'Los Menucos',
      'Las Coloradas',
      'Villa Pichi Picun Leufu',
      'Villa Rincon Chico',
      'Huaiquimil',
      'San Ignacio',
      'Zaina Yegua',
      'Piedra Pintada',
      'Cortadera',
      'Huantraico',
      'Huitrin',
      'San Eduardo',
      'Sierra De Huantraico',
      'El Huecu',
      'Picun Leufu',
    ],
    'AR-R': [
      'Naupa Huen',
      'Maquinchao',
      'Caita Toro',
      'Chanquin',
      'Campana Mahuida',
      'Arroyo Los Berros',
      'Paso Flores',
      'Cubanea',
      'Chipauquil',
      'Pichi Mahuida',
      'Las Grutas',
      'Arroyo Ventana',
      'Barda Del Medio',
      'Contralmirante Cordero',
      'Pilquiniyeu',
      'El Tropezon',
      'Vaca Laufquen',
      'Cerro Mesa',
      'Atraico',
      'La Esperanza',
      'Mina Santa Teresita',
      'Villa Mascardi',
      'Barrio Presidente Peron',
      'Cinco Saltos',
      'La Parra',
      'Ingeniero Jacobacci',
      'Laguna Blanca',
      'Villa Catedral',
      'Colonia Suiza',
      'San Carlos De Bariloche',
      'Villa Los Coihues',
      'Villa Llao Llao',
      'Villa Arelauquen',
      'Barrio El Pilar',
      'Villa Campanario',
      'Peninsula San Pedro',
      'Barrio La Barda',
      'Barrio La Costa',
      'Ingeniero Luis A. Huergo',
      'General Enrique Godoy',
      'Barrio Goretti',
      'Barrio La Lor',
      'Barrio Tres Luces',
      'Renteria',
      'Cuatro Esquinas',
      'Colonia Curri Lamuen',
      'Ferri',
      'Barrio Puente De Madera',
      'La Falda',
      'Las Perlas',
      'Barrio Maria Elvira',
      'Colonia Confluencia',
      'Barrio El Treinta',
      'Barrio Norte',
      'Tres Luces',
      'Barrio Puente 83',
      'Cipolletti',
      'Santa Rosa',
      'Nahuel Niyeu',
      'Salitral Negro',
      'El Cain',
      'Guardia Mitre',
      'Ojos De Agua',
      'Lipetren',
      'Yuquiche',
      'Darwin',
      'Rio Chico',
      'Catriel',
      'Las Bayas',
      'Pichi Leufu',
      'Paso Chacabuco',
      'Paso Miranda',
      'Corralito',
      'Paso De Los Molles',
      'Coquelen',
      'Pichi Leufu Abajo',
      'Pilcaniyeu',
      'Segunda Angostura',
      'Colonia Chocori',
      'Boca De La Travesia',
      'Colonia La Luisa',
      'Barrio Planta Compresora De Gas',
      'El Porvenir',
      'Colonia San Juan',
      'Chelforo',
      'Santa Lucia',
      'Mainque',
      'Barrio Luisillo',
      'General Conesa',
      'Barrio Colonia Conesa',
      'Colonia Santa Teresita',
      'Colonia Santa Rosa',
      'Comico',
      'Chasico',
      'Tambelen',
      'Clemente Onelli',
      'Anecon Grande',
      'Colonia El Gualicho',
      'Salto Andersen',
      'El Cuy',
      'Trapalco',
      'San Lorenzo',
      'La Julia',
      'Colonia Josefa',
      'Negro Muerto',
      'La Japonesa',
      'Villa Llanquin',
      'Chacay Huarruca',
      'El Montoso',
      'El Portezuelo',
      'Barrio Esperanza',
      'Colonia Reig',
      'Colonia Julia Y Echarren',
      'Rio Colorado',
      'Juventud Unida',
      'San Javier',
      'Barrio La Defensa',
      'Cervantes',
      'Barrio Porvenir',
      'Colonia Fatima',
      'Aguada De Guerra',
      'Barrio Destacamento',
      'Barrio Pinar',
      'Valle Verde',
      'Peñas Blancas',
      'Ñorquinco',
      'Mamuel Choique',
      'Dina Huapi',
      'Ñirihuau',
      'Barrio Pino Azul',
      'General Roca',
      'Barrio El Petroleo',
      'Barrio La Ribera - Barrio Apycar',
      'Barrio Mosconi',
      'Barrio Las Angustias',
      'Paso Cordova',
      'Barrio Frontera',
      'Barrio Canale',
      'Barrio Mar Del Plata',
      'Barrio Chacra Monte',
      'Primera Angostura',
      'Pozo Salado',
      'Monte Bagual',
      'Zanjon De Oyuela',
      'Sauce Blanco',
      'Bahia Creek',
      'Loteo Costa De Rio',
      'La Loberia',
      'La Ensenada',
      'Valle Azul',
      'Pampa Linda',
      'Comallo Arriba',
      'Cañadon Chileno',
      'Cerro Negro',
      'Comallo Abajo',
      'Quepu Niyeu',
      'San Carlos',
      'El Chacay',
      'Barrio Costa Este',
      'Cerro Policia',
      'Barrio Costa Oeste',
      'Villa Alberdi',
      'Villa Regina',
      'Barrio Santa Rita',
      'Peninsula Ruca Co',
      'Bajo San Cayetano',
      'Lamarque',
      'Colan Conue',
      'Valcheta',
      'Aguada Cecilio',
      'Treneta',
      'Ministro Ramos Mexia',
      'Los Menucos',
      'El Manso',
      'Rio Villegas',
      'El Foyel',
      'Sierra Colorada',
      'Saco Viejo',
      'San Antonio Oeste',
      'Puerto San Antonio Este',
      'Estacion Empalme',
      'Los Alamos',
      'Costa Del Rio Azul',
      'Cuesta Del Ternero',
      'Los Repollos',
      'Mallin Ahogado',
      'Tres Puentes Arriba',
      'El Bolson',
      'Arroyo Quemquemtreu',
      'Barrio Union',
      'General Fernandez Oro',
      'Barrio Costa Linda',
      'Barrio Isla 10',
      'Chimpay',
      'Colonia Santa Gregoria',
      'Cona Niyeu',
      'Luis Beltran',
      'Villa San Isidro',
      'Villa Manzano',
      'Barrio El Labrador',
      'Sargento Vidal',
      'Pomona',
      'Pilahue',
      'Mencue',
      'Blancura Centro',
      'Quili Malal',
      'Palenque Niyeu',
      'La Angostura',
      'Coronel Belisle',
      'Comallo',
      'Playas Doradas',
      'Sierra Grande',
      'Mina Gonzalito',
      'Punta Colorada',
      'Yaminue',
      'El Paso',
      'El Condor',
      'La Boca',
      'Viedma',
      'El Juncal',
      'Choele Choel',
      'Arroyo El Tembrao',
      'Sierra Paileman',
      'Chajaijo',
      'Colonia Ceferino Namuncura',
      'Ingeniero Otto Krause',
      'Chichinales',
      'Villa Del Parque',
      'Barrio Moño Azul',
      'Pilquiniyeu Del Limay',
      'Barrio Guerrico',
      'Barrio Calle Ciega N° 10',
      'Barrio Emergente',
      'Barrio Blanco',
      'Barrio Calle Ciega N° 6',
      'Barrio El Maruchito',
      'Barrio La Herradura',
      'Allen',
      'Prahuaniyeu',
      'Barda Colorada',
      'Lonco Vaca',
      'Aguada Guzman',
    ],
    'AR-A': [
      'Mojotoro',
      'Islas De Vaqueros',
      'Santa Gertrudis',
      'La Calderilla',
      'Los Sauces',
      'Los Porongos',
      'La Caldera',
      'El Gallinato',
      'Campo Alegre',
      'San Jose De Aguilar',
      'Pucallpa',
      'Lizoite',
      'La Soledad',
      'Hornillos',
      'El Puesto',
      'La Falda',
      'Rodeo Pampa',
      'Pucara',
      'La Huerta',
      'Campo La Paz',
      'Pueblo Viejo',
      'San Francisco',
      'San Jose',
      'Abra De Santa Cruz',
      'Santa Cruz',
      'Chorro',
      'Santa Victoria',
      'Abra De San Antonio',
      'Antigal',
      'Laguna',
      'San Felipe',
      'Santa Cruz De Aguilar',
      'Mecoyita',
      'Acoyte',
      'Rio Piedras',
      'Lumbreras',
      'Arenales',
      'Potrerillos',
      'El Jardin',
      'Divisadero',
      'Yacochuya',
      'El Paso',
      'Las Conchas',
      'Cafayate',
      'Santa Barbara',
      'Tolombom',
      'Aguas Blancas',
      'El Brete',
      'El Tala',
      'Los Mogotes',
      'Finca Los Tapires',
      'Los Viborones',
      'El 93',
      'San Roque',
      'Pozo Nuevo',
      'Finca El Milagro',
      'Santa Cecilia',
      'Finca La Floresta',
      'El Yuchan',
      'Puerta Blanca',
      'El Totoral',
      'Lujan',
      'El Cardito',
      'Los Laureles',
      'San Nicolas',
      'Balbuena',
      'San David',
      'Esperanza',
      'La Candelaria',
      'Santa Laura',
      'Santa Teresa',
      'Jume Pozo',
      'Laguna Verde',
      'El Retiro',
      'Centro 25 De Junio',
      'Resistencia',
      'El Destierro',
      'El Potrerillo',
      'La Argentina',
      'Salta Forestal',
      'Laguna Blanca',
      'San Cristobal',
      'San Jorge',
      'Santa Ana',
      'Bella Vista',
      'San Antonio',
      'Coronel Olleros',
      'San Andres',
      'El Sunchal',
      'Pilcomayo',
      'El Gritao',
      'San Simon',
      'El Valle (Finca)',
      'La Union',
      'Pozo Verde',
      'El Manantial',
      'Piquete Cabado',
      'El Guayacan',
      'Puesto Del Medio',
      'Ceibalito',
      'San Alfonso',
      'Los Blancos',
      'Pozo Grande',
      'Campo Redondo (Puesto)',
      'Santa Maria',
      'La Lagunita',
      'San Ignacio',
      'Pozo Largo',
      'El Estanque',
      'Vizcacheral',
      'Toro Pozo',
      'Finca El Algarrobal',
      'Santos Lugares',
      'La Posicion',
      'Bella Flor',
      'Luz De Anta',
      'El 103',
      'Los Pozos',
      'Las Mercedes',
      'Joaquin V. Gonzalez',
      'Pozo Hallado',
      'Buen Lugar',
      'Independencia',
      'La Aguada',
      'San Martin',
      'Santo Domingo',
      'El Recreo',
      'Remancito',
      'El 21',
      'El Yeso',
      'Retiro',
      'San Pedro',
      'San Bernardo',
      'Las Vacas',
      'El Quebrachalito',
      'Puesto La Providencia',
      'La Poblacion',
      'Nolasco',
      'Finca La Moraleja',
      'El Desmonte',
      'General Pizarro',
      'Loma De Burro',
      'Las Avispas',
      'Las Bebidas',
      'Arrayanal',
      'Luis Burela',
      'La Esmeralda',
      'El Puestito (Finca)',
      'El Real',
      'Corral Quemado',
      'El Cebilar',
      'Palo Santo',
      'Agua Caliente',
      'Palo A Pique',
      'El Lindero',
      'El Trementinal',
      'Pocoy',
      'Recaredo',
      'Madrejones',
      'Barrio El Jardin De San Martin',
      'Coronel Cornejo',
      'General Mosconi',
      'Campamento Vespucio',
      'San Telmo',
      'Chicoana',
      'Barrio Santa Teresita',
      'El Candado',
      'Chivilme',
      'Las Animas',
      'Escoipe',
      'Barrio La Rotonda',
      'Molino De Gongora',
      'El Rodeo',
      'El Tipal',
      'Villa Fanny',
      'Quebrada De Escoipe',
      'Pulares',
      'El Simbolar',
      'La Zanja',
      'Potrero Diaz',
      'Las Moras',
      'El Nogalar',
      'El Mollar',
      'La Maroma',
      'Sunchal',
      'Agua Negra',
      'Campo La Cruz',
      'Nazareno',
      'San F. De Tuctuca',
      'Baritu',
      'Kelloticar',
      'Cuesta Azul',
      'Lipeo',
      'San Juancito',
      'Poscaya',
      'El Molino De Cuesta Azul',
      'Bacoya',
      'San Marcos',
      'El Pabellon',
      'La Loma',
      'Casas Viejas',
      'El Trampeadero',
      'El Potrerito',
      'Pozo El Chañar',
      'Las Juntas',
      'Las Horquetas',
      'Pozo El Anta',
      'El Naranjo',
      'La Brea',
      'Tres De Mayo',
      'La Trampa',
      'Capitan Juan Page',
      'La Rinconada',
      'El Madrejon',
      'El Rosario',
      'Alto Verde',
      'Fortin Belgrano',
      'El Pertigo',
      'El Chorro',
      'La Providencia',
      'Pluma De Pato',
      'El Quebracho',
      'El Carpintero',
      'El Espinillo',
      'El Yacon',
      'El Sauzal',
      'El Traslado',
      'Las Maravillas',
      'La Victoria',
      'Los Baldes',
      'Pozo De Algarrobo',
      'Palmar',
      'El Ganso',
      'Buena Vista',
      'El Campamento',
      'La Iguana',
      'La Junta',
      'San Patricio',
      'Coronel Juan Sola',
      'El Puestito',
      'Monte Rico',
      'La Bolsa',
      'Las Delicias',
      'La Palmita',
      'El Carancho',
      'Pozo Del Sauce',
      'El Salado',
      'La Elenita',
      'El Cienego',
      'Los Nogales',
      'La Invernada',
      'El Quirquincho',
      'Las Horquetasas',
      'San Agustin',
      'La Entrada',
      'El Botin',
      'El Pergamino',
      'El Escondido',
      'Finca Resistencia',
      'La Mesada',
      'El Porongal',
      'Fortaleza',
      'El Quejon',
      'Finca La Argentina',
      'La Ensenada',
      'El Paraiso',
      'Campo Argentino',
      'Pozo El Mulato',
      'El Azul',
      'Dos Yuchanes',
      'Puesto El Pancho',
      'El Rondadero',
      'El Coleto',
      'El Talar',
      'La Mora (Finca)',
      'Montevideo',
      'El Cortaderal',
      'El Desemboque',
      'El Tartagal',
      'La Salvacion',
      'La Esperanza',
      'El Chivil',
      'Los Ranchitos',
      'Los Noques',
      'El Sauce',
      'El Ceibal',
      'El Bordo',
      'El Prado',
      'Ovejeria',
      'El Galpon',
      'Pringles',
      'Lagunita',
      'El Altamisqui',
      'Cuchi Pozo',
      'El Vallecito',
      'Agua Blanca',
      'San Jose De Orquera',
      'Potrero',
      'El Mojon',
      'Los Rosales',
      'Bajo Grande',
      'Las Vertientes',
      'Saladillo',
      'Alto Del Mistol',
      'Quebracho Herrado',
      'El Pacara',
      'Poblacion De Ortega',
      'El Porvenir',
      'El Tunal',
      'Paso De Las Carreras',
      'Campo Largo',
      'El Pajeal',
      'Piquirenda',
      'Capiazuti',
      'Macueta',
      'Dique Itiyuro',
      'La Represa',
      'Tobantirenda',
      'Aguaray',
      'Timboirenda',
      'El Chilcar',
      'Acambuco',
      'Boca Del Tigre',
      'Santa Clara',
      'Macapillo',
      'El Vencido',
      'La Jornada',
      'Las Piedras',
      'El Quebrachal',
      'Anta Pozo',
      'Tolloche',
      'El Mosquito',
      'La Laguna',
      'Alto Alegre',
      'San Rafael',
      'San Juan',
      'La Bomba',
      'San Tadeo',
      'Flor De Mayo',
      'Los Jardines',
      'Mangrullo',
      'Santa Rosa',
      'El Simbol',
      'Nuestra Señora De Talavera',
      'Macapillo Viejo',
      'Santa Elena',
      'San Isidro',
      'El Geologo',
      'El Norte',
      'Gaona',
      'Algarrobal',
      'El Saladillo',
      'Cerro Negro',
      'Hornadillas',
      'Cobres',
      'Cangrejillos',
      'La Poma',
      'Piscuno',
      'Churcal',
      'Pozo Bravo',
      'Esquina Colorada',
      'El Cajon',
      'Esquina De Guardia',
      'Esquina Azul',
      'El Trigal',
      'Agua De Castilla',
      'Salar De Pocitos',
      'Acazoque',
      'Chorrillos',
      'El Rincon',
      'Tolar Chico',
      'Toron',
      'San Antonio De Los Cobres',
      'Olacapato',
      'Carachi',
      'Corralitos',
      'Condor Huasi',
      'Santa Rosa De Los Pastos Grandes',
      'El Desierto',
      'Tonono',
      'Barrio El Milagro',
      'Mision Cherenta',
      'Yacuy',
      'Yariguarenda',
      'San Ramon',
      'Tartagal',
      'Tres Pozos',
      'Pacara',
      'Mision Kilometro 6',
      'Bobadal',
      'Mision El Cruce',
      'Zanja Honda',
      'Palo Blanco',
      'Tranquitas',
      'El Rumical',
      'La Merced',
      'Sumalao',
      'Villa Sarmiento',
      'Las Tienditas',
      'Las Pircas',
      'San Miguel',
      'El Huaico',
      'Yerba Buena',
      'Tuyunti',
      'Sauzal',
      'Profesor Salvador Mazza',
      'El Oculto',
      'Playa Ancha',
      'El Algarrobal',
      'Campo Duran',
      'Los Yacones',
      'Vaqueros',
      'Lesser',
      'Seclantas',
      'Seclantas Adentro',
      'Isla De Cañas',
      'Animana',
      'Corralito',
      'El Barrial',
      'El Carril',
      'El Pedregal',
      'Las Garzas',
      'Las Barrancas',
      'Calvimonte',
      'Vaqueria',
      'Sauce Redondo',
      'Carahuasi',
      'Acosta',
      'El Sapo',
      'Guachipas',
      'Coropampa',
      'La Bodeguita',
      'La Florida',
      'Alemania',
      'Pampa Grande',
      'Los Castillos',
      'La Costa',
      'Cinco Duraznos',
      'Punta Del Agua',
      'Metan Viejo',
      'El Pastiadero',
      'Los Lapachos',
      'La Aguadita',
      'Vera Cruz',
      'El Guanaco',
      'Nogalito',
      'Sacha Pera',
      'San Jose De Metan',
      'El Garabatal',
      'El Fuerte',
      'El Rey',
      'Paso De La Cruz',
      'Rio Del Valle',
      'Las Viboras',
      'Las Lajitas',
      'Pantanillo',
      'San Gabriel',
      'El Piquete',
      'Reina Del Valle',
      'Palermo',
      'El Gramillal',
      'Cabeza De Anta',
      'Miraflores',
      'Alto Bello',
      'Finca El Mollar',
      'El Libano',
      'El Molino',
      'Saladillo De Juarez',
      'Rio Seco',
      'Estancia Vieja Del Rey',
      'El Ceibalito',
      'Salta',
      'La Quesera',
      'La Higuera',
      'Cc La Almudena',
      'La Troja',
      'Chamical',
      'Cc El Tipal',
      'Compuel',
      'Cochiyaco',
      'La Puerta',
      'Banda Grande',
      'Colome',
      'Cuchiyaco',
      'Molinos',
      'Luracatao',
      'Alumbre',
      'Aguadita',
      'Tacuil',
      'Amaicha',
      'El Churcal',
      'San Lucas',
      'El Pescadero',
      'Los Naranjos',
      'Rivadavia',
      'El Toba',
      'El Ocultar',
      'El Cercado',
      'Los Tres Pozos',
      'El Divisadero',
      'Puesto Viejo',
      'San Aniceto',
      'El Cielito',
      'Mision San Felipe',
      'El Mirador',
      'Martin Garcia',
      'Aguas Muertas',
      'Pozo Del Zorro',
      'La Fortuna',
      'Villa Petrona',
      'Las Bolsas',
      'Ciervo Cansado',
      'Las Flores',
      'El Timon',
      'El Milagro',
      'Palmarcito',
      'El Lecheron',
      'El Breal',
      'Ternera Atada',
      'El Yacare',
      'El Vinalar',
      'La Siberia',
      'San Fermin',
      'El Azotado',
      'Las Llaves',
      'La Toma',
      'Pelicano Quemado',
      'El Cocal',
      'Las Tortugas',
      'La Media Luna (Finca)',
      'El Valle',
      'San Manuel',
      'Monte Alto',
      'Finca Santa Rosa',
      'La Sota',
      'La Carneada',
      'Tres Horcones',
      'San Luis',
      'Almona',
      'El Churcalito',
      'Canteros',
      'Simbol Yaco',
      'La Costosa',
      'La Firmeza',
      'El Churqui',
      'Aragon',
      'Las Catitas',
      'Los Corrales',
      'La Almona',
      'Unquillo',
      'El Cadillal',
      'Las Lajas',
      'Almirante Brown',
      'Antilla',
      'Puente De Plata',
      'Copo Quile',
      'El Potrero',
      'La Bajada',
      'San Lorenzo',
      'Las Cortaderas',
      'Tonco',
      'Piul',
      'San Geronimo',
      'Payogasta',
      'Potrero De Payogasta',
      'Castellanos',
      'Las Costas',
      'La Cienaga',
      'Villa San Lorenzo',
      'Atocha',
      'Barrio San Rafael',
      'Vallecito',
      'La Arcadia',
      'La Angostura',
      'La Isla',
      'El Arremo',
      'Angastaco',
      'Rio Grande',
      'Los Cardones',
      'El Carmen',
      'Candado',
      'Colonia G',
      'Finca El Cedral',
      'Tablada',
      'Abra Grande',
      'Rio Pescado',
      'Parani',
      'San Ramon De La Nueva Oran',
      'Anta Muerta',
      'Barrio El Congreso',
      'Barrio Los Olmos',
      'La Candelaria (Finca)',
      'Cerrillos',
      'Finca La Blanca',
      'Barrio Las Tunas',
      'Villa Los Alamos',
      'Barrio Los Pinares',
      'Las Palmas (Finca)',
      'Los Pinos',
      'Rodeo Colorado',
      'Porongal',
      'Iruya',
      'Las Capillas',
      'Mantacillas Del Valle Delgado',
      'Tres Morros',
      'Palca',
      'Colanzuli',
      'Vizcarra',
      'Valle Delgado',
      'Abra De Araguyoc',
      'Cortaderas',
      'Las Trancas',
      'Huayra Huasi',
      'Casa Grande',
      'Volcan Higueras',
      'Campo Cabrera',
      'Sala Escuya',
      'Abra Del Sauce',
      'Chiyayoc',
      'San Isidro De Iruya',
      'El Alfarcito',
      'La Mesada Grande',
      'Los Toldos',
      'Arazay',
      'La Mision',
      'La Bodega',
      'Osma',
      'Cabra Corral',
      'Coronel Moldes',
      'Churqui Solo',
      'El Silencio',
      'El Pescadito',
      'Las Cantoras',
      'El Arenal',
      'General Ballivian',
      'Las Catas',
      'Las Palmas',
      'El Castigado',
      'Campo Libre',
      'La Curtiembre',
      'Los Desmontes',
      'Campo El Tigre',
      'El Teniente',
      'El Pucara',
      'Villa Mercedes (Finca)',
      'Cerro Negro De Tirao',
      'La Merced De Arriba',
      'Carabajal',
      'Rosario De Lerma',
      'La Merced Del Encon',
      'El Timbo',
      'La Estrella',
      'La Esquina',
      'Pozo La Esquina',
      'Pozo Azul',
      'El Mistol',
      'Pozo Cercado',
      'La Paja',
      'Martinez Del Tineo',
      'Pichanal',
      'Bordo La Esquina',
      'Los Pocitos',
      'Guayacan',
      'Morterito',
      'Jeronimo Matorras',
      'Manuel Elordi',
      'Abra Navarro',
      'Chuculaqui',
      'Vega De Arizaro',
      'Quebrada Del Agua',
      'Socompa',
      'Taca Taca',
      'Tolar Grande',
      'Caipe',
      'Saucelito',
      'Colonia Santa Rosa',
      'Santa Rosa De Tastil',
      'Tacuara',
      'Campo Quijano',
      'Incahuasi',
      'El Palomar',
      'Agua Chica',
      'Estancia El Golgota',
      'Ingeniero Maury',
      'El Toro',
      'Villa Angelica',
      'El Alisal',
      'La Silleta',
      'Carrera Muerta',
      'Las Cuevas',
      'Morohuasi',
      'Pascha',
      'San Bernardo De Las Zorras',
      'La Hoyada',
      'El Manzano',
      'El Encon',
      'Tres Cruces',
      'El Rosal',
      'Colonia Neuropsiquiatica',
      'Cachi Adentro',
      'Palermo Oeste',
      'Rumihuasi',
      'Las Pailas',
      'San Jose De Escalchi',
      'Escalchi',
      'Piedra Del Molino',
      'Colte',
      'Las Arcas',
      'Cachipampa',
      'Rancagua',
      'Escalchi Adentro',
      'La Paya',
      'Cachi',
      'El Tabacal',
      'Hipolito Yrigoyen',
      'Santa Rita',
      'La Cueva',
      'El Zapallar',
      'Yaquiasme',
      'Ojo De Agua',
      'Madre Vieja',
      'La Trampa (Finca)',
      'Palomitas',
      'General Guemes',
      'Rosario De La Frontera',
      'La Bebida',
      'El Portezuelo',
      'Los Colorados',
      'Santa Isabel',
      'Balboa',
      'Canta Rana',
      'La Carrera',
      'Bajada Grande',
      'Las Mojarras',
      'La Federacion',
      'Los Churquis',
      'La Banda',
      'Arenal Viejo',
      'El Algorrobal',
      'Cabas',
      'Las Mesillas',
      'Camara',
      'Horcones',
      'San Pedro De Aranda',
      'Ceibal',
      'Mision Tierras Fiscales',
      'La Granada',
      'Santa Fe',
      'Tabaco Cimarron',
      'La Mina',
      'Senda Hachada',
      'La Quena',
      'Padre Lozano',
      'El Quemado',
      'El Suri',
      'Monte Carmelo',
      'Villa Nueva',
      'Monte Seco',
      'San Esteban',
      'Tucumancito',
      'Pompeya',
      'Mision Chaqueña',
      'Campichuelo',
      'Luna Muerta',
      'Dragones',
      'El Melonar',
      'Las Yanas',
      'La Emboscada',
      'Las Pavas',
      'Tartagalito',
      'Pozo Del Macho',
      'Rosario',
      'Embarcacion',
      'Santillan',
      'Carboncito',
      'El Tajamar',
      'Agua Linda',
      'Media Luna',
      'Hickman',
      'Amblayo',
      'Palo Pintado',
      'Rumiarco',
      'Payogastilla',
      'Rio Salado',
      'San Carlos',
      'Isonza',
      'Las Trampas',
      'Los Rastrojitos',
      'Talapampa',
      'Las Curtiembres',
      'La Viña',
      'Las Lechuzas',
      'Ampascachi',
      'El Infiernillo',
      'Entre Rios',
      'Las Tacanas',
      'La Encrucijada',
      'Finca San Nicolas',
      'Las Abritas',
      'La Ramada',
      'Cabeza De Buey',
      'Cobos',
      'Betania',
      'Campo Santo',
      'Coronel Mollinedo',
      'El Dorado',
      'Las Flacas',
      'San Cayetano',
      'Apolinario Saravia',
      'La Quinta',
      'La Pelada',
      'San Vicente',
      'Santa Lucia',
      'Agua Sucia',
      'El Bordo (Finca)',
      'Agua Verde',
      'La Curvita',
      'Pozo El Bravo',
      'Magdalena',
      'San M. De La Ceiba',
      'Mision San Luis',
      'Pozo Del Toro',
      'Amberes',
      'El Pelicano',
      'El Rosado',
      'Pozo El Toro',
      'El Palmar',
      'La Gracia',
      'Las Vertienes',
      'Hito 1',
      'Alto De La Sierra',
      'La Puntana',
      'La China',
      'Pozo El Tigre',
      'Santa Victoria Este',
      'Mision La Paz',
      'La Paz',
      'Urundel',
    ],
    'AR-J': [
      'Villa Tacu',
      'Villa Basilio Nievas',
      'Los Paramillos',
      'Zonda Arriba',
      'Pachaco',
      'Dique Pachimoco',
      'La Frontera',
      'Niquivil',
      'Huaco',
      'Gualcamayo',
      'Otra Banda',
      'La Falda',
      'Cruz De Piedra',
      'La Cienaga',
      'El Fiscal',
      'Niquivil Viejo',
      'Indio Muerto',
      'San Isidro',
      'Panacan',
      'Bella Vista',
      'La Toma',
      'El Medano',
      'El Volcan',
      'Tamberias',
      'Mogna',
      'Villa Mercedes',
      'Pampa Vieja',
      'San Jose De Jachal',
      'Los Puestos',
      'Las Aguaditas',
      'Boca De La Quebrada',
      'Villa Malvinas Argentinas',
      'Gran China',
      'Las Piedritas',
      'Villa Barboza',
      'Estacion Sanchez De Loria',
      'Colonia Cantoni',
      'Segundo Cuartel',
      'Barrio Ruta 40',
      'Villa Aeropuerto',
      'El Abanico',
      'Quinto Cuartel',
      'Villa Cabecera',
      'Campo De Batalla',
      'Villa Aberastain',
      'Barrio Municipal',
      'Carpinteria',
      'Villa Nacusi',
      'La Callecita',
      'Villa Centenario',
      'La Rinconada',
      'Las Chacras Marayes',
      'Pozo De Los Algarrobos',
      'Las Liebres',
      'Barrio Justo P. Castro Iv',
      'Villa Independencia',
      'Marayes',
      'Divisoria',
      'El Rincon',
      'Las Talas',
      'Los Medanos',
      'La Puntilla',
      'Laguna Seca',
      'Pie De Palo',
      'Las Chacras',
      'Bermejo',
      'Vallecito',
      'Caucete',
      'Tira Larga',
      'Barreal',
      'La Alumbrera',
      'Puchuzun',
      'Villa Nueva',
      'La Isla',
      'Colon',
      'Alcaparrosa',
      'Sorocayense',
      'Villa Corral',
      'Villa Pituil',
      'Hilario',
      'Calingasta',
      'El Leoncito',
      'Villa Ibañez',
      'Dique Ullum',
      'El Chilote',
      'San Juan',
      'Las Chacritas',
      'La Majadita',
      'Rincon Cercado',
      'Colonia Fiorito',
      '9 De Julio',
      'Bauchaceta',
      'Zonda',
      'Mondaca',
      'Achango',
      'Iglesia',
      'Tudcum',
      'Rodeo',
      'Guardia Vieja',
      'Maliman De Arriba',
      'El Retiro',
      'Maliman De Abajo',
      'Pismanta',
      'Fierro Nuevo',
      'Las Flores',
      'Fierro Viejo',
      'Angualasto',
      'Tocota',
      'Villa El Tango',
      'El Encon',
      'Villa Borjas',
      'Villa Santa Rosa',
      'La Tranca',
      'Cuatro Esquinas',
      'Tupeli',
      'Las Casuarinas',
      'Estacion Punta Del Agua',
      'Estacion Algarrobo Verde',
      'Pozo Del Salado',
      'La Chimbera',
      'Villa Sefair (Talacasto)',
      'El Alamito',
      'Las Tapias',
      'Punta Del Monte',
      'Villa El Salvador',
      'El Bosque',
      'Santo Domingo',
      'Baldes De La Chilca',
      'La Huerta',
      'San Antonio',
      'Chucuma',
      'Colonia Los Valecianos',
      'Rincon Chico',
      'Villa San Agustin',
      'Los Baldecitos',
      'Sierra De Elizondo',
      'Astica',
      'Baldes Del Norte',
      'Las Juntas',
      'Los Bretes',
      'Agua Cercada',
      'Usno',
      'Balde Del Rosario',
      'Los Berros',
      'Colonia San Antonio',
      'Estacion Cochagual',
      'Las Lagunas',
      'Guanacache',
      'Villa Media Agua',
      'Cañada Honda',
      'Pedernal',
      'Cienaguita',
      'Colonia Fiscal',
      'San Carlos',
      'Divisadero',
      'Punta Del Medano',
      'Tres Esquinas',
      'Marquesado',
      'Barrio Camus',
      'Jardin De Los Poetas',
      'Rivadavia',
      'Villa Nueva Argentina',
      'Barrio Fortabat',
      'Santa Lucia',
      'Barrio Bermejito',
      'La Legua',
      'Colonia Richet Zapata',
      'Alto De Sierra',
      'Colonia Gutierrez',
      'Obispo Zapata',
      'El Topon',
      'Finca El Salado',
      'Campo Afuera',
      'La Cañada',
      'Villa Ampacama',
      'El Salado',
      'Villa General San Martin',
      'Tierra Adentro',
      'El Mogote',
      'Villa Observatorio',
      'Villa Paula Albarracin',
      'Villa Union',
      'Villa Sarmiento',
      'Chimbas',
      'Barrio Parque Idustrial',
      'Villa Obrera',
      'Barrio Parque Independencia',
      'Colonia Rodas',
      'Villa Bolaños',
      'Los Corredores',
      'Colonia Medano De Oro',
      'El Medanito',
      'Villa Krause',
      'Rawson',
      'Villa San Damian',
      'Colonia Pan De Azucar',
      'Villa San Martin',
      'Villa Dominguito',
      'Barrio Sadop',
      'Villa Don Bosco',
      'Los Compartos',
      'Dos Acequias',
      'Boca Del Tigre',
    ],
    'AR-D': [
      'Villa Mercedes',
      'La Rivera',
      'Dique Vulpiani',
      'La Ribera',
      'La Cienaga',
      'Las Aguadas',
      'Tala Verde',
      'El Puesto',
      'Los Molles',
      'La Toma',
      'Los Cajones',
      'Las Barrancas',
      'Las Islitas',
      'Santa Ana',
      'Balde De Escudero',
      'Las Palomas',
      'Las Barranquitas',
      'Estancia Grande',
      'El Durazno',
      'El Zapallar',
      'La Brea',
      'La Aguada',
      'Quines',
      'Balcarce',
      'Cortaderas',
      'Riocito',
      'Balde De La Isla',
      'Paso Del Rey',
      'Pampa Del Tamboreo',
      'Rio Grande',
      'Las Pircas',
      'El Trapiche',
      'Las Lagunas',
      'Carolina',
      'Las Rosas',
      'Mina Los Condores',
      'San Antonio',
      'Villa Larca',
      'Gorgonta',
      'Santa Cecilia',
      'El Calden',
      'Mosmota',
      'El Milagro',
      'Las Piedritas',
      'El Mataco',
      'Las Vizcacheras',
      'Suyuque Nuevo',
      'Charlone',
      'Donado',
      'El Charabon',
      'La Irene',
      'La Fortuna',
      'El Molle',
      'Juan W. Gez',
      'El Portezuelo',
      'El Recuerdo',
      'Los Puquios',
      'Chosmes',
      'Santa Rosa',
      'Varela',
      'Las Gamas',
      'Daniel Donovan',
      'Punta Del Cerro',
      'Los Cerrillos',
      'Paso De Las Vacas',
      'Pescadores',
      'San Martin Del Alto Negro',
      'Nacion Ranquel',
      'Cazador Viejo',
      'Cazador',
      'Zanjitas',
      'La Costa',
      'Juan Jorba',
      'Bagual',
      'Colonia Urdaniz',
      'Martin De Loyola',
      'Colonia Calzada',
      'La Estrella',
      'El Rodeo',
      'Frisia',
      'El Aguila',
      'Los Overos',
      'Nahuel Mapa',
      'La Maroma',
      'Nueva Constitucion',
      'La Verde',
      'San Gregorio',
      'Saladillo',
      'El Volcan',
      'Los Algarrobos Blancos',
      'San Luis',
      'Boca Del Tigre',
      'Tintitaco',
      'Leandro N Alem',
      'La Majada',
      'Pozo De Los Rayos',
      'La Punilla',
      'Fortin El Patria',
      'Navia',
      'Villa De Praga',
      'El Paraiso',
      'La Puerta',
      'San Pablo',
      'La Florida',
      'La Primavera',
      'Los Quemados',
      'El Rincon',
      'Balde Viejo',
      'El Zampal',
      'Santo Domingo',
      'San Miguel',
      'El Baldecito',
      'San Roque',
      'Rodeo De Cadenas',
      'La Avenencia',
      'La Salvadora',
      'Balde De Quines',
      'Lomas Blancas',
      'Pampa Grande',
      'El Injerto',
      'Los Pozos',
      'La Tranca',
      'El Algarrobal',
      'La Represita',
      'Las Chimbas',
      'San Ignacio',
      'Balde Retamo',
      'Monte Carmelo',
      'Balde De Los Torres',
      'Las Claritas',
      'Balde De Azcurra',
      'Baldecito De La Pampa',
      'Balde Del Carmen',
      'La Plata',
      'La Botija',
      'Santa Teresa',
      'El Barrial',
      'Las Tosquitas',
      'El Vinagrillo',
      'Las Lagunitas',
      'Santa Rosa De Catantal',
      'Bella Vista',
      'Balde Ultimo',
      'Talita',
      'Santa Rosa Del Conlara',
      'El Duraznito',
      'Union',
      'Lomitas',
      'La Lomita',
      'Lafinur',
      'Tilisarao',
      'La Vertiente',
      '9 De Julio',
      'Candelaria',
      'La Moderna',
      'Santa Maria',
      'Alto Pencoso',
      'Nogoli',
      'Naschel',
      'Buena Esperanza',
      'Fortuna',
      'Las Chacras',
      'El Cerrito',
      'El Estanquito',
      'La Quinta',
      'Carpinteria',
      'Arizona',
      'Paso Grande',
      'Villa Del Carmen',
      'San Martin',
      'Justo Daract',
      'Villa Salles',
      'Pedernera',
      'Liborio Luna',
      'Coronel Alzogaray',
      'Las Mestizas',
      'Las Isletas',
      'Soven',
      'Chalanta',
      'Colonia Don Antonio',
      'Villa Reynolds',
      'La Angelina',
      'Rio Quinto',
      '5Ta Brigada',
      'El Guanaco',
      'La Esquina',
      'La Rosada',
      'Nueva Escocia',
      'Country Club Los Caldenes',
      'Cramer',
      'Caldenadas',
      'Villa De La Quebrada',
      'Lavaisse',
      'San Francisco Del Monte De Oro',
      'Pozo Del Molle',
      'Beazley',
      'Las Horquetas',
      'Renca',
      'El Chorrillo',
      'Cerro Colorado',
      'Quebrada De Los Condores',
      'Cruz De Piedra',
      'La Suiza',
      'Pozo Cavado',
      'Punta De La Loma',
      'Colonia Zubelzu',
      'Los Condores',
      'La Gramilla',
      'Santa Martina',
      'El Tala',
      'San Felipe',
      'La Celestina',
      'Huejeda',
      'Alto Pelado',
      'Nueva Galia',
      'Juan Llerena',
      'Anchorena',
      'Planta De Sandia',
      'Rincon Del Carmen',
      'Guanaco Pampa',
      'La Ramada',
      'San Vicente',
      'Cabeza De Novillo',
      'Ojo De Agua',
      'San Isidro',
      'Manantial',
      'Barranca Alta',
      'Piedra Bola',
      'Conlara',
      'El Paraguay',
      'La Totora',
      'La Cocha',
      'Casa De Los Tigres',
      'El Valle',
      'Potrerillo',
      'Los Comederos',
      'La Huerta',
      'San Fernando',
      'Mesilla Del Cura',
      'Puerta Colorada',
      'Papagayos',
      'El Churrasco',
      'Concaran',
      'El Sifon',
      'El Sauce',
      'Lujan',
      'Pozo Del Carril',
      'Ciudad De La Punta',
      'San Jeronimo',
      'Merlo',
      'Cerro De Oro',
      'Los Araditos',
      'Buen Orden',
      'Hualtaran',
      'El Divisadero',
      'Los Ramblones',
      'El Pedernal',
      'El Jarillal',
      'El Recodo',
      'San Pedro',
      'Pozo Del Tala',
      'Represa Del Carmen',
      'Santa Rosa Del Gigante',
      'Estancia De Amieva',
      'El Espinillo',
      'Cabeza De Vaca',
      'Bella Estancia',
      'Santa Rita',
      'El Ramblon',
      'Naranjo Esquino',
      'Toro Negro',
      'Arbol Solo',
      'El Retamal',
      'Las Playas',
      'Potrero De Los Funes',
      'Desaguadero',
      'Jarilla',
      'San Jose Del Morro',
      'Los Quebrachos',
      'Ojo Del Rio',
      'Cerrito Blanco',
      'Los Lobos',
      'La Isla',
      'La Chilca',
      'Bajo De Veliz',
      'Batavia',
      'Fraga',
      'Salinas Del Bebedero',
      'Balde',
      'La Calera',
      'Intihuasi',
      'La Bajada',
      'Paso De Las Carretas',
      'Eleodoro Lobos',
      'Loma Alta',
      'Comandante Granville',
      'El Arenal',
      'Valle De Pancanta',
      'Cerros Largos',
      'La Petra',
      'Cienaga De Intihuasi',
      'El Manantial',
      'Marmol Verde',
      'Cuatro Esquinas',
      'Villa General Roca',
    ],
    'AR-Z': [
      'El Chalten',
      'Cañadon Seco',
      'Caleta Olivia',
      'Florida Negra',
      'Bella Vista',
      'El Salado',
      'Las Heras',
      'Mina 3',
      'Hipolito Yrigoyen',
      'Puerto Deseado',
      'Comandante Luis Piedrabuena',
      'Las Tres Hermanas',
      'Los Monos',
      'Alma Gaucha',
      'Tehuelches',
      'Tres Cerros',
      'La Loberia',
      'Pampa Alta',
      'Bahia Laura',
      'Gobernador Moyano',
      'Minerales',
      'Piedra Clavada',
      'Charles Fuhr',
      'Punta Bandera',
      'El Cerrito',
      'La Leona',
      'Gendarme Barreto',
      'Rincon',
      'Laguna Grande',
      'La Barrancosa',
      'Estancia San Ramon',
      'Koluel Kaike',
      'Jaramillo',
      'Rio Gallegos',
      'Fitz Roy',
      'Puerto San Julian',
      'Rospentek',
      'Gobernador Gregores',
      'Pico Truncado',
      'Tellier',
      '28 De Noviembre',
      'Bajo Caracoles',
      'El Turbio',
      'La Peninsula',
      'Lago Cardiel',
      'El Calafate',
      'Tres Lagos',
      'Puente Blanco',
      'Las Horquetas',
      'Estancia Las Vegas',
      'Ocho Hermanos',
      'Cerro Leon',
      'Gaypon',
      'La Esperanza',
      'Estancia Glencross',
      'Cancha Carrera',
      'Le Marchand',
      'Estancia El Condor',
      'Puerto Coig',
      'Yacimientos Rio Turbio',
      'Puerto Santa Cruz',
      'Los Antiguos',
      'Julia Dufour',
      'La Aragonesa',
      'La Manchuria',
      'El Portezuelo',
      'Perito Moreno',
    ],
    'AR-S': [
      'Oratorio Morante',
      'Godoy',
      'Campo La Victoria',
      'Correa',
      'Berretta',
      'Estacion Berreta',
      'Colonia Iturraspe',
      'Colonia La Posta',
      'Arequito',
      'General Lagos',
      'Suardi',
      'Campo Colla',
      'Las Higueritas',
      'Coronel Rodriguez',
      'Santa Clara De Buena Vista',
      'Las Avispas',
      'Labordeboy',
      'General Gelly',
      'Campo Fondato',
      'Campo Ghiano',
      'Campo Ulla',
      'El Trebol',
      'Campo Riberi',
      'Santa Teresa',
      'Francisco Paz',
      'Fortin Arenales',
      'Campo Bonazola',
      'Las Taperitas',
      'Lanteri',
      'Campo Siete Provincias',
      'Flor De Oro',
      'La Britanica',
      'Colonia Teresa',
      'Campo Piaggio',
      'Maua',
      'La Potasa',
      'Dos Rosas Y La Legua',
      'Campo Hardy',
      'Los Tabanos',
      'Santo Domingo',
      'Campo La Union',
      'Los Cardos',
      'Santa Maria Norte',
      'Palacios',
      'Monigotes',
      'Pedro Gomez Cello',
      'La Clara',
      'Colonia La Osca',
      'La Mora Y Pantanoso',
      'Ramona',
      'Estancia La Markonia',
      'Llambi Campbell',
      'Aromos',
      'Montes De Oca',
      'Campo Los Troncos',
      'San Antonio De Obligado',
      'Constanza',
      'Las Palmas',
      'La Esmeralda',
      'Campo Mendoza',
      'Las Amintas',
      'Los Laureles',
      'Obraje San Juan',
      'Villa Guillermina',
      'Ramal San Juan',
      'Noghe',
      'El Salitral',
      'Gato Colorado',
      'Campo El Dormido',
      'Fortin 6',
      'Campo Chiodi',
      'Estacion Kilometro 405',
      'Colonia Los Troncos',
      'Las Parejas',
      'Campo Albertengo',
      'Chabas',
      'Los Quebrachales',
      'Campo Derotier',
      'Santa Margarita',
      'Villa San Jose',
      'Colonia Indigena',
      'Colonia Criolla',
      'Colonia San Ignacio',
      'San Javier',
      'Isla Las Palmas',
      'Colonia San Jose',
      'Colonia California',
      'Las Cañas',
      'Miguel Escalada',
      'Nare',
      'Estacion El Cantor',
      'Cafferata',
      'Barrio Cicarelli',
      'Colonia Medici',
      'Larguia',
      'Campo Rasetto',
      'Campo Rovetto',
      'Campo Barbero',
      'Totoras',
      'Esteban Rams',
      'Nueva Italia',
      'Pozo Borrado',
      'El Pirincho',
      'El Tunalito',
      'Campo Contarde',
      'Campo Las Mellizas',
      'Campo Los Claveles',
      'Las Limpias',
      'Campo El 51',
      'Maria Susana',
      'Campo Bajo Las Liebres',
      'El Ricardito',
      'La Diamela',
      'Berna',
      'Campo Furrer',
      'Saladero Cabal',
      'Saladero Mariano Cabal',
      'El Laurel',
      'Kilometro 101',
      'Monte Flores',
      'Arbilla',
      'Alvear',
      'Rincon Del Quebracho',
      'Villa Saralegui',
      'Petronila',
      'Maria Eugenia',
      'La Negra',
      'La Cabaña',
      'Vera Y Pintado',
      'Luis Palacios',
      'Santo Tome',
      'Campo Jullier',
      'Pueblo Marini',
      'Toba',
      'Kilometro 12',
      'Guaycuru',
      'Lote 127',
      'La Zulema',
      'Kilometro 302',
      'Campo Donnet',
      'Avena',
      'San Martin De Las Escobas',
      'Campo El Danubio',
      'Campo Oitana',
      'Villa Eloisa',
      'Campo Loma Partida',
      'San Ricardo',
      'Funes',
      'San Francisco De Santa Fe',
      'Diaz',
      'Granadero Baigorria',
      'El Prado',
      'Ramayon',
      'Villa Mercedes',
      'Estancia San Juan',
      'Villa Lastenia',
      'San Juan',
      'Puerto Aragon',
      'Barrancas',
      'Gobernador Crespo',
      'Campo La Germania',
      'Campo Calcaterra',
      'Classon',
      'Campo El Ensayo',
      'Crispi',
      'Colonia Las Yerbas',
      'Campo Seveso',
      'Providencia',
      'Pavon',
      'Lucio  V. Lopez',
      'Lucio V. Lopez',
      'Campo Medina',
      'El Caramelo',
      'Alvarez',
      'Peyrano',
      'San Carlos Centro',
      'Felicia',
      'La Alicia',
      'Aguara Grande',
      'Timbues',
      'Villa Elvira',
      'Gessler',
      'Colonia Los Robles',
      'Murphy',
      'Barrio Mitre',
      'Empalme Villa Constitucion',
      'El Colorado',
      'Carreras',
      'Zenon Pereyra',
      'Estacion Kilometro 501',
      'Campo La Malagueña',
      'Pavon Arriba',
      'Campo Bernardi',
      'Lote 184',
      'Santa Felicia',
      'Pueblo Santa Lucia',
      'Kilometro 38',
      'Caraguatay',
      'Espin',
      'Lote 21',
      'Campo Zamo',
      'Kilometro 71',
      'Vera',
      'El Ñandubay',
      'Pujato',
      'Campo Risso',
      'Campo Leonhardt',
      'Reconquista',
      'La Lola',
      'Puerto Reconquista',
      'Empalme San Carlos',
      'Desvio Km 407',
      'La Isleta',
      'Villa Adela',
      'Estacion Kilometro 403',
      'Villa Ocampo',
      'Campo Bello Norte',
      'Campo El Piave',
      'Campo Yaccuzzi',
      'Campo Bello Sur',
      'Campo Piccoli',
      'San Vicente',
      'Campo Fantin',
      'San Carlos Norte',
      'San Jeronimo Del Sauce',
      'Campo La Vigilancia',
      'Campo Marinzalda',
      'Campo Gimbatti',
      'Tortugas',
      'Campo Charo',
      'Arrufo',
      'San Rafael',
      'La Vanguardia',
      'Campo La Rosario',
      'San Eugenio',
      'Colonia Las Margaritas',
      'Margarita',
      'Campo  Pavicich',
      'Campo Molassi',
      'Campo Colnaghi',
      'La Nicolosa',
      'Rivadavia',
      'Las Palmeras',
      'Fray Luis Beltran',
      'Bombal',
      'Campo Cuco',
      'Colonia Raquel',
      'Ituzaingo',
      'Piamonte',
      'Los Molinos',
      'Campo Foressi',
      'San Guillermo',
      'Ceres',
      'Arocena',
      'Barrio El Pacaa - Barrio Comipini',
      'Colonia Belgrano',
      'Colonia El Dichoso',
      'Colonia La Hiedra',
      'Fortin Atahualpa',
      'Colonia El Mate',
      'Villa Minetti',
      'Estancia Los Guasunchos',
      'Campo San Isidoro',
      'Empalme Ruta 91',
      'Colonia La Avanzada',
      'Campo Garay',
      'Puerto General San Martin',
      'Bella Vista',
      'Perez',
      'Villa America',
      'Candioti',
      'El 94',
      'Campo Berli',
      'Campo Huber',
      'El Gusano',
      'Colonia Duran',
      'Golondrina',
      'Sastre',
      'Estacion Kilometro 465',
      'Galvez',
      'Castellano Plaza',
      'Castellanos',
      'Colonia La Francia',
      'Cañada Rosquin',
      'San Antonio',
      'Tacuarendi',
      'La Hortensia',
      'Campo Ballesteros',
      'Campo Troffe',
      'Campo Chapino',
      'Villa Cañas',
      'Los Quebrachos',
      'Silva',
      'San Miguel',
      'Amenabar',
      'Colonia Falucho',
      'Estancia El Abolengo',
      'Campo Cullak',
      'El Uno -La Sarita',
      'Cuatro Bocas',
      'Colonia San Manuel',
      'La Sarita',
      'Paraje San Manuel',
      'La Selva',
      'La Carola',
      'Ibarlucea',
      'Angeloni',
      'Luciano Leiva',
      'Tacural',
      'Aldao',
      'Colonia El Empalme',
      'Venado Tuerto',
      'La Escondida',
      'San Marcos',
      'San Jose Del Rincon',
      'Montefiore',
      'La Elsa',
      'Galisteo',
      'Laguna Paiva',
      'Sunchales',
      'Colonia La Manuelita',
      'Campo Ristorto',
      'El Fortin',
      'Grutly',
      'Isla Vuelta Del Paraguayo',
      'Santa Fe',
      'Miguel Torres',
      'Huanqueros',
      'Balneario La Verde',
      'Colonia Rosa',
      'Cañada Rica',
      'San Jorge',
      'Campo Durando',
      'Campo El Injerto',
      'Ñanducita',
      'Colonia Cello',
      'Eusebia Y Carolina',
      'Santa Clara De Saguier',
      'Campo Rivarossa',
      'Cañada Ombu',
      'Hugentobler',
      'Pujato Norte',
      'San Agustin',
      'Campo Periotti',
      'Bajo Las Tunas',
      'Los Tres Reyes',
      'Colonia Dolores',
      'Gaboto',
      'Balneario Monje',
      'La Josefina',
      'Campo Maria Rosa',
      'Tartagal',
      'Campo Dean',
      'El Tajamar',
      'Colonia Lussino',
      'Bouquet',
      'La Carolina',
      'Los Muchachos - La Alborada',
      'Piñero',
      'La Pelada',
      'Moussy',
      'La Vertiente',
      'Colmena',
      'El Carmen De Avellaneda',
      'Santa Ana',
      'El Timbo',
      'Avellaneda',
      'Pilar',
      'Carrizales',
      'Esmeralda',
      'Presidente Roca',
      'Estacion Presidente Roca',
      'Colonia Corondina',
      'Coronda',
      'Colonias Las Lonjas',
      'Colonia Los Prados',
      'Villada',
      'Curupayti',
      'Fidela',
      'Ricardone',
      'Eustolia',
      'Arminda',
      'Capivara',
      'Campo Moschen',
      'Campo Magnago',
      'Campo Ramseyer',
      'Malabrigo',
      'Kilometro 742',
      'Santa Maria Centro',
      'Campo San Pedro',
      'Juncal',
      'Campo Spagnolo',
      'Armstrong',
      'Godeken',
      'Elortondo',
      'Santa Emilia',
      'Santa Anita',
      'Las Petacas',
      'Alejandra',
      'Los Jacintos',
      'Colonia La Maria',
      'El Progreso',
      'Villa San Antonio',
      'El Ceibo',
      'Los Corralitos',
      'Colonia Alejandra',
      'Los Cuervos',
      'Estacion El Gaucho',
      'Isla El Espinillo',
      'Rosario',
      'Coronel Fraga',
      'El Araza',
      'Hersilia',
      'Jacinto L. Arauz',
      'Campo Stangaferro',
      'Kilometro 54',
      'Campo Fiant',
      'El Rabon',
      'Sa Pereyra',
      'Canton De Zarate',
      'Wildermuth',
      'Recreo',
      'Susana',
      'Campo Piacenza',
      'Colonia Bossi',
      'Colonia Mascias',
      'Colonia San Joaquin',
      'Elisa',
      'Maria Teresa',
      'Est. La Barrancosa',
      'El Bayo',
      'Ataliva',
      'Colonia Cavour',
      'Cavour',
      'Beravebu',
      'Fuentes',
      'Portugalete',
      'Campo La Chingola',
      'Coloniamorgan',
      'San Gregorio',
      'Soutomayor',
      'Colonia La Rinconada',
      'Campo Mugueta',
      'Juan B. Molina',
      'La Picasa',
      'Aaron Castellanos',
      'Los Lapachos',
      'Arroyo Del Rey',
      'Ingeniero Chanourdie',
      'Tres Isletas',
      'Tres Bocas',
      'Estacion Kilometro 41',
      'Estancia La Sombrilla',
      'Los Amores',
      'Estancia El Ñacurutu',
      'Estancia El Tourne',
      'Estacion Kilometro 302',
      'Estancia La Viruela',
      'La Campana',
      'Campana',
      'Christophersen',
      'Colonia La Argentina Chica',
      'Puerto Arroyo Seco',
      'Arroyo Seco',
      'Casalegno',
      'Plaza Saguier',
      'Estacion Saguier',
      'Campo Ambroggio',
      'Fighiera',
      'Colonia Pujol',
      'Rincon Del Pintado',
      'Colonia Larrechea',
      'Esperanza',
      'Ambrosetti',
      'Achaval Rodriguez',
      'Campo La Nieva',
      'Colonia Reina Margarita',
      'Humberto Primo',
      'Colonia Roccia',
      'Campo Rodeo Chico',
      'Colonia Escribano',
      'Navarro',
      'Coronel Bogado',
      'Capilla Fassi',
      'Egusquiza',
      'La Penca Y Caraguata',
      'La Rinconada',
      'Colonia La Mora',
      'Chovet',
      'Villa Divisa De Mayo',
      'Colonia Bicha',
      'Santurce',
      'Marcelino Escalada',
      'Campo Botto',
      'Villa Trinidad',
      'Los Bretes',
      'Campo Andino',
      'Monje',
      'Fortin Charrua',
      'Pueblo Luis Berli',
      'El 17',
      'El Historico',
      'Paraje 29',
      'Los Charabones',
      'El Campanal',
      'El Chañar',
      'Kilometro 48',
      'Fortin Chilcas',
      'Fortin Olmos',
      'Lote 12',
      'Matilde',
      'Plaza Matilde',
      'Colonia Las Flores',
      'Casilda',
      'Colonia Desmochado Afuera',
      'Colonia Candelaria',
      'Cacique Ariacaiquin',
      'La Penca - San Mariano',
      'San Mariano',
      'Rafaela',
      'Campo Rubiolo',
      'San Genaro',
      'San Genaro Norte',
      'Villa Mugueta',
      'Maizales',
      'Campo La Celia',
      'La Cabral',
      'Palos Negros',
      'San Fabian',
      'Yamandu',
      'Arroyo Aguiar',
      'Villa Laura',
      'El 38',
      'San Roberto',
      'El Palmar',
      'Campo Taleb',
      'Estacion Kilometro 213',
      'La Gallareta',
      'Estancia El Peludo',
      'Campo Rotella',
      'Campo Giauque',
      'Km El 13',
      'Campo San Jose',
      'Colonia Sager',
      'Colonia Wingeyer',
      'Romang',
      'Costa Del Toba',
      'Campo Kaufmann',
      'Campo Althaus',
      'Virginia',
      'Theobald',
      'Colonia Alberdi',
      'Pueblo Uranga',
      'Santa Isabel',
      'Runciman',
      'Colonia Santa Lucia',
      'Bernardo De Irigoyen',
      'Campo Genero',
      'Los Quirquinchos',
      'Campo Crenna',
      'La Clorinda',
      'Cayastacito',
      'Grutly Norte',
      'Hipatia',
      'La Lucila',
      'Nelson',
      'Manucho',
      'Iriondo',
      'Rincon De Avila',
      'Maria Juana',
      'Las Bandurrias',
      'Campo Castro',
      'Wheelwright',
      'Merceditas',
      'Villa Del Plata',
      'Villa Amelia',
      'Kilometro 28',
      'Guasuncho',
      'Colonia Piloto',
      'La Reserva',
      'Campo Redondo',
      'Villa Ana',
      'El Amargo',
      'Villa San Diego',
      'Villa Gobernador Galvez',
      'Coronel Aguirre',
      'Garibaldi',
      'Landeta',
      'Colonialandeta',
      'Campo La Oriental',
      'Campo Santa Isabel',
      'Colonia San Antonio',
      'Las Rosas',
      'Iturraspe',
      'Campo La Pradera',
      'Campo El Rafango',
      'La California',
      'Sargento Cabral',
      'La Ema',
      'Campo Los Bayos',
      'Las Chañas',
      'El Centinela',
      'Kilometro 844',
      'El Molle',
      'El Descanso',
      'La Cautiva',
      'San Bernardo',
      'Guadalupe Norte',
      'San Jose De La Esquina',
      'Los Nogales',
      'Progreso',
      'Colonia Margarita',
      'Nuevo Torino',
      'Cepeda',
      'Stephenson',
      'Rincon Potrero',
      'Arroyo Leyes',
      'Rincon Norte',
      'Sancti Spiritu',
      'Campo Tardini',
      'Campo Langarica',
      'Vera Mujica',
      'Los Saladillos',
      'San Justo',
      'Paikin',
      'Colonia El Fortin',
      'Estancia Pichuco',
      'Campo La Pepita',
      'Estancia San Francisco',
      'San Cristobal',
      'Campo Puerta',
      'Campo Speranza',
      'Florencia',
      'Las Tunas',
      'Capitan Bermudez',
      'Coronel Arnold',
      'Chañar Ladeado',
      'Pueblo Esther',
      'Salto Grande',
      'Colonia El Carmen',
      'Traill',
      'Cabal',
      'Arroyo Verde',
      'Los Cerrillos',
      'Cayasta',
      'Los Tres Pozos',
      'Kilometro 115',
      'Garabato',
      'Pozo De Los Indios',
      'Acebal',
      'Melincue',
      'Campo Sierra',
      'Campo Almendra',
      'Capilla Vottero',
      'Josefina',
      'Maggiolo',
      'Campo El Rincon',
      'La Chispa',
      'Soledad',
      'Helvecia Sur',
      'Campo Del Medio',
      'Colonia Helvecia Oeste',
      'Los Algarrobos',
      'Helvecia',
      'Villa Constitucion',
      'Barrio Arroyo Del Medio',
      'Monte Oscuridad',
      'San Lorenzo',
      'Colonia Bigand',
      'Videla',
      'Colonia Sol De Mayo',
      'Emilia',
      'Las Toscas',
      'Campo Winkler',
      'La Curva',
      'Gregoria Perez De Denis',
      'Zavalla',
      'Campo La Elvira',
      'Colonia Ana',
      'Sanford',
      'Coronel Rodolfo S. Dominguez',
      'El Carmelo',
      'Roldan',
      'Plaza Clucellas',
      'Estacion Clucellas',
      'Campo La Fortuna',
      'San Eduardo',
      'Esther',
      'Cuatro Esquinas',
      'Carmen Del Sauce',
      'Larrechea',
      'Casas',
      'Campo Cravero',
      'Carcaraña',
      'Arroyo Ceibal',
      'Campo Sager',
      'Villa Sol De Mayo',
      'Chapuy',
      'Estancia La Florida',
      'Logroño',
      'Las Norias',
      'Independencia',
      'El Tapialito',
      'Las Garzas',
      'Isla Guaycuru',
      'Rueda',
      'Nueva Lehmann',
      'Lehmann',
      'Campo Giacossa',
      'Cañada Del Ucle',
      'Sauce Viejo',
      'Villa Adelina',
      'Bella Italia',
      'Pueblo Muñoz',
      'Estancia Las Aves',
      'La Hosca',
      'Campo Baroni',
      'Desvio Km 213',
      'Colonia Doña Mariana',
      'El Aromal',
      'Calchaqui',
      'Estancia San Pedro',
      'San Wendelino',
      'San Jeronimo Norte',
      'Santa Rosa De Calchines',
      'Los Zapallos',
      'Diego De Alvear',
      'Firmat',
      'Colonia Los Trojes',
      'La Camila',
      'Campo Oroño',
      'Castelar',
      'Soldini',
      'Alcorta',
      'Oliveros',
      'Villa La Rivera - Oliveros',
      'San Carlos Sud',
      'Lazzarino',
      'Campo Morello',
      'Angelica',
      'Campo Baudino',
      'Pueblo Andino',
      'Villa La Rivera - Pueblo Andino',
      'Loma Alta',
      'Colonia La Blanca',
      'La Criolla',
      'La Nevada',
      'Colonia Norte',
      'Maximo Paz',
      'Intiyaco',
      'Los Leones',
      'Montenegro',
      'Florida',
      'Campo Borgarello',
      'Campo Canavesio',
      'Bauer Y Sigel',
      'Campo Torriglia',
      'Campo Cardini',
      'Cañada De Gomez',
      'Campo Las Vascas',
      'San Estanislao',
      'Campo Carbonari',
      'Campo Iadanza',
      'Campo Marinsalta',
      'Serodino',
      'Centeno',
      'El Bosque',
      'Maria Luisa',
      'Rabiola',
      'Carmen',
      'La Brava',
      'Colonia Ovejita',
      'San Martin Norte',
      'Arteaga',
      'Hughes',
      'Campo El Mataco',
      'La Rubia',
      'Albarellos',
      'San Jose',
      'Cululu',
      'Campo La Teresita',
      'Los Sembrados',
      'Bigand',
      'Irigoyen',
      'Colonia Albertengo',
      'Coronel Rosetti',
      'Rufino',
      'Tarragona',
      'Maciel',
      'La Ramada',
      'Sarmiento',
      'Ingeniero Boassi',
      'San Marcelo',
      'Campo La Delia',
      'Campo Tazzioli',
      'Teodelina',
      'Campo Gerardo',
      'Estancia Santa Juana',
      'Colonia Nueva Norte',
      'Humboldt',
      'Colonia Nueva Centro',
      'Lopez',
      'San Jeronimo Sud',
      'Campo Maria Teresa',
      'Carlos Pellegrini',
      'Campo Busso',
      'Campo Nicoli',
      'Campo La Caledonia',
      'Barrios Acapulco Y Veracruz',
      'Villa Josefina',
      'Frontera',
      'Aurelia',
      'Aurelia Norte',
      'Campo Ubino',
      'Bustinza',
      'Campo Mosca',
      'Colonia Tres Reyes',
      'Campo Bertoni',
      'Vila',
      'Colonia El Inca',
      'Tostado',
      'Campo Pergolesi',
      'Campo Don Bosco',
      'Campo Maria Alicia',
      'El Cacique',
      'Tres Pozos',
      'Estancia El Palmar',
      'Antonio Pini',
      'Campo La Maruca',
      'Colonia50 Los Charabones',
      'Barrio Caima',
      'Desvio Arijon',
      'Paraje La Costa',
      'Monte Vera',
      'Angel Gallardo',
      'Ascochinga',
      'Paraje Chaco Chico',
      'Campo Crespo',
      'Franck',
      'Costa Rica',
      'Campo Morzan',
      'Colonia El Yaguare',
      'Moises Ville',
    ],
    'AR-G': [
      'Chilca Juliana',
      'Garza',
      'Villa General Mitre',
      'Campo Gallo',
      'Doña Luisa',
      'Sabagasta',
      'La Darsena',
      'San Ramon',
      'El Zanjon',
      'Villa Matoque',
      'Guampacha',
      'Villa Guasayan',
      'Pozo Del Toba',
      'Quebracho Coto',
      'Villa Robles',
      'Sol De Mayo',
      'Juanillo',
      'Punta Pozo',
      'El Aibe',
      'Abra Grande',
      'Remes',
      'San Benito',
      'El Dean',
      'San Vicente',
      'Santa Catalina',
      'Santa Maria',
      'Caspi Corral',
      'Vaca Huañuna',
      'Canal Melero',
      'La Simona',
      'La Nena',
      'Tres Cruces',
      'Yuchan',
      'La Noria',
      'Sauce Solo',
      'Amama',
      'Villa Brana',
      'Libertad',
      'Negra Muerta',
      'Km 49',
      'Campo Grande',
      'Villa Mercedes',
      'Santo Domingo',
      'Amicha',
      'Lezcanos',
      'Los Ovejeros',
      'Sotelos',
      'Los Romanos',
      'Villa Hipolita',
      'Vaca Human',
      'Tio Pozo',
      'Villa Nueva',
      'Huachana',
      'Sumamao',
      'Ahi Veremos',
      'Pozo Del Arbolito',
      'Roldan',
      'San Antonio',
      'El Hoyon',
      'El Sauzal',
      'Atoj Pozo',
      'Vuelta De La Barranca',
      'El Crucero',
      'Las Tinajas',
      'Colonia El Simbolar',
      'La Banda',
      'La Bajada',
      'San Carlos',
      'Ingeniero Forres',
      'Los Quiroga',
      'Pozo Hondo',
      'El Charco',
      'Pozancones',
      'San Juan',
      'La Vuelta',
      'Shishi Pozo',
      '25 De Mayo De Banegas',
      'Monte Redondo',
      'San Delfin',
      'Pichana',
      'Alto Bello',
      'San Pedro',
      'Estacion La Punta',
      'El Quebracho',
      'Ancajan',
      'Los Ralos',
      'El Salvador',
      'Rumi Esquina',
      'La Aurora',
      'San Justo',
      'Monte Pampa',
      '25 De Mayo',
      'La Laguna',
      'Kilometro 55',
      'Cerro Chico',
      'Puerta De Chavez',
      'Palo Parado',
      'Viva Mercedes',
      'Las Barrancas',
      'Las Tejas',
      'Pozo Del Simbol',
      'Santa Cruz',
      'Villa Adela',
      'El Puestito',
      'Las Lomitas',
      'La Represa',
      'San Rafael',
      'La Tusca',
      'El Desmonte',
      'Sobremonte',
      'El Canario',
      'Santa Lucia',
      'Punta Del Monte',
      'San Miguel',
      'Pozo De La Puerta',
      'El Milagro',
      'Las Palmitas',
      'Lugones',
      'Estacion Tacañitas',
      'Villa Salavina',
      'Villa Figueroa',
      'Villa San Martin',
      'Pozo Betbeder',
      'Colonia Tinco',
      'Tintina',
      'Taco Pozo',
      'Santa Rosa',
      'Colonia Libanesa',
      'Lago Muyoj',
      'Palermo',
      'Blanca Pozo',
      'Percas',
      'San Roque',
      'San Jose',
      'Campo Alegre',
      'La Costa',
      'Colonia Isla',
      'Yacasnioj',
      'Colonia Alcira',
      'Breayoj',
      'Pozo Mosoj',
      'Punta Isla',
      'Loro Pampa',
      'Lujan',
      'Paso Grande',
      'Tala Pozo',
      'Gramilla',
      'Novillo Pozo',
      'Totora',
      'El Molle',
      'Navicha',
      'San Antonio De Copo',
      'Mancapa',
      'Salviayoj',
      'Caloj',
      'Tusca Pozo',
      'Punta Corral',
      'Hurmanita Estancia',
      'Puente Negro',
      'Tala Atun',
      'Villa Rio Hondo',
      'Corral Quemado',
      'Rumi Pozo',
      'Urutau',
      'Estados Unidos',
      'Cabeza Del Toro',
      'El Ceibal',
      'Vinal Pozo',
      'El Puesto',
      'Ranchillos',
      'Manga Bajada',
      'Lavalle',
      'San Bernardo',
      'La Esperanza',
      'Consuelo',
      'Belgrano',
      'Mailin',
      'Lote 43',
      'Guayacan Pozo',
      'San Javier',
      'La Virtud',
      'La Candelaria',
      'El 60',
      'Vinal Suni',
      'Puestos Unidos',
      'Toro Pampa',
      'La Salvacion',
      'Itati',
      'El Rincon',
      'Colombia',
      'Nueva Esperanza',
      'La Union',
      'Dos Arboles',
      'Cruz Bajada',
      'Los Tigres',
      'Belgica',
      'Toro Pozo',
      'Los Pocitos',
      'Las Malvinas',
      'San Isidro',
      'La Armonia',
      'La Firmeza',
      'San Ignacio',
      'El Palmar',
      'Ifia',
      'El Aerolito',
      'Buenos Aires',
      'Rincon Del Valle',
      'Bahia Blanca',
      'Paaj Pozo',
      'El Tunquelen',
      'Puesto Cordoba',
      'San Cristobal',
      'Los Morteros',
      'Iskoy Pozo',
      'Lote 40',
      'Tres Varones',
      'El Corrido',
      'Las Lomas',
      'Caloj Pozo',
      'Piruaj Bajo',
      'Los Pozancones',
      'El Valle',
      'Ramirez De Velazco',
      'Chaupi Pozo',
      'Real Sayana',
      'El Colorado',
      'Pozuelos',
      'Puesto Nuevo',
      'La Florida',
      'La Rivera',
      'Mili',
      'Chilca',
      'Los Pereyra',
      'Pozo Sumi',
      'Los Arias',
      'Colonia Jaime',
      'Sauce Bajada',
      'El Quebrachal',
      'Lomitas',
      'Nueva Industria',
      'Loaj',
      'Higuera Chacra',
      'El Soler',
      'Janta',
      'Buey Muerto',
      'El Refugio',
      'Mirella',
      'Troncos',
      'Maco',
      'Morcillo',
      'Media Luna',
      'San Nicolas',
      'El Cuadro',
      'Lote 24',
      'Limache',
      'El Huaico',
      'Las Abras',
      'El Albardon',
      'Las Viboritas',
      'Quebrachitos',
      'Domingo De Ramos',
      'Puesto Del Medio',
      'San Andres',
      'La Ramadita',
      'Coro Pampa',
      'La Abrita',
      'La Higuera',
      'Matara',
      'Villa Silipica',
      'Simbol',
      'Pampa De Los Guanacos',
      'Sumampa',
      'San Jose Del Boqueron',
      'Arbol Solo',
      'El Algarrobal',
      'El Cerro',
      'Los Remansos',
      'El Bajo',
      'Coronel Fernandez',
      'El Mistol',
      'Campo Del Cisne',
      'Rama Paso',
      'Villa Quebrachos',
      'El Espartal',
      'La Blanquita',
      'Fuerte Viejo',
      'La Trampa',
      'San Francisco',
      'El Pueblito',
      'El Paraiso',
      'El Talar',
      'Cuchi Corral',
      'Puerta Del Monte',
      'Sumampa Viejo',
      'Buena Vista',
      'La Yerba',
      'Pozo Del Monte',
      'Horcos Tucucuna',
      'Gaucho De Guemes',
      'El Ayudante',
      'El Ucle',
      'Corral Del Rey',
      'Rio Viejo',
      'La Granada',
      'El Desvio',
      '14 De Mayo',
      'Oratorio',
      'Santa Ana',
      'El Laurel',
      'La Chicharra',
      'Los Algarrobos',
      'Termas De Rio Hondo',
      'Icaño',
      'Tomas Young',
      'Nueva Francia',
      'Vilmer',
      'Laprida',
      'Tapso',
      'Herrera',
      'Bandera',
      'Weisburd',
      'Colonia Alpina',
      'Rapelli',
      'Cuquero',
      'Cuatro Esquinas',
      'El Remanso',
      'Jumial Grande',
      'La Ingrata',
      'Tres Pozos',
      'Cruz Chica',
      'Tacanitas',
      'El Porvenir',
      'El Fisco/Lote48',
      'La Oveja',
      'Agustina Libarona',
      'Chañarito',
      'Esteco',
      'Hoyo Cerco',
      'Ingrata Sur',
      'Vinal Viejo',
      'Campo Verde',
      'Esteros',
      'Campo Bandera',
      'El Simbol',
      'La Paloma',
      'Santa Maria Salome',
      'La Delia',
      'El Aibal',
      'La Manga',
      'Las Carpas',
      'Monte Rico',
      'Anca Overa',
      'Montevideo',
      'Noqueoj',
      'Pozo Salado',
      'Coronel Manuel L. Rico',
      'El Majan',
      'Milagros',
      'Ranchitos',
      'La Frontera',
      'Villa Palmar',
      'Las Perforaciones',
      'La Cambicha',
      'Maninioj',
      'El Yunchancito',
      'Saladillo',
      'Pozo Grande',
      'La Fortuna',
      'Pozo Limpio',
      'La Sarita',
      'San Luis',
      'Rio Muerto',
      'Ingrata Norte',
      'Villa Union',
      '9 De Julio',
      'Campo De Leones',
      'Cruz Del Norte',
      'El Cardonal',
      'La Soledad',
      'Puerta De Los Cerros',
      'La Aguadita',
      'Algarrobo',
      'El Arbol',
      'Puerta De Los Rios',
      'La Chirquita',
      'Piedra Blanca',
      'Amiman',
      'Minguecho',
      'El Barrial',
      'Pozo Del Garabato',
      'Baez',
      'Ambargasta',
      'Lomitas Blancas',
      'Amoladeras',
      'Kilometro 88',
      'Kilometro 96',
      'Balbuena',
      'Chacras',
      'El  Molino',
      'La Isla',
      'Tala Yacu',
      'Oncan',
      'Inti Huasi',
      'Las Mangas',
      'Suri Pozo',
      'Pampa Grande',
      'Las Chacras',
      'La Cruz',
      'Agua Blanca',
      'La Estancia',
      'Añatuya',
      'Palomar',
      'Puesto De San Antonio',
      'Loma Grande',
      'Pozo Cavado',
      'Antilo',
      'Dolores',
      'La Puerta',
      'Palma Pozo',
      'Los Positos',
      'La Mesada',
      'El Mojon',
      'San Lorenzo De Los Sayagos',
      'San Antonio De Los Caceres',
      'Rodeo De Soria',
      'La Estancita',
      'Lomas De Zamora',
      'Tipiro',
      'Los Cardozos',
      'Morales',
      'Upianita',
      'Huaico Hondo',
      'Tunas Punco',
      'San Lorenzo',
      'Churqui',
      'Yanda',
      'Estacion Ingeniero Ezcurra',
      'Mal Paso',
      'Pampa Muyoj',
      '7 De Abril',
      'Agua Azul',
      'Las Puertas',
      'El Rosado',
      'Tres Bajos',
      'El Guapo',
      'Lomas Blancas',
      'Tacko Yuraj',
      'Monte Quemado',
      'La Cañada',
      'Siete Arboles',
      'San Serafin',
      'Santa Maria De Las Chacras',
      'La Ovejeria',
      'El Arenal',
      'Taco Punco',
      'Quebracho Esquina',
      'La Bolsa',
      'Tusca Bajada',
      'El Bordo',
      'El Cajon',
      'Villa Estela',
      'Yuchancito',
      'El Cambiado',
      'Santa Felisa',
      'El Socorro',
      'La Costosa',
      'Quimilioj',
      'Toro Human',
      'El Corralito',
      'Pampa Suni',
      'Nuevo Simbolar',
      'La Reaccion',
      'Pampa Pozo',
      'El Saladillo',
      'El Quemado',
      'Los Cerros',
      'San Gregorio',
      'Los Cercos',
      'La Blanca',
      'Las Lajas',
      'El Diablo',
      'El Sauce',
      'Pozo Nuevo',
      'El Remate',
      'Monte Potrero',
      'Algarrobal Viejo',
      'Babilonia',
      'El Azul',
      'El Ojito',
      'El Rosario',
      'Agua Amarga',
      'Tres Quebrachos',
      'Taco Bajada',
      'Puesto Del Angel',
      'Taco  Pozo',
      'Santiago Del Estero',
      'Maquito',
      'Quimili',
      'Fortin Inca',
      'Cuatro Bocas',
      'Antaje',
      'Palo Negro',
      'Sauzal',
      'Estacion Taboada',
      'Ardiles',
      'Villa Atamisqui',
      'Selva',
      'Medellin',
      'Veron',
      'El Candelario',
      'Navarro',
      'Guerra',
      'Los Cerrillos',
      'Rubia Paso',
      'El Simbolar',
      'Anga',
      'Campos De Cejas',
      'Bordo Pampa',
      'Nueva Loma',
      'La Centella',
      'Chira',
      'Taco Isla',
      'Carreta Paso',
      'Barrancas',
      'Yacu Hurmana',
      'Puente Del Saladillo',
      'Malota',
      'Mistol Pozo',
      'Chañar Sinuchay',
      'La Ramada',
      'El Cadillal',
      'Rincon Grande',
      'La Guanaca',
      'Las Cejas',
      'El Palomar',
      'Poleo Pozo',
      'El Fisco De Fatima',
      'Los Santillan',
      'Ceja Pozo',
      'Bajo Alegre',
      'Buen Lugar',
      'Puesto Libertad',
      'San Felix',
      'Isca Yacu',
      'Bajo Hondo',
      'Isca Yacu Semaul',
      'El Pacara',
      'Los Tunales',
      'Las Zanjitas',
      'Uturungo',
      'Mistol Puesto',
      'Pozo Lindo',
      'Humaita',
      'El Bagual',
      'El Churqui',
      'San Bartolo',
      'Lilo Viejo',
      'Patay',
      'Malbran',
      'Los Juries',
      'Las Dolores',
      'Tres Lagunas',
      'Los Tableros',
      'Aspirante',
      'El Destino',
      'Isla Baja',
      'Donadeu',
      'Colonia Libertad',
      'El Oso',
      'Colonia Hermelinda',
      'Tronco Blanco',
      'Campo Contardi',
      'Las Promesas',
      'La Providencia',
      'El Tropezon',
      'Choya',
      'Simbolar',
      'Chañar Pozo De Abajo',
      'Isla De Los Sotelos',
      'Los Miranda',
      'Los Castillos',
      'Loma Del Medio',
      'La Nueva Donosa',
      'Palma Redonda',
      'Aragones',
      'San Pablo',
      'El Manantial',
      'Los Quebrachos',
      'Bahoma',
      'Charco Viejo',
      'Taquello',
      'Dique Frontal',
      'Isla De Aragones',
      'Chañar Pozo De Arriba',
      'Abrita Grande',
      'Puesto Del Sauzal',
      'Chauchillas',
      'Casilla Del Medio',
      'Cañada De Robles',
      'Cañada Del Monte',
      'Las Palmeras',
      'Gramilla Vieja',
      'Algarrobales',
      'La Aguada',
      'Villa Turistica Del Embalse',
      'Galeano',
      'Santa Feliza',
      'Barrialito',
      'Mansupa',
      'Loro Huasi',
      'Sotelillos',
      'Rodeo De Valdez',
      'Villa Gimenez',
      'Chañar Pozo Del Medio',
      'La Reserva',
      'Brea Puñuna',
      'Amapola',
      'El Bobadal',
      'Las Delicias',
      'Pueblo Pablo Torelo',
      'El Cuadrado',
      'Vilelas',
      'Los Gallegos',
      'Suncho Pozo',
      'Shillpi',
      'Barrial Alto',
      'Pampa Atun',
      'Cheej',
      'Majadas',
      'Brea Pozo Viejo',
      'Perchil Bajo',
      'Tacoyoj',
      'La Verde',
      'Puestito',
      'Tres Jazmines',
      'Diaspa',
      'El Msitol',
      'Santos Lugares',
      'La Invernada Sud',
      'Averias',
      'Dos Hermanas',
      'El Cachi',
      'Nueva Colonia',
      'La Tapa',
      'Huilla Catina',
      'Pueblo Nuevo',
      'La Paciencia',
      'Punitayoj',
      'El Negrito',
      'Cardon Esquina',
      'Machaguay Huanchina',
      'Puesto De Mena',
      'La Loma',
      'El Vizcacheral',
      'Lote La Cañada',
      'San Salvador',
      'Vinal Isla',
      'Minerva',
      'Maderas',
      'Kilometro 30',
      'Aguas Coloradas',
      'Cartavio',
      'Yacu Hichacuna',
      'Callejon Bajada',
      'La Barrosa',
      'Campo Y Cielo',
      'Jume Esquina',
      'La Guardia',
      'San Jorge',
      'El Tableado',
      'San Felipe',
      'Kilometro Cero',
      'El Pirucho',
      'Colonia Totorillas',
      'Jumialito',
      'Santa Rita',
      'Tablada Del Boqueron',
      'Fernandez',
      'Estacion Robles',
      'Tierra Del Este',
      'Mercedes',
      'Lincho',
      'Tres Mojones',
      'El Arbolito',
      'Lote 48',
      'Roversi',
      'Stayle',
      'El Carmen',
      'La Curva',
      'Hernan Mejia Miraval',
      'Armonia',
      'Santa Justina',
      'Tinajerayoj',
      'Villa Petocha',
      'Hasse',
      'El Pertigo',
      'Lote 115',
      'El Hoyo',
      'Catamarca',
      'El Prado',
      'Aerolito',
      'Lote L 3',
      'Muyuska',
      'Obraje Maria Angelica',
      'El Tanque',
      'Magdalena',
      'Pampa Charquina',
      'Las Dos A',
      'Ledesma',
      'Colonia Arbol Blanco',
      'Floresta',
      'Los Milagros',
      'La Nombrada',
      'La Magdalena',
      'Trinidad',
      'Arbol Blanco',
      'Celestina',
      'Lote 87',
      'La Pampa',
      'Villa Matilde',
      'Alhuampa',
      'Lote 31',
      'El Fisco',
      'Santa Teresita',
      'San Martin',
      'Pozo Barrancayoj',
      'Chilcan',
      'Ampa',
      'Oso Huanchina',
      'Ovejeria',
      'Paaj Rodeo',
      'San Marcos',
      'Villa Matara',
      'Azogasta',
      'La Falda',
      'Colonia Siegel',
      'Concepcion',
      'Conchayoj',
      'Sachayoj',
      'Los Alderetes',
      'El Barrialito',
      'Nueva Lujan',
      'Nueva Libano',
      'Isla Corral',
      'Monte Bello',
      'Colonia Maria Luisa',
      'Cuyoj',
      'Jumi Pozo',
      'Vaca Muerta',
      'Rubia Moreno',
      'Cerrillos',
      'Bayo Muerto',
      'Tramo 16',
      'El Ojo De Agua',
      'Los Acosta',
      'Acosta',
      'La Capilla',
      'El Favorito',
      'Pampa Mayo',
      'Los Gomez',
      'Colonia Gamara',
      'La Quisca',
      'Mistolito',
      'Tabla Redonda',
      'Bajo Grande',
      'Palmares',
      'Los Gallardo',
      'Tramo 20',
      'Ardiles De La Costa',
      'El Polear',
      'Quita Punco',
      'El Alambrado',
      'Cara Pujio',
      'Los Angeles',
      'Colonia Argentina',
      'Santa Elena',
      'Tramo 26',
      'Alto Pozo',
      'La Granja',
      'Esquina Pozo',
      'Los Diaz',
      'Los Soria',
      'Palmitas',
      'Palos Quemados',
      'Guaycuru',
      'Palmita De Gerez',
      'El Puente',
      'Quishca',
      'Huyamampa',
      'Colonia San Juan',
      'Brea Pozo',
      'Casares',
      'El Peral',
      'San Dionisio',
      'Codo Viejo',
      'Tasigasta',
      'Collera Huarcana',
      'Paloma',
      'Simbol Pozo',
      'Puesto Del Rosario',
      'El Dorado',
      'Brea Loma',
      'El Peru',
      'Los Tolozos',
      'Soconcho',
      'Puerta Grande',
      'Los Peraltas',
      'Ancocha',
      'Guanaco Sombriana',
      'Ventura Pampa',
      'Saucioj',
      'Chilca La Loma',
      'Santa Isabel',
      'Beltran',
      'Sol De Julio',
      'Colonia Dora',
      'Cañada Escobar',
      'Los Nuñez',
      'El Cabure',
      'Vinara',
      'Estacion Atamisqui',
      'Lotes 33-37-40-42',
      'Lotes 46 A 48',
      'Villa Los Pocitos',
      'Villa Abregu',
      'Selva Negra',
      'Buen Paso',
      'Pozo Herrera',
      'Suncho Pozo Del Triunfo',
      'Miel De Palo',
      'Suncho Pozo Alto',
      'Estacion Las Gamas',
      'La Huerta',
      'Lote 15',
      'Obraje Mailin',
      'Lotes 1 A 9',
      'La Piamontesa',
      'Lotes 25 A 29',
      'Sanavirones',
      'Selva Blanca',
      'Campo Lagar',
      'Pozo Del Medio',
      'Kilometro 454',
      'La Salamanca',
      'Lote 42',
      'Los Linares',
      'El Malacara',
      'Villa Carolina',
      'Taco Atun',
      'La Paulina',
      'Campo Toledo',
      'Clodomira',
      'Suncho Corral',
      'La Invernada',
      'Bandera Bajada',
      'Frias',
      'Los Pirpintos',
      'Villa Ojo De Agua',
      'Argentina',
      'Villa Mailin',
      'Arraga',
      'El Apeadero',
      'Lote 63',
      'Colonia Josefina',
      'Lojlo',
      'Lote 59',
      'El 20',
      'Lote 69',
      'El Carretel',
      'Lote 28',
      'Pozo Del Tigre',
      'Puente Bajada',
      'Lote 110',
      'Kilometro 477',
      'Rincon Del Saladillo',
      'Taruy',
      'Rodeo Bajada',
      'Campo Del Cielo',
      'Lote 29 Chico',
      'Chichillal',
      'Lote 32 La Reserva',
      'Guardia Escolta',
      'La Victoria',
      'El Aromito',
      'Colonia La Victoria',
      'Colonia Mackinlay',
      'La Federacion',
      'La Huanaca',
      'Dos Provincias',
      'Los Encantos',
      'Nueva Ceres',
      'La Romelia',
      'Los Porongos',
      'Paraje 12',
      'El Galpon',
      'El Quimil',
      'Moron',
      'La Calera',
      'Medio Mundo',
      'Villa Rosa',
      'Tres Cerros',
      'Las Juntas',
      'El Tajamar',
      'El Cadillo',
      'El Mangrullo',
      'Santa Barbara',
      'Mistol Muyoj',
      'La Chilca',
      'La Breita',
      'Parana',
      'Pozancon',
      'Las Talitas',
      'Los Telares',
      'Villa La Punta',
      'Rio Pinto',
      'Villa Vieja',
      'La Dormida',
      'Morampa',
      'La Resbalosa',
      'Diente Del Arado',
      'Puesto De Beltran',
      'Totora Pampa',
      'La Revancha',
      'Crucesitas',
      'Tacanas',
      'Isla Verde',
      'Ayuncha',
      'Puesto De Juanes',
      'Pozo Verde',
      'Pozo Ciego',
      'Kilometro 83',
      'Punua',
      'La Meleada',
    ],
    'AR-V': [
      'Ushuaia',
      'Puerto Darwin',
      'Pradera Del Ganso',
      'Puerto Leith',
      'Puerto Argentino',
      'Grytviken',
      'San Sebastian',
      'Estancia Sara',
      'Cullen',
      'El Paramo',
      'Destacamento Decepcion',
      'Base Belgrano Ii',
      'Destacamento Petrel',
      'Base Esperanza',
      'Destacamento Melchior',
      'Base San Martin',
      'Base Primavera',
      'Base Brown',
      'Base Orcadas',
      'Destacamento Camara',
      'Base Matienzo',
      'Base Marambio',
      'Base Carlini',
      'Rio Grande',
      'Laguna Escondida',
      'Tolhuin',
    ],
    'AR-T': [
      'Villa Tercera',
      'Ex Ingenio Los Ralos',
      'Las Mercedes',
      'Villa Recaste',
      'Campo La Flor',
      'Muyo',
      'Alpachiri',
      'Las Lenguas',
      'El Molino',
      'Cochuna',
      'La Calera',
      'Las Pavas',
      'Simoca',
      'Soldado Maldonado',
      'Los Pereyra Norte',
      'Gastona',
      'Finca Leon Cornet',
      'Gastonilla',
      'La Higuera',
      'Las Faldas',
      'Finca La Falda',
      'Arcadia',
      'Los Robles',
      'San Jose De Flores',
      'La Cienaga',
      'Rincon De Balderrama',
      'Acheral',
      'Alto De Leiva',
      'Las Tacanas',
      'La Bolsa',
      'El Infiernillo',
      'Tafi Del Valle',
      'Los Cuartos',
      'Rodeo Grande',
      'El Rincon',
      'La Angostura',
      'La Junta',
      'Esquina Del Valle',
      'Ojo De Agua',
      'Santa Cruz',
      'Las Carreras',
      'El Mollar',
      'El Cortaderal',
      'Romera Pozo',
      'Mixta',
      'Los Camperos',
      'Loma Verde',
      'Puma Pozo',
      'Santa Rosa De Leales',
      'Agua Azul',
      'Los Nogalitos',
      'El Nogalito',
      'Punta Del Monte',
      'Potrero De Las Tablas',
      'Mundo Nuevo',
      'El Duraznillo',
      'Mala Mala',
      'Ingenio San Pablo',
      'Ex Ingenio Esperanza',
      'Ingenio La Florida',
      'El Fortin',
      'La Florida',
      'El Talar',
      'El Paraiso',
      'Villa Burruyacu',
      'Monte Bello',
      'Las Animas',
      'Chasquivil',
      'San Jose De Chasquivil',
      'Ancajuli',
      'Condor Huasi',
      'Tusca Pozo',
      'Agua Dulce',
      'Estacion Cachi Yaco',
      'Oran',
      'Laguna Blanca',
      'Villa San Javier',
      'El Corte',
      'Barrio San Jose Iii',
      'Ex Ingenio San Jose',
      'Yerba Buena - Marcos Paz',
      'Barrio Lomas De Tafi',
      'Barrio Los Pocitos (Las Talitas)',
      'La Aguadita',
      'Barrio El Cruce',
      'Barrio Mutual San Martin',
      'Los Nogales',
      'Cevil Pozo',
      'Ex Ingenio Lujan',
      'Barrio Aeropuerto',
      'Colonia La Bonaria',
      'Balderrama Sur',
      'Yerba Buena',
      'El Jardin',
      'La Ramadita',
      'Los Sosa',
      'Las Mesadas',
      'El Naranjal',
      'Monte Grande',
      'La Cocha',
      'Alto De La Cocha',
      'Villa Nueva',
      'El Porvenir',
      'La Posta',
      'Casas Viejas',
      'Pozo De La Esquina',
      'Sur De Trejos',
      'Sur De Lazarte',
      'Nueva Trinidad',
      'El Durazno',
      'El Pacara',
      'Santa Isabel',
      'Niogasta',
      'Santa Ana',
      'Villa Clodomiro Hileret',
      'La Cuchilla',
      'Vacahuasi',
      'El Tipal',
      'Agua Negra',
      'Villa Padre Monti',
      'Las Lajitas',
      'La Rinconada',
      'Alto De Medina',
      'Rio Del Nio',
      'Belicha',
      'Belicha Huaico',
      'Yucumanita',
      'Gastona Sur',
      'Gastona Norte',
      'El Carmen',
      'Colonia San Jose',
      'Los Porceles',
      'San Andres',
      'San Jose De La Cocha',
      'Manchala',
      'San Jose De Buena Vista',
      'Entre Rios',
      'Rio Colorado',
      'El Bracho',
      'El Cevilar',
      'Monteros',
      'Tala Pozo',
      'Piedrabuena',
      'La Tuna',
      'Villa Dolores',
      'San Miguel',
      'Santa Rosa',
      'La Union',
      'La Verde',
      'La Soledad',
      'La Virginia',
      'Villa Maria',
      'El Once',
      'Puesto Del Medio',
      'Escaba De Arriba',
      'Escaba De Abajo',
      'Sargento Moya',
      'Blanco Pozo',
      'Rafaela Pozo',
      'Las Cejas',
      'Barrio San Felipe',
      'Santa Barbara',
      'Los Aguirre',
      'Puente El Manantial',
      'El Milagro',
      'La Esperanza',
      'La Trinidad',
      'San Carlos',
      'Country Jockey Club',
      'Curva De Los Vegas',
      'Cevil Redondo',
      'Villa Carmela',
      'El Naranjito',
      'San Vicente',
      'Favorina',
      'La Tala',
      'Paso De La Patria',
      'Puerta Alegre',
      'El Triunfo',
      'Garmendia',
      'Paja Colorada',
      'El Manantial',
      'Barrio Araujo',
      'El Chañar',
      'Taquello',
      'Boca Del Tigre',
      'El Espinillo',
      'Taco Palta',
      'La Marta',
      'Los Pocitos',
      'Tafi Viejo',
      'Villa Las Flores',
      'Barrio Parada 14',
      'Barrio U.T.A. Ii',
      'La Picada',
      'Benjamin Paz',
      'El Brete',
      'Aragon',
      'Las Juntas',
      'Las Arcas',
      'Leocadio Paz',
      'Villa De Trancas',
      'Tuna Sola',
      'El Sauce',
      'San Isidro',
      'El Simbolar',
      'San Jose',
      'Amaicha Del Llano',
      'Bella Vista',
      'San Ramon',
      'Colonia Sobrecasas',
      'Arsenal Miguel De Azcuenaga',
      'Diag. Norte - Luz Y Fuerza - Los Pocitos',
      'Villa Mariano Moreno - El Colmenar',
      'Manuel Garcia Fernandez',
      'Medina',
      'Los Juarez',
      'Alto Verde',
      'Cortaderas',
      'Monte Rico Viejo',
      'Carreta Quemada',
      'Villa Quinteros',
      'Los Rojos',
      'Naranjo Esquina',
      'Yaquilo',
      'Campo Bello',
      'Donato Alvarez',
      'Juan Bautista Alberdi',
      'Caspinchango',
      'Santa Lucia',
      'San Javier',
      'Viclos',
      'El Quimil',
      'El Mojon',
      'La Hoyada',
      'Raco',
      'San Jose De Raco',
      'Alto De Anfama',
      'Las Tipas',
      'Anfama',
      'Atahona',
      'Ampata',
      'Alto De Las Lechuzas',
      'Cejas De Aroca',
      'Quilmes',
      'Rincon De Quilmes',
      'Lara',
      'Colalao Del Valle',
      'La Fronterita',
      'Pichao',
      'Anjuana',
      'El Arbolar',
      'Estacion Araoz',
      'Tres Pozos',
      'Las Tusquitas',
      'Balderrama',
      'Estacion Manuela Pedraza',
      'Teniente Berdina',
      'Los Cordoba',
      'Rio Chico',
      'Ampimpa',
      'Salas',
      'Calimonte',
      'Yasyamayo',
      'Los Zazos',
      'Tio Punco',
      'Amaicha Del Valle',
      'El Tio',
      'El Paso',
      'Estacion Cruz Del Norte',
      'General Paz',
      'Colombres',
      'San Miguelito',
      'Pozo Del Alto',
      'El Cercado',
      'El Churqui',
      'El Rodeo',
      'Tusca Pampa',
      'La Cruz De Arriba',
      'La Ramada',
      'La Cruz',
      'Macomitas',
      'San Jose De Macomitas',
      'Erin',
      'Esquina',
      'Mancopa',
      'Esquina Del Llano',
      'Mancopa Chico',
      'Pueblo Viejo',
      'El Potrerillo',
      'Bajastine',
      'Quebrachito',
      'Huasa Pampa Sur',
      'Lazarte',
      'Palominos',
      'La Reina',
      'Monteagudo',
      'Los Amaya',
      'Arroyo Atahona',
      'Los Perez',
      'El Sunchal',
      'Barrio San Jorge',
      'Las Corzuelas',
      'Mariño',
      'Tranquitas',
      'El Naranjo',
      'Las Talas',
      'Finca Tina',
      'Chilcas',
      'Pampa Pozo',
      'La Ruda',
      'Laguna De Robles',
      'El Castoral',
      'Pozo Grande',
      '7 De Abril',
      'Los Quemados',
      'San Antonio',
      'Vizcacheral',
      'Villa De Leales',
      'Las Talitas',
      'Villa Chicligasta',
      'Yacuchiri',
      'Arbol Solo',
      'Carbon Pozo',
      'Bajo Grande',
      'Ranchillos',
      'El Puesto',
      'Laguna Larga',
      'Amumpa',
      'Arboles Grandes',
      'Los Ruiz',
      'Barrancas',
      'La Loma',
      'Los Sauces',
      'Los Ranchillos',
      'Las Lomitas',
      'Dos Pozos',
      'Sol De Mayo',
      'Lamadrid',
      'Los Cercos',
      'Estacion La Encantada',
      'Villa Fiad - Ingenio Leales',
      'San Nicolas',
      'Pala Pala',
      'Los Sueldos',
      'Timbo Nuevo',
      'El Cadillal',
      'Timbo Viejo',
      'Alta Gracia',
      'Las Salinas',
      'Pampa Mayo',
      'El Oval',
      'Guemes',
      'San Agustin',
      'Colonia Mayo - Barrio La Milagrosa',
      'Finca Mayo',
      'Lolita',
      'Loma De Ciudacita',
      'Ciudacita',
      'Nueva Esperanza',
      'Taficillo',
      'La Reduccion',
      'San Rafael',
      'Lules',
      'El Ceibal',
      'Potrero Grande',
      'Tecotex',
      'Agua Salada',
      'Los Herrera',
      'Yalapa',
      'Los Britos',
      'Puesto Chico',
      'Los Diaz',
      'Carancho Pozo',
      'El Guardamonte',
      'Campo Azul',
      'Los Puestos',
      'La Encrucijada',
      'Molle Pozo',
      'Villa Belgrano',
      'Talamuyo',
      'San Miguel De Tucuman',
      'Pacara',
      'Banda Del Rio Sali',
      'Pacara Pintado',
      'Lastenia',
      'Los Rios',
      'Ingenio Santa Barbara',
      'El Tuscal',
      'Colonia Santa Barbara',
      'Aguilares',
      'Monte Redondo',
      'La Tipa',
      'Los Sarmientos',
      'Los Bulacios',
      'Rio Seco',
      'El Sacrificio',
      'La Invernada',
      'Alto Del Puesto',
      'El Nogal',
      'La Salvacion',
      'El Zapallar',
      'El Mistol',
      'La Chilca',
      'Pozo Verde',
      'La Iguana',
      'Los Mistoles',
      'Los Molles',
      'Ramos',
      'El Quebrachito',
      'Paez',
      'Pozo Hondo',
      'El Simbol',
      'Puesto Los Perez',
      'Villa Pujio',
      'El Puestito',
      'Taco Ralo',
      'El Corralito',
      'Yanimas',
      'Pilco',
      'Huasa Pampa',
      'Yonopongo',
      'Isla San Jose',
      'Pueblo Independencia',
      'Amberes',
      'Campo Volante',
      'Buena Vista Oeste',
      'Buena Vista',
      'La Lagunita',
      'Vipos',
      'Ex Ingenio Nueva Baviera',
      'El Cruce',
      'Kilometro102',
      'San Gabriel Del Monte',
      'Agua Blanca',
      'Cumbre El Matadero',
      'Santa Clara',
      'San Gabriel',
      'Barrio Casa Rosada',
      'Campo De Herrera',
      'Ingenio Fronterita',
      'Barrio Oeste',
      'Famailla',
      'Estacion Padilla',
      'Iltico',
      'Concepcion',
      'San Roque',
      'El Tajamar',
      'El Sinquial',
      'Taruca Pampa',
      'La Toma',
      'Villa Benjamin Araoz',
      'Rumi Punco',
      'Huacra',
      'Requelme',
      'El Puestito De Arriba',
      'El Obraje',
      'Pozo Cavado',
      'Tala Pampa',
      'San Pedro Martir',
      'Puesto Los Valdez',
      'San Antonio De Padua',
      'Capitan Caceres',
      'Yacuchina',
      'San Pedro De Colalao',
      'Rearte Sur',
      'Hualinchay',
      'Rearte',
      'Chulca',
      'Zarate',
      'San Fernando',
      'Zarate Sur',
      'Zarate Norte',
      'Gonzalo',
      'Choromoro',
      'Ticucho',
      'Alderetes',
      'Las Piedritas',
      'Los Gutierrez',
      'Barranqueras',
      'Campo Grande',
      'Chacras Viejas',
      'Toro Muerto',
      'Graneros',
      'Ichipuca',
      'Taco Rodeo',
    ],
  },
  AUS: {
    'AU-ACT': [],
    'AU-NSW': [
      'Aberdare',
      'Abermain',
      'Adaminaby',
      'Adelong',
      'Agnes Banks',
      'Anna Bay',
      'Ardlethan',
      'Ariah Park',
      'Ashford',
      'Austinmer',
      'Avoca Beach',
      'Ballina',
      'Balranald',
      'Bangalow',
      'Baradine',
      'Bargo',
      'Barham',
      'Barraba',
      'Batemans Bay',
      'Batlow',
      'Bega',
      'Bellbird',
      'Bellingen',
      'Berkeley Vale',
      'Bermagui',
      'Berridale',
      'Berrigan',
      'Berrima',
      'Berry',
      'Bilpin',
      'Binalong',
      'Bingara',
      'Binnaway',
      'Blackheath',
      'Blaxland',
      'Blayney',
      'Boggabilla',
      'Boggabri',
      'Bolwarra',
      'Bomaderry',
      'Bombala',
      'Bonalbo',
      'Bonnells Bay',
      'Bowenfels',
      'Bowraville',
      'Braidwood',
      'Branxton',
      'Brewarrina',
      'Brooklyn',
      'Brunswick Heads',
      'Bulahdelah',
      'Bullaburra',
      'Bulli',
      'Bundarra',
      'Bungendore',
      'Buronga',
      'Burradoo',
      'Canowindra',
      'Captains Flat',
      'Clarence Town',
      'Cobar',
      'Coledale',
      'Collarenebri',
      'Condobolin',
      'Coolamon',
      'Cooma',
      'Coonabarabran',
      'Coonamble',
      'Cooranbong',
      'Cootamundra',
      'Corowa',
      'Cowra',
      'Crescent Head',
      'Crookwell',
      'Cudal',
      'Cumnock',
      'Dapto',
      'Dareton',
      'Deepwater',
      'Delegate',
      'Delungra',
      'Deniliquin',
      'Denman',
      'Dorrigo',
      'Dunedoo',
      'Dungog',
      'Edgeworth',
      'Ellalong',
      'Emu Plains',
      'Eugowra',
      'Euston',
      'Evans Head',
      'Faulconbridge',
      'Fingal Head',
      'Forbes',
      'Forster',
      'Frederickton',
      'Galong',
      'Ganmain',
      'Gerringong',
      'Geurie',
      'Gilgandra',
      'Gillieston Heights',
      'Gladstone',
      'Glen Innes',
      'Glenbrook',
      'Gol Gol',
      'Gorokan',
      'Greenhill',
      'Greenwell Point',
      'Grenfell',
      'Greta',
      'Grose Vale',
      'Gulargambone',
      'Gundagai',
      'Gunnedah',
      'Gunning',
      'Guyra',
      'Harden',
      'Hawks Nest',
      'Hay',
      'Hazelbrook',
      'Heddon Greta',
      'Helensburgh',
      'Henty',
      'Hexham',
      'Hillston',
      'Holbrook',
      'Huskisson',
      'Inverell',
      'Ivanhoe',
      'Jennings',
      'Jerilderie',
      'Jindabyne',
      'Jugiong',
      'Junee',
      'Kandos',
      'Katoomba',
      'Kearsley',
      'Kempsey',
      'Kimovale',
      'Kinchela',
      'Kurrajong',
      'Kurri Kurri',
      'Kyogle',
      'Lake Cargelligo',
      'Lake Illawarra',
      'Lapstone',
      'Lawson',
      'Leura',
      'Lightning Ridge',
      'Macksville',
      'Mallanganee',
      'Manildra',
      'Manilla',
      'Marulan',
      'Mathoura',
      'Medlow Bath',
      'Mendooran',
      'Menindee',
      'Merimbula',
      'Millfield',
      'Milton',
      'Moama',
      'Molong',
      'Moree',
      'Moulamein',
      'Mount Riverview',
      'Mount Victoria',
      'Mudgee',
      'Murrumburrah',
      'Murwillumbah',
      'Muswellbrook',
      'Nabiac',
      'Nambucca Heads',
      'Narooma',
      'Narrandera',
      'Narromine',
      'Neath',
      'Nelson Bay',
      'Nimmitabel',
      'Noraville',
      'North Richmond',
      'Nowra',
      'Numbaa',
      'Nundle',
      'Nyngan',
      'Old Junee',
      'Ourimbah',
      'Oxley Vale',
      'Pallamallawa',
      'Pambula',
      'Parkes',
      'Paterson',
      'Paxton',
      'Peak Hill',
      'Picton',
      'Port Kembla',
      'Port Macquarie',
      'Raleigh',
      'Raymond Terrace',
      'Rylstone',
      'Scarborough',
      'Sidney',
      'Smithtown',
      'South Gundagai',
      'South West Rocks',
      'Springwood',
      'Stanwell Park',
      'Stuart Town',
      'Sussex Inlet',
      'Talbingo',
      'Tarcutta',
      'Taree',
      'Tea Gardens',
      'Tenterfield',
      'Terrigal',
      'The Oaks',
      'The Rock',
      'Thirlmere',
      'Thirroul',
      'Thurgoona',
      'Tingha',
      'Tomerong',
      'Tottenham',
      'Toukley',
      'Trangie',
      'Trundle',
      'Tullamore',
      'Tumbarumba',
      'Tumut',
      'Tuncurry',
      'Tuntable Creek',
      'Tweed Heads',
      'Ulladulla',
      'Ungarie',
      'Uralla',
      'Urana',
      'Uranquinty',
      'Urbenville',
      'Urunga',
      'Valley Heights',
      'Walcha',
      'Walgett',
      'Warialda',
      'Warrell Creek',
      'Warrimoo',
      'Waterfall',
      'Wellington',
      'Wentworth',
      'Wentworth Falls',
      'West Wallsend',
      'West Wyalong',
      'Weston',
      'Wilcannia',
      'Wingham',
      'Wombarra',
      'Woodburn',
      'Woodenbong',
      'Woodford',
      'Woodstock',
      'Wyalong',
      'Yass',
      'Yeoval',
      'Young',
    ],
    'AU-NT': [
      'Adelaide River',
      'Alice Springs',
      'Alpurrurulam',
      'Alyangula',
      'Amoonguna',
      'Angurugu',
      'Aputula',
      'Areyonga',
      'Atitjere',
      'Barrow Creek',
      'Barunga',
      'Batchelor',
      'Birdum',
      'Borroloola',
      'Bulman',
      'Daly River',
      'Daly Waters',
      'Elliott',
      'Fleming',
      'Gunbalanya',
      'Haasts Bluff',
      'Harts Range',
      'Hermannsburg',
      'Humpty Doo',
      'Imanpa',
      'Jabiru',
      'Kalkarindji',
      'Kaltukatjara',
      'Katherine',
      'Kintore',
      'Kulgera',
      'Lajamanu',
      'Larrimah',
      'Mandorah',
      'Maningrida',
      'Mataranka',
      'Milikapiti',
      'Minjilang',
      'Mutitjulu',
      'Newcastle Waters',
      'Nganmarriyanga',
      'Ngukurr',
      'Nhulunbuy',
      'Northern Territory v Mr Griffiths and Lorraine Jones',
      'Numbulwar',
      'Nyirripi',
      'Papunya',
      'Peppimenarti',
      'Pine Creek',
      'Renner Springs',
      'Roper Bar',
      'Rum Jungle',
      'Tennant Creek',
      'Ti Tree',
      'Timber Creek',
      'Titjikala',
      'Top Springs',
      'Wadeye',
      'Wallace Rockhole',
      'Warruwi',
      'Wurrumiyanga',
      'Yarralin',
      'Yirrkala',
      'Yuendumu',
      'Yulara',
    ],
    'AU-QLD': [
      'Adavale',
      'Allora',
      'Aramac',
      'Atherton',
      'Augathella',
      'Ayr',
      'Banana',
      'Barcaldine',
      'Beaudesert',
      'Bedourie',
      'Biloela',
      'Birdsville',
      'Blackall',
      'Blackbutt',
      'Blackwater',
      'Bogantungan',
      'Boonah',
      'Boulia',
      'Bowen',
      'Bray Park',
      'Brisbane',
      'Calliope',
      'Cambooya',
      'Camooweal',
      'Capella',
      'Cardwell',
      'Cashmere',
      'Charleville',
      'Childers',
      'Chillagoe',
      'Chinchilla',
      'Clermont',
      'Clifton',
      'Cloncurry',
      'Coen',
      'Collinsville',
      'Cooktown',
      'Crows Nest',
      'Cunnamulla',
      'Dalby',
      'Dirranbandi',
      'Duaringa',
      'Dysart',
      'Eidsvold',
      'Emerald',
      'Emu Park',
      'Esk',
      'Gatton',
      'Gayndah',
      'Georgetown',
      'Goombungee',
      'Goondiwindi',
      'Gordonvale',
      'Gracemere',
      'Grantham',
      'Greenvale',
      'Hebel',
      'Herberton',
      'Highfields',
      'Hughenden',
      'Ingham',
      'Inglewood',
      'Injune',
      'Innisfail',
      'Isisford',
      'Jimboomba',
      'Kilcoy',
      'Kilkivan',
      'Kingaroy',
      'Laidley',
      'Longreach',
      'Maleny',
      'Mareeba',
      'Marlborough',
      'Miles',
      'Mitchell',
      'Monto',
      'Mount Morgan',
      'Mount Samson',
      'Moura',
      'Mundubbera',
      'Murgon',
      'Muttaburra',
      'Nambour',
      'Nobby',
      'Normanton',
      'Oakey',
      'Proserpine',
      'Quilpie',
      'Rathdowney',
      'Richmond',
      'Rolleston',
      'Roma',
      'Rosewood',
      'Samford',
      'Samsonvale',
      'Sapphire',
      'Sarina',
      'Springsure',
      'St George',
      'Stanthorpe',
      'Strathpine',
      'Surat',
      'Tambo',
      'Taroom',
      'Texas',
      'Thargomindah',
      'Theodore',
      'Toowoomba',
      'Townsville',
      'Tully',
      'Wallangarra',
      'Warner',
      'Warwick',
      'Weipa',
      'Westwood',
      'Windorah',
      'Winton',
      'Yeppoon',
      'Yungaburra',
    ],
    'AU-SA': [
      'Adelaide',
      'Agery',
      'Alawoona',
      'Alford',
      'Allendale East',
      'American River',
      'Andamooka',
      'Andrews',
      'Angaston',
      'Angle Vale',
      'Appila',
      'Ardrossan',
      'Armagh',
      'Arno Bay',
      'Arthurton',
      'Auburn',
      'Avenue Range',
      'Bagot Well',
      'Baird Bay',
      'Balaklava',
      'Balgowan',
      'Balhannah',
      'Barabba',
      'Barmera',
      'Beachport',
      'Beltana',
      'Berri',
      'Bethany',
      'Binnum',
      'Birdwood',
      'Black Hill',
      'Black Point',
      'Blakiston',
      'Blanche Harbor',
      'Blanchetown',
      'Blinman',
      'Blyth',
      'Booborowie',
      'Booleroo Centre',
      'Border Village',
      'Bordertown',
      'Borrika',
      'Boston',
      'Bower',
      'Bowhill',
      'Bowmans',
      'Brentwood',
      'Brinkworth',
      'Bruce',
      'Brukunga',
      'Buckleboo',
      'Burra',
      'Burrungule',
      'Bute',
      'Butler',
      'Cadell',
      'Calca',
      'Callington',
      'Calomba',
      'Caloote',
      'Calperum Station',
      'Caltowie',
      'Cambrai',
      'Cape Jervis',
      'Carpenter Rocks',
      'Carrickalinga',
      'Carrieton',
      'Ceduna',
      'Charleston',
      'Cherry Gardens',
      'Cherryville',
      'Chowilla',
      'Clare',
      'Clarendon',
      'Clayton Bay',
      'Cleve',
      'Clinton',
      'Cobdogla',
      'Cockaleechie',
      'Cockatoo Valley',
      'Cockburn',
      'Coffin Bay',
      'Commissariat Point',
      'Coober Pedy',
      'Coobowie',
      'Cook',
      'Cooke Plains',
      'Cooltong',
      'Coomandook',
      'Coonalpyn',
      'Coonawarra',
      'Coorabie',
      'Copeville',
      'Copley',
      'Corny Point',
      'Coulta',
      'Cowell',
      'Cradock',
      'Crystal Brook',
      'Cudlee Creek',
      'Culburra',
      'Cultana',
      'Cummins',
      'Cungena',
      'Curramulka',
      'Currency Creek',
      'Danggali',
      'Darke Peak',
      'Davenport',
      'Dawesley',
      'Delamere',
      'Donovans',
      'Dowlingville',
      'Dublin',
      'Dutton',
      'Eden Valley',
      'Ediacara',
      'Edillilie',
      'Edithburgh',
      'Elliston',
      'Encounter Bay',
      'Ernabella',
      'Eudunda',
      'False Bay',
      'Farrell Flat',
      'Finniss',
      'Foul Bay',
      'Fowlers Bay',
      'Frances',
      'Freeling',
      'Fregon',
      'Furner',
      'Galga',
      'Gawler',
      'Geranium',
      'Giles Corner',
      'Glencoe',
      'Glendambo',
      'Gluepot',
      'Goolwa',
      'Greenock',
      'Greenways',
      'Gulnare',
      'Gumeracha',
      'Hahndorf',
      'Halbury',
      'Halidon',
      'Hallett',
      'Hamilton',
      'Hamley Bridge',
      'Hammond',
      'Harrogate',
      'Hartley',
      'Haslam',
      'Hatherleigh',
      'Hawker',
      'Hayborough',
      'Head of the Bight',
      'Hill River',
      'Hilltown',
      'Hincks',
      'Honiton',
      'Hoyleton',
      'Hynam',
      'Inman Valley',
      'Innamincka',
      'Inneston',
      'Iron Baron',
      'Iron Knob',
      'Island Beach',
      'Jabuk',
      'James Well',
      'Jamestown',
      'Jervois',
      'Kadina',
      'Kainton',
      'Kalangadoo',
      'Kanmantoo',
      'Kapunda',
      'Karkoo',
      'Karoonda',
      'Keith',
      'Kersbrook',
      'Keyneton',
      'Ki Ki',
      'Kielpa',
      'Kimba',
      'Kingoonya',
      'Kingscote',
      'Kingston SE',
      'Kingston-On-Murray',
      'Kongorong',
      'Koolunga',
      'Koppio',
      'Korunye',
      'Krondorf',
      'Kunytjanu',
      'Kyancutta',
      'Kybybolite',
      'Lake View',
      'Lameroo',
      'Langhorne Creek',
      'Laura',
      'Leigh Creek',
      'Lenswood',
      'Lewiston',
      'Light Pass',
      'Linwood',
      'Lipson',
      'Littlehampton',
      'Lobethal',
      'Lochiel',
      'Lock',
      'Long Plains',
      'Longwood',
      'Louth Bay',
      'Loveday',
      'Lower Light',
      'Loxton',
      'Loxton North',
      'Lucindale',
      'Lyndhurst',
      'Lyndoch',
      'Lyrup',
      'Macclesfield',
      'Maitland',
      'Mallala',
      'Mambray Creek',
      'Manna Hill',
      'Mannum',
      'Manoora',
      'Mantung',
      'Marama',
      'Marananga',
      'Marion Bay',
      'Marla',
      'Marrabel',
      'Marree',
      'McCracken',
      'Meadows',
      'Melrose',
      'Meningie',
      'Mercunda',
      'Merriton',
      'Middle Beach',
      'Middleback Range',
      'Middleton',
      'Mil Lel',
      'Milang',
      'Millicent',
      'Mindarie',
      'Minlaton',
      'Minnipa',
      'Mintabie',
      'Mintaro',
      'Miranda',
      'Moculta',
      'Monarto South',
      'Monash',
      'Moonta',
      'Moorak',
      'Moorlands',
      'Moorook',
      'Morchard',
      'Morgan',
      'Mount Barker',
      'Mount Bryan',
      'Mount Burr',
      'Mount Compass',
      'Mount Gambier',
      'Mount Pleasant',
      'Mount Torrens',
      'Mullaquana',
      'Mundallio',
      'Mundoora',
      'Murdinga',
      'Murray Bridge',
      'Murray Bridge East',
      'Murray Bridge South',
      'Murray Town',
      'Mylor',
      'Mypolonga',
      'Myponga',
      'Nackara',
      'Nain',
      'Nairne',
      'Nangwarry',
      'Nantawarra',
      'Naracoorte',
      'Narrung',
      'New Well',
      'Nildottie',
      'Ninnes',
      'Nonning',
      'Normanville',
      'Norton Summit',
      'Nullarbor',
      'Nundroo',
      'Nuriootpa',
      'OB Flat',
      'Oakbank',
      'Olary',
      'Olympic Dam',
      'Oodnadatta',
      'Orroroo',
      'Overland Corner',
      'Owen',
      'Padthaway',
      'Palmer',
      'Parachilna',
      'Paratoo',
      'Parham',
      'Parilla',
      'Paringa',
      'Parndana',
      'Parrakie',
      'Paruna',
      'Paskeville',
      'Peake',
      'Peebinga',
      'Penneshaw',
      'Penola',
      'Penrice',
      'Penwortham',
      'Perlubie',
      'Perponda',
      'Peterborough',
      'Piccadilly',
      'Pine Point',
      'Pinkerton Plains',
      'Pinnaroo',
      'Point Boston',
      'Point Lowly',
      'Point Mcleay',
      'Point Pass',
      'Point Pearce',
      'Point Souttar',
      'Point Sturt',
      'Point Turton',
      'Polda',
      'Poochera',
      'Port Arthur',
      'Port Augusta',
      'Port Augusta North',
      'Port Augusta West',
      'Port Broughton',
      'Port Elliot',
      'Port Flinders',
      'Port Gawler',
      'Port Germein',
      'Port Hughes',
      'Port Julia',
      'Port Kenny',
      'Port Lincoln',
      'Port MacDonnell',
      'Port Neill',
      'Port Paterson',
      'Port Pirie',
      'Port Pirie South',
      'Port Pirie West',
      'Port Victoria',
      'Port Vincent',
      'Port Wakefield',
      'Price',
      'Proof Range',
      'Punyelroo',
      'Qualco',
      'Quorn',
      'Ramco',
      'Rapid Bay',
      'Raukkan',
      'Redbanks',
      'Redhill',
      'Reeves Plains',
      'Rendelsham',
      'Renmark',
      'Renmark South',
      'Risdon Park',
      'Risdon Park South',
      'Riverton',
      'Robe',
      'Robertstown',
      'Rogues Point',
      'Roseworthy',
      'Rowland Flat',
      'Roxby Downs',
      'Rudall',
      'Saddleworth',
      'Saltia',
      'Sandalwood',
      'Sanderston',
      'Sandilands',
      'Sandy Creek',
      'Sapphiretown',
      'Seaford',
      'Second Valley',
      'Secret Rocks',
      'Sedan',
      'Seppeltsfield',
      'Shea-Oak Log',
      'Sherlock',
      'Smoky Bay',
      'Snowtown',
      'Solomontown',
      'South Kilkerran',
      'Southend',
      'Spalding',
      'Springton',
      'Stanley Flat',
      'Stansbury',
      'Stenhouse Bay',
      'Stirling',
      'Stirling North',
      'Stockport',
      'Stockwell',
      'Stone Hut',
      'Stone Well',
      'Strathalbyn',
      'Streaky Bay',
      'Sultana Point',
      'Summertown',
      'Sutherlands',
      'Swan Reach',
      'Tailem Bend',
      'Taldra',
      'Tantanoola',
      'Tanunda',
      'Taplan',
      'Tarcoola',
      'Tarcowie',
      'Tarlee',
      'Tarpeena',
      'Taylorville Station',
      'Templers',
      'Terowie',
      'Thevenard',
      'Thompson Beach',
      'Tickera',
      'Tiddy Widdy Beach',
      'Tintinara',
      'Tooligie',
      'Totness',
      'Trihi',
      'Truro',
      'Tumby Bay',
      'Tungkillo',
      'Two Wells',
      'Uleybury',
      'Ungarra',
      'Upper Sturt',
      'Uraidla',
      'Veitch',
      'Venus Bay',
      'Verdun',
      'Victor Harbor',
      'Virginia',
      'Waikerie',
      'Wallaroo',
      'Wami Kata',
      'Wanbi',
      'Wangary',
      'Wanilla',
      'Warnertown',
      'Warooka',
      'Warrachie',
      'Warramboo',
      'Warrow',
      'Wasleys',
      'Watervale',
      'Waukaringa',
      'Webb Beach',
      'Weetulta',
      'Wharminda',
      'Whites Flat',
      'Whyalla',
      'Whyalla Barson',
      'Whyalla Jenkins',
      'Whyalla Norrie',
      'Whyalla Playford',
      'Whyalla Stuart',
      'Whyte Yarcowie',
      'Williamstown',
      'Willunga',
      'Wilmington',
      'Windsor',
      'Winkie',
      'Winninowie',
      'Wirrabara',
      'Wirrulla',
      'Wistow',
      'Witchelina',
      'Wolseley',
      'Woodside',
      'Wool Bay',
      'Woolundunga',
      'Woomera',
      'Wudinna',
      'Wynarka',
      'Yacka',
      'Yahl',
      'Yalata',
      'Yallunda Flat',
      'Yaninee',
      'Yankalilla',
      'Yeelanna',
      'Yellabinna',
      'Yongala',
      'Yorketown',
      'Yumali',
      'Yunta',
    ],
    'AU-TAS': [
      'Abbotsham',
      'Abels Bay',
      'Aberdeen',
      'Acacia Hills',
      'Acton',
      'Acton Park',
      'Adventure Bay',
      'Akaroa',
      'Alberton',
      'Alcomie',
      'Allens Rivulet',
      'Alonnah',
      'Ambleside',
      'Andover',
      'Ansons Bay',
      'Antill Ponds',
      'Apollo Bay',
      'Apslawn',
      'Apsley',
      'Arthur River',
      'Arthurs Lake',
      'Austins Ferry',
      'Avoca',
      'Baden',
      'Badger Head',
      'Bagdad',
      'Bakers Beach',
      'Banca',
      'Bangor',
      'Barnes Bay',
      'Barretta',
      'Barrington',
      'Battery Point',
      'Beaconsfield',
      'Beaumaris',
      'Beauty Point',
      'Beechford',
      'Bell Bay',
      'Bellerive',
      'Bellingham',
      'Ben Lomond',
      'Berriedale',
      'Beulah',
      'Bicheno',
      'Binalong Bay',
      'Birchs Bay',
      'Birralee',
      'Bishopsbourne',
      'Black Hills',
      'Black River',
      'Blackmans Bay',
      'Blackstone Heights',
      'Blackwall',
      'Blackwood Creek',
      'Blessington',
      'Blue Rocks',
      'Blumont',
      'Boat Harbour',
      'Boat Harbour Beach',
      'Bonnet Hill',
      'Boobyalla',
      'Boomer Bay',
      'Bothwell',
      'Boyer',
      'Bracknell',
      'Bradys Lake',
      'Brandum',
      'Branxholm',
      'Breadalbane',
      'Bream Creek',
      'Breona',
      'Bridgenorth',
      'Bridgewater',
      'Bridport',
      'Brighton',
      'Brittons Swamp',
      'Broadmarsh',
      'Broadmeadows',
      'Bronte Park',
      'Brooks Bay',
      'Buckland',
      'Bungaree',
      'Burnie',
      'Burns Creek',
      'Bushy Park',
      'Butlers Gorge',
      'Calder',
      'Cambridge',
      'Camdale',
      'Camena',
      'Campania',
      'Campbell Town',
      'Cape Barren Island',
      'Cape Pillar',
      'Cape Portland',
      'Cape Raoul',
      'Carlton',
      'Carlton River',
      'Carrick',
      'Castle Forbes Bay',
      'Castra',
      'Caveside',
      'Central Plateau',
      'Cethana',
      'Chain of Lagoons',
      'Charlotte Cove',
      'Chasm Creek',
      'Chigwell',
      'Christmas Hills',
      'Chudleigh',
      'Claremont',
      'Clarence Point',
      'Clarendon Vale',
      'Claude Road',
      'Cleveland',
      'Clifton Beach',
      'Cluan',
      'Colebrook',
      'Coles Bay',
      'Collinsvale',
      'Conara',
      'Coningham',
      'Connellys Marsh',
      'Cooee',
      'Copping',
      'Corinna',
      'Cornwall',
      'Couta Rocks',
      'Cowrie Point',
      'Crabtree',
      'Cradle Mountain',
      'Cradoc',
      'Cramps Bay',
      'Cranbrook',
      'Crayfish Creek',
      'Cremorne',
      'Cressy',
      'Cuckoo',
      'Cuprona',
      'Currie',
      'Cygnet',
      'Dairy Plains',
      'Deddington',
      'Dee',
      'Deep Bay',
      'Deloraine',
      'Dennes Point',
      'Derby',
      'Derwent Bridge',
      'Derwent Park',
      'Detention',
      'Deviot',
      'Devon Hills',
      'Devonport',
      'Dilston',
      'Doctors Point',
      'Doctors Rocks',
      'Dodges Ferry',
      'Dolphin Sands',
      'Don',
      'Douglas River',
      'Douglas-Apsley',
      'Dover',
      'Downlands',
      'Dowsing Point',
      'Dromedary',
      'Dulcot',
      'Dunalley',
      'Dunorlan',
      'Dynnyrne',
      'Eaglehawk Neck',
      'East Cam',
      'East Devonport',
      'East Launceston',
      'East Ridgley',
      'Eddystone',
      'Edgcumbe Beach',
      'Edith Creek',
      'Egg Lagoon',
      'Eggs and Bacon Bay',
      'Elderslie',
      'Electrona',
      'Elizabeth Town',
      'Ellendale',
      'Emita',
      'Emu Heights',
      'Epping Forest',
      'Erriba',
      'Eugenana',
      'Evandale',
      'Exeter',
      'Exton',
      'Falmouth',
      'Fentonbury',
      'Fern Tree',
      'Fingal',
      'Fitzgerald',
      'Flintstone',
      'Florentine',
      'Flowerdale',
      'Flowerpot',
      'Flowery Gully',
      'Forcett',
      'Forest',
      'Forester',
      'Fortescue',
      'Forth',
      'Forthside',
      'Four Mile Creek',
      'Frankford',
      'Franklin',
      'Freycinet',
      'Friendly Beaches',
      'Gagebrook',
      'Garden Island Creek',
      'Gardners Bay',
      'Geeveston',
      'Geilston Bay',
      'George Town',
      'Glaziers Bay',
      'Glebe',
      'Glen Huon',
      'Glendevie',
      'Glenfern',
      'Glengarry',
      'Glenlusk',
      'Glenora',
      'Glenorchy',
      'Golconda',
      'Golden Valley',
      'Goodwood',
      'Gordon',
      'Gormanston',
      'Goshen',
      'Goulds Country',
      'Gowrie Park',
      'Granton',
      'Granville Harbour',
      'Grasstree Hill',
      'Grassy',
      'Gravelly Beach',
      'Gray',
      'Great Bay',
      'Greens Beach',
      'Gretna',
      'Grindelwald',
      'Grove',
      'Guildford',
      'Gunns Plains',
      'Hadspen',
      'Hagley',
      'Hampshire',
      'Harford',
      'Hastings',
      'Havenview',
      'Hawley Beach',
      'Hayes',
      'Hellyer',
      'Henrietta',
      'Herdsmans Cove',
      'Hermitage',
      'Herrick',
      'Heybridge',
      'Highclere',
      'Highcroft',
      'Hillcrest',
      'Hillwood',
      'Hobart',
      'Hollow Tree',
      'Holwell',
      'Honeywood',
      'Howden',
      'Howrah',
      'Howth',
      'Huntingfield',
      'Huonville',
      'Ida Bay',
      'Interlaken',
      'Invermay',
      'Irishtown',
      'Jackeys Marsh',
      'Jericho',
      'Jetsonville',
      'Judbury',
      'Kamona',
      'Kaoota',
      'Karanja',
      'Karoola',
      'Kayena',
      'Kellevie',
      'Kelso',
      'Kempton',
      'Kettering',
      'Killiecrankie',
      'Killora',
      'Kimberley',
      'Kindred',
      'Kings Meadows',
      'Kingston',
      'Kingston Beach',
      'Koonya',
      'Lachlan',
      'Lackrana',
      'Lady Barron',
      'Lake Leake',
      'Lake Margaret',
      'Lake Sorell',
      'Lake St Clair',
      'Lalla',
      'Lanena',
      'Lapoinya',
      'Latrobe',
      'Lauderdale',
      'Launceston',
      'Lawitta',
      'Lebrina',
      'Leeka',
      'Lefroy',
      'Legana',
      'Legerwood',
      'Leith',
      'Lemont',
      'Lenah Valley',
      'Leslie Vale',
      'Levendale',
      'Lewisham',
      'Liawenee',
      'Liena',
      'Lietinna',
      'Liffey',
      'Lileah',
      'Lillico',
      'Lilydale',
      'Lindisfarne',
      'Lisle',
      'Little Pine Lagoon',
      'Little Swanport',
      'Loccota',
      'Loira',
      'London Lakes',
      'Long Reach',
      'Longford',
      'Longley',
      'Lonnavale',
      'Loongana',
      'Loorana',
      'Lorinna',
      'Lottah',
      'Low Head',
      'Lower Barrington',
      'Lower Beulah',
      'Lower Longley',
      'Lower Marshes',
      'Lower Snug',
      'Lower Turners Marsh',
      'Lower Wattle Grove',
      'Lower Wilmot',
      'Loyetea',
      'Lucaston',
      'Lughrata',
      'Luina',
      'Lulworth',
      'Lunawanna',
      'Lune River',
      'Lutana',
      'Lymington',
      'Lymwood',
      'Macquarie Heads',
      'Macquarie Plains',
      'Magra',
      'Malbina',
      'Mangalore',
      'Mangana',
      'Margate',
      'Maria Island',
      'Marrawah',
      'Mathinna',
      'Mawbanna',
      'Mayberry',
      'Maydena',
      'Mayfield',
      'Meadowbank',
      'Meander',
      'Mella',
      'Melton Mowbray',
      'Memana',
      'Mengha',
      'Mersey Forest',
      'Merseylea',
      'Meunna',
      'Miandetta',
      'Middlesex',
      'Midway Point',
      'Miena',
      'Milabena',
      'Millers Bluff',
      'Moina',
      'Mole Creek',
      'Molesworth',
      'Moltema',
      'Montagu',
      'Montagu Bay',
      'Montana',
      'Montello',
      'Montrose',
      'Montumana',
      'Moogara',
      'Moonah',
      'Mooreville',
      'Moorina',
      'Moorleah',
      'Morass Bay',
      'Moriarty',
      'Mornington',
      'Mount Direction',
      'Mount Field',
      'Mount Hicks',
      'Mount Lloyd',
      'Mount Nelson',
      'Mount Roland',
      'Mount Rumney',
      'Mount Seymour',
      'Mount Stuart',
      'Mount William',
      'Mountain River',
      'Mowbray',
      'Murdunna',
      'Musselroe Bay',
      'Myalla',
      'Myrtle Bank',
      'Nabageena',
      'Nabowla',
      'Naracoopa',
      'National Park',
      'Natone',
      'Needles',
      'Neika',
      'New Norfolk',
      'New Town',
      'Newnham',
      'Newstead',
      'Nicholls Rivulet',
      'Nietta',
      'Nile',
      'Nook',
      'North Bruny',
      'North Hobart',
      'North Lilydale',
      'North Motton',
      'North Scottsdale',
      'Northdown',
      'Norwood',
      'Notley Hills',
      'Nowhere Else',
      'Nubeena',
      'Nugara',
      'Nugent',
      'Nunamara',
      'Oakdowns',
      'Oaks',
      'Oatlands',
      'Ocean Vista',
      'Old Beach',
      'Oldina',
      'Oonah',
      'Opossum Bay',
      'Orford',
      'Orielton',
      'Osmaston',
      'Osterley',
      'Otago',
      'Ouse',
      'Oyster Cove',
      'Palana',
      'Paloona',
      'Paradise',
      'Parattah',
      'Park Grove',
      'Parkham',
      'Parklands',
      'Parrawe',
      'Patersonia',
      'Pawleena',
      'Pawtella',
      'Pearshape',
      'Pegarah',
      'Pelham',
      'Pelverata',
      'Penguin',
      'Penna',
      'Perth',
      'Petcheys Bay',
      'Pioneer',
      'Pipers Brook',
      'Pipers River',
      'Plenty',
      'Poatina',
      'Police Point',
      'Pontville',
      'Pontypool',
      'Port Huon',
      'Port Latta',
      'Port Sorell',
      'Powranna',
      'Premaydena',
      'Preolenna',
      'Preservation Bay',
      'Preston',
      'Primrose Sands',
      'Promised Land',
      'Prospect',
      'Prospect Vale',
      'Punchbowl',
      'Pyengana',
      'Quamby Bend',
      'Quamby Brook',
      'Queens Domain',
      'Queenstown',
      'Quoiba',
      'Railton',
      'Raminea',
      'Randalls Bay',
      'Ranelagh',
      'Ranga',
      'Ravenswood',
      'Recherche',
      'Red Hills',
      'Redpa',
      'Reedy Marsh',
      'Reekara',
      'Relbia',
      'Renison Bell',
      'Retreat',
      'Reynolds Neck',
      'Rheban',
      'Rhyndaston',
      'Riana',
      'Ridgeway',
      'Ridgley',
      'Ringarooma',
      'Risdon',
      'Risdon Vale',
      'Riverside',
      'Robigana',
      'Rocherlea',
      'Roches Beach',
      'Rocky Cape',
      'Rocky Hills',
      'Roger River',
      'Rokeby',
      'Roland',
      'Romaine',
      'Rose Bay',
      'Rosebery',
      'Rosegarland',
      'Rosetta',
      'Rosevale',
      'Rosevears',
      'Rosny',
      'Rosny Park',
      'Ross',
      'Rossarden',
      'Round Hill',
      'Rowella',
      'Royal George',
      'Runnymede',
      'Rushy Lagoon',
      'Saltwater River',
      'Sandfly',
      'Sandford',
      'Sandy Bay',
      'Sassafras',
      'Savage River',
      'Scamander',
      'Schouten Island',
      'Scopus',
      'Scotchtown',
      'Scottsdale',
      'Sea Elephant',
      'Selbourne',
      'Seven Mile Beach',
      'Seymour',
      'Shannon',
      'Shearwater',
      'Sheffield',
      'Shorewell Park',
      'Sidmouth',
      'Simpsons Bay',
      'Sisters Beach',
      'Sisters Creek',
      'Sloping Main',
      'Smithton',
      'Snug',
      'Somerset',
      'Sorell',
      'Sorell Creek',
      'South Arm',
      'South Bruny',
      'South Burnie',
      'South Forest',
      'South Hobart',
      'South Launceston',
      'South Mount Cameron',
      'South Nietta',
      'South Preston',
      'South Riana',
      'South Spreyton',
      'South Springfield',
      'Southport',
      'Southport Lagoon',
      'Southwest',
      'Spalford',
      'Sprent',
      'Spreyton',
      'Spring Beach',
      'Springfield',
      'Squeaking Point',
      'St Helens',
      'St Leonards',
      'St Marys',
      'Stanley',
      'Staverton',
      'Steppes',
      'Stieglitz',
      'Stonehenge',
      'Stonor',
      'Stony Head',
      'Stony Rise',
      'Stoodley',
      'Stormlea',
      'Stowport',
      'Strahan',
      'Strathblane',
      'Strathgordon',
      'Strickland',
      'Strzelecki',
      'Styx',
      'Sulphur Creek',
      'Summerhill',
      'Sunnyside',
      'Surges Bay',
      'Surprise Bay',
      'Surveyors Bay',
      'Swan Bay',
      'Swan Point',
      'Swansea',
      'Swanston',
      'Table Cape',
      'Takone',
      'Talawa',
      'Taranna',
      'Targa',
      'Tarleton',
      'Taroona',
      'Tarraleah',
      'Tayene',
      'Tea Tree',
      'Telita',
      'Temma',
      'Tewkesbury',
      'The Gardens',
      'Thirlstane',
      'Three Hummock Island',
      'Tiberias',
      'Tinderbox',
      'Tods Corner',
      'Togari',
      'Toiberry',
      'Tolmans Hill',
      'Tomahawk',
      'Tonganah',
      'Tooms Lake',
      'Tranmere',
      'Travellers Rest',
      'Trenah',
      'Trevallyn',
      'Triabunna',
      'Trial Harbour',
      'Trowutta',
      'Tugrah',
      'Tulendeena',
      'Tullah',
      'Tunbridge',
      'Tunnack',
      'Tunnel',
      'Turners Beach',
      'Turners Marsh',
      'Tyenna',
      'Ulverstone',
      'Underwood',
      'Upper Blessington',
      'Upper Burnie',
      'Upper Castra',
      'Upper Esk',
      'Upper Natone',
      'Upper Scamander',
      'Upper Stowport',
      'Upper Woodstock',
      'Uxbridge',
      'Verona Sands',
      'Victoria Valley',
      'Waddamana',
      'Walls of Jerusalem',
      'Waratah',
      'Warrane',
      'Warrentinna',
      'Waterhouse',
      'Waterloo',
      'Wattle Grove',
      'Wattle Hill',
      'Waverley',
      'Wayatinah',
      'Weegena',
      'Weetah',
      'Weldborough',
      'Wellington Park',
      'Wesley Vale',
      'West Coast',
      'West Hobart',
      'West Kentish',
      'West Launceston',
      'West Montagu',
      'West Moonah',
      'West Pine',
      'West Ridgley',
      'West Scottsdale',
      'West Takone',
      'West Ulverstone',
      'Westbury',
      'Western Creek',
      'Western Junction',
      'Westerway',
      'Weymouth',
      'White Beach',
      'White Hills',
      'Whitefoord',
      'Whitemark',
      'Whitemore',
      'Wickham',
      'Wilburville',
      'Wilmot',
      'Wiltshire',
      'Windermere',
      'Wingaroo',
      'Winkleigh',
      'Winnaleah',
      'Wivenhoe',
      'Woodbridge',
      'Woodbury',
      'Woodsdale',
      'Woolnorth',
      'Wyena',
      'Wynyard',
      'Yambacoona',
      'Yarra Creek',
      'Yolla',
      'York Plains',
      'York Town',
      'Youngtown',
      'Zeehan',
    ],
    'AU-VIC': [
      'Acheron',
      'Addington',
      'Adjie',
      'Adzar',
      'Aire',
      'Albacutya',
      'Alberton East',
      'Alberton West',
      'Alexandra',
      'Allambee',
      'Allambee East',
      'Amherst',
      'Amphitheatre',
      'Anakie',
      'Angahook',
      'Angora',
      'Annuello',
      'Annya',
      'Apsley *Arapiles',
      'Ararat',
      'Arcadia',
      'Archdale',
      'Ardno',
      'Ardonachie',
      'Areegra',
      'Argyle',
      'Ascot',
      'Ashens',
      'Audley',
      'Avenel',
      'Awonga',
      'Axedale',
      'Baangal',
      'Baawang',
      'Babatchio',
      'Bael Bael',
      'Bagshot',
      'Bahgallah',
      'Bailieston',
      'Bairnsdale',
      'Ballaarat',
      'Ballangeich',
      'Ballapur',
      'Ballarat',
      'Ballark',
      'Ballendella',
      'Balliang',
      'Balloong',
      'Ballyrogan',
      'Balmattum',
      'Balmoral',
      'Balnarring',
      'Balrook',
      'Balrootan',
      'Bamawm',
      'Bambadin',
      'Bambra',
      'Bamganie',
      'Banangal',
      'Bangerang',
      'Banu Bonyit',
      'Banyarmbite',
      'Banyena',
      'Banyenong',
      'Barambogie',
      'Baranduda',
      'Barga',
      'Baring',
      'Baringhup',
      'Barkly',
      'Barmah',
      'Barnawartha North',
      'Barnawartha South',
      'Barnoolut',
      'Barongarook',
      'Barp',
      'Barrakee',
      'Barramunga',
      'Barrarbool',
      'Barroworn',
      'Barwidgee',
      'Barwite',
      'Barwo',
      'Barwon Downs',
      'Barwongemoong',
      'Batchica',
      'Batyik',
      'Baulkamaugh',
      'Baw Baw',
      'Baynton',
      'Bealiba',
      'Beaufort',
      'Beckworth',
      'Beear',
      'Beechworth',
      'Beek Beek',
      'Beenak',
      'Beerik',
      'Beethang',
      'Beewar',
      'Bellarine',
      'Bellaura',
      'Bellellen',
      'Beloka',
      'Belvoir West',
      'Bemboka',
      'Bemm',
      'Benalla',
      'Benambra',
      'Benayeo',
      'Bendock',
      'Bengworden',
      'Bengworden West',
      'Benjeroop',
      'Beolite',
      'Bepcha',
      'Beremboke',
      'Berontha',
      'Berrimal',
      'Berringa',
      'Berringama',
      'Berriwillock',
      'Berrmarr',
      'Berwick',
      'Bessiebelle',
      'Bet Bet',
      'Bete Bolong North',
      'Bete Bolong South',
      'Betka',
      'Beyal',
      'Bidwell',
      'Bil-Bil-Wyt',
      'Billabong',
      'Billian',
      'Billiminah',
      'Bilpah',
      'Bimbourie',
      'Bindi',
      'Binginwarri',
      'Bingo-Munjie',
      'Bingo-Munjie North',
      'Bingo-Munjie South',
      'Binnican',
      'Binnuc',
      'Birregun',
      'Birregurra',
      'Bitchigal',
      'Bitterang',
      'Bittern',
      'Blackwood',
      'Bochara',
      'Boga',
      'Bogalara',
      'Bogalara part in the County of Follett',
      'Bogong North',
      'Bogong South',
      'Boho',
      'Boigbeat',
      'Boikerbert',
      'Boinka',
      'Bolaira',
      'Bolangum',
      'Bolerch',
      'Bolga',
      'Bollinda',
      'Bonang',
      'Bondi',
      'Bonegilla',
      'Bonn',
      'Bontherambo',
      'Boodyarn',
      'Boola Boloke',
      'Boola Boola',
      'Boole Poole',
      'Boolungal',
      'Boomahnoomoonah',
      'Boonahwah',
      'Boonderoot',
      'Booran',
      'Boorgunyah',
      'Boorhaman',
      'Boorolite',
      'Boorong',
      'Boorongie',
      'Booroopki',
      'Boorpool',
      'Boorpuk',
      'Boort',
      'Boosey',
      'Bootahpool',
      'Boramboram',
      'Boreang East',
      'Boreang West',
      'Borhoneyghurk',
      'Borodomanin',
      'Boroka',
      'Boroondara',
      'Borriyalloak',
      'Borung',
      'Boulka',
      'Bourka',
      'Bow-Worrung',
      'Boweya',
      'Bradford',
      'Bralak',
      'Bramburra',
      'Branjee',
      'Brankeet',
      'Branxholme',
      'Brenanah',
      'Brewster',
      'Briagolong',
      'Bright',
      'Brim Brim',
      'Brimboal',
      'Brimbonga',
      'Brimin',
      'Brindat',
      'Bringalbart',
      'Brit Brit',
      'Broadford',
      'Broadlands',
      'Broadwater',
      'Brockie',
      'Bruarong',
      'Brucknell',
      'Bruk Bruk',
      'Bruthen',
      'Buangor',
      'Buchan',
      'Buckenderra',
      'Buckeran Yarrack',
      'Buckrabanyule',
      'Budgee Budgee',
      'Budgeree',
      'Budgerum East',
      'Budgerum West',
      'Bulart',
      'Bulban',
      'Bulga',
      'Bulgaback',
      'Bulgana',
      'Bulla Bulla',
      'Bullamalk',
      'Bullanbul',
      'Bullarook',
      'Bullarto',
      'Bullawin',
      'Bulleen',
      'Bullengarook',
      'Bullioh',
      'Bullumwaal',
      'Bullung',
      'Bumbang',
      'Bumberrah',
      'Bundalaguah',
      'Bundalong',
      'Bundara-Munjie',
      'Bundowra',
      'Bung Bong',
      'Bungal',
      'Bungalally',
      'Bungamero',
      'Bunganail',
      'Bungeeltap',
      'Bungeet',
      'Bungil',
      'Bungil East',
      'Bunguluke',
      'Bungywarr',
      'Buninyong',
      'Bunnugal',
      'Bunurouk',
      'Bunyip',
      'Buragwonduc',
      'Burgoyne',
      'Burke',
      'Burnell',
      'Burnewang',
      'Burr',
      'Burrah Burrah',
      'Burramboot',
      'Burramboot East',
      'Burramine',
      'Burrong North',
      'Burrong South',
      'Burrowye',
      'Burrum Burrum',
      'Burrumbeep',
      'Burrumbeet',
      'Burrungabugge',
      'Burtwarrah',
      'Burupga',
      'Butgalla',
      'Buttlejorrk',
      'Buxton',
      'Byaduk',
      'Byambynee',
      'Byanga',
      'Byawatha',
      'Byjuke',
      'Bylands',
      'Caarneek',
      'Cabanandra',
      'Calivil',
      'Callawadda',
      'Callignee',
      'Cambacanya',
      'Cambatong',
      'Campaspe',
      'Campbelltown',
      'Canabore',
      'Caniambo',
      'Cannie',
      'Cannum',
      'Cantala',
      'Carag Carag',
      'Caralulup',
      'Caramballuc North',
      'Caramballuc South',
      'Caramut',
      'Caramut South',
      'Carapooee',
      'Carapooee West',
      'Carapook',
      'Carapugna',
      'Carboor',
      'Carchap',
      'Cardigan',
      'Cargerie',
      'Carina',
      'Carisbrook',
      'Carlyle',
      'Carneek',
      'Carngham',
      'Carool',
      'Carori',
      'Carpendeit',
      'Carrah',
      'Carrajung',
      'Carrak',
      'Carraragarmungee',
      'Carron',
      'Carrung-e-murnong',
      'Carruno',
      'Carwarp',
      'Casterton',
      'Castle Donnington',
      'Castlemaine',
      'Catiabrim',
      'Cavendish',
      'Changue',
      'Charam',
      'Charlton East',
      'Charlton West',
      'Chatsworth',
      'Chatsworth West',
      'Chepstowe',
      'Cherrington',
      'Chewton',
      'Chillingollah',
      'Chilpin',
      'Chiltern',
      'Chiltern West',
      'Chinangin',
      'Chintin',
      'Chiprick',
      'Clarkesdale',
      'Clonleigh',
      'Clunes',
      'Cobaw',
      'Cobbannah',
      'Cobboboonee',
      'Cobon',
      'Cobra Killuc',
      'Cobram',
      'Cobungra',
      'Cocamba',
      'Cocomah',
      'Cocoroc',
      'Codrington',
      'Cohuna',
      'Coimadai',
      'Colac',
      'Colac Colac',
      'Colbinabbin',
      'Coleraine',
      'Coliban',
      'Colignan',
      'Colongulac',
      'Colquhoun',
      'Colquhoun East',
      'Colquhoun North',
      'Colvinsby',
      'Combienbar',
      'Commeralghip',
      'Concongella',
      'Concongella South',
      'Condah',
      'Conewarre',
      'Conga Wonga',
      'Congupna',
      'Connangorach',
      'Connewarren',
      'Connewirrecoo',
      'Cooack',
      'Cooaggalah',
      'Cooirejong',
      'Coolebarghurk',
      'Coolumbooka',
      'Coolungoolun',
      'Coolungubra',
      'Coomboona',
      'Coongulla',
      'Coongulmerang',
      'Coonimur',
      'Coonooer East',
      'Coonooer West',
      'Coopracambra',
      'Cooramook',
      'Coornburt',
      'Coornmill',
      'Cooroopajerrup',
      'Corack',
      'Corack East',
      'Coradjil',
      'Corangamite',
      'Corea',
      'Corindhap',
      'Corinella',
      'Corio',
      'Cornella',
      'Corop',
      'Corryong',
      'Cowa',
      'Coynallan',
      'Craigie',
      'Cranbourne',
      'Creswick',
      'Cronomby',
      'Crookayan',
      'Crosbie',
      'Crowlands',
      'Croxton East',
      'Croxton West',
      'Cudgewa',
      'Cundare',
      'Curlip',
      'Curracurt',
      'Currawa',
      'Curtayne',
      'Curyo',
      'Cut Paw Paw',
      'Daahl',
      'Dahwedarre',
      'Dalyenong',
      'Dandenong',
      'Danyo',
      'Darbalang',
      'Dargalong',
      'Dargile',
      'Dargo',
      'Darkbonee',
      'Darlingford',
      'Darlington',
      'Darlington West',
      'Darnum',
      'Darragan',
      'Darraweit Guim',
      'Darriman',
      'Darriwil',
      'Dartagook',
      'Dartella',
      'Dartmoor',
      'Dattuck',
      'Daytrap',
      'Dean',
      'Deddick',
      'Dederang',
      'Delatite',
      'Dellicknora',
      'Denison',
      'Dennying',
      'Dereel',
      'Dering',
      'Derndang',
      'Derril',
      'Derrimut',
      'Detarka',
      'Deutgam',
      'Devenish',
      'Devon',
      'Dewrang',
      'Dewry',
      'Digby',
      'Diggorra',
      'Dimboola',
      'Dimboola part in the County of Borung',
      'Ding-a-ding',
      'Dingee',
      'Dinyarrak',
      'Djerriwarrh',
      'Doboobetic',
      'Doledrook',
      'Dollin',
      'Dollin part in the County of Borung',
      'Donald',
      'Dondangadale',
      'Doodwuk',
      'Dooen',
      'Dookie',
      'Doolam',
      'Doomburrim',
      'Dopewora',
      'Dorchap',
      'Doroq',
      'Doutta Galla',
      'Dowling Forest',
      'Drajurk',
      'Dreeite',
      'Drik Drik',
      'Dropmore',
      'Drouin East',
      'Drouin West',
      'Drumanure',
      'Drumborg',
      'Drumdlemara',
      'Drummond',
      'Drung Drung',
      'Duchembegarra',
      'Duddo',
      'Dueran',
      'Dueran East',
      'Dulungalong',
      'Dumbalk',
      'Dunbulbalane',
      'Duneed',
      'Dunkeld',
      'Dunmore',
      'Dunmunkle',
      'Dunnawalla',
      'Dunneworthy',
      'Dunolly',
      'Durdidwarrah',
      'Durndal',
      'Durong',
      'Echuca North',
      'Echuca South',
      'Ecklin',
      'Eddington',
      'Edenhope',
      'Edgecombe',
      'Edi',
      'Egerton',
      'Eglinton',
      'Eildon',
      'Eilyar',
      'El Dorado',
      'Elingamite',
      'Ellerslie',
      'Ellesmere',
      'Elliminyt',
      'Ellinging',
      'Elmore',
      'Elphinstone',
      'Emberton',
      'Enano',
      'Enfield',
      "Enoch's Point",
      'Ensay',
      'Enuc',
      'Eppalock',
      'Ercildoun',
      'Errinundra',
      'Estcourt',
      'Ettrick',
      'Eucambene',
      'Eumana',
      'Eumemmerring',
      'Eumeralla',
      'Eurambeen',
      'Eurandelong',
      'Eureka',
      'Euroa',
      'Eversley',
      'Everton',
      'Faraday',
      'Flinders',
      'Forest Hill',
      'Framlingham East',
      'Framlingham West',
      'Frankston',
      'Freeburgh',
      'French Island',
      'Fryers',
      'Fumina',
      'Gaalanungah',
      'Gabo',
      'Galaquil',
      'Galbarmuck',
      'Galla',
      'Gama',
      'Gampola',
      'Gannawarra',
      'Ganoo Ganoo',
      'Garratanbunell',
      'Garvoc',
      'Gatum Gatum',
      'Gayfield',
      'Geelengla',
      'Geera',
      'Geerak',
      'Gelantipy East',
      'Gelantipy West',
      'Gellibrand',
      'Gembrook',
      'Gerang Gerung',
      'Gerangamete',
      'Gherang Gherang',
      'Gherineghap',
      'Ghin Ghin',
      'Gibbo',
      'Giffard',
      'Gillingal',
      'Gillum',
      'Gingimrick',
      'Girgarre',
      'Girgarre East',
      'Gisborne',
      'Glenaladale',
      'Glenalbyn',
      'Glenaroua',
      'Glenaulin',
      'Glenburnie',
      'Glencoe South',
      'Glendale',
      'Glendaruel',
      'Glendhu',
      'Glenelg',
      'Glengower',
      'Glenhope',
      'Glenlogie',
      'Glenloth',
      'Glenlyon',
      'Glenmaggie',
      'Glenmona',
      'Glenmore',
      'Glenormiston',
      'Glenpatrick',
      'Glenrowen',
      'Glenwatts',
      'Glynwylln',
      'Gnarkeet',
      'Gnarwarre',
      'Gnarwee',
      'Gobarup',
      'Gobur',
      'Goldie',
      'Golton Golton',
      'Gonzaga',
      'Goolengook',
      'Goomalibee',
      'Goon Nure',
      'Goongerah',
      'Gooramadda',
      'Goorambat',
      'Gooramgooramgong',
      'Goornong',
      'Gorae',
      'Goroke',
      'Gorong',
      'Gorrinn',
      'Gorrockburkghap',
      'Gorya',
      'Goulburn',
      'Gowangardie',
      'Gowar',
      'Goyura',
      'Gracedale',
      'Graham',
      'Granya',
      'Grassdale',
      'Gre Gre',
      'Gredgwin',
      'Greenhills',
      'Greensborough',
      'Gringegalgona',
      'Gritjurk',
      'Gruyere',
      'Gunamalary',
      'Gunbower',
      'Gunbower West',
      'Gundowring',
      'Gungarlan',
      'Gunyah Gunyah',
      'Gutchu',
      'Guttamurra',
      'Gymbowen',
      'Haddon',
      'Harcourt',
      'Harrietville',
      'Harrow',
      'Havelock',
      'Hawkestone',
      'Hayanmi',
      'Hazelwood',
      'Heathcote',
      'Helendoite',
      'Hesse',
      'Hexham East',
      'Hexham West',
      'Heywood',
      'Hilgray',
      'Hindmarsh',
      'Hinno-Munjie',
      'Holcombe',
      'Holden',
      'Holey Plains',
      'Homerton',
      'Horsham',
      'Hotham',
      'Hotspur',
      'Howqua',
      'Howqua West',
      'Huntly',
      'Illawarra',
      'Indi',
      'Ingeegoobee',
      'Irrewarra',
      'Irrewillipe',
      'Jallakin',
      'Jallukar',
      'Jalur',
      'Jamieson',
      'Jan Juc',
      'Jancourt',
      'Janiember East',
      'Janiember West',
      'Jarklan',
      'Jeeralang',
      'Jeetho',
      'Jeetho West',
      'Jeffcott',
      'Jellalabad',
      'Jemba',
      'Jennawarra',
      'Jeparit',
      'Jerrywarook',
      'Jeruk',
      'Jika Jika',
      'Jil Jil',
      'Jilpanger',
      'Jilwain',
      'Jinderboine',
      'Jindivick',
      'Jingallala',
      'Jinjellic',
      'Jirnkee',
      'Jirrah',
      'Joel Joel',
      'Joop',
      'Jumbuk',
      'Jumbunna',
      'Jumbunna East',
      'Jung Jung',
      'Jungkum',
      'Kaanglang',
      'Kaarimba',
      'Kadnook',
      'Kaerwut',
      'Kaladbro',
      'Kalingur',
      'Kalk Kalk',
      'Kalkallo',
      'Kalkee',
      'Kallery',
      'Kalpienung',
      'Kalymna',
      'Kamarooka',
      'Kanawalla',
      'Kanawinka',
      'Kancobin',
      'Kaneira',
      'Kangderaar',
      'Kangerong',
      'Kangertong',
      'Kaniva',
      'Kanyapella',
      'Kapong',
      'Karabeal',
      'Karawah',
      'Kariah',
      'Karlo',
      'Karnak',
      'Karngun',
      'Karrabumet',
      'Karramomus',
      'Karup Karup',
      'Karyrie',
      'Katamatite',
      'Katandra',
      'Kattyoong',
      'Katunga',
      'Katyil',
      'Kay',
      'Keelangie',
      'Keelbundora',
      'Keilambete',
      'Kelfeera',
      'Kellalac',
      'Kenmare',
      'Kentbruck',
      'Kerang',
      'Kergunyah',
      'Kergunyah North',
      'Kerrie',
      'Kerrisdale',
      'Kerrit Bareet',
      'Kevington',
      'Kewell East',
      'Kewell West',
      'Kia',
      'Kialla',
      'Kianeek',
      'Kiata',
      'Killara',
      'Killawarra',
      'Killingworth',
      'Kilnoorat',
      'Kimbolton',
      'Kinabulla',
      'Kinglake',
      'Kingower',
      'Kinimakatka',
      'Kinkella',
      'Kinypanial',
      'Kiora',
      'Kirkella',
      'Kirkenong',
      'Kirrak',
      'Knaawing',
      'Knockwood',
      'Knowsley',
      'Knowsley East',
      'Kobyboyn',
      'Koetong',
      'Koimbo',
      'Kolara',
      'Konardin',
      'Kongbool',
      'Kongwak',
      'Konnepra',
      'Konong Wootong',
      'Koo Wee Rup',
      'Koo Wee Rup East',
      'Kooem',
      'Koola',
      'Koolomert',
      'Koomberar',
      'Koonik Koonik',
      'Koonika',
      'Kooragan',
      'Koorangie',
      'Kooreh',
      'Koorkahb',
      'Kooroc',
      'Koorool',
      'Koorooman',
      'Kooroon',
      'Kooroop',
      'Koort-koort-nong',
      'Korkuperrimul',
      'Kornong',
      'Koro-Ganeit',
      'Koroit',
      'Korong',
      'Kororoit',
      'Korrak Korrak',
      'Korumburra',
      'Korweinguboora',
      'Kosciusko',
      'Kotupna',
      'Kout Narin',
      'Kowat',
      'Koyuga',
      'Krambruk',
      'Kuark',
      'Kulk',
      'Kulkyne',
      'Kulwin',
      'Kunat Kunat',
      'Kurac-a-ruc',
      'Kurdgweechee',
      'Kurnbrunin',
      'Kurraca',
      'Kurrambee',
      'Kurting',
      'Kyabram',
      'Kyabram East',
      'Kybeyan',
      'La Trobe',
      'Laanecoorie',
      'Laang',
      'Laceby',
      'Laen',
      'Lah-arum',
      'Lake Lake Wollard',
      'Lal Lal',
      'Lalbert',
      'Lalkaldarno',
      'Lallat',
      'Lambruk',
      'Lancefield',
      'Landsborough',
      'Lang Lang',
      'Lang Lang East',
      'Langi Logan',
      'Langi-Gharin',
      'Langi-kal-kal',
      'Langkoop',
      'Langley',
      'Langulac',
      'Langwarrin',
      'Lara',
      'Larneebunyah',
      'Larundel',
      'Lascelles',
      'Lauraville',
      'Lauriston',
      'Lawaluk',
      'Lawloit',
      'Leaghur',
      'Ledcourt',
      'Leeor',
      'Leichardt',
      'Leongatha',
      'Lexington',
      'Lexton',
      'Lianiduck',
      'Licola',
      'Ligar',
      'Lillicur',
      'Lillimur',
      'Lilliput',
      'Lillirie',
      'Lima',
      'Linlithgow',
      'Linton',
      'Liparoo',
      'Lismore',
      'Livingstone',
      'Lockwood',
      'Loddon',
      'Lodge Park',
      'Longerenong',
      'Longwarry',
      'Loomat',
      'Loongelaat',
      'Lorne',
      'Lorquon',
      'Lowan',
      'Loy Yang',
      'Loyola',
      'Ludrik-Munjie',
      'Lurg',
      'Lyell',
      'Lynchfield',
      'Lyngaller',
      'Macarthur',
      'Macedon',
      'Macorna',
      'Maffra',
      'Mageppa',
      'Magorra',
      'Maharatta',
      'Mahkwallok',
      'Maindample',
      'Maintongoon',
      'Malakoff',
      'Malanganee',
      'Maldon',
      'Malkara',
      'Mallacoota',
      'Mambourin',
      'Mamengoroock',
      'Manangatang',
      'Manango',
      'Mandurang',
      'Maneroo',
      'Mannibadar',
      'Manpy',
      'Mansfield',
      'Maramingo',
      'Mardan',
      'Margooya',
      'Maribyrnong',
      'Marida Yallock',
      'Marlbed',
      'Marlooh',
      'Marma',
      'Marmal',
      'Marnoo',
      'Marong',
      'Marraweeny',
      'Marroo',
      'Maryborough',
      'Maryvale',
      'Matlock',
      'Matong',
      'Matong North',
      'Meatian',
      'Meeniyan',
      'Meerai',
      'Meereek',
      'Meering',
      'Meering West',
      'Meerlieu',
      'Melbourne North',
      'Melbourne South',
      'Mellick-Munjie',
      'Mellier',
      'Menaak',
      'Mepunga',
      'Meran',
      'Merbein',
      'Meredith',
      'Merino',
      'Merriang',
      'Merrijig',
      'Merrimu',
      'Merrymbuela',
      'Merton',
      'Metcalfe',
      'Mickleham',
      'Miepoll',
      'Mildura',
      'Mildura shared with Karkarooc',
      'Millewa',
      'Milloo',
      'Minapre',
      'Mincha',
      'Mincha West',
      'Mindai',
      'Minhamite',
      'Minimay',
      'Minimera',
      'Minjah',
      'Minjah North',
      'Minto',
      'Miowera',
      'Mirampiram',
      'Mirboo',
      'Mirboo North',
      'Mirimbah',
      'Mirkoo',
      'Mirnee',
      'Mirranatwa',
      'Mitiamo',
      'Mitta Mitta',
      'Mittyack',
      'Mittyan',
      'Moah',
      'Moallaack',
      'Mocamboro',
      'Mockinya',
      'Mockinya part in the County of Borung',
      'Modewarre',
      'Moe',
      'Moglonemby',
      'Mohican',
      'Moira',
      'Mokanger',
      'Mokepilly',
      'Mokoan',
      'Moliagul',
      'Molka',
      'Mologa',
      'Monbulk',
      'Monda',
      'Monea North',
      'Monea South',
      'Monegeetta',
      'Monivae',
      'Monomak',
      'Moodarra',
      'Moolap',
      'Moolerr',
      'Moolort',
      'Moolpah',
      'Moomowroong',
      'Moonip',
      'Moonkan',
      'Moora',
      'Moorabbin',
      'Mooradoranook',
      'Mooralla',
      'Moorarbool East',
      'Moorarbool West',
      'Moorbanool',
      'Mooree',
      'Moorl Moorl',
      'Moormurng',
      'Moornapa',
      'Moorngag',
      'Moorooduc',
      'Mooroolbark',
      'Mooroopna',
      'Mooroopna West',
      'Moorpanyal',
      'Moortworra',
      'Moorwinstowe',
      'Moranding',
      'Morang',
      'Moranghurk',
      'Moray',
      'Mordialloc',
      'Morea',
      'Moreep',
      'Morekana',
      'Morockdong',
      'Moroka',
      'Mortat',
      'Mortchup',
      'Mortlake',
      'Mostyn',
      'Mount Cole',
      'Mournpoul',
      'Moutajup',
      'Mouyong',
      'Mouzie',
      'Mowamba',
      'Moyangul',
      'Moyhu',
      'Moyreisk',
      'Moyston',
      'Moyston West',
      'Muckleford',
      'Mudgeegonga',
      'Mulcra',
      'Mulgrave',
      'Mullagong',
      'Mullawye',
      'Mullindolingong',
      'Mullroo',
      'Mullungdung',
      'Mumbannar',
      'Mumbel',
      'Mundoona',
      'Muntham',
      'Murchison',
      'Murchison North',
      'Murdeduke',
      'Murgheboluc',
      'Murmungee',
      'Murndal',
      'Murnungin',
      'Murrabit',
      'Murrabit West',
      'Murramurrangbong',
      'Murrandarra',
      'Murrawong',
      'Murrindal East',
      'Murrindal West',
      'Murrindindi',
      'Murroon',
      'Murrungowar',
      'Murtcaim',
      'Muryrtym',
      'Muskerry',
      'Myall',
      'Myamyn',
      'Myaring',
      'Myrniong',
      'Myrrhee',
      'Myrtleford',
      'Mysia',
      'Nagwarry',
      'Nalangil',
      'Nanapundah',
      'Nandemarriman',
      'Nangana',
      'Nangeela',
      'Nanimia',
      'Nanneella',
      'Nap-nap-marra',
      'Napier',
      'Nappa',
      'Nar Nar Goon',
      'Nar-be-thong',
      'Narbourac',
      'Nareeb Nareeb',
      'Nariel',
      'Naringaningalook',
      'Naringhil North',
      'Naringhil South',
      'Narioka',
      'Narmbool',
      'Narracan',
      'Narracan South',
      'Narrang',
      'Narraport',
      'Narrawaturk',
      'Narrawong',
      'Narre Warren',
      'Narrewillock',
      'Narrobuk',
      'Narrobuk North',
      'Nateyip',
      'Natimuk',
      'Natte Murrang',
      'Natteyallock',
      'Natya',
      'Navarre',
      'Nayook',
      'Nayook West',
      'Neereman',
      'Neerim',
      'Neerim East',
      'Neilborough',
      'Nekeeya',
      'Nenandie',
      'Nepean',
      'Nerran',
      'Nerrena',
      'Nerrin Nerrin',
      'Nerring',
      'Neuarpur',
      'Newham',
      'Newlingrook',
      'Newmerella',
      'Ni Ni',
      'Niagaroon',
      'Nillahcootie',
      'Nillumbik',
      'Nindoo',
      'Ninnie',
      'Ninveunook',
      'Nirranda',
      'Nolan',
      'Noojee',
      'Noojee East',
      'Noonga',
      'Noorilim',
      'Noorinbee',
      'Noorongong',
      'Norong',
      'North Hamilton',
      'Northwood',
      'Nowa Nowa',
      'Nowa Nowa South',
      'Nowie',
      'Nowingi',
      'Nowyeo',
      'Noyong',
      'Nulkwyne',
      'Nullan',
      'Nullawil',
      'Nullwarre',
      'Numbie-Munjie',
      'Numbruk',
      'Nunawading',
      'Nungal',
      'Nungatta',
      'Nuntin',
      'Nurcoung',
      'Nurnurnemal',
      'Nurong',
      'Nurrabiel',
      'Nyallo',
      'Nyang',
      'Nypo',
      'Nyrraby',
      'Olangolah',
      'Omeo',
      'Ondit',
      'Onyim',
      'Orbost',
      'Orbost East',
      'Otway',
      'Ouyen',
      'Oxley',
      'Paaratte',
      'Paignie',
      'Painswick',
      'Pakenham',
      'Pallarang',
      'Palpara',
      'Panbulla',
      'Panitya',
      'Panmure',
      'Pannoobamawm',
      'Pannoomilloo',
      'Panyule',
      'Panyyabyr',
      'Paraparap',
      'Parbine',
      'Parrie Yalloak',
      'Parupa',
      'Parwan',
      'Patchewollock',
      'Patho',
      'Pawbymbyr',
      'Paywit',
      'Peechelba',
      'Peechember',
      'Pelluebla',
      'Pendyk Pendyk',
      'Pengana',
      'Pental Island',
      'Perenna',
      'Perrit Perrit',
      'Phillip Island',
      'Piangil',
      'Piangil West',
      'Picola',
      'Pier-Millan',
      'Pigick',
      'Pine Lodge',
      'Pines',
      'Pinnak',
      'Pinnibar',
      'Pircarra',
      'Piro',
      'Pirron Yaloak',
      'Poliah North',
      'Poliah South',
      'Polisbet',
      'Pom Pom',
      'Pomborneit',
      'Pompapeil',
      'Pomponderoo',
      'Poorneet',
      'Poowong',
      'Poowong East',
      'Porepunkah',
      'Port Fairy',
      'Portland',
      'Powlett',
      'Prahran',
      'Pranjip',
      'Propodollah',
      'Puckapunyal',
      'Puebla',
      'Pullut',
      'Purdeet',
      'Purdeet East',
      'Purgagoolah',
      'Purnim',
      'Purrumbete North',
      'Purrumbete South',
      'Pyalong',
      'Pywheitjorrk',
      'Quag-Munjie',
      'Quambatook',
      'Quamby',
      'Quamby North',
      'Quantong',
      'Raak',
      'Raglan',
      'Raglan West',
      'Rainbow',
      'Rathscar',
      'Redbank',
      'Redcastle',
      'Redesdale',
      'Redruth',
      'Riachella',
      'Rich Avon East',
      'Rich Avon West',
      'Rochester',
      'Rochester West',
      'Rochford',
      'Rodborough',
      'Rosedale',
      'Roseneath',
      'Rothesay',
      'Ruffy',
      'Rupanyup',
      'Sale',
      'Salisbury',
      'Salisbury West',
      'Samaria',
      'Sandhurst',
      'Sandon',
      'Sargood',
      'Sarsfield',
      'Scarsdale',
      'Seacombe',
      'Sedgwick',
      'Shadforth',
      'Shelbourne',
      'Shelford',
      'Shelford West',
      'Shepparton',
      'Sherwood',
      'Shirley',
      'Skipton',
      'Smeaton',
      'Smythesdale',
      'Snake Island',
      'South Hamilton',
      'Spinifex',
      'Spring Hill',
      'Springplains',
      'St Arnaud',
      'St James',
      'St Margaret',
      'St.Clair',
      'St.Helens',
      'Stawell',
      'Steavenson',
      'Stewarton',
      'Stradbroke',
      'Strangeways',
      'Stratford',
      'Strathbogie',
      'Strathfieldsaye',
      'Strathmerton',
      'Streatham',
      'Struan',
      'Sunday Island',
      'Sutton',
      'Sutton Grange',
      'Swanwater',
      'Switzerland',
      'Taaraak',
      'Tabbara',
      'Tabberabbera',
      'Tabilk',
      'Taggerty',
      'Tahara',
      'Talambe',
      'Talgarno',
      'Talgitcha',
      'Tallageira',
      'Tallandoon',
      'Tallang',
      'Tallangallook',
      'Tallangatta',
      'Tallangoork',
      'Tallarook',
      'Tallygaroopna',
      'Tamboon',
      'Tamboritha',
      'Taminick',
      'Tamleugh',
      'Tandarook',
      'Tandarra',
      'Tangambalanga',
      'Tanjil',
      'Tanjil East',
      'Taponga',
      'Tara',
      'Tarcombe',
      'Taripta',
      'Tarkeeth',
      'Tarldarn',
      'Tarnagulla',
      'Tarneit',
      'Tarra Tarra',
      'Tarragal',
      'Tarranginnie',
      'Tarranyurk',
      'Tarrawarra',
      'Tarrawarra North',
      'Tarrawingee',
      'Tarrayoukyan',
      'Tarrengower',
      'Tarwin',
      'Tarwin South',
      'Tatong',
      'Tatonga',
      'Tatyoon',
      'Tawanga',
      'Tchirree',
      'Tchuterr',
      'Teddywaddy',
      'Telangatuk',
      'Telbit',
      'Terang',
      'Terlite-Munjie',
      'Terrappee',
      'Terrick Terrick East',
      'Terrick Terrick West',
      'Terrinallum',
      'Thalia',
      'Thanni',
      'Tharanbegga',
      'Theddora',
      'Thologolong',
      'Thorkidaan',
      'Thornley',
      'Thornton',
      'Thowgla',
      'Thurra',
      'Tiega',
      'Tildesley East',
      'Tildesley West',
      'Timbarra',
      'Timberoo',
      'Timboon',
      'Timmering',
      'Tinamba',
      'Tingaringy',
      'Tintaldra',
      'Tittybong',
      'Toltol',
      'Tong Bong',
      'Tongala',
      'Tongaro',
      'Tonghi',
      'Tongio-Munjie East',
      'Tongio-Munjie West',
      'Tonimbuk',
      'Tonimbuk East',
      'Too-rour',
      'Tooan',
      'Toolamba',
      'Toolamba West',
      'Toolang',
      'Tooliorook',
      'Toolka',
      'Toolleen',
      'Toolome',
      'Toolondo',
      'Toolongrook',
      'Tooloy',
      'Toombon',
      'Toombullup',
      'Toombullup North',
      'Toonambool',
      'Toongabbie North',
      'Toongabbie South',
      'Toonginbooka',
      'Toonyarak',
      'Toora',
      'Toorak',
      'Toorongo',
      'Toorourrong',
      'Toort',
      'Torbreck',
      'Torrumbarry',
      'Torrumbarry North',
      'Tottington',
      'Toupnein',
      'Tourello',
      'Towamba',
      'Towan',
      'Towaninny',
      'Towanway',
      'Towma',
      'Towong',
      'Traawool',
      'Tragowel',
      'Traralgon',
      'Trawalla',
      'Trentham',
      'Trewalla',
      'Trinnta',
      'Truganina',
      'Tubbut',
      'Tullamarine',
      'Tullich',
      'Tullyvea',
      'Tungie',
      'Turandurey',
      'Turkeeth',
      'Turoar',
      'Tutegong',
      'Tutye',
      'Tyabb',
      'Tyalla',
      'Tyamoonya',
      'Tyar',
      'Tyirra',
      'Tylden',
      'Tyntynder',
      'Tyntynder North',
      'Tyntynder West',
      'Tyrendarra',
      'Tyrrell',
      'Ultima',
      'Ulupna',
      'Undera',
      'Underbool',
      'Undowah',
      'Upotipotpon',
      'Urangara',
      'Vectis East',
      'Vite Vite',
      'Wa-de-lock',
      'Waaia',
      'Waanyarra',
      'Waarre',
      'Wabba',
      'Wabdallah',
      'Wabonga',
      'Wabonga South',
      'Wagant',
      'Waggarandall',
      'Wagra',
      'Wahring',
      'Waitchie',
      'Wakool',
      'Walhalla',
      'Walhalla East',
      'Walla Walla',
      'Wallaby',
      'Wallagoot',
      'Wallaloo',
      'Wallan Wallan',
      'Walle',
      'Wallinduc',
      'Wallowa',
      'Wallup',
      'Walmer',
      'Walpamunda',
      'Walpeup',
      'Walwa',
      'Wamba',
      'Wanalta',
      'Wandiligong',
      'Wandin Yallock',
      'Wando',
      'Wandown',
      'Wangarabell',
      'Wangaratta North',
      'Wangaratta South',
      'Wangerrip',
      'Wangie',
      'Wangoom',
      'Wangry',
      'Wannaeue',
      'Wanurp',
      'Wanwandyra',
      'Wanwin',
      'Wappan',
      'Waranga',
      'Waratah North',
      'Warburton',
      'Wareek',
      'Warina',
      'Warmur',
      'Warngar',
      'Warra Warra',
      'Warrabkook',
      'Warracbarunah',
      'Warracknabeal',
      'Warragamba',
      'Warragul',
      'Warrain',
      'Warrak',
      'Warrambat',
      'Warrambine',
      'Warrandyte',
      'Warranook',
      'Warraquil',
      'Warrayure',
      'Warren',
      'Warrenbayne',
      'Warrenheip',
      'Warrenmang',
      'Warrion',
      'Warrock',
      'Warrong',
      'Wartook',
      'Warung',
      'Wat Wat',
      'Wataepoolan',
      'Watchegatcheca',
      'Watchem',
      'Watchupga',
      'Wategat',
      'Watgania',
      'Watgania West',
      'Wathe',
      'Watta Wella',
      'Wau Wauka',
      'Wau Wauka West',
      'Waygara',
      'Wedderburne',
      'Weeaproinah',
      'Weecurra',
      'Weeragua',
      'Weerangourt',
      'Weering',
      'Wehla',
      'Wellsford',
      'Welshpool',
      'Welumla',
      'Wemen',
      'Wennga',
      'Wensleydale',
      'Wermatong',
      'Werrap',
      'Werribee',
      'Werrigar',
      'Werrikoo',
      'Wewin',
      'Whanregarwen',
      'Wharparilla',
      'Whirily',
      'Whirrakee',
      'Whitfield',
      'Whitfield South',
      'Whoorel',
      'Whorouly',
      'Whroo',
      'Wiall',
      'Wibenduck',
      'Wickliffe North',
      'Wickliffe South',
      'Wilgul North',
      'Wilgul South',
      'Wilhelmina',
      'Wilkin',
      'Wilkur',
      'Will Will Rook',
      'Willam',
      'Willangie',
      'Willatook',
      'Willaura',
      'Willenabrina',
      'Wills',
      'Willung',
      'Windarra',
      'Windham',
      'Wing Wing',
      'Wingan',
      'Wingeel',
      'Winiam',
      'Winjallok',
      'Winnambool',
      'Winnindoo',
      'Winteriga',
      'Winyar',
      'Winyayung',
      'Wirchilleba',
      'Wiridjil',
      'Wirmbirchip',
      'Wirmbool',
      'Wirrate',
      'Wirrbibial',
      'Witchipool',
      'Woatwoara',
      'Wodonga',
      'Wollert',
      'Wollonaby',
      'Wombat',
      'Wombelano',
      'Wondoomarook',
      'Wonga Wonga',
      'Wonga Wonga South',
      'Wongan',
      'Wongarra',
      'Wongungarra',
      'Wonnangatta',
      'Wonthaggi',
      'Wonthaggi North',
      'Wonwondah',
      'Wonwron',
      'Wonyip',
      'Woodbourne',
      'Woodend',
      'Woodnaggerak',
      'Woohlpooer',
      'Wookurkook',
      'Woolamai',
      'Woolenook',
      'Woolsthorpe',
      'Woolwoola',
      'Woongulmerang East',
      'Woongulmerang West',
      'Woorak',
      'Woorarra',
      'Woori Yallock',
      'Woorinen',
      'Wooriwyrite',
      'Woornack',
      'Woorndoo',
      'Woornyalook',
      'Wooronok',
      'Woorragee',
      'Woorragee North',
      'Woosang',
      'Wooundellah',
      'Wooyoot',
      'Woraigworm',
      'Woranga',
      'Wormangal',
      'Wormbete',
      'Worooa',
      'Worrough',
      'Worrowing',
      'Wortongie',
      'Wrathung',
      'Wrixon',
      'Wuk Wuk',
      'Wull Wullock',
      'Wurdi-Youang',
      'Wurrin',
      'Wurrook',
      'Wurruk Wurruk',
      'Wurutwun',
      'Wy-Yung',
      'Wyangil',
      'Wycheproof',
      'Wychitella',
      'Wyeeboo',
      'Wyelangta',
      'Wymlet',
      'Wyperfeld',
      'Wytwalan',
      'Wytwarrone',
      'Wyuna',
      'Yaapeet',
      'Yabba',
      'Yabba Yabba',
      'Yackandandah',
      'Yalca',
      'Yalimba',
      'Yalimba East',
      'Yalla-y-poora',
      'Yallakar',
      'Yallock',
      'Yallook',
      'Yallum',
      'Yalmy',
      'Yaloak',
      'Yalong',
      'Yalong South',
      'Yambuk',
      'Yambulla',
      'Yan Yan Gourt',
      'Yanac-a-yanac',
      'Yanakie',
      'Yanakie South',
      'Yandoit',
      'Yangardook',
      'Yangerahwill',
      'Yangery',
      'Yangoura',
      'Yanipy',
      'Yannathan',
      'Yarak',
      'Yarck',
      'Yarima',
      'Yarpturk',
      'Yarraberb',
      'Yarragon',
      'Yarram',
      'Yarramyljup',
      'Yarrangook',
      'Yarrawonga',
      'Yarrock',
      'Yarrowalla',
      'Yarrowee',
      'Yarroweyah',
      'Yarrum',
      'Yarryne',
      'Yat Nat',
      'Yatchew East',
      'Yatchew West',
      'Yatmerone',
      'Yaugher',
      'Yea',
      'Yearinga',
      'Yeerik',
      'Yeerung',
      'YeerungBairnsdale',
      'Yehrip',
      'Yellangip',
      'Yelta',
      'Yelwell',
      'Yeo',
      'Yering',
      'Yertoo',
      'Yeth-youang',
      'Yeungroon',
      'Yielima',
      'Yinnar',
      'Yonduk',
      'Youanmite',
      'Youarang',
      'Youarrabuk',
      'Youpayang',
      'Youpella',
      'Yowang',
      'Yulecart',
      'Yungiera',
      'Yuonga',
      'Yuppeckiar',
      'Yuroke',
      'Zenobia',
    ],
    'AU-WA': [
      'Agnew',
      'Ajana',
      'Albany',
      'Aldersyde',
      'Allanson',
      'Amelup',
      'Amery',
      'Ardath',
      'Arrino',
      'Arrowsmith',
      'Augusta',
      'Australind',
      'Baandee',
      'Babakin',
      'Badgebup',
      'Badgingarra',
      'Badjaling',
      'Bailup',
      'Bakers Hill',
      'Baldivis',
      'Balgo',
      'Balingup',
      'Balkuling',
      'Balladonia',
      'Ballidu',
      'Bardi',
      'Barragup',
      'Beacon',
      'Beermullah',
      'Bejoording',
      'Belka',
      'Bencubbin',
      'Bendering',
      'Benger',
      'Benjaberring',
      'Beverley',
      'Bilbarin',
      'Bindi Bindi',
      'Bindoon',
      'Binningup',
      'Binnu',
      'Bodallin',
      'Boddington',
      'Bolgart',
      'Bonnie Rock',
      'Bonnie Vale',
      'Boranup',
      'Borden',
      'Bornholm',
      'Boscabel',
      'Bow Bridge',
      'Boxwood Hill',
      'Boyanup',
      'Boyup Brook',
      'Bremer Bay',
      'Bridgetown',
      'Brookton',
      'Broome',
      'Broomehill',
      'Bruce Rock',
      'Brunswick Junction',
      'Bullabulling',
      'Bullaring',
      'Bullfinch',
      'Bullsbrook',
      'Bulong',
      'Bunbury',
      'Bungulla',
      'Bunjil',
      'Buntine',
      'Burakin',
      'Burekup',
      'Burracoppin',
      'Busselton',
      'Byford',
      'Cadoux',
      'Caiguna',
      'Calingiri',
      'Camballin',
      'Cape Burney',
      'Capel',
      'Carbunup River',
      'Carcoola',
      'Carnamah',
      'Carnarvon',
      'Carrabin',
      'Cataby',
      'Cervantes',
      'Chidlow',
      'Chittering',
      'Clackline',
      'Cocklebiddy',
      'Collie',
      'Condingup',
      'Congelin',
      'Cookernup',
      'Coolgardie',
      'Coolup',
      'Coomberdale',
      'Coorow',
      'Coral Bay',
      'Corrigin',
      'Cowaramup',
      'Cowcowing',
      'Crossman',
      'Cuballing',
      'Cue',
      'Cunderdin',
      'Dalwallinu',
      'Dalyup',
      'Dampier',
      'Dandaragan',
      'Dangin',
      'Dardanup',
      'Darkan',
      'Davyhurst',
      'Day Dawn',
      'Deanmill',
      'Denham',
      'Denmark',
      'Dinninup',
      'Dongara',
      'Donnelly River',
      'Donnybrook',
      'Doodlakine',
      'Dowerin',
      'Drummond Cove',
      'Dudinin',
      'Dumbleyung',
      'Dunsborough',
      'Duranillin',
      'Dwarda',
      'Dwellingup',
      'Ejanding',
      'Elgin',
      'Elleker',
      'Eneabba',
      'Eradu',
      'Erikin',
      'Esperance',
      'Eucla',
      'Exmouth',
      'Ferguson',
      'Fitzroy Crossing',
      'Forrest',
      'Frankland',
      'Gabbin',
      'Gairdner',
      'Gascoyne Junction',
      'Geraldton',
      'Gibson',
      'Gidgegannup',
      'Gingin',
      'Gnarabup',
      'Gnowangerup',
      'Goomalling',
      'Gracetown',
      'Grass Patch',
      'Grass Valley',
      'Green Head',
      'Greenbushes',
      'Greenough',
      'Guilderton',
      'Gutha',
      'Halls Creek',
      'Hamel',
      'Hamelin Pool',
      'Harrismith',
      'Harvey',
      'Herron',
      'Hester',
      'Highbury',
      'Hines Hill',
      'Holt Rock',
      'Hopetoun',
      'Horrocks',
      'Howatharra',
      'Hyden',
      'Ilkurlka',
      'Israelite Bay',
      'Isseka',
      'Jardee',
      'Jarrahdale',
      'Jarrahwood',
      'Jennacubbine',
      'Jennapullin',
      'Jerdacuttup',
      'Jerramungup',
      'Jigalong Community',
      'Jitarning',
      'Jurien Bay',
      'Kalannie',
      'Kalbarri',
      'Kalgan',
      'Kalgoorlie',
      'Kambalda',
      'Karlgarin',
      'Karratha',
      'Karridale',
      'Katanning',
      'Kellerberrin',
      'Kendenup',
      'Keysbrook',
      'King River',
      'Kirup',
      'Kiwirrkurra',
      'Kojarena',
      'Kojonup',
      'Kondinin',
      'Kondut',
      'Koojan',
      'Koolyanobbing',
      'Koorda',
      'Korrelocking',
      'Kukerin',
      'Kulin',
      'Kulja',
      'Kumarina',
      'Kunjin',
      'Kununoppin',
      'Kununurra',
      'Kweda',
      'Kwelkan',
      'Kwolyin',
      'Lake Brown',
      'Lake Clifton',
      'Lake Grace',
      'Lake King',
      'Lancelin',
      'Latham',
      'Laverton',
      'Learmonth',
      'Ledge Point',
      'Leeman',
      'Leinster',
      'Leonora',
      'Little Grove',
      'Lower King',
      'Ludlow',
      'Lynton',
      'Madura',
      'Mandurah',
      'Manjimup',
      'Manmanning',
      'Manypeaks',
      'Marble Bar',
      'Marchagee',
      'Margaret River',
      'Marradong',
      'Marvel Loch',
      'Maya',
      'Mayanup',
      'Meckering',
      'Meekatharra',
      'Menzies',
      'Merkanooka',
      'Merredin',
      'Metricup',
      'Miling',
      'Mingenew',
      'Minnenooka',
      'Mogumber',
      'Monkey Mia',
      'Mooliabeenie',
      'Moonyoonooka',
      'Moorine Rock',
      'Morawa',
      'Moulyinning',
      'Mount Kokeby',
      'Mount Magnet',
      'Muchea',
      'Mukinbudin',
      'Mullalyup',
      'Mullewa',
      'Mundijong',
      'Mundrabilla',
      'Munglinup',
      'Muntadgin',
      'Muradup',
      'Myalup',
      'Nabawa',
      'Nangeenan',
      'Nangetty',
      'Nannup',
      'Nanson',
      'Narembeen',
      'Narrikup',
      'Narrogin',
      'New Norcia',
      'Newdegate',
      'Newman',
      'Nornalup',
      'Norseman',
      'North Bannister',
      'North Dandalup',
      'North Yunderup',
      'Northam',
      'Northampton',
      'Northcliffe',
      'Nullagine',
      'Nungarin',
      'Nyabing',
      'Oakajee',
      'Ocean Beach',
      'Ongerup',
      'Onslow',
      'Oombulgurri',
      'Ora Banda',
      'Osmington',
      'Palgarup',
      'Pannawonica',
      'Pantapin',
      'Paraburdoo',
      'Paynes Find',
      'Pemberton',
      'Perenjori',
      'Piawaning',
      'Piesseville',
      'Pindar',
      'Pingaring',
      'Pingelly',
      'Pingrup',
      'Pinjarra',
      'Pintharuka',
      'Pithara',
      'Point Samson',
      'Popanyinning',
      'Porongurup',
      'Port Denison',
      'Port Gregory',
      'Port Hedland',
      'Port Kennedy',
      'Preston Beach',
      'Prevelly',
      'Quairading',
      'Quindalup',
      'Quindanning',
      'Ranford',
      'Ravensthorpe',
      'Rawlinna',
      'Redcliffe',
      'Redmond',
      'Reedy',
      'Regans Ford',
      'Rocky Gully',
      'Roebourne',
      'Roelands',
      'Rosa Brook',
      'Salmon Gums',
      'Sandstone',
      'Scaddan',
      'Schotts',
      'Seabird',
      'Secret Harbour',
      'Serpentine',
      'Shackleton',
      'South Hedland',
      'South Kumminin',
      'South Yunderup',
      'Southern Cross',
      'Stratham',
      'Tambellup',
      'Tammin',
      'Tardun',
      'Telfer',
      'Tenindewa',
      'Tenterden',
      'The Lakes',
      'Three Springs',
      'Tincurrin',
      'Tom Price',
      'Toodyay',
      'Torbay',
      'Trayning',
      'Tuckanarra',
      'Tunney',
      'Useless Loop',
      'Varley',
      'Vasse',
      'Vivien',
      'Wagerup',
      'Wagin',
      'Walebing',
      'Walgoolan',
      'Walkaway',
      'Walpole',
      'Wandering',
      'Wannamal',
      'Warmun',
      'Waroona',
      'Watheroo',
      'Wedge Island',
      'Welbungin',
      'Wellstead',
      'Westonia',
      'Wialki',
      'Wicherina',
      'Wickepin',
      'Widgiemooltha',
      'Wilga',
      'Williams',
      'Wiluna',
      'Wilyabrup',
      'Windy Harbour',
      'Witchcliffe',
      'Wittenoom',
      'Wokalup',
      'Wongan Hills',
      'Wonnerup',
      'Woodanilling',
      'Woodarra',
      'Wooramel',
      'Wooroloo',
      'Worsley',
      'Wubin',
      'Wundowie',
      'Wyalkatchem',
      'Wyndham',
      'Xantippe',
      'Yalgoo',
      'Yallingup',
      'Yanchep',
      'Yandanooka',
      'Yarloop',
      'Yarri',
      'Yealering',
      'Yelbeni',
      'Yellowdine',
      'Yerecoin',
      'Yerilla',
      'Yilliminning',
      'Yoongarillup',
      'York',
      'Yorkrakine',
      'Yornaning',
      'Yornup',
      'Yoting',
      'Youndegin',
      'Yoweragabbie',
      'Yuna',
      'Zanthus',
    ],
  },
  BOL: {
    'BO-B': [
      'Baures',
      'Exaltacion',
      'Guayaramerín',
      'Huacaraje',
      'Puerto Siles',
      'Reyes',
      'Riberalta',
      'Rurrenabaque',
      'San Andrés',
      'San Borja',
      'San Joaquín',
      'San Ramón',
      'Santa Ana de Yacuma',
      'Trinidad',
    ],
    'BO-H': [
      'Camargo',
      'Culpina',
      'El Villar',
      'Huacaya',
      'Icla (R.Mujia)',
      'Incahuasi',
      'Las Carretas',
      'Machareti',
      'Monteagudo',
      'Padilla',
      'Poroma',
      'Presto',
      'San Lucas',
      'San Pablo de Huacareta',
      'Sopachuy',
      'Sucre',
      'Tarabuco',
      'Tarvita (Villa Arias)',
      'Tomina',
      'Villa Abecia',
      'Villa Alcalá',
      'Villa Azurduy',
      'Villa Mojocoya',
      'Villa Serrano',
      'Villa Vaca Guzmán (Muyupampa)',
      'Yamparáez',
      'Yotala',
      'Zudañez',
    ],
    'BO-C': [
      'Aiquile',
      'Alalay',
      'Anzaldo',
      'Arani',
      'Arbieto',
      'Arque',
      'Bolivar',
      'Capinota',
      'Chimore',
      'Cliza',
      'Cochabamba',
      'Colcapirhua',
      'Colomi',
      'Cuchumuela (V.G. Villarroel)',
      'Entre Rios (Bulo Bulo)',
      'Mizque',
      'Morochata',
      'Omereque',
      'Pasorapa',
      'Pocona',
      'Pojo',
      'Puerto Villarroel',
      'Punata',
      'Quillacollo',
      'Sacaba',
      'Sacabamba',
      'Santibañez',
      'Sicaya',
      'Sipe Sipe',
      'Tacachi',
      'Tacopaya',
      'Tapacarí',
      'Tarata',
      'Tiquipaya',
      'Tiraque',
      'Toko',
      'Tolata',
      'Totora',
      'Vacas',
      'Vila Vila',
      'Villa Rivero',
      'Villa Tunari',
      'Vinto',
    ],
    'BO-L': [
      'Achacachi',
      'Achocalla',
      'Ancoraimes',
      'Apolo',
      'Aucapata',
      'Ayata',
      'Ayo Ayo',
      'Batallas',
      'Cairoma',
      'Cajuata',
      'Calacoto',
      'Calamarca',
      'Caquiaviri',
      'Caranavi',
      'Catacora',
      'Chacarilla',
      'Charazani (Gen. Perez)',
      'Charaña',
      'Chulumani',
      'Chuma',
      'Collana',
      'Colquencha',
      'Colquiri',
      'Comanche',
      'Combaya',
      'Copacabana',
      'Coripata',
      'Coro Coro',
      'Coroico',
      'Curva',
      'Desaguadero',
      'Guanay',
      'Guaqui',
      'Ichoca',
      'Inquisivi',
      'Irupana',
      'Ixiamas',
      'Jesús de Machaca',
      'La Asunta',
      'Laja',
      'Licoma (Villa Libertad)',
      'Luribay',
      'Malla',
      'Mapiri',
      'Mecapaca',
      'Mocomoco',
      'Nazacara de Pacajes',
      'Palca',
      'Palos Blancos',
      'Papel Pampa',
      'Patacamaya',
      'Pelechuco',
      'Pucarani',
      'Puerto Acosta',
      'Puerto Carabuco',
      'Puerto Perez',
      'Quiabaya',
      'Quime',
      'San Andrés de Machaca',
      'San Buenaventura',
      'San Pedro de Curahuara',
      'San Pedro de Tiquina',
      'Santiago de Callapa',
      'Santiago de Machaca',
      'Sapahaqui',
      'Sica Sica',
      'Sorata',
      'Tacacoma',
      'Taraco',
      'Teoponte',
      'Tiahuanacu',
      'Tipuani',
      'Tito Yupanki',
      'Umala',
      'Viacha',
      'Waldo Ballivian',
      'Yaco',
      'Yanacachi',
    ],
    'BO-O': [
      'Antequera (Bolivar)',
      'Belén de Andamarca',
      'Caracollo',
      'Carangas',
      'Challapata',
      'Chipaya',
      'Choquecota',
      'Coipasa',
      'Corque',
      'Cruz de Machacamarca',
      'Curahuara de Carangas',
      'El Choro',
      'Escara',
      'Esmeralda',
      'Eucaliptus',
      'Huachacalla',
      'La Rivera',
      'Machacamarca',
      'Oruro',
      'Pampa Aullagas',
      'Paria',
      'Pazña',
      'Poopó',
      'Sabaya',
      'Salinas de Garci Mendoza',
      'San Pedro de Totora',
      'Santiago de Andamarca',
      'Santiago de Huari',
      'Santiago de Huayllamarca',
      'Santuario de Quillacas',
      'Todos Santos',
      'Toledo',
      'Turco',
      'Villa Huanuni',
      'Yunguyo del Litoral *',
    ],
    'BO-N': [
      'Bella Flor',
      'Bolpebra (Mukden)',
      'Cobija',
      'El Sena',
      'Filadelfia',
      'Ingavi',
      'Nuevo Manoa (Nueva Esperanza)',
      'Porvenir',
      'Puerto Gonzales Moreno',
      'Puerto Rico',
      'San Pedro (Conquista)',
      'Santa Rosa del Abuná',
      'Santos Mercado',
      'Villa Nueva (Loma Alta)',
    ],
    'BO-P': [
      'Acasio',
      'Arampampa',
      'Atocha',
      'Belén de Urmiri',
      'Betanzos',
      'Caiza D',
      'Caripuyo',
      'Chaqui',
      'Chayanta',
      'Colcha K (V. Martin)',
      'Colquechaca',
      'Cotagaita',
      'Llallagua',
      'Llica',
      'Mojinete',
      'Ocuri',
      'Pocoata',
      'Porco',
      'Potosí',
      'Puna',
      'Ravelo',
      'Sacaca',
      'San Agustín',
      'San Antonio de Esmoraca',
      'San Pablo de Lipez',
      'San Pedro de Buena Vista',
      'San Pedro de Quemes',
      'Tacobamba',
      'Tahua',
      'Tinquipaya',
      'Tomave',
      'Toro Toro',
      'Tupiza',
      'Uncía',
      'Uyuni (Thola Pampa)',
      'Villazón',
      'Vitichi',
      'Yocalla',
    ],
    'BO-S': [
      'Ascención de Guarayos',
      'Boyuibe',
      'Buena Vista',
      'Cabezas',
      'Camiri',
      'Carmen Rivero Torrez',
      'Charagua',
      'Colpa Belgica',
      'Comarapa',
      'Cotoca',
      'Cuatro Canadas',
      'Cuevo',
      'El Puente',
      'El Torno',
      'Fernandez Alonso',
      'General Saavedra',
      'Gutiérrez',
      'La Guardia',
      'Lagunillas',
      'Mairana',
      'Mineros',
      'Montero',
      'Moro Moro',
      'Okinawa Uno',
      'Pailón',
      'Pampa Grande',
      'Porongo (Ayacucho)',
      'Portachuelo',
      'Postrer Valle',
      'Pucara',
      'Puerto Quijarro',
      'Puerto Suarez',
      'Quirusillas',
      'Robore',
      'Saipina',
      'Samaipata',
      'San Antonio de Lomerio',
      'San Ignacio de Velasco',
      'San Jose de Chiquitos',
      'San Juan',
      'San Julián',
      'San Matías',
      'San Miguel de Velasco',
      'Santa Cruz de la Sierra',
      'Santa Rosa del Sara',
      'Trigal',
      'Urubicha',
      'Vallegrande',
      'Warnes',
      'Yapacaní',
    ],
    'BO-T': [
      'Caraparí',
      'Entre Rios (La Moreta)',
      'Padcaya',
      'Tarija',
      'Tomayapo (El Puente)',
      'Uriondo',
      'Villa San Lorenzo',
      'Villamontes',
      'Yacuiba',
      'Yunchara',
    ],
  },
  BRA: {
    'BR-AC': [
      'Acrelândia',
      'Assis Brasil',
      'Brasiléia',
      'Bujari',
      'Campinas',
      'Capixaba',
      'Cruzeiro do Sul',
      'Diadema',
      'Epitaciolândia',
      'Feijó',
      'Figueira',
      'Jordão',
      'Manoel Urbano',
      'Marechal Thaumaturgo',
      'Mâncio Lima',
      'Plácido de Castro',
      'Porto Acre',
      'Porto Walter',
      'Rio Branco',
      'Rodrigues Alves',
      'Santa Rosa do Purus',
      'Sena Madureira',
      'Senador Guiomard',
      'Tarauacá',
      'Xapuri',
    ],
    'BR-AL': [
      'Alazão',
      'Alecrim',
      'Anadia',
      'Anel',
      'Anum Novo',
      'Anum Velho',
      'Arapiraca',
      'Atalaia',
      'Baixa Grande',
      'Baixa da Onça',
      'Baixa do Capim',
      'Bananeiras',
      'Barra Grande',
      'Barra de  Santo Antônio',
      'Barra de São Miguel',
      'Barra do Bonifácio',
      'Barreiras',
      'Barro Vermelho',
      'Batalha',
      'Batingas',
      'Belo Monte',
      'Belém',
      'Boa Sorte',
      'Boa Vista',
      'Boca da Mata',
      'Bom Jardim',
      'Bonifácio',
      'Bonsucesso',
      'Boqueirão',
      'Botafogo',
      'Branquinha',
      'Bálsamo',
      'Cacimbinhas',
      'Cajarana',
      'Cajueiro',
      'Caldeirões de Cima',
      'Camadanta',
      'Campestre',
      'Campo Alegre',
      'Campo Grande',
      'Cana Brava',
      'Canafístula',
      'Canapi',
      'Canastra',
      'Canaã',
      'Cangandu',
      'Capela',
      'Carneiros',
      'Carrasco',
      'Chã Preta',
      'Coité do Noia',
      'Colônia Leopoldina',
      'Coqueiro Seco',
      'Coruripe',
      'Coruripe da Cal',
      'Craíbas',
      'Delmiro Gouveia',
      'Dois Riachos',
      'Entremontes',
      'Estrela de Alagoas',
      'Farrinheira',
      'Feira Grande',
      'Feliz Deserto',
      'Flexeiras',
      'Gaspar',
      'Girau do Ponciano',
      'Ibateguara',
      'Igaci',
      'Igreja Nova',
      'Ingá',
      'Inhapi',
      'Jacaré dos Homens',
      'Jacuípe',
      'Japaratinga',
      'Jaramataia',
      'Jenipapo',
      'Jequiá da Praia',
      'Joaquim Gomes',
      'Jundiá',
      'Junqueiro',
      'Lagoa Dantas',
      'Lagoa Do Caldeirao (Palmeira Dos Índios)',
      'Lagoa Grande',
      'Lagoa da Areia',
      'Lagoa da Canoa',
      'Lagoa da Pedra',
      'Lagoa do Caldeirão',
      'Lagoa do Canto',
      'Lagoa do Exú',
      'Lagoa do Rancho',
      'Lajes do Caldeirão',
      'Laranjal',
      'Limoeiro de Anadia',
      'Luziápolis',
      'Maceió',
      'Major Isidoro',
      'Mangabeiras',
      'Mar Vermelho',
      'Maragogi',
      'Maravilha',
      'Marechal Deodoro',
      'Maribondo',
      'Massaranduba',
      'Mata Grande',
      'Mata Limpa',
      'Matriz de Camaragibe',
      'Messias',
      'Minador do Negrão',
      'Monteirópolis',
      'Moreira',
      'Munguba',
      'Murici',
      'Novo Lino',
      "Olho D'Água de Cima",
      "Olho D'Água dos Dandanhas",
      "Olho d'Água Grande",
      "Olho d'Água das Flores",
      "Olho d'Água do Casado",
      'Olivença',
      'Ouro Branco',
      'Palestina',
      'Palmeira de Fora',
      'Palmeira dos Índios',
      'Pariconha',
      'Paripueira',
      'Passo de Camaragibe',
      "Pau D'Arco",
      'Pau Ferro',
      'Paulo Jacinto',
      'Penedo',
      'Peroba',
      'Piaçabuçu',
      'Pilões',
      'Pindoba',
      'Piranhas',
      'Pontal de Coruripe',
      'Porto Calvo',
      'Porto Real do Colégio',
      'Porto de Pedras',
      'Poxim',
      'Poço',
      'Poço da Pedra',
      'Poço das Trincheiras',
      'Poço de Baixo',
      'Poço de Santana',
      'Poção',
      'Pão de Açúcar',
      'Quati',
      'Quebrangulo',
      'Riacho Fundo de Cima',
      'Riacho do Sertão',
      'Riachão',
      'Rio Largo',
      'Rio dos Bichos',
      'Rocha Cavalcante',
      'Roteiro',
      'Santa Efigênia',
      'Santa Luzia do Norte',
      'Santana do Ipanema',
      'Santana do Mundaú',
      'Santo Antônio',
      'Sapucaia',
      'Satuba',
      'Senador Rui Palmeira',
      'Serra da Mandioca',
      'Serra da Massa',
      'Serra do São José',
      'São Brás',
      'São José da Lage',
      'São José da Laje',
      'São José da Tapera',
      'São Lourenço',
      'São Luís do Quitunde',
      'São Miguel dos Campos',
      'São Miguel dos Milagres',
      'São Sebastião',
      'Tabocas',
      'Taboleiro do Pinto',
      'Taboquinha',
      "Tanque d'Arca",
      'Taquara',
      'Taquarana',
      'Tatuamunha',
      'Teotônio Vilela',
      'Traipu',
      'União dos Palmares',
      'Usina Camaçari',
      'Varginha',
      'Vila Aparecida',
      'Vila São Francisco',
      'Viçosa',
      'Água Branca',
    ],
    'BR-AP': [
      'Abacate da Pedreira',
      'Amapá',
      'Ambé',
      'Aporema',
      'Ariri',
      'Bailique',
      'Boca do Jari',
      'Calçoene',
      'Cantanzal',
      'Carmo',
      'Clevelândia do Norte',
      'Corre Água',
      'Cunani',
      'Curiaú',
      'Cutias',
      'Ferreira Gomes',
      'Fortaleza',
      'Gaivota',
      'Gurupora',
      'Igarapé do Lago',
      'Ilha de Santana',
      'Inajá',
      'Itaubal',
      'Laranjal do Jari',
      'Livramento do Pacuí',
      'Lourenço',
      'Macapá',
      'Mazagão',
      'Mazagão Velho',
      'Oiapoque',
      'Paredão',
      'Pedra Branca do Amapari',
      'Porto Grande',
      'Pracuúba',
      'Santa Luzia do Pacuí',
      'Santa Maria',
      'Santana',
      'Serra do Navio',
      'Sucuriju',
      'São Joaquim do Pacuí',
      'São Sebastião do Livramento',
      'São Tomé',
      'Tartarugalzinho',
      'Vila Velha',
      'Vitória do Jari',
    ],
    'BR-AM': [
      'Agrovila São Sebastião do Caburi',
      'Alvarães',
      'Amatari',
      'Amaturá',
      'Anamã',
      'Anori',
      'Apuí',
      'Araras',
      'Ariaú',
      'Atalaia do Norte',
      'Augusto Montenegro',
      'Autazes',
      'Axinim',
      'Badajós',
      'Balbina',
      'Barcelos',
      'Barreirinha',
      'Belém de Solimões',
      'Benjamin Constant',
      'Beruri',
      'Boa Vista do Ramos',
      'Boca do Acre',
      'Borba',
      'Caapiranga',
      'Cacau Pirêra',
      'Caiambé',
      'Cametá',
      'Canumã',
      'Canutama',
      'Carauari',
      'Careiro',
      'Careiro Parauá',
      'Careiro da Várzea',
      'Carvoeiro',
      'Coari',
      'Codajás',
      'Cucuí',
      'Eirunepé',
      'Envira',
      'Estirão do Equador',
      'Feijoal',
      'Floriano Peixoto',
      'Fonte Boa',
      'Freguesia do Andirá',
      'Guajará',
      'Humaitá',
      'Iauaretê',
      'Ipixuna',
      'Iranduba',
      'Itacoatiara',
      'Itamarati',
      'Itapeaçu',
      'Itapiranga',
      'Içanã',
      'Japurá',
      'Juruá',
      'Jutaí',
      'Lago Preto',
      'Lago do Limão',
      'Limoeiro',
      'Lábrea',
      'Manacapuru',
      'Manaquiri',
      'Manaus',
      'Manicoré',
      'Maraã',
      'Massauari',
      'Maués',
      'Mocambo',
      'Murituba',
      'Murutinga',
      'Nhamundá',
      'Nova Olinda do Norte',
      'Novo Airão',
      'Novo Aripuanã',
      'Novo Céu',
      'Novo Remanso',
      'Osório da Fonseca',
      'Palmeiras',
      'Paricatuba',
      'Parintins',
      'Pauini',
      'Pedras',
      'Platô do Piquiá',
      'Presidente Figueiredo',
      'Purupuru',
      'Repartimento',
      'Rio Preto da Eva',
      'Santa Isabel do Rio Negro',
      'Santo Antônio do Içá',
      'Santo Antônio do Matupi',
      'Silves',
      'São Felipe',
      'São Gabriel da Cachoeira',
      'São Paulo de Olivença',
      'São Sebastião do Uatumã',
      'Tabatinga',
      'Tapauá',
      'Tefé',
      'Terra Nova',
      'Tonantins',
      'Uarini',
      'Urucará',
      'Urucurituba',
      'Vila Amazônia',
      'Vila Bittencourt',
      'Vila Lindóia',
      'Vila Pitinga',
      'Vila Rica de Caviana',
      'Vila Zé Açu',
      'Vila de Campinas',
      'Vila de Sacambu',
      'Vila do Lago do Jacaré',
    ],
    'BR-BA': [
      'Abadia',
      'Abaré',
      'Abaíra',
      'Abelhas',
      'Abrantes',
      'Abóbora',
      'Acajutiba',
      'Acupe',
      'Adro de São Gonçalo',
      'Adustina',
      'Afligidos',
      'Afrânio Peixoto',
      'Aiquara',
      'Alagoinhas',
      'Alcobaça',
      'Algodão',
      'Algodões',
      'Almadina',
      'Alto Bonito',
      'Amado Bahia',
      'Amaniú',
      'Amargosa',
      'Amélia Rodrigues',
      'América Dourada',
      'Américo Alves',
      'Anagé',
      'Andaraí',
      'Andorinha',
      'Angical',
      'Angico',
      'Anguera',
      'Antarí',
      'Antas',
      'Antônio Cardoso',
      'Antônio Gonçalves',
      'Aporá',
      'Apuarema',
      'Aracatu',
      'Araci',
      'Aramari',
      'Arapiranga',
      'Arataca',
      'Aratuípe',
      'Araçás',
      'Areia Branca',
      'Areias',
      'Arembepe',
      'Argoim',
      'Argolo',
      'Aribice',
      'Aritaguá',
      'Aroeiras',
      "Arraial D'Ajuda",
      'Aurelino Leal',
      'Açu da Torre',
      'Açudina',
      'Baianópolis',
      'Baixa do Palmeira',
      'Baixinha',
      'Baixão',
      'Baluarte',
      'Banco Central',
      'Bandeira do Almada',
      'Bandeira do Colônia',
      'Bandiaçu',
      'Banzaê',
      'Baraúnas',
      'Barcelos do Sul',
      'Barra',
      'Barra Avenida',
      'Barra da Estiva',
      'Barra do Choça',
      'Barra do Jacuípe',
      'Barra do Mendes',
      'Barra do Pojuca',
      'Barra do Rocha',
      'Barra do Tarrachil',
      'Barreiros',
      'Barro Alto',
      'Barro Preto',
      'Barrocas',
      'Barrocão',
      'Bastião',
      'Bate Pé',
      'Batinga',
      'Bela Flor',
      'Bela Vista',
      'Belmonte',
      'Belo Campo',
      'Belém da Cachoeira',
      'Bem-Bom',
      'Bendegó',
      'Bento Simões',
      'Biritinga',
      'Boa Espera',
      'Boa Nova',
      'Boa União',
      'Boa Vista do Lagamar',
      'Boa Vista do Tupim',
      'Boaçu',
      'Boca do Córrego',
      'Bom Jesus da Lapa',
      'Bom Jesus da Serra',
      'Bom Sossego',
      'Bonfim da Feira',
      'Boninal',
      'Bonito',
      'Boquira',
      'Botuporã',
      'Botuquara',
      'Brejinho das Ametistas',
      'Brejo Luíza de Brito',
      'Brejo Novo',
      'Brejo da Serra',
      'Brejolândia',
      'Brejões',
      'Brotas de Macaúbas',
      'Brumado',
      'Bucuituba',
      'Buerarema',
      'Buracica',
      'Buranhém',
      'Buril',
      'Buris de Abrantes',
      'Buritirama',
      'Caatiba',
      'Cabaceiras do Paraguaçu',
      'Cabeceira do Jibóia',
      'Cabrália',
      'Cabôto',
      'Cacha Pregos',
      'Cachoeira',
      'Cachoeira do Mato',
      'Caculé',
      'Caetanos',
      'Caetité',
      'Caeté-Açu',
      'Cafarnaum',
      'Caimbé',
      'Cairu',
      'Caiubi',
      'Caiçara',
      'Cajuí',
      'Caldas do Jorro',
      'Caldeiras',
      'Caldeirão',
      'Caldeirão Grande',
      'Camacan',
      'Camamu',
      'Camassandi',
      'Camaçari',
      'Camirim',
      'Campinhos',
      'Campo Alegre de Lourdes',
      'Campo Formoso',
      'Camurugi',
      'Canabravinha',
      'Canarana',
      'Canatiba',
      'Canavieiras',
      'Canché',
      'Candeal',
      'Candeias',
      'Candiba',
      'Canoão',
      'Cansanção',
      'Canto do Sol',
      'Canudos',
      'Canápolis',
      'Capela do Alto Alegre',
      'Capim Grosso',
      'Capão',
      'Caraguataí',
      'Caraibuna',
      'Caraiva',
      'Caravelas',
      'Caraíbas',
      'Caraípe',
      'Cardeal da Silva',
      'Carinhanha',
      'Caripare',
      'Carnaíba do Sertão',
      'Caroba',
      'Carrapichel',
      'Casa Nova',
      'Castelo Novo',
      'Castro Alves',
      'Catinga do Moura',
      'Catingal',
      'Catolezinho',
      'Catolândia',
      'Catolés',
      'Catu',
      'Catu de Abrantes',
      'Caturama',
      'Cavunge',
      'Caém',
      'Central',
      'Ceraima',
      'Cercadinho',
      'Chorrochó',
      'Cinco Rios',
      'Cipó',
      'Coaraci',
      'Cocos',
      'Colônia',
      'Colônia do Formoso',
      'Comércio',
      'Conceição da Feira',
      'Conceição do Almeida',
      'Conceição do Coité',
      'Conceição do Jacuípe',
      'Conde',
      'Condeúba',
      'Contendas do Sincorá',
      'Copixaba',
      'Coqueiros',
      'Coquinhos',
      'Coração de Maria',
      'Cordeiros',
      'Coribe',
      'Coronel João Sá',
      'Correntina',
      'Corta Mão',
      'Cotegipe',
      'Coutos',
      'Cravolândia',
      'Cristalândia',
      'Cristópolis',
      'Crisópolis',
      'Crussaí',
      'Cruz das Almas',
      'Cumuruxatiba',
      'Cunhangi',
      'Curaçá',
      'Curral Falso',
      'Cândido Sales',
      'Cícero Dantas',
      'Dantelândia',
      'Delfino',
      'Descoberto',
      'Dias Coelho',
      "Dias d'Ávila",
      'Diógenes Sampaio',
      'Dom Basílio',
      'Dom Macedo Costa',
      'Dona Maria',
      'Duas Barras do Morro',
      'Dário Meira',
      'Elísio Medrado',
      'Encruzilhada',
      'Engenheiro França',
      'Engenheiro Pontes',
      'Entre Rios',
      'Esplanada',
      'Espraiado',
      'Euclides da Cunha',
      'Eunápolis',
      'Feira da Mata',
      'Feira de Santana',
      'Ferradas',
      'Filadélfia',
      'Filanésia',
      'Firmino Alves',
      'Floresta Azul',
      'Florestal',
      'Formosa do Rio Preto',
      'França',
      'Fátima',
      'Gabiarra',
      'Galeão',
      'Gamboa',
      'Gameleira da Lapa',
      'Gameleira do Assuruá',
      'Gandu',
      'Gavião',
      'Gentio do Ouro',
      'Geolândia',
      'Glória',
      'Gongogi',
      'Governador João Durval Carneiro',
      'Governador Mangabeira',
      'Guagirus',
      'Guajeru',
      'Guanambi',
      'Guapira',
      'Guarajuba',
      'Guaratinga',
      'Guaí',
      'Guerém',
      'Guiné',
      'Guirapa',
      'Gurupá Mirim',
      'Heliópolis',
      'Helvecia',
      'Hidrolândia',
      'Humildes',
      'Iaçu',
      'Ibatui',
      'Ibiajara',
      'Ibiapora',
      'Ibiassucê',
      'Ibiaçu',
      'Ibicaraí',
      'Ibicoara',
      'Ibicuí',
      'Ibipeba',
      'Ibipetum',
      'Ibipitanga',
      'Ibiquera',
      'Ibiraba',
      'Ibirajá',
      'Ibiranhém',
      'Ibirapitanga',
      'Ibirapuã',
      'Ibirataia',
      'Ibitiara',
      'Ibitiguira',
      'Ibitira',
      'Ibititá',
      'Ibitunane',
      'Ibitupa',
      'Ibotirama',
      'Ibó',
      'Ichu',
      'Icó',
      'Igaporã',
      'Igarité',
      'Igará',
      'Igatu',
      'Igrapiúna',
      'Iguaibi',
      'Iguatemi',
      'Iguaí',
      'Iguira',
      'Iguitu',
      'Iguá',
      'Ilha de Bom Jesus dos Passos',
      'Ilha de Maré',
      'Ilha dos Frades',
      'Ilhéus',
      'Indaí',
      'Inema',
      'Inhambupe',
      'Inhata',
      'Inhaúmas',
      'Inhobim',
      'Inúbia',
      'Ipecaetá',
      'Ipiaú',
      'Ipirá',
      'Ipiúna',
      'Ipucaba',
      'Ipupiara',
      'Irajuba',
      'Iramaia',
      'Iraporanga',
      'Iraquara',
      'Irará',
      'Irecê',
      'Irundiara',
      'Ita-Azul',
      'Itabatan',
      'Itabela',
      'Itaberaba',
      'Itabuna',
      'Itacaré',
      'Itacava',
      'Itachama',
      'Itacimirim',
      'Itaeté',
      'Itagi',
      'Itagibá',
      'Itagimirim',
      'Itaguaçu da Bahia',
      'Itaia',
      'Itaibó',
      'Itaipu',
      'Itajaí',
      'Itaju do Colônia',
      'Itajubaquara',
      'Itajuru',
      'Itajuípe',
      'Itamaraju',
      'Itamari',
      'Itambé',
      'Itamira',
      'Itamotinga',
      'Itanagra',
      'Itanagé',
      'Itanhi',
      'Itanhém',
      'Itaparica',
      'Itapebi',
      'Itapeipu',
      'Itapetinga',
      'Itapicuru',
      'Itapirema',
      'Itapitanga',
      'Itapora',
      'Itapura',
      'Itapé',
      'Itaquara',
      'Itaquaraí',
      'Itarantim',
      'Itati',
      'Itatiaia do Alto Bonito',
      'Itatim',
      'Itatingui',
      'Itaítu',
      'Itiruçu',
      'Itiúba',
      'Itororó',
      'Ituaçu',
      'Ituberá',
      'Itupeva',
      'Iuiú',
      'Jaborandi',
      'Jacaraci',
      'Jacobina',
      'Jacu',
      'Jacuruna',
      'Jaguaquara',
      'Jaguara',
      'Jaguarari',
      'Jaguaripe',
      'Jandaíra',
      'Japomirim',
      'Japu',
      'Jauá',
      'Jaíba',
      'Jequiriçá',
      'Jequié',
      'Jeremoabo',
      'Jiquiriçá',
      'Jiribatuba',
      'Jitaúna',
      'José Gonçalves',
      'João Amaro',
      'João Correia',
      'João Dourado',
      'Juacema',
      'Juazeiro',
      'Jucuruçu',
      'Juerana',
      'Junco',
      'Jupaguá',
      'Juraci',
      'Juremal',
      'Jussara',
      'Jussari',
      'Jussiape',
      'Km Sete',
      'Lafaiete Coutinho',
      'Lagoa Clara',
      'Lagoa José Luís',
      'Lagoa Preta',
      'Lagoa Real',
      'Lagoa de Melquíades',
      'Lagoa do Boi',
      'Laje',
      'Laje do Banco',
      'Lajedinho',
      'Lajedo Alto',
      'Lajedo do Tabocal',
      'Lajedão',
      'Lamarao Do Passe (Sao Sebastiao Do Passe)',
      'Lamarão',
      'Lamarão do Passe',
      'Lapão',
      'Largo',
      'Lauro de Freitas',
      'Lençóis',
      'Licínio de Almeida',
      'Limoeiro do Bom Viver',
      'Livramento de Nossa Senhora',
      'Lucaia',
      'Lustosa',
      'Luís Eduardo Magalhães',
      'Luís Viana',
      'Macajuba',
      'Macarani',
      'Macaúbas',
      'Macururé',
      'Madeira',
      'Madre de Deus',
      'Maetinga',
      'Maiquinique',
      'Mairi',
      'Malhada',
      'Malhada de Pedras',
      'Mandiroba',
      'Mangue Seco',
      'Maniaçu',
      'Manoel Vitorino',
      'Mansidão',
      'Mantiba',
      'Mar Grande',
      'Maracás',
      'Maragogipe',
      'Maragogipinho',
      'Maraú',
      'Marcionílio Souza',
      'Marcolino Moura',
      'Maria Quitéria',
      'Maricoabo',
      'Mariquita',
      'Mascote',
      'Massacara',
      'Massaroca',
      'Mata da Aliança',
      'Mata de São João',
      'Mataripe',
      'Matina',
      'Matinha',
      'Medeiros Neto',
      'Menino Jesus',
      'Miguel Calmon',
      'Milagres',
      'Mimoso',
      'Minas do Espírito Santo',
      'Minas do Mimoso',
      'Mirandela',
      'Miranga',
      'Mirangaba',
      'Mirante',
      'Missão de Aricobé',
      'Mogiquiçaba',
      'Monte Branco',
      'Monte Cruzeiro',
      'Monte Gordo',
      'Monte Recôncavo',
      'Monte Santo',
      'Morpará',
      'Morrinhos',
      'Morro das Flores',
      'Morro de São Paulo',
      'Morro do Chapéu',
      'Mortugaba',
      'Mucugê',
      'Mucuri',
      'Mulungu do Morro',
      'Mundo Novo',
      'Muniz Ferreira',
      'Muquém de São Francisco',
      'Muritiba',
      'Mutas',
      'Mutuípe',
      'Nagé',
      'Narandiba',
      'Nazaré',
      'Nilo Peçanha',
      'Nordestina',
      'Nova Alegria',
      'Nova Brasília',
      'Nova Canaã',
      'Nova Fátima',
      'Nova Ibiá',
      'Nova Itaipê',
      'Nova Itarana',
      'Nova Lídice',
      'Nova Redenção',
      'Nova Soure',
      'Nova Viçosa',
      'Novo Acre',
      'Novo Horizonte',
      'Novo Triunfo',
      'Nuguaçu',
      'Núcleo Residencial Pilar',
      "Olhos D'Água do Seco",
      "Olhos D'Água do Serafim",
      'Olindina',
      'Oliveira dos Brejinhos',
      'Onha',
      'Oriente Novo',
      'Ouricana',
      'Ouricuri do Ouro',
      'Ouriçangas',
      'Ourolândia',
      'Outeiro Redondo',
      'Paiol',
      'Pajeú do Vento',
      'Palame',
      'Palmares',
      'Palmas de Monte Alto',
      'Parafuso',
      'Paramirim',
      'Parateca',
      'Paratinga',
      'Paripiranga',
      'Passagem dos Teixeiras',
      'Passé',
      'Patamuté',
      'Pataíba',
      'Pau Brasil',
      'Pau a Pique',
      'Paulo Afonso',
      'Pedra Alta',
      'Pedras Altas do Mirim',
      'Pedro Alexandre',
      'Pedrão',
      'Peixe',
      'Petim',
      'Piabanha',
      'Piatã',
      'Pilão Arcado',
      'Pimenteira',
      'Pindaí',
      'Pindobaçu',
      'Pinga Fogo',
      'Pinhões',
      'Pintadas',
      'Piragi',
      'Pirajuia',
      'Pirajá',
      'Piraí do Norte',
      'Piri',
      'Piripá',
      'Piritiba',
      'Pituba',
      'Piçarrão',
      'Planaltino',
      'Planalto',
      'Pojuca',
      'Ponta da Areia',
      'Ponto Novo',
      'Porto Novo',
      'Porto Sauípe',
      'Porto Seguro',
      'Posto da Mata',
      'Potiraguá',
      'Poxim do Sul',
      'Poço Central',
      'Poço de Fora',
      'Poços',
      'Poções',
      'Prado',
      'Pradoso',
      'Praia do Forte',
      'Presidente Dutra',
      'Presidente Jânio Quadros',
      'Presidente Tancredo Neves',
      'Prevenido',
      'Pé de Serra',
      'Quaraçu',
      'Queimadas',
      'Quijingue',
      'Quixabeira',
      'Quixabá',
      'Rafael Jambeiro',
      'Rancho das Mães',
      'Raspador',
      'Recife',
      'Remanso',
      'Remédios',
      'Retirolândia',
      'Riacho Seco',
      'Riacho da Guia',
      'Riacho de Santana',
      'Riachão das Neves',
      'Riachão do Jacuípe',
      'Riachão do Utinga',
      'Ribeira do Amparo',
      'Ribeira do Pombal',
      'Ribeirão do Largo',
      'Ribeirão do Salto',
      'Rio Fundo',
      'Rio Real',
      'Rio da Dona',
      'Rio de Contas',
      'Rio do Antônio',
      'Rio do Braço',
      'Rio do Meio',
      'Rio do Pires',
      'Roda Velha',
      'Rodelas',
      'Rosário',
      'Ruy Barbosa',
      'Saldanha',
      'Salgadália',
      'Salinas da Margarida',
      'Salobro',
      'Salvador',
      'Sambaíba',
      'Santa Brígida',
      'Santa Cruz Cabrália',
      'Santa Cruz da Vitória',
      'Santa Inês',
      'Santa Luzia',
      'Santa Maria da Vitória',
      'Santa Rita de Cássia',
      'Santa Teresinha',
      'Santa Terezinha',
      'Santaluz',
      'Santana do Sobrado',
      'Santanópolis',
      'Santiago do Iguapé',
      'Santo Amaro',
      'Santo Antônio de Barcelona',
      'Santo Antônio de Jesus',
      'Santo Estêvão',
      'Santo Inácio',
      'Sapeaçu',
      'Saubara',
      'Saudável',
      'Saúde',
      'Seabra',
      'Sebastião Laranjeiras',
      'Senhor do Bonfim',
      'Sento Sé',
      'Sergi',
      'Serra Dourada',
      'Serra Grande',
      'Serra Preta',
      'Serra da Canabrava',
      'Serra do Ramalho',
      'Serra do São Francisco',
      'Serrinha',
      'Serrolândia',
      'Simões Filho',
      'Soares',
      'Sobradinho',
      'Souto Soares',
      'Subaúma',
      'Sussuarana',
      'Sátiro Dias',
      'São Desidério',
      'São Domingos',
      'São Francisco do Conde',
      'São Félix',
      'São Félix do Coribe',
      'São Gabriel',
      'São Gonçalo dos Campos',
      'São José da Vitória',
      'São José do Colônia',
      'São José do Jacuípe',
      'São José do Prado',
      'São José do Rio Grande',
      'São João',
      'São João da Fortaleza',
      'São João da Vitória',
      'São Miguel das Matas',
      'São Paulinho',
      'São Roque do Paraguaçu',
      'São Sebastião do Passé',
      'São Timóteo',
      'Sítio Grande',
      'Sítio Novo',
      'Sítio da Baraúna',
      'Sítio do Mato',
      'Sítio do Meio',
      'Sítio do Quinto',
      'Tabocas do Brejo Velho',
      'Taboleiro do Castro',
      'Taboquinhas',
      'Taguá',
      'Tamburil',
      'Tanhaçu',
      'Tanque Novo',
      'Tanquinho',
      'Tanquinho do Poço',
      'Taperoá',
      'Tapirama',
      'Tapiramutá',
      'Tapiranga',
      'Tapiraípe',
      'Tapúia',
      'Taquarendi',
      'Taquarinha',
      'Tartaruga',
      'Tauapé',
      'Teixeira de Freitas',
      'Teodoro Sampaio',
      'Teofilândia',
      'Teolândia',
      'Tijuaçú',
      'Tiquaruçu',
      'Tracupa',
      'Trancoso',
      'Tremedal',
      'Triunfo do Sincorá',
      'Tucano',
      'Uauá',
      'Ubaitaba',
      'Ubatã',
      'Ubaíra',
      'Ubiracaba',
      'Ubiraitá',
      'Uibaí',
      'Umburanas',
      'Umbuzeiro',
      'Una',
      'Urandi',
      'Uruçuca',
      'Utinga',
      'Vale Verde',
      'Valente',
      'Valença',
      'Varzedo',
      'Velha Boipeba',
      'Ventura',
      'Vera Cruz',
      'Vereda',
      'Veredinha',
      'Vila Mariana',
      'Vila do Café',
      'Vitória da Conquista',
      'Volta Grande',
      'Volta da Serra',
      'Várzea Nova',
      'Várzea da Roça',
      'Várzea do Caldas',
      'Várzea do Cerco',
      'Várzea do Poço',
      'Várzeas',
      'Wagner',
      'Wanderley',
      'Wenceslau Guimarães',
      'Xique-Xique',
      'Água Doce',
      'Água Fria',
      'Águas do Paulista',
      'Érico Cardoso',
    ],
    'BR-CE': [
      'Abaiara',
      'Abílio Martins',
      'Acarape',
      'Acaraú',
      'Acopiara',
      'Adrianópolis',
      'Aguaí',
      'Aiuaba',
      'Aiuá',
      'Alagoinha',
      'Alazans',
      'Alcântaras',
      'Almofala',
      'Altaneira',
      'Alto Lindo',
      'Alto Santo',
      'Amanaiara',
      'Amanari',
      'Amaniutuba',
      'Amarelas',
      'Amaro',
      'Amontada',
      'América',
      'Anauá',
      'Anil',
      'Aningás',
      'Anjinhos',
      'Antonina do Norte',
      'Antônio Diogo',
      'Antônio Marques',
      'Aprazível',
      'Apuiarés',
      'Aquinópolis',
      'Aquiraz',
      'Aracati',
      'Aracatiara',
      'Aracatiaçu',
      'Aracoiaba',
      'Arajara',
      'Aranaú',
      'Arapari',
      'Araporanga',
      'Arapá',
      'Araquém',
      'Ararendá',
      'Araripe',
      'Arariús',
      'Aratama',
      'Araticum',
      'Aratuba',
      'Areial',
      'Areré',
      'Ariscos dos Marianos',
      'Arneiroz',
      'Arrojado',
      'Aruaru',
      'Assaré',
      'Assis',
      'Assunção',
      'Aurora',
      'Açude dos Pinheiros',
      'Açudinho',
      'Açudinho dos Costas',
      'Baixa Fria',
      'Baixio',
      'Baixio da Donana',
      'Baixio das Palmeiras',
      'Baleia',
      'Balseiros',
      'Banabuiú',
      'Bandeira',
      'Baracho',
      'Barbada',
      'Barbalha',
      'Barra Nova',
      'Barra do Ingá',
      'Barra do Sotero',
      'Barreira',
      'Barreira dos Vianas',
      'Barrento',
      'Barrinha',
      'Barro',
      'Barroquinha',
      'Barão de Aquiraz',
      'Bastiões',
      'Baturité',
      'Baú',
      'Beberibe',
      'Bela Cruz',
      'Betânia',
      'Bilheira',
      'Bitupitá',
      'Bixopa',
      'Boa Esperança',
      'Boa Viagem',
      'Boa Vista do Caxitoré',
      'Boa Água',
      'Bom Princípio',
      'Bonfim',
      'Bonhu',
      'Borges',
      'Brejinho',
      'Brejo Grande',
      'Brejo Santo',
      'Brotas',
      'Buritizal',
      'Buritizinho',
      'Cabreiro',
      'Cachoeira Grande',
      'Cachoeira de Fora',
      'Cacimba Nova',
      'Cacimbas',
      'Caio Prado',
      'Caioca',
      'Caipu',
      'Caiçarinha',
      'Cajazeiras',
      'Calabaça',
      'Caldas',
      'Califórnia',
      'Camará',
      'Camboas',
      'Camilos',
      'Camocim',
      'Campanário',
      'Campos',
      'Campos Belos',
      'Campos Sales',
      'Canaan',
      'Canafistula',
      'Canaúna',
      'Cangati',
      'Canindezinho',
      'Canindé',
      'Canta Galo',
      'Capim de Roça',
      'Capistrano',
      'Capitão Mor',
      'Capitão Pedro Sampaio',
      'Caponga',
      'Caponga da Bernarda',
      'Caponguinha',
      'Caracará',
      'Caridade',
      'Caririaçu',
      'Cariré',
      'Cariutaba',
      'Cariús',
      'Carmelópolis',
      'Carnaubal',
      'Carnaubinha',
      'Carnaúba',
      'Carnaúbas',
      'Carquejo',
      'Carrapateiras',
      'Caruataí',
      'Carvalho',
      'Cascavel',
      'Castanhão',
      'Catarina',
      'Catolé',
      'Catolé da Pista',
      'Catuana',
      'Catunda',
      'Caucaia',
      'Caxitoré',
      'Cedro',
      'Cemoaba',
      'Chaval',
      'Chile',
      'Chorozinho',
      'Choró',
      'Cipó dos Anjos',
      'Cococi',
      'Codiá',
      'Coité',
      'Colina',
      'Conceição',
      'Coreaú',
      'Corrente',
      'Crateús',
      'Crato',
      'Crioulos',
      'Cristais',
      'Croatá',
      'Cruxati',
      'Cruz',
      'Cruz de Pedra',
      'Cruzeirinho',
      'Cuncas',
      'Curatis',
      'Curral Velho',
      'Curupira',
      'Custódio',
      'Córrego',
      'Córrego dos Fernandes',
      'Damião Carneiro',
      'Daniel de Queirós',
      'Deputado Irapuan Pinheiro',
      'Deserto',
      'Dom Leme',
      'Dom Maurício',
      'Dom Quintino',
      'Domingos da Costa',
      'Donato',
      'Dourado',
      'Ebron',
      'Ema',
      'Ematuba',
      'Encantado',
      'Engenheiro José Lopes',
      'Engenheiro João Tomé',
      'Engenho Velho',
      'Ererê',
      'Espacinha',
      'Esperança',
      'Estrela',
      'Eusébio',
      'Farias Brito',
      'Faveira',
      'Faísca',
      'Feiticeiro',
      'Feitosa',
      'Felipe',
      'Felizardo',
      'Flamengo',
      'Forquilha',
      'Fortim',
      'Frecheirinha',
      'Gadelha',
      'Gado',
      'Gado dos Rodrigues',
      'Gameleira de São Sebastião',
      'Garças',
      'General Sampaio',
      'General Tibúrcio',
      'Gereraú',
      'Giqui',
      'Girau',
      'Grande Basílio',
      'Granja',
      'Granjeiro',
      'Graça',
      'Groaíras',
      'Guaiúba',
      'Guajiru',
      'Guanacés',
      'Guaraciaba do Norte',
      'Guaramiranga',
      'Guararu',
      'Guassi',
      'Guassussê',
      'Guia',
      'Guriú',
      'Gázea',
      'Holanda',
      'Horizonte',
      'Iapi',
      'Iara',
      'Ibaretama',
      'Ibiapaba',
      'Ibiapina',
      'Ibicatu',
      'Ibicuitaba',
      'Ibicuitinga',
      'Ibicuã',
      'Iborepi',
      'Ibuaçu',
      'Ibuguaçu',
      'Icapuí',
      'Icaraí',
      'Icozinho',
      'Ideal',
      'Igaroi',
      'Iguatu',
      'Iguaçu',
      'Independência',
      'Ingazeiras',
      'Inhamuns',
      'Inhuporanga',
      'Inhuçu',
      'Ipaguaçú',
      'Ipaporanga',
      'Ipaumirim',
      'Ipiranga',
      'Ipu',
      'Ipueiras',
      'Ipueiras dos Gomes',
      'Iracema',
      'Irajá',
      'Irapuã',
      'Iratinga',
      'Irauçuba',
      'Isidoro',
      'Itacima',
      'Itacolomy',
      'Itaguá',
      'Itaipaba',
      'Itaitinga',
      'Itaiçaba',
      'Itans',
      'Itapagé',
      'Itapajé',
      'Itapebussu',
      'Itapeim',
      'Itapipoca',
      'Itapiúna',
      'Itapó',
      'Itarema',
      'Itatira',
      'Jaburuna',
      'Jacampari',
      'Jacarecoara',
      'Jacaúna',
      'Jaguaretama',
      'Jaguaribara',
      'Jaguaribe',
      'Jaguaruana',
      'Jaguarão',
      'Jaibaras',
      'Jamacaru',
      'Jandrangoeira',
      'Jardim',
      'Jardimirim',
      'Jati',
      'Jenipapeiro',
      'Jijoca de Jericoacoara',
      'José de Alencar',
      'João Cordeiro',
      'João de Castro',
      'Juatama',
      'Juazeiro de Baixo',
      'Juazeiro do Norte',
      'Jubaia',
      'Jucá',
      'Jucás',
      'Jurema',
      'Juritianha',
      'Justiniano Serpa',
      'Juá',
      'Lacerda',
      'Ladeira Grande',
      'Lages',
      'Lagoa da Cruz',
      'Lagoa das Pedras',
      'Lagoa de São João',
      'Lagoa do Barro',
      'Lagoa do Carneiro',
      'Lagoa do Juvenal',
      'Lagoa do Mato',
      'Lagoa dos Crioulos',
      'Lagoinha',
      'Lambedouro',
      'Lameiro',
      'Lapa',
      'Laranjeiras',
      'Lavras da Mangabeira',
      'Lima Campos',
      'Limoeiro do Norte',
      'Lisieux',
      'Livramento',
      'Logradouro',
      'Macambira',
      'Macaraú',
      'Macaóca',
      'Madalena',
      'Major Simplício',
      'Majorlândia',
      'Malhada Grande',
      'Mangabeira',
      'Manhoso',
      'Manibu',
      'Manituba',
      'Manoel Correia',
      'Manoel Guedes',
      'Mapuá',
      'Maracanaú',
      'Maranguape',
      'Mararupá',
      'Maratoã',
      'Marco',
      'Marinheiros',
      'Marrecas',
      'Marrocos',
      'Marruás',
      'Martinslândia',
      'Martinópole',
      'Massapê',
      'Mata Fresca',
      'Matias',
      'Matriz',
      'Mauriti',
      'Mel',
      'Meruoca',
      'Messejana',
      'Miguel Xavier',
      'Milhã',
      'Milton Belo',
      'Mineirolândia',
      'Miragem',
      'Mirambé',
      'Miraíma',
      'Missi',
      'Missão Nova',
      'Missão Velha',
      'Moitas',
      'Mombaça',
      'Monguba',
      'Monsenhor Tabosa',
      'Monte Alegre',
      'Monte Alverne',
      'Monte Castelo',
      'Monte Grave',
      'Monte Sion',
      'Montenebo',
      'Morada Nova',
      'Moraújo',
      'Morrinhos Novos',
      'Morro Branco',
      'Mosquito',
      'Mucambo',
      'Mulungu',
      'Mumbaba',
      'Mundau',
      'Muribeca',
      'Mutambeiras',
      'Naraniu',
      'Nascente',
      'Nenenlândia',
      'Nossa Senhora do Livramento',
      'Nova Betânia',
      'Nova Floresta',
      'Nova Olinda',
      'Nova Russas',
      'Nova Santa Cruz',
      'Nova Veneza',
      'Nova Vida',
      'Novo Assis',
      'Novo Oriente',
      'Núcleo Colonial Pio XII',
      'Ocara',
      'Oiticica',
      "Olho D'Água",
      "Olho D'água do Bezerril",
      "Olho-D'Água da Bica",
      'Oliveiras',
      'Orós',
      'Pacajus',
      'Pacatuba',
      'Pacoti',
      'Pacujá',
      'Padre Cícero',
      'Padre Linhares',
      'Padre Vieira',
      'Pai João',
      'Pajeú',
      'Palestina do Norte',
      'Palhano',
      'Palmatória',
      'Palmácia',
      'Panacuí',
      'Papara',
      'Paracuru',
      'Paracuá',
      'Paraipaba',
      'Paraiso',
      'Parajuru',
      'Parambu',
      'Paramoti',
      'Parangaba',
      'Parapuí',
      'Parazinho',
      'Pascoal',
      'Passagem',
      'Passagem Funda',
      'Passagem da Onça',
      'Pasta',
      'Patacas',
      'Patos',
      'Patos dos Liberatos',
      'Patriarca',
      'Paus Branco',
      'Paus Brancos',
      'Pavuna',
      'Pecém',
      'Pedra Branca',
      'Pedra de Fogo',
      'Pedras Brancas',
      'Pedrinhas',
      'Peixe Gordo',
      'Penaforte',
      'Pentecoste',
      'Pereiro',
      'Pernambuquinho',
      'Pessoa Anta',
      'Pindoguaba',
      'Pindoretama',
      'Pio X',
      'Piquet Carneiro',
      'Pirangi',
      'Pires Ferreira',
      'Pitombeira',
      'Pitombeiras',
      'Plácido Martins',
      'Ponta da Serra',
      'Poranga',
      'Porfirio Sampaio',
      'Porteiras',
      'Potengi',
      'Poti',
      'Potiretama',
      'Poço Comprido',
      'Poço Doce',
      'Poço Grande',
      'Poço Verde',
      'Poço da Onça',
      'Prata',
      'Pratiús',
      'Prefeita Suely Pinheiro',
      'Prudente de Morais',
      'Quatiguaba',
      'Queimados',
      'Quimami',
      'Quincoé',
      'Quincuncá',
      'Quitaiús',
      'Quiterianópolis',
      'Quixadá',
      'Quixariú',
      'Quixelô',
      'Quixeramobim',
      'Quixeré',
      'Rafael Arruda',
      'Raimundo Martins',
      'Ramadinha',
      'Realejo',
      'Redenção',
      'Repartição',
      'Reriutaba',
      'Riacho Grande',
      'Riacho Verde',
      'Riacho Vermelho',
      'Rinaré',
      'Roldão',
      'Russas',
      'Sabiaguaba',
      'Saboeiro',
      'Sacramento',
      'Salgado dos Machados',
      'Salitre',
      'Salão',
      'Santa Ana',
      'Santa Cruz do Banabuiú',
      'Santa Felícia',
      'Santa Fé',
      'Santa Quitéria',
      'Santa Tereza',
      'Santana do Acaraú',
      'Santana do Cariri',
      'Santarém',
      'Santo André',
      'Santo Antônio da Pindoba',
      'Santo Antônio dos Fernandes',
      'Sao Joao (Erere)',
      'Sapo',
      'Sapupara',
      'Saquinho',
      'Sebastião de Abreu',
      'Senador Carlos Jereissati',
      'Senador Pompeu',
      'Senador Sá',
      'Sereno de Cima',
      'Serra do Félix',
      'Serragem',
      'Serrota',
      'Serrote',
      'Serrote do Meio',
      'Simão',
      'Sitiá',
      'Siupê',
      'Sobral',
      'Soledade',
      'Solidão',
      'Solonópole',
      'Suassurana',
      'Sucatinga',
      'Sucesso',
      'Sussuanha',
      'São Bartolomeu',
      'São Benedito',
      'São Bernardo',
      'São Francisco',
      'São Gonçalo do Amarante',
      'São Gonçalo do Umari',
      'São Joaquim',
      'São Joaquim do Salgado',
      'São José',
      'São José das Lontras',
      'São José de Solonópole',
      'São José do Lagamar',
      'São José do Torto',
      'São João de Deus',
      'São João do Amanari',
      'São João do Jaguaribe',
      'São João dos Queiroz',
      'São Luís do Curu',
      'São Miguel',
      'São Pedro',
      'São Pedro do Gavião',
      'São Pedro do Norte',
      'São Raimundo',
      'São Romão',
      'São Roque',
      'São Vicente',
      'Sítio Alegre',
      'Sítios Novos',
      'Tabainha',
      'Taboleiro',
      'Tabuleiro do Norte',
      'Tamboril',
      'Tangente',
      'Tanques',
      'Tapera',
      'Taperuaba',
      'Tapuiara',
      'Tapuio',
      'Targinos',
      'Tarrafas',
      'Tauá',
      'Taíba',
      'Tejuçuoca',
      'Tianguá',
      'Timbaúba dos Marinheiros',
      'Timonha',
      'Tipi',
      'Tomé',
      'Trairi',
      'Trapiá',
      'Trici',
      'Triunfo',
      'Triângulo',
      'Trussu',
      'Tróia',
      'Tucunduba',
      'Tucuns',
      'Tururu',
      'Tuína',
      'Ubajara',
      'Ubaúna',
      'Ubiraçu',
      'Uiraponga',
      'Umari',
      'Umarituba',
      'Umarizeiras',
      'Umirim',
      'União',
      'Unió',
      'Uruburetama',
      'Uruoca',
      'Uruquê',
      'Varjota',
      'Vazantes',
      'Vazente do Curú',
      'Velame',
      'Vertentes do Lagedo',
      'Video',
      'Vila Soares',
      'Vista Alegre',
      'Viçosa do Ceará',
      'Várzea',
      'Várzea Alegre',
      'Várzea da Onça',
      'Várzea da Volta',
      'Várzea do Gilo',
      'Várzea dos Espinhos',
      'Água Verde',
      'Águas Belas',
    ],
    'BR-DF': [
      'Brasília',
      'Brazlândia',
      'Candangolândia',
      'Ceilândia',
      'Cruzeiro',
      'Guará',
      'Lago Norte',
      'Lago Sul',
      'Novo Gama',
      'Núcleo Bandeirante',
      'Paranoá',
      'Planaltina',
      'Recanto das Emas',
      'Riacho Fundo',
      'Samambaia',
      'Taguatinga',
      'Águas Claras',
    ],
    'BR-ES': [
      'Acioli',
      'Afonso Cláudio',
      'Aghá',
      'Airituba',
      'Alfredo Chaves',
      'Alto Caldeirão',
      'Alto Calçado',
      'Alto Castelinho',
      'Alto Mutum Preto',
      'Alto Rio Novo',
      'Alto Santa Maria',
      'Anchieta',
      'Anutiba',
      'Apiacá',
      'Aracruz',
      'Aracui',
      'Aracê',
      'Araguaia',
      'Araraí',
      'Araçatiba',
      'Argolas',
      'Atílio Vivácqua',
      'Baixo Guandu',
      'Barra Seca',
      'Barra de São Francisco',
      'Baunilha',
      'Bebedouro',
      'Boapaba',
      'Bom Jesus do Norte',
      'Braço do Rio',
      'Brejetuba',
      'Burarama',
      'Cachoeirinha de Itaúna',
      'Cachoeiro de Itapemirim',
      'Café',
      'Calogi',
      'Carapina',
      'Cariacica',
      'Castelo',
      'Celina',
      'Colatina',
      'Conceição da Barra',
      'Conceição do Castelo',
      'Conceição do Muqui',
      'Conduru',
      'Cotaxé',
      'Coutinho',
      'Cristal do Norte',
      'Crubixá',
      'Câmara',
      'Córrego Moacyr Ávidos',
      'Córrego dos Monos',
      'Desengano',
      'Divino Espírito Santo',
      'Divino de São Lourenço',
      'Djalma Coutinho',
      'Domingos Martins',
      'Dona América',
      'Dores do Rio Preto',
      'Duas Barras',
      'Ecoporanga',
      'Estrela do Norte',
      'Fartura',
      'Fazenda Guandu',
      'Fundão',
      'Garrafão',
      'Gironda',
      'Goiabeiras',
      'Governador Lacerda de Aguiar',
      'Governador Lindenberg',
      'Graça Aranha',
      'Gruta',
      'Guarapari',
      'Guararema',
      'Guaçuí',
      'Ibatiba',
      'Ibicaba',
      'Ibiraçu',
      'Ibitirama',
      'Ibitiruí',
      'Ibituba',
      'Iconha',
      'Imburana',
      'Iriritiba',
      'Irundi',
      'Irupi',
      'Isabel',
      'Itabaiana',
      'Itaguaçu',
      'Itaicí',
      'Itaimbé',
      'Itaipava',
      'Itapecoá',
      'Itapemirim',
      'Itaperuna',
      'Itapina',
      'Itaquari',
      'Itarana',
      'Itauninhas',
      'Itaçu',
      'Itaóca',
      'Itaúnas',
      'Iúna',
      'Jabaquara',
      'Jaciguá',
      'Jacupemba',
      'Jaguaré',
      'Jerônimo Monteiro',
      'Joatuba',
      'Joaçuba',
      'José Carlos',
      'João Neiva',
      'Jurama',
      'Lajinha',
      'Laranja da Terra',
      'Linhares',
      'Mangaraí',
      'Mantenópolis',
      'Marataízes',
      'Marechal Floriano',
      'Marilândia',
      'Matilde',
      'Melgaço',
      'Mimoso do Sul',
      'Montanha',
      'Monte Carmelo do Rio Novo',
      'Monte Pio',
      'Monte Sinai',
      'Morello',
      'Mucurici',
      'Muniz Freire',
      'Muqui',
      'Nestor Gomes',
      'Nossa Senhora das Graças',
      'Nossa Senhora de Fátima',
      'Nova Almeida',
      'Nova Venécia',
      'Nova Verona',
      'Novo Brasil',
      'Pacotuba',
      'Paineiras',
      'Palmeira',
      'Palmerino',
      'Pancas',
      'Paraju',
      'Paulista',
      'Pedro Canário',
      'Pendanga',
      'Pequiá',
      'Piaçu',
      'Pinheiros',
      'Piracema',
      'Piúma',
      'Ponte de Itabapoana',
      'Ponto Belo',
      'Pontões',
      'Porangá',
      'Praia Grande',
      'Presidente Kennedy',
      'Princesa',
      'Prosperidade',
      'Queimado',
      'Quilômetro 14 do Mutum',
      'Regência',
      'Riacho',
      'Ribeirão do Cristo',
      'Rio Bananal',
      'Rio Calçado',
      'Rio Muqui',
      'Rio Novo do Sul',
      'Rio Preto',
      'Rive',
      'Sagrada Família',
      'Santa Angélica',
      'Santa Cruz',
      'Santa Cruz de Irupi',
      'Santa Júlia',
      'Santa Leopoldina',
      'Santa Luzia de Mantenópolis',
      'Santa Luzia do Azul',
      'Santa Maria de Jetibá',
      'Santa Maria de Marechal',
      'Santa Marta',
      'Santa Teresa',
      'Santo Agostinho',
      'Santo Antônio do Canaã',
      'Santo Antônio do Muqui',
      'Santo Antônio do Pousalegre',
      'Santo Antônio do Quinze',
      'Santíssima Trindade',
      'Serra',
      'Serra Pelada',
      'Sobreiro',
      'Sooretama',
      'São Domingos do Norte',
      'São Francisco Xavier do Guandu',
      'São Gabriel da Palha',
      'São Geraldo',
      'São Jacinto',
      'São Jorge da Barra Seca',
      'São Jorge do Oliveira',
      'São Jorge do Tiradentes',
      'São José das Torres',
      'São José de Fruteiras',
      'São José de Mantenópolis',
      'São José do Calçado',
      'São José do Sobradinho',
      'São João de Petrópolis',
      'São João de Viçosa',
      'São João do Norte',
      'São João do Príncipe',
      'São João do Sobrado',
      'São Mateus',
      'São Pedro de Itabapoana',
      'São Pedro de Rates',
      'São Rafael',
      'São Raimundo da Pedra Menina',
      'São Roque do Canaã',
      'São Tiago',
      'Timbuí',
      'Todos os Santos',
      'Urânia',
      'Vargem Alta',
      'Vargem Grande do Soturno',
      'Venda Nova do Imigrante',
      'Viana',
      'Vieira Machado',
      'Vila Nelita',
      'Vila Nova de Bananal',
      'Vila Pavão',
      'Vila Valério',
      'Vila Verde',
      'Vinhático',
      'Vinte e Cinco de Julho',
      'Vitória',
      'Água Doce do Norte',
      'Águia Branca',
      'Ângelo Frechiani',
    ],
    'BR-GO': [
      'Abadia de Goiás',
      'Abadiânia',
      'Acreúna',
      'Adelândia',
      'Alexânia',
      'Aloândia',
      'Alto Alvorada',
      'Alto Horizonte',
      'Alto Paraíso de Goiás',
      'Alvorada do Norte',
      'Amaralina',
      'Americano do Brasil',
      'Amorinópolis',
      'Anhangüera',
      'Anicuns',
      'Anápolis',
      'Aparecida',
      'Aparecida de Goiás',
      'Aparecida de Goiânia',
      'Aparecida do Rio Claro',
      'Aparecida do Rio Doce',
      'Aporé',
      'Aragarças',
      'Aragoiânia',
      'Araguapaz',
      'Arantina',
      'Araçu',
      'Arenópolis',
      'Aruanã',
      'Aurilândia',
      'Auriverde',
      'Avelinópolis',
      'Bacilândia',
      'Baliza',
      'Bandeirantes',
      'Barbosilândia',
      'Bela Vista de Goiás',
      'Bezerra',
      'Bom Jardim de Goiás',
      'Bom Jesus',
      'Bom Jesus de Goiás',
      'Bonfinópolis',
      'Bonópolis',
      'Brazabrantes',
      'Britânia',
      'Buenolândia',
      'Buriti Alegre',
      'Buriti de Goiás',
      'Buritinópolis',
      'Cabeceiras',
      'Cachoeira Alta',
      'Cachoeira Dourada',
      'Cachoeira de Goiás',
      'Caiapônia',
      'Calcilândia',
      'Caldas Novas',
      'Caldazinha',
      'Calixto',
      'Campestre de Goiás',
      'Campinaçu',
      'Campinorte',
      'Campo Alegre de Goiás',
      'Campo Limpo',
      'Campo Limpo de Goiás',
      'Campo Lindo',
      'Campolândia',
      'Campos Lindos',
      'Campos Verdes',
      'Canadá',
      'Capelinha',
      'Caraíba',
      'Carmo do Rio Verde',
      'Castelândia',
      'Castrinópolis',
      'Catalão',
      'Caturaí',
      'Cavalcante',
      'Cavalheiro',
      'Caçu',
      'Cebrasa',
      'Ceres',
      'Cezarina',
      'Chapadão do Céu',
      'Choupana',
      'Cibele',
      'Cidade Eclética',
      'Cidade Ocidental',
      'Cirilândia',
      'Claudinápolis',
      'Cocalzinho de Goiás',
      'Colinas do Sul',
      'Colinaçu',
      'Corumbaíba',
      'Corumbá de Goiás',
      'Cristalina',
      'Cristianópolis',
      'Crixás',
      'Cromínia',
      'Cruzeiro do Norte',
      'Cumari',
      'Córrego Rico',
      'Córrego do Ouro',
      'Damianópolis',
      'Damolândia',
      'Davidópolis',
      'Davinópolis',
      'Diolândia',
      'Diorama',
      'Divinópolis de Goiás',
      'Domiciano Ribeiro',
      'Doverlândia',
      'Edealina',
      'Edilândia',
      'Edéia',
      'Faina',
      'Fazenda Nova',
      'Firminópolis',
      'Flores de Goiás',
      'Formoso',
      'Forte',
      'Gameleira de Goiás',
      'Geriaçu',
      'Girassol',
      'Goialândia',
      'Goiandira',
      'Goianira',
      'Goianápolis',
      'Goianésia',
      'Goiatuba',
      'Goiás',
      'Goiânia',
      'Gouvelândia',
      'Guapó',
      'Guarani de Goiás',
      'Guaraíta',
      'Guarinos',
      'Heitoraí',
      'Hidrolina',
      'Iaciara',
      'Inaciolândia',
      'Indiara',
      'Inhumas',
      'Interlândia',
      'Ipameri',
      'Ipiranga de Goiás',
      'Iporá',
      'Israelândia',
      'Itaberaí',
      'Itaguari',
      'Itaguaru',
      'Itajá',
      'Itapaci',
      'Itapirapuã',
      'Itapuranga',
      'Itarumã',
      'Itauçu',
      'Itumbiara',
      'Ivolândia',
      'JK',
      'Jacilândia',
      'Jandaia',
      'Jaraguá',
      'Jardim Abc De Goias',
      'Jataí',
      'Jaupaci',
      'Jeroaquara',
      'Jesúpolis',
      'Joanápolis',
      'Joviânia',
      'Juscelino Kubitschek',
      'Juscelândia',
      'Lagoa Santa',
      'Lagoa do Bauzinho',
      'Lagolândia',
      'Leopoldo de Bulhões',
      'Lucilândia',
      'Luiz Alves',
      'Luziânia',
      'Mairipotaba',
      'Mambaí',
      'Mara Rosa',
      'Marcianópolis',
      'Marzagão',
      'Matrinchã',
      'Maurilândia',
      'Meia Ponte',
      'Messianópolis',
      'Mimoso de Goiás',
      'Minaçu',
      'Mineiros',
      'Moiporá',
      'Monte Alegre de Goiás',
      'Montes Claros de Goiás',
      'Montividiu',
      'Montividiu do Norte',
      'Morro Agudo de Goiás',
      'Mossâmedes',
      'Mozarlândia',
      'Mutunópolis',
      'Natinópolis',
      'Nazário',
      'Nerópolis',
      'Niquelândia',
      'Nova América',
      'Nova Aurora',
      'Nova Crixás',
      'Nova Glória',
      'Nova Iguaçu de Goiás',
      'Nova Roma',
      'Novo Goiás',
      'Novo Planalto',
      'Olaria do Angico',
      "Olhos D'Água",
      'Orizona',
      'Ouro Verde de Goiás',
      'Ouroana',
      'Ouvidor',
      'Padre Bernardo',
      'Palestina de Goiás',
      'Palmeiras de Goiás',
      'Palmelo',
      'Palminópolis',
      'Panamá',
      'Paranaiguara',
      'Paraúna',
      'Perolândia',
      'Petrolina de Goiás',
      'Pilar de Goiás',
      'Pilôandia',
      'Piracanjuba',
      'Pirenópolis',
      'Pires Belo',
      'Pires do Rio',
      'Planalmira',
      'Pontalina',
      'Porangatu',
      'Porteirão',
      'Portelândia',
      'Posse',
      "Posse D'Abadia",
      'Posselândia',
      'Professor Jamil',
      'Quirinópolis',
      'Registro do Araguaia',
      'Rialma',
      'Rianápolis',
      'Rio Quente',
      'Rio Verde',
      'Riverlândia',
      'Rosalândia',
      'Rubiataba',
      'Sanclerlândia',
      'Santa Bárbara de Goiás',
      'Santa Cruz das Lajes',
      'Santa Cruz de Goiás',
      'Santa Fé de Goiás',
      'Santa Helena de Goiás',
      'Santa Isabel',
      'Santa Rita do Araguaia',
      'Santa Rita do Novo Destino',
      'Santa Rosa de Goiás',
      'Santa Tereza de Goiás',
      'Santa Terezinha de Goiás',
      'Santo Antônio da Barra',
      'Santo Antônio da Esperança',
      'Santo Antônio de Goiás',
      'Santo Antônio do Descoberto',
      'Santo Antônio do Rio Verde',
      'Sarandi',
      'Senador Canedo',
      'Serranópolis',
      'Silvânia',
      'Simolândia',
      'Sousânia',
      'Souzalândia',
      'São Francisco de Goiás',
      'São Gabriel de Goiás',
      'São Jorge',
      "São João D'Aliança",
      'São João da Paraúna',
      'São Luiz do Tocantins',
      'São Luís de Montes Belos',
      'São Luíz do Norte',
      'São Miguel do Araguaia',
      'São Miguel do Passa Quatro',
      'São Patrício',
      'São Sebastião do Rio Claro',
      'São Simão',
      "Sítio D'Abadia",
      'Taquaral de Goiás',
      'Taveira',
      'Teresina de Goiás',
      'Terezópolis de Goiás',
      'Trevo do José Rosário',
      'Trindade',
      'Trombas',
      'Três Ranchos',
      'Tupiracaba',
      'Turvelândia',
      'Turvânia',
      'Uirapuru',
      'Uruana',
      'Uruaçu',
      'Uruita',
      'Urutaí',
      'Uvá',
      'Valdelândia',
      'Valparaíso de Goiás',
      'Varjão',
      'Vazante',
      'Vianópolis',
      'Vicentinópolis',
      'Vila Boa',
      'Vila Propício',
      'Vila Sertaneja',
      'Água Fria de Goiás',
      'Água Limpa',
      'Águas Lindas de Goiás',
    ],
    'BR-MA': [
      'Afonso Cunha',
      'Alcântara',
      'Aldeias Altas',
      'Altamira do Maranhão',
      'Alto Alegre do Maranhão',
      'Alto Alegre do Pindaré',
      'Alto Parnaíba',
      'Amapá do Maranhão',
      'Amarante do Maranhão',
      'Anajatuba',
      'Anapurus',
      'Apicum-Açu',
      'Araguanã',
      'Araioses',
      'Arame',
      'Arari',
      'Aurizona',
      'Axixá',
      'Açailândia',
      'Bacabal',
      'Bacabeira',
      'Bacatuba',
      'Bacuri',
      'Bacurituba',
      'Balsas',
      'Barra do Corda',
      'Barreirinhas',
      'Barro Duro',
      'Barão de Grajaú',
      'Barão de Tromai',
      'Bela Vista do Maranhão',
      'Belágua',
      'Benedito Leite',
      'Bequimão',
      'Bernardo do Mearim',
      'Boa Vista do Gurupi',
      'Boa Vista do Pindaré',
      'Bom Jesus das Selvas',
      'Bom Lugar',
      'Bonfim do Arari',
      'Brejo',
      'Brejo de Areia',
      'Brejo de São Félix',
      'Buriti',
      'Buriti Bravo',
      'Buriti Cortado',
      'Buriticupu',
      'Buritirana',
      'Cajapió',
      'Cajari',
      'Campestre do Maranhão',
      'Cantanhede',
      'Capinzal do Norte',
      'Caraíba do Norte',
      'Carolina',
      'Carutapera',
      'Caxias',
      'Cedral',
      'Central do Maranhão',
      'Centro Novo do Maranhão',
      'Centro do Guilherme',
      'Chapadinha',
      'Cidelândia',
      'Codozinho',
      'Codó',
      'Coelho Neto',
      'Colinas',
      'Conceição do Lago-Açu',
      'Coroatá',
      'Curupa',
      'Cururupu',
      'Curva Grande',
      'Custódio Lima',
      'Cândido Mendes',
      'Dom Pedro',
      'Duque Bacelar',
      'Esperantinópolis',
      'Estandarte',
      'Estreito',
      'Feira Nova do Maranhão',
      'Fernando Falcão',
      'Formosa da Serra Negra',
      'Fortaleza dos Nogueiras',
      'Fortuna',
      'Frecheiras',
      'Godofredo Viana',
      'Gonçalves Dias',
      'Governador Archer',
      'Governador Edison Lobão',
      'Governador Eugênio Barros',
      'Governador Luiz Rocha',
      'Governador Newton Bello',
      'Governador Nunes Freire',
      'Grajaú',
      'Guimarães',
      'Humberto de Campos',
      'Ibipira',
      'Icatu',
      'Igarapé Grande',
      'Igarapé do Meio',
      'Imperatriz',
      'Itaipava do Grajaú',
      'Itamataré',
      'Itapecuru Mirim',
      'Itapera',
      'Itinga do Maranhão',
      'Jatobá',
      'Jenipapo dos Vieiras',
      'Joselândia',
      'João Lisboa',
      'Junco do Maranhão',
      'Lago Verde',
      'Lago da Pedra',
      'Lago do Junco',
      'Lago dos Rodrigues',
      'Lagoa Grande do Maranhão',
      'Lajeado Novo',
      'Lapela',
      'Leandro',
      'Luís Domingues',
      'Magalhães de Almeida',
      'Maioba',
      'Maracaçumé',
      'Marajá do Sena',
      'Maranhãozinho',
      'Marianópolis',
      'Mata',
      'Mata Roma',
      'Matões',
      'Matões do Norte',
      'Milagres do Maranhão',
      'Mirador',
      'Miranda do Norte',
      'Mirinzal',
      'Montes Altos',
      'Monção',
      'Morros',
      'Nina Rodrigues',
      'Nova Colinas',
      'Nova Iorque',
      'Nova Olinda do Maranhão',
      "Olho D'Água das Cunhãs",
      'Olinda Nova do Maranhão',
      'Palmeirândia',
      'Papagaio',
      'Paraibano',
      'Parnarama',
      'Passagem Franca',
      'Pastos Bons',
      'Paulino Neves',
      'Paulo Ramos',
      'Paço do Lumiar',
      'Pedreiras',
      'Pedro do Rosário',
      'Penalva',
      'Peri Mirim',
      'Peritoró',
      'Pimentel',
      'Pindaré-Mirim',
      'Pinheiro',
      'Pio XII',
      'Pirapemas',
      'Porto Franco',
      'Porto Rico do Maranhão',
      'Porto das Gabarras',
      'Poção de Pedras',
      'Presidente Juscelino',
      'Presidente Médici',
      'Presidente Sarney',
      'Presidente Vargas',
      'Primeira Cruz',
      'Raposa',
      'Resplandes',
      'Ribamar Fiquene',
      'Ribeirão Azul',
      'Rocado',
      'Roque',
      'Santa Filomena do Maranhão',
      'Santa Helena',
      'Santa Luzia do Paruá',
      'Santa Quitéria do Maranhão',
      'Santana do Maranhão',
      'Santo Amaro do Maranhão',
      'Santo Antônio dos Lopes',
      'Satubinha',
      'Senador Alexandre Costa',
      'Senador La Rocque',
      'Senador La Roque',
      'Serrano do Maranhão',
      'Sucupira do Norte',
      'Sucupira do Riachão',
      'São Benedito do Rio Preto',
      'São Bento',
      'São Domingos do Azeitão',
      'São Domingos do Maranhão',
      'São Francisco do Brejão',
      'São Francisco do Maranhão',
      'São Félix de Balsas',
      'São Joaquim dos Melos',
      'São José de Ribamar',
      'São José dos Basílios',
      'São João Batista',
      'São João de Cortes',
      'São João do Carú',
      'São João do Paraíso',
      'São João do Sóter',
      'São João dos Patos',
      'São Luís',
      'São Luís Gonzaga do Maranhão',
      'São Mateus do Maranhão',
      'São Pedro da Água Branca',
      'São Pedro dos Crentes',
      'São Raimundo das Mangabeiras',
      'São Raimundo de Codó',
      'São Raimundo do Doca Bezerra',
      'São Roberto',
      'São Vicente Ferrer',
      'Tasso Fragoso',
      'Timbiras',
      'Timon',
      'Trizidela do Vale',
      'Tufilândia',
      'Tuntum',
      'Turiaçu',
      'Turilândia',
      'Tutóia',
      'Urbano Santos',
      'Vargem Grande',
      'Vila Nova dos Martírios',
      'Vitorino Freire',
      'Vitória do Mearim',
      'Zé Doca',
      'Água Doce do Maranhão',
    ],
    'BR-MT': [
      'Acorizal',
      'Aguapeí',
      'Aguaçu',
      'Ainhumas',
      'Alcantilado',
      'Alta Floresta',
      'Alto Araguaia',
      'Alto Boa Vista',
      'Alto Coité',
      'Alto Garças',
      'Alto Juruena',
      'Alto Paraguai',
      'Alto Paraíso',
      'Alto Taquari',
      'Analândia do Norte',
      'Apiacás',
      'Araguaiana',
      'Araguainha',
      'Araputanga',
      'Arenápolis',
      'Aripuanã',
      'Arruda',
      'Assari',
      'Barra do Bugres',
      'Barra do Garças',
      'Barão de Melgaço',
      'Batovi',
      'Bauxi',
      'Baús',
      'Bel Rios',
      'Bezerro Branco',
      'Bocaiuval',
      'Bom Jesus do Araguaia',
      'Bom Sucesso',
      'Brasnorte',
      'Brianorte',
      'Caite',
      'Campinápolis',
      'Campo Novo do Parecis',
      'Campo Verde',
      'Campos Novos',
      'Campos de Júlio',
      'Canabrava do Norte',
      'Cangas',
      'Capão Grande',
      'Capão Verde',
      'Caramujo',
      'Caravagio',
      'Carlinda',
      'Cassununga',
      'Castanheira',
      'Catuai',
      'Chapada dos Guimarães',
      'Cidade Morena',
      'Cláudia',
      'Cocalinho',
      'Colniza',
      'Colorado do Norte',
      'Colíder',
      'Comodoro',
      'Comunidade Parque Boa Vista',
      'Confresa',
      "Conquista D'Oeste",
      'Coronel Ponce',
      'Cotrel',
      'Cotriguaçu',
      'Coxipó Açu',
      'Coxipó da Ponte',
      'Coxipó do Ouro',
      'Cristinópolis',
      'Cristo Rei',
      'Cuiabá',
      'Curvelândia',
      'Cáceres',
      'Del Rios',
      'Denise',
      'Diamantino',
      'Dom Aquino',
      'Engenho',
      'Espigão do Leste',
      'Estrela do Leste',
      'Faval',
      'Fazenda de Cima',
      'Feliz Natal',
      "Figueirópolis D'Oeste",
      'Flor da Serra',
      'Fontanilhas',
      'Gaúcha do Norte',
      'General Carneiro',
      "Glória D'Oeste",
      'Groslândia',
      'Guarantã do Norte',
      'Guariba',
      'Guarita',
      'Guiratinga',
      'Horizonte do Oeste',
      'Indianápolis',
      'Indiavaí',
      'Ipiranga do Norte',
      'Irenópolis',
      'Itamarati Norte',
      'Itanhangá',
      'Itanorte',
      'Itaúba',
      'Itiquira',
      'Jaciara',
      'Jangada',
      'Jarudore',
      'Jauru',
      'Juara',
      'Juruena',
      'Juscimeira',
      'Juína',
      "Lambari D'Oeste",
      'Lavouras',
      'Lucas do Rio Verde',
      'Lucialva',
      'Luciara',
      'Machado',
      'Marcelândia',
      'Marechal Rondon',
      'Mata Dentro',
      'Matupá',
      "Mirassol D'Oeste",
      'Monte Castelo do Oeste',
      'Nobres',
      'Nonoai do Norte',
      'Nortelândia',
      'Nossa Senhora da Guia',
      'Nova Alvorada',
      'Nova Bandeirantes',
      'Nova Brasilândia',
      'Nova Canaã do Norte',
      'Nova Catanduva',
      'Nova Cáceres',
      'Nova Esperança',
      'Nova Galileia',
      'Nova Guarita',
      'Nova Lacerda',
      'Nova Marilândia',
      'Nova Maringá',
      'Nova Monte Verde',
      'Nova Mutum',
      'Nova Nazaré',
      'Nova Olímpia',
      'Nova Primavera',
      'Nova Santa Helena',
      'Nova Ubiratã',
      'Nova Xavantina',
      'Novo Diamantino',
      'Novo Eldorado',
      'Novo Horizonte do Norte',
      'Novo Mato Grosso',
      'Novo Mundo',
      'Novo Paraná',
      'Novo Santo Antônio',
      'Novo São Joaquim',
      'Padronal',
      'Pai André',
      'Paranatinga',
      'Paranaíta',
      'Paraíso do Leste',
      'Parque Água Limpa',
      'Passagem da Conceição',
      'Pedra Preta',
      'Pedro Neca',
      'Peixoto de Azevedo',
      'Piratininga',
      'Pirizal',
      'Placa de Santo Antônio',
      'Planalto da Serra',
      'Poconé',
      'Pombas',
      'Pontal do Araguaia',
      'Ponte Branca',
      'Ponte de Pedra',
      'Pontes e Lacerda',
      'Pontinópolis',
      'Porto Alegre do Norte',
      'Porto Esperidião',
      'Porto Estrela',
      'Porto dos Gaúchos',
      'Poxoréo',
      'Poxoréu',
      'Praia Rica',
      'Primavera',
      'Primavera do Leste',
      'Progresso',
      'Querência',
      'Rancharia',
      'Reserva do Cabaçal',
      'Ribeirão Cascalheira',
      'Ribeirão dos Cocais',
      'Ribeirãozinho',
      'Rio Manso',
      'Riolândia',
      'Rondolândia',
      'Rondonópolis',
      'Rosário Oeste',
      'Salto do Céu',
      'Sangradouro',
      'Santa Carmem',
      'Santa Clara do Monte Cristo',
      'Santa Cruz do Xingu',
      'Santa Elvira',
      'Santa Rita do Trivelato',
      'Santa Terezinha do Rio Ferro',
      'Santaninha',
      'Santo Afonso',
      'Santo Antonio do Rio Bonito',
      'Santo Antônio do Leste',
      'Santo Antônio do Leverger',
      'Sapezal',
      'Selma',
      'Serra Nova Dourada',
      'Sinop',
      'Sonho Azul',
      'Sorriso',
      'Sumidouro',
      'São Félix do Araguaia',
      'São José do Apuí',
      'São José do Pingador',
      'São José do Planalto',
      'São José do Povo',
      'São José do Rio Claro',
      'São José do Xingu',
      'São José dos Quatro Marcos',
      'São Lourenço de Fátima',
      'São Pedro da Cipa',
      'Tabaporã',
      'Tangará da Serra',
      'Tapirapua',
      'Tapurah',
      'Terra Nova do Norte',
      'Terra Roxa',
      'Tesouro',
      'Toricueyje',
      'Torixoréu',
      'Três Pontes',
      'União do Sul',
      'Vale Rico',
      'Vale de São Domingos',
      'Vale dos Sonhos',
      'Veranópolis',
      'Vila Atlântica',
      'Vila Bela da Santíssima Trindade',
      'Vila Bueno',
      'Vila Cardoso',
      'Vila Mutum',
      'Vila Operária',
      'Vila Paulista',
      'Vila Progresso',
      'Vila Rica',
      'Várzea Grande',
      'Água Boa',
      'Água da Prata',
    ],
    'BR-MS': [
      'Albuquerque',
      'Alcinópolis',
      'Alto Sucuriú',
      'Amambai',
      'Amandina',
      'Amolar',
      'Anastácio',
      'Anaurilândia',
      'Angélica',
      'Anhandui',
      'Antônio João',
      'Aparecida do Taboado',
      'Aquidauana',
      'Aral Moreira',
      'Arapuã',
      'Areado',
      'Bataguassu',
      'Bataiporã',
      'Batayporã',
      'Bela Alvorada',
      'Bocajá',
      'Bodoquena',
      'Bom Fim',
      'Brasilândia',
      'Caarapó',
      'Cabeceira do Apá',
      'Camapuã',
      'Camisão',
      'Capão Seco',
      'Caracol',
      'Carumbé',
      'Cassilândia',
      'Chapadão do Sul',
      'Cipolândia',
      'Coimbra',
      'Congonhas',
      'Corguinho',
      'Coronel Sapucaia',
      'Corumbá',
      'Costa Rica',
      'Coxim',
      'Cruzaltina',
      'Culturama',
      'Cupins',
      'Debrasa',
      'Deodápolis',
      'Dois Irmãos do Buriti',
      'Douradina',
      'Dourados',
      'Figueirão',
      'Fátima do Sul',
      'Garcias',
      'Glória de Dourados',
      'Guadalupe do Alto Paraná',
      'Guaçu',
      'Guaçulândia',
      'Guia Lopes da Laguna',
      'Ilha Comprida',
      'Ilha Grande',
      'Indaiá Grande',
      'Indaiá do Sul',
      'Indápolis',
      'Inocência',
      'Ipezal',
      'Itahum',
      'Itaporã',
      'Itaquiraí',
      'Ivinhema',
      'Jabuti',
      'Jacareí',
      'Japorã',
      'Jaraguari',
      'Jateí',
      'Juti',
      'Ladário',
      'Lagoa Bonita',
      'Laguna Carapã',
      'Maracaju',
      'Montese',
      'Morangas',
      'Morraria do Sul',
      'Morumbi',
      'Naviraí',
      'Nhecolândia',
      'Nioaque',
      'Nova Alvorada do Sul',
      'Nova Andradina',
      'Nova Casa Verde',
      'Nova Jales',
      'Novo Horizonte do Sul',
      'Oriente',
      'Paiaguás',
      'Pana',
      'Panambi',
      'Paranaíba',
      'Paranhos',
      'Paraíso das Águas',
      'Pedro Gomes',
      'Picadinha',
      'Pirapora',
      'Piraputanga',
      'Ponta Porã',
      'Ponte Vermelha',
      'Pontinha do Cocho',
      'Porto Esperança',
      'Porto Murtinho',
      'Porto Vilma',
      'Porto XV de Novembro',
      'Presidente Castelo',
      'Prudêncio Thomaz',
      'Quebra Côco',
      'Quebracho',
      'Ribas do Rio Pardo',
      'Rio Brilhante',
      'Rio Negro',
      'Rio Verde de Mato Grosso',
      'Rochedinho',
      'Rochedo',
      'Sanga Puitã',
      'Santa Rita do Pardo',
      'Selvíria',
      'Sete Quedas',
      'Sidrolândia',
      'Sonora',
      'São Gabriel do Oeste',
      'São José do Sucuriú',
      'São João do Apore',
      'Tacuru',
      'Tamandaré',
      'Taquari',
      'Taquarussu',
      'Taunay',
      'Terenos',
      'Três Lagoas',
      'Velhacaria',
      'Vicentina',
      'Vila Formosa',
      'Vila Marques',
      'Vila União',
      'Vila Vargas',
      'Água Clara',
      'Árvore Grande',
    ],
    'BR-MG': [
      'Abadia dos Dourados',
      'Abaeté',
      'Abaeté dos Mendes',
      'Abaíba',
      'Abre Campo',
      'Abreus',
      'Acaiaca',
      'Acuruí',
      'Adão Colares',
      'Aguanil',
      'Aimorés',
      'Aiuruoca',
      'Alagoa',
      'Albertina',
      'Alberto Isaacson',
      'Albertos',
      'Aldeia',
      'Alegria',
      'Alexandrita',
      'Alfenas',
      'Alfredo Vasconcelos',
      'Almeida',
      'Almenara',
      'Alpercata',
      'Alpinópolis',
      'Alterosa',
      'Alto Belo',
      'Alto Caparaó',
      'Alto Capim',
      'Alto Jequitibá',
      'Alto Maranhão',
      'Alto Rio Doce',
      'Alto de Santa Helena',
      'Altolândia',
      'Alvarenga',
      'Alvação',
      'Alvinópolis',
      'Alvorada',
      'Alvorada de Minas',
      'Além Paraíba',
      'Amanda',
      'Amanhece',
      'Amarantina',
      'Amparo da Serra',
      'Amparo do Serra',
      'Andiroba',
      'Andradas',
      'Andrelândia',
      'Andrequicé',
      'Angaturama',
      'Angelândia',
      'Angicos de Minas',
      'Angueretá',
      'Angustura',
      'Antunes',
      'Antônio Carlos',
      'Antônio Dias',
      'Antônio Ferreira',
      'Antônio Pereira',
      'Antônio Prado de Minas',
      'Antônio dos Santos',
      'Aparecida de Minas',
      'Aracati de Minas',
      'Aracitaba',
      'Araguari',
      'Aramirim',
      'Aranha',
      'Araponga',
      'Araporã',
      'Arapuá',
      'Araxá',
      'Araçaji de Minas',
      'Araçaí',
      'Araçuaí',
      'Araújos',
      'Araúna',
      'Arceburgo',
      'Arcos',
      'Arcângelo',
      'Argenita',
      'Argirita',
      'Aricanduva',
      'Arinos',
      'Aristides Batista',
      'Ascenção',
      'Assaraí',
      'Astolfo Dutra',
      'Ataléia',
      'Augusto de Lima',
      'Avaí do Jacinto',
      'Azurita',
      'Açucena',
      'Babilônia',
      'Baependi',
      'Baguari',
      'Baixa',
      'Baixa Quente',
      'Baiões',
      'Balbinópolis',
      'Baldim',
      'Bambuí',
      'Bandeira do Sul',
      'Barbacena',
      'Barra Alegre',
      'Barra Feliz',
      'Barra Longa',
      'Barra da Figueira',
      'Barra do Ariranha',
      'Barra do Cuieté',
      'Barranco Alto',
      'Barreiro',
      'Barreiro Branco',
      'Barreiro da Raiz',
      'Barreiro do Rio Verde',
      'Barretos de Alvinópolis',
      'Barroso',
      'Barão de Cocais',
      'Barão de Monte Alto',
      'Bação',
      'Bela Vista de Minas',
      'Belisário',
      'Belmiro Braga',
      'Belo Horizonte',
      'Belo Oriente',
      'Belo Vale',
      'Beltrão',
      'Bentópolis de Minas',
      'Berilo',
      'Berizal',
      'Bertópolis',
      'Betim',
      'Bias Fortes',
      'Bicas',
      'Bicuíba',
      'Biquinhas',
      'Bituri',
      'Boa Família',
      'Boa União de Itabirinha',
      'Boa Vista de Minas',
      'Boa Vista de Santa Maria',
      'Bocaina de Minas',
      'Bocaiúva',
      'Bom Despacho',
      'Bom Jardim das Pedras',
      'Bom Jardim de Minas',
      'Bom Jesus da Cachoeira',
      'Bom Jesus da Penha',
      'Bom Jesus de Angicos',
      'Bom Jesus de Cardosos',
      'Bom Jesus do Amparo',
      'Bom Jesus do Divino',
      'Bom Jesus do Galho',
      'Bom Jesus do Madeira',
      'Bom Jesus do Prata',
      'Bom Pastor',
      'Bom Repouso',
      'Bom Retiro',
      'Bom Sucesso de Patos',
      'Bonança',
      'Bonfinópolis de Minas',
      'Bonito de Minas',
      'Borba Gato',
      'Borda da Mata',
      'Botelhos',
      'Boticão',
      'Botumirim',
      'Brasilândia de Minas',
      'Brasília de Minas',
      'Brasópolis',
      'Braúnas',
      'Brejaubinha',
      'Brejaúba',
      'Brejo Bonito',
      'Brejo do Amparo',
      'Brumadinho',
      'Brumal',
      'Brás Pires',
      'Buarque de Macedo',
      'Bueno',
      'Bueno Brandão',
      'Buenópolis',
      'Bugre',
      'Buritis',
      'Buritizeiro',
      'Caatinga',
      'Cabeceira Grande',
      'Cabo Verde',
      'Caburu',
      'Cachoeira Alegre',
      'Cachoeira da Prata',
      'Cachoeira de Minas',
      'Cachoeira de Pajeú',
      'Cachoeira de Santa Cruz',
      'Cachoeira do Aranã',
      'Cachoeira do Brumado',
      'Cachoeira do Campo',
      'Cachoeira do Manteiga',
      'Cachoeira do Vale',
      'Cachoeira dos Antunes',
      'Cachoeirinha',
      'Caetano Lopes',
      'Caetanópolis',
      'Caeté',
      'Cafemirim',
      'Caiana',
      'Caiapó',
      'Cajuri',
      'Camacho',
      'Camanducaia',
      'Camargos',
      'Cambuquira',
      'Cambuí',
      'Campanha',
      'Campestrinho',
      'Campina Verde',
      'Campo Alegre de Minas',
      'Campo Azul',
      'Campo Belo',
      'Campo Florido',
      'Campo do Meio',
      'Campolide',
      'Campos Altos',
      'Campos Gerais',
      'Cana Verde',
      'Canabrava',
      'Canastrão',
      'Canoeiros',
      'Cantagalo',
      'Caparaó',
      'Capela Nova',
      'Capetinga',
      'Capim Branco',
      'Capinópolis',
      'Capitânia',
      'Capitão Andrade',
      'Capitão Enéas',
      'Capitólio',
      'Caputira',
      'Caranaíba',
      'Carandaí',
      'Carangola',
      'Caratinga',
      'Caraí',
      'Carbonita',
      'Careaçu',
      'Carioca',
      'Carlos Alves',
      'Carlos Chagas',
      'Carmo da Cachoeira',
      'Carmo da Mata',
      'Carmo de Minas',
      'Carmo do Cajuru',
      'Carmo do Paranaíba',
      'Carmo do Rio Claro',
      'Carmésia',
      'Carmópolis de Minas',
      'Carneirinho',
      'Carrancas',
      'Carvalhos',
      'Carvalhópolis',
      'Casa Grande',
      'Cascalho Rico',
      'Cataguarino',
      'Cataguases',
      'Catajás',
      'Catas Altas',
      'Catas Altas da Noruega',
      'Catiara',
      'Catuji',
      'Catuni',
      'Catuné',
      'Catuti',
      'Caxambu',
      'Caçaratiba',
      'Caçarema',
      'Cedro do Abaeté',
      'Centenário',
      'Central de Minas',
      'Central de Santa Helena',
      'Centralina',
      'Cervo',
      'Chalé',
      'Chapada Gaúcha',
      'Chapada de Minas',
      'Chapada do Norte',
      "Chapéu D'Uvas",
      'Chaves',
      'Chaveslândia',
      'Chiador',
      'Chonim',
      'Chonin de Baixo',
      'Chumbo',
      'Chácara',
      'Cipotânea',
      'Cisneiros',
      'Claraval',
      'Claro de Minas',
      'Claro dos Poções',
      'Cláudio',
      'Cláudio Manuel',
      'Cocais',
      'Coco',
      'Coluna',
      'Comendador Gomes',
      'Comercinho',
      'Conceição da Aparecida',
      'Conceição da Barra de Minas',
      'Conceição da Boa Vista',
      'Conceição da Brejaúba',
      'Conceição da Ibitipoca',
      'Conceição das Alagoas',
      'Conceição das Pedras',
      'Conceição de Ipanema',
      'Conceição de Itaguá',
      'Conceição de Minas',
      'Conceição de Piracicaba',
      'Conceição de Tronqueiras',
      'Conceição do Capim',
      'Conceição do Formoso',
      'Conceição do Mato Dentro',
      'Conceição do Pará',
      'Conceição do Rio Acima',
      'Conceição do Rio Verde',
      'Conceição dos Ouros',
      'Concórdia de Mucuri',
      'Condado do Norte',
      'Confins',
      'Congonhal',
      'Congonhas do Norte',
      'Conquista',
      'Conselheiro Lafaiete',
      'Conselheiro Mata',
      'Conselheiro Pena',
      'Consolação',
      'Contagem',
      'Contrato',
      'Contria',
      'Coqueiral',
      'Coração de Jesus',
      'Cordeiro de Minas',
      'Cordisburgo',
      'Cordislândia',
      'Corinto',
      'Coroaci',
      'Coromandel',
      'Coronel Fabriciano',
      'Coronel Murta',
      'Coronel Pacheco',
      'Coronel Xavier Chaves',
      'Correia de Almeida',
      'Correntinho',
      'Costa Sena',
      'Costas',
      'Costas da Mantiqueira',
      'Couto de Magalhães de Minas',
      'Crispim Jaques',
      'Cristiano Otoni',
      'Cristina',
      'Cristália',
      'Crisólia',
      'Crisólita',
      'Crucilândia',
      'Cruzeiro da Fortaleza',
      'Cruzeiro dos Peixotos',
      'Cruzinha',
      'Cruzília',
      'Cubas',
      'Cuité Velho',
      'Cuparaque',
      'Curimataí',
      'Curral Novo de Minas',
      'Curral de Dentro',
      'Curvelo',
      'Cássia',
      'Córrego Danta',
      'Córrego Fundo',
      'Córrego Novo',
      'Córrego do Barro',
      'Córrego do Bom Jesus',
      'Córrego dos Bernardes',
      'Córrego dos Borges',
      'Córrego dos Melquíades',
      'Córregos',
      'Cônego João Pio',
      'Cônego Marinho',
      'Datas',
      'Delfim Moreira',
      'Delfinópolis',
      'Delta',
      'Deputado Augusto Clementino',
      'Derribadinha',
      'Desembargador Otoni',
      'Desemboque',
      'Desterro de Entre Rios',
      'Desterro do Melo',
      'Diamante de Ubá',
      'Diamantina',
      'Dias',
      'Dias Tavares',
      'Diogo de Vasconcelos',
      'Dionísio',
      'Divino',
      'Divino das Laranjeiras',
      'Divino de Virgolândia',
      'Divinolândia de Minas',
      'Divinésia',
      'Divinópolis',
      'Divisa Alegre',
      'Divisa Nova',
      'Divisópolis',
      'Dois de Abril',
      'Dom Bosco',
      'Dom Cavati',
      'Dom Joaquim',
      'Dom Lara',
      'Dom Modesto',
      'Dom Silvério',
      'Dom Viçoso',
      'Dona Eusébia',
      'Dona Euzébia',
      'Dores da Vitória',
      'Dores de Campos',
      'Dores de Guanhães',
      'Dores do Indaiá',
      'Dores do Paraibuna',
      'Dores do Turvo',
      'Doresópolis',
      'Douradinho',
      'Douradoquara',
      'Doutor Campolina',
      'Doutor Lund',
      'Durandé',
      'Edgard Melo',
      'Elói Mendes',
      'Emboabas',
      'Engenheiro Caldas',
      'Engenheiro Correia',
      'Engenheiro Dolabela',
      'Engenheiro Navarro',
      'Engenheiro Schnoor',
      'Engenho Novo',
      'Engenho do Ribeiro',
      'Entre Folhas',
      'Entre Rios de Minas',
      'Epaminondas Otoni',
      'Era Nova',
      'Ermidinha',
      'Ervália',
      'Esmeraldas',
      'Esmeraldas de Ferros',
      'Espera Feliz',
      'Espinosa',
      'Espírito Santo do Dourado',
      'Esteios',
      'Estevão de Araújo',
      'Estiva',
      'Estrela Dalva',
      'Estrela da Barra',
      'Estrela de Jordânia',
      'Estrela do Indaiá',
      'Estrela do Sul',
      'Eugenópolis',
      'Euxenita',
      'Ewbank da Câmara',
      'Expedicionário Alício',
      'Extração',
      'Extrema',
      'Fama',
      'Faria',
      'Faria Lemos',
      'Farias',
      'Fechados',
      'Felicina',
      'Felisburgo',
      'Felixlândia',
      'Felício dos Santos',
      'Fernandes Tourinho',
      'Fernão Dias',
      'Ferreiras',
      'Ferreirópolis',
      'Ferros',
      'Ferruginha',
      'Fervedouro',
      'Fidalgo',
      'Fidelândia',
      'Flor de Minas',
      'Florestina',
      'Florália',
      'Fonseca',
      'Formiga',
      'Fortaleza de Minas',
      'Fortuna de Minas',
      'Francisco Badaró',
      'Francisco Dumont',
      'Francisco Sá',
      'Franciscópolis',
      'Frei Eustáquio',
      'Frei Gaspar',
      'Frei Inocêncio',
      'Frei Lagonegro',
      'Frei Orlando',
      'Frei Serafim',
      'Freire Cardoso',
      'Fronteira',
      'Fronteira dos Vales',
      'Fruta de Leite',
      'Frutal',
      'Funchal',
      'Funilândia',
      'Furquim',
      'Galego',
      'Galena',
      'Galiléia',
      'Gameleiras',
      'Garapuava',
      'Glaucilândia',
      'Glaura',
      'Glucínio',
      'Glória de Cataguases',
      'Goiabal',
      'Goiabeira',
      'Goiaminas',
      'Goianases',
      'Goianá',
      'Gonçalves',
      'Gororós',
      'Gorutuba',
      'Gouveia',
      'Governador Valadares',
      'Gramínea',
      'Granada',
      'Grota',
      'Grupiara',
      'Grão Mogol',
      'Guaicui',
      'Guaipava',
      'Guanhães',
      'Guapé',
      'Guaraciaba',
      'Guaraciama',
      'Guarani',
      'Guaranilândia',
      'Guaranésia',
      'Guarará',
      'Guarataia',
      'Guarda dos Ferreiros',
      'Guarda-Mor',
      'Guardinha',
      'Guaxima',
      'Guaxupé',
      'Guidoval',
      'Guimarânia',
      'Guinda',
      'Guiricema',
      'Gurinhatã',
      'Heliodora',
      'Hematita',
      'Hermilo Alves',
      'Honorópolis',
      'Iapu',
      'Ibertioga',
      'Ibiaí',
      'Ibiracatu',
      'Ibiraci',
      'Ibirité',
      'Ibitiúra de Minas',
      'Ibituruna',
      'Ibiá',
      'Icaraí de Minas',
      'Igarapé',
      'Igaratinga',
      'Iguatama',
      'Ijaci',
      'Ilha do Rio Doce',
      'Ilhéus do Prata',
      'Ilicínea',
      'Imbé de Minas',
      'Inconfidentes',
      'Indaiabira',
      'Indianópolis',
      'Ingaí',
      'Inhapim',
      'Inhaí',
      'Inhaúma',
      'Inimutaba',
      'Ipaba',
      'Ipanema',
      'Ipatinga',
      'Ipiaçu',
      'Ipoema',
      'Ipuiúna',
      'Iraí de Minas',
      'Itabira',
      'Itabirinha',
      'Itabirinha de Mantena',
      'Itabirito',
      'Itaboca',
      'Itacambira',
      'Itacarambi',
      'Itaci',
      'Itacolomi',
      'Itaguara',
      'Itaim',
      'Itaipé',
      'Itajubá',
      'Itajutiba',
      'Itamarandiba',
      'Itamarati de Minas',
      'Itambacuri',
      'Itambé do Mato Dentro',
      'Itamirim',
      'Itamogi',
      'Itamonte',
      'Itamuri',
      'Itanhandu',
      'Itanhomi',
      'Itaobim',
      'Itapagipe',
      'Itapanhoacanga',
      'Itapecerica',
      'Itapeva',
      'Itapiru',
      'Itapirucu',
      'Itatiaiuçu',
      'Itauninha',
      'Itaverava',
      'Itaú de Minas',
      'Itaúna',
      'Itererê',
      'Itinga',
      'Itira',
      'Itueta',
      'Ituiutaba',
      'Itumirim',
      'Iturama',
      'Itutinga',
      'Ituí',
      'Jaboticatubas',
      'Jacarandira',
      'Jacaré',
      'Jacinto',
      'Jacu das Piranhas',
      'Jacutinga',
      'Jacuí',
      'Jaguaraçu',
      'Jaguaritira',
      'Jampruca',
      'Janaúba',
      'Januária',
      'Japaraíba',
      'Japonvar',
      'Jardinésia',
      'Jeceaba',
      'Jenipapo de Minas',
      'Jequeri',
      'Jequitaí',
      'Jequitibá',
      'Jequitinhonha',
      'Jesuânia',
      'Joanésia',
      'Joaquim Felício',
      'Joaíma',
      'Jordânia',
      'Josenópolis',
      'José Gonçalves de Minas',
      'José Raydan',
      'João Monlevade',
      'João Pinheiro',
      'Juatuba',
      'Jubaí',
      'Juiraçu',
      'Juiz de Fora',
      'Junco de Minas',
      'Juramento',
      'Juruaia',
      'Jurumirim',
      'Juréia',
      'Justinópolis',
      'Juvenília',
      'Lacerdina',
      'Ladainha',
      'Lagamar',
      'Lagoa Dourada',
      'Lagoa Formosa',
      'Lagoa Grande de Minas Novas',
      'Lagoa Seca',
      'Lagoa da Prata',
      'Lagoa dos Patos',
      'Lambari',
      'Lamim',
      'Lamounier',
      'Lapinha',
      'Laranjeiras de Caldas',
      'Lassance',
      'Lavras',
      'Lavras Novas',
      'Leandro Ferreira',
      'Leme do Prado',
      'Leopoldina',
      'Levinópolis',
      'Liberdade',
      'Lima Duarte',
      'Limeira de Mantena',
      'Limeira do Oeste',
      'Lobo Leite',
      'Lontra',
      'Lufa',
      'Luisburgo',
      'Luislândia',
      'Luiz Pires de Minas',
      'Luizlândia do Oeste',
      'Luminosa',
      'Luminárias',
      'Luz',
      'Macaia',
      'Machacalis',
      'Macuco',
      'Macuco de Minas',
      'Madre de Deus de Minas',
      'Major Ezequiel',
      'Major Porto',
      'Malacacheta',
      'Mamonas',
      'Manga',
      'Manhuaçu',
      'Manhumirim',
      'Mantena',
      'Mantiqueira',
      'Mantiqueira do Palmital',
      'Mar de Espanha',
      'Marambainha',
      'Maravilhas',
      'Maria da Fé',
      'Mariana',
      'Marilac',
      'Maripá de Minas',
      'Marliéria',
      'Marmelópolis',
      'Martinho Campos',
      'Martins Guimarães',
      'Martins Soares',
      'Martinésia',
      'Mata Verde',
      'Materlândia',
      'Mateus Leme',
      'Mathias Lobato',
      'Matias Barbosa',
      'Matias Cardoso',
      'Matipó',
      'Mato Verde',
      'Matozinhos',
      'Matutina',
      'Medeiros',
      'Medina',
      'Melo Viana',
      'Mendanha',
      'Mendes Pimentel',
      'Mendonça',
      'Mercês',
      'Mercês de Água Limpa',
      'Mesquita',
      'Mestre Caetano',
      'Miguel Burnier',
      'Milagre',
      'Milho Verde',
      'Minas Novas',
      'Minduri',
      'Mirabela',
      'Miradouro',
      'Miragaia',
      'Miralta',
      'Mirantão',
      'Miraporanga',
      'Miravânia',
      'Miraí',
      'Missionário',
      'Mocambeiro',
      'Mocambinho',
      'Moeda',
      'Moema',
      'Monjolinho de Minas',
      'Monjolos',
      'Monsenhor Horta',
      'Monsenhor Isidro',
      'Monsenhor João Alexandre',
      'Monsenhor Paulo',
      'Montalvânia',
      'Monte Alegre de Minas',
      'Monte Azul',
      'Monte Belo',
      'Monte Carmelo',
      'Monte Celeste',
      'Monte Formoso',
      'Monte Rei',
      'Monte Santo de Minas',
      'Monte Sião',
      'Monte Verde',
      'Montes Claros',
      'Montezuma',
      'Morada Nova de Minas',
      'Morro',
      'Morro Vermelho',
      'Morro da Garça',
      'Morro do Ferro',
      'Morro do Pilar',
      'Mundo Novo de Minas',
      'Munhoz',
      'Muquém',
      'Muriaé',
      'Mutum',
      'Muzambinho',
      'Mário Campos',
      'Mãe dos Homens',
      'Nacip Raydan',
      'Nanuque',
      'Naque',
      'Naque-Nanuque',
      'Natalândia',
      'Natércia',
      'Nazareno',
      'Nazaré de Minas',
      'Nelson de Sena',
      'Neolândia',
      'Nepomuceno',
      'Nhandutiba',
      'Nicolândia',
      'Ninheira',
      'Nova Belém',
      'Nova Era',
      'Nova Lima',
      'Nova Minda',
      'Nova Módica',
      'Nova Ponte',
      'Nova Porteirinha',
      'Nova Resende',
      'Nova Santa Luzia',
      'Nova Serrana',
      'Nova União',
      'Novilhona',
      'Novo Cruzeiro',
      'Novo Oriente de Minas',
      'Novorizonte',
      'Ocidente',
      'Olaria',
      'Olegário Maciel',
      "Olhos D'Água do Oeste",
      'Oliveira',
      'Oliveira Fortes',
      'Olímpio Campos',
      'Olímpio Noronha',
      'Onça de Pitangui',
      'Oratórios',
      'Orizânia',
      'Ouro Fino',
      'Ouro Preto',
      'Ouro Verde de Minas',
      'Paciência',
      'Padre Brito',
      'Padre Carvalho',
      'Padre Felisberto',
      'Padre Fialho',
      'Padre João Afonso',
      'Padre Júlio Maria',
      'Padre Paraíso',
      'Padre Pinto',
      'Padre Viegas',
      'Pai Pedro',
      'Pains',
      'Paiolinho',
      'Paiva',
      'Palma',
      'Palmeiral',
      'Palmeirinha',
      'Palmital de Minas',
      'Palmital dos Carvalhos',
      'Palmópolis',
      'Papagaios',
      'Paracatu',
      'Paraguai',
      'Paraguaçu',
      'Paraisópolis',
      'Paraopeba',
      'Paraíso Garcia',
      'Paredão de Minas',
      'Parque Durval de Barros',
      'Pará de Minas',
      'Passa Dez',
      'Passa Quatro',
      'Passa Tempo',
      'Passa Vinte',
      'Passabém',
      'Passagem de Mariana',
      'Passos',
      'Patis',
      'Patos de Minas',
      'Patrimônio',
      'Patrocínio',
      'Patrocínio do Muriaé',
      'Paula Cândido',
      'Paula Lima',
      'Paulistas',
      'Pavão',
      'Pedra Azul',
      'Pedra Bonita',
      'Pedra Corrida',
      'Pedra Dourada',
      'Pedra Grande',
      'Pedra Menina',
      'Pedra do Anta',
      'Pedra do Indaiá',
      'Pedra do Sino',
      'Pedralva',
      'Pedras de Maria da Cruz',
      'Pedras de Marilândia',
      'Pedrinópolis',
      'Pedro Leopoldo',
      'Pedro Lessa',
      'Pedro Teixeira',
      'Pedro Versiani',
      'Penha Longa',
      'Penha de França',
      'Penha do Capim',
      'Penha do Cassiano',
      'Penha do Norte',
      'Penido',
      'Penédia',
      'Pequeri',
      'Pequi',
      'Perdigão',
      'Perdilândia',
      'Perdizes',
      'Perdões',
      'Pereirinhas',
      'Periquito',
      'Perpétuo Socorro',
      'Pescador',
      'Petúnia',
      'Peçanha',
      'Piacatuba',
      'Piau',
      'Pic Sagarana',
      'Piedade de Caratinga',
      'Piedade de Ponte Nova',
      'Piedade do Paraopeba',
      'Piedade do Rio Grande',
      'Piedade dos Gerais',
      'Pimenta',
      'Pindaíbas',
      "Pingo-d'Água",
      'Pinheirinhos',
      'Pinheiro Grosso',
      'Pinheiro de Minas',
      'Pinheiros Altos',
      'Pinhotiba',
      'Pintos Negreiros',
      'Pintópolis',
      'Piracaiba',
      'Pirajuba',
      'Piranga',
      'Piranguinho',
      'Piranguita',
      'Piranguçu',
      'Pirapanema',
      'Pirapetinga',
      'Pirapitinga',
      'Piraúba',
      'Piscamba',
      'Pitangui',
      'Pitarana',
      'Piumhi',
      'Pião',
      'Planalto de Minas',
      'Planura',
      'Plautino Soares',
      'Poaia',
      'Pocrane',
      'Pompéu',
      'Poncianos',
      'Pontalete',
      'Ponte Alta',
      'Ponte Alta de Minas',
      'Ponte Firme',
      'Ponte Nova',
      'Ponte Segura',
      'Ponte do Cosme',
      'Ponte dos Ciganos',
      'Pontevila',
      'Ponto Chique',
      'Ponto Chique do Martelo',
      'Ponto do Marambaia',
      'Ponto dos Volantes',
      'Porteirinha',
      'Porto Agrário',
      'Porto Firme',
      'Porto das Flores',
      'Porto dos Mendes',
      'Posses',
      'Poté',
      'Pouso Alegre',
      'Pouso Alto',
      'Poço Fundo',
      'Poços de Caldas',
      'Poções de Paineiras',
      'Prados',
      'Pratinha',
      'Pratápolis',
      'Presidente Bernardes',
      'Presidente Kubitschek',
      'Presidente Olegário',
      'Presidente Pena',
      'Professor Sperber',
      'Providência',
      'Pântano',
      'Pé do Morro',
      'Quartel Geral',
      'Quartel de São João',
      'Quartel do Sacramento',
      'Quatituba',
      'Queixada',
      'Queluzito',
      'Quem-Quem',
      'Quilombo',
      'Quilombo Nossa Senhora do Rosário',
      'Quintinos',
      'Raposos',
      'Raul Soares',
      'Ravena',
      'Realeza',
      'Recreio',
      'Reduto',
      'Resende Costa',
      'Resplendor',
      'Ressaquinha',
      'Retiro Velho',
      'Riachinho',
      'Riacho da Cruz',
      'Riacho dos Machados',
      'Ribeiro Junqueira',
      'Ribeiros',
      'Ribeirão Vermelho',
      'Ribeirão da Folha',
      'Ribeirão das Neves',
      'Ribeirão de São Domingos',
      'Rio Acima',
      'Rio Casca',
      'Rio Doce',
      'Rio Espera',
      'Rio Melo',
      'Rio Novo',
      'Rio Paranaíba',
      'Rio Pardo de Minas',
      'Rio Piracicaba',
      'Rio Pomba',
      'Rio Pretinho',
      'Rio Vermelho',
      'Rio das Mortes',
      'Rio do Prado',
      'Ritápolis',
      'Rochedo de Minas',
      'Rodeador',
      'Rodeiro',
      'Rodrigo Silva',
      'Romaria',
      'Roseiral',
      'Rosário da Limeira',
      'Rosário de Minas',
      'Rosário do Pontal',
      'Roça Grande',
      'Roças Novas',
      'Rubelita',
      'Rubim',
      'Ruralminas',
      'Sabará',
      'Sabinópolis',
      'Salinas',
      'Salitre de Minas',
      'Salto da Divisa',
      'Sanatório Santa Fé',
      'Santa Bárbara do Leste',
      'Santa Bárbara do Monte Verde',
      'Santa Bárbara do Tugúrio',
      'Santa Cruz da Aparecida',
      'Santa Cruz de Botumirim',
      'Santa Cruz de Minas',
      'Santa Cruz de Salinas',
      'Santa Cruz do Escalvado',
      'Santa Cruz do Prata',
      'Santa Efigênia de Minas',
      'Santa Filomena',
      'Santa Fé de Minas',
      'Santa Helena de Minas',
      'Santa Izabel',
      'Santa Juliana',
      'Santa Luzia da Serra',
      'Santa Margarida',
      'Santa Maria de Itabira',
      'Santa Maria do Baixio',
      'Santa Maria do Salto',
      'Santa Maria do Suaçuí',
      'Santa Rita Durão',
      'Santa Rita da Estrela',
      'Santa Rita de Caldas',
      'Santa Rita de Ibitipoca',
      'Santa Rita de Jacutinga',
      'Santa Rita de Minas',
      'Santa Rita de Ouro Preto',
      'Santa Rita do Cedro',
      'Santa Rita do Itueto',
      'Santa Rita do Rio do Peixe',
      'Santa Rita do Sapucaí',
      'Santa Rosa da Serra',
      'Santa Rosa de Lima',
      'Santa Rosa dos Dourados',
      'Santa Teresa do Bonito',
      'Santa Terezinha de Minas',
      'Santa Vitória',
      'Santa Vitória de Cocais dos Arrudas',
      'Santa da Pedra',
      'Santana da Vargem',
      'Santana de Caldas',
      'Santana de Cataguases',
      'Santana de Patos',
      'Santana de Pirapama',
      'Santana do Alfié',
      'Santana do Araçuaí',
      'Santana do Campestre',
      'Santana do Capivari',
      'Santana do Deserto',
      'Santana do Garambéu',
      'Santana do Jacaré',
      'Santana do Manhuaçu',
      'Santana do Paraopeba',
      'Santana do Paraíso',
      'Santana do Riacho',
      'Santana do Tabuleiro',
      'Santana dos Montes',
      'Santo Antônio da Boa Vista',
      'Santo Antônio da Fortaleza',
      'Santo Antônio da Vargem Alegre',
      'Santo Antônio do Amparo',
      'Santo Antônio do Aventureiro',
      'Santo Antônio do Boqueirão',
      'Santo Antônio do Cruzeiro',
      'Santo Antônio do Glória',
      'Santo Antônio do Grama',
      'Santo Antônio do Itambé',
      'Santo Antônio do Jacinto',
      'Santo Antônio do Leite',
      'Santo Antônio do Manhuaçu',
      'Santo Antônio do Monte',
      'Santo Antônio do Mucuri',
      'Santo Antônio do Norte',
      'Santo Antônio do Pirapetinga',
      'Santo Antônio do Pontal',
      'Santo Antônio do Porto',
      'Santo Antônio do Retiro',
      'Santo Antônio do Rio Abaixo',
      'Santo Antônio do Salto',
      'Santo Antônio dos Araújos',
      'Santo Antônio dos Campos',
      'Santo Hilário',
      'Santo Hipólito',
      'Santos Dumont',
      'Sapucaia de Guanhães',
      'Sapucaia do Norte',
      'Sapucaí',
      'Sapucaí-Mirim',
      'Sarandira',
      'Sardoá',
      'Sarzedo',
      'Saudade',
      'Sem Peixe',
      'Senador Amaral',
      'Senador Cortes',
      'Senador Firmino',
      'Senador José Bento',
      'Senador Modestino Gonçalves',
      'Senador Mourão',
      'Senhora da Glória',
      'Senhora da Penha',
      'Senhora das Dores',
      'Senhora de Oliveira',
      'Senhora do Carmo',
      'Senhora do Porto',
      'Senhora dos Remédios',
      'Sereno',
      'Sericita',
      'Seritinga',
      'Serra Azul',
      'Serra Azul de Minas',
      'Serra Bonita',
      'Serra Nova',
      'Serra da Canastra',
      'Serra da Saudade',
      'Serra do Camapuã',
      'Serra do Cipó',
      'Serra do Salitre',
      'Serra dos Aimorés',
      'Serra dos Lemes',
      'Serrania',
      'Serranos',
      'Serranópolis de Minas',
      'Serro',
      'Sertãozinho',
      'Sete Cachoeiras',
      'Sete Lagoas',
      'Setubinha',
      'Silva Campos',
      'Silva Xavier',
      'Silvano',
      'Silveira Carvalho',
      'Silveirânia',
      'Silvestre',
      'Silvianópolis',
      'Simonésia',
      'Simão Campos',
      'Simão Pereira',
      'Sobral Pinto',
      'Sobrália',
      'Soledade de Minas',
      'Sopa',
      'Sucanga',
      'São Bartolomeu de Sem Peixe',
      'São Bento Abade',
      'São Bento de Caldas',
      'São Braz',
      'São Brás do Suaçuí',
      'São Cândido',
      'São Domingos da Bocaina',
      'São Domingos das Dores',
      'São Domingos do Prata',
      'São Francisco de Paula',
      'São Francisco de Sales',
      'São Francisco do Glória',
      'São Francisco do Humaitá',
      'São Félix de Minas',
      'São Geraldo da Piedade',
      'São Geraldo de Tumiritinga',
      'São Geraldo do Baguari',
      'São Geraldo do Baixio',
      'São Gonçalo de Botelhos',
      'São Gonçalo do Abaeté',
      'São Gonçalo do Monte',
      'São Gonçalo do Pará',
      'São Gonçalo do Rio Abaixo',
      'São Gonçalo do Rio Preto',
      'São Gonçalo do Rio das Pedras',
      'São Gonçalo do Sapucaí',
      'São Gotardo',
      'São Jerônimo dos Poções',
      'São Joaquim de Bicas',
      'São José da Barra',
      'São José da Bela Vista',
      'São José da Lapa',
      'São José da Pedra Menina',
      'São José da Safira',
      'São José da Varginha',
      'São José do Acácio',
      'São José do Alegre',
      'São José do Barreiro',
      'São José do Batatal',
      'São José do Buriti',
      'São José do Divino',
      'São José do Goiabal',
      'São José do Itueto',
      'São José do Jacaré',
      'São José do Jacuri',
      'São José do Mantimento',
      'São José do Mato Dentro',
      'São José do Paraopeba',
      'São José do Pântano',
      'São José do Rio Manso',
      'São José dos Lopes',
      'São José dos Salgados',
      'São João Batista do Glória',
      'São João Del Rei',
      'São João Evangelista',
      'São João Nepomuceno',
      'São João da Chapada',
      'São João da Lagoa',
      'São João da Mata',
      'São João da Ponte',
      'São João da Sapucaia',
      'São João da Serra',
      'São João da Serra Negra',
      'São João da Vereda',
      'São João das Missões',
      'São João do Bonito',
      'São João do Jacutinga',
      'São João do Manhuaçu',
      'São João do Manteninha',
      'São João do Oriente',
      'São João do Pacuí',
      'São Judas Tadeu de Minas',
      'São Manoel do Boi',
      'São Manoel do Guaiaçu',
      'São Mateus de Minas',
      'São Miguel do Anta',
      'São Pedro da Garça',
      'São Pedro da União',
      'São Pedro das Tabocas',
      'São Pedro de Caldas',
      'São Pedro do Avaí',
      'São Pedro do Glória',
      'São Pedro do Jequitinhonha',
      'São Pedro do Passa Três',
      'São Pedro do Suaçuí',
      'São Pedro dos Ferros',
      'São Roque de Minas',
      'São Sebastião da Barra',
      'São Sebastião da Bela Vista',
      'São Sebastião da Vala',
      'São Sebastião da Vargem Alegre',
      'São Sebastião da Vitória',
      'São Sebastião de Braúnas',
      'São Sebastião do Anta',
      'São Sebastião do Baixio',
      'São Sebastião do Barreado',
      'São Sebastião do Barreiro',
      'São Sebastião do Bonsucesso',
      'São Sebastião do Bugre',
      'São Sebastião do Gil',
      'São Sebastião do Maranhão',
      'São Sebastião do Oeste',
      'São Sebastião do Paraíso',
      'São Sebastião do Pontal',
      'São Sebastião do Rio Preto',
      'São Sebastião do Rio Verde',
      'São Sebastião do Sacramento',
      'São Sebastião do Soberbo',
      'São Sebastião do Óculo',
      'São Sebastião dos Poções',
      'São Sebastião dos Robertos',
      'São Sebastião dos Torres',
      'São Thomé das Letras',
      'São Tomás de Aquino',
      'São Vicente da Estrela',
      'São Vicente de Minas',
      'São Vicente do Grama',
      'São Vicente do Rio Doce',
      'São Vítor',
      'Tabajara',
      'Tabaúna',
      'Tabuleiro',
      'Tabuão',
      'Taiobeiras',
      'Taparuba',
      'Tapira',
      'Tapiraí',
      'Tapuirama',
      'Taquaral de Guanhães',
      'Taquaraçu de Minas',
      'Taruaçu',
      'Tarumirim',
      'Tebas',
      'Teixeiras',
      'Tejuco',
      'Terra Branca',
      'Teófilo Otoni',
      'Timóteo',
      'Tiradentes',
      'Tiros',
      'Tobati',
      'Tocandira',
      'Tocantins',
      'Tocos do Moji',
      'Toledos',
      'Tombos',
      'Tomás Gonzaga',
      'Topázio',
      'Torneiros',
      'Torreões',
      'Trimonte',
      'Três Barras da Estrada Real',
      'Três Corações',
      'Três Ilhas',
      'Três Marias',
      'Três Pontas',
      'Tuiutinga',
      'Tumiritinga',
      'Tupaciguara',
      'Tuparecê',
      'Turmalina',
      'Turvolândia',
      'Ubaporanga',
      'Ubari',
      'Ubaí',
      'Uberaba',
      'Uberlândia',
      'Ubá',
      'Umburatiba',
      'Unaí',
      'União de Minas',
      'Uruana de Minas',
      'Urucuia',
      'Urucânia',
      'Usina Monte Alegre',
      'Vai-Volta',
      'Valadares',
      'Vale Verde de Minas',
      'Valo Fundo',
      'Valão',
      'Vardiero',
      'Vargem Alegre',
      'Vargem Bonita',
      'Vargem Grande da Serra',
      'Vargem Grande do Rio Pardo',
      'Vargem Linda',
      'Varjão de Minas',
      'Varzelândia',
      'Vau-Açu',
      'Vera Cruz de Minas',
      'Verdelândia',
      'Vereda do Paraíso',
      'Veredas',
      'Vermelho',
      'Vermelho Novo',
      'Vermelho Velho',
      'Veríssimo',
      'Vespasiano',
      'Vieiras',
      'Vila Acari',
      'Vila Bem-Querer',
      'Vila Bom Jesus',
      'Vila Costina',
      'Vila Nova Floresta',
      'Vila Nova de Minas',
      'Vila Nova dos Poções',
      'Vila Pereira',
      'Vilas Boas',
      'Vinte Alqueires',
      'Virgem da Lapa',
      'Virginópolis',
      'Virgolândia',
      'Virgínia',
      'Visconde do Rio Branco',
      'Vitorinos',
      'Várzea da Palma',
      'Wenceslau Braz',
      'Zelândia',
      'Zito Soares',
      'Água Branca de Minas',
      'Água Comprida',
      'Água Santa de Minas',
      'Água Viva',
      'Águas Formosas',
      'Águas Férreas',
      'Águas Vermelhas',
      'Águas de Araxá',
      'Águas de Contendas',
    ],
    'BR-PR': [
      'Abapã',
      'Abatiá',
      'Abranches',
      'Acampamento das Minas',
      'Adhemar de Barros',
      'Agostinho',
      'Agudos do Sul',
      'Ahu',
      'Almirante Tamandaré',
      'Altamira do Paraná',
      'Alto Alegre',
      'Alto Alegre do Iguaçu',
      'Alto Amparo',
      'Alto Boqueirão',
      'Alto Paraná',
      'Alto Pará',
      'Alto Piquiri',
      'Alto Porã',
      'Alto Sabiá',
      'Alto Santa Fé',
      'Alto São João',
      'Alto da Glória',
      'Alto da XV',
      'Alto do Amparo',
      'Altônia',
      'Alvorada do Iguaçu',
      'Alvorada do Sul',
      'Amaporã',
      'Amorinha',
      'Ampére',
      'Anahy',
      'Andirá',
      'Andorinhas',
      'Angai',
      'Antonina',
      'Antônio Brandão de Oliveira',
      'Antônio Olinto',
      'Anunciação',
      'Aparecida do Ivaí',
      'Aparecida do Oeste',
      'Apiaba',
      'Apucarana',
      'Aquidaban',
      'Arapongas',
      'Arapoti',
      'Arapuan',
      'Ararapira',
      'Araruna',
      'Araucária',
      'Areia Branca dos Assis',
      'Ariranha do Ivaí',
      'Aroeira',
      'Arquimedes',
      'Assaí',
      'Assis Chateaubriand',
      'Astorga',
      'Atuba',
      'Aurora do Iguaçu',
      'Açungui',
      'Bacacheri',
      'Bairro Alto',
      'Bairro Cachoeira',
      'Bairro Limoeiro',
      'Balsa Nova',
      'Bananas',
      "Bandeirantes d'Oeste",
      'Banhado',
      'Barbosa Ferraz',
      'Barra Bonita',
      'Barra Santa Salete',
      'Barra do Jacaré',
      'Barracão',
      'Barão de Lucena',
      'Bateias',
      'Batel',
      'Baulândia',
      'Bela Vista da Caroba',
      'Bela Vista do Ivaí',
      'Bela Vista do Paraíso',
      'Bela Vista do Piquiri',
      'Bela Vista do Tapiracui',
      'Bentópolis',
      'Bernardelli',
      'Betaras',
      'Bigorrilho',
      'Biscaia',
      'Bituruna',
      'Boa Esperança do Iguaçu',
      'Boa Ventura de São Roque',
      'Boa Vista da Aparecida',
      'Bocaina',
      'Bocaiúva do Sul',
      'Bom Jardim do Sul',
      'Bom Jesus do Sul',
      'Bom Progresso',
      'Bom Sucesso do Sul',
      'Borda do Campo',
      'Borman',
      'Borrazópolis',
      'Bourbonia',
      'Braganey',
      'Bragantina',
      'Brasilândia do Sul',
      'Bulcão',
      'Butiatuvinha',
      'Cabral',
      'Cabrito',
      'Cacatu',
      'Cachoeira de Cima',
      'Cachoeira de São José',
      'Cachoeira do Espírito Santo',
      'Cadeadinho',
      'Caetano Mendes',
      'Cafeara',
      'Cafeeiros',
      'Cafelândia',
      'Cafezal do Sul',
      'Caitá',
      'Caiva',
      'Cajuru',
      'Calógeras',
      'Cambará',
      'Cambiju',
      'Cambira',
      'Cambé',
      'Campina',
      'Campina Grande do Sul',
      'Campina da Lagoa',
      'Campina do Miranguava',
      'Campina do Simão',
      'Campina do Siqueira',
      'Campina dos Furtados',
      'Campo Bonito',
      'Campo Comprido',
      'Campo Largo',
      'Campo Largo da Roseira',
      'Campo Magro',
      'Campo Mourão',
      'Campo de Santana',
      'Campo do Bugre',
      'Campo do Tenente',
      'Candeia',
      'Candói',
      'Canela',
      'Canzianópolis',
      'Capanema',
      'Capinzal',
      'Capitão Leônidas Marques',
      'Capivara',
      'Capoeirinha',
      'Capão Alto',
      'Capão Bonito',
      'Capão Raso',
      'Capão Rico',
      'Capão da Imbuia',
      'Capão da Lagoa',
      'Cara Pintado',
      'Carajá',
      'Carambeí',
      'Caramuru',
      'Caratuva',
      'Carazinho',
      'Carbonera',
      'Carlópolis',
      'Cará-Cará',
      'Casa Branca',
      'Cascatinha',
      'Castro',
      'Catanduvas',
      'Catanduvas do Sul',
      'Catarinenses',
      'Caximba',
      'Centenário do Sul',
      'Central Lupion',
      'Centralito',
      'Centro',
      'Centro Cívico',
      'Centro Novo',
      'Cerne',
      'Cerrado Grande',
      'Cerro Azul',
      'Cerro Velho',
      'Charco',
      'Chopinzinho',
      'Cianorte',
      'Cidade Gaúcha',
      'Cidade Industrial',
      'Cintra Pimentel',
      'Clevelândia',
      'Coitinho',
      'Colombo',
      'Colorado',
      'Colônia Acioli',
      'Colônia Cachoeira',
      'Colônia Castelhanos',
      'Colônia Castrolânda',
      'Colônia Centenário',
      'Colônia Cristina',
      'Colônia Dom Carlos',
      'Colônia Esperança',
      'Colônia General Carneiro',
      'Colônia Iapó',
      'Colônia Jordãozinho',
      'Colônia Malhada',
      'Colônia Melissa',
      'Colônia Murici',
      'Colônia Padre Paulo',
      'Colônia Pereira',
      'Colônia Samambaia',
      'Colônia Santos Andrade',
      'Colônia Sapucaí',
      'Colônia Saúde',
      'Colônia Socorro',
      'Colônia São José',
      'Colônia Tapera',
      'Colônia Vitória',
      'Comur',
      'Conchas Velhas',
      'Conciolândia',
      'Concórdia do Oeste',
      'Congonhinhas',
      'Conselheiro Mairinck',
      'Conselheiro Zacarias',
      'Contenda',
      'Copacabana do Norte',
      'Corbélia',
      'Cornélio Procópio',
      'Coronel Domingos Soares',
      'Coronel Firmino Martins',
      'Coronel Vivida',
      'Correia de Freitas',
      'Corumbataí do Sul',
      'Corvo',
      'Costeira',
      'Covó',
      'Coxilha Rica',
      'Cruz Machado',
      'Cruzeiro do Iguaçu',
      'Cruzeiro do Oeste',
      'Cruzmaltina',
      'Cunhaporanga',
      'Curitiba',
      'Curiúva',
      'Curucaca',
      'Cândido de Abreu',
      'Céu Azul',
      'Deputado José Afonso',
      'Despique',
      'Dez de Maio',
      "Diamante d'Oeste",
      'Diamante do Norte',
      'Diamante do Oeste',
      'Diamante do Sul',
      'Doce Grande',
      'Dois Irmãos',
      'Dois Marcos',
      'Dois Vizinhos',
      'Dom Rodrigo',
      'Dorizon',
      'Doutor Antônio Paranhos',
      'Doutor Camargo',
      'Doutor Ernesto',
      'Doutor Oliveira Castro',
      'Doutor Ulysses',
      'Eduardo Xavier da Silva',
      'Eliza',
      'Emboguaçu',
      'Emboque',
      "Encantado D'Oeste",
      'Engenheiro Beltrão',
      'Entre Rios do Oeste',
      'Enéas Marques',
      'Esperança Nova',
      'Esperança do Norte',
      'Espigão Alto do Iguaçu',
      'Espírito Santo',
      'Estação General Lúcio',
      'Estação Roça Nova',
      'Europa',
      'Euzébio de Oliveira',
      'Faisqueira',
      'Fanny',
      'Farol',
      'Faxina',
      'Faxinal',
      'Faxinal Santa Cruz',
      'Faxinal do Céu',
      'Faxinal dos Elias',
      'Fazenda Jangada',
      'Fazenda Rio Grande',
      'Fazenda Salmo 23',
      'Fazenda do Brigadeiro',
      'Fazenda dos Barbosas',
      'Fazendinha',
      'Felpudo',
      'Fernandes Pinheiro',
      'Ferraria',
      'Figueira do Oeste',
      'Fiusas',
      'Floraí',
      'Florestópolis',
      'Floriano',
      'Florópolis',
      'Fluviópolis',
      'Flórida',
      'Flôr da Serra do Sul',
      'Formigone',
      'Formigueiro',
      'Formosa do Oeste',
      'Foz do Iguaçu',
      'Foz do Jordão',
      'Francisco Alves',
      'Francisco Beltrão',
      'Francisco Frederico Teixeira Guimarães',
      'Frei Timóteo',
      'Fueros',
      'Fênix',
      'Gamadinho',
      'Gamela',
      'Ganchinho',
      'Gaúcha',
      'General Osório',
      'Geremia Lunardelli',
      'Godoy Moreira',
      'Goioerê',
      'Goioxim',
      'Gonçalves Júnior',
      'Graciosa',
      'Grandes Rios',
      'Guabirotuba',
      'Guaiporã',
      'Guairaçá',
      'Guajuvira',
      'Guamiranga',
      'Guamirim',
      'Guapirama',
      'Guaporema',
      'Guaporé',
      'Guaraci',
      'Guaragi',
      'Guaraituba',
      'Guaraniaçu',
      'Guarapuava',
      'Guarapuavinha',
      'Guaraqueçaba',
      'Guaratuba',
      'Guaravera',
      'Guaraí',
      'Guaraúna',
      'Guardamoria',
      'Guaíra',
      'Góis',
      'Harmonia',
      'Hauer',
      'Herculândia',
      'Herval Grande',
      'Herveira',
      'Hidrelétrica Itaipu',
      'Honório Serpa',
      'Hugo Lange',
      'Iarama',
      'Ibaiti',
      'Ibema',
      'Ibiaci',
      'Ibiporã',
      'Icaraíma',
      'Igrejinha',
      'Iguaraçu',
      'Iguiporã',
      'Ilha Encantada',
      'Ilha de Eufrasina',
      'Ilha de São Miguel',
      'Ilha do Amparo',
      'Ilha do Mel',
      'Ilha do Teixeira',
      'Ilha dos Valadares',
      'Imbauzinho',
      'Imbaú',
      'Imbituva',
      'Inspetor Carvalho',
      'Invernada',
      'Invernadinha',
      'Inácio Martins',
      'Iolópolis',
      'Iporã',
      'Iracema do Oeste',
      'Irapuan',
      'Irati',
      'Irerê',
      'Iretama',
      'Itaguajé',
      'Itaiacoca',
      'Itaipulândia',
      'Itambaracá',
      'Itambezinho',
      'Itapanhacanga',
      'Itapara',
      "Itapejara d'Oeste",
      'Itapejara do Oeste',
      'Itaperuçu',
      'Itaqui',
      'Itaúna do Sul',
      'Ivailândia',
      'Ivaiporã',
      'Ivaitinga',
      'Ivatuba',
      'Ivaté',
      'Ivaí',
      'Içara',
      'Jaboti',
      'Jaboticabal',
      'Jaburu',
      'Jacarezinho',
      'Jaciaba',
      'Jaguapitã',
      'Jaguariaíva',
      'Jandaia do Sul',
      'Jandinópolis',
      'Jangada do Sul',
      'Janiópolis',
      'Japira',
      'Jaracatiá',
      'Jardim Alegre',
      'Jardim Olinda',
      'Jardim Paredão',
      'Jardim Social',
      'Jardim das Américas',
      'Jataizinho',
      'Javacaé',
      'Jesuítas',
      'Joaquim Távora',
      'José Lacerda',
      'Joá',
      'Juciara',
      'Jundiaí do Sul',
      'Juranda',
      'Juvevê',
      'Juvinópolis',
      'Kaloré',
      'Lagoa',
      'Lagoa Verde',
      'Lagoa dos Ribas',
      'Lajeado',
      'Lajeado Bonito',
      'Lajeado Grande',
      'Lamenha Pequena',
      'Laranja Azeda',
      'Laranjeiras do Sul',
      'Lavra',
      'Lavrinha',
      'Lerroville',
      'Leópolis',
      'Lidianópolis',
      'Lindoeste',
      'Lindóia',
      'Linha Giacomini',
      'Loanda',
      'Lobato',
      'Londrina',
      'Lopei',
      'Lovat',
      'Luar',
      'Luiziana',
      'Lunardelli',
      'Lupionópolis',
      'Macaco',
      'Macucos',
      'Mairá',
      'Maitá',
      'Mallet',
      'Malu',
      'Mamborê',
      'Mandaguari',
      'Mandaguaçu',
      'Mandaçaia',
      'Mandiocaba',
      'Mandirituba',
      'Manfrinópolis',
      'Mangueirinha',
      'Manoel Ribas',
      'Marabá',
      'Maracanã',
      'Marajó',
      'Marcelino',
      'Marechal Cândido Rondon',
      'Margarida',
      'Maria Helena',
      'Maria Luiza',
      'Marialva',
      'Mariental',
      'Marilena',
      'Marilu',
      'Mariluz',
      'Marilândia do Sul',
      'Marimbondo',
      'Maringá',
      'Maripá',
      'Maristela',
      'Mariza',
      'Mariópolis',
      'Marmeleiro',
      'Marmelândia',
      'Marquinho',
      'Marquês de Abrantes',
      'Marquês dos Reis',
      'Martins',
      'Martinópolis',
      'Marumbi',
      'Matelândia',
      'Matinhos',
      'Mato Queimado',
      'Mato Rico',
      'Mauá da Serra',
      'Medianeira',
      'Meia-Lua',
      'Memória',
      'Mendeslândia',
      'Mirante do Piquiri',
      'Miraselva',
      'Missal',
      'Monjolinho',
      'Monte Real',
      'Moreira Sales',
      'Morretes',
      'Morro Alto',
      'Morro Inglês',
      'Mossunguê',
      'Munhoz de Melo',
      'Natingui',
      'Nilza',
      'Nossa Senhora Aparecida',
      'Nossa Senhora da Aparecida',
      'Nossa Senhora da Candelária',
      'Nossa Senhora de Lourdes',
      'Nossa Senhora do Carmo',
      'Nova Aliança do Ivaí',
      'Nova Altamira',
      'Nova Amoreira',
      'Nova América da Colina',
      'Nova Bilac',
      'Nova Brasília do Itararé',
      'Nova Cantu',
      'Nova Concórdia',
      'Nova Esperança do Sudoeste',
      'Nova Laranjeiras',
      'Nova Londrina',
      'Nova Lourdes',
      'Nova Prata do Iguaçu',
      'Nova Riqueza',
      'Nova Santa Bárbara',
      'Nova Santa Rosa',
      'Nova Tebas',
      'Nova Tirol',
      'Nova Videira',
      'Novo Itacolomi',
      'Novo Jardim',
      'Novo Sarandi',
      'Novo Sobradinho',
      'Novo Três Passos',
      'Olho Agudo',
      "Olho d'Água",
      'Orleans',
      'Ortigueira',
      'Ourilândia',
      'Ourizona',
      'Ouro Verde',
      'Ouro Verde do Oeste',
      'Ouro Verde do Piquiri',
      'Padre Ponciano',
      'Paiol Queimado',
      'Paiol de Baixo',
      'Paiquerê',
      'Paiçandu',
      'Palmas',
      'Palmira',
      'Palmital',
      'Palmital de São Silvestre',
      'Palmitópolis',
      'Palotina',
      'Panema',
      'Pangaré',
      'Papagaios Novos',
      'Paranacity',
      'Paranagi',
      'Paranaguá',
      'Paranapoema',
      'Paranavaí',
      "Paraná d'Oeste",
      'Paraíso do Norte',
      'Parolin',
      'Passa Una',
      'Passo Amarelo',
      'Passo Fundo',
      'Passo Liso',
      'Passo da Ilha',
      'Passo dos Pupos',
      'Pato Bragado',
      'Pato Branco',
      'Patos Velhos',
      "Pau d'Alho do Sul",
      'Paula Freitas',
      'Paulistânia',
      'Paulo Frontin',
      'Peabiru',
      'Pedra Branca do Araraquara',
      'Pedro Lustosa',
      'Pelado',
      'Perobal',
      'Piassuguera',
      'Pilarzinho',
      'Pinaré',
      'Pinhais',
      'Pinhal de São Bento',
      'Pinhalzinho',
      'Pinhalão',
      'Pinheirinho',
      'Pinhão',
      'Piquirivaí',
      'Pirapó',
      'Piraquara',
      'Piraí do Sul',
      'Piriquitos',
      'Pitanga',
      'Pitangueiras',
      'Piên',
      'Planaltina do Paraná',
      'Pocinho',
      'Poema',
      'Ponta Grossa',
      'Ponta do Pasto',
      'Pontal do Paraná',
      'Porecatu',
      'Porteira Preta',
      'Porto Amazonas',
      'Porto Barreiro',
      'Porto Belo',
      'Porto Brasílio',
      'Porto Camargo',
      'Porto Meira',
      'Porto Mendes',
      'Porto Rico',
      'Porto San Juan',
      'Porto Santana',
      'Porto São Carlos',
      'Porto São José',
      'Porto Vitória',
      'Porto de Cima',
      'Portão',
      'Prado Ferreira',
      'Prado Velho',
      'Pranchita',
      'Prata Um',
      'Presidente Castelo Branco',
      'Primeiro de Maio',
      'Prudentópolis',
      'Pulinópolis',
      'Pérola',
      'Pérola Independente',
      "Pérola d'Oeste",
      'Pérola do Oeste',
      'Quarto Centenário',
      'Quatiguá',
      'Quatro Barras',
      'Quatro Pontes',
      'Quebra Freio',
      'Quedas do Iguaçu',
      'Querência do Norte',
      'Quinta do Sol',
      'Quinzópolis',
      'Quitandinha',
      'Ramilândia',
      'Rancho Alegre',
      "Rancho Alegre d'Oeste",
      'Rancho Alegre do Oeste',
      'Rebouças',
      'Região dos Valos',
      'Reianópolis',
      'Renascença',
      'Reserva',
      'Reserva do Iguaçu',
      'Retiro Grande',
      'Ribeirão Bonito',
      'Ribeirão Claro',
      'Ribeirão do Pinhal',
      'Ribeirão do Pinheiro',
      'Rio Abaixo',
      'Rio Azul',
      'Rio Bom',
      'Rio Bonito',
      'Rio Bonito do Iguaçu',
      'Rio Branco do Ivaí',
      'Rio Branco do Sul',
      'Rio Claro do Sul',
      'Rio Pinheiro',
      'Rio Quatorze',
      'Rio Saltinho',
      'Rio Saudade',
      'Rio XV de Baixo',
      'Rio da Prata',
      'Rio das Antas',
      'Rio das Pedras',
      'Rio das Pombas',
      'Rio do Mato',
      'Rio do Salto',
      'Riviera',
      'Roberto Silveira',
      'Rolândia',
      'Romeópolis',
      'Roncador',
      'Rondinha',
      'Rondon',
      'Rosário do Ivaí',
      'Roça Velha',
      'Sabáudia',
      'Salgado Filho',
      'Salles de Oliveira',
      'Saltinho',
      'Saltinho do Oeste',
      'Salto Portão',
      'Salto do Itararé',
      'Salto do Lontra',
      'Santa Amélia',
      'Santa Cecília do Pavão',
      'Santa Clara',
      'Santa Cruz de Monte Castelo',
      'Santa Cândida',
      'Santa Eliza',
      'Santa Esmeralda',
      'Santa Felicidade',
      'Santa Fé do Pirapó',
      'Santa Isabel do Ivaí',
      'Santa Izabel do Oeste',
      'Santa Lurdes',
      'Santa Luzia da Alvorada',
      'Santa Lúcia',
      'Santa Maria do Oeste',
      'Santa Maria do Rio do Peixe',
      'Santa Mariana',
      'Santa Mônica',
      'Santa Rita do Oeste',
      'Santa Tereza do Oeste',
      'Santa Terezinha de Itaipu',
      'Santa Zélia',
      'Santana do Itararé',
      'Santo Antônio da Platina',
      'Santo Antônio do Caiuá',
      'Santo Antônio do Iratim',
      'Santo Antônio do Palmital',
      'Santo Antônio do Paraíso',
      'Santo Antônio do Sudoeste',
      'Santo Izidoro',
      'Santo Rei',
      'Sapopema',
      'Sapé',
      'Saudade do Iguaçu',
      'Sede Alvorada',
      'Sede Chaparral',
      "Sede Nova Sant'Ana",
      'Sede Progresso',
      'Selva',
      'Seminário',
      'Sengés',
      'Senhor Bom Jesus dos Gramados',
      'Serra Negra',
      'Serra dos Dourados',
      'Serranópolis do Iguaçu',
      'Serraria Klas',
      'Sertaneja',
      'Sertanópolis',
      'Sete Saltos de Cima',
      'Siqueira Belo',
      'Siqueira Campos',
      'Socavão',
      'Sulina',
      'Sumaré',
      'Sussui',
      'Sutis',
      'São Camilo',
      'São Carlos do Ivaí',
      'São Cirilo',
      'São Clemente',
      'São Cristovão',
      'São Francisco de Imbaú',
      'São Jerônimo da Serra',
      'São Joaquim do Pontal',
      "São Jorge D'Oeste",
      'São Jorge do Ivaí',
      'São Jorge do Oeste',
      'São Jorge do Patrocínio',
      'São José da Boa Vista',
      'São José das Palmeiras',
      'São José do Iguaçu',
      'São José do Itavo',
      'São José do Ivaí',
      'São José dos Pinhais',
      "São João d'Oeste",
      'São João do Caiuá',
      'São João do Ivaí',
      'São João do Pinhal',
      'São João do Triunfo',
      'São Judas Tadeu',
      'São Leonardo',
      'São Luiz',
      'São Luiz do Oeste',
      'São Luiz do Purunã',
      'São Manoel do Paraná',
      'São Marcos',
      'São Martinho',
      'São Mateus do Sul',
      'São Miguel do Cambui',
      'São Miguel do Iguaçu',
      'São Paulo',
      'São Pedro Lopei',
      'São Pedro do Florido',
      'São Pedro do Iguaçu',
      'São Pedro do Ivaí',
      'São Pedro do Paraná',
      'São Pio X',
      'São Roque do Chopim',
      'São Roque do Pinhal',
      'São Salvador',
      'São Sebastião da Amoreira',
      'São Silvestre',
      'São Valentim',
      'Sítio Cercado',
      'Taboão',
      'Taipa',
      'Tamarana',
      'Tambarutaca',
      'Tamboara',
      'Tanque Grande',
      'Tapejara',
      'Tapui',
      'Taquari dos Polacos',
      'Taquari dos Russos',
      'Taquaruna',
      'Tarumã',
      'Tatuquara',
      'Teixeira Soares',
      'Telêmaco Borba',
      'Tereza Breda',
      'Tereza Cristina',
      'Terra Boa',
      'Terra Rica',
      'Tibagi',
      'Tijucas do Sul',
      'Tijuco Preto',
      'Timbu Velho',
      'Tindiquera',
      'Tingui',
      'Tomaz Coelho',
      'Tomazina',
      'Triolândia',
      'Tronco',
      'Três Barras do Paraná',
      'Três Bicos',
      'Três Bocas',
      'Três Capões',
      'Três Córregos',
      'Três Pinheiros',
      'Três Placas',
      'Tunas do Paraná',
      'Tuneiras do Oeste',
      'Tupinambá',
      'Tupãssi',
      'Turvo',
      'Ubaldino Taques',
      'Ubauna',
      'Ubiratã',
      'Umbará',
      'Umuarama',
      'Uniflor',
      'União da Vitória',
      'União do Oeste',
      'Uraí',
      'Uvaia',
      'Valentins',
      'Valério',
      'Vargeado',
      'Vassoural',
      'Ventania',
      'Vera Cruz do Oeste',
      'Vera Guarani',
      'Verê',
      'Vida Nova',
      'Vidigal',
      'Vila Alta',
      'Vila Celeste',
      'Vila Diniz',
      'Vila Flórida',
      'Vila Gandhi',
      'Vila Guay',
      'Vila Ipiranga',
      'Vila Izabel',
      'Vila Nova',
      'Vila Nova de Florença',
      'Vila Paraíso',
      'Vila Reis',
      'Vila Rica do Ivaí',
      'Vila Silva Jardim',
      'Vila dos Roldos',
      'Virmond',
      'Vista Bonita',
      'Vitorino',
      'Warta',
      'Xambrê',
      'Xaxim',
      'Yolanda',
      'km 30',
      'Água Azul',
      'Água Mineral',
      'Água Vermelha',
      'Ângulo',
    ],
    'BR-PB': [
      'Aguiar',
      'Alagoa Grande',
      'Alagoa Nova',
      'Alcantil',
      'Algodão de Jandaíra',
      'Alhandra',
      'Amparo',
      'Arara',
      'Araçagi',
      'Areia',
      'Areia de Baraúnas',
      'Balanços',
      'Baraúna',
      'Barra de Santa Rosa',
      'Barra de Santana',
      'Barra do Camaratuba',
      'Bayeux',
      'Baía da Traição',
      'Bebelândia',
      'Belém do Brejo do Cruz',
      'Bernardino Batista',
      'Boa Ventura',
      'Bonito de Santa Fé',
      'Borborema',
      'Brejo do Cruz',
      'Brejo dos Santos',
      'Caaporã',
      'Cabaceiras',
      'Cabedelo',
      'Cachoeira dos Índios',
      'Cacimba de Areia',
      'Cacimba de Dentro',
      'Cajazeirinhas',
      'Caldas Brandão',
      'Camalaú',
      'Campina Grande',
      'Camurupim',
      'Capim',
      'Caraúbas',
      'Cardoso',
      'Carrapateira',
      'Casinha do Homem',
      'Casserengue',
      'Catingueira',
      'Catolé do Rocha',
      'Caturité',
      'Cepilho',
      'Condado',
      'Congo',
      'Coremas',
      'Coronel Maia',
      'Coxixola',
      'Cruz do Espírito Santo',
      'Cubati',
      'Cuitegi',
      'Cuité',
      'Cuité de Mamanguape',
      'Cupissura',
      'Curral de Cima',
      'Damião',
      'Desterro',
      'Dona Inês',
      'Duas Estradas',
      'Emas',
      'Engenheiro Ávidos',
      'Fagundes',
      'Forte Velho',
      'Frei Martinho',
      'Gado Bravo',
      'Galante',
      'Guarabira',
      'Gurinhém',
      'Gurjão',
      'Ibiara',
      'Igaracy',
      'Imaculada',
      'Itajubatiba',
      'Itaporanga',
      'Itapororoca',
      'Itatuba',
      'Jacaraú',
      'Jericó',
      'Joca Claudino',
      'João Pessoa',
      'Juarez Távora',
      'Juazeirinho',
      'Junco do Seridó',
      'Juripiranga',
      'Juru',
      'Lagoa de Dentro',
      'Lastro',
      'Lerolândia',
      'Lucena',
      'Maia',
      'Malta',
      'Mamanguape',
      'Manaíra',
      'Marcação',
      'Mari',
      'Marizópolis',
      'Mata Virgem',
      'Mataraca',
      'Matinhas',
      'Mato Grosso',
      'Maturéia',
      'Melo',
      'Mogeiro',
      'Montadas',
      'Monte Horebe',
      'Monteiro',
      'Montevidéu',
      "Mãe D'Água",
      'Natuba',
      'Nazarezinho',
      'Nova Palmeira',
      'Núcleo N 2',
      'Núcleo N 3',
      'Odilândia',
      'Olivedos',
      'Ouro Velho',
      'Parari',
      'Pedra Lavrada',
      'Pedras de Fogo',
      'Pedro Régis',
      'Pelo Sinal',
      'Pereiros',
      'Piancó',
      'Picuí',
      'Pilõezinhos',
      'Pindurão',
      'Pirauá',
      'Pirpirituba',
      'Pitanga de Estrada',
      'Pitimbu',
      'Pocinhos',
      'Pombal',
      'Porteirinha de Pedra',
      'Poço Dantas',
      'Poço de José de Moura',
      'Princesa Isabel',
      'Puxinanã',
      'Remígio',
      'Riacho de Santo Antônio',
      'Riacho dos Cavalos',
      'Riachão do Bacamarte',
      'Riachão do Poço',
      'Ribeira',
      'Rio Tinto',
      'Rua Nova',
      'Salema',
      'Salgadinho',
      'Salgado de São Félix',
      'Santa Cecília',
      'Santa Gertrudes',
      'Santa Luzia do Cariri',
      'Santana de Mangueira',
      'Santana dos Garrotes',
      'Seridó',
      'Serra Branca',
      'Serra Redonda',
      'Serra da Raiz',
      'Serraria',
      'Sobrado',
      'Solânea',
      'Sossêgo',
      'Sousa',
      'Sucuru',
      'Sumé',
      'São Bentinho',
      'São Domingos de Pombal',
      'São Domingos do Cariri',
      'São Gonçalo',
      'São José da Lagoa Tapada',
      'São José da Mata',
      'São José de Caiana',
      'São José de Espinharas',
      'São José de Marimbas',
      'São José de Piranhas',
      'São José de Princesa',
      'São José do Bonfim',
      'São José do Brejo do Cruz',
      'São José do Sabugi',
      'São José dos Cordeiros',
      'São José dos Ramos',
      'São João Bosco',
      'São João do Cariri',
      'São João do Rio do Peixe',
      'São João do Tigre',
      'São Mamede',
      'São Miguel de Taipu',
      'São Sebastião de Lagoa de Roça',
      'São Sebastião do Umbuzeiro',
      'São Vicente do Seridó',
      'Tacima',
      'Tambauzinho',
      'Tavares',
      'Teixeira',
      'Tenório',
      'Uiraúna',
      'Vieirópolis',
      'Vista Serrana',
      'Várzea Comprida',
      'Zabelê',
    ],
    'BR-PA': [
      'Abaetetuba',
      'Abel Figueiredo',
      'Acará',
      'Afuá',
      'Agrópolis Bela Vista',
      'Alenquer',
      'Algodoal',
      'Almeirim',
      'Almoço',
      'Alta Pará',
      'Altamira',
      'Alter do Chão',
      'Americano',
      'Anajás',
      'Ananindeua',
      'Anapu',
      'Antônio Lemos',
      'Apeú',
      'Apinagés',
      'Arapixuna',
      'Araquaim',
      'Arco-Íris',
      'Arumanduba',
      'Aruri',
      'Aturiaí',
      'Augusto Corrêa',
      'Aurora do Pará',
      'Aveiro',
      'Bagre',
      'Baião',
      'Bannach',
      'Barcarena',
      'Barreira Branca',
      'Barreira dos Campos',
      'Beja',
      'Bela Vista do Caracol',
      'Belterra',
      'Benevides',
      'Benfica',
      'Boa Fé',
      'Boa Vista do Iririteua',
      'Boim',
      'Bom Jesus do Tocantins',
      'Bragança',
      'Brasil Novo',
      'Brasília Legal',
      'Brejo Grande do Araguaia',
      'Brejo do Meio',
      'Breu Branco',
      'Breves',
      'Bujaru',
      'Cachoeira da Serra',
      'Cachoeira do Arari',
      'Cachoeira do Piriá',
      'Cafezal',
      'Cairari',
      'Caju',
      'Camiranga',
      'Canaã dos Carajás',
      'Capitão Poço',
      'Caracará do Arari',
      'Carajás',
      'Carapajó',
      'Caraparu',
      'Caratateua',
      'Caripi',
      'Carrazedo',
      'Casa de Tábua',
      'Castanhal',
      'Castelo dos Sonhos',
      'Colares',
      'Conceição do Araguaia',
      'Concórdia do Pará',
      'Condeixa',
      'Coqueiro',
      'Cripurizinho',
      'Cripurizão',
      'Cuiú-Cuiú',
      'Cumaru do Norte',
      'Curionópolis',
      'Curralinho',
      'Curuaí',
      'Curumu',
      'Curuá',
      'Curuçambaba',
      'Curuçá',
      'Câmara do Marajó',
      'Dom Eliseu',
      'Eldorado dos Carajás',
      'Emboraí',
      'Espírito Santo do Tauá',
      'Faro',
      'Fernandes Belo',
      'Flexal',
      'Floresta do Araguaia',
      'Garrafão do Norte',
      'Goianésia do Pará',
      'Gradaus',
      'Guajará-Açú',
      'Guajará-Miri',
      'Gurupizinho',
      'Gurupá',
      'Hidrelétrica Tucuruí',
      'Iataí',
      'Icoaraci',
      'Igarapé da Lama',
      'Igarapé-Açu',
      'Igarapé-Miri',
      'Inanu',
      'Inhangapi',
      'Ipixuna do Pará',
      'Irituia',
      'Itaituba',
      'Itapixuna',
      'Itatupã',
      'Itupiranga',
      'Jacareacanga',
      'Jacundá',
      'Jamanxinzinho',
      'Jambuaçu',
      'Jandiaí',
      'Japerica',
      'Joana Coeli',
      'Joana Peres',
      'Joanes',
      'Juabá',
      'Jubim',
      'Juruti',
      'Km 19',
      'Km 26',
      'Lauro Sodré',
      'Ligação do Pará',
      'Limoeiro do Ajuru',
      'Magalhães Barata',
      'Maiauata',
      'Manjeiro',
      'Marajoara',
      'Marapanim',
      'Marituba',
      'Marudá',
      'Mata Geral',
      'Matapiquara',
      'Medicilândia',
      'Menino Deus do Anapu',
      'Meruú',
      'Mirasselvas',
      'Miritituba',
      'Mocajuba',
      'Moiraba',
      'Moju',
      'Mojuí dos Campos',
      'Monsaras',
      'Monte Alegre do Mau',
      'Monte Dourado',
      'Moraes Almeida',
      'Mosqueiro',
      'Muaná',
      'Murajá',
      'Murucupi',
      'Murumuru',
      'Muta',
      'Mutucal',
      'Mãe do Rio',
      'Nazaré de Mocajuba',
      'Nazaré dos Patos',
      'Nova Esperança do Piriá',
      'Nova Ipixuna',
      'Nova Mocajuba',
      'Nova Timboteua',
      'Novo Progresso',
      'Novo Repartimento',
      'Núcleo Urbano Quilômetro 30',
      'Oeiras do Pará',
      'Oriximiná',
      'Osvaldilândia',
      'Ourilândia do Norte',
      'Ourém',
      'Outeiro',
      'Pacajá',
      'Pacoval',
      'Palestina do Pará',
      'Paragominas',
      'Paratins',
      'Parauapebas',
      'Pedreira',
      'Peixe-Boi',
      'Penhalonga',
      'Perseverança',
      'Pesqueiro',
      'Piabas',
      'Pinhal',
      'Piriá',
      'Piçarra',
      'Placas',
      'Ponta de Pedras',
      'Ponta de Ramos',
      'Portel',
      'Porto Salvo',
      'Porto Trombetas',
      'Porto de Moz',
      'Prainha',
      'Quatipuru',
      'Quatro Bocas',
      'Remansão',
      'Rio Maria',
      'Riozinho',
      'Rondon do Pará',
      'Rurópolis',
      'Salinópolis',
      'Salvaterra',
      'Santa Bárbara do Pará',
      'Santa Cruz do Arari',
      'Santa Isabel do Pará',
      'Santa Luzia do Pará',
      'Santa Maria das Barreiras',
      'Santa Maria do Pará',
      'Santa Rosa da Vigia',
      'Santana do Araguaia',
      'Santarém Novo',
      'Santo Antônio do Tauá',
      'Senador José Porfírio',
      'Soure',
      'São Caetano de Odivelas',
      'São Domingos do Araguaia',
      'São Domingos do Capim',
      'São Francisco da Jararaca',
      'São Francisco do Pará',
      'São Félix do Xingu',
      'São Geraldo do Araguaia',
      'São Joaquim do Tapará',
      'São José do Gurupi',
      'São José do Piriá',
      'São João da Ponta',
      'São João de Pirabas',
      'São João do Acangata',
      'São João do Araguaia',
      'São João do Piriá',
      'São João dos Ramos',
      'São Luiz do Tapajós',
      'São Miguel de Pracuuba',
      'São Miguel do Guamá',
      'São Miguel dos Macacos',
      'São Pedro de Viseu',
      'São Pedro do Capim',
      'São Raimundo de Borralhos',
      'São Raimundo do Araguaia',
      'São Raimundo dos Furtados',
      'São Sebastião da Boa Vista',
      'São Sebastião de Viçosa',
      'Tailândia',
      'Tatuteua',
      'Tauari',
      'Tauarizinho',
      'Tentugal',
      'Terra Alta',
      'Terra Santa',
      'Tijoca',
      'Timboteua',
      'Tomé-Açu',
      'Tracuateua',
      'Trairão',
      'Tucumã',
      'Tucuruí',
      'Ulianópolis',
      'União da Floresta',
      'Uruará',
      'Urucuri',
      'Urucuriteua',
      'Val-de-Cães',
      'Veiros',
      'Vigia',
      'Vila França',
      'Vila Goreth',
      'Vila Isol',
      'Vila Mandi',
      'Vila Planalto',
      'Vila Santa Fé',
      'Vila Socorro',
      'Vila do Carmo do Tocantins',
      'Vila dos Cabanos',
      'Vilarinho do Monte',
      'Viseu',
      'Vista Alegre do Pará',
      'Vitória do Xingu',
      'Xinguara',
      'Xinguarinha',
      'Água Azul do Norte',
      'Óbidos',
    ],
    'BR-PE': [
      'Abreu e Lima',
      'Afogados da Ingazeira',
      'Afrânio',
      'Agrestina',
      'Airi',
      'Albuquerque Né',
      'Aliança',
      'Altinho',
      'Alverne',
      'Amaraji',
      'Ameixas',
      'Angelim',
      'Apoti',
      'Araripina',
      'Araçoiaba',
      'Arcoverde',
      'Aripibu',
      'Arizona',
      'Atapus',
      'Barra de Farias',
      'Barra de Guabiraba',
      'Barra de São Pedro',
      'Barra do Brejo',
      'Barra do Chata',
      'Barra do Jardim',
      'Barra do Riachão',
      'Barra do Sirinhaém',
      'Batateira',
      'Belo Jardim',
      'Belém de Maria',
      'Belém do São Francisco',
      'Bengalas',
      'Bentivi',
      'Bernardo Vieira',
      'Bezerros',
      'Bizarra',
      'Boas Novas',
      'Bodocó',
      'Bom Conselho',
      'Bom Nome',
      'Brejo da Madre de Deus',
      'Brejão',
      'Buenos Aires',
      'Buíque',
      'Cabanas',
      'Cabo',
      'Cabo de Santo Agostinho',
      'Cabrobó',
      'Cachoeira Seca',
      'Cachoeira do Pinto',
      'Cachoeira do Roberto',
      'Caetés',
      'Caiçarinha da Penha',
      'Caldeirões',
      'Calumbi',
      'Calçado',
      'Camaragibe',
      'Camela',
      'Camocim de São Félix',
      'Camutanga',
      'Canhotinho',
      'Capoeiras',
      'Caraibeiras',
      'Carapotos',
      'Caraúba Torta',
      'Carice',
      'Carima',
      'Caririmirim',
      'Carnaubeira da Penha',
      'Carnaíba',
      'Carne-de-Vaca',
      'Carneiro',
      'Caroalina',
      'Carpina',
      'Carqueja',
      'Caruaru',
      'Casinhas',
      'Catende',
      'Catimbaú',
      'Cavaleiro',
      'Cavalo Ruço de Deus',
      'Chã Grande',
      'Chã de Alegria',
      'Chã de Cruz',
      'Chã do Rocha',
      'Cimbres',
      'Clarana',
      'Cocau',
      'Conceição das Crioulas',
      'Correntes',
      'Cortês',
      "Couro D'Antas",
      'Cruanji',
      'Cruzeiro do Nordeste',
      'Cruzes',
      'Cuiambuca',
      'Cuieiras',
      'Cumaru',
      'Cupira',
      'Curral Queimado',
      'Custódia',
      'Dois Leões',
      'Dormentes',
      'Entroncamento',
      'Escada',
      'Exu',
      'Feira Nova',
      'Feitoria',
      'Fernando de Noronha',
      'Ferreiros',
      'Frei Miguelinho',
      'Frexeiras',
      'Gambá',
      'Gameleira',
      'Garanhuns',
      'Glória do Goitá',
      'Goiana',
      'Gonçalves Ferreira',
      'Granito',
      'Gravatá',
      'Gravatá do Ibiapina',
      'Grossos',
      'Grotão',
      'Guanumbi',
      'Henrique Dias',
      'Iateca',
      'Iati',
      'Ibimirim',
      'Ibirajuba',
      'Ibiranga',
      'Ibiratinga',
      'Ibitiranga',
      'Icaiçara',
      'Igapó',
      'Igarapeassu',
      'Igarapeba',
      'Igarassu',
      'Iguaraci',
      'Ilha de Itamaracá',
      'Ingazeira',
      'Ipojuca',
      'Ipubi',
      'Ipuera',
      'Iraguaçu',
      'Irajaí',
      'Iratama',
      'Itacuruba',
      'Itapetim',
      'Itapissuma',
      'Itaquitinga',
      'Itaíba',
      'Ituguaçu',
      'Iuiteporã',
      'Izacolandia',
      'Jabitaca',
      'Jaboatão dos Guararapes',
      'Jacaré Grande',
      'Japecanga',
      'Jaqueira',
      'Jataúba',
      'Jatiúca',
      'Jirau',
      'Joaquim Nabuco',
      'José Mariano',
      'José da Costa',
      'João Alfredo',
      'Juca Ferrado',
      'Jucati',
      'Jupi',
      'Juçaral',
      'Km 25',
      'Lagoa da Vaca',
      'Lagoa de São José',
      'Lagoa do Carro',
      'Lagoa do Itaenga',
      'Lagoa do Ouro',
      'Lagoa do Souza',
      'Lagoa dos Gatos',
      'Laje Grande',
      'Laje de São José',
      'Lajedo',
      'Lajedo do Cedro',
      'Livramento do Tiúma',
      'Logradouro dos Leões',
      'Luanda',
      'Lério de Cima',
      'Macaparana',
      'Machados',
      'Macujé',
      'Malhada Barreiras Queimadas',
      'Malhada de Pedra',
      'Manari',
      'Mandacaia',
      'Mandacaru',
      'Maniçoba',
      'Maraial',
      'Massangano',
      'Matinada',
      'Miracica',
      'Mirandiba',
      'Moderna',
      'Morais',
      'Moreilândia',
      'Moxotó',
      'Murupé',
      'Mutuca',
      'Nazaré da Mata',
      'Negras',
      'Neves',
      'Nossa Senhora da Luz',
      'Nossa Senhora do Ó',
      'Nova Cruz',
      'Nova Descoberta',
      'Ns2 Núcleo de Serviços',
      "Olho D'Água de Dentro",
      'Olinda',
      'Oratório',
      'Ori',
      'Orobó',
      'Orocó',
      'Ouricuri',
      'Palmeirina',
      'Panelas',
      'Paquevira',
      'Paranatama',
      'Paratibe',
      'Parnamirim',
      'Pará',
      'Passagem do Tó',
      'Passira',
      'Pau Amarelo',
      'Pau-Santo',
      'Paudalho',
      'Pedra',
      'Pelada',
      'Pesqueira',
      'Petrolina',
      'Petrolândia',
      'Pirituba',
      'Pombos',
      'Pontas de Pedra',
      'Poção de Afrânio',
      'Pão de Açúcar do Poção',
      'Pé-de-Serra dos Mendes',
      'Quipapá',
      'Quitimbu',
      'Quixaba',
      'Rafael',
      'Rainha Isabel',
      'Raiz',
      'Rajada',
      'Rangel',
      'Riacho Fechado',
      'Riacho Pequeno',
      'Riacho das Almas',
      'Riacho do Meio',
      'Ribeirão',
      'Rio Formoso',
      'Rio da Barra',
      'Sairé',
      'Salgueiro',
      'Saloá',
      'Sanharó',
      'Santa Cruz da Baixa Verde',
      'Santa Cruz do Capibaribe',
      'Santa Maria da Boa Vista',
      'Santa Maria do Cambucá',
      'Santana de São Joaquim',
      'Santo Antônio das Queimadas',
      'Santo Antônio dos Palmares',
      'Sao Francisco do Brida',
      'Sapucarana',
      'Saué',
      'Serra Talhada',
      'Serra da Cachoeira',
      'Serra do Vento',
      'Serrinha da Prata',
      'Serrita',
      'Serrote do Urubu',
      'Serrote dos Bois de Cima',
      'Sertânia',
      'Sertãozinho de Baixo',
      'Siriji',
      'Sirinhaém',
      'Surubim',
      'São Benedito do Sul',
      'São Bento do Una',
      'São Caetano',
      'São Caetano do Navio',
      'São Caitano',
      'São Francisco do Brígida',
      'São Joaquim do Monte',
      'São José da Coroa Grande',
      'São José do Belmonte',
      'São José do Egito',
      'São João do Ferraz',
      'São Lorenço',
      'São Lourenço da Mata',
      'São Lázaro',
      'São Severino',
      'Sítio dos Nunes',
      'Sítio dos Remédios',
      'Tabira',
      'Tacaimbó',
      'Tacaratu',
      'Tamboatá',
      'Tapiraim',
      'Taquaritinga do Norte',
      'Tauapiranga',
      'Tejucupapo',
      'Tenebre',
      'Terezinha',
      'Terra Vermelha',
      'Timbaúba',
      'Timorante',
      'Toritama',
      'Tracunhaém',
      'Três Ladeiras',
      'Tupanaci',
      'Tupanatinga',
      'Tuparetama',
      'Tupaóca',
      'Umburetama',
      'Umãs',
      'Upatininga',
      'Urimama',
      'Urucubá',
      'Uruás',
      'Uruçu-Mirim',
      'Usina Roçadinho',
      'Valdemar Siqueira',
      'Varzinha',
      'Vasques',
      'Veneza',
      'Venturosa',
      'Verdejante',
      'Vermelhos',
      'Vertente do Lério',
      'Vertentes',
      'Vicência',
      'Vila Nova - N5',
      'Viração',
      'Vitória de Santo Antão',
      'Volta do Moxotó',
      'Xexéu',
      'Xicuru',
      'Xucuru',
      'Zé Gomes',
      'Água Preta',
    ],
    'BR-PI': [
      'Acauã',
      'Agricolândia',
      'Alagoinha do Piauí',
      'Alegrete do Piauí',
      'Alto Longá',
      'Altos',
      'Alvorada do Gurguéia',
      'Amarante',
      'Angical do Piauí',
      'Antônio Almeida',
      'Anísio de Abreu',
      'Aroazes',
      'Aroeiras do Itaim',
      'Arraial',
      'Assunção do Piauí',
      'Avelino Lopes',
      'Baixa Grande do Ribeiro',
      "Barra D'Alcântara",
      'Barras',
      'Barreiras do Piauí',
      'Bela Vista do Piauí',
      'Belém do Piauí',
      'Beneditinos',
      'Bertolínia',
      'Betânia do Piauí',
      'Boa Hora',
      'Bom Princípio do Piauí',
      'Bonfim do Piauí',
      'Boqueirão do Piauí',
      'Brasileira',
      'Brejo do Piauí',
      'Buriti dos Lopes',
      'Buriti dos Montes',
      'Cabeceiras do Piauí',
      'Cajazeiras do Piauí',
      'Cajueiro da Praia',
      'Caldeirão Grande do Piauí',
      'Campinas do Piauí',
      'Campo Alegre do Fidalgo',
      'Campo Grande do Piauí',
      'Campo Largo do Piauí',
      'Campo Maior',
      'Canavieira',
      'Canto do Buriti',
      'Capitão Gervásio Oliveira',
      'Capitão de Campos',
      'Caraúbas do Piauí',
      'Caridade do Piauí',
      'Castelo do Piauí',
      'Caxingó',
      'Cocal',
      'Cocal de Telha',
      'Cocal dos Alves',
      'Coivaras',
      'Colônia do Gurguéia',
      'Colônia do Piauí',
      'Conceição do Canindé',
      'Coronel José Dias',
      'Cristalândia do Piauí',
      'Cristino Castro',
      'Curimatá',
      'Currais',
      'Curral Novo do Piauí',
      'Curralinhos',
      'Demerval Lobão',
      'Dirceu Arcoverde',
      'Dom Expedito Lopes',
      'Dom Inocêncio',
      'Domingos Mourão',
      'Elesbão Veloso',
      'Eliseu Martins',
      'Esperantina',
      'Fartura do Piauí',
      'Flores do Piauí',
      'Floresta do Piauí',
      'Francinópolis',
      'Francisco Ayres',
      'Francisco Macedo',
      'Francisco Santos',
      'Fronteiras',
      'Geminiano',
      'Gilbués',
      'Guadalupe',
      'Guaribas',
      'Hugo Napoleão',
      'Inhuma',
      'Ipiranga do Piauí',
      'Isaías Coelho',
      'Itainópolis',
      'Itaueira',
      'Jacobina do Piauí',
      'Jaicós',
      'Jardim do Mulato',
      'Jatobá do Piauí',
      'Jerumenha',
      'Joaquim Pires',
      'Joca Marques',
      'José de Freitas',
      'João Costa',
      'Juazeiro do Piauí',
      'Júlio Borges',
      'Lagoa Alegre',
      'Lagoa de São Francisco',
      'Lagoa do Barro do Piauí',
      'Lagoa do Piauí',
      'Lagoa do Sítio',
      'Lagoinha do Piauí',
      'Landri Sales',
      'Luzilândia',
      'Luís Correia',
      'Madeiro',
      'Manoel Emídio',
      'Marcolândia',
      'Marcos Parente',
      'Massapê do Piauí',
      'Matias Olímpio',
      'Miguel Alves',
      'Miguel Leão',
      'Milton Brandão',
      'Monsenhor Gil',
      'Monsenhor Hipólito',
      'Monte Alegre do Piauí',
      'Morro Cabeça no Tempo',
      'Morro do Chapéu do Piauí',
      'Murici dos Portelas',
      'Nazaré do Piauí',
      'Nazária',
      'Nossa Senhora de Nazaré',
      'Nossa Senhora dos Remédios',
      'Nova Santa Rita',
      'Novo Nilo',
      'Novo Oriente do Piauí',
      'Oeiras',
      "Olho D'Água do Piauí",
      'Padre Marcos',
      'Paes Landim',
      'Pajeú do Piauí',
      'Palmeira do Piauí',
      'Palmeirais',
      'Paquetá',
      'Parnaguá',
      'Parnaíba',
      'Passagem Franca do Piauí',
      'Patos do Piauí',
      "Pau D'Arco do Piauí",
      'Paulistana',
      'Pavussu',
      'Pedro II',
      'Pedro Laurentino',
      'Picos',
      'Pimenteiras',
      'Pio IX',
      'Piracuruca',
      'Piripiri',
      'Porto',
      'Porto Alegre do Piauí',
      'Prata do Piauí',
      'Queimada Nova',
      'Redenção do Gurguéia',
      'Regeneração',
      'Riacho Frio',
      'Ribeira do Piauí',
      'Ribeiro Gonçalves',
      'Rio Grande do Piauí',
      'Santa Cruz do Piauí',
      'Santa Cruz dos Milagres',
      'Santa Luz',
      'Santa Rosa do Piauí',
      'Santana do Piauí',
      'Santo Antônio de Lisboa',
      'Santo Antônio dos Milagres',
      'Santo Inácio do Piauí',
      'Sebastião Barros',
      'Sebastião Leal',
      'Sigefredo Pacheco',
      'Simplício Mendes',
      'Simões',
      'Socorro do Piauí',
      'Sussuapara',
      'São Braz do Piauí',
      'São Francisco de Assis do Piauí',
      'São Francisco do Piauí',
      'São Félix do Piauí',
      'São Gonçalo do Gurguéia',
      'São Gonçalo do Piauí',
      'São José do Peixe',
      'São José do Piauí',
      'São João da Canabrava',
      'São João da Fronteira',
      'São João da Varjota',
      'São João do Arraial',
      'São João do Piauí',
      'São Julião',
      'São Lourenço do Piauí',
      'São Luís do Piauí',
      'São Miguel da Baixa Grande',
      'São Miguel do Fidalgo',
      'São Miguel do Tapuio',
      'São Pedro do Piauí',
      'São Raimundo Nonato',
      'Tamboril do Piauí',
      'Tanque do Piauí',
      'Teresina',
      'Uruçuí',
      'Valença do Piauí',
      'Vera Mendes',
      'Vila Nova do Piauí',
      'Várzea Branca',
      'Wall Ferraz',
    ],
    'BR-RN': [
      'Acari',
      'Afonso Bezerra',
      'Alexandria',
      'Almino Afonso',
      'Alto do Rodrigues',
      'Angicos',
      'Antônio Martins',
      'Apodi',
      'Arez',
      'Arês',
      'Augusto Severo',
      'Açu',
      'Barcelona',
      'Barão de Serra Branca',
      'Baía Formosa',
      'Bebida Velha',
      'Bento Fernandes',
      'Boa Saúde',
      'Bodó',
      'Caicó',
      'Caiçara do Norte',
      'Caiçara do Rio do Vento',
      'Canguaretama',
      'Carnaubais',
      'Carnaúba dos Dantas',
      'Ceará-Mirim',
      'Cerro Corá',
      'Coronel Ezequiel',
      'Coronel João Pessoa',
      'Cruzeta',
      'Currais Novos',
      'Córrego de São Mateus',
      'Doutor Severiano',
      'Encanto',
      'Equador',
      'Espírito Santo do Oeste',
      'Extremoz',
      'Felipe Guerra',
      'Fernando Pedroza',
      'Firmamento',
      'Florânia',
      'Francisco Dantas',
      'Frutuoso Gomes',
      'Galinhos',
      'Goianinha',
      'Governador Dix-Sept Rosado',
      'Guamaré',
      'Ielmo Marinho',
      'Ipanguaçu',
      'Ipueira',
      'Itaú',
      'Janduís',
      'Januário Cicco',
      'Japi',
      'Jardim de Angicos',
      'Jardim de Piranhas',
      'Jardim do Seridó',
      'Jaçanã',
      'José da Penha',
      'João Câmara',
      'João Dias',
      'Jucurutu',
      "Lagoa D'Anta",
      'Lagoa Nova',
      'Lagoa Salgada',
      'Lagoa da Anta',
      'Lagoa de Pedras',
      'Lagoa de Velhos',
      'Lajes',
      'Lajes Pintadas',
      'Lucrécia',
      'Luís Gomes',
      'Macau',
      'Macaíba',
      'Major Felipe',
      'Major Sales',
      'Marcelino Vieira',
      'Mata de São Braz',
      'Maxaranguape',
      'Messias Targino',
      'Montanhas',
      'Monte das Gameleiras',
      'Mossoró',
      'Natal',
      'Nísia Floresta',
      "Olho-d'Água do Borges",
      'Paraú',
      'Parelhas',
      'Passa e Fica',
      'Patu',
      'Pau dos Ferros',
      'Pedro Avelino',
      'Pedro Velho',
      'Pendências',
      'Pipa',
      'Portalegre',
      'Porto do Mangue',
      'Poço Branco',
      'Pureza',
      'Rafael Fernandes',
      'Rafael Godeiro',
      'Riachuelo',
      'Rio do Fogo',
      'Rodolfo Fernandes',
      'Salva Vida',
      'Santana do Matos',
      'Santana do Seridó',
      'Santo Antônio do Potengi',
      'Senador Elói de Souza',
      'Senador Georgino Avelino',
      'Serra Caiada',
      'Serra Negra do Norte',
      'Serra da Tapuia',
      'Serra de São Bento',
      'Serra do Mel',
      'Serrinha dos Pintos',
      'Severiano Melo',
      'São Bento do Norte',
      'São Bento do Trairi',
      'São Fernando',
      'São Francisco do Oeste',
      'São José da Passagem',
      'São José de Mipibu',
      'São José do Campestre',
      'São José do Seridó',
      'São João do Sabugi',
      'São Miguel de Touros',
      'São Miguel do Gostoso',
      'São Paulo do Potengi',
      'Taboleiro Grande',
      'Taipu',
      'Tangará',
      'Tenente Ananias',
      'Tenente Laurentino Cruz',
      'Tibau',
      'Tibau do Sul',
      'Timbaúba dos Batistas',
      'Touros',
      'Triunfo Potiguar',
      'Umarizal',
      'Upanema',
      'Venha-Ver',
      'Vila Flor',
      'Água Nova',
    ],
    'BR-RS': [
      'Aceguá',
      'Afonso Rodrigues',
      'Aguapés',
      'Agudo',
      'Ajuricaba',
      'Albardão',
      'Alegrete',
      'Alfredo Brenner',
      'Almirante Tamandaré do Sul',
      'Alpestre',
      'Alto Erval Novo',
      'Alto Feliz',
      'Alto Paredão',
      'Alto Recreio',
      'Alto Uruguai',
      'Alto da União',
      'Amaral Ferrador',
      'Ametista do Sul',
      'Amoras',
      'André da Rocha',
      'Anta Gorda',
      'Antônio Kerpel',
      'Antônio Prado',
      'Arambaré',
      'Araricá',
      'Aratiba',
      'Arco Verde',
      'Arlindo',
      'Arroio Bonito',
      'Arroio Canoas',
      'Arroio Grande',
      'Arroio Teixeira',
      'Arroio do Meio',
      'Arroio do Ouro',
      'Arroio do Padre',
      'Arroio do Sal',
      'Arroio do Sol',
      'Arroio do Só',
      'Arroio do Tigre',
      'Arroio dos Mengues',
      'Arroio dos Ratos',
      'Arvore Só',
      'Arvorezinha',
      'Atafona',
      'Atiaçu',
      'Atlântico',
      'Augusto Pestana',
      'Avelino Paranhos',
      'Azevedo Sodré',
      'Açoita Cavalo',
      'Bacupari',
      'Bagé',
      'Balneário Pinhal',
      'Bandeirinha',
      'Banhado do Colégio',
      'Barra Curta Baixa',
      'Barra Funda',
      'Barra do Guarita',
      'Barra do Ouro',
      'Barra do Quaraí',
      'Barra do Ribeiro',
      'Barra do Rio Azul',
      'Barragem do Itu',
      'Barreirinho',
      'Barros Cassal',
      'Barão',
      'Barão de Cotegipe',
      'Barão do Triunfo',
      'Basílio',
      'Batovira',
      'Bela Vista do Fão',
      'Beluno',
      'Benjamin Constant do Sul',
      'Bento Gonçalves',
      'Bexiga',
      'Boa Vista das Missões',
      'Boa Vista do Buricá',
      'Boa Vista do Cadeado',
      'Boa Vista do Incra',
      'Boa Vista do Sul',
      'Boca do Monte',
      'Boi Preto',
      'Bojuru',
      'Bom Plano',
      'Bom Recreio',
      'Bom Retiro do Guaíba',
      'Bom Retiro do Sul',
      'Bom Será',
      'Boqueirão do Leão',
      'Bororé',
      'Borussia',
      'Bossoroca',
      'Bote',
      'Botucaraí',
      'Bozano',
      'Boêmios',
      'Braga',
      'Braço Forte',
      'Brochier',
      'Brugnarotto',
      'Butiatuva',
      'Butiá',
      'Butiás',
      'CR-1',
      'Cacequi',
      'Cachoeira do Sul',
      'Cacique Doble',
      'Cadorna',
      'Caibaté',
      'Camaquã',
      'Cambará do Sul',
      'Camobi',
      'Campestre Baixo',
      'Campestre da Serra',
      'Campina Redonda',
      'Campina das Missões',
      'Campinas do Sul',
      'Campinho',
      'Campo Bom',
      'Campo Branco',
      'Campo Novo',
      'Campo Santo',
      'Campo Seco',
      'Campo Vicente',
      'Campo de Sobradinho',
      'Campos Borges',
      'Candelária',
      'Candiota',
      'Canguçu',
      'Canhembora',
      'Canoas',
      'Canto Krewer',
      'Canudos do Vale',
      'Capané',
      'Capao Novo (Capao Da Canoa)',
      'Capela Santo Antônio',
      'Capela São Francisco',
      'Capela São Paulo',
      'Capela Velha',
      'Capela da Luz',
      'Capela de Santana',
      'Capitão',
      'Capitão Noronha',
      'Capivari do Sul',
      'Capivarita',
      'Capo-Erê',
      'Capoeira Grande',
      'Capão Bonito do Sul',
      'Capão Comprido',
      'Capão Novo',
      'Capão da Canoa',
      'Capão da Herança',
      'Capão da Porteira',
      'Capão do Cedro',
      'Capão do Cipó',
      'Capão do Leão',
      'Capão do Tigre',
      'Carajá Seival',
      'Caraá',
      'Carlos Barbosa',
      'Carlos Gomes',
      'Carovi',
      'Casa Velha',
      'Casca',
      'Cascata',
      'Caseiros',
      'Castelinho',
      'Catanduva Grande',
      'Catimbau',
      'Catuípe',
      'Cavajuretã',
      'Caverá',
      'Caxias do Sul',
      'Cazuza Ferreira',
      'Caçapava do Sul',
      'Cedro Marcado',
      'Centro Linha Brasil',
      'Cerrito',
      'Cerrito Alegre',
      'Cerrito do Ouro',
      'Cerrito do Ouro ou Vila do Cerrito',
      'Cerro Alegre Baixo',
      'Cerro Alto',
      'Cerro Branco',
      'Cerro Chato',
      'Cerro Claro',
      'Cerro Grande',
      'Cerro Grande do Sul',
      'Cerro Largo',
      'Cerro Partido',
      'Cerro Preto',
      'Cerro do Martins',
      'Cerro do Roque',
      'Chapada',
      'Charqueadas',
      'Charrua',
      'Chiapetta',
      'Chicolomã',
      'Chimarrão',
      'Chorão',
      'Chuvisca',
      'Chuí',
      'Cidreira',
      'Cinco da Boa Vista',
      'Cinqüentenario',
      'Ciríaco',
      'Clara',
      'Clemente Argolo',
      'Coloninha',
      'Colônia Medeiros',
      'Colônia Municipal',
      'Colônia Nova',
      'Colônia São João',
      'Colônia Z-3',
      'Colônia das Almas',
      'Comandaí',
      'Condor',
      'Consolata',
      'Constantina',
      'Constantino',
      'Coqueiro Baixo',
      'Coqueiros do Sul',
      'Cordeiro',
      'Cordilheira',
      'Coroados',
      'Coronel Barros',
      'Coronel Bicaco',
      'Coronel Finzito',
      'Coronel Pilar',
      'Coronel Prestes',
      'Coronel Teixeira',
      'Cortado',
      'Costa da Cadeia',
      'Costão',
      'Cotiporã',
      'Coxilha',
      'Coxilha Grande',
      'Coxilha Seca',
      'Coxilha do Lageado',
      'Crissiumal',
      'Cristal',
      'Cristal do Sul',
      'Criúva',
      'Cruzaltense',
      'Cruzaltinha',
      'Curral Alto',
      'Curumim',
      'Cândido Freire',
      'Cândido Godói',
      'Daltro Filho',
      'David Canabarro',
      'Delfina',
      'Deodoro',
      'Depósito',
      'Derrubadas',
      'Despraiado',
      'Dezesseis de Novembro',
      'Dilermando de Aguiar',
      'Dois Irmãos das Missões',
      'Dois Lajeados',
      'Dom Diogo',
      'Dom Feliciano',
      'Dom Pedrito',
      'Dom Pedro de Alcântara',
      'Dona Francisca',
      'Dona Otília',
      'Douradilho',
      'Doutor Bozano',
      'Doutor Edgardo Pereira Velho',
      'Doutor Maurício Cardoso',
      'Doutor Ricardo',
      'Durasnal',
      'Dário Lassance',
      'Eldorado do Sul',
      'Eletra',
      'Encruzilhada São Sebastião',
      'Encruzilhada do Sul',
      'Engenheiro Luiz Englert',
      'Engenho Grande',
      'Entre Rios do Sul',
      'Entre-Ijuís',
      'Entrepelado',
      'Enxovia',
      'Erebango',
      'Erechim',
      'Ernestina',
      'Ernesto Alves',
      'Erval Grande',
      'Erval Seco',
      'Erveiras',
      'Esperança do Sul',
      'Espigão',
      'Espigão Alto',
      'Espinilho Grande',
      'Espumoso',
      'Esquina Araújo',
      'Esquina Bom Sucesso',
      'Esquina Brasil Neves',
      'Esquina Gaúcha',
      'Esquina Ipiranga',
      'Esquina Piratini',
      'Estação',
      'Esteio',
      'Esteira',
      'Estrela Velha',
      'Estância Grande',
      'Estância Nova',
      'Estância Velha',
      'Eugênio de Castro',
      'Evangelista',
      'Evaristo',
      'Fagundes Varela',
      'Farinhas',
      'Farrapos',
      'Farroupilha',
      'Faxinal Preto',
      'Faxinal do Soturno',
      'Faxinalzinho',
      'Fazenda Colorado',
      'Fazenda Fialho',
      'Fazenda Souza',
      'Fazenda Vilanova',
      'Fazenda das Laranjeiras',
      'Feliz',
      'Ferreira',
      'Flores da Cunha',
      'Fontoura Xavier',
      'Forninho',
      'Forqueta',
      'Forqueta Baixa',
      'Forquetinha',
      'Fortaleza dos Valos',
      'Francesa Alta',
      'Frederico Westphalen',
      'Frei Sebastião',
      'Freire',
      'Fão',
      'Garibaldi',
      'Garibaldina',
      'Garruchos',
      'Gaurama',
      'General Câmara',
      'General Neto',
      'Gentil',
      'Getúlio Vargas',
      'Giruazinho',
      'Giruá',
      'Glorinha',
      'Goio-En',
      'Gramado',
      'Gramado São Pedro',
      'Gramado Xavier',
      'Gramado dos Loureiros',
      'Granja Getúlio Vargas',
      'Gravataí',
      'Guabiju',
      'Guajuviras',
      'Guarani das Missões',
      'Guassu Boi',
      'Guassupi',
      'Guaíba',
      'Herval',
      'Herveiras',
      'Hidráulica',
      'Horizontina',
      'Hulha Negra',
      'Ibarama',
      'Ibaré',
      'Ibiaçá',
      'Ibiraiaras',
      'Ibirapuitã',
      'Ibirubá',
      'Ijucapirama',
      'Ijuí',
      'Ilha dos Marinheiros',
      'Ilópolis',
      'Imbé',
      'Imigrante',
      'Inhacorá',
      'Inhanduí',
      'Ipiranga do Sul',
      'Ipuaçu',
      'Ipê',
      'Iraí',
      'Iruí',
      'Ismael',
      'Itaara',
      'Itacurubi',
      'Itaimbezinho',
      'Itapororó',
      'Itapuca',
      'Itapuã',
      'Itatiba do Sul',
      'Itaí',
      'Ituim',
      'Itão',
      'Ivorá',
      'Ivoti',
      'Jaboticaba',
      'Jacuizinho',
      'Jaguarete',
      'Jaguari',
      'Jaguarão Chico',
      'Jaguarão Grande',
      'Jansen',
      'Jaquirana',
      'Jari',
      'Jazidas',
      'Jazidas ou Capela São Vicente',
      'José Otávio',
      'João Arregui',
      'João Rodrigues',
      'Joça Tavares',
      'Jóia',
      'Júlio de Castilhos',
      'Lagoa Bonita do Sul',
      'Lagoa Vermelha',
      'Lagoa dos Três Cantos',
      'Lagoão',
      'Lajeado Cerne',
      'Lajeado do Bugre',
      'Laranjeira',
      'Lava-Pés',
      'Lavras do Sul',
      'Lejeado Micuim',
      'Leonel Rocha',
      'Liberato Salzano',
      'Lindolfo Collor',
      'Linha Bonita',
      'Linha Comprida',
      'Linha Ferrari',
      'Linha Francesa Alta',
      'Linha Glória',
      'Linha Harmonia',
      'Linha Nova',
      'Linha Ocidental',
      'Linha Porto Alegre',
      'Linha Silveira',
      'Linha São João',
      'Linha Vitória',
      'Machadinho',
      'Magistério',
      'Mampituba',
      'Manchinha',
      'Mangueiras',
      'Manoel Viana',
      'Maquiné',
      'Maratá',
      'Marau',
      'Marcelino Ramos',
      'Marcorama',
      'Maria Santa',
      'Mariana Pimentel',
      'Mariano Moro',
      'Mariante',
      'Mariápolis',
      'Marques de Souza',
      'Matarazzo',
      'Mato Castelhano',
      'Mato Grande',
      'Mato Leitão',
      'Mato Perso',
      'Mauá',
      'Maximiliano de Almeida',
      'Maçambará',
      'Minas do Leão',
      'Mingote',
      'Minuano',
      'Miraguaia',
      'Miraguaí',
      'Mirim',
      'Montauri',
      'Monte Alegre dos Campos',
      'Monte Belo do Sul',
      'Monte Bonito',
      'Montenegro',
      'Mormaço',
      'Morrinhos do Sul',
      'Morro Azul',
      'Morro Gaúcho',
      'Morro Grande',
      'Morro Redondo',
      'Morro Reuter',
      'Morro dos Leffas',
      'Morungava',
      'Mostardas',
      'Muitos Capões',
      'Muliterno',
      'Murta',
      'Muçum',
      'Nicolau Vergueiro',
      'Nonoai',
      'Nossa Senhora da Conceição',
      'Nossa Senhora da Saúde',
      'Nova Araçá',
      'Nova Bassano',
      'Nova Boa Vista',
      'Nova Bréscia',
      'Nova Candelária',
      'Nova Esperança do Sul',
      'Nova Hartz',
      'Nova Milano',
      'Nova Palma',
      'Nova Petrópolis',
      'Nova Prata',
      'Nova Pádua',
      'Nova Ramada',
      'Nova Roma do Sul',
      'Nova Sardenha',
      'Nova Tramandaí',
      'Novo Barreiro',
      'Novo Cabrais',
      'Novo Hamburgo',
      'Novo Machado',
      'Novo Paraíso',
      'Novo Tiradentes',
      'Novo Xingu',
      'Não-Me-Toque',
      'Oliva',
      'Oralina',
      'Osvaldo Cruz',
      'Osvaldo Kroeff',
      'Osório',
      'Otávio Rocha',
      'Pacheca',
      'Padilha',
      'Padre Gonzales',
      'Paim Filho',
      'Palanque',
      'Palmares do Sul',
      'Palmeira das Missões',
      'Palmitinho',
      'Pampeiro',
      'Pantano Grande',
      'Paraí',
      'Paraíso do Sul',
      'Pareci Novo',
      'Parobé',
      'Parque Eldorado',
      'Passa Sete',
      'Passinhos',
      'Passo Burmann',
      'Passo Novo',
      'Passo Raso',
      'Passo Real',
      'Passo Real de Candiota',
      'Passo da Areia',
      'Passo da Caveira',
      'Passo das Pedras',
      'Passo do Adão',
      'Passo do Carro',
      'Passo do Goulart',
      'Passo do Mendonça',
      'Passo do Sabão',
      'Passo do Sobrado',
      'Passo do Verde',
      'Paulo Bento',
      'Paverama',
      'Pedras Altas',
      'Pedregal',
      'Pedro Garcia',
      'Pedro Osório',
      'Pedro Paiva',
      'Pega Fogo',
      'Pejuçara',
      'Pelotas',
      'Picada Café',
      'Pinhal Alto',
      'Pinhal Grande',
      'Pinhal Queimado',
      'Pinhal da Serra',
      'Pinheirinho do Vale',
      'Pinheiro Machado',
      'Pinheiro Marcado',
      'Pinto Bandeira',
      'Piquiri',
      'Piraju',
      'Piratini',
      'Piraí',
      'Pitingal',
      'Plano Alto',
      'Polígono Do Erval',
      'Pompeu Machado',
      'Ponte Preta',
      'Pontes Filho',
      'Pontão',
      'Pontão Santo Antônio',
      'Porto Alegre',
      'Porto Batista',
      'Porto Colônia',
      'Porto Lucena',
      'Porto Mauá',
      'Porto Soberbo',
      'Porto Vera Cruz',
      'Porto Xavier',
      'Posse dos Linhares',
      'Pouso Novo',
      'Povo Novo',
      'Povoado Tozzo',
      'Poço das Antas',
      'Prado Novo',
      'Pranchada',
      'Pratos',
      'Presidente Lucena',
      'Protásio Alves',
      'Pulador',
      'Putinga',
      'Pólo Petroquímico de Triunfo',
      'Quaraim',
      'Quaraí',
      'Quatro Irmãos',
      'Quevedos',
      'Quinta',
      'Quintão',
      'Quinze de Novembro',
      'Quitéria',
      'Rainha do Mar',
      'Ranchinho',
      'Rancho Velho',
      'Redentora',
      'Refugiado',
      'Relvado',
      'Ressaca do Buriti',
      'Restinga Seca',
      'Rincao dos Pintos',
      'Rincão Comprido',
      'Rincão Del Rei',
      'Rincão Doce',
      'Rincão Maciel',
      'Rincão Vermelho',
      'Rincão da Cruz',
      'Rincão da Estrela',
      'Rincão de São Miguel',
      'Rincão de São Pedro',
      'Rincão do Appel',
      'Rincão do Cristóvão Pereira',
      'Rincão do Ivaí',
      'Rincão do Meio',
      'Rincão do Segredo',
      'Rincão dos Kroeff',
      'Rincão dos Mellos',
      'Rincão dos Mendes',
      'Rincão dos Meoti',
      'Rincão dos Moraes',
      'Rincão dos Paivas',
      'Rincão dos Roratos',
      'Rincão dos Toledos',
      'Rio Grande',
      'Rio Pardinho',
      'Rio Pardo',
      'Rio Telha',
      'Rio Tigre',
      'Rio Toldo',
      'Rio da Ilha',
      'Rio do Terra',
      'Rio dos Índios',
      'Roca Sales',
      'Rodeio Bonito',
      'Rolador',
      'Rolante',
      'Rolantinho da Figueira',
      'Ronda Alta',
      'Roque Gonzales',
      'Rosário do Sul',
      'Saicã',
      'Saldanha Marinho',
      'Salto do Jacuí',
      'Salvador das Missões',
      'Salvador do Sul',
      'Sampaio',
      'Sananduva',
      'Sanga Funda',
      "Sant'auta",
      'Santa Auta',
      'Santa Bárbara do Sul',
      'Santa Catarina',
      'Santa Cecília do Sul',
      'Santa Clara do Ingaí',
      'Santa Clara do Sul',
      'Santa Cristina',
      'Santa Cristina do Pinhal',
      'Santa Cruz da Concórdia',
      'Santa Cruz do Sul',
      'Santa Emília',
      'Santa Flora',
      'Santa Gema',
      'Santa Izabel do Sul',
      'Santa Luiza',
      'Santa Lúcia do Piaí',
      'Santa Margarida do Sul',
      'Santa Maria do Herval',
      'Santa Rita do Sul',
      'Santa Silvana',
      'Santa Vitória do Palmar',
      'Santana da Boa Vista',
      'Santana do Livramento',
      'Santiago',
      'Santo Amaro do Sul',
      'Santo Antonio dos Pinheirinhos',
      'Santo Antão',
      'Santo Antônio da Patrulha',
      'Santo Antônio das Missões',
      'Santo Antônio de Castro',
      'Santo Antônio do Bom Retiro',
      'Santo Antônio do Palma',
      'Santo Antônio do Planalto',
      'Santo Augusto',
      'Santo Cristo',
      'Santo Expedito do Sul',
      'Santo Ângelo',
      'Sapiranga',
      'Sapucaia do Sul',
      'Saraiva',
      'Scharlau',
      'Seberi',
      'Seca',
      'Sede Aurora',
      'Sede Independência',
      'Sede Nova',
      'Segredo',
      'Seival',
      'Selbach',
      'Senador Salgado Filho',
      'Sentinela do Sul',
      'Serafim Schmidt',
      'Serafina Corrêa',
      'Serra do Pontão',
      'Serra dos Gregórios',
      'Serrinha Velha',
      'Sertão',
      'Sertão Santana',
      'Sete de Setembro',
      'Severiano de Almeida',
      'Silva Jardim',
      'Silveira',
      'Silveira Martins',
      'Sinimbu',
      'Sossego',
      'Souto Neto',
      'Souza Ramos',
      'Suspiro',
      'São Bom Jesus',
      'São Borja',
      'São Carlos',
      'São Domingos do Sul',
      'São Francisco de Assis',
      'São Jerônimo',
      'São José da Glória',
      'São José da Reserva',
      'São José das Missões',
      'São José de Castro',
      'São José do Centro',
      'São José do Herval',
      'São José do Hortêncio',
      'São José do Inhacorá',
      'São José do Norte',
      'São José do Ouro',
      'São José do Sul',
      'São José dos Ausentes',
      'São José dos Campos Borges',
      'São João da Urtiga',
      'São João do Polêsine',
      'São João dos Mellos',
      'São Leopoldo',
      'São Lourenço das Missões',
      'São Lourenço do Sul',
      'São Luiz Gonzaga',
      'São Luís Rei',
      'São Manuel',
      'São Marcos Baixo',
      'São Martinho da Serra',
      'São Miguel das Missões',
      'São Nicolau',
      'São Paulo das Missões',
      'São Paulo das Tunas',
      'São Pedro da Serra',
      'São Pedro das Missões',
      'São Pedro do Butiá',
      'São Pedro do Iraxim',
      'São Pedro do Sul',
      'São Sebastião do Caí',
      'São Sepé',
      'São Valentim do Sul',
      'São Valentin da Gruta',
      'São Valério do Sul',
      'São Vendelino',
      'São Vicente do Sul',
      'Sério',
      'Sírio',
      'Sítio Alto',
      'Sítio Cassemiro',
      'Sítio Gabriel',
      'Sítio do Herval',
      'Tabaí',
      'Taboãozinho',
      'Taim',
      'Tainhas',
      'Tamanduá',
      'Tanque',
      'Tapes',
      'Taquaral',
      'Taquarichim',
      'Taquaruçu do Sul',
      'Tenente Portela',
      'Terra de Areia',
      'Tesouras',
      'Teutônia',
      'Tiaraju',
      'Timbaúva',
      'Tio Hugo',
      'Tiradentes do Sul',
      'Toropi',
      'Toroquá',
      'Torquato Severo',
      'Torres',
      'Torrinhas',
      'Touro Passo',
      'Tramandaí',
      'Travesseiro',
      'Trentin',
      'Treze de Maio',
      'Trindade do Sul',
      'Tronqueiras',
      'Três Arroios',
      'Três Barras',
      'Três Cachoeiras',
      'Três Coroas',
      'Três Forquilhas',
      'Três Mártires',
      'Três Palmeiras',
      'Três Passos',
      'Três Vendas',
      'Três de Maio',
      'Tucunduva',
      'Tuiuti',
      'Tunas',
      'Tupanci',
      'Tupanci do Sul',
      'Tupanciretã',
      'Tupandi',
      'Tupantuba',
      'Tuparendi',
      'Tupi Silveira',
      'Turuçu',
      'Turvinho',
      'Túnel Verde',
      'Ubiretama',
      'Umbu',
      'Unistalda',
      'União da Serra',
      'Uruguaiana',
      'Vacacaí',
      'Vacaria',
      'Valdástico',
      'Vale Real',
      'Vale Veneto',
      'Vale do Arroio Grande',
      'Vale do Rio Cai',
      'Vale do Sampaio',
      'Vale do Sol',
      'Vale dos Vinhedos',
      'Vanini',
      'Varame',
      'Varzea (Sao Jose Dos Ausentes)',
      'Vasco Alves',
      'Veado Pardo',
      'Venâncio Aires',
      'Vespasiano Corrêa',
      'Viadutos',
      'Viamão',
      'Vicente Dutra',
      'Victor Graeff',
      'Vila Bender',
      'Vila Block',
      'Vila Boqueirão',
      'Vila Campos',
      'Vila Cristina',
      'Vila Cruz',
      'Vila Fernando Ferrari',
      'Vila Flores',
      'Vila Freire',
      'Vila Ituim',
      'Vila Laranjeira',
      'Vila Lângaro',
      'Vila Maria',
      'Vila Nova do Sul',
      'Vila Oliva',
      'Vila Paz',
      'Vila Seca',
      'Vila Souza',
      'Vila Turvo',
      'Vista Alegre do Prata',
      'Vista Gaúcha',
      'Vista Nova',
      'Vitória das Missões',
      'Volta Alegre',
      'Volta Fechada',
      'Volta Vitória',
      'Várzea dos Antunes',
      'Westfalia',
      'Xadrez',
      'Xangri-lá',
      'Xarqueada',
      'Xiniquá',
      'Água Santa',
      'Áurea',
    ],
    'BR-RJ': [
      'Abarracamento',
      'Afonso Arinos',
      'Andrade Pinto',
      'Angra dos Reis',
      'Aperibé',
      'Araruama',
      'Areal',
      'Arraial do Cabo',
      'Arrozal',
      'Avelar',
      'Bacaxá',
      'Baltazar',
      'Banquete',
      'Barra Mansa',
      'Barra de Macaé',
      'Barra de São João',
      'Barra do Piraí',
      'Barão de Juparana',
      'Batatal',
      'Belford Roxo',
      'Bemposta',
      'Bom Jesus do Itabapoana',
      'Bom Jesus do Querendo',
      'Búzios',
      'Cabo Frio',
      'Cachoeiras de Macacu',
      'Cachoeiros',
      'Calheiros',
      'Califórnia da Barra',
      'Cambiasca',
      'Cambuci',
      'Campo do Coelho',
      'Campos Elíseos',
      'Campos dos Goytacazes',
      'Carabuçu',
      'Carapebus',
      'Cardoso Moreira',
      'Casimiro de Abreu',
      'Cava',
      'Coelho da Rocha',
      'Comendador Levy Gasparian',
      'Comendador Venâncio',
      'Conceição de Jacareí',
      'Conceição de Macabu',
      'Conrado',
      'Conselheiro Paulino',
      'Conservatória',
      'Coroa Grande',
      'Correas',
      'Correntezas',
      'Córrego da Prata',
      'Dores de Macabu',
      'Dorândia',
      'Doutor Elias',
      'Doutor Loreti',
      'Duque de Caxias',
      'Engenheiro Passos',
      'Engenheiro Paulo de Frontin',
      'Engenheiro Pedreira',
      'Estrada Nova',
      'Euclidelândia',
      'Frade',
      'Fumaça',
      'Funil',
      'Gaviões',
      'Getulândia',
      'Glicério',
      'Governador Portela',
      'Guapimirim',
      'Guia de Pacobaíba',
      'Ibitiguaçu',
      'Ibitioca',
      'Iguaba Grande',
      'Imbariê',
      'Inconfidência',
      'Inhomirim',
      'Inoã',
      'Ipiabas',
      'Ipiabás',
      'Ipiiba',
      'Ipituna',
      'Ipuca',
      'Itabapoana',
      'Itaboraí',
      'Itacurussá',
      'Itaguaí',
      'Itaipuaçu',
      'Itajara',
      'Italva',
      'Itaocara',
      'Itatiaia',
      'Jaguarembé',
      'Jamapará',
      'Japeri',
      'Japuíba',
      'Laje do Muriaé',
      'Laranjais',
      'Lumiar',
      'Lídice',
      'Macabuzinho',
      'Macaé',
      'Magé',
      'Mambucaba',
      'Mangaratiba',
      'Manilha',
      'Maniva',
      'Manuel Duarte',
      'Marangatu',
      'Maricá',
      'Mendes',
      'Miguel Pereira',
      'Miracema',
      'Monjolo',
      'Monnerat',
      'Monumento',
      'Morangaba',
      'Morro do Côco',
      'Mussurepe',
      'Natividade',
      'Nhunguaçu',
      'Nilópolis',
      'Niterói',
      'Nossa Senhora da Penha',
      'Nova Friburgo',
      'Nova Iguaçu',
      'Ourânia',
      'Papucaia',
      'Paquequer Pequeno',
      'Paracambi',
      'Paraoquena',
      'Parapeúna',
      'Parati',
      'Parati Mirim',
      'Paraíba do Sul',
      'Paraíso do Tobias',
      'Passa Três',
      'Paty do Alferes',
      'Pedra Selada',
      'Pedro do Rio',
      'Pentagna',
      'Petrópolis',
      'Piabetá',
      'Pinheiral',
      'Pipeiras',
      'Pirangaí',
      'Pirapetinga de Bom Jesus',
      'Ponta Negra',
      'Porciúncula',
      'Portela',
      'Porto Real',
      'Porto Velho do Cunha',
      'Purilândia',
      'Quartéis',
      'Quatis',
      'Quissamã',
      'Raposo',
      'Resende',
      'Retiro do Muriaé',
      'Rio Claro',
      'Rio das Flores',
      'Rio das Ostras',
      'Rio de Janeiro',
      'Riograndina',
      'Rosal',
      'Sacra Família do Tinguá',
      'Salutaris',
      'Sambaetiba',
      'Sampaio Correia',
      'Sana',
      'Santa Cruz da Serra',
      'Santa Isabel do Rio Preto',
      'Santa Maria Madalena',
      'Santa Rita da Floresta',
      'Santanésia',
      'Santo Aleixo',
      'Santo Amaro de Campos',
      'Santo Antônio de Pádua',
      'Santo Antônio do Imbé',
      'Santo Eduardo',
      'Saquarema',
      'Saracuruna',
      'Sebastião de Lacerda',
      'Seropédica',
      'Sete Pontes',
      'Sodrelândia',
      'Subaio',
      'Suruí',
      'São Fidélis',
      'São Francisco de Itabapoana',
      'São José de Ubá',
      'São José do Ribeirão',
      'São José do Turvo',
      'São José do Vale do Rio Preto',
      'São João Marcos',
      'São João da Barra',
      'São João de Meriti',
      'São Pedro da Aldeia',
      'São Sebastião de Campos',
      'São Sebastião do Alto',
      'São Sebastião do Paraíba',
      'São Sebastião dos Ferreiros',
      'São Vicente de Paula',
      'Taboas',
      'Tamoios',
      'Tanguá',
      'Tarituba',
      'Teresópolis',
      'Tocos',
      'Trajano de Moraes',
      'Travessão',
      'Três Irmãos',
      'Três Rios',
      'Valão do Barro',
      'Varre-Sai',
      'Vassouras',
      'Venda das Flores',
      'Vila Muriqui',
      'Vila Nova de Campos',
      'Vila da Grama',
      'Visconde de Imbé',
      'Visconde de Mauá',
      'Volta Redonda',
      'Werneck',
      'Xerém',
    ],
    'BR-RO': [
      'Abunã',
      "Alta Floresta D'Oeste",
      'Alta Floresta do Oeste',
      'Alto Alegre dos Parecis',
      "Alvorada D'Oeste",
      'Alvorada do Oeste',
      'Ariquemes',
      'Boa Vista de Pacarana',
      'Bom Futuro',
      'Cabixi',
      'Cacaulândia',
      'Cacoal',
      'Calama',
      'Campo Novo de Rondônia',
      'Candeias do Jamari',
      'Castanheiras',
      'Cerejeiras',
      'Chupinguaia',
      'Colorado do Oeste',
      'Corumbiara',
      'Costa Marques',
      'Cujubim',
      'Demarcação',
      'Espigão do Oeste',
      'Fortaleza do Abunã',
      'Governador Jorge Teixeira',
      'Guajará-Mirim',
      'Industrial',
      'Itapuã do Oeste',
      'Jaci Paraná',
      'Jamari',
      'Jaru',
      'Ji-Paraná',
      "Machadinho D'Oeste",
      'Machadinho do Oeste',
      'Marco Rondon',
      'Ministro Andreazza',
      'Mirante da Serra',
      'Monte Negro',
      'Mutum Paraná',
      "Nova Brasilândia D'Oeste",
      'Nova Brasilândia do Oeste',
      'Nova Califórnia',
      'Nova Colina',
      'Nova Conquista',
      'Nova Dimensão',
      'Nova Mamoré',
      'Novo Horizonte do Oeste',
      'Ouro Preto do Oeste',
      'Parecis',
      'Pedras Negras',
      'Pimenta Bueno',
      'Pimenteiras do Oeste',
      'Porto Velho',
      'Primavera de Rondônia',
      'Príncipe da Beira',
      'Rio Crespo',
      'Rolim de Moura',
      "Santa Luzia D'Oeste",
      'Santa Luzia do Oeste',
      'Seringueiras',
      "São Felipe D'Oeste",
      'São Felipe do Oeste',
      'São Francisco do Guaporé',
      'São Miguel do Guaporé',
      'Tarilândia',
      'Teixeirópolis',
      'Theobroma',
      'União Bandeirante',
      'Urupá',
      'Vale do Anari',
      'Vale do Paraíso',
      'Vila Extrema',
      'Vilhena',
      'Vista Alegre do Abunã',
    ],
    'BR-RR': [
      'Amajari',
      'Cantá',
      'Caracaraí',
      'Caroebe',
      'Félix Pinto',
      'Mucajaí',
      'Normandia',
      'Pacaraima',
      'Rorainópolis',
      'São João da Baliza',
      'Taboca',
      'Uiramutã',
    ],
    'BR-SC': [
      'Abdon Batista',
      'Abelardo Luz',
      'Agrolândia',
      'Agronômica',
      'Aguti',
      'Aiurê',
      'Alfredo Wagner',
      'Alto Bela Vista',
      'Alto da Serra',
      'Angelina',
      'Anita Garibaldi',
      'Anitápolis',
      'Apiúna',
      'Arabutã',
      'Araquari',
      'Araranguá',
      'Armazém',
      'Arnópolis',
      'Arroio Trinta',
      'Arvoredo',
      'Ascurra',
      'Atalanta',
      'Aterrado Torto',
      'Azambuja',
      'Baia Alta',
      'Balneário Arroio do Silva',
      'Balneário Barra do Sul',
      'Balneário Camboriú',
      'Balneário Gaivota',
      'Balneário Morro dos Conventos',
      'Balneário Piçarras',
      'Balneário Rincão',
      'Bandeirante',
      'Barra Clara',
      'Barra Fria',
      'Barra São João',
      'Barra Velha',
      'Barra da Lagoa',
      'Barra da Prata',
      'Barro Branco',
      'Bateias de Baixo',
      'Bela Vista do Sul',
      'Bela Vista do Toldo',
      'Benedito Novo',
      'Biguaçu',
      'Blumenau',
      'Bocaina do Sul',
      'Boiteuxburgo',
      'Bom Jardim da Serra',
      'Bom Jesus do Oeste',
      'Bombinhas',
      'Botuverá',
      'Braço do Norte',
      'Braço do Trombudo',
      'Brunópolis',
      'Brusque',
      'Cachoeira de Fátima',
      'Cachoeira do Bom Jesus',
      'Caibi',
      'Calmon',
      'Camboriú',
      'Cambuinzal',
      'Campeche',
      'Campo Belo do Sul',
      'Campo Erê',
      'Canasvieiras',
      'Canelinha',
      'Canoinhas',
      'Capivari de Baixo',
      'Catuíra',
      'Caxambu do Sul',
      'Caçador',
      'Cedro Alto',
      'Celso Ramos',
      'Cerro Negro',
      'Chapadão do Lageado',
      'Chapecó',
      'Claraíba',
      'Cocal do Sul',
      'Colônia Santa Tereza',
      'Concórdia',
      'Cordilheira Alta',
      'Coronel Freitas',
      'Coronel Martins',
      'Correia Pinto',
      'Corupá',
      'Criciúma',
      'Cunha Porã',
      'Cunhataí',
      'Curitibanos',
      'Dal Pai',
      'Dalbérgia',
      'Descanso',
      'Dionísio Cerqueira',
      'Dona Emma',
      'Doutor Pedrinho',
      'Enseada de Brito',
      'Ermo',
      'Erval Velho',
      'Espinilho',
      'Estação Cocal',
      'Faxinal dos Guedes',
      'Fazenda Zandavalli',
      'Felipe Schmidt',
      'Florianópolis',
      'Flôr do Sertão',
      'Formosa do Sul',
      'Forquilhinha',
      'Fragosos',
      'Fraiburgo',
      'Frederico Wastner',
      'Frei Rogério',
      'Galvão',
      'Garcia',
      'Garopaba',
      'Garuva',
      'Governador Celso Ramos',
      'Gravatal',
      'Grápia',
      'Grão Pará',
      'Guabiruba',
      'Guaporanga',
      'Guaramirim',
      'Guarujá do Sul',
      'Guatambú',
      'Guatá',
      'Gôio-En',
      'Herciliópolis',
      'Hercílio Luz',
      "Herval d'Oeste",
      'Ibiam',
      'Ibicaré',
      'Ibirama',
      'Idamar',
      'Ilhota',
      'Imaruí',
      'Imbituba',
      'Imbuia',
      'Indaial',
      'Ingleses do Rio Vermelho',
      'Iomerê',
      'Ipira',
      'Ipoméia',
      'Iporã do Oeste',
      'Ipumirim',
      'Iraceminha',
      'Irakitan',
      'Irani',
      'Iraputã',
      'Irineópolis',
      'Itaió',
      'Itaiópolis',
      'Itapema',
      'Itapocu',
      'Itapoá',
      'Itoupava',
      'Ituporanga',
      'Itá',
      'Jaborá',
      'Jacinto Machado',
      'Jaguaruna',
      'Jaraguá do Sul',
      'Jardinópolis',
      'Joaçaba',
      'Joinville',
      'Jorge Lacerda',
      'José Boiteux',
      'Jupiá',
      'Lacerdópolis',
      'Lagoa da Estiva',
      'Laguna',
      'Laurentino',
      'Lauro Müller',
      'Lebon Régis',
      'Leoberto Leal',
      'Leão',
      'Lindóia do Sul',
      'Linha das Palmeiras',
      'Lontras',
      'Lourdes',
      'Luzerna',
      'Macieira',
      'Mafra',
      'Major Gercino',
      'Major Vieira',
      'Maracajá',
      'Marari',
      'Marcílio Dias',
      'Marechal Bormann',
      'Marema',
      'Mariflor',
      'Marombas',
      'Marombas Bossardi',
      'Matos Costa',
      'Meleiro',
      'Mirim Doce',
      'Modelo',
      'Mondaí',
      'Monte Carlo',
      'Morro Chato',
      'Morro da Fumaça',
      'Navegantes',
      'Nossa Senhora de Caravaggio',
      'Nova Cultura',
      'Nova Erechim',
      'Nova Itaberaba',
      'Nova Teutônia',
      'Nova Trento',
      'Otacílio Costa',
      'Ouro',
      'Paial',
      'Painel',
      'Palhoça',
      'Palma Sola',
      'Palmitos',
      'Papanduva',
      'Paraíso',
      'Passo Manso',
      'Passo de Torres',
      'Passos Maia',
      'Paula Pereira',
      'Paulo Lopes',
      'Pedras Grandes',
      'Penha',
      'Pericó',
      'Peritiba',
      'Pescaria Brava',
      'Pindotiba',
      'Pinheiro Preto',
      'Pirabeiraba',
      'Piratuba',
      'Piçarras',
      'Planalto Alegre',
      'Pomerode',
      'Ponte Alta do Norte',
      'Ponte Serrada',
      'Porto União',
      'Pouso Redondo',
      'Poço Preto',
      'Presidente Castello Branco',
      'Presidente Getúlio',
      'Presidente Nereu',
      'Pântano do Sul',
      'Quarta Linha',
      'Quilômetro Doze',
      'Rancho Queimado',
      'Ratones',
      'Residência Fuck',
      'Ribeirão Pequeno',
      'Ribeirão da Ilha',
      'Rio Antinha',
      "Rio D'Una",
      'Rio Fortuna',
      'Rio Maina',
      'Rio Negrinho',
      'Rio Preto do Sul',
      'Rio Rufino',
      'Rio da Anta',
      'Rio da Luz',
      'Rio das Furnas',
      'Rio do Campo',
      'Rio do Oeste',
      'Rio do Sul',
      'Rio dos Bugres',
      'Rio dos Cedros',
      'Riqueza',
      'Rodeio',
      'Romelândia',
      'Sai',
      'Salete',
      'Salto Veloso',
      'Sanga da Toca',
      'Sangão',
      'Santa Cruz do Pery',
      'Santa Cruz do Timbó',
      'Santa Rosa do Sul',
      'Santa Terezinha do Progresso',
      'Santa Terezinha do Salto',
      'Santiago do Sul',
      'Santo Amaro da Imperatriz',
      'Saudades',
      'Schroeder',
      'Seara',
      'Sede Oldemburg',
      'Serra Alta',
      'Sertão do Maruim',
      'Siderópolis',
      'Sombrio',
      'Sorocaba do Sul',
      'Sul Brasil',
      'São Bento Baixo',
      'São Bento do Sul',
      'São Bernardino',
      'São Bonifácio',
      'São Cristóvão',
      'São Cristóvão do Sul',
      'São Defende',
      'São Francisco do Sul',
      'São José do Cedro',
      'São José do Cerrito',
      'São José do Laranjal',
      'São João do Itaperiú',
      'São João do Oeste',
      'São João do Rio Vermelho',
      'São João do Sul',
      'São Lourenço do Oeste',
      'São Ludgero',
      'São Miguel da Boa Vista',
      'São Miguel da Serra',
      'São Miguel do Oeste',
      'São Pedro Tobias',
      'São Pedro de Alcântara',
      'São Sebastião do Arvoredo',
      'São Sebastião do Sul',
      'Taió',
      'Taquara Verde',
      'Taquaras',
      'Tigipió',
      'Tigrinhos',
      'Tijucas',
      'Timbé do Sul',
      'Timbó',
      'Timbó Grande',
      'Treviso',
      'Treze Tílias',
      'Trombudo Central',
      'Tubarão',
      'Tunápolis',
      'Tupitinga',
      'Urubici',
      'Uruguai',
      'Urupema',
      'Urussanga',
      'Vargem',
      'Vargem do Cedro',
      'Vargeão',
      'Vidal Ramos',
      'Videira',
      'Vila Conceição',
      'Vila Milani',
      'Vila de Volta Grande',
      'Vitor Meireles',
      'Witmarsum',
      'Xanxerê',
      'Xavantina',
      'Zortéa',
      'Águas Brancas',
      'Águas Frias',
      'Águas Mornas',
      'Águas de Chapecó',
      'Índios',
    ],
    'BR-SE': [
      'Altos Verdes',
      'Amparo de São Francisco',
      'Aquidabã',
      'Aracaju',
      'Arauá',
      'Barra dos Coqueiros',
      'Boquim',
      'Campo do Brito',
      'Canhoba',
      'Canindé de São Francisco',
      'Carira',
      'Carmópolis',
      'Cedro de São João',
      'Cristinápolis',
      'Cumbe',
      'Divina Pastora',
      'Estância',
      'Frei Paulo',
      'Gararu',
      'General Maynard',
      'Graccho Cardoso',
      'Gracho Cardoso',
      'Ilha das Flores',
      'Indiaroba',
      'Itabaianinha',
      'Itabi',
      "Itaporanga d'Ajuda",
      'Japaratuba',
      'Japoatã',
      'Lagarto',
      'Lagoa Funda',
      'Malhada dos Bois',
      'Malhador',
      'Maruim',
      'Moita Bonita',
      'Monte Alegre de Sergipe',
      'Neópolis',
      'Nossa Senhora da Glória',
      'Nossa Senhora das Dores',
      'Nossa Senhora do Socorro',
      'Pedra Mole',
      'Pirambu',
      'Porto da Folha',
      'Poço Redondo',
      'Propriá',
      'Riachão do Dantas',
      'Ribeirópolis',
      'Rosário do Catete',
      'Salgado',
      'Santa Luzia do Itanhy',
      'Santana do São Francisco',
      'Santo Amaro das Brotas',
      'Simão Dias',
      'Siriri',
      'São Mateus da Palestina',
      'São Miguel do Aleixo',
      'Telha',
      'Tobias Barreto',
      'Tomar do Geru',
      'Umbaúba',
    ],
    'BR-SP': [
      'Adamantina',
      'Adolfo',
      'Agisse',
      'Agudos',
      'Agulha',
      'Ajapi',
      'Alambari',
      'Alberto Moreira',
      'Aldeia da Serra',
      'Alfredo Guedes',
      'Alfredo Marcondes',
      'AlphavilleTamboré',
      'Altair',
      'Altinópolis',
      'Alumínio',
      'Alvinlândia',
      'Amandaba',
      'Americana',
      'Américo Brasiliense',
      'Américo de Campos',
      'Ana Dias',
      'Analândia',
      'Andradina',
      'Angatuba',
      'Anhembi',
      'Anhumas',
      "Aparecida D'Oeste",
      'Aparecida de Monte Alto',
      'Aparecida de São Manuel',
      'Aparecida do Bonito',
      'Apiaí',
      'Apiaí Mirim',
      'Arabela',
      'Arabá',
      'Aracaçu',
      'Aramina',
      'Arandu',
      'Arapeí',
      'Araraquara',
      'Araxás',
      'Araçariguama',
      'Araçatuba',
      'Araçaíba',
      'Araçoiaba da Serra',
      'Arco Íris',
      'Arealva',
      'Areiópolis',
      'Ariranha',
      'Artur Nogueira',
      'Arujá',
      'Aspásia',
      'Assistência',
      'Atibaia',
      'Atlântida',
      'Auriflama',
      'Avanhandava',
      'Avaré',
      'Avaí',
      'Bacaetava',
      'Bacuriti',
      'Bady Bassitt',
      'Baguaçu',
      'Balbinos',
      'Bananal',
      "Bandeirantes D'Oeste",
      'Barbosa',
      'Barequeçaba',
      'Bariri',
      'Barra Dourada',
      'Barra do Chapéu',
      'Barra do Turvo',
      'Barra do Una',
      'Barretos',
      'Barrânia',
      'Barueri',
      'Barão Ataliba Nogueira',
      'Barão de Antonina',
      'Bastos',
      'Batatais',
      'Batatuba',
      'Batista Botelho',
      'Bauru',
      'Bela Floresta',
      'Bento de Abreu',
      'Bernardino de Campos',
      'Bertioga',
      'Bilac',
      'Birigui',
      'Biritiba Mirim',
      'Biritiba Ussu',
      'Boa Esperança do Sul',
      'Boa Vista dos Andradas',
      'Bofete',
      'Boituva',
      'Boiçucanga',
      'Bom Fim do Bom Jesus',
      'Bom Jesus dos Perdões',
      'Bom Retiro da Esperança',
      'Bom Sucesso de Itararé',
      'Bonfim Paulista',
      'Boracéia',
      'Borebi',
      'Borá',
      'Botelho',
      'Botucatu',
      'Botujuru',
      'Bragança Paulista',
      'Brasitânia',
      'Braço',
      'Braúna',
      'Brejo Alegre',
      'Brodowski',
      'Brás Cubas',
      'Bueno de Andrada',
      'Buri',
      'Buritama',
      'Cabreúva',
      'Cabrália Paulista',
      'Cachoeira Paulista',
      'Cachoeira de Emas',
      'Caconde',
      'Cafesópolis',
      'Caiabu',
      'Caibura',
      'Caieiras',
      'Caiuá',
      'Cajamar',
      'Cajati',
      'Cajobi',
      'Cambaquara',
      'Cambaratiba',
      'Camburi',
      'Campina de Fora',
      'Campina do Monte Alegre',
      'Campinal',
      'Campo Limpo Paulista',
      'Campos Novos Paulista',
      'Campos de Cunha',
      'Campos do Jordão',
      'Cananéia',
      'Canas',
      'Candia',
      'Canguera',
      'Canitar',
      'Capela do Alto',
      'Capivari',
      'Capivari da Mata',
      'Caporanga',
      'Capuava',
      'Caraguatatuba',
      'Carapicuíba',
      'Cardeal',
      'Caruara',
      'Castilho',
      'Catanduva',
      'Catiguá',
      'Catucaba',
      'Caucaia do Alto',
      'Caçapava',
      'Cerqueira César',
      'Cerquilho',
      'Cesário Lange',
      'Cezar de Souza',
      'Charqueada',
      'Chavantes',
      'Cipó Guaçu',
      'Clarinia',
      'Clementina',
      'Cocaes',
      'Colômbia',
      'Conceição de Monte Alegre',
      'Conchal',
      'Conchas',
      'Cordeirópolis',
      'Coronel Goulart',
      'Coronel Macedo',
      'Corredeira',
      'Corumbataí',
      'Cosmorama',
      'Cosmópolis',
      'Costa Machado',
      'Cotia',
      'Cravinhos',
      'Cristais Paulista',
      'Cruz das Posses',
      'Cruzália',
      'Cubatão',
      'Cuiabá Paulista',
      'Cunha',
      'Curupá',
      'Cássia dos Coqueiros',
      'Cândido Mota',
      'Cândido Rodrigues',
      'Dalas',
      'Descalvado',
      'Dirce Reis',
      'Divinolândia',
      'Dobrada',
      'Dois Córregos',
      'Dolcinópolis',
      'Domélia',
      'Dracena',
      'Duartina',
      'Dumont',
      'Duplo Céu',
      'Echaporã',
      'Eldorado Paulista',
      'Eleutério',
      'Elias Fausto',
      'Elisiário',
      'Embaúba',
      'Embu',
      'Embu Guaçu',
      'Embu das Artes',
      'Emilianópolis',
      'Eneida',
      'Engenheiro Balduíno',
      'Engenheiro Coelho',
      'Engenheiro Maia',
      'Engenheiro Schmitt',
      "Esperança D'Oeste",
      'Espírito Santo do Pinhal',
      'Espírito Santo do Turvo',
      'Estiva Gerbi',
      "Estrela D'Oeste",
      'Euclides da Cunha Paulista',
      'Eugênio de Melo',
      'Fazenda Velha',
      'Fernando Prestes',
      'Fernandópolis',
      'Fernão',
      'Ferraz de Vasconcelos',
      'Flora Rica',
      'Floreal',
      'Floresta do Sul',
      'Florínia',
      'Flórida Paulista',
      'Franca',
      'Francisco Morato',
      'Franco da Rocha',
      'Frutal do Campo',
      'Fátima Paulista',
      'Gabriel Monteiro',
      'Gardênia',
      'Garça',
      'Gastão Vidigal',
      'Gavião Peixoto',
      'General Salgado',
      'Getulina',
      'Gramadinho',
      'Granja Viana',
      'Guachos',
      'Guaianas',
      'Guaimbê',
      'Guaiçara',
      'Guamium',
      'Guapiara',
      'Guapiaçu',
      'Guapiranga',
      "Guaraciaba D'Oeste",
      "Guarani D'Oeste",
      'Guarantã',
      'Guarapiranga',
      'Guarapuá',
      'Guararapes',
      'Guaratinguetá',
      'Guaraçaí',
      'Guareí',
      'Guariroba',
      'Guarizinho',
      'Guarujá',
      'Guarulhos',
      'Guatapará',
      'Guzolândia',
      'Gália',
      'Holambra',
      'Holambra II',
      'Hortolândia',
      'Iacanga',
      'Iacri',
      'Iaras',
      'Ibaté',
      'Ibiporanga',
      'Ibirarema',
      'Ibirá',
      'Ibitinga',
      'Ibitiruna',
      'Ibitiúva',
      'Ibiúna',
      'Icém',
      'Ida Iolanda',
      'Iepê',
      'Igarapava',
      'Igaratá',
      'Igaraçu do Tietê',
      'Igaraí',
      'Igaçaba',
      'Iguape',
      'Ilha Diana',
      'Ilha Solteira',
      'Ilhabela',
      'Indaiatuba',
      'Indaiá do Aguapeí',
      'Indiana',
      'Indiaporã',
      'Ingás',
      'Inúbia Paulista',
      'Ipaussu',
      'Iperó',
      'Ipeúna',
      'Ipiguá',
      'Iporanga',
      'Ipuã',
      'Iracemápolis',
      'Irapuru',
      'Irapé',
      'Itaberá',
      'Itaboa',
      'Itaiúba',
      'Itajobi',
      'Itaju',
      'Itanhaém',
      'Itapecerica da Serra',
      'Itapetininga',
      'Itapeuna',
      'Itapevi',
      'Itapira',
      'Itapirapuã Paulista',
      'Itapuí',
      'Itaquaquecetuba',
      'Itaqueri da Serra',
      'Itararé',
      'Itariri',
      'Itatiba',
      'Itatinga',
      'Itirapina',
      'Itirapuã',
      'Itobi',
      'Itororó do Paranapanema',
      'Itu',
      'Ituverava',
      'Itápolis',
      'Iubatinga',
      'Jaci',
      'Jaciporã',
      'Jacuba',
      'Jacupiranga',
      'Jafa',
      'Jaguariúna',
      'Jales',
      'Jamaica',
      'Jambeiro',
      'Jandira',
      'Jardim Belval',
      'Jardim Presidente Dutra',
      'Jardim Silveira',
      'Jarinu',
      'Jaú',
      'Jeriquara',
      'Joanópolis',
      'Joaquim Egídio',
      'Jordanésia',
      'José Bonifácio',
      'João Ramalho',
      'Juliânia',
      'Jumirim',
      'Jundiapeba',
      'Jundiaí',
      'Junqueira',
      'Junqueirópolis',
      'Juquiratiba',
      'Juquitiba',
      'Juquiá',
      'Juritis',
      'Jurucê',
      'Jurupeba',
      'Jurupema',
      'Júlio Mesquita',
      'Lageado de Araçaíba',
      'Lagoa Azul',
      'Lagoa Branca',
      'Laranjal Paulista',
      'Laras',
      'Lauro Penteado',
      'Lavrinhas',
      'Lavínia',
      'Leme',
      'Lençóis Paulista',
      'Limeira',
      'Lins',
      'Lobo',
      'Lorena',
      'Louveira',
      'Lucianópolis',
      'Lucélia',
      'Luiziânia',
      'Lupércio',
      'Lutécia',
      'Luís Antônio',
      'Macatuba',
      'Macaubal',
      'Macedônia',
      'Mailasqui',
      'Mairinque',
      'Mairiporã',
      'Major Prado',
      'Manduri',
      'Mangaratú',
      'Marabá Paulista',
      'Maracaí',
      'Marapoama',
      'Marcondésia',
      'Maresias',
      'Marinópolis',
      'Martim Francisco',
      'Marília',
      'Matão',
      'Meridiano',
      'Mesópolis',
      'Miguelópolis',
      'Mineiros do Tietê',
      'Mira Estrela',
      'Miracatu',
      'Miraluz',
      'Mirandópolis',
      'Mirante do Paranapanema',
      'Mirassol',
      'Mirassolândia',
      'Mococa',
      'Mogi Guaçu',
      'Mogi Mirim',
      'Mogi das Cruzes',
      'Mombuca',
      'Mongaguá',
      'Monte Alegre do Sul',
      'Monte Alto',
      'Monte Aprazível',
      'Monte Azul Paulista',
      'Monte Cabrão',
      'Monte Mor',
      'Monte Verde Paulista',
      'Monteiro Lobato',
      'Monções',
      'Moreira César',
      'Morro Agudo',
      'Morro do Alto',
      'Morungaba',
      'Motuca',
      'Mourão',
      'Murutinga do Sul',
      'Mágda',
      'Nantes',
      'Natividade da Serra',
      'Nazaré Paulista',
      'Neves Paulista',
      'Nhandeara',
      'Nipoã',
      'Nogueira',
      'Nossa Senhora do Remédio',
      'Nova Alexandria',
      'Nova Aliança',
      'Nova Aparecida',
      'Nova Campina',
      'Nova Canaã Paulista',
      'Nova Cardoso',
      'Nova Castilho',
      'Nova Europa',
      'Nova Granada',
      'Nova Guataporanga',
      'Nova Independência',
      'Nova Itapirema',
      'Nova Luzitânia',
      'Nova Odessa',
      'Nova Pátria',
      'Novais',
      'Novo Cravinhos',
      'Nuporanga',
      'Ocauçu',
      'Oliveira Barros',
      'Olímpia',
      'Onda Branca',
      'Onda Verde',
      'Orindiúva',
      'Orlândia',
      'Osasco',
      'Oscar Bressane',
      'Ourinhos',
      'Ouro Fino Paulista',
      'Ouroeste',
      'Oásis',
      'Pacaembu',
      'Palmares Paulista',
      "Palmeira D'Oeste",
      'Palmeiras de São Paulo',
      'Panorama',
      'Paraguaçu Paulista',
      'Paraibuna',
      'Paraisolândia',
      'Paranabi',
      'Paranapanema',
      'Paranapiacaba',
      'Paranapuã',
      'Parapuã',
      'Pardinho',
      'Pariquera-Açu',
      'Parisi',
      'Parque Meia Lua',
      'Paruru',
      'Patrocínio Paulista',
      'Paulicéia',
      'Paulo de Faria',
      'Paulínia',
      'Paulópolis',
      'Paúba',
      'Pederneiras',
      'Pedra Bela',
      'Pedra Branca de Itararé',
      'Pedranópolis',
      'Pedregulho',
      'Pedrinhas Paulista',
      'Pedro Barros',
      'Pedro de Toledo',
      'Penápolis',
      'Pereira Barreto',
      'Pereiras',
      'Peruíbe',
      'Piacatu',
      'Picinguaba',
      'Piedade',
      'Pilar do Sul',
      'Pindamonhangaba',
      'Pindorama',
      'Pioneiros',
      'Piquerobi',
      'Piquete',
      'Piracaia',
      'Piracicaba',
      'Pirajuí',
      'Pirambóia',
      'Pirapora do Bom Jesus',
      'Pirapozinho',
      'Pirassununga',
      'Planalto do Sul',
      'Platina',
      'Poloni',
      'Polvilho',
      'Pompéia',
      'Pongaí',
      'Pontal',
      'Pontalinda',
      'Pontes Gestal',
      'Populina',
      'Porangaba',
      'Porto Feliz',
      'Porto Ferreira',
      'Potim',
      'Potirendaba',
      'Potunduva',
      'Poá',
      'Pracinha',
      'Pradínia',
      'Pradópolis',
      'Pratânia',
      'Presidente Alves',
      'Presidente Epitácio',
      'Presidente Prudente',
      'Presidente Venceslau',
      'Promissão',
      'Prudêncio de Morais',
      'Quadra',
      'Quatá',
      'Queiroz',
      'Queluz',
      'Quintana',
      'Quiririm',
      'Rafard',
      'Rechan',
      'Redenção da Serra',
      'Regente Feijó',
      'Reginópolis',
      'Registro',
      'Restinga',
      'Ribeiro do Vale',
      'Ribeiro dos Santos',
      'Ribeirão Branco',
      'Ribeirão Corrente',
      'Ribeirão Grande',
      'Ribeirão Pires',
      'Ribeirão Preto',
      'Ribeirão do Sul',
      'Ribeirão dos Índios',
      'Rifaina',
      'Rincão',
      'Rinópolis',
      'Rio Grande da Serra',
      'Riversul',
      'Riviera de São Lourenço',
      'Roberto',
      'Rosana',
      'Roseira',
      'Rubinéia',
      'Rubiácea',
      'Rubião Júnior',
      'Ruilândia',
      'Sabaúna',
      'Sabino',
      'Sagres',
      'Sales',
      'Sales Oliveira',
      'Salesópolis',
      'Salmourão',
      'Salto Grande',
      'Salto de Pirapora',
      'Salto do Avanhandava',
      'Sandovalina',
      'Santa Adélia',
      'Santa Albertina',
      'Santa América',
      'Santa Branca',
      "Santa Bárbara D'Oeste",
      "Santa Clara D'Oeste",
      'Santa Cruz da Conceição',
      'Santa Cruz da Esperança',
      'Santa Cruz da Estrela',
      'Santa Cruz das Palmeiras',
      'Santa Cruz do Rio Pardo',
      'Santa Cruz dos Lopes',
      'Santa Ernestina',
      'Santa Eudóxia',
      'Santa Fé do Sul',
      'Santa Isabel do Marinheiro',
      'Santa Maria da Serra',
      'Santa Maria do Gurupá',
      'Santa Mercedes',
      "Santa Rita D'Oeste",
      'Santa Rita do Passa Quatro',
      'Santa Rita do Ribeira',
      'Santa Rosa de Viterbo',
      'Santa Salete',
      'Santana da Ponte Pensa',
      'Santana de Parnaíba',
      'Santelmo',
      'Santo Anastácio',
      'Santo Antônio da Alegria',
      'Santo Antônio da Estiva',
      'Santo Antônio de Posse',
      'Santo Antônio do Aracanguá',
      'Santo Antônio do Jardim',
      'Santo Antônio do Paranapanema',
      'Santo Antônio do Pinhal',
      'Santo Expedito',
      'Santos',
      'Santópolis do Aguapeí',
      'Sarapuí',
      'Sarutaiá',
      'Sebastianópolis do Sul',
      'Serrana',
      'Sete Barras',
      'Severínia',
      'Silveiras',
      'Socorro',
      'Sodrélia',
      'Solemar',
      'Sorocaba',
      'Sousas',
      'Sud Mennucci',
      'Suinana',
      'Suzano',
      'Suzanápolis',
      'São Benedito da Cachoeirinha',
      'São Benedito das Areias',
      'São Bento do Sapucaí',
      'São Bernardo do Campo',
      'São Berto',
      'São Caetano do Sul',
      'São Francisco Xavier',
      'São Francisco da Praia',
      'São Joaquim da Barra',
      'São José das Laranjeiras',
      'São José do Rio Pardo',
      'São José do Rio Preto',
      'São José dos Campos',
      'São João Novo',
      'São João da Boa Vista',
      'São João das Duas Pontes',
      'São João de Iracema',
      'São João de Itaguaçu',
      'São João do Marinheiro',
      "São João do Pau d'Alho",
      'São Lourenço da Serra',
      'São Luiz do Guaricanga',
      'São Luiz do Paraitinga',
      "São Martinho D'Oeste",
      'São Miguel Arcanjo',
      'São Pedro do Turvo',
      'São Roque da Fartura',
      'São Sebastião da Grama',
      'São Sebastião da Serra',
      'Tabapuã',
      'Taboão da Serra',
      'Taciba',
      'Taguaí',
      'Taiacupeba',
      'Taiaçu',
      'Taiúva',
      'Talhado',
      'Tambaú',
      'Tanabi',
      'Tapinas',
      'Tapiratiba',
      'Taquaritinga',
      'Taquarituba',
      'Taquarivaí',
      'Tarabai',
      'Tatuí',
      'Taubaté',
      'Tecainda',
      'Tejupá',
      'Termas de Ibirá',
      "Terra Nova D'Oeste",
      'Tibiriçá',
      'Tibiriçá do Paranapanema',
      'Tietê',
      'Timburi',
      'Toque Toque Grande',
      'Toque Toque Pequeno',
      'Torre de Pedra',
      'Torrinha',
      'Trabiju',
      'Tratiba',
      'Tremembé',
      'Três Alianças',
      'Três Fronteiras',
      'Tujuguaba',
      'Tupi',
      'Tupi Paulista',
      'Tupã',
      'Turiba do Sul',
      'Turiúba',
      'Ubarana',
      'Ubatuba',
      'Ubirajara',
      'Uchoa',
      'União Paulista',
      'Uru',
      'Urupês',
      'Ururai',
      'Vale Formoso',
      'Valentim Gentil',
      'Valinhos',
      'Valparaíso',
      'Vanglória',
      'Vargem Grande Paulista',
      'Vargem Grande do Sul',
      'Venda Branca',
      'Vicente de Carvalho',
      'Vila Dirce',
      'Vila Nery',
      'Vila Xavier',
      'Vinhedo',
      'Viradouro',
      'Vista Alegre do Alto',
      'Vitoriana',
      'Vitória Brasil',
      'Votorantim',
      'Votuporanga',
      'Várzea Paulista',
      'Zacarias',
      'Águas da Prata',
      'Águas de Lindóia',
      'Águas de Santa Bárbara',
      'Águas de São Pedro',
      'Álvares Florence',
      'Álvares Machado',
      'Álvaro de Carvalho',
      'Ártemis',
      'Óleo',
    ],
    'BR-TO': [
      'Abreulândia',
      'Aguiarnópolis',
      'Aliança do Tocantins',
      'Almas',
      'Anajanópolis',
      'Ananás',
      'Aparecida do Rio Negro',
      'Apinajé',
      'Aragaçuí',
      'Aragominas',
      'Araguacema',
      'Araguatins',
      'Araguaçu',
      'Araguaína',
      'Arapoema',
      'Arraias',
      'Augustinópolis',
      'Aurora do Tocantins',
      'Axixá do Tocantins',
      'Babaçulândia',
      'Bandeirantes do Tocantins',
      'Barra do Grota',
      'Barrolândia',
      'Bernardo Sayão',
      'Brasilândia do Tocantins',
      'Brejinho de Nazaré',
      'Buriti do Tocantins',
      'Cariri do Tocantins',
      'Carmolândia',
      'Carrasco Bonito',
      'Cartucho',
      'Caseara',
      'Chapada da Natividade',
      'Chapada de Areia',
      'Cocalândia',
      'Colinas do Tocantins',
      'Colméia',
      'Combinado',
      'Conceição do Tocantins',
      'Correinha',
      'Couto de Magalhães',
      'Craolândia',
      'Crixás do Tocantins',
      'Darcinópolis',
      'Dianópolis',
      'Divinópolis do Tocantins',
      'Dois Irmãos do Tocantins',
      'Duerê',
      'Escondido',
      'Figueirópolis',
      'Formoso do Araguaia',
      'Fortaleza do Tabocão',
      'Goianorte',
      'Goiatins',
      'Gurupi',
      'Ilha Barreira Branca',
      'Itacajá',
      'Itaguatins',
      'Itapiratins',
      'Itaporã do Tocantins',
      'Jaú do Tocantins',
      'Juarina',
      'Lagoa da Confusão',
      'Lagoa do Tocantins',
      'Lavandeira',
      'Lizarda',
      'Luzimangues',
      'Luzinópolis',
      'Marianópolis do Tocantins',
      'Mateiros',
      'Maurilândia do Tocantins',
      'Miracema do Tocantins',
      'Miranorte',
      'Monte Lindo',
      'Monte Santo do Tocantins',
      'Monte do Carmo',
      'Muricilândia',
      'Nova Rosalândia',
      'Novo Acordo',
      'Novo Alegre',
      'Oliveira de Fátima',
      'Palmeirante',
      'Palmeiras do Tocantins',
      'Palmeirópolis',
      'Paranã',
      'Paraíso do Tocantins',
      'Pedro Afonso',
      'Pedro Ludovico',
      'Pequizeiro',
      'Pindorama do Tocantins',
      'Piraquê',
      'Pium',
      'Ponte Alta do Bom Jesus',
      'Ponte Alta do Tocantins',
      'Pontes',
      'Porto Alegre do Tocantins',
      'Porto Lemos',
      'Porto Nacional',
      'Porãozinho',
      'Praia Norte',
      'Príncipe',
      'Pugmil',
      'Pé da Serra',
      'Recursolândia',
      'Rio Sono',
      'Rio da Conceição',
      'Rio dos Bois',
      'Sandolândia',
      'Santa Fé do Araguaia',
      'Santa Maria do Tocantins',
      'Santa Rita do Tocantins',
      'Santa Rosa do Tocantins',
      'Santa Tereza do Tocantins',
      'Santa Terezinha do Tocantins',
      'Silvanópolis',
      'Sucupira',
      'São Bento do Tocantins',
      'São Félix do Tocantins',
      'São Miguel do Tocantins',
      'São Salvador do Tocantins',
      'São Sebastião do Tocantins',
      'São Valério da Natividade',
      'Sítio Novo do Tocantins',
      'Taipas do Tocantins',
      'Talismã',
      'Taquaralto',
      'Taquarussu do Tocantins',
      'Tocantinópolis',
      'Tocantínia',
      'Tupirama',
      'Tupiratins',
      'Tupiratã',
      'Vênus',
      'Wanderlândia',
      'Xambioá',
    ],
  },
  CAN: {
    'CA-AB': [
      'Acme',
      'Airdrie',
      'Alberta Beach',
      'Alix',
      'Alliance',
      'Amisk',
      'Andrew',
      'Argentia Beach',
      'Arrowwood',
      'Athabasca',
      'Banff',
      'Barnwell',
      'Barons',
      'Barrhead',
      'Bashaw',
      'Bassano',
      'Bawlf',
      'Beaumont',
      'Beaverlodge',
      'Beiseker',
      'Bentley',
      'Berwyn',
      'Betula Beach',
      'Big Valley',
      'Birch Cove',
      'Birchcliff',
      'Bittern Lake',
      'Black Diamond',
      'Blackfalds',
      'Bon Accord',
      'Bondiss',
      'Bonnyville',
      'Bonnyville Beach',
      'Bow Island',
      'Bowden',
      'Boyle',
      'Breton',
      'Brooks',
      'Bruderheim',
      'Burnstick Lake',
      'Calgary',
      'Calmar',
      'Camrose',
      'Canmore',
      'Carbon',
      'Cardston',
      'Carmangay',
      'Caroline',
      'Carstairs',
      'Castle Island',
      'Castor',
      'Cereal',
      'Champion',
      'Chauvin',
      'Chestermere',
      'Chipman',
      'Claresholm',
      'Clive',
      'Clyde',
      'Coaldale',
      'Coalhurst',
      'Cochrane',
      'Cold Lake',
      'Consort',
      'Coronation',
      'Coutts',
      'Cowley',
      'Cremona',
      'Crossfield',
      'Crystal Springs',
      'Czar',
      'Daysland',
      'Delburne',
      'Delia',
      'Dewberry',
      'Didsbury',
      'Donalda',
      'Donnelly',
      'Drayton Valley',
      'Drumheller',
      'Duchess',
      'Eckville',
      'Edberg',
      'Edgerton',
      'Edmonton',
      'Edson',
      'Elk Point',
      'Elnora',
      'Empress',
      'Fairview',
      'Falher',
      'Ferintosh',
      'Foremost',
      'Forestburg',
      'Fort Macleod',
      'Fort Saskatchewan',
      'Fox Creek',
      'Gadsby',
      'Ghost Lake',
      'Gibbons',
      'Girouxville',
      'Glendon',
      'Glenwood',
      'Golden Days',
      'Grande Prairie',
      'Grandview',
      'Granum',
      'Grimshaw',
      'Gull Lake',
      'Half Moon Bay',
      'Halkirk',
      'Hanna',
      'Hardisty',
      'Hay Lakes',
      'Heisler',
      'High Level',
      'High Prairie',
      'High River',
      'Hill Spring',
      'Hines Creek',
      'Hinton',
      'Horseshoe Bay',
      'Hussar',
      'Hythe',
      'Innisfree',
      'Irma',
      'Irricana',
      'Island Lake',
      'Island Lake South',
      'Itaska Beach',
      'Jarvis Bay',
      'Kapasiwin',
      'Killam',
      'Kitscoty',
      'Lacombe',
      'Lakeview',
      'Lamont',
      'Larkspur',
      'Leduc',
      'Legal',
      'Lethbridge',
      'Linden',
      'Lloydminster',
      'Lomond',
      'Longview',
      'Lougheed',
      'Ma-Me-O Beach',
      'Magrath',
      'Manning',
      'Mannville',
      'Marwayne',
      'Mayerthorpe',
      'McLennan',
      'Medicine Hat',
      'Mewatha Beach',
      'Milk River',
      'Millet',
      'Milo',
      'Morinville',
      'Morrin',
      'Mundare',
      'Munson',
      'Myrnam',
      'Nakamun Park',
      'Nampa',
      'Nanton',
      'Nobleford',
      'Norglenwold',
      'Norris Beach',
      'Okotoks',
      'Olds',
      'Onoway',
      'Oyen',
      'Paradise Valley',
      'Parkland Beach',
      'Peace River',
      'Pelican Narrows',
      'Penhold',
      'Picture Butte',
      'Pincher Creek',
      'Point Alison',
      'Ponoka',
      'Poplar Bay',
      'Provost',
      'Rainbow Lake',
      'Raymond',
      'Red Deer',
      'Redcliff',
      'Redwater',
      'Rimbey',
      'Rochon Sands',
      'Rocky Mountain House',
      'Rockyford',
      'Rosalind',
      'Rosemary',
      'Ross Haven',
      'Rycroft',
      'Ryley',
      'Sandy Beach',
      'Seba Beach',
      'Sedgewick',
      'Sexsmith',
      'Silver Beach',
      'Silver Sands',
      'Slave Lake',
      'Smoky Lake',
      'South Baptiste',
      'South View',
      'Spirit River',
      'Spring Lake',
      'Spruce Grove',
      'St. Albert',
      'St. Paul',
      'Standard',
      'Stavely',
      'Stettler',
      'Stony Plain',
      'Strathmore',
      'Sunbreaker Cove',
      'Sundance Beach',
      'Sundre',
      'Sunrise Beach',
      'Sunset Beach',
      'Sunset Point',
      'Swan Hills',
      'Sylvan Lake',
      'Taber',
      'Thorsby',
      'Three Hills',
      'Tofield',
      'Trochu',
      'Turner Valley',
      'Two Hills',
      'Val Quentin',
      'Valleyview',
      'Vauxhall',
      'Vegreville',
      'Vermilion',
      'Veteran',
      'Viking',
      'Vilna',
      'Vulcan',
      'Wabamun',
      'Wainwright',
      'Waiparous',
      'Warburg',
      'Waskatenau',
      'Wembley',
      'West Baptiste',
      'West Cove',
      'Westlock',
      'Wetaskiwin',
      'Whispering Hills',
      'White Sands',
      'Whitecourt',
      'Yellowstone',
      'Youngstown',
    ],
    'CA-BC': [
      '100 Mile House',
      'Abbotsford',
      'Alert Bay',
      'Anmore',
      'Armstrong',
      'Ashcroft',
      'Barriere',
      'Belcarra',
      'Bowen Island',
      'Burnaby',
      'Burns Lake',
      'Cache Creek',
      'Campbell River',
      'Canal Flats',
      'Castlegar',
      'Central Saanich',
      'Chase',
      'Chetwynd',
      'Chilliwack',
      'Clearwater',
      'Coldstream',
      'Colwood',
      'Comox',
      'Coquitlam',
      'Courtenay',
      'Creston',
      'Cumberland',
      'Dawson Creek',
      'Duncan',
      'Elkford',
      'Enderby',
      'Esquimalt',
      'Fernie',
      'Fort St. James',
      'Fort St. John',
      'Fraser Lake',
      'Fruitvale',
      'Gibsons',
      'Gold River',
      'Golden',
      'Grand Forks',
      'Granisle',
      'Greenwood',
      'Harrison Hot Springs',
      'Hazelton',
      'Highlands',
      'Hope',
      'Houston',
      "Hudson's Hope",
      'Invermere',
      'Jumbo Glacier',
      'Kamloops',
      'Kaslo',
      'Kelowna',
      'Kent',
      'Keremeos',
      'Kitimat',
      'Ladysmith',
      'Lake Country',
      'Lake Cowichan',
      'Langford',
      'Lantzville',
      'Lillooet',
      'Lions Bay',
      'Logan Lake',
      'Lumby',
      'Lytton',
      'Mackenzie',
      'Maple Ridge',
      'Masset',
      'McBride',
      'Merritt',
      'Metchosin',
      'Midway',
      'Mission',
      'Nakusp',
      'Nanaimo',
      'New Denver',
      'New Hazelton',
      'New Westminster',
      'North Cowichan',
      'North Saanich',
      'North Vancouver',
      'Northern Rockies',
      'Oak Bay',
      'Oliver',
      'Osoyoos',
      'Parksville',
      'Peachland',
      'Penticton',
      'Pitt Meadows',
      'Port Alberni',
      'Port Alice',
      'Port Clements',
      'Port Coquitlam',
      'Port Edward',
      'Port Hardy',
      'Port McNeill',
      'Port Moody',
      'Pouce Coupe',
      'Powell River',
      'Prince George',
      'Prince Rupert',
      'Princeton',
      'Qualicum Beach',
      'Queen Charlotte',
      'Quesnel',
      'Radium Hot Springs',
      'Revelstoke',
      'Rossland',
      'Saanich',
      'Salmo',
      'Salmon Arm',
      'Sayward',
      'Sechelt',
      'Sechelt Indian Government District',
      'Sicamous',
      'Silverton',
      'Slocan',
      'Smithers',
      'Sooke',
      'Spallumcheen',
      'Sparwood',
      'Squamish',
      'Stewart',
      'Summerland',
      'Sun Peaks',
      'Surrey',
      'Tahsis',
      'Taylor',
      'Telkwa',
      'Terrace',
      'Tofino',
      'Trail',
      'Tumbler Ridge',
      'Ucluelet',
      'Valemount',
      'Vancouver',
      'Vanderhoof',
      'Vernon',
      'View Royal',
      'Warfield',
      'Wells',
      'West Kelowna',
      'West Vancouver',
      'Whistler',
      'White Rock',
      'Williams Lake',
      'Zeballos',
    ],
    'CA-MB': [
      'Altona',
      'Arborg',
      'Beausejour',
      'Brandon',
      'Carberry',
      'Carman',
      'Churchill',
      'Dauphin',
      'Dunnottar',
      'Flin Flon',
      'Gillam',
      'Grand Rapids',
      'Lac du Bonnet',
      'Leaf Rapids',
      'Lynn Lake',
      'Melita',
      'Minnedosa',
      'Morden',
      'Morris',
      'Neepawa',
      'Niverville',
      'Portage la Prairie',
      'Powerview-Pine Falls',
      'Selkirk',
      'Snow Lake',
      'St-Pierre-Jolys',
      'Ste. Anne',
      'Steinbach',
      'Stonewall',
      'Swan River',
      'Teulon',
      'The Pas',
      'Thompson',
      'Virden',
      'Winkler',
      'Winnipeg',
      'Winnipeg Beach',
    ],
    'CA-NB': [
      'Alma',
      'Aroostook',
      'Atholville',
      'Bas-Caraquet',
      'Bath',
      'Bathurst',
      'Beaubassin East',
      'Belledune',
      'Beresford',
      'Bertrand',
      'Blacks Harbour',
      'Blackville',
      'Bouctouche',
      'Cambridge-Narrows',
      'Campbellton',
      'Campobello Island',
      'Canterbury',
      'Cap-Pelé',
      'Caraquet',
      'Centreville',
      'Charlo',
      'Cocagne',
      'Dalhousie',
      'Dieppe',
      'Doaktown',
      'Dorchester',
      'Edmundston',
      'Eel River Crossing',
      'Florenceville-Bristol',
      'Fredericton',
      'Fredericton Junction',
      'Gagetown',
      'Grand Bay-Westfield',
      'Grand Falls',
      'Grand Manan',
      'Grande-Anse',
      'Hampton',
      'Hanwell',
      'Hartland',
      'Haut-Madawaska',
      'Hillsborough',
      'Kedgwick',
      'Lac Baker',
      'Lamèque',
      'Le Goulet',
      'Maisonnette',
      'McAdam',
      'Meductic',
      'Memramcook',
      'Millville',
      'Miramichi',
      'Moncton',
      'Nackawic',
      'Neguac',
      'New Maryland',
      'Nigadoo',
      'Norton',
      'Oromocto',
      'Paquetville',
      'Perth-Andover',
      'Petit-Rocher',
      'Petitcodiac',
      'Plaster Rock',
      'Pointe-Verte',
      'Port Elgin',
      'Quispamsis',
      'Rexton',
      'Richibucto',
      'Riverside-Albert',
      'Riverview',
      'Rivière-Verte',
      'Rogersville',
      'Sackville',
      'Saint Andrews',
      'Saint John',
      'Saint-André',
      'Saint-Antoine',
      'Saint-Isidore',
      'Saint-Louis de Kent',
      'Saint-Léolin',
      'Saint-Léonard',
      'Saint-Quentin',
      'Sainte-Anne-de-Madawaska',
      'Sainte-Marie-Saint-Raphaël',
      'Shediac',
      'Shippagan',
      'St. George',
      'St. Martins',
      'St. Stephen',
      'Sussex',
      'Sussex Corner',
      'Tide Head',
      'Tracadie',
      'Tracy',
      'Upper Miramichi',
    ],
    'CA-NL': [
      'Admirals Beach',
      'Anchor Point',
      'Appleton',
      'Aquaforte',
      "Arnold's Cove",
      'Avondale',
      'Badger',
      'Baie Verte',
      'Baine Harbour',
      'Bauline',
      'Bay Bulls',
      "Bay L'Argent",
      'Bay Roberts',
      'Bay de Verde',
      'Baytona',
      'Beachside',
      'Bellburns',
      'Belleoram',
      'Birchy Bay',
      'Bird Cove',
      "Bishop's Cove",
      "Bishop's Falls",
      'Bonavista',
      'Botwood',
      'Branch',
      "Brent's Cove",
      'Brigus',
      "Bryant's Cove",
      'Buchans',
      'Burgeo',
      'Burin',
      'Burlington',
      'Burnt Islands',
      'Cape Broyle',
      'Cape St. George',
      'Carbonear',
      'Carmanville',
      'Cartwright',
      'Centreville-Wareham-Trinity',
      'Chance Cove',
      'Change Islands',
      'Channel-Port aux Basques',
      'Chapel Arm',
      'Charlottetown',
      'Clarenville',
      "Clarke's Beach",
      "Coachman's Cove",
      'Colinet',
      'Colliers',
      'Come By Chance',
      'Comfort Cove-Newstead',
      'Conception Bay South',
      'Conception Harbour',
      'Conche',
      "Cook's Harbour",
      'Cormack',
      'Corner Brook',
      'Cottlesville',
      'Cow Head',
      "Cox's Cove",
      'Crow Head',
      'Cupids',
      "Daniel's Harbour",
      'Deer Lake',
      'Duntara',
      'Eastport',
      'Embree',
      'Englee',
      'English Harbour East',
      'Fermeuse',
      'Ferryland',
      'Flatrock',
      'Fleur de Lys',
      "Flower's Cove",
      'Fogo Island',
      'Forteau',
      'Fortune',
      'Fox Cove-Mortier',
      'Fox Harbour',
      "Frenchman's Cove",
      'Gallants',
      'Gambo',
      'Gander',
      'Garnish',
      'Gaskiers-Point La Haye',
      'Gaultois',
      'Gillams',
      'Glenburnie-Birchy Head-Shoal Brook',
      'Glovertown',
      'Goose Cove East',
      'Grand Bank',
      'Grand Falls-Windsor',
      'Grand le Pierre',
      'Greenspond',
      'Hampden',
      "Hant's Harbour",
      'Happy Adventure',
      'Happy Valley-Goose Bay',
      'Harbour Breton',
      'Harbour Grace',
      "Harbour Main-Chapel's Cove-Lakeview",
      'Hare Bay',
      "Hawke's Bay",
      "Heart's Content",
      "Heart's Delight-Islington",
      "Heart's Desire",
      'Hermitage-Sandyville',
      'Holyrood',
      'Hopedale',
      'Howley',
      'Hughes Brook',
      'Humber Arm South',
      'Indian Bay',
      'Irishtown-Summerside',
      'Isle aux Morts',
      "Jackson's Arm",
      'Keels',
      "King's Cove",
      "King's Point",
      'Kippens',
      "L'Anse-au-Clair",
      "L'Anse-au-Loup",
      'LaScie',
      'Labrador City',
      'Lamaline',
      'Lark Harbour',
      'Lawn',
      'Leading Tickles',
      "Lewin's Cove",
      'Lewisporte',
      'Little Bay',
      'Little Bay East',
      'Little Bay Islands',
      'Little Burnt Bay',
      'Logy Bay-Middle Cove-Outer Cove',
      'Long Harbour-Mount Arlington Heights',
      "Lord's Cove",
      'Lumsden',
      'Lushes Bight-Beaumont-Beaumont North',
      'Main Brook',
      'Makkovik',
      "Mary's Harbour",
      'Marystown',
      'Massey Drive',
      'McIvers',
      'Middle Arm',
      'Miles Cove',
      'Millertown',
      "Milltown-Head of Bay d'Espoir",
      "Ming's Bight",
      'Morrisville',
      'Mount Carmel-Mitchells Brook-St. Catherines',
      'Mount Moriah',
      'Mount Pearl',
      'Musgrave Harbour',
      'Musgravetown',
      'New Perlican',
      'New-Wes-Valley',
      "Nipper's Harbour",
      "Norman's Cove-Long Cove",
      'Norris Arm',
      'Norris Point',
      'North River',
      'North West River',
      'Northern Arm',
      'Old Perlican',
      'Pacquet',
      'Parkers Cove',
      "Parson's Pond",
      'Pasadena',
      'Peterview',
      'Petty Harbour-Maddox Cove',
      "Pilley's Island",
      'Pinware',
      'Placentia',
      'Point Lance',
      'Point Leamington',
      'Point May',
      'Point au Gaul',
      'Point of Bay',
      "Pool's Cove",
      'Port Anson',
      'Port Blandford',
      'Port Hope Simpson',
      'Port Kirwan',
      'Port Rexton',
      'Port Saunders',
      'Port au Choix',
      'Port au Port East',
      'Port au Port West-Aguathuna-Felix Cove',
      'Portugal Cove South',
      "Portugal Cove–St. Philip's",
      'Postville',
      'Pouch Cove',
      'Ramea',
      'Red Bay',
      'Red Harbour',
      'Reidville',
      'Rencontre East',
      'Renews-Cappahayden',
      'Rigolet',
      'River of Ponds',
      'Riverhead',
      "Robert's Arm",
      'Rocky Harbour',
      'Roddickton-Bide Arm',
      'Rose Blanche-Harbour le Cou',
      'Rushoon',
      "Sally's Cove",
      'Salmon Cove',
      'Salvage',
      'Sandringham',
      'Sandy Cove',
      'Seal Cove',
      "Small Point-Adam's Cove-Blackhead-Broad Cove",
      'South Brook',
      'South River',
      'Southern Harbour',
      "Spaniard's Bay",
      'Springdale',
      "St. Alban's",
      'St. Anthony',
      "St. Bernard's-Jacques Fontaine",
      "St. Brendan's",
      "St. Bride's",
      "St. George's",
      "St. Jacques-Coomb's Cove",
      "St. John's",
      "St. Joseph's",
      'St. Lawrence',
      'St. Lewis',
      'St. Lunaire-Griquet',
      "St. Mary's",
      'St. Pauls',
      "St. Shott's",
      "St. Vincent's-St. Stephen's-Peter's River",
      'Steady Brook',
      'Stephenville',
      'Stephenville Crossing',
      'Summerford',
      'Terrenceville',
      'Tilt Cove',
      'Traytown',
      'Trepassey',
      'Trinity',
      'Trinity Bay North',
      'Triton',
      'Trout River',
      'Twillingate',
      'Upper Island Cove',
      'Wabana',
      'Wabush',
      'West St. Modeste',
      'Westport',
      'Whitbourne',
      'Whiteway',
      'Winterland',
      'Winterton',
      'Witless Bay',
      'Woody Point',
      'York Harbour',
    ],
    'CA-NT': [
      'Aklavik',
      'Behchokǫ̀',
      'Deline',
      'Enterprise',
      'Fort Good Hope',
      'Fort Liard',
      'Fort McPherson',
      'Fort Providence',
      'Fort Resolution',
      'Fort Simpson',
      'Fort Smith',
      'Gamèti',
      'Hay River',
      'Inuvik',
      'Norman Wells',
      'Paulatuk',
      'Sachs Harbour',
      'Tsiigehtchic',
      'Tuktoyaktuk',
      'Tulita',
      'Ulukhaktok',
      'Wekweeti',
      'Whatì',
      'Yellowknife',
    ],
    'CA-NS': [
      'Annapolis',
      'Annapolis Royal',
      'Antigonish',
      'Cape Breton',
      'Chester',
      "Clark's Harbour",
      'Colchester',
      'East Hants',
      'Guysborough',
      'Halifax',
      'Inverness',
      'Kentville',
      'Kings',
      'Lockeport',
      'Lunenburg',
      'Mahone Bay',
      'New Glasgow',
      'Oxford',
      'Pictou',
      'Port Hawkesbury',
      'Queens',
      'Shelburne',
      'Stellarton',
      'Stewiacke',
      'Trenton',
      'West Hants',
      'Westville',
      'Wolfville',
      'Yarmouth',
    ],
    'CA-NU': ['Iqaluit'],
    'CA-ON': [
      'Addington Highlands',
      'Adelaide-Metcalfe',
      'Adjala-Tosorontio',
      'Admaston/Bromley',
      'Ajax',
      'Alfred and Plantagenet',
      'Algonquin Highlands',
      'Alnwick/Haldimand',
      'Amaranth',
      'Amherstburg',
      'Armour',
      'Arnprior',
      'Arran-Elderslie',
      'Ashfield-Colborne-Wawanosh',
      'Asphodel-Norwood',
      'Assiginack',
      'Athens',
      'Atikokan',
      'Aylmer',
      'Baldwin',
      'Bancroft',
      'Barrie',
      'Bayham',
      'Beckwith',
      'Belleville',
      'Billings',
      'Black River-Matheson',
      'Blandford-Blenheim',
      'Blind River',
      'Bluewater',
      'Bonfield',
      'Bonnechere Valley',
      'Bracebridge',
      'Bradford West Gwillimbury',
      'Brampton',
      'Brant',
      'Brantford',
      'Brethour',
      'Brock',
      'Brockton',
      'Brockville',
      'Brooke-Alvinston',
      'Bruce Mines',
      'Brudenell, Lyndoch and Raglan',
      "Burk's Falls",
      'Burpee and Mills',
      'Caledon',
      'Callander',
      'Calvin',
      'Carleton Place',
      'Carling',
      'Carlow/Mayo',
      'Casey',
      'Casselman',
      'Cavan-Monaghan',
      'Central Elgin',
      'Central Frontenac',
      'Central Huron',
      'Central Manitoulin',
      'Centre Hastings',
      'Centre Wellington',
      'Chamberlain',
      'Champlain',
      'Chapleau',
      'Chapple',
      'Charlton and Dack',
      'Chatham-Kent',
      'Chisholm',
      'Clarence-Rockland',
      'Clarington',
      'Clearview',
      'Cobalt',
      'Cobourg',
      'Cockburn Island',
      'Coleman',
      'Collingwood',
      'Conmee',
      'Cramahe',
      'Dawn-Euphemia',
      'Dawson',
      'Deep River',
      'Deseronto',
      'Dorion',
      'Douro-Dummer',
      'Drummond/North Elmsley',
      'Dryden',
      'Dubreuilville',
      'Dutton/Dunwich',
      'Dysart, Dudley, Harcourt, Guilford, Harburn, Bruton, Havelock, Eyre and Clyde',
      'Ear Falls',
      'East Ferris',
      'East Garafraxa',
      'East Gwillimbury',
      'East Hawkesbury',
      'East Zorra-Tavistock',
      'Edwardsburgh/Cardinal',
      'Elizabethtown-Kitley',
      'Elliot Lake',
      'Emo',
      'Englehart',
      'Enniskillen',
      'Erin',
      'Espanola',
      'Essa',
      'Essex',
      'Evanturel',
      'Fauquier-Strickland',
      'Fort Erie',
      'Fort Frances',
      'French River',
      'Front of Yonge',
      'Frontenac Islands',
      'Gananoque',
      'Gauthier',
      'Georgian Bay',
      'Georgian Bluffs',
      'Georgina',
      'Gillies',
      'Goderich',
      'Gordon/Barrie Island',
      'Gore Bay',
      'Grand Valley',
      'Gravenhurst',
      'Greater Madawaska',
      'Greater Napanee',
      'Greater Sudbury',
      'Greenstone',
      'Grey Highlands',
      'Grimsby',
      'Guelph',
      'Guelph/Eramosa',
      'Haldimand',
      'Halton Hills',
      'Hanover',
      'Harley',
      'Harris',
      'Hastings Highlands',
      'Havelock-Belmont-Methuen',
      'Hawkesbury',
      'Head, Clara and Maria',
      'Hearst',
      'Highlands East',
      'Hilliard',
      'Hilton',
      'Hilton Beach',
      'Hornepayne',
      'Horton',
      'Howick',
      'Hudson',
      'Huntsville',
      'Huron East',
      'Huron Shores',
      'Huron-Kinloss',
      'Ignace',
      'Ingersoll',
      'Innisfil',
      'Iroquois Falls',
      'James',
      'Jocelyn',
      'Johnson',
      'Joly',
      'Kapuskasing',
      'Kawartha Lakes',
      'Kearney',
      'Kenora',
      'Kerns',
      'Killaloe, Hagarty and Richards',
      'Killarney',
      'Kincardine',
      'King',
      'Kingsville',
      'Kirkland Lake',
      'Kitchener',
      'La Vallee',
      'LaSalle',
      'Laird',
      'Lake of Bays',
      'Lake of the Woods',
      'Lakeshore',
      'Lambton Shores',
      'Lanark Highlands',
      'Larder Lake',
      'Latchford',
      'Laurentian Hills',
      'Laurentian Valley',
      'Leamington',
      'Leeds and the Thousand Islands',
      'Limerick',
      'London',
      'Loyalist',
      'Lucan Biddulph',
      'Macdonald, Meredith and Aberdeen Additional',
      'Machar',
      'Machin',
      'Madawaska Valley',
      'Madoc',
      'Magnetawan',
      'Malahide',
      'Manitouwadge',
      'Mapleton',
      'Marathon',
      'Markham',
      'Markstay-Warren',
      'Marmora and Lake',
      'Matachewan',
      'Mattawa',
      'Mattawan',
      'Mattice-Val Côté',
      'McDougall',
      'McGarry',
      'McKellar',
      'McMurrich/Monteith',
      'McNab/Braeside',
      'Meaford',
      'Melancthon',
      'Merrickville-Wolford',
      'Middlesex Centre',
      'Midland',
      'Minden Hills',
      'Mississauga',
      'Mississippi Mills',
      'Mono',
      'Montague',
      'Moonbeam',
      'Moosonee',
      'Morley',
      'Morris-Turnberry',
      'Mulmur',
      'Muskoka Lakes',
      'Nairn and Hyman',
      'Neebing',
      'New Tecumseth',
      'Newbury',
      'Newmarket',
      'Niagara Falls',
      'Niagara-on-the-Lake',
      'Nipigon',
      'Nipissing',
      'Norfolk',
      'North Algona Wilberforce',
      'North Bay',
      'North Dumfries',
      'North Dundas',
      'North Frontenac',
      'North Glengarry',
      'North Grenville',
      'North Huron',
      'North Kawartha',
      'North Middlesex',
      'North Perth',
      'North Stormont',
      'Northeastern Manitoulin and the Islands',
      'Northern Bruce Peninsula',
      'Norwich',
      "O'Connor",
      'Oakville',
      'Oil Springs',
      'Oliver Paipoonge',
      'Opasatika',
      'Orangeville',
      'Orillia',
      'Oro-Medonte',
      'Oshawa',
      'Otonabee-South Monaghan',
      'Ottawa',
      'Owen Sound',
      'Papineau-Cameron',
      'Parry Sound',
      'Pelee',
      'Pembroke',
      'Penetanguishene',
      'Perry',
      'Perth East',
      'Perth South',
      'Petawawa',
      'Petrolia',
      'Pickering',
      'Pickle Lake',
      'Plummer Additional',
      'Plympton-Wyoming',
      'Point Edward',
      'Port Colborne',
      'Port Hope',
      'Powassan',
      'Prescott',
      'Prince',
      'Prince Edward',
      'Puslinch',
      'Quinte West',
      'Rainy River',
      'Ramara',
      'Red Lake',
      'Red Rock',
      'Renfrew',
      'Richmond Hill',
      'Rideau Lakes',
      'Russell',
      'Ryerson',
      'Sables-Spanish Rivers',
      'Sarnia',
      'Saugeen Shores',
      'Sault Ste. Marie',
      'Schreiber',
      'Scugog',
      'Seguin',
      'Selwyn',
      'Severn',
      'Shuniah',
      'Sioux Lookout',
      'Sioux Narrows-Nestor Falls',
      'Smiths Falls',
      'Smooth Rock Falls',
      'South Algonquin',
      'South Bruce',
      'South Bruce Peninsula',
      'South Dundas',
      'South Frontenac',
      'South Glengarry',
      'South Huron',
      'South Stormont',
      'South-West Oxford',
      'Southgate',
      'Southwest Middlesex',
      'Southwold',
      'Spanish',
      'Springwater',
      'St. Catharines',
      'St. Charles',
      'St. Clair',
      'St. Joseph',
      'St. Marys',
      'St. Thomas',
      'Stirling-Rawdon',
      'Stone Mills',
      'Strathroy-Caradoc',
      'Strong',
      'Sundridge',
      'Tarbutt',
      'Tay',
      'Tay Valley',
      'Tecumseh',
      'Tehkummah',
      'Temagami',
      'Temiskaming Shores',
      'Terrace Bay',
      'Thames Centre',
      'The Archipelago',
      'The Blue Mountains',
      'The Nation',
      'The North Shore',
      'Thessalon',
      'Thornloe',
      'Thorold',
      'Thunder Bay',
      'Tillsonburg',
      'Timmins',
      'Tiny',
      'Toronto',
      'Trent Hills',
      'Trent Lakes',
      'Tudor and Cashel',
      'Tweed',
      'Tyendinaga',
      'Val Rita-Harty',
      'Vaughan',
      'Wainfleet',
      'Wasaga Beach',
      'Wawa',
      'Welland',
      'Wellesley',
      'Wellington North',
      'West Elgin',
      'West Grey',
      'West Lincoln',
      'West Nipissing',
      'West Perth',
      'Whitby',
      'Whitchurch-Stouffville',
      'White River',
      'Whitestone',
      'Whitewater Region',
      'Wollaston',
      'Woolwich',
      'Zorra',
    ],
    'CA-PE': [
      'Abram-Village',
      'Afton',
      'Annandale-Little Pond-Howe Bay',
      'Bedeque and Area',
      'Belfast',
      'Bonshaw',
      'Borden-Carleton',
      'Brackley',
      'Central Kings',
      'Central Prince',
      'Clyde River',
      'Crapaud',
      'Eastern Kings',
      'Greenmount-Montrose',
      'Hunter River',
      'Kensington',
      'Kinkora',
      'Linkletter',
      'Lot 11 and Area',
      'Malpeque Bay',
      'Miltonvale Park',
      'Miminegash',
      'Miscouche',
      'Morell',
      'Mount Stewart',
      'Murray Harbour',
      'Murray River',
      'New Haven-Riverdale',
      'North Rustico',
      'North Shore',
      'North Wiltshire',
      'Northport',
      "O'Leary",
      'Sherbrooke',
      'Souris',
      'Souris West',
      'St. Felix',
      'St. Louis',
      'St. Nicholas',
      'St. Peters Bay',
      'Stanley Bridge, Hope River, Bayview, Cavendish and North Rustico',
      'Summerside',
      'Three Rivers',
      'Tignish',
      'Tignish Shore',
      'Tyne Valley',
      'Union Road',
      'Warren Grove',
      'West River',
    ],
    'CA-QC': [
      'Acton Vale',
      'Amos',
      'Amqui',
      'Asbestos',
      'Baie-Comeau',
      "Baie-D'Urfé",
      'Baie-Saint-Paul',
      'Barkmere',
      'Beauceville',
      'Beauharnois',
      'Beaupré',
      'Bedford',
      'Belleterre',
      'Beloeil',
      'Berthierville',
      'Blainville',
      'Bois-des-Filion',
      'Boisbriand',
      'Bonaventure',
      'Boucherville',
      'Brome Lake',
      'Bromont',
      'Brossard',
      'Brownsburg-Chatham',
      'Bécancour',
      'Candiac',
      'Cap-Chat',
      'Cap-Santé',
      'Carignan',
      'Carleton-sur-Mer',
      'Causapscal',
      'Chambly',
      'Chandler',
      'Chapais',
      'Charlemagne',
      'Chibougamau',
      'Château-Richer',
      'Châteauguay',
      'Coaticook',
      'Contrecoeur',
      'Cookshire-Eaton',
      'Coteau-du-Lac',
      'Cowansville',
      'Côte Saint-Luc',
      'Danville',
      'Daveluyville',
      'Delson',
      'Desbiens',
      'Deux-Montagnes',
      'Disraeli',
      'Dolbeau-Mistassini',
      'Dollard-des-Ormeaux',
      'Donnacona',
      'Dorval',
      'Drummondville',
      'Dunham',
      'Duparquet',
      'Dégelis',
      'East Angus',
      'Estérel',
      'Farnham',
      'Fermont',
      'Forestville',
      'Fossambault-sur-le-Lac',
      'Gaspé',
      'Gatineau',
      'Gracefield',
      'Granby',
      'Grande-Rivière',
      'Hampstead',
      'Huntingdon',
      'Joliette',
      'Kingsey Falls',
      'Kirkland',
      "L'Ancienne-Lorette",
      "L'Assomption",
      "L'Épiphanie",
      "L'Île-Cadieux",
      "L'Île-Dorval",
      "L'Île-Perrot",
      'La Malbaie',
      'La Pocatière',
      'La Prairie',
      'La Sarre',
      'La Tuque',
      'Lac-Delage',
      'Lac-Mégantic',
      'Lac-Saint-Joseph',
      'Lac-Sergent',
      'Lachute',
      'Laval',
      'Lavaltrie',
      'Lebel-sur-Quévillon',
      'Longueuil',
      'Lorraine',
      'Louiseville',
      'Léry',
      'Lévis',
      'Macamic',
      'Magog',
      'Malartic',
      'Maniwaki',
      'Marieville',
      'Mascouche',
      'Matagami',
      'Matane',
      'Mercier',
      'Mirabel',
      'Mont-Joli',
      'Mont-Laurier',
      'Mont-Saint-Hilaire',
      'Mont-Tremblant',
      'Montmagny',
      'Montreal',
      'Montreal West',
      'Montréal-Est',
      'Mount Royal',
      'Murdochville',
      'Métabetchouan–Lac-à-la-Croix',
      'Métis-sur-Mer',
      'Neuville',
      'New Richmond',
      'Nicolet',
      'Normandin',
      "Notre-Dame-de-l'Île-Perrot",
      'Notre-Dame-des-Prairies',
      'Otterburn Park',
      'Paspébiac',
      'Percé',
      'Pincourt',
      'Plessisville',
      'Pohénégamook',
      'Pointe-Claire',
      'Pont-Rouge',
      'Port-Cartier',
      'Portneuf',
      'Princeville',
      'Prévost',
      'Québec',
      'Repentigny',
      'Richelieu',
      'Rimouski',
      'Rivière-Rouge',
      'Rivière-du-Loup',
      'Roberval',
      'Rosemère',
      'Rouyn-Noranda',
      'Saguenay',
      'Saint-Augustin-de-Desmaures',
      'Saint-Basile',
      'Saint-Basile-le-Grand',
      'Saint-Bruno-de-Montarville',
      'Saint-Colomban',
      'Saint-Constant',
      'Saint-Césaire',
      'Saint-Eustache',
      'Saint-Félicien',
      'Saint-Gabriel',
      'Saint-Georges',
      'Saint-Hyacinthe',
      'Saint-Jean-sur-Richelieu',
      'Saint-Joseph-de-Beauce',
      'Saint-Joseph-de-Sorel',
      'Saint-Jérôme',
      'Saint-Lambert',
      'Saint-Lazare',
      'Saint-Lin-Laurentides',
      'Saint-Marc-des-Carrières',
      'Saint-Ours',
      'Saint-Pamphile',
      'Saint-Pascal',
      'Saint-Pie',
      'Saint-Raymond',
      'Saint-Rémi',
      'Saint-Sauveur',
      'Saint-Tite',
      'Sainte-Adèle',
      'Sainte-Agathe-des-Monts',
      'Sainte-Anne-de-Beaupré',
      'Sainte-Anne-de-Bellevue',
      'Sainte-Anne-des-Monts',
      'Sainte-Anne-des-Plaines',
      'Sainte-Catherine',
      'Sainte-Catherine-de-la-Jacques-Cartier',
      'Sainte-Julie',
      'Sainte-Marguerite-du-Lac-Masson',
      'Sainte-Marie',
      'Sainte-Marthe-sur-le-Lac',
      'Sainte-Thérèse',
      'Salaberry-de-Valleyfield',
      'Schefferville',
      'Scotstown',
      'Senneterre',
      'Sept-Îles',
      'Shawinigan',
      'Sorel-Tracy',
      'Stanstead',
      'Terrebonne',
      'Thetford Mines',
      'Thurso',
      'Trois-Pistoles',
      'Trois-Rivières',
      'Témiscaming',
      'Témiscouata-sur-le-Lac',
      "Val-d'Or",
      'Valcourt',
      'Varennes',
      'Vaudreuil-Dorion',
      'Victoriaville',
      'Ville-Marie',
      'Waterville',
      'Westmount',
    ],
    'CA-YT': ['Carmacks', 'Haines Junction', 'Mayo', 'Teslin', 'Watson Lake', 'Whitehorse'],
  },
  CHL: {
    'CL-AI': [
      'Aysén',
      'Balmaceda',
      'Chile Chico',
      'Cisnes',
      'Coyhaique',
      'Guaitecas',
      'La Junta',
      "O'Higgins",
      'Puerto Aguirre',
      'Puerto Aysen',
      'Puerto Chacabuco',
      'Puerto Cisnes',
      'Puyuhuapi',
      'Río Ibánez',
      'Tortel',
      'Villa Manihuales',
    ],
    'CL-AN': [
      'Antofagasta',
      'Codelco Radomiro Tomic',
      'Maria Elena',
      'Mejillones',
      'Ollague',
      'San Pedro De Atacama',
      'Sierra Gorda',
      'Taltal',
      'Tocopilla',
    ],
    'CL-AP': ['Arica', 'Camarones', 'General Lagos', 'Putre'],
    'CL-AT': [
      'Alto Del Carmen',
      'Caldera',
      'Chañaral',
      'Copiapo',
      'Diego De Almagro',
      'El Salvador',
      'Estacion Paipote',
      'Freirina',
      'Fuerte Baquedano',
      'Huasco',
      'Paipote',
      'Tierra Amarilla',
      'Vallenar',
    ],
    'CL-BI': [
      'Alto Bíobío',
      'Antuco',
      'Cabrero',
      'Cañete',
      'Chiguayante',
      'Cholguan',
      'Concepcion',
      'Contulmo',
      'Coronel',
      'Curanilahue',
      'Florida',
      'Hualpén',
      'Hualqui',
      'Huepil',
      'Lebu',
      'Los Alamos',
      'Los Angeles',
      'Lota',
      'Mulchen',
      'Nacimiento',
      'Negrete',
      'Nueva Aldea',
      'Penco',
      'Pueblo Seco',
      'Quilaco',
      'Quilleco',
      'Quiriquina',
      'San Pedro De La Paz',
      'San Rosendo',
      'Santa Barbara',
      'Santa Juana',
      'Talcahuano',
      'Tirua',
      'Tome',
      'Tucapel',
      'Yumbel',
    ],
    'CL-CO': [
      'Andacollo',
      'Combarbala',
      'Coquimbo',
      'Illapel',
      'La Higuera',
      'La Serena',
      'Los Vilos',
      'Monte Patria',
      'Ovalle',
      'Paihuano',
      'Punitaqui',
      'Río Hurtado',
      'Salamanca',
      'Vicuña',
    ],
    'CL-AR': [
      'Angol',
      'Carahue',
      'Cholchol',
      'Collipulli',
      'Cunco',
      'Curacautin',
      'Curarrehue',
      'Ercilla',
      'Galvarino',
      'Gorbea',
      'Lautaro',
      'Loncoche',
      'Lonquimay',
      'Los Sauces',
      'Lumaco',
      'Melipeuco',
      'Mininco',
      'Nueva Imperial',
      'Padre Las Casas',
      'Perquenco',
      'Pitrufquen',
      'Pucon',
      'Puren',
      'Quepe',
      'Renaico',
      'Temuco',
      'Teodoro Schmidt',
      'Toltén',
      'Traiguen',
      'Vilcún',
      'Villarrica',
    ],
    'CL-LI': [
      'Bucalemu',
      'Chepica',
      'Chimbarongo',
      'Codegua',
      'Coinco',
      'Coltauco',
      'Doñihue',
      'La Estrella',
      'Las Cabras',
      'Litueche',
      'Lo Miranda',
      'Lolol',
      'Machali',
      'Malloa',
      'Marchigue',
      'Nancagua',
      'Navidad',
      'Olivar',
      'Palmilla',
      'Paredones',
      'Pelequen',
      'Peralillo',
      'Peumo',
      'Pichidegua',
      'Pichilemu',
      'Placilla',
      'Pumanque',
      'Quinta De Tilcoco',
      'Rancagua',
      'Rengo',
      'Requinoa',
      'San Francisco De Mostazal',
      'Santa Amelia',
    ],
    'CL-LL': [
      'Achao',
      'Ancud',
      'Calbuco',
      'Chaiten',
      'Chonchi',
      'Cochamo',
      'Curaco De Velez',
      'Dalcahue',
      'Entre Lagos',
      'Fresia',
      'Frutillar',
      'Futaleufu',
      'Hornopiren',
      'Hualaihué',
      'Lago Ranco',
      'Llanquihue',
      'Los Muermos',
      'Maullin',
      'Osorno',
      'Palena',
      'Pargua',
      'Puerto Montt',
      'Puerto Octay',
      'Puerto Varas',
      'Puqueldon',
      'Purranque',
      'Puyehue',
      'Queilen',
      'Quellon',
      'Quemchi',
      'Quinchao',
      'San Juan de la Costa',
      'San Pablo',
    ],
    'CL-LR': [
      'Corral',
      'Futrono',
      'Isla Teja',
      'La Union',
      'Lanco',
      'Mafil',
      'Mariquina',
      'Paillaco',
      'Panguipulli',
      'Rio Bueno',
      'San Jose de la Mariquina',
      'Valdivia',
    ],
    'CL-MA': [
      'Antártica',
      'Cabo de Hornos',
      'Laguna Blanca',
      'Natales',
      'Puerto Williams',
      'Punta Arenas',
      'Río Verde',
      'San Gregorio',
      'Timaukel',
      'Torres Del Paine',
    ],
    'CL-ML': [
      'Cauquenes',
      'Chanco',
      'Colbun',
      'Constitucion',
      'Cumpeo',
      'Curepto',
      'Curico',
      'Hualañe',
      'Itahue',
      'Licanten',
      'Linares',
      'Longavi',
      'Lontue',
      'Maule',
      'Molina',
      'Parral',
      'Pelarco',
      'Pelluhue',
      'Pencahue',
      'Rauco',
      'Romeral',
      'Río Claro',
      'Sagrada Familia',
      'Talca',
      'Teno',
      'Vichuquen',
      'Villa Alegre',
      'Yerbas Buenas',
    ],
    'CL-RM': [
      'Alhue',
      'Alto Jahuel',
      'Batuco',
      'Buin',
      'Calera De Tango',
      'Cerro Navia',
      'Conchalí',
      'Curacavi',
      'El Bosque',
      'El Monte',
      'El Paico',
      'Estacion Central',
      'Huechuraba',
      'Isla De Maipo',
      'La Cisterna',
      'La Florida',
      'La Granja',
      'La Pintana',
      'La Reina',
      'Lampa',
      'Las Condes',
      'Lo Barnechea',
      'Lo Espejo',
      'Lo Prado',
      'Longovilo',
      'Lonquen',
      'Macul',
      'Malloco',
      'Maria Pinto',
      'Melipilla',
      'Nos',
      'Padre Hurtado',
      'Paine',
      'Pedro Aguirre Cerda',
      'Peñaflor',
      'Peñalolén',
      'Pirque',
      'Providencia',
      'Pudahuel',
      'Puente Alto',
      'Quilicura',
      'Quinta Normal',
      'Renca',
      'San Jose De Maipo',
      'San Jose De Melipilla',
      'San Pedro Quinta Region',
      'Talagante',
      'Til-Til',
      'Vitacura',
      'Ñuñoa',
    ],
    'CL-TA': ['Alto Hospicio', 'Camiña', 'Colchane', 'Huara', 'Iquique', 'Pica', 'Pozo Almonte'],
    'CL-VS': [
      'Algarrobo',
      'Artificio',
      'Barrancas',
      'Calle Larga',
      'Cartagena',
      'Casablanca',
      'Catemu',
      'Con-Con',
      'El Belloto',
      'El Melon',
      'El Quisco',
      'El Tabito',
      'El Tabo',
      'Hijuelas',
      'Isla De Pascua',
      'Isla Negra',
      'Juan Fernández',
      'La Cruz',
      'La Ligua',
      'Las Cruces',
      'Limache',
      'Llay-Llay',
      'Llo Lleo',
      'Nogales',
      'Olmue',
      'Panquehue',
      'Papudo',
      'Penablanca',
      'Petorca',
      'Placilla Quinta Region',
      'Puchuncavi',
      'Putaendo',
      'Quillota',
      'Quilpue',
      'Quintero',
      'Renaca',
      'San Esteban',
      'San Felipe',
      'San Francisco de Limache',
      'San Sebastian',
      'Santo Domingo',
      'Valparaiso',
      'Villa Alemana',
      'Viña Del Mar',
      'Zapallar',
    ],
    'CL-NB': [
      'Bulnes',
      'Chillán',
      'Chillán Viejo',
      'Cobquecura',
      'Coelemu',
      'Coihueco',
      'Ninhue',
      'Pemuco',
      'Portezuelo',
      'Quillón',
      'Quirihue',
      'Ránquil',
      'San Fabián',
      'Treguaco',
      'Yungay',
      'Ñiquén',
    ],
  },
  CHN: {
    'CN-AH': [
      'Anqing',
      'Bengbu',
      'Bozhou',
      'Chaohu',
      'Chizhou',
      'Chuzhou',
      'Fuyang',
      'Hefei',
      'Huaibei',
      'Huainan',
      'Huangshan',
      'Jieshou',
      "Lu'an",
      "Ma'anshan",
      'Mingguang',
      'Ningguo',
      'Suzhou',
      'Tianchang',
      'Tongcheng',
      'Tongling',
      'Wuhu',
      'Xuancheng',
    ],
    'CN-BJ': ['Beijing'],
    'CN-CQ': ['Chongqing'],
    'CN-FJ': [
      "Fu'an",
      'Fuding',
      'Fuqing',
      'Fuzhou',
      "Jian'ou",
      'Jinjiang',
      'Longhai',
      'Longyan',
      "Nan'an",
      'Nanping',
      'Ningde',
      'Putian',
      'Quanzhou',
      'Sanming',
      'Shaowu',
      'Shishi',
      'Wuyishan',
      'Xiamen',
      "Yong'an",
      'Zhangping',
      'Zhangzhou',
    ],
    'CN-GS': [
      'Baiyin',
      'Dingxi',
      'Dunhuang',
      'Hezuo',
      'Jiayuguan',
      'Jinchang',
      'Jiuquan',
      'Lanzhou',
      'Linxia',
      'Longnan',
      'Pingliang',
      'Qingyang',
      'Tianshui',
      'Wuwei',
      'Yumen',
      'Zhangye',
    ],
    'CN-GD': [
      'Chaozhou',
      'Dongguan',
      'Enping',
      'Foshan',
      'Gaozhou',
      'Guangzhou',
      'Heshan',
      'Heyuan',
      'Hong Kong',
      'Huazhou',
      'Huizhou',
      'Jiangmen',
      'Jieyang',
      'Kaiping',
      'Lechang',
      'Leizhou',
      'Lianjiang',
      'Lianzhou',
      'Lufeng',
      'Luoding',
      'Maoming',
      'Meizhou',
      'Nanxiong',
      'Puning',
      'Qingyuan',
      'Shantou',
      'Shanwei',
      'Shaoguan',
      'Shenzhen',
      'Sihui',
      'Taishan',
      'Wuchuan',
      'Xingning',
      'Xinyi',
      'Yangchun',
      'Yangjiang',
      'Yingde',
      'Yunfu',
      'Zhanjiang',
      'Zhaoqing',
      'Zhongshan',
      'Zhuhai',
    ],
    'CN-GX': [
      'Baise',
      'Beihai',
      'Beiliu',
      'Cenxi',
      'Chongzuo',
      'Dongxing',
      'Fangchenggang',
      'Guigang',
      'Guilin',
      'Guiping',
      'Hechi',
      'Hezhou',
      'Jingxi',
      'Laibin',
      'Liuzhou',
      'Nanning',
      'Pingxiang',
      'Qinzhou',
      'Wuzhou',
      'Yulin',
    ],
    'CN-GZ': [
      'Anshun',
      'Bijie',
      'Chishui',
      'Duyun',
      'Fuquan',
      'Guiyang',
      'Kaili',
      'Liupanshui',
      'Panzhou',
      'Qingzhen',
      'Renhuai',
      'Tongren',
      'Xingyi',
      'Zunyi',
    ],
    'CN-HI': ['Danzhou', 'Dongfang', 'Haikou', 'Qionghai', 'Sansha', 'Sanya', 'Wanning', 'Wenchang', 'Wuzhishan'],
    'CN-HE': [
      'Anguo',
      'Baoding',
      'Bazhou',
      'Botou',
      'Cangzhou',
      'Chengde',
      'Dingzhou',
      'Gaobeidian',
      'Handan',
      'Hejian',
      'Hengshui',
      'Huanghua',
      'Jinzhou',
      'Langfang',
      'Nangong',
      'Pingquan',
      "Qian'an",
      'Qinhuangdao',
      'Renqiu',
      'Sanhe',
      'Shahe',
      'Shenzhou',
      'Shijiazhuang',
      'Tangshan',
      "Wu'an",
      'Xingtai',
      'Xinji',
      'Xinle',
      'Zhangjiakou',
      'Zhuozhou',
      'Zunhua',
    ],
    'CN-HL': [
      'Anda',
      "Bei'an",
      'Daqing',
      'Dongning',
      'Fujin',
      'Fuyuan',
      'Hailin',
      'Hailun',
      'Harbin',
      'Hegang',
      'Heihe',
      'Hulin',
      'Jiamusi',
      'Jixi',
      'Mishan',
      'Mudanjiang',
      'Muling',
      'Nehe',
      "Ning'an",
      'Qiqihar',
      'Qitaihe',
      'Shangzhi',
      'Shuangyashan',
      'Suifenhe',
      'Suihua',
      'Tieli',
      'Tongjiang',
      'Wuchang',
      'Wudalianchi',
      'Yichun',
      'Zhaodong',
    ],
    'CN-HA': [
      'Anyang',
      'Changge',
      'Dengfeng',
      'Dengzhou',
      'Gongyi',
      'Hebi',
      'Huixian',
      'Jiaozuo',
      'Jiyuan',
      'Kaifeng',
      'Lingbao',
      'Linzhou',
      'Luohe',
      'Luoyang',
      'Mengzhou',
      'Nanyang',
      'Pingdingshan',
      'Puyang',
      'Qinyang',
      'Ruzhou',
      'Sanmenxia',
      'Shangqiu',
      'Weihui',
      'Wugang',
      'Xiangcheng',
      'Xingyang',
      'Xinmi',
      'Xinxiang',
      'Xinyang',
      'Xinzheng',
      'Xuchang',
      'Yanshi',
      'Yima',
      'Yongcheng',
      'Yuzhou',
      'Zhengzhou',
      'Zhoukou',
      'Zhumadian',
    ],
    'CN-HB': [
      'Anlu',
      'Chibi',
      'Dangyang',
      'Danjiangkou',
      'Daye',
      'Enshi',
      'Ezhou',
      'Guangshui',
      'Hanchuan',
      'Honghu',
      'Huanggang',
      'Huangshi',
      'Jingmen',
      'Jingzhou',
      'Laohekou',
      'Lichuan',
      'Macheng',
      'Qianjiang',
      'Shishou',
      'Shiyan',
      'Songzi',
      'Suizhou',
      'Tianmen',
      'Wuhan',
      'Wuxue',
      'Xiangyang',
      'Xianning',
      'Xiantao',
      'Xiaogan',
      'Yichang',
      'Yicheng',
      'Yidu',
      'Yingcheng',
      'Zaoyang',
      'Zhijiang',
      'Zhongxiang',
    ],
    'CN-HN': [
      'Changde',
      'Changning',
      'Changsha',
      'Chenzhou',
      'Hengyang',
      'Hongjiang',
      'Huaihua',
      'Jinshi',
      'Jishou',
      'Leiyang',
      'Lengshuijiang',
      'Lianyuan',
      'Liling',
      'Linxiang',
      'Liuyang',
      'Loudi',
      'Miluo',
      'Ningxiang',
      'Shaoshan',
      'Shaoyang',
      'Xiangtan',
      'Xiangxiang',
      'Yiyang',
      'Yongzhou',
      'Yuanjiang',
      'Yueyang',
      'Zhangjiajie',
      'Zhuzhou',
      'Zixing',
    ],
    'CN-NM': [
      'Arxan',
      'Baotou',
      'Bayannur',
      'Chifeng',
      'Erenhot',
      'Ergun',
      'Fengzhen',
      'Genhe',
      'Hohhot',
      'Holingol',
      'Hulunbuir',
      'Manzhouli',
      'Ordos',
      'Tongliao',
      'Ulanhot',
      'Ulanqab',
      'Wuhai',
      'Xilinhot',
      'Yakeshi',
      'Zhalantun',
    ],
    'CN-JS': [
      'Changshu',
      'Changzhou',
      'Danyang',
      'Dongtai',
      'Gaoyou',
      'Haimen',
      "Huai'an",
      'Jiangyin',
      'Jingjiang',
      'Jurong',
      'Kunshan',
      'Lianyungang',
      'Liyang',
      'Nanjing',
      'Nantong',
      'Pizhou',
      'Qidong',
      'Rugao',
      'Suqian',
      'Taicang',
      'Taixing',
      'Taizhou',
      'Wuxi',
      'Xinghua',
      'Xuzhou',
      'Yancheng',
      'Yangzhong',
      'Yangzhou',
      'Yixing',
      'Yizheng',
      'Zhangjiagang',
      'Zhenjiang',
    ],
    'CN-JX': [
      'Dexing',
      'Fengcheng',
      'Ganzhou',
      "Gao'an",
      'Gongqingcheng',
      'Guixi',
      "Ji'an",
      'Jingdezhen',
      'Jinggangshan',
      'Jiujiang',
      'Leping',
      'Lushan',
      'Nanchang',
      'Ruichang',
      'Ruijin',
      'Shangrao',
      'Xinyu',
      'Yingtan',
      'Zhangshu',
    ],
    'CN-JL': [
      'Baicheng',
      'Baishan',
      'Changchun',
      "Da'an",
      'Dehui',
      'Dunhua',
      'Fuyu',
      'Gongzhuling',
      'Helong',
      'Huadian',
      'Hunchun',
      'Jiaohe',
      'Jilin',
      'Liaoyuan',
      'Linjiang',
      'Longjing',
      'Meihekou',
      'Panshi',
      'Shuangliao',
      'Shulan',
      'Siping',
      'Songyuan',
      'Taonan',
      'Tonghua',
      'Tumen',
      'Yanji',
      'Yushu',
    ],
    'CN-LN': [
      'Anshan',
      'Beipiao',
      'Beizhen',
      'Benxi',
      'Chaoyang',
      'Dalian',
      'Dandong',
      'Dashiqiao',
      'Dengta',
      'Diaobingshan',
      'Donggang',
      'Fushun',
      'Fuxin',
      'Gaizhou',
      'Haicheng',
      'Huludao',
      'Kaiyuan',
      'Liaoyang',
      'Linghai',
      'Lingyuan',
      'Panjin',
      'Shenyang',
      'Tieling',
      'Wafangdian',
      'Xingcheng',
      'Xinmin',
      'Yingkou',
      'Zhuanghe',
    ],
    'CN-NX': ['Guyuan', 'Lingwu', 'Qingtongxia', 'Shizuishan', 'Wuzhong', 'Yinchuan', 'Zhongwei'],
    'CN-QH': ['Delingha', 'Golmud', 'Haidong', 'Xining'],
    'CN-SN': [
      'Ankang',
      'Baoji',
      'Hancheng',
      'Hanzhong',
      'Huayin',
      'Shangluo',
      'Shenmu',
      'Tongchuan',
      'Weinan',
      "Xi'an",
      'Xianyang',
      'Xingping',
      "Yan'an",
    ],
    'CN-SD': [
      'Anqiu',
      'Binzhou',
      'Changyi',
      'Dezhou',
      'Dongying',
      'Feicheng',
      'Gaomi',
      'Haiyang',
      'Heze',
      'Jiaozhou',
      'Jinan',
      'Jining',
      'Laiwu',
      'Laixi',
      'Laiyang',
      'Laizhou',
      'Leling',
      'Liaocheng',
      'Linqing',
      'Linyi',
      'Longkou',
      'Penglai',
      'Pingdu',
      'Qingdao',
      'Qingzhou',
      'Qixia',
      'Qufu',
      'Rizhao',
      'Rongcheng',
      'Rushan',
      'Shouguang',
      "Tai'an",
      'Tengzhou',
      'Weifang',
      'Weihai',
      'Xintai',
      'Yantai',
      'Yucheng',
      'Zaozhuang',
      'Zhaoyuan',
      'Zhucheng',
      'Zibo',
      'Zoucheng',
    ],
    'CN-SH': ['Shanghai'],
    'CN-SX': [
      'Changzhi',
      'Datong',
      'Fenyang',
      'Gaoping',
      'Gujiao',
      'Hejin',
      'Houma',
      'Huozhou',
      'Jiexiu',
      'Jincheng',
      'Jinzhong',
      'Linfen',
      'Lucheng',
      'Lüliang',
      'Shuozhou',
      'Taiyuan',
      'Xiaoyi',
      'Xinzhou',
      'Yangquan',
      'Yongji',
      'Yuanping',
      'Yuncheng',
    ],
    'CN-SC': [
      'Barkam',
      'Bazhong',
      'Chengdu',
      'Chongzhou',
      'Dazhou',
      'Deyang',
      'Dujiangyan',
      'Emeishan',
      "Guang'an",
      'Guanghan',
      'Guangyuan',
      'Huaying',
      'Jiangyou',
      'Jianyang',
      'Kangding',
      'Langzhong',
      'Leshan',
      'Longchang',
      'Luzhou',
      'Meishan',
      'Mianyang',
      'Mianzhu',
      'Nanchong',
      'Neijiang',
      'Panzhihua',
      'Pengzhou',
      'Qionglai',
      'Shifang',
      'Suining',
      'Wanyuan',
      'Xichang',
      "Ya'an",
      'Yibin',
      'Zigong',
      'Ziyang',
    ],
    'CN-TJ': ['Tianjin'],
    'CN-XJ': [
      'Aksu',
      'Alashankou',
      'Altay',
      'Aral',
      'Artux',
      'Beitun',
      'Bole',
      'Changji',
      'Fukang',
      'Hami',
      'Hotan',
      'Karamay',
      'Kashgar',
      'Khorgas',
      'Kokdala',
      'Korla',
      'Kunyu',
      'Kuytun',
      'Shihezi',
      'Shuanghe',
      'Tacheng',
      'Tiemenguan',
      'Tumxuk',
      'Turpan',
      'Wujiaqu',
      'Wusu',
      'Yining',
      'ÜrümqiÜrümqi',
    ],
    'CN-XZ': ['Lhasa', 'Nagqu', 'Nyingchi', 'Qamdo', 'Shannan', 'Xigazê'],
    'CN-YN': [
      'Anning',
      'Baoshan',
      'Chuxiong',
      'Dali',
      'Gejiu',
      'Jinghong',
      'Kunming',
      'Lijiang',
      'Lincang',
      'Lushui',
      'Mang',
      'Mengzi',
      'Mile',
      "Pu'er",
      'Qujing',
      'Ruili',
      'Shangri-La',
      'Tengchong',
      'Wenshan',
      'Xuanwei',
      'Yuxi',
      'Zhaotong',
    ],
    'CN-ZJ': [
      'Cixi',
      'Dongyang',
      'Haining',
      'Hangzhou',
      'Huzhou',
      'Jiande',
      'Jiangshan',
      'Jiaxing',
      'Jinhua',
      'Lanxi',
      'Linhai',
      'Lishui',
      'Longquan',
      'Ningbo',
      'Pinghu',
      'Quzhou',
      'Ruian',
      'Shaoxing',
      'Shengzhou',
      'Tongxiang',
      'Wenling',
      'Wenzhou',
      'Yiwu',
      'Yongkang',
      'Yueqing',
      'Yuhuan',
      'Yuyao',
      'Zhoushan',
      'Zhuji',
    ],
  },
  COL: {
    'CO-AMA': [
      'Alto Orinoco (La Esmeralda)',
      'Atabapo (San Fernando de Atabapo)',
      'Atures (Puerto Ayacucho)',
      'Autana (Isla Ratón)',
      'Bagua',
      'Bongará',
      'Calamar',
      'Cartagena Del Chairá',
      'Carurú',
      'Chachapoyas',
      'Condorcanqui',
      'El Encanto',
      'La Chorrera',
      'La Pedrera',
      'La Victoria (Pacoa)',
      'Leticia',
      'Luya',
      'Manapiare (San Juan de Manapiare)',
      'Maroa (Maroa)',
      'Miraflores',
      'Mirití-Paraná (Campoamor)',
      'Mitú',
      'Otra ciudad',
      'Pacoa',
      'Papunaua',
      'Puerto Alegría',
      'Puerto Arica',
      'Puerto Leguízamo',
      'Puerto Nariño',
      'Rodríguez de Mendoza',
      'Río Negro (San Carlos de Río Negro)',
      'San Vicente Del Caguán',
      'Santander (Araracuara)',
      'Solano',
      'Taraira',
      'Tarapacá',
      'Utcubamba',
      'Yavaraté',
    ],
    'CO-ANT': [
      'Abejorral',
      'Abriaquí',
      'Alejandría',
      'Amagá',
      'Amalfi',
      'Andes',
      'Angelópolis',
      'Angostura',
      'Anorí',
      'Anzá',
      'Apartadó',
      'Arboletes',
      'Argelia',
      'Armenia',
      'Bello',
      'Belmira',
      'Betania',
      'Betulia',
      'Briceño',
      'Buriticá',
      'Caicedo',
      'Campamento',
      'Caracolí',
      'Caramanta',
      'Carepa',
      'Caucasia',
      'Cañasgordas',
      'Chigorodó',
      'Cisneros',
      'Ciudad Bolívar',
      'Cocorna',
      'Currulao',
      'Dabeiba',
      'Don Matias',
      'Doradal',
      'Ebéjico',
      'El Bagre',
      'El Carmen de Viboral',
      'El Santuario',
      'El Valle del Cauca',
      'Entrerrios',
      'Envigado',
      'Fredonia',
      'Frontino',
      'Giraldo',
      'Girardota',
      'Guarne',
      'Guatape',
      'Gómez Plata',
      'Heliconia',
      'Hispania',
      'Itaguí',
      'Ituango',
      'Jardín',
      'La Ceja',
      'La Unión',
      'Laxa0Sierra',
      'Liborina',
      'Llanos de Cuivá',
      'Maceo',
      'Marinilla',
      'Medellín',
      'Montebello',
      'Murindó',
      'Mutatá',
      'Nariño',
      'Nechí',
      'Necoclí',
      'Nueva Colonia',
      'Olaya',
      'Peque',
      'Peñol',
      'Pueblorrico',
      'Puerto Berrio',
      'Puerto Nare',
      'Puerto Triunfo',
      'Puerto Claver',
      'Puerto Perales Nuevo',
      'Remedios',
      'Rionegro',
      'Sabanalarga',
      'Sabaneta',
      'Salgar',
      'San Andrés de Cuerquia',
      'San Antonio de Prado',
      'San Cristbbbal',
      'San José De La Montaña',
      'San Juan De Urabá',
      'San Pedro De Urabá',
      'San Pedro de los Milagros',
      'Santa Fe Antioquia',
      'Santa Rosa De Osos',
      'Santuario',
      'San Cristobal',
      'Segovia',
      'Sonsón',
      'Sopetrán',
      'Tarazá',
      'Tarso',
      'Titiribí',
      'Turbo',
      'Támesis',
      'Uramita',
      'Urrao',
      'Vegachí',
      'Venecia',
      'Vigia Del Fuerte',
      'Yalí',
      'Yarumal',
      'Yolombó',
      'Yondó (Casabe)',
      'Zaragoza',
    ],
    'CO-ARA': ['Arauca', 'Arauquita', 'Cravo Norte', 'Fortul', 'Puerto Rondón', 'Saravena', 'Tame'],
    'CO-ATL': [
      'Aguada de Pablo',
      'Baranoa',
      'Barranquilla',
      'Campo De La Cruz',
      'Cascajal',
      'Galapa',
      'Juan De Acosta',
      'Juan Mina',
      'La Peña',
      'Luruaco',
      'Malambo',
      'Manatí',
      'Palmar De Varela',
      'Piojó',
      'Polonuevo',
      'Ponedera',
      'Puerto Colombia',
      'Puerto Giraldo',
      'Repelón',
      'Sabanagrande',
      'Santo Tomás',
      'Soledad',
      'Suan',
      'Tubará',
      'Usiacurí',
    ],
    'CO-DC': [
      'Antonio Nariño',
      'Barrios Unidos',
      'Bosa',
      'Chapinero',
      'Ciudad Bolivar',
      'Engativá',
      'Fontibón',
      'Kennedy',
      'Martires',
      'Puente Aranda',
      'Rafael Uribe Uribe',
      'San Cristobal Sur',
      'Santa Fe',
      'Suba',
      'Sumapaz',
      'Teusaquillo',
      'Tunjuelito',
      'Usaquén',
      'Usme',
    ],
    'CO-BOL': [
      'Achí',
      'Altos Del Rosario',
      'Arenal',
      'Arjona',
      'Arroyohondo',
      'Barranco De Loba',
      'Bayunca',
      'Cantagallo',
      'Cartagena De Indias',
      'Cicuco',
      'Clemencia',
      'El Carmen De Bolívar',
      'El Guamo',
      'El Peñón',
      'Gambote',
      'Hatillo De Loba',
      'Juan Arias',
      'Magangué',
      'Mahates',
      'Malagana',
      'Margarita',
      'María La Baja',
      'Mompós',
      'Montecristo',
      'Morales',
      'Pasacaballos',
      'Pinillos',
      'Pontezuela',
      'Punta de Cartagena',
      'Regidor',
      'Rio Viejo',
      'San Estanislao',
      'San Jacinto',
      'San Jacinto Del Cauca',
      'San Juan Nepomuceno',
      'San Martín De Loba',
      'Santa Rosa Del Sur',
      'Simití',
      'Sincerin',
      'Soplaviento',
      'Talaigua Nuevo',
      'Tiquisio (Puerto Rico)',
      'Tiquisio Nuevo',
      'Turbaco',
      'Turbana',
      'Villanueva',
      'Yati',
      'Zambrano',
    ],
    'CO-BOY': [
      'Aquitania',
      'Arcabuco',
      'Belencito',
      'Berbeo',
      'Beteitiva',
      'Boavita',
      'Boyacá',
      'Buenavista',
      'Busbanza',
      'Campohermoso',
      'Cerinza',
      'Chinavita',
      'Chiquinquirá',
      'Chiscas',
      'Chita',
      'Chitaraque',
      'Chivatá',
      'Chivor',
      'Chíquiza',
      'Ciénega',
      'Coper',
      'Corrales',
      'Covarachía',
      'Cubará',
      'Cucaita',
      'Cuítiva',
      'Cómbita',
      'Duitama',
      'El Cocuy',
      'El Espino',
      'Encino',
      'Firavitoba',
      'Gachantivá',
      'Garagoa',
      'Guacamayas',
      'Guateque',
      'Guayatá',
      'Guicán',
      'Gámeza',
      'Iza',
      'Jenesano',
      'La Capilla',
      'La Uvita',
      'La Victoria',
      'Labranzagrande',
      'Macanal',
      'Maripí',
      'Mongua',
      'Monguí',
      'Moniquirá',
      'Motavita',
      'Muzo',
      'Nobsa',
      'Nuevo Colón',
      'Oicatá',
      'Otanche',
      'Pachavita',
      'Paipa',
      'Pajarito',
      'Panqueba',
      'Pauna',
      'Paya',
      'Paz De Rio',
      'Pesca',
      'Pisva',
      'Puerto Boyacá',
      'Páez',
      'Quípama',
      'Ramiriquí',
      'Rondón',
      'Ráquira',
      'Saboyá',
      'Samacá',
      'San Eduardo',
      'San José de Pare',
      'San Luis De Gaceno',
      'San Mateo',
      'San Miguel De Sema',
      'San Pablo De Borbur',
      'Santa Rosa De Viterbo',
      'Santa Sofía',
      'Sativanorte',
      'Sativasur',
      'Siachoque',
      'Soatá',
      'Socha',
      'Socotá',
      'Sogamoso',
      'Somondoco',
      'Sora',
      'Soracá',
      'Sotaquirá',
      'Susacón',
      'Sutamarchán',
      'Sutatenza',
      'Sáchica',
      'Tasco',
      'Tenza',
      'Tibaná',
      'Tibasosa',
      'Tierra Negra',
      'Tinjacá',
      'Tipacoque',
      'Toca',
      'Togüí',
      'Tota',
      'Tunja',
      'Tununguá',
      'Turmequé',
      'Tuta',
      'Tutazá',
      'Tópaga',
      'Ventaquemada',
      'Villa De Leiva',
      'Villa de Leyva',
      'Viracachá',
      'Zetaquira',
      'Úmbita',
    ],
    'CO-CAL': [
      'Aguadas',
      'Alto Tablazo',
      'Anserma',
      'Aranzazu',
      'Bajo Tablazo',
      'Belalcazar',
      'Bolivia',
      'Chinchiná',
      'Guarinocito',
      'La Dorada',
      'La Linda',
      'La Merced',
      'Manizales',
      'Manzanares',
      'Marmato',
      'Marquetalia',
      'Marulanda',
      'Neira',
      'Norcasia',
      'Pensilvania',
      'Pácora',
      'Riosucio',
      'Risaralda',
      'Salamina',
      'Samaná',
      'San José',
      'Supia',
      'Villamaria',
      'Viterbo',
    ],
    'CO-CAQ': [
      'Albania',
      'Belén De Los Andaquíes',
      'Curillo',
      'El Doncello',
      'El Paujil',
      'Florencia',
      'Milán',
      'Montañita',
      'Morelia',
      'San José Del Fragua',
      'Solita',
      'Campo Hermoso',
    ],
    'CO-CAS': [
      'Aguazul',
      'Chámeza',
      'Hato Corozal',
      'La Salina',
      'Maní',
      'Monterrey',
      'Nunchía',
      'Orocué',
      'Paz De Ariporo',
      'Pore',
      'Recetor',
      'San Luis De Palenque',
      'Sácama',
      'Tauramena',
      'Támara',
      'Yopal',
    ],
    'CO-CAU': [
      'Almaguer',
      'Balboa',
      'Cajibio',
      'Caldono',
      'Caloto',
      'El Tambo',
      'El Bordo',
      'El Estrecho',
      'El Plateado',
      'Guachene',
      'Guapi',
      'Inzá',
      'Jambaló',
      'La Sierra',
      'La Vega',
      'López',
      'Mercaderes',
      'Micay',
      'Ortigal',
      'Patía (El Bordo)',
      'Piamonte',
      'Piendamo',
      'Popayán',
      'Puerto Tejada',
      'Puracé (Coconuco)',
      'Páez (Belalcazar)',
      'Rosas',
      'San Sebastián',
      'Santander De Quilichao',
      'Silvia',
      'Sotará (Paispamba)',
      'Suárez',
      'Timbio',
      'Timbiquí',
      'Toribio',
      'Totoró',
      'Tunia',
      'Villa Rica',
    ],
    'CO-CES': [
      'Aguachica',
      'Agustín Codazzi',
      'Astrea',
      'Becerril',
      'Bosconia',
      'Casacaza',
      'Chimichagua',
      'Chiriguana',
      'Codazzi',
      'Curumaní',
      'El Copey',
      'El Paso',
      'Gamarra',
      'González',
      'La Gloria',
      'La Jagua de Ibirico',
      'Manaure Balcón Del Cesar',
      'Pailitas',
      'Pelaya',
      'Pueblo Bello',
      'Rio De Oro',
      'San Diego',
      'Tamalameque',
      'Valledupar',
      'La Loma',
      'La Mata',
      'Las Vegas',
      'Mina Drumond Pribbenow',
      'El Juncal',
    ],
    'CO-CHO': [
      'Acandí',
      'Alto Baudó (Pie De Pato)',
      'Atrato (Yuto)',
      'Bagadó',
      'Bahía Solano (Mutis)',
      'Bajo Baudó (Pizarro)',
      'Bojayá (Bellavista)',
      'Carmen del Darien',
      'Condoto',
      'Cértegui',
      'El Cantón Del San Pablo (Managrú)',
      'El Carmen de Atrato',
      'El Litoral Del San Juán (Docordo)',
      'Istmina',
      'Juradó',
      'Lloró',
      'Medio Atrato',
      'Medio Baudó(Boca De Pepe)',
      'Medio San Juan',
      'Nuquí',
      'Nóvita',
      'Pizarro',
      'Quibdó',
      'Rio Iró (Santa Rita De Iro)',
      'Rio Quito (Paimado)',
      'San José Del Palmar',
      'Sipí',
      'Tadó',
      'Unguía',
      'Unión Panamericana (Las Animas)',
      'Belén de Bajirá',
    ],
    'CO-CUN': [
      'Agua De Dios',
      'Albán',
      'Anapoima',
      'Anolaima',
      'Apulo',
      'Arbeláez',
      'Beltrán',
      'Bituima',
      'Bojacá',
      'Cabrera',
      'Cachipay',
      'Cajicá',
      'Caparrapí',
      'Capellania',
      'Carmen De Carupa',
      'Chaguaní',
      'Chinauta',
      'Chipaque',
      'Choachí',
      'Chocontá',
      'Chía',
      'Cogua',
      'Cota',
      'Cucunubá',
      'Cáqueza',
      'El Colegio',
      'El Rosal',
      'El Triunfo',
      'Facatativá',
      'Fosca',
      'Funza',
      'Fusagasugá',
      'Fómeque',
      'Fúquene',
      'Gachalá',
      'Gachancipá',
      'Gachetá',
      'Girardot',
      'Guachetá',
      'Guaduas',
      'Guasca',
      'Guataquí',
      'Guatavita',
      'Guayabal De Síquima',
      'Guayabetal',
      'Jerusalén',
      'La Mesa',
      'La Palma',
      'La Gran Vía',
      'Lenguazaque',
      'Limoncitos',
      'Machetá',
      'Madrid',
      'Manta',
      'Mosquera',
      'Nemocón',
      'Nilo',
      'Nimaima',
      'Nocaima',
      'Pacho',
      'Paime',
      'Pandi',
      'Paratebueno',
      'Pasca',
      'Puente Quetame',
      'Puente de Piedra',
      'Puerto Salgar',
      'Puerto Bogota',
      'Pulí',
      'Quebradanegra',
      'Quetame',
      'Quipile',
      'Ricaurte',
      'San Antonio Del Tequendama',
      'San Juan de Ríoseco',
      'Santandercito',
      'San Joaquin',
      'Sasaima',
      'Sesquilé',
      'Sibaté',
      'Silvanía',
      'Simijaca',
      'Soacha',
      'Sopó',
      'Subachoque',
      'Subia',
      'Suesca',
      'Supatá',
      'Susa',
      'Sutatausa',
      'Tabio',
      'Tausa',
      'Tena',
      'Tenjo',
      'Tibacuy',
      'Tibirita',
      'Tibito',
      'Tocaima',
      'Tocancipá',
      'Tolemaida',
      'Topaipí',
      'Ubalá',
      'Ubaque',
      'Ubaté',
      'Une',
      'Vergara',
      'Vianí',
      'Villa de San Diego de Ubate',
      'Villagómez',
      'Villapinzón',
      'Villeta',
      'Viotá',
      'Yacopí',
      'Zipacón',
      'Zipaquirá',
      'Útica',
    ],
    'CO-COR': [
      'Ayapel',
      'Canalete',
      'Carrillo',
      'Cereté',
      'Cerromatoso',
      'Chimá',
      'Chinú',
      'Ciénaga De Oro',
      'Cotorra',
      'La Apartada',
      'La Apartada y La Frontera',
      'Lorica',
      'Los Córdobas',
      'Los Garzones',
      'Momil',
      'Montelíbano',
      'Montería',
      'Moñitos',
      'Planeta Rica',
      'Pueblo Nuevo',
      'Puerto Escondido',
      'Puerto Libertador',
      'Purísima',
      'Sahagún',
      'San Andrés De Sotavento',
      'San Antero',
      'San Bernardo Del Viento',
      'San José de Uré',
      'San Pelayo',
      'Tierralta',
      'Tuchin',
      'Valencia',
    ],
    'CO-GUA': [
      'Barranco Mina',
      'Cacahual',
      'Inírida',
      'La Guadalupe',
      'Mapiripana',
      'Morichal (Morichal Nuevo)',
      'Paná-Paná (Campo Alegre)',
      'Puerto Inirida',
    ],
    'CO-LAG': [
      'Cuestecitas',
      'Dibulla',
      'Distraccion',
      'El Molino',
      'Hatonuevo',
      'La Jagua Del Pilar',
      'La Mina',
      'Maicao',
      'Manaure',
      'Mingueo',
      'Palomino',
      'Paraguachon',
      'Riohacha',
      'San Juan Del Cesar',
      'Uribia',
      'Urumita',
    ],
    'CO-GUV': ['El Retorno', 'San José Del Guaviare'],
    'CO-HUI': [
      'Acevedo',
      'Agrado',
      'Aipe',
      'Algeciras',
      'Baraya',
      'Belen',
      'Bruselas',
      'Caguan',
      'Campoalegre',
      'Colombia',
      'Elías',
      'Garzón',
      'Gigante',
      'Guayabal',
      'Hobo',
      'Isnos',
      'La Argentina',
      'Neiva',
      'Nátaga',
      'Oporapa',
      'Pacarni',
      'Paicol',
      'Pital',
      'Pitalito',
      'Rivera',
      'Saladoblanco',
      'Suaza',
      'Tarqui',
      'Tello',
      'Teruel',
      'Tesalia',
      'Timaná',
      'Ulloa',
      'Villavieja',
      'Yaguará',
      'Zuluaga',
      'Íquira',
      'San Jose De Isnos',
    ],
    'CO-MAG': [
      'Aracataca',
      'Ariguaní (El Dificil)',
      'Buritaca',
      'Carreto',
      'Cerro De San Antonio',
      'Chibolo',
      'Ciénaga',
      'El Banco',
      'El Piñón',
      'El Retén',
      'El Dificil',
      'Fundación',
      'Gaira',
      'Guacamayal',
      'Guachaca',
      'Guamal',
      'La Gran Via',
      'Nueva Granada',
      'Pedraza',
      'Pijiño Del Carmen',
      'Pivijay',
      'Plato',
      'Puebloviejo',
      'Remolino',
      'Sabanas De San Angel',
      'San Sebastián De Buenavista',
      'San Zenón',
      'Santa Bárbara De Pinto',
      'Santa Rosalia',
      'San Angel',
      'Sitionuevo',
      'Taganga',
      'Tenerife',
      'Zapayán',
      'Zona Bananera',
    ],
    'CO-MET': [
      'Acacias',
      'Alto Pompeya',
      'Apiay',
      'Barranca De Upia',
      'Cabuyaro',
      'Castilla La Nueva',
      'Cubarral',
      'Cumaral',
      'El Calvario',
      'El Castillo',
      'Fuente de Oro',
      'La Macarena',
      'La Palmera',
      'Lejanías',
      'Mapiripán',
      'Medellin de Ariari',
      'Mesetas',
      'Pachaquiaro',
      'Puerto Concordia',
      'Puerto Gaitán',
      'Puerto Lleras',
      'Puerto López',
      'Restrepo',
      'Rubiales',
      'San Carlos De Guaroa',
      'San Juan De Arama',
      'San Juanito',
      'San Juan del Losada',
      'Uribe',
      'Villavicencio',
      'Vistahermosa',
    ],
    'CO-NAR': [
      'Albán (San Jose)',
      'Aldana',
      'Ancuya',
      'Arboleda (Berruecos)',
      'Barbacoas',
      'Buesaco',
      'Catambuco',
      'Chachaguí',
      'Colon (Genova)',
      'Consacá',
      'Contadero',
      'Cuaspud (Carlosama)',
      'Cumbal',
      'Cumbitara',
      'El Charco',
      'El Peñol',
      'El Rosario',
      'El Tablón',
      'Francisco Pizarro (Salahonda)',
      'Genova',
      'Guachucal',
      'Guaitarilla',
      'Gualmatán',
      'Iles',
      'Imués',
      'Ipiales',
      'Iscuande',
      'La Llanada',
      'La Tola',
      'Leiva',
      'Llorente',
      'Los Andes (Sotomayor)',
      'Magüí (Payan)',
      'Mallama (Piedrancha)',
      'Olaya Herrera (Bocas De Satinga)',
      'Ospina',
      'Pasto',
      'Policarpa',
      'Puerres',
      'Pupiales',
      'Roberto Payán (San Jose)',
      'Samaniego',
      'San Pedro De Cartago (Cartago)',
      'Sandoná',
      'Santa Bárbara (Iscuande)',
      'Santa Cruz (Guachaves)',
      'Sapuyes',
      'Sotomayor',
      'Taminango',
      'Tangua',
      'Tumaco',
      'Túquerres',
      'Yacuanquer',
      'Bocas De Satinga',
      'El Encano',
    ],
    'CO-NSA': [
      'Abrego',
      'Aguas Claras',
      'Arboledas',
      'Bochalema',
      'Bucarasica',
      'Campo Dos',
      'Carcasi',
      'Chinácota',
      'Chitagá',
      'Convención',
      'Cucutilla',
      'Cáchira',
      'Cácota',
      'Cúcuta',
      'Durania',
      'El Tarra',
      'El Zulia',
      'Gramalote',
      'Hacarí',
      'Herrán',
      'La Esperanza',
      'La Playa',
      'Labateca',
      'La Donjuana',
      'La Floresta',
      'La Jarra',
      'Los Patios',
      'Mutiscua',
      'Ocaña',
      'Pamplona',
      'Pamplonita',
      'Puerto Santander',
      'Ragonvalia',
      'Salazar',
      'San Calixto',
      'San Bernardo de Bata',
      'Sardinata',
      'Silos',
      'Teorama',
      'Tibú',
      'Villa Caro',
      'Villa Del Rosario',
    ],
    'CO-PUT': [
      'Leguizamo',
      'Mocoa',
      'Orito',
      'Puerto Asís',
      'Puerto Caicedo',
      'Puerto Guzmán',
      'San Miguel (La Dorada)',
      'Sibundoy',
      'Valle Del Guamuéz (La Hormiga)',
      'Villagarzón',
      'La Hormiga',
    ],
    'CO-QUI': [
      'Calarcá',
      'Circasia',
      'Filandia',
      'Génova',
      'La Tebaida',
      'Pijao',
      'Quimbaya',
      'Salento',
      'El Caimo',
      'Pueblo Tapado',
    ],
    'CO-RIS': [
      'Apía',
      'Belén De Umbría',
      'Caimalito',
      'Dosquebradas',
      'El Crucero de Combia',
      'Guática',
      'Irra',
      'La Celia',
      'La Virginia',
      'Marsella',
      'Mistrató',
      'Pereira',
      'Pueblo Rico',
      'Quinchía',
      'Santa Rosa De Cabal',
    ],
    'CO-SAP': ['Providencia Y Santa Catalina (Santa Isabel)'],
    'CO-SAN': [
      'Acapulco',
      'Aguada',
      'Aratoca',
      'Barichara',
      'Barrancabermeja',
      'Bucaramanga',
      'California',
      'Capitanejo',
      'Carcasí',
      'Cepitá',
      'Charalá',
      'Charta',
      'Chima',
      'Chipatá',
      'Cimitarra',
      'Cite',
      'Confines',
      'Contratación',
      'Coromoro',
      'Curití',
      'El Carmen de Chucuri',
      'El Guacamayo',
      'El Playón',
      'El Centro',
      'El Llanito',
      'Enciso',
      'Floridablanca',
      'Florián',
      'Galán',
      'Girón',
      'Guaca',
      'Guapotá',
      'Guavatá',
      'Gámbita',
      'Güepsa',
      'Hato',
      'Jordán',
      'La Belleza',
      'La Fortuna',
      'Landázuri',
      'Lebrija',
      'Los Santos',
      'Macaravita',
      'Matanza',
      'Mogotes',
      'Molagavita',
      'Málaga',
      'Ocamonte',
      'Oiba',
      'Olival',
      'Onzaga',
      'Palmar',
      'Palmas Del Socorro',
      'Palo Gordo',
      'Piedecuesta',
      'Pinchote',
      'Puente Nacional',
      'Puente Sogamoso',
      'Puerto Parra',
      'Puerto Wilches',
      'Puerto Araujo',
      'Páramo',
      'Sabana De Torres',
      'San Gil',
      'San José De Miranda',
      'San Vicente De Chucurí',
      'Santa Helena Del Opón',
      'Simácota',
      'Suaita',
      'Suratá',
      'Tienda Nueva',
      'Tona',
      'Vado Real',
      'Valle De San José',
      'Valle del Cauca de San Jose',
      'Vetas',
      'Vélez',
      'Zapatoca',
    ],
    'CO-SUC': [
      'Altos de Santa Fe',
      'Altos de Sucre',
      'Arapo',
      'Araya',
      'Caigüire',
      'Caimito',
      'Cariaco',
      'Carúpano',
      'Chalán',
      'Colosó',
      'Corozal',
      'Coveñas',
      'Cumanacoa',
      'Cumaná',
      'El Roble',
      'Galeras',
      'Golfo de Cariaco',
      'Guaranda',
      'Güiria',
      'Irapa',
      'Los Bordones',
      'Los Palmítos',
      'Macarapana',
      'Majagual',
      'Mariguitar',
      'Mochima',
      'Morróa',
      'Nueva Cumaná',
      'Ovejas',
      'Palmito',
      'Parc. Miranda',
      'Playa Colorada',
      'Río Caribe',
      'Río Caribe-Playa Medina',
      'S. Juan de Unare',
      'Sampués',
      'San Benito Abad',
      'San Juan De Betulia',
      'San Marcos',
      'San Onofre',
      'Sincelejo',
      'Sincé',
      'Tolú',
      'Tolú Viejo',
      'Unare',
      'Vía Cariaco-Casanay',
    ],
    'CO-TOL': [
      'Ajamarca',
      'Alpujarra',
      'Alvarado',
      'Ambalema',
      'Anzoátegui',
      'Armero (Guayabal)',
      'Ataco',
      'Cajamarca',
      'Carmen De Apicalá',
      'Casabianca',
      'Chaparral',
      'Chicoral',
      'Coello',
      'Coyaima',
      'Cunday',
      'Espinal',
      'Falan',
      'Flandes',
      'Fresno',
      'Gaitania',
      'Gualanday',
      'Guamo',
      'Herrera',
      'Herveo',
      'Honda',
      'Ibagué',
      'Icononzo',
      'Lérida',
      'Líbano',
      'Melgar',
      'Murillo',
      'Natagaima',
      'Ortega',
      'Pajonales',
      'Palocabildo',
      'Piedras',
      'Planadas',
      'Purificación',
      'Rioblanco',
      'Roncesvalles',
      'Rovira',
      'Saldaña',
      'Valle De San Juan',
      'Venadillo',
      'Villahermosa',
      'Valle del Cauca de San Juan',
      'Santiago Perez',
    ],
    'CO-VAC': [
      'Alcalá',
      'Amaime',
      'Andalucía',
      'Ansermanuevo',
      'Bahia Málaga',
      'Borrero Ayerbe',
      'Buenaventura',
      'Buga',
      'Bugalagrande',
      'Caicedonia',
      'Cali',
      'Calima (El Darien)',
      'Cartago',
      'Cascajal I',
      'Dagua',
      'El Cairo',
      'El Dovio',
      'El Saladito',
      'El Águila',
      'El Cabuyal',
      'El Carmelo',
      'El Placer',
      'El Queremal',
      'Ginebra',
      'Guabitas',
      'Guacarí',
      'Guadalajara de Buga',
      'Jamundí',
      'La Cumbre',
      'La Paila',
      'Lobo Guerrero',
      'Obando',
      'Pradera',
      'Riofrio',
      'Roldanillo',
      'Rozo',
      'Santa Elena',
      'San Antonio de Los Caballeros',
      'Sevilla',
      'Toro',
      'Trujillo',
      'Tuluá',
      'Uribe Uribe',
      'Versalles',
      'Vijes',
      'Villa Gorgona',
      'Yotoco',
      'Yumbo',
      'Zarzal',
    ],
    'CO-VAU': ['Pacoa (Cor. Departamental)', 'Papunaua (Cor. Departamental)', 'Yavaraté (Cor. Departamental)'],
    'CO-VID': ['Cumaribo', 'La Primavera', 'Puerto Carreño'],
  },
  CRI: {
    'CR-A': [
      'Alfaro Ruiz',
      'Atenas',
      'Grecia',
      'Guatuso',
      'Los Chiles',
      'Naranjo',
      'Orotina',
      'Poás',
      'Upala',
      'Valverde Vega',
    ],
    'CR-C': ['El Guarco', 'Oreamuno', 'Turrialba'],
    'CR-G': ['Abangares', 'Bagaces', 'Cañas', 'Hojancha', 'Liberia', 'Nandayure', 'Nicoya', 'Tilarán'],
    'CR-H': ['Barva', 'Sarapiquí'],
    'CR-L': ['Guácimo', 'Pococí', 'Siquirres', 'Talamanca'],
    'CR-P': [
      'Corredores',
      'Coto Brus',
      'Esparza',
      'Garabito',
      'Golfito',
      'Montes de Oro',
      'Osa',
      'Parrita',
      'Puntarenas',
    ],
    'CR-SJ': [
      'Acosta',
      'Alajuelita',
      'Aserrí',
      'Curridabat',
      'Desamparados',
      'Dota',
      'Escazú',
      'Goicoechea',
      'León Cortés Castro',
      'Montes de Oca',
      'Mora',
      'Moravia',
      'Puriscal',
      'Pérez Zeledón',
      'Tarrazú',
      'Tibás',
      'Turrubares',
      'Vázquez de Coronado',
    ],
  },
  CUB: {
    'CU-15': [
      'Alquízar',
      'Artemisa',
      'Bahía Honda',
      'Bauta',
      'Guanajay',
      'Güira de Melena',
      'Mariel',
      'San Antonio de los Baños',
    ],
    'CU-09': [
      'Camagüey',
      'Carlos Manuel de Céspedes',
      'Guáimaro',
      'Jimaguayú',
      'Najasa',
      'Nuevitas',
      'Santa Cruz del Sur',
      'Sibanicú',
      'Sierra de Cubitas',
      'Vertientes',
    ],
    'CU-08': ['Baraguá', 'Chambas', 'Ciego de Ávila', 'Ciro Redondo', 'Majagua', 'Primero de Enero', 'Venezuela'],
    'CU-06': ['Aguada de Pasajeros', 'Cienfuegos', 'Cruces', 'Cumanayagua', 'Rodas', 'Santa Isabel de las Lajas'],
    'CU-12': [
      'Bartolomé Masó',
      'Bayamo',
      'Buey Arriba',
      'Campechuela',
      'Cauto Cristo',
      'Guisa',
      'Jiguaní',
      'Manzanillo',
      'Niquero',
      'Pilón',
      'Río Cauto',
      'Yara',
    ],
    'CU-14': [
      'Baracoa',
      'Caimanera',
      'Guantánamo',
      'Imías',
      'Maisí',
      'Manuel Tames',
      'Niceto Pérez',
      'San Antonio del Sur',
      'Yateras',
    ],
    'CU-11': [
      'Antilla',
      'Banes',
      'Báguanos',
      'Cacocum',
      'Calixto García',
      'Cueto',
      'Frank País',
      'Gibara',
      'Holguín',
      'Mayarí',
      'Moa',
      'Rafael Freyre',
      'Sagua de Tánamo',
      'Urbano Noris',
    ],
    'CU-99': ['Isla de la Juventud'],
    'CU-02': [
      'Arroyo Naranjo',
      'Boyeros',
      'Centro Habana',
      'Cerro',
      'Cotorro',
      'Diez de Octubre',
      'Guanabacoa',
      'La Habana Vieja',
      'La Habana del Este',
      'La Lisa',
      'Marianao',
      'Playa',
      'Plaza de la Revolución',
      'Regla',
      'San Miguel del Padrón',
    ],
    'CU-10': ['Amancio', 'Jesús Menéndez', 'Jobabo', 'Las Tunas', 'Majibacoa', 'Puerto Padre'],
    'CU-04': [
      'Calimete',
      'Ciénaga de Zapata',
      'Cárdenas',
      'Jagüey Grande',
      'Jovellanos',
      'Limonar',
      'Los Arabos',
      'Martí',
      'Matanzas',
      'Pedro Betancourt',
      'Perico',
      'Unión de Reyes',
    ],
    'CU-16': [
      'Batabanó',
      'Bejucal',
      'Güines',
      'Jaruco',
      'Madruga',
      'Melena del Sur',
      'Nueva Paz',
      'Quivicán',
      'San José de las Lajas',
      'Santa Cruz del Norte',
    ],
    'CU-01': [
      'Consolación del Sur',
      'Guane',
      'Los Palacios',
      'Mantua',
      'Minas de Matahambre',
      'Pinar del Río',
      'San Juan y Martínez',
      'Sandino',
      'Viñales',
    ],
    'CU-07': ['Cabaiguán', 'Fomento', 'Jatibonico', 'La Sierpe', 'Sancti Spíritus', 'Taguasco', 'Yaguajay'],
    'CU-13': [
      'Contramaestre',
      'Guamá',
      'Palma Soriano',
      'Santiago de Cuba',
      'Segundo Frente',
      'Songo-La Maya',
      'Tercer Frente',
    ],
    'CU-05': [
      'Caibarién',
      'Camajuaní',
      'Cifuentes',
      'Corralillo',
      'Encrucijada',
      'Manicaragua',
      'Placetas',
      'Quemado de Güines',
      'Ranchuelo',
      'Sagua la Grande',
      'San Juan de los Remedios',
    ],
  },
  ECU: {
    'EC-A': [
      'Camilo Ponce Enríquez',
      'Chordeleg',
      'Cordelec',
      'Cuenca',
      'El Pan',
      'Guachapala',
      'Gualaceo',
      'Nabón',
      'Oña',
      'Paute',
      'Sevilla de Oro',
      'Sig Sig',
    ],
    'EC-B': ['Caluma', 'Chillanes', 'Chimbo', 'Echeandía', 'Las Naves'],
    'EC-C': ['El Angel', 'Espejo', 'Mira', 'Montúfar', 'San  Gabriel', 'San Pedro de Huaca', 'Tulcán'],
    'EC-F': ['Azogues', 'Biblián', 'Cañar', 'Déleg', 'La Troncal', 'Suscal'],
    'EC-H': ['Alausí', 'Chambo', 'Chunchi', 'Colta', 'Cumandá', 'Guamote', 'Guano', 'Pallatanga', 'Penipe', 'Riobamba'],
    'EC-X': ['La Maná', 'Latacunga', 'Pangua', 'Pujilí', 'Salcedo', 'Saquislí', 'Sigchos'],
    'EC-O': [
      'Arenillas',
      'Atahualpa',
      'Chilla',
      'El Guabo',
      'Huaquillas',
      'Las Lajas',
      'Machala',
      'Marcabellí',
      'Paccha',
      'Pasaje',
      'Piñas',
      'Portovelo',
      'Zaruma',
    ],
    'EC-E': [
      'Atacames',
      'Eloy Alfaro',
      'La concordia',
      'Muisne',
      'Quinindé',
      'Rioverde',
      'Rosa Zárate',
      'Valdez (Limones)',
    ],
    'EC-W': ['Isabela', 'Puerto Ayora', 'Puerto Baquerizo', 'Puerto Villamil'],
    'EC-YQ': [
      'Bolivar (Sagrario)',
      'Carbo (Concepción)',
      'De Chongón',
      'Febres Cordero',
      'García Moreno',
      'Juan Gomez Rendon (Progreso)',
      'Letamendi',
      'Nueve de Octubre',
      'Olmedo (San Alejo)',
      'Pascuales',
      'Posorja',
      'Roca',
      'Rocafuerte',
      'Tenguel',
      'Urdaneta',
      'Ximena',
    ],
    'EC-G': [
      'A. Baquerizo Moreno',
      'Balao',
      'Balzar',
      'Colimes',
      'Daule',
      'Durán',
      'El Empalme',
      'Gral. Antonio Elizalde',
      'Guayaquil',
      'Isidro Ayora',
      'Lomas de Sargentillo',
      'Marcelino Maridueña',
      'Milagro',
      'Naranjal',
      'Naranjito',
      'Nobol',
      'Pedro Carbo',
      'Playas',
      'Samborondón',
      'Simón Bolívar',
      'Urbina Jado',
      'Yaguachi',
    ],
    'EC-I': ['Antonio Ante', 'Atuntaqui', 'Cotacachi', 'Ibarra', 'Otavalo', 'Pimampiro', 'San Miguel de Urcuquí'],
    'EC-L': [
      'Calvas',
      'Cariamanga',
      'Catacocha',
      'Catamayo',
      'Celica',
      'Chaguarpamba',
      'Espíndola',
      'Gonzanamá',
      'Loja',
      'Macará',
      'Olmedo',
      'Paltas',
      'Pindal',
      'Puyango',
      'Quilanga',
      'Saraguro',
      'Sozoranga',
      'Zapotillo',
    ],
    'EC-R': [
      'Baba',
      'Babahoyo',
      'Buena Fe',
      'Mocache',
      'Montalvo',
      'Palenque',
      'Quevedo',
      'Quinsaloma',
      'Ventanas',
      'Vinces',
    ],
    'EC-M': [
      '24 de mayo',
      'Bahía',
      'Chone',
      'Flavio Alfaro',
      'Jama',
      'Jaramijó',
      'Jipijapa',
      'Montecristi',
      'Paján',
      'Pedernales',
      'Pichincha',
      'Portoviejo',
      'Tosagua',
    ],
    'EC-S': [
      'Gualaquiza',
      'Huamboya',
      'Limón Indanza',
      'Logroño',
      'Macas',
      'Morona',
      'Pablo Sexto',
      'Palora',
      'San Juan Bosco',
      'Sucúa',
      'Taisha',
      'Tiwintza',
    ],
    'EC-N': ['Archidona', 'Baeza', 'Carlos Julio Arosemena Tola', 'El Chaco', 'Quijos'],
    'EC-D': ['Aguarico', 'Coca', 'La Joya de los Sachas', 'Machachi', 'Orellana'],
    'EC-Y': ['Arajuno', 'Mera', 'Pastaza', 'Puyo', 'Shell'],
    'EC-P': [
      'Cayambe',
      'Mejía',
      'Pedro Moncayo',
      'Pedro Vicente Maldonado',
      'Puerto Quito',
      'Quito',
      'Rumiñahui',
      'San Miguel de los Bancos',
    ],
    'EC-Q': [
      'Alangasi',
      'Amaguaña',
      'Atahualpa (Habaspamba)',
      'Belisario Quevedo',
      'Calacali',
      'Calderon (Carapungo)',
      'Carcelén',
      'Centro Histórico',
      'Chavezpamba',
      'Checa (Chilpa)',
      'Chilibulo',
      'Chillogallo',
      'Chimbacalle',
      'Cochapamba',
      'Comité del Pueblo',
      'Conocoto',
      'Cotocollao',
      'Cumbaya',
      'El Condado',
      'El Inca',
      'El Quinche',
      'Gualea',
      'Guamaní',
      'Guangopolo',
      'Guayllabamba',
      'Itchimbía',
      'Iñaquito',
      'La Argelia',
      'La Ecuatoriana',
      'La Ferroviaria',
      'La Libertad',
      'La Mena',
      'Llano Chico',
      'Lloa',
      'Mariscal Sucre',
      'Nanegal',
      'Nanegalito',
      'Nayon',
      'Nono',
      'Pacto',
      'Perucho',
      'Pifo',
      'Pintag',
      'Pomasqui',
      'Ponceano',
      'Puellaro',
      'Puembo',
      'Puengasí',
      'Quitumbe',
      'Rumipamba',
      'San Bartolo',
      'San Jose de Minas',
      'Solanda',
      'Tababela',
      'Tumbaco',
      'Turubamba',
      'Yaruqui',
      'Zambiza',
    ],
    'EC-SE': [],
    'EC-SD': ['La Concordia', 'La Villegas'],
    'EC-U': [
      'Cascales',
      'Cuyabeno',
      'Gonzalo Pizarro',
      'La Bonita',
      'Lago Agrío',
      'Lumbaqui',
      'Nueva Loja',
      'Putumayo',
      'Shushufindi',
      'Sucumbíos',
      'Tarapoa',
    ],
    'EC-T': ['Baños', 'Cevallos', 'Mocha', 'Patate', 'Quero', 'San Pedro de Pelileo', 'Santiago de Píllaro', 'Tisaleo'],
    'EC-Z': [
      'Centinela del Cóndor (Guayzimi)',
      'Chinchipe (Zumba)',
      'El Pangui',
      'Nangaritza (Guayzimi)',
      'Palanda',
      'Paquisha',
      'Yacuambi (28 de Mayo)',
      'Yantzaza',
      'Zamora',
    ],
  },
  SLV: {
    'SV-AH': [
      'Ahuachapán',
      'Apaneca',
      'Atiquizaya',
      'Concepción de Ataco',
      'El Refugio',
      'Guaymango',
      'Jujutla',
      'San Francisco Menéndez',
      'San Pedro Puxtla',
      'Tacuba',
      'Turín',
    ],
    'SV-CA': ['Cinquera', 'Guacotecti', 'Ilobasco', 'Jutiapa', 'Sensuntepeque', 'Tejutepeque'],
    'SV-CH': [
      'Agua Caliente',
      'Arcatao',
      'Azacualpa',
      'Cancasque',
      'Chalatenango',
      'Citalá',
      'Comalapa',
      'Concepción Quezaltepeque',
      'Dulce Nombre de María',
      'El Carrizal',
      'El Paraíso',
      'La Laguna',
      'Las Vueltas',
      'Nombre de Jesús',
      'Nueva Concepción',
      'Nueva Trinidad',
      'Ojos de Agua',
      'Potonico',
      'San Antonio Los Ranchos',
      'San Antonio de la Cruz',
      'San Francisco Lempa',
      'San Francisco Morazán',
      'San Isidro Labrador',
      'San Luis del Carmen',
      'San Miguel de Mercedes',
      'Tejutla',
    ],
    'SV-CU': [
      'Cojutepeque',
      'Monte San Juan',
      'Oratorio de Concepción',
      'San Bartolomé Perulapía',
      'San José Guayabal',
      'San Pedro Perulapán',
      'San Rafael Cedros',
      'Santa Cruz Analquito',
      'Santa Cruz Michapa',
      'Suchitoto',
      'Tenancingo',
    ],
    'SV-LI': [
      'Antiguo Cuscatlán',
      'Chiltiupán',
      'Ciudad Arce',
      'Comasagua',
      'Huizúcar',
      'Jayaque',
      'Jicalapa',
      'Nuevo Cuscatlán',
      'Quezaltepeque',
      'Sacacoyo',
      'San José Villanueva',
      'San Juan Opico',
      'San Pablo Tacachico',
      'Santa Tecla',
      'Talnique',
      'Tamanique',
      'Teotepeque',
      'Tepecoyo',
    ],
    'SV-PA': [
      'Cuyultitán',
      'Mercedes La Ceiba',
      'Olocuilta',
      'Paraíso de Osorio',
      'San Antonio Masahuat',
      'San Emigdio',
      'San Francisco Chinameca',
      'San Juan Nonualco',
      'San Juan Talpa',
      'San Juan Tepezontes',
      'San Luis La Herradura',
      'San Luis Talpa',
      'San Miguel Tepezontes',
      'San Pedro Masahuat',
      'San Pedro Nonualco',
      'San Rafael Obrajuelo',
      'Santa María Ostuma',
      'Santiago Nonualco',
      'Tapalhuaca',
      'Zacatecoluca',
    ],
    'SV-UN': [
      'Anamorós',
      'Concepción de Oriente',
      'Conchagua',
      'El Sauce',
      'Intipucá',
      'Lislique',
      'Meanguera del Golfo',
      'Nueva Esparta',
      'Pasaquina',
      'Polorós',
      'San Alejo',
      'Yayantique',
      'Yucuaiquín',
    ],
    'SV-MO': [
      'Arambala',
      'Cacaopera',
      'Chilanga',
      'Delicias de Concepción',
      'El Divisadero',
      'Gualococti',
      'Guatajiagua',
      'Joateca',
      'Jocoaitique',
      'Jocoro',
      'Lolotiquillo',
      'Meanguera',
      'Osicala',
      'Perquín',
      'San Francisco Gotera',
      'San Simón',
      'Sensembra',
      'Sociedad',
      'Torola',
      'Yamabal',
      'Yoloaiquín',
    ],
    'SV-SM': [
      'Chapeltique',
      'Chinameca',
      'Chirilagua',
      'Ciudad Barrios',
      'Comacarán',
      'El Tránsito',
      'Lolotique',
      'Moncagua',
      'Nueva Guadalupe',
      'Nuevo Edén de San Juan',
      'Quelepa',
      'San Gerardo',
      'San Jorge',
      'San Luis de la Reina',
      'San Rafael Oriente',
      'Sesori',
      'Uluazapa',
    ],
    'SV-SS': [
      'Apopa',
      'Ayutuxtepeque',
      'Cuscatancingo',
      'Delgado',
      'El Paisnal',
      'Guazapa',
      'Ilopango',
      'Mejicanos',
      'Nejapa',
      'Panchimalco',
      'Rosario de Mora',
      'Santiago Texacuangos',
      'Soyapango',
      'Tonacatepeque',
    ],
    'SV-SV': [
      'Apastepeque',
      'San Cayetano Istepeque',
      'San Esteban Catarina',
      'San Ildefonso',
      'Tecoluca',
      'Tepetitán',
      'Verapaz',
    ],
    'SV-SA': [
      'Candelaria de la Frontera',
      'Chalchuapa',
      'Coatepeque',
      'El Congo',
      'Masahuat',
      'Metapán',
      'San Antonio Pajonal',
      'San Sebastián Salitrillo',
      'Santa Rosa Guachipilín',
      'Santiago de la Frontera',
      'Texistepeque',
    ],
    'SV-SO': [
      'Acajutla',
      'Caluco',
      'Cuisnahuat',
      'Izalco',
      'Juayúa',
      'Nahuizalco',
      'Nahulingo',
      'Salcoatitán',
      'San Antonio del Monte',
      'Santa Catarina Masahuat',
      'Santa Isabel Ishuatán',
      'Santo Domingo de Guzmán',
      'Sonsonate',
      'Sonzacate',
    ],
    'SV-US': [
      'Alegría',
      'Berlín',
      'Concepción Batres',
      'Ereguayquín',
      'Estanzuelas',
      'Jiquilisco',
      'Jucuapa',
      'Jucuarán',
      'Mercedes Umaña',
      'Ozatlán',
      'Puerto El Triunfo',
      'San Buena Ventura',
      'San Dionisio',
      'San Francisco Javier',
      'Santiago de María',
      'Tecapán',
      'Usulután',
    ],
  },
  FRA: {
    'FR-PAC': [],
    'FR-BFC': [],
    'FR-01': ['Bourg-en-Bresse', 'Oyonnax'],
    'FR-02': ['Laon', 'Soissons'],
    'FR-03': ['Montluçon', 'Vichy'],
    'FR-04': ['Manosque'],
    'FR-05': ['Gap'],
    'FR-06': [
      'Antibes',
      'Cagnes-sur-Mer',
      'Cannes',
      'Grasse',
      'Le Cannet',
      'Mandelieu-la-Napoule',
      'Menton',
      'Nice',
      'Saint-Laurent-du-Var',
      'Vallauris',
    ],
    'FR-07': [],
    'FR-08': ['Charleville-Mézières'],
    'FR-09': [],
    'FR-10': ['Troyes'],
    'FR-11': ['Carcassonne', 'Narbonne'],
    'FR-12': ['Millau', 'Rodez'],
    'FR-13': [
      'Aix-en-Provence',
      'Arles',
      'Aubagne',
      'Istres',
      'La Ciotat',
      'Marignane',
      'Marseille',
      'Martigues',
      'Miramas',
      'Salon-de-Provence',
      'Vitrolles',
    ],
    'FR-14': ['Caen', 'Hérouville-Saint-Clair'],
    'FR-15': ['Aurillac'],
    'FR-16': ['Angoulême'],
    'FR-17': ['La Rochelle', 'Rochefort', 'Saintes'],
    'FR-18': ['Bourges', 'Vierzon'],
    'FR-19': ['Brive-la-Gaillarde'],
    'FR-21': ['Beaune', 'Dijon'],
    'FR-22': ['Saint-Brieuc'],
    'FR-23': [],
    'FR-24': ['Bergerac', 'Périgueux'],
    'FR-25': ['Besançon', 'Montbéliard'],
    'FR-26': ['Montélimar', 'Romans-sur-Isère', 'Valence'],
    'FR-27': ['Évreux'],
    'FR-28': ['Chartres', 'Dreux'],
    'FR-29': ['Brest', 'Quimper'],
    'FR-30': ['Alès', 'Nîmes'],
    'FR-31': ['Blagnac', 'Colomiers', 'Muret', 'Toulouse', 'Tournefeuille'],
    'FR-32': ['Auch'],
    'FR-33': [
      'Bordeaux',
      'Bègles',
      'Cenon',
      'Gradignan',
      'La Teste-de-Buch',
      'Le Bouscat',
      'Libourne',
      'Mérignac',
      'Pessac',
      'Saint-Médard-en-Jalles',
      'Talence',
      "Villenave-d'Ornon",
    ],
    'FR-34': ['Agde', 'Béziers', 'Frontignan', 'Lunel', 'Montpellier', 'Sète'],
    'FR-35': ['Rennes', 'Saint-Malo'],
    'FR-36': ['Châteauroux'],
    'FR-37': ['Joué-lès-Tours', 'Tours'],
    'FR-38': ['Bourgoin-Jallieu', 'Fontaine', 'Grenoble', "Saint-Martin-d'Hères", 'Vienne', 'Échirolles'],
    'FR-39': ['Dole'],
    'FR-40': ['Dax', 'Mont-de-Marsan'],
    'FR-41': ['Blois'],
    'FR-42': ['Roanne', 'Saint-Chamond', 'Saint-Étienne'],
    'FR-43': [],
    'FR-44': ['Orvault', 'Rezé', 'Saint-Herblain', 'Saint-Nazaire', 'Saint-Sébastien-sur-Loire', 'Vertou'],
    'FR-45': ['Fleury-les-Aubrais', 'Orléans'],
    'FR-46': [],
    'FR-47': ['Agen', 'Villeneuve-sur-Lot'],
    'FR-48': [],
    'FR-49': ['Angers', 'Cholet', 'Saumur'],
    'FR-50': ['Cherbourg-Octeville'],
    'FR-51': ['Châlons-en-Champagne', 'Reims', 'Épernay'],
    'FR-52': ['Chaumont', 'Saint-Dizier'],
    'FR-53': [],
    'FR-54': ['Nancy', 'Vandoeuvre-lès-Nancy'],
    'FR-55': [],
    'FR-56': ['Lanester', 'Lorient', 'Vannes'],
    'FR-57': ['Forbach', 'Metz', 'Montigny-lès-Metz', 'Sarreguemines', 'Thionville'],
    'FR-58': ['Nevers'],
    'FR-59': [
      'Armentières',
      'Coudekerque-Branche',
      'Croix',
      'Denain',
      'Douai',
      'Dunkirk',
      'Grande-Synthe',
      'Halluin',
      'Hazebrouck',
      'La Madeleine',
      'Lambersart',
      'Lille',
      'Loos',
      'Marcq-en-Barœul',
      'Maubeuge',
      'Mons-en-Barœul',
      'Roubaix',
      'Tourcoing',
      'Valenciennes',
      "Villeneuve-d'Ascq",
      'Wasquehal',
      'Wattrelos',
    ],
    'FR-60': ['Alençon', 'Beauvais', 'Compiègne', 'Creil'],
    'FR-61': [],
    'FR-62': [
      'Arras',
      'Boulogne-sur-Mer',
      'Bruay-la-Buissière',
      'Béthune',
      'Calais',
      'Hénin-Beaumont',
      'Lens',
      'Liévin',
    ],
    'FR-63': ['Clermont-Ferrand'],
    'FR-64': ['Anglet', 'Bayonne', 'Biarritz', 'Pau', 'Perpignan'],
    'FR-65': ['Tarbes'],
    'FR-66': [],
    'FR-67': ['Haguenau', 'Illkirch-Graffenstaden', 'Schiltigheim', 'Strasbourg'],
    'FR-68': ['Colmar', 'Mulhouse'],
    'FR-69': [
      'Bron',
      'Caluire-et-Cuire',
      'Décines-Charpieu',
      'Lyon',
      'Meyzieu',
      'Oullins',
      'Rillieux-la-Pape',
      'Saint-Genis-Laval',
      'Saint-Priest',
      'Sainte-Foy-lès-Lyon',
      'Vaulx-en-Velin',
      'Villefranche-sur-Saône',
      'Villeurbanne',
      'Vénissieux',
    ],
    'FR-70': [],
    'FR-71': ['Chalon-sur-Saône', 'Le Creusot', 'Mâcon'],
    'FR-72': ['Le Mans'],
    'FR-73': ['Aix-les-Bains', 'Chambéry'],
    'FR-74': ['Annecy', 'Annemasse', 'Thonon-les-Bains'],
    'FR-75': ['Paris'],
    'FR-76': [],
    'FR-77': [
      'Bussy-Saint-Georges',
      'Champs-sur-Marne',
      'Chelles',
      'Combs-la-Ville',
      'Dammarie-les-Lys',
      'Lagny-sur-Marne',
      'Le Grand-Quevilly',
      'Le Havre',
      'Le Mée-sur-Seine',
      'Le Petit-Quevilly',
      'Meaux',
      'Melun',
      'Pontault-Combault',
      'Roissy-en-Brie',
      'Rouen',
      'Saint-Étienne-du-Rouvray',
      'Savigny-le-Temple',
      'Sotteville-lès-Rouen',
      'Torcy',
      'Villeparisis',
    ],
    'FR-78': [
      'Chatou',
      'Conflans-Sainte-Honorine',
      'Guyancourt',
      'Houilles',
      'La Celle-Saint-Cloud',
      'Le Chesnay',
      'Les Mureaux',
      'Maisons-Laffitte',
      'Mantes-la-Jolie',
      'Montigny-le-Bretonneux',
      'Plaisir',
      'Poissy',
      'Rambouillet',
      'Saint-Germain-en-Laye',
      'Sartrouville',
      'Trappes',
      'Vélizy-Villacoublay',
      'Élancourt',
    ],
    'FR-79': ['Niort'],
    'FR-80': ['Abbeville', 'Amiens'],
    'FR-81': ['Albi', 'Castres'],
    'FR-82': ['Montauban'],
    'FR-83': [
      'Draguignan',
      'Fréjus',
      'Hyères',
      'La Garde',
      'La Seyne-sur-Mer',
      'La Valette-du-Var',
      'Saint-Raphaël',
      'Six-Fours-les-Plages',
      'Toulon',
    ],
    'FR-84': ['Avignon', 'Carpentras', 'Cavaillon', 'Orange'],
    'FR-85': ['La Roche-sur-Yon'],
    'FR-86': ['Châtellerault', 'Poitiers'],
    'FR-87': ['Limoges'],
    'FR-88': ['Saint-Dié-des-Vosges', 'Épinal'],
    'FR-89': ['Auxerre', 'Sens'],
    'FR-90': ['Belfort'],
    'FR-91': [
      'Athis-Mons',
      'Brunoy',
      'Brétigny-sur-Orge',
      'Corbeil-Essonnes',
      'Draveil',
      'Gif-sur-Yvette',
      'Grigny',
      'Les Ulis',
      'Longjumeau',
      'Massy',
      'Montgeron',
      'Morsang-sur-Orge',
      'Palaiseau',
      'Ris-Orangis',
      'Saint-Michel-sur-Orge',
      'Sainte-Geneviève-des-Bois',
      'Savigny-sur-Orge',
      'Vigneux-sur-Seine',
      'Viry-Châtillon',
      'Yerres',
      'Étampes',
      'Évry',
    ],
    'FR-92': [
      'Antony',
      'Asnières-sur-Seine',
      'Bagneux',
      'Bois-Colombes',
      'Boulogne-Billancourt',
      'Châtenay-Malabry',
      'Châtillon',
      'Clamart',
      'Clichy',
      'Colombes',
      'Courbevoie',
      'Fontenay-aux-Roses',
      'Gennevilliers',
      'Issy-les-Moulineaux',
      'La Garenne-Colombes',
      'Le Plessis-Robinson',
      'Levallois-Perret',
      'Meudon',
      'Montrouge',
      'Nanterre',
      'Neuilly-sur-Seine',
      'Puteaux',
      'Rueil-Malmaison',
      'Saint-Cloud',
      'Suresnes',
      'Sèvres',
      'Vanves',
      'Villeneuve-la-Garenne',
    ],
    'FR-93': [
      'Aubervilliers',
      'Aulnay-sous-Bois',
      'Bagnolet',
      'Bobigny',
      'Bondy',
      'Clichy-sous-Bois',
      'Drancy',
      'Gagny',
      'La Courneuve',
      'Le Blanc-Mesnil',
      'Les Lilas',
      'Les Pavillons-sous-Bois',
      'Livry-Gargan',
      'Montfermeil',
      'Montreuil',
      'Neuilly-Plaisance',
      'Neuilly-sur-Marne',
      'Noisy-le-Grand',
      'Noisy-le-Sec',
      'Pantin',
      'Pierrefitte-sur-Seine',
      'Romainville',
      'Rosny-sous-Bois',
      'Saint-Denis',
      'Saint-Ouen',
      'Sevran',
      'Stains',
      'Tremblay-en-France',
      'Villemomble',
      'Villepinte',
      'Épinay-sur-Seine',
    ],
    'FR-94': [
      'Alfortville',
      'Cachan',
      'Champigny-sur-Marne',
      'Charenton-le-Pont',
      'Choisy-le-Roi',
      'Créteil',
      'Fontenay-sous-Bois',
      'Fresnes',
      'Ivry-sur-Seine',
      "L'Haÿ-les-Roses",
      'Le Kremlin-Bicêtre',
      'Le Perreux-sur-Marne',
      'Maisons-Alfort',
      'Nogent-sur-Marne',
      'Orly',
      'Saint-Mandé',
      'Saint-Maur-des-Fossés',
      'Sucy-en-Brie',
      'Thiais',
      'Villejuif',
      'Villeneuve-Saint-Georges',
      'Villiers-sur-Marne',
      'Vincennes',
      'Vitry-sur-Seine',
    ],
    'FR-ARA': [],
    'FR-BL': [],
    'FR-BRE': [],
    'FR-COR': ['Ajaccio'],
    'FR-CVL': [],
    'FR-GES': [],
    'FR-GF': ['Cayenne', 'Kourou', 'Matoury', 'Saint-Laurent-du-Maroni'],
    'FR-HDF': [],
    'FR-IDF': [],
    'FR-NAQ': [],
    'FR-NOR': [],
    'FR-OCC': [],
    'FR-95': [
      'Argenteuil',
      'Bezons',
      'Cergy',
      'Cormeilles-en-Parisis',
      'Deuil-la-Barre',
      'Eaubonne',
      'Ermont',
      'Franconville',
      'Garges-lès-Gonesse',
      'Gonesse',
      'Goussainville',
      'Herblay',
      'Montmorency',
      'Pontoise',
      'Saint-Gratien',
      "Saint-Ouen-l'Aumône",
      'Sannois',
      'Sarcelles',
      'Taverny',
      'Villiers-le-Bel',
    ],
  },
  DEU: {
    'DE-NW': [
      'Aachen',
      'Ahlen',
      'Arnsberg',
      'Bad Salzuflen',
      'Bergheim',
      'Bergisch Gladbach',
      'Bielefeld',
      'Bocholt',
      'Bochum',
      'Bottrop',
      'Castrop-Rauxel',
      'Cologne',
      'Detmold',
      'Dinslaken',
      'Dormagen',
      'Dorsten',
      'Dortmund',
      'Duisburg',
      'Düren',
      'Düsseldorf',
      'Eschweiler',
      'Essen',
      'Euskirchen',
      'Frechen',
      'Gelsenkirchen',
      'Gladbeck',
      'Grevenbroich',
      'Gummersbach',
      'Gütersloh',
      'Hagen',
      'Hamm',
      'Hattingen',
      'Herford',
      'Herne',
      'Herten',
      'Hilden',
      'Hürth',
      'Ibbenbüren',
      'Iserlohn',
      'Kerpen',
      'Kleve',
      'Krefeld',
      'Langenfeld, Rhineland',
      'Leverkusen',
      'Lippstadt',
      'Lüdenscheid',
      'Lünen',
      'Marl',
      'Meerbusch',
      'Menden, Sauerland',
      'Minden',
      'Moers',
      'Mönchengladbach',
      'Mülheim an der Ruhr',
      'Münster',
      'Neuss',
      'Oberhausen',
      'Paderborn',
      'Pulheim',
      'Ratingen',
      'Recklinghausen',
      'Remscheid',
      'Rheine',
      'Sankt Augustin',
      'Siegen',
      'Solingen',
      'Stolberg, Rhineland',
      'Troisdorf',
      'Unna',
      'Velbert',
      'Viersen',
      'Wesel',
      'Willich',
      'Witten',
      'Wuppertal',
    ],
    'DE-BW': [
      'Aalen',
      'Achern',
      'Albstadt',
      'Backnang',
      'Baden-Baden',
      'Balingen',
      'Biberach an der Riss',
      'Bietigheim-Bissingen',
      'Bretten',
      'Bruchsal',
      'Böblingen',
      'Bühl',
      'Crailsheim',
      'Ehingen',
      'Emmendingen',
      'Esslingen am Neckar',
      'Ettlingen',
      'Fellbach',
      'Filderstadt',
      'Freiburg im Breisgau',
      'Friedrichshafen',
      'Gaggenau',
      'Geislingen an der Steige',
      'Göppingen',
      'Heidelberg',
      'Heidenheim an der Brenz',
      'Heilbronn',
      'Herrenberg',
      'Karlsruhe',
      'Kehl',
      'Kirchheim unter Teck',
      'Konstanz',
      'Kornwestheim',
      'Lahr/Schwarzwald',
      'Leimen',
      'Leinfelden-Echterdingen',
      'Leonberg',
      'Ludwigsburg',
      'Lörrach',
      'Mannheim',
      'Mühlacker',
      'Neckarsulm',
      'Nürtingen',
      'Offenburg',
      'Ostfildern',
      'Pforzheim',
      'Radolfzell am Bodensee',
      'Rastatt',
      'Ravensburg',
      'Remseck am Neckar',
      'Reutlingen',
      'Rheinfelden (Baden)',
      'Rottenburg am Neckar',
      'Rottweil',
      'Schorndorf',
      'Schwäbisch Gmünd',
      'Schwäbisch Hall',
      'Sindelfingen',
      'Singen (Hohentwiel)',
      'Sinsheim',
      'Stuttgart',
      'Tuttlingen',
      'Tübingen',
      'Ulm',
      'Vaihingen an der Enz',
      'Villingen-Schwenningen',
      'Waiblingen',
      'Wangen im Allgäu',
      'Weil am Rhein',
      'Weingarten, Württemberg',
      'Weinheim',
      'Weinstadt',
      'Wiesloch',
      'Winnenden',
    ],
    'DE-BY': [
      'Aichach',
      'Amberg',
      'Ansbach',
      'Aschaffenburg',
      'Augsburg',
      'Bad Kissingen',
      'Bamberg',
      'Bayreuth',
      'Coburg',
      'Dachau',
      'Deggendorf',
      'Erding',
      'Erlangen',
      'Forchheim',
      'Freising',
      'Friedberg',
      'Fürstenfeldbruck',
      'Fürth',
      'Garmisch-Partenkirchen',
      'Gauting',
      'Geretsried',
      'Germering',
      'Gersthofen',
      'Günzburg',
      'Haar',
      'Herzogenaurach',
      'Hof',
      'Ingolstadt',
      'Karlsfeld',
      'Kaufbeuren',
      'Kempten (Allgäu)',
      'Kitzingen',
      'Kulmbach',
      'Königsbrunn',
      'Landsberg am Lech',
      'Landshut',
      'Lauf an der Pegnitz',
      'Lichtenfels',
      'Lindau (Bodensee)',
      'Memmingen',
      'Munich',
      'Mühldorf am Inn',
      'Neu-Ulm',
      'Neuburg an der Donau',
      'Neufahrn bei Freising',
      'Neumarkt in der Oberpfalz',
      'Neusäß',
      'Nuremberg',
      'Nördlingen',
      'Olching',
      'Ottobrunn',
      'Passau',
      'Pfaffenhofen an der Ilm',
      'Puchheim',
      'Regensburg',
      'Rosenheim',
      'Roth',
      'Schwabach',
      'Schwandorf',
      'Schweinfurt',
      'Senden',
      'Sonthofen',
      'Starnberg',
      'Straubing',
      'Traunreut',
      'Traunstein',
      'Unterhaching',
      'Unterschleißheim',
      'Vaterstetten',
      'Waldkraiburg',
      'Weiden in der Oberpfalz',
      'Weilheim in Oberbayern',
      'Würzburg',
      'Zirndorf',
    ],
    'DE-BB': [
      'Bernau bei Berlin',
      'Blankenfelde-Mahlow',
      'Brandenburg an der Havel',
      'Cottbus',
      'Eberswalde',
      'Eisenhüttenstadt',
      'Falkensee',
      'Finsterwalde',
      'Forst (Lausitz)',
      'Frankfurt (Oder)',
      'Fürstenwalde',
      'Guben',
      'Hennigsdorf',
      'Hohen Neuendorf',
      'Hoppegarten',
      'Kleinmachnow',
      'Königs Wusterhausen',
      'Luckenwalde',
      'Ludwigsfelde',
      'Lübbenau',
      'Nauen',
      'Neuenhagen bei Berlin',
      'Neuruppin',
      'Oranienburg',
      'Panketal',
      'Petershagen-Eggersdorf',
      'Potsdam',
      'Prenzlau',
      'Rathenow',
      'Rüdersdorf bei Berlin',
      'Schwedt',
      'Senftenberg',
      'Spremberg',
      'Stahnsdorf',
      'Strausberg',
      'Teltow',
      'Templin',
      'Wandlitz',
      'Werder (Havel)',
      'Wittenberge',
      'Zossen',
    ],
    'DE-HB': ['Bremen', 'Bremerhaven'],
    'DE-HH': ['Hamburgo'],
    'DE-HE': [
      'Bad Hersfeld',
      'Bad Homburg vor der Höhe',
      'Bad Nauheim',
      'Bad Soden am Taunus',
      'Bad Vilbel',
      'Baunatal',
      'Bensheim',
      'Bruchköbel',
      'Butzbach',
      'Büdingen',
      'Darmstadt',
      'Dietzenbach',
      'Dillenburg',
      'Dreieich',
      'Eschborn',
      'Flörsheim am Main',
      'Frankfurt am Main',
      'Friedrichsdorf',
      'Fulda',
      'Gelnhausen',
      'Giessen',
      'Griesheim',
      'Groß-Gerau',
      'Groß-Umstadt',
      'Hanau',
      'Hattersheim am Main',
      'Heppenheim',
      'Herborn',
      'Hofheim am Taunus',
      'Idstein',
      'Karben',
      'Kassel',
      'Kelkheim (Taunus)',
      'Korbach',
      'Lampertheim',
      'Langen',
      'Limburg an der Lahn',
      'Maintal',
      'Marburg',
      'Mörfelden-Walldorf',
      'Mühlheim am Main',
      'Neu-Isenburg',
      'Nidderau',
      'Obertshausen',
      'Oberursel (Taunus)',
      'Offenbach am Main',
      'Pfungstadt',
      'Riedstadt',
      'Rodgau',
      'Rödermark',
      'Rüsselsheim am Main',
      'Seligenstadt',
      'Stadtallendorf',
      'Taunusstein',
      'Viernheim',
      'Weiterstadt',
      'Wetzlar',
      'Wiesbaden',
    ],
    'DE-NI': [
      'Achim',
      'Aurich',
      'Bad Zwischenahn',
      'Barsinghausen',
      'Bramsche',
      'Braunschweig',
      'Buchholz in der Nordheide',
      'Burgdorf',
      'Buxtehude',
      'Celle',
      'Cloppenburg',
      'Cuxhaven',
      'Delmenhorst',
      'Einbeck',
      'Emden',
      'Ganderkesee',
      'Garbsen',
      'Geestland',
      'Georgsmarienhütte',
      'Gifhorn',
      'Goslar',
      'Göttingen',
      'Hamelin',
      'Helmstedt',
      'Hildesheim',
      'Laatzen',
      'Langenhagen',
      'Leer (Ostfriesland)',
      'Lehrte',
      'Lingen (Ems)',
      'Lohne',
      'Lüneburg',
      'Melle',
      'Meppen',
      'Neustadt am Rübenberge',
      'Nienburg (Weser)',
      'Norden',
      'Nordenham',
      'Nordhorn',
      'Northeim',
      'Oldenburg',
      'Osnabrück',
      'Osterholz-Scharmbeck',
      'Papenburg',
      'Peine',
      'Rinteln',
      'Salzgitter',
      'Seelze',
      'Seevetal',
      'Springe',
      'Stade',
      'Stuhr',
      'Uelzen',
      'Vechta',
      'Verden an der Aller',
      'Wedemark',
      'Weyhe',
      'Wilhelmshaven',
      'Winsen (Luhe)',
      'Wolfenbüttel',
      'Wolfsburg',
      'Wunstorf',
    ],
    'DE-MV': [
      'Altentreptow',
      'Anklam',
      'Bad Doberan',
      'Bad Sülze',
      'Barth',
      'Bergen auf Rügen',
      'Boizenburg/Elbe',
      'Brüel',
      'Burg Stargard',
      'Bützow',
      'Crivitz',
      'Dargun',
      'Dassow',
      'Demmin',
      'Dömitz',
      'Eggesin',
      'Franzburg',
      'Friedland',
      'Gadebusch',
      'Garz/Rügen',
      'Gnoien',
      'Goldberg',
      'Grabow',
      'Greifswald',
      'Grevesmühlen',
      'Grimmen',
      'Güstrow',
      'Gützkow',
      'Hagenow',
      'Jarmen',
      'Klütz',
      'Krakow am See',
      'Kröpelin',
      'Kühlungsborn',
      'Laage',
      'Lassan',
      'Loitz',
      'Ludwigslust',
      'Lübtheen',
      'Lübz',
      'Malchin',
      'Malchow',
      'Marlow',
      'Mirow',
      'Neubrandenburg',
      'Neubukow',
      'Neukalen',
      'Neukloster',
      'Neustadt-Glewe',
      'Neustrelitz',
      'Parchim',
      'Pasewalk',
      'Penkun',
      'Penzlin',
      'Plau am See',
      'Putbus',
      'Rehna',
      'Rerik',
      'Ribnitz-Damgarten',
      'Richtenberg',
      'Rostock',
      'Röbel/Müritz',
      'Sassnitz',
      'Schwaan',
      'Schwerin (state capital)',
      'Schönberg',
      'Stavenhagen',
      'Sternberg',
      'Stralsund',
      'Strasburg (Uckermark)',
      'Tessin',
      'Teterow',
      'Torgelow',
      'Tribsees',
      'Ueckermünde',
      'Usedom',
      'Waren (Müritz)',
      'Warin',
      'Wesenberg',
      'Wismar',
      'Wittenburg',
      'Woldegk',
      'Wolgast',
      'Zarrentin am Schaalsee',
    ],
    'DE-RP': [
      'Alzey',
      'Andernach',
      'Bad Dürkheim',
      'Bad Kreuznach',
      'Bad Neuenahr-Ahrweiler',
      'Bendorf',
      'Betzdorf',
      'Bingen am Rhein',
      'Bitburg',
      'Bobenheim-Roxheim',
      'Boppard',
      'Böhl-Iggelheim',
      'Diez',
      'Frankenthal (Pfalz)',
      'Germersheim',
      'Grafschaft, Rhineland',
      'Grünstadt',
      'Herxheim bei Landau/Pfalz',
      'Idar-Oberstein',
      'Ingelheim am Rhein',
      'Kaiserslautern',
      'Koblenz',
      'Konz',
      'Lahnstein',
      'Landau in der Pfalz',
      'Limburgerhof',
      'Ludwigshafen am Rhein',
      'Mainz',
      'Mayen',
      'Montabaur',
      'Morbach',
      'Mutterstadt',
      'Mülheim-Kärlich',
      'Neustadt an der Weinstraße',
      'Neuwied',
      'Pirmasens',
      'Remagen',
      'Schifferstadt',
      'Sinzig',
      'Speyer',
      'Trier',
      'Wittlich',
      'Worms',
      'Wörth am Rhein',
      'Zweibrücken',
    ],
    'DE-SL': [
      'Annaberg-Buchholz',
      'Aue',
      'Auerbach (Vogtland)',
      'Bautzen',
      'Beckingen',
      'Bexbach',
      'Blieskastel',
      'Borna',
      'Chemnitz',
      'Coswig',
      'Crimmitschau',
      'Delitzsch',
      'Dillingen, Saarland',
      'Dresden',
      'Döbeln',
      'Eilenburg',
      'Eppelborn',
      'Freiberg',
      'Freital',
      'Friedrichsthal',
      'Glauchau',
      'Grimma',
      'Großenhain',
      'Görlitz',
      'Heidenau',
      'Heusweiler',
      'Homburg (Saar)',
      'Hoyerswerda',
      'Illingen',
      'Kirkel',
      'Kleinblittersdorf',
      'Lebach',
      'Leipzig',
      'Limbach-Oberfrohna',
      'Losheim am See',
      'Mandelbachtal',
      'Marienberg',
      'Markkleeberg',
      'Markranstädt',
      'Marpingen',
      'Meissen',
      'Merzig',
      'Mettlach',
      'Neunkirchen, Saarland',
      'Ottweiler',
      'Pirna',
      'Plauen',
      'Püttlingen',
      'Quierschied',
      'Radeberg',
      'Radebeul',
      'Rehlingen-Siersburg',
      'Reichenbach im Vogtland',
      'Riegelsberg',
      'Riesa',
      'Saarbrücken',
      'Saarlouis',
      'Saarwellingen',
      'Sankt Ingbert',
      'Sankt Wendel',
      'Schiffweiler',
      'Schkeuditz',
      'Schmelz',
      'Schwalbach, Saarland',
      'Schwarzenberg',
      'Spiesen-Elversberg',
      'Sulzbach/Saar',
      'Taucha',
      'Tholey',
      'Torgau',
      'Völklingen',
      'Wadern',
      'Wadgassen',
      'Weißwasser',
      'Werdau',
      'Wurzen',
      'Zittau',
      'Zwickau',
      'Überherrn',
    ],
    'DE-SN': [],
    'DE-ST': [
      'Aschersleben',
      'Bernburg',
      'Burg',
      'Dessau, desde 2007 Dessau-Roßlau',
      'Halberstadt',
      'Halle',
      'Köthen',
      'Lutherstadt Eisleben',
      'Lutherstadt Wittenberg',
      'Magdeburgo5',
      'Merseburg',
      'Naumburgo',
      'Quedlinburg',
      'Salzwedel',
      'Sangerhausen',
      'Schönebeck',
      'Staßfurt',
      'Stendal',
      'Weißenfels',
      'Wernigerode',
      'Wolfen, desde 2007 Bitterfeld-Wolfen',
      'Zeitz',
    ],
    'DE-SH': [
      'Ahrensburg',
      'Bad Oldesloe',
      'Bad Schwartau',
      'Bad Segeberg',
      'Bargteheide',
      'Eckernförde',
      'Elmshorn',
      'Eutin',
      'Flensburg',
      'Geesthacht',
      'Glinde',
      'Halstenbek',
      'Heide',
      'Henstedt-Ulzburg',
      'Husum',
      'Itzehoe',
      'Kaltenkirchen',
      'Kiel',
      'Lübeck',
      'Mölln',
      'Neumünster',
      'Neustadt in Holstein',
      'Norderstedt',
      'Pinneberg',
      'Preetz',
      'Quickborn',
      'Ratekau',
      'Reinbek',
      'Rendsburg',
      'Schenefeld',
      'Schleswig',
      'Schwarzenbek',
      'Stockelsdorf',
      'Uetersen',
      'Wedel',
    ],
    'DE-TH': [
      'Altenburg',
      'Apolda',
      'Arnstadt',
      'Bad Langensalza',
      'Bad Salzungen',
      'Eisenach',
      'Eisenberg',
      'Erfurt',
      'Gera',
      'Gotha',
      'Greiz',
      'Heilbad Heiligenstadt',
      'Hildburghausen',
      'Ilmenau',
      'Jena',
      'Leinefelde-Worbis',
      'Meiningen',
      'Meuselwitz',
      'Mühlhausen/Thüringen',
      'Nordhausen',
      'Pößneck',
      'Rudolstadt',
      'Saalfeld/Saale',
      'Schmalkalden',
      'Schmölln',
      'Sondershausen',
      'Sonneberg',
      'Suhl',
      'Sömmerda',
      'Waltershausen',
      'Weimar',
      'Zella-Mehlis',
      'Zeulenroda-Triebes',
    ],
  },
  GBR: {
    'GB-ENG': [
      'Barking and Dagenham',
      'Barnet',
      'Barnsley',
      'Bath and North East Somerset',
      'Bexley',
      'Birmingham',
      'Blackburn with Darwen',
      'Blackpool',
      'Bolton',
      'Bournemouth',
      'Bracknell Forest',
      'Brent',
      'Brighton and Hove',
      'Bristol',
      'Bromley',
      'Buckinghamshire',
      'Bury',
      'Calderdale',
      'Cambridgeshire',
      'Camden',
      'Central Bedfordshire',
      'Cheshire East',
      'Cheshire West and Chester',
      'Coventry',
      'Croydon',
      'Cumbria',
      'Derbyshire',
      'Doncaster',
      'Dorset',
      'Dudley',
      'Durham County',
      'Ealing',
      'East Riding of Yorkshire',
      'East Sussex',
      'Gateshead',
      'Gloucestershire',
      'Greenwich',
      'Hackney',
      'Halton',
      'Hammersmith and Fulham',
      'Haringey',
      'Hartlepool',
      'Havering',
      'Herefordshire',
      'Hertfordshire',
      'Hillingdon',
      'Hounslow',
      'Isle of Wight',
      'Isles of Scilly',
      'Islington',
      'Kensington and Chelsea',
      'Kingston upon Hull',
      'Kingston upon Thames',
      'Kirklees',
      'Lambeth',
      'Lancashire',
      'Leeds',
      'Leicester',
      'Leicestershire',
      'Lincolnshire',
      'Liverpool',
      'Luton',
      'Manchester',
      'Medway',
      'Middlesbrough',
      'Milton Keynes',
      'Newcastle upon Tyne',
      'North East Lincolnshire',
      'North Lincolnshire',
      'North Somerset',
      'North Tyneside',
      'North Yorkshire',
      'Northamptonshire',
      'Northumberland',
      'Nottingham',
      'Nottinghamshire',
      'Oldham',
      'Oxfordshire',
      'Plymouth',
      'Poole',
      'Portsmouth',
      'Reading',
      'Redbridge',
      'Redcar and Cleveland',
      'Richmond upon Thames',
      'Rochdale',
      'Rotherham',
      'Rutland',
      'Salford',
      'Sandwell',
      'Sefton',
      'Shropshire',
      'Slough',
      'Solihull',
      'South Gloucestershire',
      'South Tyneside',
      'Southampton',
      'Southend-on-Sea',
      'Southwark',
      'St. Helens',
      'Staffordshire',
      'Stockton-on-Tees',
      'Stoke-on-Trent',
      'Suffolk',
      'Sunderland',
      'Swindon',
      'Tameside',
      'Telford and Wrekin',
      'Thurrock',
      'Tower Hamlets',
      'Trafford',
      'Wakefield',
      'Walsall',
      'Waltham Forest',
      'Wandsworth',
      'Warrington',
      'Warwickshire',
      'West Berkshire',
      'West Sussex',
      'Westminster',
      'Wigan',
      'Windsor and Maidenhead',
      'Wirral',
      'Wokingham',
      'Wolverhampton',
      'Worcestershire',
    ],
    'GB-NIR': [
      'Antrim and Newtownabbey',
      'Ards and North Down',
      'Armagh, Banbridge and Craigavon',
      'Causeway Coast and Glens',
      'Derry and Strabane',
      'Fermanagh and Omagh',
      'Lisburn and Castlereagh',
      'Mid Ulster',
      'Mid and East Antrim',
      'Newry, Mourne and Down',
    ],
    'GB-SCT': [
      'Aberdeenshire',
      'Angus',
      'Argyll and Bute',
      'Clackmannanshire',
      'Dumfries and Galloway',
      'Dundee',
      'East Ayrshire',
      'East Dunbartonshire',
      'East Lothian',
      'East Renfrewshire',
      'Edinburgh',
      'Eilean Siar',
      'Falkirk',
      'Fife',
      'Glasgow',
      'Highland',
      'Inverclyde',
      'Midlothian',
      'North Ayrshire',
      'North Lanarkshire',
      'Orkney Islands',
      'Perth and Kinross',
      'Renfrewshire',
      'Shetland Islands',
      'South Ayrshire',
      'South Lanarkshire',
      'The Scottish Borders',
      'West Dunbartonshire',
      'West Lothian',
    ],
    'GB-WLS': [
      'Blaenau Gwent',
      'Bridgend',
      'Caerphilly',
      'Cardiff',
      'Carmarthenshire',
      'Ceredigion',
      'Conwy',
      'Denbighshire',
      'Flintshire',
      'Gwynedd',
      'Isle of Anglesey',
      'Merthyr Tydfil',
      'Monmouthshire',
      'Neath Port Talbot',
      'Newport',
      'Pembrokeshire',
      'Powys',
      'Rhondda, Cynon, Taff',
      'The Vale of Glamorgan',
      'Torfaen',
      'Wrexham',
    ],
  },
  GTM: {
    'GT-AV': [
      'Chahal',
      'Chisec',
      'Cobán',
      'Fray Bartolomé de las Casas',
      'Lanquín',
      'Panzós',
      'Raxruhá',
      'San Cristóbal Verapaz',
      'San Juan Chamelco',
      'San Miguel Tucurú',
      'San Pedro Carchá',
      'Santa Catalina La Tinta',
      'Santa Cruz Verapaz',
      'Santa María Cahabón',
      'Senahú',
      'Tactíc',
      'Tamahú',
    ],
    'GT-BV': ['Cubulco', 'Granados', 'Purulhá', 'Rabinal', 'Salamá', 'San Miguel Chicaj', 'Santa Cruz El Chol'],
    'GT-CM': [
      'Acatenango',
      'Chimaltenango',
      'El Tejar',
      'Parramos',
      'Patzicía',
      'Patzún',
      'Pochuta',
      'San Andrés Itzapa',
      'San José Poaquíl',
      'San Juan Comalapa',
      'San Martín Jilotepeque',
      'Santa Apolonia',
      'Santa Cruz Balanyá',
      'Tecpán Guatemala',
      'Yepocapa',
    ],
    'GT-CQ': [
      'Camotán',
      'Chiquimula',
      'Concepción Las Minas',
      'Esquipulas',
      'Ipala',
      'Jocotán',
      'Olopa',
      'San José La Arada',
      'San Juan Ermita',
    ],
    'GT-PR': [
      'El Jícaro',
      'Guastatoya',
      'Morazán',
      'San Agustín Acasaguastlán',
      'San Antonio La Paz',
      'San Cristóbal Acasaguastlán',
      'Sanarate',
      'Sansare',
    ],
    'GT-ES': [
      'Escuintla',
      'Guanagazapa',
      'Iztapa',
      'La Democracia',
      'La Gomera',
      'Masagua',
      'Palín',
      'San Vicente Pacaya',
      'Santa Lucía Cotzumalguapa',
      'Siquinalá',
      'Tiquisate',
    ],
    'GT-GU': [
      'Amatitlán',
      'Chinautla',
      'Chuarrancho',
      'Ciudad Guatemala',
      'Fraijanes',
      'Mixco',
      'Palencia',
      'San José Pinula',
      'San José del Golfo',
      'San Juan Sacatepéquez',
      'San Miguel Petapa',
      'San Pedro Ayampuc',
      'San Pedro Sacatepéquez',
      'San Raimundo',
      'Santa Catarina Pinula',
      'Villa Canales',
      'Villa Nueva',
    ],
    'GT-HU': [
      'Aguacatán',
      'Chiantla',
      'Colotenango',
      'Concepción Huista',
      'Cuilco',
      'Huehuetenango',
      'Ixtahuacán',
      'Jacaltenango',
      'Malacatancito',
      'Nentón',
      'San Antonio Huista',
      'San Gaspar Ixchil',
      'San Juan Atitán',
      'San Juan Ixcoy',
      'San Mateo Ixtatán',
      'San Miguel Acatán',
      'San Pedro Necta',
      'San Pedro Soloma',
      'San Rafael La Independencia',
      'San Rafael Pétzal',
      'San Sebastián Coatán',
      'San Sebastián Huehuetenango',
      'Santa Ana Huista',
      'Santa Cruz Barillas',
      'Santa Eulalia',
      'Santiago Chimaltenango',
      'Tectitán',
      'Todos Santos Cuchumatán',
      'Unión Cantinil',
    ],
    'GT-IZ': ['El Estor', 'Livingstón', 'Los Amates', 'Puerto Barrios'],
    'GT-JA': [
      'Jalapa',
      'Mataquescuintla',
      'Monjas',
      'San Carlos Alzatate',
      'San Luis Jilotepeque',
      'San Manuel Chaparrón',
      'San Pedro Pinula',
    ],
    'GT-JU': [
      'Agua Blanca',
      'Asunción Mita',
      'Atescatempa',
      'Comapa',
      'Conguaco',
      'El Adelanto',
      'El Progreso',
      'Jalpatagua',
      'Jeréz',
      'Moyuta',
      'Pasaco',
      'Quesada',
      'San José Acatempa',
      'Santa Catarina Mita',
      'Yupiltepeque',
      'Zapotitlán',
    ],
    'GT-PE': ['Melchor de Mencos', 'Poptún', 'Sayaxché'],
    'GT-QZ': [
      'Almolonga',
      'Cabricán',
      'Cajolá',
      'Cantél',
      'Colomba',
      'Concepción Chiquirichapa',
      'El Palmar',
      'Flores Costa Cuca',
      'Huitán',
      'Olintepeque',
      'Palestina de Los Altos',
      'Quetzaltenango',
      'Salcajá',
      'San Carlos Sija',
      'San Francisco La Unión',
      'San Juan Ostuncalco',
      'San Martín Sacatepéquez',
      'San Miguel Sigüilá',
      'Sibilia',
      'Zuníl',
    ],
    'GT-QC': [
      'Canillá',
      'Chajul',
      'Chicamán',
      'Chichicastenango',
      'Chiché',
      'Chinique',
      'Cunén',
      'Ixcán',
      'Joyabaj',
      'Pachalúm',
      'Patzité',
      'Sacapulas',
      'San Andrés Sajcabajá',
      'San Antonio Ilotenango',
      'San Bartolomé Jocotenango',
      'San Juan Cotzal',
      'San Pedro Jocopilas',
      'Santa Cruz del Quiché',
      'Santa María Nebaj',
      'Uspantán',
      'Zacualpa',
    ],
    'GT-RE': [
      'Champerico',
      'El Asintal',
      'Nuevo San Carlos',
      'Retalhuleu',
      'San Andrés Villa Seca',
      'San Martín Zapotitlán',
      'Santa Cruz Muluá',
    ],
    'GT-SA': [
      'Alotenango',
      'Antigua Guatemala',
      'Ciudad Vieja',
      'Jocotenango',
      'Magdalena Milpas Altas',
      'Pastores',
      'San Antonio Aguas Calientes',
      'San Bartolomé Milpas Altas',
      'San Lucas Sacatepéquez',
      'San Miguel Dueñas',
      'Santa Catarina Barahona',
      'Santa Lucía Milpas Altas',
      'Santa María de Jesús',
      'Santiago Sacatepéquez',
      'Santo Domingo Xenacoj',
      'Sumpango',
    ],
    'GT-SM': [
      'Ayutla Tecún Umán',
      'Comitancillo',
      'Concepción Tutuapa',
      'El Quetzal',
      'El Rodeo',
      'El Tumbador',
      'Esquipulas Palo Gordo',
      'Ixchiguán',
      'La Reforma',
      'Malacatán',
      'Nuevo Progreso',
      'Ocós',
      'Pajapita',
      'Río Blanco',
      'San Antonio Sacatepéquez',
      'San Cristóbal Cucho',
      'San José Ojetenam',
      'San Miguel Ixtahuacán',
      'San Rafaél Pie de La Cuesta',
      'Sibinal',
      'Sipacapa',
      'Tacaná',
      'Tajumulco',
    ],
    'GT-SR': [
      'Barberena',
      'Casillas',
      'Chiquimulilla',
      'Cuilapa',
      'Guazacapán',
      'Nueva Santa Rosa',
      'Oratorio',
      'Pueblo Nuevo Viñas',
      'San Juan Tecuaco',
      'San Rafaél Las Flores',
      'Santa Cruz Naranjo',
      'Santa María Ixhuatán',
      'Taxisco',
    ],
    'GT-SO': [
      'Nahualá',
      'Panajachel',
      'San Andrés Semetabaj',
      'San Antonio Palopó',
      'San José Chacayá',
      'San Juan La Laguna',
      'San Lucas Tolimán',
      'San Marcos La Laguna',
      'San Pablo La Laguna',
      'San Pedro La Laguna',
      'Santa Catarina Ixtahuacán',
      'Santa Catarina Palopó',
      'Santa Clara La Laguna',
      'Santa Cruz La Laguna',
      'Santa Lucía Utatlán',
      'Santa María Visitación',
      'Santiago Atitlán',
      'Sololá',
    ],
    'GT-SU': [
      'Chicacao',
      'Cuyotenango',
      'Mazatenango',
      'Patulul',
      'Pueblo Nuevo (Suchitepéquez)',
      'Río Bravo',
      'Samayac',
      'San Antonio Suchitepéquez',
      'San Bernardino',
      'San Francisco Zapotitlán',
      'San Gabriel',
      'San José El Ídolo',
      'San Juan Bautista',
      'San Miguel Panán',
      'San Pablo Jocopilas',
      'Santo Domingo Suchitepéquez',
      'Santo Tomás La Unión',
      'Zunilito',
    ],
    'GT-TO': [
      'Momostenango',
      'San Andrés Xecul',
      'San Cristóbal Totonicapán',
      'San Francisco El Alto',
      'Santa Lucía La Reforma',
      'Santa María Chiquimula',
      'Totonicapán',
    ],
    'GT-ZA': ['Cabañas', 'Estanzuela', 'Gualán', 'Huité', 'Río Hondo', 'Teculután', 'Usumatlán', 'Zacapa'],
  },
  HND: {
    'HN-AT': ['Esparta', 'La Ceiba', 'La Masica', 'Tela'],
    'HN-CH': [
      'Apacilagua',
      'Choluteca',
      'Concepción de Maria',
      'Duyure',
      'El Corpus',
      'Marcovia',
      'Morolica',
      'Namasigue',
      'Orocuina',
      'Pespire',
      'San Antonio de Flores',
      'San Marcos de Colón',
      'Santa Ana de Yusguare',
    ],
    'HN-CL': ['Balfate', 'Bonito Oriental', 'Iriona', 'Limón', 'Sabá', 'Santa Rosa de Aguán', 'Sonaguera', 'Tocoa'],
    'HN-CM': [
      'Ajuterique',
      'Comayagua',
      'Esquías',
      'Humuya',
      'La Trinidad',
      'Lamaní',
      'Lejamaní',
      'Meámbar',
      'Minas de Oro',
      'San José de Comayagua',
      'San José del Potrero',
      'Siguatepeque',
      'Taulabé',
      'Villa de San Antonio',
    ],
    'HN-CP': [
      'Copán Ruinas',
      'Corquín',
      'Cucuyagua',
      'Dulce Nombre',
      'La Jigua',
      'Nueva Arcadia',
      'San Juan de Opoa',
      'San Pedro de Copán',
      'Santa Rosa de Copán',
      'Trinidad de Copán',
      'Veracruz',
    ],
    'HN-CR': [
      'Choloma',
      'La Lima',
      'Omoa',
      'Pimienta',
      'Potrerillos',
      'Puerto Cortés',
      'San Antonio de Cortés',
      'San Francisco de Yojoa',
      'San Manuel',
      'San Pedro Sula',
      'Santa Cruz de Yojoa',
    ],
    'HN-EP': [
      'Alauca',
      'Danlí',
      'Güinope',
      'Jacaleapa',
      'Liure',
      'Morocelí',
      'Oropolí',
      'Teupasenti',
      'Texiguat',
      'Trojes',
      'Vado Ancho',
      'Yauyupe',
      'Yuscarán',
    ],
    'HN-FM': [
      'Alubarén',
      'Cedros',
      'Curarén',
      'Distrito Central',
      'Guaimaca',
      'La Venta',
      'Lepaterique',
      'Maraita',
      'Marale',
      'Nueva Armenia',
      'Ojojona',
      'Orica',
      'Reitoca',
      'San Antonio de Oriente',
      'San Juan de Flores',
      'San Miguelito',
      'Talanga',
      'Tatumbla',
      'Valle de Ángeles',
      'Vallecillo',
      'Villa de San Francisco',
    ],
    'HN-GD': ['Ahuas', 'Brus Laguna', 'Juan Francisco Bulnes', 'Puerto Lempira', 'Villeda Morales', 'Wampusirpi'],
    'HN-IN': [
      'Camasca',
      'Colomoncagua',
      'Intibucá',
      'Jesús de Otoro',
      'Masaguara',
      'San Francisco de Opalaca',
      'San Marcos de La Sierra',
      'Yamaranguila',
    ],
    'HN-IB': ['Guanaja', 'José Santos Guardiola', 'Roatán', 'Utila'],
    'HN-LP': [
      'Aguanqueterique',
      'Cane',
      'Chinacla',
      'Guajiquiro',
      'Lauterique',
      'Marcala',
      'Mercedes de Oriente',
      'Opatoro',
      'San Antonio del Norte',
      'San Pedro de Tutule',
      'Santiago de Puringla',
      'Yarula',
    ],
    'HN-LE': [
      'Cololaca',
      'Erandique',
      'Gracias',
      'Gualcince',
      'La Campa',
      'La Iguala',
      'La Virtud',
      'Lepaera',
      'Mapulaca',
      'Piraera',
      'San Juan Guarita',
      'San Manuel Colohete',
      'San Marcos de Caiquín',
      'Talgua',
      'Tambla',
      'Tomalá',
      'Valladolid',
    ],
    'HN-OC': [
      'Belén Gualcho',
      'Dolores Merendón',
      'Fraternidad',
      'La Encarnación',
      'La Labor',
      'Lucerna',
      'Ocotepeque',
      'San Francisco del Valle',
      'Sensenti',
      'Sinuapa',
    ],
    'HN-OL': [
      'Catacamas',
      'Dulce Nombre de Culmí',
      'Esquipulas del Norte',
      'Gualaco',
      'Guarizama',
      'Guata',
      'Guayape',
      'Jano',
      'Juticalpa',
      'Mangulile',
      'Manto',
      'Patuca',
      'San Francisco de Becerra',
      'San Francisco de La Paz',
      'Santa María del Real',
      'Silca',
      'Yocón',
    ],
    'HN-SB': [
      'Arada',
      'Atima',
      'Ceguaca',
      'Chinda',
      'Concepción del Norte',
      'Concepción del Sur',
      'El Níspero',
      'Gualala',
      'Ilama',
      'Macuelizo',
      'Nueva Frontera',
      'Nuevo Celilac',
      'Petoa',
      'Protección',
      'Quimistán',
      'San Francisco de Ojuera',
      'San José de Colinas',
      'San Pedro Zacapa',
      'San Vicente Centenario',
    ],
    'HN-VA': ['Amapala', 'Aramecina', 'Caridad', 'Goascorán', 'Langue', 'Nacaome', 'San Francisco de Coray'],
    'HN-YO': ['El Negrito', 'Jocón', 'Olanchito', 'Sulaco', 'Yorito', 'Yoro'],
  },
  HKG: {
    'HK-HK': [
      'Central & Western',
      'Eastern',
      'Islands',
      'Kowloon City',
      'Kwai Tsing',
      'Kwun Tong',
      'North',
      'Sai Kung',
      'Sha Tin',
      'Sham Shui Po',
      'Southern',
      'Tai Po',
      'Tsuen Wan',
      'Tuen Mun',
      'Wan Chai',
      'Wong Tai Sin',
      'Yau Tsim Mong',
      'Yuen Long',
    ],
  },
  IND: {
    'IN-AP': [
      'Adoni',
      'Amalapuram',
      'Anakapalle',
      'Anantapur',
      'Bapatla',
      'Bheemunipatnam',
      'Bhimavaram',
      'Bobbili',
      'Chilakaluripet',
      'Chirala',
      'Chittoor',
      'Dharmavaram',
      'Eluru',
      'Gooty',
      'Gudivada',
      'Gudur',
      'Guntakal',
      'Guntur',
      'Hindupur',
      'Jaggaiahpet',
      'Jammalamadugu',
      'Kadapa',
      'Kadiri',
      'Kakinada',
      'Kandukur',
      'Kavali',
      'Kovvur',
      'Kurnool',
      'Macherla',
      'Machilipatnam',
      'Madanapalle',
      'Mandapeta',
      'Markapur',
      'Nagari',
      'Naidupet',
      'Nandyal',
      'Narasapuram',
      'Narasaraopet',
      'Narsipatnam',
      'Nellore',
      'Nidadavole',
      'Nuzvid',
      'Ongole',
      'Palacole',
      'Palasa Kasibugga',
      'Parvathipuram',
      'Pedana',
      'Peddapuram',
      'Pithapuram',
      'Ponnur',
      'Proddatur',
      'Punganur',
      'Puttur',
      'Rajahmundry',
      'Rajam',
      'Rajampet',
      'Ramachandrapuram',
      'Rayachoti',
      'Rayadurg',
      'Renigunta',
      'Repalle',
      'Salur',
      'Samalkot',
      'Sattenapalle',
      'Srikakulam',
      'Srikalahasti',
      'Srisailam Project (Right Flank Colony) Township',
      'Sullurpeta',
      'Tadepalligudem',
      'Tadpatri',
      'Tanuku',
      'Tenali',
      'Tirupati',
      'Tiruvuru',
      'Tuni',
      'Uravakonda',
      'Venkatagiri',
      'Vijayawada',
      'Vinukonda',
      'Visakhapatnam',
      'Vizianagaram',
      'Yemmiganur',
      'Yerraguntla',
    ],
    'IN-AR': ['Naharlagun', 'Pasighat'],
    'IN-AS': [
      'Barpeta',
      'Bongaigaon City',
      'Dhubri',
      'Dibrugarh',
      'Diphu',
      'Goalpara',
      'Guwahati',
      'Jorhat',
      'Karimganj',
      'Lanka',
      'Lumding',
      'Mangaldoi',
      'Mankachar',
      'Margherita',
      'Mariani',
      'Marigaon',
      'Nagaon',
      'Nalbari',
      'North Lakhimpur',
      'Rangia',
      'Sibsagar',
      'Silapathar',
      'Silchar',
      'Tezpur',
      'Tinsukia',
    ],
    'IN-BR': [
      'Araria',
      'Arrah',
      'Arwal',
      'Asarganj',
      'Aurangabad',
      'Bagaha',
      'Barh',
      'Begusarai',
      'Bettiah',
      'Bhabua',
      'Bhagalpur',
      'Buxar',
      'Darbhanga',
      'Dehri-on-Sone',
      'Dumraon',
      'Forbesganj',
      'Gaya',
      'Gopalganj',
      'Hajipur',
      'Jamalpur',
      'Jamui',
      'Jehanabad',
      'Katihar',
      'Kishanganj',
      'Lakhisarai',
      'Lalganj',
      'Madhepura',
      'Madhubani',
      'Maharajganj',
      'Mahnar Bazar',
      'Makhdumpur',
      'Maner',
      'Manihari',
      'Marhaura',
      'Masaurhi',
      'Mirganj',
      'Mokameh',
      'Motihari',
      'Motipur',
      'Munger',
      'Murliganj',
      'Muzaffarpur',
      'Narkatiaganj',
      'Naugachhia',
      'Nawada',
      'Nokha',
      'Patna',
      'Purnia',
      'Rafiganj',
      'Rajgir',
      'Ramnagar',
      'Raxaul Bazar',
      'Revelganj',
      'Rosera',
      'Saharsa',
      'Samastipur',
      'Sasaram',
      'Sheikhpura',
      'Sheohar',
      'Sherghati',
      'Silao',
      'Sitamarhi',
      'Siwan',
      'Sonepur',
      'Sugauli',
      'Sultanganj',
      'Supaul',
      'Warisaliganj',
    ],
    'IN-CH': ['Chandigarh'],
    'IN-CT': [
      'Ambikapur',
      'Bhatapara',
      'Bhilai Nagar',
      'Bilaspur',
      'Chirmiri',
      'Dalli-Rajhara',
      'Dhamtari',
      'Durg',
      'Jagdalpur',
      'Korba',
      'Mahasamund',
      'Manendragarh',
      'Mungeli',
      'Naila Janjgir',
      'Raigarh',
      'Raipur',
      'Rajnandgaon',
      'Sakti',
      'Tilda Newra',
    ],
    'IN-DN': ['Silvassa'],
    'IN-DL': ['Delhi', 'New Delhi'],
    'IN-GA': ['Mapusa', 'Margao', 'Marmagao', 'Panaji'],
    'IN-GJ': [
      'Adalaj',
      'Ahmedabad',
      'Amreli',
      'Anand',
      'Anjar',
      'Ankleshwar',
      'Bharuch',
      'Bhavnagar',
      'Bhuj',
      'Chhapra',
      'Deesa',
      'Dhoraji',
      'Godhra',
      'Jamnagar',
      'Kadi',
      'Kapadvanj',
      'Keshod',
      'Khambhat',
      'Lathi',
      'Limbdi',
      'Lunawada',
      'Mahemdabad',
      'Mahesana',
      'Mahuva',
      'Manavadar',
      'Mandvi',
      'Mangrol',
      'Mansa',
      'Modasa',
      'Morvi',
      'Nadiad',
      'Navsari',
      'Padra',
      'Palanpur',
      'Palitana',
      'Pardi',
      'Patan',
      'Petlad',
      'Porbandar',
      'Radhanpur',
      'Rajkot',
      'Rajpipla',
      'Rajula',
      'Ranavav',
      'Rapar',
      'Salaya',
      'Sanand',
      'Savarkundla',
      'Sidhpur',
      'Sihor',
      'Songadh',
      'Talaja',
      'Thangadh',
      'Tharad',
      'Umbergaon',
      'Umreth',
      'Unjha',
      'Upleta',
      'Vadnagar',
      'Vadodara',
      'Valsad',
      'Vapi',
      'Veraval',
      'Vijapur',
      'Viramgam',
      'Visnagar',
      'Vyara',
      'Wadhwan',
      'Wankaner',
    ],
    'IN-HR': [
      'Bahadurgarh',
      'Bhiwani',
      'Charkhi Dadri',
      'Faridabad',
      'Fatehabad',
      'Gohana',
      'Gurgaon',
      'Hansi',
      'Hisar',
      'Jind',
      'Kaithal',
      'Karnal',
      'Ladwa',
      'Mahendragarh',
      'Mandi Dabwali',
      'Narnaul',
      'Narwana',
      'Palwal',
      'Panchkula',
      'Panipat',
      'Pehowa',
      'Pinjore',
      'Rania',
      'Ratia',
      'Rewari',
      'Rohtak',
      'Safidon',
      'Samalkha',
      'Sarsod',
      'Shahbad',
      'Sirsa',
      'Sohna',
      'Sonipat',
      'Taraori',
      'Thanesar',
      'Tohana',
      'Yamunanagar',
    ],
    'IN-HP': ['Mandi', 'Nahan', 'Shimla', 'Solan', 'Sundarnagar'],
    'IN-AN': ['Port Blair'],
    'IN-JK': ['Anantnag', 'Baramula', 'Jammu', 'Kathua', 'Punch', 'Rajauri', 'Sopore', 'Srinagar', 'Udhampur'],
    'IN-JH': [
      'Adityapur',
      'Bokaro Steel City',
      'Chaibasa',
      'Chatra',
      'Chirkunda',
      'Deoghar',
      'Dhanbad',
      'Dumka',
      'Giridih',
      'Gumia',
      'Hazaribag',
      'Jamshedpur',
      'Jhumri Tilaiya',
      'Lohardaga',
      'Madhupur',
      'Medininagar (Daltonganj)',
      'Mihijam',
      'Musabani',
      'Pakaur',
      'Patratu',
      'Phusro',
      'Ramgarh',
      'Ranchi',
      'Sahibganj',
      'Saunda',
      'Simdega',
      'Tenu dam-cum-Kathhara',
    ],
    'IN-KA': [
      'Adyar',
      'Afzalpur',
      'Arsikere',
      'Athni',
      'Ballari',
      'Belagavi',
      'Bengaluru',
      'Chikkamagaluru',
      'Davanagere',
      'Gokak',
      'Hubli-Dharwad',
      'Karwar',
      'Kolar',
      'Lakshmeshwar',
      'Lingsugur',
      'Maddur',
      'Madhugiri',
      'Madikeri',
      'Magadi',
      'Mahalingapura',
      'Malavalli',
      'Malur',
      'Mandya',
      'Mangaluru',
      'Manvi',
      'Mudabidri',
      'Mudalagi',
      'Muddebihal',
      'Mudhol',
      'Mulbagal',
      'Mundargi',
      'Nanjangud',
      'Nargund',
      'Navalgund',
      'Nelamangala',
      'Pavagada',
      'Piriyapatna',
      'Raayachuru',
      'Rabkavi Banhatti',
      'Ramanagaram',
      'Ramdurg',
      'Ranebennuru',
      'Ranibennur',
      'Robertson Pet',
      'Ron',
      'Sadalagi',
      'Sagara',
      'Sakaleshapura',
      'Sanduru',
      'Sankeshwara',
      'Saundatti-Yellamma',
      'Savanur',
      'Sedam',
      'Shahabad',
      'Shahpur',
      'Shiggaon',
      'Shikaripur',
      'Shivamogga',
      'Shrirangapattana',
      'Sidlaghatta',
      'Sindagi',
      'Sindhagi',
      'Sindhnur',
      'Sira',
      'Sirsi',
      'Siruguppa',
      'Srinivaspur',
      'Surapura',
      'Talikota',
      'Tarikere',
      'Tekkalakote',
      'Terdal',
      'Tiptur',
      'Tumkur',
      'Udupi',
      'Vijayapura',
      'Wadi',
      'Yadgir',
    ],
    'IN-KL': [
      'Adoor',
      'Alappuzha',
      'Attingal',
      'Chalakudy',
      'Changanassery',
      'Cherthala',
      'Chittur-Thathamangalam',
      'Guruvayoor',
      'Kanhangad',
      'Kannur',
      'Kasaragod',
      'Kayamkulam',
      'Kochi',
      'Kodungallur',
      'Kollam',
      'Kottayam',
      'Koyilandy',
      'Kozhikode',
      'Kunnamkulam',
      'Malappuram',
      'Mattannur',
      'Mavelikkara',
      'Mavoor',
      'Muvattupuzha',
      'Nedumangad',
      'Neyyattinkara',
      'Nilambur',
      'Ottappalam',
      'Palai',
      'Palakkad',
      'Panamattom',
      'Panniyannur',
      'Pappinisseri',
      'Paravoor',
      'Pathanamthitta',
      'Peringathur',
      'Perinthalmanna',
      'Perumbavoor',
      'Ponnani',
      'Punalur',
      'Puthuppally',
      'Shoranur',
      'Taliparamba',
      'Thiruvalla',
      'Thiruvananthapuram',
      'Thodupuzha',
      'Thrissur',
      'Tirur',
      'Vaikom',
      'Varkala',
      'Vatakara',
    ],
    'IN-MP': [
      'Alirajpur',
      'Ashok Nagar',
      'Balaghat',
      'Bhopal',
      'Ganjbasoda',
      'Gwalior',
      'Indore',
      'Itarsi',
      'Jabalpur',
      'Lahar',
      'Maharajpur',
      'Mahidpur',
      'Maihar',
      'Malaj Khand',
      'Manasa',
      'Manawar',
      'Mandideep',
      'Mandla',
      'Mandsaur',
      'Mauganj',
      'Mhow Cantonment',
      'Mhowgaon',
      'Morena',
      'Multai',
      'Mundi',
      'Murwara',
      'Nagda',
      'Nainpur',
      'Narsinghgarh',
      'Neemuch',
      'Nepanagar',
      'Niwari',
      'Nowgong',
      'Nowrozabad (Khodargama)',
      'Pachore',
      'Pali',
      'Panagar',
      'Pandhurna',
      'Panna',
      'Pasan',
      'Pipariya',
      'Pithampur',
      'Porsa',
      'Prithvipur',
      'Raghogarh-Vijaypur',
      'Rahatgarh',
      'Raisen',
      'Rajgarh',
      'Ratlam',
      'Rau',
      'Rehli',
      'Rewa',
      'Sabalgarh',
      'Sagar',
      'Sanawad',
      'Sarangpur',
      'Sarni',
      'Satna',
      'Sausar',
      'Sehore',
      'Sendhwa',
      'Seoni',
      'Seoni-Malwa',
      'Shahdol',
      'Shajapur',
      'Shamgarh',
      'Sheopur',
      'Shivpuri',
      'Shujalpur',
      'Sidhi',
      'Sihora',
      'Singrauli',
      'Sironj',
      'Sohagpur',
      'Tarana',
      'Tikamgarh',
      'Ujjain',
      'Umaria',
      'Vidisha',
      'Vijaypur',
      'Wara Seoni',
    ],
    'IN-MH': [
      'Achalpur',
      'Ahmednagar',
      'Akola',
      'Akot',
      'Amalner',
      'Ambejogai',
      'Amravati',
      'Anjangaon',
      'Arvi',
      'Bhiwandi',
      'Dhule',
      'Greater Mumbai',
      'Ichalkaranji',
      'Kalyan-Dombivali',
      'Karjat',
      'Latur',
      'Loha',
      'Lonar',
      'Lonavla',
      'Mahad',
      'Malegaon',
      'Malkapur',
      'Mangalvedhe',
      'Mangrulpir',
      'Manjlegaon',
      'Manmad',
      'Manwath',
      'Mehkar',
      'Mhaswad',
      'Mira-Bhayandar',
      'Morshi',
      'Mukhed',
      'Mul',
      'Murtijapur',
      'Nagpur',
      'Nanded-Waghala',
      'Nandgaon',
      'Nandura',
      'Nandurbar',
      'Narkhed',
      'Nashik',
      'Navi Mumbai',
      'Nawapur',
      'Nilanga',
      'Osmanabad',
      'Ozar',
      'Pachora',
      'Paithan',
      'Palghar',
      'Pandharkaoda',
      'Pandharpur',
      'Panvel',
      'Parbhani',
      'Parli',
      'Partur',
      'Pathardi',
      'Pathri',
      'Patur',
      'Pauni',
      'Pen',
      'Phaltan',
      'Pulgaon',
      'Pune',
      'Purna',
      'Pusad',
      'Rahuri',
      'Rajura',
      'Ramtek',
      'Ratnagiri',
      'Raver',
      'Risod',
      'Sailu',
      'Sangamner',
      'Sangli',
      'Sangole',
      'Sasvad',
      'Satana',
      'Satara',
      'Savner',
      'Sawantwadi',
      'Shahade',
      'Shegaon',
      'Shendurjana',
      'Shirdi',
      'Shirpur-Warwade',
      'Shirur',
      'Shrigonda',
      'Shrirampur',
      'Sillod',
      'Sinnar',
      'Solapur',
      'Soyagaon',
      'Talegaon Dabhade',
      'Talode',
      'Tasgaon',
      'Thane',
      'Tirora',
      'Tuljapur',
      'Tumsar',
      'Uchgaon',
      'Udgir',
      'Umarga',
      'Umarkhed',
      'Umred',
      'Uran',
      'Uran Islampur',
      'Vadgaon Kasba',
      'Vaijapur',
      'Vasai-Virar',
      'Vita',
      'Wadgaon Road',
      'Wai',
      'Wani',
      'Wardha',
      'Warora',
      'Warud',
      'Washim',
      'Yavatmal',
      'Yawal',
      'Yevla',
    ],
    'IN-MN': ['Imphal', 'Lilong', 'Mayang Imphal', 'Thoubal'],
    'IN-ML': ['Nongstoin', 'Shillong', 'Tura'],
    'IN-MZ': ['Aizawl', 'Lunglei', 'Saiha'],
    'IN-NL': ['Dimapur', 'Kohima', 'Mokokchung', 'Tuensang', 'Wokha', 'Zunheboto'],
    'IN-OR': [
      'Balangir',
      'Baleshwar Town',
      'Barbil',
      'Bargarh',
      'Baripada Town',
      'Bhadrak',
      'Bhawanipatna',
      'Bhubaneswar',
      'Brahmapur',
      'Byasanagar',
      'Cuttack',
      'Dhenkanal',
      'Jatani',
      'Jharsuguda',
      'Kendrapara',
      'Kendujhar',
      'Malkangiri',
      'Nabarangapur',
      'Paradip',
      'Parlakhemundi',
      'Pattamundai',
      'Phulabani',
      'Puri',
      'Rairangpur',
      'Rajagangapur',
      'Raurkela',
      'Rayagada',
      'Sambalpur',
      'Soro',
      'Sunabeda',
      'Sundargarh',
      'Talcher',
      'Tarbha',
      'Titlagarh',
    ],
    'IN-PY': ['Karaikal', 'Mahe', 'Pondicherry', 'Yanam'],
    'IN-PB': [
      'Amritsar',
      'Barnala',
      'Batala',
      'Bathinda',
      'Dhuri',
      'Faridkot',
      'Fazilka',
      'Firozpur',
      'Firozpur Cantt',
      'Gobindgarh',
      'Gurdaspur',
      'Hoshiarpur',
      'Jagraon',
      'Jalandhar',
      'Jalandhar Cantt.',
      'Kapurthala',
      'Khanna',
      'Kharar',
      'Kot Kapura',
      'Longowal',
      'Ludhiana',
      'Malerkotla',
      'Malout',
      'Moga',
      'Mohali',
      'Morinda',
      'Mukerian',
      'Muktsar',
      'Nabha',
      'Nakodar',
      'Nangal',
      'Nawanshahr',
      'Pathankot',
      'Patiala',
      'Patti',
      'Pattran',
      'Phagwara',
      'Phillaur',
      'Qadian',
      'Raikot',
      'Rajpura',
      'Rampura Phul',
      'Rupnagar',
      'Samana',
      'Sangrur',
      'Sirhind Fatehgarh Sahib',
      'Sujanpur',
      'Sunam',
      'Talwara',
      'Tarn Taran',
      'Urmar Tanda',
      'Zira',
      'Zirakpur',
    ],
    'IN-RJ': [
      'Ajmer',
      'Alwar',
      'Bhilwara',
      'Bikaner',
      'Jaipur',
      'Jodhpur',
      'Lachhmangarh',
      'Ladnu',
      'Lakheri',
      'Lalsot',
      'Losal',
      'Makrana',
      'Malpura',
      'Mandalgarh',
      'Mandawa',
      'Merta City',
      'Mount Abu',
      'Nadbai',
      'Nagar',
      'Nagaur',
      'Nasirabad',
      'Nathdwara',
      'Neem-Ka-Thana',
      'Nimbahera',
      'Nohar',
      'Phalodi',
      'Phulera',
      'Pilani',
      'Pilibanga',
      'Pindwara',
      'Pipar City',
      'Prantij',
      'Pratapgarh',
      'Raisinghnagar',
      'Rajakhera',
      'Rajaldesar',
      'Rajgarh (Alwar)',
      'Rajgarh (Churu)',
      'Rajsamand',
      'Ramganj Mandi',
      'Ramngarh',
      'Ratangarh',
      'Rawatbhata',
      'Rawatsar',
      'Reengus',
      'Sadri',
      'Sadulpur',
      'Sadulshahar',
      'Sagwara',
      'Sambhar',
      'Sanchore',
      'Sangaria',
      'Sardarshahar',
      'Sawai Madhopur',
      'Shahpura',
      'Sheoganj',
      'Sikar',
      'Sirohi',
      'Sojat',
      'Sri Madhopur',
      'Sujangarh',
      'Sumerpur',
      'Suratgarh',
      'Taranagar',
      'Todabhim',
      'Todaraisingh',
      'Tonk',
      'Udaipur',
      'Udaipurwati',
    ],
    'IN-TN': [
      'Arakkonam',
      'Aruppukkottai',
      'Chennai',
      'Coimbatore',
      'Erode',
      'Gobichettipalayam',
      'Kancheepuram',
      'Karur',
      'Lalgudi',
      'Madurai',
      'Manachanallur',
      'Nagapattinam',
      'Nagercoil',
      'Namagiripettai',
      'Namakkal',
      'Nandivaram-Guduvancheri',
      'Nanjikottai',
      'Natham',
      'Nellikuppam',
      'Neyveli (TS)',
      'O Valley',
      'Oddanchatram',
      'P.N.Patti',
      'Pacode',
      'Padmanabhapuram',
      'Palani',
      'Palladam',
      'Pallapatti',
      'Pallikonda',
      'Panagudi',
      'Panruti',
      'Paramakudi',
      'Parangipettai',
      'Pattukkottai',
      'Perambalur',
      'Peravurani',
      'Periyakulam',
      'Periyasemur',
      'Pernampattu',
      'Pollachi',
      'Polur',
      'Ponneri',
      'Pudukkottai',
      'Pudupattinam',
      'Puliyankudi',
      'Punjaipugalur',
      'Rajapalayam',
      'Ramanathapuram',
      'Rameshwaram',
      'Ranipet',
      'Rasipuram',
      'Salem',
      'Sankarankoil',
      'Sankari',
      'Sathyamangalam',
      'Sattur',
      'Shenkottai',
      'Sholavandan',
      'Sholingur',
      'Sirkali',
      'Sivaganga',
      'Sivagiri',
      'Sivakasi',
      'Srivilliputhur',
      'Surandai',
      'Suriyampalayam',
      'Tenkasi',
      'Thammampatti',
      'Thanjavur',
      'Tharamangalam',
      'Tharangambadi',
      'Theni Allinagaram',
      'Thirumangalam',
      'Thirupuvanam',
      'Thiruthuraipoondi',
      'Thiruvallur',
      'Thiruvarur',
      'Thuraiyur',
      'Tindivanam',
      'Tiruchendur',
      'Tiruchengode',
      'Tiruchirappalli',
      'Tirukalukundram',
      'Tirukkoyilur',
      'Tirunelveli',
      'Tirupathur',
      'Tiruppur',
      'Tiruttani',
      'Tiruvannamalai',
      'Tiruvethipuram',
      'Tittakudi',
      'Udhagamandalam',
      'Udumalaipettai',
      'Unnamalaikadai',
      'Usilampatti',
      'Uthamapalayam',
      'Uthiramerur',
      'Vadakkuvalliyur',
      'Vadalur',
      'Vadipatti',
      'Valparai',
      'Vandavasi',
      'Vaniyambadi',
      'Vedaranyam',
      'Vellakoil',
      'Vellore',
      'Vikramasingapuram',
      'Viluppuram',
      'Virudhachalam',
      'Virudhunagar',
      'Viswanatham',
    ],
    'IN-TG': [
      'Adilabad',
      'Bellampalle',
      'Bhadrachalam',
      'Bhainsa',
      'Bhongir',
      'Bodhan',
      'Farooqnagar',
      'Gadwal',
      'Hyderabad',
      'Jagtial',
      'Jangaon',
      'Kagaznagar',
      'Kamareddy',
      'Karimnagar',
      'Khammam',
      'Koratla',
      'Kothagudem',
      'Kyathampalle',
      'Mahbubnagar',
      'Mancherial',
      'Mandamarri',
      'Manuguru',
      'Medak',
      'Miryalaguda',
      'Nagarkurnool',
      'Narayanpet',
      'Nirmal',
      'Nizamabad',
      'Palwancha',
      'Ramagundam',
      'Sadasivpet',
      'Sangareddy',
      'Siddipet',
      'Sircilla',
      'Suryapet',
      'Tandur',
      'Vikarabad',
      'Wanaparthy',
      'Warangal',
      'Yellandu',
    ],
    'IN-TR': ['Agartala', 'Belonia', 'Dharmanagar', 'Kailasahar', 'Khowai'],
    'IN-UP': [
      'Achhnera',
      'Agra',
      'Aligarh',
      'Allahabad',
      'Amroha',
      'Azamgarh',
      'Bahraich',
      'Chandausi',
      'Etawah',
      'Fatehpur Sikri',
      'Firozabad',
      'Hapur',
      'Jhansi',
      'Kalpi',
      'Kanpur',
      'Khair',
      'Laharpur',
      'Lakhimpur',
      'Lal Gopalganj Nindaura',
      'Lalitpur',
      'Lar',
      'Loni',
      'Lucknow',
      'Mathura',
      'Meerut',
      'Modinagar',
      'Moradabad',
      'Nagina',
      'Najibabad',
      'Nakur',
      'Nanpara',
      'Naraura',
      'Naugawan Sadat',
      'Nautanwa',
      'Nawabganj',
      'Nehtaur',
      'Niwai',
      'Noida',
      'Noorpur',
      'Obra',
      'Orai',
      'Padrauna',
      'Palia Kalan',
      'Parasi',
      'Phulpur',
      'Pihani',
      'Pilibhit',
      'Pilkhuwa',
      'Powayan',
      'Pukhrayan',
      'Puranpur',
      'Purquazi',
      'Purwa',
      'Rae Bareli',
      'Rampur',
      'Rampur Maniharan',
      'Rasra',
      'Rath',
      'Renukoot',
      'Reoti',
      'Robertsganj',
      'Rudauli',
      'Rudrapur',
      'Sadabad',
      'Safipur',
      'Saharanpur',
      'Sahaspur',
      'Sahaswan',
      'Sahawar',
      'Sahjanwa',
      'Saidpur',
      'Sambhal',
      'Samdhan',
      'Samthar',
      'Sandi',
      'Sandila',
      'Sardhana',
      'Seohara',
      'Shahabad (Hardoi)',
      'Shahabad (Rampur)',
      'Shahganj',
      'Shahjahanpur',
      'Shamli',
      'Shamsabad (Agra)',
      'Shamsabad (Farrukhabad)',
      'Sherkot',
      'Shikohabad',
      'Shishgarh',
      'Siana',
      'Sikanderpur',
      'Sikandra Rao',
      'Sikandrabad',
      'Sirsaganj',
      'Sitapur',
      'Soron',
      'Suar',
      'Sultanpur',
      'Tanda',
      'Thakurdwara',
      'Thana Bhawan',
      'Tilhar',
      'Tirwaganj',
      'Tulsipur',
      'Tundla',
      'Ujhani',
      'Unnao',
      'Utraula',
      'Varanasi',
      'Vrindavan',
      'Warhapur',
      'Zaidpur',
      'Zamania',
    ],
    'IN-UT': [
      'Bageshwar',
      'Dehradun',
      'Haldwani',
      'Hardwar',
      'Kashipur',
      'Manglaur',
      'Mussoorie',
      'Nagla',
      'Nainital',
      'Pauri',
      'Pithoragarh',
      'Rishikesh',
      'Roorkee',
      'Sitarganj',
      'Tehri',
    ],
    'IN-WB': [
      'Adra',
      'Alipurduar',
      'Arambagh',
      'Asansol',
      'Baharampur',
      'Bankura',
      'Darjiling',
      'English Bazar',
      'Habra',
      'Hugli-Chinsurah',
      'Jalpaiguri',
      'Jhargram',
      'Kharagpur',
      'Kolkata',
      'Mainaguri',
      'Malda',
      'Mathabhanga',
      'Medinipur',
      'Memari',
      'Monoharpur',
      'Murshidabad',
      'Nabadwip',
      'Naihati',
      'Panchla',
      'Pandua',
      'Paschim Punropara',
      'Purulia',
      'Raghunathganj',
      'Raghunathpur',
      'Raiganj',
      'Rampurhat',
      'Ranaghat',
      'Sainthia',
      'Santipur',
      'Siliguri',
      'Sonamukhi',
      'Srirampore',
      'Suri',
      'Taki',
      'Tamluk',
      'Tarakeswar',
    ],
  },
  ITA: {
    'IT-AG': [
      'Agrigento',
      'Alessandria Roc.',
      'Aragona',
      'Bivona',
      'Burgio',
      'Calamonaci',
      'Caltabellotta',
      'Camastra',
      'Cammarata',
      'Campobello di Lic.',
      'Canicattì',
      'Casteltermini',
      'Castrofilippo',
      'Cattolica Er.',
      'Cianciana',
      'Comitini',
      'Favara',
      'Grotte',
      'Joppolo Gian.',
      'Lampedusa',
      'Licata',
      'Linosa',
      'Lucca Sicula',
      'Menfi',
      'Montallegro',
      'Montaperto',
      'Montevaso',
      'Naro',
      'Palma di Montechiaro',
      'Pelagie',
      'Porto Empedocle',
      'Racalmuto',
      'Raffadali',
      'Ravanusa',
      'Realmonte',
      'Ribera',
      'Sambuca di Sicilia',
      'San Biagio Platani',
      'San Giovanni Gemini',
      "Sant'Angelo Muxaro",
      'Santa Elisabetta',
      'Santo Stefano Quisquina',
      'Sciacca',
      'Siculiana',
      'Sta. Margher. Belice',
      'Villafranca Sicula',
    ],
    'IT-AL': [
      'Acqui Terme',
      'Albera Ligure',
      'Alessandria',
      'Alfiano Natta',
      'Alice bel Colle',
      'Alluvioni Cambió',
      'Altavilla Monferrato',
      'Alzano Scrivia',
      'Arquata Scrivia',
      'Avolasca',
      'Balzola',
      'Basaluzzo',
      'Bassignana',
      'Belforte Monferrato',
      'Bergamasco',
      'Berzano di Tortona',
      'Bistagno',
      'Borghetto di Borbera',
      'Borgo San Martino',
      'Borgoratto Alessandrino',
      'Bosco Marengo',
      'Bosio',
      'Bozzole',
      'Brignano Frascata',
      'Cabella Ligure',
      'Camagna Monferrato',
      'Camino',
      'Cantalupo Ligure',
      "Capriata d' Orba",
      'Carbonara Scrivia',
      'Carentino',
      'Carezzano',
      'Carpeneto',
      'Carrega Ligure',
      'Carrosio',
      'Cartosio',
      'Casal Cermelli',
      'Casale Monferrato',
      'Casaleggio Boiro',
      'Casalnoceto',
      'Casasco',
      'Cassano Spinola',
      'Cassine',
      'Cassinelle',
      'Castellania',
      'Castellar Guidobono',
      'Castellazzo Bormida',
      'Castelletto Merli',
      'Castelletto Monferrato',
      "Castelletto d' Erro",
      "Castelletto d' Orba",
      'Castelnuovo Bormida',
      'Castelnuovo Scrivia',
      'Castelspina',
      'Cavatore',
      'Cella Monte',
      'Cereseto',
      'Cerreto Grue',
      'Cerrina Monferrato',
      'Coniolo',
      'Conzano',
      'Costa Vescovato',
      'Cremolino',
      'Cuccaro Monferrato',
      'Denice',
      'Dernice',
      'Fabbrica Curone',
      'Felizzano',
      'Fraconalto',
      'Francavilla Bisio',
      'Frascaro',
      'Frassinello Monferrato',
      'Frassineto Po',
      'Fresonara',
      'Frugarolo',
      'Fubine',
      'Gabiano',
      'Gamalero',
      'Garbagna',
      'Gavazzana',
      'Gavi',
      'Giarole',
      'Gremiasco',
      'Grognardo',
      'Grondona',
      'Guazzora',
      "Isola Sant' Antonio",
      'Lerma',
      'Lu',
      'Malvicino',
      'Masio',
      'Melazzo',
      'Merana',
      'Mirabello Monferrato',
      'Molare',
      'Molino dei Torti',
      'Mombello Monferrato',
      'Momperone',
      'Moncestino',
      'Mongiardino Ligure',
      'Monleale',
      'Montacuto',
      'Montaldeo',
      'Montaldo Bormida',
      'Montecastello',
      "Montechiaro d' Acqui",
      'Montegioco',
      'Montemarzino',
      'Morano sul Po',
      'Morbello',
      'Mornese',
      'Morsasco',
      'Murisengo',
      'Novi Ligure',
      'Occimiano',
      'Odalengo Grande',
      'Odalengo Piccolo',
      'Olivola',
      'Orsara Bormida',
      'Ottiglio',
      'Ovada',
      'Oviglio',
      'Ozzano Monferrato',
      'Paderna',
      'Pareto',
      'Parodi Ligure',
      'Pasturana',
      'Pecetto di Valenza',
      'Pietra Marazzi',
      'Piovera',
      'Pomaro Monferrato',
      'Pontecurone',
      'Pontestura',
      'Ponti',
      'Ponzano Monferrato',
      'Ponzone',
      'Pozzol Groppo',
      'Pozzolo Formigaro',
      'Prasco',
      'Predosa',
      'Quargnento',
      'Quattordio',
      'Ricaldone',
      'Rivalta Bormida',
      'Rivarone',
      'Rocca Grimalda',
      'Roccaforte Ligure',
      'Rocchetta Ligure',
      'Rosignano Monferrato',
      'Sala Monferrato',
      'San Cristoforo',
      'San Giorgio Monferrato',
      'San Salvatore Monferrato',
      'San Sebastiano Curone',
      "Sant' Agata Fossili",
      'Sardigliano',
      'Sarezzano',
      'Serralunga di Crea',
      'Serravalle Scrivia',
      'Sezzadio',
      "Silvano d' Orba",
      'Solero',
      'Solonghello',
      'Spigno Monferrato',
      'Spineto Scrivia',
      'Stazzano',
      'Strevi',
      'Tagliolo Monferrato',
      'Tassarolo',
      'Terruggia',
      'Terzo',
      'Ticineto',
      'Tortona',
      'Treville',
      'Trisobbio',
      'Valenza',
      'Valmacca',
      'Vignale Monferrato',
      'Vignole Borbera',
      'Viguzzolo',
      'Villadeati',
      'Villalvernia',
      'Villamiroglio',
      'Villanova Monferrato',
      'Villaromagnano',
      'Visone',
      'Volpedo',
      'Volpeglino',
      'Voltaggio',
    ],
    'IT-AN': [
      'Agugliano',
      'Ancona',
      'Arcevia',
      'Barbara',
      'Belvedere Ostrense',
      'Camerano',
      'Camerata Picena',
      'Castel Colonna',
      'Castelbellino',
      'Castelfidardo',
      'Castelleone di Suasa',
      'Castelplanio',
      "Cerreto d' Esi",
      'Chiaravalle',
      'Corinaldo',
      'Cupramontana',
      'Fabriano',
      'Falconara Marittima',
      'Filottrano',
      'Genga',
      'Jesi',
      'Maiolati Spontini',
      'Mergo',
      'Monsano',
      'Monte Roberto',
      'Monte San Vito',
      'Montecarotto',
      'Montemarciano',
      'Monterado',
      "Morro d' Alba",
      'Numana',
      'Offagna',
      'Osimo',
      'Ostra',
      'Ostra Vetere',
      'Poggio San Marcello',
      'Polverigi',
      'Porto Recanati',
      'Portonovo',
      'Recanati',
      'Ripe',
      'Rosora',
      'San Marcello',
      'San Paolo di Jesi',
      'Santa Maria Nuova',
      'Sassoferrato',
      'Senigallia',
      'Serra San Quirico',
      "Serra de' Conti",
      'Sirolo',
      'Staffolo',
      'Trecastelli',
    ],
    'IT-AO': [
      'Allein',
      "Antey Saint Andre'",
      'Aosta',
      'Arnad',
      'Arvier',
      'Avise',
      'Ayas',
      'Aymavilles',
      'Bard',
      'Bionaz',
      'Brissogne',
      'Brusson',
      'Challand Saint Anselme',
      'Challand Saint Victor',
      'Chambave',
      'Chamois',
      'Champdepraz',
      'Champorcher',
      'Charvensod',
      'Chatillon',
      'Cogne',
      'Courmayeur',
      'Donnas',
      'Doues',
      'Emarese',
      'Etroubles',
      'Fenis',
      'Fontainemore',
      'Gaby',
      'Gignod',
      'Gressan',
      "Gressoney La Trinite'",
      'Gressoney Saint Jean',
      'Hone',
      'Introd',
      'Issime',
      'Issogne',
      'Jovencan',
      'La Magdeleine',
      'La Salle',
      'La Thuile',
      'Lillianes',
      'Montjovet',
      'Morgex',
      'Nus',
      'Ollomont',
      'Oyace',
      'Perloz',
      'Pollein',
      'Pont Saint Martin',
      'Pontboset',
      'Pontey',
      "Pre' Saint Didier",
      'Quart',
      'Rhemes Notre Dame',
      'Rhemes Saint Georges',
      'Roisan',
      'Saint Christophe',
      'Saint Denis',
      'Saint Marcel',
      'Saint Nicolas',
      'Saint Oyen',
      'Saint Pierre',
      'Saint Rhemy',
      'Saint Vincent',
      'Sarre',
      'Torgnon',
      'Valgrisenche',
      'Valpelline',
      'Valsavarenche',
      'Valtournenche',
      'Verrayes',
      'Verres',
      'Villeneuve',
    ],
    'IT-AR': [
      'Anghiari',
      'Arezzo',
      'Badia Tebalda',
      'Bibbiena',
      'Bucine',
      'Capolona',
      'Caprese Michelangelo',
      'Castel Focognano',
      'Castel San Niccoló',
      'Castelfranco di Sopra',
      'Castiglion Fibocchi',
      'Castiglion Fiorentino',
      'Cavriglia',
      'Chitignano',
      'Chiusi della Verna',
      'Civitella in Val di Chiana',
      'Cortona',
      'Foiano della Chiana',
      'Laterina',
      'Loro Ciuffenna',
      'Lucignano',
      'Marciano della Chiana',
      'Monte San Savino',
      'Montemignaio',
      'Monterchi',
      'Montevarchi',
      'Ortignano Raggiolo',
      'Pergine Valdarno',
      'Pian di Sco',
      'Pieve Santo Stefano',
      'Poppi',
      'Pratovecchio',
      'San Giovanni Valdarno',
      'Sansepolcro',
      'Sestino',
      'Stia',
      'Subbiano',
      'Talla',
      'Terranuova Bracciolini',
    ],
    'IT-AP': [
      'Acquasanta Terme',
      'Acquaviva Picena',
      'Appignano del Tronto',
      'Arquata del Tronto',
      'Ascoli Piceno',
      'Carassai',
      'Castel di Lama',
      'Castignano',
      'Castorano',
      'Colli del Tronto',
      'Comunanza',
      'Cossignano',
      'Cupra Marittima',
      'Folignano',
      'Force',
      'Grottammare',
      'Maltignano',
      'Massignano',
      'Monsampolo del Tronto',
      'Montalto delle Marche',
      'Montedinove',
      "Montefiore dell' Aso",
      'Montegallo',
      'Montemonaco',
      'Monteprandone',
      'Offida',
      'Palmiano',
      'Ripatransone',
      'Roccafluvione',
      'Rotella',
      'San Benedetto del Tronto',
      'Spinetoli',
      'Venarotta',
    ],
    'IT-AT': [
      'Agliano',
      'Albugnano',
      'Antignano',
      'Aramengo',
      'Asti',
      "Azzano d' Asti",
      "Baldichieri d' Asti",
      'Belveglio',
      'Berzano di San Pietro',
      'Bruno',
      'Bubbio',
      "Buttigliera d' Asti",
      'Calamandrana',
      'Calliano',
      'Calosso',
      'Camerano Casasco',
      'Canelli',
      'Cantarana',
      'Capriglio',
      'Casorzo',
      'Cassinasco',
      'Castagnole Monferrato',
      'Castagnole delle Lanze',
      'Castel Boglione',
      'Castel Rocchero',
      "Castell' Alfero",
      'Castellero',
      'Castelletto Molina',
      'Castello di Annone',
      'Castelnuovo Belbo',
      'Castelnuovo Calcea',
      'Castelnuovo Don Bosco',
      'Cellarengo',
      'Celle Enomondo',
      "Cerreto d' Asti",
      'Cerro Tanaro',
      'Cessole',
      "Chiusano d' Asti",
      'Cinaglio',
      "Cisterna d' Asti",
      'Coazzolo',
      'Cocconato',
      'Colcavagno',
      'Corsione',
      'Cortandone',
      'Cortanze',
      'Cortazzone',
      'Cortiglione',
      'Cossombrato',
      "Costigliole d' Asti",
      'Cunico',
      'Dusino San Michele',
      'Ferrere',
      'Fontanile',
      'Frinco',
      'Grana',
      'Grazzano Badoglio',
      'Incisa Scapaccino',
      "Isola d' Asti",
      'Loazzolo',
      'Maranzana',
      'Maretto',
      'Moasca',
      'Mombaldone',
      'Mombaruzzo',
      'Mombercelli',
      'Monale',
      'Monastero Bormida',
      'Moncalvo',
      'Moncucco Torinese',
      'Mongardino',
      'Montabone',
      'Montafia',
      'Montaldo Scarampi',
      "Montechiaro d' Asti",
      "Montegrosso d' Asti",
      'Montemagno',
      'Montiglio',
      'Moransengo',
      'Nizza Monferrato',
      'Olmo Gentile',
      'Passerano Marmorito',
      'Penango',
      'Piea',
      "Pino d' Asti",
      'Piovà Massaia',
      'Portacomaro',
      'Quaranti',
      'Refrancore',
      "Revigliasco d' Asti",
      'Roatto',
      'Robella',
      "Rocca d' Arazzo",
      'Roccaverano',
      'Rocchetta Palafea',
      'Rocchetta Tanaro',
      "San Damiano d' Asti",
      'San Giorgio Scarampi',
      'San Martino Alfieri',
      'San Marzano Oliveto',
      'San Paolo Solbrito',
      'Scandeluzza',
      'Scurzolengo',
      'Serole',
      'Sessame',
      'Settime',
      'Soglio',
      'Tigliole',
      'Tonco',
      'Tonengo',
      'Vaglio Serra',
      'Valfenera',
      'Vesime',
      'Viarigi',
      "Vigliano d' Asti",
      'Villa San Secondo',
      "Villafranca d' Asti",
      "Villanova d' Asti",
      'Vinchio',
    ],
    'IT-AV': [
      'Aiello del Sabato',
      'Altavilla Irpina',
      'Andretta',
      'Aquilonia',
      'Ariano Irpino',
      'Atripalda',
      'Avella',
      'Avellino',
      'Bagnoli Irpino',
      'Baiano',
      'Bisaccia',
      'Cairano',
      'Calabritto',
      'Calitri',
      'Candida',
      'Caposele',
      'Capriglia Irpina',
      'Carife',
      'Casalbore',
      'Cassano Irpino',
      'Castel Baronia',
      'Castelfranci',
      'Castelvetere sul Calore',
      'Cervinara',
      'Cesinali',
      'Chianche',
      'Chiusano San Domenico',
      'Contrada',
      'Conza della Campania',
      'Domicella',
      'Flumeri',
      'Fontanarosa',
      'Forino',
      'Frigento',
      'Gesualdo',
      'Greci',
      'Grottaminarda',
      'Grottolella',
      'Guardia Lombardi',
      'Lacedonia',
      'Lapio',
      'Lauro',
      'Lioni',
      'Luogosano',
      'Manocalzati',
      'Marzano di Nola',
      'Melito Irpino',
      'Mercogliano',
      'Mirabella Eclano',
      'Montaguto',
      'Montecalvo Irpino',
      'Montefalcione',
      'Monteforte Irpino',
      'Montefredane',
      'Montefusco',
      'Montella',
      'Montemarano',
      'Montemiletto',
      'Montorio Inferiore',
      'Montorio Superiore',
      'Morra de Sanctis',
      'Moschiano',
      'Mugnano del Cardinale',
      'Nusco',
      "Ospedaletto d'Alpinolo",
      'Pago del Vallo di Lauro',
      'Parolise',
      'Paternopoli',
      'Pietradefusi',
      'Pietrastornina',
      'Prata di Principato Ultra',
      'Pratolaserra',
      'Quadrelle',
      'Quindici',
      'Rocca San Felice',
      'Roccabascerano',
      'Rotondi',
      'Salza Irpina',
      'San Mango sul Calore',
      'San Martino Valle Caudina',
      'San Michele di Serino',
      'San Nicola Baronia',
      'San Potito Ultra',
      'San Sossio Baronia',
      "Sant'Andrea di Conza",
      "Sant'Angelo a Scala",
      "Sant'Angelo all'Esca",
      "Sant'Angelo dei Lombardi",
      'Santa Lucia di Serino',
      'Santa Paolina',
      'Santo Stefano del Sole',
      'Savignano Irpino',
      'Scampitella',
      'Senerchia',
      'Serino',
      'Sirignano',
      'Solofra',
      'Sorbo Serpico',
      'Sperone',
      'Sturno',
      'Summonte',
      'Taurano',
      'Taurasi',
      'Teora',
      'Torella dei Lombardi',
      'Torre le Nocelle',
      'Torrioni',
      'Trevico',
      'Tufo',
      'Vallata',
      'Vallesaccarda',
      'Venticano',
      'Villamaina',
      'Villanova del Battista',
      'Volturara Irpina',
      'Zungoli',
    ],
    'IT-BA': [
      'Acquaviva delle Fonti',
      'Adelfia',
      'Alberobello',
      'Altamura',
      'Andria',
      'Bari',
      'Barletta',
      'Binetto',
      'Bisceglie',
      'Bitetto',
      'Bitonto',
      'Bitritto',
      'Canosa di Puglia',
      'Capurso',
      'Casamassima',
      'Cassano delle Murge',
      'Castellana Grotte',
      'Ceglie del Campo',
      'Cellamare',
      'Conversano',
      'Corato',
      'Giovinazzo',
      'Gravina in Puglia',
      'Grumo Appula',
      'Isola di Bari',
      'Locorotondo',
      'Minervino Murge',
      'Modugno',
      'Molfetta',
      'Monopoli',
      'Noci',
      'Noicattaro',
      'Palo del Colle',
      'Poggiorsini',
      'Polignano a Mare',
      'Putignano',
      'Rutigliano',
      'Ruvo di Puglia',
      'Sammichele di Bari',
      'Sannicandro di Bari',
      'Santeramo in Colle',
      'Spinazzola',
      'Terlizzi',
      'Toritto',
      'Trani',
      'Triggiano',
      'Turi',
      'Valenzano',
    ],
    'IT-BL': [
      'Agordo',
      'Alano di Piave',
      'Alleghe',
      'Arsié',
      'Auronzo di Cadore',
      'Belluno',
      'Borca di Cadore',
      'Calalzo di Cadore',
      "Canale d' Agordo",
      'Castello Lavazzo',
      'Cencenighe Agordino',
      'Cesiomaggiore',
      "Chies d' Alpago",
      'Cibiana di Cadore',
      'Colle Santa Lucia',
      'Comelico Superiore',
      "Cortina d' Ampezzo",
      'Danta di Cadore',
      'Domegge di Cadore',
      'Falcade',
      "Farra d' Alpago",
      'Feltre',
      'Fonzaso',
      'Forno di Zoldo',
      'Gosaldo',
      'La Valle Agordina',
      'Lamon',
      'Lentiai',
      'Limana',
      'Livinallongo del Col di Lana',
      'Longarone',
      'Lorenzago di Cadore',
      'Lozzo di Cadore',
      'Ospitale di Cadore',
      'Pedavena',
      'Perarolo di Cadore',
      "Pieve d' Alpago",
      'Pieve di Cadore',
      'Ponte nelle Alpi',
      "Puos d' Alpago",
      'Rivamonte Agordino',
      'Rocca Pietore',
      'San Gregorio Nelle Alpi',
      'San Nicoló di Comelico',
      'San Pietro di Cadore',
      'San Tomaso Agordino',
      'San Vito di Cadore',
      'Santa Giustina',
      'Santo Stefano di Cadore',
      'Sappada',
      'Sedico',
      'Selva di Cadore',
      'Seren del Grappa',
      'Sospirolo',
      'Soverzene',
      'Sovramonte',
      'Taibon Agordino',
      'Tambre',
      'Trichiana',
      'Vallada Agordina',
      'Valle di Cadore',
      'Vas',
      'Vigo di Cadore',
      'Vodo Cadore',
      'Voltago Agordino',
      'Zoldo Alto',
      'Zoppé di Cadore',
    ],
    'IT-BN': [
      'Airola',
      'Amorosi',
      'Apice',
      'Apollosa',
      'Arpaia',
      'Arpaise',
      'Baselice',
      'Benevento',
      'Bonea',
      'Bucciano',
      'Buonalbergo',
      'Calvi',
      'Campolattaro',
      'Campoli M.T.',
      'Casalduni',
      'Castelfranco in Miscano',
      'Castelpagano',
      'Castelpoto',
      'Castelvenere',
      'Castelvetere Valfortore',
      'Cautano',
      'Ceppaloni',
      'Cerreto Sannita',
      'Circello',
      'Colle Sannita',
      'Curano Mutri',
      'Dugenta',
      'Durazzano',
      'Faiccho',
      'Foglianise',
      'Foiano Valfortore',
      'Forchia',
      "Fragneto l'Abate",
      'Frasso Telesino',
      'Ginestra degli Schiavoni',
      'Guardia Sanframondi',
      'Limatola',
      'Melizzano',
      'Moiano',
      'Molinara',
      'Montefalcone',
      'Montesarchio',
      'Morcone',
      'Paduli',
      'Pago Veiano',
      'Pannarano',
      'Paolisi',
      'Paupusi',
      'Pesco Sannita',
      'Petralcina',
      'Pietraroja',
      'Ponte',
      'Pontelandolfo',
      'Puglianello',
      'Reino',
      'San Bartolomeo in Galdo',
      'San Giorgio La Monara',
      'San Giorgio del Sannio',
      'San Leucio del Sannio',
      'San Lorenzello',
      'San Lorenzo Maggiore',
      'San Lupo',
      'San Marco dei Cavoti',
      'San Martino Sannita',
      'San Nazzaro',
      'San Nicola Manfredi',
      'San Salvatore Telesino',
      "Sant'Agata dei Goti",
      "Sant'Angelo a Cupolo",
      "Sant'Arcangelo Trimonte",
      'Santa Croce del Sannio',
      'Sassinoro',
      'Solopaca',
      'Telese Terme',
      'Tocco Caudio',
      'Torrecuso',
      'Vitulano',
    ],
    'IT-BI': [
      'Ailoche',
      'Andorno Micca',
      'Benna',
      'Biella',
      'Bioglio',
      'Borriana',
      'Brusnengo',
      'Callabiana',
      'Camandona',
      'Camburzano',
      'Campiglia Cervo',
      'Candelo',
      'Caprile',
      'Casapinta',
      'Castelletto Cervo',
      'Cavaglia',
      'Cerreto Castello',
      'Cerrione',
      'Coggiola',
      'Cossato',
      'Crevacuore',
      'Crosa',
      'Curino',
      'Dorzano',
      'Gaglianico',
      'Gifflenga',
      'Graglia',
      'Lessona',
      'Magnano',
      'Massazza',
      'Masserano',
      'Mezzana Mortigliengo',
      'Miagliano',
      'Mongrando',
      'Mosso Santa Maria',
      'Mottalciata',
      'Muzzano',
      'Netro',
      'Occhieppo Inferiore',
      'Occhieppo Superiore',
      'Pettinengo',
      'Piatto',
      'Piedicavallo',
      'Pistolesa',
      'Pollone',
      'Ponderano',
      'Portula',
      'Pralungo',
      'Pray',
      'Quaregna',
      'Quittengo',
      'Ronco Biellese',
      'Roppolo',
      'Rosazza',
      'Sagliano Micca',
      'Sala Biellese',
      'Salussola',
      'San Paolo Cervo',
      'Sandigliano',
      'Selve Marcone',
      'Soprana',
      'Sordevolo',
      'Sostegno',
      'Strona',
      'Tavigliano',
      'Ternengo',
      'Tollegno',
      'Torrazzo',
      'Trivero',
      'Valdengo',
      'Vallanzengo',
      'Valle Mosso',
      'Valle San Nicolao',
      'Veglio',
      'Verrone',
      'Vigliano Biellese',
      'Villa del Bosco',
      'Villanova Biellese',
      'Viverone',
      'Zimone',
      'Zubiena',
      'Zumaglia',
    ],
    'IT-BO': [
      'Altedo',
      "Anzola dell' Emilia",
      'Argelato',
      'Baricella',
      'Bazzano',
      'Bentivoglio',
      'Bolonia',
      'Borgo Tossignano',
      'Budrio',
      'Calderara di Reno',
      'Camugnano',
      'Casalecchio di Reno',
      'Casalfiumanese',
      'Castel Guelfo di Bologna',
      'Castel Maggiore',
      'Castel San Pietro Terme',
      "Castel d' Aiano",
      'Castel del Rio',
      'Castel di Casio',
      "Castello d' Argile",
      'Castello di Serravalle',
      'Castenaso',
      'Castiglione dei Pepoli',
      'Crespellano',
      'Crevalcore',
      'Dozza',
      'Fontanelice',
      'Gaggio Montano',
      'Galliera',
      'Granaglione',
      "Granarolo dell' Emilia",
      'Grizzana Morandi',
      'Imola',
      'Lizzano in Belvedere',
      'Loiano',
      'Malalbergo',
      'Marzabotto',
      'Medicina',
      'Minerbio',
      'Molinella',
      'Monghidoro',
      'Monte San Pietro',
      'Monterenzio',
      'Monteveglio',
      'Monzuno',
      'Mordano',
      "Ozzano dell' Emilia",
      'Pianoro',
      'Pieve di Cento',
      'Porretta Terme',
      'Rastignano',
      'Sala Bolognese',
      'San Benedetto Val di Sambro',
      'San Giorgio di Piano',
      'San Giovanni in Persiceto',
      'San Lazzaro di Savena',
      'San Pietro in Casale',
      "Sant'Agata Bolognese",
      'Sasso Marconi',
      'Savigno',
      'Vergato',
    ],
    'IT-BZ': [
      'Aldino',
      'Andriano',
      'Anterivo',
      'Appiano sulla Strada del Vino',
      'Avelengo',
      'Badia',
      'Barbiano',
      'Bolzano',
      'Braies',
      'Brennero',
      'Bressanone',
      'Bronzolo',
      'Brunico',
      'Caines',
      'Caldaro sulla Strada del Vino',
      'Campo Tures',
      'Campo di Trens',
      'Castelbello Ciardes',
      'Castelrotto',
      'Cermes',
      'Chienes',
      'Chiusa',
      "Cornedo all' Isarco",
      'Cortaccia sulla Strada del Vino',
      'Cortina sulla Strada del Vino',
      'Corvara in Badia',
      'Curon Venosta',
      'Dobbiaco',
      'Egna',
      'Falzes',
      'Fiè allo Sciliar',
      'Fortezza',
      'Gais',
      'Gargazzone',
      'Glorenza',
      'La Valle',
      'Laces',
      'Lagundo',
      'Laion',
      'Laives',
      'Lana',
      'Lasa',
      'Lauregno',
      'Luson',
      'Magré sulla Strada del Vino',
      'Malles Venosta',
      'Marebbe',
      'Marlengo',
      'Martello',
      'Meltina',
      'Merano',
      'Monguelfo',
      'Montagna',
      'Moso in Passiria',
      'Nalles',
      'Naturno',
      'Naz Sciaves',
      'Nova Levante',
      'Nova Ponente',
      'Ora',
      'Ortisei',
      'Parcines',
      'Perca',
      'Plaus',
      'Ponte Gardena',
      'Postal',
      'Prato allo Stelvio',
      'Predoi',
      'Proves',
      'Racines',
      'Rasun Anterselva',
      'Renon',
      'Rifiano',
      'Rio di Pusteria',
      'Rodengo',
      'Salorno',
      'San Candido',
      'San Genesio Atesino',
      'San Leonardo in Passiria',
      'San Lorenzo di Sebato',
      'San Martino in Badia',
      'San Martino in Passiria',
      'San Pancrazio',
      'Santa Cristina Valgardena',
      'Sarentino',
      'Scena',
      'Selva dei Molini',
      'Selva di Val Gardena',
      'Senale-San Felice',
      'Senales',
      'Sesto',
      'Silandro',
      'Sluderno',
      'Stelvio',
      'Terento',
      'Terlano',
      'Termeno sulla Strada del Vino',
      'Tesimo',
      'Tires',
      'Tirolo',
      'Trodena',
      'Tubre',
      'Ultimo',
      'Vadena',
      'Val di Vizze',
      'Valdaora',
      'Valle Aurina',
      'Valle di Casies',
      'Vandoies',
      'Varna',
      'Velturno',
      'Verano',
      'Villabassa',
      'Villandro',
      'Vipiteno',
    ],
    'IT-BS': [
      'Acquafredda',
      'Adro',
      'Agnosine',
      'Alfianello',
      'Alfo',
      'Angolo Terme',
      'Artogne',
      'Azzano Mella',
      'Bagnolo Mella',
      'Bagolino',
      'Barbariga',
      'Barghe',
      'Bassano Bresciano',
      'Bedizzole',
      'Berlingo',
      'Berzo Demo',
      'Berzo Inferiore',
      'Bienno',
      'Bione',
      'Borgo San Giacomo',
      'Borgosatollo',
      'Borno',
      'Botticino',
      'Bovegno',
      'Bovezzo',
      'Brandico',
      'Braone',
      'Breno',
      'Brescia',
      'Brione',
      'Caino',
      'Calcinato',
      'Calvagese della Riviera',
      'Calvisano',
      'Capo di Ponte',
      'Capovalle',
      'Capriano del Colle',
      'Capriolo',
      'Carpenedolo',
      'Castegnato',
      'Castel Mella',
      'Castelcovati',
      'Castenedolo',
      'Casto',
      'Castrezzato',
      'Cazzago San Martino',
      'Cedegolo',
      'Cellatica',
      'Cerveno',
      'Ceto',
      'Cevo',
      'Chiari',
      'Cigole',
      'Cimbergo',
      'Cividate Camuno',
      'Coccaglio',
      'Collebeato',
      'Collio',
      'Comezzano Cizzago',
      'Concesio',
      'Corte Franca',
      'Corteno Golgi',
      'Corzano',
      'Darfo Boario Terme',
      'Dello',
      'Desenzano del Garda',
      'Edolo',
      'Erbusco',
      'Esine',
      'Fiesse',
      'Flero',
      'Gambara',
      'Gardone Riviera',
      'Gardone Val Trompia',
      'Gargnano',
      'Gavardo',
      'Ghedi',
      'Gianico',
      'Gottolengo',
      'Gussago',
      'Idro',
      'Incudine',
      'Iseo',
      'Isorella',
      'Lavenone',
      'Leno',
      'Limone sul Garda',
      'Lodrino',
      'Lonato',
      'Longhena',
      'Losine',
      'Lozio',
      'Lumezzane',
      'Maclodio',
      'Magasa',
      'Mairano',
      'Malegno',
      'Malonno',
      'Manerba del Garda',
      'Manerbio',
      'Marcheno',
      'Marmentino',
      'Marone',
      'Mazzano',
      'Milzano',
      'Moniga del Garda',
      'Monno',
      'Monte Isola',
      'Monticeli Brusati',
      'Montichiari',
      'Montirone',
      'Mura',
      'Muscoline',
      'Nave',
      'Niardo',
      'Nuvolento',
      'Nuvolera',
      'Odolo',
      'Offlaga',
      'Ome',
      'Ono San Pietro',
      'Orzinuovi',
      'Orzivecchi',
      'Ospitaletto',
      'Ossimo',
      'Padenghe sul Garda',
      'Paderno Franciacorta',
      'Paisco Loveno',
      'Paitone',
      "Palazzolo sull' Oglio",
      'Paratico',
      'Paspardo',
      'Passirano',
      'Pavone del Mella',
      'Pertica Alta',
      'Pertica Bassa',
      'Pezzate',
      'Pian Camuno',
      'Piancogno',
      'Pisogne',
      'Polaveno',
      'Polpenazze del Garda',
      'Pompiano',
      'Poncarale',
      'Ponte di Legno',
      'Pontevico',
      'Pontoglio',
      'Pozzolengo',
      'Pralboino',
      'Preseglie',
      'Prestine',
      'Prevalle',
      'Provaglio Val Sabbia',
      "Provaglio d' Iseo",
      'Puegnago sul Garda',
      "Quinzano d' Oglio",
      'Remedello',
      'Rezzato',
      'Roccafranca',
      'Rodengo Saiano',
      'Roncadelle',
      'Rovato',
      'Roè Volciano',
      'Rudiano',
      'Sabbio Chiese',
      'Sale Marasino',
      'Saló',
      'San Colombano Collio',
      'San Felice del Benaco',
      'San Gervasio Bresciano',
      'San Paolo',
      'San Zeno Naviglio',
      'Sarezzo',
      "Saviore dell' Adamello",
      'Sellero',
      'Seniga',
      'Serle',
      'Sirmione',
      'Soiano del Lago',
      'Sonico',
      'Sulzano',
      'Tavernole sul Mella',
      'Temú',
      'Tignale',
      'Torbole Casaglia',
      'Toscolano Maderno',
      'Travagliato',
      'Tremosine',
      'Trenzano',
      'Treviso Bresciano',
      "Urago d'Oglio",
      'Vallio Terme',
      'Valvestino',
      'Verolanuova',
      'Verolavecchia',
      'Vestone',
      "Vezza d' Oglio",
      'Villa Carcina',
      'Villa Chiara',
      'Villanuova sul Clisi',
      'Vione',
      'Visano',
      'Vobarno',
      'Zone',
    ],
    'IT-BR': [
      'Brindisi',
      'Carovigno',
      'Ceglie Messapica',
      'Cellino San Marco',
      'Cisternino',
      'Erchie',
      'Fasano',
      'Francavilla Fontana',
      'Latiano',
      'Mesagne',
      'Oria',
      'Ostuni',
      'San Donaci',
      'San Michele Salentino',
      'San Pancrazio Salentino',
      'San Pietro Vernotico',
      'San Vito dei Normanni',
      'Torchiarolo',
      'Torre Santa Susanna',
      'Villa Castelli',
    ],
    'IT-BG': [
      'Adrara San Martino',
      'Adrara San Rocco',
      "Albano Sant' Alessandro",
      'Albino',
      'Algua',
      'Almenno San Bartolomeo',
      'Almenno San Salvatore',
      'Almé',
      'Alzano Lombardo',
      'Ambivere',
      'Antegnate',
      'Arcene',
      'Ardesio',
      "Arzago d' Adda",
      'Averara',
      'Aviatico',
      'Azzano San Paolo',
      'Azzone',
      'Bagnatica',
      'Barbata',
      'Bariano',
      'Barzana',
      'Bedulita',
      'Berbenno',
      'Bergamo',
      'Berzo San Fermo',
      'Bianzano',
      'Blello',
      'Bolgare',
      'Boltiere',
      'Bonate Sopra',
      'Bonate Sotto',
      'Borgo di Terzo',
      'Bossico',
      'Bottanuco',
      'Bracca',
      'Brambate',
      'Branzi',
      'Brembate di Sopra',
      'Brembilla',
      "Brignano Gera d' Adda",
      'Brumano',
      'Brusaporto',
      'Calcinate',
      'Calcio',
      "Calusco d' Adda",
      'Calvenzano',
      'Camerata Cornello',
      "Canonica d' Adda",
      'Capizzone',
      'Capriate San Gervasio',
      'Caprino Bergamasco',
      'Caravaggio',
      'Carobbio degli Angeli',
      'Carona',
      'Carvico',
      'Casazza',
      "Casirate d' Adda",
      'Casnigo',
      'Cassiglio',
      'Castel Rozzone',
      'Castelli Calepio',
      'Castione della Presolana',
      'Cavernago',
      "Cazzano Sant' Andrea",
      'Cenate Sopra',
      'Cenate Sotto',
      'Cene',
      'Cerete',
      "Chignolo d' Isola",
      'Chiuduno',
      'Cisano Bergamasco',
      'Ciserano',
      'Cividate al Piano',
      'Clusone',
      'Colere',
      'Cologno al Serio',
      'Colzate',
      'Comun Nuovo',
      'Corna Imagna',
      'Cornalba',
      'Cortenova',
      'Costa Valle Imagna',
      'Costa Volpino',
      'Costa di Mezzate',
      'Costa di Serina',
      'Covo',
      'Credaro',
      'Curno',
      'Cusio',
      'Dalmine',
      'Dossena',
      'Endine Gaiano',
      'Entratico',
      "Fara Gera d' Adda",
      'Fara Olivana con Isola',
      'Filago',
      'Fino del Monte',
      'Fiorano al Serio',
      'Fontanella',
      'Fonteno',
      'Foppolo',
      'Foresto Sparso',
      'Fornovo San Giovanni',
      'Fuipiano Valle Imagna',
      'Gandellino',
      'Gandino',
      'Gandosso',
      'Gaverina Terme',
      'Gazzaniga',
      'Gerosa',
      'Ghisalba',
      'Gorlago',
      'Gorle',
      'Gorno',
      'Grassobbio',
      'Gromo',
      'Grone',
      'Grumello del Monte',
      'Isola di Fondra',
      'Isso',
      'Lallio',
      'Leffe',
      'Lenna',
      'Levate',
      'Locatello',
      'Lovere',
      'Lurano',
      'Luzzano',
      'Madone',
      'Mapello',
      'Martinengo',
      'Medolago',
      'Mezzoldo',
      "Misano di Gera d' Adda",
      "Moio de' Calvi",
      'Monasterolo del Castello',
      'Morengo',
      'Mornico al Serio',
      'Mozzanica',
      'Mozzo',
      'Nembro',
      'Olmo al Brembo',
      'Oltre il Colle',
      'Oltressenda Alta',
      'Oneta',
      'Onore',
      'Orio al Serio',
      'Ornica',
      'Osio Sopra',
      'Osio Sotto',
      'Pagazzano',
      'Paladina',
      'Palazzago',
      'Palosco',
      'Parre',
      'Parzanica',
      'Pedrengo',
      'Peia',
      'Pianico',
      'Piario',
      'Piazza Brembana',
      'Piazzatorre',
      'Piazzolo',
      'Pognano',
      'Ponte Nossa',
      'Ponte San Pietro',
      'Ponteranica',
      'Pontida',
      'Pontirolo Nuovo',
      'Pradalunga',
      'Predore',
      'Premolo',
      'Presezzo',
      'Pumenengo',
      'Ranica',
      'Ranzanico',
      'Riva di Solto',
      'Rogno',
      'Romano di Lombardia',
      'Roncobello',
      'Roncola',
      "Rota d' Imagna",
      'Rovetta',
      'San Giovanni Bianco',
      "San Paolo d' Argon",
      'San Pellegrino Terme',
      "Sant' Omobono Imagna",
      'Santa Brigida',
      'Sarnico',
      'Scanzorosciate',
      'Schilpario',
      'Sedrina',
      'Selvino',
      'Seriate',
      'Serina',
      'Solto Collina',
      'Solza',
      'Songavazzo',
      'Sorisole',
      'Sotto il Monte Giovanni XXIII',
      'Sovere',
      'Spinone al Lago',
      'Spirano',
      'Stezzano',
      'Strozza',
      'Suisio',
      'Taleggio',
      'Tavernola Bergamasca',
      'Telgate',
      "Terno d' Isola",
      'Torre Boldone',
      'Torre Pallavicina',
      "Torre de' Roveri",
      'Trescore Balneario',
      'Treviglio',
      'Treviolo',
      'Ubiale Clanezzo',
      'Urgnano',
      'Valbondione',
      'Valbrembo',
      'Valgoglio',
      'Valleve',
      'Valnegra',
      'Valsecca',
      'Valtorta',
      'Vedeseta',
      'Verdellino',
      'Verdello',
      'Vertova',
      'Viadanica',
      'Vigano San Martino',
      'Vigolo',
      "Villa d' Adda",
      "Villa d' Almé",
      "Villa d' Ogna",
      'Villa di Serio',
      'Villongo',
      'Vilminore di Scalve',
      'Zandobbio',
      'Zanica',
      'Zogno',
    ],
    'IT-CA': [
      'Armungia',
      'Assemini',
      'Ballao',
      'Barrali',
      'Burcei',
      'Cagliari',
      'Capoterra',
      'Castiadas',
      'Decimomannu',
      'Decimoputzu',
      'Dolianova',
      'Domus de Maria',
      'Donorì',
      'Elmas',
      'Escalaplano',
      'Escolca',
      'Esterzili',
      'Gergei',
      'Gesico',
      'Gesturi',
      'Goni',
      'Guamaggiore',
      'Guasila',
      'Isili',
      'Mandas',
      'Maracalagonis',
      'Monastir',
      'Monserrato',
      'Muravera',
      'Nuragus',
      'Nurallao',
      'Nuraminis',
      'Nurri',
      'Orroli',
      'Ortacesus',
      'Pula',
      "Quartu Sant'Elena",
      'Quartucciu',
      'Sadali',
      'Samatzai',
      'San Basilio',
      'San Nicolò Gerrei',
      'San Sperate',
      'San Vito',
      "Sant'Andrea Frius",
      'Sarroch',
      'Selargius',
      'Selegas',
      'Senorb',
      'Serdiana',
      'Serri',
      'Sestu',
      'Settimo San Pietro',
      'Seulo',
      'Siliqua',
      'Silius',
      'Sinnai',
      'Siurgus Donigala',
      'Soleminis',
      'Suelli',
      'Teulada',
      'Uta',
      'Vallermosa',
      'Villa San Pietro',
      'Villanova Tulo',
      'Villaputzu',
      'Villasalto',
      'Villasimius',
      'Villasor',
      'Villaspeciosa',
    ],
    'IT-CL': [
      'Acquaviva Platani',
      'Bompensiere',
      'Butera',
      'Caltanissetta',
      'Campofranco',
      'Disueri',
      'Gela',
      'Marianopoli',
      'Mazzarino',
      'Milena',
      'Montedoro',
      'Mussomeli',
      'Niscemi',
      'Resuttano',
      'Riesi',
      'San Cataldo',
      'Santa Caterina Villarmosa',
      'Serradifalco',
      'Sommatino',
      'Sutera',
      'Vallelunga Pratameno',
      'Villalba',
    ],
    'IT-CB': [
      'Acquaviva Collecroce',
      'Baranello',
      'Bojano',
      'Bonefro',
      'Busso',
      'Campobasso',
      'Campochiaro',
      'Campodipietra',
      'Campolieto',
      'Campomarino',
      'Casacalenda',
      'Casalciprano',
      'Castelbottaccio',
      'Castellino del Biferno',
      'Castelmauro',
      'Castropignano',
      'Cercemaggiore',
      'Cercepiccola',
      'Civitacampomarano',
      "Colle d' Anchise",
      'Colletorto',
      'Duronia',
      'Ferrazzano',
      'Fossalto',
      'Gambatesa',
      'Gildone',
      'Guardialfiera',
      'Guardiaregia',
      'Guglionesi',
      'Jelsi',
      'Larino',
      'Limosano',
      'Lucito',
      'Lupara',
      'Macchia Valfortore',
      'Mafalda',
      'Matrice',
      'Mirabello Sannitico',
      'Molise',
      'Monacilioni',
      'Montagano',
      'Montecilfone',
      'Montefalcone nel Sannio',
      'Montelongo',
      'Montemitro',
      'Montenero di Bisaccia',
      'Montorio nei Frentani',
      'Morrone del Sannio',
      'Oratino',
      'Palata',
      'Petacciato',
      'Petrella Tifernina',
      'Pietracatella',
      'Pietracupa',
      'Portocannone',
      'Provvidenti',
      'Riccia',
      'Ripabottoni',
      'Ripalimosani',
      'Roccavivara',
      'Rotello',
      'Salcito',
      'San Biase',
      'San Felice del Molise',
      'San Giacomo degli Schiavoni',
      'San Giovanni in Galdo',
      'San Giuliano del Sannio',
      'San Giuliano di Puglia',
      'San Martino in Pensilis',
      'San Massimo',
      'San Polomatese',
      "Sant' Angelo Limosano",
      "Sant'Elia a Pianisi",
      'Santa Croce di Magliano',
      'Santo Stefano',
      'Sepino',
      'Spinete',
      'Tavenna',
      'Termoli',
      'Torella del Sannio',
      'Trivento',
      'Tufara',
      'Ururi',
      'Vinchiaturo',
    ],
    'IT-CI': [
      'Buggerru',
      "Calasetta (Isla de Sant'Antioco)",
      'Carbonia',
      'Carloforte (Isla de San Pietro)',
      'Domusnovas',
      'Fluminimaggiore',
      'Giba',
      'Gonnesa',
      'Iglesias',
      'Masainas',
      'Musei',
      'Narcao',
      'Nuxis',
      'Perdaxius',
      'Piscinas',
      'Portoscuro',
      'San Giovanni Suergiu',
      "Sant'Anna Arresi",
      "Sant'Antioco (Isla de)",
      'Santadi',
      'Tratalias',
      'Villamassargia',
      'Villaperuccio',
    ],
    'IT-CE': [
      'Ailano',
      'Alife',
      'Alvignano',
      'Arienzo',
      'Aversa',
      'Baia Latina',
      'Bellona',
      'Caianello',
      'Caiazzo',
      'Calvi Risorta',
      'Camigliano',
      'Cancello Arnone',
      'Capodrise',
      'Capriati al Volturno',
      'Capua',
      'Carinaro',
      'Carinola',
      'Casagiove',
      'Casal di Principe',
      'Casaluce',
      'Casapesenna',
      'Casapulla',
      'Caserta',
      'Castel Campagnano',
      'Castel Morrone',
      'Castel Volturno',
      'Castel di Sasso',
      'Castello Matese',
      'Cellole',
      'Cervino',
      'Cesa',
      'Ciorlano',
      'Conca della Campania',
      'Curti',
      'Dragoni',
      'Falciano del M.',
      'Fontegreca',
      'Formicola',
      'Francolise',
      'Frignano',
      'Gallo',
      'Galluccio',
      'Giano Vetusto',
      'Gioia Sannitica',
      'Grazzanise',
      'Gricignano',
      'Letino',
      'Liberi',
      'Lusciano',
      'Macerata Campania',
      'Maddaloni',
      'Marcianise',
      'Marzano Appio',
      'Mignano Montelungo',
      'Mondragone',
      'Orta di Atella',
      'Parete',
      'Pastorano',
      'Piana di M.Verna',
      'Piedimonte Matese',
      "Piedimonte d'Alife",
      'Pietramelara',
      'Pietravairano',
      'Pignataro Maggiore',
      'Pontelatone',
      'Portico di Caserta',
      'Prata Sannita',
      'Pratella',
      'Presenzano',
      'Raviscanina',
      'Recale',
      'Riardo',
      "Rocca d'Evandro",
      'Roccamonfina',
      'Roccaromana',
      'Rocchetta e Croce',
      'Ruviano',
      "San Cipriano d'Aversa",
      'San Felice a Cancello',
      'San Gregorio Matese',
      'San Marcellino',
      'San Marco Evangelista',
      'San Nicola la Strada',
      'San Pietro Infine',
      'San Potito',
      'San Prisco',
      'San Tammaro',
      'Sannitico',
      "Sant'Angelo d'Alife",
      "Sant'Arpino",
      'Santa Maria Capua Vetere',
      'Santa Maria a Vico',
      'Santa Maria la Fossa',
      'Sessa Aurunca',
      'Sparanise',
      'Succivo',
      'Teano',
      'Teverola',
      'Tora e Piccilli',
      'Trentola',
      'Vairano Patenora',
      'Valle Agricola',
      'Valle di Maddaloni',
      'Villa Literno',
      'Villa di Briano',
      'Vitulazio',
    ],
    'IT-CT': [
      'Aci Bonaccorsi',
      'Aci Castello',
      'Aci Catena',
      "Aci Sant'Antonio",
      'Acireale',
      'Adrano',
      'Belpasso',
      'Biancavilla',
      'Bronte',
      'Calatabiano',
      'Caltagirone',
      'Camporotondo Etneo',
      'Castel di Judica',
      'Castiglione di Sicilia',
      'Catania',
      'Fiumefreddo di Sicilia',
      'Giarre',
      'Grammichele',
      'Gravina di Catania',
      'Licodia Eubea',
      'Liguaglossa',
      'Maletto',
      'Maniace',
      'Mascali',
      'Mascalucia',
      'Mazzarone',
      'Militello in Val di Catania',
      'Mineo',
      'Mirabella Imbaccari',
      'Misterbianco',
      "Motta Sant'Anastasia",
      'Nicolosi',
      'Palagonia',
      'Paternò',
      'Pedara',
      'Piedimonte etneo',
      'Raddusa',
      'Ragalna',
      'Ramacca',
      'Randazzo',
      'Riposto',
      'San Cono',
      'San Giovanni La Punta',
      'San Gregorio di Catania',
      'San Michele di Ganzaria',
      'San Pietro Clarenza',
      "Sant'Agata Libattiati",
      "Sant'Alfio",
      'Santa Maria di Licodia',
      'Santa Venerina',
      'Scordia',
      'Trecastagni',
      'Tremestieri Etneo',
      'Valverde',
      'Viagrande',
      'Vizzini',
      'Zafferana Etnea',
    ],
    'IT-CZ': [
      'Amaroni',
      'Amato',
      'Andali',
      'Argusto',
      'Badolato',
      'Belcastro',
      'Borgia',
      'Botricello',
      'Caraffa di Catanzaro',
      'Cardinale',
      'Carlopoli',
      'Catanzaro',
      'Cenadi',
      'Centrache',
      'Cerva',
      'Chiaravalle Centrale',
      'Cicala',
      'Conflenti',
      'Cortale',
      'Cropani',
      'Curinga',
      'Davoli',
      'Decollatura',
      'Falerna',
      'Feroleto Antico',
      'Fossato Serralta',
      'Gagliato',
      'Gasperina',
      'Gimigliano',
      'Girifalco',
      'Gizzeria',
      'Guardavalle',
      'Iacurso',
      'Isca sullo Ionio',
      'Lamezia Terme',
      'Magisano',
      'Maida',
      'Marcedusa',
      'Marcellinara',
      'Martirano',
      'Martirano Lombardo',
      'Miglierina',
      'Montauro',
      'Montepaone',
      'Motta Santa Lucia',
      'Nocera Terinese',
      'Olivadi',
      'Palermiti',
      'Pentone',
      'Petrizzi',
      'Petroná',
      'Pianopoli',
      'Platania',
      'San Floro',
      "San Mango d' Aquino",
      'San Pietro Apostolo',
      'San Pietro a Maida',
      'San Sostene',
      'San Vito sullo Ionio',
      "Sant' Andrea Apostolo dello Ionio",
      'Santa Caterina dello Ionio',
      'Satriano',
      'Sellia',
      'Sellia Marina',
      'Serrastretta',
      'Sersale',
      'Settingiano',
      'Simeri Crichi',
      'Sorbo San Basile',
      'Soverato',
      'Soveria Mannelli',
      'Soveria Simeri',
      'Squillace',
      'Stalettì',
      'Taverna',
      'Tiriolo',
      'Torre di Ruggiero',
      'Vallefiorita',
      'Zagarise',
    ],
    'IT-CH': [
      'Altino',
      'Archi',
      'Ari',
      'Arielli',
      'Atessa',
      'Bomba',
      'Borrello',
      'Bucchianico',
      'Canosa Sannita',
      'Carpineto Sinello',
      'Carunchio',
      'Casacanditella',
      'Casalanguida',
      'Casalbordino',
      'Casalincontrada',
      'Casoli',
      'Castel Frentano',
      'Castelguidone',
      'Castiglione Messer Marino',
      'Celenza sul Trigno',
      'Chieti',
      'Civitaluparella',
      'Civitella Messer Raimondo',
      'Colledimacine',
      'Colledimezzo',
      'Crecchio',
      'Cupello',
      'Dogliola',
      'Fallo',
      'Fara Filiorum Petri',
      'Fara San Martino',
      'Filetto',
      'Fossacesia',
      'Fraine',
      'Francavilla al Mare',
      'Fresagrandinaria',
      'Frisa',
      'Furci',
      'Gamberale',
      'Gessopalena',
      'Gissi',
      'Giuliano Teatino',
      'Giuliopoli',
      'Guardiagrele',
      'Guilmi',
      'Lama dei Peligni',
      'Lanciano',
      'Lentella',
      'Lettopalena',
      'Liscia',
      'Miglianico',
      'Montazzoli',
      'Montebello sul Sangro',
      'Monteferrante',
      'Montelapiano',
      'Montenerodomo',
      'Monteodorisio',
      'Mozzagrogna',
      'Orsogna',
      'Ortona',
      'Paglieta',
      'Palmoli',
      'Palombaro',
      'Pennadomo',
      'Pennapiedimonte',
      'Perano',
      'Pietraferrazzana',
      'Pizzoferrato',
      'Poggiofiorito',
      'Pollutri',
      'Pretoro',
      'Quadri',
      'Rapino',
      'Ripa Teatina',
      'Rocca San Giovanni',
      'Roccamontepiano',
      'Roccascalegna',
      'Roccaspinalveti',
      'Roio del Sangro',
      'Rosello',
      'San Buono',
      'San Giovanni Lipioni',
      'San Giovanni Teatino',
      'San Martino sulla Marrucina',
      'San Salvo',
      'San Vito Chietino',
      "Sant'Eusanio del Sangro",
      'Santa Maria Imbaro',
      'Scerni',
      'Schiavi di Abruzzo',
      'Taranta Peligna',
      'Tollo',
      'Torino di Sangro',
      'Tornareccio',
      'Torrebruna',
      'Torrevecchia Teatina',
      'Torricella Peligna',
      'Treglio',
      'Tufillo',
      'Vacri',
      'Vasto',
      'Villa Santa Maria',
      'Villafonsina',
      'Villamagna',
    ],
    'IT-CO': [
      'Albavilla',
      'Albese con Cassano',
      'Albiolo',
      'Alserio',
      'Alzate Brianza',
      'Anzano del Parco',
      'Appiano Gentile',
      'Argegno',
      'Arosio',
      'Asso',
      'Barni',
      'Bellagio',
      'Bene Lario',
      'Beregazzo con Figliaro',
      'Binago',
      'Bizzarone',
      'Blessagno',
      'Blevio',
      'Bosisio Parini',
      'Bregnano',
      'Brenna',
      'Brienno',
      'Brunate',
      'Bulgarograsso',
      'Cabiate',
      'Cadorago',
      'Caglio',
      'Cagno',
      "Campione d' Italia",
      'Cantú',
      'Canzo',
      'Capiago Intimiano',
      'Carate Urio',
      'Carbonate',
      'Carimate',
      'Carlazzo',
      'Carugo',
      "Casasco d' Intelvi",
      "Caslino d' Erba",
      'Casnate con Bernate',
      'Cassina Rizzardi',
      'Castelmarte',
      'Castelnuovo Bozzente',
      "Castiglione d' Intelvi",
      'Cavallasca',
      'Cavargna',
      "Cerano d' Intelvi",
      'Cermenate',
      'Cernobbio',
      'Cirimido',
      'Civenna',
      'Claino con Osteno',
      'Colonno',
      'Como',
      'Consiglio di Rumo',
      'Corrido',
      'Cremia',
      'Cucciago',
      'Cusino',
      'Dizzasco',
      'Domaso',
      'Dongo',
      'Dosso del Liro',
      'Drezzo',
      'Erba',
      'Eupilio',
      'Faggeto Lario',
      'Faloppio',
      'Fenegró',
      'Figino Serenza',
      'Fino Mornasco',
      'Garzeno',
      'Gera Lario',
      'Germasino',
      'Gironico',
      'Grandate',
      'Grandola ed Uniti',
      'Gravedona',
      'Griante',
      'Guanzate',
      'Inverigo',
      'Laglio',
      'Laino',
      'Lambrugo',
      "Lanzo d' Intelvi",
      'Lasnigo',
      'Lenno',
      'Lezzeno',
      'Limido Comasco',
      'Lipomo',
      'Livo',
      'Locate Varesino',
      'Lomazzo',
      'Longone al Segrino',
      'Luisago',
      'Lurago Marinone',
      "Lurago d' Erba",
      'Lurate Caccivio',
      'Magreglio',
      'Mariano Comense',
      'Maslianico',
      'Menaggio',
      'Merone',
      'Mezzegra',
      'Moltrasio',
      'Monguzzo',
      'Montano Lucino',
      'Montemezzo',
      'Montorfano',
      'Mozzate',
      'Musso',
      'Nesso',
      'Novedrate',
      'Olgiate Comasco',
      'Oltrona di San Mamette',
      'Orsenigo',
      'Ossuccio',
      'Paré',
      'Peglio',
      'Pellio Intelvi',
      'Pianello del Lario',
      'Pigra',
      'Plesio',
      'Pognana Lario',
      'Ponna',
      'Ponte Lambro',
      'Porlezza',
      'Proserpio',
      'Pusiano',
      'Ramponio Verna',
      'Rezzago',
      'Rodero',
      'Rogeno',
      'Ronago',
      'Rovellasca',
      'Rovello Porro',
      'Sala Comacina',
      'San Bartolomeo Val Cavargna',
      'San Fedele Intelvi',
      'San Fermo della Battaglia',
      'San Nazzaro val Cavargna',
      "Sant' Abbondio",
      'Santa Maria Rezzonico',
      'Schignano',
      'Senna Comasco',
      'Solbiate',
      'Sorico',
      'Sormano',
      'Stazzona',
      'Tavernerio',
      'Torno',
      'Tremezzo',
      'Trezzone',
      'Turate',
      'Uggiate Trevano',
      'Val Rezzo',
      'Valbrona',
      'Valmorea',
      'Valsolda',
      'Veleso',
      'Veniano',
      'Vercana',
      'Vertemate con Minoprio',
      'Villa Guardia',
      'Zelbio',
    ],
    'IT-CS': [
      'Acquaformosa',
      'Acquappesa',
      'Acri',
      'Aiello Calabro',
      'Aieta',
      'Albidonia',
      'Alessandria del Carretto',
      'Altilia',
      'Altomonte',
      'Amantea',
      'Amendolara',
      'Aprigliano',
      'Belmonte Calabro',
      'Belsito',
      'Belvedere Marittimo',
      'Bianchi',
      'Bisignano',
      'Bocchigliero',
      'Bonifati',
      'Buonvicino',
      'Calopezzati',
      'Caloveto',
      'Canna',
      'Cariati',
      'Carolei',
      'Carpanzano',
      'Casole Bruzio',
      'Cassano allo Ionio',
      'Castiglione Cosentino',
      'Castrolibero',
      'Castroregio',
      'Castrovillari',
      'Celico',
      'Cellara',
      'Cerchiara di Calabria',
      'Cerisano',
      'Cervicati',
      'Cerzeto',
      'Cetraro',
      'Civita',
      'Cleto',
      'Colosimi',
      'Corigliano Calabro',
      'Cosenza',
      'Cropalati',
      'Crosia',
      'Dipignano',
      'Domanico',
      'Fagnano Castello',
      'Falconara Albanese',
      'Figliene Vegliaturo',
      'Firmo',
      'Fiumefreddo Bruzio',
      'Francavilla Marittima',
      'Frascineto',
      'Fuscaldo',
      'Grimaldi',
      'Grisolia',
      'Guardia Piemontese',
      'Lago',
      'Laino Borgo',
      'Laino Castello',
      'Lappano',
      'Lattarico',
      'Longobardi',
      'Longobucco',
      'Lungro',
      'Luzzi',
      'Maierá',
      'Malito',
      'Malvito',
      'Mandatoriccio',
      'Mangone',
      'Marano Marchesato',
      'Marano Principato',
      'Marzi',
      'Mendicino',
      'Mongrassano',
      'Montalto Uffugo',
      'Montegiordano',
      'Morano Calabro',
      'Mormanno',
      'Motta Follone',
      'Nocara',
      'Oriolo',
      'Orsomarso',
      'Paludi',
      'Panettieri',
      'Paola',
      'Papasidero',
      'Parenti',
      'Paterno Calabro',
      'Pedace',
      'Pedivigliano',
      'Piane Crati',
      'Pietrafitta',
      'Pietrapaola',
      'Plataci',
      'Praia a Mare',
      'Rende',
      'Rocca Imperiale',
      'Roggiano Gravina',
      'Rogliano',
      'Rose',
      'Roseto Capo Spulico',
      'Rossano',
      'Rota Greca',
      'Rovito',
      'San Basile',
      'San Benedetto Ullano',
      'San Cosmo Albanese',
      'San Demetrio Corone',
      'San Donato Ninea',
      'San Fili',
      'San Giorgio Albanese',
      'San Giovanni in Fiore',
      'San Lorenzo Bellizzi',
      'San Lorenzo del Vallo',
      'San Lucido',
      'San Marco Argentano',
      'San Martino di Finita',
      'San Nicola Arcella',
      'San Pietro in Amantea',
      'San Pietro in Guarano',
      'San Sosti',
      'San Vincenzo la Costa',
      'Sangineto',
      "Sant'Agata d' Esaro",
      'Santa Caterina Albanese',
      'Santa Domenica Talao',
      'Santa Maria del Cedro',
      "Santa Sofia d' Epiro",
      'Santo Stefano di Rogliano',
      'Saracena',
      'Scala Coeli',
      'Scalea',
      'Scigliano',
      'Serra Aiello',
      'Serra Pedace',
      'Spezzano Albanese',
      'Spezzano Piccolo',
      'Spezzano della Sila',
      'Tarsia',
      'Terranova da Sibari',
      'Terravecchia',
      'Torano Castello',
      'Tortora',
      'Trebisacce',
      'Trenta',
      'Vaccarizzo Albanese',
      'Verbicaro',
      'Villapiana',
      'Zumpano',
    ],
    'IT-CR': [
      'Acquanegra Cremonese',
      'Agnadello',
      'Annico',
      'Azzanello',
      'Bagnolo Cremasco',
      'Bonemerse',
      'Bordolano',
      "Ca' D' Andrea",
      'Calvatone',
      'Camisano',
      'Campagnola Cremasca',
      'Capergnanica',
      'Cappella Cantone',
      "Cappella de' Picenardi",
      'Capralba',
      'Casalbuttano ed Uniti',
      'Casale Cremasco Vidolasco',
      'Casaletto Ceredano',
      'Casaletto Vaprio',
      'Casaletto di Sopra',
      'Casalmaggiore',
      'Casalmorano',
      'Castel Gabbiano',
      'Casteldidone',
      'Castelleone',
      'Castelverde',
      'Castelvisconti',
      'Cella Dati',
      'Chieve',
      'Cicognolo',
      "Cingia de' Botti",
      "Corte de' Cortesi con Cignone",
      "Corte de' Frati",
      'Credera Rubbiano',
      'Crema',
      'Cremosano',
      "Crotta d' Adda",
      'Cumignano sul Naviglio',
      'Derovere',
      'Dovera',
      'Drizzona',
      'Fiesco',
      'Formigara',
      'Gabbioneta Binanuova',
      'Gadesco Pieve Delmona',
      'Genivolta',
      "Gerre de' Caprioli",
      'Gombito',
      'Grontardo',
      'Grumelo Cremonese ed Uniti',
      'Gussola',
      'Isola Dovarese',
      'Izano',
      'Madignano',
      'Martignana di Po',
      'Monte Cremasco',
      'Montodine',
      'Moscazzano',
      'Motta Baluffi',
      'Offanengo',
      'Olmeneta',
      'Ostiano',
      'Paderno Ponchielli',
      'Palazzo Pignano',
      'Pandino',
      'Persico Dosimo',
      'Pescarolo ed Uniti',
      'Pessina Cremonese',
      'Piadena',
      'Pianengo',
      'Pieranica',
      'Pieve San Giacomo',
      "Pieve d' Olmi",
      'Pizzighettone',
      'Pozzaglio ed Uniti',
      'Quintano',
      'Ricengo',
      'Ripalta Arpina',
      'Ripalta Guerina',
      'Rivarolo del Re ed Uniti',
      "Rivolta d' Adda",
      "Robecco d' Oglio",
      'Romanengo',
      'Salvirola',
      'San Bassano',
      'San Daniele Po',
      'San Giovanni in Croce',
      'San Martino del Lago',
      'Scandolara Ravara',
      "Scandolara Ripa d' Oglio",
      'Sergnano',
      'Sesto ed Uniti',
      'Solarolo Rainerio',
      'Soncino',
      'Soresina',
      'Sospiro',
      'Spinadesco',
      'Spineda',
      "Spino d' Adda",
      'Stagno Lombardo',
      'Ticengo',
      'Torlino Vimercati',
      'Tornata',
      "Torre de' Picenardi",
      'Torricella del Pizzo',
      'Trescore Cremasco',
      'Trigolo',
      'Vaiano Cremasco',
      'Vailate',
      'Vescovato',
      'Volongo',
      'Voltido',
    ],
    'IT-KR': [
      'Belvedere di Spinello',
      'Caccuri',
      'Carfizzi',
      'Casabona',
      'Castelsilano',
      'Cerenzia',
      'Ciró',
      'Ciró Marina',
      'Cotronei',
      'Crotone',
      'Crucoli',
      'Cutro',
      'Isola Capo Rizzuto',
      'Melissa',
      'Mesoraca',
      'Pallagorio',
      'Petilia Policastro',
      'Rocca di Neto',
      'Roccabernarda',
      'San Mauro Marchesato',
      "San Nicola dell'Alto",
      'Santa Severina',
      'Savelli',
      'Scandale',
      'Strongoli',
      'Umbriatico',
      'Verzino',
    ],
    'IT-CN': [
      'Acceglio',
      'Aisone',
      'Alba',
      'Albaretto della Torre',
      'Alto',
      'Argentera',
      'Arguello',
      'Bagnasco',
      'Bagnolo Piemonte',
      "Baldissero d' Alba",
      'Barbaresco',
      'Barge',
      'Barolo',
      'Bastia Mondovì',
      'Battifollo',
      'Beinette',
      'Bellino',
      'Belvedere Langhe',
      'Bene Vacienna',
      'Benevello',
      'Bergolo',
      'Bernezzo',
      'Bonvicino',
      'Borgo San Dalmazzo',
      'Borgomale',
      'Bosia',
      'Bossolasco',
      'Boves',
      'Bra',
      'Briaglia',
      'Briga Alta',
      'Brondello',
      'Brossasco',
      'Busca',
      'Camerana',
      'Camo',
      'Canale',
      'Canosio',
      'Caprauna',
      'Caraglio',
      'Caramagna Piemonte',
      'Cards',
      'Carrú',
      'Cartignano',
      'Casalgrasso',
      'Castagnito',
      'Casteldelfino',
      'Casteletto Uzzone',
      'Castellar',
      'Castelletto Stura',
      'Castellinaldo',
      'Castellino Tanaro',
      'Castelmagno',
      'Castelnuovo di Ceva',
      'Castiglione Falletto',
      'Castiglione Tinella',
      'Castino',
      'Cavallerleone',
      'Cavallermaggiore',
      'Centallo',
      'Ceresole Alba',
      'Cerreto Langhe',
      'Cervasca',
      'Cervere',
      'Ceva',
      'Cherasco',
      'Chiusa di Pesio',
      'Ciglié',
      'Cissone',
      'Clavesana',
      "Corneliano d' Alba",
      'Cortemilia',
      'Cossano Belbo',
      'Costiglione Saluzzo',
      'Cravanzana',
      'Crissolo',
      'Cuneo',
      'Demonte',
      "Diano d' Alba",
      'Dogliani',
      'Dronero',
      'Elva',
      'Entracque',
      'Envie',
      'Farigliano',
      'Faule',
      'Feisoglio',
      'Fossano',
      'Frabosa Soprana',
      'Frabosa Sottana',
      'Frassino',
      'Gaiola',
      'Gambasca',
      'Garessio',
      'Genola',
      'Gorzegno',
      'Gottasecca',
      'Govone',
      'Grinzane Cavour',
      'Guarene',
      'Igliano',
      'Isasca',
      'La Morra',
      'Lagnasco',
      'Lequio Berria',
      'Lequio Tanaro',
      'Lesegno',
      'Levice',
      'Limone Piemonte',
      'Lisio',
      'Macra',
      'Magliano Alfieri',
      'Magliano Alpi',
      'Mango',
      'Marene',
      'Marmora',
      'Marsaglia',
      'Martiniana Po',
      'Moiola',
      'Mombarcaro',
      'Monastero di Vasco',
      'Monasterolo Casotto',
      'Monasterolo di Savigliano',
      'Monchiero',
      'Mondoví',
      'Monesiglio',
      "Monforte d' Alba",
      'Montaldo Roero',
      'Montaldo di Mondoví',
      'Montanera',
      'Montelupo Albese',
      'Montemale di Cuneo',
      'Monterosso Grana',
      'Monteu Roero',
      'Montezemolo',
      "Monticello d' Alba",
      'Montá',
      'Moretta',
      'Morozzo',
      'Murazzano',
      'Murello',
      'Narzole',
      'Neive',
      'Neviglie',
      'Niella Belbo',
      'Niella Tanaro',
      'Novello',
      'Nucetto',
      'Oncino',
      'Ormea',
      'Ostana',
      'Paesana',
      'Pagno',
      'Pamparato',
      'Paroldo',
      'Perletto',
      'Perlo',
      'Peveragno',
      'Pezzolo Valle Uzzone',
      'Pianfei',
      'Piasco',
      'Pietraporzio',
      "Piobesi d' Alba",
      'Piozzo',
      'Pocapaglia',
      'Polonghera',
      'Pontechianale',
      'Pradleves',
      'Prazzo',
      'Priero',
      'Priocca',
      'Prunetto',
      'Racconigi',
      'Revello',
      'Rifreddo',
      'Rittana',
      'Roaschia',
      'Roascio',
      'Robilante',
      'Roburent',
      'Rocca Ciglié',
      "Rocca de' Balbi",
      'Roccabruna',
      'Roccaforte Mondoví',
      'Roccasparvera',
      'Roccavione',
      'Rocchetta Belbo',
      'Roddi',
      'Roddino',
      'Rodello',
      'Rossana',
      'Ruffia',
      'Sale San Giovanni',
      'Sale delle Langhe',
      'Saliceto',
      'Salmour',
      'Saluzzo',
      'Sambuco',
      'Sampeyre',
      'San Benedetto Belbo',
      'San Damiano Macra',
      'San Michele Mondoví',
      'Sanfront',
      'Sanfrs',
      "Sant' Albano Stura",
      "Santa Vittoria d' Alba",
      'Santo Stefano Belbo',
      'Santo Stefano Roero',
      'Savigliano',
      'Scagnello',
      'Scarnafigi',
      "Serralunga d' Alba",
      'Serravalle Langhe',
      'Sinio',
      'Somano',
      'Sommariva Perno',
      'Sommariva del Bosco',
      'Stroppo',
      'Tarantasca',
      'Torre Bormida',
      'Torre Mondoví',
      'Torre San Giorgio',
      'Torresina',
      'Treiso',
      'Trezzo Tinella',
      'Trinitá',
      'Valdieri',
      'Valgrana',
      'Valloriate',
      'Valmala',
      'Venasca',
      'Verduno',
      'Vernante',
      'Verzuolo',
      "Vezza d' Alba",
      'Vicoforte',
      'Vignolo',
      'Villafalletto',
      'Villanova Mondoví',
      'Villanova Solaro',
      'Villar San Costanzo',
      'Vinadio',
      'Viola',
      'Vottignasco',
    ],
    'IT-EN': [
      'Agira',
      'Aidone',
      'Assoro',
      'Barrafranca',
      'Calascibetta',
      'Castelferrato',
      'Catenanuova',
      'Centuripe',
      'Cerami',
      'Enna',
      'Gagliano Castelferrato',
      'Leonforte',
      'Nicosia',
      'Nissoria',
      'Piazza Armerina',
      'Pietraperzia',
      'Regalbuto',
      'Sperlinga',
      'Troina',
      'Valguarnera Caropepe',
      'Villarosa',
    ],
    'IT-FM': [
      'Altidona',
      'Amandola',
      'Belmonte Piceno',
      'Campofilone',
      'Falerone',
      'Fermo',
      "Francavilla d' Ete",
      'Grottazzolina',
      'Lapedona',
      'Magliano di Tenna',
      'Massa Fermana',
      'Monsampietro Morico',
      'Montappone',
      'Monte Giberto',
      'Monte Rinaldo',
      'Monte San Pietrangeli',
      'Monte Urano',
      'Monte Vidon Combatte',
      'Monte Vidon Corrado',
      'Montefalcone Appennino',
      'Montefortino',
      'Montegiorgio',
      'Montegranaro',
      'Monteleone di Fermo',
      'Montelparo',
      'Monterubbiano',
      'Montottone',
      'Moresco',
      'Ortezzano',
      'Pedaso',
      'Petritoli',
      'Ponzano di Fermo',
      'Porto San Giorgio',
      "Porto Sant' Elpidio",
      'Rapagnano',
      "Sant'Elpidio a Mare",
      'Santa Vittoria in Matenano',
      'Servigliano',
      'Smerillo',
      'Torre San Patrizio',
    ],
    'IT-FE': [
      'Argenta',
      'Berra',
      'Bondeno',
      'Cento',
      'Codigoro',
      'Comacchio',
      'Copparo',
      'Ferrara',
      'Formignana',
      'Goro',
      'Jolanda di Savoia',
      'Lagosanto',
      'Masi Torello',
      'Massa Fiscaglia',
      'Mesola',
      'Migliarino',
      'Migliaro',
      'Mirabello',
      'Ostellato',
      'Poggio Renatico',
      'Portomaggiore',
      'Ro',
      "Sant' Agostino",
      'Tresigallo',
      'Vigarano Mainarda',
      'Voghiera',
    ],
    'IT-FI': [
      'Bagno a Ripoli',
      "Barberino Val d'Elsa",
      'Barberino di Mugello',
      'Borgo San Lorenzo',
      'Calenzano',
      'Campi Bisenzio',
      'Capraia e Limite',
      'Castelfiorentino',
      'Cerreto Guidi',
      'Certaldo',
      'Dicomano',
      'Empoli',
      'Fiesole',
      'Figline e Incisa Valdarno',
      'Firenzuola',
      'Fucecchio',
      'Gambassi Terme',
      'Greve in Chianti',
      'Impruneta',
      'Lamole',
      'Lastra a Signa',
      'Londa',
      'Marradi',
      'Mercatale Val di Pesa',
      'Montaione',
      'Montelupo Fiorentino',
      'Montespertoli',
      'Palazzuolo sul Senio',
      'Panzano',
      'Pelago',
      'Pontassieve',
      'Reggello',
      "Rignano sull'Arno",
      'Rufina',
      'San Casciano in Val di Pesa',
      'San Donato in Poggio',
      'San Godenzo',
      'San Piero a Sieve',
      'San Polo in Chianti',
      'Scandicci',
      'Scarperia',
      'Sesto Fiorentino',
      'Signa',
      'Tavernelle Val di Pesa',
      'Vaglia',
      'Vicchio',
      'Vinci',
    ],
    'IT-FG': [
      'Accadia',
      'Alberona',
      'Anzano di Puglia',
      'Apricena',
      'Ascoli Satriano',
      'Biccari',
      'Bovino',
      'Cagnano Varano',
      'Candela',
      'Carapelle',
      'Carlantino',
      'Carpino',
      'Casalnuovo Monterotaro',
      'Casalvecchio di Puglia',
      'Castelluccio Valmaggiore',
      'Castelluccio dei Sauri',
      'Castelnuovo della Daunia',
      'Celenza Valfortore',
      'Celle di San Vito',
      'Cerignola',
      'Chieuti',
      'Deliceto',
      'Faeto',
      'Foggia',
      'Ischitella',
      'Isole Tremiti',
      'Lesina',
      'Lucera',
      'Manfredonia',
      'Margherita di Savoia',
      'Mattinata',
      'Monteleone di Puglia',
      'Motta Montecorvino',
      'Ordonia',
      'Orsara di Puglia',
      'Ortanova',
      'Panni',
      'Peschici',
      'Pietra Montecorvino',
      'Poggio Imperiale',
      'Rignano Garganico',
      'Rocchetta S. Antonio',
      'Rodi Garganico',
      'Roseto Valfortore',
      'San Ferdinando di Puglia',
      'San Giovanni Rotondo',
      'San Marco La Catola',
      'San Marco in Lamis',
      'San Paolo di Civitate',
      'San Severo',
      'Sannicandro Garganico',
      "Sant' Agata di Puglia",
      'Serracapriola',
      'Stornara',
      'Stornarella',
      'Torremaggiore',
      'Trinitapoli',
      'Troia',
      'Vico del Gargano',
      'Vieste',
      'Volturara Appula',
      'Volturino',
      'Zapponeta',
    ],
    'IT-FO': [
      'Bagno di Romagna',
      'Bertinoro',
      'Borghi',
      'Castrocaro Terme e Terra del Sole',
      'Cesena',
      'Cesenatico',
      'Civitella di Romagna',
      'Dovadola',
      'Forli',
      'Forlimpopoli',
      'Galeata',
      'Gambettola',
      'Gatteo',
      'Longiano',
      'Meldola',
      'Mercato Saraceno',
      'Modigliana',
      'Montiano',
      'Permilcuore',
      'Portico e San Benedetto',
      'Predappio',
      'Rocca San Casciano',
      'Roncofreddo',
      'San Mauro Pascoli',
      'Santa Sofia',
      'Sarsina',
      'Savignano sul Rubicone',
      'Sogliano al Rubicone',
      'Tredozio',
      'Verghereto',
    ],
    'IT-FR': [
      'Acquafondata',
      'Acuto',
      'Alatri',
      'Alvito',
      'Amaseno',
      'Anagni',
      'Aquino',
      'Arce',
      'Arnara',
      'Arpino',
      'Atina',
      'Ausonia',
      'Belmonte Castello',
      'Boville Ernica',
      'Broccostella',
      'Campoli Appennino',
      'Casalattico',
      'Casalvieri',
      'Cassino',
      'Castelliri',
      'Castelnuovo Parano',
      'Castro dei Volsci',
      'Castrocielo',
      'Ceccano',
      'Ceprano',
      'Cervaro',
      'Colfelice',
      'Colle San Magno',
      'Collepardo',
      'Coreno Ausonio',
      'Esperia',
      'Falvaterra',
      'Ferentino',
      'Filettino',
      'Fiuggi',
      'Fontana Liri',
      'Fontechiari',
      'Frosinone',
      'Fumone',
      'Gallinaro',
      'Giuliano di Roma',
      'Guarcino',
      'Isola del Liri',
      'Monte San Giovanni Campano',
      'Morolo',
      'Paliano',
      'Pastena',
      'Patrica',
      'Pescosolido',
      'Picinisco',
      'Pico',
      'Piedimonte San Germano',
      'Piglio',
      'Pignataro Interamna',
      'Pofi',
      'Pontecorvo',
      'Posta Fibreno',
      'Ripi',
      "Rocca d' Arce",
      'Roccasecca',
      'San Biagio Saracinisco',
      'San Donato Val di Comino',
      'San Giorgio a Liri',
      'San Giovanni Incarico',
      'San Vittore del Lazio',
      "Sant' Ambrogio sul Garigliano",
      "Sant' Andrea del Garigliano",
      "Sant' Apollinare",
      "Sant' Elia Fiumerapido",
      'Santopadre',
      'Serrone',
      'Settefrati',
      'Sgurgola',
      'Stragolagalli',
      'Supino',
      'Terelle',
      'Torre Cajetani',
      'Torrice',
      'Trevi nel Lazio',
      'Trivigliano',
      'Vallecorsa',
      'Vallemaio',
      'Vallerotonda',
      'Veroli',
      'Vicalvi',
      'Vico nel Lazio',
      'Villa Latina',
      'Villa Santa Lucia',
      'Villa Santo Stefano',
      'Viticuso',
    ],
    'IT-GO': [
      'Capriva del Friuli',
      'Cormons',
      'Doberdò del Lago',
      'Dolegna del Collio',
      "Farra d' Isonzo",
      'Fogliano Redipuglia',
      'Gorizia',
      "Gradisca d'Isonzo",
      'Grado',
      'Mariano del Friuli',
      'Medea',
      'Monfalcone',
      'Moraro',
      'Mossa',
      "Romans d' Isonzo",
      'Ronchi dei Legionari',
      'Sagrado',
      "San Canzian d' Isonzo",
      'San Floriano del Collio',
      'San Lorenzo Isontino',
      "San Pier d' Isonzo",
      "Savogna d' Isonzo",
      'Staranzano',
      'Turriaco',
      'Villesse',
    ],
    'IT-GR': [
      'Alberese',
      'Albinia',
      'Arcidosso',
      'Campagnatico',
      'Capalbio',
      'Castel del Piano',
      "Castell'Azzara",
      'Castiglione della Pescaia',
      'Cinigiano',
      'Civitella Paganico',
      'Follonica',
      'Gavorrano',
      'Grosseto',
      'Isola del Giglio',
      'Magliano in Toscana',
      'Manciano',
      'Massa Marittima',
      'Monte Argentario',
      'Monterotondo Marittimo',
      'Montieri',
      'Orbetello',
      'Pitigliano',
      'Roccalbegna',
      'Roccastrada',
      'Santa Fiora',
      'Scansano',
      'Scarlino',
      'Seggiano',
      'Semproniano',
      'Sorano',
    ],
    'IT-GE': [
      'Arenzano',
      'Avegno',
      'Bargagli',
      'Bogliasco',
      'Borzonasca',
      'Busalla',
      'Camogli',
      'Campo Ligure',
      'Campomorone',
      'Carasco',
      'Casarza Ligure',
      'Casella',
      'Castiglione Chiavarese',
      'Ceranesi',
      'Chiavari',
      'Cicagna',
      'Cogoleto',
      'Cogorno',
      'Coreglia Ligure',
      'Crocefieschi',
      'Davagna',
      'Fascia',
      'Favale di Malvaro',
      'Fontanigorda',
      'Gorreto',
      'Isola del Cantone',
      'Lavagna',
      'Leivi',
      'Lerici',
      'Lorsica',
      'Lumarzo',
      'Masone',
      'Mele',
      'Mezzanego',
      'Mignanego',
      'Moconesi',
      'Moneglia',
      'Montebruno',
      'Montoggio',
      'Ne',
      'Neirone',
      'Orero',
      'Pieve Ligure',
      'Portofino',
      'Propata',
      'Rapallo',
      'Recco',
      'Rezzoaglio',
      'Ronco Scrivia',
      'Rondanina',
      'Rossiglione',
      'Rovegno',
      'San Colombano Certenoli',
      "Sant' Olcese",
      'Santa Margherita Ligure',
      "Santo Stefano d' Aveto",
      'Savignone',
      'Serra Riccó',
      'Sestri Levante',
      'Sori',
      'Tiglieto',
      'Torriglia',
      'Tribogna',
      'Uscio',
      'Valbrevenna',
      'Vobbia',
      'Zoagli',
    ],
    'IT-IM': [
      'Airole',
      'Apricale',
      'Aquila di Arroscia',
      'Armo',
      'Aurigo',
      'Badalucco',
      'Baiardo',
      'Bordighera',
      "Borghetto d' Arroscia",
      'Borgomaro',
      'Camporosso',
      'Caravonica',
      'Carpasio',
      'Castel Vittorio',
      'Castellaro',
      'Ceriana',
      'Cesio',
      'Chiusanico',
      'Chiusavecchia',
      'Cipressa',
      'Civezza',
      'Cosio di Arroscia',
      'Costarainera',
      'Diano Arentino',
      'Diano Castello',
      'Diano Marina',
      'Diano San Pietro',
      'Dolceacqua',
      'Dolcedo',
      'Imperia',
      'Isolabona',
      'Lucinasco',
      'Mendatica',
      'Molini di Triora',
      'Montalto Ligure',
      'Montegrosso Pian Latte',
      'Olivetta San Michele',
      'Ospedaletti',
      'Perinaldo',
      'Pietrabruna',
      'Pieve di Teco',
      'Pigna',
      'Pompeiana',
      'Pontedassio',
      'Pornassio',
      'Prelá',
      'Ranzo',
      'Rezzo',
      'Riva Ligure',
      'Rocchetta Nervina',
      'San Bartolomeo al Mare',
      'San Biagio della Cima',
      'San Lorenzo al Mare',
      'San Remo',
      'Santo Stefano al Mare',
      'Seborga',
      'Soldano',
      'Taggia',
      'Terzorio',
      'Triora',
      'Vallebona',
      'Vallecrosia',
      'Vasia',
      'Ventimiglia',
      'Vessalico',
      'Villa Faraldi',
    ],
    'IT-IS': [
      "Acquaviva d'Isernia",
      'Agnone',
      'Bagnoli del Trigno',
      'Belmonte del Sannio',
      'Cantalupo nel Sannio',
      'Capracotta',
      'Carovilli',
      'Carpinone',
      'Castel San Vincenzo',
      'Castel del Giudice',
      'Castelpetroso',
      'Castelpizzuto',
      'Castelverrino',
      'Cerro al Volturno',
      'Chiauci',
      'Civitanova del Sannio',
      'Colli a Volturno',
      'Conca Casale',
      'Filignano',
      'Forlì del Sannio',
      'Fornelli',
      'Frosolone',
      'Isernia',
      'Longano',
      "Macchia d' Isernia",
      'Macchiagodena',
      'Montaquila',
      'Montenero Val Cocchiara',
      'Monteroduni',
      'Pesche',
      'Pescolanciano',
      'Pescopennataro',
      'Pettoranello del Molise',
      'Pietrabbondante',
      'Pizzone',
      'Poggio Sannita',
      'Pozzilli',
      'Rionero Sannitico',
      'Roccamandolfi',
      'Roccasicura',
      'Rocchetta a Volturno',
      'San Pietro Avellana',
      "Sant' Agapito",
      "Sant' Angelo del Pesco",
      "Sant' Elena Sannita",
      'Santa Maria del Molise',
      'Scapoli',
      'Sessano del Molise',
      'Sesto Campano',
      'Vastogirardi',
      'Venafro',
    ],
    'IT-AQ': [
      'Abruzzi',
      'Acciano',
      'Aielli',
      'Alfedena',
      'Anversa degli Abruzzi',
      'Ateleta',
      'Avezzano',
      'Balsorano',
      'Barete',
      'Barisciano',
      'Barrea',
      'Bisegna',
      'Bugnana',
      'Cagnano Amiterno',
      'Calascio',
      'Campo Imperatore',
      'Campo di Giove',
      'Campotosto',
      'Canistro',
      'Cansano',
      'Capestrano',
      'Capistrello',
      'Capitignano',
      'Caporciano',
      'Cappadocia',
      'Carapelle Calvisio',
      'Carsoli',
      'Castel del Monte',
      'Castel di Ieri',
      'Castel di Sangro',
      'Castellafiume',
      'Castelvecchio Calvisio',
      'Castelvecchio Subequo',
      'Celano',
      'Cerchio',
      "Civita d' Antino",
      'Civitella Alfedena',
      'Civitella Roveto',
      'Cocullo',
      'Collarmele',
      'Collelongo',
      'Collepietro',
      'Corfinio',
      'Fagnano Alto',
      'Fontecchio',
      'Fossa',
      'Gagliano Aterno',
      'Gioia dei Marsi',
      'Goriano Sicoli',
      'Introdacqua',
      "L'Aquila",
      'Lecce nei Marsi',
      'Luco dei Marsi',
      'Lucoli',
      "Magliano de' Marsi",
      "Massa d' Albe",
      'Molina Eterno',
      'Montereale',
      'Morino',
      'Navelli',
      'Ocre',
      'Ofena',
      'Opi',
      'Oricola',
      'Ortona dei Marsi',
      'Ortucchio',
      'Ovindoli',
      'Pacentro',
      'Pereto',
      'Pescasseroli',
      'Pescina',
      'Pescocostanzo',
      'Pettorano sul Gizio',
      'Pizzoli',
      'Poggio Picenze',
      "Prata d' Ansidonia",
      'Pratola Peligna',
      'Prezza',
      'Raiano',
      'Rivisondoli',
      'Rocca Pia',
      'Rocca di Botte',
      'Rocca di Cambio',
      'Rocca di Mezzo',
      'Roccacasale',
      'Roccaraso',
      'Roveto',
      'San Benedetto dei Marsi',
      'San Benedetto in Perillis',
      "San Demetrio ne' Vestini",
      'San Pio delle Camere',
      'San Vincenzo Valle',
      "Sant' Eusanio Forconese",
      'Sante Marie',
      'Scanno',
      'Scontrone',
      'Scoppito',
      'Scurcola Marsicana',
      'Secinaro',
      'Sessanio',
      'Sulmona',
      'Tagliacozzo',
      'Tione degli Abruzzi',
      'Tornimparte',
      'Trasacco',
      "Villa Sant'Angelo",
      'Villa Santa Lucia degli Abruzzi',
      'Villalago',
      'Villavallelonga',
      'Villetta Barrea',
      'Vittorito',
    ],
    'IT-SP': [
      'Ameglia',
      'Arcola',
      'Beverino',
      'Bolano',
      'Bonassola',
      'Borghetto di Vara',
      'Brugnato',
      'Calice al Cornoviglio',
      'Carro',
      'Carrodano',
      'Castelnuovo Magra',
      'Deiva Marina',
      'Follo',
      'Framura',
      'La Spezia',
      'Levanto',
      'Maissana',
      'Monterosso al Mare',
      'Ortonovo',
      'Pignone',
      'Portovenere',
      'Riccò del Golfo di La Spezia',
      'Riomaggiore',
      'Rocchetta di Vara',
      'Santo Stefano di Magra',
      'Sarzana',
      'Sesta Godano',
      'Varese Ligure',
      'Vernazza',
      'Vezzano Ligure',
      'Zignago',
    ],
    'IT-LT': [
      'Aprilia',
      'Bassiano',
      'Campodimele',
      'Castelforte',
      'Cisterna di Latina',
      'Cori',
      'Fondi',
      'Formia',
      'Gaeta',
      'Itri',
      'Latina',
      'Lenola',
      'Maenza',
      'Minturno',
      'Monte San Biagio',
      'Norma',
      'Pontinia',
      'Ponza',
      'Priverno',
      'Prossedi',
      'Rocca Massima',
      'Roccagorga',
      'Roccasecca dei Volsci',
      'Sabaudia',
      'San Felice Circeo',
      'Santi Cosma e Damiano',
      'Sermoneta',
      'Sezze',
      'Sonnino',
      'Sperlonga',
      'Spigno Saturnia',
      'Terracina',
      'Ventotene',
    ],
    'IT-LE': [
      'Acquarica del Capo',
      'Alessano',
      'Alezio',
      'Alliste',
      'Andrano',
      'Aradeo',
      'Arnesano',
      'Bagnolo del Salento',
      'Botrugno',
      'Calimera',
      'Campi Salentina',
      'Cannole',
      'Capranica di Lecce',
      'Carmiano',
      'Carpignano Salentino',
      'Casarano',
      'Castri di Lecce',
      'Castrignano de Greci',
      'Castrignano del Capo',
      'Catro',
      'Cavallino',
      'Collepasso',
      'Copertino',
      "Corigliano d' Otranto",
      'Corsano',
      'Cursi',
      'Cutrofiano',
      'Diso',
      'Gagliano del Capo',
      'Galatina',
      'Galatone',
      'Gallipoli',
      'Giuggianello',
      'Giurdignano',
      'Guagnano',
      'Lecce',
      'Lequile',
      'Leverano',
      'Lizzanello',
      'Maglie',
      'Martano',
      'Martignano',
      'Matino',
      'Melendugno',
      'Melissano',
      'Melpignano',
      'Miggiano',
      'Minervino di Lecce',
      'Monteroni di Lecce',
      'Montesano Salentino',
      'Morciano di Leuca',
      'Muro Leccese',
      'Nardo',
      'Neviano',
      'Nociglia',
      'Novoli',
      'Ortelle',
      'Otranto',
      'Palmariggi',
      'Parabita',
      'Patú',
      'Poggiardo',
      'Porto Cesareo',
      'Presicce',
      'Racale',
      'Ruffano',
      'Salice Salentino',
      'Salve',
      'San Cassiano',
      'San Cesario di Lecce',
      'San Donato di Lecce',
      'San Pietro in Lama',
      'Sanarica',
      'Sannicola',
      'Santa Cesarea Terme',
      'Scorrano',
      'Seclì',
      'Sogliano Cavour',
      'Soleto',
      'Specchia',
      'Spongano',
      'Squinzano',
      'Sternatia',
      'Supersano',
      'Surano',
      'Surbo',
      'Taurisano',
      'Taviano',
      'Tiggiano',
      'Trepuzzi',
      'Tricase',
      'Tuglie',
      'Ugento',
      'Uggiano La Chiesa',
      'Veglie',
      'Vernole',
      'Zollino',
    ],
    'IT-LC': [
      'Abbadia Lariana',
      'Airuno',
      'Annone di Brianza',
      'Ballabio',
      'Barzago',
      'Barzanó',
      'Barzio',
      'Bellano',
      'Brivio',
      'Bulciago',
      'Calco',
      'Calolziocorte',
      'Carenno',
      'Casargo',
      'Casatenovo',
      'Cassago Brianza',
      'Cassina Valsassina',
      'Castello di Brianza',
      'Cernusco Lombardone',
      'Cesana di Brianza',
      'Civate',
      'Colico',
      'Colle Brianza',
      'Costa Masnaga',
      'Crandola Valsassina',
      'Cremella',
      'Cremeno',
      'Dervio',
      'Dolzago',
      'Dorio',
      'Ello',
      'Erve',
      'Esino Lario',
      'Galbiate',
      'Garbagnate Monastero',
      'Garlate',
      'Imbersago',
      'Introbio',
      'Introzzo',
      'Lecco',
      'Lierna',
      'Lomagna',
      'Malgrate',
      'Mandello del Lario',
      'Margno',
      'Merate',
      'Missaglia',
      'Moggio',
      'Molteno',
      'Monte Marenzo',
      'Montevecchia',
      'Monticello Brianza',
      'Morterone',
      'Nibbionno',
      'Oggiono',
      'Olgiate Molgora',
      'Olginate',
      'Oliveto Lario',
      'Osnago',
      "Paderno d' Adda",
      'Pagnona',
      'Parlasco',
      'Pasturo',
      'Perego',
      'Perledo',
      'Pescate',
      'Premana',
      'Primaluna',
      'Robbiate',
      'Rovagnate',
      'Santa Maria Hoé',
      'Sirone',
      'Sirtori',
      'Sueglio',
      'Suello',
      'Taceno',
      'Torre de Busi',
      'Tremenico',
      'Valgreghentino',
      'Valmadrera',
      'Varenna',
      'Vendrogno',
      'Vercurago',
      'Verderio Inferiore',
      'Verderio Superiore',
      'Vestreno',
      'Viganó',
    ],
    'IT-LI': [
      'Abbadia Cerreto',
      'Bertonico',
      'Bibbona',
      "Boffalora d' Adda",
      'Borghetto Lodigiano',
      'Borgo San Giovanni',
      'Brembio',
      'Camairago',
      'Campiglia Marittima',
      "Campo nell'Elba",
      'Capoliveri',
      'Capraia Isola (Isla)',
      'Casaletto Lodigiano',
      'Casalmaiocco',
      'Casalpusterlengo',
      'Caselle Landi',
      'Caselle Lurani',
      'Castagneto Carducci',
      "Castelnuovo Bocca d' Adda",
      'Castiglioncello',
      "Castiglione d' Adda",
      'Castiraga Vidardo',
      'Cavacurta',
      "Cavenago d' Adda",
      'Cecina',
      "Cervignano d' Adda",
      'Codogno',
      'Collesalvetti',
      'Comazzo',
      'Cornegliano Laudense',
      'Corno Giovine',
      'Cornovecchio',
      'Corte Palasio',
      'Crespiatica',
      'Fombio',
      'Galgagnano',
      'Graffignana',
      'Guardamiglio',
      'Livorno',
      'Livraga',
      'Lodi',
      'Lodivecchio',
      'Maccastorna',
      'Mairago',
      'Maleo',
      'Marciana',
      'Marciana Marina',
      'Marudo',
      'Massalengo',
      'Meleti',
      'Merlino',
      'Montanaso Lombardo',
      'Mulazzano',
      'Orio Litta',
      'Ospedaletto Lodigiano',
      'Ossago Lodigiano',
      'Pieve Fissiraga',
      'Piombino',
      'Porto Azzurro',
      'Portoferraio',
      'Rio Marina',
      "Rio nell'Elba",
      'Rosignano Marittimo',
      'Salerano sul Lambro',
      'San Fiorano',
      'San Martino in Strada',
      'San Rocco al Porto',
      'San Vincenzo',
      "Sant' Angelo Lodigiano",
      'Santo Stefano Lodigiano',
      'Sassetta',
      'Secugnago',
      'Senna Lodigiana',
      'Somaglia',
      'Sordio',
      'Suvereto',
      'Tavazzano con Villavesco',
      'Terranova dei Passerini',
      'Turano Lodigiano',
      'Valera Fratta',
      'Venturina',
      'Villanova del Sillaro',
      'Zelo Buon Persico',
    ],
    'IT-LO': [],
    'IT-LU': [
      'Altopascio',
      'Bagni di Lucca',
      'Borgo a Mozzano',
      'Camaiore',
      'Camporgiano',
      'Capannori',
      'Careggine',
      'Castelnuovo di Garfagnana',
      'Castiglione di Garfagnana',
      'Coreglia Antelminelli',
      'Diecimo',
      'Fabbriche di Vallico',
      'Fagnano',
      'Forte dei Marmi',
      'Fosciandora',
      'Gallicano',
      'Giuncugnano',
      'Lucca',
      'Massarosa',
      'Minucciano',
      'Molazzana',
      'Pescaglia',
      'Piazza al Serchio',
      'Pietrasanta',
      'Pieve Fosciana',
      'Porcari',
      'San Romano in Garfagnana',
      'Seravezza',
      'Sillano',
      'Stazzema',
      'Vagli Sotto',
      'Vergemoli',
      'Viareggio',
      'Villa Basilica',
      'Villa Collemandina',
    ],
    'IT-MC': [
      'Acquacanina',
      'Apiro',
      'Appignano',
      'Belforte del Chienti',
      'Bolognola',
      'Caldarola',
      'Camerino',
      'Camporotondo di Fiastrone',
      'Castelraimondo',
      'Castelsantangelo sul Nera',
      'Cessapalombo',
      'Cingoli',
      'Civitanova Marche',
      'Colmurano',
      'Corridonia',
      'Esanatoglia',
      'Fiastra',
      'Fiordimonte',
      'Fiuminata',
      'Gagliole',
      'Gualdo',
      'Loro Piceno',
      'Macerata',
      'Matelica',
      'Mogliano',
      'Monte Cavallo',
      'Monte San Giusto',
      'Monte San Martino',
      'Montecassiano',
      'Montecosaro',
      'Montefano',
      'Montelupone',
      'Morrovalle',
      'Muccia',
      'Penna San Giovanni',
      'Petriolo',
      'Pieve Torina',
      'Pievebovigliana',
      'Pioraco',
      'Poggio San Vicino',
      'Pollenza',
      'Potenza Picena',
      'Ripe San Ginesio',
      'San Ginesio',
      'San Severino Marche',
      "Sant' Angelo in Pontano",
      'Sarnano',
      'Sefro',
      'Serrapetrona',
      'Serravalle di Chieti',
      'Tolentino',
      'Treia',
      'Urbisaglia',
      'Ussita',
      'Visso',
    ],
    'IT-MN': [
      'Acquanegra sul Chiese',
      'Asola',
      'Bagnolo San Vito',
      'Bigarello',
      'Borgoforte',
      'Borgofranco sul Po',
      'Bozzolo',
      "Canneto sull' Oglio",
      'Carbonara di Po',
      'Casalmoro',
      'Casaloldo',
      'Casalromano',
      'Castel Goffredo',
      "Castel d' Ario",
      'Castelbelforte',
      'Castellucchio',
      'Castiglione delle Stiviere',
      'Cavriana',
      'Ceresara',
      'Commessaggio',
      'Curtatone',
      'Dosolo',
      'Felonica',
      'Gazoldo degli Ippoliti',
      'Gazzuolo',
      'Goito',
      'Guidizzolo',
      'Magnacavallo',
      'Mantova',
      'Marcaria',
      'Mariana Mantovana',
      'Marmirolo',
      'Medole',
      'Moglia',
      'Monzambano',
      'Mottegiana',
      'Ostiglia',
      'Pegognaga',
      'Pieve di Coriano',
      'Piubega',
      'Poggio Rusco',
      'Pomponesco',
      'Ponti sul Mincio',
      'Porto Mantovano',
      'Quingentole',
      'Quistello',
      'Redondesco',
      'Revere',
      'Rivarolo Mantovano',
      'Rodigo',
      'Roncoferraro',
      'Roverbella',
      'Sabbioneta',
      'San Benedetto Po',
      'San Giacomo delle Segnate',
      'San Giorgio di Mantova',
      'San Giovanni del Dosso',
      "San Martino dell' Argine",
      'Schivenoglia',
      'Sermide',
      'Serravale a Po',
      'Solferino',
      'Sustinente',
      'Suzzara',
      'Viadana',
      'Villa Poma',
      'Villimpenta',
      'Virgilio',
      'Volta Mantovana',
    ],
    'IT-MS': [
      'Aulla',
      'Bagnone',
      'Carrara',
      'Casola in Lunigiana',
      'Comano',
      'Filattiera',
      'Fivizzano',
      'Fosdinovo',
      'Licciana Nardi',
      'Marina di Massa',
      'Massa',
      'Montignoso',
      'Mulazzo',
      'Podenzana',
      'Pontremoli',
      'Tresana',
      'Villafranca in Lunigiana',
      'Zeri',
    ],
    'IT-MT': [
      'Accettura',
      'Aliano',
      'Bernalda',
      'Calciano',
      'Cirigliano',
      'Colobraro',
      'Craco',
      'Ferrandina',
      'Garaguso',
      'Gorgoglione',
      'Grassano',
      'Grottole',
      'Irsina',
      'Matera',
      'Miglionico',
      'Montalbano Jonico',
      'Montescaglioso',
      'Nova Siri',
      'Oliveto Lucano',
      'Pisticci',
      'Policoro',
      'Pomarico',
      'Rotondella',
      'Salandra',
      'San Giorgio Lucano',
      'San Mauro Forte',
      'Scanzano Jonico',
      'Stigliano',
      'Tricarico',
      'Tursi',
      'Valsinni',
    ],
    'IT-VS': [
      'Arbus',
      'Barumini',
      'Collinas',
      'Furtei',
      'Genuri',
      'Gonnosfanadiga',
      'Guspini',
      'Las Plassas',
      'Lunamatrona',
      'Pabillonis',
      'Pauli Arbarei',
      'Samassi',
      'San Gavino Monreale',
      'Sanluri',
      'Sardara',
      'Segariu',
      'Serramanna',
      'Serrenti',
      'Setzu',
      'Siddi',
      'Tuili',
      'Turri',
      'Ussaramanna',
      'Villacidro',
      'Villamar',
      'Villanovaforru',
      'Villanovafranca',
    ],
    'IT-ME': [
      'Acquedolci',
      'Alcara Lifusi',
      'Aliterme',
      'Alì',
      'Antillo',
      'Barcellona Pozzo di Gotto',
      'Basicó',
      'Brolo',
      'Capizzi',
      "Capo d'Orlando",
      'Caprileone',
      'Caronia',
      'Casalvecchio Siculo',
      'Castel di Lucio',
      "Castell'Umberto",
      'Castelmola',
      'Catroreale',
      'Cesaro',
      'Condró',
      'Eolie Isole (Islas Eolias)',
      'Falcone',
      'Ficarra',
      'Fiumedinisi',
      'Fondachelli Fantina',
      "Forza d'Agró",
      'Francavilla di Sicilia',
      'Frazzanó',
      'Furci Siculo',
      'Furnari',
      'Gaggi',
      'Galati',
      'Gallodoro',
      'Giardini Naxos',
      'Ginostra',
      'Gioiosa Marea',
      'Graniti',
      'Gualtieri Sicaminó',
      'Itala',
      'Leni',
      'Letojanni',
      'Librizzi',
      'Limina',
      'Lipari',
      'Longi',
      'Malfa',
      'Malvagna',
      'Mandanici',
      "Mazzarrà Sant'Andrea",
      'Merí',
      'Messina',
      'Milazzo',
      'Militello Rosmarino',
      'Mirto',
      'Mistretta',
      'Mojo Alcantara',
      'Monforte San Giorgio',
      'Mongiuffi Melia',
      'Montagnareale',
      'Montalbano Elicona',
      'Motta Camastra',
      "Motta d'Affermo",
      'Naso',
      'Nizza di Sicilia',
      'Novara di Sicilia',
      'Oliveri',
      'Pace del Mela',
      'Pagliara',
      'Pettineo',
      'Piraino',
      'Raccuja',
      'Reitano',
      'Roccafiorita',
      'Roccalumera',
      'Roccavaldina',
      'Roccella Valdemone',
      'Rodi Milici',
      'Rometta',
      'San Filippo del Mela',
      'San Fratello',
      "San Marco D'Alunzio",
      'San Pier Niceto',
      'San Piero Patti',
      'San Salvatore Di Fitalia',
      'San Teodoro',
      "Sant'Agata di Militello",
      "Sant'Alessio Siculo",
      "Sant'Angelo di Brolo",
      'Santa Domenica Vittoria',
      'Santa Lucia del Mela',
      'Santa Marina Salina',
      'Santa Teresa di Riva',
      'Santo Stefano di Camastra',
      'Saponara',
      'Savoca',
      'Scaletta Zanclea',
      'Sinagra',
      'Spadafora',
      'Taormina',
      'Terme Vigliatore',
      'Torregrotta',
      'Torrenova',
      'Tortorici',
      'Tripi',
      'Tusa',
      'Ucria',
      'Valdina',
      'Venetico',
      'Villafranca Tirrena',
    ],
    'IT-MI': [
      'Abbiategrasso',
      'Agrate Brianza',
      'Aicurzio',
      'Albairate',
      'Albiate',
      'Arconate',
      'Arcore',
      'Arese',
      'Arluno',
      'Assago',
      'Bareggio',
      'Barlassina',
      'Basiano',
      'Basiglio',
      'Bellinzago Lombardo',
      'Bellusco',
      'Bernareggio',
      'Bernate Ticino',
      'Besana in Brianza',
      'Besate',
      'Biassono',
      'Binasco',
      'Boffalora sopra Ticino',
      'Bollate',
      'Bovisio Masciago',
      'Bresso',
      'Briosco',
      'Brugherio',
      'Bubbiano',
      'Buccinasco',
      'Burago di Molgora',
      'Buscate',
      'Busnago',
      'Bussero',
      'Busto Garolfo',
      'Calvignasco',
      'Cambiago',
      'Camparada',
      'Canegrate',
      'Caponago',
      'Carate Brianza',
      'Carnate',
      'Carpiano',
      'Carugate',
      'Casarile',
      'Casorezzo',
      "Cassano d' Adda",
      "Cassina de' Pecchi",
      'Cassinetta di Lugagnano',
      'Castano Primo',
      'Cavenago di Brianza',
      'Ceriano Laghetto',
      'Cernusco sul Naviglio',
      'Cerro Maggiore',
      'Cerro al Lambro',
      'Cesano Boscone',
      'Cesano Maderno',
      'Cesate',
      'Cinisello Balsamo',
      'Cisliano',
      'Cogliate',
      'Cologno Monzese',
      'Colturano',
      'Concorezzo',
      'Coprezzana',
      'Corbetta',
      'Cormano',
      'Cornaredo',
      "Cornate d' Adda",
      'Corsico',
      'Cuggiono',
      'Cusago',
      'Cusano Milanino',
      'Dairago',
      'Desio',
      'Dresano',
      'Gaggiano',
      'Garbagnate Milanese',
      'Gessate',
      'Giussano',
      'Gorgonzola',
      'Grezzago',
      'Gudo Visconti',
      'Inveruno',
      'Inzago',
      'Lacchiarella',
      'Lainate',
      'Lazzate',
      'Legnano',
      'Lentate sul Seveso',
      'Lesmo',
      'Limbiate',
      'Liscate',
      'Lissone',
      'Locate di Triulzi',
      'Macherio',
      'Magenta',
      'Magnago',
      'Marcallo con Casone',
      'Masate',
      'Meda',
      'Mediglia',
      'Melegnano',
      'Melzo',
      'Mesero',
      'Mezzago',
      'Milan',
      'Misinto',
      'Monza',
      'Morimondo',
      'Motta Visconti',
      'Muggió',
      'Nerviano',
      'Nosate',
      'Nova Milanese',
      'Novate Milanese',
      'Noviglio',
      'Opera',
      'Ornago',
      'Ossona',
      'Ozzero',
      'Paderno Dugnano',
      'Pantigliate',
      'Parabiago',
      'Paullo',
      'Pero',
      'Peschiera Borromeo',
      'Pessano con Bornago',
      'Pieve Emanuele',
      'Pioltello',
      'Pogliano Milanese',
      "Pozzo d' Adda",
      'Pozzuolo Martesana',
      'Pregnana Milanese',
      'Renate',
      'Rescaldina',
      'Rho',
      'Robecchetto con Induno',
      'Robecco sul Naviglio',
      'Rodano',
      'Roncello',
      'Ronco Briantino',
      'Rosate',
      'Rozzano',
      'San Colombano al Lambro',
      'San Donato Milanese',
      'San Giorgio su Legnano',
      'San Giuliano Milanese',
      'San Vittore Olona',
      'San Zenone al Lambro',
      'Santo Stefano Ticino',
      'Sedriano',
      'Segrate',
      'Senago',
      'Seregno',
      'Sesto San Giovanni',
      'Settala',
      'Settimo Milanese',
      'Seveso',
      'Solaro',
      'Sovico',
      'Sulbiate',
      'Trezzano Rosa',
      'Trezzano sul Naviglio',
      "Trezzo sull' Adda",
      'Tribiano',
      'Triuggio',
      'Trucazzano',
      'Turbigo',
      'Usmate Velate',
      'Vanzaghello',
      'Vanzago',
      "Vaprio d' Adda",
      'Varedo',
      'Vedano al Lambro',
      'Veduggio con Colzano',
      'Verano Brianza',
      'Vermezzo',
      'Vernate',
      'Vignate',
      'Villa Cortese',
      'Villasanta',
      'Vimercate',
      'Vimodrone',
      'Vittuone',
      'Vizzolo Predabissi',
      'Zelo Surrigone',
      'Zibido San Giacomo',
    ],
    'IT-MO': [
      'Bastiglia',
      'Bomporto',
      'Campogalliano',
      'Camposanto',
      'Carpi',
      'Castelfranco Emilia',
      'Castelnuovo Rangone',
      'Castelvetro di Modena',
      'Cavezzo',
      'Concordia sulla Secchia',
      'Fanano',
      'Finale Emilia',
      'Fiorano Modenese',
      'Fiumalbo',
      'Formigine',
      'Frassinoro',
      'Guiglia',
      'Lama Mocogno',
      'Maranello',
      'Marano sul Panaro',
      'Medolla',
      'Mirandola',
      'Modena',
      'Monantola',
      'Montecreto',
      'Montefiorino',
      'Novi di Modena',
      'Palagano',
      'Pavullo nel Frignano',
      'Pievepelago',
      'Polinago',
      'Prignano sulla Secchia',
      'Ravarino',
      'Riolunato',
      'San Cesario sul Panaro',
      'San Felice sul Panaro',
      'San Possidonio',
      'San Prospero',
      'Sassuolo',
      'Savignano sul Panaro',
      'Serramazzoni',
      'Sestola',
      'Soliera',
      'Spilamberto',
      'Vignola',
      'Zocca',
    ],
    'IT-NO': [
      'Agrate Conturbia',
      'Ameno',
      'Armeno',
      'Arona',
      'Barengo',
      'Bellinzago Novarese',
      'Biandrate',
      'Boca',
      'Bogogno',
      'Bolzano Novarese',
      'Borgo Ticino',
      'Borgolavezzaro',
      'Borgomanero',
      'Briga Novarese',
      'Briona',
      'Caltignaga',
      'Cameri',
      'Carpignano Sesia',
      'Casalbeltrame',
      'Casaleggio Novara',
      'Casalino',
      'Casalvolone',
      'Castellazzo Novarese',
      'Castelletto Sopra Ticino',
      'Cavaglietto',
      "Cavaglio d' Agogna",
      'Cavallirio',
      'Cerano',
      'Colazza',
      'Comignago',
      'Cressa',
      'Cureggio',
      'Divignano',
      'Dormelletto',
      'Fara Novarese',
      "Fontaneto d' Agogna",
      'Galliate',
      'Garbagna Novarese',
      'Gargallo',
      'Gattico',
      'Ghemme',
      'Gozzano',
      'Granozzo con Monticello',
      'Grignasco',
      'Invorio',
      'Landiona',
      'Lesa',
      'Maggiora',
      'Mandello Vitta',
      'Marano Ticino',
      'Massino Visconti',
      'Meina',
      'Mezzomerico',
      'Miasino',
      'Momo',
      'Nebbiuno',
      'Nibbiola',
      'Novara',
      'Oleggio',
      'Oleggio Castello',
      'Orta San Giulio',
      'Paruzzaro',
      'Pella',
      'Pettenasco',
      'Pisano',
      'Pogno',
      'Pombia',
      'Prato Sesia',
      'Recetto',
      'Romagnano Sesia',
      'Romentino',
      "San Maurizio d' Opaglio",
      'San Nazzaro Sesia',
      'San Pietro Mosezzo',
      'Sillavengo',
      'Sizzano',
      'Soriso',
      'Sozzago',
      'Suno',
      'Terdobbiate',
      'Tornaco',
      'Trecate',
      "Vaprio d' Agogna",
      'Varallo Pombia',
      'Veruno',
      'Vespolate',
      'Vicolungo',
      'Viganella',
      'Vinzaglio',
    ],
    'IT-NU': [
      'Aritzo',
      'Atzara',
      'Austis',
      'Belvì',
      'Birori',
      'Bitti',
      'Bolotana',
      'Borore',
      'Bortigali',
      'Desulo',
      'Dorgali',
      'Dualchi',
      'Fonni',
      'Gadoni',
      'Galtellì',
      'Gavoi',
      'Irgoli',
      'Lei',
      'Loculi',
      "Lode'",
      'Lodine',
      'Lula',
      'Macomer',
      'Mamoiada',
      'Meana Sardo',
      'Noragugume',
      'Nuoro',
      'Oliena',
      'Ollodai',
      'Olzai',
      'Onani',
      'Onifai',
      'Oniferi',
      'Orani',
      'Orgosolo',
      'Orosei',
      'Orotelli',
      'Ortueri',
      'Orune',
      'Osidda',
      'Ottana',
      'Ovodda',
      'Posada',
      'Sarule',
      'Silanus',
      'Sindia',
      'Siniscola',
      'Sorgono',
      'Teti',
      'Tiana',
      'Tonara',
      'Torpè',
    ],
    'IT-NA': [
      'Acerra',
      'Afragola',
      'Agerola',
      'Anacapri',
      'Arzano',
      'Bacoli',
      "Barano d'Ischia",
      'Boscoreale',
      'Boscotrecase',
      'Brusciano',
      'Caivano',
      'Calvizzano',
      'Camposano',
      'Capri',
      'Carbonara di Nola',
      'Cardito',
      'Casalnuovo',
      'Casamarciano',
      'Casamicciola Terme',
      'Casandrino',
      'Casavatore',
      'Casola di Napoli',
      'Casoria',
      'Castellammare di Stabia',
      'Castello di Cisterna',
      'Cercola',
      'Cicciano',
      'Cimitile',
      'Comiziano',
      'Crispano',
      'Forio',
      'Frattamaggiore',
      'Giugliano in Campania',
      'Gragnano',
      'Grumo Nevano',
      'Herculano (Ercolano)',
      'Ischia',
      'Lacco Ameno',
      'Lettere',
      'Liveri',
      'Marano di Napoli',
      'Mariglianella',
      'Marigliano',
      'Massa Lubrense',
      'Massa di Somma',
      'Melito di Napoli',
      'Meta',
      'Monte di Procida',
      'Mugnano di Napoli',
      'Napoles',
      'Nola',
      'Ottaviano',
      'Palma Campania',
      'Piano di Sorrento',
      'Pimonte',
      'Poggiomarino',
      'Pollena Trocchia',
      "Pomigliano d'Arco",
      'Pompeya (Pompei)',
      'Portici',
      'Pozzuoli',
      'Procida',
      'Qualiano',
      'Quarto',
      'Roccarinola',
      'San Gennaro Vesuviano',
      'San Giorgio a Cremano',
      'San Giuseppe Vesuviano',
      'San Paolo Belsito',
      'San Sebastiano al Vesuvio',
      'San Vitaliano',
      "Sant'Agnello",
      "Sant'Anastasia",
      "Sant'Antimo",
      "Sant'Antonio Abate",
      'Santa Maria la Carità',
      'Saviano',
      'Scisciano',
      'Serrara Fontana',
      'Somma Vesuviana',
      'Sorrento',
      'Striano',
      'Terzigno',
      'Torre Annunziata',
      'Torre del Greco',
      'Trecase',
      'Tufino',
      'Vico Equense',
      'Villaricca',
      'Visciano',
      'Volla',
    ],
    'IT-OG': [
      'Arzana',
      'Bari Sardo',
      'Baunei',
      'Cardedu',
      'Elini',
      'Gairo',
      'Girasole',
      'Ilbono',
      'Jerzu',
      'Lanusei',
      'Loceri',
      'Lotzorai',
      'Osini',
      'Perdasdefogu',
      'Seui',
      'Talana',
      'Tertenia',
      "Tortoli'",
      'Trieti',
      'Ulassai',
      'Urzulei',
    ],
    'IT-OT': [
      'Aggius',
      'Aglientu',
      "Ala' dei Sardi",
      'Arzachena',
      'Badesi',
      'Berchidda',
      'Bortigiadas',
      "Budduso'",
      'Budoni',
      'Calangianus',
      'Golfo Aranci',
      'La Maddalena (Isla)',
      'Loiri Porto San Paolo',
      'Luogosanto',
      'Luras',
      'Monti',
      'Olbia',
      'Oschiri',
      'Padru',
      'Palau',
      "Sant'Antonio di Gallura",
      'Santa Teresa Gallura',
      'Telti',
      'Tempio Pausania',
      "Trinita D'Agultu e Vignola",
    ],
    'IT-OR': [
      'Abbasanta',
      'Aidomaggiore',
      'Albagiara',
      'Ales',
      'Allai',
      'Arborea',
      'Ardauli',
      'Assolo',
      'Asuni',
      'Baradili',
      'Baratili San Pietro',
      'Baressa',
      'Bauladu',
      'Bidonì',
      'Bonarcado',
      'Boroneddu',
      'Busachi',
      'Cabras',
      'Cuglieri',
      'Curcuris',
      'Flussio',
      'Fordongianus',
      'Genoni',
      'Ghilarza',
      'Gonnoscodina',
      'Gonnosnò',
      'Gonnostramatza',
      'Laconi',
      'Magomadas',
      'Marrubiu',
      'Masullas',
      'Milis',
      'Modolo',
      'Mogorella',
      'Mogoro',
      'Montresta',
      'Morgongiori',
      'Narbolia',
      'Neoneli',
      'Norbello',
      'Nuchedu Santa Vittoria',
      'Nurachi',
      'Nureci',
      'Ollastra',
      'Oristano',
      'Palmas Arborea',
      'Paulilatino',
      'Pompu',
      'Riola Sardo',
      'Ruinas',
      'Sagama',
      'Samugheo',
      "San Nicolò d'Arcidano",
      'San VEro Milis',
      'Santa Giusta',
      'Santu Lussurgiu',
      'Scano di Montiferro',
      'Sedilo',
      'Seneghe',
      'Senis',
      'Sennariolo',
      'Siamaggiore',
      'Siamanna',
      'Siapiccia',
      'Simala',
      'Simaxis',
      'Sini',
      'Siris',
      'Soddì',
      'Solarussa',
      'Sorradile',
      'Suni',
      'Tadasuni',
      'Terralba',
      'Tinnura',
      'Tramatza',
      'Tresnuraghes',
      'Ulà Tirso',
      'Uras',
      'Usellus',
      "Villa Sant'Antonio",
      'Villa Verde',
      'Villanova Truschedu',
      'Villaurbana',
      'Zeddiani',
      'Zerfaliu',
    ],
    'IT-PD': [
      'Abano Terme',
      'Agna',
      'Albignasego',
      'Anguillara Veneta',
      'Arquá Petrarca',
      'Arre',
      'Arzergrande',
      'Bagnoli di Sopra',
      'Baone',
      'Barbona',
      'Battaglia Terme',
      'Boara Pisani',
      'Borgoricco',
      'Bovolenta',
      'Brugine',
      'Cadoneghe',
      'Campo San Martino',
      'Campodarsego',
      'Campodoro',
      'Camposampiero',
      'Candiana',
      'Carceri',
      'Carmignano di Brenta',
      'Carrara San Giorgio',
      'Carrara Santo Stefano',
      'Cartura',
      'Casale di Scodosia',
      'Casalserugo',
      'Castelbaldo',
      'Cervarese Santa Croce',
      'Cinto Euganeo',
      'Cittadella',
      'Codevigo',
      'Conselve',
      'Correzzola',
      'Curtarolo',
      'Este',
      'Fontaniva',
      'Galliera Veneta',
      'Galzignano Terme',
      'Gazzo',
      'Grantorto',
      'Granze',
      'Legnaro',
      'Limena',
      'Loreggia',
      'Lozzo Atestino',
      'Maserá di Padova',
      'Masi',
      'Massanzago',
      'Megliadino San Fidenzio',
      'Megliadino San Vitale',
      'Merlara',
      'Mestrino',
      'Monselice',
      'Montagnana',
      'Montegrotto Terme',
      'Noventa Padovana',
      'Ospedaletto Euganeo',
      'PIove di Sacco',
      'Padova',
      'Pernumia',
      "Piacenza d' Adige",
      'Piazzola sul Brenta',
      'Piombino Dese',
      'Polverara',
      'Ponso',
      'Ponte San Nicoló',
      'Pontelongo',
      'Pozzonovo',
      'Rovolon',
      'Rubano',
      'Saccolongo',
      'Saletto',
      'San Giorgio delle Pertiche',
      'San Giorgio in Bosco',
      'San Martino di Lupari',
      'San Pietro Viminario',
      'San Pietro in Gu',
      "Sant' Angelo di Piove di Sacco",
      "Sant' Elena",
      "Sant' Urbano",
      'Santa Giustina in Colle',
      "Santa Margherita d' Adige",
      'Saonara',
      'Selvazzano Dentro',
      'Solesino',
      'Stanghella',
      'Teolo',
      'Terrassa Padovana',
      'Tombolo',
      'Torreglia',
      'Trebaseleghe',
      'Tribano',
      'Urbana',
      'Veggiano',
      'Vescovana',
      "Vighizzolo d' Este",
      'Vigodarzere',
      'Vigonza',
      'Villa Estense',
      'Villa del Conte',
      'Villafranca Padovana',
      'Villanova di Camposampiero',
      'Vo',
    ],
    'IT-PA': [
      'Alia',
      'Alimena',
      'Aliminusa',
      'Altavilla Milicia',
      'Altofonte',
      'Bagheria',
      'Balestrate',
      'Baucina',
      'Belmonte Mezzagno',
      'Bisacquino',
      'Blufi',
      'Bolognetta',
      'Bompietro',
      'Borgetto',
      'Caccamo',
      'Caltavuturo',
      'Campofelice di Fitalia',
      'Campofelice di Roccella',
      'Campofiorito',
      'Camporeale',
      'Capaci',
      'Carini',
      'Castelbuono',
      'Casteldaccia',
      'Castellana Sicula',
      'Castronovo di Sicilia',
      'Cefalá Diana',
      'Cefalú',
      'Cerda',
      'Chiusa Sclafani',
      'Ciminna',
      'Cinisi',
      'Collesano',
      'Contessa Entellina',
      'Corleone',
      'Entella',
      'Ficarazzi di Palermo',
      'Ficuzza',
      'Finale',
      'Gangi',
      'Geraci Siculo',
      'Giardinello',
      'Godrano',
      'Gratteri',
      'Isnello',
      'Isola delle Femmine',
      'Lascari',
      'Lercara Friddi',
      'Marineo',
      'Mezzojuso',
      'Misilmeri',
      'Monreale',
      'Montelepre',
      'Montemaggiore Belsito',
      'Palazzo Adriano',
      'Partinico',
      'Petralia Soprana',
      'Petralia Sottana',
      'Piana degli Albanesi',
      'Polizzi Generosa',
      'Pollina',
      'Prizzi',
      'Roccamena',
      'Roccapalumba',
      'San Cipirello',
      'San Giuseppe Jato',
      'San Mauro Castelverde',
      'Santa Cristina Gena',
      'Santa Flavia',
      'Sciara',
      'Scillato',
      'Sclafani Bagni',
      'Termini Imerese',
      'Terrasini',
      'Torretta',
      'Trabia',
      'Trappeto',
      'Ustica',
      'Valledolmo',
      'Ventimiglia di Sicilia',
      'Vicari',
      'Villabate',
      'Villafrati',
    ],
    'IT-PR': [
      'Albareto',
      'Bedonia',
      'Berceto',
      'Bore',
      'Borgo Val di Taro',
      'Busseto',
      'Calestano',
      'Collecchio',
      'Colorno',
      'Compiano',
      'Corniglio',
      'Felino',
      'Fidenza',
      'Fontanellato',
      'Fontevivo',
      'Fornovo di Taro',
      'Langhirano',
      "Lesignano de' Bagni",
      'Medesano',
      'Mezzani',
      'Monchio delle Corti',
      'Montechiarugolo',
      'Neviano degli Arduini',
      'Noceto',
      'Palanzano',
      'Parma',
      'Pellegrino Parmense',
      'Polesine Parmense',
      'Riana di Monchio',
      'Roccabianca',
      'Sala Baganza',
      'Salsomaggiore Terme',
      'San Secondo Parmense',
      'Selva del Bocchetto',
      'Sissa',
      'Solignano',
      'Soragna',
      'Sorbolo',
      'Terenzo',
      'Tizzano Val Parma',
      'Tornolo',
      'Torrile',
      'Traversetolo',
      'Trecasali',
      'Valmozzola',
      "Varano de' Melegari",
      'Varsi',
      'Zibello',
    ],
    'IT-PV': [
      'Alagna',
      'Albaredo',
      'Albonese',
      'Albuzzano',
      'Arena Po',
      'Badia Pavese',
      'Bagnaria',
      'Barbianello',
      'Bascapé',
      'Bastida Pancarana',
      "Bastida de' Dossi",
      'Battuda',
      'Belgioioso',
      'Bereguardo',
      'Borgarello',
      'Borgo Priolo',
      'Borgo San Siro',
      'Borgoratto Mormorolo',
      'Bornasco',
      'Bosnasco',
      'Brallo di Pregola',
      'Breme',
      'Bressana Bottarone',
      'Broni',
      'Calvignano',
      'Campospinoso',
      'Candia Lomellina',
      'Canevino',
      'Canneto Pavese',
      'Carbonara al Ticino',
      'Casanova Lonati',
      'Casatisma',
      'Casei Gerola',
      'Casorate Primo',
      'Cassolnovo',
      'Castana',
      'Casteggio',
      'Castelletto di Branduzzo',
      "Castello d' Agogna",
      'Castelnovetto',
      'Cava Manara',
      'Ceranova',
      'Ceretto Lomellina',
      'Cergnago',
      'Certosa di Pavia',
      'Cervesina',
      'Chignolo Po',
      'Cigognola',
      'Cilavegna',
      'Codevilla',
      'Confienza',
      'Copiano',
      'Corana',
      'Cornale',
      'Corteolona',
      'Corvino San Quirico',
      "Costa de' Nobili",
      'Cozzo',
      'Cura Carpignano',
      'Dorno',
      'Ferrera Erbognone',
      'Filighera',
      'Fortunago',
      'Frascarolo',
      'Galliavola',
      'Gambarana',
      'Gamboló',
      'Garlasco',
      'Genzone',
      'Gerenzago',
      'Giussago',
      'Godiasco',
      'Golferenzo',
      'Gravellona Lomellina',
      'Gropello Cairoli',
      'Inverno e Monteleone',
      'Landriano',
      'Langosco',
      'Lardirago',
      'Linarolo',
      'Lirio',
      'Lomello',
      'Lungavilla',
      'Magherno',
      'Marcignago',
      'Marzano',
      'Mede',
      'Menconico',
      'Mezzana Bigli',
      'Mezzana Rabattone',
      'Mezzanino',
      'Mirandolo Terme',
      'Montalto Pavese',
      'Montebello della Battaglia',
      'Montecalvo Versiggia',
      'Montescano',
      'Montesegale',
      'Monticelli Pavese',
      'Montù Beccaria',
      'Mornico Losana',
      'Mortara',
      'Nicorvo',
      'Olevano di Lomellina',
      'Oliva Gessi',
      'Ottobiano',
      'Palestro',
      'Pancarana',
      'Parona',
      'Pavia',
      "Pietra de' Giorgi",
      'Pieve Albignola',
      'Pieve Porto Morone',
      'Pieve del Cairo',
      'Pinarolo Po',
      'Pizzale',
      'Ponte Nizza',
      'Portalbera',
      'Rea',
      'Redavalle',
      'Retorbido',
      'Rivanazzano',
      'Robbio',
      'Robecco Pavese',
      'Rocca Susella',
      "Rocca de' Giorgi",
      'Rognano',
      'Romagnese',
      'Roncaro',
      'Rosasco',
      'Rovescala',
      'Ruino',
      'San Cipriano Po',
      'San Damiano al Colle',
      'San Genesio ed Uniti',
      'San Giorgio di Lomellina',
      'San Martino Siccomario',
      'San Zenone al Po',
      "Sannazzaro de' Burgondi",
      "Sant'Alessio con Vialone",
      "Sant'Angelo Lomellina",
      'Santa Cristina e Bissone',
      'Santa Giuletta',
      'Santa Margherita di Staffora',
      'Santa Maria della Versa',
      'Sartirana Lomellina',
      'Scaldasole',
      'Semiana',
      'Silvano Pietra',
      'Siziano',
      'Sommo',
      'Spessa',
      'Stradella',
      'Suardi',
      'Torrazza Coste',
      'Torre Beretti e Castellaro',
      "Torre d' Arese",
      "Torre d' Isola",
      "Torre de' Negri",
      'Torrevecchia Pia',
      'Torricella Verzate',
      'Travacò Siccomario',
      'Trivolzio',
      'Tromello',
      'Trovo',
      'Val di Nizza',
      'Valeggio',
      'Valle Lomellina',
      'Valle Salimbene',
      'Varzi',
      'Velezzo Bellini',
      'Velezzo Lomellina',
      'Verretto',
      'Verrua Po',
      'Vidigulfo',
      'Vigevano',
      'Villa Biscossi',
      "Villanova d' Ardenghi",
      'Villanterio',
      'Vistarino',
      'Voghera',
      'Volpara',
      'Zavattarello',
      'Zeccone',
      'Zeme',
      'Zenevredo',
      'Zerbo',
      'Zerboló',
      'Zinasco',
    ],
    'IT-PG': [
      'Asis',
      'Bastia',
      'Bettona',
      'Bevagna',
      'Campello sul Clitunno',
      'Cannara',
      'Cascia',
      'Castel Ritaldi',
      'Castiglione del Lago',
      'Cerreto di Spoleto',
      'Citerna',
      'Città della Pieve',
      'Città di Castello',
      'Collazzone',
      'Corciano',
      'Costacciaro',
      'Deruta',
      'Foligno',
      'Fossato di Vico',
      "Giano dell' Umbria",
      'Gualdo Cattaneo',
      'Gualdo Tadino',
      'Gubbio',
      'Lisciano Niccone',
      'Magione',
      'Marsciano',
      'Massa Martana',
      'Monte Castello di Vibio',
      'Monte Santa Maria Tiberina',
      'Montefalco',
      'Monteleone di Spoleto',
      'Montone',
      'Nocera Umbra',
      'Norcia',
      'Paciano',
      'Panicale',
      'Passignano sul Trasimeno',
      'Perugia',
      'Piegaro',
      'Pietralunga',
      'Poggiodomo',
      'Preci',
      'San Giustino',
      "Sant'Anatolia di Narco",
      'Scheggia e Pascelupo',
      'Scheggino',
      'Sellano',
      'Sigillo',
      'Spello',
      'Spoleto',
      'Todi',
      'Torgiano',
      'Tratta Todina',
      'Trevi',
      'Tuoro sul Trasimeno',
      'Umbertide',
      'Valfabbrica',
      'Vallo di Nera',
      'Valtopina',
    ],
    'IT-PS': [
      'Acqualagna',
      'Apecchio',
      'Auditore',
      'Barchi',
      "Belforte all' Isauro",
      'Borgo Pace',
      'Cagli',
      'Cantiano',
      'Carpegna',
      'Cartoceto',
      'Casteldelci',
      'Colbordolo',
      'Fano',
      'Fermignano',
      'Fossombrone',
      'Fratte Rosa',
      'Frontone',
      'Gabicce Mare',
      'Gradara',
      'Isola del Piano',
      'Lunano',
      'Macerata Feltria',
      'Maiolo',
      'Mercatello sul Metauro',
      'Mercatino Conca',
      'Mombaroccio',
      'Mondavio',
      'Mondolfo',
      'Monte Cerignone',
      'Monte Porzio',
      'Montecalvo in Foglia',
      'Monteciccardo',
      'Montecopiolo',
      'Montefelcino',
      'Montegrimano',
      'Montelabbate',
      'Montemaggiore al Metauro',
      'Novafeltria',
      'Orciano di Pesaro',
      'Pennabilli',
      'Pergola',
      'Pesaro',
      'Petriano',
      'Piagge',
      'Piandimeleto',
      'Pietrarubbia',
      'Piobbico',
      'Saltara',
      'San Costanzo',
      'San Giorgio di Pesaro',
      'San Leo',
      'San Lorenzo in Campo',
      "Sant' Agata Feltria",
      "Sant' Angelo in Lizzola",
      "Sant' Angelo in Vado",
      "Sant' Ippolito",
      'Sassocorvaro',
      'Sassofeltrio',
      "Serra Sant' Abbondio",
      'Serrungarina',
      'Talamello',
      'Tavoleto',
      'Tavullia',
      'Urbania',
      'Urbino',
    ],
    'IT-PE': [
      'Abbateggio',
      'Alanno',
      'Bolognano',
      'Brittoli',
      'Bussi sul Tirino',
      'Cappelle sul Tavo',
      'Caramanico Terme',
      'Carpineto della Nora',
      'Castiglione a Casauria',
      'Catignano',
      'Cepagatti',
      "Cittá Sant'Angelo",
      'Civitaquana',
      'Civitella Casanova',
      'Collecorvino',
      'Corvara',
      'Cugnoli',
      'Elice',
      'Farindola',
      'Lettomanoppello',
      'Loreto Aprutino',
      'Manoppello',
      'Montebello di Bertona',
      'Montesilvano',
      'Moscufo',
      'Nocciano',
      'Penne',
      'Pescara',
      'Pescosansonesco',
      'Pianella',
      'Picciano',
      'Pietranico',
      'Popoli',
      'Roccamorice',
      'Rosciano',
      'Salle',
      'San Valentino in Abruzzo Citeriore',
      "Sant' Eufemia a Maiella",
      'Scafa',
      'Serramonacesca',
      'Spoltore',
      'Tocco da Casauria',
      "Torre de' Passeri",
      'Turrivalignani',
      'Vicoli',
      'Villa Celiera',
    ],
    'IT-PC': [
      'Agazzano',
      'Alseno',
      'Besenzone',
      'Bettola',
      'Bobbio',
      'Borgonovo Val Tidone',
      'Cadeo',
      'Calendasco',
      'Caminata',
      'Caorso',
      'Carpaneto',
      'Castel San Giovanni',
      "Castell'Arquato",
      'Castelvetro Piacentino',
      'Cerignale',
      'Coli',
      'Corte Brugnatella',
      'Cortemaggiore',
      'Farini',
      'Ferriere',
      "Fiorenzuola d' Arda",
      'Gazzola',
      'Gossolengo',
      'Gragnano Trebbiense',
      'Gropparello',
      "Lugagnano Val d' Arda",
      "Monticelli d' Ongina",
      'Morfasso',
      'Nibbiano',
      'Ottone',
      'Pecorara',
      'Piacenza',
      'Pianello Val Tidone',
      'Piozzano',
      'Podenzano',
      "Ponte dell'Olio",
      'Pontenure',
      'Rivergaro',
      'Rottofreno',
      'San Giorgio Piacentino',
      'San Pietro in Cerro',
      'Sarmato',
      'Travo',
      'Vernasca',
      'Vigolzone',
      "Villanova sull'Arda",
      'Zerba',
      'Ziano Piacentino',
    ],
    'IT-PI': [
      'Bientina',
      'Buti',
      'Calci',
      'Calcinaia',
      'Capannoli',
      'Casale Marittimo',
      'Casciana Terme',
      'Cascina',
      'Castelfranco di Sotto',
      'Castellina Marittima',
      'Castelnuovo di Val di Cecina',
      'Chianni',
      'Crespina',
      'Fauglia',
      'Guardistallo',
      'Lajatico',
      'Lari',
      'Lorenzana',
      'Montecatini Val di Cecina',
      'Montescudaio',
      'Monteverdi Marittimo',
      "Montopoli in Val d'Arno",
      'Orciano Pisano',
      'Palaia',
      'Peccioli',
      'Pisa',
      'Pomarance',
      'Ponsacco',
      'Pontedera',
      'Riparbella',
      'San Giuliano Terme',
      'San Miniato',
      "Santa Croce sull'Arno",
      'Santa Luce',
      'Santa Maria a Monte',
      'Terricciola',
      'Vecchiano',
      'Vicopisano',
      'Volterra',
    ],
    'IT-PT': [
      'Abetone',
      'Agliana',
      'Buggiano',
      'Chiesa Uzzanese',
      'Collodi',
      'Cutigliano',
      'Lamporecchio',
      'Larciano',
      'Marliana',
      'Massa e Cozzile',
      'Monsummano Terme',
      'Montale',
      'Montecatini Terme',
      'Pescia',
      'Pieve a Nievole',
      'Pistoia',
      'Piteglio',
      'Ponte Buggianese',
      'Quarrata',
      'Sambuca Pistoiese',
      'San Marcello Pistoiese',
      'Serravalle Pistoiese',
      'Uzzano',
    ],
    'IT-PN': [
      'Andreis',
      'Arba',
      'Arzene',
      'Aviano',
      'Azzano Decimo',
      'Barcis',
      'Brugnera',
      'Budoia',
      'Caneva',
      'Casarza della Delizia',
      'Castelnovo del Friuli',
      'Cavasso Nuovo',
      'Chions',
      'Cimolais',
      'Claut',
      'Clauzetto',
      'Cordenons',
      'Cordovado',
      'Erto e Casso',
      'Fanna',
      'Fiume Veneto',
      'Fontanafredda',
      'Frisanco',
      'Maniago',
      'Meduno',
      'Montereale Valcellina',
      'Morsano al Tagliamento',
      'Pasiano di Pordenone',
      'Pinzano al Tagliamento',
      'Poffabro',
      'Polcenigo',
      'Porcia',
      'Pordenone',
      'Prata di Pordenone',
      'Pravisdomini',
      'Roveredo in Piano',
      'Sacile',
      'San Giorgio della Richinvelda',
      'San Martino al Tagliamento',
      'San Quirino',
      'San Vito al Tagliamento',
      'Sequals',
      'Sesto al Reghena',
      'Spilimbergo',
      'Tramonti di Sopra',
      'Tramonti di Sotto',
      'Travesio',
      'Vajont',
      'Valvasone',
      "Vito d' Asio",
      'Vivaro',
      'Zoppola',
    ],
    'IT-PZ': [
      'Abriola',
      'Aceranza',
      'Albano di Lucania',
      'Anzi',
      'Armento',
      'Atella',
      'Avigliano',
      'Balvano',
      'Banzi',
      'Baragiano',
      'Barile',
      'Bella',
      'Brienza',
      'Brindisi Montagna',
      'Calvello',
      'Calvera',
      'Campomaggiore',
      'Cancellara',
      'Carbone',
      'Castelgrande',
      'Castelluccio Inferiore',
      'Castelluccio Superiore',
      'Castelmezzano',
      'Castelsaraceno',
      "Castronuovo di Sant'Andrea",
      'Cersosimo',
      'Chiaromonte',
      'Corleto Perticara',
      'Episcopia',
      'Fardella',
      'Filiano',
      'Forenza',
      'Francavilla in Sinni',
      'Gallicchio',
      'Genzano di Lucania',
      'Ginestra',
      'Grumento Nova',
      'Guardia Perticara',
      'Lagonegro',
      'Latronico',
      'Laurenzana',
      'Lauria',
      'Lavello',
      'Maratea',
      'Marsico Nuovo',
      'Marsicovetere',
      'Maschito',
      'Melfi',
      'Missanello',
      'Moliterno',
      'Montemilone',
      'Montemurro',
      'Muro Lucano',
      'Nemoli',
      'Noepoli',
      'Oppido Lucano',
      'Palazzo San Gervasio',
      'Paterno',
      'Pescopagano',
      'Picerno',
      'Pietragalla',
      'Pietrapertosa',
      'Pignola',
      'Potenza',
      'Rapolla',
      'Rapone',
      'Rionero in Vulture',
      'Ripacandida',
      'Rivello',
      'Roccanova',
      'Rotonda',
      'Ruoti',
      'Ruvo del Monte',
      'San Chirico Nuovo',
      'San Chirico Raparo',
      'San Costantino Albanese',
      'San Fele',
      "San Martino d'Agri",
      'San Paolo Albanese',
      'San Severino Lucano',
      "Sant'Angelo le Fratte",
      "Sant'Arcangelo",
      'Sarconi',
      'Sasso di Castalda',
      'Satriano di Lucania',
      'Savoia di Lucania',
      'Senise',
      'Spinoso',
      'Teana',
      'Terranova di Pollino',
      'Tito',
      'Tolve',
      'Tramutola',
      'Trecchina',
      'Trivigno',
      'Vaglio Basilicata',
      'Venosa',
      'Vietri di Potenza',
      'Viggianello',
      'Viggiano',
    ],
    'IT-PO': ['Carmignano', 'Montemurlo', 'Poggio a Caiano', 'Prato', 'Vaiano', 'Vernio'],
    'IT-RG': [
      'Acate',
      'Chiaramonte Gulfi',
      'Comiso',
      'Giarratana',
      'Ispica',
      'Modica',
      'Monterosso Almo',
      'Pozzallo',
      'Ragusa',
      'Santa Croce Camerina',
      'Scicli',
      'Vittoria',
    ],
    'IT-RE': [
      'Albinea',
      'Bagnolo in Piano',
      'Baiso',
      'Bibbiano',
      'Boretto',
      'Brescello',
      'Busana',
      'Cadelbosco di Sopra',
      'Campagnola Emilia',
      'Campegine',
      'Canossa',
      'Carpineti',
      'Casalgrande',
      'Casina',
      'Castellarano',
      'Castelnovo di Sotto',
      "Castelnovo ne'Monti",
      'Cavriago',
      'Collagna',
      'Correggio',
      'Fabbrico',
      'Gattatico',
      'Gualtieri',
      'Guastalla',
      'Ligonchio',
      'Luzzara',
      'Montecchio Emilia',
      'Novellara',
      'Poviglio',
      'Quattro Castella',
      'Ramiseto',
      'Reggio Emilia',
      'Reggiolo',
      'Rio Saliceto',
      'Rolo',
      'Rubiera',
      'San Martino in Rio',
      "San Polo d' Enza",
      "Sant'Ilario d' Enza",
      'Scandiano',
      'Toano',
      'Vetto',
      'Vezzano sul Crostolo',
      'Viano',
      'Villa Minozzo',
    ],
    'IT-RC': [
      'Africo',
      'Agnana Calabra',
      'Anoia',
      'Antonimina',
      'Ardore',
      'Bagaladi',
      'Bagnara Calabra',
      'Benestare',
      'Bianco',
      'Bivongi',
      'Bova',
      'Bova Marina',
      'Bovalino',
      'Brancaleone',
      'Bruzzano Zeffirio',
      'Calanna',
      'Camini',
      'Campo Calabro',
      'Candidoni',
      'Canolo',
      'Caraffa del Bianco',
      'Cardeto',
      'Careri',
      'Casignana',
      'Caulonia',
      'Ciminá',
      'Cinquefrondi',
      'Cittanova',
      'Condofuri',
      'Cosoleto',
      'Delianuova',
      'Feroleto della Chiesa',
      'Ferruzzano',
      'Fiumara',
      'Galatro',
      'Gambarie',
      'Gerace',
      'Giffone',
      'Gioia Tauro',
      'Gioiosa Ionica',
      'Grotteria',
      'Laganadi',
      'Laureana di Borrello',
      'Locri',
      'Mammola',
      'Marina di Gioiosa Ionica',
      'Maropati',
      'Martone',
      'Melicucca',
      'Melicucco',
      'Melito Porto Salvo',
      'Molochio',
      'Monasterace',
      'Montebello Ionico',
      'Motta San Giovanni',
      'Oppido Mamertina',
      'Palizzi',
      'Palmi',
      'Pazzano',
      'Placanica',
      'Platí',
      'Polistena',
      'Portigliola',
      'Reggio Calabria',
      'Riace',
      'Rizziconi',
      'Roccaforte del Greco',
      'Roccella Ionica',
      'Roghudi',
      'Rosarno',
      'Samo',
      'San Ferdinando',
      'San Giorgio Morgeto',
      'San Giovanni di Gerace',
      'San Luca',
      'San Pietro di Caridá',
      'San Procopio',
      'San Roberto',
      "Sant'Agata del Bianco",
      "Sant'Alessio d'Aspromonte",
      "Sant'Eufemia d'Aspromonte",
      "Sant'Ilario dello Ionio",
      "Santa Cristina d'Aspromonte",
      'Santo Stefano in Aspromonte',
      'Scido',
      'Scilla',
      'Seminara',
      'Serrata',
      'Siderno',
      'Sinopoli',
      'Staiti',
      'Stignano',
      'Stilo',
      'Taurianova',
      'Terranova Sappo Minulio',
      'Varapodio',
      'Villa San Giovanni',
    ],
    'IT-RI': [
      'Accumoli',
      'Amatrice',
      'Antrodoco',
      'Ascrea',
      'Belmonte in Sabina',
      'Borbona',
      'Borgo Velino',
      'Borgorose',
      'Cantalice',
      'Cantalupo in Sabina',
      'Casaprota',
      'Casperia',
      "Castel Sant' Angelo",
      'Castel di Tora',
      'Castelnuovo di Farfa',
      'Cittaducale',
      'Cittareale',
      'Collalto Sabino',
      'Colle di Tora',
      'Collegiove',
      'Collevecchio',
      'Colli sul Velino',
      'Concerviano',
      'Configni',
      'Cottanello',
      'Fara in Sabina',
      'Fiamignano',
      'Forano',
      'Frasso Sabino',
      'Greccio',
      'Labro',
      'Leonessa',
      'Longone Sabino',
      'Magliano Sabina',
      'Marcetelli',
      'Micigliano',
      'Mompeo',
      'Montasola',
      'Monte San Giovanni in Sabina',
      'Montebuono',
      'Monteleone Sabino',
      'Montenero Sabino',
      'Montopoli di Sabina',
      'Morro Reatino',
      'Nespolo',
      'Orvinio',
      'Paganico Sabino',
      'Pescorocchiano',
      'Petrella Salto',
      'Poggio Bustone',
      'Poggio Catino',
      'Poggio Mirteto',
      'Poggio Moiano',
      'Poggio Nativo',
      'Poggio San Lorenzo',
      'Posta',
      'Pozzaglia Sabino',
      'Rieti',
      'Rivodutri',
      'Rocca Sinibalda',
      'Roccantica',
      'Salisano',
      'Scandriglia',
      'Selci',
      'Stimigliano',
      'Tarano',
      'Toffia',
      'Torri in Sabina',
      'Torricella in Sabina',
      'Turania',
      'Vacone',
      'Varco Sabino',
    ],
    'IT-RM': [
      'Affile',
      'Agosta',
      'Albano Laziale',
      'Allumiere',
      'Anguillara Sabazia',
      'Anticoli Corrado',
      'Anzio',
      'Arcinazzo Romano',
      'Ardea',
      'Ariccia',
      'Arsoli',
      'Artena',
      'Bellegra',
      'Boville',
      'Bracciano',
      'Camerata Nuova',
      'Campagnano di Roma',
      'Canale Monterano',
      'Canterano',
      'Capena',
      'Capranica Prenestina',
      'Carpineto Romano',
      'Casape',
      'Castel Gandolfo',
      'Castel Madama',
      'Castel Nuovo di Porto',
      'Castel San Pietro Romano',
      'Cave',
      'Cerreto Laziale',
      'Cerveteri',
      'Ciciliano',
      'Cineto Romano',
      'Civitavecchia',
      'Civitella San Paolo',
      'Colleferro',
      'Colonna',
      'Fiano Romano',
      'Filacciano',
      'Fiumicino',
      'Formello',
      'Frascati',
      'Gallicano nel Lazio',
      'Gavignano',
      'Genazzano',
      'Genzano di Roma',
      'Gerano',
      'Gorga',
      'Grottaferrata',
      'Guidonia Montecelio',
      'Jenne',
      'Labico',
      'Ladispoli',
      'Lanuvio',
      'Lariano',
      'Licenza',
      'Magliano Romano',
      'Mandela',
      'Manziana',
      'Marano Equo',
      'Marcellina',
      'Marino',
      'Mazzano Romano',
      'Mentana',
      'Monte Porzio Catone',
      'Montecompatri',
      'Monteflavio',
      'Montelanico',
      'Montelibretti',
      'Monterotondo',
      'Montorio Romano',
      'Moricone',
      'Morlupo',
      'Nazzano',
      'Nemi',
      'Nerola',
      'Nettuno',
      'Olevano Romano',
      'Palestrina',
      'Palombara Sabina',
      'Percile',
      'Pisoniano',
      'Poli',
      'Pomezia',
      'Ponzano Romano',
      'Riano',
      'Rignano Flaminio',
      'Riofreddo',
      'Rocca Canterano',
      'Rocca Priora',
      'Rocca Santo Stefano',
      'Rocca di Cave',
      'Rocca di Papa',
      'Roccagiovane',
      'Roiate',
      'Roviano',
      'Sacrofano',
      'Sambuci',
      'San Cesareo',
      'San Gregorio da Sassola',
      'San Polo dei Cavalieri',
      'San Vito Romano',
      "Sant' Angelo Romano",
      "Sant' Oreste",
      'Santa Marinella',
      'Saracinesco',
      'Segni',
      'Subiaco',
      'Tivoli',
      'Tolfa',
      'Torrita Tiberina',
      'Trevignano Romano',
      'Vallepietra',
      'Vallinfreda',
      'Valmontone',
      'Velletri',
      'Vicovaro',
      'Vivaro Romano',
      'Zagarolo',
    ],
    'IT-RO': [
      'Adria',
      'Ariano nel Polesine',
      'Arquá Polesine',
      'Badia Polesine',
      'Bagnolo di Po',
      'Bergantino',
      'Bosaro',
      'Calto',
      'Canaro',
      'Canda',
      'Castelguglielmo',
      'Castelmassa',
      'Castelnovo Bariano',
      'Ceneselli',
      'Ceregnano',
      'Contarina',
      'Corbola',
      'Costa di Rovigo',
      'Crespino',
      'Donada',
      'Ficarolo',
      'Fiesso Umbertiano',
      'Frassinelle Polesine',
      'Fratta Polesine',
      'Gaiba',
      'Gavello',
      'Giacciano con Baruchella',
      'Guarda Veneta',
      'Lendinara',
      'Loreo',
      'Lusia',
      'Melara',
      'Occhiobello',
      'Papozze',
      'Pettorazza Grimani',
      'Pincara',
      'Polesella',
      'Pontecchio Polesine',
      'Porto Tolle',
      'Rosolina',
      'Rovigo',
      'Salara',
      'San Bellino',
      'San Martino di Venezze',
      'Stienta',
      'Taglio di Po',
      'Trecenta',
      'Villadose',
      'Villamarzana',
      'Villanova Marchesana',
      'Villanova del Ghebbo',
    ],
    'IT-RA': [
      'Alfonsine',
      'Bagnacavallo',
      'Bagnara di Romagna',
      'Brisighella',
      'Casola Valsenio',
      'Castel Bolognese',
      'Cervia',
      'Conselice',
      'Cotignola',
      'Faenza',
      'Fusignano',
      'Lugo',
      'Massa Lombarda',
      'Ravenna',
      'Riolo Terme',
      'Russi',
      "Sant' Agata sul Santerno",
      'Solarolo',
    ],
    'IT-RN': [
      'Bellaria Igea Marina',
      'Cattolica',
      'Coriano',
      'Gemmano',
      'Misano Adriatico',
      'Mondaino',
      'Monte Colombo',
      'Montefiore Conca',
      'Montegridolfo',
      'Montescudo',
      'Morciano di Romagna',
      'Poggio Berni',
      'Riccione',
      'Rimini',
      'Saludecio',
      'San Giovanni in Marignano',
      'Santarcangelo di Romagna',
      'Torriana',
      'Verucchio',
    ],
    'IT-SA': [
      'Acciaroli',
      'Acerno',
      'Agropoli',
      'Angri',
      'Ascea Marina',
      'Atena Lucana',
      'Atrani',
      'Auletta',
      'Battipaglia',
      'Camerota Marina',
      'Campagna',
      'Capaccio Paestum',
      'Capitello Ispani',
      'Casalvelino',
      'Caselle in Pittari',
      'Castellabate',
      'Castelnuovo di Conza',
      "Cava de' Tirreni",
      'Celle di Bulgheria',
      'Centola Palinuro',
      'Cetara',
      'Colliano',
      'Conca dei Marini',
      'Controne',
      'Contursi Terme',
      'Corbara',
      'Eboli',
      'Fisciano',
      'Furore',
      'Giffoni Vallepiana',
      'Gioi Cilento',
      'Ispani Capitello',
      'Laurino',
      'Laurito',
      'Maiori',
      'Mercato San Severino',
      'Minori',
      'Monte San Giacomo',
      'Montecorice Agnone',
      'Montecorvino Rovella',
      'Montesano sulla Marcellana',
      'Nocera Inferiore',
      'Novi Velia',
      'Ogliastro Marina Castellabate',
      'Oliveto Citra',
      'Padula',
      'Pagani',
      'Palinuro',
      'Perdifumo',
      'Pertosa',
      'Petina',
      'Piaggine',
      'Pioppi',
      'Pisciotta',
      'Policastro Bussentino',
      'Polla',
      'Pollica',
      'Pontecagnano',
      'Positano',
      'Postiglione',
      'Praiano',
      'Ravello',
      'Roccadaspide',
      'Roscigno',
      'Sala Consilina',
      'Salerno',
      'San Giovanni a Piro Scario',
      'San Gregorio Magno',
      'San Marco di Castellabate',
      'San Marzano sul Samo',
      'San Mauro Cilento',
      'San Valentino Torio',
      "Sant' Arsenio",
      "Sant' Egidio del Monte Albino",
      'Santa Maria di Castellabate',
      'Santa Marina Policastro B.',
      'Santomenna',
      'Sapri',
      'Sarno',
      'Sassano',
      'Scafati',
      'Scala',
      'Scario',
      'Sicignano degli Alburni',
      'Teggiano',
      'Torchiara',
      'Torre Orsaia',
      'Tramonti',
      'Vallo della Lucania',
      'Vietri sul Mare',
      'Vivonati Villammare',
    ],
    'IT-SV': [
      'Alassio',
      'Albenga',
      'Albisola Superiore',
      'Albissola Marina',
      'Altare',
      'Andora',
      'Arnasco',
      'Balestrino',
      'Bardineto',
      'Bergeggi',
      'Boissano',
      'Borghetto Santo Spirito',
      'Borgio Verezzi',
      'Bormida',
      'Cairo Montenotte',
      'Calice Ligure',
      'Calizzano',
      'Carcare',
      'Casanova Lerrone',
      'Castelbianco',
      'Castelvecchio di Rocca Barbena',
      'Celle Ligure',
      'Cengio',
      'Ceriale',
      'Cisano sul Neva',
      'Cosseria',
      'Dego',
      'Erli',
      'Finale Ligure',
      'Garlenda',
      'Giustenice',
      'Giusvalla',
      'Laigueglia',
      'Loano',
      'Magliolo',
      'Mallare',
      'Massimino',
      'Millesimo',
      'Mioglia',
      'Murialdo',
      'Nasino',
      'Noli',
      'Onzo',
      'Orco Feglino',
      'Ortovero',
      'Osiglia',
      'Pallare',
      'Piana Crixia',
      'Pietra Ligure',
      'Plodio',
      'Pontinvrea',
      'Quiliano',
      'Rialto',
      'Roccavignale',
      'Sassello',
      'Savona',
      'Spotorno',
      'Stella',
      'Stellanello',
      'Testico',
      'Toirano',
      'Tovo San Giacomo',
      'Urbe',
      'Vado Ligure',
      'Varazze',
      'Vendone',
      'Vezzi Portio',
      "Villanova d' Albenga",
      'Zuccarello',
    ],
    'IT-SI': [
      'Abbadia San Salvatore',
      'Asciano',
      'Buonconvento',
      "Casole d'Elsa",
      'Castellina in Chianti',
      'Castelnuovo Berardenga',
      "Castiglione d'Orcia",
      'Cetona',
      'Chianciano Terme',
      'Chiusdino',
      'Chiusi',
      "Colle di Val d'Elsa",
      'Fonterutoli',
      'Gaiole in Chianti',
      'Montalcino',
      'Montepulciano',
      'Monteriggioni',
      "Monteroni d'Arbia",
      'Monticiano',
      'Murlo',
      'Piancastagnaio',
      'Pienza',
      'Poggibonsi',
      'Quercegrossa',
      'Radda in Chianti',
      'Radicofani',
      'Radicondoli',
      'Rapolano Terme',
      'San Casciano dei Bagni',
      'San Gimignano',
      "San Giovanni d'Asso",
      'San Gusmé',
      "San Quirico d'Orcia",
      'Sarteano',
      'Siena',
      'Sinalunga',
      'Sovicille',
      'Torrita di Siena',
      'Trequanda',
    ],
    'IT-SR': [
      'Avola',
      'Buccheri',
      'Buscemi',
      'Canicattini Bagni',
      'Carlentini',
      'Cassaro',
      'Ferla',
      'Floridia',
      'Francofonte',
      'Lentini',
      'Melilli',
      'Noto',
      'Pachino',
      'Palazzolo Acreide',
      'Portopalo di Capo Passero',
      'Priolo Gargallo',
      'Rosolini',
      'Siracusa',
      'Solarino',
      'Sortino',
    ],
    'IT-SO': [
      'Albaredo per San Marco',
      'Albosaggia',
      'Andalo Valtellino',
      'Aprica',
      'Ardenno',
      'Bema',
      'Berbenno di Valtellina',
      'Bianzone',
      'Bormio',
      'Buglio in Monte',
      'Caiolo',
      'Campodolcino',
      'Caspoggio',
      "Castello dell' Acqua",
      'Castione Andevenno',
      'Cedrasco',
      'Cercino',
      'Chiavenna',
      'Chiesa in Valmalenco',
      'Chiuro',
      'Cino',
      'Civo',
      'Colorina',
      'Cosio Valtellino',
      'Dazio',
      'Delebio',
      'Dubino',
      'Faedo Valtellino',
      'Forcola',
      'Fusine',
      'Gerola Alta',
      'Gordona',
      'Grosio',
      'Grosotto',
      'Lanzada',
      'Livigno',
      'Lovero',
      'Madesimo',
      'Mantello',
      'Mazzo di Valtellina',
      'Mello',
      'Menarola',
      'Mese',
      'Montagna in Valtellina',
      'Morbegno',
      'Novate Mezzola',
      'Pedesina',
      'Piantedo',
      'Piateda',
      'Piuro',
      'Poggiridenti',
      'Ponte in Valtellina',
      'Postalesio',
      'Prata Camportaccio',
      'Rasura',
      'Rogolo',
      'Samolaco',
      'San Giacomo Filippo',
      'Sernio',
      'Sondalo',
      'Sondrio',
      'Spriana',
      'Talamona',
      'Tartano',
      'Teglio',
      'Torre di Santa Maria',
      "Tovo di Sant' Agata",
      'Traona',
      'Tresivio',
      'Val Masino',
      'Valdidentro',
      'Valdisotto',
      'Valfurva',
      'Verceia',
      'Vervio',
      'Villa di Chiavenna',
      'Villa di Tirano',
    ],
    'IT-SS': [
      'Alghero',
      'Anela',
      'Ardara',
      'Banari',
      'Benetutti',
      'Bessude',
      'Bonnanaro',
      'Bono',
      'Bonorva',
      'Borutta',
      'Bottidda',
      'Bultei',
      'Bulzi',
      'Burgos',
      'Cargeghe',
      'Castelsardo',
      'Cheremule',
      'Chiaramonti',
      'Codrongianos',
      'Cossoine',
      'Erula',
      'Esporlatu',
      'Florinas',
      'Giave',
      'Illorai',
      'Ittireddu',
      'Ittiri',
      'Laerru',
      'Mara',
      'Martis',
      'Monteleone Rocca Doria',
      'Mores',
      'Muros',
      'Nughedu di San Nicolò',
      'Nule',
      'Nulvi',
      'Osilo',
      'Ossi',
      'Ozieri',
      'Padria',
      'Pattada',
      'Perfugas',
      'Ploaghe',
      'Porto Torres',
      'Pozzomaggiore',
      'Putifigari',
      'Romana',
      'Santa Maria Coghinas',
      'Sassari',
      'Sedini',
      'Semestene',
      'Sennori',
      'Siligo',
      'Sorso',
      'Stintino',
      'Tergu',
      'Thiesi',
      'Tissi',
      'Torralba',
      'Tula',
      'Uri',
      'Usini',
      'Valledoria',
      'Viddalba',
      'Villanova Monteleon',
    ],
    'IT-TA': [
      'Avetrana',
      'Carosino',
      'Castellaneta',
      'Crispiano',
      'Faggiano',
      'Fragagnano',
      'Ginosa',
      'Grottaglie',
      'Laterza',
      'Leporano',
      'Lizzano',
      'Manduria',
      'Martina Franca',
      'Maruggio',
      'Massafra',
      'Monteiasi',
      'Montemesola',
      'Monteparano',
      'Mottola',
      'Palagianello',
      'Palagiano',
      'Pulsano',
      'Roccaforzata',
      'San Giorgio Ionico',
      'San Marzano di San Giuseppe',
      'Sava',
      'Statte',
      'Taranto',
      'Torricella',
    ],
    'IT-TE': [
      'Alba Adriatica',
      'Ancarano',
      'Arsita',
      'Atri',
      'Basciano',
      'Bellante',
      'Bisenti',
      'Campli',
      'Canzano',
      'Castel Castagna',
      'Castellalto',
      'Castiglione Messer Raimondo',
      'Castilenti',
      'Cellino Attanasio',
      'Cermignano',
      'Civitella del Tronto',
      'Colledara',
      'Colonnella',
      'Controguerra',
      'Corropoli',
      'Cortino',
      'Crognaleto',
      'Fano Adriano',
      'Giulianova',
      "Isola del Gran Sasso d' Italia",
      'Martinsicuro',
      'Montefino',
      'Montorio al Vomano',
      "Morro d' Oro",
      "Mosciano Sant' Angelo",
      'Nereto',
      'Notaresco',
      "Penna Sant' Andrea",
      'Pietracamela',
      'Pineto',
      'Rocca Santa Maria',
      'Roseto degli Abruzzi',
      "Sant' Egidio Alla Vibrata",
      "Sant' Omero",
      'Silvi',
      'Teramo',
      'Torano Nuovo',
      'Torricella Sicura',
      'Tortoreto',
      'Tossica',
      'Valle Castellana',
    ],
    'IT-TR': [
      'Acquasparta',
      'Allerona',
      'Alviano',
      'Amelia',
      'Arrone',
      'Attigliano',
      'Avigliano Umbro',
      'Baschi',
      "Calvi dell' Umbria",
      'Castel Giorgio',
      'Castel Viscardo',
      'Fabro',
      'Ferentillo',
      'Ficulle',
      'Giove',
      'Guardea',
      'Lugnano in Teverina',
      'Montecastrilli',
      'Montecchio',
      'Montefranco',
      'Montegabbione',
      "Monteleone d' Orvieto",
      'Narni',
      'Orvieto',
      'Otricoli',
      'Parrano',
      'Penna in Teverina',
      'Polino',
      'Porano',
      'San Venanzio',
      'Sangemini',
      'Stroncone',
      'Terni',
    ],
    'IT-TP': [
      'Alcamo',
      'Buseto Palizzolo',
      'Calatafimi',
      'Campobello di Mazara',
      'Castellammare del Golfo',
      'Castelvetrano',
      'Custonaci',
      'Egadi (Islas)',
      'Erice',
      'Favignana',
      'Gibellina',
      'Marsala',
      'Mazara del Vallo',
      'Paceco',
      'Pantelleria',
      'Partanna',
      'Petrosino',
      'Poggioreale',
      'Salaparuta',
      'Salemi',
      'San Vito Lo Capo',
      'Santa Ninfa',
      'Trapani',
      'Valderice',
    ],
    'IT-TN': [
      'Ala',
      'Albiano',
      'Aldeno',
      'Amblar',
      'Andalo',
      'Arco',
      'Avio',
      'Baselga di Piné',
      'Bersone',
      'Besenello',
      'Betollo',
      'Bezzecca',
      'Bieno',
      'Bleggio Inferiore',
      'Bleggio Superiore',
      'Bocenago',
      'Bolbeno',
      'Bondo',
      'Bondone',
      'Borgo Valsugana',
      'Bosentino',
      'Breguzzo',
      'Brentonico',
      'Bresimo',
      'Brez',
      'Caderzone',
      'Cagnó',
      'Calavino',
      'Calceranica al Lago',
      'Caldes',
      'Caldonazzo',
      'Campodenno',
      'Canal San Bovo',
      'Canazei',
      'Capitello di Fassa',
      'Capriana',
      'Carano',
      'Carisolo',
      'Carzano',
      'Castel Condino',
      'Castelfondo',
      'Castello Molina di Fiemme',
      'Castello Tesino',
      'Castelnuovo',
      'Cavalese',
      'Cavareno',
      'Cavedago',
      'Cavedine',
      'Cavizzana',
      'Cembra',
      'Centa San Nicoló',
      'Cimego',
      'Cimone',
      'Cinte Tesino',
      'Cis',
      'Civezzano',
      'Cles',
      'Cloz',
      'Commezzadura',
      'Concei',
      'Condino',
      'Coredo',
      'Croviana',
      'Daiano',
      'Dambel',
      'Daone',
      'Daré',
      'Denno',
      'Dimaro',
      'Dorsino',
      'Drena',
      'Dro',
      'Faedo',
      'Fai della Paganella',
      'Faver',
      'Fiavé',
      'Fiera di Primiero',
      'Fierozzo',
      'Flavon',
      'Folgaria',
      'Fondo',
      'Fornace',
      'Frassilongo',
      'Garniga',
      'Giovo',
      'Giustino',
      'Grauno',
      'Grigno',
      'Grumes',
      'Imer',
      'Isera',
      'Ivano Fracena',
      'Lardaro',
      'Lasino',
      'Lavarone',
      'Lavis',
      'Levico Terme',
      'Lisignago',
      'Lomaso',
      'Lona Lases',
      'Luserna',
      'Malosco',
      'Malé',
      'Massimeno',
      'Mazzin',
      'Mezzana',
      'Mezzano',
      'Mezzocorona',
      'Mezzolombardo',
      'Moena',
      'Molina di Ledro',
      'Molveno',
      'Monclassico',
      'Montagne',
      'Mori',
      'Nago Torbole',
      'Nanno',
      'Nave San Rocco',
      'Nogaredo',
      'Nomi',
      'Novaledo',
      'Ospedaletto',
      'Ossana',
      'Padergnone',
      'Palù del Fersina',
      'Panchiá',
      'Peio',
      'Pellizzano',
      'Pelugo',
      'Pergine Valsugana',
      'Pieve Tesino',
      'Pieve di Bono',
      'Pieve di Ledro',
      'Pinzolo',
      'Pomarolo',
      'Pozza di Fassa',
      'Praso',
      'Predazzo',
      'Preore',
      'Prezzo',
      'Rabbi',
      'Ragoli',
      'Revó',
      'Riva del Garda',
      'Romallo',
      'Romeno',
      'Roncegno',
      'Ronchi Valsugana',
      'Roncone',
      'Ronzo Chienis',
      'Ronzone',
      'Rovereto',
      'Roveré della Luna',
      'Ruffrs',
      'Rumo',
      'Sagron Mis',
      'Samone',
      'San Lorenzo in Banale',
      "San Michele all' Adige",
      "Sant' Orsola Terme",
      'Sanzeno',
      'Sarnonico',
      'Scurelle',
      'Segonzano',
      'Sfruz',
      'Siror',
      'Smarano',
      'Soraga',
      'Sover',
      'Spera',
      'Spiazzo',
      'Spormaggiore',
      'Sporminore',
      'Stenico',
      'Storo',
      'Strembo',
      'Strigno',
      'Taio',
      'Tassullo',
      'Telve',
      'Telve di Sopra',
      'Tenna',
      'Tenno',
      'Terlago',
      'Terragnolo',
      'Terres',
      'Terzolas',
      'Tesero',
      'Tiarno di Sopra',
      'Tiarno di Sotto',
      'Tione di Trento',
      'Ton',
      'Tonadico',
      'Torcegno',
      'Trambileno',
      'Transacqua',
      'Trento',
      'Tres',
      'Tuenno',
      'Valda',
      'Valfloriana',
      'Vallarsa',
      'Varena',
      'Vattaro',
      'Vermiglio',
      'Vervó',
      'Vezzano',
      'Vignola Falesina',
      'Vigo Rendena',
      'Vigo di Fassa',
      'Vigolo Vattaro',
      'Villa Agnedo',
      'Villa Lagarina',
      'Villa Rendena',
      'Volano',
      'Zambana',
      'Ziano di Fiemme',
      'Zuclo',
    ],
    'IT-TV': [
      'Altivole',
      'Arcade',
      'Asolo',
      'Borso del Grappa',
      'Breda di Piave',
      'Caerano di San Marco',
      'Cappella Maggiore',
      'Casale sul Sile',
      'Casier',
      'Castelcucco',
      'Castelfranco Veneto',
      'Castello di Godego',
      'Cavaso del Tomba',
      'Cessalto',
      'Chiarano',
      'Cimadolmo',
      'Cison di Valmarino',
      'Codogné',
      'Colle Umberto',
      'Conegliano',
      'Cordignano',
      'Cornuda',
      'Crespano del Grappa',
      'Crocetta del Montello',
      'Farra di Soligo',
      'Follina',
      'Fontanelle',
      'Fonte',
      'Francenigo',
      'Fregona',
      'Gaiarine',
      'Giavera del Montello',
      "Godega di Sant' Urbano",
      'Gorgo al Monticano',
      'Istrana',
      'Loria',
      'Mansué',
      'Mareno di Piave',
      'Maser',
      'Maserada sul Piave',
      'Meduna di Livenza',
      'Miane',
      'Mogliano Veneto',
      'Monastier di Treviso',
      'Monfumo',
      'Montebelluna',
      'Morgano',
      'Moriago della Battaglia',
      'Motta di Livenza',
      'Nervesa della Battaglia',
      'Oderzo',
      'Ormelle',
      'Orsago',
      'Paderno del Grappa',
      'Paese',
      'Pederobba',
      'Pieve di Soligo',
      'Ponte di Piave',
      'Ponzano Veneto',
      'Portobuffols',
      'Possagno',
      'Povegliano',
      'Preganziol',
      'Quinto di Treviso',
      'Refrontolo',
      'Resana',
      'Revine Lago',
      'Riese Pio X',
      'Roncade',
      'Salgareda',
      'San Biagio di Callalta',
      'San Fior',
      'San Pietro di Feletto',
      'San Polo di Piave',
      'San Vendemiano',
      'San Vito di Altivole',
      'San Zenone degli Ezzelini',
      'Santa Lucia di Piave',
      'Sarmede',
      'Segusino',
      'Sernaglia della Battaglia',
      'Silea',
      'Spresiano',
      'Susegana',
      'Tarzo',
      'Trevignano',
      'Valdobbiadene',
      'Vazzola',
      'Vedelago',
      'Vidor',
      'Villorba',
      'Vittorio Veneto',
      'Volpago del Montello',
      'Zenson di Piave',
      'Zero Branco',
    ],
    'IT-TS': ['Duino Aurisina', 'Monrupino', 'Muggia', 'San Dorligo della Valle', 'Sgonico', 'Trieste'],
    'IT-TO': [
      'Aglié',
      'Airasca',
      'Ala di Stura',
      "Albiano d' Ivrea",
      'Alice Superiore',
      'Almese',
      'Alpette',
      'Alpignano',
      'Andezeno',
      'Andrate',
      'Angrogna',
      'Arignano',
      'Avigliana',
      'Azeglio',
      'Bairo',
      'Balangero',
      'Baldissero Canavese',
      'Baldissero Torinese',
      'Balme',
      'Banchette',
      'Barbania',
      'Bardonecchia',
      'Barone Canavese',
      'Beinasco',
      'Bibiana',
      'Bobbio Pellice',
      'Bollengo',
      'Borgaro Torinese',
      'Borgiallo',
      "Borgofranco d' Ivrea",
      'Borgomasino',
      'Borgone Susa',
      'Bosconero',
      'Brandizzo',
      'Bricherasio',
      'Brosso',
      'Brozolo',
      'Bruino',
      'Brusasco',
      'Bruzolo',
      'Buriasco',
      'Burolo',
      'Busano',
      'Bussoleno',
      'Buttigliera Alta',
      'Cafasse',
      'Caluso',
      'Cambiano',
      'Campiglione Fenile',
      'Candia Canavese',
      'Candiolo',
      'Canischio',
      'Cantalupa',
      'Cantoira',
      'Caprie',
      'Caravino',
      'Carema',
      'Carignano',
      'Carmagnola',
      'Casalborgone',
      "Cascinette d' Ivrea",
      'Caselette',
      'Caselle Torinese',
      'Castagneto Po',
      'Castagnole Piemonte',
      'Castellamonte',
      'Castelnuovo Nigra',
      'Castiglione Torinese',
      'Cavagnolo',
      'Cavour',
      'Cercenasco',
      'Ceresole Reale',
      'Cesana Torinese',
      'Chialamberto',
      'Chianocco',
      'Chiaverano',
      'Chieri',
      'Chiesanuova',
      'Chiomonte',
      'Chiusa di San Michele',
      'Chivasso',
      'Ciconio',
      'Cintano',
      'Cinzano',
      'Ciris',
      'Claviere',
      'Coassolo Torinese',
      'Coazze',
      'Collegno',
      'Colleretto Castelnuovo',
      'Colleretto Giacosa',
      'Condove',
      'Cossano Canavese',
      'Cuceglio',
      'Cumiana',
      'Cuorgné',
      'Druento',
      'Exilles',
      'Favria',
      'Feletto',
      'Fenestrelle',
      'Fiano',
      'Fiorano Canavese',
      'Foglizzo',
      'Forno Canavese',
      'Frassinetto',
      'Front',
      'Frossasco',
      'Garzigliana',
      'Gassino Torinese',
      'Germagnano',
      'Giaglione',
      'Giaveno',
      'Givoletto',
      'Gravere',
      'Groscavallo',
      'Grosso',
      'Grugliasco',
      'Ingria',
      'Inverso Pinasca',
      'Isolabella',
      'Issiglio',
      'Ivrea',
      'La Cassa',
      'La Loggia',
      'Lanzo Torinese',
      'Lauriano',
      'Leini',
      'Lemie',
      'Lessolo',
      'Levone',
      'Lobriasco',
      'Locana',
      'Lombardore',
      'Loranzé',
      'Lugnacco',
      'Luserna San Giovanni',
      'Lusernetta',
      'Lusiglis',
      'Macello',
      'Maglione',
      'Marentino',
      'Massello',
      'Mathi',
      'Mattie',
      'Mazzé',
      'Meana di Susa',
      'Mercenasco',
      'Meugliano',
      'Mezzenile',
      'Mombello di Torino',
      'Mompantero',
      'Monastero di Lanzo',
      'Moncalieri',
      'Moncenisio',
      'Montaldo Torinese',
      'Montalenghe',
      'Montalto Dora',
      'Montanaro',
      'Monteu da Po',
      'Moriondo Torinese',
      'Nichelino',
      'Noasca',
      'Nole',
      'Nomaglio',
      'None',
      'Novalesa',
      'Oglianico',
      'Orbassano',
      'Orio Canavese',
      'Osasio',
      'Oulx',
      'Ozegna',
      'Palazzo Canavese',
      'Pancalieri',
      'Parella',
      'Pavarolo',
      'Pavone Canavese',
      'Pecco',
      'Pecetto Torinese',
      'Perosa Argentina',
      'Perosa Canavese',
      'Perrero',
      'Pertusio',
      'Pessinetto',
      'Pianezza',
      'Pinasca',
      'Pinerolo',
      'Pino Torinese',
      'Piobesi Torinese',
      'Piorino',
      'Piossasco',
      'Piscina',
      'Piverone',
      'Pomaretto',
      'Pont Canavese',
      'Porte',
      'Pragelato',
      'Prali',
      'Pralormo',
      'Pramollo',
      'Prarostino',
      'Prascorsano',
      'Pratiglione',
      'Quagliuzzo',
      'Quassolo',
      'Quincinetto',
      'Reano',
      'Ribordone',
      'Riva Presso Chieri',
      'Rivalba',
      'Rivalta di Torino',
      'Rivara',
      'Rivarolo Canavese',
      'Rivarossa',
      'Rivoli',
      'Rocca Canavese',
      'Roletto',
      'Romano Canavese',
      'Ronco Canavese',
      'Rondissone',
      'Rorá',
      'Rosta',
      'Roure',
      'Rovassomero',
      'Rubiana',
      'Rueglio',
      'Salassa',
      'Salbertrand',
      'Salerano Canavese',
      'Salza di Pinerolo',
      'San Benigno Canavese',
      'San Carlo Canavese',
      'San Colombano Belmonte',
      'San Didero',
      'San Francesco al Campo',
      'San Germano Chisone',
      'San Gillio',
      'San Giorgio Canavese',
      'San Giorio di Susa',
      'San Giusto Canavese',
      'San Martino Canavese',
      'San Maurizio Canavese',
      'San Mauro Torinese',
      'San Pietro Val Lemina',
      'San Ponso',
      'San Raffaele Cimena',
      'San Sebastiano da Po',
      'San Secondo di Pinerolo',
      'Sangano',
      "Sant' Ambrogio di Torino",
      "Sant' Antonio di Susa",
      'Santena',
      "Sauze d' Oulx",
      'Sauze di Cesana',
      'Scalenghe',
      'Scarmagno',
      'Sciolze',
      'Sestriere',
      'Settimo Rottaro',
      'Settimo Torinese',
      'Settimo Vittore',
      'Sparone',
      'Strambinello',
      'Strambino',
      'Tavagnasco',
      'Torrazza Piemonte',
      'Torre Canavese',
      'Torre Pellice',
      'Trana',
      'Trausella',
      'Traversella',
      'Traves',
      'Trofarello',
      'Turin',
      'Usseaux',
      'Usseglio',
      'Vaie',
      'Val della Torre',
      'Valgioie',
      'Vallo Torinese',
      'Valperga',
      'Valprato Soana',
      'Varisella',
      'Vauda Canavese',
      'Venaria',
      'Venaus',
      'Verolengo',
      'Verrua Savoia',
      'Vestigné',
      'Vialfrs',
      'Vico Canavese',
      'Vidracco',
      'Vigone',
      'Villafranca Piemonte',
      'Villanova Canavese',
      'Villar Dora',
      'Villar Focchiardo',
      'Villar Pellice',
      'Villar Perosa',
      'Villarbasse',
      'Villareggia',
      'Villastellone',
      'Vinovo',
      'Virle Piemonte',
      'Vische',
      'Vistrorio',
      'Viú',
      'Volpiano',
      'Volvera',
    ],
    'IT-UD': [
      'Aiello del Friuli',
      'Ampezzo',
      'Aquileia',
      'Arta Terme',
      'Artegna',
      'Attimis',
      'Bagnaria Arsa',
      'Basiliano',
      'Bertiolo',
      'Bicinicco',
      'Bordano',
      'Buia',
      'Buttrio',
      'Camino al Tagliamento',
      'Campoformido',
      'Campolongo al Torre',
      'Carlino',
      'Cassacco',
      'Castions di Strada',
      'Cavazzo Carnico',
      'Cercivento',
      'Cervignano del Friuli',
      'Chiopris Viscone',
      'Chiusaforte',
      'Cividale del Friuli',
      'Codroipo',
      'Colloredo di Monte Albano',
      'Comeglians',
      'Corno di Rosazzo',
      'Coseano',
      'Dignano',
      'Dogna',
      'Drenchia',
      'Enemonzo',
      'Faedis',
      'Fagagna',
      'Fiumicello',
      'Flaibano',
      'Forgaria nel Friuli',
      'Forni Avoltri',
      'Forni di Sopra',
      'Forni di Sotto',
      'Gemona del Friuli',
      'Gonars',
      'Grimacco',
      'Latisana',
      'Lauco',
      'Lestizza',
      'Lignano Sabbiadoro',
      'Ligosullo',
      'Lusevera',
      'Magnano in Riviera',
      'Majano',
      'Malborghetto Valbruna',
      'Manzano',
      'Marano Lagunare',
      'Martignacco',
      'Mereto di Tomba',
      'Moggio Udinese',
      'Moimacco',
      'Montenars',
      'Mortegliano',
      'Moruzzo',
      'Muzzana del Turgnano',
      'Nimis',
      'Osoppo',
      'Ovaro',
      'Pagnacco',
      'Palazzolo dello Stella',
      'Palmanova',
      'Paluzza',
      'Pasian di Prato',
      'Paularo',
      'Pavia di Udine',
      'Pocenia',
      'Pontebba',
      'Porpetto',
      'Povoletto',
      'Pozzuolo del Friuli',
      'Pradamano',
      'Prato Carnico',
      'Precenicco',
      'Premariacco',
      'Preone',
      'Prepotto',
      'Pulfero',
      'Ragogna',
      'Ravascletto',
      'Raveo',
      'Reana del Roiale',
      'Remanzacco',
      'Resia',
      'Resiutta',
      'Rigolato',
      "Rive d' Arcano",
      'Rivigliano',
      'Ronchis',
      'Ruda',
      'Sal Vito al Torre',
      'San Daniele del Friuli',
      'San Giorgio di Nogaro',
      'San Giovanni al Natisone',
      'San Leonardo',
      'San Pietro al Natisone',
      'San Vito di Falagna',
      'Santa Maria La Longa',
      'Sauris',
      'Savogna',
      'Sedegliano',
      'Socchieve',
      'Stregna',
      'Sutrio',
      'Taipana',
      'Talmassons',
      'Tapogliano',
      'Tarcento',
      'Tarvisio',
      'Tavagnacco',
      'Teor',
      "Terzo d' Aquileia",
      'Tolmezzo',
      'Torreano',
      'Torviscosa',
      'Trasaghis',
      'Treppo Carnico',
      'Treppo Grande',
      'Tricesimo',
      'Trivignano Udinese',
      'Udine',
      'Varmo',
      'Venzone',
      'Verzegnis',
      'Villa Santina',
      'Villa Vicentina',
      'Visco',
      'Zuglio',
    ],
    'IT-VA': [
      'Albizzate',
      'Angera',
      'Arcisate',
      'Arsago Seprio',
      'Azzate',
      'Azzio',
      'Barasso',
      'Bardello',
      'Bedero Valcuvia',
      'Besano',
      'Besnate',
      'Besozzo',
      'Biandronno',
      'Bisuschio',
      'Bodio Lomnago',
      'Bolladello',
      'Brebbia',
      'Bregano',
      'Brenta',
      'Brezzo di Bedero',
      'Brinzio',
      'Brissago Valtravaglia',
      'Brunello',
      'Brusimpiano',
      'Buguggiate',
      'Busto Arsizio',
      'Cadegliano Viconago',
      'Cadrezzate',
      'Cairate',
      'Cantello',
      'Caravate',
      'Cardano al Campo',
      'Carnago',
      'Caronno Petrusella',
      'Caronno Varesino',
      'Casale Litta',
      'Casalzuigno',
      'Casciago',
      'Casorate Sempione',
      'Cassano Magnago',
      'Cassano Valcuvia',
      'Castellanza',
      'Castello Cabiaglio',
      'Castelseprio',
      'Castelveccana',
      'Castiglione Olona',
      'Castronno',
      'Cavaria con Premezzo',
      'Cazzago Brabbia',
      'Cislago',
      'Cittiglio',
      'Clivio',
      'Cocquio Trevisago',
      'Comabbio',
      'Comerio',
      'Cremenaga',
      'Crosio della Valle',
      'Cuasso al Monte',
      'Cugliate Fabiasco',
      'Cunardo',
      'Curiglia con Monteviasco',
      'Cuveglio',
      'Cuvio',
      'Daverio',
      'Dumenza',
      'Duno',
      'Fagnano Olona',
      'Ferno',
      'Ferrera di Varese',
      'Galiate Lombardo',
      'Gallarate',
      'Gavirate',
      'Gazzada Schianno',
      'Gemonio',
      'Gerenzano',
      'Germignaga',
      'Golasecca',
      'Gorla Maggiore',
      'Gorla Minore',
      'Gornate Olona',
      'Grantola',
      'Inarzo',
      'Induno Olona',
      'Ispra',
      'Jerago con Orago',
      'Lavena Ponte Tresa',
      'Laveno Mombello',
      'Leggiuno',
      'Lonate Ceppino',
      'Lonate Pozzolo',
      'Lozza',
      'Luino',
      'Luvinate',
      'Maccagno',
      'Malgesso',
      'Marnate',
      'Marzio',
      'Masciago Primo',
      'Mercallo',
      'Mesenzana',
      'Montegrino Valtravaglia',
      'Monvalle',
      'Morazzone',
      'Mornago',
      'Oggiona con Santo Stefano',
      'Olgiate Olona',
      'Origgio',
      'Orino',
      'Osmate',
      'Pino sulla Sponda del Lago',
      'Porto Ceresio',
      'Porto Valtravaglia',
      'Rancio Valcuvia',
      'Ranco',
      'Saltrio',
      'Samarate',
      'Sangiano',
      'Saronno',
      'Sesto Calende',
      'Solbiate Arno',
      'Solbiate Olona',
      'Somma Lombardo',
      'Sumirago',
      'Taino',
      'Ternate',
      'Tradate',
      'Travedona Monate',
      'Tronzano Lago Maggiore',
      'Uboldo',
      'Valganna',
      'Varano Borghi',
      'Varese',
      'Vedano Olona',
      'Veddasca',
      'Venegono Inferiore',
      'Venegono Superiore',
      'Vergiate',
      'Viggiú',
      'Vizzola Ticino',
    ],
    'IT-VE': [
      '(Lido di Jesolo)',
      'Annone Veneto',
      'Campagna Lupia',
      'Campolongo Maggiore',
      'Camponogara',
      'Caorle',
      'Cavarzere',
      'Ceggia',
      'Chioggia',
      'Cinto Caomaggiore',
      'Cona',
      'Concordia Sagittaria',
      'Dolo',
      'Eraclea',
      "Fiesso d' Artico",
      'Fossalta di Piave',
      'Fossalta di Portogruaro',
      'Fossó',
      'Gruaro',
      'Jesolo',
      'Marcon',
      'Martellago',
      'Meolo',
      'Mestre',
      'Murano',
      'Musile di Piave',
      'Noale',
      'Noventa di Piave',
      'Pianiga',
      'Portogruaro',
      'Pramaggiore',
      "Quarto d' Altino",
      'Salzano',
      'San Doná di Piave',
      'San Michele al Tagliamento',
      'Santa Maria di Sala',
      'Santo Stino di Livenza',
      'Scorzé',
      'Spinea',
      'Stra',
      'Teglio Veneto',
      'Torre di Mosto',
      'Vigonovo',
    ],
    'IT-VB': [
      'Antrona Schieranco',
      "Anzola D' Ossola",
      'Arizzano',
      'Arola',
      'Aurano',
      'Baceno',
      'Bannio Anzino',
      'Baveno',
      'Bee',
      'Belgirate',
      'Beura Cardezza',
      'Bognanco',
      'Brovello-Carpugnino',
      'Calasca Castiglione',
      'Cannero Rivera',
      'Cannobio',
      'Caprezzo',
      'Casale Corte Cerro',
      'Cavaglio Spoccia',
      'Ceppo Morelli',
      'Cesara',
      'Cossogno',
      'Craveggia',
      'Crevoladossola',
      'Crodo',
      'Cursolo-Orasso',
      'Domodossola',
      'Druogno',
      'Falmenta',
      'Formazza',
      'Germagno',
      'Ghiffa',
      'Gignese',
      'Gravellona Toce',
      'Gurro',
      'Intragna',
      'Loreglia',
      'Macugnaga',
      'Madonna del Sasso',
      'Malesco',
      'Masera',
      'Massiola',
      'Mergozzo',
      'Miazzina',
      'Montecrestese',
      'Montescheno',
      'Nonio',
      'Oggebbio',
      'Omegna',
      'Ornavasso',
      'Pallanzeno',
      'Piedimulera',
      'Pieve Vergonte',
      'Premeno',
      'Premia',
      'Premosello-Chiovenda',
      'Quarna Sotto',
      'Quarna di Sopra',
      'Re',
      'San Bernardino Verbano',
      'Santa Maria Maggiore',
      'Seppiana',
      'Stresa',
      'Toceno',
      'Trarego Viggiona',
      'Trasquera',
      'Trontano',
      'Valstrona',
      'Vanzone San Carlo',
      'Varzo',
      'Verbania',
      'Vignone',
      'Villadossola',
      'Villette',
      'Vogogna',
    ],
    'IT-VC': [
      'Alagna Valsesia',
      'Albano Vercellese',
      'Alice Castello',
      'Arborio',
      'Asigliano Vercellese',
      'Balmuccia',
      'Balocco',
      'Bianzé',
      'Boccioleto',
      'Borgo Vercelli',
      "Borgo d' Ale",
      'Borgosesia',
      'Breia',
      'Buronzo',
      'Campertogno',
      'Carcoforo',
      'Caresana',
      'Caresanablot',
      'Carisio',
      'Casanova Elvo',
      'Cellio',
      'Cervatto',
      'Cigliano',
      'Civiasco',
      'Collobiano',
      'Costanzana',
      'Cravagliana',
      'Crescentino',
      'Crova',
      'Desana',
      'Fobello',
      'Fontanetto Po',
      'Formigliana',
      'Gattinara',
      'Ghislarengo',
      'Greggio',
      'Guardabosone',
      'Lamporo',
      'Lenta',
      'Lignana',
      'Livorno Ferraris',
      'Lozzolo',
      'Mollia',
      'Moncrivello',
      "Motta de' Conti",
      'Olcenengo',
      'Oldenico',
      'Palazzolo Vercellese',
      'Pertengo',
      'Pezzana',
      'Piode',
      'Postua',
      'Prarolo',
      'Quarona',
      'Quinto Vercellese',
      'Rassa',
      'Rima San Giuseppe',
      'Rimasco',
      'Rimella',
      'Riva Valdobbia',
      'Roasio',
      'Ronsecco',
      'Rovasenda',
      'Sabbia',
      'Salasco',
      'Sali Vercellese',
      'Saluggia',
      'San Germano Vercellese',
      'San Giacomo Vercellese',
      'Santhiá',
      'Scopa',
      'Scopello',
      'Serravalle Sesia',
      'Stroppiana',
      'Tricesso',
      'Trino',
      'Tronzano Vercellese',
      'Valduggia',
      'Varallo',
      'Vercelli',
      'Villarboit',
      'Villata',
      'Vocca',
    ],
    'IT-VR': [
      'Affi',
      "Albaredo d' Adige",
      'Algiari',
      'Arcole',
      'Badia Calavena',
      'Bardolino',
      'Belfiore',
      'Bevilacqua',
      'Bonavigo',
      "Boschi Sant' Anna",
      'Bosco Chiesanuova',
      'Bovolone',
      'Brentino Belluno',
      'Brenzone',
      'Bussolengo',
      'Buttapietra',
      'Caldiero',
      'Caprino Veronese',
      'Casaleone',
      'Castagnaro',
      "Castel d' Azzano",
      'Castelnuovo del Garda',
      'Cazzano di Tramigna',
      'Cerea',
      'Cerro Veronese',
      'Cologna Veneta',
      'Colognola ai Colli',
      'Concamarise',
      'Costermano',
      'Dolcé',
      'Erbezzo',
      'Erbé',
      'Ferrara di Monte Baldo',
      'Fumane',
      'Garda',
      'Gavaion Veronese',
      'Gazzo Veronese',
      'Grezzana',
      'Illasi',
      'Isola Rizza',
      'Isola della Scala',
      'Lavagno',
      'Lazise',
      'Legnago',
      'Malcesine',
      'Marano di Valpolicella',
      'Mezzane di Sotto',
      'Minerbe',
      'Montecchia di Crosara',
      "Monteforte d' Alpone",
      'Mozzecane',
      'Negrar',
      'Nogara',
      'Nogarole Rocca',
      'Oppeano',
      'Palú',
      'Pastrengo',
      'Pescantina',
      'Peschiera del Garda',
      'Povegliano Veronese',
      'Pressana',
      'Rivoli Veronese',
      "Ronco all' Adige",
      'Roncá',
      'Roverchiara',
      'Roveredo di Guá',
      'Roverè Veronese',
      'Salizzole',
      'San Bonifacio',
      'San Giovanni Ilarione',
      'San Giovanni Lupatoto',
      'San Martino Buon Albergo',
      'San Mauro di Saline',
      'San Pietro di Morubio',
      'San Pietro in Cariano',
      'San Zeno di Montagna',
      'Sanguinetto',
      "Sant'Ambrogio di Valpolicella",
      "Sant'Anna d' Alfaedo",
      'Selva di Progno',
      'Soave',
      'Sommacampagna',
      'Sona',
      'Sorgá',
      'Terrazzo',
      'Torri del Benaco',
      'Tregnago',
      'Trevenzuolo',
      'Valeggio sul Mincio',
      'Velo Veronese',
      'Verona',
      'Veronella',
      'Vestenanova',
      'Vigasio',
      'Villa Bartolomea',
      'Villafranca di Verona',
      'Zevio',
      'Zimella',
    ],
    'IT-VV': [
      'Acquaro',
      'Arena',
      'Briatico',
      'Brognaturo',
      'Cessaniti',
      'Dasá',
      'Dinami',
      'Drapia',
      'Fabrizia',
      'Filandari',
      'Filogaso',
      'Francavilla Angitola',
      'Francica',
      'Gerocarne',
      'Ionadi',
      'Ioppolo',
      'Limbadi',
      'Maierato',
      'Mileto',
      'Mongiana',
      'Monterosso Calabro',
      'Nardodipace',
      'Nicotera',
      'Parghelia',
      'Pizzo Calabro',
      'Pizzoni',
      'Polia',
      'Ricadi',
      'Rombiolo',
      'San Calogero',
      'San Costantino Calabro',
      "San Gregorio d' Ippona",
      'San Nicola da Crissa',
      "Sant' Onofrio",
      'Serra San Bruno',
      'Simbario',
      'Sorianello',
      'Soriano Calabro',
      'Spadola',
      'Spilinga',
      'Stefanaconi',
      'Tropea',
      'Vallelonga',
      'Vazzano',
      'Vibo Valentia',
      'Zaccanopoli',
      'Zambrone',
      'Zungri',
    ],
    'IT-VI': [
      'Agugliaro',
      'Albettone',
      'Alonte',
      'Altavilla Vicentina',
      'Arcugnano',
      'Arsiero',
      'Arzignano',
      'Asiago',
      'Asigliano Veneto',
      'Barbarano Vicentino',
      'Bassano del Grappa',
      'Bolzano Vicentino',
      'Breganze',
      'Brendola',
      'Bressanvivo',
      'Brogliano',
      'Caldogno',
      'Caltrano',
      'Calvene',
      'Camisano Vicentino',
      'Campiglia dei Berici',
      'Campolongo sul Brenta',
      'Carré',
      'Cartigliano',
      'Cassola',
      'Castegnero',
      'Castelgomberto',
      'Cesuna',
      'Chiampo',
      'Chiuppano',
      'Cismon del Grappa',
      'Cogollo del Cengio',
      'Conco',
      'Cornedo Vicentino',
      'Costabissara',
      'Creazzo',
      'Crespadoro',
      'Dueville',
      'Enego',
      'Fara Vicentino',
      'Foza',
      'Gallio',
      'Gambellara',
      'Gambugliano',
      'Grancona',
      'Grisignano di Zocco',
      'Grumoli delle Abbadesse',
      'Isola Vicentina',
      'Laghi',
      'Lastebasse',
      'Longare',
      'Lonigo',
      'Lugo di Vicenza',
      'Lusiana',
      'Malo',
      'Marano Vicentino',
      'Marostica',
      'Mason Vicentino',
      'Molvena',
      'Monte di Malo',
      'Montebello Vicentino',
      'Montecchio Maggiore',
      'Montecchio Precalcino',
      'Montegalda',
      'Montegaldella',
      'Monteviale',
      'Monticello Conte Otto',
      'Montorso Vicentino',
      'Mossano',
      'Mussolente',
      'Nanto',
      'Nogarole Vicentino',
      'Nove',
      'Noventa Vicentina',
      'Orgiano',
      'Pedemonte',
      'Pianezze',
      'Piovene Rocchette',
      'Poiana Maggiore',
      'Posina',
      'Pove del Grappa',
      'Pozzoleone',
      'Quinto Vicentino',
      'Recoaro Terme',
      'Roana',
      "Romano d' Ezzelino",
      'Rossano Veneto',
      'Rosá',
      'Rotzo',
      'San Germano dei Berici',
      'San Nazario',
      'San Pietro Mussolino',
      'San Vito di Leguzzano',
      'Sandrigo',
      'Santorso',
      'Sarcedo',
      'Sarego',
      'Schiavon',
      'Schio',
      'Solagna',
      'Sossano',
      'Sovizzo',
      'Tezze sul Brenta',
      'Thienne',
      'Tonezza del Cimone',
      'Torrebelvicino',
      'Torri di Quartesolo',
      'Trissino',
      'Valdagno',
      'Valdastico',
      'Valli del Pasubio',
      'Valstagna',
      "Velo d' Astico",
      'Vicenza',
      'Villaga',
      'Villaverla',
      'Zané',
      'Zermeghedo',
      'Zovencedo',
      'Zugliano',
    ],
    'IT-VT': [
      'Acquapendente',
      'Arlena',
      'Bagnoregio',
      'Barbarano Romano',
      'Bassano Romano',
      'Bassano in Teverina',
      'Blera',
      'Bolsena',
      'Bomarzo',
      'Calcata',
      'Canepina',
      'Canino',
      'Capodimonte',
      'Capranica',
      'Caprarola',
      'Carbognano',
      "Castel Sant' Elia",
      'Castiglione in Teverina',
      'Celleno',
      'Cellere',
      'Civita Castellana',
      "Civitella d' Agliano",
      'Corchiano',
      'Fabrica di Roma',
      'Faleria',
      'Farnese',
      'Gallese',
      'Gradoli',
      'Graffignano',
      'Grotte di Castro',
      'Ischia di Castro',
      'Latera',
      'Lubriano',
      'Marta',
      'Montalto di Castro',
      'Monte Romano',
      'Montefiascone',
      'Monterosi',
      'Nepi',
      'Onano',
      'Oriolo Romano',
      'Orte',
      'Piansano',
      'Proceno',
      'Ronciglione',
      'San Lorenzo Nuovo',
      'Soriano nel Cimino',
      'Sutri',
      'Tarquinia',
      'Tessennano',
      'Tuscania',
      'Valentano',
      'Vallerano',
      'Vasanello',
      'Vejano',
      'Vetralla',
      'Vignanello',
      'Villa San Giovanni in Tuscia',
      'Vitorchiano',
    ],
  },
  JPN: {
    'JP-23': [
      'Aisai',
      'Ama',
      'Anjō',
      'Chiryū',
      'Gamagōri',
      'Handa',
      'Hekinan',
      'Ichinomiya',
      'Inazawa',
      'Inuyama',
      'Iwakura',
      'Kariya',
      'Kasugai',
      'Kitanagoya',
      'Kiyosu',
      'Komaki',
      'Kōnan',
      'Miyoshi',
      'Nagakute',
      'Nagoya',
      'Nishio',
      'Nisshin',
      'Okazaki',
      'Owariasahi',
      'Seto',
      'Shinshiro',
      'Takahama',
      'Tokoname',
      'Toyoake',
      'Toyohashi',
      'Toyokawa',
      'Toyota',
      'Tsushima',
      'Tōkai',
      'Yatomi',
      'Ōbu',
    ],
    'JP-05': [
      'Akita',
      'Daisen',
      'Katagami',
      'Kazuno',
      'Kitaakita',
      'Nikaho',
      'Noshiro',
      'Oga',
      'Semboku',
      'Yokote',
      'Yurihonjō',
      'Yuzawa',
      'Ōdate',
    ],
    'JP-02': [
      'Aomori',
      'Goshogawara',
      'Hachinohe',
      'Hirakawa',
      'Hirosaki',
      'Kuroishi',
      'Misawa',
      'Mutsu',
      'Towada',
      'Tsugaru',
    ],
    'JP-12': [
      'Abiko',
      'Asahi',
      'Chiba',
      'Chōshi',
      'Funabashi',
      'Futtsu',
      'Ichihara',
      'Ichikawa',
      'Inzai',
      'Isumi',
      'Kamagaya',
      'Kamogawa',
      'Kashiwa',
      'Katori',
      'Katsuura',
      'Kimitsu',
      'Kisarazu',
      'Matsudo',
      'Minamibōsō',
      'Mobara',
      'Nagareyama',
      'Narashino',
      'Narita',
      'Noda',
      'Oamishirasato',
      'Sakura',
      'Sanmu',
      'Shiroi',
      'Sodegaura',
      'Sōsa',
      'Tateyama',
      'Tomisato',
      'Tōgane',
      'Urayasu',
      'Yachimata',
      'Yachiyo',
      'Yotsukaidō',
    ],
    'JP-38': [
      'Imabari',
      'Iyo',
      'Matsuyama',
      'Niihama',
      'Saijō',
      'Seiyo',
      'Shikokuchūō',
      'Tōon',
      'Uwajima',
      'Yawatahama',
      'Ōzu',
    ],
    'JP-18': ['Awara', 'Echizen', 'Fukui', 'Katsuyama', 'Obama', 'Sabae', 'Sakai', 'Tsuruga', 'Ōno'],
    'JP-40': [
      'Asakura',
      'Buzen',
      'Chikugo',
      'Chikushino',
      'Dazaifu',
      'Fukuoka',
      'Fukutsu',
      'Iizuka',
      'Itoshima',
      'Kama',
      'Kasuga',
      'Kitakyushu',
      'Koga',
      'Kurume',
      'Miyama',
      'Miyawaka',
      'Munakata',
      'Nakagawa',
      'Nakama',
      'Nōgata',
      'Ogōri',
      'Tagawa',
      'Ukiha',
      'Yame',
      'Yanagawa',
      'Yukuhashi',
      'Ōkawa',
      'Ōmuta',
      'Ōnojō',
    ],
    'JP-07': [
      'Aizuwakamatsu',
      'Date',
      'Fukushima',
      'Iwaki',
      'Kitakata',
      'Kōriyama',
      'Minamisōma',
      'Motomiya',
      'Nihonmatsu',
      'Shirakawa',
      'Sukagawa',
      'Sōma',
      'Tamura',
    ],
    'JP-21': [
      'Ena',
      'Gero',
      'Gifu',
      'Gujō',
      'Hashima',
      'Hida',
      'Kaizu',
      'Kakamigahara',
      'Kani',
      'Mino',
      'Minokamo',
      'Mizuho',
      'Mizunami',
      'Motosu',
      'Nakatsugawa',
      'Seki',
      'Tajimi',
      'Takayama',
      'Toki',
      'Yamagata',
      'Ōgaki',
    ],
    'JP-10': [
      'Annaka',
      'Fujioka',
      'Isesaki',
      'Kiryū',
      'Maebashi',
      'Midori',
      'Numata',
      'Shibukawa',
      'Takasaki',
      'Tatebayashi',
      'Tomioka',
      'Ōta',
    ],
    'JP-34': [
      'Akitakata',
      'Etajima',
      'Fuchū',
      'Fukuyama',
      'Hatsukaichi',
      'Higashihiroshima',
      'Hiroshima',
      'Kure',
      'Mihara',
      'Onomichi',
      'Shōbara',
      'Takehara',
      'Ōtake',
    ],
    'JP-01': [
      'Abashiri',
      'Akabira',
      'Asahikawa',
      'Ashibetsu',
      'Bibai',
      'Chitose',
      'Ebetsu',
      'Eniwa',
      'Fukagawa',
      'Furano',
      'Hakodate',
      'Hokuto',
      'Ishikari',
      'Iwamizawa',
      'Kitahiroshima',
      'Kitami',
      'Kushiro',
      'Mikasa',
      'Monbetsu',
      'Muroran',
      'Nayoro',
      'Nemuro',
      'Noboribetsu',
      'Obihiro',
      'Otaru',
      'Rumoi',
      'Sapporo',
      'Shibetsu',
      'Sunagawa',
      'Takikawa',
      'Tomakomai',
      'Utashinai',
      'Wakkanai',
      'Yūbari',
    ],
    'JP-28': [
      'Aioi',
      'Akashi',
      'Akō',
      'Amagasaki',
      'Asago',
      'Ashiya',
      'Awaji',
      'Himeji',
      'Itami',
      'Kakogawa',
      'Kasai',
      'Katō',
      'Kawanishi',
      'Kobe',
      'Miki',
      'Minamiawaji',
      'Nishinomiya',
      'Nishiwaki',
      'Ono',
      'Sanda',
      'Sasayama',
      'Shisō',
      'Sumoto',
      'Takarazuka',
      'Takasago',
      'Tamba',
      'Tatsuno',
      'Toyooka',
      'Yabu',
    ],
    'JP-08': [
      'Bandō',
      'Chikusei',
      'Hitachi',
      'Hitachinaka',
      'Hitachiōmiya',
      'Hitachiōta',
      'Hokota',
      'Inashiki',
      'Ishioka',
      'Itako',
      'Jōsō',
      'Kamisu',
      'Kasama',
      'Kashima',
      'Kasumigaura',
      'Kitaibaraki',
      'Mito',
      'Moriya',
      'Naka',
      'Namegata',
      'Omitama',
      'Ryūgasaki',
      'Sakuragawa',
      'Shimotsuma',
      'Takahagi',
      'Toride',
      'Tsuchiura',
      'Tsukuba',
      'Tsukubamirai',
      'Ushiku',
      'Yūki',
    ],
    'JP-17': ['Hakui', 'Hakusan', 'Kaga', 'Kahoku', 'Kanazawa', 'Komatsu', 'Nanao', 'Nonoichi', 'Suzu', 'Wajima'],
    'JP-03': [
      'Hachimantai',
      'Hanamaki',
      'Ichinoseki',
      'Kamaishi',
      'Kitakami',
      'Kuji',
      'Miyako',
      'Morioka',
      'Ninohe',
      'Rikuzentakata',
      'Takizawa',
      'Tōno',
      'Ōfunato',
      'Ōshū',
    ],
    'JP-37': ['Higashikagawa', "Kan'onji", 'Marugame', 'Mitoyo', 'Sakaide', 'Sanuki', 'Takamatsu', 'Zentsūji'],
    'JP-46': [
      'Aira',
      'Akune',
      'Amami',
      'Hioki',
      'Ibusuki',
      'Ichikikushikino',
      'Isa',
      'Izumi',
      'Kagoshima',
      'Kanoya',
      'Kirishima',
      'Makurazaki',
      'Minamikyūshū',
      'Minamisatsuma',
      'Nishinoomote',
      'Satsumasendai',
      'Shibushi',
      'Soo',
      'Tarumizu',
    ],
    'JP-14': [
      'Atsugi',
      'Ayase',
      'Chigasaki',
      'Ebina',
      'Fujisawa',
      'Hadano',
      'Hiratsuka',
      'Isehara',
      'Kamakura',
      'Kawasaki',
      'Minamiashigara',
      'Miura',
      'Odawara',
      'Sagamihara',
      'Yamato',
      'Yokohama',
      'Yokosuka',
      'Zama',
      'Zushi',
    ],
    'JP-26': [
      'Ayabe',
      'Fukuchiyama',
      'Jōyō',
      'Kameoka',
      'Kizugawa',
      'Kyoto',
      'Kyōtanabe',
      'Kyōtango',
      'Maizuru',
      'Miyazu',
      'Mukō',
      'Nagaokakyō',
      'Nantan',
      'Uji',
      'Yawata',
    ],
    'JP-43': [
      'Amakusa',
      'Arao',
      'Aso',
      'Hitoyoshi',
      'Kami-Amakusa',
      'Kikuchi',
      'Kumamoto',
      'Kōshi',
      'Minamata',
      'Tamana',
      'Uki',
      'Uto',
      'Yamaga',
      'Yatsushiro',
    ],
    'JP-39': ['Aki', 'Kami', 'Kōchi', 'Muroto', 'Nankoku', 'Shimanto', 'Sukumo', 'Susaki', 'Tosa', 'Tosashimizu'],
    'JP-24': [
      'Iga',
      'Inabe',
      'Ise',
      'Kameyama',
      'Kumano',
      'Kuwana',
      'Matsusaka',
      'Nabari',
      'Owase',
      'Shima',
      'Suzuka',
      'Toba',
      'Tsu',
      'Yokkaichi',
    ],
    'JP-04': [
      'Higashimatsushima',
      'Ishinomaki',
      'Iwanuma',
      'Kakuda',
      'Kesennuma',
      'Kurihara',
      'Natori',
      'Sendai',
      'Shiogama',
      'Shiroishi',
      'Tagajō',
      'Tomiya',
      'Ōsaki',
    ],
    'JP-45': ['Ebino', 'Hyūga', 'Kobayashi', 'Kushima', 'Miyakonojō', 'Miyazaki', 'Nichinan', 'Nobeoka', 'Saito'],
    'JP-20': [
      'Azumino',
      'Chikuma',
      'Chino',
      'Iida',
      'Iiyama',
      'Ina',
      'Komagane',
      'Komoro',
      'Matsumoto',
      'Nagano',
      'Nakano',
      'Okaya',
      'Saku',
      'Shiojiri',
      'Suwa',
      'Suzaka',
      'Tōmi',
      'Ueda',
      'Ōmachi',
    ],
    'JP-42': [
      'Gotō',
      'Hirado',
      'Iki',
      'Isahaya',
      'Matsuura',
      'Minamishimabara',
      'Nagasaki',
      'Saikai',
      'Sasebo',
      'Shimabara',
      'Unzen',
      'Ōmura',
    ],
    'JP-29': [
      'Gojō',
      'Gose',
      'Ikoma',
      'Kashiba',
      'Kashihara',
      'Katsuragi',
      'Nara',
      'Sakurai',
      'Tenri',
      'Uda',
      'Yamatokōriyama',
      'Yamatotakada',
    ],
    'JP-15': [
      'Agano',
      'Gosen',
      'Itoigawa',
      'Jōetsu',
      'Kamo',
      'Kashiwazaki',
      'Minami-Uonuma',
      'Mitsuke',
      'Murakami',
      'Myōkō',
      'Nagaoka',
      'Niigata',
      'Ojiya',
      'Sado',
      'Sanjō',
      'Shibata',
      'Tainai',
      'Tsubame',
      'Tōkamachi',
      'Uonuma',
    ],
    'JP-33': [
      'Akaiwa',
      'Asakuchi',
      'Bizen',
      'Ibara',
      'Kasaoka',
      'Kurashiki',
      'Maniwa',
      'Mimasaka',
      'Niimi',
      'Okayama',
      'Setouchi',
      'Sōja',
      'Takahashi',
      'Tamano',
      'Tsuyama',
    ],
    'JP-47': [
      'Ginowan',
      'Ishigaki',
      'Itoman',
      'Miyakojima',
      'Nago',
      'Naha',
      'Nanjō',
      'Okinawa',
      'Tomigusuku',
      'Urasoe',
      'Uruma',
    ],
    'JP-27': [
      'Daitō',
      'Fujiidera',
      'Habikino',
      'Hannan',
      'Higashiōsaka',
      'Hirakata',
      'Ibaraki',
      'Ikeda',
      'Izumisano',
      'Izumiōtsu',
      'Kadoma',
      'Kaizuka',
      'Kashiwara',
      'Katano',
      'Kawachinagano',
      'Kishiwada',
      'Matsubara',
      'Minoh',
      'Moriguchi',
      'Neyagawa',
      'Osaka',
      'Sennan',
      'Settsu',
      'Shijōnawate',
      'Suita',
      'Takaishi',
      'Takatsuki',
      'Tondabayashi',
      'Toyonaka',
      'Yao',
      'Ōsakasayama',
    ],
    'JP-41': ['Imari', 'Kanzaki', 'Karatsu', 'Ogi', 'Saga', 'Takeo', 'Taku', 'Tosu', 'Ureshino'],
    'JP-11': [
      'Ageo',
      'Asaka',
      'Chichibu',
      'Fujimi',
      'Fujimino',
      'Fukaya',
      'Gyōda',
      'Hannō',
      'Hanyū',
      'Hasuda',
      'Hidaka',
      'Higashimatsuyama',
      'Honjō',
      'Iruma',
      'Kasukabe',
      'Kawagoe',
      'Kawaguchi',
      'Kazo',
      'Kitamoto',
      'Koshigaya',
      'Kuki',
      'Kumagaya',
      'Kōnosu',
      'Misato',
      'Niiza',
      'Okegawa',
      'Saitama',
      'Sakado',
      'Satte',
      'Sayama',
      'Shiki',
      'Shiraoka',
      'Sōka',
      'Toda',
      'Tokorozawa',
      'Tsurugashima',
      'Wakō',
      'Warabi',
      'Yashio',
      'Yoshikawa',
    ],
    'JP-25': [
      'Higashiōmi',
      'Hikone',
      'Konan',
      'Kusatsu',
      'Kōka',
      'Maibara',
      'Moriyama',
      'Nagahama',
      'Rittō',
      'Takashima',
      'Yasu',
      'Ōmihachiman',
      'Ōtsu',
    ],
    'JP-32': ['Gōtsu', 'Hamada', 'Izumo', 'Masuda', 'Matsue', 'Unnan', 'Yasugi', 'Ōda'],
    'JP-22': [
      'Atami',
      'Fuji',
      'Fujieda',
      'Fujinomiya',
      'Fukuroi',
      'Gotenba',
      'Hamamatsu',
      'Itō',
      'Iwata',
      'Izu',
      'Izunokuni',
      'Kakegawa',
      'Kikugawa',
      'Kosai',
      'Makinohara',
      'Mishima',
      'Numazu',
      'Omaezaki',
      'Shimada',
      'Shimoda',
      'Shizuoka',
      'Susono',
      'Yaizu',
    ],
    'JP-09': [
      'Ashikaga',
      'Kanuma',
      'Mooka',
      'Nasukarasuyama',
      'Nasushiobara',
      'Nikkō',
      'Oyama',
      'Sano',
      'Shimotsuke',
      'Tochigi',
      'Utsunomiya',
      'Yaita',
      'Ōtawara',
    ],
    'JP-36': ['Anan', 'Awa', 'Komatsushima', 'Mima', 'Naruto', 'Tokushima', 'Yoshinogawa'],
    'JP-31': ['Kurayoshi', 'Sakaiminato', 'Tottori', 'Yonago'],
    'JP-16': ['Himi', 'Imizu', 'Kurobe', 'Namerikawa', 'Oyabe', 'Takaoka', 'Tonami', 'Toyama', 'Uozu'],
    'JP-13': [
      'Adachi',
      'Akiruno',
      'Akishima',
      'Arakawa',
      'Bunkyō',
      'Chiyoda',
      'Chōfu',
      'Chūō',
      'Edogawa',
      'Fussa',
      'Hachiōji',
      'Hamura',
      'Higashikurume',
      'Higashimurayama',
      'Higashiyamato',
      'Hino',
      'Inagi',
      'Itabashi',
      'Katsushika',
      'Kita',
      'Kiyose',
      'Kodaira',
      'Koganei',
      'Kokubunji',
      'Komae',
      'Kunitachi',
      'Kōtō',
      'Machida',
      'Meguro',
      'Minato',
      'Mitaka',
      'Musashimurayama',
      'Musashino',
      'Nerima',
      'Nishitōkyō',
      'Setagaya',
      'Shibuya',
      'Shinagawa',
      'Shinjuku',
      'Special wards of Tokyo',
      'Suginami',
      'Sumida',
      'Tachikawa',
      'Taitō',
      'Tama',
      'Toshima',
      'Ōme',
    ],
    'JP-30': ['Arida', 'Gobō', 'Hashimoto', 'Iwade', 'Kainan', 'Kinokawa', 'Shingū', 'Tanabe', 'Wakayama'],
    'JP-06': [
      'Higashine',
      'Kaminoyama',
      'Murayama',
      'Nagai',
      "Nan'yō",
      'Obanazawa',
      'Sagae',
      'Sakata',
      'Shinjō',
      'Tendō',
      'Tsuruoka',
      'Yonezawa',
    ],
    'JP-35': [
      'Hagi',
      'Hikari',
      'Hōfu',
      'Iwakuni',
      'Kudamatsu',
      'Mine',
      'Nagato',
      "San'yō-Onoda",
      'Shimonoseki',
      'Shūnan',
      'Ube',
      'Yamaguchi',
      'Yanai',
    ],
    'JP-19': [
      'Fuefuki',
      'Fujiyoshida',
      'Kai',
      'Kōfu',
      'Kōshū',
      'Minami-Alps',
      'Nirasaki',
      'Tsuru',
      'Uenohara',
      'Yamanashi',
      'Ōtsuki',
    ],
    'JP-44': [
      'Beppu',
      'Bungo-ōno',
      'Bungotakada',
      'Hita',
      'Kitsuki',
      'Kunisaki',
      'Nakatsu',
      'Saiki',
      'Taketa',
      'Tsukumi',
      'Usa',
      'Usuki',
      'Yufu',
      'Ōita',
    ],
  },
  MEX: {
    'MX-AGU': [
      'Aguascalientes',
      'Asientos',
      'Calvillo',
      'Cosió',
      'El Llano',
      'Jesús Maria',
      'Pabellón De Arteaga',
      'Rincón De Romos',
      'San Francisco De Los Romo',
      'San José De Gracia',
      'Tepezala',
    ],
    'MX-BCN': ['Mexicali', 'Playas De Rosarito', 'Tecate', 'Tijuana'],
    'MX-BCS': ['Ciudad Constitución', 'Comondu', 'José Azueta', 'Los Cabos', 'Mulege'],
    'MX-CAM': [
      'Becal',
      'Calakmul',
      'Calkini',
      'Carmen',
      'Champotón',
      'Escárcega',
      'Hecelchakan',
      'Hopelchen',
      'Palizada',
      'Tenabo',
    ],
    'MX-CHP': [
      'Acacoyagua',
      'Acala',
      'Acapetahua',
      'Aldama',
      'Altamirano',
      'Amatan',
      'Amatenango De La Frontera',
      'Amatenango Del Valle',
      'Angel Albino Corzo',
      'Arriaga',
      'Bejucal De Ocampo',
      'Berriozabal',
      'Bochil',
      'Cacahoatan',
      'Catazaja',
      'Chalchihuitan',
      'Chamula',
      'Chanal',
      'Chapultenango',
      'Chenalho',
      'Chiapa De Corzo',
      'Chiapilla',
      'Chicoasen',
      'Chicomuselo',
      'Chilon',
      'Cintalapa',
      'Coapilla',
      'Comitán De Domínguez',
      'Copainala',
      'Francisco León',
      'Frontera Comalapa',
      'Frontera Hidalgo',
      'Huehuetan',
      'Huitiupan',
      'Huixtan',
      'Huixtla',
      'Ixhuatan',
      'Ixtacomitan',
      'Ixtapa',
      'Ixtapangajoya',
      'Jiquipilas',
      'Jitotol',
      'Juárez',
      'La Grandeza',
      'La Independencia',
      'La Trinitaria',
      'Larrainzar',
      'Las Margaritas',
      'Las Rosas',
      'Mapastepec',
      'Mazapa De Madero',
      'Mazatan',
      'Metapa',
      'Mitontic',
      'Motozintla',
      'Nicolás Ruiz',
      'Ocosingo',
      'Ocotepec',
      'Ocozocoautla De Espinosa',
      'Ostuacan',
      'Osumacinta',
      'Oxchuc',
      'Pantelho',
      'Pantepec',
      'Pichucalco',
      'Pijijiapan',
      'Pueblo Nuevo Solistahuacan',
      'Rayón',
      'Reforma',
      'Sabanilla',
      'Salto De Agua',
      'San Cristóbal De Las Casas',
      'San Juan Cancuc',
      'Siltepec',
      'Simojovel',
      'Sitala',
      'Socoltenango',
      'Solosuchiapa',
      'Soyalo',
      'Suchiapa',
      'Suchiate',
      'Sunuapa',
      'Tapachula',
      'Tapalapa',
      'Tapilula',
      'Tecpatan',
      'Tenejapa',
      'Teopisca',
      'Tila',
      'Tonala',
      'Totolapa',
      'Tumbala',
      'Tuxtla Chico',
      'Tuxtla Gutiérrez',
      'Tuzantan',
      'Tzimol',
      'Unión Juárez',
      'Venustiano Carranza',
      'Villa Comaltitlan',
      'Villa Corzo',
      'Villaflores',
      'Yajalon',
      'Zinacantan',
      'San Andrés Duraznal',
      'Santiago el Pinar',
      'Benemérito de las Américas',
      'Marqués de Comillas',
      'Montecristo de Guerrero',
      'Maravilla Tenejapa',
    ],
    'MX-CHH': [
      'Ahumada',
      'Allende',
      'Aquiles Serdán',
      'Ascensión',
      'Bachiniva',
      'Balleza',
      'Batopilas',
      'Bocoyna',
      'Carichi',
      'Casas Grandes',
      'Chihuahua',
      'Chinipas',
      'Coronado',
      'Coyame',
      'Cuauhtémoc',
      'Cusihuiriachi',
      'Delicias',
      'Doctor Belisario Domínguez',
      'El Tule',
      'Galeana',
      'General Trias',
      'Gomez Farias',
      'Gran Morelos',
      'Guachochi',
      'Guadalupe Y Calvo',
      'Guazapares',
      'Guerrero',
      'Hidalgo Del Parral',
      'Huejotitan',
      'Ignacio Zaragoza',
      'Janos',
      'Julimes',
      'Madera',
      'Maguarichi',
      'Manuel Benavides',
      'Matachi',
      'Matamoros',
      'Meoqui',
      'Morelos',
      'Morís',
      'Namiquipa',
      'Nonoava',
      'Nuevo Casas Grandes',
      'Ocampo',
      'Ojinaga',
      'Práxedis G. Guerrero',
      'Riva Palacio',
      'Rosales',
      'San Francisco De Borja',
      'San Francisco De Conchos',
      'San Francisco Del Oro',
      'Satevo',
      'Saucillo',
      'Temósachic',
      'Urique',
      'Uruachi',
      'Valle De Zaragoza',
      'Coyame del Sotol',
    ],
    'MX-COA': [
      'Abasolo',
      'Acuña',
      'Arteaga',
      'Castaños',
      'Cuatrocienegas',
      'Escobedo',
      'Francisco I Madero',
      'General Cepeda',
      'Hidalgo',
      'Lamadrid',
      'Monclova',
      'Muzquiz',
      'Nadadores',
      'Nava',
      'Parras',
      'Piedras Negras',
      'Progreso',
      'Ramos Arizpe',
      'Sabinas',
      'Saltillo',
      'San Juan De Sabinas',
      'Sierra Mojada',
      'Torreón',
      'Viesca',
      'Villa Union',
    ],
    'MX-COL': [
      'Armería',
      'Colima',
      'Comala',
      'Coquimatlan',
      'Cuauhtemoc',
      'Ixtlahuacán',
      'Minatitlan',
      'Tecoman',
      'Villa De Álvarez',
    ],
    'MX-DIF': [
      'Alvaro Obregón',
      'Azcapotzalco',
      'Benito juárez',
      'Coyoacán',
      'Cuajimalpa De Morelos',
      'Gustavo A. Madero',
      'Iztacalco',
      'Iztapalapa',
      'La Magdalena Contreras',
      'Miguel Hidalgo',
      'Milpa Alta',
      'Tlalpan',
      'Tláhuac',
      'Xochimilco',
      'Estacion In House NLU',
    ],
    'MX-DUR': [
      'Canatlan',
      'Canelas',
      'Coneto De Comonfort',
      'Cuencame',
      'Durango',
      'El Oro',
      'General Simón Bolívar',
      'Guadalupe Victoria',
      'Guanacevi',
      'Gómez Palacio',
      'Inde',
      'Lerdo',
      'Mapimi',
      'Mezquital',
      'Nazas',
      'Nombre De Dios',
      'Nuevo Ideal',
      'Otaez',
      'Panuco De Coronado',
      'Peñón Blanco',
      'Poanas',
      'Rodeo',
      'San Dimas',
      'San Juan De Guadalupe',
      'San Juan Del Río',
      'San Luis Del Cordero',
      'San Pedro Del Gallo',
      'Santiago Papasquiaro',
      'Suchil',
      'Tamazula',
      'Tepehuanes',
      'Tlahualilo',
      'Topia',
      'Vicente Guerrero',
    ],
    'MX-MEX': [
      'Acambay',
      'Acolman',
      'Aculco',
      'Almoloya De Alquisiras',
      'Almoloya De Juárez',
      'Almoloya Del Río',
      'Amanalco',
      'Amatepec',
      'Amecameca',
      'Apaxco',
      'Atenco',
      'Atizapán',
      'Atizapán De Zaragoza',
      'Atlacomulco',
      'Atlautla',
      'Axapusco',
      'Ayapango',
      'Calimaya',
      'Capulhuac',
      'Chalco',
      'Chapa De Mota',
      'Chapultepec',
      'Chiautla',
      'Chicoloapan',
      'Chiconcuac',
      'Chimalhuacán',
      'Coacalco de Berriozabal',
      'Coatepec Harinas',
      'Cocotitlan',
      'Coyotepec',
      'Cuautitlan',
      'Cuautitlan Izcalli',
      'Donato Guerra',
      'Ecatepec de Morelos',
      'Ecatzingo',
      'Huehuetoca',
      'Hueypoxtla',
      'Huixquilucan',
      'Isidro Fabela',
      'Ixtapaluca',
      'Ixtapan De La Sal',
      'Ixtapan Del Oro',
      'Ixtlahuaca',
      'Jalatlaco',
      'Jaltenco',
      'Jilotepec',
      'Jilotzingo',
      'Jiquipilco',
      'Jocotitlan',
      'Joquicingo',
      'Juchitepec',
      'Luvianos',
      'Malinalco',
      'Melchor Ocampo',
      'Metepec',
      'Mexicalcingo',
      'Naucalpan',
      'Nextlalpan',
      'Nezahualcoyotl',
      'Nicolás Romero',
      'Nopaltepec',
      'Ocoyoacac',
      'Ocuilan',
      'Otumba',
      'Otzoloapan',
      'Otzolotepec',
      'Ozumba',
      'Papalotla',
      'Polotitlan',
      'San Antonio La Isla',
      'San Felipe Del Progreso',
      'San Martín De Las Pirámides',
      'San Mateo Atenco',
      'San Simón De Guerrero',
      'Santo Tomas',
      'San José del Rincón',
      'Soyaniquilpan De Juárez',
      'Sultepec',
      'Tecamac',
      'Tejupilco',
      'Temamatla',
      'Temascalapa',
      'Temascalcingo',
      'Temascaltepec',
      'Temoaya',
      'Tenango Del Aire',
      'Tenango Del Valle',
      'Teoloyucan',
      'Teotihuacan',
      'Tepetlaoxtoc',
      'Tepetlixpa',
      'Tepotzotlan',
      'Tequixquiac',
      'Texcaltitlan',
      'Texcalyacac',
      'Texcoco',
      'Tezoyuca',
      'Tianguistenco',
      'Timilpan',
      'Tlalmanalco',
      'Tlalnepantla de Baz',
      'Tlatlaya',
      'Toluca',
      'Tonanitla',
      'Tonatico',
      'Tultepec',
      'Tultitlán',
      'Valle De Bravo',
      'Valle De Chalco Solidaridad',
      'Villa De Allende',
      'Villa Del Carbón',
      'Villa Guerrero',
      'Villa Victoria',
      'Xalatlaco',
      'Xonacatlan',
      'Zacazonapan',
      'Zacualpan',
      'Zinacantepec',
      'Zumpahuacan',
      'Zumpango',
    ],
    'MX-GUA': [
      'Acambaro',
      'Apaseo El Alto',
      'Apaseo El Grande',
      'Atarjea',
      'Celaya',
      'Comonfort',
      'Coroneo',
      'Cortazar',
      'Cueramaro',
      'Doctor Mora',
      'Dolores Hidalgo',
      'Guanajuato',
      'Huanimaro',
      'Irapuato',
      'Jaral Del Progreso',
      'Jerecuaro',
      'León',
      'Manuel Doblado',
      'Moroleón',
      'Penjamo',
      'Purísima Del Rincón',
      'Romita',
      'Salvatierra',
      'San Diego De La Unión',
      'San Francisco Del Rincón',
      'San Jose Iturbide',
      'San Luis De La Paz',
      'San Miguel De Allende',
      'Santa Cruz De Juventino Rosas',
      'Santiago Maravatio',
      'Tarandacuao',
      'Tarimoro',
      'Tierra Blanca',
      'Uriangato',
      'Valle De Santiago',
      'Villagran',
      'Xichu',
      'Yuriria',
    ],
    'MX-GRO': [
      'Acatepec',
      'Ahuacuotzingo',
      'Ajuchitlán Del Progreso',
      'Alcozauca De Guerrero',
      'Alpoyeca',
      'Apaxtla',
      'Arcelia',
      'Atenango Del Río',
      'Atlamajalcingo Del Monte',
      'Atlixtac',
      'Atoyac De Álvarez',
      'Ayutla De Los Libres',
      'Azoyu',
      'Buenavista De Cuellar',
      'Chilapa De Álvarez',
      'Chilpancingo De Los Bravo',
      'Coahuayutla De José Maria Izazaga',
      'Cocula',
      'Copala',
      'Copalillo',
      'Copanatoyac',
      'Coyuca De Benítez',
      'Coyuca De Catalán',
      'Cuajinicuilapa',
      'Cualac',
      'Cuautepec',
      'Cuetzala Del Progreso',
      'Cutzamala De Pinzon',
      'Eduardo Neri',
      'Florencio Villarreal',
      'General Canuto A Neri',
      'General Heliodoro Castillo',
      'Huamuxtitlan',
      'Huitzuco De Los Figueroa',
      'Iguala De La Independencia',
      'Igualapa',
      'Iliatenco',
      'Ixcateopan De Cuauhtémoc',
      'Juan R Escudero',
      'Juchitán',
      'Leonardo Bravo',
      'Malinaltepec',
      'Marquelia',
      'Metlatonoc',
      'Mochitlan',
      'Mártir De Cuilapan',
      'Olinala',
      'Ometepec',
      'Pedro Ascencio Alquisiras',
      'Petatlan',
      'Pilcaya',
      'Pungarabato',
      'Quechultenango',
      'San Luis Acatlan',
      'San Miguel Totolapan',
      'Taxco De Alarcón',
      'Tecoanapa',
      'Tecpan De Galeana',
      'Teloloapan',
      'Tepecoacuilco De Trujano',
      'Tetipac',
      'Tixtla De Guerrero',
      'Tlacoachistlahuaca',
      'Tlacoapa',
      'Tlalchapa',
      'Tlalixtaquilla De Maldonado',
      'Tlapa De Comonfort',
      'Tlapehuala',
      'Xalpatlahuac',
      'Xochihuehuetlan',
      'Xochistlahuaca',
      'Zapotitlan Tablas',
      'Zirandaro',
      'Zitlala',
      'Zihuatanejo de Azueta',
      'Cochoapa el Grande',
      'José Joaquín De Herrera',
    ],
    'MX-HID': [
      'Acatlán',
      'Acaxochitlán',
      'Actopan',
      'Agua Blanca De Iturbide',
      'Ajacuba',
      'Alfajayucan',
      'Almoloya',
      'Apan',
      'Atitalaquia',
      'Atlapexco',
      'Atotonilco De Tula',
      'Atotonilco El Grande',
      'Calicanto',
      'Calnali',
      'Cardonal',
      'Chapantongo',
      'Chapulhuacan',
      'Chilcuautla',
      'Cuautepec De Hinojosa',
      'El Arenal',
      'Eloxochitlan',
      'Emiliano Zapata',
      'Epazoyucan',
      'Huasca De Ocampo',
      'Huautla',
      'Huazalingo',
      'Huehuetla',
      'Huejutla De Reyes',
      'Huichapan',
      'Ixmiquilpan',
      'Jacala De Ledezma',
      'Jaltocan',
      'Juárez Hidalgo',
      'La Misión',
      'Lolotla',
      'Metztitlan',
      'Mineral De La Reforma',
      'Mineral Del Chico',
      'Mineral Del Monte',
      'Mixquiahuala De Juárez',
      'Molango De Escamilla',
      'Nicolás Flores',
      'Nopala De Villagran',
      'Omitlan De Juárez',
      'Pachuca De Soto',
      'Pacula',
      'Pisaflores',
      'Progreso De Obregón',
      'San Agustín Metzquititlan',
      'San Agustín Tlaxiaca',
      'San Bartolo Tutotepec',
      'San Felipe Orizatlan',
      'Santiago De Anaya',
      'Santiago Tulantepec De Lugo Guerrero',
      'Singuilucan',
      'Tasquillo',
      'Tecozautla',
      'Tenango De Doria',
      'Tepeapulco',
      'Tepehuacan De Guerrero',
      'Tepeji Del Río De Ocampo',
      'Tepetitlan',
      'Tetepango',
      'Tezontepec De Aldama',
      'Tianguistengo',
      'Tizayuca',
      'Tlahuelilpan',
      'Tlahuiltepa',
      'Tlanalapa',
      'Tlanchinol',
      'Tlaxcoapan',
      'Tolcayuca',
      'Tula De Allende',
      'Tulancingo De Bravo',
      'Villa De Tezontepec',
      'Xochiatipan',
      'Xochicoatlan',
      'Yahualica',
      'Zacualtipan De Ángeles',
      'Zapotlan De Juárez',
      'Zempoala',
      'Zimapan',
    ],
    'MX-JAL': [
      'Acatic',
      'Acatlán De Juárez',
      'Ahualulco De Mercado',
      'Ajijic',
      'Amacueca',
      'Amatitan',
      'Ameca',
      'Antonio Escobedo',
      'Arandas',
      'Atemajac De Brizuela',
      'Atengo',
      'Atenguillo',
      'Atotonilco El Alto',
      'Atoyac',
      'Autlán De Navarro',
      'Ayotlan',
      'Ayutla',
      'Bolaños',
      'Cabo Corrientes',
      'Casimiro Castillo',
      'Cañadas De Obregón',
      'Chapala',
      'Chimaltitan',
      'Chiquilistlan',
      'Cihuatlan',
      'Ciudad Guzmán',
      'Ciudad Venustiano Carranza',
      'Colotlan',
      'Concepción De Buenos Aires',
      'Cuautitlán de García Barragán',
      'Cuautla',
      'Cuquio',
      'Degollado',
      'Ejutla',
      'El Grullo',
      'El Limón',
      'El Salto',
      'Encarnación De Diaz',
      'Etzatlan',
      'Guachinango',
      'Guadalajara',
      'Gómez Farias',
      'Hostotipaquillo',
      'Huejucar',
      'Huejuquilla El Alto',
      'Ixtlahuacan De Los Membrillos',
      'Ixtlahuacan Del Río',
      'Jalostotitlan',
      'Jamay',
      'Jilotlan De Los Dolores',
      'Jocotepec',
      'Juanacatlan',
      'Juchitlan',
      'La Barca',
      'La Huerta',
      'Lagos De Moreno',
      'Manuel M Dieguez',
      'Manzanilla De La Paz',
      'Mascota',
      'Mazamitla',
      'Mexticacan',
      'Mezquitic',
      'Mixtlan',
      'Ocotlan',
      'Ojuelos De Jalisco',
      'Pihuamo',
      'Poncitlan',
      'Puerto Vallarta',
      'Quitupan',
      'San Cristóbal De La Barranca',
      'San Diego De Alejandría',
      'San Juan De Los Lagos',
      'San Martín De Bolaños',
      'San Martín Hidalgo',
      'San Miguel El Alto',
      'San Sebastián Del Oeste',
      'Santa Maria De Los Ángeles',
      'Sayula',
      'Tala',
      'Talpa De Allende',
      'Tamazula De Gordiano',
      'Tapalpa',
      'Tecalitlan',
      'Techaluta De Montenegro',
      'Tecolotlan',
      'Tenamaxtlan',
      'Teocaltiche',
      'Teocuitatlan De Corona',
      'Tepatitlan De Morelos',
      'Tequila',
      'Teuchitlan',
      'Tizapán El Alto',
      'Tlajomulco De Zúñiga',
      'Tlaquepaque',
      'Toliman',
      'Tomatlan',
      'Tonaya',
      'Tonila',
      'Totatiche',
      'Tototlan',
      'Tuxcacuesco',
      'Tuxcueca',
      'Tuxpan',
      'Unión De San Antonio',
      'Unión De Tula',
      'Valle De Guadalupe',
      'Valle De Juárez',
      'Villa Corona',
      'Villa Hidalgo',
      'Villa Purificación',
      'Yahualica De González Gallo',
      'Zacoalco De Torres',
      'Zapopan',
      'Zapotiltic',
      'Zapotitlan De Vadillo',
      'Zapotlan Del Rey',
      'Zapotlanejo',
      'San Juanito de Escobedo',
      'La Manzanilla de la Paz',
      'San Ignacio Cerro Gordo',
      'Zapotlán el Grande',
      'Santa María del Oro',
    ],
    'MX-MIC': [
      'Acuitzio',
      'Aguililla',
      'Angamacutiro',
      'Angangueo',
      'Apatzingan',
      'Aporo',
      'Aquila',
      'Ario',
      'Briseñas',
      'Caracuaro',
      'Charapan',
      'Charo',
      'Chavinda',
      'Cheran',
      'Chilchota',
      'Chinicuila',
      'Chucandiro',
      'Churintzio',
      'Churumuco',
      'Coahuayana',
      'Coalcoman De Vázquez Pallares',
      'Coeneo',
      'Cojumatlan De Regules',
      'Contepec',
      'Copandaro',
      'Cotija',
      'Cuitzeo',
      'Ecuandureo',
      'Epitacio Huerta',
      'Erongaricuaro',
      'Gabriel Zamora',
      'Huandacareo',
      'Huaniqueo',
      'Huetamo',
      'Huiramba',
      'Indaparapeo',
      'Irimbo',
      'Ixtlan',
      'Jacona',
      'Jiquilpan',
      'José Sixto Verduzco',
      'Jungapeo',
      'La Huacana',
      'La Piedad',
      'Los Reyes',
      'Lázaro Cárdenas',
      'Madero',
      'Maravatio',
      'Marcos Castellanos',
      'Mugica',
      'Nahuatzen',
      'Nocupetaro',
      'Nuevo Parangaricutiro',
      'Nuevo Urecho',
      'Numaran',
      'Pajacuaran',
      'Panindicuaro',
      'Paracho',
      'Paracuaro',
      'Penjamillo',
      'Periban',
      'Purepero',
      'Puruandiro',
      'Pátzcuaro',
      'Querendaro',
      'Quiroga',
      'Sahuayo',
      'Salvador Escalante',
      'Santa Ana Maya',
      'Senguio',
      'Susupuato',
      'Tacambaro',
      'Tancitaro',
      'Tangamandapio',
      'Tangancicuaro',
      'Tanhuato',
      'Taretan',
      'Tarimbaro',
      'Tepalcatepec',
      'Tingambato',
      'Tinguindin',
      'Tiquicheo De Nicolás Romero',
      'Tlalpujahua',
      'Tlazazalca',
      'Tocumbo',
      'Tumbiscatio',
      'Turicato',
      'Tuzantla',
      'Tzintzuntzan',
      'Tzitzio',
      'Uruapan',
      'Vista Hermosa',
      'Yurecuaro',
      'Zacapu',
      'Zinaparo',
      'Zinapecuaro',
      'Ziracuaretiro',
      'Zitacuaro',
    ],
    'MX-MOR': [
      'Amacuzac',
      'Atlatlahucan',
      'Axochiapan',
      'Ayala',
      'Coatlán Del Río',
      'Cuernavaca',
      'Huitzilac',
      'Jantetelco',
      'Jiutepec',
      'Jojutla',
      'Jonacatepec',
      'Mazatepec',
      'Miacatlan',
      'Ocuituco',
      'Puente De Ixtla',
      'Temixco',
      'Temoac',
      'Tepalcingo',
      'Tepoztlan',
      'Tequesquitengo',
      'Tetecala',
      'Tlalnepantla',
      'Tlaltizapan',
      'Tlaquiltenango',
      'Tlayacapan',
      'Totolapan',
      'Tétela Del Volcán',
      'Xochitepec',
      'Yautepec',
      'Yecapixtla',
      'Zacatepec',
    ],
    'MX-NAY': [
      'Acaponeta',
      'Ahuacatlán',
      'Amatlán De Cañas',
      'Bahía De Banderas',
      'Compostela',
      'El Nayar',
      'Huajicori',
      'Ixtlan Del Río',
      'Jala',
      'La Yesca',
      'Rosamorada',
      'Ruiz',
      'San Blas',
      'San Pedro Lagunillas',
      'Santa Maria Del Oro',
      'Santiago Ixcuintla',
      'Tecuala',
      'Tepic',
      'Xalisco',
    ],
    'MX-NLE': [
      'Agualeguas',
      'Anahuac',
      'Apodaca',
      'Aramberri',
      'Cadereyta Jiménez',
      'Cerralvo',
      'China',
      'Ciénega De Flores',
      'Doctor Arroyo',
      'Doctor Coss',
      'Doctor González',
      'García',
      'General Bravo',
      'General Escobedo',
      'General Terán',
      'General Treviño',
      'General Zaragoza',
      'General Zuazua',
      'Higueras',
      'Hualahuises',
      'Iturbide',
      'Lampazos De Naranjo',
      'Los Aldamas',
      'Los Herreras',
      'Los Ramones',
      'Marín',
      'Mier Y Noriega',
      'Mina',
      'Montemorelos',
      'Paras',
      'Pesqueria',
      'Rayones',
      'Sabinas Hidalgo',
      'Salinas Victoria',
      'San Nicolás De Los Garza',
      'San Pedro Garza García',
      'Villaldama',
    ],
    'MX-OAX': [
      'Abejones',
      'Acatlán De Pérez Figueroa',
      'Animas Trujano',
      'Asunción Cacalotepec',
      'Asunción Cuyotepeji',
      'Asunción Ixtaltepec',
      'Asunción Nochixtlán',
      'Asunción Ocotlán',
      'Asunción Tlacolulita',
      'Ayoquezco De Aldama',
      'Ayotzintepec',
      'Calihuala',
      'Candelaria Loxicha',
      'Capulalpam De Méndez',
      'Chahuites',
      'Chalcatongo De Hidalgo',
      'Ciudad Ixtepec',
      'Ciénega de Zimatlán',
      'Coatecas Altas',
      'Coicoyan De Las Flores',
      'Concepción Buenavista',
      'Concepción Papalo',
      'Constancia Del Rosario',
      'Cosolapa',
      'Cosoltepec',
      'Cuilapam De Guerrero',
      'Cuyamecalco Villa De Zaragoza',
      'Ejutla De Crespo',
      'El Barrio De La Soledad',
      'El Espinal',
      'Eloxochitlan De Flores Magon',
      'Fresnillo De Trujano',
      'Guadalupe Etla',
      'Guadalupe de Ramírez',
      'Guelatao De Juárez',
      'Guevea De Humboldt',
      'Heroica Ciudad De Tlaxiaco',
      'Huajuapan De León',
      'Huautepec',
      'Huautla De Jiménez',
      'Ixpantepec Nieves',
      'Ixtlan De Juárez',
      'Juchitan De Zaragoza',
      'La Compañía',
      'La Pe',
      'La Trinidad Vista Hermosa',
      'Loma Bonita',
      'Magdalena Apasco',
      'Magdalena Jaltepec',
      'Magdalena Mixtepec',
      'Magdalena Ocotlan',
      'Magdalena Peñasco',
      'Magdalena Teitipac',
      'Magdalena Tequisistlan',
      'Magdalena Tlacotepec',
      'Magdalena Yodocono De Porfirio Diaz',
      'Magdalena Zahuatlan',
      'Mariscala De Juárez',
      'Matías Romero',
      'Mazatlán Villa De Flores',
      'Mesones Hidalgo',
      'Miahuatlan De Porfirio Diaz',
      'Mixistlan De La Reforma',
      'Mártires De Tacubaya',
      'Natividad',
      'Nazareno Etla',
      'Nejapa De Madero',
      'Nuevo Soyaltepec',
      'Nuevo Zoquiapam',
      'Oaxaca De Juárez',
      'Ocotlan De Morelos',
      'Pinotepa De Don Luis',
      'Pluma Hidalgo',
      'Putla Villa De Guerrero',
      'Reforma De Pineda',
      'Reyes Etla',
      'Rojas De Cuauhtémoc',
      'Salina Cruz',
      'San Agustin Etla',
      'San Agustín Amatengo',
      'San Agustín Atenango',
      'San Agustín Chayuco',
      'San Agustín De Las Juntas',
      'San Agustín Loxicha',
      'San Agustín Tlacotepec',
      'San Agustín Yatareni',
      'San Andres Ixtlahuaca',
      'San Andrés Cabecera Nueva',
      'San Andrés Dinicuiti',
      'San Andrés Huaxpaltepec',
      'San Andrés Huayapam',
      'San Andrés Lagunas',
      'San Andrés Nuxiño',
      'San Andrés Paxtlan',
      'San Andrés Sinaxtla',
      'San Andrés Solaga',
      'San Andrés Teotilalpam',
      'San Andrés Tepetlapa',
      'San Andrés Yaa',
      'San Andrés Zabache',
      'San Andrés Zautla',
      'San Antonino Castillo Velasco',
      'San Antonino El Alto',
      'San Antonino Monte Verde',
      'San Antonio Acutla',
      'San Antonio De La Cal',
      'San Antonio Huitepec',
      'San Antonio Nanahuatipam',
      'San Antonio Sinicahua',
      'San Antonio Tepetlapa',
      'San Baltazar Chichicapam',
      'San Baltazar Loxicha',
      'San Baltazar Yatzachi El Bajo',
      'San Bartolo Coyotepec',
      'San Bartolo Soyaltepec',
      'San Bartolo Yautepec',
      'San Bartolomé Ayautla',
      'San Bartolomé Loxicha',
      'San Bartolomé Quialana',
      'San Bartolomé Yucuañe',
      'San Bartolomé Zoogocho',
      'San Bernardo Mixtepec',
      'San Blas Atempa',
      'San Carlos Yautepec',
      'San Cristóbal Amatlan',
      'San Cristóbal Amoltepec',
      'San Cristóbal Lachirioag',
      'San Cristóbal Suchixtlahuaca',
      'San Dionisio Del Mar',
      'San Dionisio Ocotepec',
      'San Dionisio Ocotlan',
      'San Esteban Atatlahuca',
      'San Felipe Jalapa De Diaz',
      'San Felipe Tejalapam',
      'San Felipe Usila',
      'San Francisco Cahuacua',
      'San Francisco Cajonos',
      'San Francisco Chapulapa',
      'San Francisco Chindua',
      'San Francisco Del Mar',
      'San Francisco Huehuetlan',
      'San Francisco Ixhuatan',
      'San Francisco Jaltepetongo',
      'San Francisco Lachigolo',
      'San Francisco Logueche',
      'San Francisco Nuxaño',
      'San Francisco Ozolotepec',
      'San Francisco Sola',
      'San Francisco Telixtlahuaca',
      'San Francisco Teopan',
      'San Francisco Tlapancingo',
      'San Gabriel Mixtepec',
      'San Ildefonso Amatlan',
      'San Ildefonso Sola',
      'San Ildefonso Villa Alta',
      'San Jacinto Amilpas',
      'San Jacinto Tlacotepec',
      'San Jerónimo Coatlan',
      'San Jerónimo Silacayoapilla',
      'San Jerónimo Sosola',
      'San Jerónimo Taviche',
      'San Jerónimo Tecoatl',
      'San Jerónimo Tlacochahuaya',
      'San Jorge Nuchita',
      'San José Ayuquila',
      'San José Chiltepec',
      'San José Del Peñasco',
      'San José Del Progreso',
      'San José Estancia Grande',
      'San José Independencia',
      'San José Lachiguiri',
      'San José Tenango',
      'San Juan Achiutla',
      'San Juan Atepec',
      'San Juan Bautista Atatlahuca',
      'San Juan Bautista Coixtlahuaca',
      'San Juan Bautista Cuicatlan',
      'San Juan Bautista Guelache',
      'San Juan Bautista Jayacatlan',
      'San Juan Bautista Lo De Soto',
      'San Juan Bautista Suchitepec',
      'San Juan Bautista Tlachichilco',
      'San Juan Bautista Tlacoatzintepec',
      'San Juan Bautista Tuxtepec',
      'San Juan Bautista Valle Nacional',
      'San Juan Cacahuatepec',
      'San Juan Chicomezuchil',
      'San Juan Chilateca',
      'San Juan Chiquihuitlan',
      'San Juan Cieneguilla',
      'San Juan Coatzospam',
      'San Juan Colorado',
      'San Juan Comaltepec',
      'San Juan Cotzocon',
      'San Juan De Los Cues',
      'San Juan Del Estado',
      'San Juan Diuxi',
      'San Juan Evangelista Analco',
      'San Juan Guelavia',
      'San Juan Guichicovi',
      'San Juan Ihualtepec',
      'San Juan Juquila Mixes',
      'San Juan Juquila Vijanos',
      'San Juan Lachao',
      'San Juan Lachigalla',
      'San Juan Lajarcia',
      'San Juan Lalana',
      'San Juan Mazatlan',
      'San Juan Mixtepec Juxtlahuaca',
      'San Juan Mixtepec Miahuatlan',
      'San Juan Ozolotepec',
      'San Juan Petlapa',
      'San Juan Quiahije',
      'San Juan Quiotepec',
      'San Juan Sayultepec',
      'San Juan Tabaa',
      'San Juan Tamazola',
      'San Juan Teita',
      'San Juan Teitipac',
      'San Juan Tepeuxila',
      'San Juan Teposcolula',
      'San Juan Yaeé',
      'San Juan Yatzona',
      'San Juan Yucuita',
      'San Juan Ñumi',
      'San Lorenzo Albarradas',
      'San Lorenzo Cacaotepec',
      'San Lorenzo Cuaunecuiltitla',
      'San Lorenzo Texmelucan',
      'San Lorenzo Victoria',
      'San Lucas Camotlan',
      'San Lucas Ojitlan',
      'San Lucas Quiavini',
      'San Lucas Zoquiapam',
      'San Luis Amatlan',
      'San Marcial Ozolotepec',
      'San Marcos Arteaga',
      'San Martín De Los Cansecos',
      'San Martín Huamelulpam',
      'San Martín Itunyoso',
      'San Martín Lachila',
      'San Martín Peras',
      'San Martín Tilcajete',
      'San Martín Toxpalan',
      'San Martín Zacatepec',
      'San Mateo Cajonos',
      'San Mateo Del Mar',
      'San Mateo Etlatongo',
      'San Mateo Nejapam',
      'San Mateo Peñasco',
      'San Mateo Piñas',
      'San Mateo Río Hondo',
      'San Mateo Sindihui',
      'San Mateo Tlapiltepec',
      'San Mateo Yoloxochitlan',
      'San Mateo Yucutindoo',
      'San Melchor Betaza',
      'San Miguel Achiutla',
      'San Miguel Ahuehuetitlan',
      'San Miguel Aloapam',
      'San Miguel Amatitlan',
      'San Miguel Amatlan',
      'San Miguel Chicahua',
      'San Miguel Chimalapa',
      'San Miguel Coatlan',
      'San Miguel Del Puerto',
      'San Miguel Del Río',
      'San Miguel Ejutla',
      'San Miguel El Grande',
      'San Miguel Huautla',
      'San Miguel Mixtepec',
      'San Miguel Panixtlahuaca',
      'San Miguel Peras',
      'San Miguel Piedras',
      'San Miguel Quetzaltepec',
      'San Miguel Santa Flor',
      'San Miguel Suchixtepec',
      'San Miguel Talea De Castro',
      'San Miguel Tecomatlan',
      'San Miguel Tenango',
      'San Miguel Tequixtepec',
      'San Miguel Tilquiapam',
      'San Miguel Tlacamama',
      'San Miguel Tlacotepec',
      'San Miguel Tulancingo',
      'San Miguel Yotao',
      'San Nicolás Hidalgo',
      'San Pablo Coatlan',
      'San Pablo Cuatro Venados',
      'San Pablo Etla',
      'San Pablo Huitzo',
      'San Pablo Huixtepec',
      'San Pablo Macuiltianguis',
      'San Pablo Tijaltepec',
      'San Pablo Villa De Mitla',
      'San Pablo Yaganiza',
      'San Pedro Amuzgos',
      'San Pedro Apostol',
      'San Pedro Atoyac',
      'San Pedro Cajonos',
      'San Pedro Comitancillo',
      'San Pedro Coxcaltepec Cántaros',
      'San Pedro El Alto',
      'San Pedro Huamelula',
      'San Pedro Huilotepec',
      'San Pedro Ixcatlan',
      'San Pedro Ixtlahuaca',
      'San Pedro Jaltepetongo',
      'San Pedro Jicayan',
      'San Pedro Jocotipac',
      'San Pedro Juchatengo',
      'San Pedro Mixtepec-juquila',
      'San Pedro Mixtepec-miahuatlan',
      'San Pedro Molinos',
      'San Pedro Mártir',
      'San Pedro Mártir Quiechapa',
      'San Pedro Mártir Yucuxaco',
      'San Pedro Nopala',
      'San Pedro Ocopetatillo',
      'San Pedro Ocotepec',
      'San Pedro Pochutla',
      'San Pedro Quiatoni',
      'San Pedro Sochiapam',
      'San Pedro Tapanatepec',
      'San Pedro Taviche',
      'San Pedro Teozacoalco',
      'San Pedro Teutila',
      'San Pedro Tidaa',
      'San Pedro Topiltepec',
      'San Pedro Totolapa',
      'San Pedro Tututepec',
      'San Pedro Y San Pablo Ayutla',
      'San Pedro Y San Pablo Teposcolula',
      'San Pedro Y San Pablo Tequixt',
      'San Pedro Yaneri',
      'San Pedro Yolox',
      'San Pedro Yucunama',
      'San Raymundo Jalpan',
      'San Sebastián Abasolo',
      'San Sebastián Coatlan',
      'San Sebastián Ixcapa',
      'San Sebastián Nicananduta',
      'San Sebastián Río Hondo',
      'San Sebastián Tecomaxtlahuaca',
      'San Sebastián Teitipac',
      'San Sebastián Tutla',
      'San Simon Zahuatlan',
      'San Simón Almolongas',
      'San Vicente Coatlan',
      'San Vicente Lachixio',
      'San Vicente Nuñu',
      'Santa Ana Ateixtlahuaca',
      'Santa Ana Cuauhtémoc',
      'Santa Ana Del Valle',
      'Santa Ana Tavela',
      'Santa Ana Tlapacoyan',
      'Santa Ana Yareni',
      'Santa Ana Zegache',
      'Santa Catalina Quieri',
      'Santa Catarina Cuixtla',
      'Santa Catarina Ixtepeji',
      'Santa Catarina Juquila',
      'Santa Catarina Lachatao',
      'Santa Catarina Loxicha',
      'Santa Catarina Mechoacan',
      'Santa Catarina Minas',
      'Santa Catarina Quiane',
      'Santa Catarina Quioquitani',
      'Santa Catarina Tayata',
      'Santa Catarina Ticua',
      'Santa Catarina Yosonotu',
      'Santa Catarina Zapoquila',
      'Santa Cruz Acatepec',
      'Santa Cruz Amilpas',
      'Santa Cruz De Bravo',
      'Santa Cruz Itundujia',
      'Santa Cruz Mixtepec',
      'Santa Cruz Nundaco',
      'Santa Cruz Papalutla',
      'Santa Cruz Tacache De Mina',
      'Santa Cruz Tacahua',
      'Santa Cruz Tayata',
      'Santa Cruz Xitla',
      'Santa Cruz Xoxocotlan',
      'Santa Cruz Zenzontepec',
      'Santa Gertrudis',
      'Santa Inés De Zaragoza',
      'Santa Inés Del Monte',
      'Santa Inés Yatzeche',
      'Santa Lucia Del Camino',
      'Santa Lucia Miahuatlan',
      'Santa Lucia Monteverde',
      'Santa Lucia Ocotlan',
      'Santa Magdalena Jicotlan',
      'Santa Maria Alotepec',
      'Santa Maria Apazco',
      'Santa Maria Atzompa',
      'Santa Maria Camotlan',
      'Santa Maria Chachoapam',
      'Santa Maria Chilapa De Diaz',
      'Santa Maria Chilchotla',
      'Santa Maria Chimalapa',
      'Santa Maria Colotepec',
      'Santa Maria Cortijo',
      'Santa Maria Coyotepec',
      'Santa Maria Del Rosario',
      'Santa Maria Del Tule',
      'Santa Maria Ecatepec',
      'Santa Maria Guelace',
      'Santa Maria Guienagati',
      'Santa Maria Huatulco',
      'Santa Maria Huazolotitlan',
      'Santa Maria Ipalapa',
      'Santa Maria Ixcatlan',
      'Santa Maria Jacatepec',
      'Santa Maria Jalapa Del Marques',
      'Santa Maria Jaltianguis',
      'Santa Maria La Asunción',
      'Santa Maria Lachixio',
      'Santa Maria Mixtequilla',
      'Santa Maria Nativitas',
      'Santa Maria Nduayaco',
      'Santa Maria Ozolotepec',
      'Santa Maria Papalo',
      'Santa Maria Petapa',
      'Santa Maria Peñoles',
      'Santa Maria Quiegolani',
      'Santa Maria Sola',
      'Santa Maria Tataltepec',
      'Santa Maria Tecomavaca',
      'Santa Maria Temaxcalapa',
      'Santa Maria Temaxcaltepec',
      'Santa Maria Teopoxco',
      'Santa Maria Tepantlali',
      'Santa Maria Texcatitlan',
      'Santa Maria Tlahuitoltepec',
      'Santa Maria Tlalixtac',
      'Santa Maria Tonameca',
      'Santa Maria Totolapilla',
      'Santa Maria Xadani',
      'Santa Maria Yalina',
      'Santa Maria Yavesia',
      'Santa Maria Yolotepec',
      'Santa Maria Yosoyua',
      'Santa Maria Yucuhiti',
      'Santa Maria Zacatepec',
      'Santa Maria Zaniza',
      'Santa Maria Zoquitlan',
      'Santiago Amoltepec',
      'Santiago Apoala',
      'Santiago Apóstol',
      'Santiago Astata',
      'Santiago Atitlan',
      'Santiago Ayuquililla',
      'Santiago Cacaloxtepec',
      'Santiago Camotlan',
      'Santiago Chazumba',
      'Santiago Choapam',
      'Santiago Comaltepec',
      'Santiago Del Río',
      'Santiago Huajolotitlan',
      'Santiago Huauclilla',
      'Santiago Ihuitlan Plumas',
      'Santiago Ixcuintepec',
      'Santiago Ixtayutla',
      'Santiago Jamiltepec',
      'Santiago Jocotepec',
      'Santiago Juxtlahuaca',
      'Santiago Lachiguiri',
      'Santiago Lalopa',
      'Santiago Laollaga',
      'Santiago Laxopa',
      'Santiago Llano Grande',
      'Santiago Matatlán',
      'Santiago Miltepec',
      'Santiago Minas',
      'Santiago Nacaltepec',
      'Santiago Nejapilla',
      'Santiago Niltepec',
      'Santiago Nundiche',
      'Santiago Nuyoo',
      'Santiago Pinotepa Nacional',
      'Santiago Suchilquitongo',
      'Santiago Tamazola',
      'Santiago Tapextla',
      'Santiago Tenango',
      'Santiago Tepetlapa',
      'Santiago Tetepec',
      'Santiago Texcalcingo',
      'Santiago Textitlan',
      'Santiago Tilantongo',
      'Santiago Tillo',
      'Santiago Tlazoyaltepec',
      'Santiago Xanica',
      'Santiago Xiacui',
      'Santiago Yaitepec',
      'Santiago Yaveo',
      'Santiago Yolomecatl',
      'Santiago Yosondua',
      'Santiago Yucuyachi',
      'Santiago Zacatepec',
      'Santiago Zoochila',
      'Santo Domingo Albarradas',
      'Santo Domingo Armenta',
      'Santo Domingo Chihuitan',
      'Santo Domingo De Morelos',
      'Santo Domingo Ingenio',
      'Santo Domingo Ixcatlan',
      'Santo Domingo Nuxaa',
      'Santo Domingo Ozolotepec',
      'Santo Domingo Petapa',
      'Santo Domingo Roayaga',
      'Santo Domingo Tehuantepec',
      'Santo Domingo Teojomulco',
      'Santo Domingo Tepuxtepec',
      'Santo Domingo Tlatayapam',
      'Santo Domingo Tomaltepec',
      'Santo Domingo Tonala',
      'Santo Domingo Tonaltepec',
      'Santo Domingo Xagacia',
      'Santo Domingo Yanhuitlan',
      'Santo Domingo Yodohino',
      'Santo Domingo Zanatepec',
      'Santo Tomas Jalieza',
      'Santo Tomas Mazaltepec',
      'Santo Tomas Ocotepec',
      'Santo Tomas Tamazulapam',
      'Santos Reyes Nopala',
      'Santos Reyes Papalo',
      'Santos Reyes Tepejillo',
      'Santos Reyes Yucuna',
      'Silacayoapam',
      'Sitio De Xitlapehua',
      'Soledad Etla',
      'Tamazulapam Del Espíritu Santo',
      'Tanetze De Zaragoza',
      'Taniche',
      'Tataltepec De Valdes',
      'Teococuilco De Marcos Pérez',
      'Teotitlan De Flores Magón',
      'Teotitlan Del Valle',
      'Teotongo',
      'Tepelmeme Villa De Morelos',
      'Tezoatlan De Segura Y Luna',
      'Tlacolula De Matamoros',
      'Tlacotepec Plumas',
      'Tlalixtac De Cabrera',
      'Totontepec Villa De Morelos',
      'Trinidad Zaachila',
      'Unión Hidalgo',
      'Valerio Trujano',
      'Villa De Etla',
      'Villa De Tamazulapam Del Progreso',
      'Villa De Zaachila',
      'Villa Diaz Ordaz',
      'Villa Sola De Vega',
      'Villa Tejupam De La Unión',
      'Yaxe',
      'Yogana',
      'Yutanduchi De Guerrero',
      'Zapotitlan Del Río',
      'Zapotitlan Lagunas',
      'Zapotitlan Palmas',
      'Zimatlan De Álvarez',
      'San Miguel Soyaltepec',
      'Villa de Chilapa de Díaz',
      'Villa de Tututepec de Melchor Ocampo',
      'Villa Talea de Castro',
      'San Pedro Y San Pablo Tequixtepec',
      'Chiquihuitlán de Benito Juárez',
    ],
    'MX-PUE': [
      'Acajete',
      'Acateno',
      'Acatzingo',
      'Acteopan',
      'Ahuatlan',
      'Ahuazotepec',
      'Ahuehuetitla',
      'Ajalpan',
      'Albino Zertuche',
      'Aljojuca',
      'Altepexi',
      'Amixtlan',
      'Amozoc',
      'Aquixtla',
      'Atempan',
      'Atexcal',
      'Atlequizayan',
      'Atlixco',
      'Atoyatempan',
      'Atzala',
      'Atzitzihuacan',
      'Atzitzintla',
      'Axutla',
      'Ayotoxco De Guerrero',
      'Calpan',
      'Caltepec',
      'Camocuautla',
      'Caxhuacan',
      'Cañada Morelos',
      'Chalchicomula De Sesma',
      'Chapulco',
      'Chiautzingo',
      'Chichiquila',
      'Chiconcuautla',
      'Chietla',
      'Chigmecatitlan',
      'Chignahuapan',
      'Chignautla',
      'Chila',
      'Chila De La Sal',
      'Chila Honey',
      'Chilchotla',
      'Chinantla',
      'Chipilo',
      'Coatepec',
      'Coatzingo',
      'Cohetzala',
      'Cohuecan',
      'Coronango',
      'Coxcatlan',
      'Coyomeapan',
      'Cuapiaxtla De Madero',
      'Cuautempan',
      'Cuautinchan',
      'Cuautlancingo',
      'Cuayuca De Andrade',
      'Cuetzalan Del Progreso',
      'Cuyoaco',
      'Domingo Arenas',
      'Epatlan',
      'Esperanza',
      'Francisco Z Mena',
      'General Felipe Ángeles',
      'Hermenegildo Galeana',
      'Honey',
      'Huaquechula',
      'Huatlatlauca',
      'Huauchinango',
      'Huehuetlan El Chico',
      'Huehuetlan El Grande',
      'Huejotzingo',
      'Hueyapan',
      'Hueytamalco',
      'Hueytlalpan',
      'Huitzilan De Serdan',
      'Huitziltepec',
      'Ignacio Allende',
      'Ixcamilpa De Guerrero',
      'Ixcaquixtla',
      'Ixtacamaxtitlan',
      'Ixtepec',
      'Izucar De Matamoros',
      'Jalpan',
      'Jolalpan',
      'Jonotla',
      'Jopala',
      'Juan C Bonilla',
      'Juan Galindo',
      'Juan N Méndez',
      'La Magdalena Tlatlauquitepec',
      'Lafragua',
      'Libres',
      'Los Reyes De Juárez',
      'Mazapiltepec De Juárez',
      'Mixtla',
      'Molcaxac',
      'Naupan',
      'Nauzontla',
      'Nealtican',
      'Nicolás Bravo',
      'Nopalucan',
      'Ocoyucan',
      'Olintla',
      'Oriental',
      'Pahuatlan',
      'Palmar De Bravo',
      'Petlalcingo',
      'Piaxtla',
      'Quecholac',
      'Quimixtlan',
      'Rafael Lara Grajales',
      'San Andrés Cholula',
      'San Antonio Cañada',
      'San Diego La Mesa Tochimiltzingo',
      'San Felipe Teotlalcingo',
      'San Felipe Tepatlan',
      'San Gabriel Chilac',
      'San Gregorio Atzompa',
      'San Jerónimo Tecuanipan',
      'San Jerónimo Xayacatlan',
      'San José Chiapa',
      'San José Miahuatlan',
      'San Juan Atenco',
      'San Juan Atzompa',
      'San Martín Texmelucan',
      'San Martín Totoltepec',
      'San Matías Tlalancaleca',
      'San Miguel Ixitlan',
      'San Miguel Xoxtla',
      'San Nicolás Buenos Aires',
      'San Nicolás De Los Ranchos',
      'San Pablo Anicano',
      'San Pedro Cholula',
      'San Pedro Yeloixtlahuaca',
      'San Salvador El Seco',
      'San Salvador El Verde',
      'San Salvador Huixcolotla',
      'San Sebastián Tlacotepec',
      'Santa Catarina Tlaltempan',
      'Santa Inés Ahuatempan',
      'Santa Isabel Cholula',
      'Santiago Miahuatlan',
      'Santo Tomas Hueyotlipan',
      'Soltepec',
      'Tecali De Herrera',
      'Tecamachalco',
      'Tecomatlan',
      'Tehuacan',
      'Tehuitzingo',
      'Tenampulco',
      'Teopantlan',
      'Teotlalco',
      'Tepanco De López',
      'Tepango De Rodríguez',
      'Tepatlaxco De Hidalgo',
      'Tepeaca',
      'Tepemaxalco',
      'Tepeojuma',
      'Tepetzintla',
      'Tepexco',
      'Tepexi De Rodríguez',
      'Tepeyahualco',
      'Tepeyahualco De Cuauhtémoc',
      'Teziutlan',
      'Tianguismanalco',
      'Tilapa',
      'Tlachichuca',
      'Tlacotepec De Benito Juárez',
      'Tlacuilotepec',
      'Tlahuapan',
      'Tlaltenango',
      'Tlanepantla',
      'Tlaola',
      'Tlapacoya',
      'Tlapanala',
      'Tlatlauquitepec',
      'Tlaxco',
      'Tochimilco',
      'Tochtepec',
      'Totoltepec De Guerrero',
      'Tulcingo',
      'Tuzamapan De Galeana',
      'Tzicatlacoyan',
      'Tétela De Ocampo',
      'Tételes De Ávila Castillo',
      'Xayacatlan De Bravo',
      'Xicotepec',
      'Xicotlan',
      'Xiutetelco',
      'Xochiapulco',
      'Xochiltepec',
      'Xochitlan De Vicente Suárez',
      'Xochitlan Todos Santos',
      'Yaonahuac',
      'Yehualtepec',
      'Zacapala',
      'Zacapoaxtla',
      'Zacatlan',
      'Zapotitlan',
      'Zapotitlan De Méndez',
      'Zautla',
      'Zihuateutla',
      'Zinacatepec',
      'Zongozotla',
      'Zoquiapan',
      'Zoquitlan',
    ],
    'MX-QUE': [
      'Amealco De Bonfil',
      'Cadereyta De Montes',
      'Colon',
      'Corregidora',
      'El Marques',
      'Ezequiel Montes',
      'Huimilpan',
      'Jalpan De Serra',
      'Landa De Matamoros',
      'Pedro Escobedo',
      'Peñamiller',
      'Pinal De Amoles',
      'Querétaro',
      'Tequisquiapan',
    ],
    'MX-ROO': [
      'Bacalar',
      'Cancún/Benito Juárez',
      'Cozumel',
      'Felipe Carrillo Puerto',
      'Isla Mujeres',
      'José Ma. Morelos',
      'Othon P Blanco',
      'Puerto Morelos',
      'Solidaridad / Riviera Maya',
      'Tulum',
    ],
    'MX-SLP': [
      'Ahualulco',
      'Alaquines',
      'Aquismon',
      'Armadillo De Los Infante',
      'Axtla De Terrazas',
      'Catorce',
      'Cerritos',
      'Cerro De San Pedro',
      'Charcas',
      'Ciudad Del Maíz',
      'Ciudad Fernández',
      'Ciudad Valles',
      'Ebano',
      'Guadalcazar',
      'Huehuetlan',
      'Matehuala',
      'Matlapa',
      'Mexquitic De Carmona',
      'Moctezuma',
      'San Ciro De Acosta',
      'San Luis Potosí',
      'San Martín Chalchicuautla',
      'San Nicolas Tolentino',
      'San Vicente Tancuayalab',
      'Santa Maria Del Río',
      'Soledad De Graciano Sánchez',
      'Tamasopo',
      'Tamazunchale',
      'Tampacan',
      'Tampamolon Corona',
      'Tamuin',
      'Tancanhuitz De Santos',
      'Tanlajas',
      'Tanquian De Escobedo',
      'Tierranueva',
      'Vanegas',
      'Venado',
      'Villa De Arista',
      'Villa De Arriaga',
      'Villa De Guadalupe',
      'Villa De La Paz',
      'Villa De Ramos',
      'Villa De Reyes',
      'Villa Juárez',
      'Xilitla',
      'El Naranjo',
    ],
    'MX-SIN': [
      'Ahome',
      'Badiraguato',
      'Choix',
      'Culiacán',
      'Cósala',
      'El Fuerte',
      'Elota',
      'Escuinapa',
      'Guasave',
      'Mazatlán',
      'Mocorito',
      'Navolato',
      'Salvador Alvarado',
      'Sinaloa',
    ],
    'MX-SON': [
      'Aconchi',
      'Agua Prieta',
      'Alamitos',
      'Alamos',
      'Altar',
      'Arivechi',
      'Arizpe',
      'Atil',
      'Bacadehuachi',
      'Bacanora',
      'Bacerac',
      'Bacoachi',
      'Bacum',
      'Banamichi',
      'Baviacora',
      'Bavispe',
      'Benjamín Hill',
      'Caborca',
      'Cajeme',
      'Cananea',
      'Carbo',
      'Cucurpe',
      'Cumpas',
      'Divisaderos',
      'Empalme',
      'Etchojoa',
      'Fronteras',
      'General Plutarco Elías Calles',
      'Guaymas',
      'Hermosillo',
      'Huachinera',
      'Huasabas',
      'Huatabampo',
      'Huepac',
      'Imuris',
      'La Colorada',
      'Naco',
      'Nacori Chico',
      'Nacozari De García',
      'Navojoa',
      'Obregon',
      'Onavas',
      'Opodepe',
      'Oquitoa',
      'Pitiquito',
      'Puerto Peñasco',
      'Quiriego',
      'Sahuaripa',
      'San Felipe De Jesús',
      'San Luis Río Colorado',
      'San Miguel De Horcasitas',
      'San Pedro De La Cueva',
      'Saric',
      'Soyopa',
      'Suaqui Grande',
      'Tepache',
      'Trincheras',
      'Tubutama',
      'Ures',
      'Villa Pesquería',
      'Yecora',
      'Benitoxa0Juárez',
      'San Ignacio Rio Muerto',
    ],
    'MX-TAB': [
      'Balancan',
      'Centla',
      'Comalcalco',
      'Cunduacan',
      'Huimanguillo',
      'Jalpa De Méndez',
      'Jonuta',
      'Macuspana',
      'Nacajuca',
      'Tacotalpa',
      'Teapa',
      'Tenosique',
    ],
    'MX-TAM': [
      'Antiguo Morelos',
      'Casas',
      'Ciudad Madero',
      'Ciudad Mante',
      'Cruillas',
      'El Mante',
      'Guemez',
      'Gustavo Diaz Ordaz',
      'Jaumave',
      'Llera',
      'Mainero',
      'Mier',
      'Miguel Alemán',
      'Miquihuana',
      'Méndez',
      'Nuevo Laredo',
      'Nuevo Morelos',
      'Palmillas',
      'Reynosa',
      'San Nicolas',
      'Soto La Marina',
      'Tampico',
      'Valle Hermoso',
      'Xicotencatl',
    ],
    'MX-TLA': [
      'Acuamanala De Miguel Hidalgo',
      'Amaxac De Guerrero',
      'Apetatitlán De A Carbajal',
      'Apizaco',
      'Atlangatepec',
      'Atltzayanca',
      'Calpulalpan',
      'Chiautempan',
      'Contla De Juan Cuamatzi',
      'Cuapiaxtla',
      'Cuaxomulco',
      'El Carmen Tequexquitla',
      'Españita',
      'Huamantla',
      'Hueyotlipan',
      'Ixtacuixtla De M Matamoros',
      'Ixtenco',
      'Mazatecochco De José Ma. Morelos',
      'Muñoz De Domingo Arenas',
      'Nanacamilpa De Mariano Arista',
      'Nativitas',
      'Panotla',
      'Papalotla De Xicohtencatl',
      'San Juan Huactzinco',
      'San Pablo Del Monte',
      'Sanctorum De Lázaro Cárdenas',
      'Santa Cruz Tlaxcala',
      'Santa Isabel Xiloxostla',
      'Teolocholco',
      'Tepetitla De Lardizábal',
      'Tepeyanco',
      'Terrenate',
      'Tetla',
      'Tetlatlahuca',
      'Tlaxcala',
      'Tocatlan',
      'Totolac',
      'Tzompantepec',
      'Xaloztoc',
      'Xaltocan',
      'Xicohtzinco',
      'Yauhquemehcan',
      'Z De Trinidad Sanchez Santos',
      'Zacatelco',
      'San Damián Texoloc',
      'La Magdalena Tlaltelulco',
      'Santa Cruz Quilehtla',
      'Santa Ana Nopalucan',
      'Tetla de la Solidaridad',
      'San Lucas Tecopilco',
      'Santa Apolonia Teacalco',
      'San Jerónimo Zacualpan',
      'San José Teacalco',
      'San Lorenzo Axocomanitla',
      'San Francisco Tetlanohcan',
      'Santa Catarina Ayometla',
    ],
    'MX-VER': [
      'Acayucan',
      'Acula',
      'Acultzingo',
      'Agua Dulce',
      'Alpatlahuac',
      'Alto Lucero',
      'Altotonga',
      'Amatlan De Los Reyes',
      'Amatlan Tuxpan',
      'Apazapan',
      'Astacinga',
      'Atlahuilco',
      'Atzacan',
      'Atzalan',
      'Ayahualulco',
      'Banderilla',
      'Boca Del Río',
      'Calcahualco',
      'Camarón De Tejeda',
      'Camerino Z Mendoza',
      'Carlos A. Carrillo',
      'Carrillo Puerto',
      'Castillo De Teayo',
      'Catemaco',
      'Cazones De Herrera',
      'Chacaltianguis',
      'Chalma',
      'Chiconamel',
      'Chiconquiaco',
      'Chicontepec',
      'Chinampa De Gorostiza',
      'Chocaman',
      'Chontla',
      'Chumatlan',
      'Citlaltepetl',
      'Coacoatzintla',
      'Coahuitlan',
      'Coatzacoalcos',
      'Coatzintla',
      'Coetzala',
      'Colipa',
      'Cosamaloapan',
      'Cosautlan De Carvajal',
      'Coscomatepec',
      'Cosoleacaque',
      'Cotaxtla',
      'Coxquihui',
      'Coyutla',
      'Cuichapa',
      'Cuitláhuac',
      'El Higo',
      'Filomeno Mata',
      'Fortín',
      'Gutiérrez Zamora',
      'Hidalgotitlan',
      'Huatusco',
      'Huayacocotla',
      'Hueyapan De Ocampo',
      'Huiloapan De Cuauhtémoc',
      'Ignacio De La Llave',
      'Ilamatlan',
      'Ixcatepec',
      'Ixhuacan De Los Reyes',
      'Ixhuatlan De Madero',
      'Ixhuatlan Del Café',
      'Ixhuatlan Del Sureste',
      'Ixhuatlancillo',
      'Ixmatlahuacan',
      'Ixtaczoquitlan',
      'Jalacingo',
      'Jalcomulco',
      'Jaltipan',
      'Jamapa',
      'Jesús Carranza',
      'Juan Rodríguez Clara',
      'Juchique De Ferrer',
      'La Antigua',
      'La Perla',
      'Landero Y Coss',
      'Las Choapas',
      'Las Minas',
      'Las Vigas De Ramírez',
      'Lerdo De Tejada',
      'Maltrata',
      'Manlio Fabio Altamirano',
      'Mariano Escobedo',
      'Martínez De La Torre',
      'Mecatlan',
      'Mecayapan',
      'Miahuatlan',
      'Misantla',
      'Mixtla De Altamirano',
      'Moloacán',
      'Nanchital De Lázaro Cárdenas Del Río',
      'Naolinco',
      'Nautla',
      'Oluta',
      'Omealca',
      'Orizaba',
      'Otatitlan',
      'Oteapan',
      'Ozuluama',
      'Pajapan',
      'Panuco',
      'Papantla',
      'Paso De Ovejas',
      'Paso Del Macho',
      'Perote',
      'Platon Sánchez',
      'Playa Vicente',
      'Poza Rica De Hidalgo',
      'Pueblo Viejo',
      'Rafael Delgado',
      'Rafael Lucio',
      'Saltabarranca',
      'San Andrés Tenejapan',
      'San Andrés Tuxtla',
      'San Juan Evangelista',
      'Santiago Tuxtla',
      'Sayula De Alemán',
      'Sochiapa',
      'Soconusco',
      'Soledad Atzompa',
      'Soledad De Doblado',
      'Soteapan',
      'Tamalin',
      'Tamiahua',
      'Tampico Alto',
      'Tancoco',
      'Tantima',
      'Tantoyuca',
      'Tatatila',
      'Tecolutla',
      'Tehuipango',
      'Tejería',
      'Temapache',
      'Tempoal',
      'Tenampa',
      'Tenochtitlan',
      'Teocelo',
      'Tepatlaxco',
      'Tepetlan',
      'Texcatepec',
      'Texhuacan',
      'Texistepec',
      'Tezonapa',
      'Tihuatlan',
      'Tlachichilco',
      'Tlacojalpan',
      'Tlacolulan',
      'Tlacotalpan',
      'Tlacotepec De Mejia',
      'Tlalixcoyan',
      'Tlalnelhuayocan',
      'Tlaltetela',
      'Tlapacoyan',
      'Tlaquilpa',
      'Tlilapan',
      'Tonayan',
      'Totutla',
      'Tres Valles',
      'Tuxtilla',
      'Ursulo Galván',
      'Uxpanapa',
      'Vega De Alatorre',
      'Villa Aldama',
      'Xalapa',
      'Xico',
      'Xoxocotla',
      'Yanga',
      'Yecuatla',
      'Zentla',
      'Zongolica',
      'Zontecomatlán de López y Fuentes',
      'Zozocolco De Hidalgo',
      'Ángel R Cabada',
      'Santiago Sochiapan',
      'Tatahuicapan De Juárez',
      'Naranjos Amatlán',
      'Álamo Temapache',
    ],
    'MX-YUC': [
      'Abala',
      'Acanceh',
      'Akil',
      'Baca',
      'Bokoba',
      'Buctzotz',
      'Cacalchen',
      'Calotmul',
      'Cansahcab',
      'Cantamayec',
      'Celestun',
      'Cenotillo',
      'Chablekal',
      'Chacsinkin',
      'Chankom',
      'Chapab',
      'Chemax',
      'Chichimila',
      'Chicxulub Pueblo',
      'Chikindzonot',
      'Chochola',
      'Chumayel',
      'Conkal',
      'Cuncunul',
      'Cuzama',
      'Dzan',
      'Dzemul',
      'Dzidzantun',
      'Dzilam De Bravo',
      'Dzilam González',
      'Dzitas',
      'Dzoncauich',
      'Espita',
      'Halacho',
      'Hocaba',
      'Hoctun',
      'Homun',
      'Huhi',
      'Hunucma',
      'Ixil',
      'Izamal',
      'Kanasin',
      'Kantunil',
      'Kaua',
      'Kinchil',
      'Konkal',
      'Kopoma',
      'Mama',
      'Maxcanu',
      'Mayapan',
      'Mococha',
      'Motul',
      'Muna',
      'Muxupip',
      'Mérida',
      'Opichen',
      'Oxkutzcab',
      'Panaba',
      'Peto',
      'Quintana Roo',
      'Río Lagartos',
      'Sacalum',
      'Samahil',
      'Sanahcat',
      'Seye',
      'Sinanche',
      'Sotuta',
      'Sucila',
      'Sudzal',
      'Suma',
      'Tahdziu',
      'Tahmek',
      'Teabo',
      'Tecoh',
      'Tekal De Venegas',
      'Tekanto',
      'Tekax',
      'Tekit',
      'Tekom',
      'Telchac Pueblo',
      'Telchac Puerto',
      'Temax',
      'Temozon',
      'Tepakan',
      'Tetiz',
      'Teya',
      'Ticul',
      'Timucuy',
      'Tinum',
      'Tixcacalcupul',
      'Tixkokob',
      'Tixmehuac',
      'Tixpehual',
      'Tizimin',
      'Tunkas',
      'Tzucacab',
      'Uayma',
      'Ucu',
      'Uman',
      'Xocchel',
      'Yaxcaba',
      'Yaxkukul',
      'Yobain',
    ],
    'MX-ZAC': [
      'Apozol',
      'Apulco',
      'Atolinga',
      'Cañitas De Felipe Pescador',
      'Chalchihuites',
      'Concepción Del Oro',
      'Francisco R Murguía',
      'Fresnillo',
      'Genaro Codina',
      'General Enrique Estrada',
      'General Joaquín Amaro',
      'General Panfilo Natera',
      'Huanusco',
      'Jalpa',
      'Jerez',
      'Jiménez Del Teul',
      'Juan Aldama',
      'Juchipila',
      'Luis Moya',
      'Mazapil',
      'Mezquital Del Oro',
      'Miguel Auza',
      'Momax',
      'Monte Escobedo',
      'Moyahua De Estrada',
      'Nochistlan De Mejia',
      'Noria De Ángeles',
      'Ojocaliente',
      'Pinos',
      'Sain Alto',
      'Sombrerete',
      'Susticacan',
      'Tabasco',
      'Tepechitlan',
      'Tepetongo',
      'Teul De González Ortega',
      'Tlaltenango De Sánchez Román',
      'Trinidad García De La Cadena',
      'Vetagrande',
      'Villa De Cos',
      'Villa García',
      'Villa González Ortega',
      'Zacatecas',
      'Santa María de la Paz',
      'El Plateado de Joaquin Amaro',
    ],
  },
  NIC: {
    'NI-AN': ['Bonanza', 'Mulukukú', 'Prinzapolka', 'Puerto Cabezas', 'Rosita', 'Siuna', 'Waslala', 'Waspán'],
    'NI-AS': [
      'Bluefields',
      'Desembocadura de Río Grande',
      'El Ayote',
      'El Rama',
      'El Tortuguero',
      'Islas del Maíz',
      'Kukra Hill',
      'La Cruz de Río Grande',
      'Laguna de Perlas',
      'Muelle de los Bueyes',
      'Nueva Guinea',
      'Paiwas',
    ],
    'NI-BO': ['Boaco', 'Camoapa', 'San José de Los Remates', 'Teustepe'],
    'NI-CA': ['Diriamba', 'Jinotepe', 'La Conquista', 'La Paz de Oriente'],
    'NI-CI': [
      'Chichigalpa',
      'Chinandega',
      'Cinco Pinos',
      'El Realejo',
      'El Viejo',
      'Posoltega',
      'Puerto Morazán',
      'San Francisco del Norte',
      'San Pedro del Norte',
      'Santo Tomás del Norte',
      'Somotillo',
    ],
    'NI-CO': ['Acoyapa', 'El Coral', 'Juigalpa', 'San Francisco de Cuapa', 'San Pedro de Lóvago', 'Villa Sandino'],
    'NI-ES': ['Condega', 'Estelí', 'San Juan de Limay'],
    'NI-GR': ['Diriomo', 'Diriá', 'Nandaime'],
    'NI-JI': [
      'El Cuá',
      'Jinotega',
      'San José de Bocay',
      'San Rafael del Norte',
      'San Sebastián de Yalí',
      'Santa María de Pantasma',
      'Wiwilí',
    ],
    'NI-LE': [
      'Achuapa',
      'El Jicaral',
      'La Paz Centro',
      'Larreynaga',
      'Nagarote',
      'Quezalguaque',
      'Santa Rosa del Peñón',
      'Telica',
    ],
    'NI-MD': [
      'Las Sabanas',
      'Palacagüina',
      'San José de Cúsmapa',
      'San Juan de Río Coco',
      'Somoto',
      'Telpaneca',
      'Totogalpa',
      'Yalagüina',
    ],
    'NI-MN': [
      'Ciudad Sandino',
      'El Crucero',
      'Managua',
      'Mateare',
      'San Francisco Libre',
      'San Rafael del Sur',
      'Ticuantepe',
      'Tipitapa',
      'Villa El Carmen',
    ],
    'NI-MS': [
      'La Concepción',
      'Masatepe',
      'Masaya',
      'Nandasmo',
      'Nindirí',
      'Niquinohomo',
      'San Juan de Oriente',
      'Tisma',
    ],
    'NI-MT': [
      'Ciudad Darío',
      'El Tuma - La Dalia',
      'Matagalpa',
      'Matiguás',
      'Muy Muy',
      'Rancho Grande',
      'Sébaco',
      'Terrabona',
    ],
    'NI-NS': ['Ciudad Antigua', 'Dipilto', 'Güigüilí', 'Mozonte', 'Murra', 'Ocotal', 'Quilalí'],
    'NI-RI': ['Altagracia', 'Moyogalpa', 'Rivas', 'San Juan del Sur', 'Tola'],
    'NI-SJ': ['El Almendro', 'Morrito', 'San Juan del Norte'],
  },
  PAN: {
    'PA-1': ['Bocas del Toro', 'Changuinola', 'Chiriquí Grande'],
    'PA-4': [
      'Alanje',
      'Barú',
      'Boquerón',
      'Boquete',
      'Bugaba',
      'David',
      'Dolega',
      'Gualaca',
      'Renacimiento',
      'San Félix',
      'Tolé',
    ],
    'PA-2': ['Aguadulce', 'Antón', 'Natá', 'Olá', 'Penonomé'],
    'PA-3': ['Chagres', 'Donoso', 'Portobelo'],
    'PA-5': ['Chepigana', 'Pinogana'],
    'PA-EM': ['Cémaco', 'Sambú'],
    'PA-6': ['Chitré', 'Los Pozos', 'Ocú', 'Parita', 'Pesé'],
    'PA-7': ['Guararé', 'Las Tablas', 'Macaracas', 'Pedasí', 'Pocrí', 'Tonosí'],
    'PA-NB': ['Besiko', 'Kankintú', 'Kusapín', 'Mironó', 'Müna', 'Nole Düima', 'Ñürün'],
    'PA-8': ['Arraiján', 'Capira', 'Chame', 'Chepo', 'Chimán', 'Taboga'],
    'PA-KY': [],
    'PA-9': [
      'Ailigandi',
      'Calobre',
      'Cañazas',
      'Las Palmas',
      'Mariato',
      'Nargana',
      'Obaldia',
      'Río de Jesús',
      'Soná',
      'Tubuala',
    ],
  },
  PRY: {
    'PY-16': ['Bahía Negra', 'Fuerte Olimpo', 'Isla Margarita', 'Lagerenza', 'Puerto Guaraní', 'Puerto la Esperanza'],
    'PY-10': [
      'Ciudad del Este',
      'Domingo Martinez de Irala',
      'Dr. Juan Leon Mallorquin',
      'Hernandarias',
      'Itaquyry',
      'Juan E. Oleary',
      'Los Cedrales',
      'Mbaracayú',
      'Minga Guazu',
      'Minga Pora',
      'Presidente Franco',
      'Puerto Bertoni',
      'Santa Rosa del Monday',
      'Yguazu',
      'Ñacunday',
    ],
    'PY-13': ['Capitán Bado', 'Pedro Juan Caballero'],
    'PY-ASU': [
      'Banco San Miguel',
      'Bañado Santa Ana',
      'Bañado Tacumbú',
      'Catedral',
      'Cañada del Ybaray',
      'Ciudad Nueva',
      'Dr. Francia',
      'General Caballero',
      'General Díaz',
      'Hipódromo',
      'Itá Enramada',
      'Itá Pytá Punta',
      'Jara',
      'Las Lomas (Carmelitas)',
      'Las Mercedes',
      'Loma Pytá',
      'Madame Lynch',
      'Manorá',
      'Mariscal Estigarribia',
      'Mariscal López',
      'Mbocayaty',
      'Mburicaó',
      'Nazareth',
      'Obrero',
      'Panambí Retá',
      'Panambí Verá',
      'Pettirossi',
      'Pinoza',
      'Republicano',
      'Ricardo Brugada (Chacarita)',
      'Roberto L. Pettit',
      'Sajonia',
      'Salvador del Mundo',
      'Seminario',
      'Tablada Nueva',
      'Tacumbú',
      'Tembetary',
      'Terminal',
      'Villa Aurelia',
      'Villa Morra',
      'Virgen de Fátima',
      'Virgen de la Asunción',
      'Virgen del Huerto',
      'Ycuá Satí',
      'Ytay',
      'Zeballos Cué',
      'Ñu Guazú',
    ],
    'PY-19': [
      'Capitán Joel Estigarribia',
      'Colonia Neuland',
      'Dr. Pedro P. Peña',
      'General Eugenio A. Garay',
      'Loma Plata',
      'Teniente Primero Irala Fernandez',
    ],
    'PY-5': [
      '3 de Febrero',
      'Caaguazu',
      'Carayao',
      'Cecilio Báez',
      'Colonia Genaro Romero',
      'Coronel Oviedo',
      'Dr. José E. Estigarribia',
      'Dr. Juan Manuel Frutos',
      'José Domingo Ocampos',
      'Mariscal F. Solano Lopez',
      'Nueva Australia',
      'Nueva Londres',
      'R.I. 3 Corrales',
      'Raul A. Oviedo',
      'Repatriación',
      'San Antonio Cordillera',
      'San José de los Arroyos',
      'Santa Rosa del Mbutu',
      'Simon Bolivar',
      'Yhu',
    ],
    'PY-6': [
      'Abaí',
      'Caazapá',
      'Col. Mayor Nicolas Arguello',
      'Colonia San Cosme',
      'Compañía San Francisco',
      'Dr. Moises Bertoni',
      'Estacion Gral. Patricio Colman',
      'Estación Yuty',
      'General Higinio Morínigo',
      'Isla Saca',
      'Maciel',
      'Santa Luisa',
      'Tabai',
      'Yacubo',
      'Yegros',
      'Yuty',
    ],
    'PY-14': [
      'Colonia Anahi',
      'Colonia Catuete',
      'Corpus Christi',
      'Curuguaty',
      'General Francisco Alvarez',
      'Itarara',
      'La Paloma',
      'Nueva Esperanza',
      'Salto del Guairá',
      'Ygatimí',
      'Ypé Jhú',
    ],
    'PY-11': [
      'Areguá',
      'Capiatá',
      'Fernando de la Mora',
      'Guarambaré',
      'Itagua',
      'José Augusto Saldivar',
      'Lambaré',
      'Limpio',
      'Loma Pyta',
      'Luque',
      'Mariano Roque Alonso',
      'Nueva Italia',
      'Villa Elisa',
      'Ypacarai',
      'Ypane',
      'Zeballos Cue',
      'Ñemby',
    ],
    'PY-1': ['Horqueta', 'Paso Barreto', 'Paso Mbutú', 'Puerto Fonciere', 'San Lázaro', 'Valle-Mí', 'Yby - Yau'],
    'PY-3': [
      'Alfonso Tranquera',
      'Arroyos y Esteros',
      'Atyrá',
      'Caacupé',
      'Col. G. Bernardino Caballero',
      'Compañía San Antonio',
      'Emboscada',
      'Eusebio Ayala',
      'Isla Pucu',
      'Itacurubí de la Cordillera',
      'Itapirú',
      'Juan de Mena',
      'Loma Grande',
      'Mbocayaty del Yhaguy',
      'Nueva Colombia',
      'Piribebuy',
      'Primero de Marzo',
      'San José Obrero',
      'Tobatí',
      'Valenzuela',
      'Yaguarete Cua',
    ],
    'PY-4': [
      'Barrio Estacion',
      'Borja',
      'Capitan Mauricio José Troche',
      'Colonia Carlos Pfannl',
      'Colonia San Roque González',
      'Coronel Martinez',
      'Dr. Bottrell',
      'Félix Pérez Cardozo',
      'Iturbe',
      'José Fasardi',
      'Natalicio Talavera',
      'Paso Yobay',
      'Pindoyu',
      'Tebicuary',
      'Yataity',
      'Ñumi',
    ],
    'PY-7': [
      'Alto Verá',
      'Barrio San Roque',
      'Cambyretá',
      'Capitán Meza',
      'Capitán Miranda',
      'Carlos Antonio Lopez',
      'Carmen del Parana',
      'Centro de Fronteras',
      'Colonia Federico Chavez',
      'Colonia Samu-u',
      'Colonia Triunfo',
      'Coronel Bogado',
      'Curuñai',
      'Edelira',
      'Encarnación',
      'Fram',
      'General Artigas',
      'General Delgado',
      'Hohenau',
      'Isla Alta',
      'Jesus',
      'José L. Oviedo',
      'Mayor Julio Otaño',
      'Natalio',
      'Nueva Alborada',
      'Obligado',
      'Pirapo',
      'San Cosme y Damián',
      'San Juan del Paraná',
      'San Luis del Paraná',
      'San Pedro del Parana',
      'San Rafael del Parana',
      'Tomas Romero Pereira',
      'Yatytay',
    ],
    'PY-8': [
      'Ayolas',
      'Colonia Alejo García',
      'Itayurú',
      'San Juan Bautista - Misiones',
      'San Patricio',
      'Villa Florida',
      'Yabebyry',
      'Yacuti',
    ],
    'PY-9': [
      'Acahay',
      'Caapucú',
      'Caballero',
      'Carapeguá',
      'Cerro Leon',
      'Colonia G. Cesar Barrientos',
      'Colonia Santa Isabel',
      'La Colmena',
      'Mbuyapey',
      'Paraguari',
      'Pirayu',
      'Quiindy',
      'Quyquyho',
      'San Roque Gonzalez',
      'Sapucai',
      'Tebicuary-Mi',
      'Valle Apúa',
      'Yaguarón',
      'Ybycuí',
      'Ybytymí',
    ],
    'PY-15': [
      'Benjamín Aceval',
      'Chaco-i',
      'Colonia Falcón',
      'Dr. Francia (Beteretecue)',
      'Fortin Esteban Martinez',
      'Fortín General Bruguez',
      'Fortín General Caballero',
      'Nanawa',
      'Pozo Colorado',
      'Puerto Pinasco',
      'Villa Hayes',
    ],
    'PY-2': [
      '25 de Diciembre',
      'Antequera',
      'Chore',
      'Colonia Friesland',
      'Colonia Navidad',
      'Colonia Volendam',
      'General Aquino',
      'General Resquin',
      'Guayaibi',
      'Nueva Germania',
      'Puerto Rosario',
      'Puerto Ybapobó',
      'San José del Rosario',
      'Tacuatí',
      'Villa del Rosario',
      'Yataity del Norte',
    ],
    'PY-12': [
      'Barrio Burrerita',
      'Barrio Obrero',
      'Desmochado',
      'General José Eduvigis Díaz',
      'Guazu Cua',
      'Isla Umbú',
      'Laureles',
      'Mayor José de J. Martinez',
      'Paso de Patria',
      'San Juan B. de Ñeembucu',
      'Tacuaras',
      'Villa Franca',
      'Villa Oliva',
      'Villalbin',
    ],
  },
  PER: {
    'PE-AMA': [],
    'PE-ANC': [
      'Aija',
      'Antonio Raymondi',
      'Asunción',
      'Bolognesi',
      'Carhuaz',
      'Carlos Fermín Fitzcarrald',
      'Casma',
      'Corongo',
      'Huaraz',
      'Huari',
      'Huarmey',
      'Huaylas',
      'Mariscal Luzuriaga',
      'Ocros',
      'Pallasca',
      'Pomabamba',
      'Recuay',
      'Santa',
      'Sihuas',
    ],
    'PE-APU': ['Abancay', 'Andahuaylas', 'Antabamba', 'Aymaraes', 'Chincheros', 'Cotabambas', 'Grau'],
    'PE-ARE': ['Arequipa', 'Camaná', 'Caravelí', 'Castilla', 'Caylloma', 'Condesuyos', 'Islay'],
    'PE-AYA': [
      'Cangayo',
      'Huamanga',
      'Huancasancos',
      'Huanta',
      'La Mar',
      'Lucanas',
      'Parinacochas',
      'Paucar del Sara Sara',
      'Victor Fajardo',
      'Vilcas Huamán',
    ],
    'PE-CAJ': ['Cajabamba', 'Celendín', 'Chota', 'Contumazá', 'Cutervo', 'Hualgayoc', 'Jaén'],
    'PE-CUS': [
      'Acomayo',
      'Canchis',
      'Chumbivilcas',
      'Cusco',
      'Espinar',
      'La Convención',
      'Paruro',
      'Paucartambo',
      'Quispicanchi',
      'Urubamba',
    ],
    'PE-HUV': ['Acobamba', 'Angaraes', 'Castrovirreyna', 'Churcampa', 'Huancavelica', 'Huaytará', 'Tayacaja'],
    'PE-HUC': [
      'Ambo',
      'Dos de Mayo',
      'Huacaybamba',
      'Huamalíes',
      'Huánuco',
      'Lauricocha',
      'Leoncio Prado',
      'Marañón',
      'Pachitea',
      'Puerto Inca',
      'Yarowilca',
    ],
    'PE-ICA': ['Chincha', 'Ica', 'Nazca', 'Palpa', 'Pisco'],
    'PE-JUN': ['Chanchamayo', 'Chupaca', 'Huancayo', 'Jauja', 'Satipo', 'Tarma', 'Yauli'],
    'PE-LAL': [
      'Ascope',
      'Chepén',
      'Gran Chimú',
      'Julcan',
      'Otuzco',
      'Pacasmayo',
      'Pataz',
      'Virú',
      'Sanchez Carrion',
      'Santiago De Chuco',
    ],
    'PE-LAM': ['Chiclayo', 'Ferreñafe', 'Lambayeque'],
    'PE-LMA': [
      'Ancón',
      'Ate',
      'Barranco',
      'Bellavista',
      'Breña',
      'Callao',
      'Carabayllo',
      'Carmen de la Legua Reynoso',
      'Chaclacayo',
      'Chorrillos',
      'Cieneguilla',
      'Comas',
      'El Agustino',
      'La Molina',
      'La Punta',
      'Lince',
      'Los Olivos',
      'Lurigancho',
      'Lurín',
      'Magdalena del Mar',
      'Mi Perú',
      'Pachacámac',
      'Pucusana',
      'Pueblo Libre',
      'Puente Piedra',
      'Punta Hermosa',
      'Punta Negra',
      'Rimac',
      'San Juan de Lurigancho',
      'San Juan de Miraflores',
      'San Martín de Porres',
      'Santa Anita',
      'Santa María del Mar',
      'Santiago de Surco',
      'Surquillo',
      'Ventanilla',
      'Villa El Salvador',
      'Villa María del Triunfo',
    ],
    'PE-LIM': ['Barranca', 'Cajatambo', 'Canta', 'Huaral', 'Huarochirí', 'Huaura', 'Oyón', 'Yauyos'],
    'PE-LOR': ['Alto Amazonas', 'Datem del Marañón', 'Mariscal Ramón Castilla', 'Maynas', 'Requena', 'Ucayali'],
    'PE-MDD': ['Manu', 'Tahuamanu', 'Tambopata'],
    'PE-MOQ': ['General Sánchez Cerro', 'IIO', 'Mariscal Nieto'],
    'PE-PAS': ['Daniel A. Carrión', 'Oxapampa', 'Pasco'],
    'PE-PIU': ['Ayabaca', 'Huancabamba', 'Morropón', 'Paita', 'Piura', 'Sechura', 'Sullana', 'Talara'],
    'PE-PUN': [
      'Azángaro',
      'Carabaya',
      'Chucuito',
      'El Collao',
      'Huancané',
      'Moho',
      'Puno',
      'San Antonio de Putina',
      'San Román',
      'Sandia',
      'Yunguyo',
    ],
    'PE-SAM': ['Huallaga', 'Lamas', 'Mariscal Cáceres', 'Moyobamba', 'Picota', 'Rioja', 'Tocache'],
    'PE-TAC': ['Candarave', 'Jorge Basadre', 'Tacna'],
    'PE-TUM': ['Contralmirante Villar', 'Tumbes', 'Zarumilla'],
    'PE-UCA': ['Atalaya', 'Coronel Portillo', 'Padre Abad', 'Purús'],
  },
  PRT: {
    'PT-01': [
      'Albergaria-a-Velha',
      'Arouca',
      'Castelo de Paiva',
      'Espinho',
      'Estarreja',
      'Mealhada',
      'Murtosa',
      'Oliveira de Azeméis',
      'Oliveira do Bairro',
      'Ovar',
      'Santa Maria da Feira',
      'Sever do Vouga',
      'São João da Madeira',
      'Vagos',
      'Vale de Cambra',
      'Águeda',
      'Ílhavo',
    ],
    'PT-02': [
      'Aljustrel',
      'Almodôvar',
      'Barrancos',
      'Castro Verde',
      'Cuba',
      'Ferreira do Alentejo',
      'Mértola',
      'Odemira',
      'Ourique',
      'Serpa',
      'Vidigueira',
    ],
    'PT-03': [
      'Amares',
      'Cabeceiras de Basto',
      'Celorico de Basto',
      'Esposende',
      'Fafe',
      'Póvoa de Lanhoso',
      'Terras de Bouro',
      'Vieira do Minho',
      'Vila Nova de Famalicão',
      'Vizela',
    ],
    'PT-04': [
      'Alfândega da Fé',
      'Carrazeda de Ansiães',
      'Freixo de Espada à Cinta',
      'Macedo de Cavaleiros',
      'Miranda do Douro',
      'Mogadouro',
      'Torre de Moncorvo',
      'Vimioso',
      'Vinhais',
    ],
    'PT-05': [
      'Castelo Branco',
      'Covilhã',
      'Idanha-a-Nova',
      'Oleiros',
      'Penamacor',
      'Proença-a-Nova',
      'Sertã',
      'Vila Velha de Ródão',
      'Vila de Rei',
    ],
    'PT-06': [
      'Arganil',
      'Condeixa-a-Nova',
      'Figueira da Foz',
      'Lousã',
      'Miranda do Corvo',
      'Montemor-o-Velho',
      'Oliveira do Hospital',
      'Pampilhosa da Serra',
      'Penacova',
      'Penela',
      'Tábua',
      'Vila Nova de Poiares',
    ],
    'PT-08': [
      'Albufeira',
      'Alcoutim',
      'Aljezur',
      'Castro Marim',
      'Lagoa (Algarve)',
      'Lagos',
      'Loulé',
      'Monchique',
      'Olhão',
      'Portimão',
      'São Brás de Alportel',
      'Tavira',
      'Vila Real de Santo António',
      'Vila do Bispo',
    ],
    'PT-09': [
      'Aguiar da Beira',
      'Celorico da Beira',
      'Figueira de Castelo Rodrigo',
      'Fornos de Algodres',
      'Guarda',
      'Manteigas',
      'Pinhel',
      'Sabugal',
      'Seia',
      'Vila Nova de Foz Côa',
    ],
    'PT-30': [
      'Calheta',
      'Câmara de Lobos',
      'Machico',
      'Outros',
      'Ponta do Sol',
      'Porto Moniz',
      'Ribeira Brava',
      'Vila Baleira',
    ],
    'PT-20': ['Angra do Heroísmo', 'Horta', 'Ponta Delgada', 'Praia da Vitória', 'Ribeira Grande'],
    'PT-10': [
      'Alvaiázere',
      'Ansião',
      'Bombarral',
      'Caldas da Rainha',
      'Castanheira de Pera',
      'Figueiró dos Vinhos',
      'Leiria',
      'Marinha Grande',
      'Pedrógão Grande',
      'Peniche',
      'Porto de Mós',
    ],
    'PT-11': [
      'Amadora',
      'Arruda dos Vinhos',
      'Cadaval',
      'Cascais',
      'Lisboa',
      'Loures',
      'Lourinhã',
      'Odivelas',
      'Sintra',
      'Sobral de Monte Agraço',
      'Torres Vedras',
      'Vila Franca de Xira',
    ],
    'PT-12': ['Arronches', 'Avis', 'Castelo de Vide', 'Elvas', 'Marvão', 'Monforte', 'Nisa', 'Ponte de Sôr', 'Sousel'],
    'PT-13': [
      'Felgueiras',
      'Gondomar',
      'Lousada',
      'Marco de Canaveses',
      'Matosinhos',
      'Paredes',
      'Paços de Ferreira',
      'Penafiel',
      'Póvoa de Varzim',
      'Santo Tirso',
      'Trofa',
      'Valongo',
      'Vila Nova de Gaia',
      'Vila do Conde',
    ],
    'PT-14': [
      'Alcanena',
      'Alpiarça',
      'Benavente',
      'Cartaxo',
      'Chamusca',
      'Constância',
      'Coruche',
      'Ferreira do Zêzere',
      'Golegã',
      'Mação',
      'Rio Maior',
      'Salvaterra de Magos',
      'Sardoal',
      'Tomar',
      'Torres Novas',
      'Vila Nova da Barquinha',
    ],
    'PT-15': [
      'Alcochete',
      'Alcácer do Sal',
      'Almada',
      'Grândola',
      'Moita',
      'Montijo',
      'Palmela',
      'Santiago do Cacém',
      'Seixal',
      'Sesimbra',
      'Setúbal',
      'Sines',
    ],
    'PT-16': [
      'Arcos de Valdevez',
      'Caminha',
      'Paredes de Coura',
      'Ponte da Barca',
      'Ponte de Lima',
      'Viana do Castelo',
      'Vila Nova de Cerveira',
    ],
    'PT-17': [
      'Alijó',
      'Boticas',
      'Mesão Frio',
      'Mondim de Basto',
      'Montalegre',
      'Murça',
      'Peso da Régua',
      'Ribeira de Pena',
      'Sabrosa',
      'Santa Marta de Penaguião',
      'Valpaços',
      'Vila Pouca de Aguiar',
      'Vila Real',
    ],
    'PT-18': [
      'Armamar',
      'Carregal do Sal',
      'Castro Daire',
      'Cinfães',
      'Lamego',
      'Mangualde',
      'Moimenta da Beira',
      'Mortágua',
      'Nelas',
      'Oliveira de Frades',
      'Penalva do Castelo',
      'Penedono',
      'Santa Comba Dão',
      'Sernancelhe',
      'Sátão',
      'São João da Pesqueira',
      'Tabuaço',
      'Tarouca',
      'Tondela',
      'Vila Nova de Paiva',
      'Vouzela',
    ],
    'PT-07': [
      'Alandroal',
      'Arraiolos',
      'Estremoz',
      'Montemor-o-Novo',
      'Redondo',
      'Reguengos de Monsaraz',
      'Vendas Novas',
      'Viana do Alentejo',
      'Vila Viçosa',
      'Évora',
    ],
  },
  DOM: {
    'DO-02': [
      'Azua de Compostela',
      'Estebania',
      'Las Charcas',
      'Las Yayas de Viajama',
      'Peralta',
      'Sabana Yegua',
      'Tabara Arriba',
    ],
    'DO-03': ['Galvan', 'Los Rios', 'Neyba', 'Tamayo', 'Villa Jaragua'],
    'DO-04': [
      'Enriquillo',
      'Jaquimelles',
      'La Ciénaga',
      'Las Salinas',
      'Polo',
      'Santa Cruz de Barahona',
      'Vicente Noble',
    ],
    'DO-05': ['Dajabón', 'Loma de Cabrera', 'Partido', 'Restauración'],
    'DO-01': [],
    'DO-06': ['Arenoso', 'Castillo', 'Hostos', 'Las Guáranas', 'San Francisco de Macorís', 'Villa Rivas'],
    'DO-08': ['Miches', 'Santa Cruz del Seibo'],
    'DO-07': ['Banica', 'Comendador', 'Hondo Valle', 'Juan Santiago', 'Pedro Santana'],
    'DO-09': ['Cayetano Germosén', 'Gaspar Hernández', 'Jamao al Norte', 'Moca'],
    'DO-30': ['El Valle', 'Hato Mayor del Rey', 'Sabana de la Mar'],
    'DO-10': ['Cristóbal', 'Duvergé', 'Jimaní', 'La Descubierta', 'Postrer Rio'],
    'DO-11': ['Lagunas de Nisibón', 'Salvaleón de Higüey', 'San Rafael del Yuma'],
    'DO-12': ['Guaymate', 'La Romana', 'Villa Hermosa'],
    'DO-13': ['Concepción de La Vega', 'Constanza', 'Jarabacoa', 'Jima Abajo'],
    'DO-14': ['El Factor', 'Nagua', 'Rio San Juan'],
    'DO-28': ['Bonao', 'Maimón', 'Piedra Blanca'],
    'DO-29': ['Bayaguana', 'Monte Plata', 'Peralvillo', 'Sabana Grande de Boyá', 'Yamasá'],
    'DO-15': [
      'Castañuela',
      'Guayubín',
      'Las Matas de Santa Cruz',
      'Pepillo Salcedo (Manzanillo)',
      'San Fernando de Monte Cristi',
      'Villa Vázquez',
    ],
    'DO-16': ['Oviedo'],
    'DO-17': ['Baní', 'Nizao'],
    'DO-18': ['Guananico', 'Imbert', 'Los Hidalgos', 'Luperón', 'San Felipe de Puerto Plata', 'Sosúa', 'Villa Isabela'],
    'DO-19': ['Tenares', 'Villa Tapia'],
    'DO-20': ['Las Terrenas', 'Santa Bárbara de Samaná', 'Sánchez'],
    'DO-21': [
      'Bajos de Haina',
      'Cambita Garabito',
      'Los Cacaos',
      'Nigua',
      'Sabana Grande de Palenque',
      'San Gregorio de Yaguate',
      'Villa Altagracia',
    ],
    'DO-31': ['Rancho Arriba', 'Sabana Larga', 'San José de Ocoa'],
    'DO-22': [
      'Bohechio',
      'El Cercado',
      'Juan de Herrera',
      'Las Matas de Farfán',
      'San Juan de la Maguana',
      'Vallejuelo',
    ],
    'DO-23': ['Consuelo', 'Los Llanos', 'Quisqueya', 'Ramón Santana', 'San Pedro de Macorís'],
    'DO-25': [
      'Jánico',
      'Licey al Medio',
      'San José de Las Matas',
      'Santiago de los treinta Caballeros',
      'Villa Bisonó',
      'Villa González',
    ],
    'DO-26': ['Los Almácigos', 'Monción', 'San Ignacio de Sabaneta'],
    'DO-32': [
      'Boca Chica',
      'Los Alcarrizos',
      'Pedro Brand',
      'San Antonio de Guerra',
      'Santo Domingo Este',
      'Santo Domingo Norte',
      'Santo Domingo Oeste',
    ],
    'DO-24': ['Cevicos', 'Cotuí', 'Fantino', 'Villa La Mata'],
    'DO-27': ['Laguna Salada', 'Mao'],
  },
  KOR: {
    'KR-26': ['Gijang', 'Jangan', 'Jeonggwan'],
    'KR-27': ['Dasa', 'Hwawon', 'Nongong'],
    'KR-30': [],
    'KR-42': [
      'Cheorwon',
      'Chuncheon',
      'Dogye',
      'Donghae',
      'Dongsong',
      'Galmal',
      'Gangneung',
      'Ganseong',
      'Geojin',
      'Gimhwa',
      'Gohan',
      'Hoengseong',
      'Hongcheon',
      'Hwacheon',
      'Inje',
      'Jeongseon',
      'Jumunjin',
      'Munmak',
      'Pyeongchang',
      'Sabuk',
      'Samcheok',
      'Sangdong',
      'Sinbuk',
      'Sindong',
      'Sokcho',
      'Taebaek',
      'Wondeok',
      'Wonju',
      'Yanggu',
      'Yangyang',
      'Yeongwol',
    ],
    'KR-29': [],
    'KR-41': [
      'Anjung',
      'Ansan',
      'Anseong',
      'Baekseok',
      'Beobwon',
      'Bongdam',
      'Bubal',
      'Bucheon',
      'Chowol',
      'Dongducheon',
      'Ganam',
      'Gapyeong',
      'Gimpo',
      'Gochon',
      'Gongdo',
      'Gonjiam',
      'Goyang',
      'Gunpo',
      'Guri',
      'Gwacheon',
      'Gwangju',
      'Gwangmyeong',
      'Hanam',
      'Hwado',
      'Hwaseong',
      'Hyangnam',
      'Icheon',
      'Janghowon',
      'Jeongok',
      'Jingeon',
      'Jinjeop',
      'Jori',
      'Munsan',
      'Namyang',
      'Namyangju',
      'Onam',
      'Opo',
      'Osan',
      'Paengseong',
      'Paju',
      'Pocheon',
      'Pogok',
      'Poseung',
      'Pyeongtaek',
      'Seongnam',
      'Siheung',
      'Soheul',
      'Suwon',
      'Tongjin',
      'Uijeongbu',
      'Uiwang',
      'Ujeong',
      'Wabu',
      'Yangchon',
      'Yangju',
      'Yangpyeong',
      'Yeoju',
      'Yeoncheon',
      'Yongin',
    ],
    'KR-28': ['Ganghwa'],
    'KR-49': ['Aewor', 'Daejeong', 'Gujwa', 'Hanrim', 'Jeju', 'Jocheon', 'Namwon', 'Seogwipo', 'Seongsan'],
    'KR-43': [
      'Boeun',
      'Bongyang',
      'Cheongju',
      'Chungju',
      'Eumseong',
      'Geumwang',
      'Goesan',
      'Jecheon',
      'Jeungpyeong',
      'Jincheon',
      'Judeok',
      'Maepo',
      'Naesu',
      'Ochang',
      'Okcheon',
      'Osong',
      'Yeongdong',
    ],
    'KR-47': [
      'Andong',
      'Angang',
      'Apo',
      'Bonghwa',
      'Buksam',
      'Cheongdo',
      'Cheongsong',
      'Daegaya',
      'Gampo',
      'Gaun',
      'Geoncheon',
      'Geumho',
      'Gimcheon',
      'Goa',
      'Gumi',
      'Gunwi',
      'Guryongpo',
      'Gyeongju',
      'Gyeongsan',
      'Hamchang',
      'Hayang',
      'Heunghae',
      'Jillyang',
      'Mungyeong',
      'Ocheon',
      'Oedong',
      'Pohang',
      'Punggi',
      'Pungsan',
      'Pyeonghae',
      'Sangju',
      'Seokjeok',
      'Seongju',
      'Seonsan',
      'Uiseong',
      'Uljin',
      'Ulleung',
      'Waegwan',
      'Yecheon',
      'Yeongcheon',
      'Yeongdeok',
      'Yeongju',
      'Yeongyang',
      'Yeonil',
      'wayang',
    ],
    'KR-45': [
      'Bongdong',
      'Buan',
      'Gimje',
      'Gochang',
      'Gunsan',
      'Hamyeol',
      'Iksan',
      'Imsil',
      'Jangsu',
      'Jeongeup',
      'Jeonju',
      'Mangyeong',
      'Muju',
      'Okgu',
      'Samrye',
      'Sintaein',
      'Sunchang',
      'Unbong',
      'Yongjin',
    ],
    'KR-50': ['Jochiwon'],
    'KR-11': [],
    'KR-44': [
      'Anmyeon',
      'Asan',
      'Baebang',
      'Boryeong',
      'Buyeo',
      'Cheonan',
      'Cheongyang',
      'Daesan',
      'Dangjin',
      'Ganggyeong',
      'Geumsan',
      'Gongju',
      'Gwangcheon',
      'Gyeryong',
      'Hapdeok',
      'Hongseong',
      'Janghang',
      'Jiksan',
      'Mokcheon',
      'Nonsan',
      'Sapgyo',
      'Seocheon',
      'Seonggeo',
      'Seonghwan',
      'Seosan',
      'Songak',
      'Taean',
      'Ungcheon',
      'Yeomchi',
      'Yeonmu',
      'Yesan',
      'Yugu',
    ],
    'KR-48': [
      'Changnyeong',
      'Changwon',
      'Chirwon',
      'Dong',
      'Geochang',
      'Geoje',
      'Gimhae',
      'Goseong',
      'Hadong',
      'Hamyang',
      'Hapcheon',
      'Jinju',
      'Jinyeong',
      'Miryang',
      'Naeseo',
      'Namhae',
      'Namji',
      'Sacheon',
      'Samnangjin',
      'Sancheong',
      'Sanyang',
      'Tongyeong',
      'Uiryeong',
      'Yangsan',
    ],
    'KR-46': [
      'Aphae',
      'Baeksu',
      'Beolgyo',
      'Boseong',
      'Daedeok',
      'Damyang',
      'Dolsan',
      'Doyang',
      'Gangjin',
      'Geumil',
      'Goheung',
      'Gokseong',
      'Gurye',
      'Gwangyang',
      'Gwansan',
      'Haenam',
      'Hampyeong',
      'Hongnong',
      'Hwasun',
      'Illo',
      'Jangheung',
      'Jangseong',
      'Jido',
      'Jindo',
      'Mokpo',
      'Muan',
      'Naju',
      'Nampyeong',
      'Nohwa',
      'Samho',
      'Samhyang',
      'Seungju',
      'Suncheon',
      'Yeongam',
      'Yeonggwang',
      'Yeosu',
    ],
    'KR-31': ['Beomseo', 'Eonyang', 'Onsan', 'Onyang'],
  },
  ESP: {
    'ES-AB': [
      'Abengibre',
      'Alatoz',
      'Albacete',
      'Albatana',
      'Alborea',
      'Alcadozo',
      'Alcalá del Júcar',
      'Alcaraz',
      'Almansa',
      'Alpera',
      'Aýna',
      'Balazote',
      'Balsa de Ves',
      'Barrax',
      'Bienservida',
      'Bogarra',
      'Bonete',
      'Casas de Juan Núñez',
      'Casas de Lázaro',
      'Casas de Ves',
      'Casas-Ibáñez',
      'Caudete',
      'Cenizate',
      'Chinchilla de Monte-Aragón',
      'Corral-Rubio',
      'Cotillas',
      'El Ballestero',
      'El Bonillo',
      'Elche de la Sierra',
      'Fuensanta',
      'Fuente-Álamo',
      'Fuentealbilla',
      'Férez',
      'Golosalvo',
      'Hellín',
      'Higueruela',
      'Hoya-Gonzalo',
      'Jorquera',
      'La Gineta',
      'La Herrera',
      'La Recueja',
      'La Roda',
      'Letur',
      'Lezuza',
      'Liétor',
      'Madrigueras',
      'Mahora',
      'Masegoso',
      'Minaya',
      'Molinicos',
      'Montalvos',
      'Montealegre del Castillo',
      'Motilleja',
      'Munera',
      'Navas de Jorquera',
      'Nerpio',
      'Ontur',
      'Ossa de Montiel',
      'Paterna del Madera',
      'Peñas de San Pedro',
      'Peñascosa',
      'Povedilla',
      'Pozo Cañada',
      'Pozo-Lorente',
      'Pozohondo',
      'Pétrola',
      'Riópar',
      'Robledo',
      'Salobre',
      'Socovos',
      'Tobarra',
      'Valdeganga',
      'Vianos',
      'Villa de Ves',
      'Villalgordo del Júcar',
      'Villamalea',
      'Villapalacios',
      'Villarrobledo',
      'Villatoya',
      'Villavaliente',
      'Villaverde de Guadalimar',
      'Yeste',
    ],
    'ES-A': [
      'Adsubia',
      'Agost',
      'Agres',
      'Aigües',
      'Albatera',
      'Alcalalí',
      'Alcocer de Planes',
      'Alcoleja',
      'Alcoy',
      'Alfafara',
      'Algorfa',
      'Algueña',
      'Alicante',
      'Almoradí',
      'Almudaina',
      'Altea',
      'Aspe',
      'Balones',
      'Banyeres de Mariola',
      'Benasau',
      'Beneixama',
      'Benejúzar',
      'Benferri',
      'Beniarbeig',
      'Beniardá',
      'Beniarrés',
      'Benidoleig',
      'Benidorm',
      'Benifallim',
      'Benifato',
      'Benigembla',
      'Benijófar',
      'Benilloba',
      'Benillup',
      'Benimantell',
      'Benimarfull',
      'Benimassot',
      'Benimeli',
      'Benissa',
      'Biar',
      'Bigastro',
      'Bolulla',
      'Busot',
      "Callosa d'En Sarrià",
      'Callosa de Segura',
      'Castalla',
      'Castell de Castells',
      'Catral',
      'Cañada',
      'Cocentaina',
      'Confrides',
      'Cox',
      'Crevillent',
      'Daya Nueva',
      'Daya Vieja',
      'Dénia',
      'El Campello',
      'El Castell de Guadalest',
      "El Ràfol d'Almúnia",
      'El Verger',
      'Elche',
      'Elda',
      'Els Poblets',
      'Facheca',
      'Famorca',
      'Finestrat',
      'Formentera del Segura',
      'Gaianes',
      'Gata de Gorgos',
      'Granja de Rocamora',
      'Guardamar del Segura',
      'Hondón de los Frailes',
      'Jacarilla',
      "L' Alfàs del Pi",
      "L' Alqueria d'Asnar",
      'La Nucia',
      "La Vall d'Alcalà",
      "La Vall d'Ebo",
      'La Vall de Laguar',
      'Llíber',
      'Los Montesinos',
      'Millena',
      'Monforte del Cid',
      'Murla',
      'Muro de Alcoy',
      'Mutxamel',
      'Novelda',
      'Ondara',
      'Onil',
      'Orba',
      'Orihuela',
      'Orxeta',
      'Parcent',
      'Pedreguer',
      'Pego',
      'Penàguila',
      'Petrer',
      'Pilar de la Horadada',
      'Planes',
      'Polop',
      'Quatretondeta',
      'Rafal',
      'Redován',
      'Relleu',
      'Rojales',
      'Sagra',
      'San Fulgencio',
      'San Miguel de Salinas',
      'Sanet y Negrals',
      "Sant Joan d'Alacant",
      'Sant Vicent del Raspeig',
      'Santa Pola',
      'Sax',
      'Sella',
      'Senija',
      'Tarazona de la Mancha',
      'Tibi',
      'Tollos',
      'Tormos',
      'Torrevieja',
      'Tàrbena',
      'Vall de Gallinera',
      'Villena',
    ],
    'ES-AL': [
      'Abla',
      'Abrucena',
      'Alboloduy',
      'Albox',
      'Albánchez',
      'Alcolea',
      'Alcudia de Monteagud',
      'Alcóntar',
      'Alhabia',
      'Alhama de Almería',
      'Alicún',
      'Almería',
      'Almócita',
      'Alsodux',
      'Arboleas',
      'Armuña de Almanzora',
      'Bacares',
      'Bayarque',
      'Bayárcal',
      'Beires',
      'Benahadux',
      'Benitagla',
      'Benizalón',
      'Bentarique',
      'Berja',
      'Bédar',
      'Canjáyar',
      'Cantoria',
      'Carboneras',
      'Castro de Filabres',
      'Chercos',
      'Chirivel',
      'Cuevas del Almanzora',
      'Cóbdar',
      'Dalías',
      'El Ejido',
      'Enix',
      'Felix',
      'Fines',
      'Fiñana',
      'Fondón',
      'Garrucha',
      'Gádor',
      'Gérgal',
      'Huécija',
      'Huércal de Almería',
      'Huércal-Overa',
      'Illar',
      'Instinción',
      'La Mojonera',
      'Laroya',
      'Las Tres Villas',
      'Los Gallardos',
      'Lubrín',
      'Lucainena de las Torres',
      'Láujar de Andarax',
      'Líjar',
      'Lúcar',
      'Macael',
      'María',
      'Mojácar',
      'Níjar',
      'Ohanes',
      'Olula de Castro',
      'Olula del Río',
      'Padules',
      'Partaloa',
      'Paterna del Río',
      'Pechina',
      'Pulpí',
      'Purchena',
      'Roquetas de Mar',
      'Roquetas del Mar',
      'Rágol',
      'Santa Cruz de Marchena',
      'Santa Fe de Mondújar',
      'Senés',
      'Serón',
      'Sierro',
      'Somontín',
      'Sorbas',
      'Suflí',
      'Tabernas',
      'Taberno',
      'Tahal',
      'Terque',
      'Turre',
      'Turrillas',
      'Tíjola',
      'Uleila del Campo',
      'Urrácal',
      'Velefique',
      'Viator',
      'Vélez-Blanco',
      'Vélez-Rubio',
      'Vícar',
      'Zurgena',
    ],
    'ES-O': [
      'Allande',
      'Aller',
      'Amieva',
      'Avilés',
      'Belmonte de Miranda',
      'Bimenes',
      'Boal',
      'Cabrales',
      'Cabranes',
      'Candamo',
      'Cangas de Onís',
      'Cangas del Narcea',
      'Caravia',
      'Carballo',
      'Carreño',
      'Caso',
      'Castrillón',
      'Castropol',
      'Coaña',
      'Colunga',
      'Corvera de Asturias',
      'Cudillero',
      'Degaña',
      'El Franco',
      'Gijón',
      'Gozón',
      'Grandas de Salime',
      'Ibias',
      'Illano',
      'Illas',
      'Las Regueras',
      'Laviana',
      'Lena',
      'Llanera',
      'Llanes',
      'Llangréu',
      'Mestas de Con',
      'Mieres',
      'Morcín',
      'Muros de Nalón',
      'Navia',
      'Noreña',
      'Onís',
      'Parres',
      'Pesoz',
      'Peñamellera Alta',
      'Peñamellera Baja',
      'Piloña',
      'Pola de Siero',
      'Ponga',
      'Pravia',
      'Proaza',
      'Quirós',
      'Ribadedeva',
      'Ribadesella',
      'Ribera de Arriba',
      'Riosa',
      'Salas',
      'Samartín del Rei Aurelio',
      'San Martín de Oscos',
      'San Tirso de Abres',
      'Santa Eulalia de Oscos',
      'Santo Adriano',
      'Sariego',
      'Siero',
      'Sobrescobio',
      'Somiedo',
      'Soto del Barco',
      'Tapia de Casariego',
      'Taramundi',
      'Teverga',
      'Tineo',
      'Valdés',
      'Vegadeo',
      'Villanueva de Oscos',
      'Villaviciosa',
      'Villayón',
      'Yernes y Tameza',
    ],
    'ES-BA': [
      'Acedera',
      'Aceuchal',
      'Ahillones',
      'Alange',
      'Alburquerque',
      'Alconchel',
      'Alconera',
      'Aljucén',
      'Almendral',
      'Almendralejo',
      'Arroyo de San Serván',
      'Azuaga',
      'Badajoz',
      'Barcarrota',
      'Baterno',
      'Benquerencia de la Serena',
      'Berlanga',
      'Bienvenida',
      'Bodonal de la Sierra',
      'Burguillos del Cerro',
      'Cabeza del Buey',
      'Cabeza la Vaca',
      'Calamonte',
      'Calera de León',
      'Calzadilla de los Barros',
      'Campanario',
      'Campillo de Llerena',
      'Capilla',
      'Carmonita',
      'Casas de Don Pedro',
      'Casas de Reina',
      'Castilblanco',
      'Castuera',
      'Cheles',
      'Cordobilla de Lácara',
      'Corte de Peleas',
      'Don Benito',
      'Don Álvaro',
      'El Carrascalejo',
      'Entrín Bajo',
      'Esparragalejo',
      'Esparragosa de Lares',
      'Esparragosa de la Serena',
      'Feria',
      'Fregenal de la Sierra',
      'Fuenlabrada de los Montes',
      'Fuente de Cantos',
      'Fuente del Arco',
      'Fuente del Maestre',
      'Fuentes de León',
      'Garbayuela',
      'Garlitos',
      'Granja de Torrehermosa',
      'Guareña',
      'Helechosa de los Montes',
      'Herrera del Duque',
      'Higuera de Llerena',
      'Higuera de Vargas',
      'Higuera de la Serena',
      'Higuera la Real',
      'Hinojosa del Valle',
      'Hornachos',
      'Jerez de los Caballeros',
      'La Albuera',
      'La Codosera',
      'La Coronada',
      'La Garrovilla',
      'La Haba',
      'La Lapa',
      'La Morera',
      'La Nava de Santiago',
      'La Parra',
      'La Roca de la Sierra',
      'Llerena',
      'Lobón',
      'Los Santos de Maimona',
      'Magacela',
      'Maguilla',
      'Malcocinado',
      'Malpartida de la Serena',
      'Manchita',
      'Medina de las Torres',
      'Mengabril',
      'Mirandilla',
      'Miróbriga',
      'Monesterio',
      'Montemolín',
      'Monterrubio de la Serena',
      'Navalvillar de Pela',
      'Oliva de Mérida',
      'Oliva de la Frontera',
      'Olivenza',
      'Orellana de la Sierra',
      'Orellana la Vieja',
      'Palomas',
      'Peraleda del Zaucejo',
      'Peñalsordo',
      'Puebla de Alcocer',
      'Puebla de Obando',
      'Puebla de Sancho Pérez',
      'Puebla de la Calzada',
      'Puebla de la Reina',
      'Puebla del Maestre',
      'Puebla del Prior',
      'Pueblonuevo del Guadiana',
      'Quintana de la Serena',
      'Reina',
      'Rena',
      'Retamal de Llerena',
      'Ribera del Fresno',
      'Risco',
      'Salvaleón',
      'Salvatierra de los Barros',
      'San Pedro de Mérida',
      'San Vicente de Alcántara',
      'Sancti-Spíritus',
      'Santa Amalia',
      'Segura de León',
      'Siruela',
      'Solana de los Barros',
      'Talarrubias',
      'Talavera la Real',
      'Tamurejo',
      'Torre de Miguel Sesmero',
      'Torremayor',
      'Torremejía',
      'Trasierra',
      'Trujillanos',
      'Táliga',
      'Usagre',
      'Valdecaballeros',
      'Valdelacalzada',
      'Valencia de las Torres',
      'Valencia del Mombuey',
      'Valencia del Ventoso',
      'Valle de Matamoros',
      'Valle de Santa Ana',
      'Valle de la Serena',
      'Valverde de Burguillos',
      'Valverde de Leganés',
      'Valverde de Llerena',
      'Valverde de Mérida',
      'Villafranca de los Barros',
      'Villagarcía de la Torre',
      'Villagonzalo',
      'Villalba de los Barros',
      'Villanueva de la Serena',
      'Villanueva del Fresno',
      'Villar de Rena',
      'Villar del Rey',
      'Villarta de los Montes',
      'Zafra',
      'Zahínos',
      'Zalamea de la Serena',
      'Zarza-Capilla',
    ],
    'ES-PM': [
      'Alaior',
      'Alaró',
      'Alcúdia',
      'Algaida',
      'Andratx',
      'Ariany',
      'Artà',
      'Banyalbufar',
      'Binissalem',
      'Bunyola',
      'Búger',
      'Cala Rajada',
      'Calvià',
      'Campanet',
      'Capdepera',
      'Ciutadella de Menorca',
      'Consell',
      'Costitx',
      'Eivissa',
      'Es Castell',
      'Es Mercadal',
      'Es Migjorn Gran',
      'Escorca',
      'Esporles',
      'Estellencs',
      'Felanitx',
      'Ferreries',
      'Fornalutx',
      'Ibiza',
      'Inca',
      'Lloret de Vistalegre',
      'Lloseta',
      'Llubí',
      'Llucmajor',
      'Manacor',
      'Mancor de la Vall',
      'Maria de la Salut',
      'Marratxí',
      'Maó',
      'Montuïri',
      'Muro',
      'Petra',
      'Pollença',
      'Porreres',
      'Puigpunyent',
      'Sa Pobla',
      'Sant Antoni de Portmany',
      'Sant Joan',
      'Sant Joan de Labritja',
      'Sant Josep de sa Talaia',
      'Sant Llorenç des Cardassar',
      'Sant Lluís',
      'Santa Eugènia',
      'Santa Eulalia del Río',
      'Santa Margalida',
      'Santa María del Camí',
      'Santanyí',
      'Sencelles',
      'Ses Salines',
      'Sineu',
      'Son Servera',
      'Sóller',
      'Valldemossa',
    ],
    'ES-B': [
      'Abrera',
      'Aguilar de Segarra',
      'Aiguafreda',
      'Alella',
      'Alpens',
      'Arenys de Mar',
      'Arenys de Munt',
      'Argentona',
      'Argençola',
      'Artés',
      'Avinyonet del Penedès',
      'Avinyó',
      'Avià',
      'Badalona',
      'Badia del Vallès',
      'Badía del Vallès',
      'Bagà',
      'Balaguer',
      'Balenyà',
      'Balsareny',
      'Barberà del Vallès',
      'Begues',
      'Bellprat',
      'Berga',
      'Bigues i Riells',
      'Borredà',
      "Cabrera d'Anoia",
      'Cabrera de Mar',
      'Cabrils',
      'Calaf',
      'Calders',
      "Caldes d'Estrac",
      'Caldes de Montbui',
      'Calella',
      'Calldetenes',
      'Callús',
      'Calonge de Segarra',
      'Campins',
      'Canet de Mar',
      'Canovelles',
      'Capellades',
      'Capolat',
      'Cardedeu',
      'Carme',
      'Casserres',
      "Castell de l'Areny",
      "Castellar de n'Hug",
      'Castellar del Riu',
      'Castellar del Vallès',
      'Castellbell i el Vilar',
      'Castellbisbal',
      'Castellcir',
      'Castelldefels',
      'Castellet i la Gornal',
      'Castellfollit de Riubregós',
      'Castellfollit del Boix',
      'Castellgalí',
      'Castellnou de Bages',
      'Castellolí',
      'Castellterçol',
      'Castellví de Rosanes',
      'Castellví de la Marca',
      'Centelles',
      'Cercs',
      'Cerdanyola del Vallès',
      'Cervelló',
      'Collbató',
      'Collsuspina',
      'Copons',
      'Corbera de Llobregat',
      'Cornellà de Llobregat',
      'Cubelles',
      'Cànoves i Samalús',
      'Dosrius',
      'El Bruc',
      'El Brull',
      'El Masnou',
      'El Papiol',
      'El Pla del Penedès',
      'El Pont de Vilomara i Rocafort',
      'El Prat de Llobregat',
      'Els Hostalets de Pierola',
      'Els Prats de Rei',
      'Esparreguera',
      'Esplugues de Llobregat',
      'Figaró-Montmany',
      'Fogars de Montclús',
      'Fogars de la Selva',
      'Folgueroles',
      'Fonollosa',
      'Font-rubí',
      'Fígols',
      'Gaià',
      'Gallifa',
      'Gavà',
      'Gelida',
      'Gironella',
      'Gisclareny',
      'Granera',
      'Granollers',
      'Gualba',
      'Guardiola de Berguedà',
      'Gurb',
      'Hospitalet de Llobregat',
      'Igualada',
      'Jorba',
      "L' Ametlla del Vallès",
      "L' Hospitalet de Llobregat",
      'La Canonja',
      'La Garriga',
      'La Llacuna',
      'La Llagosta',
      'La Nou de Berguedà',
      'La Pobla de Claramunt',
      'La Pobla de Lillet',
      'La Quar',
      'La Roca del Vallès',
      'La Torre de Claramunt',
      'Les Cabanyes',
      'Les Franqueses del Vallès',
      'Les Masies de Roda',
      'Les Masies de Voltregà',
      'Llinars del Vallès',
      "Lliçà d'Amunt",
      'Lliçà de Vall',
      'Lluçà',
      'Malgrat de Mar',
      'Manlleu',
      'Manresa',
      'Marganell',
      'Martorell',
      'Martorelles',
      'Masquefa',
      'Matadepera',
      'Mataró',
      'Mediona',
      'Moià',
      'Molins de Rei',
      'Mollet del Vallès',
      'Monistrol de Calders',
      'Monistrol de Montserrat',
      'Montcada i Reixac',
      'Montclar',
      'Montesquiu',
      'Montgat',
      'Montmajor',
      'Montmaneu',
      'Montmeló',
      'Montornès del Vallès',
      'Montseny',
      'Muntanyola',
      'Navarcles',
      'Navàs',
      'Olesa de Bonesvalls',
      'Olesa de Montserrat',
      'Olivella',
      'Olost',
      'Olvan',
      'Olèrdola',
      'Oristà',
      'Orpí',
      'Orís',
      'Pacs del Penedès',
      'Palafolls',
      'Palau-solità i Plegamans',
      'Pallejà',
      'Pallejá',
      'Palma de Cervelló',
      'Parets del Vallès',
      'Parets del Vallés',
      'Perafita',
      'Piera',
      'Pineda de Mar',
      'Polinyà',
      'Pontons',
      'Prats de Lluçanès',
      'Premià de Dalt',
      'Premià de Mar',
      'Puig-reig',
      'Puigdàlber',
      'Pujalt',
      'Rajadell',
      'Rellinars',
      'Ripollet',
      'Roda de Ter',
      'Rubió',
      'Rubí',
      'Rupit i Pruit',
      'Sabadell',
      'Sagàs',
      'Saldes',
      'Sallent',
      'San Baudilio de Llobregat',
      'Sant Adrià de Besòs',
      'Sant Agustí de Lluçanès',
      'Sant Andreu de Llavaneres',
      'Sant Andreu de la Barca',
      'Sant Antoni de Vilamajor',
      'Sant Bartomeu del Grau',
      'Sant Boi de Llobregat',
      'Sant Boi de Lluçanès',
      'Sant Boi del Llobregat',
      'Sant Cebrià de Vallalta',
      'Sant Celoni',
      'Sant Climent de Llobregat',
      'Sant Cugat Sesgarrigues',
      'Sant Cugat del Vallès',
      'Sant Esteve Sesrovires',
      'Sant Esteve de Palautordera',
      'Sant Feliu Sasserra',
      'Sant Feliu de Codines',
      'Sant Feliu de Llobregat',
      'Sant Fost de Campsentelles',
      'Sant Fruitós de Bages',
      'Sant Hipòlit de Voltregà',
      'Sant Iscie de Ballata',
      'Sant Iscle de Vallalta',
      'Sant Jaume de Frontanyà',
      'Sant Joan Despí',
      'Sant Joan de Vilatorrada',
      'Sant Julià de Cerdanyola',
      'Sant Julià de Vilatorta',
      'Sant Just Desvern',
      'Sant Llorenç Savall',
      "Sant Llorenç d'Hortons",
      'Sant Martí Sarroca',
      'Sant Martí Sesgueioles',
      "Sant Martí d'Albars",
      'Sant Martí de Centelles',
      'Sant Martí de Tous',
      'Sant Mateu de Bages',
      'Sant Pere Sallavinera',
      'Sant Pere de Ribes',
      'Sant Pere de Riudebitlles',
      'Sant Pere de Torelló',
      'Sant Pere de Vilamajor',
      'Sant Pol de Mar',
      'Sant Quintí de Mediona',
      'Sant Quirze Safaja',
      'Sant Quirze de Besora',
      'Sant Quirze del Vallès',
      "Sant Sadurní d'Anoia",
      "Sant Sadurní d'Osormort",
      'Sant Salvador de Guardiola',
      'Sant Vicenç de Castellet',
      'Sant Vicenç de Montalt',
      'Sant Vicenç de Torelló',
      'Sant Vicenç dels Horts',
      'Santa Cecília de Voltregà',
      'Santa Coloma de Cervelló',
      'Santa Coloma de Gramanet',
      'Santa Coloma de Gramenet',
      'Santa Eugènia de Berga',
      'Santa Eulàlia de Riuprimer',
      'Santa Eulàlia de Ronçana',
      'Santa Fe del Penedès',
      'Santa Margarida de Montbui',
      'Santa Margarida i els Monjos',
      "Santa Maria d'Oló",
      'Santa Maria de Besora',
      'Santa Maria de Corcó',
      'Santa Maria de Martorelles',
      'Santa Maria de Merlès',
      'Santa Maria de Miralles',
      'Santa Maria de Palautordera',
      'Santa Perpètua de Mogoda',
      'Santa Susanna',
      'Santpedor',
      'Sentmenat',
      'Seva',
      'Sitges',
      'Sobremunt',
      'Subirats',
      'Súria',
      'Tagamanent',
      'Taradell',
      'Tavertet',
      'Tavèrnoles',
      'Teià',
      'Terrassa',
      'Tordera',
      'Torelló',
      'Torrelavit',
      'Torrelles de Foix',
      'Torrelles de Llobregat',
      'Ullastrell',
      'Vacarisses',
      "Vallbona d'Anoia",
      'Vallcebre',
      'Vallgorguina',
      'Vallirana',
      'Vallromanes',
      'Veciana',
      'Vic',
      'Vilada',
      'Viladecans',
      'Viladecavalls',
      'Vilafranca del Penedès',
      'Vilalba Sasserra',
      'Vilanova de Sau',
      'Vilanova del Camí',
      'Vilanova del Vallès',
      'Vilanova i la Geltrú',
      'Vilassar de Dalt',
      'Vilassar de Mar',
      'Vilobí del Penedès',
      'Viver i Serrateix',
      'Òdena',
      'Òrrius',
    ],
    'ES-BI': [
      'Abadiño',
      'Ajangiz',
      'Alonsotegi',
      'Amorebieta-Etxano',
      'Amoroto',
      'Arakaldo',
      'Arantzazu',
      'Areatza',
      'Arrankudiaga',
      'Arratzu',
      'Arrigorriaga',
      'Artzentales',
      'Atxondo',
      'Aulesti',
      'Bakio',
      'Balmaseda',
      'Barakaldo',
      'Barrika',
      'Basauri',
      'Bedia',
      'Berango',
      'Bermeo',
      'Berriatua',
      'Berriz',
      'Bilbao',
      'Busturia',
      'Derio',
      'Dima',
      'Elantxobe',
      'Elorrio',
      'Erandio',
      'Ereño',
      'Ermua',
      'Errigoiti',
      'Etxebarri',
      'Etxebarria',
      'Forua',
      'Fruiz',
      'Galdakao',
      'Galdames',
      'Gamiz-Fika',
      'Garai',
      'Gatika',
      'Gautegiz Arteaga',
      'Gernika-Lumo',
      'Getxo',
      'Gizaburuaga',
      'Gordexola',
      'Gorliz',
      'Güeñes',
      'Ibarrangelu',
      'Igorre',
      'Ispaster',
      'Iurreta',
      'Izurtza',
      'Karrantza Harana/Valle de Carranza',
      'Kortezubi',
      'Lanestosa',
      'Larrabetzu',
      'Laukiz',
      'Leioa',
      'Lekeitio',
      'Lemoa',
      'Lemoiz',
      'Loiu',
      'Mallabia',
      'Markina-Xemein',
      'Maruri-Jatabe',
      'Mañaria',
      'Mendata',
      'Mendexa',
      'Meñaka',
      'Morga',
      'Mundaka',
      'Mungia',
      'Munitibar-Arbatzegi Gerrikaitz',
      'Murueta',
      'Muskiz',
      'Muxika',
      'Nabarniz',
      'Ondarroa',
      'Orozko',
      'Ortuella',
      'Otxandio',
      'Plentzia',
      'Portugalete',
      'Santurtzi',
      'Sestao',
      'Sondika',
      'Sopela',
      'Sopuerta',
      'Sukarrieta',
      'Trucios-Turtzioz',
      'Ubide',
      'Ugao-Miraballes',
      'Urduliz',
      'Valle de Trápaga - Trapagaran',
      'Zaldibar',
      'Zalla',
      'Zamudio',
      'Zaratamo',
      'Zeanuri',
      'Zeberio',
      'Zierbena',
      'Ziortza-Bolibar',
    ],
    'ES-BU': [
      'Abajas',
      'Adrada de Haza',
      'Aguas Cándidas',
      'Aguilar de Bureba',
      'Albillos',
      'Alcocero de Mola',
      'Alfoz de Bricia',
      'Alfoz de Quintanadueñas',
      'Alfoz de Santa Gadea',
      'Altable',
      'Ameyugo',
      'Anguix',
      'Aranda de Duero',
      'Arandilla',
      'Arauzo de Miel',
      'Arauzo de Salce',
      'Arauzo de Torre',
      'Arenillas de Riopisuerga',
      'Arija',
      'Arlanzón',
      'Arraya de Oca',
      'Atapuerca',
      'Avellanosa de Muñó',
      'Bahabón de Esgueva',
      'Barbadillo de Herreros',
      'Barbadillo del Mercado',
      'Barbadillo del Pez',
      'Barrio de Muñó',
      'Barrios de Colina',
      'Basconcillos del Tozo',
      'Bascuñana',
      'Baños de Valdearados',
      'Bañuelos de Bureba',
      'Belbimbre',
      'Belorado',
      'Berberana',
      'Berlangas de Roa',
      'Berzosa de Bureba',
      'Bozoó',
      'Brazacorta',
      'Briviesca',
      'Bugedo',
      'Buniel',
      'Busto de Bureba',
      'Cabañes de Esgueva',
      'Cabezón de la Sierra',
      'Caleruega',
      'Campillo de Aranda',
      'Campolara',
      'Canicosa de la Sierra',
      'Cantabrana',
      'Carazo',
      'Carcedo de Bureba',
      'Carcedo de Burgos',
      'Cardeñadijo',
      'Cardeñajimeno',
      'Cardeñuela Riopico',
      'Carrias',
      'Cascajares de Bureba',
      'Cascajares de la Sierra',
      'Castellanos de Castro',
      'Castil de Peones',
      'Castildelgado',
      'Castrillo Matajudíos',
      'Castrillo de Riopisuerga',
      'Castrillo de la Reina',
      'Castrillo de la Vega',
      'Castrillo del Val',
      'Castrojeriz',
      'Cavia',
      'Cayuela',
      'Cebrecos',
      'Celada del Camino',
      'Cerezo de Río Tirón',
      'Cerratón de Juarros',
      'Ciadoncha',
      'Cillaperlata',
      'Cilleruelo de Abajo',
      'Cilleruelo de Arriba',
      'Ciruelos de Cervera',
      'Cogollos',
      'Condado de Treviño',
      'Contreras',
      'Coruña del Conde',
      'Covarrubias',
      'Cubillo del Campo',
      'Cubo de Bureba',
      'Cuevas de San Clemente',
      'Encío',
      'Espinosa de Cervera',
      'Espinosa de los Monteros',
      'Espinosa del Camino',
      'Estépar',
      'Fontioso',
      'Frandovínez',
      'Fresneda de la Sierra Tirón',
      'Fresneña',
      'Fresnillo de las Dueñas',
      'Fresno de Rodilla',
      'Fresno de Río Tirón',
      'Frías',
      'Fuentebureba',
      'Fuentecén',
      'Fuentelcésped',
      'Fuentelisendo',
      'Fuentemolinos',
      'Fuentenebro',
      'Fuentespina',
      'Galbarros',
      'Grijalba',
      'Grisaleña',
      'Gumiel de Izán',
      'Gumiel de Mercado',
      'Hacinas',
      'Haza',
      'Hontanas',
      'Hontangas',
      'Hontoria de Valdearados',
      'Hontoria de la Cantera',
      'Hontoria del Pinar',
      'Hornillos del Camino',
      'Hortigüela',
      'Hoyales de Roa',
      'Huerta de Arriba',
      'Humada',
      'Hurones',
      'Huérmeces',
      'Ibeas de Juarros',
      'Ibrillos',
      'Iglesiarrubia',
      'Isar',
      'Itero del Castillo',
      'Jaramillo Quemado',
      'Jaramillo de la Fuente',
      'Junta de Traslaloma',
      'Junta de Villalba de Losa',
      'Jurisdicción de Lara',
      'Jurisdicción de San Zadornil',
      'La Cueva de Roa',
      'La Gallega',
      'La Horra',
      'La Puebla de Arganzón',
      'La Revilla y Ahedo',
      'La Sequera de Haza',
      'La Vid de Bureba',
      'La Vid y Barrios',
      'Las Hormazas',
      'Las Quintanillas',
      'Llano de Bureba',
      'Los Altos',
      'Los Ausines',
      'Los Balbases',
      'Los Barrios de Bureba',
      'Madrigal del Monte',
      'Madrigalejo del Monte',
      'Mahamud',
      'Mambrilla de Castrejón',
      'Mambrillas de Lara',
      'Mamolar',
      'Manciles',
      'Mazuela',
      'Mecerreyes',
      'Medina de Pomar',
      'Melgar de Fernamental',
      'Merindad de Cuesta-Urria',
      'Merindad de Montija',
      'Merindad de Río Ubierna',
      'Merindad de Sotoscueva',
      'Merindad de Valdeporres',
      'Merindad de Valdivielso',
      'Miranda de Ebro',
      'Miraveche',
      'Modúbar de la Emparedada',
      'Monasterio de Rodilla',
      'Monasterio de la Sierra',
      'Moncalvillo',
      'Monterrubio de la Demanda',
      'Montorio',
      'Moradillo de Roa',
      'Nava de Roa',
      'Navas de Bureba',
      'Nebreda',
      'Neila',
      'Olmedillo de Roa',
      'Olmillos de Muñó',
      'Oquillas',
      'Orbaneja Riopico',
      'Padilla de Abajo',
      'Padilla de Arriba',
      'Padrones de Bureba',
      'Palacios de Riopisuerga',
      'Palacios de la Sierra',
      'Palazuelos de Muñó',
      'Palazuelos de la Sierra',
      'Pampliega',
      'Pancorbo',
      'Pardilla',
      'Partido de la Sierra en Tobalina',
      'Pedrosa de Duero',
      'Pedrosa de Río Úrbel',
      'Pedrosa del Príncipe',
      'Pedrosa del Páramo',
      'Peral de Arlanza',
      'Peñaranda de Duero',
      'Pineda Trasmonte',
      'Pineda de la Sierra',
      'Pinilla Trasmonte',
      'Pinilla de los Barruecos',
      'Pinilla de los Moros',
      'Piérnigas',
      'Poza de la Sal',
      'Pradoluengo',
      'Presencio',
      'Prádanos de Bureba',
      'Puentedura',
      'Quemada',
      'Quintana del Pidio',
      'Quintanabureba',
      'Quintanaortuño',
      'Quintanapalla',
      'Quintanar de la Sierra',
      'Quintanavides',
      'Quintanaélez',
      'Quintanilla San García',
      'Quintanilla Vivar',
      'Quintanilla de la Mata',
      'Quintanilla del Agua y Tordueles',
      'Quintanilla del Coco',
      'Rabanera del Pinar',
      'Rabé de las Calzadas',
      'Rebolledo de la Torre',
      'Redecilla del Camino',
      'Redecilla del Campo',
      'Regumiel de la Sierra',
      'Reinoso',
      'Retuerta',
      'Revilla Vallejera',
      'Revilla del Campo',
      'Revillarruz',
      'Rezmondo',
      'Riocavado de la Sierra',
      'Roa',
      'Royuela de Río Franco',
      'Rubena',
      'Rublacedo de Abajo',
      'Rucandio',
      'Rábanos',
      'Salas de Bureba',
      'Salas de los Infantes',
      'Saldaña de Burgos',
      'Salinillas de Bureba',
      'San Adrián de Juarros',
      'San Juan del Monte',
      'San Mamés de Burgos',
      'San Martín de Rubiales',
      'San Millán de Lara',
      'San Vicente del Valle',
      'Santa Cecilia',
      'Santa Cruz de la Salceda',
      'Santa Cruz del Valle Urbión',
      'Santa Gadea del Cid',
      'Santa Inés',
      'Santa María Rivarredonda',
      'Santa María del Campo',
      'Santa María del Invierno',
      'Santa María del Mercadillo',
      'Santa Olalla de Bureba',
      'Santibáñez de Esgueva',
      'Santibáñez del Val',
      'Santo Domingo de Silos',
      'Sargentes de la Lora',
      'Sarracín',
      'Sasamón',
      'Solarana',
      'Sordillos',
      'Sotillo de la Ribera',
      'Sotragero',
      'Sotresgudo',
      'Susinos del Páramo',
      'Tamarón',
      'Tardajos',
      'Tejada',
      'Terradillos de Esgueva',
      'Tinieblas de la Sierra',
      'Tobar',
      'Tordómar',
      'Torrecilla del Monte',
      'Torregalindo',
      'Torrelara',
      'Torrepadre',
      'Torresandino',
      'Tosantos',
      'Trespaderne',
      'Tubilla del Agua',
      'Tubilla del Lago',
      'Tórtoles de Esgueva',
      'Vadocondes',
      'Valdeande',
      'Valdezate',
      'Valdorros',
      'Vallarta de Bureba',
      'Valle de Losa',
      'Valle de Manzanedo',
      'Valle de Mena',
      'Valle de Oca',
      'Valle de Santibáñez',
      'Valle de Sedano',
      'Valle de Tobalina',
      'Valle de Valdebezana',
      'Valle de Valdelaguna',
      'Valle de Valdelucio',
      'Valle de Zamanzas',
      'Valle de las Navas',
      'Vallejera',
      'Valles de Palenzuela',
      'Valluércanes',
      'Vileña',
      'Villadiego',
      'Villaescusa de Roa',
      'Villaescusa la Sombría',
      'Villaespasa',
      'Villafranca Montes de Oca',
      'Villafruela',
      'Villagalijo',
      'Villagonzalo Pedernales',
      'Villahoz',
      'Villalba de Duero',
      'Villalbilla de Burgos',
      'Villalbilla de Gumiel',
      'Villaldemiro',
      'Villalmanzo',
      'Villamayor de Treviño',
      'Villamayor de los Montes',
      'Villambistia',
      'Villamedianilla',
      'Villamiel de la Sierra',
      'Villangómez',
      'Villanueva de Argaño',
      'Villanueva de Carazo',
      'Villanueva de Gumiel',
      'Villanueva de Teba',
      'Villaquirán de la Puebla',
      'Villaquirán de los Infantes',
      'Villarcayo de Merindad de Castilla la Vieja',
      'Villariezo',
      'Villasandino',
      'Villasur de Herreros',
      'Villatuelda',
      'Villaverde del Monte',
      'Villaverde-Mogina',
      'Villayerno Morquillas',
      'Villazopeque',
      'Villegas',
      'Villoruebo',
      'Viloria de Rioja',
      'Vilviestre del Pinar',
      'Vizcaínos',
      'Zael',
      'Zarzosa de Río Pisuerga',
      'Zazuar',
      'Zuñeda',
      'Úrbel del Castillo',
    ],
    'ES-S': [
      'Alfoz de Lloredo',
      'Ampuero',
      'Anievas',
      'Arenas de Iguña',
      'Argoños',
      'Arnuero',
      'Arredondo',
      'Bareyo',
      'Bárcena de Cicero',
      'Bárcena de Pie de Concha',
      'Cabezón de Liébana',
      'Cabezón de la Sal',
      'Cabuérniga',
      'Camaleño',
      'Campoo de Enmedio',
      'Campoo de Yuso',
      'Cartes',
      'Castañeda',
      'Castro Urdiales',
      'Castro-Urdiales',
      'Cillorigo de Liébana',
      'Colindres',
      'Comillas',
      'Corvera de Toranzo',
      'El Astillero',
      'Entrambasaguas',
      'Guriezo',
      'Hazas de Cesto',
      'Hermandad de Campoo de Suso',
      'Herrerías',
      'Lamasón',
      'Laredo',
      'Las Rozas de Valdearroyo',
      'Liendo',
      'Limpias',
      'Liérganes',
      'Los Corrales de Buelna',
      'Los Tojos',
      'Luena',
      'Marina de Cudeyo',
      'Mazcuerras',
      'Medio Cudeyo',
      'Meruelo',
      'Miengo',
      'Miera',
      'Molledo',
      'Noja',
      'Penagos',
      'Pesaguero',
      'Pesquera',
      'Peñarrubia',
      'Piélagos',
      'Polaciones',
      'Polanco',
      'Potes',
      'Puente Viesgo',
      'Ramales de la Victoria',
      'Rasines',
      'Reinosa',
      'Reocín',
      'Ribamontán al Mar',
      'Ribamontán al Monte',
      'Rionansa',
      'Riotuerto',
      'Ruente',
      'Ruesga',
      'Ruiloba',
      'San Felices de Buelna',
      'San Miguel de Aguayo',
      'San Pedro del Romeral',
      'San Roque de Riomiera',
      'San Vicente de la Barquera',
      'Santa Cruz de Bezana',
      'Santa María de Cayón',
      'Santander',
      'Santillana del Mar',
      'Santiurde de Reinosa',
      'Santiurde de Toranzo',
      'Santoña',
      'Saro',
      'Selaya',
      'Soba',
      'Solórzano',
      'Suances',
      'Torrelavega',
      'Tresviso',
      'Tudanca',
      'Udías',
      'Val de San Vicente',
      'Valdeolea',
      'Valdeprado del Río',
      'Valderredible',
      'Valdáliga',
      'Valle de Villaverde',
      'Vega de Liébana',
      'Vega de Pas',
      'Villacarriedo',
      'Villaescusa',
      'Villafufre',
    ],
    'ES-CS': [
      'Albocàsser',
      'Alcalà de Xivert',
      'Alcudia de Veo',
      'Alfondeguilla',
      'Algimia de Almonacid',
      'Almedíjar',
      'Alquerías del Niño Perdido',
      'Altura',
      'Arañuel',
      'Ares del Maestrat',
      'Argelita',
      'Artana',
      'Atzeneta del Maestrat',
      'Ayódar',
      'Azuébar',
      'Aín',
      'Bejís',
      'Benafer',
      'Benafigos',
      'Benasal',
      'Benicarló',
      'Benicassim',
      'Benlloch',
      'Betxí',
      'Borriol',
      'Cabanes',
      'Canet lo Roig',
      'Castell de Cabres',
      'Castellfort',
      'Castellnovo',
      'Castellón',
      'Castillo de Villamalefa',
      'Catí',
      'Caudiel',
      'Cervera del Maestre',
      'Chóvar',
      'Cinctorres',
      'Cirat',
      'Cortes de Arenoso',
      'Costur',
      'Culla',
      'Càlig',
      'El Toro',
      'Eslida',
      'Espadilla',
      'Fanzara',
      'Figueroles',
      'Forcall',
      'Fuente la Reina',
      'Fuentes de Ayódar',
      'Gaibiel',
      'Geldo',
      'Herbés',
      'Jérica',
      "L' Alcora",
      'La Jana',
      'La Llosa',
      'La Mata de Morella',
      'La Pobla Tornesa',
      'La Pobla de Benifassà',
      'La Salzadella',
      "La Torre d'En Besora",
      "La Vall d'Uixó",
      'La Vilavella',
      'Les Coves de Vinromà',
      'Lucena del Cid',
      'Ludiente',
      'Matet',
      'Moncofa',
      'Montanejos',
      'Montán',
      'Morella',
      'Navajas',
      'Nules',
      'Olocau del Rey',
      'Onda',
      'Palanques',
      'Pavías',
      'Pina de Montalgrao',
      'Portell de Morella',
      'Puebla de Arenoso',
      'Ribesalbes',
      'Rossell',
      'Sacañet',
      'San Rafael del Río',
      'Sant Joan de Moró',
      'Santa Magdalena de Pulpis',
      'Sarratella',
      'Segorbe',
      'Sierra Engarcerán',
      'Soneja',
      'Sot de Ferrer',
      'Tales',
      'Teresa',
      'Todolella',
      'Toga',
      'Torralba del Pinar',
      'Torreblanca',
      'Torrechiva',
      'Torás',
      'Traiguera',
      'Tírig',
      "Vall d'Alba",
      'Vall de Almonacid',
      'Vallat',
      'Vallibona',
      'Vila-real',
      'Vilafamés',
      "Vilanova d'Alcolea",
      'Vilar de Canes',
      'Villahermosa del Río',
      'Villamalur',
      'Villanueva de Viver',
      'Villores',
      'Vinaròs',
      'Vistabella del Maestrazgo',
      'Viver',
      'Zorita del Maestrazgo',
      'Zucaina',
    ],
    'ES-CR': [
      'Abenójar',
      'Alamillo',
      'Albaladejo',
      'Alcolea de Calatrava',
      'Alcubillas',
      'Alcázar de San Juan',
      'Aldea del Rey',
      'Almadenejos',
      'Almadén',
      'Almedina',
      'Almodóvar del Campo',
      'Almuradiel',
      'Anchuras',
      'Arenales de San Gregorio',
      'Arenas de San Juan',
      'Argamasilla de Alba',
      'Argamasilla de Calatrava',
      'Arroba de los Montes',
      'Ballesteros de Calatrava',
      'Bolaños de Calatrava',
      'Brazatortas',
      'Cabezarados',
      'Cabezarrubias del Puerto',
      'Calzada de Calatrava',
      'Campo de Criptana',
      'Caracuel de Calatrava',
      'Carrizosa',
      'Carrión de Calatrava',
      'Castellar de Santiago',
      'Cañada de Calatrava',
      'Chillón',
      'Ciudad Real',
      'Corral de Calatrava',
      'Cózar',
      'Daimiel',
      'El Robledo',
      'Fernán Caballero',
      'Fontanarejo',
      'Fuencaliente',
      'Fuenllana',
      'Fuente el Fresno',
      'Granátula de Calatrava',
      'Guadalmez',
      'Herencia',
      'Hinojosas de Calatrava',
      'Horcajo de los Montes',
      'La Solana',
      'Las Labores',
      'Llanos del Caudillo',
      'Los Cortijos',
      'Los Pozuelos de Calatrava',
      'Luciana',
      'Malagón',
      'Membrilla',
      'Mestanza',
      'Miguelturra',
      'Montiel',
      'Moral de Calatrava',
      'Navalpino',
      'Navas de Estena',
      'Pedro Muñoz',
      'Picón',
      'Piedrabuena',
      'Poblete',
      'Porzuna',
      'Pozuelo de Calatrava',
      'Puebla de Don Rodrigo',
      'Puebla del Príncipe',
      'Puerto Lápice',
      'Puertollano',
      'Retuerta del Bullaque',
      'Ruidera',
      'Saceruela',
      'San Carlos del Valle',
      'San Lorenzo de Calatrava',
      'Santa Cruz de Mudela',
      'Santa Cruz de los Cáñamos',
      'Socuéllamos',
      'Solana del Pino',
      'Terrinches',
      'Tomelloso',
      'Torralba de Calatrava',
      'Torre de Juan Abad',
      'Torrenueva',
      'Valdemanco del Esteras',
      'Valdepeñas',
      'Valenzuela de Calatrava',
      'Villamanrique',
      'Villamayor de Calatrava',
      'Villanueva de San Carlos',
      'Villanueva de la Fuente',
      'Villar del Pozo',
      'Villarrubia de los Ojos',
      'Villarta de San Juan',
      'Viso del Marqués',
    ],
    'ES-CU': [
      'Abia de la Obispalía',
      'Alarcón',
      'Albaladejo del Cuende',
      'Albalate de las Nogueras',
      'Albendea',
      'Alcalá de la Vega',
      'Alcantud',
      'Alcohujate',
      'Alconchel de la Estrella',
      'Alcázar del Rey',
      'Algarra',
      'Aliaguilla',
      'Almendros',
      'Almodóvar del Pinar',
      'Almonacid del Marquesado',
      'Altarejos',
      'Arandilla del Arroyo',
      'Arcas del Villar',
      'Arcos de la Sierra',
      'Arguisuelas',
      'Arrancacepas',
      'Atalaya del Cañavate',
      'Barajas de Melo',
      'Barchín del Hoyo',
      'Bascuñana de San Pedro',
      'Beamud',
      'Belinchón',
      'Belmontejo',
      'Beteta',
      'Boniches',
      'Buciegas',
      'Buenache de Alarcón',
      'Buenache de la Sierra',
      'Buendía',
      'Campillo de Altobuey',
      'Campillos-Paravientos',
      'Campillos-Sierra',
      'Campos del Paraíso',
      'Canalejas del Arroyo',
      'Carboneras de Guadazaón',
      'Cardenete',
      'Carrascosa',
      'Carrascosa de Haro',
      'Casas de Benítez',
      'Casas de Fernando Alonso',
      'Casas de Garcimolina',
      'Casas de Guijarro',
      'Casas de Haro',
      'Casas de los Pinos',
      'Casasimarro',
      'Castejón',
      'Castillejo de Iniesta',
      'Castillejo-Sierra',
      'Castillo de Garcimuñoz',
      'Castillo-Albaráñez',
      'Cañada Juncosa',
      'Cañada del Hoyo',
      'Cañamares',
      'Cañaveras',
      'Cañaveruelas',
      'Cañizares',
      'Cervera del Llano',
      'Chillarón de Cuenca',
      'Chumillas',
      'Cueva del Hierro',
      'El Acebrón',
      'El Cañavate',
      'El Herrumblar',
      'El Hito',
      'El Pedernoso',
      'El Peral',
      'El Picazo',
      'El Pozuelo',
      'El Provencio',
      'El Valle de Altomira',
      'Enguídanos',
      'Fresneda de Altarejos',
      'Fresneda de la Sierra',
      'Fuente de Pedro Naharro',
      'Fuentelespino de Haro',
      'Fuentelespino de Moya',
      'Fuentenava de Jábaga',
      'Fuentes',
      'Fuertescusa',
      'Gabaldón',
      'Garaballa',
      'Gascueña',
      'Graja de Campalbo',
      'Graja de Iniesta',
      'Henarejos',
      'Honrubia',
      'Hontanaya',
      'Hontecillas',
      'Horcajo de Santiago',
      'Huelves',
      'Huerta de la Obispalía',
      'Huerta del Marquesado',
      'Huete',
      'Huélamo',
      'Huérguina',
      'Iniesta',
      'La Alberca de Záncara',
      'La Almarcha',
      'La Cierva',
      'La Frontera',
      'La Hinojosa',
      'La Parra de las Vegas',
      'La Peraleja',
      'La Pesquera',
      'Laguna del Marquesado',
      'Lagunaseca',
      'Landete',
      'Las Majadas',
      'Las Mesas',
      'Las Pedroñeras',
      'Las Valeras',
      'Ledaña',
      'Leganiel',
      'Los Hinojosos',
      'Los Valdecolmenas',
      'Masegosa',
      'Minglanilla',
      'Monreal del Llano',
      'Montalbanejo',
      'Montalbo',
      'Monteagudo de las Salinas',
      'Mota de Altarejos',
      'Mota del Cuervo',
      'Motilla del Palancar',
      'Narboneta',
      'Olivares de Júcar',
      'Olmeda de la Cuesta',
      'Olmeda del Rey',
      'Olmedilla de Alarcón',
      'Olmedilla de Eliz',
      'Osa de la Vega',
      'Pajaroncillo',
      'Pajarón',
      'Palomares del Campo',
      'Palomera',
      'Pinarejo',
      'Pineda de Gigüela',
      'Piqueras del Castillo',
      'Portalrubio de Guadamejud',
      'Portilla',
      'Poyatos',
      'Pozoamargo',
      'Pozorrubielos de la Mancha',
      'Pozorrubio',
      'Priego',
      'Puebla de Almenara',
      'Puebla del Salvador',
      'Quintanar del Rey',
      'Rada de Haro',
      'Reíllo',
      'Rozalén del Monte',
      'Saceda-Trasierra',
      'Saelices',
      'Salinas del Manzano',
      'Salmeroncillos',
      'Salvacañete',
      'San Lorenzo de la Parrilla',
      'San Martín de Boniches',
      'San Pedro Palmiches',
      'Santa Cruz de Moya',
      'Santa María de los Llanos',
      'Santa María del Campo Rus',
      'Santa María del Val',
      'Sisante',
      'Solera de Gabaldón',
      'Sotorribas',
      'Talayuelas',
      'Tarancón',
      'Tejadillos',
      'Tinajas',
      'Torrejoncillo del Rey',
      'Torrubia del Campo',
      'Torrubia del Castillo',
      'Tragacete',
      'Tresjuncos',
      'Tribaldos',
      'Tébar',
      'Uclés',
      'Uña',
      'Valdemeca',
      'Valdemorillo de la Sierra',
      'Valdemoro-Sierra',
      'Valdeolivas',
      'Valdetórtola',
      'Valhermoso de la Fuente',
      'Valsalobre',
      'Valverde de Júcar',
      'Valverdejo',
      'Vara de Rey',
      'Vega del Codorno',
      'Vellisca',
      'Villaconejos de Trabaque',
      'Villaescusa de Haro',
      'Villagarcía del Llano',
      'Villalba de la Sierra',
      'Villalba del Rey',
      'Villalgordo del Marquesado',
      'Villalpardo',
      'Villamayor de Santiago',
      'Villanueva de Guadamejud',
      'Villanueva de la Jara',
      'Villar de Cañas',
      'Villar de Domingo García',
      'Villar de Olalla',
      'Villar de la Encina',
      'Villar del Humo',
      'Villar del Infantado',
      'Villar y Velasco',
      'Villarejo de Fuentes',
      'Villarejo de la Peñuela',
      'Villarejo-Periesteban',
      'Villares del Saz',
      'Villarrubio',
      'Villarta',
      'Villas de la Ventosa',
      'Villaverde y Pasaconsol',
      'Vindel',
      'Víllora',
      'Yémeda',
      'Zafra de Záncara',
      'Zafrilla',
      'Zarza de Tajo',
      'Zarzuela',
    ],
    'ES-CC': [
      'Abadía',
      'Abertura',
      'Acehúche',
      'Aceituna',
      'Ahigal',
      'Alagón del Río',
      'Albalá',
      'Alcollarín',
      'Alcuéscar',
      'Alcántara',
      'Aldea del Cano',
      'Aldeacentenera',
      'Aldeanueva de la Vera',
      'Aldeanueva del Camino',
      'Aldehuela de Jerte',
      'Aliseda',
      'Almaraz',
      'Almoharín',
      'Alía',
      'Arroyo de la Luz',
      'Arroyomolinos de la Vera',
      'Barrado',
      'Baños de Montemayor',
      'Belvís de Monroy',
      'Benquerencia',
      'Berrocalejo',
      'Berzocana',
      'Bohonal de Ibor',
      'Botija',
      'Brozas',
      'Cabañas del Castillo',
      'Cabezabellosa',
      'Cabezuela del Valle',
      'Cachorrilla',
      'Cadalso',
      'Calzadilla',
      'Caminomorisco',
      'Campillo de Deleitosa',
      'Campo Lugar',
      'Carbajo',
      'Carcaboso',
      'Carrascalejo',
      'Casar de Cáceres',
      'Casar de Palomero',
      'Casares de las Hurdes',
      'Casas de Don Antonio',
      'Casas de Don Gómez',
      'Casas de Millán',
      'Casas de Miravete',
      'Casas del Castañar',
      'Casas del Monte',
      'Casatejada',
      'Casillas de Coria',
      'Castañar de Ibor',
      'Cañaveral',
      'Ceclavín',
      'Cedillo',
      'Cilleros',
      'Collado',
      'Conquista de la Sierra',
      'Coria',
      'Cuacos de Yuste',
      'Deleitosa',
      'Descargamaría',
      'El Gordo',
      'Eljas',
      'Escurial',
      'Fresnedoso de Ibor',
      'Galisteo',
      'Garciaz',
      'Garganta la Olla',
      'Gargantilla',
      'Gargüera',
      'Garrovillas de Alconétar',
      'Garvín',
      'Guijo de Coria',
      'Guijo de Galisteo',
      'Guijo de Granadilla',
      'Guijo de Santa Bárbara',
      'Herguijuela',
      'Hernán-Pérez',
      'Herrera de Alcántara',
      'Herreruela',
      'Hervás',
      'Hinojal',
      'Holguera',
      'Hoyos',
      'Huélaga',
      'Ibahernando',
      'Jaraicejo',
      'Jarandilla de la Vera',
      'Jaraíz de la Vera',
      'Jarilla',
      'Jerte',
      'La Aldea del Obispo',
      'La Garganta',
      'La Pesga',
      'Ladrillar',
      'Logrosán',
      'Losar de la Vera',
      'Madrigal de la Vera',
      'Madrigalejo',
      'Madroñera',
      'Majadas',
      'Malpartida de Cáceres',
      'Malpartida de Plasencia',
      'Marchagaz',
      'Mata de Alcántara',
      'Membrío',
      'Mesas de Ibor',
      'Miajadas',
      'Millanes',
      'Mohedas de Granadilla',
      'Monroy',
      'Montehermoso',
      'Montánchez',
      'Moraleja',
      'Morcillo',
      'Navaconcejo',
      'Navalmoral de la Mata',
      'Navalvillar de Ibor',
      'Navas del Madroño',
      'Navezuelas',
      'Nuñomoral',
      'Oliva de Plasencia',
      'Palomero',
      'Pasarón de la Vera',
      'Pedroso de Acim',
      'Peraleda de San Román',
      'Peraleda de la Mata',
      'Perales del Puerto',
      'Pescueza',
      'Piedras Albas',
      'Pinofranqueado',
      'Piornal',
      'Plasencia',
      'Plasenzuela',
      'Portaje',
      'Pozuelo de Zarzón',
      'Puerto de Santa Cruz',
      'Riolobos',
      'Robledillo de Gata',
      'Robledillo de Trujillo',
      'Robledillo de la Vera',
      'Robledollano',
      'Romangordo',
      'Rosalejo',
      'Ruanes',
      'Salorino',
      'Salvatierra de Santiago',
      'San Martín de Trevejo',
      'Santa Cruz de Paniagua',
      'Santa Marta de Magasca',
      'Santiago de Alcántara',
      'Santiago del Campo',
      'Santibáñez el Alto',
      'Santibáñez el Bajo',
      'Saucedilla',
      'Segura de Toro',
      'Serradilla',
      'Serrejón',
      'Sierra de Fuentes',
      'Talaveruela de la Vera',
      'Talaván',
      'Talayuela',
      'Tejeda de Tiétar',
      'Toril',
      'Tornavacas',
      'Torre de Don Miguel',
      'Torre de Santa María',
      'Torrecilla de los Ángeles',
      'Torrecillas de la Tiesa',
      'Torrejoncillo',
      'Torrejón el Rubio',
      'Torremenga',
      'Torremocha',
      'Torreorgaz',
      'Torrequemada',
      'Valdastillas',
      'Valdecañas de Tajo',
      'Valdefuentes',
      'Valdehúncar',
      'Valdelacasa de Tajo',
      'Valdemorales',
      'Valdeobispo',
      'Valencia de Alcántara',
      'Valverde de la Vera',
      'Valverde del Fresno',
      'Vegaviana',
      'Viandar de la Vera',
      'Villa del Campo',
      'Villa del Rey',
      'Villamesías',
      'Villamiel',
      'Villanueva de la Sierra',
      'Villanueva de la Vera',
      'Villar de Plasencia',
      'Villar del Pedroso',
      'Villasbuenas de Gata',
      'Zarza de Granadilla',
      'Zarza de Montánchez',
      'Zarza la Mayor',
      'Zorita',
    ],
    'ES-CA': [
      'Alcalá de los Gazules',
      'Alcalá del Valle',
      'Algar',
      'Algodonales',
      'Arcos de la Frontera',
      'Barbate',
      'Benalup-Casas Viejas',
      'Benaocaz',
      'Bornos',
      'Castellar de la Frontera',
      'Chiclana de la Frontera',
      'Chipiona',
      'Conil de la Frontera',
      'Cádiz',
      'El Gastor',
      'El Puerto de Santa María',
      'Grazalema',
      'Jerez de la Frontera',
      'Jimena de la Frontera',
      'La Línea de la Concepción',
      'Los Barrios',
      'Medina-Sidonia',
      'Olvera',
      'Paterna de Rivera',
      'Prado del Rey',
      'Puerto Real',
      'Puerto Serrano',
      'Rota',
      'San José del Valle',
      'Sanlúcar de Barrameda',
      'Setenil de las Bodegas',
      'Tarifa',
      'Torre Alháquime',
      'Trebujena',
      'Ubrique',
      'Vejer de la Frontera',
      'Villaluenga del Rosario',
      'Villamartín',
    ],
    'ES-CO': [
      'Adamuz',
      'Aguilar de la Frontera',
      'Alcaracejos',
      'Almedinilla',
      'Almodóvar del Río',
      'Añora',
      'Baena',
      'Belalcázar',
      'Belmez',
      'Benamejí',
      'Bujalance',
      'Carcabuey',
      'Cardeña',
      'Castro del Río',
      'Cañete de las Torres',
      'Dos Torres',
      'Doña Mencía',
      'El Carpio',
      'El Guijo',
      'El Viso',
      'Encinas Reales',
      'Espiel',
      'Fernán-Núñez',
      'Fuente Obejuna',
      'Fuente Palmera',
      'Fuente la Lancha',
      'Fuente-Tójar',
      'Guadalcázar',
      'Hinojosa del Duque',
      'Hornachuelos',
      'Iznájar',
      'La Granjuela',
      'La Rambla',
      'Los Blázquez',
      'Montalbán de Córdoba',
      'Montemayor',
      'Montilla',
      'Monturque',
      'Moriles',
      'Nueva Carteya',
      'Obejo',
      'Palenciana',
      'Palma del Río',
      'Pedro Abad',
      'Pedroche',
      'Peñarroya-Pueblonuevo',
      'Pozoblanco',
      'Priego de Córdoba',
      'Puente Genil',
      'Rute',
      'San Sebastián de los Ballesteros',
      'Santa Eufemia',
      'Santaella',
      'Torrecampo',
      'Valsequillo',
      'Villa del Río',
      'Villafranca de Córdoba',
      'Villaharta',
      'Villanueva de Córdoba',
      'Villanueva del Duque',
      'Villanueva del Rey',
      'Villaralto',
      'Villaviciosa de Córdoba',
      'Zuheros',
    ],
    'ES-GI': [
      'Agullana',
      'Aiguaviva',
      'Albanyà',
      'Albons',
      'Alp',
      'Amer',
      'Arbúcies',
      'Argelaguer',
      'Avinyonet de Puigventós',
      'Banyoles',
      'Begur',
      "Bellcaire d'Empordà",
      'Besalú',
      'Bescanó',
      'Beuda',
      'Biure',
      'Blanes',
      'Boadella i les Escaules',
      'Bolvir',
      'Bordils',
      'Borrassà',
      'Breda',
      'Brunyola',
      'Bàscara',
      'Cabanelles',
      'Cadaqués',
      'Caldes de Malavella',
      'Calonge',
      'Campdevànol',
      'Campelles',
      'Campllong',
      'Camprodon',
      'Camós',
      "Canet d'Adri",
      'Cantallops',
      'Capmany',
      'Cassà de la Selva',
      "Castell-Platja d'Aro",
      'Castellfollit de la Roca',
      "Castelló d'Empúries",
      'Celrà',
      'Cervià de Ter',
      'Cistella',
      'Colera',
      'Colomers',
      'Cornellà del Terri',
      'Corçà',
      'Crespià',
      "Cruïlles, Monells i Sant Sadurní de l'Heura",
      'Darnius',
      'Das',
      "El Far d'Empordà",
      'El Port de la Selva',
      'Espinelves',
      'Espolla',
      'Esponellà',
      'Figueres',
      'Flaçà',
      'Foixà',
      'Fontanals de Cerdanya',
      'Fontanilles',
      'Fontcoberta',
      'Forallac',
      'Fornells de la Selva',
      'Fortià',
      'Garrigoles',
      'Garriguella',
      'Garrigàs',
      'Girona',
      'Girona (municipio)',
      'Gombrèn',
      'Gualta',
      'Guils de Cerdanya',
      'Hostalric',
      'Isòvol',
      'Jafre',
      'Juià',
      "La Bisbal d'Empordà",
      'La Cellera de Ter',
      'La Jonquera',
      'La Pera',
      'La Selva de Mar',
      "La Tallada d'Empordà",
      'La Vajol',
      "La Vall d'en Bas",
      'La Vall de Bianya',
      'Les Llosses',
      "Les Planes d'Hostoles",
      'Les Preses',
      'Lladó',
      'Llagostera',
      'Llambilles',
      'Llanars',
      'Llançà',
      'Llers',
      'Lloret de Mar',
      'Llívia',
      'Madremanya',
      'Maià de Montcal',
      'Masarac',
      'Maçanet de Cabrenys',
      'Maçanet de la Selva',
      'Meranges',
      'Mollet de Peralada',
      'Molló',
      'Mont-ras',
      'Montagut i Oix',
      'Ogassa',
      'Olot',
      'Ordis',
      'Osor',
      'Palafrugell',
      'Palamós',
      'Palau de Santa Eulàlia',
      'Palau-sator',
      'Palau-saverdera',
      'Palol de Revardit',
      'Pals',
      'Parlavà',
      'Pedret i Marzà',
      'Peralada',
      'Planoles',
      'Pont de Molins',
      'Pontós',
      'Porqueres',
      'Portbou',
      'Puigcerdà',
      'Queralbs',
      'Rabós',
      'Regencós',
      'Ribes de Freser',
      'Riells i Viabrea',
      'Ripoll',
      'Riudarenes',
      'Riudaura',
      'Riudellots de la Selva',
      'Riumors',
      'Roses',
      'Rupià',
      'Sales de Llierca',
      'Salt',
      'Sant Andreu Salou',
      'Sant Aniol de Finestres',
      'Sant Climent Sescebes',
      'Sant Feliu de Buixalleu',
      'Sant Feliu de Guíxols',
      'Sant Feliu de Pallerols',
      'Sant Ferriol',
      'Sant Gregori',
      'Sant Hilari Sacalm',
      'Sant Jaume de Llierca',
      'Sant Joan de Mollet',
      'Sant Joan de les Abadesses',
      'Sant Joan les Fonts',
      'Sant Jordi Desvalls',
      'Sant Julià de Ramis',
      'Sant Julià del Llor i Bonmatí',
      'Sant Llorenç de la Muga',
      'Sant Martí Vell',
      'Sant Martí de Llémena',
      'Sant Miquel de Campmajor',
      'Sant Miquel de Fluvià',
      'Sant Mori',
      'Sant Pau de Segúries',
      'Sant Pere Pescador',
      'Santa Coloma de Farners',
      "Santa Cristina d'Aro",
      "Santa Llogaia d'Àlguema",
      'Santa Pau',
      'Sarrià de Ter',
      'Saus, Camallera i Llampaies',
      'Serinyà',
      'Serra de Daró',
      'Setcases',
      'Sils',
      'Susqueda',
      'Terrades',
      'Torroella de Fluvià',
      'Torroella de Montgrí',
      'Tortellà',
      'Toses',
      'Tossa de Mar',
      'Ullastret',
      'Ullà',
      'Ultramort',
      'Urús',
      'Vall-llobrega',
      'Vallfogona de Ripollès',
      'Ventalló',
      'Verges',
      'Vidreres',
      'Vidrà',
      'Vila-sacra',
      'Vilabertran',
      'Vilablareix',
      'Viladamat',
      'Viladasens',
      'Vilademuls',
      'Viladrau',
      'Vilafant',
      'Vilajuïga',
      'Vilallonga de Ter',
      'Vilamacolum',
      'Vilamalla',
      'Vilamaniscle',
      'Vilanant',
      'Vilaür',
      "Vilobí d'Onyar",
      'Vilopriu',
    ],
    'ES-SS': [
      'Abaltzisketa',
      'Aduna',
      'Aia',
      'Aizarnazabal',
      'Albiztur',
      'Alegia',
      'Alkiza',
      'Altzaga',
      'Altzo',
      'Amezketa',
      'Andoain',
      'Anoeta',
      'Antzuola',
      'Arama',
      'Aretxabaleta',
      'Arrasate',
      'Asteasu',
      'Astigarraga',
      'Ataun',
      'Azkoitia',
      'Azpeitia',
      'Baliarrain',
      'Beasain',
      'Beizama',
      'Belauntza',
      'Berastegi',
      'Bergara',
      'Berrobi',
      'Bidegoian',
      'Donostia-San Sebastián',
      'Eibar',
      'Elduain',
      'Elgeta',
      'Elgoibar',
      'Errenteria',
      'Errezil',
      'Eskoriatza',
      'Ezkio-Itsaso',
      'Gabiria',
      'Getaria',
      'Hernani',
      'Hernialde',
      'Hondarribia',
      'Idiazabal',
      'Ikaztegieta',
      'Irura',
      'Irún',
      'Itsasondo',
      'Larraul',
      'Lasarte-Oria',
      'Lazkao',
      'Leaburu',
      'Legorreta',
      'Leintz-Gatzaga',
      'Lezo',
      'Lizartza',
      'Mendaro',
      'Mutiloa',
      'Mutriku',
      'Olaberria',
      'Ordizia',
      'Orendain',
      'Orexa',
      'Orio',
      'Ormaiztegi',
      'Oñati',
      'Pasaia',
      'Tolosa',
      'Urnieta',
      'Urretxu',
      'Usurbil',
      'Zaldibia',
      'Zarautz',
      'Zegama',
      'Zerain',
      'Zestoa',
      'Zizurkil',
      'Zumaia',
      'Zumarraga',
    ],
    'ES-GR': [
      'Agrón',
      'Alamedilla',
      'Albolote',
      'Albondón',
      'Albuñol',
      'Albuñuelas',
      'Albuñán',
      'Aldeire',
      'Alfacar',
      'Algarinejo',
      'Alhama de Granada',
      'Alhendín',
      'Alicún de Ortega',
      'Almegíjar',
      'Almuñécar',
      'Alpujarra de la Sierra',
      'Alquife',
      'Arenas del Rey',
      'Armilla',
      'Atarfe',
      'Baza',
      'Beas de Granada',
      'Beas de Guadix',
      'Benalúa',
      'Benalúa de las Villas',
      'Benamaurel',
      'Bubión',
      'Busquístar',
      'Bérchules',
      'Cacín',
      'Calicasas',
      'Campotéjar',
      'Caniles',
      'Capileira',
      'Carataunas',
      'Castilléjar',
      'Castril',
      'Cenes de la Vega',
      'Chauchina',
      'Chimeneas',
      'Churriana de la Vega',
      'Cijuela',
      'Cogollos de Guadix',
      'Cogollos de la Vega',
      'Colomera',
      'Cortes de Baza',
      'Cortes y Graena',
      'Cuevas del Campo',
      'Cádiar',
      'Cájar',
      'Cástaras',
      'Cáñar',
      'Cúllar',
      'Cúllar Vega',
      'Darro',
      'Dehesas de Guadix',
      'Deifontes',
      'Diezma',
      'Dílar',
      'Dólar',
      'Dúdar',
      'Dúrcal',
      'El Pinar',
      'Escúzar',
      'Fonelas',
      'Freila',
      'Fuente Vaqueros',
      'Galera',
      'Gobernador',
      'Gor',
      'Gorafe',
      'Guadahortuna',
      'Guadix',
      'Gualchos',
      'Gójar',
      'Güejar Sierra',
      'Güevéjar',
      'Huélago',
      'Huéneja',
      'Huéscar',
      'Huétor Tájar',
      'Huétor Vega',
      'Huétor de Santillán',
      'Illora',
      'Itrabo',
      'Iznalloz',
      'Jayena',
      'Jerez del Marquesado',
      'Jete',
      'Jun',
      'Juviles',
      'La Calahorra',
      'La Malahá',
      'La Peza',
      'La Taha',
      'La Zubia',
      'Lanjarón',
      'Lanteira',
      'Las Gabias',
      'Lecrín',
      'Lentegí',
      'Lobras',
      'Los Guajares',
      'Lugros',
      'Láchar',
      'Lújar',
      'Maracena',
      'Marchal',
      'Moclín',
      'Molvízar',
      'Monachil',
      'Montefrío',
      'Montejícar',
      'Montillana',
      'Moraleda de Zafayona',
      'Morelábor',
      'Motril',
      'Murtas',
      'Nevada',
      'Nigüelas',
      'Nívar',
      'Ogíjares',
      'Orce',
      'Otura',
      'Otívar',
      'Padul',
      'Pampaneira',
      'Pedro Martínez',
      'Peligros',
      'Pinos Genil',
      'Pinos Puente',
      'Polopos',
      'Polícar',
      'Puebla de Don Fadrique',
      'Pulianas',
      'Purullena',
      'Píñar',
      'Pórtugos',
      'Quéntar',
      'Rubite',
      'Salar',
      'Salobreña',
      'Santa Cruz del Comercio',
      'Soportújar',
      'Sorvilán',
      'Torre-Cardela',
      'Torvizcón',
      'Trevélez',
      'Turón',
      'Ugíjar',
      'Valle del Zalabí',
      'Vegas del Genil',
      'Ventas de Huelma',
      'Villamena',
      'Villanueva Mesía',
      'Villanueva de las Torres',
      'Válor',
      'Vélez de Benaudalla',
      'Víznar',
      'Zafarraya',
      'Zagra',
      'Zújar',
      'Órgiva',
    ],
    'ES-GU': [
      'Ablanque',
      'Abánades',
      'Adobes',
      'Alaminos',
      'Alarilla',
      'Albalate de Zorita',
      'Albares',
      'Albendiego',
      'Alcocer',
      'Alcolea de las Peñas',
      'Alcolea del Pinar',
      'Alcoroches',
      'Aldeanueva de Guadalajara',
      'Algar de Mesa',
      'Algora',
      'Alique',
      'Almadrones',
      'Almoguera',
      'Almonacid de Zorita',
      'Alocén',
      'Alovera',
      'Alustante',
      'Angón',
      'Anquela del Ducado',
      'Anquela del Pedregal',
      'Aranzueque',
      'Arbancón',
      'Arbeteta',
      'Argecilla',
      'Armallones',
      'Armuña de Tajuña',
      'Arroyo de las Fraguas',
      'Atanzón',
      'Atienza',
      'Auñón',
      'Azuqueca de Henares',
      'Baides',
      'Barriopedro',
      'Baños de Tajo',
      'Bañuelos',
      'Berninches',
      'Brihuega',
      'Budia',
      'Bujalaro',
      'Bustares',
      'Cabanillas del Campo',
      'Campillo de Dueñas',
      'Campillo de Ranas',
      'Campisábalos',
      'Canredondo',
      'Cantalojas',
      'Casa de Uceda',
      'Casas de San Galindo',
      'Caspueñas',
      'Castejón de Henares',
      'Castellar de la Muela',
      'Castilforte',
      'Castilnuevo',
      'Cañizar',
      'Cendejas de Enmedio',
      'Cendejas de la Torre',
      'Centenera',
      'Checa',
      'Chequilla',
      'Chillarón del Rey',
      'Chiloeches',
      'Cincovillas',
      'Ciruelas',
      'Ciruelos del Pinar',
      'Cobeta',
      'Cogollor',
      'Cogolludo',
      'Condemios de Abajo',
      'Condemios de Arriba',
      'Congostrina',
      'Copernal',
      'Corduente',
      'Driebes',
      'Durón',
      'El Cardoso de la Sierra',
      'El Casar',
      'El Cubillo de Uceda',
      'El Olivar',
      'El Ordial',
      'El Pedregal',
      'El Pobo de Dueñas',
      'El Recuenco',
      'El Sotillo',
      'Embid',
      'Escamilla',
      'Escariche',
      'Escopete',
      'Espinosa de Henares',
      'Esplegares',
      'Establés',
      'Estriégana',
      'Fontanar',
      'Fuembellida',
      'Fuencemillán',
      'Fuentelahiguera de Albatages',
      'Fuentelencina',
      'Fuentelsaz',
      'Fuentelviejo',
      'Fuentenovilla',
      'Gajanejos',
      'Galve de Sorbe',
      'Gascueña de Bornova',
      'Henche',
      'Heras de Ayuso',
      'Herrería',
      'Hiendelaencina',
      'Hijes',
      'Hombrados',
      'Hontoba',
      'Horche',
      'Hortezuela de Océn',
      'Huertahernando',
      'Hueva',
      'Humanes',
      'Huérmeces del Cerro',
      'Illana',
      'Iniéstola',
      'Irueste',
      'Jadraque',
      'Jirueque',
      'La Bodera',
      'La Huerce',
      'La Mierla',
      'La Miñosa',
      'La Olmeda de Jadraque',
      'La Toba',
      'La Yunta',
      'Las Inviernas',
      'Las Navas de Jadraque',
      'Ledanca',
      'Loranca de Tajuña',
      'Lupiana',
      'Luzaga',
      'Luzón',
      'Majaelrayo',
      'Malaguilla',
      'Mandayona',
      'Mantiel',
      'Maranchón',
      'Marchamalo',
      'Masegoso de Tajuña',
      'Matarrubia',
      'Matillas',
      'Mazarete',
      'Mazuecos',
      'Medranda',
      'Megina',
      'Membrillera',
      'Miedes de Atienza',
      'Millana',
      'Milmarcos',
      'Mirabueno',
      'Miralrío',
      'Mochales',
      'Mohernando',
      'Molina de Aragón',
      'Monasterio',
      'Mondéjar',
      'Montarrón',
      'Moratilla de los Meleros',
      'Morenilla',
      'Muduex',
      'Málaga del Fresno',
      'Negredo',
      'Ocentejo',
      'Olmeda de Cobeta',
      'Orea',
      'Pardos',
      'Paredes de Sigüenza',
      'Pareja',
      'Pastrana',
      'Peralejos de las Truchas',
      'Peralveche',
      'Peñalver',
      'Peñalén',
      'Pinilla de Jadraque',
      'Pinilla de Molina',
      'Pioz',
      'Piqueras',
      'Poveda de la Sierra',
      'Pozo de Almoguera',
      'Pozo de Guadalajara',
      'Prados Redondos',
      'Prádena de Atienza',
      'Puebla de Beleña',
      'Puebla de Valles',
      'Pálmaces de Jadraque',
      'Quer',
      'Rebollosa de Jadraque',
      'Renera',
      'Retiendas',
      'Riba de Saelices',
      'Rillo de Gallo',
      'Riofrío del Llano',
      'Robledillo de Mohernando',
      'Robledo de Corpes',
      'Romanillos de Atienza',
      'Romanones',
      'Rueda de la Sierra',
      'Sacecorbo',
      'Sacedón',
      'Saelices de la Sal',
      'Salmerón',
      'San Andrés del Congosto',
      'San Andrés del Rey',
      'Santiuste',
      'Sayatón',
      'Saúca',
      'Selas',
      'Setiles',
      'Sienes',
      'Sigüenza',
      'Solanillos del Extremo',
      'Somolinos',
      'Sotodosos',
      'Tamajón',
      'Taragudo',
      'Taravilla',
      'Tartanedo',
      'Tendilla',
      'Terzaga',
      'Tierzo',
      'Tordellego',
      'Tordelrábano',
      'Tordesilos',
      'Torija',
      'Torre del Burgo',
      'Torrecuadrada de Molina',
      'Torrecuadradilla',
      'Torrejón del Rey',
      'Torremocha de Jadraque',
      'Torremocha del Campo',
      'Torremocha del Pinar',
      'Torremochuela',
      'Torrubia',
      'Tortuera',
      'Tortuero',
      'Traíd',
      'Trijueque',
      'Tórtola de Henares',
      'Uceda',
      'Ujados',
      'Utande',
      'Valdarachas',
      'Valdearenas',
      'Valdeavellano',
      'Valdeaveruelo',
      'Valdeconcha',
      'Valdegrudas',
      'Valdelcubo',
      'Valdenuño Fernández',
      'Valdepeñas de la Sierra',
      'Valderrebollo',
      'Valdesotos',
      'Valfermoso de Tajuña',
      'Valhermoso',
      'Valtablado del Río',
      'Valverde de los Arroyos',
      'Viana de Jadraque',
      'Villanueva de Alcorón',
      'Villanueva de Argecilla',
      'Villanueva de la Torre',
      'Villares de Jadraque',
      'Villaseca de Henares',
      'Villaseca de Uceda',
      'Villel de Mesa',
      'Viñuelas',
      'Yebes',
      'Yebra',
      'Yunquera de Henares',
      'Yélamos de Abajo',
      'Yélamos de Arriba',
      'Zaorejas',
      'Zarzuela de Jadraque',
      'Zorita de los Canes',
    ],
    'ES-H': [
      'Aljaraque',
      'Almonaster la Real',
      'Almonte',
      'Alosno',
      'Alájar',
      'Aracena',
      'Aroche',
      'Arroyomolinos de León',
      'Ayamonte',
      'Beas',
      'Berrocal',
      'Bollullos Par del Condado',
      'Bonares',
      'Cabezas Rubias',
      'Cala',
      'Calañas',
      'Cartaya',
      'Castaño del Robledo',
      'Cañaveral de León',
      'Chucena',
      'Corteconcepción',
      'Cortegana',
      'Cortelazor',
      'Cumbres Mayores',
      'Cumbres de Enmedio',
      'Cumbres de San Bartolomé',
      'El Campillo',
      'El Cerro de Andévalo',
      'El Granado',
      'El Portil',
      'Encinasola',
      'Escacena del Campo',
      'Fuenteheridos',
      'Galaroza',
      'Gibraleón',
      'Higuera de la Sierra',
      'Hinojales',
      'Hinojos',
      'Huelva',
      'Isla Cristina',
      'Jabugo',
      'La Granada de Río-Tinto',
      'La Nava',
      'La Palma del Condado',
      'Lepe',
      'Linares de la Sierra',
      'Los Marines',
      'Lucena del Puerto',
      'Manzanilla',
      'Minas de Riotinto',
      'Moguer',
      'Nerva',
      'Niebla',
      'Palos de la Frontera',
      'Paterna del Campo',
      'Paymogo',
      'Puebla de Guzmán',
      'Puerto Moral',
      'Punta Umbría',
      'Rociana del Condado',
      'Rosal de la Frontera',
      'San Bartolomé de la Torre',
      'San Juan del Puerto',
      'San Silvestre de Guzmán',
      'Sanlúcar de Guadiana',
      'Santa Ana la Real',
      'Santa Bárbara de Casa',
      'Santa Olalla del Cala',
      'Trigueros',
      'Valdelarco',
      'Valverde del Camino',
      'Villablanca',
      'Villalba del Alcor',
      'Villanueva de las Cruces',
      'Villanueva de los Castillejos',
      'Villarrasa',
      'Zalamea la Real',
      'Zufre',
    ],
    'ES-HU': [
      'Abiego',
      'Abizanda',
      'Adahuesca',
      'Agüero',
      'Aisa',
      'Albalate de Cinca',
      'Albalatillo',
      'Albelda',
      'Albero Alto',
      'Albero Bajo',
      'Alberuela de Tubo',
      'Alcalá de Gurrea',
      'Alcalá del Obispo',
      'Alcampell',
      'Alcolea de Cinca',
      'Alcubierre',
      'Alerre',
      'Alfántega',
      'Almudévar',
      'Almunia de San Juan',
      'Almuniente',
      'Alquézar',
      'Altorricón',
      'Angüés',
      'Ansó',
      'Antillón',
      'Aragüés del Puerto',
      'Argavieso',
      'Arguis',
      'Arén',
      'Ayerbe',
      'Azanuy-Alins',
      'Azara',
      'Azlor',
      'Aínsa-Sobrarbe',
      'Bailo',
      'Baldellou',
      'Ballobar',
      'Banastás',
      'Barbastro',
      'Barbués',
      'Barbuñales',
      'Baélls',
      'Belver de Cinca',
      'Benabarre',
      'Benasque',
      'Berbegal',
      'Bielsa',
      'Bierge',
      'Biescas',
      'Binaced',
      'Binéfar',
      'Bisaurri',
      'Biscarrués',
      'Blecua y Torres',
      'Boltaña',
      'Bonansa',
      'Borau',
      'Broto',
      'Bárcabo',
      'Caldearenas',
      'Campo',
      'Camporrélls',
      'Candasnos',
      'Canfranc',
      'Capdesaso',
      'Casbas de Huesca',
      'Castejón de Monegros',
      'Castejón de Sos',
      'Castejón del Puente',
      'Castelflorite',
      'Castiello de Jaca',
      'Castigaleu',
      'Castillazuelo',
      'Castillonroy',
      'Chalamera',
      'Chimillas',
      'Colungo',
      'El Grado',
      'El Pueyo de Araguás',
      'Esplús',
      'Estada',
      'Estadilla',
      'Estopiñán del Castillo',
      'Fago',
      'Fanlo',
      'Fiscal',
      'Fonz',
      'Foradada del Toscar',
      'Gistaín',
      'Graus',
      'Grañén',
      'Gurrea de Gállego',
      'Hoz de Jaca',
      'Hoz y Costean',
      'Huerto',
      'Huesca',
      'Ibieca',
      'Igriés',
      'Ilche',
      'Isábena',
      'Jaca',
      'Jasa',
      'La Fueva',
      'La Puebla de Castro',
      'La Sotonera',
      'Labuerda',
      'Laluenga',
      'Lalueza',
      'Lanaja',
      'Laperdiguera',
      'Las Peñas de Riglos',
      'Lascellas-Ponzano',
      'Lascuarre',
      'Laspaúles',
      'Laspuña',
      'Loarre',
      'Loporzano',
      'Loscorrales',
      'Lupiñén-Ortilla',
      'Monesma y Cajigar',
      'Monflorite-Lascasas',
      'Montanuy',
      'Monzón',
      'Naval',
      'Novales',
      'Nueno',
      'Olvena',
      'Ontiñena',
      'Osso de Cinca',
      'Panticosa',
      'Peralta de Alcofea',
      'Peralta de Calasanz',
      'Peraltilla',
      'Perarrúa',
      'Pertusa',
      'Peñalba',
      'Piracés',
      'Poleñino',
      'Pozán de Vero',
      'Puente de Montañana',
      'Puente la Reina de Jaca',
      'Pueyo de Santa Cruz',
      'Puértolas',
      'Quicena',
      'Robres',
      'Sahún',
      'Salas Altas',
      'Salas Bajas',
      'Salillas',
      'Sallent de Gállego',
      'Samianigo',
      'San Esteban de Litera',
      'San Juan de Plan',
      'San Miguel del Cinca',
      'Sangarrén',
      'Santa Cilia',
      'Santa Cruz de la Serós',
      'Santa María de Dulcis',
      'Santaliestra y San Quílez',
      'Sarinyena',
      'Secastilla',
      'Seira',
      'Senés de Alcubierre',
      'Sesa',
      'Sesué',
      'Siétamo',
      'Sopeira',
      'Tamarite de Litera',
      'Tardienta',
      'Tella-Sin',
      'Tierz',
      'Tolva',
      'Torla',
      'Torralba de Aragón',
      'Torre la Ribera',
      'Torrente de Cinca',
      'Torres de Alcanadre',
      'Torres de Barbués',
      'Tramaced',
      'Valfarta',
      'Valle de Bardají',
      'Valle de Hecho',
      'Valle de Lierp',
      'Velilla de Cinca',
      'Vencillón',
      'Viacamp y Litera',
      'Vicién',
      'Villanova',
      'Villanueva de Sigena',
      'Villanúa',
      'Yebra de Basa',
      'Yésero',
      'Zaidín',
    ],
    'ES-J': [
      'Albanchez de Mágina',
      'Alcalá la Real',
      'Alcaudete',
      'Aldeaquemada',
      'Andújar',
      'Arjonilla',
      'Arquillos',
      'Arroyo del Ojanco',
      'Bailén',
      'Baños de la Encina',
      'Beas de Segura',
      'Bedmar y Garcíez',
      'Begíjar',
      'Benatae',
      'Bélmez de la Moraleda',
      'Cabra del Santo Cristo',
      'Cambil',
      'Campillo de Arenas',
      'Canena',
      'Carboneros',
      'Castillo de Locubín',
      'Cazalilla',
      'Cazorla',
      'Chiclana de Segura',
      'Chilluévar',
      'Cárcheles',
      'Escañuela',
      'Espelúy',
      'Fuensanta de Martos',
      'Fuerte del Rey',
      'Guarromán',
      'Génave',
      'Higuera de Calatrava',
      'Hinojares',
      'Hornos',
      'Huelma',
      'Huesa',
      'Ibros',
      'Iznatoraf',
      'Jabalquinto',
      'Jamilena',
      'Jimena',
      'Jódar',
      'La Carolina',
      'La Guardia de Jaén',
      'La Iruela',
      'La Puerta de Segura',
      'Lahiguera',
      'Larva',
      'Lopera',
      'Los Villares',
      'Lupión',
      'Mancha Real',
      'Marmolejo',
      'Martos',
      'Mengíbar',
      'Montizón',
      'Navas de San Juan',
      'Noalejo',
      'Orcera',
      'Peal de Becerro',
      'Pegalajar',
      'Porcuna',
      'Pozo Alcón',
      'Puente de Génave',
      'Sabiote',
      'Santiago de Calatrava',
      'Santiago-Pontones',
      'Santisteban del Puerto',
      'Segura de la Sierra',
      'Siles',
      'Sorihuela del Guadalimar',
      'Torreblascopedro',
      'Torredelcampo',
      'Torredonjimeno',
      'Torreperogil',
      'Torres de Albánchez',
      'Valdepeñas de Jaén',
      'Vilches',
      'Villacarrillo',
      'Villanueva de la Reina',
      'Villanueva del Arzobispo',
      'Villardompardo',
      'Villarrodrigo',
      'Villatorres',
      'Úbeda',
    ],
    'ES-C': [
      'A Baña',
      'A Capela',
      'A Coruña',
      'A Laracha',
      'A Pobra do Caramiñal',
      'Abegondo',
      'Aranga',
      'Arteixo',
      'Arzúa',
      'Aríns',
      'As Pontes de García Rodríguez',
      'As Somozas',
      'Bergondo',
      'Boimorto',
      'Boiro',
      'Boqueixón',
      'Brión',
      'Cabana de Bergantiños',
      'Camariñas',
      'Cambre',
      'Cariño',
      'Carnota',
      'Carral',
      'Cedeira',
      'Cerdido',
      'Cesuras',
      'Coirós',
      'Corcubión',
      'Coristanco',
      'Culleredo',
      'Curtis',
      'Dodro',
      'Dumbría',
      'Fene',
      'Ferrol',
      'Fisterra',
      'Frades',
      'Irixoa',
      'Laxe',
      'Lousame',
      'Malpica de Bergantiños',
      'Mazaricos',
      'Mañón',
      'Mesía',
      'Miño',
      'Moeche',
      'Monfero',
      'Mugardos',
      'Muxía',
      'Narón',
      'Neda',
      'Negreira',
      'Noia',
      'O Pino',
      'Ordes',
      'Oroso',
      'Outes',
      'Oza dos Ríos',
      'Paderne',
      'Padrón',
      'Ponteceso',
      'Pontedeume',
      'Porto do Son',
      'Rianxo',
      'Rois',
      'Sada',
      'San Sadurniño',
      'Santa Comba',
      'Santiago de Compostela',
      'Santiso',
      'Teo',
      'Toques',
      'Tordoia',
      'Touro',
      'Val do Dubra',
      'Valdoviño',
      'Vedra',
      'Vilarmaior',
      'Vilasantar',
      'Vimianzo',
      'Zas',
    ],
    'ES-LO': [
      'Agoncillo',
      'Aguilar del Río Alhama',
      'Ajamil de Cameros',
      'Albelda de Iregua',
      'Alberite',
      'Alcanadre',
      'Aldeanueva de Ebro',
      'Alesanco',
      'Alesón',
      'Alfaro',
      'Almarza de Cameros',
      'Anguciana',
      'Anguiano',
      'Arenzana de Abajo',
      'Arenzana de Arriba',
      'Arnedillo',
      'Arnedo',
      'Arrúbal',
      'Ausejo',
      'Autol',
      'Azofra',
      'Badarán',
      'Bañares',
      'Baños de Rioja',
      'Baños de Río Tobía',
      'Berceo',
      'Bergasa',
      'Bergasillas Bajera',
      'Bezares',
      'Bobadilla',
      'Brieva de Cameros',
      'Briones',
      'Briñas',
      'Cabezón de Cameros',
      'Calahorra',
      'Camprovín',
      'Canales de la Sierra',
      'Canillas de Río Tuerto',
      'Casalarreina',
      'Castañares de Rioja',
      'Castroviejo',
      'Cellorigo',
      'Cenicero',
      'Cervera del Río Alhama',
      'Cidamón',
      'Cihuri',
      'Cirueña',
      'Clavijo',
      'Cordovín',
      'Corera',
      'Cornago',
      'Corporales',
      'Cuzcurrita de Río Tirón',
      'Daroca de Rioja',
      'El Rasillo de Cameros',
      'El Redal',
      'El Villar de Arnedo',
      'Entrena',
      'Estollo',
      'Ezcaray',
      'Foncea',
      'Fonzaleche',
      'Fuenmayor',
      'Galbárruli',
      'Galilea',
      'Gallinero de Cameros',
      'Gimileo',
      'Grañón',
      'Grávalos',
      'Haro',
      'Herce',
      'Herramélluri',
      'Hervías',
      'Hormilla',
      'Hormilleja',
      'Hornillos de Cameros',
      'Hornos de Moncalvillo',
      'Huércanos',
      'Igea',
      'Jalón de Cameros',
      'Laguna de Cameros',
      'Lagunilla del Jubera',
      'Lardero',
      'Ledesma de la Cogolla',
      'Leza de Río Leza',
      'Lumbreras',
      'Manjarrés',
      'Mansilla de la Sierra',
      'Manzanares de Rioja',
      'Matute',
      'Medrano',
      'Munilla',
      'Murillo de Río Leza',
      'Muro de Aguas',
      'Muro en Cameros',
      'Nalda',
      'Navajún',
      'Navarrete',
      'Nestares',
      'Nieva de Cameros',
      'Nájera',
      'Ochánduri',
      'Ocón',
      'Ojacastro',
      'Ollauri',
      'Ortigosa de Cameros',
      'Pazuengos',
      'Pedroso',
      'Pradejón',
      'Pradillo',
      'Préjano',
      'Quel',
      'Rabanera',
      'Ribafrecha',
      'Rincón de Soto',
      'Robres del Castillo',
      'Rodezno',
      'Sajazarra',
      'San Asensio',
      'San Millán de Yécora',
      'San Millán de la Cogolla',
      'San Román de Cameros',
      'San Torcuato',
      'San Vicente de la Sonsierra',
      'Santa Coloma',
      'Santa Engracia del Jubera',
      'Santa Eulalia Bajera',
      'Santo Domingo de la Calzada',
      'Santurde de Rioja',
      'Santurdejo',
      'Sojuela',
      'Sorzano',
      'Soto en Cameros',
      'Sotés',
      'Terroba',
      'Tirgo',
      'Tobía',
      'Tormantos',
      'Torre en Cameros',
      'Torrecilla en Cameros',
      'Torrecilla sobre Alesanco',
      'Torremontalbo',
      'Treviana',
      'Tricio',
      'Tudelilla',
      'Uruñuela',
      'Valdemadera',
      'Valgañón',
      'Ventosa',
      'Ventrosa',
      'Viguera',
      'Villalba de Rioja',
      'Villalobar de Rioja',
      'Villamediana de Iregua',
      'Villanueva de Cameros',
      'Villar de Torre',
      'Villarejo',
      'Villarroya',
      'Villarta-Quintana',
      'Villavelayo',
      'Villaverde de Rioja',
      'Villoslada de Cameros',
      'Viniegra de Abajo',
      'Viniegra de Arriba',
      'Zarratón',
      'Zarzosa',
      'Zorraquín',
      'Ábalos',
    ],
    'ES-GC': [
      'Agaete',
      'Agüimes',
      'Antigua',
      'Arrecife',
      'Artenara',
      'Arucas',
      'Betancuria',
      'Firgas',
      'Gáldar',
      'Haría',
      'Ingenio',
      'La Aldea de San Nicolás',
      'La Oliva',
      'Las Palmas de Gran Canaria',
      'Mogán',
      'Moya',
      'Puerto del Rosario',
      'Pájara',
      'San Bartolomé',
      'San Bartolomé de Tirajana',
      'Santa Lucía de Tirajana',
      'Santa María de Guía de Gran Canaria',
      'Teguise',
      'Tejeda',
      'Telde',
      'Teror',
      'Tinajo',
      'Tuineje',
      'Tías',
      'Valleseco',
      'Valsequillo de Gran Canaria',
      'Vecindario',
      'Vega de San Mateo',
      'Yaiza',
    ],
    'ES-LE': [
      'Acebedo',
      'Algadefe',
      'Alija del Infantado',
      'Almanza',
      'Ardón',
      'Arganza',
      'Barjas',
      'Bembibre',
      'Benavides',
      'Benuza',
      'Bercianos del Páramo',
      'Bercianos del Real Camino',
      'Berlanga del Bierzo',
      'Boca de Huérgano',
      'Borrenes',
      'Boñar',
      'Brazuelo',
      'Burón',
      'Bustillo del Páramo',
      'Cabañas Raras',
      'Cabreros del Río',
      'Cabrillanes',
      'Cacabelos',
      'Calzada del Coto',
      'Campazas',
      'Campo de Villavidel',
      'Camponaraya',
      'Candín',
      'Carracedelo',
      'Carrizo',
      'Carrocera',
      'Carucedo',
      'Castilfalé',
      'Castrillo de Cabrera',
      'Castrillo de la Valduerna',
      'Castrocalbón',
      'Castrocontrigo',
      'Castropodame',
      'Castrotierra de Valmadrigal',
      'Cea',
      'Cebanico',
      'Cebrones del Río',
      'Chozas de Abajo',
      'Cimanes de la Vega',
      'Cimanes del Tejar',
      'Cistierna',
      'Congosto',
      'Corbillos de los Oteros',
      'Corullón',
      'Crémenes',
      'Cuadros',
      'Cubillas de Rueda',
      'Cubillas de los Oteros',
      'Cubillos del Sil',
      'Cármenes',
      'Destriana',
      'El Burgo Ranero',
      'Encinedo',
      'Escobar de Campos',
      'Fabero',
      'Folgoso de la Ribera',
      'Fresno de la Vega',
      'Fuentes de Carbajal',
      'Garrafe de Torío',
      'Gordaliza del Pino',
      'Gordoncillo',
      'Gradefes',
      'Grajal de Campos',
      'Gusendos de los Oteros',
      'Hospital de Órbigo',
      'Igüeña',
      'Izagre',
      'Joarilla de las Matas',
      'La Bañeza',
      'La Ercina',
      'La Pola de Gordón',
      'La Robla',
      'La Vecilla',
      'Laguna Dalga',
      'Laguna de Negrillos',
      'Las Omañas',
      'Llamas de la Ribera',
      'Los Barrios de Luna',
      'Lucillo',
      'Luyego',
      'Magaz de Cepeda',
      'Mansilla Mayor',
      'Mansilla de las Mulas',
      'Maraña',
      'Matadeón de los Oteros',
      'Matallana de Torío',
      'Molinaseca',
      'Murias de Paredes',
      'Noceda del Bierzo',
      'Oencia',
      'Onzonilla',
      'Oseja de Sajambre',
      'Pajares de los Oteros',
      'Palacios de la Valduerna',
      'Palacios del Sil',
      'Peranzanes',
      'Pobladura de Pelayo García',
      'Ponferrada',
      'Posada de Valdeón',
      'Pozuelo del Páramo',
      'Prado de la Guzpeña',
      'Priaranza del Bierzo',
      'Prioro',
      'Puebla de Lillo',
      'Puente de Domingo Flórez',
      'Páramo del Sil',
      'Quintana del Castillo',
      'Quintana del Marco',
      'Quintana y Congosto',
      'Regueras de Arriba',
      'Reyero',
      'Riaño',
      'Riego de la Vega',
      'Riello',
      'Rioseco de Tapia',
      'Roperuelos del Páramo',
      'Sabero',
      'San Adrián del Valle',
      'San Andrés del Rabanedo',
      'San Cristóbal de la Polantera',
      'San Emiliano',
      'San Esteban de Nogales',
      'San Justo de la Vega',
      'San Millán de los Caballeros',
      'San Pedro Bercianos',
      'Sancedo',
      'Santa Colomba de Curueño',
      'Santa Colomba de Somoza',
      'Santa Cristina de Valmadrigal',
      'Santa Elena de Jamuz',
      'Santa Marina del Rey',
      'Santa María de Ordás',
      'Santa María de la Isla',
      'Santa María del Monte de Cea',
      'Santa María del Páramo',
      'Santas Martas',
      'Santiago Millas',
      'Santovenia de la Valdoncina',
      'Sariegos',
      'Sena de Luna',
      'Soto de la Vega',
      'Soto y Amío',
      'Toral de los Guzmanes',
      'Toral de los Vados',
      'Toreno',
      'Torre del Bierzo',
      'Trabadelo',
      'Turcia',
      'Urdiales del Páramo',
      'Val de San Lorenzo',
      'Valdefresno',
      'Valdefuentes del Páramo',
      'Valdelugueros',
      'Valdemora',
      'Valdepiélago',
      'Valdepolo',
      'Valderas',
      'Valderrey',
      'Valderrueda',
      'Valdesamario',
      'Valdevimbre',
      'Valencia de Don Juan',
      'Valverde de la Virgen',
      'Valverde-Enrique',
      'Vega de Espinareda',
      'Vega de Infanzones',
      'Vega de Valcarce',
      'Vegacervera',
      'Vegaquemada',
      'Vegas del Condado',
      'Villablino',
      'Villabraz',
      'Villadangos del Páramo',
      'Villademor de la Vega',
      'Villafranca del Bierzo',
      'Villagatón',
      'Villamandos',
      'Villamanín',
      'Villamartín de Don Sancho',
      'Villamañán',
      'Villamejil',
      'Villamol',
      'Villamontán de la Valduerna',
      'Villamoratiel de las Matas',
      'Villanueva de las Manzanas',
      'Villaobispo de Otero',
      'Villaornate y Castro',
      'Villaquejida',
      'Villaquilambre',
      'Villarejo de Órbigo',
      'Villares de Órbigo',
      'Villasabariego',
      'Villaselán',
      'Villaturiel',
      'Villazala',
      'Villazanzo de Valderaduey',
      'Zotes del Páramo',
    ],
    'ES-LU': [
      'A Fonsagrada',
      'A Pastoriza',
      'A Pobra do Brollón',
      'A Pontenova',
      'Abadín',
      'Alfoz',
      'Antas de Ulla',
      'As Nogais',
      'Baleira',
      'Baralla',
      'Becerreá',
      'Begonte',
      'Burela',
      'Bóveda',
      'Carballedo',
      'Castro de Rei',
      'Castroverde',
      'Chantada',
      'Cospeito',
      'Folgoso do Courel',
      'Foz',
      'Friol',
      'Guitiriz',
      'Guntín',
      'Lourenzá',
      'Láncara',
      'Meira',
      'Mondoñedo',
      'Monforte de Lemos',
      'Monterroso',
      'Muras',
      'Navia de Suarna',
      'Negueira de Muñiz',
      'O Corgo',
      'O Incio',
      'O Páramo',
      'O Saviñao',
      'O Valadouro',
      'O Vicedo',
      'Ourol',
      'Outeiro de Rei',
      'Palas de Rei',
      'Pantón',
      'Paradela',
      'Pedrafita do Cebreiro',
      'Pol',
      'Portomarín',
      'Ribadeo',
      'Ribas de Sil',
      'Ribeira de Piquín',
      'Riotorto',
      'Rábade',
      'Samos',
      'Sober',
      'Taboada',
      'Trabada',
      'Triacastela',
      'Vilalba',
      'Viveiro',
      'Xermade',
      'Xove',
    ],
    'ES-L': [
      'Abella de la Conca',
      'Agramunt',
      'Aitona',
      'Albatàrrec',
      'Albesa',
      'Alcanó',
      'Alcarràs',
      'Alcoletge',
      'Alfarràs',
      'Alfés',
      'Algerri',
      'Alguaire',
      'Alins',
      'Almacelles',
      'Almatret',
      'Almenar',
      'Alpicat',
      'Alt Àneu',
      'Alàs i Cerc',
      'Alòs de Balaguer',
      'Anglesola',
      'Arbeca',
      'Arres',
      'Arsèguel',
      'Artesa de Lleida',
      'Artesa de Segre',
      'Aspa',
      'Baix Pallars',
      'Barbens',
      'Bassella',
      'Bausen',
      'Belianes',
      "Bell-lloc d'Urgell",
      'Bellaguarda',
      "Bellcaire d'Urgell",
      "Bellmunt d'Urgell",
      'Bellpuig',
      'Bellver de Cerdanya',
      'Bellvís',
      'Benavent de Segrià',
      'Biosca',
      'Bossòst',
      'Bovera',
      'Cabanabona',
      'Cabó',
      'Canejan',
      'Castell de Mur',
      'Castellar de la Ribera',
      'Castelldans',
      'Castellnou de Seana',
      'Castellserà',
      'Castelló de Farfanya',
      'Cervera',
      'Cervià de les Garrigues',
      'Ciutadilla',
      'Clariana de Cardener',
      'Coll de Nargó',
      'Conca de Dalt',
      'Corbins',
      'Cubells',
      'El Cogul',
      "El Palau d'Anglesola",
      'El Poal',
      'El Pont de Bar',
      'El Pont de Suert',
      'El Soleràs',
      'El Vilosell',
      'Els Alamús',
      'Els Omellons',
      'Els Omells de na Gaia',
      'Els Plans de Sió',
      'Es Bòrdes',
      'Espot',
      'Estamariu',
      'Estaràs',
      "Esterri d'Àneu",
      'Esterri de Cardós',
      'Farrera',
      'Fondarella',
      'Foradada',
      'Fulleda',
      'Fígols i Alinyà',
      'Gavet de la Conca',
      'Gimenells i el Pla de la Font',
      'Golmés',
      'Granyanella',
      'Granyena de Segarra',
      'Granyena de les Garrigues',
      'Guimerà',
      'Guissona',
      'Guixers',
      'Gósol',
      'Isona i Conca Dellà',
      "Ivars d'Urgell",
      'Ivars de Noguera',
      'Ivorra',
      'Josa i Tuixén',
      'Juncosa',
      'Juneda',
      'La Baronia de Rialb',
      'La Coma i la Pedra',
      'La Fuliola',
      'La Granadella',
      "La Granja d'Escarp",
      "La Guingueta d'Àneu",
      'La Molsosa',
      'La Pobla de Cérvoles',
      'La Pobla de Segur',
      'La Portella',
      'La Sentiu de Sió',
      "La Seu d'Urgell",
      'La Torre de Cabdella',
      'La Vall de Boí',
      'La Vansa i Fórnols',
      'Les',
      'Les Avellanes i Santa Linya',
      'Les Borges Blanques',
      'Les Oluges',
      "Les Valls d'Aguilar",
      'Les Valls de Valira',
      'Linyola',
      'Lladorre',
      'Lladurs',
      'Llardecans',
      'Llavorsí',
      'Lleida',
      'Lles de Cerdanya',
      'Llimiana',
      'Llobera',
      'Maials',
      'Maldà',
      'Massalcoreig',
      'Massoteres',
      'Menàrguens',
      'Miralcamp',
      'Mollerussa',
      'Montellà i Martinet',
      'Montferrer i Castellbò',
      'Montgai',
      'Montoliu de Lleida',
      'Montoliu de Segarra',
      'Montornès de Segarra',
      'Nalec',
      'Naut Aran',
      'Odèn',
      'Oliana',
      'Oliola',
      'Olius',
      'Organyà',
      'Os de Balaguer',
      'Ossó de Sió',
      'Penelles',
      'Peramola',
      'Pinell de Solsonès',
      'Pinós',
      'Prats i Sansor',
      'Preixana',
      'Preixens',
      'Prullans',
      'Puiggròs',
      "Puigverd d'Agramunt",
      'Puigverd de Lleida',
      'Rialp',
      "Ribera d'Ondara",
      "Ribera d'Urgellet",
      'Riner',
      'Riu de Cerdanya',
      'Rosselló',
      'Salàs de Pallars',
      'Sanaüja',
      'Sant Esteve de la Sarga',
      'Sant Guim de Freixenet',
      'Sant Guim de la Plana',
      'Sant Llorenç de Morunys',
      'Sant Martí de Riucorb',
      'Sant Ramon',
      'Sarroca de Bellera',
      'Sarroca de Lleida',
      'Senterada',
      'Seròs',
      'Sidamon',
      'Solsona',
      'Soriguera',
      'Sort',
      'Soses',
      'Sudanell',
      'Sunyer',
      'Talarn',
      'Tarroja de Segarra',
      'Tarrés',
      'Tiurana',
      'Tornabous',
      'Torre-serona',
      'Torrebesses',
      'Torrefarrera',
      'Torrefeta i Florejacs',
      'Torregrossa',
      'Torrelameu',
      'Torres de Segre',
      'Torà',
      'Tremp',
      'Tàrrega',
      'Térmens',
      'Tírvia',
      'Vall de Cardós',
      'Vallbona de les Monges',
      'Vallfogona de Balaguer',
      'Verdú',
      'Vielha e Mijaran',
      'Vila-sana',
      'Vilagrassa',
      'Vilaller',
      'Vilamòs',
      'Vilanova de Bellpuig',
      'Vilanova de Meià',
      'Vilanova de Segrià',
      "Vilanova de l'Aguda",
      'Vilanova de la Barca',
      'Vinaixa',
      'Àger',
    ],
    'ES-M': [
      'Ajalvir',
      'Alameda del Valle',
      'Alcalá de Henares',
      'Alcobendas',
      'Alcorcón',
      'Aldea del Fresno',
      'Algete',
      'Alpedrete',
      'Ambite',
      'Anchuelo',
      'Aranjuez',
      'Arganda del Rey',
      'Arroyomolinos',
      'Batres',
      'Becerril de la Sierra',
      'Belmonte de Tajo',
      'Berzosa del Lozoya',
      'Boadilla del Monte',
      'Braojos',
      'Brea de Tajo',
      'Brunete',
      'Buitrago de Lozoya',
      'Buitrago del Lozoya',
      'Bustarviejo',
      'Cabanillas de la Sierra',
      'Cadalso de los Vidrios',
      'Camarma de Esteruelas',
      'Campo Real',
      'Canencia',
      'Carabaña',
      'Casarrubuelos',
      'Cenicientos',
      'Cerceda',
      'Cercedilla',
      'Cervera de Buitrago',
      'Chapinería',
      'Chinchón',
      'Ciempozuelos',
      'Cobeña',
      'Collado Mediano',
      'Collado Villalba',
      'Colmenar Viejo',
      'Colmenar de Oreja',
      'Colmenar del Arroyo',
      'Colmenarejo',
      'Corpa',
      'Coslada',
      'Cubas de la Sagra',
      'Daganzo de Arriba',
      'El Atazar',
      'El Berrueco',
      'El Boalo',
      'El Escorial',
      'El Vellón',
      'El Álamo (Madrid)',
      'Estremera',
      'Fresnedillas de la Oliva',
      'Fresno de Torote',
      'Fuenlabrada',
      'Fuente el Saz de Jarama',
      'Fuentidueña de Tajo',
      'Galapagar',
      'Garganta de los Montes',
      'Gargantilla del Lozoya y Pinilla de Buitrago',
      'Gascones',
      'Getafe',
      'Griñón',
      'Guadalix de la Sierra',
      'Guadarrama',
      'Horcajo de la Sierra-Aoslos',
      'Horcajuelo de la Sierra',
      'Hoyo de Manzanares',
      'Humanes de Madrid',
      'La Acebeda',
      'La Cabrera',
      'La Hiruela',
      'La Serna del Monte',
      'Las Rozas',
      'Leganés',
      'Loeches',
      'Los Molinos',
      'Los Santos de la Humosa',
      'Lozoya',
      'Lozoyuela-Navas-Sieteiglesias',
      'Madarcos',
      'Madrid (desambiguación)',
      'Majadahonda',
      'Manzanares el Real',
      'Mataelpino',
      'Meco',
      'Mejorada del Campo',
      'Miraflores de la Sierra',
      'Montejo de la Sierra',
      'Moraleja de Enmedio',
      'Moralzarzal',
      'Morata de Tajuña',
      'Móstoles',
      'Navacerrada',
      'Navalafuente',
      'Navalagamella',
      'Navalcarnero',
      'Navarredonda y San Mamés',
      'Navas del Rey',
      'Nuevo Baztán',
      'Olmeda de las Fuentes',
      'Orusco de Tajuña',
      'Paracuellos del Jarama',
      'Parla',
      'Patones',
      'Pedrezuela',
      'Pelayos de la Presa',
      'Perales de Tajuña',
      'Pezuela de las Torres',
      'Pinilla del Valle',
      'Piñuécar-Gandullas',
      'Pozuelo de Alarcón',
      'Pozuelo del Rey',
      'Prádena del Rincón',
      'Puebla de la Sierra',
      'Puentes Viejas',
      'Quijorna',
      'Rascafría',
      'Redueña',
      'Ribatejada',
      'Rivas-Vaciamadrid',
      'Robledillo de la Jara',
      'Robledo de Chavela',
      'Robregordo',
      'Rozas de Puerto Real',
      'San Agustín del Guadalix',
      'San Fernando de Henares',
      'San Lorenzo del Escorial',
      'San Martín de Valdeiglesias',
      'San Martín de la Vega',
      'San Sebastián de los Reyes',
      'Santa María de la Alameda',
      'Santorcaz',
      'Serranillos del Valle',
      'Seseña',
      'Sevilla La Nueva',
      'Somosierra',
      'Soto del Real',
      'Talamanca de Jarama',
      'Talamanca del Jarama',
      'Tielmes',
      'Titulcia',
      'Torrejón de Ardoz',
      'Torrejón de Velasco',
      'Torrejón de la Calzada',
      'Torrelaguna',
      'Torrelodones',
      'Torremocha de Jarama',
      'Torres de la Alameda',
      'Tres Cantos',
      'Valdaracete',
      'Valdeavero',
      'Valdelaguna',
      'Valdemanco',
      'Valdemaqueda',
      'Valdemorillo',
      'Valdemoro',
      'Valdeolmos-Alalpardo',
      'Valdepiélagos',
      'Valdetorres de Jarama',
      'Valdilecha',
      'Valverde de Alcalá',
      'Vega del Tajuña',
      'Velilla de San Antonio',
      'Venturada',
      'Villa del Prado',
      'Villaconejos',
      'Villalbilla',
      'Villamanrique de Tajo',
      'Villamanta',
      'Villamantilla',
      'Villanueva de Perales',
      'Villanueva de la Cañada',
      'Villanueva del Pardillo',
      'Villar del Olmo',
      'Villarejo de Salvanés',
      'Villaviciosa de Odón',
      'Villavieja del Lozoya',
      'Zarzalejo',
    ],
    'ES-MU': [
      'Abanilla',
      'Abarán',
      'Albudeite',
      'Alcantarilla',
      'Aledo',
      'Alguazas',
      'Alhama de Murcia',
      'Archena',
      'Beniel',
      'Blanca',
      'Bullas',
      'Calasparra',
      'Campos del Río',
      'Caravaca de la Cruz',
      'Cehegín',
      'Ceutí',
      'Cieza',
      'Fuente Álamo de Murcia',
      'Jumilla',
      'Las Torres de Cotillas',
      'Librilla',
      'Lorca',
      'Lorquí',
      'Los Alcázares',
      'Mazarrón',
      'Molina de Segura',
      'Moratalla',
      'Mula',
      'Murcia',
      'Ojós',
      'Pliego',
      'Puerto Lumbreras',
      'Ricote',
      'San Pedro del Pinatar',
      'Santomera',
      'Torre-Pacheco',
      'Totana',
      'Ulea',
      'Villanueva del Río Segura',
      'Yecla',
      'Águilas',
    ],
    'ES-MA': [
      'Alameda',
      'Alcaucín',
      'Alfarnate',
      'Alfarnatejo',
      'Algatocín',
      'Alhaurín de la Torre',
      'Alhaurín el Grande',
      'Almargen',
      'Almogía',
      'Almáchar',
      'Alozaina',
      'Alpandeire',
      'Ardales',
      'Arriate',
      'Atajate',
      'Benadalid',
      'Benahavís',
      'Benalauría',
      'Benalmádena',
      'Benamargosa',
      'Benamocarra',
      'Benaoján',
      'Benarrabá',
      'Campillos',
      'Canillas de Aceituno',
      'Canillas de Albaida',
      'Carratraca',
      'Cartajima',
      'Casabermeja',
      'Casarabonela',
      'Casares',
      'Cañete la Real',
      'Colmenar',
      'Comares',
      'Cortes de la Frontera',
      'Coín',
      'Cuevas Bajas',
      'Cuevas de San Marcos',
      'Cuevas del Becerro',
      'Cártama',
      'Cómpeta',
      'Cútar',
      'El Borge',
      'El Burgo',
      'Estepona',
      'Faraján',
      'Frigiliana',
      'Fuengirola',
      'Fuente de Piedra',
      'Gaucín',
      'Genalguacil',
      'Guaro',
      'Humilladero',
      'Igualeja',
      'Istán',
      'Iznate',
      'Jimera de Líbar',
      'Jubrique',
      'Júzcar',
      'Macharaviaya',
      'Manilva',
      'Maqueda',
      'Marbella',
      'Mijas',
      'Moclinejo',
      'Mollina',
      'Montejaque',
      'Nerja',
      'Ojén',
      'Parauta',
      'Periana',
      'Pizarra',
      'Pujerra',
      'Rincón de la Victoria',
      'Riogordo',
      'Ronda',
      'Salares',
      'Sayalonga',
      'Sedella',
      'Sierra de Yeguas',
      'Teba',
      'Tolox',
      'Torremolinos',
      'Torrox',
      'Totalán',
      'Valle de Abdalajís',
      'Villanueva de Algaidas',
      'Villanueva de Tapia',
      'Villanueva de la Concepción',
      'Villanueva del Rosario',
      'Villanueva del Trabuco',
      'Viñuela',
      'Vélez-Málaga',
      'Yunquera',
      'Álora',
      'Árchez',
    ],
    'ES-NA': [
      'Aberin',
      'Ablitas',
      'Abáigar',
      'Abárzuza',
      'Adiós',
      'Aguilar de Codés',
      'Allo',
      'Allín',
      'Améscoa Baja',
      'Andosilla',
      'Anue',
      'Araitz',
      'Arakil',
      'Arano',
      'Arantza',
      'Aras',
      'Arbizu',
      'Arellano',
      'Areso',
      'Arguedas',
      'Aria',
      'Aribe',
      'Armañanzas',
      'Arruazu',
      'Arróniz',
      'Artajona',
      'Artazu',
      'Atez',
      'Azagra',
      'Azuelo',
      'Añorbe',
      'Bakaiku',
      'Barañain',
      'Barbarin',
      'Bargota',
      'Barillas',
      'Barásoain',
      'Basaburua',
      'Baztan',
      'Beintza-Labaien',
      'Beire',
      'Belascoáin',
      'Bera',
      'Berbinzana',
      'Beriáin',
      'Berrioplano',
      'Berriozar',
      'Bertizarana',
      'Betelu',
      'Bidaurreta',
      'Biurrun-Olcoz',
      'Buñuel',
      'Cabanillas',
      'Cabredo',
      'Cadreita',
      'Caparroso',
      'Carcastillo',
      'Cascante',
      'Castillonuevo',
      'Cendea de Olza/Oltza Zendea',
      'Cintruénigo',
      'Ciriza',
      'Cizur',
      'Corella',
      'Cortes',
      'Cárcar',
      'Cáseda',
      'Desojo',
      'Dicastillo',
      'Donamaria',
      'Doneztebe/Santesteban',
      'Echarri',
      'Egüés',
      'El Busto',
      'Elgorriaga',
      'Eratsun',
      'Ergoiena',
      'Erro',
      'Estella/Lizarra',
      'Esteribar',
      'Etayo',
      'Etxalar',
      'Etxarri-Aranatz',
      'Etxauri',
      'Eulate',
      'Ezcabarte',
      'Ezkurra',
      'Ezprogui',
      'Falces',
      'Fitero',
      'Fontellas',
      'Fustiñana',
      'Galar',
      'Gallipienzo',
      'Garaioa',
      'Garde',
      'Garralda',
      'Garínoain',
      'Genevilla',
      'Goizueta',
      'Goñi',
      'Guirguillano',
      'Hiriberri/Villanueva de Aezkoa',
      'Huarte/Uharte',
      'Ibargoiti',
      'Igantzi',
      'Igúzquiza',
      'Imotz',
      'Irañeta',
      'Irurtzun',
      'Ituren',
      'Iturmendi',
      'Izagaondoa',
      'Jaurrieta',
      'Javier',
      'Juslapeña',
      'Lakuntza',
      'Lantz',
      'Lapoblación',
      'Larraga',
      'Larraona',
      'Larraun',
      'Lazagurría',
      'Leache',
      'Legarda',
      'Legaria',
      'Leitza',
      'Lekunberri',
      'Lerga',
      'Lerín',
      'Lesaka',
      'Lezáun',
      'Lizoáin-Arriasgoiti',
      'Liédena',
      'Lodosa',
      'Los Arcos',
      'Lumbier',
      'Luquin',
      'Luzaide/Valcarlos',
      'Marcilla',
      'Mañeru',
      'Mendavia',
      'Mendaza',
      'Mendigorría',
      'Metauten',
      'Mirafuentes',
      'Miranda de Arga',
      'Monreal',
      'Morentin',
      'Mues',
      'Murchante',
      'Murieta',
      'Murillo el Cuende',
      'Murillo el Fruto',
      'Muruzábal',
      'Mélida',
      'Navascués',
      'Nazar',
      'Obanos',
      'Oco',
      'Odieta',
      'Oitz',
      'Olaibar',
      'Olazti/Olazagutía',
      'Olejua',
      'Ollo',
      'Orbaitzeta',
      'Orbara',
      'Orkoien',
      'Orreaga/Roncesvalles',
      'Orísoain',
      'Oteiza',
      'Pamplona/Iruña',
      'Petilla de Aragón',
      'Piedramillera',
      'Pitillas',
      'Pueyo',
      'Ribaforada',
      'Romanzado',
      'Roncal/Erronkari',
      'Saldías',
      'San Adrián',
      'San Martín de Unx',
      'Sangüesa/Zangoza',
      'Sansol',
      'Santacara',
      'Sartaguda',
      'Sesma',
      'Sorlada',
      'Sunbilla',
      'Tafalla',
      'Tiebas-Muruarte de Reta',
      'Tirapu',
      'Torralba del Río',
      'Torres del Río',
      'Tudela',
      'Tulebras',
      'Ucar',
      'Uharte-Arakil',
      'Ujué',
      'Ultzama',
      'Unciti',
      'Unzué',
      'Urdazubi/Urdax',
      'Urdiain',
      'Urraul Alto',
      'Urraul Bajo',
      'Urrotz',
      'Urroz-Villa',
      'Uterga',
      'Valtierra',
      'Villafranca',
      'Villamayor de Monjardín',
      'Villatuerta',
      'Yesa',
      'Ziordia',
      'Zizur Mayor/Zizur Nagusia',
      'Zubieta',
      'Zugarramurdi',
      'Zúñiga',
    ],
    'ES-OR': [
      'A Arnoia',
      'A Bola',
      'A Gudiña',
      'A Merca',
      'A Mezquita',
      'A Peroxa',
      'A Pobra de Trives',
      'A Rúa',
      'A Teixeira',
      'A Veiga',
      'Allariz',
      'Amoeiro',
      'Avión',
      'Baltar',
      'Bande',
      'Barbadás',
      'Baños de Molgas',
      'Beade',
      'Beariz',
      'Boborás',
      'Calvos de Randín',
      'Carballeda de Avia',
      'Carballeda de Valdeorras',
      'Cartelle',
      'Castrelo de Miño',
      'Castrelo do Val',
      'Castro Caldelas',
      'Celanova',
      'Cenlle',
      'Chandrexa de Queixa',
      'Coles',
      'Cualedro',
      'Entrimo',
      'Esgos',
      'Gomesende',
      'Larouco',
      'Laza',
      'Leiro',
      'Lobios',
      'Maceda',
      'Maside',
      'Montederramo',
      'Monterrei',
      'Muíños',
      'Nogueira de Ramuín',
      'O Barco de Valdeorras',
      'O Bolo',
      'O Carballiño',
      'O Irixo',
      'O Pereiro de Aguiar',
      'Os Blancos',
      'Ourense',
      'Oímbra',
      'Paderne de Allariz',
      'Padrenda',
      'Parada de Sil',
      'Petín',
      'Piñor',
      'Pontedeva',
      'Punxín',
      'Quintela de Leirado',
      'Rairiz de Veiga',
      'Ramirás',
      'Ribadavia',
      'Riós',
      'Rubiá',
      'San Amaro',
      'San Cibrao das Viñas',
      'San Cristovo de Cea',
      'San Xoán de Río',
      'Sandiás',
      'Sarreaus',
      'Taboadela',
      'Toén',
      'Trasmiras',
      'Verea',
      'Verín',
      'Viana do Bolo',
      'Vilamartín de Valdeorras',
      'Vilamarín',
      'Vilar de Barrio',
      'Vilar de Santos',
      'Vilardevós',
      'Vilariño de Conso',
      'Xinzo de Limia',
      'Xunqueira de Ambía',
      'Xunqueira de Espadanedo',
    ],
    'ES-P': [
      'Abarca de Campos',
      'Abia de las Torres',
      'Aguilar de Campoo',
      'Alar del Rey',
      'Alba de Cerrato',
      'Amayuelas de Arriba',
      'Ampudia',
      'Amusco',
      'Antigüedad',
      'Arconada',
      'Astudillo',
      'Autilla del Pino',
      'Autillo de Campos',
      'Ayuela',
      'Baltanás',
      'Baquerín de Campos',
      'Barruelo de Santullán',
      'Becerril de Campos',
      'Belmonte de Campos',
      'Berzosilla',
      'Boada de Campos',
      'Boadilla de Rioseco',
      'Boadilla del Camino',
      'Brañosera',
      'Buenavista de Valdavia',
      'Bustillo de la Vega',
      'Bustillo del Páramo de Carrión',
      'Bárcena de Campos',
      'Báscones de Ojeda',
      'Calahorra de Boedo',
      'Calzada de los Molinos',
      'Capillas',
      'Cardeñosa de Volpejera',
      'Carrión de los Condes',
      'Castil de Vela',
      'Castrejón de la Peña',
      'Castrillo de Don Juan',
      'Castrillo de Onielo',
      'Castrillo de Villavega',
      'Castromocho',
      'Cervatos de la Cueza',
      'Cervera de Pisuerga',
      'Cevico Navero',
      'Cevico de la Torre',
      'Cobos de Cerrato',
      'Collazos de Boedo',
      'Congosto de Valdavia',
      'Cordovilla la Real',
      'Cubillas de Cerrato',
      'Dehesa de Montejo',
      'Dehesa de Romanos',
      'Dueñas',
      'Espinosa de Cerrato',
      'Espinosa de Villagonzalo',
      'Frechilla',
      'Fresno del Río',
      'Frómista',
      'Fuentes de Nava',
      'Fuentes de Valdepero',
      'Grijota',
      'Guardo',
      'Guaza de Campos',
      'Herrera de Pisuerga',
      'Herrera de Valdecañas',
      'Hontoria de Cerrato',
      'Hornillos de Cerrato',
      'Husillos',
      'Hérmedes de Cerrato',
      'Itero de la Vega',
      'La Pernía',
      'La Puebla de Valdavia',
      'La Serna',
      'La Vid de Ojeda',
      'Lantadilla',
      'Ledigos',
      'Loma de Ucieza',
      'Lomas',
      'Magaz de Pisuerga',
      'Manquillos',
      'Mantinos',
      'Marcilla de Campos',
      'Mazariegos',
      'Mazuecos de Valdeginate',
      'Melgar de Yuso',
      'Meneses de Campos',
      'Micieces de Ojeda',
      'Monzón de Campos',
      'Moratinos',
      'Mudá',
      'Nogal de las Huertas',
      'Olea de Boedo',
      'Olmos de Ojeda',
      'Osornillo',
      'Osorno la Mayor',
      'Palenzuela',
      'Paredes de Nava',
      'Payo de Ojeda',
      'Pedraza de Campos',
      'Pedrosa de la Vega',
      'Perales',
      'Pino del Río',
      'Piña de Campos',
      'Población de Arroyo',
      'Población de Campos',
      'Población de Cerrato',
      'Polentinos',
      'Pomar de Valdivia',
      'Poza de la Vega',
      'Pozo de Urama',
      'Prádanos de Ojeda',
      'Páramo de Boedo',
      'Quintana del Puente',
      'Quintanilla de Onsoña',
      'Reinoso de Cerrato',
      'Renedo de la Vega',
      'Requena de Campos',
      'Respenda de la Peña',
      'Revenga de Campos',
      'Revilla de Collazos',
      'Ribas de Campos',
      'Riberos de la Cueza',
      'Salinas de Pisuerga',
      'San Cebrián de Campos',
      'San Cebrián de Mudá',
      'San Cristóbal de Boedo',
      'San Mamés de Campos',
      'San Román de la Cuba',
      'Santa Cecilia del Alcor',
      'Santa Cruz de Boedo',
      'Santervás de la Vega',
      'Santibáñez de Ecla',
      'Santibáñez de la Peña',
      'Santoyo',
      'Soto de Cerrato',
      'Sotobañado y Priorato',
      'Tabanera de Cerrato',
      'Tabanera de Valdavia',
      'Tariego de Cerrato',
      'Torquemada',
      'Torremormojón',
      'Triollo',
      'Támara de Campos',
      'Valbuena de Pisuerga',
      'Valde-Ucieza',
      'Valdeolmillos',
      'Valderrábano',
      'Valle de Cerrato',
      'Valle del Retortillo',
      'Velilla del Río Carrión',
      'Venta de Baños',
      'Vertavillo',
      'Villabasta de Valdavia',
      'Villacidaler',
      'Villaconancio',
      'Villada',
      'Villaeles de Valdavia',
      'Villaherreros',
      'Villahán',
      'Villalaco',
      'Villalba de Guardo',
      'Villalcázar de Sirga',
      'Villalcón',
      'Villalobón',
      'Villaluenga de la Vega',
      'Villamartín de Campos',
      'Villamediana',
      'Villameriel',
      'Villamoronta',
      'Villamuriel de Cerrato',
      'Villanueva del Rebollar',
      'Villanuño de Valdavia',
      'Villaprovedo',
      'Villarmentero de Campos',
      'Villarrabé',
      'Villarramiel',
      'Villasarracino',
      'Villasila de Valdavia',
      'Villaturde',
      'Villaumbrales',
      'Villaviudas',
      'Villerías de Campos',
      'Villodre',
      'Villodrigo',
      'Villoldo',
      'Villota del Páramo',
      'Villovieco',
    ],
    'ES-PO': [
      'A Cañiza',
      'A Estrada',
      'A Guarda',
      'A Illa de Arousa',
      'A Lama',
      'Agolada',
      'Arbo',
      'As Neves',
      'Baiona',
      'Bueu',
      'Caldas de Reis',
      'Cambados',
      'Campo Lameiro',
      'Catoira',
      'Cerdedo',
      'Cotobade',
      'Covelo',
      'Crecente',
      'Cuntis',
      'Dozón',
      'Forcarei',
      'Fornelos de Montes',
      'Lalín',
      'Meaño',
      'Meis',
      'Moaña',
      'Mondariz',
      'Mondariz-Balneario',
      'Moraña',
      'Mos',
      'Nigrán',
      'O Grove',
      'O Porriño',
      'O Rosal',
      'Oia',
      'Pazos de Borbén',
      'Poio',
      'Ponte Caldelas',
      'Ponteareas',
      'Pontecesures',
      'Pontevedra',
      'Portas',
      'Redondela',
      'Ribadumia',
      'Salceda de Caselas',
      'Salvaterra de Miño',
      'Sanxenxo',
      'Silleda',
      'Soutomaior',
      'Tomiño',
      'Tui',
      'Valga',
      'Vigo',
      'Vila de Cruces',
      'Vilaboa',
      'Vilagarcía de Arousa',
      'Vilanova de Arousa',
    ],
    'ES-SA': [
      'Abusejo',
      'Agallas',
      'Ahigal de Villarino',
      'Ahigal de los Aceiteros',
      'Alaraz',
      'Alba de Tormes',
      'Alba de Yeltes',
      'Alconada',
      'Aldea del Obispo',
      'Aldeacipreste',
      'Aldeadávila de la Ribera',
      'Aldealengua',
      'Aldeanueva de Figueroa',
      'Aldeanueva de la Sierra',
      'Aldearrodrigo',
      'Aldearrubia',
      'Aldeaseca de Alba',
      'Aldeaseca de la Frontera',
      'Aldeatejada',
      'Aldeavieja de Tormes',
      'Aldehuela de Yeltes',
      'Aldehuela de la Bóveda',
      'Almenara de Tormes',
      'Almendra',
      'Anaya de Alba',
      'Arabayona de Mógica',
      'Arapiles',
      'Arcediano',
      'Armenteros',
      'Añover de Tormes',
      'Babilafuente',
      'Barbadillo',
      'Barbalos',
      'Barceo',
      'Barruecopardo',
      'Bañobárez',
      'Beleña',
      'Bermellar',
      'Berrocal de Huebra',
      'Berrocal de Salvatierra',
      'Boada',
      'Bogajo',
      'Brincones',
      'Buenamadre',
      'Béjar',
      'Bóveda del Río Almar',
      'Cabeza del Caballo',
      'Cabezabellosa de la Calzada',
      'Cabrerizos',
      'Cabrillas',
      'Calvarrasa de Abajo',
      'Calvarrasa de Arriba',
      'Calzada de Don Diego',
      'Calzada de Valdunciel',
      'Campillo de Azaba',
      'Candelario',
      'Canillas de Abajo',
      'Cantalapiedra',
      'Cantalpino',
      'Cantaracillo',
      'Carbajosa de la Sagrada',
      'Carpio de Azaba',
      'Carrascal de Barregas',
      'Carrascal del Obispo',
      'Casafranca',
      'Casillas de Flores',
      'Castellanos de Moriscos',
      'Castellanos de Villiquera',
      'Castillejo de Martín Viejo',
      'Castraz',
      'Cepeda',
      'Cereceda de la Sierra',
      'Cerezal de Peñahorcada',
      'Cerralbo',
      'Cespedosa de Tormes',
      'Chagarcía Medianero',
      'Cilleros de la Bastida',
      'Cipérez',
      'Ciudad Rodrigo',
      'Coca de Alba',
      'Colmenar de Montemayor',
      'Cordovilla',
      'Cuéllar',
      'Dios le Guarde',
      'Doñinos de Ledesma',
      'Doñinos de Salamanca',
      'Ejeme',
      'El Arco',
      'El Bodón',
      'El Cabaco',
      'El Campo de Peñaranda',
      'El Cerro',
      'El Cubo de Don Sancho',
      'El Manzano',
      'El Maíllo',
      'El Milano',
      'El Payo',
      'El Pedroso de la Armuña',
      'El Pino de Tormes',
      'El Sahugo',
      'El Tejado',
      'El Tornadizo',
      'Encina de San Silvestre',
      'Encinas de Abajo',
      'Encinas de Arriba',
      'Encinasola de los Comendadores',
      'Endrinal',
      'Escurial de la Sierra',
      'Espadaña',
      'Espeja',
      'Espino de la Orbada',
      'Florida de Liébana',
      'Forfoleda',
      'Frades de la Sierra',
      'Fresnedoso',
      'Fresno Alhándiga',
      'Fuenteguinaldo',
      'Fuenteliante',
      'Fuenterroble de Salvatierra',
      'Fuentes de Béjar',
      'Fuentes de Oñoro',
      'Gajates',
      'Galindo y Perahuy',
      'Galinduste',
      'Galisancho',
      'Gallegos de Argañán',
      'Gallegos de Solmirón',
      'Garcibuey',
      'Garcihernández',
      'Garcirrey',
      'Gejuelo del Barro',
      'Golpejas',
      'Gomecello',
      'Guadramiro',
      'Guijo de Ávila',
      'Guijuelo',
      'Herguijuela de Ciudad Rodrigo',
      'Herguijuela de la Sierra',
      'Herguijuela del Campo',
      'Hinojosa de Duero',
      'Horcajo Medianero',
      'Horcajo de Montemayor',
      'Iruelos',
      'Ituero de Azaba',
      'Juzbado',
      'La Alameda de Gardón',
      'La Alamedilla',
      'La Alberca',
      'La Alberguería de Argañán',
      'La Atalaya',
      'La Bouza',
      'La Cabeza de Béjar',
      'La Calzada de Béjar',
      'La Fregeneda',
      'La Fuente de San Esteban',
      'La Hoya',
      'La Mata de Ledesma',
      'La Maya',
      'La Orbada',
      'La Redonda',
      'La Rinconada de la Sierra',
      'La Sagrada',
      'La Tala',
      'La Vellés',
      'La Vídola',
      'La Zarza de Pumareda',
      'Larrodrigo',
      'Las Casas del Conde',
      'Las Veguillas',
      'Ledrada',
      'Linares de Riofrío',
      'Lumbrales',
      'Machacón',
      'Macotera',
      'Madroñal',
      'Malpartida',
      'Mancera de Abajo',
      'Martiago',
      'Martinamor',
      'Martín de Yeltes',
      'Masueco',
      'Matilla de los Caños del Río',
      'Membribe de la Sierra',
      'Mieza',
      'Miranda de Azán',
      'Miranda del Castañar',
      'Mogarraz',
      'Molinillo',
      'Monforte de la Sierra',
      'Monleras',
      'Monleón',
      'Monsagro',
      'Montejo',
      'Montemayor del Río',
      'Monterrubio de Armuña',
      'Monterrubio de la Sierra',
      'Morasverdes',
      'Morille',
      'Moriscos',
      'Moronta',
      'Moríñigo',
      'Mozárbez',
      'Narros de Matalayegua',
      'Nava de Béjar',
      'Nava de Francia',
      'Nava de Sotrobal',
      'Navacarros',
      'Navales',
      'Navalmoral de Béjar',
      'Navamorales',
      'Navarredonda de la Rinconada',
      'Navasfrías',
      'Negrilla de Palencia',
      'Olmedo de Camaces',
      'Pajares de la Laguna',
      'Palacios del Arzobispo',
      'Palaciosrubios',
      'Palencia de Negrilla',
      'Parada de Arriba',
      'Parada de Rubiales',
      'Paradinas de San Juan',
      'Pedraza de Alba',
      'Pedrosillo de Alba',
      'Pedrosillo de los Aires',
      'Pedrosillo el Ralo',
      'Pelabravo',
      'Pelarrodríguez',
      'Pelayos',
      'Peralejos de Abajo',
      'Peralejos de Arriba',
      'Pereña de la Ribera',
      'Peromingo',
      'Peñacaballera',
      'Peñaparda',
      'Peñaranda de Bracamonte',
      'Peñarandilla',
      'Pinedas',
      'Pitiegua',
      'Pizarral',
      'Poveda de las Cintas',
      'Pozos de Hinojo',
      'Puebla de Azaba',
      'Puebla de San Medel',
      'Puebla de Yeltes',
      'Puente del Congosto',
      'Puertas',
      'Puerto Seguro',
      'Puerto de Béjar',
      'Retortillo',
      'Robleda',
      'Robliza de Cojos',
      'Rollán',
      'Rágama',
      'Saelices el Chico',
      'Saldeana',
      'Salmoral',
      'Salvatierra de Tormes',
      'San Cristóbal de la Cuesta',
      'San Esteban de la Sierra',
      'San Felices de los Gallegos',
      'San Martín del Castañar',
      'San Miguel de Valero',
      'San Miguel del Robledo',
      'San Morales',
      'San Muñoz',
      'San Pedro de Rozados',
      'San Pedro del Valle',
      'San Pelayo de Guareña',
      'Sanchotello',
      'Sanchón de la Ribera',
      'Sanchón de la Sagrada',
      'Santa Marta de Tormes',
      'Santa María de Sando',
      'Santiago de la Puebla',
      'Santibáñez de Béjar',
      'Santibáñez de la Sierra',
      'Santiz',
      'Sardón de los Frailes',
      'Saucelle',
      'Sepulcro-Hilario',
      'Sequeros',
      'Serradilla del Arroyo',
      'Serradilla del Llano',
      'Sieteiglesias de Tormes',
      'Sobradillo',
      'Sorihuela',
      'Sotoserrano',
      'Tabera de Abajo',
      'Tamames',
      'Tarazona de Guareña',
      'Tardáguila',
      'Tejeda y Segoyuela',
      'Tenebrón',
      'Terradillos',
      'Topas',
      'Tordillos',
      'Torresmenudas',
      'Trabanca',
      'Tremedal de Tormes',
      'Valdecarros',
      'Valdefuentes de Sangusín',
      'Valdehijaderos',
      'Valdelacasa',
      'Valdelageve',
      'Valdelosa',
      'Valdemierque',
      'Valderrodrigo',
      'Valdunciel',
      'Valero',
      'Vallejera de Riofrío',
      'Valsalabroso',
      'Valverde de Valdelacasa',
      'Valverdón',
      'Vecinos',
      'Vega de Tirados',
      'Ventosa del Río Almar',
      'Villagonzalo de Tormes',
      'Villalba de los Llanos',
      'Villamayor',
      'Villanueva del Conde',
      'Villar de Argañán',
      'Villar de Ciervo',
      'Villar de Gallimazo',
      'Villar de Peralonso',
      'Villar de Samaniego',
      'Villar de la Yegua',
      'Villares de Yeltes',
      'Villares de la Reina',
      'Villarino de los Aires',
      'Villarmayor',
      'Villarmuerto',
      'Villasbuenas',
      'Villasdardo',
      'Villaseco de los Gamitos',
      'Villaseco de los Reyes',
      'Villasrubias',
      'Villaverde de Guareña',
      'Villavieja de Yeltes',
      'Villoria',
      'Villoruela',
      'Vilvestre',
      'Vitigudino',
      'Yecla de Yeltes',
      'Zamarra',
      'Zamayón',
      'Zarapicos',
      'Zorita de la Frontera',
    ],
    'ES-TF': [
      'Adeje',
      'Agulo',
      'Alajeró',
      'Arafo',
      'Arico',
      'Barlovento',
      'Breña Alta',
      'Breña Baja',
      'Buenavista del Norte',
      'El Pinar de El Hierro',
      'El Sauzal',
      'El Tanque',
      'Fasnia',
      'Fuencaliente de la Palma',
      'Garachico',
      'Garafía',
      'Granadilla de Abona',
      'Guía de Isora',
      'Güímar',
      'Hermigua',
      'Icod de los Vinos',
      'La Guancha',
      'La Matanza de Acentejo',
      'La Orotava',
      'La Victoria de Acentejo',
      'Los Llanos de Aridane',
      'Los Realejos',
      'Los Silos',
      'Puerto de la Cruz',
      'Puntagorda',
      'Puntallana',
      'San Andrés y Sauces',
      'San Juan de la Rambla',
      'San Miguel de Abona',
      'San Sebastián de La Gomera',
      'San Sebastián de la Gomera',
      'Santa Cruz de la Palma',
      'Santa Úrsula',
      'Santiago del Teide',
      'Tacoronte',
      'Tazacorte',
      'Tegueste',
      'Tijarafe',
      'Valle Gran Rey',
      'Vilaflor',
      'Villa de Mazo',
    ],
    'ES-SG': [
      'Abades',
      'Adrada de Pirón',
      'Adrados',
      'Aguilafuente',
      'Alconada de Maderuelo',
      'Aldea Real',
      'Aldealcorvo',
      'Aldealengua de Pedraza',
      'Aldealengua de Santa María',
      'Aldeanueva de la Serrezuela',
      'Aldeanueva del Codonal',
      'Aldeasoña',
      'Aldehorno',
      'Aldehuela del Codonal',
      'Aldeonte',
      'Anaya',
      'Arahuetes',
      'Arcones',
      'Arevalillo de Cega',
      'Armuña',
      'Ayllón',
      'Añe',
      'Barbolla',
      'Basardilla',
      'Bercial',
      'Bercimuel',
      'Bernardos',
      'Bernuy de Porreros',
      'Boceguillas',
      'Brieva',
      'Caballar',
      'Cabañas de Polendos',
      'Cabezuela',
      'Calabazas de Fuentidueña',
      'Campo de San Pedro',
      'Cantalejo',
      'Cantimpalos',
      'Carbonero el Mayor',
      'Carrascal del Río',
      'Casla',
      'Castillejo de Mesleón',
      'Castro de Fuentidueña',
      'Castrojimeno',
      'Castroserna de Abajo',
      'Castroserracín',
      'Cedillo de la Torre',
      'Cerezo de Abajo',
      'Cerezo de Arriba',
      'Chañe',
      'Cilleruelo de San Mamés',
      'Cobos de Fuentidueña',
      'Collado Hermoso',
      'Condado de Castilnovo',
      'Corral de Ayllón',
      'Cozuelos de Fuentidueña',
      'Cubillo',
      'Cuevas de Provanco',
      'Domingo García',
      'Donhierro',
      'Duruelo',
      'El Espinar',
      'Encinas',
      'Encinillas',
      'Escalona del Prado',
      'Escarabajosa de Cabezas',
      'Escobar de Polendos',
      'Espirdo',
      'Fresneda de Cuéllar',
      'Fresno de Cantespino',
      'Fresno de la Fuente',
      'Frumales',
      'Fuente de Santa Cruz',
      'Fuente el Olmo de Fuentidueña',
      'Fuente el Olmo de Íscar',
      'Fuentepelayo',
      'Fuentepiñel',
      'Fuenterrebollo',
      'Fuentesaúco de Fuentidueña',
      'Fuentesoto',
      'Fuentidueña',
      'Gallegos',
      'Garcillán',
      'Gomezserracín',
      'Grajera',
      'Honrubia de la Cuesta',
      'Hontalbilla',
      'Hontanares de Eresma',
      'Ituero y Lama',
      'Juarros de Riomoros',
      'Juarros de Voltoya',
      'La Lastrilla',
      'La Losa',
      'La Matilla',
      'Labajos',
      'Laguna de Contreras',
      'Languilla',
      'Lastras de Cuéllar',
      'Lastras del Pozo',
      'Los Huertos',
      'Maderuelo',
      'Marazoleja',
      'Marazuela',
      'Martín Miguel',
      'Martín Muñoz de la Dehesa',
      'Martín Muñoz de las Posadas',
      'Marugán',
      'Mata de Cuéllar',
      'Matabuena',
      'Melque de Cercos',
      'Membibre de la Hoz',
      'Migueláñez',
      'Montejo de Arévalo',
      'Montejo de la Vega de la Serrezuela',
      'Monterrubio',
      'Moral de Hornuez',
      'Mozoncillo',
      'Muñopedro',
      'Muñoveros',
      'Nava de la Asunción',
      'Navafría',
      'Navalilla',
      'Navalmanzano',
      'Navares de Ayuso',
      'Navares de Enmedio',
      'Navares de las Cuevas',
      'Navas de Oro',
      'Navas de Riofrío',
      'Navas de San Antonio',
      'Nieva',
      'Olombrada',
      'Orejana',
      'Ortigosa de Pestaño',
      'Ortigosa del Monte',
      'Otero de Herreros',
      'Pajarejos',
      'Palazuelos de Eresma',
      'Pelayos del Arroyo',
      'Perosillo',
      'Pinarejos',
      'Pinarnegrillo',
      'Pradales',
      'Prádena',
      'Puebla de Pedraza',
      'Rapariegos',
      'Real Sitio de San Ildefonso',
      'Rebollo',
      'Remondo',
      'Riaguas de San Bartolomé',
      'Riaza',
      'Ribota',
      'Riofrío de Riaza',
      'Roda de Eresma',
      'Sacramenia',
      'Samboal',
      'San Cristóbal de Cuéllar',
      'San Cristóbal de Segovia',
      'San Cristóbal de la Vega',
      'San Martín y Mudrián',
      'San Miguel de Bernuy',
      'San Pedro de Gaíllos',
      'Sanchonuño',
      'Sangarcía',
      'Santa Marta del Cerro',
      'Santa María la Real de Nieva',
      'Santiuste de Pedraza',
      'Santiuste de San Juan Bautista',
      'Santo Domingo de Pirón',
      'Santo Tomé del Puerto',
      'Sauquillo de Cabezas',
      'Sebúlcor',
      'Sepúlveda',
      'Sequera de Fresno',
      'Sotillo',
      'Sotosalbos',
      'Tabanera la Luenga',
      'Tolocirio',
      'Torre Val de San Pedro',
      'Torreadrada',
      'Torrecaballeros',
      'Torrecilla del Pinar',
      'Torreiglesias',
      'Trescasas',
      'Turégano',
      'Urueñas',
      'Valdeprados',
      'Valdevacas de Montejo',
      'Valdevacas y Guijar',
      'Valle de Tabladillo',
      'Vallelado',
      'Valleruela de Pedraza',
      'Valleruela de Sepúlveda',
      'Valseca',
      'Valtiendas',
      'Valverde del Majano',
      'Veganzones',
      'Vegas de Matute',
      'Ventosilla y Tejadilla',
      'Villacastín',
      'Villaverde de Montejo',
      'Villaverde de Íscar',
      'Villeguillo',
      'Yanguas de Eresma',
      'Zarzuela del Monte',
      'Zarzuela del Pinar',
    ],
    'ES-SE': [
      'Alanís',
      'Albaida del Aljarafe',
      'Alcalá de Guadaíra',
      'Alcalá del Río',
      'Alcolea del Río',
      'Algámitas',
      'Almadén de la Plata',
      'Almensilla',
      'Arahal',
      'Aznalcázar',
      'Aznalcóllar',
      'Badolatosa',
      'Benacazón',
      'Bollullos de la Mitación',
      'Bormujos',
      'Brenes',
      'Burguillos',
      'Camas',
      'Cantillana',
      'Carrión de los Céspedes',
      'Casariche',
      'Castilblanco de los Arroyos',
      'Castilleja de Guzmán',
      'Castilleja de la Cuesta',
      'Castilleja del Campo',
      'Cazalla de la Sierra',
      'Cañada Rosal',
      'Coria del Río',
      'Coripe',
      'Dos Hermanas',
      'El Castillo de las Guardas',
      'El Coronil',
      'El Cuervo de Sevilla',
      'El Garrobo',
      'El Madroño',
      'El Pedroso',
      'El Real de la Jara',
      'El Ronquillo',
      'El Rubio',
      'El Saucejo',
      'El Viso del Alcor',
      'Espartinas',
      'Estepa',
      'Fuentes de Andalucía',
      'Gelves',
      'Gerena',
      'Gilena',
      'Gines',
      'Guadalcanal',
      'Guillena',
      'Huévar del Aljarafe',
      'Isla Mayor',
      'La Algaba',
      'La Lantejuela',
      'La Luisiana',
      'La Puebla de Cazalla',
      'La Puebla de los Infantes',
      'La Puebla del Río',
      'La Rinconada',
      'La Roda de Andalucía',
      'Las Cabezas de San Juan',
      'Las Navas de la Concepción',
      'Lora de Estepa',
      'Lora del Río',
      'Los Corrales',
      'Los Molares',
      'Los Palacios y Villafranca',
      'Mairena del Alcor',
      'Mairena del Aljarafe',
      'Marchena',
      'Marinaleda',
      'Martín de la Jara',
      'Montellano',
      'Morón de la Frontera',
      'Olivares',
      'Osuna',
      'Palomares del Río',
      'Pedrera',
      'Pilas',
      'Pruna',
      'Salteras',
      'San Juan de Aznalfarache',
      'San Nicolás del Puerto',
      'Sanlúcar la Mayor',
      'Santiponce',
      'Tocina',
      'Tomares',
      'Umbrete',
      'Utrera',
      'Valencina de la Concepción',
      'Villamanrique de la Condesa',
      'Villanueva de San Juan',
      'Villanueva del Ariscal',
      'Villanueva del Río y Minas',
      'Villaverde del Río',
      'Écija',
    ],
    'ES-SO': [
      'Abejar',
      'Adradas',
      'Alconaba',
      'Alcubilla de Avellaneda',
      'Alcubilla de las Peñas',
      'Aldealafuente',
      'Aldealices',
      'Aldealpozo',
      'Aldealseñor',
      'Aldehuela de Periáñez',
      'Alentisque',
      'Aliud',
      'Almajano',
      'Almaluez',
      'Almarza',
      'Almazul',
      'Almazán',
      'Almenar de Soria',
      'Alpanseque',
      'Arancón',
      'Arcos de Jalón',
      'Arévalo de la Sierra',
      'Ausejo de la Sierra',
      'Baraona',
      'Barca',
      'Barcones',
      'Bayubas de Abajo',
      'Bayubas de Arriba',
      'Beratón',
      'Berlanga de Duero',
      'Blacos',
      'Bliecos',
      'Borjabad',
      'Borobia',
      'Buberos',
      'Buitrago',
      'Burgo de Osma-Ciudad de Osma',
      'Cabrejas del Campo',
      'Cabrejas del Pinar',
      'Calatañazor',
      'Caltojar',
      'Candilichera',
      'Carabantes',
      'Caracena',
      'Carrascosa de Abajo',
      'Carrascosa de la Sierra',
      'Casarejos',
      'Castilfrío de la Sierra',
      'Castillejo de Robledo',
      'Castilruiz',
      'Cañamaque',
      'Centenera de Andaluz',
      'Cerbón',
      'Cidones',
      'Cigudosa',
      'Cihuela',
      'Ciria',
      'Cirujales del Río',
      'Coscurita',
      'Covaleda',
      'Cubilla',
      'Cubo de la Solana',
      'Cueva de Ágreda',
      'Deza',
      'Duruelo de la Sierra',
      'Dévanos',
      'El Royo',
      'Escobosa de Almazán',
      'Espeja de San Marcelino',
      'Espejón',
      'Estepa de San Juan',
      'Frechilla de Almazán',
      'Fresno de Caracena',
      'Fuentearmegil',
      'Fuentecambrón',
      'Fuentecantos',
      'Fuentelmonge',
      'Fuentelsaz de Soria',
      'Fuentepinilla',
      'Fuentes de Magaña',
      'Fuentestrún',
      'Garray',
      'Golmayo',
      'Gormaz',
      'Gómara',
      'Herrera de Soria',
      'Hinojosa del Campo',
      'La Losilla',
      'La Póveda de Soria',
      'La Riba de Escalote',
      'Langa de Duero',
      'Las Aldehuelas',
      'Liceras',
      'Los Rábanos',
      'Los Villares de Soria',
      'Magaña',
      'Maján',
      'Matalebreras',
      'Matamala de Almazán',
      'Medinaceli',
      'Miño de Medinaceli',
      'Miño de San Esteban',
      'Molinos de Duero',
      'Momblona',
      'Monteagudo de las Vicarías',
      'Montejo de Tiermes',
      'Montenegro de Cameros',
      'Morón de Almazán',
      'Muriel Viejo',
      'Muriel de la Fuente',
      'Nafría de Ucero',
      'Narros',
      'Navaleno',
      'Nepas',
      'Nolay',
      'Noviercas',
      'Oncala',
      'Pinilla del Campo',
      'Portillo de Soria',
      'Pozalmuro',
      'Quintana Redonda',
      'Quintanas de Gormaz',
      'Quiñonería',
      'Rebollar',
      'Recuerda',
      'Rello',
      'Renieblas',
      'Retortillo de Soria',
      'Reznos',
      'Rioseco de Soria',
      'Rollamienta',
      'Salduero',
      'San Esteban de Gormaz',
      'San Felices',
      'San Leonardo de Yagüe',
      'San Pedro Manrique',
      'Santa Cruz de Yanguas',
      'Santa María de Huerta',
      'Santa María de las Hoyas',
      'Serón de Nágima',
      'Soliedra',
      'Soria',
      'Sotillo del Rincón',
      'Suellacabras',
      'Tajahuerce',
      'Tajueco',
      'Talveila',
      'Tardelcuende',
      'Taroda',
      'Torlengua',
      'Torreblacos',
      'Torrubia de Soria',
      'Trévago',
      'Ucero',
      'Vadillo',
      'Valdeavellano de Tera',
      'Valdegeña',
      'Valdelagua del Cerro',
      'Valdemaluque',
      'Valdenebro',
      'Valdeprado',
      'Valderrodilla',
      'Valtajeros',
      'Velamazán',
      'Velilla de la Sierra',
      'Velilla de los Ajos',
      'Viana de Duero',
      'Villaciervos',
      'Villanueva de Gormaz',
      'Villar del Ala',
      'Villar del Campo',
      'Villar del Río',
      'Villasayas',
      'Villaseca de Arciel',
      'Vinuesa',
      'Vizmanos',
      'Vozmediano',
      'Yanguas',
      'Yelo',
      'Ágreda',
      'Ólvega',
    ],
    'ES-T': [
      'Aiguamúrcia',
      'Albinyana',
      'Alcanar',
      'Alcover',
      'Aldover',
      'Alfara de Carles',
      'Alforja',
      'Alió',
      'Almoster',
      'Altafulla',
      'Amposta',
      'Arbolí',
      'Arnes',
      'Ascó',
      'Banyeres del Penedès',
      'Barberà de la Conca',
      'Batea',
      'Bellmunt del Priorat',
      'Bellvei',
      'Benifallet',
      'Benissanet',
      'Blancafort',
      'Bonastre',
      'Botarell',
      'Bràfim',
      'Cabacés',
      'Cabra del Camp',
      'Calafell',
      'Camarles',
      'Cambrils',
      'Capafonts',
      'Capçanes',
      'Caseres',
      'Castellvell del Camp',
      'Colldejou',
      'Constantí',
      "Corbera d'Ebre",
      'Cornudella de Montsant',
      'Creixell',
      'Cunit',
      'Deltebre',
      'Duesaigües',
      'El Catllar',
      'El Lloar',
      'El Masroig',
      'El Milà',
      'El Molar',
      'El Montmell',
      'El Morell',
      'El Perelló',
      'El Pinell de Brai',
      'El Pla de Santa Maria',
      "El Pont d'Armentera",
      'El Vendrell',
      'Els Garidells',
      'Els Guiamets',
      'Els Pallaresos',
      'Falset',
      'Figuerola del Camp',
      'Flix',
      'Forès',
      'Freginals',
      'Gandesa',
      'Ginestar',
      'Godall',
      'Gratallops',
      'Horta de Sant Joan',
      "L'Arboç",
      'La Bisbal de Falset',
      'La Bisbal del Penedès',
      'La Fatarella',
      'La Febró',
      'La Figuera',
      'La Galera',
      'La Masó',
      'La Morera de Montsant',
      'La Nou de Gaià',
      "La Palma d'Ebre",
      'La Pobla de Mafumet',
      'La Pobla de Massaluca',
      'La Pobla de Montornès',
      'La Riba',
      'La Riera de Gaià',
      'La Secuita',
      'La Selva del Camp',
      'La Sénia',
      'La Torre de Fontaubella',
      "La Torre de l'Espanyol",
      'La Vilella Alta',
      'La Vilella Baixa',
      'Les Borges del Camp',
      'Les Piles',
      'Llorac',
      'Llorenç del Penedès',
      'Margalef',
      'Marçà',
      'Mas de Barberans',
      'Masdenverge',
      'Masllorenç',
      'Maspujols',
      'Miravet',
      'Mont-ral',
      'Mont-roig del Camp',
      'Montblanc',
      'Montbrió del Camp',
      'Montferri',
      "Móra d'Ebre",
      'Móra la Nova',
      'Nulles',
      'Passanant i Belltall',
      'Paüls',
      'Perafort',
      'Pira',
      'Poboleda',
      'Pontils',
      'Porrera',
      'Pradell de la Teixeta',
      'Prades',
      'Prat de Comte',
      'Pratdip',
      'Puigpelat',
      'Querol',
      'Rasquera',
      'Renau',
      'Reus',
      "Riba-roja d'Ebre",
      'Riudecanyes',
      'Riudecols',
      'Riudoms',
      'Rocafort de Queralt',
      'Roda de Barà',
      'Rodonyà',
      'Roquetes',
      'Salomó',
      'Salou',
      'Sant Carles de la Ràpita',
      "Sant Jaume d'Enveja",
      'Sant Jaume dels Domenys',
      'Santa Bàrbara',
      'Santa Coloma de Queralt',
      'Santa Oliva',
      'Sarral',
      'Savallà del Comtat',
      'Senan',
      'Solivella',
      'Tarragona',
      'Tivenys',
      'Tivissa',
      'Torredembarra',
      'Torroja del Priorat',
      'Tortosa',
      'Ulldecona',
      'Ulldemolins',
      'Vallclara',
      'Vallfogona de Riucorb',
      'Vallmoll',
      'Valls',
      "Vandellòs i l'Hospitalet de l'Infant",
      'Vespella de Gaià',
      'Vila-rodona',
      'Vila-seca',
      'Vilabella',
      'Vilalba dels Arcs',
      'Vilallonga del Camp',
      "Vilanova d'Escornalbou",
      'Vilanova de Prades',
      'Vilaplana',
      'Vilaverd',
      'Vimbodí i Poblet',
      'Vinebre',
      'Vinyols i els Arcs',
      'Xerta',
    ],
    'ES-TE': [
      'Ababuj',
      'Abejuela',
      'Aguatón',
      'Aguaviva',
      'Aguilar del Alfambra',
      'Alacón',
      'Albalate del Arzobispo',
      'Albarracín',
      'Albentosa',
      'Alcaine',
      'Alcalá de la Selva',
      'Alcañiz',
      'Alcorisa',
      'Alfambra',
      'Aliaga',
      'Allepuz',
      'Alloza',
      'Allueva',
      'Almohaja',
      'Alobras',
      'Alpeñés',
      'Anadón',
      'Andorra (Teruel)',
      'Arcos de las Salinas',
      'Arens de Lledó',
      'Argente',
      'Ariño',
      'Azaila',
      'Barrachina',
      'Bañón',
      'Bea',
      'Beceite',
      'Belmonte de San José',
      'Berge',
      'Bezas',
      'Blancas',
      'Bordón',
      'Bronchales',
      'Bueña',
      'Burbáguena',
      'Bádenas',
      'Báguena',
      'Cabra de Mora',
      'Calaceite',
      'Calamocha',
      'Calanda',
      'Calomarde',
      'Camarena de la Sierra',
      'Camarillas',
      'Camañas',
      'Caminreal',
      'Cantavieja',
      'Cascante del Río',
      'Castejón de Tornos',
      'Castel de Cabra',
      'Castellote',
      'Castelnou',
      'Castelserás',
      'Cañada Vellida',
      'Cañada de Benatanduz',
      'Cañizar del Olivar',
      'Cedrillas',
      'Celadas',
      'Cella',
      'Corbalán',
      'Cosa',
      'Cretas',
      'Crivillén',
      'Cubla',
      'Cucalón',
      'Cuevas Labradas',
      'Cuevas de Almudén',
      'Ejulve',
      'El Castellar',
      'El Pobo',
      'El Vallecillo',
      'Escorihuela',
      'Escucha',
      'Estercuel',
      'Ferreruela de Huerva',
      'Fonfría',
      'Formiche Alto',
      'Fortanete',
      'Foz-Calanda',
      'Frías de Albarracín',
      'Fuenferrada',
      'Fuentes Calientes',
      'Fuentes Claras',
      'Fuentes de Rubielos',
      'Fuentespalda',
      'Fórnoles',
      'Galve',
      'Gea de Albarracín',
      'Guadalaviar',
      'Gúdar',
      'Hinojosa de Jarque',
      'Huesa del Común',
      'Híjar',
      'Jabaloyas',
      'Jarque de la Val',
      'Jatiel',
      'Jorcas',
      'Josa',
      'La Cañada de Verich',
      'La Cerollera',
      'La Codoñera',
      'La Cuba',
      'La Fresneda',
      'La Ginebrosa',
      'La Hoz de la Vieja',
      'La Iglesuela del Cid',
      'La Mata de los Olmos',
      'La Portellada',
      'La Puebla de Híjar',
      'La Puebla de Valverde',
      'La Zoma',
      'Lagueruela',
      'Lanzuela',
      'Las Parras de Castellote',
      'Lidón',
      'Linares de Mora',
      'Lledó',
      'Los Olmos',
      'Loscos',
      'Maicas',
      'Manzanera',
      'Martín del Río',
      'Mas de las Matas',
      'Mazaleón',
      'Mezquita de Jarque',
      'Mirambel',
      'Miravete de la Sierra',
      'Monforte de Moyuela',
      'Monreal del Campo',
      'Monroyo',
      'Montalbán',
      'Monteagudo del Castillo',
      'Monterde de Albarracín',
      'Mora de Rubielos',
      'Moscardón',
      'Mosqueruela',
      'Muniesa',
      'Noguera de Albarracín',
      'Nogueras',
      'Nogueruelas',
      'Obón',
      'Odón',
      'Ojos Negros',
      'Olba',
      'Oliete',
      'Orihuela del Tremedal',
      'Orrios',
      'Palomar de Arroyos',
      'Pancrudo',
      'Peracense',
      'Peralejos',
      'Perales del Alfambra',
      'Peñarroya de Tastavins',
      'Pitarque',
      'Plou',
      'Pozondón',
      'Pozuel del Campo',
      'Puertomingalvo',
      'Rillo',
      'Riodeva',
      'Royuela',
      'Rubielos de Mora',
      'Rubielos de la Cérida',
      'Ráfales',
      'Ródenas',
      'Salcedillo',
      'Saldón',
      'Samper de Calanda',
      'San Martín del Río',
      'Santa Cruz de Nogueras',
      'Sarrión',
      'Segura de los Baños',
      'Seno',
      'Singra',
      'Terriente',
      'Toril y Masegoso',
      'Tormón',
      'Tornos',
      'Torralba de los Sisones',
      'Torre de Arcas',
      'Torre de las Arcas',
      'Torre del Compte',
      'Torre los Negros',
      'Torrecilla de Alcañiz',
      'Torrecilla del Rebollar',
      'Torrelacárcel',
      'Torremocha de Jiloca',
      'Torres de Albarracín',
      'Torrevelilla',
      'Torrijas',
      'Torrijo del Campo',
      'Tramacastiel',
      'Tramacastilla',
      'Tronchón',
      'Urrea de Gaén',
      'Utrillas',
      'Valacloche',
      'Valbona',
      'Valdealgorfa',
      'Valdecuenca',
      'Valdelinares',
      'Valdeltormo',
      'Valderrobres',
      'Valjunquera',
      'Veguillas de la Sierra',
      'Villafranca del Campo',
      'Villahermosa del Campo',
      'Villanueva del Rebollar de la Sierra',
      'Villar del Cobo',
      'Villar del Salz',
      'Villarluengo',
      'Villarquemado',
      'Villarroya de los Pinares',
      'Villastar',
      'Villel',
      'Vinaceite',
      'Visiedo',
      'Vivel del Río Martín',
    ],
    'ES-TO': [
      'Ajofrín',
      'Alameda de la Sagra',
      'Albarreal de Tajo',
      'Alcabón',
      'Alcaudete de la Jara',
      'Alcañizo',
      'Alcolea de Tajo',
      'Aldea en Cabo',
      'Aldeanueva de Barbarroya',
      'Aldeanueva de San Bartolomé',
      'Almendral de la Cañada',
      'Almonacid de Toledo',
      'Almorox',
      'Arcicóllar',
      'Argés',
      'Azután',
      'Añover de Tajo',
      'Barcience',
      'Bargas',
      'Belvís de la Jara',
      'Borox',
      'Burguillos de Toledo',
      'Burujón',
      'Cabañas de Yepes',
      'Cabañas de la Sagra',
      'Cabezamesada',
      'Calera y Chozas',
      'Caleruela',
      'Calzada de Oropesa',
      'Camarena',
      'Camarenilla',
      'Camuñas',
      'Cardiel de los Montes',
      'Carranque',
      'Carriches',
      'Casarrubios del Monte',
      'Casasbuenas',
      'Castillo de Bayuela',
      'Cazalegas',
      'Cedillo del Condado',
      'Cervera de los Montes',
      'Chozas de Canales',
      'Ciruelos',
      'Cobeja',
      'Cobisa',
      'Consuegra',
      'Corral de Almaguer',
      'Cuerva',
      'Domingo Pérez',
      'Dosbarrios',
      'El Campillo de la Jara',
      'El Carpio de Tajo',
      'El Casar de Escalona',
      'El Puente del Arzobispo',
      'El Real de San Vicente',
      'El Romeral',
      'El Toboso',
      'El Viso de San Juan',
      'Erustes',
      'Escalona',
      'Escalonilla',
      'Espinoso del Rey',
      'Esquivias',
      'Fuensalida',
      'Garciotum',
      'Gerindote',
      'Guadamur',
      'Gálvez',
      'Herreruela de Oropesa',
      'Hinojosa de San Vicente',
      'Hontanar',
      'Hormigos',
      'Huecas',
      'Huerta de Valdecarábanos',
      'Illescas',
      'Illán de Vacas',
      'La Iglesuela',
      'La Nava de Ricomalillo',
      'La Puebla de Almoradiel',
      'La Puebla de Montalbán',
      'La Pueblanueva',
      'La Torre de Esteban Hambrán',
      'La Villa de Don Fadrique',
      'Lagartera',
      'Las Herencias',
      'Las Ventas con Peña Aguilera',
      'Las Ventas de Retamosa',
      'Las Ventas de San Julián',
      'Layos',
      'Lillo',
      'Lominchar',
      'Los Cerralbos',
      'Los Navalmorales',
      'Los Navalucillos',
      'Los Yébenes',
      'Lucillos',
      'Madridejos',
      'Magán',
      'Malpica de Tajo',
      'Manzaneque',
      'Marjaliza',
      'Marrupe',
      'Mascaraque',
      'Mazarambroz',
      'Mejorada',
      'Menasalbas',
      'Mesegar de Tajo',
      'Miguel Esteban',
      'Mocejón',
      'Mohedas de la Jara',
      'Montearagón',
      'Montesclaros',
      'Méntrida',
      'Nambroca',
      'Navahermosa',
      'Navalcán',
      'Navalmoralejo',
      'Navamorcuende',
      'Noblejas',
      'Noez',
      'Nombela',
      'Novés',
      'Numancia de la Sagra',
      'Nuño Gómez',
      'Olías del Rey',
      'Ontígola',
      'Orgaz',
      'Oropesa',
      'Otero',
      'Palomeque',
      'Pantoja',
      'Paredes de Escalona',
      'Parrillas',
      'Pelahustán',
      'Polán',
      'Portillo de Toledo',
      'Puerto de San Vicente',
      'Quintanar de la Orden',
      'Quismondo',
      'Recas',
      'Retamoso de la Jara',
      'Rielves',
      'Robledo del Mazo',
      'San Bartolomé de las Abiertas',
      'San Martín de Montalbán',
      'San Martín de Pusa',
      'San Pablo de los Montes',
      'San Román de los Montes',
      'Santa Ana de Pusa',
      'Santa Cruz de la Zarza',
      'Santa Cruz del Retamar',
      'Santa Olalla',
      'Santo Domingo-Caudilla',
      'Sartajada',
      'Segurilla',
      'Sevilleja de la Jara',
      'Sonseca',
      'Sotillo de las Palomas',
      'Talavera de la Reina',
      'Tembleque',
      'Torralba de Oropesa',
      'Torrecilla de la Jara',
      'Torrico',
      'Torrijos',
      'Totanés',
      'Turleque',
      'Ugena',
      'Urda',
      'Valdeverdeja',
      'Valmojado',
      'Velada',
      'Villacañas',
      'Villafranca de los Caballeros',
      'Villaluenga de la Sagra',
      'Villamiel de Toledo',
      'Villaminaya',
      'Villamuelas',
      'Villanueva de Alcardete',
      'Villanueva de Bogas',
      'Villarejo de Montalbán',
      'Villarrubia de Santiago',
      'Villaseca de la Sagra',
      'Villasequilla',
      'Villatobas',
      'Yeles',
      'Yepes',
      'Yuncler',
      'Yunclillos',
      'Yuncos',
    ],
    'ES-V': [
      'Ademuz',
      'Ador',
      'Agullent',
      'Aielo de Malferit',
      'Aielo de Rugat',
      'Alaquàs',
      'Albaida',
      'Albal',
      'Albalat de la Ribera',
      'Albalat dels Sorells',
      'Albalat dels Tarongers',
      'Alberic',
      'Alborache',
      'Alboraia',
      'Albuixech',
      'Alcublas',
      'Alcàntera de Xúquer',
      'Alcàsser',
      'Aldaia',
      'Alfafar',
      'Alfara de la Baronia',
      'Alfara del Patriarca',
      'Alfarp',
      'Alfarrasí',
      'Alfauir',
      'Algar de Palancia',
      'Algemesí',
      'Algimia de Alfara',
      'Alginet',
      'Almiserà',
      'Almoines',
      'Almussafes',
      'Almàssera',
      'Alpuente',
      'Alzira',
      'Andilla',
      'Anna',
      'Antella',
      'Aras de los Olmos',
      "Atzeneta d'Albaida",
      'Ayora',
      'Barx',
      'Barxeta',
      'Bellreguard',
      'Bellús',
      'Benaguasil',
      'Benagéber',
      'Benavites',
      'Beneixida',
      'Benetússer',
      'Beniarjó',
      'Beniatjar',
      'Benicolet',
      'Benicull de Xúquer',
      'Benifairó de la Valldigna',
      'Benifairó de les Valls',
      'Benifaió',
      'Beniflá',
      'Benigànim',
      'Benimodo',
      'Benimuslem',
      'Beniparrell',
      'Benirredrà',
      'Benisanó',
      'Benissoda',
      'Benisuera',
      'Bicorp',
      'Bocairent',
      'Bolbaite',
      'Bonrepòs i Mirambell',
      'Bufali',
      'Bugarra',
      'Burjassot',
      'Buñol',
      'Bèlgida',
      'Bétera',
      'Calles',
      'Calpe',
      'Camporrobles',
      'Canals',
      "Canet d'En Berenguer",
      'Carcaixent',
      'Carlet',
      'Carrícola',
      'Casas Altas',
      'Casas Bajas',
      'Casinos',
      'Castellonet de la Conquesta',
      'Castelló de Rugat',
      'Castielfabib',
      'Catadau',
      'Catarroja',
      'Caudete de las Fuentes',
      'Cerdà',
      'Chella',
      'Chelva',
      'Chera',
      'Cheste',
      'Chiva',
      'Chulilla',
      'Cofrentes',
      'Corbera',
      'Cortes de Pallás',
      'Cotes',
      'Cullera',
      'Càrcer',
      'Daimús',
      'Domeño',
      'Dos Aguas',
      'Enguera',
      'Estivella',
      'Estubeny',
      'Faura',
      'Foios',
      'Fontanars dels Alforins',
      'Fortaleny',
      'Fuenterrobles',
      'Gavarda',
      'Genovés',
      'Gestalgar',
      'Gilet',
      'Godella',
      'Godelleta',
      'Guadasequies',
      'Guadassuar',
      'Guardamar de la Safor',
      'Gátova',
      'Higueruelas',
      'Jalance',
      'Jarafuel',
      "L'Eliana",
      "La Font d'En Carròs",
      'La Font de la Figuera',
      'La Granja de la Costera',
      'La Llosa de Ranes',
      'La Pobla Llarga',
      'La Pobla de Farnals',
      'La Pobla de Vallbona',
      'La Pobla del Duc',
      'La Yesa',
      'Llanera de Ranes',
      'Llaurí',
      "Llocnou d'En Fenollet",
      'Llocnou de Sant Jeroni',
      'Llocnou de la Corona',
      'Llombai',
      'Llutxent',
      'Llíria',
      'Loriguilla',
      'Losa del Obispo',
      'Macastre',
      'Manises',
      'Manuel',
      'Marines',
      'Massalavés',
      'Massalfassar',
      'Massamagrell',
      'Massanassa',
      'Meliana',
      'Millares',
      'Mislata',
      'Moncada',
      'Montaverner',
      'Montesa',
      'Montroy',
      'Montserrat',
      'Museros',
      'Navarrés',
      'Náquera',
      'Olocau',
      'Ontinyent',
      'Otos',
      'Paiporta',
      'Palma de Gandía',
      'Paterna',
      'Pedralba',
      'Petrés',
      'Picanya',
      'Picassent',
      'Piles',
      'Pinet',
      'Polinyà de Xúquer',
      'Potríes',
      'Puebla de San Miguel',
      'Puçol',
      'Quart de Poblet',
      'Quart de les Valls',
      'Quartell',
      'Quatretonda',
      'Quesa',
      'Rafelcofer',
      'Rafelguaraf',
      'Real',
      'Real de Gandía',
      'Riba-roja de Túria',
      'Riola',
      'Rocafort',
      'Rotglà i Corberà',
      'Rugat',
      'Ráfol de Salem',
      'Rótova',
      'Sagunto',
      'San Antonio de Benagéber',
      'Sant Joanet',
      'Sedaví',
      'Segart',
      'Sellent',
      'Sempere',
      'Senyera',
      'Siete Aguas',
      'Silla',
      'Simat de la Valldigna',
      'Sinarcas',
      'Sollana',
      'Sot de Chera',
      'Sueca',
      'Sumacàrcer',
      'Tavernes Blanques',
      'Tavernes de la Valldigna',
      'Teresa de Cofrentes',
      'Terrateig',
      'Titaguas',
      'Torrebaja',
      'Torrella',
      'Torrent',
      'Torres Torres',
      'Tous',
      'Turís',
      'Tuéjar',
      'Utiel',
      'Vallada',
      'Vallanca',
      'Vallés',
      'Venta del Moro',
      'Vilamarxant',
      'Villalonga',
      'Villanueva de Castellón',
      'Villar del Arzobispo',
      'Villargordo del Cabriel',
      'Vinalesa',
      'Xeraco',
      'Xeresa',
      'Xirivella',
      'Xàtiva',
      'Yátova',
      'Zarra',
    ],
    'ES-VA': [
      'Adalia',
      'Aguasal',
      'Aguilar de Campos',
      'Alaejos',
      'Alcazarén',
      'Aldea de San Miguel',
      'Aldeamayor de San Martín',
      'Almenara de Adaja',
      'Amusquillo',
      'Arroyo de la Encomienda',
      'Ataquines',
      'Bahabón',
      'Barcial de la Loma',
      'Barruelo del Valle',
      'Becilla de Valderaduey',
      'Benafarces',
      'Bercero',
      'Berceruelo',
      'Berrueces',
      'Bobadilla del Campo',
      'Bocigas',
      'Bocos de Duero',
      'Boecillo',
      'Bolaños de Campos',
      'Brahojos de Medina',
      'Bustillo de Chaves',
      'Cabezón de Pisuerga',
      'Cabezón de Valderaduey',
      'Cabreros del Monte',
      'Campaspero',
      'Camporredondo',
      'Canalejas de Peñafiel',
      'Canillas de Esgueva',
      'Carpio',
      'Casasola de Arión',
      'Castrejón de Trabancos',
      'Castrillo de Duero',
      'Castrillo-Tejeriego',
      'Castrobol',
      'Castrodeza',
      'Castromembibre',
      'Castromonte',
      'Castronuevo de Esgueva',
      'Castronuño',
      'Castroponce',
      'Castroverde de Cerrato',
      'Ceinos de Campos',
      'Cervillego de la Cruz',
      'Cigales',
      'Ciguñuela',
      'Cistérniga',
      'Cogeces de Íscar',
      'Cogeces del Monte',
      'Corcos',
      'Corrales de Duero',
      'Cubillas de Santa Marta',
      'Cuenca de Campos',
      'Curiel de Duero',
      'Encinas de Esgueva',
      'Esguevillas de Esgueva',
      'Fombellida',
      'Fompedraza',
      'Fontihoyuelo',
      'Fresno el Viejo',
      'Fuensaldaña',
      'Fuente el Sol',
      'Fuente-Olmedo',
      'Gallegos de Hornija',
      'Gatón de Campos',
      'Geria',
      'Herrín de Campos',
      'Hornillos de Eresma',
      'La Cistérniga',
      'La Mudarra',
      'La Parrilla',
      'La Pedraja de Portillo',
      'La Seca',
      'La Unión de Campos',
      'La Zarza',
      'Laguna de Duero',
      'Langayo',
      'Llano de Olmedo',
      'Lomoviejo',
      'Marzales',
      'Matapozuelos',
      'Matilla de los Caños',
      'Mayorga',
      'Medina de Rioseco',
      'Medina del Campo',
      'Megeces',
      'Melgar de Abajo',
      'Melgar de Arriba',
      'Mojados',
      'Monasterio de Vega',
      'Montealegre de Campos',
      'Montemayor de Pililla',
      'Moral de la Reina',
      'Moraleja de las Panaderas',
      'Morales de Campos',
      'Mota del Marqués',
      'Mucientes',
      'Muriel',
      'Nava del Rey',
      'Nueva Villa de las Torres',
      'Olivares de Duero',
      'Olmos de Esgueva',
      'Olmos de Peñafiel',
      'Palazuelo de Vedija',
      'Pedrajas de San Esteban',
      'Pedrosa del Rey',
      'Pesquera de Duero',
      'Peñafiel',
      'Peñaflor de Hornija',
      'Piña de Esgueva',
      'Piñel de Abajo',
      'Piñel de Arriba',
      'Pollos',
      'Portillo',
      'Pozal de Gallinas',
      'Pozaldez',
      'Pozuelo de la Orden',
      'Puras',
      'Quintanilla de Arriba',
      'Quintanilla de Onésimo',
      'Quintanilla de Trigueros',
      'Quintanilla del Molar',
      'Ramiro',
      'Renedo de Esgueva',
      'Roales de Campos',
      'Robladillo',
      'Roturas',
      'Rubí de Bracamonte',
      'Rueda',
      'Saelices de Mayorga',
      'Salvador de Zapardiel',
      'San Cebrián de Mazote',
      'San Llorente',
      'San Martín de Valvení',
      'San Miguel del Arroyo',
      'San Miguel del Pino',
      'San Pablo de la Moraleja',
      'San Pedro de Latarce',
      'San Román de Hornija',
      'San Vicente del Palacio',
      'Santa Eufemia del Arroyo',
      'Santervás de Campos',
      'Santibáñez de Valcorba',
      'Santovenia de Pisuerga',
      'Sardón de Duero',
      'Serrada',
      'Siete Iglesias de Trabancos',
      'Simancas',
      'Tamariz de Campos',
      'Tiedra',
      'Tordehumos',
      'Tordesillas',
      'Torre de Esgueva',
      'Torre de Peñafiel',
      'Torrecilla de la Abadesa',
      'Torrecilla de la Orden',
      'Torrecilla de la Torre',
      'Torrelobatón',
      'Torrescárcela',
      'Traspinedo',
      'Trigueros del Valle',
      'Tudela de Duero',
      'Urones de Castroponce',
      'Urueña',
      'Valbuena de Duero',
      'Valdearcos de la Vega',
      'Valdenebro de los Valles',
      'Valdestillas',
      'Valdunquillo',
      'Valoria la Buena',
      'Valverde de Campos',
      'Vega de Ruiponce',
      'Vega de Valdetronco',
      'Velascálvaro',
      'Velilla',
      'Velliza',
      'Ventosa de la Cuesta',
      'Viana de Cega',
      'Villabaruz de Campos',
      'Villabrágima',
      'Villabáñez',
      'Villacarralón',
      'Villacid de Campos',
      'Villaco',
      'Villafrades de Campos',
      'Villafranca de Duero',
      'Villafrechós',
      'Villafuerte',
      'Villagarcía de Campos',
      'Villagómez la Nueva',
      'Villalar de los Comuneros',
      'Villalba de la Loma',
      'Villalba de los Alcores',
      'Villalbarba',
      'Villalán de Campos',
      'Villalón de Campos',
      'Villamuriel de Campos',
      'Villanubla',
      'Villanueva de Duero',
      'Villanueva de San Mancio',
      'Villanueva de la Condesa',
      'Villanueva de los Caballeros',
      'Villanueva de los Infantes',
      'Villardefrades',
      'Villarmentero de Esgueva',
      'Villasexmir',
      'Villavaquerín',
      'Villavellid',
      'Villaverde de Medina',
      'Villavicencio de los Caballeros',
      'Villán de Tordesillas',
      'Viloria',
      'Zaratán',
      'Íscar',
    ],
    'ES-ZA': [
      'Abezames',
      'Alcañices',
      'Alcubilla de Nogales',
      'Alfaraz de Sayago',
      'Algodre',
      'Almaraz de Duero',
      'Almeida de Sayago',
      'Andavías',
      'Arcenillas',
      'Arcos de la Polvorosa',
      'Argañín',
      'Argujillo',
      'Arquillinos',
      'Arrabalde',
      'Aspariegos',
      'Ayoó de Vidriales',
      'Barcial del Barco',
      'Belver de los Montes',
      'Benegiles',
      'Bermillo de Sayago',
      'Bretocino',
      'Bretó',
      'Brime de Sog',
      'Brime de Urz',
      'Burganes de Valverde',
      'Bustillo del Oro',
      'Cabañas de Sayago',
      'Calzadilla de Tera',
      'Camarzana de Tera',
      'Carbajales de Alba',
      'Carbellino',
      'Casaseca de Campeán',
      'Casaseca de las Chanas',
      'Castrillo de la Guareña',
      'Castrogonzalo',
      'Castronuevo',
      'Castroverde de Campos',
      'Cazurra',
      'Cañizal',
      'Cañizo',
      'Cerecinos de Campos',
      'Cerecinos del Carrizal',
      'Cernadilla',
      'Cobreros',
      'Coomonte',
      'Coreses',
      'Corrales del Vino',
      'Cotanes del Monte',
      'Cubillos',
      'Cubo de Benavente',
      'Cuelgamures',
      'El Cubo de Tierra del Vino',
      'El Maderal',
      'El Pego',
      'El Perdigón',
      'El Piñero',
      'Entrala',
      'Espadañedo',
      'Faramontanos de Tábara',
      'Fariza',
      'Fermoselle',
      'Ferreras de Abajo',
      'Ferreras de Arriba',
      'Ferreruela',
      'Figueruela de Arriba',
      'Fresno de Sayago',
      'Fresno de la Polvorosa',
      'Fresno de la Ribera',
      'Friera de Valverde',
      'Fuente Encalada',
      'Fuentelapeña',
      'Fuentes de Ropel',
      'Fuentesaúco',
      'Fuentesecas',
      'Fuentespreadas',
      'Galende',
      'Gallegos del Pan',
      'Gallegos del Río',
      'Gamones',
      'Gema',
      'Granja de Moreruela',
      'Granucillo',
      'Guarrate',
      'Hermisende',
      'Jambrina',
      'Justel',
      'La Bóveda de Toro',
      'La Hiniesta',
      'La Torre del Valle',
      'Losacino',
      'Losacio',
      'Lubián',
      'Luelmo',
      'Madridanos',
      'Mahide',
      'Maire de Castroponce',
      'Malva',
      'Manganeses de la Lampreana',
      'Manganeses de la Polvorosa',
      'Manzanal de Arriba',
      'Manzanal de los Infantes',
      'Manzanal del Barco',
      'Matilla de Arzón',
      'Matilla la Seca',
      'Mayalde',
      'Melgar de Tera',
      'Micereces de Tera',
      'Milles de la Polvorosa',
      'Molacillos',
      'Molezuelas de la Carballeda',
      'Mombuey',
      'Monfarracinos',
      'Moral de Sayago',
      'Moraleja de Sayago',
      'Moraleja del Vino',
      'Morales de Rey',
      'Morales de Toro',
      'Morales de Valverde',
      'Morales del Vino',
      'Moralina',
      'Moreruela de Tábara',
      'Moreruela de los Infanzones',
      'Muelas de los Caballeros',
      'Muelas del Pan',
      'Muga de Sayago',
      'Navianos de Valverde',
      'Olmillos de Castro',
      'Otero de Bodas',
      'Pajares de la Lampreana',
      'Palacios de Sanabria',
      'Palacios del Pan',
      'Pedralba de la Pradería',
      'Peleagonzalo',
      'Peleas de Abajo',
      'Pereruela',
      'Perilla de Castro',
      'Peñausende',
      'Piedrahita de Castro',
      'Pinilla de Toro',
      'Pino del Oro',
      'Pobladura de Valderaduey',
      'Pobladura del Valle',
      'Pozoantiguo',
      'Pozuelo de Tábara',
      'Puebla de Sanabria',
      'Pueblica de Valverde',
      'Pías',
      'Quintanilla de Urz',
      'Quintanilla del Monte',
      'Quintanilla del Olmo',
      'Quiruelas de Vidriales',
      'Requejo',
      'Revellinos',
      'Riofrío de Aliste',
      'Rionegro del Puente',
      'Roales',
      'Robleda-Cervantes',
      'Roelos de Sayago',
      'Rosinos de la Requejada',
      'Rábano de Aliste',
      'Salce',
      'Samir de los Caños',
      'San Agustín del Pozo',
      'San Cebrián de Castro',
      'San Cristóbal de Entreviñas',
      'San Esteban del Molar',
      'San Martín de Valderaduey',
      'San Miguel de la Ribera',
      'San Miguel del Valle',
      'San Pedro de Ceque',
      'San Pedro de la Nave-Almendra',
      'San Vicente de la Cabeza',
      'San Vitero',
      'Santa Clara de Avedillo',
      'Santa Colomba de las Monjas',
      'Santa Cristina de la Polvorosa',
      'Santa Croya de Tera',
      'Santa Eufemia del Barco',
      'Santa María de Valverde',
      'Santa María de la Vega',
      'Santibáñez de Tera',
      'Santibáñez de Vidriales',
      'Santovenia',
      'Sanzoles',
      'Tapioles',
      'Torregamones',
      'Torres del Carrizal',
      'Trabazos',
      'Trefacio',
      'Tábara',
      'Uña de Quintana',
      'Vadillo de la Guareña',
      'Valcabado',
      'Valdefinjas',
      'Valdescorriel',
      'Vallesa de la Guareña',
      'Vega de Tera',
      'Vega de Villalobos',
      'Vegalatrave',
      'Venialbo',
      'Vezdemarbán',
      'Vidayanes',
      'Videmala',
      'Villabrázaro',
      'Villabuena del Puente',
      'Villadepera',
      'Villaferrueña',
      'Villafáfila',
      'Villageriz',
      'Villalazán',
      'Villalba de la Lampreana',
      'Villalcampo',
      'Villalobos',
      'Villalonso',
      'Villalpando',
      'Villalube',
      'Villamayor de Campos',
      'Villamor de los Escuderos',
      'Villanueva de Azoague',
      'Villanueva de Campeán',
      'Villanueva de las Peras',
      'Villanueva del Campo',
      'Villanázar',
      'Villar de Fallaves',
      'Villar del Buey',
      'Villaralbo',
      'Villardeciervos',
      'Villardiegua de la Ribera',
      'Villardondiego',
      'Villarrín de Campos',
      'Villaseco del Pan',
      'Villavendimio',
      'Villaveza de Valverde',
      'Villaveza del Agua',
      'Villárdiga',
      'Viñas',
    ],
    'ES-Z': [
      'Abanto',
      'Acered',
      'Aguarón',
      'Aguilón',
      'Agón',
      'Ainzón',
      'Aladrén',
      'Alagón',
      'Alarba',
      'Alberite de San Juan',
      'Albeta',
      'Alborge',
      'Alcalá de Ebro',
      'Alcalá de Moncayo',
      'Alconchel de Ariza',
      'Aldehuela de Liestos',
      'Alfajarín',
      'Alfamén',
      'Alforque',
      'Alhama de Aragón',
      'Almochuel',
      'Almonacid de la Cuba',
      'Almonacid de la Sierra',
      'Alpartir',
      'Ambel',
      'Anento',
      'Aniñón',
      'Aranda de Moncayo',
      'Ardisa',
      'Ariza',
      'Artieda',
      'Arándiga',
      'Asín',
      'Ateca',
      'Azuara',
      'Añón de Moncayo',
      'Badules',
      'Bagüés',
      'Balconchán',
      'Bardallur',
      'Belchite',
      'Belmonte de Gracián',
      'Berdejo',
      'Berrueco',
      'Biel',
      'Bijuesca',
      'Biota',
      'Bisimbre',
      'Boquiñeni',
      'Bordalba',
      'Botorrita',
      'Brea de Aragón',
      'Bubierca',
      'Bujaraloz',
      'Bulbuente',
      'Bureta',
      'Bárboles',
      'Cabañas de Ebro',
      'Cabolafuente',
      'Cadrete',
      'Calatayud',
      'Calatorao',
      'Calcena',
      'Calmarza',
      'Campillo de Aragón',
      'Carenas',
      'Cariñena',
      'Caspe',
      'Castejón de Alarba',
      'Castejón de Valdejasa',
      'Castejón de las Armas',
      'Castiliscar',
      'Cervera de la Cañada',
      'Cerveruela',
      'Cetina',
      'Chiprana',
      'Chodes',
      'Cimballa',
      'Cinco Olivas',
      'Clarés de Ribota',
      'Codos',
      'Contamina',
      'Cosuenda',
      'Cuarte de Huerva',
      'Cubel',
      'Daroca',
      'El Burgo de Ebro',
      'El Buste',
      'El Frago',
      'El Frasno',
      'Embid de Ariza',
      'Encinacorba',
      'Erla',
      'Escatrón',
      'Exeya',
      'Fabara',
      'Farlete',
      'Fayón',
      'Figueruelas',
      'Fombuena',
      'Fréscano',
      'Fuendejalón',
      'Fuendetodos',
      'Fuentes de Ebro',
      'Fuentes de Jiloca',
      'Gallocanta',
      'Gallur',
      'Gelsa',
      'Godojos',
      'Gotor',
      'Grisel',
      'Grisén',
      'Herrera de los Navarros',
      'Ibdes',
      'Illueca',
      'Isuerre',
      'Jaraba',
      'Jarque',
      'Jaulín',
      'La Almolda',
      'La Almunia de Doña Godina',
      'La Joyosa',
      'La Muela',
      'La Puebla de Alfindén',
      'La Vilueña',
      'La Zaida',
      'Lacasta',
      'Lagata',
      'Langa del Castillo',
      'Las Cuerlas',
      'Las Pedrosas',
      'Layana',
      'Lechón',
      'Leciñena',
      'Letux',
      'Litago',
      'Lituénigo',
      'Lobera de Onsella',
      'Longares',
      'Longás',
      'Los Fayos',
      'Los Pintanos',
      'Lucena de Jalón',
      'Luceni',
      'Luesia',
      'Luesma',
      'Lumpiaque',
      'Luna',
      'Lécera',
      'Maella',
      'Magallón',
      'Mainar',
      'Malanquilla',
      'Maleján',
      'Mallén',
      'Maluenda',
      'Malón',
      'Manchones',
      'Marracos',
      'María de Huerva',
      'Mediana de Aragón',
      'Mequinenza',
      'Mesones de Isuela',
      'Mezalocha',
      'Mianos',
      'Miedes de Aragón',
      'Monegrillo',
      'Moneva',
      'Monreal de Ariza',
      'Monterde',
      'Montón',
      'Morata de Jalón',
      'Morata de Jiloca',
      'Moros',
      'Morés',
      'Moyuela',
      'Mozota',
      'Muel',
      'Munébrega',
      'Murero',
      'Murillo de Gállego',
      'Navardún',
      'Nigüella',
      'Nombrevilla',
      'Nonaspe',
      'Novallas',
      'Novillas',
      'Nuez de Ebro',
      'Nuévalos',
      'Olvés',
      'Orcajo',
      'Orera',
      'Orés',
      'Oseja',
      'Osera de Ebro',
      'Paniza',
      'Paracuellos de Jiloca',
      'Paracuellos de la Ribera',
      'Pastriz',
      'Pedrola',
      'Perdiguera',
      'Piedratajada',
      'Pina de Ebro',
      'Pinseque',
      'Plasencia de Jalón',
      'Pleitas',
      'Plenas',
      'Pomer',
      'Pozuel de Ariza',
      'Pozuelo de Aragón',
      'Pradilla de Ebro',
      'Puebla de Albortón',
      'Puendeluna',
      'Purujosa',
      'Quinto',
      'Remolinos',
      'Retascón',
      'Ricla',
      'Romanos',
      'Rueda de Jalón',
      'Ruesca',
      'Sabiñán',
      'Salillas de Jalón',
      'Salvatierra de Esca',
      'Samper del Salz',
      'San Martín de la Virgen de Moncayo',
      'San Mateo de Gállego',
      'Santa Cruz de Grío',
      'Santa Cruz de Moncayo',
      'Santa Eulalia de Gállego',
      'Santed',
      'Sediles',
      'Sestrica',
      'Sierra de Luna',
      'Sigüés',
      'Sisamón',
      'Sobradiel',
      'Sos del Rey Católico',
      'Sádaba',
      'Sástago',
      'Tabuenca',
      'Talamantes',
      'Tarazona',
      'Tauste',
      'Terrer',
      'Tierga',
      'Tobed',
      'Torralba de Ribota',
      'Torralba de los Frailes',
      'Torralbilla',
      'Torrehermosa',
      'Torrelapaja',
      'Torrellas',
      'Torres de Berrellén',
      'Torrijo de la Cañada',
      'Tosos',
      'Trasmoz',
      'Trasobares',
      'Uncastillo',
      'Undués de Lerda',
      'Urrea de Jalón',
      'Urriés',
      'Used',
      'Utebo',
      'Val de San Martín',
      'Valdehorna',
      'Valmadrid',
      'Valpalmas',
      'Valtorres',
      'Velilla de Ebro',
      'Velilla de Jiloca',
      'Vera de Moncayo',
      'Vierlas',
      'Villadoz',
      'Villafeliche',
      'Villafranca de Ebro',
      'Villalba de Perejil',
      'Villalengua',
      'Villamayor de Gállego',
      'Villanueva de Gállego',
      'Villanueva de Huerva',
      'Villanueva de Jiloca',
      'Villar de los Navarros',
      'Villarreal de Huerva',
      'Villarroya de la Sierra',
      'Villarroya del Campo',
      'Zuera',
      'Épila',
    ],
    'ES-VI': [
      'Amurrio',
      'Aramaio',
      'Armiñón',
      'Arraia-Maeztu',
      'Arrazua-Ubarrundia',
      'Artziniega',
      'Asparrena',
      'Ayala/Aiara',
      'Añana',
      'Barrundia',
      'Baños de Ebro/Mañueta',
      'Berantevilla',
      'Bernedo',
      'Campezo/Kanpezu',
      'Elburgo/Burgelu',
      'Elciego',
      'Elvillar/Bilar',
      'Harana/Valle de Arana',
      'Iruraiz-Gauna',
      'Iruña Oka/Iruña de Oca',
      'Kripan',
      'Kuartango',
      'Labastida/Bastida',
      'Lagrán',
      'Laguardia',
      'Lanciego/Lantziego',
      'Lantarón',
      'Lapuebla de Labarca',
      'Laudio/Llodio',
      'Legutio',
      'Navaridas',
      'Okondo',
      'Oyón-Oion',
      'Peñacerrada-Urizaharra',
      'Ribera Baja/Erribera Beitia',
      'Salvatierra/Agurain',
      'San Millán/Donemiliaga',
      'Urkabustaiz',
      'Valdegovía/Gaubea',
      'Villabuena de Álava/Eskuernaga',
      'Vitoria-Gasteiz',
      'Yécora/Iekora',
      'Zalduondo',
      'Zambrana',
      'Zigoitia',
      'Zuia',
    ],
    'ES-AV': [
      'Adanero',
      'Albornos',
      'Aldeanueva de Santa Cruz',
      'Aldeaseca',
      'Amavida',
      'Arevalillo',
      'Arévalo',
      'Aveinte',
      'Barromán',
      'Becedas',
      'Becedillas',
      'Bercial de Zapardiel',
      'Bernuy-Zapardiel',
      'Berrocalejo de Aragona',
      'Blascomillán',
      'Blasconuño de Matacabras',
      'Blascosancho',
      'Bohoyo',
      'Bonilla de la Sierra',
      'Brabos',
      'Bularros',
      'Burgohondo',
      'Cabezas de Alambre',
      'Cabezas del Pozo',
      'Cabezas del Villar',
      'Cabizuela',
      'Canales',
      'Candeleda',
      'Cantiveros',
      'Cardeñosa',
      'Casas del Puerto',
      'Casasola',
      'Casavieja',
      'Castellanos de Zapardiel',
      'Cebreros',
      'Cepeda la Mora',
      'Cillán',
      'Cisla',
      'Collado de Contreras',
      'Collado del Mirón',
      'Constanzana',
      'Crespos',
      'Cuevas del Valle',
      'Diego del Carpio',
      'Donjimeno',
      'Donvidas',
      'El Barco de Ávila',
      'El Barraco',
      'El Bohodón',
      'El Fresno',
      'El Hornillo',
      'El Hoyo de Pinares',
      'El Losar del Barco',
      'El Mirón',
      'El Parral',
      'El Tiemblo',
      'Espinosa de los Caballeros',
      'Flores de Ávila',
      'Fontiveros',
      'Fresnedilla',
      'Fuente el Saúz',
      'Fuentes de Año',
      'Gallegos de Altamiros',
      'Gallegos de Sobrinos',
      'Garganta del Villar',
      'Gavilanes',
      'Gemuño',
      'Gil García',
      'Gilbuena',
      'Gimialcón',
      'Gotarrendura',
      'Grandes y San Martín',
      'Guisando',
      'Gutierre-Muñoz',
      'Hernansancho',
      'Herradón de Pinares',
      'Herreros de Suso',
      'Higuera de las Dueñas',
      'Horcajo de las Torres',
      'Hoyocasero',
      'Hoyorredondo',
      'Hoyos de Miguel Muñoz',
      'Hoyos del Collado',
      'Hoyos del Espino',
      'Hurtumpascual',
      'Junciana',
      'La Adrada',
      'La Aldehuela',
      'La Carrera',
      'La Colilla',
      'La Hija de Dios',
      'La Horcajada',
      'La Serrada',
      'La Torre',
      'Langa',
      'Lanzahíta',
      'Las Berlanas',
      'Las Navas del Marqués',
      'Los Llanos de Tormes',
      'Madrigal de las Altas Torres',
      'Maello',
      'Malpartida de Corneja',
      'Mamblas',
      'Mancera de Arriba',
      'Manjabálago',
      'Marlín',
      'Martiherrero',
      'Martínez',
      'Mediana de Voltoya',
      'Medinilla',
      'Mengamuñoz',
      'Mesegar de Corneja',
      'Mijares',
      'Mingorría',
      'Mironcillo',
      'Mirueña de los Infanzones',
      'Mombeltrán',
      'Monsalupe',
      'Moraleja de Matacabras',
      'Muñana',
      'Muñico',
      'Muñogalindo',
      'Muñogrande',
      'Muñomer del Peco',
      'Muñopepe',
      'Muñosancho',
      'Muñotello',
      'Narrillos del Rebollar',
      'Narrillos del Álamo',
      'Narros de Saldueña',
      'Narros del Castillo',
      'Narros del Puerto',
      'Nava de Arévalo',
      'Nava del Barco',
      'Navacepedilla de Corneja',
      'Navadijos',
      'Navaescurial',
      'Navahondilla',
      'Navalacruz',
      'Navalonguilla',
      'Navalosa',
      'Navalperal de Pinares',
      'Navalperal de Tormes',
      'Navaluenga',
      'Navaquesera',
      'Navarredonda de Gredos',
      'Navarredondilla',
      'Navarrevisca',
      'Navatalgordo',
      'Navatejares',
      'Neila de San Miguel',
      'Niharra',
      'Ojos-Albos',
      'Orbita',
      'Padiernos',
      'Pajares de Adaja',
      'Palacios de Goda',
      'Papatrigo',
      'Pascualcobo',
      'Pedro Bernardo',
      'Pedro-Rodríguez',
      'Peguerinos',
      'Peñalba de Ávila',
      'Piedrahíta',
      'Piedralaves',
      'Poveda',
      'Poyales del Hoyo',
      'Pozanco',
      'Pradosegar',
      'Puerto Castilla',
      'Rasueros',
      'Riocabado',
      'Riofrío',
      'Rivilla de Barajas',
      'Salobral',
      'Salvadiós',
      'San Bartolomé de Béjar',
      'San Bartolomé de Corneja',
      'San Bartolomé de Pinares',
      'San Esteban de Zapardiel',
      'San Esteban de los Patos',
      'San Esteban del Valle',
      'San García de Ingelmos',
      'San Juan de Gredos',
      'San Juan de la Encinilla',
      'San Juan de la Nava',
      'San Juan del Molinillo',
      'San Juan del Olmo',
      'San Lorenzo de Tormes',
      'San Martín de la Vega del Alberche',
      'San Martín del Pimpollar',
      'San Miguel de Corneja',
      'San Miguel de Serrezuela',
      'San Pascual',
      'San Pedro del Arroyo',
      'San Vicente de Arévalo',
      'Sanchidrián',
      'Sanchorreja',
      'Santa Cruz de Pinares',
      'Santa Cruz del Valle',
      'Santa María de los Caballeros',
      'Santa María del Arroyo',
      'Santa María del Berrocal',
      'Santa María del Cubillo',
      'Santa María del Tiétar',
      'Santiago del Collado',
      'Santiago del Tormes',
      'Santo Domingo de las Posadas',
      'Santo Tomé de Zabarcos',
      'Serranillos',
      'Sigeres',
      'Sinlabajos',
      'Solana de Rioalmar',
      'Solana de Ávila',
      'Solosancho',
      'Sotalbo',
      'Sotillo de la Adrada',
      'Tiñosillos',
      'Tolbaños',
      'Tormellas',
      'Tornadizos de Ávila',
      'Tórtoles',
      'Umbrías',
      'Vadillo de la Sierra',
      'Valdecasa',
      'Vega de Santa María',
      'Velayos',
      'Villaflor',
      'Villafranca de la Sierra',
      'Villanueva de Gómez',
      'Villanueva de Ávila',
      'Villanueva del Aceral',
      'Villanueva del Campillo',
      'Villar de Corneja',
      'Villarejo del Valle',
      'Villatoro',
      'Viñegra de Moraña',
      'Zapardiel de la Cañada',
      'Zapardiel de la Ribera',
      'Ávila',
    ],
  },
  TUR: {
    'TR-01': ['Adana', 'Ceyhan', 'Kozan', 'Pozantı', 'İmamoğlu'],
    'TR-02': ['Karataş'],
    'TR-03': [
      'Adıyaman',
      'Afyon',
      'Besni',
      'Bolvadin',
      'Dinar',
      'Emirdağ',
      'Gölbaşı',
      'Işıklar',
      'Kahta',
      'Sandıklı',
      'Çay',
      'Çelikhan',
      'Çobanlar',
      'İscehisar',
      'Şuhut',
    ],
    'TR-68': ['Aksaray', 'Eskil', 'Ortaköy', 'Sultanhanı'],
    'TR-05': ['Amasya', 'Gümüşhacıköy', 'Merzifon', 'Suluova', 'Taşova'],
    'TR-06': ['Ankara', 'Beypazarı', 'Haymana', 'Kızılcahamam', 'Nallıhan', 'Polatlı', 'Çayırhan', 'Şereflikoçhisar'],
    'TR-07': [
      'Alanya',
      'Antalya',
      'Avsallar',
      'Cikcilli',
      'Demre',
      'Elmalı',
      'Finike',
      'Gazipaşa',
      'Ilıca',
      'Kemer',
      'Kestel',
      'Konaklı',
      'Korkuteli',
      'Kumluca',
      'Mahmutlar',
      'Manavgat',
      'Mavikent',
      'Obaköy',
      'Sahilkent',
      'Sarılar',
      'Serik',
      'Side',
      'Turunçova',
      'Çolaklı',
    ],
    'TR-75': ['Ardahan', 'Göle'],
    'TR-08': ['Arhavi', 'Artvin', 'Borçka', 'Hopa'],
    'TR-09': [
      'Acarlar',
      'Atça',
      'Aydın',
      'Bozdoğan',
      'Buharkent',
      'Davutlar',
      'Didim',
      'Germencik',
      'Kuyucak',
      'Kuşadası',
      'Köşk',
      'Nazilli',
      'Ortaklar',
      'Ovaeymir',
      'Savuca',
      'Söke',
      'Umurlu',
      'Çine',
      'İncirliova',
    ],
    'TR-04': ['Ağrı', 'Diyadin', 'Doğubayazıt', 'Eleşkirt', 'Patnos'],
    'TR-10': [
      'Akçay',
      'Altınoluk',
      'Altınova',
      'Ayvalık',
      'Balıkesir',
      'Bandırma',
      'Bigadiç',
      'Burhaniye',
      'Dursunbey',
      'Edremit',
      'Erdek',
      'Gönen',
      'Havran',
      'Küçükköy',
      'Savaştepe',
      'Susurluk',
      'Sındırgı',
      'Zeytinli',
    ],
    'TR-74': ['Bartın'],
    'TR-72': ['Batman', 'Beşiri', 'Kozluk', 'Sason'],
    'TR-69': ['Bayburt'],
    'TR-11': ['Bilecik', 'Bozüyük', 'Osmaneli', 'Söğüt'],
    'TR-12': ['Bingöl', 'Genç', 'Solhan'],
    'TR-13': ['Adilcevaz', 'Ahlat', 'Bitlis', 'Güroymak', 'Hizan', 'Tatvan'],
    'TR-14': ['Bolu', 'Gerede', 'Göynük'],
    'TR-15': ['Bucak', 'Burdur', 'Gölhisar'],
    'TR-16': [
      'Bursa',
      'Karacabey',
      'Mustafakemalpaşa',
      'Orhaneli',
      'Orhangazi',
      'Yeniceköy',
      'Yenişehir',
      'İnegöl',
      'İznik',
    ],
    'TR-20': ['Acıpayam', 'Buldan', 'Denizli', 'Honaz', 'Kale', 'Sarayköy', 'Serinhisar', 'Tavas', 'Çivril'],
    'TR-21': ['Bismil', 'Dicle', 'Diyarbakır', 'Ergani', 'Hani', 'Kulp', 'Lice', 'Silvan', 'Çermik', 'Çınar'],
    'TR-81': ['Akçakoca', 'Düzce', 'Gölyaka', 'Kaynaşlı', 'Çilimli'],
    'TR-22': ['Edirne', 'Havsa', 'Karaağaç', 'Keşan', 'Uzunköprü', 'İpsala'],
    'TR-23': ['Elâzığ', 'Karakoçan', 'Kovancılar', 'Palu', 'Yazıkonak', 'Yurtbaşı'],
    'TR-24': ['Erzincan'],
    'TR-25': ['Aşkale', 'Erzurum', 'Horasan', 'Hınıs', 'Karaçoban', 'Oltu', 'Pasinler'],
    'TR-26': ['Eskişehir', 'Sivrihisar', 'Çifteler'],
    'TR-35': ['Alaçatı', 'Bergama', 'Dikili', 'Kiraz', 'Kınık', 'Tire', 'Çeşme', 'Ödemiş', 'İzmir'],
    'TR-34': ['Istanbul'],
    'TR-27': ['Araban', 'Gaziantep', 'Nizip', 'Nurdağı', 'Sakçagöze', 'İslahiye'],
    'TR-28': [
      'Bulancak',
      'Espiye',
      'Eynesil',
      'Giresun',
      'Görele',
      'Keşap',
      'Piraziz',
      'Tirebolu',
      'Yağlıdere',
      'Şebinkarahisar',
    ],
    'TR-29': ['Gümüşhane', 'Kelkit', 'Şiran'],
    'TR-30': ['Hakkâri', 'Yüksekova', 'Çukurca', 'Şemdinli'],
    'TR-31': [
      'Akbez',
      'Aktepe',
      'Antakya',
      'Bekbele',
      'Denizciler',
      'Dörtyol',
      'Erzin',
      'Gözcüler',
      'Harbiye',
      'Hassa',
      'Karayılan',
      'Kuzuculu',
      'Küçükdalyan',
      'Kırıkhan',
      'Narlıca',
      'Odabaşı',
      'Payas',
      'Reyhanlı',
      'Samandağ',
      'Serinyol',
      'Tekebaşı',
      'Yeşilköy',
      'Çekmece',
      'İskenderun',
    ],
    'TR-32': ['Eğirdir', 'Isparta', 'Keçiborlu', 'Uluborlu', 'Yalvaç', 'Şarkikaraağaç'],
    'TR-76': ['Iğdır', 'Tuzluca'],
    'TR-46': [
      'Afşin',
      'Andırın',
      'Arıtaş',
      'Beyoğlu',
      'Elbistan',
      'Göksun',
      'Kahramanmaraş',
      'Narlı',
      'Pazarcık',
      'Türkoğlu',
      'Çağlayancerit',
      'Şekeroba',
    ],
    'TR-78': ['Karabük', 'Safranbolu', 'Yenice'],
    'TR-70': ['Ermenek', 'Karaman'],
    'TR-36': ['Kars', 'Kağızman', 'Sarıkamış'],
    'TR-37': ['Kastamonu', 'Taşköprü', 'Tosya', 'İnebolu'],
    'TR-38': ['Bünyan', 'Develi', 'Kayseri', 'Pınarbaşı', 'Tomarza', 'Yahyalı', 'Yeşilhisar'],
    'TR-79': ['Kilis'],
    'TR-39': [],
    'TR-41': [
      'Başiskele',
      'Darıca',
      'Derince',
      'Dilovası',
      'Gebze',
      'Gölcük',
      'Kandıra',
      'Karamürsel',
      'Kartepe',
      'Körfez',
      'Çayırova',
      'İzmit',
    ],
    'TR-42': [
      'Akşehir',
      'Beyşehir',
      'Bozkır',
      'Cihanbeyli',
      'Ereğli',
      'Ilgın',
      'Kadınhanı',
      'Karapınar',
      'Konya',
      'Kulu',
      'Ladik',
      'Sarayönü',
      'Seydişehir',
      'Yeniceoba',
      'Yunak',
      'Çumra',
      'İsmil',
      'İçeriçumra',
    ],
    'TR-43': ['Emet', 'Gediz', 'Kütahya', 'Simav', 'Tavşanlı', 'Tunçbilek'],
    'TR-71': ['Babaeski', 'Keskin', 'Kırklareli', 'Kırıkkale', 'Lüleburgaz', 'Pınarhisar', 'Vize', 'Yahşihan'],
    'TR-40': ['Kaman', 'Kırşehir', 'Mucur', 'Çiçekdağı'],
    'TR-44': [
      'Akçadağ',
      'Battalgazi',
      'Bostanbaşı',
      'Darende',
      'Dilek',
      'Doğanşehir',
      'Hekimhan',
      'Malatya',
      'Yakınca',
      'Yeşilyurt',
    ],
    'TR-45': [
      'Ahmetli',
      'Akhisar',
      'Alaşehir',
      'Demirci',
      'Gölmarmara',
      'Gördes',
      'Kırkağaç',
      'Manisa',
      'Salihli',
      'Saruhanlı',
      'Sarıgöl',
      'Soma',
      'Turgutalp',
      'Turgutlu',
    ],
    'TR-47': [
      'Dargeçit',
      'Derik',
      'Gelinkaya',
      'Gökçe',
      'Kabala',
      'Kızıltepe',
      'Mardin',
      'Mazıdağı',
      'Midyat',
      'Nusaybin',
      'Savur',
      'Yeşilli',
    ],
    'TR-33': [
      'Anamur',
      'Atakent',
      'Atayurt',
      'Aydıncık',
      'Bozyazı',
      'Erdemli',
      'Kargıpınarı',
      'Mersin',
      'Mut',
      'Silifke',
      'Tarsus',
      'Taşucu',
      'Tömük',
    ],
    'TR-49': ['Bulanık', 'Hasköy', 'Malazgirt', 'Muş', 'Varto'],
    'TR-48': [
      'Armutalan',
      'Beldibi',
      'Bitez',
      'Bodrum',
      'Dalaman',
      'Datça',
      'Fethiye',
      'Karaçulha',
      'Konacık',
      'Köyceğiz',
      'Marmaris',
      'Milas',
      'Muğla',
      'Ortaca',
      'Turgutreis',
      'Yalıkavak',
      'Yatağan',
    ],
    'TR-50': ['Avanos', 'Derinkuyu', 'Gülşehir', 'Kozaklı', 'Nevşehir', 'Ürgüp'],
    'TR-51': ['Bor', 'Niğde', 'Ulukışla'],
    'TR-52': ['Aybastı', 'Fatsa', 'Gölköy', 'Gürgentepe', 'Korgan', 'Kumru', 'Ordu', 'Perşembe', 'Çamaş', 'Ünye'],
    'TR-80': ['Bahçe', 'Düziçi', 'Kadirli', 'Osmaniye', 'Toprakkale'],
    'TR-53': ['Ardeşen', 'Fındıklı', 'Pazar', 'Rize', 'Çayeli'],
    'TR-54': ['Adapazarı', 'Geyve', 'Karasu', 'Kocaali', 'Pamukova'],
    'TR-55': ['Alaçam', 'Bafra', 'Havza', 'Kavak', 'Ondokuzmayıs', 'Samsun', 'Terme', 'Vezirköprü', 'Çarşamba'],
    'TR-56': ['Eruh', 'Kurtalan', 'Siirt'],
    'TR-57': ['Ayancık', 'Boyabat', 'Durağan', 'Gerze'],
    'TR-58': ['Divriği', 'Gürün', 'Kangal', 'Sivas', 'Suşehri', 'Yıldızeli', 'Zara', 'Şarkışla'],
    'TR-59': [
      'Büyükyoncalı',
      'Hayrabolu',
      'Kapaklı',
      'Kızılpınar',
      'Marmaraereğlisi',
      'Muratlı',
      'Saray',
      'Sultanköy',
      'Tekirdağ',
      'Velimeşe',
      'Yeniçiftlik',
      'Çerkezköy',
      'Çorlu',
      'Şarköy',
    ],
    'TR-60': ['Erbaa', 'Niksar', 'Reşadiye', 'Tokat', 'Turhal', 'Zile'],
    'TR-61': [
      'Akçaabat',
      'Araklı',
      'Arsin',
      'Beşikdüzü',
      'Maçka',
      'Of',
      'Pelitli',
      'Söğütlü',
      'Sürmene',
      'Tonya',
      'Trabzon',
      'Vakfıkebir',
      'Yomra',
      'Çarşıbaşı',
    ],
    'TR-62': ['Pertek', 'Tunceli'],
    'TR-64': ['Banaz', 'Eşme', 'Uşak'],
    'TR-65': ['Başkale', 'Bostaniçi', 'Erciş', 'Gevaş', 'Muradiye', 'Van', 'Çaldıran', 'Çelebibağı', 'Özalp'],
    'TR-77': ['Koru', 'Yalova', 'Çiftlikköy', 'Çınarcık'],
    'TR-66': [
      'Akdağmadeni',
      'Boğazlıyan',
      'Saraykent',
      'Sarıkaya',
      'Sorgun',
      'Yerköy',
      'Yozgat',
      'Çayıralan',
      'Çekerek',
      'Şefaatli',
    ],
    'TR-67': [
      'Alaplı',
      'Devrek',
      'Gökçebey',
      'Gülüç',
      'Karadeniz Ereğli',
      'Kilimli',
      'Kozlu',
      'Zonguldak',
      'Çatalağzı',
      'Çaycuma',
    ],
    'TR-17': ['Ayvacık', 'Bayramiç', 'Biga', 'Ezine', 'Gelibolu', 'Kepez', 'Lapseki', 'Çan', 'Çanakkale'],
    'TR-18': ['Ilgaz', 'Çankırı', 'Çerkeş'],
    'TR-19': ['Alaca', 'Bayat', 'Osmancık', 'Sungurlu', 'Çorum', 'İskilip'],
    'TR-63': [
      'Akçakale',
      'Birecik',
      'Bozova',
      'Ceylanpınar',
      'Halfeti',
      'Hilvan',
      'Kadıkendi',
      'Karaköprü',
      'Siverek',
      'Suruç',
      'Viranşehir',
      'Şanlıurfa',
    ],
    'TR-73': [],
  },
  USA: {
    'US-AL': [
      'Abanda',
      'Aberfoil',
      'Abernant',
      'Adamsville',
      'Addison',
      'Akron',
      'Alabaster',
      'Alberta',
      'Albertville',
      'Alexander City',
      'Aliceville',
      'Allgood',
      'Altoona',
      'Andalusia',
      'Anderson',
      'Anniston',
      'Ansley',
      'Arab',
      'Ardmore',
      'Argo',
      'Ariton',
      'Arkadelphia',
      'Arley',
      'Ashby',
      'Ashland',
      'Ashville',
      'Atmore',
      'Attalla',
      'Autaugaville',
      'Avon',
      'Axis',
      'Babbie',
      'Baileyton',
      'Baker Hill',
      'Ballplay',
      'Banks',
      'Barton',
      'Batesville',
      'Bay Minette',
      'Bayou La Batre',
      'Bazemore',
      'Bear Creek',
      'Beatrice',
      'Beaverton',
      'Belgreen',
      'Belk',
      'Bellamy',
      'Bellefontaine',
      'Benton',
      'Berlin',
      'Bessemer',
      'Bexar',
      'Billingsley',
      'Black',
      'Blanche',
      'Bleecker',
      'Blountsville',
      'Blue Ridge',
      'Blue Springs',
      'Bluff Park',
      'Boaz',
      'Boligee',
      'Bolling',
      'Bon Air',
      'Bon Secour',
      'Booth',
      'Borden Springs',
      'Boykin',
      'Bradley',
      'Brantley',
      'Brantleyville',
      'Brewton',
      'Bridgeport',
      'Brilliant',
      'Brook Highland',
      'Brookside',
      'Brooksville',
      'Brookwood',
      'Broomtown',
      'Brundidge',
      'Bucks',
      'Burnsville',
      'Burnt Corn',
      'Caffee Junction',
      'Calhoun',
      'Calvert',
      'Camp Hill',
      'Campbell',
      'Carbon Hill',
      'Carlisle',
      'Carrollton',
      'Castleberry',
      'Catherine',
      'Cecil',
      'Cedar Bluff',
      'Center Point',
      'Centre',
      'Chancellor',
      'Chandler Springs',
      'Chapman',
      'Chastang',
      'Chatom',
      'Chelsea',
      'Cherokee',
      'Chickasaw',
      'Childersburg',
      'Choccolocco',
      'Choctaw Bluff',
      'Chrysler',
      'Chunchula',
      'Citronelle',
      'Claiborne',
      'Clanton',
      'Clay',
      'Clayhatchee',
      'Clayton',
      'Clio',
      'Clopton',
      'Cloverdale',
      'Coaling',
      'Coffee Springs',
      'Coffeeville',
      'Coker',
      'Collbran',
      'Columbia',
      'Columbiana',
      'Comer',
      'Concord',
      'Coosada',
      'Cordova',
      'Cottondale',
      'Cottonwood',
      'County Line',
      'Courtland',
      'Cowarts',
      'Cragford',
      'Crawford',
      'Creola',
      'Cromwell',
      'Crosby',
      'Crossville',
      'Cullman',
      'Cullomburg',
      'Curry',
      'Cusseta',
      'Cypress',
      'Dadeville',
      'Daleville',
      'Daphne',
      'Dauphin Island',
      'Daviston',
      'Dayton',
      'DeArmanville',
      'Deatsville',
      'Decatur',
      'Deer Park',
      'Demopolis',
      'Detroit',
      'Dixie',
      'Dixons Mills',
      'Dodge City',
      'Dolomite',
      'Dora',
      'Dothan',
      'Double Springs',
      'Douglas',
      'Dozier',
      'Duncanville',
      'East Brewton',
      'East Point',
      'Echo',
      'Eclectic',
      'Edgewater',
      'Edwardsville',
      'Egypt',
      'Elba',
      'Elberta',
      'Eldridge',
      'Elkmont',
      'Elrod',
      'Emelle',
      'Eoline',
      'Epes',
      'Ethelsville',
      'Eufaula',
      'Eulaton',
      'Eunola',
      'Eutaw',
      'Eva',
      'Evergreen',
      'Excel',
      'Fackler',
      'Fairfield',
      'Fairford',
      'Fairhope',
      'Falkville',
      'Faunsdale',
      'Fayette',
      'Fayetteville',
      'Fitzpatrick',
      'Five Points',
      'Flat Rock',
      'Flatwood',
      'Flint City',
      'Flomaton',
      'Florala',
      'Florence',
      'Foley',
      'Forest Home',
      'Forestdale',
      'Forkland',
      'Forney',
      'Fort Davis',
      'Fort Deposit',
      'Fort Mitchell',
      'Fort Morgan',
      'Fort Payne',
      'Fosters',
      'Frankville',
      'Frisco City',
      'Fruitdale',
      'Fruithurst',
      'Fulton',
      'Fultondale',
      'Fyffe',
      'Gadsden',
      'Gainesville',
      'Gallant',
      'Gallion',
      'Gantt',
      'Garden City',
      'Gardendale',
      'Garland',
      'Gasque',
      'Gaylesville',
      'Geiger',
      'Geneva',
      'Georgiana',
      'Geraldine',
      'Gilbertown',
      'Glen Allen',
      'Glenville',
      'Goldville',
      'Good Hope',
      'Goodwater',
      'Gordo',
      'Gordonville',
      'Gorgas',
      'Grady',
      'Grand Bay',
      'Grant',
      'Grayson',
      'Grayson Valley',
      'Graysville',
      'Greensboro',
      'Greenville',
      'Grimes',
      'Grove Hill',
      'Gu-Win',
      'Guin',
      'Gulf Shores',
      'Gulfcrest',
      'Guntersville',
      'Gurley',
      'Hackleburg',
      'Hackneyville',
      'Hacoda',
      'Haleburg',
      'Haleyville',
      'Hammondville',
      'Hanceville',
      'Hardaway',
      'Harpersville',
      'Hartford',
      'Hartselle',
      'Harvest',
      'Hatchechubbee',
      'Hatton',
      'Hayden',
      'Hayneville',
      'Hazel Green',
      'Hazen',
      'Headland',
      'Heath',
      'Heflin',
      'Heiberger',
      'Helena',
      'Henagar',
      'Hendrix',
      'Heron Bay',
      'Highland Home',
      'Highland Lake',
      'Hillsboro',
      'Hissop',
      'Hobson',
      'Hobson City',
      'Hodges',
      'Hokes Bluff',
      'Hollins',
      'Hollis Crossroads',
      'Holly Pond',
      'Hollywood',
      'Holt',
      'Holtville',
      'Homewood',
      'Honoraville',
      'Hoover',
      'Horn Hill',
      'Hueytown',
      'Huguley',
      'Hunter',
      'Hurtsboro',
      'Huxford',
      'Hybart',
      'Hytop',
      'Ider',
      'Indian Springs Village',
      'Ironaton',
      'Irondale',
      'Isbell',
      'Ivalee',
      'Jackson',
      'Jacksons Gap',
      'Jacksonville',
      'Jasper',
      'Jemison',
      'Jenifer',
      'Jones',
      'Jones Chapel',
      'Joppa',
      'Kansas',
      'Keener',
      'Kellyton',
      'Killen',
      'Kimberly',
      'Kimbrough',
      'Kinsey',
      'Kinston',
      'Knoxville',
      'Ladonia',
      'Lafayette',
      'Lamison',
      'Land',
      'Landersville',
      'Lanett',
      'Langston',
      'Lawley',
      'Leesburg',
      'Lehigh',
      'Leighton',
      'Leroy',
      'Lester',
      'Letohatchee',
      'Level Plains',
      'Libertyville',
      'Lilita',
      'Lillian',
      'Lim Rock',
      'Lineville',
      'Lipscomb',
      'Lisman',
      'Little River',
      'Littleville',
      'Livingston',
      'Loachapoka',
      'Lockhart',
      'Locust Fork',
      'Lomax',
      'Long Island',
      'Louisville',
      'Lowndesboro',
      'Loxley',
      'Luverne',
      'Lynn',
      'Macedonia',
      'Madison',
      'Magnolia Springs',
      'Malcolm',
      'Malone',
      'Malvern',
      'Manack',
      'Maplesville',
      'Marbury',
      'Margaret',
      'Marion',
      'Marion Junction',
      'Marvel',
      'Maylene',
      'Maytown',
      'McDonald Chapel',
      'McIntosh',
      'McKenzie',
      'McMullen',
      'McWilliams',
      'Meadowbrook',
      'Megargel',
      'Melvin',
      'Memphis',
      'Mentone',
      'Meridianville',
      'Midfield',
      'Midland City',
      'Mignon',
      'Millbrook',
      'Miller',
      'Millers Ferry',
      'Millerville',
      'Millport',
      'Millry',
      'Milstead',
      'Minor',
      'Minter',
      'Mobile',
      'Monroeville',
      'Montevallo',
      'Montgomery',
      'Moody',
      'Moores Bridge',
      'Moores Mill',
      'Mooresville',
      'Morgan City',
      'Morrison Crossroad',
      'Mosses',
      'Moulton',
      'Moulton Heights',
      'Moundville',
      'Mount Andrew',
      'Mount Olive',
      'Mount Vernon',
      'Mountain Brook',
      'Mountain Creek',
      'Movico',
      'Mulga',
      'Munford',
      'Muscle Shoals',
      'Myrtlewood',
      'Nanafalia',
      'Nances Creek',
      'Napier Field',
      'Natural Bridge',
      'Nauvoo',
      'Nectar',
      'Needham',
      'New Brockton',
      'New Hope',
      'New Market',
      'New Site',
      'Newbern',
      'Newton',
      'Newtonville',
      'Newville',
      'Normal',
      'North Bibb',
      'North Courtland',
      'North Johns',
      'Notasulga',
      'Oak Grove',
      'Oak Hill',
      'Oakman',
      'Odenville',
      'Ohatchee',
      'Oneonta',
      'Onycha',
      'Opelika',
      'Opp',
      'Orange Beach',
      'Orion',
      'Orrville',
      'Our Town',
      'Overbrook',
      'Owens Cross Roads',
      'Ozark',
      'Paint Rock',
      'Panola',
      'Parrish',
      'Peachburg',
      'Pell City',
      'Pennington',
      'Penton',
      'Perdido',
      'Perdido Beach',
      'Peterman',
      'Peterson',
      'Petersville',
      'Petrey',
      'Phenix City',
      'Phil Campbell',
      'Pickensville',
      'Piedmont',
      'Pike Road',
      'Pinckard',
      'Pine Apple',
      'Pine Hill',
      'Pine Level',
      'Pine Ridge',
      'Pinson',
      'Pisgah',
      'Pittsview',
      'Plantersville',
      'Pleasant Gap',
      'Pleasant Grove',
      'Pleasant Site',
      'Pletcher',
      'Plevna',
      'Point Clear',
      'Pollard',
      'Portersville',
      'Powell',
      'Prattville',
      'Priceville',
      'Prichard',
      'Providence',
      'Putnam',
      'Pyriton',
      'Ragland',
      'Rainbow City',
      'Rainsville',
      'Ramer',
      'Ranburne',
      'Randolph',
      'Range',
      'Ray',
      'Red Hill',
      'Red Level',
      'Reece City',
      'Reeltown',
      'Reform',
      'Rehobeth',
      'Repton',
      'Ridgeville',
      'River Falls',
      'Roanoke',
      'Robertsdale',
      'Rock Creek',
      'Rock Mills',
      'Rockford',
      'Rockledge',
      'Rockville',
      'Rosa',
      'Rosalie',
      'Russellville',
      'Rutledge',
      'Safford',
      'Saginaw',
      'Saint Florian',
      'Saint Stephens',
      'Saks',
      'Salitpa',
      'Samantha',
      'Samson',
      'Sand Rock',
      'Sanford',
      'Saraland',
      'Sardis',
      'Sardis City',
      'Satsuma',
      'Sawyerville',
      'Scottsboro',
      'Seaboard',
      'Seale',
      'Section',
      'Selmont',
      'Seminole',
      'Semmes',
      'Shady Grove',
      'Shelby',
      'Shiloh',
      'Shopton',
      'Short Creek',
      'Shorter',
      'Shorterville',
      'Silas',
      'Silverhill',
      'Sims Chapel',
      'Sipsey',
      'Skyline',
      'Slocomb',
      'Smiths Station',
      'Smoke Rise',
      'Snead',
      'Snow Hill',
      'Snowdoun',
      'Society Hill',
      'Somerville',
      'South Vinemont',
      'Southside',
      'Spanish Fort',
      'Sprague',
      'Spring Garden',
      'Springville',
      'Sprott',
      'Spruce Pine',
      'Standing Rock',
      'Stanton',
      'Stapleton',
      'Steele',
      'Sterrett',
      'Stevenson',
      'Stewartville',
      'Stockton',
      'Stroud',
      'Sulligent',
      'Sumiton',
      'Summerdale',
      'Summit',
      'Sunny South',
      'Susan Moore',
      'Suttle',
      'Sweet Water',
      'Sycamore',
      'Sylacauga',
      'Sylvan Springs',
      'Sylvania',
      'Talladega',
      'Talladega Springs',
      'Tallassee',
      'Tanner',
      'Tarrant',
      'Tennant',
      'Tensaw',
      'Texasville',
      'Thach',
      'The Colony',
      'Thomaston',
      'Thomasville',
      'Tibbie',
      'Tillmans Corner',
      'Town Creek',
      'Toxey',
      'Triana',
      'Troy',
      'Trussville',
      'Tunnel Springs',
      'Tuscaloosa',
      'Tuscumbia',
      'Tuskegee',
      'Twin',
      'Tyler',
      'Union',
      'Union Grove',
      'Union Springs',
      'Uniontown',
      'Uriah',
      'Valley',
      'Valley Creek',
      'Valley Grande',
      'Valley Head',
      'Vance',
      'Vandiver',
      'Verbena',
      'Vestavia Hills',
      'Village Springs',
      'Vina',
      'Vincent',
      'Vinegar Bend',
      'Vredenburgh',
      'Wadley',
      'Wagarville',
      'Waldo',
      'Wallsboro',
      'Walnut Grove',
      'Ward',
      'Warrior',
      'Wattsville',
      'Waverly',
      'Weaver',
      'Webb',
      'Wedowee',
      'Weogufka',
      'West Blocton',
      'West Jefferson',
      'West Point',
      'West Selmont',
      'Westover',
      'Wetumpka',
      'Whatley',
      'White Hall',
      'White Plains',
      'Whitesboro',
      'Wilmer',
      'Wilsonia',
      'Wilsonville',
      'Wilton',
      'Winfield',
      'Winterboro',
      'Woodland',
      'Woodville',
      'Wren',
      'Yarbo',
      'Yellow Bluff',
      'Yellow Pine',
    ],
    'US-AK': [
      'Adak',
      'Akhiok',
      'Akiachak',
      'Akiak',
      'Akutan',
      'Alakanuk',
      'Alatna',
      'Alcan',
      'Aleknagik',
      'Aleneva',
      'Allakaket',
      'Ambler',
      'Amchitka',
      'Anaktuvuk Pass',
      'Anchorage',
      'Angoon',
      'Aniak',
      'Annette',
      'Anvik',
      'Arctic Village',
      'Atka',
      'Atmautluak',
      'Atqasuk',
      'Attu',
      'Auke Bay',
      'Aurora Lodge',
      'Baranof',
      'Beaver',
      'Belkofski',
      'Bell Island Hot Springs',
      'Beluga',
      'Bethel',
      'Bettles',
      'Big Delta',
      'Big Lake',
      'Bill Moores',
      'Biorka',
      'Birch Creek',
      'Brevig Mission',
      'Butte',
      'Candle',
      'Cantwell',
      'Cape Pole',
      'Cape Yakataga',
      'Chalkyitsik',
      'Chandalar',
      'Chaniliut',
      'Chatanika',
      'Chatham',
      'Chefornak',
      'Chelatna Lodge',
      'Chena Hot Springs',
      'Chernofski',
      'Chevak',
      'Chickaloon',
      'Chicken',
      'Chignik',
      'Chignik Lagoon',
      'Chignik Lake',
      'Chiniak',
      'Chisana',
      'Chistochina',
      'Chitina',
      'Chuathbaluk',
      'Chugiak',
      'Circle',
      'Circle Hot Springs',
      'Clam Gulch',
      'Clarks Point',
      'Coffman Cove',
      'Cohoe',
      'Cold Bay',
      'Coldfoot',
      'College',
      'Cooper Landing',
      'Copper Center',
      'Covenant Life',
      'Craig',
      'Crooked Creek',
      'Crown Point',
      'Crystal Falls',
      'Deadhorse',
      'Deering',
      'Delta Junction',
      'Denali Park',
      'Diamond Ridge',
      'Dillingham',
      'Diomede',
      'Dot Lake',
      'Dot Lake Village',
      'Dry Creek',
      'Eagle',
      'Eagle River',
      'Eagle Village',
      'Edna Bay',
      'Eek',
      'Egegik',
      'Ekwok',
      'Elfin Cove',
      'Elim',
      'Ellamar',
      'Emmonak',
      'Eska',
      'Ester',
      'Eureka Roadhouse',
      'Evansville',
      'Excursion Inlet',
      'Fairbanks',
      'False Pass',
      'Ferry',
      'Flat',
      'Folger',
      'Fort Yukon',
      'Fox',
      'Fox River',
      'Fritz Creek',
      'Funny River',
      'Funter',
      'Gakona',
      'Gambell',
      'Game Creek',
      'Garner',
      'Gateway',
      'Girdwood',
      'Glennallen',
      'Golovin',
      'Goodnews Bay',
      'Gost Creek',
      'Grayling',
      'Gulkana',
      'Gustavus',
      'Haines',
      'Halibut Cove',
      'Happy Valley',
      'Harding Lake',
      'Hawk Inlet',
      'Haycock',
      'Healy',
      'Healy Lake',
      'Herendeen Bay',
      'Hobart Bay',
      'Hogatza',
      'Holikachuk',
      'Hollis',
      'Holy Cross',
      'Homer',
      'Hoonah',
      'Hooper Bay',
      'Hughes',
      'Huslia',
      'Hydaburg',
      'Hyder',
      'Igiugig',
      'Ikatan',
      'Iliamna',
      'Ivanof Bay',
      'Jakolof Bay',
      'Jonesville',
      'Juneau',
      'Kachemak City',
      'Kake',
      'Kaktovik',
      'Kalifornsky',
      'Kalskag',
      'Kaltag',
      'Karluk',
      'Kasaan',
      'Kashegelok',
      'Kasigluk',
      'Kasilof',
      'Katalla',
      'Kenai',
      'Kenny Lake',
      'Ketchikan',
      'Kiana',
      'King Cove',
      'King Salmon',
      'Kipnuk',
      'Kivalina',
      'Kiwalik',
      'Klawock',
      'Klukwan',
      'Knik',
      'Kobuk',
      'Kodiak',
      'Koggiung',
      'Kokhanok',
      'Kokrines',
      'Koliganek',
      'Kongiganak',
      'Kotlik',
      'Kotzebue',
      'Koyuk',
      'Koyukuk',
      'Kupreanof',
      'Kustatan',
      'Kvichak',
      'Kwethluk',
      'Kwigillingok',
      'Lake Louise',
      'Lake Minchumina',
      'Larsen Bay',
      'Lazy Mountain',
      'Lees Camp',
      'Lemeta',
      'Levelock',
      'Libbyville',
      'Lignite',
      'Lime Village',
      'Livengood',
      'Long',
      'Loring',
      'Lowell Point',
      'Lower Kalskag',
      'Lower Tonsina',
      'Lutak',
      'Manley Hot Springs',
      'Manokotak',
      'Marshall',
      'Matanuska',
      'May Creek',
      'McCarthy',
      'McGrath',
      'Meadow Lakes',
      'Medfra',
      'Mekoryuk',
      'Mendeltna',
      'Mentasta Lake',
      'Metlakatla',
      'Meyers Chuck',
      'Miller House',
      'Millers Landing',
      'Moose Creek',
      'Moose Pass',
      'Morzhovoi',
      'Mosquito Lake',
      'Mountain Village',
      'Mud Bay',
      'Nabesna',
      'Naknek',
      'Nanwalek',
      'Napakiak',
      'Napaskiak',
      'Naukati Bay',
      'Nelchina',
      'Nelson Lagoon',
      'Nenana',
      'New Stuyahok',
      'New Tokeen',
      'Newhalen',
      'Newtok',
      'Nightmute',
      'Nikiski',
      'Nikolaevsk',
      'Nikolai',
      'Nikolski',
      'Ninilchik',
      'Noatak',
      'Nome',
      'Nondalton',
      'Noorvik',
      'North Pole',
      'Northway',
      'Northway Junction',
      'Northway Village',
      'Nuiqsut',
      'Nulato',
      'Nunaka Valley',
      'Nunam Iqua',
      'Nunapitchuk',
      'Nushagak',
      'Nyac',
      'Old Harbor',
      'Old Minto',
      'Olnes',
      'Ophir',
      'Oscarville',
      'Oskawalik',
      'Ouzinkie',
      'Paxson',
      'Pedro Bay',
      'Pelican',
      'Perryville',
      'Petersburg',
      'Pilot Point',
      'Pilot Station',
      'Pitkas Point',
      'Platinum',
      'Pleasant Valley',
      'Point Baker',
      'Point Hope',
      'Point Lay',
      'Point MacKenzie',
      'Port Alexander',
      'Port Alsworth',
      'Port Armstrong',
      'Port Ashton',
      'Port Chilkoot',
      'Port Clarence',
      'Port Graham',
      'Port Heiden',
      'Port Lions',
      'Port Moller',
      "Port O'Brien",
      'Port Protection',
      'Port William',
      'Portage Creek',
      'Prudhoe Bay',
      'Quinhagak',
      'Rampart',
      'Red Devil',
      'Red Dog Mine',
      'Ruby',
      'Russian Mission',
      'Saint George',
      'Saint Marys',
      'Saint Michael',
      'Saint Paul',
      'Salamatof',
      'Salt Chuck',
      'Sanak',
      'Sand Point',
      'Savoonga',
      'Saxman',
      'Scammon Bay',
      'Selawik',
      'Seldovia',
      'Seldovia Village',
      'Seward',
      'Shageluk',
      'Shaktoolik',
      'Shishmaref',
      'Shungnak',
      'Silvertip',
      'Sitka',
      'Skagway',
      'Skwentna',
      'Slana',
      'Sleetmute',
      'Soldotna',
      'South Naknek',
      'Spenard',
      'Stebbins',
      'Sterling',
      'Stevens Village',
      'Stony River',
      'Sunrise',
      'Sunshine',
      'Suntrana',
      'Susitna',
      'Takotna',
      'Talkeetna',
      'Tanacross',
      'Tanaina',
      'Tanana',
      'Tatitlek',
      'Tazlina',
      'Tee Harbor',
      'Telida',
      'Teller',
      'Tenakee Springs',
      'Tetlin',
      'Thorne Bay',
      'Tin City',
      'Todd',
      'Tofty',
      'Togiak',
      'Tok',
      'Tokeen',
      'Toksook Bay',
      'Tolsona',
      'Tonsina',
      'Trapper Creek',
      'Tuluksak',
      'Tuntutuliak',
      'Tununak',
      'Twin Hills',
      'Two Rivers',
      'Tyonek',
      'Ugashik',
      'Umiat',
      'Umkumiute',
      'Unalakleet',
      'Unalaska',
      'Unga',
      'Utqiaġvik',
      'Uyak',
      'Valdez',
      'Venetie',
      'Wales',
      'Ward Cove',
      'Wasilla',
      'Whale Pass',
      'White Mountain',
      'Whitestone Logging Camp',
      'Whittier',
      'Willow',
      'Willow Creek',
      'Wiseman',
      'Womens Bay',
      'Wrangell',
      'Yakutat',
    ],
    'US-AZ': [
      'Aguila',
      'Ajo',
      'Ak Chin',
      'Ak-Chin Village',
      'Ali Chuk',
      'Ali Chukson',
      'Ali Molina',
      'Alpine',
      'Amado',
      'Anegam',
      'Antares',
      'Anthem',
      'Apache Junction',
      'Aripine',
      'Arivaca',
      'Arivaca Junction',
      'Arizona City',
      'Arizona Village',
      'Arlington',
      'Artesia',
      'Ash Fork',
      'Avra Valley',
      'Aztec',
      'Bacavi',
      'Bear Flat',
      'Beardsley',
      'Beaver Dam',
      'Bellemont',
      'Benson',
      'Beyerville',
      'Big Springs',
      'Bisbee',
      'Bitter Springs',
      'Black Canyon City',
      'Blaisdell',
      'Bon',
      'Bosque',
      'Bouse',
      'Bowie',
      'Brenda',
      'Bryce',
      'Buckeye',
      'Bullhead City',
      'Bumble Bee',
      'Burnside',
      'Bylas',
      'Cactus Flat',
      'Cactus Forest',
      'Calva',
      'Cameron',
      'Camp Creek',
      'Camp Verde',
      'Cane Beds',
      'Canyon Day',
      'Canyon Diablo',
      'Carefree',
      'Casa Blanca',
      'Casas Adobes',
      'Cashion',
      'Catalina',
      'Catalina Foothills',
      'Cave Creek',
      'Cedar Creek',
      'Central Heights',
      'Chambers',
      'Chandler Heights',
      'Chiawuli Tak',
      'Chilchinbito',
      'Childs',
      'Chinle',
      'Chino Valley',
      'Chloride',
      'Christmas',
      'Christopher Creek',
      'Chuichu',
      'Cibecue',
      'Cibola',
      'Cienega Springs',
      'Citrus Park',
      'Clarkdale',
      'Clay Springs',
      'Claypool',
      'Cleator',
      'Cochise',
      'Colorado City',
      'Comobabi',
      'Concho',
      'Congress',
      'Continental',
      'Coolidge',
      'Copper Hill',
      'Cordes Lakes',
      'Cornfields',
      'Cornville',
      'Corona de Tucson',
      'Cortaro',
      'Cowlic',
      'Crozier',
      'Curtiss',
      'Cutter',
      'Dateland',
      'Davis Dam',
      'Del Muerto',
      'Dennehotso',
      'Desert Hills',
      'Dewey-Humboldt',
      'Dilkon',
      'Dolan Springs',
      'Dome',
      'Dos Cabezas',
      'Double Adobe',
      'Dragoon',
      'Drexel Heights',
      'Dudleyville',
      'Eagar',
      'East Fork',
      'Ehrenberg',
      'El Mirage',
      'Elfrida',
      'Eloy',
      'First Mesa',
      'Flagstaff',
      'Florence Junction',
      'Flowing Springs',
      'Flowing Wells',
      'Forest Lakes Estates',
      'Fort Apache',
      'Fort Defiance',
      'Fort Thomas',
      'Fortuna Foothills',
      'Fountain Hills',
      'Franconia',
      'Freedom Acres',
      'Ganado',
      'Geronimo',
      'Gila Bend',
      'Gila Crossing',
      'Gilbert',
      'Gisela',
      'Gleeson',
      'Glenbar',
      'Globe',
      'Gold Canyon',
      'Goodyear',
      'Grand Canyon',
      'Granville',
      'Gray Mountain',
      'Greasewood',
      'Green Valley',
      'Greer',
      'Griffith',
      'Growler',
      'Gu Oidak',
      'Hackberry',
      'Haivana Nakya',
      'Happy Jack',
      'Harcuvar',
      'Heber',
      'Hereford',
      'Hibbard',
      'Higley',
      'Hillside',
      'Horn',
      'Hotevilla',
      'Hotevilla-Bacavi',
      'Houck',
      'Huachuca City',
      'Indian Wells',
      'Iron Springs',
      'Jacob Lake',
      'Jakes Corner',
      'Jeddito',
      'Jerome',
      'Joseph City',
      'Kachina Village',
      'Kaibab',
      'Kaibito',
      'Kaka',
      'Kayenta',
      'Keams Canyon',
      'Kearny',
      'Kelvin',
      'Kingman',
      'Kino Springs',
      'Kinter',
      'Kirkland Junction',
      'Klagetoh',
      'Ko Vaya',
      'Kofa',
      'Kohatk',
      'Kohls Ranch',
      'Komatke',
      'Kykotsmovi Village',
      'La Paz Valley',
      'Lake Havasu City',
      'Lake Montezuma',
      'Laveen',
      'LeChee',
      'Leupp',
      'Leupp Corner',
      'Lewis Springs',
      'Ligurta',
      'Litchfield Park',
      'Littlefield',
      'Littletown',
      'Low Mountain',
      'Lukachukai',
      'Lukeville',
      'Lupton',
      'Magma',
      'Maish Vaya',
      'Mammoth',
      'Manila',
      'Many Farms',
      'Marana',
      'Marble Canyon',
      'Maricopa',
      'Mayer',
      'McConnico',
      'McNary',
      'McNeal',
      'Meadview',
      'Mesa',
      'Mesa del Caballo',
      'Mescal',
      'Mesquite Creek',
      'Mexican Water',
      'Miami',
      'Miracle Valley',
      'Moccasin',
      'Moenkopi',
      'Mohave Valley',
      'Mohawk',
      'Mojave Ranch Estates',
      'Morenci',
      'Mormon Lake',
      'Morristown',
      'Mount Trumbull',
      'Mountainaire',
      'Munds Park',
      'Nazlini',
      'New River',
      'Nicksville',
      'Nolic',
      'North Komelik',
      'North Rim',
      'Nutrioso',
      'Oak Springs',
      'Oatman',
      'Olberg',
      'Oracle',
      'Oracle Junction',
      'Oraibi',
      'Oro Valley',
      'Overgaard',
      'Oxbow Estates',
      'Page',
      'Palo Verde',
      'Palominas',
      'Pantano',
      'Parker',
      'Parker Strip',
      'Parks',
      'Patagonia',
      'Paul Spur',
      'Paulden',
      'Payson',
      'Peach Springs',
      'Pearce',
      'Peeples Valley',
      'Penzance',
      'Peoria',
      'Peridot',
      'Perkinsville',
      'Phoenix',
      'Picacho',
      'Picture Rocks',
      'Piedra',
      'Pima',
      'Pimaco Two',
      'Pinal',
      'Pine',
      'Pinedale',
      'Pinetop-Lakeside',
      'Pinon',
      'Pinta',
      'Pirtleville',
      'Pisinemo',
      'Polacca',
      'Portal',
      'Poston',
      'Prescott Valley',
      'Quartzsite',
      'Queen Creek',
      'Queen Valley',
      'Quijotoa',
      'Quivero',
      'Red Mesa',
      'Rillito',
      'Rio Rico',
      'Rock Point',
      'Rock Springs',
      'Roll',
      'Roosevelt',
      'Rough Rock',
      'Round Rock',
      'Rye',
      'Sacaton',
      'Sahuarita',
      'Saint David',
      'Saint Johns',
      'Saint Michaels',
      'Salina',
      'Salome',
      'San Simon',
      'San Tan Valley',
      'Sanders',
      'Sasabe',
      'Sawmill',
      'Schuchk',
      'Seba Dalkai',
      'Second Mesa',
      'Sedona',
      'Sehili',
      'Seligman',
      'Sells',
      'Sentinel',
      'Sevenmile',
      'Sheldon',
      'Shonto',
      'Show Low',
      'Sierra Vista',
      'Sil Nakya',
      'Skull Valley',
      'Snowflake',
      'Solomon',
      'Somerton',
      'Sonoita',
      'South Komelik',
      'South Tucson',
      'Spring Valley',
      'Springerville',
      'Stanfield',
      'Star Valley',
      'Steamboat',
      'Strawberry',
      'Summerhaven',
      'Sun City',
      'Sun City West',
      'Sun Lakes',
      'Sun Valley',
      'Sunflower',
      'Sunizona',
      'Supai',
      'Superior',
      'Surprise',
      'Swift Trail Junction',
      'Tanque Verde',
      'Tat Momoli',
      'Teec Nos Pos',
      'Tees Toh',
      'Tempe',
      'Thatcher',
      'Theba',
      'Three Points',
      'Tolani Lake',
      'Tolleson',
      'Toltec',
      'Tombstone',
      'Tonalea',
      'Tonopah',
      'Tonto Basin',
      'Tonto Village',
      'Top-of-the-World',
      'Topawa',
      'Topock',
      'Tortilla Flat',
      'Toyei',
      'Truxton',
      'Tuba City',
      'Tubac',
      'Tucson',
      'Tucson Estates',
      'Tumacacori',
      'Tusayan',
      'Two Guns',
      'Utting',
      'Vail',
      'Vaiva Vo',
      'Valentine',
      'Valle',
      'Ventana',
      'Verde Village',
      'Vicksburg',
      'Wagoner',
      'Wahak Hotrontk',
      'Walapai',
      'Washington Park',
      'Wellton',
      'Wenden',
      'Whetstone',
      'Whispering Pines',
      'White Cone',
      'White Mountain Lake',
      'Whiteriver',
      'Why',
      'Wickenburg',
      'Wide Ruins',
      'Wikieup',
      'Wilhoit',
      'Willaha',
      'Willcox',
      'Williamson',
      'Willow Canyon',
      'Willow Valley',
      'Window Rock',
      'Winkelman',
      'Winona',
      'Winslow',
      'Winslow West',
      'Wintersburg',
      'Wittmann',
      'Woodruff',
      'Yampai',
      'Yarnell',
      'Yucca',
      'Yuma',
    ],
    'US-AR': [
      'Abbott',
      'Adona',
      'Agnos',
      'Alabam',
      'Alco',
      'Alexander',
      'Alicia',
      'Alleene',
      'Allport',
      'Almond',
      'Almyra',
      'Alpena',
      'Altheimer',
      'Altus',
      'Amagon',
      'Amity',
      'Amy',
      'Anthonyville',
      'Antoine',
      'Aplin',
      'Arden',
      'Arkana',
      'Arkansas City',
      'Arkinda',
      'Armorel',
      'Ash Flat',
      'Ashdown',
      'Atkins',
      'Atlanta',
      'Aubrey',
      'Austin',
      'Auvergne',
      'Avilla',
      'Bald Knob',
      'Banner',
      'Barling',
      'Bassett',
      'Bates',
      'Bauxite',
      'Bay',
      'Bayou Meto',
      'Bearden',
      'Bee Branch',
      'Beebe',
      'Beedeville',
      'Beirne',
      'Bellefonte',
      'Ben Hur',
      'Bentonville',
      'Bergman',
      'Berryville',
      'Bethel Heights',
      'Bethesda',
      'Big Flat',
      'Big Fork',
      'Bigelow',
      'Biggers',
      'Bingen',
      'Birdsong',
      'Birta',
      'Biscoe',
      'Bismarck',
      'Black Fork',
      'Black Oak',
      'Black Rock',
      'Black Springs',
      'Blackton',
      'Blackwell',
      'Blevins',
      'Blue Ball',
      'Blue Eye',
      'Blue Mountain',
      'Bluff City',
      'Bluffton',
      'Blytheville',
      'Board Camp',
      'Bodcaw',
      'Boles',
      'Booneville',
      'Boswell',
      'Boydell',
      'Boydsville',
      'Brasfield',
      'Briarcliff',
      'Brickeys',
      'Briggsville',
      'Brinkley',
      'Brookland',
      'Bryant',
      'Buckner',
      'Bull Shoals',
      'Bunn',
      'Burdette',
      'Busch',
      'Butlerville',
      'Butterfield',
      'Cabot',
      'Caddo Gap',
      'Caddo Valley',
      'Caldwell',
      'Cale',
      'Calico Rock',
      'Calion',
      'Cammack Village',
      'Camp',
      'Campbell Station',
      'Canfield',
      'Caraway',
      'Carthage',
      'Casa',
      'Cash',
      'Cass',
      'Casscoe',
      'Cato',
      'Caulksville',
      'Cauthron',
      'Cave City',
      'Cave Springs',
      'Cedarville',
      'Center',
      'Center Hill',
      'Center Ridge',
      'Centerton',
      'Centerville',
      'Central City',
      'Chatfield',
      'Cherokee City',
      'Cherokee Village',
      'Cherry Valley',
      'Chickalah',
      'Chicot',
      'Chidester',
      'Chismville',
      'Clarkedale',
      'Clarkridge',
      'Clarksville',
      'Clifty',
      'Clow',
      'Coal Hill',
      'College City',
      'College Heights',
      'College Station',
      'Collins',
      'Colt',
      'Compton',
      'Conway',
      'Cord',
      'Corinth',
      'Cornerstone',
      'Cornerville',
      'Corning',
      'Cotter',
      'Cotton Plant',
      'Cove',
      'Coy',
      'Crawfordsville',
      'Crocketts Bluff',
      'Crossett',
      'Cushman',
      'Cypert',
      'Daisy',
      'Dalark',
      'Dalton',
      'Damascus',
      'Dardanelle',
      'Datto',
      'De Ann',
      'De Queen',
      'De Valls Bluff',
      'De Witt',
      'Deckerville',
      'Deer',
      'Delaplaine',
      'Delaware',
      'Delight',
      'Dell',
      'Dennard',
      'Denning',
      'Dermott',
      'Des Arc',
      'Desha',
      'Detonti',
      'Diamond City',
      'Diaz',
      'Dierks',
      'Doddridge',
      'Donaldson',
      'Driggs',
      'Dumas',
      'Durham',
      'Dutch Mills',
      'Dyer',
      'Dyess',
      'Eagle Mills',
      'Earle',
      'East Camden',
      'East End',
      'Edmondson',
      'Elaine',
      'Elkins',
      'Elm Springs',
      'Emerson',
      'Emmet',
      'England',
      'Enola',
      'Etowah',
      'Eudora',
      'Eureka Springs',
      'Evening Shade',
      'Fair Oaks',
      'Fairfield Bay',
      'Faith',
      'Falcon',
      'Fargo',
      'Farmington',
      'Felsenthal',
      'Felton',
      'Ferndale',
      'Fiftysix',
      'Fisher',
      'Fitzhugh',
      'Flag',
      'Flippin',
      'Floral',
      'Floyd',
      'Fordyce',
      'Foreman',
      'Forrest City',
      'Fort Douglas',
      'Fouke',
      'Fountain Hill',
      'Fountain Lake',
      'Fourche',
      'Friendship',
      'Gamaliel',
      'Garfield',
      'Gassville',
      'Genoa',
      'Gentry',
      'Gifford',
      'Gillett',
      'Gillham',
      'Gilmore',
      'Goodwin',
      'Gosnell',
      'Gould',
      'Grand Glaise',
      'Grannis',
      'Grapevine',
      'Gravelly',
      'Gravette',
      'Grays',
      'Green Forest',
      'Greenbrier',
      'Greenfield',
      'Greenland',
      'Greenway',
      'Greers Ferry',
      'Gregory',
      'Grider',
      'Griffithville',
      'Grubbs',
      'Guion',
      'Gum Springs',
      'Gurdon',
      'Guy',
      'Hackett',
      'Hagarville',
      'Halley',
      'Halliday',
      'Hamburg',
      'Hardy',
      'Harmony',
      'Harrell',
      'Harriet',
      'Harrisburg',
      'Harrison',
      'Hartman',
      'Haskell',
      'Hatfield',
      'Hattieville',
      'Havana',
      'Haynes',
      'Heber Springs',
      'Hector',
      'Helena-West Helena',
      'Henderson',
      'Hensley',
      'Hickory Plains',
      'Hickory Ridge',
      'Higden',
      'Higginson',
      'Highfill',
      'Hillemann',
      'Hindsville',
      'Hiram',
      'Hiwasse',
      'Holiday Island',
      'Holland',
      'Holly Grove',
      'Holly Springs',
      'Hon',
      'Hopper',
      'Horatio',
      'Horseshoe Bend',
      'Horseshoe Lake',
      'Hot Springs',
      'Hot Springs Village',
      'Howell',
      'Hoxie',
      'Humnoke',
      'Humphrey',
      'Huntington',
      'Huttig',
      'Ida',
      'Imboden',
      'Ingalls',
      'Ivan',
      'Jacksonport',
      'Japton',
      'Jefferson',
      'Jennette',
      'Jennie',
      'Jersey',
      'Jerusalem',
      'Jessieville',
      'Joiner',
      'Jonesboro',
      'Judsonia',
      'Junction City',
      'Kedron',
      'Keiser',
      'Kensett',
      'Keo',
      'Kiblah',
      'Kibler',
      'Kingsland',
      'Kirby',
      'Knobel',
      'La Grange',
      'Ladelle',
      'Lafe',
      'Lake City',
      'Lake Hamilton',
      'Lake Village',
      'Lamar',
      'Lambrook',
      'Landis',
      'Landmark',
      'Laneburg',
      'Larue',
      'Lavaca',
      'Leachville',
      'Lead Hill',
      'Lee Creek',
      'Leola',
      'Lepanto',
      'Leslie',
      'Letona',
      'Lewisville',
      'Lexa',
      'Limestone',
      'Little Flock',
      'Little Rock',
      'Lockesburg',
      'Lono',
      'Lonoke',
      'Lonsdale',
      'Lost Bridge Village',
      'Louann',
      'Lowell',
      'Lowry',
      'Lundell',
      'Lurton',
      'Luxora',
      'Mabelvale',
      'Magazine',
      'Magness',
      'Magnet Cove',
      'Magnolia',
      'Mammoth Spring',
      'Mandeville',
      'Marble',
      'Marche',
      'Marianna',
      'Marie',
      'Marked Tree',
      'Marmaduke',
      'Martinville',
      'Marvell',
      'Maumelle',
      'Mayflower',
      'Maynard',
      'Maysville',
      'McAlmont',
      'McCaskill',
      'McCrory',
      'McDougal',
      'McGehee',
      'McKamie',
      'McNab',
      'McNeil',
      'McRae',
      'Melbourne',
      'Mena',
      'Menifee',
      'Meyers',
      'Mineral Springs',
      'Minturn',
      'Mist',
      'Mitchellville',
      'Moark',
      'Monette',
      'Monroe',
      'Monticello',
      'Moorefield',
      'Moreland',
      'Morganton',
      'Moro',
      'Moro Bay',
      'Morrilton',
      'Morrison Bluff',
      'Morriston',
      'Moscow',
      'Mount Holly',
      'Mount Ida',
      'Mount Judea',
      'Mountain Home',
      'Mountain Pine',
      'Mountain Valley',
      'Mountain View',
      'Mountainburg',
      'Mulberry',
      'Murfreesboro',
      'Murray',
      'Myron',
      'Nashville',
      'Nathan',
      'Natural Dam',
      'Natural Steps',
      'New Blaine',
      'New Edinburg',
      'New London',
      'Newark',
      'Newburg',
      'Newell',
      'Newhope',
      'Nimmons',
      'Norfork',
      'Norman',
      'Norphlet',
      'North Crossett',
      'North Little Rock',
      "O'Kean",
      'Oak Grove Heights',
      'Oakgrove',
      'Oakhaven',
      'Oakland',
      'Oark',
      'Oden',
      'Ogden',
      'Ogemaw',
      'Oil Trough',
      'Okolona',
      'Ola',
      'Old Lexington',
      'Olvey',
      'Olyphant',
      'Oma',
      'Omaha',
      'Oneida',
      'Onyx',
      'Oppelo',
      'Osage',
      'Osceola',
      'Otwell',
      'Ouachita',
      'Owensville',
      'Ozan',
      'Ozone',
      'Palestine',
      'Palmyra',
      'Pangburn',
      'Paragould',
      'Paraloma',
      'Parkdale',
      'Parkers',
      'Parkin',
      'Paron',
      'Parthenon',
      'Patmos',
      'Patterson',
      'Pea Ridge',
      'Peach Orchard',
      'Pearcy',
      'Pearson',
      'Peel',
      'Penrose',
      'Perla',
      'Perrytown',
      'Pettigrew',
      'Pickens',
      'Piggott',
      'Pike City',
      'Pindall',
      'Pine Bluff',
      'Pineville',
      'Piney',
      'Pinnacle',
      'Plainview',
      'Pleasant Plains',
      'Plumerville',
      'Pocahontas',
      'Point Cedar',
      'Ponca',
      'Poplar Grove',
      'Portia',
      'Postelle',
      'Potter',
      'Pottsville',
      'Powhatan',
      'Poyen',
      'Prairie Creek',
      'Prairie Grove',
      'Prairie View',
      'Prattsville',
      'Prim',
      'Provo',
      'Pyatt',
      'Quitman',
      'Ramsey',
      'Ratcliff',
      'Ravenden',
      'Ravenden Springs',
      'Reader',
      'Readland',
      'Rector',
      'Red Star',
      'Redfield',
      'Reed',
      'Reyno',
      'Rhea',
      'Rison',
      'Rivervale',
      'Rockport',
      'Rockwell',
      'Roe',
      'Rogers',
      'Rohwer',
      'Rondo',
      'Rosboro',
      'Rose Bud',
      'Rosston',
      'Round Pond',
      'Rover',
      'Rudy',
      'Rule',
      'Sage',
      'Saint Charles',
      'Saint Francis',
      'Saint James',
      'Saint Joe',
      'Salado',
      'Salesville',
      'Salus',
      'Saratoga',
      'Schaal',
      'Scotland',
      'Scott',
      'Scottsville',
      'Scranton',
      'Searcy',
      'Shannon Hills',
      'Sheppard',
      'Sheridan',
      'Sherrill',
      'Sidon',
      'Siloam Springs',
      'Sims',
      'Smackover',
      'Smale',
      'Smithville',
      'Smyrna',
      'Snowball',
      'Social Hill',
      'South Lead Hill',
      'Sparkman',
      'Springtown',
      'Stamps',
      'Star City',
      'Staves',
      'Stephens',
      'Steprock',
      'Story',
      'Sturkie',
      'Success',
      'Sulphur Rock',
      'Sulphur Springs',
      'Summers',
      'Sunset',
      'Swain',
      'Sweet Home',
      'Swifton',
      'Sylvan Hills',
      'Tamo',
      'Tarry',
      'Texarkana',
      'Tichnor',
      'Tillar',
      'Tilton',
      'Timbo',
      'Tinsman',
      'Tokio',
      'Tollette',
      'Tomato',
      'Tontitown',
      'Traskwood',
      'Trumann',
      'Tucker',
      'Tuckerman',
      'Tull',
      'Tumbling Shoals',
      'Tupelo',
      'Turrell',
      'Twin Groves',
      'Tyro',
      'Tyronza',
      'Umpire',
      'Urbanette',
      'Valley Springs',
      'Van Buren',
      'Vandervoort',
      'Vanndale',
      'Vick',
      'Vilonia',
      'Vimy Ridge',
      'Violet Hill',
      'Wabash',
      'Wabbaseka',
      'Waldenburg',
      'Waldron',
      'Walnut Ridge',
      'Waltreak',
      'War Eagle',
      'Warm Springs',
      'Washburn',
      'Washington',
      'Watson',
      'Waveland',
      'Weathers',
      'Webb City',
      'Weiner',
      'Weldon',
      'Weona',
      'Wesley',
      'Wesson',
      'West Crossett',
      'West Fork',
      'West Helena',
      'West Memphis',
      'Western Grove',
      'Wheatley',
      'Whelen Springs',
      'White',
      'Whitehall',
      'Wickes',
      'Wideman',
      'Widener',
      'Wiederkehr Village',
      'Wild Cherry',
      'Williford',
      'Willisville',
      'Wilmar',
      'Wilson',
      'Winchester',
      'Winthrop',
      'Witter',
      'Witts Springs',
      'Wolf Bayou',
      'Woodberry',
      'Woodson',
      'Wooster',
      'Wrightsville',
      'Wynne',
      'Y City',
      'Yale',
      'Yancopin',
      'Yarborough Landing',
      'Yellville',
      'Yorktown',
      'Zinc',
      'Zion',
    ],
    'US-CA': [
      'Acampo',
      'Adelanto',
      'Adin',
      'Agoura',
      'Agoura Hills',
      'Aguanga',
      'Ahwahnee',
      'Alamo',
      'Alamo Oaks',
      'Alberhill',
      'Albion',
      'Alderpoint',
      'Alhambra',
      'Aliso Viejo',
      'Alleghany',
      'Allendale',
      'Allensworth',
      'Almanor',
      'Alondra Park',
      'Alpaugh',
      'Alpine Village',
      'Alta',
      'Alta Loma',
      'Alta Sierra',
      'Altadena',
      'Altaville',
      'Alturas',
      'Alum Rock',
      'Amador City',
      'Amboy',
      'American Canyon',
      'Amesti',
      'Anaheim',
      'Anchor Bay',
      'Angels Camp',
      'Angiola',
      'Angwin',
      'Antelope',
      'Antioch',
      'Anza',
      'Apple Valley',
      'Applegate',
      'Aptos',
      'Arbuckle',
      'Arcata',
      'Arden Town',
      'Armona',
      'Arnold',
      'Aromas',
      'Arrowbear Lake',
      'Arrowhead Highlands',
      'Arroyo Grande',
      'Artois',
      'Arvin',
      'Aspen Springs',
      'Atascadero',
      'Atolia',
      'Atwater',
      'Atwood',
      'Auberry',
      'Auburn Lake Trails',
      'August',
      'Avalon',
      'Avenal',
      'Avery',
      'Avila Beach',
      'Avocado Heights',
      'Azusa',
      'Baker',
      'Bakersfield',
      'Balance Rock',
      'Baldwin Park',
      'Ballard',
      'Ballico',
      'Banning',
      'Barstow',
      'Bartlett',
      'Bass Lake',
      'Bay Point',
      'Bayview',
      'Bear Valley',
      'Bear Valley Springs',
      'Beckwourth',
      'Belden',
      'Bell',
      'Bell Gardens',
      'Bellflower',
      'Belltown',
      'Belmont',
      'Belvedere',
      'Benbow',
      'Bend',
      'Benicia',
      'Berenda',
      'Berkeley',
      'Bermuda Dunes',
      'Berry Creek',
      'Bethel Island',
      'Betteravia',
      'Beverly Hills',
      'Bieber',
      'Big Bar',
      'Big Bear City',
      'Big Bear Lake',
      'Big Bend',
      'Big Creek',
      'Big Lagoon',
      'Big Oak Flat',
      'Big Pine',
      'Big River',
      'Big Sur',
      'Biggs',
      'Biola',
      'Birds Landing',
      'Bishop',
      'Blackhawk',
      'Blairsden',
      'Blocksburg',
      'Bloomfield',
      'Bloomington',
      'Blue Canyon',
      'Blue Jay',
      'Blue Lake',
      'Blythe',
      'Bodega',
      'Bodega Bay',
      'Bodfish',
      'Bolinas',
      'Bombay Beach',
      'Bonita',
      'Bonny Doon',
      'Bonsall',
      'Boonville',
      'Bootjack',
      'Boron',
      'Boronda',
      'Borrego Springs',
      'Bostonia',
      'Boulder Creek',
      'Boulevard',
      'Bowles',
      'Boyes Hot Springs',
      'Bradbury',
      'Brawley',
      'Bray',
      'Brea',
      'Broadmoor',
      'Brookdale',
      'Brooktrails',
      'Brownsville',
      'Bryn Mawr',
      'Buck Meadows',
      'Buckhorn',
      'Bucks Lake',
      'Buellton',
      'Buena Park',
      'Burbank',
      'Burlingame',
      'Burney',
      'Burnt Ranch',
      'Burrel',
      'Butte Meadows',
      'Buttonwillow',
      'Byron',
      'Bystrom',
      'Cabazon',
      'Cadiz',
      'Cajon Junction',
      'Calabasas',
      'Calavo Gardens',
      'Calexico',
      'Caliente',
      'California City',
      'California Hot Springs',
      'California Pines',
      'Calimesa',
      'Calipatria',
      'Calistoga',
      'Callahan',
      'Callender',
      'Calpella',
      'Calpine',
      'Calwa',
      'Camanche Village',
      'Camarillo',
      'Cambria',
      'Cambrian Park',
      'Cameron Park',
      'Camino Tassajara',
      'Camp Nelson',
      'Camptonville',
      'Canby',
      'Cantil',
      'Cantua Creek',
      'Canyon',
      'Canyon Lake',
      'Canyondam',
      'Capistrano Beach',
      'Capitola',
      'Cardiff-by-the-Sea',
      'Caribou',
      'Carlsbad',
      'Carmel Valley',
      'Carmel Valley Village',
      'Carmel-by-the-Sea',
      'Carmet',
      'Carmichael',
      'Carnelian Bay',
      'Carpinteria',
      'Carson',
      'Caruthers',
      'Casa Conejo',
      'Casa de Oro',
      'Casitas Springs',
      'Casmalia',
      'Caspar',
      'Cassel',
      'Castaic',
      'Castella',
      'Castle Park',
      'Castro Valley',
      'Castroville',
      'Cathedral City',
      'Catheys Valley',
      'Cayucos',
      'Cazadero',
      'Cecilville',
      'Cedar Glen',
      'Cedar Grove',
      'Cedar Ridge',
      'Cedar Slope',
      'Cedarpines Park',
      'Challenge',
      'Channel Islands Beach',
      'Charter Oak',
      'Cherokee Strip',
      'Cherryland',
      'Chico',
      'China Lake Acres',
      'Chinese Camp',
      'Chino Hills',
      'Cholame',
      'Chowchilla',
      'Chualar',
      'Chubbuck',
      'Chula Vista',
      'Cima',
      'Citrus',
      'Citrus Heights',
      'City Terrace',
      'Clarksburg',
      'Clear Creek',
      'Clearlake',
      'Clearlake Oaks',
      'Cleone',
      'Clipper Mills',
      'Clovis',
      'Coachella',
      'Coalinga',
      'Coarsegold',
      'Cobb',
      'Coffee Creek',
      'Cohasset',
      'Cold Springs',
      'Coleville',
      'Colfax',
      'Collierville',
      'Colma',
      'Coloma',
      'Colton',
      'Colusa',
      'Commerce',
      'Comptche',
      'Concow',
      'Conejo',
      'Contra Costa Centre',
      'Copperopolis',
      'Corcoran',
      'Cornell',
      'Corona',
      'Corralitos',
      'Corte Madera',
      'Costa Mesa',
      'Cotati',
      'Coto De Caza',
      'Cotton Center',
      'Coulterville',
      'Country Club',
      'Covina',
      'Cowan Heights',
      'Coyote Wells',
      'Crafton',
      'Crannell',
      'Crescent City',
      'Crescent Mills',
      'Cressey',
      'Crest',
      'Crestline',
      'Crockett',
      'Cromberg',
      'Crows Landing',
      'Crucero',
      'Cudahy',
      'Culver City',
      'Cupertino',
      'Cutler',
      'Cutten',
      'Cuyama',
      'Daggett',
      'Daly City',
      'Dana Point',
      'Daphnedale Park',
      'Darwin',
      'Davis',
      'Day Valley',
      'Deep Springs',
      'Del Aire',
      'Del Dios',
      'Del Mar',
      'Del Monte Forest',
      'Del Rey',
      'Del Rey Oaks',
      'Del Rio',
      'Del Rosa',
      'Delano',
      'Delft Colony',
      'Delleker',
      'Denair',
      'Derby Acres',
      'Desert Center',
      'Desert Edge',
      'Desert Hot Springs',
      'Desert Shores',
      'Desert View Highlands',
      'Devore',
      'Di Giorgio',
      'Diablo',
      'Diablo Grande',
      'Diamond Bar',
      'Diamond Springs',
      'Dillon Beach',
      'Dinuba',
      'Discovery Bay',
      'Dixon',
      'Dobbins',
      'Dogtown',
      'Dollar Point',
      'Dominguez',
      'Dorrington',
      'Dorris',
      'Dos Palos',
      'Dos Palos Y',
      'Dos Rios',
      'Douglas City',
      'Downey',
      'Downieville',
      'Doyle',
      'Drytown',
      'Duarte',
      'Ducor',
      'Dunlap Acres',
      'Dunnigan',
      'Dunsmuir',
      'Dustin Acres',
      'Dutch Flat',
      'Eagleville',
      'Earlimart',
      'East Foothills',
      'East Hemet',
      'East Highlands',
      'East La Mirada',
      'East Los Angeles',
      'East Nicolaus',
      'East Oakdale',
      'East Orosi',
      'East Palo Alto',
      'East Pasadena',
      'East Porterville',
      'East Quincy',
      'East Rancho Dominguez',
      'East Richmond Heights',
      'East San Gabriel',
      'East Shore',
      'East Sonora',
      'East Whittier',
      'Easton',
      'Eastvale',
      'Edgemont',
      'Edgewood',
      'Edison',
      'Edmundson Acres',
      'Edna',
      'El Cajon',
      'El Casco',
      'El Dorado Hills',
      'El Granada',
      'El Nido',
      'El Portal',
      'El Rio',
      'El Segundo',
      'El Sobrante',
      'El Verano',
      'Elderwood',
      'Elk',
      'Elk Creek',
      'Elk Grove',
      'Elkhorn',
      'Elmira',
      'Elverta',
      'Emerald Bay',
      'Emerald Lake Hills',
      'Emeryville',
      'Emigrant Gap',
      'Empire',
      'Encinitas',
      'Escalon',
      'Esparto',
      'Etna',
      'Eucalyptus Hills',
      'Fairfax',
      'Fairhaven',
      'Fairmead',
      'Fall River Mills',
      'Fallbrook',
      'Farmersville',
      'Fellows',
      'Fenner',
      'Fernbrook',
      'Fetters Hot Springs',
      'Fiddletown',
      'Fieldbrook',
      'Fields Landing',
      'Fillmore',
      'Firebaugh',
      'Fish Camp',
      'Flinn Springs',
      'Florin',
      'Floriston',
      'Flournoy',
      'Folsom',
      'Fontana',
      'Foothill Farms',
      'Forbestown',
      'Ford City',
      'Forest Knolls',
      'Forest Meadows',
      'Forest Ranch',
      'Foresthill',
      'Fort Bidwell',
      'Fort Bragg',
      'Fort Dick',
      'Fort Irwin',
      'Fort Jones',
      'Foster City',
      'Fountain Valley',
      'Fowler',
      'Frazier Park',
      'Freedom',
      'Freeport',
      'Fremont',
      'French Camp',
      'French Gulch',
      'Friant',
      'Fuller Acres',
      'Fullerton',
      'Furnace Creek',
      'Galt',
      'Garberville',
      'Garden Acres',
      'Garden Farms',
      'Garden Grove',
      'Gardena',
      'Garey',
      'Garlock',
      'Garnet',
      'Gasquet',
      'Gaviota',
      'Gazelle',
      'Gerber',
      'Geyserville',
      'Gilroy',
      'Glamis',
      'Glen Avon',
      'Glen Ellen',
      'Glendora',
      'Glenn',
      'Glenview',
      'Goffs',
      'Golden Hills',
      'Goleta',
      'Gonzales',
      'Goodyears Bar',
      'Gorman',
      'Graeagle',
      'Grand Terrace',
      'Grangeville',
      'Granite Bay',
      'Granite Hills',
      'Graniteville',
      'Graton',
      'Greeley Hill',
      'Green Acres',
      'Green Valley Lake',
      'Greenacres',
      'Greenbrae',
      'Greenhorn',
      'Greenview',
      'Grenada',
      'Gridley',
      'Grossmont',
      'Groveland',
      'Grover Beach',
      'Guasti',
      'Guerneville',
      'Gustine',
      'Hacienda Heights',
      'Hackamore',
      'Haiwee',
      'Hamilton Branch',
      'Hamilton City',
      'Hanford',
      'Happy Camp',
      'Harbison Canyon',
      'Hardwick',
      'Hat Creek',
      'Hawaiian Gardens',
      'Hawthorne',
      'Hayfork',
      'Hayward',
      'Healdsburg',
      'Helendale',
      'Helm',
      'Hemet',
      'Herald',
      'Hercules',
      'Herlong',
      'Hermosa Beach',
      'Herndon',
      'Hesperia',
      'Hickman',
      'Hidden Hills',
      'Hidden Meadows',
      'Hidden Valley Lake',
      'Highgrove',
      'Hilmar',
      'Hilt',
      'Hinkley',
      'Hiouchi',
      'Hobergs',
      'Hodge',
      'Hollister',
      'Home Garden',
      'Home Gardens',
      'Homeland',
      'Honcut',
      'Honeydew',
      'Hood',
      'Hoopa',
      'Hopland',
      'Hornbrook',
      'Hornitos',
      'Hughson',
      'Humboldt Hill',
      'Huntington Beach',
      'Huntington Park',
      'Huron',
      'Hyampom',
      'Hydesville',
      'Idlewild',
      'Idria',
      'Idyllwild',
      'Ignacio',
      'Igo',
      'Imperial',
      'Imperial Beach',
      'Independence',
      'Indian Falls',
      'Indianola',
      'Indio',
      'Indio Hills',
      'Industry',
      'Ingot',
      'Inyokern',
      'Ione',
      'Iron Horse',
      'Irvine',
      'Irwin',
      'Irwindale',
      'Isla Vista',
      'Island Mountain',
      'Isleton',
      'Ivanpah',
      'Jacumba Hot Springs',
      'Jamacha Junction',
      'Jamul',
      'Janesville',
      'Jenner',
      'Jesmond Dene',
      'Johannesburg',
      'Johnsondale',
      'Johnstonville',
      'Johnstown',
      'Johnsville',
      'Joshua Tree',
      'Julian',
      'June Lake',
      'Kaweah',
      'Keddie',
      'Keeler',
      'Keene',
      'Kelseyville',
      'Kentfield',
      'Kenwood',
      'Kerman',
      'Kernville',
      'Keswick',
      'Kettleman City',
      'Keyes',
      'Kilkare Woods',
      'King City',
      'Kings Beach',
      'Kingsburg',
      'Kingvale',
      'Kirkwood',
      'Klamath',
      'Klamath River',
      'Kneeland',
      'Knights Landing',
      'Knightsen',
      'Komandorski Village',
      'Korbel',
      'Kramer Junction',
      'Kyburz',
      'La Cañada Flintridge',
      'La Crescenta',
      'La Habra',
      'La Habra Heights',
      'La Honda',
      'La Mirada',
      'La Porte',
      'La Presa',
      'La Puente',
      'La Quinta',
      'La Riviera',
      'La Selva Beach',
      'La Verne',
      'La Vina',
      'Ladera',
      'Ladera Heights',
      'Ladera Ranch',
      'Laguna Beach',
      'Laguna Hills',
      'Laguna Niguel',
      'Laguna Woods',
      'Lagunitas',
      'Lake Almanor Country Club',
      'Lake Almanor Peninsula',
      'Lake Almanor West',
      'Lake Arrowhead',
      'Lake Davis',
      'Lake Elsinore',
      'Lake Forest',
      'Lake Hughes',
      'Lake Isabella',
      'Lake Los Angeles',
      'Lake Nacimiento',
      'Lake San Marcos',
      'Lake Wildwood',
      'Lake of the Pines',
      'Lakehead',
      'Lakeland Village',
      'Lakeport',
      'Lakeside',
      'Lakewood',
      'Lamoine',
      'Lanare',
      'Lancaster',
      'Las Lomas',
      'Lathrop',
      'Laton',
      'Lawndale',
      'Laws',
      'Laytonville',
      'Le Grand',
      'Lebec',
      'Lee Vining',
      'Leggett',
      'Lemon Grove',
      'Lemon Heights',
      'Lemoncove',
      'Lemoore',
      'Lennox',
      'Lenwood',
      'Leona Valley',
      'Leucadia',
      'Lexington Hills',
      'Likely',
      'Lincoln Acres',
      'Lincoln Village',
      'Linda',
      'Lindcove',
      'Lindsay',
      'Litchfield',
      'Little Grass Valley',
      'Little Lake',
      'Little Valley',
      'Littlerock',
      'Live Oak',
      'Live Oak Springs',
      'Livermore',
      'Lockeford',
      'Lodoga',
      'Loleta',
      'Loma Linda',
      'Loma Mar',
      'Loma Rica',
      'Lomita',
      'Lompico',
      'Lompoc',
      'Lone Pine',
      'Long Barn',
      'Long Beach',
      'Lookout',
      'Loomis',
      'Los Alamitos',
      'Los Altos Hills',
      'Los Banos',
      'Los Berros',
      'Los Gatos',
      'Los Medanos',
      'Los Nietos',
      'Los Osos',
      'Los Serranos',
      'Los Trancos Woods',
      'Lost Hills',
      'Lower Lake',
      'Loyalton',
      'Lucas Valley',
      'Lucerne',
      'Lucerne Valley',
      'Lynwood',
      'Lynwood Hills',
      'Lytle Creek',
      'Mabie',
      'Macdoel',
      'Mad River',
      'Madeline',
      'Madera Acres',
      'Magalia',
      'Malaga',
      'Malibu',
      'Maltby',
      'Mammoth Lakes',
      'Manhattan Beach',
      'Manteca',
      'Manton',
      'Marin City',
      'Marina',
      'Marina del Rey',
      'Marinwood',
      'Mariposa',
      'Markleeville',
      'Martell',
      'Martinez',
      'Marysville',
      'Maxwell',
      'Mayflower Village',
      'Maywood',
      'McArthur',
      'McCloud',
      'McFarland',
      'McKinleyville',
      'McKittrick',
      'Mead Valley',
      'Meadow Valley',
      'Meadow Vista',
      'Mecca',
      'Meeks Bay',
      'Meiners Oaks',
      'Mendocino',
      'Mendota',
      'Menlo Park',
      'Merced',
      'Meridian',
      'Mesa Grande',
      'Mesa Verde',
      'Mesa Vista',
      'Mettler',
      'Mexican Colony',
      'Mi-Wuk Village',
      'Middletown',
      'Midpines',
      'Midway City',
      'Milford',
      'Mill Valley',
      'Millbrae',
      'Milpitas',
      'Mineral',
      'Minkler',
      'Mira Loma',
      'Mira Monte',
      'Miracle Hot Springs',
      'Mission Canyon',
      'Mission Hills',
      'Mission Viejo',
      'Modesto',
      'Mohawk Vista',
      'Mojave',
      'Mokelumne Hill',
      'Monmouth',
      'Mono City',
      'Mono Vista',
      'Monolith',
      'Monrovia',
      'Monson',
      'Monta Vista',
      'Montalvin',
      'Montara',
      'Montclair',
      'Monte Rio',
      'Monte Sereno',
      'Montecito',
      'Monterey',
      'Monterey Park',
      'Montgomery Creek',
      'Montpelier',
      'Moonstone',
      'Moorpark',
      'Morada',
      'Moraga',
      'Moreno Valley',
      'Morgan Hill',
      'Morongo Valley',
      'Morro Bay',
      'Mortmar',
      'Moss Beach',
      'Moss Landing',
      'Mount Baldy',
      'Mount Eden',
      'Mount Hebron',
      'Mount Hermon',
      'Mount Laguna',
      'Mount Shasta',
      'Mountain Center',
      'Mountain Gate',
      'Mountain House',
      'Mountain Mesa',
      'Mountain Ranch',
      'Mountain View Acres',
      'Muir Beach',
      'Murphys',
      'Murrieta',
      'Muscoy',
      'Myers Flat',
      'Myrtletown',
      'Napa',
      'Narod',
      'National City',
      'Nevada City',
      'New Cuyama',
      'Newberry Springs',
      'Newcastle',
      'Newhall',
      'Newport Beach',
      'Nicasio',
      'Nicolaus',
      'Niland',
      'Nipinnawasee',
      'Nipomo',
      'Nipton',
      'Norco',
      'Nord',
      'North Auburn',
      'North Edwards',
      'North El Monte',
      'North Fair Oaks',
      'North Highlands',
      'North San Juan',
      'North Tustin',
      'Norwalk',
      'Novato',
      'Nubieber',
      'Nuevo',
      "O'Neals",
      'Oak Glen',
      'Oak Hills',
      'Oak Park',
      'Oak View',
      'Oakdale',
      'Oakhurst',
      'Oakley',
      'Oasis',
      'Occidental',
      'Oceano',
      'Oceanside',
      'Ocotillo',
      'Ogilby',
      'Oildale',
      'Ojai',
      'Olancha',
      'Old Station',
      'Olivehurst',
      'Omo Ranch',
      'Ontario',
      'Opal Cliffs',
      'Orange Cove',
      'Orange Park Acres',
      'Orangevale',
      'Orcutt',
      'Orick',
      'Orinda',
      'Orland',
      'Oro Grande',
      'Orosi',
      'Oroville',
      'Otay',
      'Otterbein',
      'Owenyo',
      'Oxnard',
      'Pacheco',
      'Pacific Grove',
      'Pacifica',
      'Paicines',
      'Pajaro',
      'Pala',
      'Palm Desert',
      'Palm Desert Country',
      'Palm Springs',
      'Palmdale',
      'Palo Alto',
      'Palo Cedro',
      'Palomar Park',
      'Palos Verdes Estates',
      'Panorama Heights',
      'Paradise Park',
      'Paramount',
      'Parkfield',
      'Parksdale',
      'Parkway',
      'Parkwood',
      'Parlier',
      'Pasatiempo',
      'Paskenta',
      'Paso Robles',
      'Patton Village',
      'Paynes Creek',
      'Pearblossom',
      'Pearsonville',
      'Pebble Beach',
      'Pedley',
      'Penn Valley',
      'Penngrove',
      'Penryn',
      'Perez',
      'Perris',
      'Pescadero',
      'Petaluma',
      'Peters',
      'Phelan',
      'Phillipsville',
      'Philo',
      'Phoenix Lake',
      'Pico Rivera',
      'Piercy',
      'Pike',
      'Pilot Hill',
      'Pine Cove',
      'Pine Flat',
      'Pine Grove',
      'Pine Hills',
      'Pine Mountain Club',
      'Pine Valley',
      'Pinehurst',
      'Pineridge',
      'Pinole',
      'Piru',
      'Pismo Beach',
      'Pittsburg',
      'Pixley',
      'Piñon Hills',
      'Placerville',
      'Planada',
      'Plaster City',
      'Pleasant Hill',
      'Pleasanton',
      'Plumas Eureka',
      'Plumas Lake',
      'Point Arena',
      'Point Reyes Station',
      'Pollock Pines',
      'Pomona',
      'Pond',
      'Ponderosa',
      'Pondosa',
      'Pope Valley',
      'Poplar',
      'Port Costa',
      'Port Hueneme',
      'Porterville',
      'Portola',
      'Portola Valley',
      'Posey',
      'Poso Park',
      'Potrero',
      'Potter Valley',
      'Poway',
      'Proberta',
      'Prunedale',
      'Quartz Hill',
      'Quincy',
      'Rail Road Flat',
      'Raisin City',
      'Ramona',
      'Rancho Calaveras',
      'Rancho Cordova',
      'Rancho Cucamonga',
      'Rancho Mirage',
      'Rancho Murieta',
      'Rancho Palos Verdes',
      'Rancho Rinconada',
      'Rancho San Diego',
      'Rancho Santa Fe',
      'Rancho Santa Margarita',
      'Rancho Tehama Reserve',
      'Randsburg',
      'Ravendale',
      'Red Bluff',
      'Red Mountain',
      'Redcrest',
      'Redding',
      'Redlands',
      'Redondo Beach',
      'Redway',
      'Redwood City',
      'Redwood Terrace',
      'Redwood Valley',
      'Reedley',
      'Requa',
      'Rheem',
      'Rice',
      'Richfield',
      'Richgrove',
      'Richvale',
      'Ridgecrest',
      'Ridgemark',
      'Rimforest',
      'Rio Del Mar',
      'Rio Dell',
      'Rio Linda',
      'Rio Oso',
      'Rio Vista',
      'Ripley',
      'Ripon',
      'River Pines',
      'Riverbank',
      'Riverdale',
      'Riverdale Park',
      'Riverview Farms',
      'Roads End',
      'Robbins',
      'Rocklin',
      'Rohnert Park',
      'Rohnerville',
      'Rolinda',
      'Rolling Hills',
      'Rolling Hills Estates',
      'Rollingwood',
      'Romoland',
      'Rosamond',
      'Roseland',
      'Rosemead',
      'Rosemont',
      'Roseville',
      'Rossmoor',
      'Rough and Ready',
      'Round Mountain',
      'Round Valley',
      'Rowland Heights',
      'Rubidoux',
      'Running Springs',
      'Russell City',
      'Ruth',
      'Rutherford',
      'Saint Helena',
      'Salida',
      'Salmon Creek',
      'Salton City',
      'Salton Sea Beach',
      'Salyer',
      'Samoa',
      'San Andreas',
      'San Anselmo',
      'San Antonio Heights',
      'San Ardo',
      'San Augustine',
      'San Bruno',
      'San Diego Country Estates',
      'San Geronimo',
      'San Juan Capistrano',
      'San Juan Hot Springs',
      'San Leandro',
      'San Luis Obispo',
      'San Luis Rey',
      'San Marino',
      'San Martin',
      'San Pasqual',
      'San Quentin',
      'San Ramon',
      'San Simeon',
      'Sand City',
      'Sanger',
      'Santa Ana Heights',
      'Santa Clarita',
      'Santa Fe Springs',
      'Santa Margarita',
      'Santa Monica',
      'Santa Paula',
      'Santa Susana',
      'Santa Venetia',
      'Santa Ynez',
      'Santee',
      'Saranap',
      'Saticoy',
      'Sattley',
      'Saugus',
      'Sausalito',
      'Sawyers Bar',
      'Scotia',
      'Scotts Valley',
      'Sea Ranch',
      'Seacliff',
      'Seal Beach',
      'Searles',
      'Searles Valley',
      'Seaside',
      'Sebastopol',
      'Seeley',
      'Sespe',
      'Seville',
      'Shackelford',
      'Shafter',
      'Shandon',
      'Shasta',
      'Shasta Lake',
      'Shaver Lake',
      'Shelter Cove',
      'Shingle Springs',
      'Shingletown',
      'Shively',
      'Shore Acres',
      'Shoshone',
      'Sierra Brooks',
      'Sierra City',
      'Sierra Madre',
      'Sierra Village',
      'Sierraville',
      'Signal Hill',
      'Silver City',
      'Silver Lakes',
      'Silverado',
      'Simi Valley',
      'Sisquoc',
      'Sky Londa',
      'Sky Valley',
      'Skyforest',
      'Sleepy Hollow',
      'Sloat',
      'Smartsville',
      'Smiley Park',
      'Smith Corner',
      'Smith River',
      'Snelling',
      'Soda Bay',
      'Soda Springs',
      'Solana Beach',
      'Solromar',
      'Solvang',
      'Somes Bar',
      'Somis',
      'Sonoma',
      'Soquel',
      'Soulsbyville',
      'South Dos Palos',
      'South El Monte',
      'South Fontana',
      'South Gate',
      'South Laguna',
      'South Lake',
      'South Lake Tahoe',
      'South Oroville',
      'South Pasadena',
      'South San Francisco',
      'South San Gabriel',
      'South San Jose Hills',
      'South Taft',
      'South Whittier',
      'Spreckels',
      'Spring Valley Lake',
      'Squaw Valley',
      'Squirrel Mountain Valley',
      'Stallion Springs',
      'Standish',
      'Stanford',
      'Stevinson',
      'Stinson Beach',
      'Stirling City',
      'Stonyford',
      'Storrie',
      'Sugarloaf Mountain Park',
      'Sugarloaf Saw Mill',
      'Sugarloaf Village',
      'Suisun',
      'Sultana',
      'Suncrest',
      'Sunnymead',
      'Sunnyslope',
      'Sunnyvale',
      'Sunol',
      'Surfside',
      'Susanville',
      'Sutter',
      'Sutter Creek',
      'Taft',
      'Taft Heights',
      'Tahoe City',
      'Tahoe Vista',
      'Tahoma',
      'Tajiguas',
      'Talmage',
      'Tara Hills',
      'Tarpey Village',
      'Taylorsville',
      'Tecopa',
      'Tehachapi',
      'Tehama',
      'Temecula',
      'Temelec',
      'Temple City',
      'Templeton',
      'Terminous',
      'Termo',
      'Terra Bella',
      'Terra Linda',
      'Thermal',
      'Thermalito',
      'Thousand Oaks',
      'Thousand Palms',
      'Three Rocks',
      'Tiburon',
      'Tionesta',
      'Tipton',
      'Tobin',
      'Tollhouse',
      'Tomales',
      'Toms Place',
      'Tonyville',
      'Top of the World',
      'Topanga',
      'Topaz',
      'Toro Canyon',
      'Torrance',
      'Trabuco Canyon',
      'Trabuco Highlands',
      'Tranquillity',
      'Traver',
      'Tres Pinos',
      'Trimmer',
      'Trinity Center',
      'Trinity Village',
      'Trona',
      'Trowbridge',
      'Truckee',
      'Tulare',
      'Tulelake',
      'Tuolumne',
      'Tuolumne City',
      'Tupman',
      'Turlock',
      'Tustin',
      'Tuttle',
      'Tuttletown',
      'Twain',
      'Twain Harte',
      'Twentynine Palms',
      'Twin Lakes',
      'Twin Peaks',
      'Ukiah',
      'Union City',
      'Upland',
      'Upper Lake',
      'Vacaville',
      'Val Verde',
      'Valinda',
      'Valle Vista',
      'Vallecito',
      'Vallejo',
      'Valley Acres',
      'Valley Center',
      'Valley Ford',
      'Valley Home',
      'Valley Ranch',
      'Valley View Park',
      'Valley Wells',
      'Vandenberg Village',
      'Verdemont',
      'Verdi',
      'Victor',
      'Victorville',
      'Vidal',
      'Vidal Junction',
      'View Park',
      'Villa Park',
      'Vine Hill',
      'Vineyard',
      'Vinton',
      'Visalia',
      'Vista',
      'Vista Santa Rosa',
      'Volcano',
      'Volta',
      'Walker',
      'Wallace',
      'Walnut',
      'Walnut Creek',
      'Walnut Heights',
      'Walnut Park',
      'Warner Springs',
      'Wasco',
      'Waterford',
      'Watsonville',
      'Waukena',
      'Wawona',
      'Weaverville',
      'Weed',
      'Weedpatch',
      'Wendel',
      'Weott',
      'West Athens',
      'West Bishop',
      'West Carson',
      'West Covina',
      'West Hollywood',
      'West Menlo Park',
      'West Park',
      'West Puente Valley',
      'West Rancho Dominguez',
      'West Sacramento',
      'West Whittier',
      'Westend',
      'Westhaven',
      'Westlake Village',
      'Westley',
      'Westmont',
      'Westmorland',
      'Westside',
      'Wheatland',
      'Wheeler Ridge',
      'Wheeler Springs',
      'White Pines',
      'White Water',
      'Whitehawk',
      'Whitethorn',
      'Whitley Gardens',
      'Wildomar',
      'Willits',
      'Willow Ranch',
      'Willowbrook',
      'Willows',
      'Wilseyville',
      'Windsor Hills',
      'Winter Gardens',
      'Winterhaven',
      'Winters',
      'Wofford Heights',
      'Woodacre',
      'Woodcrest',
      'Woodfords',
      'Woodlake',
      'Worth',
      'Wrightwood',
      'Yankee Hill',
      'Yermo',
      'Yettem',
      'Yolo',
      'Yorba Linda',
      'Yosemite Lakes',
      'Yountville',
      'Yreka',
      'Yuba City',
      'Yucaipa',
      'Yucca Valley',
      'Zayante',
    ],
    'US-CO': [
      'Acres Green',
      'Adams City',
      'Agate',
      'Aguilar',
      'Alamosa',
      'Allenspark',
      'Allison',
      'Almont',
      'Andrix',
      'Anton',
      'Antonito',
      'Applewood',
      'Arapahoe',
      'Arboles',
      'Aristocrat Ranchettes',
      'Aroya',
      'Arriba',
      'Arvada',
      'Aspen',
      'Aspen Park',
      'Ault',
      'Axial',
      'Bailey',
      'Bark Ranch',
      'Basalt',
      'Battlement Mesa',
      'Bayfield',
      'Bedrock',
      'Bellvue',
      'Bennett',
      'Bergen Park',
      'Berkley',
      'Berthoud',
      'Bethune',
      'Beulah Valley',
      'Black Forest',
      'Black Hawk',
      'Blende',
      'Blue River',
      'Bonanza Mountain Estates',
      'Boncarbo',
      'Bond',
      'Bondad',
      'Boone',
      'Boulder',
      'Bow Mar',
      'Boyero',
      'Branson',
      'Breckenridge',
      'Briggsdale',
      'Brookvale',
      'Broomfield',
      'Brush',
      'Buckingham',
      'Buffalo Creek',
      'Burns',
      'Byers',
      'Caddoa',
      'Cahone',
      'Calhan',
      'Camp Bird',
      'Capulin',
      'Carbondale',
      'Carr',
      'Cascade',
      'Castle Pines',
      'Castle Pines North',
      'Castle Pines Village',
      'Castle Rock',
      'Cathedral',
      'Cattle Creek',
      'Cañon City',
      'Cedaredge',
      'Cedarwood',
      'Centennial',
      'Chacra',
      'Chama',
      'Cheraw',
      'Cherry Creek',
      'Cherry Hills Village',
      'Cheyenne Wells',
      'Chimney Rock',
      'Chipita Park',
      'Chivington',
      'Chromo',
      'Cimarron',
      'Cimarron Hills',
      'Coal Creek',
      'Coalmont',
      'Cokedale',
      'Colona',
      'Colorado Springs',
      'Columbine',
      'Columbine Valley',
      'Commerce City',
      'Conejos',
      'Conifer',
      'Cope',
      'Copper Mountain',
      'Cornish',
      'Cortez',
      'Cotopaxi',
      'Cowdrey',
      'Creede',
      'Crescent',
      'Crested Butte',
      'Crestone',
      'Cripple Creek',
      'Crisman',
      'Crook',
      'Crowley',
      'Crystola',
      'Cuchara',
      'Dacono',
      'Dailey',
      'De Beque',
      'Deer Trail',
      'Del Norte',
      'Denver',
      'Deora',
      'Dillon',
      'Dinosaur',
      'Divide',
      'Dotsero',
      'Dove Creek',
      'Dove Valley',
      'Doyleville',
      'Drake',
      'Dunton',
      'Dupont',
      'Eads',
      'East Portal',
      'Eastlake',
      'Eaton',
      'Eckley',
      'Edler',
      'Edwards',
      'Egnar',
      'El Jebel',
      'El Moro',
      'El Rancho',
      'Elbert',
      'Eldora',
      'Eldorado Springs',
      'Elizabeth',
      'Elk Springs',
      'Ellicott',
      'Englewood',
      'Erie',
      'Estes Park',
      'Estrella',
      'Evans',
      'Fairplay',
      'Federal Heights',
      'Fenders',
      'Firestone',
      'Flagler',
      'Florissant',
      'Fort Carson',
      'Fort Collins',
      'Fort Garland',
      'Fort Lupton',
      'Fountain',
      'Foxfield',
      'Franktown',
      'Fraser',
      'Frederick',
      'Frisco',
      'Fruita',
      'Fulford',
      'Galeton',
      'Gardner',
      'Garo',
      'Gem Village',
      'Genesee',
      'Gerrard',
      'Gilcrest',
      'Gill',
      'Gilman',
      'Glen Haven',
      'Glendevey',
      'Gleneagle',
      'Glenwood Springs',
      'Gold Hill',
      'Goldfield',
      'Goodrich',
      'Grand Junction',
      'Grand Lake',
      'Grand Mesa',
      'Grand View Estates',
      'Granite',
      'Greeley',
      'Green Mountain Falls',
      'Greenwood Village',
      'Greystone',
      'Grover',
      'Guffey',
      'Gunbarrel',
      'Gunnison',
      'Gypsum',
      'Hale',
      'Hartsel',
      'Hasty',
      'Haswell',
      'Hawley',
      'Haxtun',
      'Heeney',
      'Herzman Mesa',
      'Hesperus',
      'Hiawatha',
      'Hidden Lake',
      'Highlands Ranch',
      'Hillrose',
      'Hoehne',
      'Holly',
      'Holly Hills',
      'Holyoke',
      'Hooper',
      'Hot Sulphur Springs',
      'Hotchkiss',
      'Howard',
      'Hoyt',
      'Hugo',
      'Hygiene',
      'Idaho Springs',
      'Idalia',
      'Idledale',
      'Iliff',
      'Indian Hills',
      'Jaroso',
      'Joes',
      'Johnson Village',
      'Julesburg',
      'Karval',
      'Keenesburg',
      'Ken Caryl',
      'Keota',
      'Kersey',
      'Keystone',
      'Kim',
      'Kings Canyon',
      'Kiowa',
      'Kirk',
      'Kit Carson',
      'Kittredge',
      'Kline',
      'Kremmling',
      'La Garita',
      'La Jara',
      'La Junta Gardens',
      'La Veta',
      'Lake George',
      'Laporte',
      'Las Animas',
      'Last Chance',
      'Lay',
      'Lazear',
      'Lazy Acres',
      'Leadville',
      'Lewis',
      'Leyden',
      'Leyner',
      'Limon',
      'Lincoln Park',
      'Lindon',
      'Littleton',
      'Lochbuie',
      'Log Lane Village',
      'Loghill Village',
      'Loma',
      'Lone Tree',
      'Longmont',
      'Louviers',
      'Loveland',
      'Lycan',
      'Lyons',
      'Mack',
      'Manassa',
      'Mancos',
      'Manitou Springs',
      'Manzanola',
      'Marshdale',
      'Masonville',
      'Massadona',
      'Masters',
      'Matheson',
      'Maybell',
      'Mayday',
      'McClave',
      'McCoy',
      'Mead',
      'Meeker',
      'Mesita',
      'Milliken',
      'Milner',
      'Mineral Hot Springs',
      'Model',
      'Moffat',
      'Mogote',
      'Monte Vista',
      'Monument',
      'Morrison',
      'Mosca',
      'Mount Crested Butte',
      'Mountain Meadows',
      'Mulford',
      'Naturita',
      'Nederland',
      'New Castle',
      'New Raymer',
      'Ninaview',
      'Niwot',
      'No Name',
      'Norrie',
      'North La Junta',
      'North Washington',
      'Northglenn',
      'Nucla',
      'Nunn',
      'Oak Creek',
      'Ohio',
      'Olathe',
      'Olney Springs',
      'Orchard',
      'Orchard City',
      'Orchard Mesa',
      'Ordway',
      'Otis',
      'Ouray',
      'Ovid',
      'Padroni',
      'Pagosa Junction',
      'Pagosa Springs',
      'Palisade',
      'Palmer Lake',
      'Pandora',
      'Paoli',
      'Paonia',
      'Parachute',
      'Paragon Estates',
      'Parlin',
      'Parshall',
      'Peconic',
      'Peetz',
      'Perry Park',
      'Peyton',
      'Phippsburg',
      'Pierce',
      'Pikeview',
      'Pine Brook Hill',
      'Pinecliffe',
      'Pitkin',
      'Platner',
      'Platteville',
      'Pleasant View',
      'Poncha Springs',
      'Ponderosa Park',
      'Poudre Park',
      'Powder Wash',
      'Powderhorn',
      'Pritchett',
      'Proctor',
      'Prospect Heights',
      'Prospect Valley',
      'Pueblo',
      'Pueblo West',
      'Ramah',
      'Rand',
      'Rangely',
      'Raymer',
      'Red Cliff',
      'Red Feather Lakes',
      'Redmesa',
      'Redstone',
      'Redvale',
      'Rico',
      'Ridgway',
      'Rifle',
      'Rio Blanco',
      'Rock Creek Park',
      'Rockvale',
      'Rocky Ford',
      'Roggen',
      'Rollinsville',
      'Romeo',
      'Roxborough Park',
      'Rush',
      'Saguache',
      'Saint Ann Highlands',
      'Salt Creek',
      'San Acacio',
      'Sargents',
      'Sawpit',
      'Sedalia',
      'Segundo',
      'Seibert',
      'Sequndo',
      'Seven Hills',
      'Severance',
      'Shaw Heights',
      'Sheridan Lake',
      'Sherrelwood',
      'Silt',
      'Silver Cliff',
      'Silver Plume',
      'Silverthorne',
      'Simla',
      'Singleton',
      'Smeltertown',
      'Snowmass',
      'Snowmass Village',
      'Snyder',
      'South Fork',
      'South Platte',
      'Stanley Park',
      'Starkville',
      'State Bridge',
      'Steamboat Springs',
      'Stone City',
      'Stonegate',
      'Stoneham',
      'Stoner',
      'Stonewall Gap',
      'Stonington',
      'Strasburg',
      'Stratmoor',
      'Stratton',
      'Sugar City',
      'Sugarloaf',
      'Swink',
      'Tabernash',
      'Tacoma',
      'Tall Timber',
      'Tarryall',
      'Telluride',
      'Texas Creek',
      'The Pinery',
      'Tiffany',
      'Timnath',
      'Timpas',
      'Todd Creek',
      'Toonerville',
      'Toponas',
      'Towaoc',
      'Towner',
      'Trimble',
      'Trinchera',
      'Two Buttes',
      'Tyrone',
      'Uravan',
      'Utleyville',
      'Valmont',
      'Vigil',
      'Vilas',
      'Villa Grove',
      'Villegreen',
      'Vineland',
      'Vollmar',
      'Vona',
      'Wah Keeney Park',
      'Walden',
      'Wallstreet',
      'Walsenburg',
      'Walsh',
      'Watkins',
      'Wattenberg',
      'Welby',
      'Weldona',
      'Westcliffe',
      'Westcreek',
      'Western Hills',
      'Wetmore',
      'Wheat Ridge',
      'Whitewater',
      'Wiggins',
      'Wigwam',
      'Wild Horse',
      'Wiley',
      'Willard',
      'Williamsburg',
      'Winter Park',
      'Wolcott',
      'Wondervu',
      'Woodland Park',
      'Woodmoor',
      'Woodrow',
      'Woody Creek',
      'Wray',
      'Yampa',
      'Yellow Jacket',
      'Yoder',
    ],
    'US-CT': [
      'Ansonia',
      'Aspetuck',
      'Baltic',
      'Bantam',
      'Blue Hills',
      'Branchville',
      'Broad Brook',
      'Byram',
      'Cannondale',
      'Canton Valley',
      'City of Milford (balance)',
      'Cos Cob',
      'Coventry Lake',
      'Crystal Lake',
      'Danbury',
      'Danielson',
      'Darien',
      'East Brooklyn',
      'East Hampton',
      'East Hartford',
      'East Haven',
      'Falls Village',
      'Fenwick',
      'Gales Ferry',
      'Glastonbury Center',
      'Greenfield Hill',
      'Greens Farms',
      'Groton',
      'Groton Long Point',
      'Hazardville',
      'Heritage Village',
      'Higganum',
      'Jewett City',
      'Lake Pocotopaug',
      'Lakeville',
      'Long Hill',
      'Lyons Plain',
      'Mansfield Center',
      'Meriden',
      'Moodus',
      'Moosup',
      'Mystic',
      'Naugatuck',
      'New Britain',
      'New Haven',
      'New Milford',
      'New Preston',
      'Newington',
      'Newtown',
      'Niantic',
      'Noank',
      'North Granby',
      'North Grosvenor Dale',
      'North Haven',
      'Old Greenwich',
      'Old Mystic',
      'Pawcatuck',
      'Pemberwick',
      'Plantsville',
      'Poquonock Bridge',
      'Quinebaug',
      'Ridgefield',
      'Salmon Brook',
      'Saybrook Manor',
      'Sharon',
      'Shelton',
      'Sherwood Manor',
      'Somers',
      'South Coventry',
      'South Windham',
      'South Woodstock',
      'Southwood Acres',
      'Stafford Springs',
      'Stamford',
      'Storrs',
      'Suffield Depot',
      'Tariffville',
      'Terramuggus',
      'Terryville',
      'Thompsonville',
      'Titicus',
      'Topstone',
      'Torrington',
      'Trumbull',
      'Uncasville',
      'Waterbury',
      'Watertown',
      'Wauregan',
      'Weatogue',
      'West Hartford',
      'West Haven',
      'West Mystic',
      'West Simsbury',
      'Wethersfield',
      'Willimantic',
      'Windsor Locks',
      'Winsted',
      'Woodmont',
    ],
    'US-DE': [
      'Ardencroft',
      'Ardentown',
      'Bear',
      'Bethany Beach',
      'Blades',
      'Bowers Beach',
      'Bridgeville',
      'Cheswold',
      'Christiana',
      'Claymont',
      'Collins Park',
      'Dagsboro',
      'Delaware City',
      'Delmar',
      'Dewey Beach',
      'Edgemoor',
      'Elsmere',
      'Fenwick Island',
      'Frederica',
      'Harrington',
      'Hartly',
      'Henlopen Acres',
      'Highland Acres',
      'Hockessin',
      'Holloway Terrace',
      'Holly Oak',
      'Kent Acres',
      'Kenton',
      'Laurel',
      'Lebanon',
      'Leipsic',
      'Lewes',
      'Little Creek',
      'Long Neck',
      'Marshallton',
      'Milford Crossroads',
      'Millsboro',
      'Minquadale',
      'Montchanin',
      'North Star',
      'Ocean View',
      'Odessa',
      'Ogletown',
      'Pike Creek',
      'Pike Creek Valley',
      'Pleasantville',
      'Rehoboth Beach',
      'Rising Sun',
      'Rockland',
      'Rodney Village',
      'Roseville Park',
      'Saint Georges',
      'Selbyville',
      'Slaughter Beach',
      'South Bethany',
      'Talleyville',
      'Townsend',
      'Westover Hills',
      'Wilmington Manor',
      'Wyoming',
      'Yorklyn',
    ],
    'US-DC': [],
    'US-FL': [
      'Alachua',
      'Alafaya',
      'Alcoma',
      'Allandale',
      'Allentown',
      'Altamonte Springs',
      'Altha',
      'Alton',
      'Alva',
      'Amelia City',
      'American Beach',
      'Ankona',
      'Anna Maria',
      'Anthony',
      'Apalachicola',
      'Apollo Beach',
      'Apopka',
      'Archer',
      'Ariel',
      'Aripeka',
      'Asbury Lake',
      'Astatula',
      'Astor',
      'Astor Park',
      'Athena',
      'Atlantic Beach',
      'Atlantis',
      'Auburndale',
      'Aucilla',
      'Avalon Beach',
      'Aventura',
      'Avon Park',
      'Azalea Park',
      'Babson Park',
      'Bakers Mill',
      'Bal Harbour',
      'Balm',
      'Barberville',
      'Barrineau Park',
      'Bartow',
      'Bascom',
      'Basinger',
      'Baskin',
      'Bassville Park',
      'Bay Harbor Islands',
      'Bay Hill',
      'Bay Lake',
      'Bay Pines',
      'Bayonet Point',
      'Bayou George',
      'Bayport',
      'Bayshore',
      'Bayshore Gardens',
      'Beacon Hill',
      'Beacon Square',
      'Becker',
      'Bee Ridge',
      'Belle Glade',
      'Belle Isle',
      'Belleair',
      'Belleair Beach',
      'Belleair Bluffs',
      'Belleair Shores',
      'Belleview',
      'Bellview',
      'Bellwood',
      'Bereah',
      'Berrydale',
      'Beverly Beach',
      'Big Coppitt Key',
      'Big Pine Key',
      'Biscayne Park',
      'Bithlo',
      'Blackman',
      'Blanton',
      'Bloomingdale',
      'Blountstown',
      'Blue Mountain Beach',
      'Bluff Springs',
      'Boca Grande',
      'Boca Raton',
      'Bogia',
      'Bokeelia',
      'Bonifay',
      'Bonita Springs',
      'Bostwick',
      'Boulevard Gardens',
      'Bowling Green',
      'Boyd',
      'Boynton Beach',
      'Bradenton',
      'Bradenton Beach',
      'Bradfordville',
      'Bradley Junction',
      'Branford',
      'Bratt',
      'Briny Breezes',
      'Broadview Park',
      'Bronson',
      'Brooker',
      'Brookridge',
      'Browardale',
      'Brownsdale',
      'Bryceville',
      'Buckhead Ridge',
      'Buenaventura Lakes',
      'Bunnell',
      'Burnt Store Marina',
      'Bushnell',
      'Butler Beach',
      'Callaway',
      'Campton',
      'Campville',
      'Canal Point',
      'Candler',
      'Cannon Town',
      'Cantonment',
      'Cape Canaveral',
      'Cape Coral',
      'Capps',
      'Captiva',
      'Carrabelle',
      'Carrollwood',
      'Caryville',
      'Cassadaga',
      'Casselberry',
      'Cedar Key',
      'Celebration',
      'Century',
      'Chaires',
      'Charleston Park',
      'Charlotte Harbor',
      'Charlotte Park',
      'Chassahowitzka',
      'Chattahoochee',
      'Cheval',
      'Chiefland',
      'Chipley',
      'Chokoloskee',
      'Chuluota',
      'Chumuckla',
      'Cinco Bayou',
      'Citra',
      'Citrus Hills',
      'Citrus Springs',
      'Clarcona',
      'Clark',
      'Clear Springs',
      'Clewiston',
      'Cloud Lake',
      'Cobbtown',
      'Cocoa',
      'Cocoa Beach',
      'Coconut',
      'Coconut Creek',
      'Combee Settlement',
      'Compass Lake',
      'Cooks Hammock',
      'Cooper City',
      'Copeland',
      'Coral Gables',
      'Coral Springs',
      'Coral Terrace',
      'Cornwell',
      'Cottage Hill',
      'Country Walk',
      'Crawfordville',
      'Creels',
      'Crescent Beach',
      'Crestview',
      'Crooked Lake Park',
      'Cross City',
      'Crows Bluff',
      'Crystal Beach',
      'Crystal River',
      'Cudjoe Key',
      'Curlew',
      'Cutler Bay',
      'Cypress Gardens',
      'Cypress Lake',
      'Cypress Quarters',
      'Dade City',
      'Dalkeith',
      'Dallas',
      'Dania Beach',
      'Davie',
      'Day',
      'Daytona Beach',
      'Daytona Beach Shores',
      'De Funiak Springs',
      'De Leon Springs',
      'De Soto City',
      'DeBary',
      'DeLand',
      'Deerfield Beach',
      'Dekle Beach',
      'Dellwood',
      'Delray Beach',
      'Deltona',
      'Denaud',
      'Desoto Lakes',
      'Destin',
      'Dickerson City',
      'Dixonville',
      'Doctor Phillips',
      'Doctors Inlet',
      'Doral',
      'Dowling Park',
      'Drexel',
      'Drifton',
      'Duck Key',
      'Duette',
      'Dukes',
      'Dunedin',
      'Dunnellon',
      'Durbin',
      'Eagle Lake',
      'East Lake',
      'East Lake Weir',
      'East Milton',
      'East Naples',
      'East Palatka',
      'Eastpoint',
      'Eaton Park',
      'Eatonville',
      'Eau Gallie',
      'Ebro',
      'Econfina',
      'Elfers',
      'Ellaville',
      'Ellenton',
      'Ellzey',
      'Ensley',
      'Eridu',
      'Estero',
      'Esto',
      'Eucheeanna',
      'Eustis',
      'Everglades City',
      'Fairview Shores',
      'Fanning Springs',
      'Favoretta',
      'Feather Sound',
      'Fellsmere',
      'Fern Crest Village',
      'Fern Park',
      'Fernandina Beach',
      'Ferry Pass',
      'Fidelis',
      'Fish Hawk',
      'Fisher Island',
      'Flagler Beach',
      'Flamingo',
      'Florahome',
      'Floral City',
      'Florida City',
      'Florida Ridge',
      'Floridatown',
      'Flowersville',
      'Forest City',
      'Fort Basinger',
      'Fort Drum',
      'Fort Green',
      'Fort Green Springs',
      'Fort Lauderdale',
      'Fort Meade',
      'Fort Myers',
      'Fort Myers Beach',
      'Fort Myers Shores',
      'Fort Ogden',
      'Fort Pierce',
      'Fort Walton Beach',
      'Fort White',
      'Fountainebleau',
      'Franklin Park',
      'Frink',
      'Frontenac',
      'Frostproof',
      'Fruit Cove',
      'Fruitland Park',
      'Fruitville',
      'Fuller Heights',
      'Fussels Corner',
      'Gandy',
      'Gaskin',
      'Gibsonton',
      'Gladeview',
      'Glen Ridge',
      'Glen Saint Mary',
      'Glenvar Heights',
      'Golden Beach',
      'Golden Gate',
      'Golden Glades',
      'Goldenrod',
      'Golf',
      'Gomez',
      'Gonzalez',
      'Goodland',
      'Goodno',
      'Goulding',
      'Goulds',
      'Graceville',
      'Grand Island',
      'Grand Ridge',
      'Grant-Valkaria',
      'Green Cove Springs',
      'Greenacres City',
      'Grove City',
      'Gulf Breeze',
      'Gulf Gate Estates',
      'Gulf Hammock',
      'Gulf Stream',
      'Gulfport',
      'Gun Club Estates',
      'Hacienda Village',
      'Haile',
      'Haines City',
      'Hallandale Beach',
      'Hampton Springs',
      'Hanson',
      'Harbor Bluffs',
      'Harbour Heights',
      'Harlem',
      'Harlem Heights',
      'Harold',
      'Hatchbend',
      'Haverhill',
      'Heathrow',
      'Hernando',
      'Hernando Beach',
      'Hialeah',
      'Hialeah Gardens',
      'High Point',
      'High Springs',
      'Highland Beach',
      'Highland City',
      'Highland Park',
      'Highland View',
      'Highpoint',
      "Hill 'n Dale",
      'Hillcrest Heights',
      'Hillsboro Beach',
      'Hillsboro Pines',
      'Hines',
      'Hinson',
      'Hobe Sound',
      'Holden Heights',
      'Holder',
      'Holiday',
      'Holley',
      'Holly Hill',
      'Holmes Beach',
      'Holopaw',
      'Homestead',
      'Homosassa',
      'Homosassa Springs',
      'Honeyville',
      'Horseshoe Beach',
      'Hosford',
      'Howie In The Hills',
      'Hugh',
      'Hull',
      'Hunters Creek',
      'Hypoluxo',
      'Immokalee',
      'Indialantic',
      'Indian Creek Village',
      'Indian Harbour Beach',
      'Indian Pass',
      'Indian River City',
      'Indian River Estates',
      'Indian River Shores',
      'Indian Rocks Beach',
      'Indian Shores',
      'Indiantown',
      'Indrio',
      'Inglis',
      'Intercession City',
      'Interlachen',
      'Inwood',
      'Iona',
      'Islamorada',
      'Island Grove',
      'Istachatta',
      'Italia',
      'Ives Estates',
      'Izagora',
      'Jacksonville Beach',
      'Jacobs',
      'Jan-Phyl Village',
      'Jasmine Estates',
      'Jay',
      'Jensen Beach',
      'June Park',
      'Juno Beach',
      'Juno Ridge',
      'Jupiter',
      'Jupiter Inlet Beach Colony',
      'Jupiter Island',
      'Kathleen',
      'Kenansville',
      'Kendale Lakes',
      'Kendall',
      'Kendrick',
      'Kenneth City',
      'Kensington Park',
      'Key Biscayne',
      'Key Colony Beach',
      'Key Largo',
      'Key West',
      'Keystone Heights',
      'Keysville',
      'Kinard',
      'Kingsley',
      'Kissimmee',
      'Knights',
      'Korona',
      'La Crosse',
      'LaBelle',
      'Lacoochee',
      'Lady Lake',
      'Lake Alfred',
      'Lake Belvedere Estates',
      'Lake Buena Vista',
      'Lake Butler',
      'Lake Clarke Shores',
      'Lake Harbor',
      'Lake Hart',
      'Lake Helen',
      'Lake Kathryn',
      'Lake Lindsey',
      'Lake Lorraine',
      'Lake Magdalene',
      'Lake Mary',
      'Lake Monroe',
      'Lake Panasoffkee',
      'Lake Park',
      'Lake Placid',
      'Lake Sarasota',
      'Lake Wales',
      'Lake Worth',
      'Lakeland',
      'Lakeland Highlands',
      'Lakewood Park',
      'Lanark Village',
      "Land O' Lakes",
      'Lantana',
      'Lauderdale Lakes',
      'Lauderdale-by-the-Sea',
      'Lauderhill',
      'Laurel Hill',
      'Lawtey',
      'Layton',
      'Lazy Lake',
      'Lealman',
      'Lecanto',
      'Lee',
      'Lehigh Acres',
      'Leisure City',
      'Lely',
      'Lely Resort',
      'Leonia',
      'Lighthouse Point',
      'Limestone Creek',
      'Lisbon',
      'Lloyd',
      'Lochloosa',
      'Lochmoor Waterway Estates',
      'Longboat Key',
      'Lorida',
      'Loughman',
      'Lovett',
      'Lower Grand Lagoon',
      'Loxahatchee Groves',
      'Ludlam',
      'Lulu',
      'Lumberton',
      'Lundy',
      'Luraville',
      'Lutz',
      'Lynn Haven',
      'Lynne',
      'Macclenny',
      'Madeira Beach',
      'Malabar',
      'Manalapan',
      'Manasota Key',
      'Manatee Road',
      'Mangonia Park',
      'Marathon Shores',
      'Marineland',
      'Martel',
      'Mary Esther',
      'Masaryktown',
      'Mascotte',
      'Matlacha',
      'McAlpin',
      'McDavid',
      'McGregor',
      'McKinnon',
      'Meadow Woods',
      'Meadowbrook Terrace',
      'Medart',
      'Medley',
      'Medulla',
      'Melbourne Beach',
      'Melbourne Village',
      'Merritt Island',
      'Mexico Beach',
      'Miami Beach',
      'Miami Gardens',
      'Miami Lakes',
      'Miami Shores',
      'Miami Springs',
      'Micanopy',
      'Micco',
      'Miccosukee',
      'Middleburg',
      'Milligan',
      'Mims',
      'Minneola',
      'Miramar Beach',
      'Molino',
      'Montbrook',
      'Montverde',
      'Moore Haven',
      'Mossy Head',
      'Mount Carmel',
      'Mount Dora',
      'Mount Plymouth',
      'Mulat',
      'Murdock',
      'Myakka City',
      'Myrtle Grove',
      'Naples',
      'Naples Manor',
      'Naples Park',
      'Naranja',
      'Narcoossee',
      'Neptune Beach',
      'New Port Richey',
      'New Smyrna Beach',
      'Newberry',
      'Newburn',
      'Niceville',
      'Nobleton',
      'Nocatee',
      'Nokomis',
      'Noma',
      'Norfleet',
      'North Bay Village',
      'North Brooksville',
      'North DeLand',
      'North Fort Myers',
      'North Key Largo',
      'North Lauderdale',
      'North Miami',
      'North Miami Beach',
      'North Naples',
      'North Palm Beach',
      'North Port',
      'North Redington Beach',
      'North River Shores',
      'North Sarasota',
      'Northdale',
      "O'Brien",
      'Oak Ridge',
      'Oakland Park',
      'Ocala',
      'Ocean Breeze Park',
      'Ocean City',
      'Ocean Ridge',
      'Ochopee',
      'Ocoee',
      'Ojus',
      'Okahumpka',
      'Okeechobee',
      'Okeelanta',
      'Old Town',
      'Oldsmar',
      'Olga',
      'Olustee',
      'Olympia Heights',
      'Ona',
      'Opa-locka',
      'Orange City',
      'Orange Heights',
      'Orange Lake',
      'Orange Park',
      'Orangetree',
      'Orchid',
      'Orient Park',
      'Oriole Beach',
      'Orlando',
      'Orlovista',
      'Ormond Beach',
      'Ormond-by-the-Sea',
      'Oslo',
      'Osprey',
      'Osteen',
      'Otter Creek',
      'Pace',
      'Page Park',
      'Pahokee',
      'Paisley',
      'Palatka',
      'Palm Bay',
      'Palm Beach',
      'Palm Beach Gardens',
      'Palm Beach Shores',
      'Palm City',
      'Palm Coast',
      'Palm Harbor',
      'Palm River',
      'Palm Shores',
      'Palm Valley',
      'Palmetto',
      'Palmetto Bay',
      'Palmetto Estates',
      'Palmona Park',
      'Panacea',
      'Panama City',
      'Panama City Beach',
      'Paradise Beach',
      'Paradise Heights',
      'Parkland',
      'Parmalee',
      'Pebble Creek',
      'Pelican Bay',
      'Pembroke Park',
      'Pembroke Pines',
      'Penney Farms',
      'Pennsuco',
      'Pensacola',
      'Perrine',
      'Pierson',
      'Pine Barren',
      'Pine Castle',
      'Pine Island',
      'Pine Island Center',
      'Pine Island Ridge',
      'Pine Lakes',
      'Pine Log',
      'Pine Manor',
      'Pinecrest',
      'Pineda',
      'Pineland',
      'Pinellas Park',
      'Pineola',
      'Pinetta',
      'Pinewood',
      'Piney Point',
      'Pinland',
      'Pittman',
      'Placida',
      'Plains',
      'Plant City',
      'Plantation',
      'Plantation Island',
      'Plantation Key',
      'Plantation Mobile Home Park',
      'Poinciana',
      'Polk City',
      'Pomona Park',
      'Pompano Beach',
      'Pompano Park',
      'Ponce Inlet',
      'Ponce de Leon',
      'Ponte Vedra Beach',
      'Port Charlotte',
      'Port LaBelle',
      'Port Mayaca',
      'Port Orange',
      'Port Richey',
      'Port Saint Joe',
      'Port Saint John',
      'Port Saint Lucie',
      'Port Salerno',
      'Port Sewall',
      'Pretty Bayou',
      'Progress Village',
      'Prosperity',
      'Punta Gorda',
      'Punta Rassa',
      'Putnam Hall',
      'Quintette',
      'Raiford',
      'Ratliff',
      'Red Head',
      'Reddick',
      'Redington Beach',
      'Redington Shores',
      'Rerdell',
      'Resota Beach',
      'Richmond Heights',
      'Ridge Manor',
      'Ridge Wood Heights',
      'Rio',
      'River Park',
      'Riverland',
      'Riviera Beach',
      'Rochelle',
      'Roeville',
      'Roosevelt Gardens',
      'Round Lake',
      'Royal Palm Beach',
      'Royal Palm Estates',
      'Rubonia',
      'Ruskin',
      'Safety Harbor',
      'Saint Augustine',
      'Saint Augustine Beach',
      'Saint Augustine Shores',
      'Saint Augustine South',
      'Saint Catherine',
      'Saint Cloud',
      'Saint George Island',
      'Saint James City',
      'Saint Leo',
      'Saint Lucie',
      'Saint Marks',
      'Saint Pete Beach',
      'Saint Petersburg',
      'Saint Teresa',
      'Salt Springs',
      'Samoset',
      'Sampson',
      'Samsula',
      'San Carlos Park',
      'Sanborn',
      'Sanderson',
      'Sanibel',
      'Santa Rosa Beach',
      'Sarasota',
      'Sarasota Springs',
      'Satellite Beach',
      'Sawgrass',
      'Schall Circle',
      'Scottsmoor',
      'Sea Ranch Lakes',
      'Seagrove Beach',
      'Sebastian',
      'Sebring',
      'Seffner',
      'Seminole Manor',
      "Sewall's Point",
      'Shady',
      'Shady Hills',
      'Shalimar',
      'Shamrock',
      'Sharpes',
      'Siesta Key',
      'Silver Lake',
      'Silver Springs Shores',
      'Sink Creek',
      'Sirmans',
      'Sky Lake',
      'Sneads',
      'Solana',
      'Sopchoppy',
      'South Apopka',
      'South Bay',
      'South Beach',
      'South Bradenton',
      'South Brooksville',
      'South Daytona',
      'South Gate Ridge',
      'South Highpoint',
      'South Miami',
      'South Miami Heights',
      'South Palm Beach',
      'South Patrick Shores',
      'South Ponte Vedra Beach',
      'South Punta Gorda Heights',
      'South Sarasota',
      'South Venice',
      'Southchase',
      'Southwest Ranches',
      'Sparr',
      'Stacey Street',
      'Starke',
      'Steinhatchee',
      'Stock Island',
      'Stuart',
      'Sugarmill Woods',
      'Sumatra',
      'Summer Haven',
      'Summerfield',
      'Summerland Key',
      'Sumterville',
      'Sun City Center',
      'Suncoast Estates',
      'Sunniland',
      'Sunny Isles Beach',
      'Suwannee',
      'Sweetwater',
      'Tallahassee',
      'Tallevast',
      'Tamarac',
      'Tamiami',
      'Tampa',
      'Tangelo Park',
      'Tangerine',
      'Tarpon Springs',
      'Tavernier',
      'Taylor Creek',
      'Telogia',
      'Temple Terrace',
      'Tennille',
      'Tequesta',
      'The Acreage',
      'The Crossings',
      'The Hammocks',
      'The Meadows',
      'The Villages',
      'Theressa',
      'Thonotosassa',
      'Three Lakes',
      'Three Oaks',
      'Tice',
      'Tierra Verde',
      'Tiger Point',
      'Tildenville',
      'Timber Pines',
      'Titusville',
      "Town 'n' Country",
      'Treasure Island',
      'Trilby',
      'Turnbull',
      'Umatilla',
      'Union Park',
      'University Park',
      'Upper Grand Lagoon',
      'Usher',
      'Valkaria',
      'Valrico',
      'Vamo',
      'Venice',
      'Venice Gardens',
      'Venus',
      'Vermont Heights',
      'Verna',
      'Vero Beach',
      'Vilano Beach',
      'Villano Beach',
      'Villas',
      'Vineyards',
      'Virginia Gardens',
      'Wabasso',
      'Wabasso Beach',
      'Wacissa',
      'Wahneta',
      'Wakulla',
      'Wakulla Beach',
      'Walnut Hill',
      'Walton',
      'Wannee',
      'Ward Ridge',
      'Warm Mineral Springs',
      'Wauchula',
      'Waukeenah',
      'Wausau',
      'Webster',
      'Wedgefield',
      'Weeki Wachee',
      'Weeki Wachee Gardens',
      'Weirsdale',
      'Wekiwa Springs',
      'Welaka',
      'Wellborn',
      'Wesley Chapel',
      'West Bay',
      'West Bradenton',
      'West DeLand',
      'West Frostproof',
      'West Lake Wales',
      'West Little River',
      'West Melbourne',
      'West Miami',
      'West Palm Beach',
      'West Pensacola',
      'West Perrine',
      'West Samoset',
      'Westchase',
      'Westchester',
      'Westlake',
      'Westview',
      'Westwood Lake',
      'Wewahitchka',
      'Whiskey Creek',
      'White City',
      'White Springs',
      'Wildwood',
      'Williston',
      'Williston Highlands',
      'Willow Oak',
      'Wilma',
      'Wilton Manors',
      'Wimauma',
      'Winter Beach',
      'Winter Garden',
      'Winter Haven',
      'Winter Springs',
      'Wiscon',
      'Woodlawn Beach',
      'Worthington Springs',
      'Wright',
      'Yalaha',
      'Yankeetown',
      'Yeehaw Junction',
      'Yulee',
      'Zellwood',
      'Zephyrhills',
      'Zolfo Springs',
    ],
    'US-GA': [
      'Acree',
      'Acworth',
      'Adairsville',
      'Adel',
      'Adgateville',
      'Adrian',
      'Ailey',
      'Alapaha',
      'Aldora',
      'Allenhurst',
      'Almon',
      'Alpharetta',
      'Alston',
      'Alvaton',
      'Ambrose',
      'Americus',
      'Andersonville',
      'Apalachee',
      'Appling',
      'Arabi',
      'Aragon',
      'Arnold Mill',
      'Arnoldsville',
      'Ashburn',
      'Atkinson',
      'Attapulgus',
      'Austell',
      'Avera',
      'Avondale Estates',
      'Axson',
      'Baconton',
      'Bainbridge',
      'Ball Ground',
      'Barnesville',
      'Barney',
      'Barretts',
      'Barwick',
      'Baxley',
      'Beach',
      'Bellville',
      'Belvedere Park',
      'Bemiss',
      'Benevolence',
      'Berkeley Lake',
      'Bethlehem',
      'Between',
      'Blackshear',
      'Blackwells',
      'Blairsville',
      'Blakely',
      'Blitchton',
      'Bogart',
      'Bolingbroke',
      'Bonaire',
      'Bowdon',
      'Bowdon Junction',
      'Bowersville',
      'Bowman',
      'Braselton',
      'Braswell',
      'Bridgeboro',
      'Brinson',
      'Broadhurst',
      'Bronwood',
      'Brookfield',
      'Brookhaven',
      'Brooklet',
      'Broxton',
      'Brunswick',
      'Buchanan',
      'Buckhead',
      'Buford',
      'Bullard',
      'Burroughs',
      'Byromville',
      'Cadley',
      'Cadwell',
      'Cairo',
      'Calvary',
      'Camak',
      'Camilla',
      'Canon',
      'Canoochee',
      'Canton',
      'Carl',
      'Carnegie',
      'Carnesville',
      'Carsonville',
      'Cartersville',
      'Cataula',
      'Cave Spring',
      'Cedar Springs',
      'Cedartown',
      'Center Post',
      'Centralhatchee',
      'Chalybeate Springs',
      'Chamblee',
      'Charing',
      'Charles',
      'Chattahoochee Hills',
      'Chattanooga Valley',
      'Chauncey',
      'Cherry Log',
      'Chestnut Mountain',
      'Chickamauga',
      'Chicopee',
      'Chula',
      'Cisco',
      'Clarkesville',
      'Clarkston',
      'Claxton',
      'Clem',
      'Climax',
      'Clyattville',
      'Clyo',
      'Coal Mountain',
      'Cochran',
      'Cogdell',
      'Cohutta',
      'Colbert',
      'Colemans Lake',
      'College Park',
      'Colquitt',
      'Columbus',
      'Conley',
      'Conyers',
      'Cooper Heights',
      'Coosa',
      'Cordele',
      'Cornelia',
      'Cotton',
      'Council',
      'Country Club Estates',
      'Coverdale',
      'Covington',
      'Crabapple',
      'Culloden',
      'Culverton',
      'Cumming',
      'Cuthbert',
      'Dacula',
      'Dahlonega',
      'Dakota',
      'Dames Ferry',
      'Danielsville',
      'Dasher',
      'Davisboro',
      'Dawesville',
      'Dawsonville',
      'DeSoto',
      'DeWitt',
      'Dearing',
      'Deenwood',
      'Deepstep',
      'Demorest',
      'Denton',
      'Devereux',
      'Dewy Rose',
      'Dexter',
      'Dickey',
      'Dillard',
      'Dixie Union',
      'Dock Junction',
      'Doctortown',
      'Doerun',
      'Doles',
      'Donalsonville',
      'Donovan',
      'Dooling',
      'Doraville',
      'Douglasville',
      'Draketown',
      'Druid Hills',
      'Du Pont',
      'Ducktown',
      'Duluth',
      'Dunwoody',
      'Durand',
      'Eagle Grove',
      'East Dublin',
      'East Ellijay',
      'East Griffin',
      'East Juliette',
      'East Newnan',
      'Eastanollee',
      'Eastman',
      'Eatonton',
      'Edgehill',
      'Elberton',
      'Eldorendo',
      'Elko',
      'Ellabell',
      'Ellenwood',
      'Ellijay',
      'Elliotts Bluff',
      'Elmodel',
      'Emmalane',
      'Emory',
      'Enigma',
      'Ephesus',
      'Epworth',
      'Esom Hill',
      'Eton',
      'Euharlee',
      'Eulonia',
      'Everett',
      'Excelsior',
      'Experiment',
      'Faceville',
      'Fairburn',
      'Fairmount',
      'Finleyson',
      'Flemington',
      'Flippen',
      'Flovilla',
      'Flowery Branch',
      'Folkston',
      'Forest Park',
      'Forsyth',
      'Fort Gaines',
      'Fort Oglethorpe',
      'Fort Valley',
      'Fortson',
      'Fortsonia',
      'Fowlstown',
      'Franklin Springs',
      'Free Home',
      'Funston',
      'Gabbettville',
      'Garden Lakes',
      'Gardi',
      'Gay',
      'Gillsville',
      'Girard',
      'Glennville',
      'Gloster',
      'Godfrey',
      'Godwinsville',
      'Gordy',
      'Gough',
      'Gracewood',
      'Grantville',
      'Gresham Park',
      'Griffin',
      'Griswoldville',
      'Grovania',
      'Grovetown',
      'Gum Branch',
      'Gumlog',
      'Guyton',
      'Habersham',
      'Haddock',
      'Hagan',
      'Hahira',
      'Halfmoon Landing',
      'Halls',
      'Hannahs Mill',
      'Hapeville',
      'Haralson',
      'Hartwell',
      'Hatley',
      'Hawkinsville',
      'Haylow',
      'Hazlehurst',
      'Helen',
      'Hephzibah',
      'Herod',
      'Hiawassee',
      'Hickox',
      'Higgston',
      'Highland Mills',
      'Hilltop',
      'Hiltonia',
      'Hinesville',
      'Hoboken',
      'Hogansville',
      'Homerville',
      'Horns',
      'Hortense',
      'Hoschton',
      'Huber',
      'Hutchins',
      'Ila',
      'Indian Springs',
      'Inman',
      'Iron City',
      'Irwinton',
      'Irwinville',
      'Isle of Hope',
      'Ivey',
      'Jakin',
      'Jeffersonville',
      'Jenkinsburg',
      'Jesup',
      'Johns Creek',
      'Johnson Corner',
      'Juliette',
      'Juniper',
      'Keithsburg',
      'Keller',
      'Kennesaw',
      'Kildare',
      'Kinderlou',
      'Kite',
      'LaFayette',
      'Lakemont',
      'Lakeview Estates',
      'Lavonia',
      'Lawrenceville',
      'Leary',
      'Leathersville',
      'Leland',
      'Lenox',
      'Lilburn',
      'Lilly',
      'Lincolnton',
      'Lindale',
      'Lithia Springs',
      'Lithonia',
      'Lizella',
      'Locust Grove',
      'Loganville',
      'Lone Oak',
      'Lookout Mountain',
      'Louise',
      'Louvale',
      'Lovejoy',
      'Ludowici',
      'Luella',
      'Luke',
      'Lumber City',
      'Lumpkin',
      'Luthersville',
      'Lyerly',
      'Mableton',
      'Macland',
      'Macon',
      'Madras',
      'Manassas',
      'Manor',
      'Marietta',
      'Marshallville',
      'Martin',
      'Matthews',
      'Maxeys',
      'McBean',
      'McCaysville',
      'McDonough',
      'McIntyre',
      'McKinney',
      'Meansville',
      'Mechanicsville',
      'Meigs',
      'Meinhard',
      'Menlo',
      'Merrillville',
      'Mershon',
      'Metcalf',
      'Metter',
      'Midville',
      'Milledgeville',
      'Millen',
      'Millhaven',
      'Millwood',
      'Mineral Bluff',
      'Modoc',
      'Molena',
      'Moniac',
      'Morganville',
      'Morrow',
      'Morven',
      'Moultrie',
      'Mount Airy',
      'Mount Bethel',
      'Mount Zion',
      'Mountain City',
      'Mountain Park',
      'Moxley',
      'Munnerlyn',
      'Musella',
      'Nahunta',
      'Naylor',
      'Needmore',
      'Newborn',
      'Newnan',
      'Nicholls',
      'Nicholson',
      'Noonday',
      'Norcross',
      'Norman Park',
      'Normantown',
      'Norristown',
      'North Atlanta',
      'North Decatur',
      'North Druid Hills',
      'North High Shoals',
      'Nunez',
      'Oakfield',
      'Oakland Heights',
      'Oakwood',
      'Ocee',
      'Ochlocknee',
      'Ocilla',
      'Oconee',
      'Odessadale',
      'Odum',
      'Offerman',
      'Oglesby',
      'Oglethorpe',
      'Ohoopee',
      'Omega',
      'Orchard Hill',
      'Osierfield',
      'Panthersville',
      'Parrott',
      'Pavo',
      'Payne',
      'Peachtree City',
      'Peachtree Corners',
      'Pendergrass',
      'Penfield',
      'Perkins',
      'Phelps',
      'Phillipsburg',
      'Philomath',
      'Pine Lake',
      'Pine Mountain',
      'Pine Mountain Valley',
      'Pine Park',
      'Pineora',
      'Pineview',
      'Pitts',
      'Plainfield',
      'Plainville',
      'Pooler',
      'Port Wentworth',
      'Porterdale',
      'Potterville',
      'Poulan',
      'Powder Springs',
      'Powelton',
      'Pridgen',
      'Primrose',
      'Pulaski',
      'Putney',
      'Queensland',
      'Raines',
      'Ramhurst',
      'Ranger',
      'Raoul',
      'Ray City',
      'Rayle',
      'Rebecca',
      'Red Oak',
      'Redan',
      'Reed Creek',
      'Reeves',
      'Register',
      'Reidsville',
      'Remerton',
      'Renfroe',
      'Reno',
      'Rentz',
      'Resaca',
      'Rest Haven',
      'Rex',
      'Reynolds',
      'Reynoldsville',
      'Rhine',
      'Riceboro',
      'Richland',
      'Richwood',
      'Riddleville',
      'Rincon',
      'Ringgold',
      'Rising Fawn',
      'Roberta',
      'Rock Spring',
      'Rockingham',
      'Rockmart',
      'Rocky Mount',
      'Rome',
      'Roopville',
      'Roper',
      'Rosier',
      'Rossville',
      'Roswell',
      'Round Oak',
      'Royston',
      'Ruckersville',
      'Rupert',
      'Saint Clair',
      'Saint Simons',
      'Sale City',
      'Sandersville',
      'Sandy Plains',
      'Sandy Springs',
      'Santa Claus',
      'Sapelo Island',
      'Sargent',
      'Sasser',
      'Satilla',
      'Satolah',
      'Savannah',
      'Scottdale',
      'Screven',
      'Sea Island',
      'Senoia',
      'Shady Dale',
      'Sharpsburg',
      'Shawnee',
      'Shellman',
      'Shellman Bluff',
      'Shingler',
      'Sigsbee',
      'Silco',
      'Silk Hope',
      'Siloam',
      'Six Mile',
      'Skidaway Island',
      'Skipperton',
      'Smarr',
      'Snapfinger',
      'Snellville',
      'Social Circle',
      'Soperton',
      'South Fulton',
      'South Newport',
      'Sparks',
      'Sparta',
      'Spring Place',
      'Springvale',
      'Starrs Mill',
      'Starrsville',
      'Statenville',
      'Statesboro',
      'Statham',
      'Stillmore',
      'Stillwell',
      'Stockbridge',
      'Stone Mountain',
      'Stonecrest',
      'Stovall',
      'Sugar Hill',
      'Sugar Valley',
      'Sumac',
      'Summerville',
      'Sumner',
      'Sumter',
      'Sunny Side',
      'Sunset Village',
      'Surrency',
      'Suwanee',
      'Swainsboro',
      'Swords',
      'Sylvester',
      'Talbotton',
      'Talking Rock',
      'Tallapoosa',
      'Tallulah Falls',
      'Talmo',
      'Tarboro',
      'Tarrytown',
      'Tarver',
      'Tate',
      'Tate City',
      'Tazewell',
      'Temple',
      'Thalmann',
      'Thomson',
      'Thunderbolt',
      'Tifton',
      'Tiger',
      'Tignall',
      'Toccoa',
      'Toomsboro',
      'Topeka Junction',
      'Towns',
      'Trion',
      'Tunnel Hill',
      'Turnerville',
      'Twin City',
      'Ty Ty',
      'Tybee Island',
      'Unadilla',
      'Union Point',
      'Unionville',
      'Upatoi',
      'Uvalda',
      'Valdosta',
      'Van Wert',
      'Varnell',
      'Veal',
      'Vernonburg',
      'Vesta',
      'Vidalia',
      'Vidette',
      'Vienna',
      'Vinings',
      'Waco',
      'Waleska',
      'Walthourville',
      'Waresboro',
      'Waring',
      'Warner Robins',
      'Warrenton',
      'Warsaw',
      'Warthen',
      'Watkinsville',
      'Waverly Hall',
      'Waycross',
      'Waynesboro',
      'Wayside',
      'Weber',
      'Wenona',
      'West Green',
      'Westoak',
      'Whigham',
      'White Oak',
      'White Sulphur Springs',
      'Whitemarsh Island',
      'Whitesburg',
      'Whitesville',
      'Willacoochee',
      'Wilmington Island',
      'Winder',
      'Windsor Forest',
      'Winokur',
      'Winterville',
      'Withers',
      'Woodbine',
      'Woolsey',
      'Wrens',
      'Yatesville',
      'Yonah',
      'Yorkville',
      'Young Harris',
      'Zebina',
      'Zebulon',
    ],
    'US-HI': [
      'Anahola',
      'Captain Cook',
      'Discovery Harbour',
      'Eden Roc',
      'Fern Acres',
      'Fern Forest',
      'Halaʻula',
      'Haleʻiwa',
      'Hanalei',
      'Hanamāʻulu',
      'Hanapēpē',
      'Hauʻula',
      'Hawaiian Acres',
      'Hawaiian Beaches',
      'Hawaiian Ocean View',
      'Hawaiian Paradise Park',
      'Heʻeia',
      'Hilo',
      'Honalo',
      'Honokahua',
      'Honokaʻa',
      'Honolulu',
      'Honomu',
      'Honuʻapo',
      'Hoʻolehua',
      'Hālawa',
      'Hāliʻimaile',
      'Hāna',
      'Hāwī',
      'Hāʻena',
      'Hōlualoa',
      'Iroquois Point',
      'Kahakuloa',
      'Kahaluʻu',
      'Kahuku',
      'Kahului',
      'Kailua',
      'Kalaoa',
      'Kalaupapa',
      'Kalihi Wai',
      'Kaluaʻaha',
      'Kalāheo',
      'Kamalō',
      'Kapalua',
      'Kapaʻa',
      'Kapaʻau',
      'Kapolei',
      'Kaumakani',
      'Kaumalapau',
      'Kaunakakai',
      'Kawaihae',
      'Kawela Bay',
      'Kaʻaʻawa',
      'Kealakekua',
      'Keauhou',
      'Keaʻau',
      'Kekaha',
      'Kualapuʻu',
      'Kukuihaele',
      'Kurtistown',
      'Kāneʻohe',
      'Kāʻanapali',
      'Kēōkea',
      'Kīhei',
      'Kīlauea',
      'Kīpahulu',
      'Kōloa',
      'Lahaina',
      'Launiupoko',
      'Laupāhoehoe',
      'Leilani Estates',
      'Lānaʻi City',
      'Lāwaʻi',
      'Lāʻie',
      'Līhuʻe',
      'Makakilo City',
      'Makawao',
      'Maunaloa',
      'Maunawili',
      'Mililani Town',
      'Miloliʻi',
      'Mokulēʻia',
      'Māhukona',
      'Mākaha',
      'Mākaha Valley',
      'Mākena',
      'Mānā',
      'Māʻalaea',
      'Māʻili',
      'Niuliʻi',
      'Nānākuli',
      'Nānāwale Estates',
      'Nāʻālehu',
      'Olowalu',
      'Orchidlands Estates',
      'Paukaa',
      'Paʻauilo',
      'Pearl City',
      'Pepeʻekeo',
      'Poʻipū',
      'Puakō',
      'Puhi',
      'Pukalani',
      'Punaluʻu',
      'Puʻuwai',
      'Pāhala',
      'Pāhoa',
      'Pākalā Village',
      'Pāpaʻaloa',
      'Pāpaʻikou',
      'Pāʻia',
      'Pūpūkea',
      'Wahiawā',
      'Waiakoa',
      'Waialua',
      'Waiehu',
      'Waiheʻe',
      'Waikapū',
      'Waikoloa Village',
      'Waikāne',
      'Wailea',
      'Wailua',
      'Wailua Homesteads',
      'Wailuku',
      'Waimalu',
      'Waimea',
      'Waimānalo',
      'Waimānalo Beach',
      'Wainaku',
      'Wainiha',
      'Waipahu',
      'Waipiʻo',
      'Waipiʻo Acres',
      'Waiʻanae',
      'Waiʻōhinu',
      'Welokā',
      'Whitmore Village',
      'ʻAiea',
      'ʻEleʻele',
      'ʻEwa Beach',
      'ʻEwa Gentry',
      'ʻEwa Villages',
      'ʻOpihikao',
      'ʻUalapuʻe',
      'ʻUlupalakua',
      'ʻĀhuimanu',
      'ʻĀinaloa',
      'ʻŌmaʻo',
      'ʻŌʻōkala',
    ],
    'US-ID': [
      'Acequia',
      'Algoma',
      'Almo',
      'American Falls',
      'Ammon',
      'Arbon',
      'Arimo',
      'Ashton',
      'Athol',
      'Atomic City',
      'Banida',
      'Barber',
      'Basin',
      'Bellevue',
      'Bennington',
      'Berenice',
      'Blackfoot',
      'Blanchard',
      'Bliss',
      'Boise',
      'Bone',
      'Bonners Ferry',
      'Border',
      'Bovill',
      'Bowmont',
      'Bridge',
      'Bruneau',
      'Buhl',
      'Buist',
      'Burley',
      'Butte City',
      'Byrne',
      'Carey',
      'Careywood',
      'Castleford',
      'Challis',
      'Chatcolet',
      'Chesterfield',
      'Chilly',
      'Clark Fork',
      'Clementsville',
      'Clover',
      'Cocolalla',
      "Coeur d'Alene",
      'Colburn',
      'Conda',
      'Conkling Park',
      'Coolin',
      'Craigmont',
      'Crouch',
      'Crystal',
      'Culdesac',
      'Cuprum',
      'Dalton Gardens',
      'Daniels',
      'De Smet',
      'Deary',
      'Declo',
      'Dietrich',
      'Dubois',
      'East Hope',
      'Eden',
      'Edmonds',
      'Elk City',
      'Elk River',
      'Ellis',
      'Emida',
      'Emmett',
      'Enaville',
      'Featherville',
      'Felt',
      'Fenn',
      'Ferdinand',
      'Fernan Lake Village',
      'Fernwood',
      'Filer',
      'Firth',
      'Fish Haven',
      'Fort Hall',
      'Fruitland',
      'Gannett',
      'Garden Valley',
      'Gem',
      'Gibbonsville',
      'Glenns Ferry',
      'Gooding',
      'Grace',
      'Grand View',
      'Grasmere',
      'Greenleaf',
      'Grouse',
      'Gwenford',
      'Hagerman',
      'Hailey',
      'Hamer',
      'Hammett',
      'Hansen',
      'Harpster',
      'Hatch',
      'Hauser',
      'Hayden Lake',
      'Headquarters',
      'Heglar',
      'Helmer',
      'Henry',
      'Heyburn',
      'Hill City',
      'Homedale',
      'Huetter',
      'Huston',
      'Idaho City',
      'Idaho Falls',
      'Idmon',
      'Indian Valley',
      'Inkom',
      'Island Park',
      'Juliaetta',
      'Kamiah',
      'Kellogg',
      'Ketchum',
      'Kilgore',
      'King Hill',
      'Kooskia',
      'Kootenai',
      'Kuna',
      'Lake Fork',
      'Lapwai',
      'Lava Hot Springs',
      'Leadore',
      'Lemhi',
      'Lenore',
      'Letha',
      'Lewiston Orchards',
      'Lorenzo',
      'Lost River',
      'Lowman',
      'Lucile',
      'Lund',
      'Mackay',
      'Malad City',
      'Marsing',
      'May',
      'McCall',
      'McCammon',
      'Melba',
      'Menan',
      'Midvale',
      'Minidoka',
      'Mink Creek',
      'Monteview',
      'Montour',
      'Moore',
      'Moyie Springs',
      'Mud Lake',
      'Mullan',
      'Murphy',
      'Murtaugh',
      'Myrtle',
      'New Meadows',
      'New Plymouth',
      'Newdale',
      'Nezperce',
      'Niter',
      'Nordman',
      'North Fork',
      'Notus',
      'Nounan',
      'Oldtown',
      'Onaway',
      'Oreana',
      'Orofino',
      'Osburn',
      'Osgood',
      'Owyhee',
      'Palisades',
      'Parkline',
      'Paul',
      'Payette',
      'Pearl',
      'Peck',
      'Pegram',
      'Picabo',
      'Plummer',
      'Pocatello',
      'Pollock',
      'Ponderay',
      'Porthill',
      'Post Falls',
      'Potlatch',
      'Prairie',
      'Priest River',
      'Rathdrum',
      'Red River Hot Springs',
      'Reubens',
      'Rexburg',
      'Riddle',
      'Rigby',
      'Riggins',
      'Ririe',
      'Roberts',
      'Robin',
      'Rockford Bay',
      'Rogerson',
      'Rose Lake',
      'Roseworth',
      'Roy',
      'Saint Anthony',
      'Saint Maries',
      'Salmon',
      'Sandpoint',
      'Shelley',
      'Shoup',
      'Smelterville',
      'Smiths Ferry',
      'Spencer',
      'Spirit Lake',
      'Star',
      'State Line Village',
      'Stites',
      'Stone',
      'Strevell',
      'Sublett',
      'Sunbeam',
      'Swan Valley',
      'Swanlake',
      'Sweet',
      'Tensed',
      'Terreton',
      'Teton',
      'Tetonia',
      'Thama',
      'Three Creek',
      'Turner',
      'Twin Falls',
      'Tyhee',
      'Ucon',
      'Wardner',
      'Warm River',
      'Wayan',
      'Weippe',
      'Weiser',
      'Wendell',
      'White Bird',
      'Whitney',
      'Wilder',
      'Worley',
    ],
    'US-IL': [
      'Abingdon',
      'Adair',
      'Addieville',
      'Adeline',
      'Akin',
      'Albers',
      'Alexis',
      'Algonquin',
      'Allenville',
      'Allerton',
      'Alorton',
      'Alpha',
      'Alsey',
      'Alsip',
      'Altamont',
      'Alto Pass',
      'Alvin',
      'Anchor',
      'Annawan',
      'Apple Canyon Lake',
      'Apple River',
      'Aptakisic',
      'Arbury Hills',
      'Arenzville',
      'Arlington Heights',
      'Armington',
      'Aroma Park',
      'Arthur',
      'Ashkum',
      'Ashley',
      'Ashmore',
      'Assumption',
      'Astoria',
      'Ava',
      'Aviston',
      'Baileyville',
      'Balcom',
      'Bannockburn',
      'Bardolph',
      'Barnhill',
      'Barrington Hills',
      'Barrington Woods',
      'Barry',
      'Bartelso',
      'Bartonville',
      'Basco',
      'Batavia',
      'Batchtown',
      'Bay View Garden',
      'Baylis',
      'Beach Park',
      'Beardstown',
      'Beason',
      'Beaverville',
      'Beckemeyer',
      'Bedford Park',
      'Beecher',
      'Beecher City',
      'Belgium',
      'Belknap',
      'Belle Prairie City',
      'Belle Rive',
      'Bellmont',
      'Belvidere',
      'Bement',
      'Benld',
      'Bensenville',
      'Bethalto',
      'Beverly',
      'Big Rock',
      'Biggsville',
      'Billett',
      'Bingham',
      'Bishop Hill',
      'Blandinsville',
      'Blue Island',
      'Blue Mound',
      'Bluffs',
      'Bluffside',
      'Bluford',
      'Bogota',
      'Bolingbrook',
      'Bondville',
      'Bone Gap',
      'Bonnie',
      'Boody',
      'Borton',
      'Boulder Hill',
      'Bourbon',
      'Bourbonnais',
      'Braceville',
      'Breese',
      'Bridgeview',
      'Brimfield',
      'Broadview',
      'Broadwell',
      'Brocton',
      'Brookport',
      'Broughton',
      'Brownfield',
      'Browning',
      'Browns',
      'Brownstown',
      'Brussels',
      'Buckley',
      'Buda',
      'Buffalo',
      'Buffalo Grove',
      'Buffalo Prairie',
      'Bull Valley',
      'Bulpitt',
      'Buncombe',
      'Bunker Hill',
      'Bureau',
      'Burgess',
      'Burnham',
      'Burnt Prairie',
      'Burr Ridge',
      'Burtons Bridge',
      'Bush',
      'Cabery',
      'Cahokia',
      'Caledonia',
      'Calumet City',
      'Calumet Park',
      'Camp Point',
      'Campbell Hill',
      'Campton Hills',
      'Campus',
      'Cantrall',
      'Capron',
      'Carbon Cliff',
      'Carlinville',
      'Carlock',
      'Carmi',
      'Carol Stream',
      'Carpentersville',
      'Carrier Mills',
      'Carterville',
      'Cary',
      'Caseyville',
      'Catlin',
      'Cave-in-Rock',
      'Cedar Point',
      'Centralia',
      'Cerro Gordo',
      'Chadwick',
      'Champaign',
      'Chana',
      'Chandlerville',
      'Channahon',
      'Channel Lake',
      'Chapin',
      'Chebanse',
      'Chemung',
      'Chenoa',
      'Cherry',
      'Cherry Hill',
      'Chesterville',
      'Chestnut',
      'Chicago',
      'Chicago Heights',
      'Chicago Ridge',
      'Chillicothe',
      'Chrisman',
      'Christopher',
      'Cicero',
      'Cisne',
      'Cissna Park',
      'Clarendon Hills',
      'Clark Center',
      'Clay City',
      'Clear Lake',
      'Coal City',
      'Coal Valley',
      'Coalton',
      'Coatsburg',
      'Cobden',
      'Coffeen',
      'Coleta',
      'Collison',
      'Colp',
      'Congerville',
      'Cooksville',
      'Cornland',
      'Cortland',
      'Cottage Hills',
      'Country Club Hills',
      'Countryside',
      'Cowden',
      'Coyne Center',
      'Crab Orchard',
      'Crainville',
      'Creal Springs',
      'Crest Hill',
      'Crestwood',
      'Crete',
      'Creve Coeur',
      'Cropsey',
      'Crystal Lawns',
      'Cullom',
      'Curran',
      'Dahlgren',
      'Dallas City',
      'Dalton City',
      'Dalzell',
      'Damiansville',
      'Dana',
      'Danforth',
      'Danvers',
      'Davis Junction',
      'De Land',
      'De Soto',
      'DeKalb',
      'Deer Creek',
      'Deer Grove',
      'Deerfield',
      'Del Mar Woods',
      'Delafield',
      'Delavan',
      'Dennison',
      'Depue',
      'Des Plaines',
      'Diamond',
      'Diamond Lake',
      'Dieterich',
      'Divernon',
      'Dix',
      'Dixmoor',
      'Dolton',
      'Dongola',
      'Donnellson',
      'Dorsey',
      'Dowell',
      'Downers Grove',
      'Downs',
      'Du Bois',
      'Du Quoin',
      'Dundas',
      'Dunfermline',
      'Dunlap',
      'Dupo',
      'Dwight',
      'Eagerville',
      'Earlville',
      'East Alton',
      'East Cape Girardeau',
      'East Carondelet',
      'East Dubuque',
      'East Dundee',
      'East Galesburg',
      'East Gillespie',
      'East Hazel Crest',
      'East Moline',
      'East Peoria',
      'East Saint Louis',
      'Eastwood Manor',
      'Eddyville',
      'Edgar',
      'Edinburg',
      'Effingham',
      'El Dara',
      'Elburn',
      'Elco',
      'Eldena',
      'Eldred',
      'Elizabethtown',
      'Elk Grove Village',
      'Elkhart',
      'Elkville',
      'Ellis Grove',
      'Ellisville',
      'Ellsworth',
      'Elmhurst',
      'Elmwood',
      'Elmwood Park',
      'Elsah',
      'Elvaston',
      'Elwood',
      'Emington',
      'Energy',
      'Equality',
      'Esmond',
      'Evanston',
      'Evergreen Park',
      'Ewing',
      'Fairbury',
      'Fairmont',
      'Fairmont City',
      'Fairview Heights',
      'Fall Creek',
      'Fandon',
      'Farina',
      'Farmer City',
      'Fenton',
      'Ferris',
      'Fidelity',
      'Fieldon',
      'Findlay',
      'Fithian',
      'Flanagan',
      'Flora',
      'Floraville',
      'Flossmoor',
      'Foosland',
      'Ford Heights',
      'Forest Lake',
      'Forest View',
      'Forreston',
      'Fox Lake',
      'Fox Lake Hills',
      'Fox River Grove',
      'Frankfort',
      'Frankfort Square',
      'Franklin Grove',
      'Freeburg',
      'Freeman Spur',
      'French Village',
      'Fults',
      'Gages Lake',
      'Galatia',
      'Galesburg',
      'Galva',
      'Gard',
      'Garden Prairie',
      'Garrett',
      'Gays',
      'Geff',
      'Geneseo',
      'German Valley',
      'Germantown',
      'Germantown Hills',
      'Gibson City',
      'Gilberts',
      'Gillespie',
      'Gilson',
      'Glasford',
      'Glen Carbon',
      'Glen Ellyn',
      'Glendale Heights',
      'Godley',
      'Golden Eagle',
      'Goodenow',
      'Goodfield',
      'Goodings Grove',
      'Goodwine',
      'Goofy Ridge',
      'Goreville',
      'Gorham',
      'Grafton',
      'Grand Chain',
      'Grand Detour',
      'Grand Tower',
      'Grandwood Park',
      'Granite City',
      'Grant Park',
      'Grantfork',
      'Grayslake',
      'Grayville',
      'Green Oaks',
      'Green Rock',
      'Greenup',
      'Griggsville',
      'Gurnee',
      'Hainesville',
      'Haldane',
      'Half Day',
      'Hamletsburg',
      'Hanna City',
      'Hanover Park',
      'Hardin',
      'Harmon',
      'Harristown',
      'Hartsburg',
      'Harvard',
      'Harvel',
      'Harwood Heights',
      'Hawthorn Woods',
      'Hazel Crest',
      'Hazel Dell',
      'Hebron',
      'Hecker',
      'Hennepin',
      'Henning',
      'Heritage Lake',
      'Herrin',
      'Herscher',
      'Hettick',
      'Heyworth',
      'Hickory Hills',
      'Highland Hills',
      'Highwood',
      'Hillsdale',
      'Hillview',
      'Hinckley',
      'Hindsboro',
      'Hinsdale',
      'Hodgkins',
      'Hoffman',
      'Hoffman Estates',
      'Holiday Hills',
      'Holiday Shores',
      'Hollowayville',
      'Hollywood Heights',
      'Homer Glen',
      'Hometown',
      'Hookdale',
      'Hoopeston',
      'Hooppole',
      'Hopewell',
      'Hopkins Park',
      'Horatio Gardens',
      'Hord',
      'Huey',
      'Humboldt',
      'Hume',
      'Huntley',
      'Hurst',
      'Hutsonville',
      'Idylside',
      'Illinois City',
      'Illiopolis',
      'Imbs',
      'Indian Creek',
      'Indian Head Park',
      'Ingalls Park',
      'Ingraham',
      'Iola',
      'Ipava',
      'Iroquois',
      'Irving',
      'Irvington',
      'Itasca',
      'Iuka',
      'Ivesdale',
      'Jamesburg',
      'Jeisyville',
      'Jerseyville',
      'Jewett',
      'Johnsburg',
      'Johnsonville',
      'Johnston City',
      'Joliet',
      'Joslin',
      'Joy',
      'Junction',
      'Justice',
      'Kampsville',
      'Kane',
      'Kaneville',
      'Kangley',
      'Kankakee',
      'Kappa',
      'Kaskaskia',
      'Keenes',
      'Keeneyville',
      'Keensburg',
      'Kell',
      'Kenilworth',
      'Kenney',
      'Kewanee',
      'Keyesport',
      'Kilbourne',
      'Kildeer',
      'Kincaid',
      'Kinderhook',
      'Kingston Mines',
      'Kinmundy',
      'Kinsman',
      'Klondike',
      'Knollwood',
      'La Clede',
      'La Grange Park',
      'La Harpe',
      'La Moille',
      'La Rose',
      'LaPlace',
      'Lacon',
      'Ladd',
      'Lake Barrington',
      'Lake Bluff',
      'Lake Camelot',
      'Lake Catherine',
      'Lake Holiday',
      'Lake Ka-Ho',
      'Lake Petersburg',
      'Lake Summerset',
      'Lake Villa',
      'Lake Zurich',
      'Lake in the Hills',
      'Lakemoor',
      'Lakewood Shores',
      'Lanark',
      'Langleyville',
      'Lansing',
      'Latham Park',
      'Lawrence',
      'Le Roy',
      'Leaf River',
      'Ledford',
      'Lee Center',
      'Leland Grove',
      'Lenzburg',
      'Leonore',
      'Lerna',
      'Lewistown',
      'Liberty',
      'Lily Cache',
      'Lily Lake',
      'Lilymoor',
      'Lincoln Estates',
      'Lincolnwood',
      'Lindenhurst',
      'Lindenwood',
      'Literberry',
      'Little York',
      'Loami',
      'Lockport',
      'Loda',
      'Lodge',
      'Logan',
      'Lombard',
      'London Mills',
      'Long Creek',
      'Long Grove',
      'Long Lake',
      'Long Point',
      'Loraine',
      'Lost Nation',
      'Lostant',
      'Lotus Woods',
      'Loves Park',
      'Lovington',
      'Loxa',
      'Lyndon',
      'Lynnville',
      'Machesney Park',
      'Mackinaw',
      'Macomb',
      'Maeystown',
      'Mahomet',
      'Makanda',
      'Malden',
      'Manhattan',
      'Manito',
      'Manlius',
      'Manteno',
      'Maple Park',
      'Maquon',
      'Marengo',
      'Marine',
      'Marissa',
      'Mark',
      'Marley',
      'Maroa',
      'Marquette Heights',
      'Marseilles',
      'Martinsville',
      'Martinton',
      'Maryville',
      'Mascoutah',
      'Mason',
      'Mason City',
      'Matherville',
      'Matteson',
      'Mattoon',
      'Maunie',
      'Mazon',
      'McClure',
      'McCook',
      'McCormick',
      'McCullom Lake',
      'McHenry',
      'McLean',
      'McLeansboro',
      'McNabb',
      'Mechanicsburg',
      'Media',
      'Medinah',
      'Medora',
      'Melrose Park',
      'Mendon',
      'Menominee',
      'Meredosia',
      'Merna',
      'Merrionette Park',
      'Metamora',
      'Metropolis',
      'Mettawa',
      'Mill Creek',
      'Mill Shoals',
      'Millburn',
      'Miller City',
      'Millington',
      'Millstadt',
      'Minier',
      'Minonk',
      'Minooka',
      'Mitchellsville',
      'Mokena',
      'Moline',
      'Momence',
      'Monee',
      'Monroe Center',
      'Morrisonville',
      'Morton',
      'Morton Grove',
      'Mossville',
      'Mound City',
      'Mounds',
      'Mount Auburn',
      'Mount Carroll',
      'Mount Clare',
      'Mount Erie',
      'Mount Morris',
      'Mount Prospect',
      'Mount Pulaski',
      'Mount Sterling',
      'Moweaqua',
      'Muddy',
      'Mulberry Grove',
      'Mulkeytown',
      'Muncie',
      'Mundelein',
      'Murphysboro',
      'Murrayville',
      'Naperville',
      'Naplate',
      'Nason',
      'Nebo',
      'Neoga',
      'Neponset',
      'New Athens',
      'New Baden',
      'New Bedford',
      'New Berlin',
      'New Boston',
      'New Burnside',
      'New Canton',
      'New Douglas',
      'New Grand Chain',
      'New Hartford',
      'New Holland',
      'New Lenox',
      'New Minden',
      'New Salem',
      'New Windsor',
      'Niles',
      'Nilwood',
      'Noble',
      'Nora',
      'Norridge',
      'Norris',
      'Norris City',
      'North Aurora',
      'North Barrington',
      'North Chicago',
      'North Glen Ellyn',
      'North Henderson',
      'North Park',
      'North Pekin',
      'North Riverside',
      'Northbrook',
      'Northfield',
      'Northlake',
      "O'Fallon",
      'Oak Brook',
      'Oak Forest',
      'Oak Lawn',
      'Oak Run',
      'Oakbrook Terrace',
      'Oakford',
      'Oakwood Hills',
      'Oblong',
      'Odell',
      'Odin',
      'Ohlman',
      'Okawville',
      'Old Mill Creek',
      'Old Ripley',
      'Old Shawneetown',
      'Olive Branch',
      'Olivet',
      'Olmsted',
      'Olney',
      'Olympia Fields',
      'Onarga',
      'Opdyke',
      'Oquawka',
      'Oregon',
      'Orient',
      'Orland Hills',
      'Orland Park',
      'Osman',
      'Oswego',
      'Otterville',
      'Owaneco',
      'Palatine',
      'Palos Heights',
      'Palos Hills',
      'Palos Park',
      'Panama',
      'Papineau',
      'Park City',
      'Park Forest',
      'Park Ridge',
      'Parkersburg',
      'Parnell',
      'Patoka',
      'Patton',
      'Paw Paw',
      'Pawnee',
      'Pecatonica',
      'Pekin',
      'Peoria Heights',
      'Peotone',
      'Percy',
      'Peru',
      'Pesotum',
      'Phillipstown',
      'Pierron',
      'Pinckneyville',
      'Pingree Grove',
      'Pinkstaff',
      'Piper City',
      'Pistakee Highlands',
      'Pittsfield',
      'Pittwood',
      'Plano',
      'Plato Center',
      'Plattville',
      'Pleasant Mound',
      'Poag',
      'Pontiac',
      'Pontoon Beach',
      'Pontoosuc',
      'Port Barrington',
      'Port Byron',
      'Posen',
      'Potomac',
      'Prairie City',
      'Prairie du Rocher',
      'Prestbury',
      'Preston Heights',
      'Prophetstown',
      'Pyatts',
      'Radom',
      'Rankin',
      'Ransom',
      'Rantoul',
      'Rapids City',
      'Rardin',
      'Raritan',
      'Red Bud',
      'Redmon',
      'Reevesville',
      'Rentchler',
      'Richton Park',
      'Richview',
      'Ridge Farm',
      'Ridgewood',
      'Ridott',
      'Rinard',
      'Ringwood',
      'River Forest',
      'River Grove',
      'Riverwoods',
      'Roachtown',
      'Robbs',
      'Robinson',
      'Rock City',
      'Rock Falls',
      'Rock Island',
      'Rockbridge',
      'Rockdale',
      'Rockton',
      'Rockwood',
      'Rolling Meadows',
      'Romeoville',
      'Rondout',
      'Roodhouse',
      'Roscoe',
      'Rose Hill',
      'Roselle',
      'Rosewood Heights',
      'Rosiclare',
      'Round Lake Beach',
      'Round Lake Heights',
      'Round Lake Park',
      'Roxana',
      'Royal',
      'Royal Lakes',
      'Royalton',
      'Ruma',
      'Rushville',
      'Sadorus',
      'Sailor Springs',
      'Saint Anne',
      'Saint Elmo',
      'Saint Francisville',
      'Saint Jacob',
      'Saint Joseph',
      'Saint Libory',
      'Saint Peter',
      'Saint Rose',
      'Sainte Marie',
      'Sammons Point',
      'Sandoval',
      'Sandwich',
      'Sauget',
      'Sauk Village',
      'Saunemin',
      'Savanna',
      'Savoy',
      'Saybrook',
      'Scales Mound',
      'Scarboro',
      'Schaumburg',
      'Schiller Park',
      'Schram City',
      'Sciota',
      'Scottville',
      'Seaton',
      'Seatonville',
      'Secor',
      'Seneca',
      'Sesser',
      'Shabbona',
      'Shawneetown',
      'Shelbyville',
      'Sherman',
      'Sherrard',
      'Shipman',
      'Shobonier',
      'Shorewood',
      'Shumway',
      'Sibley',
      'Sidell',
      'Sigel',
      'Silvis',
      'Simpson',
      'Skokie',
      'Smithboro',
      'Smithfield',
      'Somonauk',
      'Sorento',
      'South Barrington',
      'South Beloit',
      'South Chicago Heights',
      'South Elgin',
      'South Holland',
      'South Jacksonville',
      'South Pekin',
      'South Roxana',
      'South Wilmington',
      'Southern View',
      'Sparland',
      'Spaulding',
      'Spillertown',
      'Spring Bay',
      'Spring Grove',
      'Springerton',
      'Stallings',
      'Standard City',
      'State Park Place',
      'Staunton',
      'Steeleville',
      'Steger',
      'Steward',
      'Stewardson',
      'Stickney',
      'Stillman Valley',
      'Stockland',
      'Stolle',
      'Stone Park',
      'Stonefort',
      'Stoy',
      'Strawn',
      'Streamwood',
      'Streator',
      'Stronghurst',
      'Sublette',
      'Sugar Grove',
      'Sullivan',
      'Summum',
      'Sun River Terrace',
      'Sunfield',
      'Sunny Crest',
      'Swanwick',
      'Symerton',
      'Table Grove',
      'Tallula',
      'Tamaroa',
      'Tamms',
      'Taylor Springs',
      'Taylorville',
      'Tennessee',
      'Teutopolis',
      'Thawville',
      'Thayer',
      'Thebes',
      'Third Lake',
      'Thomasboro',
      'Tilden',
      'Timberlane',
      'Time',
      'Timewell',
      'Tinley Park',
      'Tiskilwa',
      'Tolono',
      'Tonica',
      'Topeka',
      'Tovey',
      'Towanda',
      'Tower Hill',
      'Tower Lake',
      'Tremont',
      'Triumph',
      'Trout Valley',
      'Troy Grove',
      'Tuscola',
      'Twin Grove',
      'Ullin',
      'Union Hill',
      'Ursa',
      'Utica',
      'Valier',
      'Valley City',
      'Valley View',
      'Valmeyer',
      'Vandalia',
      'Venedy',
      'Venetian Village',
      'Vergennes',
      'Vermont',
      'Vernon Hills',
      'Virgil',
      'Volo',
      'Wadsworth',
      'Waggoner',
      'Walshville',
      'Waltonville',
      'Wamac',
      'Wapella',
      'Ware',
      'Warrensburg',
      'Warrenville',
      'Wasson',
      'Wataga',
      'Waterman',
      'Watseka',
      'Wauconda',
      'Waukegan',
      'Wayne',
      'Wayne City',
      'Waynesville',
      'Wedges Corner',
      'Wedron',
      'Wenonah',
      'West Brooklyn',
      'West Chicago',
      'West City',
      'West Dundee',
      'West Frankfort',
      'West Jersey',
      'West Peoria',
      'West Salem',
      'West Union',
      'West York',
      'Western Springs',
      'Westervelt',
      'Westfield',
      'Wheaton',
      'Wheeler',
      'Wheeling',
      'White Ash',
      'White Heath',
      'Whittington',
      'Williams Park',
      'Williamsfield',
      'Williamsville',
      'Willow Hill',
      'Willow Springs',
      'Wilmette',
      'Wilton Center',
      'Winnebago',
      'Winnetka',
      'Winthrop Harbor',
      'Witt',
      'Wonder Lake',
      'Wood Dale',
      'Wood River',
      'Woodhull',
      'Woodlawn',
      'Woodridge',
      'Woodworth',
      'Woosung',
      'Worden',
      'Wyanet',
      'Xenia',
      'Yates City',
      'York Center',
      'Yorkfield',
      'Zeigler',
    ],
    'US-IN': [
      'Aboite',
      'Adams',
      'Advance',
      'Ainsworth',
      'Alfordsville',
      'Alquina',
      'Ambia',
      'Amo',
      'Angola',
      'Argos',
      'Attica',
      'Azalia',
      'Bargersville',
      'Battle Ground',
      'Beal',
      'Beech Grove',
      'Bengal',
      'Berne',
      'Beverly Shores',
      'Bicknell',
      'Bippus',
      'Birdseye',
      'Blanford',
      'Blocher',
      'Brazil',
      'Bridgeton',
      'Brook',
      'Brooksburg',
      'Brookston',
      'Brookville',
      'Brownsburg',
      'Bruceville',
      'Buck Creek',
      'Bucktown',
      'Burket',
      'Burnett',
      'Burnettsville',
      'Burns City',
      'Burns Harbor',
      'Burrows',
      'Caborn',
      'Cambridge City',
      'Campbellsburg',
      'Cannelburg',
      'Cannelton',
      'Carmel',
      'Castleton',
      'Cataract',
      'Cayuga',
      'Cedar Lake',
      'Celestine',
      'Chalmers',
      'Chambersburg',
      'Charlestown',
      'Chesterton',
      'Chrisney',
      'Churubusco',
      'Clarks Hill',
      'Clifford',
      'Coatesville',
      'Coe',
      'Collegeville',
      'Columbia City',
      'Connersville',
      'Converse',
      'Cordry Sweetwater Lakes',
      'Cornettsville',
      'Corunna',
      'Cory',
      'Corydon',
      'Country Club Heights',
      'Country Squire Lakes',
      'Crandall',
      'Crane',
      'Crocker',
      'Cross Plains',
      'Crothersville',
      'Crumstown',
      'Culver',
      'Cuzco',
      'Cynthiana',
      'Dale',
      'DeMotte',
      'Decker',
      'Delong',
      'Delphi',
      'Depauw',
      'Deputy',
      'Dillsboro',
      'Domestic',
      'Dover Hill',
      'Dugger',
      'Dune Acres',
      'Dunreith',
      'Earl Park',
      'East Chicago',
      'East Enterprise',
      'East Germantown',
      'Economy',
      'Edwardsport',
      'Elberfeld',
      'Elizaville',
      'Ellettsville',
      'Eminence',
      'Emison',
      'Emma',
      'English',
      'Enos Corner',
      'Etna Green',
      'Fairland',
      'Fairview Park',
      'Farmersburg',
      'Farmland',
      'Fish Lake',
      'Fishers',
      'Fontanet',
      'Fort Branch',
      'Fort Wayne',
      'Fortville',
      'Foster',
      'Fountain City',
      'Fowlerton',
      'Francesville',
      'Francisco',
      'Frankton',
      'Fredericksburg',
      'Freelandville',
      'Freetown',
      'French Lick',
      'Galveston',
      'Gary',
      'Gas City',
      'Gaston',
      'Gentryville',
      'Gessie',
      'Gosport',
      'Grabill',
      'Granger',
      'Grass Creek',
      'Greencastle',
      'Greendale',
      'Greens Fork',
      'Greensburg',
      'Greentown',
      'Grovertown',
      'Guilford',
      'Hagerstown',
      'Hamlet',
      'Hardinsburg',
      'Harlan',
      'Harrodsburg',
      'Hartford City',
      'Hartsville',
      'Haubstadt',
      'Hazleton',
      'Heltonville',
      'Henryville',
      'Herbst',
      'Hidden Valley',
      'Highwoods',
      'Hoagland',
      'Hollandsburg',
      'Holton',
      'Homecroft',
      'Howe',
      'Howesville',
      'Hudson Lake',
      'Huntertown',
      'Huntingburg',
      'Hymera',
      'Idaville',
      'Independence Hill',
      'Indian Heights',
      'Indian Village',
      'Indianapolis',
      'Inglefield',
      'Jasonville',
      'Judson',
      'Judyville',
      'Kasson',
      'Kendallville',
      'Kennard',
      'Kentland',
      'Kewanna',
      'Kimmell',
      'Kingsbury',
      'Kingsford Heights',
      'Kirklin',
      'Knightstown',
      'Knightsville',
      'Kniman',
      'Knox',
      'Kokomo',
      'Koleen',
      'Koontz Lake',
      'Kouts',
      'Kurtz',
      'La Fontaine',
      'LaPorte',
      'Laconia',
      'Ladoga',
      'Lagrange',
      'Lagro',
      'Lake Dalecarlia',
      'Lake Hills',
      'Lake Station',
      'Lakes of the Four Seasons',
      'Laketon',
      'Landess',
      'Lanesville',
      'Laotto',
      'Lapel',
      'Larwill',
      'Laud',
      'Lawrenceburg',
      'Leavenworth',
      'Leo-Cedarville',
      'Leopold',
      'Letts',
      'Liberty Park',
      'Ligonier',
      'Lincoln City',
      'Lincoln Hills',
      'Livonia',
      'Lizton',
      'Logansport',
      'Loogootee',
      'Losantville',
      'Lottaville',
      'Lydick',
      'Mackey',
      'Macy',
      'Majenica',
      'Manson',
      'Markle',
      'Markleville',
      'Marshfield',
      'Mauckport',
      'Mays',
      'McCordsville',
      'Medaryville',
      'Mellott',
      'Melody Hill',
      'Meridian Hills',
      'Merom',
      'Merriam',
      'Metea',
      'Mexico',
      'Michiana Shores',
      'Michigan City',
      'Michigantown',
      'Middlebury',
      'Millersburg',
      'Millgrove',
      'Millhousen',
      'Milltown',
      'Milroy',
      'Mishawaka',
      'Mixersville',
      'Monon',
      'Monroe City',
      'Montmorenci',
      'Mooreland',
      'Moores Hill',
      'Morgantown',
      'Morocco',
      'Mount Ayr',
      'Mount Etna',
      'Mount Summit',
      'Munster',
      'Nabb',
      'Napoleon',
      'Nappanee',
      'New Albany',
      'New Amsterdam',
      'New Carlisle',
      'New Chicago',
      'New Elliott',
      'New Goshen',
      'New Harmony',
      'New Lisbon',
      'New Middletown',
      'New Palestine',
      'New Paris',
      'New Pekin',
      'New Point',
      'New Ross',
      'New Salisbury',
      'New Trenton',
      'New Washington',
      'New Whiteland',
      'Newburgh',
      'Noblesville',
      'North Crows Nest',
      'North Judson',
      'North Liberty',
      'North Manchester',
      'North Salem',
      'North Terre Haute',
      'North Vernon',
      'North Webster',
      'Norway',
      'Oakland City',
      'Oaktown',
      'Odon',
      'Ogden Dunes',
      'Onward',
      'Oolitic',
      'Orestes',
      'Ossian',
      'Otisco',
      'Owensburg',
      'Painted Hills',
      'Paragon',
      'Paris Crossing',
      'Parker City',
      'Parkers Settlement',
      'Patricksburg',
      'Patriot',
      'Pendleton',
      'Pennville',
      'Perrysville',
      'Pierceton',
      'Pimento',
      'Pine Village',
      'Pittsboro',
      'Pleasant Lake',
      'Point Isabel',
      'Poneto',
      'Portage',
      'Porter',
      'Poseyville',
      'Pottawattamie Park',
      'Princes Lakes',
      'Putnamville',
      'Raglesville',
      'Ragsdale',
      'Redkey',
      'Remington',
      'Rensselaer',
      'Rexville',
      'Riley',
      'Roachdale',
      'Roann',
      'Rockfield',
      'Rocky Ripple',
      'Rolling Prairie',
      'Rome City',
      'Roselawn',
      'Royal Center',
      'Russiaville',
      'Saint Bernice',
      'Saint Leon',
      'Saint Mary-of-the-Woods',
      'Saint Meinrad',
      'Salamonia',
      'San Pierre',
      'Sandborn',
      'Sardinia',
      'Schererville',
      'Schneider',
      'Scipio',
      'Scottsburg',
      'Seelyville',
      'Sellersburg',
      'Selvin',
      'Servia',
      'Shadeland',
      'Shamrock Lakes',
      'Sharpsville',
      'Sharptown',
      'Shelburn',
      'Shepardsville',
      'Shipshewana',
      'Shoals',
      'Shorewood Forest',
      'Simonton Lake',
      'Solitude',
      'South Bend',
      'South Haven',
      'South Whitley',
      'Sparksville',
      'Speedway',
      'Spencerville',
      'Spiceland',
      'Spring Hills',
      'Springport',
      'Spurgeon',
      'State Line',
      'Stilesville',
      'Stinesville',
      'Straughn',
      'Stroh',
      'Summitville',
      'Sunman',
      'Swayzee',
      'Sweetser',
      'Switz City',
      'Syracuse',
      'Tell City',
      'Tennyson',
      'Terre Haute',
      'Thorntown',
      'Toad Hop',
      'Tocsin',
      'Town of Pines',
      'Trafalgar',
      'Trail Creek',
      'Trevlac',
      'Tri-Lakes',
      'Turkey Creek Meadows',
      'Tyner',
      'Ulen',
      'Uniondale',
      'Universal',
      'Valeene',
      'Vallonia',
      'Van Bibber Lake',
      'Veedersburg',
      'Vevay',
      'Wadesville',
      'Wakarusa',
      'Walkerton',
      'Wanatah',
      'Warren Park',
      'Waynetown',
      'Wellsboro',
      'West Baden Springs',
      'West College Corner',
      'West Harrison',
      'West Lafayette',
      'West Lebanon',
      'West Terre Haute',
      'Westphalia',
      'Westpoint',
      'Wheatfield',
      'Whiteland',
      'Whitestown',
      'Whiting',
      'Wilkinson',
      'Williams Creek',
      'Williamsport',
      'Winamac',
      'Windfall',
      'Wingate',
      'Winona Lake',
      'Wolcottville',
      'Wolflake',
      'Woodlawn Heights',
      'Worthington',
      'Wynnedale',
      'Yeddo',
      'Yeoman',
      'Young America',
      'Zanesville',
      'Zionsville',
    ],
    'US-IA': [
      'Ackley',
      'Ackworth',
      'Agency',
      'Albert City',
      'Albia',
      'Alburnett',
      'Alden',
      'Algona',
      'Alleman',
      'Alta Vista',
      'Alvord',
      'Amana',
      'Amber',
      'Ames',
      'Anamosa',
      'Anita',
      'Ankeny',
      'Anthon',
      'Aplington',
      'Arbor Hill',
      'Aredale',
      'Arion',
      'Arispe',
      'Arnolds Park',
      'Asbury',
      'Aspinwall',
      'Atalissa',
      'Athelstan',
      'Atlantic',
      'Audubon',
      'Aurelia',
      'Ayrshire',
      'Bagley',
      'Balltown',
      'Bankston',
      'Barnes City',
      'Barnum',
      'Battle Creek',
      'Baxter',
      'Bayard',
      'Beaman',
      'Beaverdale',
      'Belle Plaine',
      'Belmond',
      'Bernard',
      'Bertram',
      'Bettendorf',
      'Bevington',
      'Blairsburg',
      'Blairstown',
      'Blakesburg',
      'Blencoe',
      'Blockton',
      'Blue Grass',
      'Bode',
      'Bolan',
      'Bonaparte',
      'Bondurant',
      'Botna',
      'Bouton',
      'Boxholm',
      'Boyden',
      'Braddyville',
      'Bradgate',
      'Brayton',
      'Bremer',
      'Bristow',
      'Britt',
      'Brunsville',
      'Buck Grove',
      'Buffalo Center',
      'Burchinal',
      'Burr Oak',
      'Burt',
      'Bussey',
      'Calamus',
      'California Junction',
      'Calumet',
      'Camanche',
      'Cantril',
      'Carpenter',
      'Carroll',
      'Carter Lake',
      'Castalia',
      'Cedar Falls',
      'Cedar Rapids',
      'Center Junction',
      'Chariton',
      'Charles City',
      'Charlotte',
      'Churdan',
      'Cincinnati',
      'Clarence',
      'Clarinda',
      'Clarion',
      'Clearfield',
      'Cleghorn',
      'Clemons',
      'Climbing Hill',
      'Clutier',
      'Coalville',
      'Coggon',
      'Coin',
      'Colesburg',
      'College Springs',
      'Colo',
      'Columbus City',
      'Columbus Junction',
      'Colwell',
      'Conesville',
      'Conrad',
      'Conroy',
      'Coon Rapids',
      'Coppock',
      'Coralville',
      'Corley',
      'Correctionville',
      'Corwith',
      'Coulter',
      'Council Bluffs',
      'Cresco',
      'Croton',
      'Cushing',
      'Cylinder',
      'Dakota City',
      'Dallas Center',
      'Davis City',
      'Decatur City',
      'Decorah',
      'Dedham',
      'Defiance',
      'Deloit',
      'Delphos',
      'Des Moines',
      'Diagonal',
      'Diamondhead Lake',
      'Dickens',
      'Dike',
      'Dolliver',
      'Donahue',
      'Donnan',
      'Doon',
      'Douds',
      'Dougherty',
      'Dow City',
      'Dows',
      'Drakesville',
      'Dubuque',
      'Duncombe',
      'Dunkerton',
      'Durant',
      'Dyersville',
      'Earlham',
      'Earling',
      'Early',
      'East Amana',
      'East Peru',
      'Elberon',
      'Eldon',
      'Elk Horn',
      'Elk Run Heights',
      'Elkader',
      'Elkport',
      'Ellston',
      'Elma',
      'Ely',
      'Emmetsburg',
      'Estherville',
      'Evansdale',
      'Everly',
      'Ewart',
      'Exira',
      'Exline',
      'Fairbank',
      'Fairport',
      'Farley',
      'Farlin',
      'Farnhamville',
      'Farragut',
      'Farson',
      'Faulkner',
      'Fernald',
      'Fertile',
      'Finchford',
      'Floris',
      'Folletts',
      'Fonda',
      'Fort Atkinson',
      'Fort Dodge',
      'Fort Madison',
      'Fostoria',
      'Frederika',
      'Frytown',
      'Garber',
      'Garnavillo',
      'Garrison',
      'Garwin',
      'Gaza',
      'George',
      'Gilbertville',
      'Gillett Grove',
      'Gilliatt',
      'Gilmore City',
      'Gladbrook',
      'Glidden',
      'Goodell',
      'Goose Lake',
      'Gowrie',
      'Graettinger',
      'Graf',
      'Grand Mound',
      'Grand River',
      'Gravity',
      'Green Island',
      'Green Mountain',
      'Greene',
      'Grinnell',
      'Griswold',
      'Grundy Center',
      'Gruver',
      'Guernsey',
      'Gunder',
      'Guthrie Center',
      'Guttenberg',
      'Halbur',
      'Halfa',
      'Hamlin',
      'Hancock',
      'Hanlontown',
      'Hansell',
      'Harper',
      'Harpers Ferry',
      'Hartwick',
      'Hawarden',
      'Hawkeye',
      'Hayesville',
      'Hayfield',
      'Hedrick',
      'Hepburn',
      'High Amana',
      'Highland Center',
      'Highlandville',
      'Hills',
      'Hiteman',
      'Holiday Lake',
      'Holstein',
      'Hopkinton',
      'Hornick',
      'Hospers',
      'Houghton',
      'Hubbard',
      'Humeston',
      'Hurstville',
      'Huxley',
      'Iconium',
      'Ida Grove',
      'Imogene',
      'Ionia',
      'Iowa City',
      'Iowa Falls',
      'Ira',
      'Ireton',
      'Jackson Junction',
      'Jamison',
      'Jerico',
      'Jewell',
      'Johnston',
      'Joice',
      'Jolley',
      'Jordan',
      'Kalona',
      'Kamrar',
      'Kanawha',
      'Kellerton',
      'Kelley',
      'Keokuk',
      'Keomah Village',
      'Keosauqua',
      'Kesley',
      'Killduff',
      'Kimballton',
      'Kinross',
      'Kirkman',
      'Kirkville',
      'Kiron',
      'Klemme',
      'Knierim',
      'Knoke',
      'Koszta',
      'La Motte',
      'La Porte City',
      'Lacey',
      'Lacona',
      'Ladora',
      'Lake Mills',
      'Lake Panorama',
      'Lakota',
      'Lambs Grove',
      'Lamoni',
      'Lanesboro',
      'Langdon',
      'Langworthy',
      'Lanyon',
      'Larchwood',
      'Larrabee',
      'Latimer',
      'Laurens',
      'Lawler',
      'Lawton',
      'Le Claire',
      'Le Mars',
      'Leando',
      'Ledyard',
      'Leon',
      'Lidderdale',
      'Lime Springs',
      'Linby',
      'Linn Grove',
      'Liscomb',
      'Little Cedar',
      'Little Sioux',
      'Littleport',
      'Lockridge',
      'Lohrville',
      'Lone Rock',
      'Lorimor',
      'Lovilia',
      'Low Moor',
      'Lowden',
      'Lu Verne',
      'Luana',
      'Lucas',
      'Luther',
      'Luxemburg',
      'Luzerne',
      'Lyman',
      'Macksburg',
      'Maharishi Vedic City',
      'Malcom',
      'Mallard',
      'Maloy',
      'Manly',
      'Maquoketa',
      'Marble Rock',
      'Marcus',
      'Marne',
      'Marquette',
      'Marshalltown',
      'Martelle',
      'Martensdale',
      'Martinsburg',
      'Massena',
      'Massillon',
      'Maurice',
      'May City',
      'McCallsburg',
      'McCausland',
      'McClelland',
      'McIntire',
      'Mediapolis',
      'Melcher-Dallas',
      'Merrill',
      'Meservey',
      'Meyer',
      'Middle Amana',
      'Millerton',
      'Minburn',
      'Mineola',
      'Mingo',
      'Missouri Valley',
      'Modale',
      'Moingona',
      'Mona',
      'Mondamin',
      'Moneta',
      'Monona',
      'Monteith',
      'Moorhead',
      'Moorland',
      'Morning Sun',
      'Morse',
      'Morton Mills',
      'Mount Hamill',
      'Mount Union',
      'Moville',
      'Muscatine',
      'Nashua',
      'Nemaha',
      'Neola',
      'Nevinville',
      'New Albin',
      'New Hampton',
      'New Liberty',
      'New Providence',
      'New Sharon',
      'New Vienna',
      'New Virginia',
      'Nichols',
      'Nodaway',
      'Nora Springs',
      'North Buena Vista',
      'North English',
      'Northboro',
      'Numa',
      'Oakland Acres',
      'Ocheyedan',
      'Odebolt',
      'Oelwein',
      'Okoboji',
      'Olin',
      'Ollie',
      'Onawa',
      'Oskaloosa',
      'Osterdock',
      'Otho',
      'Otley',
      'Oto',
      'Ottosen',
      'Ottumwa',
      'Owasa',
      'Oxford Junction',
      'Oyens',
      'Pacific Junction',
      'Packard',
      'Packwood',
      'Palo',
      'Panora',
      'Panorama Park',
      'Park View',
      'Paton',
      'Paullina',
      'Peosta',
      'Percival',
      'Persia',
      'Pilot Mound',
      'Pleasant Plain',
      'Plover',
      'Pomeroy',
      'Popejoy',
      'Prairieburg',
      'Primghar',
      'Promise City',
      'Protivin',
      'Quasqueton',
      'Quimby',
      'Radcliffe',
      'Rake',
      'Ralston',
      'Randalia',
      'Randall',
      'Rands',
      'Rathbun',
      'Readlyn',
      'Reasnor',
      'Reinbeck',
      'Rembrandt',
      'Remsen',
      'Renwick',
      'Rhodes',
      'Riceville',
      'Rickardsville',
      'Ricketts',
      'Ringsted',
      'Rippey',
      'River Sioux',
      'Robins',
      'Rock Rapids',
      'Rock Valley',
      'Rockwell City',
      'Rodman',
      'Rodney',
      'Rolfe',
      'Rossie',
      'Rowan',
      'Rowley',
      'Rubio',
      'Rudd',
      'Runnells',
      'Ruthven',
      'Ryan',
      'Sabula',
      'Sac City',
      'Sageville',
      'Saint Ansgar',
      'Saint Benedict',
      'Saint Donatus',
      'Saint Lucas',
      'Saint Olaf',
      'Salix',
      'Sand Springs',
      'Sandyville',
      'Saylorville',
      'Scarville',
      'Schaller',
      'Schley',
      'Searsboro',
      'Seney',
      'Sergeant Bluff',
      'Sewal',
      'Sexton',
      'Shambaugh',
      'Shannon City',
      'Sheldahl',
      'Shell Rock',
      'Shellsburg',
      'Shenandoah',
      'Shipley',
      'Shueyville',
      'Siam',
      'Sigourney',
      'Sioux Center',
      'Sioux City',
      'Sioux Rapids',
      'Slater',
      'Sloan',
      'Smithland',
      'Soldier',
      'Solon',
      'South Amana',
      'South English',
      'Spillville',
      'Spragueville',
      'Springbrook',
      'Stacyville',
      'Stanhope',
      'Stanwood',
      'State Center',
      'Steamboat Rock',
      'Stennett',
      'Stiles',
      'Stilson',
      'Storm Lake',
      'Story City',
      'Stout',
      'Strawberry Point',
      'Struble',
      'Sully',
      'Sunbury',
      'Sutherland',
      'Swaledale',
      'Swan',
      'Swea City',
      'Swedesburg',
      'Swisher',
      'Tabor',
      'Teeds Grove',
      'Terril',
      'Thor',
      'Thornburg',
      'Thurman',
      'Tiffin',
      'Tingley',
      'Titonka',
      'Toddville',
      'Toeterville',
      'Traer',
      'Treynor',
      'Tripoli',
      'Truesdale',
      'Udell',
      'University Heights',
      'Urbandale',
      'Ute',
      'Valeria',
      'Van Horne',
      'Van Meter',
      'Varina',
      'Villisca',
      'Vining',
      'Volga',
      'Voorhies',
      'Wadena',
      'Wahpeton',
      'Walcott',
      'Walford',
      'Wall Lake',
      'Wallingford',
      'Wapello',
      'Washta',
      'Waucoma',
      'Waukee',
      'Waukon',
      'Wayland',
      'Webster City',
      'Wellman',
      'Wellsburg',
      'Welton',
      'West Amana',
      'West Bend',
      'West Branch',
      'West Burlington',
      'West Chester',
      'West Des Moines',
      'West Grove',
      'West Liberty',
      'West Okoboji',
      'Westgate',
      'Wever',
      'What Cheer',
      'Whittemore',
      'Whitten',
      'Willey',
      'Windsor Heights',
      'Winterset',
      'Wiota',
      'Woden',
      'Woodward',
      'Woolstock',
      'Wyman',
      'Yetter',
      'Zearing',
      'Zwingle',
    ],
    'US-KS': [
      'Abbyville',
      'Abilene',
      'Ada',
      'Admire',
      'Aetna',
      'Agenda',
      'Agricola',
      'Alamota',
      'Albert',
      'Allen',
      'Almena',
      'Andale',
      'Angelus',
      'Anson',
      'Antonino',
      'Argonia',
      'Arma',
      'Arrington',
      'Ash Grove',
      'Asherville',
      'Assaria',
      'Atchison',
      'Aulne',
      'Axtell',
      'Bala',
      'Baldwin City',
      'Barclay',
      'Barnard',
      'Barnes',
      'Basehor',
      'Bavaria',
      'Baxter Springs',
      'Bazine',
      'Beagle',
      'Beattie',
      'Beeler',
      'Bellaire',
      'Bellefont',
      'Beloit',
      'Belpre',
      'Belvue',
      'Bendena',
      'Benedict',
      'Bern',
      'Big Bow',
      'Bird City',
      'Bison',
      'Blakeman',
      'Bloom',
      'Blue Rapids',
      'Bogue',
      'Boicourt',
      'Bonner Springs',
      'Brazilton',
      'Brownell',
      'Bucklin',
      'Bucyrus',
      'Buhler',
      'Burden',
      'Burdett',
      'Burdick',
      'Burrton',
      'Bush City',
      'Bushong',
      'Bushton',
      'Calista',
      'Caney',
      'Cassoday',
      'Catharine',
      'Cawker City',
      'Cedar',
      'Cedar Bluffs',
      'Cedar Vale',
      'Centropolis',
      'Chanute',
      'Chautauqua',
      'Cheney',
      'Cherryvale',
      'Chetopa',
      'Chiles',
      'Circleville',
      'Claflin',
      'Claudell',
      'Clay Center',
      'Clements',
      'Coats',
      'Codell',
      'Coffeyville',
      'Colby',
      'Coldwater',
      'Collyer',
      'Colony',
      'Colwich',
      'Conway Springs',
      'Corbin',
      'Corwin',
      'Cottonwood Falls',
      'Council Grove',
      'Covert',
      'Coyville',
      'Croft',
      'Cullison',
      'Cummings',
      'Cunningham',
      'Damar',
      'Dellvale',
      'Dennis',
      'Densmore',
      'Dighton',
      'Doniphan',
      'Dorrance',
      'Douglass',
      'Duquoin',
      'Earlton',
      'Eastborough',
      'Edmond',
      'Elbing',
      'Elk Falls',
      'Ellinwood',
      'Elmdale',
      'Elmo',
      'Elmont',
      'Elsmore',
      'Elyria',
      'Emporia',
      'Englevale',
      'Ensign',
      'Esbon',
      'Eskridge',
      'Everest',
      'Fairway',
      'Fall River',
      'Falun',
      'Fanning',
      'Farlington',
      'Fellsburg',
      'Ford',
      'Fort Scott',
      'Friend',
      'Furley',
      'Garden Plain',
      'Garnett',
      'Gas',
      'Gaylord',
      'Geuda Springs',
      'Glade',
      'Glasco',
      'Glen Elder',
      'Goddard',
      'Goessel',
      'Goff',
      'Gove',
      'Grainfield',
      'Grandview Plaza',
      'Great Bend',
      'Green',
      'Greenwich Heights',
      'Grenola',
      'Grigston',
      'Haddam',
      'Halls Summit',
      'Halstead',
      'Hanston',
      'Harding',
      'Hardtner',
      'Harveyville',
      'Haven',
      'Havensville',
      'Haviland',
      'Hays',
      'Haysville',
      'Hedville',
      'Heizer',
      'Hepler',
      'Herington',
      'Herkimer',
      'Hesston',
      'Hewins',
      'Hiattville',
      'Hickok',
      'Hitschmann',
      'Hoisington',
      'Holcomb',
      'Hollenberg',
      'Home',
      'Horace',
      'Hugoton',
      'Hunnewell',
      'Huscher',
      'Hutchinson',
      'Hymer',
      'Idana',
      'Iowa Point',
      'Jetmore',
      'Jingo',
      'Kackley',
      'Kalvesta',
      'Kanopolis',
      'Kanorado',
      'Kansas City',
      'Keats',
      'Kechi',
      'Kelly',
      'Kenneth',
      'Kimball',
      'Kingsdown',
      'Kinsley',
      'Kipp',
      'Kirwin',
      'Kismet',
      'La Cygne',
      'Labette',
      'Lackmans',
      'Laclede',
      'Lafontaine',
      'Lake Quivira',
      'Lakin',
      'Lane',
      'Larned',
      'Le Loup',
      'LeRoy',
      'Leawood',
      'Lebo',
      'Lecompton',
      'Lenexa',
      'Lenora',
      'Leona',
      'Leonardville',
      'Leoti',
      'Leoville',
      'Levant',
      'Liberal',
      'Liebenthal',
      'Lincolnville',
      'Lindsborg',
      'Linn',
      'Linn Valley',
      'Lone Elm',
      'Lone Star',
      'Longton',
      'Loretta',
      'Lost Springs',
      'Louisburg',
      'Lovewell',
      'Lowemont',
      'Ludell',
      'Luray',
      'Mahaska',
      'Maize',
      'Mankato',
      'Manter',
      'Maple Hill',
      'Marienthal',
      'Matfield Green',
      'Mayetta',
      'McCune',
      'McDonald',
      'McLouth',
      'McPherson',
      'Meade',
      'Medicine Lodge',
      'Melvern',
      'Mentor',
      'Midland Park',
      'Mildred',
      'Miltonvale',
      'Minneapolis',
      'Mission Woods',
      'Mont Ida',
      'Moran',
      'Morehead',
      'Morland',
      'Morrill',
      'Morrowville',
      'Mound Valley',
      'Moundridge',
      'Mount Hope',
      'Mullinville',
      'Mulvane',
      'Munden',
      'Munjor',
      'Muscotah',
      'Narka',
      'Natoma',
      'Natrona',
      'Neal',
      'Nekoma',
      'Neodesha',
      'Neosho Falls',
      'Neosho Rapids',
      'Ness City',
      'Netawaka',
      'Neutral',
      'New Almelo',
      'New Cambria',
      'New Lancaster',
      'New Strawn',
      'Nickerson',
      'Nicodemus',
      'Niotaze',
      'Norcatur',
      'North Newton',
      'Northbranch',
      'Nortonville',
      'Oak Valley',
      'Oberlin',
      'Offerle',
      'Ogallah',
      'Oketo',
      'Olmitz',
      'Olpe',
      'Olsburg',
      'Onaga',
      'Opolis',
      'Osage City',
      'Osawatomie',
      'Osborne',
      'Overland Park',
      'Ozawkie',
      'Padonia',
      'Page City',
      'Palco',
      'Park',
      'Parkerfield',
      'Parkerville',
      'Parsons',
      'Partridge',
      'Pauline',
      'Pawnee Rock',
      'Pawnee Station',
      'Paxico',
      'Peabody',
      'Penalosa',
      'Pfeifer',
      'Pierceville',
      'Piper',
      'Piqua',
      'Portis',
      'Potwin',
      'Powhattan',
      'Prairie Village',
      'Pratt',
      'Pretty Prairie',
      'Protection',
      'Quenemo',
      'Quinter',
      'Radium',
      'Rago',
      'Reager',
      'Reece',
      'Republic',
      'Reserve',
      'Rexford',
      'Rock',
      'Roeland Park',
      'Rolla',
      'Rosalia',
      'Roxbury',
      'Rozel',
      'Rush Center',
      'Russell Springs',
      'Sabetha',
      'Sallyards',
      'Satanta',
      'Saunders',
      'Savonburg',
      'Sawyer',
      'Scammon',
      'Scandia',
      'Schoenchen',
      'Schulte',
      'Scott City',
      'Selden',
      'Severy',
      'Shallow Water',
      'Sharon Springs',
      'Sharpe',
      'Shaw',
      'Sherwin',
      'Shields',
      'Silverdale',
      'Skiddy',
      'Smith Center',
      'Smolan',
      'South Hutchinson',
      'South Mound',
      'Spearville',
      'Speed',
      'Spivey',
      'St. John',
      'Stafford',
      'Stark',
      'Stilwell',
      'Stippville',
      'Strong City',
      'Studley',
      'Stull',
      'Susank',
      'Sylvan Grove',
      'Sylvia',
      'Tescott',
      'Teterville',
      'Timken',
      'Tonganoxie',
      'Tribune',
      'Trousdale',
      'Turon',
      'Udall',
      'Ulysses',
      'Unified Government of Greeley County (balance)',
      'Valley Falls',
      'Varner',
      'Vassar',
      'Vermillion',
      'Vesper',
      'Vinland',
      'Volland',
      'WaKeeney',
      'Wabaunsee',
      'Wagstaff',
      'Wamego',
      'Wathena',
      'Wauneta',
      'Webber',
      'Weir',
      'Welda',
      'Wellsville',
      'Weskan',
      'West Mineral',
      'Westfall',
      'Westmoreland',
      'Westwood Hills',
      'White Cloud',
      'Wichita',
      'Willis',
      'Willowdale',
      'Wilmore',
      'Wilroads Gardens',
      'Wilsey',
      'Windhorst',
      'Windom',
      'Winifred',
      'Wolf',
      'Woodston',
      'Yates Center',
      'Yocemento',
      'Zenda',
      'Zurich',
    ],
    'US-KY': [
      'Adairville',
      'Adolphus',
      'Ages',
      'Allegre',
      'Allen City',
      'Allensville',
      'Anneta',
      'Annville',
      'Anthoston',
      'Arjay',
      'Artemus',
      'Athertonville',
      'Audubon Park',
      'Auxier',
      'Avawam',
      'Bandana',
      'Bank Lick',
      'Barbourmeade',
      'Barbourville',
      'Bardstown',
      'Bardwell',
      'Barlow',
      'Baskett',
      'Battletown',
      'Beattyville',
      'Beaverlick',
      'Beda',
      'Bee Spring',
      'Beechburg',
      'Beechmont',
      'Beechwood',
      'Beechwood Village',
      'Belcher',
      'Belfry',
      'Bell City',
      'Bellemeade',
      'Bellewood',
      'Belton',
      'Benham',
      'Berea',
      'Bernstadt',
      'Betsy Layne',
      'Bewleyville',
      'Big Clifty',
      'Big Spring',
      'Blackey',
      'Blackford',
      'Blaine',
      'Blairs Mills',
      'Blandville',
      'Blue Ridge Manor',
      'Bohon',
      'Bonnieville',
      'Bourne',
      'Bradfordsville',
      'Brandenburg',
      'Breckinridge Center',
      'Briarwood',
      'Briensburg',
      'Brodhead',
      'Broeck Pointe',
      'Brownsboro Farm',
      'Brownsboro Village',
      'Bruin',
      'Bullittsville',
      'Burgin',
      'Burkesville',
      'Burna',
      'Burning Springs',
      'Calvert City',
      'Camp Springs',
      'Campbellsville',
      'Cane Valley',
      'Caneyville',
      'Canmer',
      'Cannel City',
      'Cannonsburg',
      'Carntown',
      'Carrsville',
      'Carter',
      'Carver',
      'Casky',
      'Catlettsburg',
      'Cawood',
      'Cayce',
      'Cecilia',
      'Centertown',
      'Cerulean',
      'Chapel Hill',
      'Chaplin',
      'Charters',
      'Chavies',
      'Chilton',
      'Clarkson',
      'Claryville',
      'Clay Village',
      'Cleaton',
      'Closplint',
      'Cloverport',
      'Co-Operative',
      'Coal Run Village',
      'Cold Spring',
      'Coldiron',
      'Coletown',
      'Colson',
      'Combs',
      'Cool Springs',
      'Cowan',
      'Coxton',
      'Cranston',
      'Crayne',
      'Creekside',
      'Creelsboro',
      'Crescent Park',
      'Crescent Springs',
      'Crestview Hills',
      'Crider',
      'Crittenden',
      'Crofton',
      'Cropper',
      'Crossgate',
      'Crutchfield',
      'Cumberland City',
      'Cundiff',
      'Custer',
      'Dan',
      'Dawson Springs',
      'Daysville',
      'Decoy',
      'Diablock',
      'Dingus',
      'Dizney',
      'Doe Valley',
      'Dorton',
      'Douglass Hills',
      'Drakesboro',
      'Drip Rock',
      'Dry Ridge',
      'Dunmor',
      'Dunnville',
      'Dwale',
      'Dycusburg',
      'Earlington',
      'East Bernstadt',
      'Ekron',
      'Elihu',
      'Elkatawa',
      'Elkhorn City',
      'Elkton',
      'Emlyn',
      'Ensor',
      'Eolia',
      'Epleys',
      'Erlanger',
      'Erose',
      'Eubank',
      'Evarts',
      'Ezel',
      'Fallsburg',
      'Fancy Farm',
      'Farmers',
      'Farristown',
      'Fearisville',
      'Field',
      'Fincastle',
      'Finchville',
      'Firebrick',
      'Flaherty',
      'Flat Lick',
      'Flatgap',
      'Flatwoods',
      'Fleming-Neon',
      'Flemingsburg',
      'Fletcher',
      'Fonde',
      'Fordsville',
      'Forest Hills',
      'Fort Wright',
      'Fountain Run',
      'Fox Chase',
      'Francisville',
      'Freeburn',
      'Freemont',
      'Frenchburg',
      'Fritz',
      'Furnace',
      'Garlin',
      'Gasper',
      'Gatliff',
      'Ghent',
      'Gilbertsville',
      'Gilpin',
      'Glen Dean',
      'Glenview Hills',
      'Glenview Manor',
      'Goose Creek',
      'Gracey',
      'Gradyville',
      'Grand Rivers',
      'Grassy Creek',
      'Gratz',
      'Gray Hawk',
      'Graymoor-Devondale',
      'Grays Branch',
      'Green Spring',
      'Grove Center',
      'Guage',
      'Guston',
      'Guthrie',
      'Hagerhill',
      'Haldeman',
      'Halfway',
      'Hall',
      'Halls Gap',
      'Handshoe',
      'Hardyville',
      'Hargis',
      'Hawesville',
      'Hazard',
      'Hazel',
      'Hebbardsville',
      'Hebron Estates',
      'Heidrick',
      'Helton',
      'Hendron',
      'Henshaw',
      'Heritage Creek',
      'Hesler',
      'Hickory',
      'Hickory Hill',
      'High Bridge',
      'Highland Heights',
      'Hill Top',
      'Hills and Dales',
      'Hindman',
      'Hiseville',
      'Hodgenville',
      'Hollow Creek',
      'Hollyhill',
      'Hollyvilla',
      'Hopeful Heights',
      'Hopkinsville',
      'Horse Branch',
      'Horse Cave',
      'Hoskinston',
      'Houston Acres',
      'Howardstown',
      'Hunters Hollow',
      'Hurstbourne',
      'Hurstbourne Acres',
      'Hustonville',
      'Ida May',
      'Inez',
      'Iron Hill',
      'Ironville',
      'Island',
      'Island City',
      'Jackstown',
      'Jeff',
      'Jeffersontown',
      'Jenkins',
      'Jessietown',
      'Johnetta',
      'Jonancy',
      'Jonestown',
      'Keavy',
      'Kenton Vale',
      'Kenvir',
      'Kevil',
      'Kimper',
      'Kirkmansville',
      'Kirksey',
      'Knifley',
      'Knob Lick',
      'Kuttawa',
      'La Center',
      'Lackey',
      'Lair',
      'Lake',
      'Lakeside Park',
      'Lakeview Heights',
      'Lamasco',
      'Langdon Place',
      'Leatherwood',
      'Lebanon Junction',
      'Ledbetter',
      'Lee City',
      'Leitchfield',
      'Lenoxburg',
      'Letcher',
      'Lewisburg',
      'Lewisport',
      'Ligon',
      'Lindseyville',
      'Livia',
      'Lola',
      'Long Ridge',
      'Loretto',
      'Lost Creek',
      'Louisa',
      'Lovelaceville',
      'Lowes',
      'Loyall',
      'Lynch',
      'Lynn Grove',
      'Lynnview',
      'Mackville',
      'Madisonville',
      'Majestic',
      'Mammoth Cave',
      'Manitou',
      'Mannington',
      'Mannsville',
      'Manor Creek',
      'Mariba',
      'Marrowbone',
      'Maryhill Estates',
      'Massac',
      'Mattoxtown',
      'Mayking',
      'Mays Lick',
      'Mazie',
      'McCarr',
      'McDaniels',
      'McDowell',
      'McKee',
      'McQuady',
      'McRoberts',
      'McVeigh',
      'Meadow Vale',
      'Meadowbrook Farm',
      'Meadowview Estates',
      'Meldrum',
      'Memphis Junction',
      'Merrimac',
      'Middlesboro',
      'Millers Creek',
      'Millstone',
      'Minerva',
      'Mitchellsburg',
      'Mockingbird Valley',
      'Mooleyville',
      'Moon',
      'Morganfield',
      'Mortons Gap',
      'Mortonsville',
      'Mount Olivet',
      'Mount Washington',
      'Mousie',
      'Mozelle',
      'Muldraugh',
      'Munfordville',
      'Murray Hill',
      'Myers',
      'Narrows',
      'New Concord',
      'Newfoundland',
      'Niagara',
      'Nicholasville',
      'Nina',
      'Norbourne Estates',
      'North Corbin',
      'North Middletown',
      'Oak Level',
      'Oakbrook',
      'Oakton',
      'Olaton',
      'Old Brownsboro Place',
      'Old Washington',
      'Olive Hill',
      'Olmstead',
      'Olympia',
      'Onton',
      'Orchard Grass Hills',
      'Ottusville',
      'Owensboro',
      'Owenton',
      'Owingsville',
      'Paducah',
      'Paint Lick',
      'Paintsville',
      'Panco',
      'Panther',
      'Park Hills',
      'Parkway Village',
      'Patesville',
      'Pathfork',
      'Payne Gap',
      'Peaks Mill',
      'Pellville',
      'Pewee Valley',
      'Pike View',
      'Pikeville',
      'Pine Knot',
      'Pioneer Village',
      'Pippa Passes',
      'Pleasureville',
      'Plum Springs',
      'Poindexter',
      'Poplar Hills',
      'Poplar Plains',
      'Port Royal',
      'Powderly',
      'Prestonsburg',
      'Prestonville',
      'Pride',
      'Pryorsburg',
      'Rabbit Hash',
      'Raceland',
      'Radcliff',
      'Raywick',
      'Rectorville',
      'Reidland',
      'Rich Pond',
      'Richardsville',
      'Richlawn',
      'Rineyville',
      'Ritchie',
      'River Bluff',
      'Riverwood',
      'Robards',
      'Rockholds',
      'Rolling Fields',
      'Rosine',
      'Royville',
      'Ryland',
      'Ryland Heights',
      'Sadieville',
      'Saint Mary',
      'Saint Matthews',
      'Saint Regis Park',
      'Salt Lick',
      'Salvisa',
      'Salyersville',
      'Samuels',
      'Sandgap',
      'Sandy Hook',
      'Saxton',
      'Science Hill',
      'Sebree',
      'Seneca Gardens',
      'Shawhan',
      'Shelbiana',
      'Shepherdsville',
      'Shopville',
      'Silver Grove',
      'Simpsonville',
      'Slade',
      'Slaughters',
      'Slemp',
      'Smith',
      'Smiths Creek',
      'Smiths Grove',
      'South Carrollton',
      'South Park View',
      'South Shore',
      'South Wallins',
      'South Williamson',
      'Speight',
      'Spottsville',
      'Spring Mill',
      'Springlake',
      'Sprout',
      'Stamping Ground',
      'Stearns',
      'Stephensburg',
      'Steubenville',
      'Strathmoor Manor',
      'Strathmoor Village',
      'Stringtown',
      'Sturgis',
      'Summer Shade',
      'Summersville',
      'Sunnybrook',
      'Symsonia',
      'Talbert',
      'Taylor Mill',
      'Taylorsport',
      'Temple Hill',
      'Ten Broeck',
      'Thornhill',
      'Thousandsticks',
      'Threelinks',
      'Tiline',
      'Tolu',
      'Tompkinsville',
      'Trent',
      'Turkey',
      'Upton',
      'Van Lear',
      'Vanceburg',
      'Vancleve',
      'Vaughns Mill',
      'Vicco',
      'Villa Hills',
      'Vine Grove',
      'Viper',
      'Virgie',
      'Vortex',
      'Waddy',
      'Wallins Creek',
      'Water Valley',
      'Watterson Park',
      'Wax',
      'Webbville',
      'West Buechel',
      'West Louisville',
      'Westbend',
      'Wheatcroft',
      'Wheelwright',
      'White Tower',
      'Whitley City',
      'Wickliffe',
      'Willisburg',
      'Windy Hills',
      'Wingo',
      'Wolf Creek',
      'Wonnie',
      'Woodland Hills',
      'Woodlawn Park',
      'Worthington Hills',
      'Worthville',
      'Wrigley',
      'Wurtland',
      'Yerkes',
      'Yosemite',
      'Zag',
    ],
    'US-LA': [
      'Abita Springs',
      'Acy',
      'Addis',
      'Alden Bridge',
      'Alsatia',
      'Alsen',
      'Amite',
      'Anacoco',
      'Anandale',
      'Angie',
      'Antonia',
      'Antrim',
      'Archibald',
      'Archie',
      'Arnaudville',
      'Avery Island',
      'Bains',
      'Ball',
      'Banks Springs',
      'Barataria',
      'Basile',
      'Bastrop',
      'Baton Rouge',
      'Bawcomville',
      'Bayou Cane',
      'Bayou Chicot',
      'Bayou Corne',
      'Bayou Gauche',
      'Bayou Goula',
      'Bayou Sorrel',
      'Bayou Vista',
      'Beekman',
      'Belle Chasse',
      'Belle Rose',
      'Belle Terre',
      'Bernice',
      'Bertrandville',
      'Bienville',
      'Bogalusa',
      'Bolinger',
      'Boothville',
      'Bordelonville',
      'Bosco',
      'Bossier City',
      'Bourg',
      'Boutte',
      'Boyce',
      'Braithwaite',
      'Breaux Bridge',
      'Bridge City',
      'Broussard',
      'Brownlee',
      'Brownsfield',
      'Brusly',
      'Brusly Landing',
      'Bryceland',
      'Bunkie',
      'Buras',
      'Burr Ferry',
      'Butte La Rose',
      'Cade',
      'Caernarvon',
      'Calcasieu',
      'Campti',
      'Cankton',
      'Caplis',
      'Carencro',
      'Carlyss',
      'Carville',
      'Caspiana',
      'Catahoula',
      'Chackbay',
      'Chalmette',
      'Charenton',
      'Chataignier',
      'Cheneyville',
      'Choctaw',
      'Chopin',
      'Choudrant',
      'Church Point',
      'Clarks',
      'Cocodrie',
      'Collinston',
      'Concession',
      'Convent',
      'Coteau Holmes',
      'Cotton Valley',
      'Cottonport',
      'Couchwood',
      'Coushatta',
      'Creole',
      'Cullen',
      'Cut Off',
      'Dalcour',
      'Darnell',
      'Davant',
      'DeQuincy',
      'DeRidder',
      'Deer Range',
      'Delcambre',
      'Denham Springs',
      'Derry',
      'Des Allemands',
      'Destrehan',
      'Deville',
      'Dixie Inn',
      'Dodson',
      'Donaldsonville',
      'Donner',
      'Downsville',
      'Doyline',
      'Dry Prong',
      'Dubach',
      'Dubberly',
      'Dulac',
      'Dunbarton',
      'Dunn',
      'Duson',
      'East Hodge',
      'Eastwood',
      'Eden Isle',
      'Edgard',
      'Edgefield',
      'Edgerly',
      'Effie',
      'Egan',
      'Elm Grove',
      'Elton',
      'English Turn',
      'Epps',
      'Erath',
      'Eros',
      'Erwinville',
      'Estelle',
      'Estherwood',
      'Ethel',
      'Eunice',
      'Evangeline',
      'Evelyn',
      'Extension',
      'Farmerville',
      'Felixville',
      'Ferriday',
      'Fields',
      'Fifth Ward',
      'Florien',
      'Fluker',
      'Forbing',
      'Fordoche',
      'Forked Island',
      'Fort Jesup',
      'Franklinton',
      'Fred',
      'French Settlement',
      'Frenier',
      'Frierson',
      'Frogmore',
      'Fryeburg',
      'Galbraith',
      'Galion',
      'Galliano',
      'Gardere',
      'Garyville',
      'Gassoway',
      'Geismar',
      'Gibsland',
      'Gilark',
      'Gilliam',
      'Gillis',
      'Glenmora',
      'Glynn',
      'Golden Meadow',
      'Goldman',
      'Goldonna',
      'Goosport',
      'Gorum',
      'Goudeau',
      'Grambling',
      'Gramercy',
      'Grand Cane',
      'Grand Chenier',
      'Grand Coteau',
      'Grand Ecore',
      'Grand Isle',
      'Grand Point',
      'Grosse Tete',
      'Gueydan',
      'Gullett',
      'Haaswood',
      'Hagewood',
      'Hahnville',
      'Hall Summit',
      'Harahan',
      'Harrisonburg',
      'Hathaway',
      'Haughton',
      'Haynesville',
      'Hessmer',
      'Hicks',
      'Hico',
      'Hineston',
      'Holly Beach',
      'Hornbeck',
      'Hosston',
      'Husser',
      'Hutton',
      'Iberville',
      'Innis',
      'Inniswold',
      'Intracoastal City',
      'Iota',
      'Iowa',
      'Jarreau',
      'Jean Lafitte',
      'Jeanerette',
      'Jefferson Island',
      'Jigger',
      'Jonesburg',
      'Jordan Hill',
      'Joyce',
      'Juanita',
      'Kaplan',
      'Keatchie',
      'Keithville',
      'Kenner',
      'Kentwood',
      'Killian',
      'Killona',
      'Kinder',
      'Kisatchie',
      'Knight',
      'Kolin',
      'Kraemer',
      'Krotz Springs',
      'Kurthwood',
      'Labadieville',
      'Lacassine',
      'Lafitte',
      'Lafourche',
      'Lake Arthur',
      'Lake Charles',
      'Lake End',
      'Lake Providence',
      'Lamourie',
      'Laplace',
      'Larose',
      'Larto',
      'Laurel Grove',
      'Lawtell',
      'Le Moyen',
      'Leander',
      'Lebeau',
      'Lecompte',
      'Ledoux',
      'Lee Bayou',
      'Leesville',
      'Leeville',
      'Lemannville',
      'Leonville',
      'Lettsworth',
      'Liberty Hill',
      'Libuse',
      'Liddieville',
      'Lillie',
      'Litroe',
      'Lockport Heights',
      'Long Bridge',
      'Longstreet',
      'Longville',
      'Loranger',
      'Loreauville',
      'Lucky',
      'Ludington',
      'Luling',
      'Lutcher',
      'Lydia',
      'Mamou',
      'Manchac',
      'Mangham',
      'Manifest',
      'Mansura',
      'Many',
      'Maringouin',
      'Marksville',
      'Marrero',
      'Marthaville',
      'Mathews',
      'Maxie',
      'Mayna',
      'McManus',
      'Melder',
      'Melville',
      'Mer Rouge',
      'Meraux',
      'Mermentau',
      'Merrydale',
      'Merryville',
      'Metairie',
      'Millikin',
      'Mimosa Park',
      'Minorca',
      'Mittie',
      'Modeste',
      'Montegut',
      'Montz',
      'Mooringsport',
      'Moreauville',
      'Morganza',
      'Moss Bluff',
      'Mound',
      'Mount Lebanon',
      'Naborton',
      'Nairn',
      'Napoleonville',
      'Natalbany',
      'Natchez',
      'Natchitoches',
      'Neame',
      'Negreet',
      'New Era',
      'New Iberia',
      'New Llano',
      'New Orleans',
      'New Roads',
      'New Sarpy',
      'Newellton',
      'Ninock',
      'North Hodge',
      'North Vacherie',
      'Oak Hills Place',
      'Oil City',
      'Old Jefferson',
      'Olla',
      'Opelousas',
      'Oretta',
      'Ossun',
      'Paincourtville',
      'Paradis',
      'Parhams',
      'Paulina',
      'Pearl River',
      'Percle',
      'Pierre Part',
      'Pilottown',
      'Pine Prairie',
      'Plain Dealing',
      'Plaquemine',
      'Plaucheville',
      'Plettenberg',
      'Point',
      'Point Blue',
      'Point Place',
      'Pointe à la Hache',
      'Ponchatoula',
      'Port Allen',
      'Port Barre',
      'Port Hudson',
      'Port Sulphur',
      'Poydras',
      'Prairieville',
      'Presquille',
      'Prien',
      'Provencal',
      'Ragley',
      'Rayne',
      'Rayville',
      'Red Chute',
      'Reddell',
      'Reggio',
      'River Ridge',
      'Robeline',
      'Robert',
      'Rock Hill',
      'Rodessa',
      'Romeville',
      'Rosepine',
      'Ruston',
      'Saint Bernard',
      'Saint Gabriel',
      'Saint Landry',
      'Saint Martinville',
      'Saint Maurice',
      'Saline',
      'Sarepta',
      'Schriever',
      'Scotlandville',
      'Serena',
      'Seymourville',
      'Shell Beach',
      'Sheltons',
      'Sherburne',
      'Shongaloo',
      'Shreveport',
      'Sicard',
      'Sicily Island',
      'Sieper',
      'Sikes',
      'Simmesport',
      'Simsboro',
      'Singer',
      'Siracusaville',
      'Slagle',
      'Slaughter',
      'Slidell',
      'Sligo',
      'Smoke Bend',
      'Sondheimer',
      'Sorrel',
      'South Mansfield',
      'South Vacherie',
      'Southdown',
      'Spearsville',
      'Spokane',
      'Springhill',
      'Starks',
      'Start',
      'Sterlington',
      'Sugar Creek',
      'Sugartown',
      'Sulphur',
      'Sun',
      'Supreme',
      'Swartz',
      'Talisheek',
      'Tallulah',
      'Tangipahoa',
      'Tannehill',
      'Tendal',
      'Terry',
      'Terrytown',
      'Theriot',
      'Thibodaux',
      'Tickfaw',
      'Tioga',
      'Transylvania',
      'Tullos',
      'Tunica',
      'Turkey Creek',
      'Urania',
      'Vacherie',
      'Varnado',
      'Ventress',
      'Verda',
      'Verret',
      'Vidrine',
      'Vienna Bend',
      'Village Saint George',
      'Ville Platte',
      'Violet',
      'Vivian',
      'Waggaman',
      'Wallace Ridge',
      'Walters',
      'Warden',
      'Wardville',
      'Warnerton',
      'Waterproof',
      'Weeks',
      'Welcome',
      'Welsh',
      'West Monroe',
      'Westdale',
      'Westwego',
      'White Castle',
      'Whiteville',
      'Willow Glen',
      'Winnfield',
      'Winnsboro',
      'Wisner',
      'Woodardville',
      'Woodmere',
      'Wyatt',
      'Youngsville',
      'Yscloskey',
      'Zachary',
      'Zimmerman',
      'Zona',
      'Zwolle',
    ],
    'US-ME': [
      'Alfred',
      'Bar Harbor',
      'Bar Mills',
      'Bass Harbor',
      'Biddeford',
      'Blue Hill',
      'Boothbay Harbor',
      'Bowdoinham',
      'Brewer',
      'Bridgton',
      'Brownville Junction',
      'Bryant Pond',
      'Bucksport',
      'Cape Neddick',
      'Carrabassett',
      'Casco',
      'Castine',
      'Chesuncook',
      'Clayton Lake',
      'Cousins Island',
      'Cumberland Center',
      'Damariscotta',
      'Dixfield',
      'Dover-Foxcroft',
      'East Holden',
      'East Millinocket',
      'Exeter Corners',
      'Falmouth Foreside',
      'Farmingdale',
      'Fort Fairfield',
      'Fort Kent',
      'Gardiner',
      'Green Lake',
      'Hallowell',
      'Hampden Highlands',
      'Houlton',
      'Howland',
      'Isle Au Haut',
      'Kennebunk',
      'Kennebunkport',
      'Kezar Falls',
      'Kittery',
      'Kittery Point',
      'Kokadjo',
      'Lisbon Falls',
      'Little Falls',
      'Littlejohn Island',
      'Livermore Falls',
      'Long Pond',
      'Lowelltown',
      'Lubec',
      'Machias',
      'Macwahoc',
      'Madawaska',
      'Mars Hill',
      'Mechanic Falls',
      'Millinocket',
      'Norridgewock',
      'North Amity',
      'North Berwick',
      'North East Carry',
      'North Waterford',
      'North Windham',
      'Olamon',
      'Old Orchard Beach',
      'Oquossoc',
      'Orono',
      'Oxbow',
      'Port Clyde',
      'Presque Isle',
      'Rumford',
      'Saco',
      'Searsport',
      'Seboeis',
      'Sherman Station',
      'Shirley Mills',
      'Skowhegan',
      'Smyrna Mills',
      'Soldier Pond',
      'Somesville',
      'South China',
      'South Eliot',
      'South Lagrange',
      'South Paris',
      'South Portland',
      'South Sanford',
      'Southwest Harbor',
      'Steep Falls',
      'Sweden',
      'Topsham',
      'Unity',
      'Waldoboro',
      'West Forks',
      'West Kennebunk',
      'West Seboeis',
      'Westbrook',
      'Wilsons Mills',
      'Winter Harbor',
      'Winterport',
      'Wiscasset',
      'Wytopitlock',
      'York Harbor',
    ],
    'US-MD': [
      'Accident',
      'Accokeek',
      'Adamstown',
      'Adelphi',
      'Ady',
      'Antietam',
      'Aquasco',
      'Arbutus',
      'Arden on the Severn',
      'Arundel Village',
      'Aspen Hill',
      'Avenue',
      'Bagtown',
      'Bakersville',
      'Ballenger Creek',
      'Baltimore',
      'Baltimore Highlands',
      'Barrelville',
      'Bartonsville',
      'Bay Ridge',
      'Bay View',
      'Bayside Beach',
      'Beallsville',
      'Beaver Creek',
      'Bel Air',
      'Bel Alton',
      'Belcamp',
      'Beltsville',
      'Berwyn Heights',
      'Betterton',
      'Bier',
      'Big Pool',
      'Bishopville',
      'Bivalve',
      'Blackhorse',
      'Bladensburg',
      'Boonsboro',
      'Bowleys Quarters',
      'Bowmans Addition',
      'Boyds',
      'Bozman',
      'Braddock Heights',
      'Brandywine',
      'Breathedsville',
      'Brinklow',
      'Brock Hall',
      'Brookeville',
      'Brooklyn Park',
      'Brookmont',
      'Brookview',
      'Broomes Island',
      'Bryans Road',
      'Bryantown',
      'Buckeystown',
      'Burkittsville',
      'Burtonsville',
      'Butlertown',
      'Cabin John',
      'Calvert Beach',
      'Calverton',
      'Cape Saint Claire',
      'Capitol Heights',
      'Carlos',
      'Carney',
      'Carrollton Manor',
      'Carsins',
      'Catonsville',
      'Cavetown',
      'Cearfoss',
      'Cecilton',
      'Cedarhurst',
      'Chance',
      'Chaneyville',
      'Chaptico',
      'Charlotte Hall',
      'Charlton',
      'Cheltenham',
      'Chesapeake Beach',
      'Chesapeake City',
      'Chesapeake Ranch Estates',
      'Chestertown',
      'Cheverly',
      'Chevy Chase',
      'Chevy Chase Section Five',
      'Chevy Chase Section Three',
      'Chevy Chase View',
      'Chevy Chase Village',
      'Chewsville',
      'Chillum',
      'Choptank',
      'Church Creek',
      'Church Hill',
      'Churchton',
      'Churchville',
      'Clarysville',
      'Clear Spring',
      'Cloverly',
      'Cobb Island',
      'Cockeysville',
      'Colesville',
      'Colmar Manor',
      'Comus',
      'Coral Hills',
      'Cornersville',
      'Corriganville',
      'Cottage City',
      'Craigtown',
      'Crellin',
      'Cresaptown',
      'Creswell',
      'Crisfield',
      'Croom',
      'Crownsville',
      'Dames Quarter',
      'Dares Beach',
      'Dargan',
      'Darnestown',
      'Davidsonville',
      'Deal Island',
      'Deale',
      'Derwood',
      'Dickerson',
      'Discovery',
      'District Heights',
      'Dodge Park',
      'Dominion',
      'Drum Point',
      'Dundalk',
      'Eagle Harbor',
      'East New Market',
      'East Riverdale',
      'Eckhart Mines',
      'Edesville',
      'Edgemere',
      'Edmonston',
      'Eldersburg',
      'Elk Mills',
      'Elk Neck',
      'Elkridge',
      'Ellicott City',
      'Emmitsburg',
      'Emmorton',
      'Ernstville',
      'Ewell',
      'Fair Hill',
      'Fairlee',
      'Fairmount Heights',
      'Fallston',
      'Federal Hill',
      'Federalsburg',
      'Finzel',
      'Fishing Creek',
      'Forest Glen',
      'Forest Heights',
      'Fork',
      'Fort Washington',
      'Fountain Green',
      'Four Corners',
      'Friendly',
      'Friendsville',
      'Frostburg',
      'Funkstown',
      'Furnace Branch',
      'Gaithersburg',
      'Galestown',
      'Galesville',
      'Gambrills',
      'Gapland',
      'Garrett Park',
      'Garretts Mill',
      'Gibson Island',
      'Girdletree',
      'Glassmanor',
      'Glen Arm',
      'Glen Burnie',
      'Glen Echo',
      'Glenarden',
      'Glenmont',
      'Glenn Dale',
      'Goldsboro',
      'Grahamtown',
      'Grantsville',
      'Grasonville',
      'Great Falls',
      'Greenbelt',
      'Halethorpe',
      'Harmans',
      'Harrisonville',
      'Harwood',
      'Havre de Grace',
      'Hebbville',
      'Herald Harbor',
      'Hess',
      'Hillandale',
      'Hoopersville',
      'Horsehead',
      'Hughesville',
      'Huntingtown',
      'Hurlock',
      'Hyattsville',
      'Ilchester',
      'Indian Head',
      'Ingleside',
      'Jacobsville',
      'Jarrettsville',
      'Jessup',
      'Jesterville',
      'Joppatowne',
      'Jugtown',
      'Keedysville',
      'Kemp Mill',
      'Kennedyville',
      'Kent Narrows',
      'Kentmore Park',
      'Kingstown',
      'Kitzmiller',
      'La Vale',
      'Lake Arbor',
      'Lake Shore',
      'Landover',
      'Landover Hills',
      'Langley Park',
      'Lanham',
      'Lansdowne',
      'Lawsonia',
      'Layhill',
      'Laytonsville',
      'Leitch',
      'Leitersburg',
      'Leonardtown',
      'Level',
      'Lexington Park',
      'Liberty Grove',
      'Libertytown',
      'Linganore',
      'Linthicum',
      'Little Orleans',
      'Loch Lynn Heights',
      'Lochearn',
      'Lonaconing',
      'Long Meadow',
      'Longwoods',
      'Lower Marlboro',
      'Lusby',
      'Lutherville',
      'Madonna',
      'Mapleville',
      'Mardela Springs',
      'Marlboro Meadows',
      'Marlow Heights',
      'Marlton',
      'Martins Additions',
      'Marydel',
      'Maryland City',
      'Mattapex',
      'Mattawoman',
      'Maugansville',
      'Mays Chapel',
      'McCoole',
      'McDaniel',
      'Melitota',
      'Mercersville',
      'Middle River',
      'Milford Mill',
      'Millersville',
      'Monkton',
      'Montgomery Village',
      'Morgnec',
      'Morningside',
      'Mount Aetna',
      'Mount Briar',
      'Mount Harmony',
      'Mount Lena',
      'Mount Rainier',
      'Mount Savage',
      'Mountain',
      'Mountain Lake Park',
      'Myersville',
      'Nanticoke',
      'Nanticoke Acres',
      'National',
      'Neavitt',
      'New Carrollton',
      'Nikep',
      'Norbeck',
      'Normans',
      'North Beach',
      'North Bethesda',
      'North Brentwood',
      'North Chevy Chase',
      'North East',
      'North Kensington',
      'North Laurel',
      'North Potomac',
      'Ocean',
      'Ocean Pines',
      'Odenton',
      'Orchard Beach',
      'Overlea',
      'Owings',
      'Owings Mills',
      'Oxon Hill',
      'Palmer Park',
      'Parkville',
      'Parole',
      'Parsonsburg',
      'Pecktonville',
      'Peppermill Village',
      'Perry Hall',
      'Perryman',
      'Pikesville',
      'Pine Orchard',
      'Pinesburg',
      'Piscataway',
      'Pittsville',
      'Pleasant Hills',
      'Pocomoke City',
      'Point of Rocks',
      'Pomfret',
      'Pomonkey',
      'Pondsville',
      'Poolesville',
      'Popes Creek',
      'Port Deposit',
      'Port Tobacco',
      'Potomac Heights',
      'Potomac Park',
      'Powellville',
      'Prince Frederick',
      'Princess Anne',
      'Pylesville',
      'Quantico',
      'Queen Anne',
      'Randallstown',
      'Randle Cliff Beach',
      'Rawlings',
      'Redland',
      'Reid',
      'Reisterstown',
      'Riderwood',
      'Ridgely',
      'Riva',
      'Robinwood',
      'Rock Hall',
      'Rohrersville',
      'Romancoke',
      'Rosaryville',
      'Rose Haven',
      'Royal Oak',
      'Ruthsburg',
      'Sabillasville',
      'Saint Leonard',
      'Saint Marys City',
      'San Mar',
      'Sandy Bottom',
      'Sandy Spring',
      'Savage',
      'Scaggsville',
      'Seabrook',
      'Seat Pleasant',
      'Secretary',
      'Severna Park',
      'Shady Side',
      'Shawan',
      'Shawsville',
      'Shepperd',
      'Silesia',
      'Silver Hill',
      'Silver Spring',
      'Skidmore',
      'Smith Island',
      'Smithsburg',
      'Solomons',
      'South Kensington',
      'South Laurel',
      'Spring Gap',
      'Spring Ridge',
      'Starr',
      'Stevensville',
      'Still Pond',
      'Sudlersville',
      'Suitland',
      'Swanton',
      'Sweet Air',
      'Sykesville',
      'Takoma Park',
      'Tall Timbers',
      'Taneytown',
      'Taylors Island',
      'Temple Hills',
      'Templeville',
      'Thurmont',
      'Tilghman',
      'Tilghman Island',
      'Tilghmanton',
      'Timonium',
      'Tolchester',
      'Tolchester Beach',
      'Towson',
      'Tracys Landing',
      'Trappe',
      'Travilah',
      'Tunis Mills',
      'Tyaskin',
      'Union Bridge',
      'Upper Crossroads',
      'Upper Marlboro',
      'Vale Summit',
      'Waldorf',
      'Walker Mill',
      'Walkersville',
      'Washington Grove',
      'Waterview',
      'West Denton',
      'West Laurel',
      'West Ocean City',
      'West Pocomoke',
      'Westernport',
      'Whaleyville',
      'White Crystal Beach',
      'White Marsh',
      'Whiteford',
      'Whitehaven',
      'Willards',
      'Wittman',
      'Woodfield',
      'Woodmore',
      'Woodsboro',
      'Worton',
      'Wye Mills',
      'Yarrowsburg',
      'Zihlman',
    ],
    'US-MA': [
      'Abington',
      'Accord',
      'Agawam',
      'Amherst Center',
      'Assinippi',
      'Attleboro',
      'Ayer',
      'Baldwinville',
      'Ballardvale',
      'Barnstable',
      'Barre',
      'Belchertown',
      'Blandford',
      'Bliss Corner',
      'Bondsville',
      'Boxford',
      'Brant Rock',
      'Brookline',
      'Buzzards Bay',
      'Cheshire',
      'Clicquot',
      'Cochituate',
      'Cordaville',
      'Cotuit',
      'Dennis Port',
      'Devens',
      'Duxbury',
      'East Brookfield',
      'East Dennis',
      'East Douglas',
      'East Falmouth',
      'East Harwich',
      'East Pepperell',
      'East Sandwich',
      'East Walpole',
      'Easthampton',
      'Edgartown',
      'Fayville',
      'Fiskdale',
      'Fitchburg',
      'Forge Village',
      'Foxborough',
      'Framingham',
      'Gleasondale',
      'Glenridge',
      'Gloucester',
      'Great Barrington',
      'Green Harbor',
      'Greenbush',
      'Hanover Center',
      'Harwich Port',
      'Hayden Row',
      'Hingham',
      'Housatonic',
      'Humarock',
      'Hyannis',
      'Ipswich',
      'Kent Park',
      'Leominster',
      'Liberty Plain',
      'Littleton Common',
      'Longmeadow',
      'Lynnfield',
      'Madaket',
      'Manchester-by-the-Sea',
      'Marblehead',
      'Marshfield Center',
      'Marshfield Hills',
      'Marstons Mills',
      'Mashpee Neck',
      'Medfield',
      'Medford',
      'Methuen',
      'Millers Falls',
      'Minot',
      'Monomoscoy Island',
      'Monument Beach',
      'Nabnasset',
      'Nahant',
      'Nantucket',
      'New Seabury',
      'Newburyport',
      'North Abington',
      'North Adams',
      'North Amherst',
      'North Attleboro',
      'North Bellingham',
      'North Billerica',
      'North Brookfield',
      'North Chelmsford',
      'North Cohasset',
      'North Eastham',
      'North Falmouth',
      'North Hanover',
      'North Lakeville',
      'North Marshfield',
      'North Pembroke',
      'North Plymouth',
      'North Scituate',
      'North Seekonk',
      'North Sudbury',
      'North Tewksbury',
      'North Truro',
      'North Westport',
      'North Wilmington',
      'Northborough',
      'Nutting Lake',
      'Ocean Bluff',
      'Ocean Grove',
      'Onset',
      'Osterville',
      'Pepperell',
      'Petersham',
      'Pigeon Cove',
      'Pine Rest',
      'Pocasset',
      'Popponesset',
      'Popponesset Island',
      'Provincetown',
      'Raynham Center',
      'Rexhame',
      'Sagamore',
      'Scituate',
      'Seconsett Island',
      'Shawsheen Village',
      'Shelburne Falls',
      'Siasconset',
      'Smith Mills',
      'South Acton',
      'South Amherst',
      'South Ashburnham',
      'South Chelmsford',
      'South Dartmouth',
      'South Deerfield',
      'South Dennis',
      'South Duxbury',
      'South Lancaster',
      'South Walpole',
      'South Westport',
      'South Yarmouth',
      'Southville',
      'Still River',
      'Sturbridge',
      'Swampscott',
      'Taunton',
      'Teaticket',
      'Topsfield',
      'Turners Falls',
      'Tyngsboro',
      'Vineyard Haven',
      'Waltham',
      'Wamesit',
      'Wareham Center',
      'West Acton',
      'West Barnstable',
      'West Boxford',
      'West Brookfield',
      'West Chatham',
      'West Concord',
      'West Dennis',
      'West Falmouth',
      'West Hanover',
      'West Medway',
      'West Springfield',
      'West Upton',
      'West Wareham',
      'West Yarmouth',
      'Westborough',
      'Weweantic',
      'White Horse Beach',
      'White Island Shores',
      'Whitinsville',
      'Wilbraham',
      'Winchendon',
      'Woburn',
      'Woods Hole',
      'Worcester',
      'Yarmouth Port',
    ],
    'US-MI': [
      'Ahmeek',
      'Alanson',
      'Algonac',
      'Allegan',
      'Allen Park',
      'Amasa',
      'Anchorville',
      'Ann Arbor',
      'Argentine',
      'Armada',
      'Au Gres',
      'Au Sable',
      'Au Train',
      'Auburn Hills',
      'Aura',
      'Bach',
      'Backus Beach',
      'Bad Axe',
      'Baie de Wasai',
      'Baraga',
      'Bark River',
      'Baroda',
      'Barryton',
      'Barton Hills',
      'Bay City',
      'Bay Port',
      'Bay Shore',
      'Beal City',
      'Bear Lake',
      'Belding',
      'Bendon',
      'Benton Harbor',
      'Benton Heights',
      'Benzonia',
      'Bergland',
      'Berrien Springs',
      'Berville',
      'Bete Grise',
      'Big Bay',
      'Big Rapids',
      'Bingham Farms',
      'Birch Run',
      'Bitely',
      'Blissfield',
      'Bloomfield Hills',
      'Boon',
      'Boyne City',
      'Boyne Falls',
      'Breedsville',
      'Brethren',
      'Brevort',
      'Bridgman',
      'Brimley',
      'Britton',
      'Brown City',
      'Brownlee Park',
      'Bruce Crossing',
      'Brutus',
      'Burton',
      'Byron Center',
      'Cadillac',
      'Cady',
      'Canada Creek Ranch',
      'Canadian Lakes',
      'Capac',
      'Carleton',
      'Caro',
      'Carp Lake',
      'Carson City',
      'Caseville',
      'Casnovia',
      'Caspian',
      'Cass City',
      'Cassopolis',
      'Cedar River',
      'Cement City',
      'Center Line',
      'Central Lake',
      'Charlevoix',
      'Cheboygan',
      'Chesaning',
      'Chilson',
      'Chums Corner',
      'Clarenceville',
      'Clarklake',
      'Clawson',
      'Cohoctah',
      'Columbiaville',
      'Comstock Park',
      'Connorville',
      'Constantine',
      'Coopersville',
      'Copemish',
      'Copper City',
      'Copper Harbor',
      'Cross Village',
      'Croswell',
      'Cutlerville',
      'Dafter',
      'Dansville',
      'Davison',
      'De Tour Village',
      'Dearborn',
      'Dearborn Heights',
      'Deerton',
      'Delton',
      'Detroit Beach',
      'Devils Lake',
      'Dimondale',
      'Dixboro',
      'Dollar Bay',
      'Dowagiac',
      'Dowling',
      'East Grand Rapids',
      'East Jordan',
      'East Lansing',
      'East Rockwood',
      'East Tawas',
      'Eastlawn',
      'Eastpointe',
      'Eaton Rapids',
      'Eau Claire',
      'Eckerman',
      'Ecorse',
      'Edgemont Park',
      'Edgewater Heights',
      'Edmore',
      'Edwardsburg',
      'Elk Rapids',
      'Elsie',
      'Elwell',
      'Engadine',
      'Escanaba',
      'Essexville',
      'Estral Beach',
      'Evart',
      'Ewen',
      'Fair Haven',
      'Fair Plain',
      'Fairgrove',
      'Farmington Hills',
      'Farwell',
      'Felch',
      'Fennville',
      'Ferrysburg',
      'Fife Lake',
      'Filer City',
      'Flint',
      'Flushing',
      'Fowlerville',
      'Frankenmuth',
      'Freda',
      'Frederic',
      'Free Soil',
      'Freeland',
      'Frontier',
      'Fruitport',
      'Gaastra',
      'Gaines',
      'Galien',
      'Garden',
      'Germfask',
      'Gibraltar',
      'Gladwin',
      'Glen Arbor',
      'Glennie',
      'Gobles',
      'Good Hart',
      'Gould City',
      'Grand Beach',
      'Grand Blanc',
      'Grand Haven',
      'Grand Ledge',
      'Grand Marais',
      'Grandville',
      'Grass Lake',
      'Grawn',
      'Greilickville',
      'Grind Stone City',
      'Grosse Pointe',
      'Grosse Pointe Farms',
      'Grosse Pointe Park',
      'Grosse Pointe Shores',
      'Grosse Pointe Woods',
      'Gwinn',
      'Hamtramck',
      'Harbert',
      'Harbor Beach',
      'Harbor Springs',
      'Haring',
      'Harper Woods',
      'Harrietta',
      'Harrisville',
      'Hart',
      'Haslett',
      'Hawks',
      'Hazel Park',
      'Hemlock',
      'Herman',
      'Hermansville',
      'Hersey',
      'Hessel',
      'Hickory Corners',
      'Hillman',
      'Honor',
      'Hopkins',
      'Horton Bay',
      'Houghton Lake',
      'Howard City',
      'Hubbard Lake',
      'Hubbardston',
      'Hubbell',
      'Hudsonville',
      'Hulbert',
      'Huntington Woods',
      'Huron Beach',
      'Imlay City',
      'Indian River',
      'Inkster',
      'Interlochen',
      'Iron Mountain',
      'Iron River',
      'Ironton',
      'Ironwood',
      'Ishpeming',
      'Ithaca',
      'Jenison',
      'K I Sawyer',
      'Kalamazoo',
      'Kaleva',
      'Kalkaska',
      'Kawkawlin',
      'Keego Harbor',
      'Kent City',
      'Keweenaw Bay',
      'Kinde',
      'Kingsford',
      'Kipling',
      "L'Anse",
      'Lachine',
      'Laingsburg',
      'Lake Angelus',
      'Lake Ann',
      'Lake Fenton',
      'Lake Leelanau',
      'Lake Linden',
      'Lake Michigan Beach',
      'Lake Odessa',
      'Lake Orion',
      'Lakewood Club',
      'Lambertville',
      'Lapeer',
      'Lathrup Village',
      'Laurium',
      'Lennon',
      'Leonard',
      'Level Park',
      'Levering',
      'Lexington Heights',
      'Lost Lake Woods',
      'Lovells',
      'Lum',
      'Luna Pier',
      'Mackinac Island',
      'Mackinaw City',
      'Madison Heights',
      'Mancelona',
      'Manistee',
      'Manistique',
      'Manitou Beach',
      'Maple City',
      'Maple Rapids',
      'Marcellus',
      'Marenisco',
      'Marine City',
      'Marlette',
      'Maybee',
      'Mayville',
      'McBain',
      'McMillan',
      'Mecosta',
      'Melstrand',
      'Melvindale',
      'Mesick',
      'Michiana',
      'Michigamme',
      'Michigan',
      'Michigan Center',
      'Middleville',
      'Mikado',
      'Milleville Beach',
      'Minden City',
      'Mineral Hills',
      'Mio',
      'Moddersville',
      'Morrice',
      'Mount Clemens',
      'Muir',
      'Mulliken',
      'Munising',
      'Muskegon',
      'Muskegon Heights',
      'Nahma',
      'National Mine',
      'Naubinway',
      'Negaunee',
      'Nessen City',
      'Nestoria',
      'New Baltimore',
      'New Buffalo',
      'New Hudson',
      'New Lothrop',
      'New Troy',
      'Newaygo',
      'North Branch',
      'North Epworth',
      'North Manitou',
      'North Muskegon',
      'Northland',
      'Northview',
      'Northville',
      'Norton Shores',
      'Novi',
      'Oakley Park',
      'Okemos',
      'Omena',
      'Omer',
      'Onekama',
      'Onsted',
      'Ontonagon',
      'Orchard Lake',
      'Ortonville',
      'Oscoda',
      'Osseo',
      'Ossineke',
      'Otisville',
      'Otsego',
      'Otsego Lake',
      'Otter Lake',
      'Owendale',
      'Owosso',
      'Painesdale',
      'Paint Creek',
      'Parchment',
      'Paw Paw Lake',
      'Pearl Beach',
      'Pelkie',
      'Pellston',
      'Pentwater',
      'Perrinton',
      'Peshawbestown',
      'Petoskey',
      'Pewamo',
      'Pickford',
      'Pigeon',
      'Pilgrim',
      'Pinckney',
      'Pinconning',
      'Plainwell',
      'Pleasant Ridge',
      'Pointe Aux Pins',
      'Ponshewaing',
      'Port Austin',
      'Port Huron',
      'Port Sanilac',
      'Powers',
      'Prudenville',
      'Quinnesec',
      'Ramsay',
      'Rapid City',
      'Rawsonville',
      'Reed City',
      'Reese',
      'River Rouge',
      'Rives Junction',
      'Rochester Hills',
      'Rogers City',
      'Romulus',
      'Roosevelt Park',
      'Roscommon',
      'Rose City',
      'Rosebush',
      'Rothbury',
      'Roulo',
      'Rudyard',
      'Rushton',
      'Saint Clair Haven',
      'Saint Clair Shores',
      'Saint Helen',
      'Saint Ignace',
      'Saint Louis',
      'Sand Lake',
      'Sandusky',
      'Saranac',
      'Saugatuck',
      'Sault Sainte Marie',
      'Schaffer',
      'Schoolcraft',
      'Sebewaing',
      'Shepherd',
      'Shingleton',
      'Shoreham',
      'Sidnaw',
      'Sister Lakes',
      'Skidway Lake',
      'Snover',
      'South Boardman',
      'South Gull Lake',
      'South Lyon',
      'South Monroe',
      'South Range',
      'South Rockwood',
      'Southfield',
      'Sparlingville',
      'Spring Arbor',
      'Stalwart',
      'Stephenson',
      'Sterling Heights',
      'Steuben',
      'Stony Creek',
      'Stony Lake',
      'Stony Point',
      'Stronach',
      'Suttons Bay',
      'Swartz Creek',
      'Tawas City',
      'Tekonsha',
      'Temperance',
      'Topinabee',
      'Tower',
      'Traverse City',
      'Trenary',
      'Trout Creek',
      'Trout Lake',
      'Trowbridge Park',
      'Trufant',
      'Twin Lake',
      'Twining',
      'Ubly',
      'Union Lake',
      'Vanderbilt',
      'Vandercook Lake',
      'Vermontville',
      'Vestaburg',
      'Wacousta',
      'Walkerville',
      'Walled Lake',
      'Walloon Lake',
      'Waltz',
      'Watersmeet',
      'Watervliet',
      'Webberville',
      'Weidman',
      'Wellston',
      'West Ishpeming',
      'Westacres',
      'Westland',
      'White Pigeon',
      'White Pine',
      'Whitmore Lake',
      'Whittaker',
      'Williamston',
      'Willow Run',
      'Winn',
      'Wixom',
      'Wolf Lake',
      'Wolverine',
      'Wolverine Lake',
      'Woodhaven',
      'Woodland Beach',
      'Wyandotte',
      'Ypsilanti',
      'Zeba',
      'Zeeland',
      'Zilwaukee',
    ],
    'US-MN': [
      'Aitkin',
      'Akeley',
      'Albert Lea',
      'Alborn',
      'Aldrich',
      'Almelund',
      'Alvwood',
      'Amiret',
      'Angle Inlet',
      'Annandale',
      'Anoka',
      'Arden Hills',
      'Askov',
      'Averill',
      'Babbitt',
      'Backus',
      'Balaton',
      'Bald Eagle',
      'Ball Club',
      'Barden',
      'Barrett',
      'Barrows',
      'Battle Lake',
      'Baudette',
      'Beaulieu',
      'Beaver Bay',
      'Bechyn',
      'Becida',
      'Bejou',
      'Belgrade',
      'Bellechester',
      'Beltrami',
      'Belview',
      'Bemidji',
      'Bena',
      'Bergen',
      'Beroun',
      'Bertha',
      'Big Bend City',
      'Big Falls',
      'Bigfork',
      'Bingham Lake',
      'Birchwood',
      'Bird Island',
      'Biscay',
      'Biwabik',
      'Bixby',
      'Blackberry',
      'Blackduck',
      'Blakeley',
      'Blomkest',
      'Blooming Prairie',
      'Blue Earth',
      'Bock',
      'Borup',
      'Bovey',
      'Bowlus',
      'Boy River',
      'Braham',
      'Brainerd',
      'Breezy Point',
      'Bricelyn',
      'Brimson',
      'Brook Park',
      'Brooklyn Center',
      'Brooten',
      'Browerville',
      'Browns Valley',
      'Brownton',
      'Brushvale',
      'Buckman',
      'Buffalo Lake',
      'Burchard',
      'Burtrum',
      'Buyck',
      'Cannon Falls',
      'Cass Lake',
      'Castle Danger',
      'Cedar Mills',
      'Center City',
      'Ceylon',
      'Champlin',
      'Chanhassen',
      'Chaska',
      'Chickamaw Beach',
      'Chisago City',
      'Chokio',
      'Circle Pines',
      'Clara City',
      'Clarissa',
      'Clarkfield',
      'Clarks Grove',
      'Clearbrook',
      'Clementson',
      'Clitherall',
      'Clontarf',
      'Cloquet',
      'Cloverton',
      'Coates',
      'Cokato',
      'Collis',
      'Columbia Heights',
      'Comfrey',
      'Comstock',
      'Conger',
      'Cormorant',
      'Correll',
      'Cosmos',
      'Cottage Grove',
      'Craigville',
      'Crane Lake',
      'Crookston',
      'Cross Lake',
      'Crow River',
      'Crown',
      'Cusson',
      'Cuyuna',
      'Cyrus',
      'Dalbo',
      'Danube',
      'Darfur',
      'Dassel',
      'De Graff',
      'Deephaven',
      'Deer River',
      'Deerwood',
      'Delft',
      'Dent',
      'Detroit Lakes',
      'Dilworth',
      'Dodge Center',
      'Doran',
      'Dorothy',
      'Dovray',
      'Downer',
      'Dresbach',
      'Duelm',
      'Dunnell',
      'Duquette',
      'Eagan',
      'Eagle Bend',
      'East Bethel',
      'East Chain',
      'East Grand Forks',
      'East Gull Lake',
      'Eden Prairie',
      'Edina',
      'Eitzen',
      'Elbow Lake',
      'Elko New Market',
      'Elmer',
      'Elrosa',
      'Elysian',
      'Embarrass',
      'Emily',
      'Emmons',
      'Erhard',
      'Ericsburg',
      'Erskine',
      'Esko',
      'Euclid',
      'Evan',
      'Eveleth',
      'Eyota',
      'Falcon Heights',
      'Faribault',
      'Federal Dam',
      'Fergus Falls',
      'Fernando',
      'Fifty Lakes',
      'Finland',
      'Finlayson',
      'Flom',
      'Floodwood',
      'Forada',
      'Forest Center',
      'Foreston',
      'Fort Ripley',
      'Fosston',
      'Fossum',
      'Four Town',
      'Foxhome',
      'Frazee',
      'Freeborn',
      'Freedhem',
      'Fridley',
      'Frost',
      'Funkley',
      'Garvin',
      'Gem Lake',
      'Gemmell',
      'Gheen',
      'Gibbon',
      'Glen',
      'Gluek',
      'Glyndon',
      'Gonvick',
      'Good Thunder',
      'Goodhue',
      'Goodridge',
      'Goodview',
      'Gowan',
      'Graceton',
      'Grand Meadow',
      'Grand Portage',
      'Grandy',
      'Granite Falls',
      'Grasston',
      'Green Isle',
      'Greenleafton',
      'Greenwald',
      'Grey Eagle',
      'Grove Lake',
      'Grygla',
      'Gully',
      'Hackensack',
      'Hadley',
      'Hallock',
      'Halma',
      'Halstad',
      'Ham Lake',
      'Hanley Falls',
      'Hanska',
      'Hassman',
      'Hawick',
      'Hay Creek',
      'Hazel Run',
      'Hendricks',
      'Hendrum',
      'Henriette',
      'Hermantown',
      'Heron Lake',
      'Hewitt',
      'Hibbing',
      'High Landing',
      'Hitterdal',
      'Hokah',
      'Holdingford',
      'Hollandale',
      'Holloway',
      'Holmes City',
      'Hovland',
      'Howard Lake',
      'Hoyt Lakes',
      'Ihlen',
      'Indus',
      'Inger',
      'Inguadona',
      'International Falls',
      'Inver Grove Heights',
      'Iron Junction',
      'Isabella',
      'Isanti',
      'Island View',
      'Isle',
      'Jacobson',
      'Jeffers',
      'Kanaranzi',
      'Kandiyohi',
      'Karlstad',
      'Kasota',
      'Keewatin',
      'Kelliher',
      'Kelly Lake',
      'Kelsey',
      'Kenyon',
      'Kerkhoven',
      'Kerrick',
      'Kettle River',
      'Kiester',
      'Kilkenny',
      'Kinbrae',
      'Kingsdale',
      'Kinney',
      'Klossner',
      'Knife River',
      'Kragnes',
      'La Crescent',
      'Lake Benton',
      'Lake Bronson',
      'Lake Crystal',
      'Lake Elmo',
      'Lake Henry',
      'Lake Itasca',
      'Lake Lillian',
      'Lake Saint Croix Beach',
      'Lake Wilson',
      'Lakefield',
      'Lakeland Shores',
      'Lamberton',
      'Lamoille',
      'Landfall',
      'Larsmont',
      'Lastrup',
      'Lavinia',
      'Le Center',
      'Le Sueur',
      'Leader',
      'Lengby',
      'Leonidas',
      'Leota',
      'Lester Prairie',
      'Lime Creek',
      'Lindstrom',
      'Lino Lakes',
      'Little Canada',
      'Little Marais',
      'Little Sauk',
      'Littlefork',
      'Loman',
      'Long Prairie',
      'Lucan',
      'Luce',
      'Lutsen',
      'Lyle',
      'Lynd',
      'Mabel',
      'Madelia',
      'Madison Lake',
      'Mahnomen',
      'Mahtomedi',
      'Mahtowa',
      'Makinen',
      'Malmo',
      'Manannah',
      'Mantorville',
      'Maple Bay',
      'Maple Grove',
      'Maple Lake',
      'Maple Plain',
      'Mapleview',
      'Maplewood',
      'Marcell',
      'Margie',
      'Marine on Saint Croix',
      'Markville',
      'Martin Lake',
      'Matawan',
      'Max',
      'Mazeppa',
      'McKinley',
      'Meadowlands',
      'Medicine Lake',
      'Meire Grove',
      'Melby',
      'Melrude',
      'Menahga',
      'Mendota Heights',
      'Merrifield',
      'Miesville',
      'Milaca',
      'Miltona',
      'Minneiska',
      'Minneota',
      'Minnesota City',
      'Minnesota Lake',
      'Minnetonka',
      'Minnetonka Beach',
      'Minnetrista',
      'Mizpah',
      'Money Creek',
      'Montevideo',
      'Moose Lake',
      'Motley',
      'Mounds View',
      'Mountain Iron',
      'Mountain Lake',
      'Murphy City',
      'Nashwauk',
      'Nassau',
      'Naytahwaush',
      'Nerstrand',
      'Nett Lake',
      'Nevis',
      'New Auburn',
      'New Brighton',
      'New Germany',
      'New Munich',
      'New Prague',
      'New Richland',
      'New Trier',
      'New Ulm',
      'New York Mills',
      'Newfolden',
      'Nicollet',
      'Nielsville',
      'Nimrod',
      'Nisswa',
      'Norseland',
      'Norshor Junction',
      'North Mankato',
      'North Oaks',
      'North Redwood',
      'North Saint Paul',
      'Northcote',
      'Northome',
      'Northrop',
      'Norwood Young America',
      'Nowthen',
      'Noyes',
      'Oak Park Heights',
      'Ogema',
      'Ogilvie',
      'Okabena',
      'Oklee',
      'Olivia',
      'Onamia',
      'Ormsby',
      'Oronoco',
      'Orr',
      'Osakis',
      'Ostrander',
      'Ottertail',
      'Outing',
      'Owatonna',
      'Oylen',
      'Park Rapids',
      'Parkers Prairie',
      'Paynesville',
      'Pease',
      'Pelican Rapids',
      'Pelland',
      'Pencer',
      'Pengilly',
      'Pennock',
      'Pequot Lakes',
      'Perham',
      'Perley',
      'Philbrook',
      'Pierz',
      'Pigeon River',
      'Pillager',
      'Pine Bend',
      'Pine Center',
      'Pine City',
      'Pine River',
      'Pine Springs',
      'Pinecreek',
      'Pipestone',
      'Ponemah',
      'Ponsford',
      'Prinsburg',
      'Prior Lake',
      'Prosit',
      'Quamba',
      'Racine',
      'Ranier',
      'Reads Landing',
      'Red Lake Falls',
      'Red Wing',
      'Redby',
      'Redwood Falls',
      'Regal',
      'Remer',
      'Renville',
      'Rice Lake',
      'Rich Valley',
      'Richville',
      'Robbin',
      'Robbinsdale',
      'Rochert',
      'Rollingstone',
      'Rollins',
      'Ronneby',
      'Rose Creek',
      'Roseau',
      'Rosemount',
      'Rosen',
      'Rosendale',
      'Rothsay',
      'Round Prairie',
      'Roy Lake',
      'Rush City',
      'Rushford',
      'Rushford Village',
      'Rushmore',
      'Rustad',
      'Ruthton',
      'Sabin',
      'Sacred Heart',
      'Saint Augusta',
      'Saint Bonifacius',
      'Saint Hilaire',
      'Saint Louis Park',
      'Saint Martin',
      'Saint Marys Point',
      'Saint Nicholas',
      'Saint Paul Park',
      'Saint Rosa',
      'Saint Stephen',
      'Salol',
      'Sargeant',
      'Sartell',
      'Sauk Centre',
      'Sauk Rapids',
      'Saum',
      'Scanlon',
      'Seaforth',
      'Sebeka',
      'Shafer',
      'Shakopee',
      'Shelly',
      'Sherack',
      'Sherburn',
      'Sheshebee',
      'Shevlin',
      'Shooks',
      'Shoreview',
      'Silver Bay',
      'Silver Creek',
      'Skime',
      'Slayton',
      'Sleepy Eye',
      'Sobieski',
      'Soderville',
      'Solway',
      'Soudan',
      'South Saint Paul',
      'Spicer',
      'Spring Lake Park',
      'Spring Park',
      'Squaw Lake',
      'Stacy',
      'Stanchfield',
      'Staples',
      'Starbuck',
      'Steen',
      'Stephen',
      'Stillwater',
      'Storden',
      'Strandquist',
      'Strathcona',
      'Sturgeon Lake',
      'Sunburg',
      'Sunfish Lake',
      'Svea',
      'Swanville',
      'Swatara',
      'Swift',
      'Swift Falls',
      'Taconite',
      'Taconite Harbor',
      'Tamarack',
      'Taopi',
      'Taylors Falls',
      'Tenney',
      'Tenstrike',
      'Theilman',
      'Thief River Falls',
      'Tintah',
      'Tobique',
      'Tofte',
      'Togo',
      'Tonka Bay',
      'Traverse',
      'Trimont',
      'Trommald',
      'Trosky',
      'Truman',
      'Turtle River',
      'Twin Valley',
      'Two Harbors',
      'Two Inlets',
      'Upsala',
      'Urbank',
      'Vadnais Heights',
      'Vergas',
      'Verndale',
      'Vernon Center',
      'Villard',
      'Wabasha',
      'Waconia',
      'Wacouta',
      'Wahkon',
      'Waite Park',
      'Wanamingo',
      'Wanda',
      'Wannaska',
      'Warba',
      'Ward Springs',
      'Warman',
      'Warroad',
      'Waseca',
      'Waskish',
      'Waubun',
      'Wawina',
      'Wayzata',
      'Wegdahl',
      'West Saint Paul',
      'Whalan',
      'Whipholt',
      'White Bear Beach',
      'White Bear Lake',
      'White Earth',
      'Whyte',
      'Willernie',
      'Willmar',
      'Willow River',
      'Wilmont',
      'Wilno',
      'Winger',
      'Wirt',
      'Witoka',
      'Wolverton',
      'Wood Lake',
      'Wrenshall',
      'Wrightstown',
      'Wyattville',
      'Wykoff',
      'Zemple',
      'Zim',
      'Zumbro Falls',
      'Zumbrota',
    ],
    'US-MS': [
      'Ackerman',
      'Albin',
      'Alligator',
      'Amory',
      'Anding',
      'Anguilla',
      'Arm',
      'Arnold Line',
      'Baird',
      'Baldwyn',
      'Barnett',
      'Barr',
      'Basic',
      'Bassfield',
      'Battles',
      'Baxterville',
      'Bay Saint Louis',
      'Bay Springs',
      'Beatty',
      'Beauregard',
      'Belzoni',
      'Benndale',
      'Benoit',
      'Bentonia',
      'Betheden',
      'Big Point',
      'Bigbee',
      'Bigbee Valley',
      'Biggersville',
      'Biloxi',
      'Bissell',
      'Bobo',
      'Bogue Chitto',
      'Bonhomie',
      'Braxton',
      'Buckatunna',
      'Bude',
      'Byhalia',
      'Calhoun City',
      'Carriere',
      'Chatawa',
      'Chicora',
      'Chunky',
      'Clarksdale',
      'Cleary',
      'Coahoma',
      'Cockrum',
      'Coila',
      'Conehatta',
      'Crenshaw',
      'Crowder',
      'Cruger',
      "D'Iberville",
      "D'Lo",
      'Darbun',
      'Darling',
      'Darlove',
      'De Kalb',
      'De Lisle',
      'DeWeese',
      'Deemer',
      'Deeson',
      'Derma',
      'Diamondhead',
      'Doddsville',
      'Dossville',
      'Drew',
      'Dubbs',
      'Duck Hill',
      'Ebenezer',
      'Ecru',
      'Eddiceton',
      'Electric Mills',
      'Enid',
      'Escatawpa',
      'Estill',
      'Etta',
      'Eupora',
      'Falkner',
      'Farrell',
      'Fitler',
      'Flowood',
      'Forkville',
      'Fort Adams',
      'Foxworth',
      'Freeny',
      'Friars Point',
      'Gallman',
      'Gatesville',
      'Gattman',
      'Gautier',
      'Geeville',
      'Gholson',
      'Glancy',
      'Glen Allan',
      'Glens',
      'Goodman',
      'Goss',
      'Grand Gulf',
      'Gulf Hills',
      'Gulf Park Estates',
      'Gunn',
      'Guntown',
      'Harperville',
      'Harriston',
      'Hattiesburg',
      'Heads',
      'Henderson Point',
      'Hermanville',
      'Hickory Flat',
      'Hide-A-Way Lake',
      'Hillhouse',
      'Hinchcliff',
      'Hiwannee',
      'Holcut',
      'Holly Bluff',
      'Holmesville',
      'Horn Lake',
      'Houlka',
      'Howison',
      'Hurley',
      'Hushpuckena',
      'Ingomar',
      'Isola',
      'Itta Bena',
      'Johns',
      'Jumpertown',
      'Kearney Park',
      'Kilmichael',
      'Kiln',
      'Kolola Springs',
      'Kossuth',
      'Kreole',
      'Lambert',
      'Leaf',
      'Leakesville',
      'Learned',
      'Leedy',
      'Leflore',
      'Lessley',
      'Lexie',
      'Lorman',
      'Louin',
      'Lucedale',
      'Lynchburg',
      'Maben',
      'Madden',
      'Magee',
      'Mantachie',
      'Mantee',
      'Marks',
      'Martin Bluff',
      'Mashulaville',
      'Mathiston',
      'Mattson',
      'Mayersville',
      'Mayhew',
      'McAdams',
      'McCall Creek',
      'McCallum',
      'McComb',
      'McCool',
      'McLain',
      'McLaurin',
      'McNair',
      'McNeill',
      'McVille',
      'Meadville',
      'Mendenhall',
      'Merigold',
      'Midnight',
      'Minter City',
      'Mize',
      'Money',
      'Moselle',
      'Moss Point',
      'Mound Bayou',
      'Myrick',
      'Neely',
      'Nellieburg',
      'Nesbit',
      'Neshoba',
      'Nettleton',
      'New Augusta',
      'New Hamilton',
      'New Hebron',
      'Nitta Yuma',
      'North Carrollton',
      'North Tunica',
      'Noxapater',
      'Oak Vale',
      'Ocean Springs',
      'Orange Grove',
      'Osyka',
      'Ovett',
      'Ozona',
      'Pachuta',
      'Paden',
      'Palmers Crossing',
      'Pascagoula',
      'Pass Christian',
      'Pattison',
      'Paulding',
      'Paulette',
      'Paynes',
      'Pearlington',
      'Pelahatchie',
      'Perkinston',
      'Petal',
      'Pheba',
      'Philadelphia',
      'Philipp',
      'Picayune',
      'Piney Woods',
      'Pinola',
      'Polkville',
      'Pontotoc',
      'Pope',
      'Poplar Creek',
      'Poplarville',
      'Port Gibson',
      'Potts Camp',
      'Prairie Point',
      'Prentiss',
      'Pricedale',
      'Prismatic',
      'Puckett',
      'Purvis',
      'Rawls Springs',
      'Red Banks',
      'Red Lick',
      'Redwood',
      'Reganton',
      'Renova',
      'Rich',
      'Richton',
      'Ridgeland',
      'Rienzi',
      'Robinsonville',
      'Rolling Fork',
      'Roxie',
      'Ruleville',
      'Runnelstown',
      'Sallis',
      'Sanatorium',
      'Sarah',
      'Satartia',
      'Saucier',
      'Schlater',
      'Scooba',
      'Seminary',
      'Senatobia',
      'Sherard',
      'Shivers',
      'Shubuta',
      'Shuqualak',
      'Skene',
      'Slate Spring',
      'Slayden',
      'Sledge',
      'Smithdale',
      'Snell',
      'Snow Lake Shores',
      'Sontag',
      'Soso',
      'Southaven',
      'Stallo',
      'Stampley',
      'Standing Pine',
      'Steens',
      'Stringer',
      'Sumrall',
      'Suqualena',
      'Swan Lake',
      'Sweatman',
      'Sylvarena',
      'Talowah',
      'Tamola',
      'Tchula',
      'Thaxton',
      'Thomastown',
      'Thorn',
      'Tie Plant',
      'Tillatoba',
      'Tillman',
      'Tinsley',
      'Tiplersville',
      'Tishomingo',
      'Toccopola',
      'Tomnolen',
      'Toomsuba',
      'Tougaloo',
      'Trebloc',
      'Tuckers Crossing',
      'Tunica Resorts',
      'Tutwiler',
      'Tylertown',
      'Union Church',
      'University',
      'Vaiden',
      'Valley Park',
      'Value',
      'Vancleave',
      'Vardaman',
      'Velma',
      'Vossburg',
      'Wade',
      'Wallerville',
      'Walls',
      'Waltersville',
      'Walthall',
      'Way',
      'Weathersby',
      'Wenasoga',
      'West',
      'West Hattiesburg',
      'White Apple',
      'Winborn',
      'Winstonville',
      'Wool Market',
      'Wyatte',
      'Yazoo City',
    ],
    'US-MO': [
      'Affton',
      'Airport Drive',
      'Akers',
      'Amazonia',
      'Amoret',
      'Amsterdam',
      'Annada',
      'Appleton City',
      'Arbela',
      'Arbyrd',
      'Arkoe',
      'Arrow Point',
      'Arrow Rock',
      'Atlas',
      'Aullville',
      'Auxvasse',
      'Bagnell',
      'Ballwin',
      'Bardley',
      'Barnhart',
      'Bates City',
      'Battlefield',
      'Bel-Nor',
      'Bel-Ridge',
      'Belgique',
      'Bella Villa',
      'Belle',
      'Bellefontaine Neighbors',
      'Bellerive Acres',
      'Bendavis',
      'Bennett Springs',
      'Benton City',
      'Berger',
      'Bernie',
      'Bevier',
      'Biehle',
      'Birch Tree',
      'Black Jack',
      'Black Walnut',
      'Blackburn',
      'Bland',
      'Blodgett',
      'Bloomsdale',
      'Blythedale',
      'Bogard',
      "Bois D'Arc",
      'Bolckow',
      'Bonne Terre',
      'Bonnots Mill',
      'Boschertown',
      'Boss',
      'Bosworth',
      'Bowers Mill',
      'Bradleyville',
      'Bragg City',
      'Braggadocio',
      'Brandsville',
      'Branson West',
      'Brashear',
      'Braymer',
      'Breckenridge Hills',
      'Briar',
      'Bronaugh',
      'Brooklyn Heights',
      'Broseley',
      'Brownbranch',
      'Brownington',
      'Brownwood',
      'Brumley',
      'Buell',
      'Bull Creek',
      'Bunceton',
      'Bunker',
      'Burlington Junction',
      'Byrnes Mill',
      'Cabool',
      'Cainsville',
      'Calverton Park',
      'Camden Point',
      'Camdenton',
      'Canalou',
      'Cape Fair',
      'Cape Girardeau',
      'Caplinger Mills',
      'Carl Junction',
      'Caruthersville',
      'Carytown',
      'Cassville',
      'Castle Point',
      'Catron',
      'Caulfield',
      'Cedar City',
      'Cedar Hill',
      'Cedar Hill Lakes',
      'Centerview',
      'Chaffee',
      'Chain of Rocks',
      'Chain-O-Lakes',
      'Champ',
      'Charity',
      'Charlack',
      'Charmwood',
      'Cherokee Pass',
      'Chesapeake',
      'Chilhowee',
      'Clarkson Valley',
      'Clarkton',
      'Claycomo',
      'Clearmont',
      'Clever',
      'Cliff Village',
      'Clifton City',
      'Clifton Hill',
      'Climax Springs',
      'Coal',
      'Cobalt Village',
      'Coffey',
      'Coffman',
      'Cole Camp',
      'Competition',
      'Conception',
      'Conception Junction',
      'Coney Island',
      'Cook Station',
      'Cool Valley',
      'Cooter',
      'Corder',
      'Cosby',
      'Cottleville',
      'Country Club Village',
      'Country Life Acres',
      'Courtney',
      'Cowgill',
      'Creighton',
      'Cross Keys',
      'Cross Timbers',
      'Crosstown',
      'Crystal City',
      'Crystal Lake Park',
      'Crystal Lakes',
      'Curryville',
      'Dardenne Prairie',
      'Davisville',
      'Dawn',
      'Decaturville',
      'Dennis Acres',
      'Des Peres',
      'Desloge',
      'Diehlstadt',
      'Diggins',
      'Doe Run',
      'Doolittle',
      'Downing',
      'Drynob',
      'Duenweg',
      'Dunnegan',
      'Duquesne',
      'Dutchtown',
      'Eagle Rock',
      'East Leavenworth',
      'East Lynne',
      'East Prairie',
      'Edgar Springs',
      'Edmundson',
      'El Dorado Springs',
      'Elkland',
      'Ellington',
      'Ellsinore',
      'Elm Point',
      'Elsberry',
      'Elsey',
      'Emerald Beach',
      'Eugene',
      'Excello',
      'Excelsior Estates',
      'Excelsior Springs',
      'Fagus',
      'Fair Grove',
      'Fair Play',
      'Fairdealing',
      'Farber',
      'Faucett',
      'Ferrelview',
      'Festus',
      'Fisk',
      'Flint Hill',
      'Flordell Hills',
      'Fordland',
      'Foristell',
      'Fort Bellefontaine',
      "Fountain N' Lakes",
      'Four Seasons',
      'Frankclay',
      'Fredericktown',
      'Freeman',
      'Freistatt',
      'Fremont Hills',
      'Fristoe',
      'Frohna',
      'Gallatin',
      'Galloway',
      'Gasconade',
      'Gerald',
      'Gerster',
      'Gibbs',
      'Gideon',
      'Gilman City',
      'Ginger Blue',
      'Gladden',
      'Glasgow Village',
      'Glen Echo Park',
      'Glenaire',
      'Glenallen',
      'Glover',
      'Gobler',
      'Golden City',
      'Goodnight',
      'Gorin',
      'Gower',
      'Grain Valley',
      'Grand Falls Plaza',
      'Grand Pass',
      'Grandin',
      'Grant City',
      'Grantwood Village',
      'Gravois Mills',
      'Gray Summit',
      'Grayridge',
      'Green Castle',
      'Green City',
      'Green Park',
      'Green Ridge',
      'Greentop',
      'Grovespring',
      'Gunn City',
      'Hallsville',
      'Halltown',
      'Hanley Hills',
      'Hannibal',
      'Hartshorn',
      'Hartville',
      'Harviell',
      'Hawk Point',
      'Hayti',
      'Hayti Heights',
      'Haywood City',
      'Hematite',
      'Henley',
      'Herculaneum',
      'Hermann',
      'Higbee',
      'Higginsville',
      'High Hill',
      'High Ridge',
      'Hoberg',
      'Holliday',
      'Holts Summit',
      'Homestown',
      'Horine',
      'Hornersville',
      'House Springs',
      'Houston Lake',
      'Houstonia',
      'Howardville',
      'Howes Mill',
      'Humansville',
      'Humphreys',
      'Huntleigh',
      'Huntsdale',
      'Hurdland',
      'Iatan',
      'Iberia',
      'Illmo',
      'Indian Point',
      'Innsbrook',
      'Irena',
      'Iron Gates',
      'Iron Mountain Lake',
      'Jameson',
      'Jamesport',
      'Jane',
      'Jefferson City',
      'Jerico Springs',
      'Joplin',
      'Josephville',
      'Kahoka',
      'Kennett',
      'Keyes Summit',
      'Keytesville',
      'Kidder',
      'Kimberling City',
      'Kimmswick',
      'Kingdom City',
      'Kinloch',
      'Kirbyville',
      'Kirksville',
      'Kissee Mills',
      'Knob Noster',
      'Knox City',
      'Koshkonong',
      'La Belle',
      'La Due',
      'La Monte',
      'La Russell',
      'Labadie',
      'Laddonia',
      'Ladue',
      'Lake Annette',
      'Lake Lafayette',
      'Lake Lotawana',
      'Lake Mykee Town',
      'Lake Ozark',
      'Lake Saint Louis',
      'Lake Spring',
      'Lake Tapawingo',
      'Lake Waukomis',
      'Lake Winnebago',
      'Lakeshire',
      'Lamar Heights',
      'Lamine',
      'Lanagan',
      'Lanton',
      'Latour',
      'Laurie',
      'Leadington',
      'Leadwood',
      'Leasburg',
      'Leeper',
      'Lees Summit',
      'Leeton',
      'Lemay',
      'Lesterville',
      'Levasy',
      'Lewis and Clark Village',
      'Licking',
      'Lilbourn',
      'Linn Creek',
      'Linneus',
      'Lithium',
      'Loch Lloyd',
      'Lock Springs',
      'Lohman',
      'Lone Jack',
      'Lonedell',
      'Longrun',
      'Longtown',
      'Loose Creek',
      'Louisiana',
      'Lowry City',
      'Lupus',
      'Machens',
      'Macks Creek',
      'Malta Bend',
      'Manes',
      'Marble Hill',
      'Marceline',
      'Marionville',
      'Marquand',
      'Marston',
      'Marthasville',
      'Maryland Heights',
      'Marys Home',
      'Mattese',
      'Mayview',
      'McBaine',
      'McCord Bend',
      'McFall',
      'McGee',
      'Mehlville',
      'Menfro',
      'Mercer',
      'Merriam Woods',
      'Merwin',
      'Middle Grove',
      'Mill Grove',
      'Mill Spring',
      'Millard',
      'Mindenmines',
      'Mine La Motte',
      'Miner',
      'Mineral Point',
      'Miramiguoa Park',
      'Missouri City',
      'Moberly',
      'Mokane',
      'Moline Acres',
      'Monett',
      'Montgomery City',
      'Montier',
      'Morehouse',
      'Mosby',
      'Moscow Mills',
      'Mount Leonard',
      'Mountain Grove',
      'Musicks Ferry',
      'Neck City',
      'Neelys Landing',
      'Neelyville',
      'Neosho',
      'New Bloomfield',
      'New Court Village',
      'New Florence',
      'New Franklin',
      'New Madrid',
      'New Melle',
      'Newtonia',
      'Niangua',
      'Nixa',
      'Noel',
      'Norborne',
      'Normandy',
      'North Kansas City',
      'North Lilbourn',
      'Northmoor',
      'Northwoods',
      'Northwye',
      'Norwood Court',
      'Novelty',
      'Novinger',
      'Oak Grove Village',
      'Oakview',
      'Oakwood Manor',
      'Oakwood Park',
      'Old Appleton',
      'Old Mines',
      'Old Monroe',
      'Olean',
      'Olivette',
      'Olympian Village',
      'Oran',
      'Orchard Farm',
      'Oronogo',
      'Orrick',
      'Osage Beach',
      'Osborn',
      'Overland',
      'Oxly',
      'Ozora',
      'Pacific',
      'Pagedale',
      'Pasadena Hills',
      'Pasadena Park',
      'Pascola',
      'Passaic',
      'Pattonsburg',
      'Peculiar',
      'Penermon',
      'Pevely',
      'Phelps City',
      'Pierce City',
      'Pierpont',
      'Pilot Grove',
      'Pilot Knob',
      'Pine Lawn',
      'Piney Park',
      'Pinhook',
      'Platte City',
      'Platte Woods',
      'Plattsburg',
      'Pleasant Green',
      'Pleasant Hope',
      'Poplar Bluff',
      'Portage Des Sioux',
      'Portageville',
      'Post Oak',
      'Potosi',
      'Powersville',
      'Prairie Hill',
      'Prairie Home',
      'Prathersville',
      'Protem',
      'Purcell',
      'Purdin',
      'Purdy',
      'Puxico',
      'Queen City',
      'Quick City',
      'Qulin',
      'Ravanna',
      'Ravenwood',
      'Raymondville',
      'Raymore',
      'Raytown',
      'Readsville',
      'Redings Mill',
      'Reeds',
      'Reeds Spring',
      'Renick',
      'Rhineland',
      'Rich Fountain',
      'Rich Hill',
      'Richards',
      'Richwoods',
      'Rington',
      'Ritchey',
      'River Bend',
      'Riverview Estates',
      'Rives',
      'Robertson',
      'Roby',
      'Rocheport',
      'Rock Port',
      'Rockaway Beach',
      'Rocky Comfort',
      'Rocky Ridge Ranch',
      'Rombauer',
      'Rosati',
      'Rosebud',
      'Rothville',
      'Round Grove',
      'Rueter',
      'Rush Hill',
      'Saddlebrooke',
      'Saint Ann',
      'Saint Clement',
      'Saint Elizabeth',
      'Saint Martins',
      'Saint Peters',
      'Saint Robert',
      'Saint Thomas',
      'Sainte Genevieve',
      'Sappington',
      'Sarcoxie',
      'Schell City',
      'Scotsdale',
      'Sedgewickville',
      'Senath',
      'Shelbina',
      'Shell Knob',
      'Shoal Creek Drive',
      'Shoal Creek Estates',
      'Shoveltown',
      'Shrewsbury',
      'Sikeston',
      'Silex',
      'Silva',
      'Simmons',
      'Sleeper',
      'South Greenfield',
      'South Lineville',
      'South West City',
      'Spanish Lake',
      'Spickard',
      'Squires',
      'Stanberry',
      'Stark City',
      'Steelville',
      'Stewartsville',
      'Stillings',
      'Stotesbury',
      'Stotts City',
      'Stoutland',
      'Stoutsville',
      'Stover',
      'Strafford',
      'Sturgeon',
      'Sundown',
      'Sunset Hills',
      'Swedeborg',
      'Sweet Springs',
      'Sycamore Hills',
      'Taberville',
      'Table Rock',
      'Taneyville',
      'Taos',
      'Tarkio',
      'Tarrants',
      'Terre du Lac',
      'The Landing',
      'Theodosia',
      'Thornfield',
      'Three Creeks Village',
      'Tiff City',
      'Tightwad',
      'Tina',
      'Tindall',
      'Town and Country',
      'Triplett',
      'Turney',
      'Twin Oaks',
      'Umber View Heights',
      'Union Star',
      'Unity Village',
      'University City',
      'Uplands Park',
      'Urich',
      'Valles Mines',
      'Vanduser',
      'Vanzant',
      'Velda Village',
      'Velda Village Hills',
      'Vibbard',
      'Viburnum',
      'Vigus',
      'Villa Ridge',
      'Vinita Park',
      'Vinita Terrace',
      'Wakenda',
      'Walnut Shade',
      'Wardell',
      'Wardsville',
      'Warson Woods',
      'Wasola',
      'Weatherby',
      'Weatherby Lake',
      'Weaubleau',
      'Webster Groves',
      'Weingarten',
      'Weldon Spring',
      'Weldon Spring Heights',
      'Wentzville',
      'West Alton',
      'West Line',
      'West Plains',
      'West Sullivan',
      'Westboro',
      'White Church',
      'Whiteside',
      'Wilbur Park',
      'Wilderness',
      'Willhoit',
      'Wilson City',
      'Windsor Place',
      'Windyville',
      'Winigan',
      'Winston',
      'Wittenberg',
      'Wood Heights',
      'Woodson Terrace',
      'Wooldridge',
      'Worland',
      'Wortham',
      'Wright City',
      'Wyaconda',
      'Yukon',
      'Zalma',
    ],
    'US-MT': [
      'Absarokee',
      'Alder',
      'Alzada',
      'Anaconda',
      'Anceney',
      'Angela',
      'Apgar',
      'Arlee',
      'Arrow Creek',
      'Azure',
      'Babb',
      'Bainville',
      'Ballantine',
      'Bannack',
      'Bear Dance',
      'Bearcreek',
      'Bearmouth',
      'Belt',
      'Benchland',
      'Biddle',
      'Big Arm',
      'Big Sandy',
      'Big Sky',
      'Big Timber',
      'Bighorn',
      'Birney',
      'Black Eagle',
      'Blossburg',
      'Boneau',
      'Bonner',
      'Bowdoin',
      'Box Elder',
      'Boyes',
      'Bozeman',
      'Brady',
      'Brandenberg',
      'Bridger',
      'Broadus',
      'Brockway',
      'Brusett',
      'Busby',
      'Bynum',
      'Camp Three',
      'Canyon Creek',
      'Capitol',
      'Cat Creek',
      'Charlos Heights',
      'Chico Hot Springs',
      'Chinook',
      'Choteau',
      'Christina',
      'Clancy',
      'Clyde Park',
      'Coalridge',
      'Coalwood',
      'Cohagen',
      'Colstrip',
      'Columbia Falls',
      'Comertown',
      'Condon',
      'Conner',
      'Cooke City',
      'Coram',
      'Corvallis',
      'Corwin Springs',
      'Crackerville',
      'Crow Agency',
      'Culbertson',
      'Cut Bank',
      'Dagmar',
      'Darby',
      'De Borgia',
      'Deer Lodge',
      'Delphia',
      'Dewey',
      'Dupuyer',
      'Eagleton',
      'East Glacier Park',
      'East Glacier Park Village',
      'East Helena',
      'East Missoula',
      'Ekalaka',
      'Emigrant',
      'Ennis',
      'Epsie',
      'Ethridge',
      'Evaro',
      'Fallon',
      'Fergus',
      'Finley Point',
      'Fishtail',
      'Flatwillow',
      'Flaxville',
      'Floweree',
      'Forest Hill Village',
      'Fort Belknap Agency',
      'Fort Benton',
      'Fort Peck',
      'Fort Shaw',
      'Fortine',
      'Four Buttes',
      'Francis',
      'Frazer',
      'Frenchtown',
      'Froid',
      'Fromberg',
      'Galata',
      'Gallatin Gateway',
      'Garneill',
      'Garryowen',
      'Geyser',
      'Gibson Flats',
      'Gildford',
      'Glendive',
      'Glentana',
      'Goldcreek',
      'Grantsdale',
      'Grass Range',
      'Greycliff',
      'Happys Inn',
      'Harlowton',
      'Haugan',
      'Havre',
      'Heart Butte',
      'Hedgesville',
      'Helmville',
      'Heron',
      'Hilger',
      'Hogeland',
      'Hungry Horse',
      'Huson',
      'Hysham',
      'Iliad',
      'Intake',
      'Ismay',
      'Janney',
      'Jardine',
      'Jette',
      'Judith Gap',
      'Kalispell',
      'Kerr',
      'Kevin',
      'Kicking Horse',
      'Kila',
      'King Arthur Park',
      'Kings Point',
      'Klein',
      'Knowlton',
      'Kremlin',
      'Lake Mary Ronan',
      'Lake McDonald',
      'Lame Deer',
      'Landusky',
      'Larslan',
      'Lavina',
      'Ledger',
      'Lennep',
      'Lewistown Heights',
      'Libby',
      'Lodge Grass',
      'Lodge Pole',
      'Lolo',
      'Lolo Hot Springs',
      'Lonepine',
      'Lothair',
      'Lozeau',
      'Lustre',
      'Maiden Rock',
      'Marsh',
      'Martin City',
      'Martinsdale',
      'Maudlow',
      'Maxville',
      'McAllister',
      'McCabe',
      'McLeod',
      'Melstone',
      'Miles City',
      'Mill Iron',
      'Missoula',
      'Moiese',
      'Molt',
      'Monarch',
      'Monida',
      'Montana City',
      'Musselshell',
      'Neihart',
      'Niarada',
      'Nohly',
      'North Browning',
      'Noxon',
      'Nye',
      'Oilmont',
      'Old Agency',
      'Olive',
      'Opheim',
      'Opportunity',
      'Orchard Homes',
      'Otter',
      'Outlook',
      'Ovando',
      'Pablo',
      'Parker School',
      'Peerless',
      'Pendroy',
      'Perma',
      'Philipsburg',
      'Piltzville',
      'Pinesdale',
      'Pioneer Junction',
      'Plentywood',
      'Polaris',
      'Polebridge',
      'Polson',
      'Pompeys Pillar',
      'Pony',
      'Post Creek',
      'Powderville',
      'Power',
      'Pryor',
      'Quietus',
      'Radersburg',
      'Rapelje',
      'Ravalli',
      'Raynesford',
      'Red Lodge',
      'Reed Point',
      'Richey',
      'Ridge',
      'Ringling',
      'Riverbend',
      "Rocky Boy's Agency",
      'Rocky Point',
      'Ronan',
      'Roosville',
      'Ross Fork',
      'Roundup',
      'Ryegate',
      'Saddle Butte',
      'Saint Ignatius',
      'Saint Marie',
      'Saint Regis',
      'Saint Xavier',
      'Saltese',
      'Sand Coulee',
      'Sangrey',
      'Scobey',
      'Seeley Lake',
      'Shawmut',
      'Shonkin',
      'Silver Gate',
      'Silver Star',
      'Simms',
      'Sioux Pass',
      'Sixteen',
      'Snider',
      'Sonnette',
      'South Browning',
      'South Glastonbury',
      'Square Butte',
      'Starr School',
      'Stockett',
      'Stryker',
      'Sula',
      'Sun Prairie',
      'Sun River',
      'Sunburst',
      'Sweet Grass',
      'Sylvanite',
      'Teigen',
      'Thompson Falls',
      'Three Forks',
      'Toston',
      'Trego',
      'Trident',
      'Turah',
      'Turtle Lake',
      'Twin Bridges',
      'Twodot',
      'Vananda',
      'Vaughn',
      'Vida',
      'Virgelle',
      'Virginia City',
      'Volborg',
      'Volt',
      'Washoe',
      'Weeksville',
      'West Glacier',
      'West Glendive',
      'West Havre',
      'West Riverside',
      'West Yellowstone',
      'Westby',
      'White Haven',
      'Whitefish',
      'Whitetail',
      'Whitlash',
      'Wibaux',
      'Wilsall',
      'Winnett',
      'Wisdom',
      'Wise River',
      'Wolf Point',
      'Woods Bay',
      'Wye',
      'Wyola',
      'Yaak',
      'Zortman',
    ],
    'US-NE': [
      'Abie',
      'Alda',
      'Almeria',
      'Alvo',
      'Anselmo',
      'Arabia',
      'Aten',
      'Barada',
      'Barneston',
      'Bartley',
      'Bazile Mills',
      'Beaver City',
      'Beaver Crossing',
      'Beemer',
      'Belmar',
      'Benkelman',
      'Bennet',
      'Bladen',
      'Blair',
      'Boelus',
      'Bow Valley',
      'Boys Town',
      'Bradshaw',
      'Brainard',
      'Broken Bow',
      'Brownson',
      'Brownville',
      'Brule',
      'Bruning',
      'Bucktail',
      'Burwell',
      'Carlson',
      'Ceresco',
      'Chadron',
      'Chappell',
      'Clatonia',
      'Cody',
      'Coleridge',
      'Cornlea',
      'Cotesfield',
      'Cowles',
      'Cozad',
      'Dannebrog',
      'Darr',
      'Davey',
      'David City',
      'Daykin',
      'Deshler',
      'Deweese',
      'Diller',
      'Dodge',
      'Dunbar',
      'Dunning',
      'Eli',
      'Elm Creek',
      'Enders',
      'Endicott',
      'Ericson',
      'Falls City',
      'Farnam',
      'Filley',
      'Flats',
      'Fort Calhoun',
      'Funk',
      'Gering',
      'Gilead',
      'Giltner',
      'Glenvil',
      'Goehner',
      'Gothenburg',
      'Grainton',
      'Gresham',
      'Gross',
      'Guide Rock',
      'Hadar',
      'Haig',
      'Haigler',
      'Hallam',
      'Halsey',
      'Harbine',
      'Hartington',
      'Hay Springs',
      'Hayes Center',
      'Heartwell',
      'Hemingford',
      'Hendley',
      'Hershey',
      'Hildreth',
      'Holdrege',
      'Hordville',
      'Hoskins',
      'Howells',
      'Inavale',
      'Inland',
      'Juniata',
      'Kenesaw',
      'King Lake',
      'Kramer',
      'Kronborg',
      'La Platte',
      'La Vista',
      'Leigh',
      'Lemoyne',
      'Leshara',
      'Lewellen',
      'Lindy',
      'Lisco',
      'Lodgepole',
      'Long Pine',
      'Lorton',
      'Loup City',
      'Lushton',
      'Magnet',
      'Manley',
      'Marsland',
      'Mascot',
      'Maskell',
      'McCool Junction',
      'McGrew',
      'Meadow Grove',
      'Melbeta',
      'Merriman',
      'Milburn',
      'Mills',
      'Minatare',
      'Mintle',
      'Monowi',
      'Morse Bluff',
      'Mullen',
      'Mynard',
      'Naper',
      'Naponee',
      'Nebraska City',
      'Nehawka',
      'Neligh',
      'Nenzel',
      'Newman Grove',
      'Niobrara',
      'North Bend',
      'North Loup',
      'North Platte',
      "O'Neill",
      'Oak',
      'Obert',
      'Oconto',
      'Octavia',
      'Ogallala',
      'Ohiowa',
      'Ong',
      'Ord',
      'Oshkosh',
      'Osmond',
      'Otoe',
      'Overton',
      'Papillion',
      'Pawnee City',
      'Pender',
      'Perrin',
      'Phillips',
      'Pickrell',
      'Pilger',
      'Platte Center',
      'Plattsmouth',
      'Pleasant Dale',
      'Polk',
      'Prague',
      'Prosser',
      'Purdum',
      'Raeville',
      'Ragan',
      'Red Cloud',
      'Redington',
      'Republican City',
      'Rising City',
      'Rulo',
      'Saint Edward',
      'Sarben',
      'Saronville',
      'Schuyler',
      'Scottsbluff',
      'Scribner',
      'Shickley',
      'Sholes',
      'Shubert',
      'South Sioux City',
      'Springview',
      'Staplehurst',
      'Steele City',
      'Steinauer',
      'Stockham',
      'Stockville',
      'Strang',
      'Stromsburg',
      'Swedeburg',
      'Tamora',
      'Tarnov',
      'Tekamah',
      'Thedford',
      'Thurston',
      'Tobias',
      'Touhy',
      'Tryon',
      'Uehling',
      'Venango',
      'Verdel',
      'Verdigre',
      'Verdon',
      'Wahoo',
      'Walthill',
      'Wann',
      'Wausa',
      'Weeping Water',
      'Weissert',
      'Wellfleet',
      'Western',
      'Westerville',
      'Whiteclay',
      'Whitman',
      'Wilber',
      'Wilcox',
      'Willow Island',
      'Winnetoon',
      'Winside',
      'Wolbach',
      'Wymore',
      'Wynot',
      'Yutan',
    ],
    'US-NV': [
      'Acoma',
      'Amargosa Valley',
      'Battle Mountain',
      'Beowawe',
      'Blue Diamond',
      'Boulder City',
      'Bunkerville',
      'Cal-Nev-Ari',
      'Carlin',
      'Carp',
      'Caselton',
      'Cobre',
      'Contact',
      'Copperfield',
      'Cosgrave',
      'Crescent Valley',
      'Crystal Bay',
      'Deeth',
      'Denio',
      'Dry Lake',
      'Dunphy',
      'East Las Vegas',
      'Eastgate',
      'Fernley',
      'Flanigan',
      'Frenchman',
      'Gabbs',
      'Gardnerville',
      'Gardnerville Ranchos',
      'Gerlach',
      'Gold Acres',
      'Gold Point',
      'Goodsprings',
      'Halleck',
      'Harney',
      'Hiko',
      'Imlay',
      'Incline Village',
      'Islen',
      'Jackpot',
      'Jarbidge',
      'Jean',
      'Johnson Lane',
      'Lakeridge',
      'Lane City',
      'Laughlin',
      'Lemmon Valley',
      'Lida',
      'Logandale',
      'Lovelock',
      'Luning',
      'McDermitt',
      'McGill',
      'Mercury',
      'Mesquite',
      'Midas',
      'Mill City',
      'Moapa',
      'Moapa Town',
      'Moapa Valley',
      'Mogul',
      'Mount Charleston',
      'Mount Montgomery',
      'New Washoe City',
      'Nixon',
      'North Las Vegas',
      'Orovada',
      'Osino',
      'Pahrump',
      'Panaca',
      'Parran',
      'Patrick',
      'Patsville',
      'Pequop',
      'Pioche',
      'Pronto',
      'Pyramid',
      'Rachel',
      'Roach',
      'Rowland',
      'Rox',
      'Ruby Valley',
      'Salt Wells',
      'Sand Pass',
      'Sandy Valley',
      'Schurz',
      'Searchlight',
      'Silver Peak',
      'Silver Springs',
      'Skyland',
      'Spanish Springs',
      'Spring Creek',
      'Stagecoach',
      'Stateline',
      'Steptoe',
      'Sunrise Manor',
      'Sutcliffe',
      'Tempiute',
      'Thorne',
      'Tippett',
      'Topaz Lake',
      'Tuscarora',
      'Ursine',
      'Valmy',
      'Vya',
      'Wabuska',
      'Walker Lake',
      'Washoe City',
      'Weed Heights',
      'West Wendover',
      'Winnemucca',
      'Yerington',
      'Zephyr Cove',
    ],
    'US-NH': [
      'Blodgett Landing',
      'Center Ossipee',
      'Center Sandwich',
      'Contoocook',
      'East Merrimack',
      'Epping',
      'Georges Mills',
      'Goffstown',
      'Groveton',
      'Hampton Beach',
      'Henniker',
      'Hooksett',
      'Jaffrey',
      'Londonderry',
      'Loudon',
      'Melvin Village',
      'Milton Mills',
      'Mountain Lakes',
      'Newfields',
      'North Conway',
      'North Haverhill',
      'North Stratford',
      'North Sutton',
      'North Walpole',
      'North Woodstock',
      'Pinardville',
      'Rye Beach',
      'Sanbornville',
      'Seabrook Beach',
      'Somersworth',
      'South Hooksett',
      'Suncook',
      'Twin Mountain',
      'West Stewartstown',
      'West Swanzey',
      'Whitefield',
      'Wolfeboro',
      'Woodsville',
    ],
    'US-NJ': [
      'Absecon',
      'Adelphia',
      'Allamuchy',
      'Allenwood',
      'Alloway',
      'Apshawa',
      'Asbury Park',
      'Atco',
      'Atlantic City',
      'Atlantic Highlands',
      'Atsion',
      'Avon-by-the-Sea',
      'Awosting',
      'Barnegat',
      'Barnegat Light',
      'Barnsboro',
      'Basking Ridge',
      'Bay Head',
      'Beach Glen',
      'Beach Haven',
      'Beach Haven West',
      'Beachwood',
      'Beattystown',
      'Beckett',
      'Bedminster',
      'Beemerville',
      'Belford',
      'Belle Mead',
      'Belleplain',
      'Bellmawr',
      'Bennetts Mills',
      'Bergenfield',
      'Bernardsville',
      'Blackwells Mills',
      'Blawenburg',
      'Bloomsbury',
      'Blue Anchor',
      'Boonton',
      'Bordentown',
      'Bound Brook',
      'Braddock',
      'Bradley Beach',
      'Bradley Gardens',
      'Brainards',
      'Branchburg Park',
      'Brass Castle',
      'Brielle',
      'Brigantine',
      'Broadway',
      'Brooklawn',
      'Browns Mills',
      'Browntown',
      'Brunswick Gardens',
      'Budd Lake',
      'Buddtown',
      'Buena',
      'Burleigh',
      'Buttzville',
      'Califon',
      'Cape May',
      'Cape May Court House',
      'Cape May Point',
      'Carlstadt',
      'Carneys Point',
      'Carteret',
      'Cedar Brook',
      'Cedar Glen Lakes',
      'Cedar Glen West',
      'Cedar Knolls',
      'Cherry Hill Mall',
      'Chesilhurst',
      'Cinnaminson',
      'Clarksboro',
      'Clearbrook Park',
      'Clementon',
      'Cliffside Park',
      'Cliffwood',
      'Cliffwood Beach',
      'Closter',
      'Collings Lakes',
      'Collingswood',
      'Collingwood Park',
      'Colonia',
      'Colts Neck',
      'Corbin City',
      'Country Lake Estates',
      'Cranberry Lake',
      'Cranbury',
      'Crandon Lakes',
      'Cream Ridge',
      'Cresskill',
      'Crestwood Village',
      'Crosswicks',
      'Deal',
      'Deans',
      'Delanco',
      'Demarest',
      'Dennisville',
      'Denville',
      'Diamond Beach',
      'Dover Beaches North',
      'Dover Beaches South',
      'Dunellen',
      'East Freehold',
      'East Hanover',
      'East Millstone',
      'East Newark',
      'East Orange',
      'East Rutherford',
      'East Trenton Heights',
      'Eatontown',
      'Echelon',
      'Edgewater Park',
      'Egg Harbor City',
      'Eldridge Park',
      'Ellisburg',
      'Englewood Cliffs',
      'Englishtown',
      'Erma',
      'Essex Fells',
      'Estell Manor',
      'Etra',
      'Evesboro',
      'Ewan',
      'Ewansville',
      'Fair Lawn',
      'Fairton',
      'Fanwood',
      'Far Hills',
      'Fieldsboro',
      'Finderne',
      'Finesville',
      'Flagtown',
      'Flanders',
      'Florham Park',
      'Fords',
      'Forked River',
      'Fort Dix',
      'Fort Lee',
      'Francis Mills',
      'Franklin Lakes',
      'Franklinville',
      'Freehold',
      'Freewood Acres',
      'Fries Mill',
      'Garwood',
      'Gibbsboro',
      'Gibbstown',
      'Gilford Park',
      'Gillette',
      'Glassboro',
      'Glen Gardner',
      'Glen Rock',
      'Glenside',
      'Gloucester City',
      'Golden Triangle',
      'Golf View',
      'Great Meadows',
      'Green Grove',
      'Green Knoll',
      'Green Pond',
      'Green Village',
      'Greentree',
      'Griggstown',
      'Groveville',
      'Hackettstown',
      'Haddon Heights',
      'Haddonfield',
      'Hainesburg',
      'Hainesport',
      'Haledon',
      'Hamilton Square',
      'Hammonton',
      'Hancocks Bridge',
      'Harlingen',
      'Harrington Park',
      'Harvey Cedars',
      'Hasbrouck Heights',
      'Haworth',
      'Hazlet',
      'Helmetta',
      'Hi-Nella',
      'Hibernia',
      'Highland Lakes',
      'Hightstown',
      'Ho-Ho-Kus',
      'Holiday Heights',
      'Holmdel',
      'Homestead Park',
      'Hopatcong',
      'Hornerstown',
      'Hurdtown',
      'Hurffville',
      'Imlaystown',
      'Independence Corner',
      'Ironia',
      'Iselin',
      'Island Heights',
      'Jacksons Mills',
      'Jersey City',
      'Jobstown',
      'Johnsonburg',
      'Juliustown',
      'Keansburg',
      'Kendall Park',
      'Kenvil',
      'Keyport',
      'Kingston Estates',
      'Kinnelon',
      'Kresson',
      'Lake Como',
      'Lake Hiawatha',
      'Lake Mohawk',
      'Lake Pine',
      'Lake Telemark',
      'Lakehurst',
      'Lamington',
      'Land of Pines',
      'Landing',
      'Laurel Lake',
      'Laurel Springs',
      'Laurence Harbor',
      'Lavallette',
      'Lawnside',
      'Ledgewood',
      'Leisure Knoll',
      'Leisure Village',
      'Leisure Village East',
      'Leisure Village West',
      'Leisuretowne',
      'Leonardo',
      'Liberty Corner',
      'Lincroft',
      'Lindenwold',
      'Little Ferry',
      'Little Silver',
      'Loch Arbour',
      'Locust',
      'Long Branch',
      'Long Valley',
      'Longport',
      'Lower Squankum',
      'Macopin',
      'Madison Park',
      'Mahwah',
      'Manahawkin',
      'Manasquan',
      'Mantoloking',
      'Manville',
      'Maple Shade',
      'Marcella',
      'Margate City',
      'Marksboro',
      'Marlboro',
      'Mays Landing',
      'McAfee',
      'McCoys Corner',
      'Medford Lakes',
      'Mendham',
      'Mercerville',
      'Merchantville',
      'Metuchen',
      'Mickleton',
      'Middlebush',
      'Mill Brook',
      'Millhurst',
      'Mine Hill',
      'Monmouth Beach',
      'Monmouth Junction',
      'Montvale',
      'Montville',
      'Moonachie',
      'Moorestown',
      'Morris Plains',
      'Mount Arlington',
      'Mount Ephraim',
      'Mount Fern',
      'Mount Freedom',
      'Mount Rose',
      'Mountainside',
      'Mullica Hill',
      'Mystic Island',
      'Navesink',
      'Neptune City',
      'Nesco',
      'Neshanic Station',
      'Netcong',
      'New Brunswick',
      'New Egypt',
      'New Vernon',
      'New Village',
      'Newfield',
      'North Arlington',
      'North Beach Haven',
      'North Bergen',
      'North Caldwell',
      'North Cape May',
      'North Haledon',
      'North Plainfield',
      'North Wildwood',
      'Northvale',
      'Oaklyn',
      'Ocean Acres',
      'Ocean Gate',
      'Oceanport',
      'Ogdensburg',
      'Old Bridge',
      'Old Tappan',
      'Oradell',
      'Owens',
      'Palisades Park',
      'Paramus',
      'Parsippany',
      'Paulsboro',
      'Peapack',
      'Pedricktown',
      'Pellettown',
      'Pemberton Heights',
      'Penns Grove',
      'Penns Neck',
      'Pennsville',
      'Pequannock',
      'Perth Amboy',
      'Pine Beach',
      'Pine Brook',
      'Pine Lake Park',
      'Pine Ridge at Crestwood',
      'Pitman',
      'Plainsboro',
      'Plainsboro Center',
      'Pluckemin',
      'Plumbsock',
      'Point Pleasant',
      'Point Pleasant Beach',
      'Pompton Lakes',
      'Pompton Plains',
      'Port Colden',
      'Port Monmouth',
      'Port Murray',
      'Port Norris',
      'Port Reading',
      'Port Republic',
      'Pottersville',
      'Presidential Lakes Estates',
      'Princeton Junction',
      'Princeton Meadows',
      'Prospect Park',
      'Prospect Plains',
      'Quinton',
      'Rahway',
      'Ramblewood',
      'Ramtown',
      'Rancocas',
      'Rancocas Woods',
      'Readington',
      'Red Bank',
      'Red Lion',
      'Repaupo',
      'Ridgefield Park',
      'River Edge',
      'Riverside Park',
      'Robbinsville',
      'Robertsville',
      'Rockaway',
      'Rockleigh',
      'Rocky Hill',
      'Roebling',
      'Roselle Park',
      'Rosenhayn',
      'Ross Corner',
      'Rudeville',
      'Rumson',
      'Runnemede',
      'Saddle River',
      'Sayreville',
      'Scobeyville',
      'Sea Bright',
      'Sea Girt',
      'Sea Isle City',
      'Seabrook Farms',
      'Seaside Heights',
      'Seaside Park',
      'Secaucus',
      'Sewaren',
      'Sewell',
      'Shark River Hills',
      'Ship Bottom',
      'Short Hills',
      'Sicklerville',
      'Silver Ridge',
      'Singac',
      'Skillman',
      'Slackwoods',
      'Smalleytown',
      'Smithburg',
      'Somerdale',
      'Somers Point',
      'South Amboy',
      'South Bound Brook',
      'South Branch',
      'South Plainfield',
      'South Toms River',
      'Southard',
      'Spotswood',
      'Spring Lake Heights',
      'Springside',
      'Star Cross',
      'Stockholm',
      'Stone Harbor',
      'Strathmere',
      'Succasunna',
      'Surf City',
      'Swedesboro',
      'Tabernacle',
      'Tansboro',
      'Tavistock',
      'Taylortown',
      'Ten Mile Run',
      'Tenafly',
      'Tennent',
      'Teterboro',
      'Thorofare',
      'Tinton Falls',
      'Toms River',
      'Totowa',
      'Towaco',
      'Troy Hills',
      'Tuckerton',
      'Turnersville',
      'Twin Rivers',
      'Union Beach',
      'Upper Montclair',
      'Upper Saddle River',
      'Van Hiseville',
      'Ventnor City',
      'Vernon Valley',
      'Victory Gardens',
      'Victory Lakes',
      'Vincentown',
      'Vista Center',
      'Voorhees',
      'Waldwick',
      'Wallington',
      'Wanamassa',
      'Wanaque',
      'Waretown',
      'Watchung',
      'Waterford Works',
      'Weehawken',
      'West Belmar',
      'West Berlin',
      'West Cape May',
      'West Creek',
      'West Freehold',
      'West Long Branch',
      'West New York',
      'West Wildwood',
      'Wharton',
      'Whippany',
      'White Horse',
      'White Meadow Lake',
      'Whitehouse Station',
      'Whitman Square',
      'Wickatunk',
      'Wildwood Crest',
      'Willingboro',
      'Wood-Lynne',
      'Wood-Ridge',
      'Woodbury Heights',
      'Woodcliff Lake',
      'Woodport',
      'Woods Tavern',
      'Woodstown',
      'Yardville',
      'Zarephath',
    ],
    'US-NM': [
      'Abeytas',
      'Abiquiu',
      'Abo',
      'Acomita',
      'Acomita Lake',
      'Adelino',
      'Aden',
      'Agua Fria',
      'Alamogordo',
      'Alcalde',
      'Algodones',
      'Alire',
      'Amistad',
      'Ancho',
      'Angel Fire',
      'Animas',
      'Anton Chico',
      'Apache Creek',
      'Arenas Valley',
      'Armijo',
      'Arrey',
      'Arroyo Hondo',
      'Atoka',
      'Beclabito',
      'Bent',
      'Berino',
      'Bernalillo',
      'Bernardo',
      'Bibo',
      'Black River Village',
      'Blanco',
      'Boles Acres',
      'Bosque Farms',
      'Brazos',
      'Brimhall Nizhoni',
      'Broncho',
      'Bueyeros',
      'Caballo',
      'Cameo',
      'Canjilon',
      'Canova',
      'Capitan',
      'Caprock',
      'Carne',
      'Carnero',
      'Carnuel',
      'Carrizozo',
      'Casa Colorada',
      'Causey',
      'Cañada de los Alamos',
      'Cañon',
      'Cañones',
      'Cebolla',
      'Cedar Crest',
      'Chamberino',
      'Chamisal',
      'Chamita',
      'Chamizal',
      'Chical',
      'Chili',
      'Chilili',
      'Chimayo',
      'Chupadero',
      'Church Rock',
      'Claunch',
      'Cliff',
      'Clines Corners',
      'Cloudcroft',
      'Cochiti',
      'Cochiti Lake',
      'Colmor',
      'Continental Divide',
      'Correo',
      'Costilla',
      'Cotton City',
      'Coyote',
      'Crossroads',
      'Crownpoint',
      'Cruzville',
      'Cubero',
      'Cuervo',
      'Cundiyo',
      'Cuyamungue',
      'Dahlia',
      'Dalies',
      'Datil',
      'Deming',
      'Dilia',
      'Domingo',
      'Doña Ana',
      'Dulce',
      'Dunken',
      'Duran',
      'Eagle Nest',
      'East Pecos',
      'El Duende',
      'El Rito',
      'El Vado',
      'El Valle de Arroyo Seco',
      'Eldorado at Santa Fe',
      'Elephant Butte',
      'Elida',
      'Embudo',
      'Encinal',
      'Endee',
      'Engle',
      'Escabosa',
      'Escondida',
      'Española',
      'Estancia',
      'Fairacres',
      'Fence Lake',
      'Fierro',
      'Flora Vista',
      'Fort Stanton',
      'Fort Sumner',
      'Fort Wingate',
      'French',
      'Gage',
      'Gallina',
      'Gallinas',
      'Gallup',
      'Gamerco',
      'Gascon',
      'Gila',
      'Gladiola',
      'Glorieta',
      'Grama',
      'Gran Quivira',
      'Grande',
      'Grants',
      'Grenville',
      'Guadalupita',
      'Hachita',
      'Hernandez',
      'High Rolls',
      'Hobbs',
      'Holman',
      'Hondo',
      'Hot Springs Landing',
      'House',
      'Humble City',
      'Isleta',
      'Jaconita',
      'Jal',
      'Jarales',
      'Jemez Pueblo',
      'Jemez Springs',
      'Joffre',
      'Kenna',
      'Kirtland',
      'Koehler',
      'Krider',
      'La Cienega',
      'La Cueva',
      'La Joya',
      'La Luz',
      'La Madera',
      'La Mesilla',
      'La Puebla',
      'La Villita',
      'Lake Sumner',
      'Lake Valley',
      'Lamy',
      'Las Maravillas',
      'Las Nutrias',
      'Las Palomas',
      'Lee Acres',
      'Lemitar',
      'Levy',
      'Llano Del Medio',
      'Loco Hills',
      'Lordsburg',
      'Los Chavez',
      'Los Luceros',
      'Los Lunas',
      'Los Ojos',
      'Los Padillas',
      'Los Pinos',
      'Los Ranchos de Albuquerque',
      'Los Trujillos',
      'Loving',
      'Lucero',
      'Lucy',
      'Luis Lopez',
      'Lyden',
      'Madrone',
      'Maljamar',
      'Manuelito',
      'Manzano Springs',
      'Mayhill',
      'Maypens',
      'McAlister',
      'McCartys',
      'Meadow Lake',
      'Medanales',
      'Mentmore',
      'Mescalero',
      'Mesilla',
      'Milnesand',
      'Mimbres',
      'Monero',
      'Montoya',
      'Moquino',
      'Mosquero',
      'Mountainair',
      'Mule Creek',
      'Nadine',
      'Nageezi',
      'Nakaibito',
      'Nambe',
      'Nara Visa',
      'Naschitti',
      'Navajo',
      'Navajo Dam',
      'Negra',
      'Nenahnezad',
      'New Laguna',
      'Newcomb',
      'Newkirk',
      'Nogal',
      'North Acomita Village',
      'North Hurley',
      'North San Ysidro',
      'North Valley',
      'Nutt',
      'Obar',
      'Ocate',
      'Ojo Amarillo',
      'Ojo Caliente',
      'Ojo Feliz',
      'Ojo Sarco',
      'Onava',
      'Optimo',
      'Organ',
      'Orogrande',
      'Oscura',
      'Paguate',
      'Paradise Hills',
      'Paraje',
      'Pastura',
      'Pecos',
      'Pedernal',
      'Pep',
      'Peña Blanca',
      'Peñasco',
      'Picuris Pueblo',
      'Pie Town',
      'Pinehill',
      'Pinos Altos',
      'Piñon',
      'Placitas',
      'Pojoaque',
      'Polvadera',
      'Ponderosa Pine',
      'Portales',
      'Prewitt',
      'Pueblito',
      'Pueblitos',
      'Pueblo Pintado',
      'Pueblo of Sandia Village',
      'Puerto De Luna',
      'Quemado',
      'Questa',
      'Radium Springs',
      'Ramon',
      'Ranchito',
      'Ranchos de Taos',
      'Raton',
      'Red River',
      'Redrock',
      'Regina',
      'Rehoboth',
      'Rio Communities',
      'Rio En Medio',
      'Rio Lucio',
      'Rio Rancho',
      'Rodarte',
      'Rodey',
      'Romeroville',
      'Rowe',
      'Royce',
      'Ruidoso',
      'Ruidoso Downs',
      'Rutheron',
      'Sabinal',
      'Sabinoso',
      'San Acacia',
      'San Antonito',
      'San Felipe Pueblo',
      'San Fidel',
      'San Ildefonso Pueblo',
      'San Jon',
      'San Juan Pueblo',
      'San Marcial',
      'San Ysidro',
      'Sandia Heights',
      'Sandia Knolls',
      'Sandia Park',
      'Sanostee',
      'Santa Ana Pueblo',
      'Santa Clara Pueblo',
      'Santo Domingo Pueblo',
      'Sapello',
      'Scholle',
      'Seama',
      'Seboyeta',
      'Sedillo',
      'Sena',
      'Separ',
      'Serafina',
      'Sheep Springs',
      'Shiprock',
      'Silio',
      'Sofia',
      'Soham',
      'Sombrillo',
      'South Garcia',
      'South Valley',
      'Springer',
      'Strauss',
      'Sunland Park',
      'Taiban',
      'Tajique',
      'Talpa',
      'Taos Pueblo',
      'Taos Ski Valley',
      'Tatum',
      'Tecolote',
      'Tecolotito',
      'Tererro',
      'Tesuque',
      'Tesuque Pueblo',
      'Texico',
      'Thoreau',
      'Tijeras',
      'Timberon',
      'Tocito',
      'Tohatchi',
      'Tolar',
      'Torreon',
      'Trementina',
      'Tres Piedras',
      'Truchas',
      'Truth or Consequences',
      'Tse Bonito',
      'Tucumcari',
      'Tularosa',
      'Turley',
      'Upham',
      'Upper Fruitland',
      'Ute Park',
      'Vadito',
      'Vado',
      'Valmora',
      'Veguita',
      'Velarde',
      'Wagon Mound',
      'Waterflow',
      'Watrous',
      'Weber City',
      'White Signal',
      'Whites City',
      'Wilna',
      'Windmill',
      'Yah-ta-hey',
      'Yates',
      'Yeso',
      'Zia Pueblo',
      'Zuni Pueblo',
    ],
    'US-NY': [
      'Acra',
      'Adams Center',
      'Airmont',
      'Albertson',
      'Alder Creek',
      'Alexandria Bay',
      'Allegany',
      'Altmar',
      'Amagansett',
      'Amawalk',
      'Amenia',
      'Amityville',
      'Angelica',
      'Angola on the Lake',
      'Annsville',
      'Antwerp',
      'Apalachin',
      'Aquebogue',
      'Archville',
      'Ardsley',
      'Arkport',
      'Armonk',
      'Armor',
      'Asharoken',
      'Athol Springs',
      'Au Sable Forks',
      'Averill Park',
      'Babylon',
      'Baiting Hollow',
      'Baldwin Harbor',
      'Baldwinsville',
      'Ballston Spa',
      'Balmville',
      'Bardonia',
      'Barker',
      'Barneveld',
      'Barnum Island',
      'Barryville',
      'Baxter Estates',
      'Bay Park',
      'Bay Wood',
      'Bayville',
      'Beach Ridge',
      'Beaver Dam Lake',
      'Bedford Center',
      'Bedford Hills',
      'Bellerose',
      'Bellerose Terrace',
      'Bellmore',
      'Bellport',
      'Bellvale',
      'Bemus Point',
      'Bennetts Corners',
      'Bergholtz',
      'Bethpage',
      'Big Flats',
      'Big Moose',
      'Big Tree',
      'Billington Heights',
      'Binghamton',
      'Blairville',
      'Blasdell',
      'Blauvelt',
      'Blodgett Mills',
      'Bloomingburg',
      'Bloomville',
      'Blue Point',
      'Bohemia',
      'Bolton Landing',
      'Bowmansville',
      'Branchport',
      'Brandreth',
      'Brasher Falls',
      'Breesport',
      'Brewerton',
      'Brewster Hill',
      'Briarcliff Manor',
      'Bridgehampton',
      'Brier Hill',
      'Brightwaters',
      'Brinckerhoff',
      'Broadalbin',
      'Brockport',
      'Bronx',
      'Bronxville',
      'Brushton',
      'Busti',
      'Byersville',
      'Calcium',
      'Callicoon',
      'Cambria Center',
      'Camillus',
      'Canajoharie',
      'Canandaigua',
      'Canaseraga',
      'Canastota',
      'Candor',
      'Canisteo',
      'Cape Vincent',
      'Carle Place',
      'Carlisle Gardens',
      'Caroga Lake',
      'Castile',
      'Castleton-on-Hudson',
      'Castorland',
      'Catskill',
      'Cattaraugus',
      'Cayuga Heights',
      'Cazenovia',
      'Celoron',
      'Center Moriches',
      'Centereach',
      'Centerport',
      'Central Bridge',
      'Central Islip',
      'Central Square',
      'Central Valley',
      'Centre Island',
      'Chadwicks',
      'Chappaqua',
      'Chateaugay',
      'Chazy',
      'Cheektowaga',
      'Chenango Bridge',
      'Cherryplain',
      'Chestnut Ridge',
      'Chittenango',
      'Clarence Center',
      'Clark Mills',
      'Clayville',
      'Clifton Springs',
      'Clintondale',
      'Clover Bank',
      'Cobleskill',
      'Cohocton',
      'Cohoes',
      'Cold Brook',
      'Cold Spring Harbor',
      'Colonial Village',
      'Colonie',
      'Commack',
      'Congers',
      'Constableville',
      'Constantia',
      'Coopers Plains',
      'Cooperstown',
      'Copake Falls',
      'Copake Lake',
      'Copenhagen',
      'Copiague',
      'Corfu',
      'Cornwall-on-Hudson',
      'Country Knolls',
      'Cove Neck',
      'Coxsackie',
      'Cragsmoor',
      'Croghan',
      'Crompond',
      'Croton Heights',
      'Croton-on-Hudson',
      'Crotonville',
      'Crown Heights',
      'Crugers',
      'Cumberland Head',
      'Cumminsville',
      'Cutchogue',
      'Cuylerville',
      'Dannemora',
      'Davenport Center',
      'De Kalb Junction',
      'De Lancey',
      'DeRuyter',
      'Deferiet',
      'Delanson',
      'Delevan',
      'Depauville',
      'Depew',
      'Deposit',
      'Dering Harbor',
      'Dix Hills',
      'Dobbs Ferry',
      'Dolgeville',
      'Dover Plains',
      'Duane Lake',
      'Duanesburg',
      'Durhamville',
      'Eagle Valley',
      'East Atlantic Beach',
      'East Aurora',
      'East Avon',
      'East Branch',
      'East Farmingdale',
      'East Garden City',
      'East Glenville',
      'East Greenbush',
      'East Hills',
      'East Islip',
      'East Ithaca',
      'East Kingston',
      'East Marion',
      'East Massapequa',
      'East Meadow',
      'East Middletown',
      'East Moriches',
      'East Nassau',
      'East Northport',
      'East Norwich',
      'East Patchogue',
      'East Quogue',
      'East Randolph',
      'East Rochester',
      'East Rockaway',
      'East Setauket',
      'East Shoreham',
      'East Syracuse',
      'East White Plains',
      'East Williston',
      'East Wilson',
      'Eastchester',
      'Eatons Neck',
      'Edenville',
      'Edmeston',
      'Eggertsville',
      'Elbridge',
      'Ellenburg Depot',
      'Ellenville',
      'Ellicottville',
      'Elma Center',
      'Elmira Heights',
      'Elmsford',
      'Endwell',
      'Evans Mills',
      'Fabius',
      'Falconer',
      'Farmingville',
      'Felts Mills',
      'Fire Island',
      'Firthcliffe',
      'Fishers Island',
      'Fishers Landing',
      'Fishkill',
      'Fleischmanns',
      'Floral Park',
      'Flower Hill',
      'Fort Ann',
      'Fort Edward',
      'Fort Johnson',
      'Fort Montgomery',
      'Fort Plain',
      'Fort Salonga',
      'Franklin Square',
      'Freedom Plains',
      'Freeville',
      'Frewsburg',
      'Fultonville',
      'Furnace Woods',
      'Galeville',
      'Galway',
      'Gang Mills',
      'Gansevoort',
      'Garden City Park',
      'Garden City South',
      'Gardnertown',
      'Gasport',
      'Gates Center',
      'Getzville',
      'Glen Aubrey',
      'Glen Cove',
      'Glen Head',
      'Glen Park',
      'Glenfield',
      'Glens Falls',
      'Glenwood Landing',
      'Gloversville',
      'Goldens Bridge',
      'Gordon Heights',
      'Gouverneur',
      'Gowanda',
      'Grand View-on-Hudson',
      'Grandyle Village',
      'Granite Springs',
      'Great Neck',
      'Great Neck Estates',
      'Great Neck Gardens',
      'Great Neck Plaza',
      'Great River',
      'Greece',
      'Greenlawn',
      'Greenport',
      'Greenwood Lake',
      'Greigsville',
      'Griffins Mills',
      'Hagaman',
      'Hailesboro',
      'Halesite',
      'Hammondsport',
      'Hampton Bays',
      'Hampton Manor',
      'Hannawa Falls',
      'Harbor Hills',
      'Harbor Isle',
      'Harriman',
      'Harris Hill',
      'Harrison Grove',
      'Hartsdale',
      'Hastings-on-Hudson',
      'Hauppauge',
      'Haverstraw',
      'Head of the Harbor',
      'Hempstead',
      'Heritage Hills',
      'Hermon',
      'Herricks',
      'Herrings',
      'Heuvelton',
      'Hewlett',
      'Hewlett Bay Park',
      'Hewlett Harbor',
      'Hewlett Neck',
      'Hicksville',
      'High Falls',
      'Highland Falls',
      'Hillburn',
      'Hillside Lake',
      'Hillside Manor',
      'Hogansburg',
      'Holland Patent',
      'Holtsville',
      'Honeoye',
      'Honeoye Falls',
      'Hoosick Falls',
      'Hopewell Junction',
      'Hornell',
      'Horseheads',
      'Hortonville',
      'Hudson Falls',
      'Hunt',
      'Huntington Bay',
      'Huntington Station',
      'Hyde Park',
      'Ilion',
      'Irondequoit',
      'Islandia',
      'Islip',
      'Islip Terrace',
      'Jamesville',
      'Jefferson Heights',
      'Jefferson Valley',
      'Jewettville',
      'Johnson City',
      'Jones Point',
      'Kaser',
      'Katonah',
      'Keeseville',
      'Kenmore',
      'Kerhonkson',
      'Keuka',
      'Keuka Park',
      'Kings Park',
      'Kiryas Joel',
      'Kysorville',
      'La Fargeville',
      'Lackawanna',
      'Ladentown',
      'Lake Carmel',
      'Lake Clear',
      'Lake Erie Beach',
      'Lake Grove',
      'Lake Katrine',
      'Lake Luzerne',
      'Lake Mohegan',
      'Lake Ronkonkoma',
      'Lake Success',
      'Larchmont',
      'Lattingtown',
      'Laurel Hollow',
      'Leonardsville',
      'Levittown',
      'Lido Beach',
      'Lime Lake',
      'Lincolndale',
      'Livingston Manor',
      'Livonia Center',
      'Lloyd Harbor',
      'Loch Sheldrake',
      'Locust Valley',
      'Lonelyville',
      'Loon Lake',
      'Lorenz Park',
      'Loudonville',
      'Lowville',
      'Ludlowville',
      'Lynbrook',
      'Lyncourt',
      'Lyndonville',
      'Lyon Mountain',
      'Lyons Falls',
      'Mahopac',
      'Malden-on-Hudson',
      'Malverne',
      'Malverne Park Oaks',
      'Mamaroneck',
      'Manhasset',
      'Manhasset Hills',
      'Manorhaven',
      'Manorville',
      'Margaretville',
      'Mariaville Lake',
      'Massapequa',
      'Massapequa Park',
      'Mastic',
      'Mastic Beach',
      'Matinecock',
      'Mattituck',
      'Mattydale',
      'Maybrook',
      'McGraw',
      'Mechanicstown',
      'Mechanicville',
      'Menands',
      'Merrick',
      'Middle Island',
      'Middleburgh',
      'Middleport',
      'Mill Neck',
      'Miller Place',
      'Minetto',
      'Mineville',
      'Minoa',
      'Model City',
      'Molyneaux Corners',
      'Monsey',
      'Montauk',
      'Montour Falls',
      'Mooers',
      'Moriches',
      'Mount Ivy',
      'Mount Kisco',
      'Mount Sinai',
      'Mount Upton',
      'Mountain Lodge Park',
      'Munnsville',
      'Munsey Park',
      'Munsons Corners',
      'Muttontown',
      'Myers Corner',
      'Nanuet',
      'Napanoch',
      'Napeague',
      'Narrowsburg',
      'Nassau Shores',
      'Nedrow',
      'Nelliston',
      'Nelsonville',
      'Nesconset',
      'New Cassel',
      'New City',
      'New Hempstead',
      'New Hyde Park',
      'New Paltz',
      'New Rochelle',
      'New Square',
      'New Suffolk',
      'New Woodstock',
      'New York',
      'Newark Valley',
      'Newfane',
      'Newton Falls',
      'Nicholville',
      'Niskayuna',
      'Nissequogue',
      'North Amityville',
      'North Babylon',
      'North Bay Shore',
      'North Bellmore',
      'North Bellport',
      'North Boston',
      'North Chili',
      'North Collins',
      'North Creek',
      'North Evans',
      'North Gates',
      'North Great River',
      'North Hills',
      'North Hornell',
      'North Lindenhurst',
      'North Lynbrook',
      'North Massapequa',
      'North Merrick',
      'North New Hyde Park',
      'North Patchogue',
      'North Ridge',
      'North Rose',
      'North Sea',
      'North Syracuse',
      'North Tonawanda',
      'North Valley Stream',
      'North Wantagh',
      'North White Plains',
      'Northwest Harbor',
      'Noyack',
      'Nunda',
      'Nyack',
      'Oak Beach',
      'Olcott',
      'Old Bethpage',
      'Old Brookville',
      'Old Field',
      'Old Forge',
      'Old Westbury',
      'Oneida Castle',
      'Orangeburg',
      'Orchard Park',
      'Oriskany',
      'Oriskany Falls',
      'Ossining',
      'Otego',
      'Owego',
      'Oyster Bay',
      'Oyster Bay Cove',
      'Painted Post',
      'Palatine Bridge',
      'Palenville',
      'Pamelia Center',
      'Parc',
      'Parish',
      'Parishville',
      'Patchogue',
      'Paul Smiths',
      'Pavilion',
      'Pawling',
      'Peach Lake',
      'Peekskill',
      'Pelham Manor',
      'Pendleton Center',
      'Penn Yan',
      'Perrysburg',
      'Philmont',
      'Phoenicia',
      'Piermont',
      'Pierrepont Manor',
      'Piffard',
      'Pine Aire',
      'Pine Bush',
      'Pine Plains',
      'Pittsford',
      'Plainedge',
      'Plandome',
      'Plandome Heights',
      'Plandome Manor',
      'Plattekill',
      'Plattsburgh',
      'Plessis',
      'Poestenkill',
      'Point Lookout',
      'Poland',
      'Pomona Heights',
      'Pond Eddy',
      'Poquott',
      'Port Chester',
      'Port Dickinson',
      'Port Ewen',
      'Port Henry',
      'Port Jefferson',
      'Port Jefferson Station',
      'Port Jervis',
      'Port Kent',
      'Port Leyden',
      'Port Washington',
      'Port Washington North',
      'Porter Center',
      'Portville',
      'Poughkeepsie',
      'Prattsburgh',
      'Pultneyville',
      'Purchase',
      'Putnam Lake',
      'Quiogue',
      'Quogue',
      'Ransomville',
      'Rapids',
      'Raquette Lake',
      'Red Creek',
      'Red Hook',
      'Red Mills',
      'Red Oaks Mill',
      'Redford',
      'Remsenburg',
      'Rensselaer Falls',
      'Retsof',
      'Rhinebeck',
      'Rhinecliff',
      'Richburg',
      'Richfield Springs',
      'Richmondville',
      'Rifton',
      'Rockville Centre',
      'Roe Park',
      'Roessleville',
      'Ronkonkoma',
      'Roosevelt Beach',
      'Roslyn',
      'Roslyn Estates',
      'Roslyn Harbor',
      'Roslyn Heights',
      'Rotterdam',
      'Rouses Point',
      'Russell Gardens',
      'Rye Brook',
      'Sabattis',
      'Sackets Harbor',
      'Saddle Rock',
      'Saddle Rock Estates',
      'Sag Harbor',
      'Sagaponack',
      'Saint Bonaventure',
      'Saint Johnsburg',
      'Saint Johnsville',
      'Saint Regis Falls',
      'Salisbury Mills',
      'Salt Point',
      'Saltaire',
      'Sand Ridge',
      'Sands Point',
      'Saranac Lake',
      'Saratoga Springs',
      'Saugerties',
      'Sauquoit',
      'Sayville',
      'Schaghticoke',
      'Schenectady',
      'Schenevus',
      'Schoharie',
      'Schroon Lake',
      'Schuyler Lake',
      'Schuylerville',
      'Scio',
      'Scotts Corners',
      'Sea Cliff',
      'Searingtown',
      'Seneca Falls',
      'Seneca Knolls',
      'Setauket',
      'Shelter Island',
      'Shelter Island Heights',
      'Shenorock',
      'Shinnecock Hills',
      'Shokan',
      'Shortsville',
      'Shrub Oak',
      'Sidney Center',
      'Sinclairville',
      'Skaneateles',
      'Slaterville Springs',
      'Sloatsburg',
      'Smallwood',
      'Smithville Flats',
      'Sodus',
      'Sodus Point',
      'Solvay',
      'Sound Beach',
      'South Blooming Grove',
      'South Colton',
      'South Corning',
      'South Dayton',
      'South Fallsburg',
      'South Farmingdale',
      'South Floral Park',
      'South Glens Falls',
      'South Hempstead',
      'South Hill',
      'South Huntington',
      'South Lima',
      'South Lockport',
      'South New Berlin',
      'South Nyack',
      'South Otselic',
      'South Salem',
      'South Valley Stream',
      'South Wilson',
      'Southfields',
      'Southold',
      'Spackenkill',
      'Sparkill',
      'Speculator',
      'Spencerport',
      'Speonk',
      'Spring Brook',
      'Springs',
      'Staatsburg',
      'Stannards',
      'Star Lake',
      'Staten Island',
      'Stella Niagara',
      'Sterling Forest',
      'Stewart Manor',
      'Stone Ridge',
      'Stony Brook',
      'Stottville',
      'Strykersville',
      'Suffern',
      'Sunset Bay',
      'Swormville',
      'Sylvan Beach',
      'Syosset',
      'Taconic Shores',
      'Tahawus',
      'Tallman',
      'Tannersville',
      'Tappan',
      'The Glen',
      'Thendara',
      'Theresa',
      'Thiells',
      'Thornwood',
      'Thousand Island Park',
      'Three Mile Bay',
      'Ticonderoga',
      'Tillson',
      'Tomkins Cove',
      'Tonawanda',
      'Towers Corners',
      'Town Line',
      'Tribes Hill',
      'Trumansburg',
      'Tuckahoe',
      'Tupper Lake',
      'Tuxedo Park',
      'Twin Lakes Village',
      'University Gardens',
      'Upper Brookville',
      'Upper Nyack',
      'Vails Gate',
      'Valatie',
      'Valhalla',
      'Valley Cottage',
      'Valley Stream',
      'Van Cortlandtville',
      'Van Etten',
      'Verplanck',
      'Vestal Center',
      'Victory Mills',
      'Village Green',
      'Village of the Branch',
      'Voorheesville',
      'Waccabuc',
      'Waddington',
      'Wading River',
      'Wainscott',
      'Walker Valley',
      'Wallkill',
      'Walton Park',
      'Wampsville',
      'Wanakah',
      'Wantagh',
      'Wappingers Falls',
      'Warrens Corners',
      'Washington Heights',
      'Washington Mills',
      'Washingtonville',
      'Watchtower',
      'Water Mill',
      'Watkins Glen',
      'Websters Corners',
      'Websters Crossing',
      'Weedsport',
      'Wendelville',
      'Wesley Hills',
      'West Babylon',
      'West Bay Shore',
      'West Carthage',
      'West Chazy',
      'West Elmira',
      'West End',
      'West Falls',
      'West Gilgo Beach',
      'West Glens Falls',
      'West Hampton Dunes',
      'West Haverstraw',
      'West Hempstead',
      'West Hills',
      'West Hurley',
      'West Islip',
      'West Nyack',
      'West Sand Lake',
      'West Sayville',
      'West Seneca',
      'West Valley',
      'West Winfield',
      'Westhampton',
      'Westhampton Beach',
      'Westmere',
      'Weston Mills',
      'Westvale',
      'Wheatley Heights',
      'Whitney Point',
      'Williston Park',
      'Willsboro',
      'Willsboro Point',
      'Witherbee',
      'Woodsburgh',
      'Wrights Corners',
      'Wurtsboro',
      'Wyandanch',
      'Wynantskill',
      'Yaphank',
      'Yonkers',
      'Yorkshire',
      'Yorktown Heights',
      'Zena',
    ],
    'US-NC': [
      'Abbottsburg',
      'Addie',
      'Ahoskie',
      'Alamance',
      'Alarka',
      'Albemarle',
      'Alexander Mills',
      'Altamahaw',
      'Angier',
      'Ansonville',
      'Apex',
      'Aquadale',
      'Archer Lodge',
      'Asheboro',
      'Asheville',
      'Ashley Heights',
      'Askewville',
      'Aulander',
      'Autryville',
      'Avery Creek',
      'Ayden',
      'Badin',
      'Bahama',
      'Bald Head Island',
      'Balfour',
      'Balsam',
      'Banner Elk',
      'Bannertown',
      'Barco',
      'Barker Heights',
      'Barker Ten Mile',
      'Battleboro',
      'Bayboro',
      'Bear Grass',
      'Beech Mountain',
      'Belhaven',
      'Bell Arthur',
      'Belville',
      'Belvoir',
      'Belwood',
      'Bent Creek',
      'Bermuda Run',
      'Bessemer City',
      'Bethania',
      'Beulaville',
      'Biltmore Forest',
      'Black Creek',
      'Black Mountain',
      'Bladenboro',
      'Blowing Rock',
      'Boardman',
      'Boger City',
      'Boiling Spring Lakes',
      'Boiling Springs',
      'Bonlee',
      'Bonnetsville',
      'Bonnie Doone',
      'Bostic',
      'Bowmore',
      'Brasstown',
      'Brevard',
      'Brices Creek',
      'Brightwood',
      'Broad Creek',
      'Brogden',
      'Brookford',
      'Bryson City',
      'Buie',
      'Buies Creek',
      'Buladean',
      'Bunnlevel',
      'Burgaw',
      'Butner',
      'Butters',
      'Cajahs Mountain',
      'Calabash',
      'Calypso',
      'Cape Carteret',
      'Caroleen',
      'Carolina Beach',
      'Carolina Shores',
      'Carrboro',
      'Casar',
      'Cashiers',
      'Castle Hayne',
      'Caswell Beach',
      'Catawba',
      'Cedar Mountain',
      'Cedar Rock',
      'Celo',
      'Chadbourn',
      'China Grove',
      'Chinquapin',
      'Chocowinity',
      'Clemmons',
      'Cliffside',
      'Cofield',
      'Coinjock',
      'Colerain',
      'Collettsville',
      'Conetoe',
      'Connelly Springs',
      'Conover',
      'Cooleemee',
      'Cornelius',
      'Corolla',
      'Cove City',
      'Cove Creek',
      'Cramerton',
      'Creedmoor',
      'Cricket',
      'Crossnore',
      'Crouse',
      'Crowders',
      'Cruso',
      'Culberson',
      'Cullowhee',
      'Currituck',
      'Davidson',
      'Deep Gap',
      'Delco',
      'Dellview',
      'Delway',
      'Derita',
      'Dobbins Heights',
      'Dobson',
      'Dortches',
      'Duck',
      'Dundarrach',
      'Earl',
      'East Arcadia',
      'East Bend',
      'East Flat Rock',
      'East Laurinburg',
      'East Rockingham',
      'East Spencer',
      'Eastover',
      'Edenton',
      'Edneyville',
      'Efland',
      'Elizabeth City',
      'Elk Park',
      'Elkin',
      'Ellenboro',
      'Ellerbe',
      'Elm City',
      'Elon',
      'Elroy',
      'Emerald Isle',
      'Engelhard',
      'Enka',
      'Enochville',
      'Enon',
      'Ernul',
      'Erwin',
      'Everetts',
      'Fair Bluff',
      'Fairfield Harbour',
      'Fairplains',
      'Faison',
      'Falkland',
      'Farmville',
      'Fearrington Village',
      'Fontana Village',
      'Forest Oaks',
      'Fort Barnwell',
      'Foscoe',
      'Four Oaks',
      'Foxfire',
      'Fuquay-Varina',
      'Gamewell',
      'Garysburg',
      'Gastonia',
      'Gates',
      'Germanton',
      'Gerton',
      'Gibsonville',
      'Glen Alpine',
      'Glen Raven',
      'Glendale Springs',
      'Godwin',
      'Goldston',
      'Grandfather',
      'Granite Quarry',
      'Grantsboro',
      'Green Level',
      'Greenevers',
      'Grifton',
      'Grimesland',
      'Gulf',
      'Half Moon',
      'Hallsboro',
      'Harkers Island',
      'Harrells',
      'Harrellsville',
      'Hassell',
      'Hatteras',
      'Haw River',
      'Haywood',
      'Hemby Bridge',
      'Hendersonville',
      'Hertford',
      'Hickory Grove',
      'Hiddenite',
      'High Rock',
      'High Shoals',
      'Hightsville',
      'Hildebran',
      'Hiwassee',
      'Hobgood',
      'Hobucken',
      'Holden Beach',
      'Holly Ridge',
      'Hookerton',
      'Hoopers Creek',
      'Hope Mills',
      'Horse Shoe',
      'Huntersville',
      'Hurdle Mills',
      'Icard',
      'Indian Beach',
      'Indian Trail',
      'Ingold',
      'Iron Station',
      'Jaars',
      'James City',
      'Jarvisburg',
      'Kannapolis',
      'Kelford',
      'Kenly',
      'Kernersville',
      'Kill Devil Hills',
      'Kings Grant',
      'Kings Mountain',
      'Kittrell',
      'Kitty Hawk',
      'Knightdale',
      'Knotts Island',
      'Kure Beach',
      'Laboratory',
      'Lake Junaluska',
      'Lake Lure',
      'Lake Santeetlah',
      'Lake Toxaway',
      'Lake Waccamaw',
      'Lasker',
      'Lattimore',
      'Lauada',
      'Laurel Park',
      'Laurinburg',
      'Laxon',
      'Lenoir',
      'Lewiston Woodville',
      'Light Oak',
      'Lilesville',
      'Lillington',
      'Linville',
      'Longhurst',
      'Love Valley',
      'Lowesville',
      'Lowgap',
      'Lowland',
      'Lucama',
      'Luck',
      'Lumber Bridge',
      'Mackeys',
      'Maggie Valley',
      'Maiden',
      'Mamers',
      'Manns Harbor',
      'Manteo',
      'Mar-Mac',
      'Marshallberg',
      'Marshville',
      'Marvin',
      'Maury',
      'Maxton',
      'Mayodan',
      'McAdenville',
      'McFarlan',
      'McGrady',
      'McLeansville',
      'Mebane',
      'Merrimon',
      'Mesic',
      'Micaville',
      'Micro',
      'Midway Park',
      'Millingport',
      'Mills River',
      'Minnesott Beach',
      'Mint Hill',
      'Misenheimer',
      'Mocksville',
      'Momeyer',
      'Moncure',
      'Montreat',
      'Mooresboro',
      'Moravian Falls',
      'Morehead City',
      'Mount Gilead',
      'Moyock',
      'Murraysville',
      'Nags Head',
      'Navassa',
      'Neuse',
      'Neuse Forest',
      'New Bern',
      'Newland',
      'Newton Grove',
      'Norlina',
      'North Topsail Beach',
      'North Wilkesboro',
      'Northlakes',
      'Northwest',
      'Oak City',
      'Oak Island',
      'Oakboro',
      'Ocean Isle Beach',
      'Ocracoke',
      'Old Fort',
      'Old Hundred',
      'Orrum',
      'Ossipee',
      'Pamlico Beach',
      'Pantego',
      'Parkton',
      'Parmele',
      'Patetown',
      'Patterson Springs',
      'Paw Creek',
      'Peletier',
      'Pilot Mountain',
      'Pine Hall',
      'Pine Knoll Shores',
      'Pinebluff',
      'Pinetops',
      'Pinetown',
      'Piney Green',
      'Pink Hill',
      'Pisgah Forest',
      'Plain View',
      'Pleasant Garden',
      'Point Harbor',
      'Polkton',
      'Pollocksville',
      'Poplar Branch',
      'Potters Hill',
      'Powellsville',
      'Proctorville',
      'Pumpkin Center',
      'Raeford',
      'Raemon',
      'Ramseur',
      'Randleman',
      'Ranlo',
      'Raynham',
      'Red Cross',
      'Red Springs',
      'Rennert',
      'Rhodhiss',
      'Rich Square',
      'Richlands',
      'Riegelwood',
      'River Road',
      'Roanoke Rapids',
      'Roaring Gap',
      'Robersonville',
      'Roberta Mill',
      'Rockfish',
      'Rodanthe',
      'Rolesville',
      'Roseboro',
      'Rosman',
      'Rougemont',
      'Roxboro',
      'Roxobel',
      'Royal Pines',
      'Ruffin',
      'Rural Hall',
      'Rutherford College',
      'Rutherfordton',
      'Saint Pauls',
      'Salemburg',
      'Salter Path',
      'Saluda',
      'Salvo',
      'Sandy Ridge',
      'Sandyfield',
      'Sawmills',
      'Saxapahaw',
      'Scaly Mountain',
      'Scotland Neck',
      'Sea Breeze',
      'Seagrove',
      'Sealevel',
      'Sedgefield',
      'Seven Devils',
      'Seven Lakes',
      'Seven Springs',
      'Shallotte',
      'Shawboro',
      'Siler City',
      'Skippers Corner',
      'Sneads Ferry',
      'Sophia',
      'South Gastonia',
      'South Henderson',
      'South Mills',
      'South Rosemary',
      'South Wadesboro',
      'South Weldon',
      'Southern Pines',
      'Southern Shores',
      'Southmont',
      'Spear',
      'Spencer Mountain',
      'Spindale',
      'Spiveys Corner',
      'Spring Hope',
      'Staley',
      'Stanleyville',
      'Stantonsburg',
      'State Road',
      'Statesville',
      'Stedman',
      'Stem',
      'Stokes',
      'Stokesdale',
      'Stoneville',
      'Stumpy Point',
      'Sugar Mountain',
      'Swannanoa',
      'Swanquarter',
      'Swansboro',
      'Swepsonville',
      'Sylva',
      'Tabor City',
      'Tar Heel',
      'Teachey',
      'Timberlake',
      'Toast',
      'Tobaccoville',
      'Topsail Beach',
      'Topton',
      'Tramway',
      'Trent Woods',
      'Troutman',
      'Tuxedo',
      'Valdese',
      'Valle Crucis',
      'Valley Hill',
      'Vanceboro',
      'Vandemere',
      'Vander',
      'Vann Crossroads',
      'Varnamtown',
      'Vass',
      'Wadesboro',
      'Wagram',
      'Wake Forest',
      'Walkertown',
      'Wallburg',
      'Walnut Cove',
      'Wanchese',
      'Warrensville',
      'Watha',
      'Waves',
      'Waxhaw',
      'Weddington',
      'West Canton',
      'West Marion',
      'West Smithfield',
      'Whitakers',
      'White Lake',
      'Whitnel',
      'Whitsett',
      'Wilkesboro',
      'Winfall',
      'Winnabow',
      'Winston-Salem',
      'Wise',
      'Woodfin',
      'Woodleaf',
      'Wrightsboro',
      'Wrightsville Beach',
      'Yadkin Valley',
      'Yadkinville',
      'Yanceyville',
      'Bald Creek',
      'Walstonburg',
    ],
    'US-ND': [
      'Abercrombie',
      'Akra',
      'Alice',
      'Alkabo',
      'Amidon',
      'Anamoose',
      'Aneta',
      'Antler',
      'Ardoch',
      'Argusville',
      'Arnegard',
      'Balta',
      'Bantry',
      'Bathgate',
      'Belcourt',
      'Belfield',
      'Berthold',
      'Binford',
      'Bonetraill',
      'Bordulac',
      'Bottineau',
      'Bowbells',
      'Bowesmont',
      'Breien',
      'Brinsmade',
      'Brocket',
      'Brooktree Park',
      'Burnstad',
      'Calio',
      'Cando',
      'Cannon Ball',
      'Carbury',
      'Carrington',
      'Cashel',
      'Casselton',
      'Cathay',
      'Cavalier',
      'Chaseley',
      'Christine',
      'Churchs Ferry',
      'Cogswell',
      'Coleharbor',
      'Colgate',
      'Coteau',
      'Coulee',
      'Crary',
      'Dahlen',
      'Dazey',
      'De Lamere',
      'De Sart',
      'Denbigh',
      'Denhoff',
      'Des Lacs',
      'Dickinson',
      'Dore',
      'Drayton',
      'Driscoll',
      'Dunn Center',
      'Dunseith',
      'East Dunseith',
      'East Fairview',
      'Eckman',
      'Edgeley',
      'Egeland',
      'Embden',
      'Emerado',
      'Enderlin',
      'Fairdale',
      'Fessenden',
      'Finley',
      'Flasher',
      'Flaxton',
      'Fordville',
      'Forest River',
      'Forman',
      'Fort Clark',
      'Fort Ransom',
      'Fort Totten',
      'Fort Yates',
      'Four Bears Village',
      'Foxholm',
      'Fryburg',
      'Gackle',
      'Gardar',
      'Gascoyne',
      'Gilby',
      'Glen Ullin',
      'Glenburn',
      'Golva',
      'Grace City',
      'Grano',
      'Grassy Butte',
      'Grenora',
      'Gwinner',
      'Hague',
      'Haley',
      'Hamberg',
      'Hankinson',
      'Hannaford',
      'Hannah',
      'Hannover',
      'Hansboro',
      'Harlow',
      'Heil',
      'Heimdal',
      'Hensel',
      'Hensler',
      'Hettinger',
      'Hickson',
      'Hoople',
      'Hurdsfield',
      'Jessie',
      'Jud',
      'Kathryn',
      'Kensal',
      'Kief',
      'Killdeer',
      'Kintyre',
      'Kulm',
      'LaMoure',
      'Landa',
      'Lankin',
      'Lansford',
      'Larimore',
      'Lark',
      'Larson',
      'Leal',
      'Lefor',
      'Lehr',
      'Lidgerwood',
      'Litchville',
      'Livona',
      'Lostwood',
      'Ludden',
      'Maddock',
      'Makoti',
      'Mandan',
      'Mandaree',
      'Mantador',
      'Manvel',
      'Marmarth',
      'Maxbass',
      'McClusky',
      'Mekinock',
      'Menoken',
      'Milnor',
      'Minnewaukan',
      'Moffit',
      'Mohall',
      'Monango',
      'Mooreton',
      'Mott',
      'Mylo',
      'Nash',
      'Neche',
      'New England',
      'New Hradec',
      'New Leipzig',
      'New Rockford',
      'Niobe',
      'Noonan',
      'Northgate',
      'Oakes',
      'Oberon',
      'Omemee',
      'Oriska',
      'Orrin',
      'Osnabrock',
      'Overly',
      'Park River',
      'Pembina',
      'Pettibone',
      'Pick City',
      'Pillsbury',
      'Pingree',
      'Pisek',
      'Plaza',
      'Porcupine',
      'Powers Lake',
      'Prairie Rose',
      'Raub',
      'Reeder',
      'Regan',
      'Regent',
      'Reiles Acres',
      'Rhame',
      'Richardton',
      'Rock Lake',
      'Rolette',
      'Roseglen',
      'Rugby',
      'Ruso',
      'Ruthville',
      'Ryder',
      'Sarles',
      'Selfridge',
      'Selz',
      'Sentinel Butte',
      'Shell Valley',
      'Sheyenne',
      'Simcoe',
      'Solen',
      'South Heart',
      'Southam',
      'Spiritwood',
      'Spiritwood Lake',
      'Starkweather',
      'Streeter',
      'Sydney',
      'Sykeston',
      'Tagus',
      'Tappen',
      'Temvik',
      'Tolley',
      'Tolna',
      'Tower City',
      'Trotters',
      'Velva',
      'Venturia',
      'Voltaire',
      'Voss',
      'Walum',
      'Watford City',
      'West Fargo',
      'Westhope',
      'White Shield',
      'Wildrose',
      'Willow City',
      'Wimbledon',
      'Wing',
      'Wishek',
      'Wolford',
      'Wyndmere',
      'Zahl',
      'Zap',
    ],
    'US-OH': [
      'Adario',
      'Addyston',
      'Adena',
      'Aid',
      'Alger',
      'Alvordton',
      'Amberley',
      'Amesville',
      'Amsden',
      'Ancor',
      'Ankenytown',
      'Apple Creek',
      'Aquilla',
      'Arcanum',
      'Archbold',
      'Armstrongs Mills',
      'Ashtabula',
      'Athalia',
      'Austinburg',
      'Austintown',
      'Avon Lake',
      'Bailey Lake',
      'Bairdstown',
      'Ballville',
      'Bannock',
      'Barberton',
      'Bartles',
      'Bay Village',
      'Beach City',
      'Beavercreek',
      'Beaverdam',
      'Beckett Ridge',
      'Bedford Heights',
      'Beechwood Trails',
      'Bellbrook',
      'Belle Center',
      'Belle Valley',
      'Belmore',
      'Bentleyville',
      'Benton Ridge',
      'Bergholz',
      'Berkey',
      'Berlin Heights',
      'Bettsville',
      'Beulah Beach',
      'Bevis',
      'Big Plain',
      'Big Prairie',
      'Blacklick Estates',
      'Blakeslee',
      'Blanchester',
      'Bloomdale',
      'Blue Ash',
      'Blue Rock',
      'Bolindale',
      'Boston Heights',
      'Botkins',
      'Bourneville',
      'Bowerston',
      'Bradner',
      'Brady Lake',
      'Branch Hill',
      'Bratenahl',
      'Brecksville',
      'Brecon',
      'Brentwood Lake',
      'Brice',
      'Brinkhaven',
      'Broadview Heights',
      'Brookfield Center',
      'Brunersburg',
      'Bryan',
      'Buchtel',
      'Buckeye Lake',
      'Burgoon',
      'Burkettsville',
      'Byer',
      'Byesville',
      'Calcutta',
      'Camp Dennison',
      'Campbellstown',
      'Canal Fulton',
      'Canal Lewisville',
      'Canal Winchester',
      'Cardington',
      'Carrothers',
      'Casstown',
      'Catawba Island',
      'Celeryville',
      'Centerburg',
      'Chagrin Falls',
      'Chardon',
      'Charm',
      'Chattanooga',
      'Cherry Fork',
      'Cherry Grove',
      'Chesterhill',
      'Chesterland',
      'Cheviot',
      'Chilo',
      'Chippewa Lake',
      'Chippewa Park',
      'Choctaw Lake',
      'Christiansburg',
      'City View Heights',
      'Clarksfield',
      'Clarktown',
      'Claysville',
      'Cleveland Heights',
      'Cleves',
      'Coal Grove',
      'Coal Run',
      'Colerain Heights',
      'College Corner',
      'Columbia Hills Corners',
      'Columbia Station',
      'Columbus Grove',
      'Commercial Point',
      'Condit',
      'Conneaut',
      'Convoy',
      'Coolville',
      'Cooperdale',
      'Coshocton',
      'Covedale',
      'Craig Beach',
      'Cridersville',
      'Crooksville',
      'Crown City',
      'Crystal Rock',
      'Curtice',
      'Custar',
      'Cuyahoga Falls',
      'Cuyahoga Heights',
      'Dallasburg',
      'Darbydale',
      'Darbyville',
      'Darrtown',
      'Day Heights',
      'Deersville',
      'Delhi Hills',
      'Dellroy',
      'Devola',
      'Dexter City',
      'Dillonvale',
      'Dodsonville',
      'Dola',
      'Donnelsville',
      'Doylestown',
      'Dry Run',
      'Duncan Falls',
      'Dunkinsville',
      'Eagleport',
      'East Canton',
      'East Claridon',
      'East Cleveland',
      'East Danville',
      'East Fultonham',
      'East Liberty',
      'East Liverpool',
      'East Palestine',
      'East Ringgold',
      'East Sparta',
      'East Springfield',
      'Eaton Estates',
      'Edon',
      'Elmwood Place',
      'Epworth Heights',
      'Evendale',
      'Fairborn',
      'Fairfield Beach',
      'Fairlawn',
      'Fairport Harbor',
      'Farmer',
      'Felicity',
      'Finneytown',
      'Fitchville',
      'Fort Jennings',
      'Fort Loramie',
      'Fort Recovery',
      'Fort Seneca',
      'Fort Shawnee',
      'Franklin Furnace',
      'Frazeysburg',
      'Freedom Station',
      'Fruit Hill',
      'Fultonham',
      'Gahanna',
      'Gallipolis',
      'Gambier',
      'Gano',
      'Garfield Heights',
      'Garrettsville',
      'Gates Mills',
      'Geneva-on-the-Lake',
      'Germano',
      'Gettysburg',
      'Gibsonburg',
      'Gilboa',
      'Glandorf',
      'Glen Este',
      'Glenford',
      'Glenmoor',
      'Glenwillow',
      'Gloria Glens Park',
      'Glouster',
      'Gnadenhutten',
      'Golf Manor',
      'Grandview Heights',
      'Gratiot',
      'Gratis',
      'Green Camp',
      'Green Meadows',
      'Green Springs',
      'Greenford',
      'Groesbeck',
      'Groveport',
      'Grover Hill',
      'Hageman',
      'Hamden',
      'Hamersville',
      'Hamler',
      'Hanging Rock',
      'Hanoverton',
      'Harbor View',
      'Harlem Springs',
      'Harriettsville',
      'Harrod',
      'Harveysburg',
      'Haskins',
      'Haydenville',
      'Hebardville',
      'Hessville',
      'Hide-A-Way Hills',
      'Higginsport',
      'Highland Holiday',
      'Hockingport',
      'Holgate',
      'Holiday City',
      'Holiday Valley',
      'Hollansburg',
      'Homeworth',
      'Hooven',
      'Howland Center',
      'Hoytville',
      'Huber Heights',
      'Huber Ridge',
      'Hunterdon',
      'Hunting Valley',
      'Jackson Center',
      'Jacksonburg',
      'Jacksontown',
      'Jacobsburg',
      'Jelloway',
      'Jenera',
      'Jeromesville',
      'Jerry City',
      'Justus',
      'Kalida',
      'Kanauga',
      'Kelleys Island',
      'Kelloggsville',
      'Kettlersville',
      'Kidron',
      'Killbuck',
      'Kings Mills',
      'Kipton',
      'Kirkersville',
      'Kirtland Hills',
      'Kitts Hill',
      'Kunkle',
      'La Croft',
      'La Rue',
      'Lafferty',
      'Lake Darby',
      'Lake Lakengren',
      'Lake Milton',
      'Lake Seneca',
      'Lakeline',
      'Lakemore',
      'Landen',
      'Lattasburg',
      'Latty',
      'Laurelville',
      'Layhigh',
      'Le Sourdsville',
      'Leavittsburg',
      'Leetonia',
      'Letart Falls',
      'Lewis Center',
      'Liberty Center',
      'Limaville',
      'Lime City',
      'Lincoln Heights',
      'Lindsey',
      'Linndale',
      'Lithopolis',
      'Little Hocking',
      'Lockbourne',
      'Lockington',
      'Lockland',
      'Locust Corner',
      'Locust Lake',
      'Logan Elm Village',
      'Lorain',
      'Lordstown',
      'Lore City',
      'Loveland Park',
      'Lowellville',
      'Lower Salem',
      'Lucasville',
      'Luckey',
      'Ludlow Falls',
      'Luhrig',
      'Madison Mills',
      'Madisonburg',
      'Magnetic Springs',
      'Maineville',
      'Malinta',
      'Maple Heights',
      'Maplewood Park',
      'Marble Cliff',
      'Mariemont',
      'Martins Ferry',
      'Massieville',
      'Masury',
      'Maud',
      'Maumee',
      'Maustown',
      'Maximo',
      'Mayfield Heights',
      'McConnelsville',
      'McCuneville',
      'McCutchenville',
      'McDermott',
      'McGonigle',
      'McGuffey',
      'McKinley Heights',
      'Melmore',
      'Mentor-on-the-Lake',
      'Meyers Lake',
      'Miami Heights',
      'Miamisburg',
      'Miamitown',
      'Miamiville',
      'Middle Point',
      'Middleburg Heights',
      'Middlefield',
      'Mifflin',
      'Milford Center',
      'Millbury',
      'Millersport',
      'Milton Center',
      'Miltonsburg',
      'Miltonville',
      'Mineral City',
      'Mineral Ridge',
      'Minerva Park',
      'Minford',
      'Mingo Junction',
      'Minster',
      'Mitiwanga',
      'Mogadore',
      'Monfort Heights',
      'Moraine',
      'Moreland Hills',
      'Morgandale',
      'Morral',
      'Mount Blanchard',
      'Mount Cory',
      'Mount Eaton',
      'Mount Healthy',
      'Mount Healthy Heights',
      'Mount Liberty',
      'Mount Orab',
      'Mount Repose',
      'Mount Victory',
      'Mowrystown',
      'Moxahala',
      'Munroe Falls',
      'Murray City',
      'Mutual',
      'Nankin',
      'Neapolis',
      'Neffs',
      'Negley',
      'Nellie',
      'Neptune',
      'Nettle Lake',
      'Neville',
      'New Alexandria',
      'New Bavaria',
      'New Bloomington',
      'New Bremen',
      'New Burlington',
      'New California',
      'New Hampshire',
      'New Knoxville',
      'New Lebanon',
      'New Lexington',
      'New Lyme Station',
      'New Madison',
      'New Marshfield',
      'New Matamoras',
      'New Miami',
      'New Petersburg',
      'New Philadelphia',
      'New Pittsburg',
      'New Riegel',
      'New Rome',
      'New Straitsville',
      'New Waterford',
      'New Weston',
      'Newburgh Heights',
      'Newcomerstown',
      'Newtonsville',
      'Ney',
      'North Baltimore',
      'North Bloomfield',
      'North Canton',
      'North College Hill',
      'North Eaton',
      'North Fairfield',
      'North Hampton',
      'North Industry',
      'North Kingsville',
      'North Lawrence',
      'North Lewisburg',
      'North Lima',
      'North Madison',
      'North Olmsted',
      'North Perry',
      'North Randall',
      'North Ridgeville',
      'North Robinson',
      'North Royalton',
      'North Zanesville',
      'Northfield Center',
      'Northridge',
      'Nova',
      'Oak Harbor',
      'Oakshade',
      'Obetz',
      'Oceola',
      'Octa',
      'Ohio City',
      'Okeana',
      'Olde West Chester',
      'Olena',
      'Olmsted Falls',
      'Oregonia',
      'Orwell',
      'Ottawa Hills',
      'Ottoville',
      'Overpeck',
      'Page Manor',
      'Painesville',
      'Pancoastburg',
      'Park Layne',
      'Parkertown',
      'Parkman',
      'Parma Heights',
      'Pataskala',
      'Peebles',
      'Pemberville',
      'Peninsula',
      'Pepper Pike',
      'Perintown',
      'Perry Heights',
      'Pettisville',
      'Pickerington',
      'Pigeon Creek',
      'Piketon',
      'Pitsburg',
      'Plain City',
      'Pleasant City',
      'Pleasant Run',
      'Pleasant Run Farm',
      'Plumwood',
      'Port Clinton',
      'Port Union',
      'Portage Lakes',
      'Pottery Addition',
      'Powhatan Point',
      'Put-in-Bay',
      'Quaker City',
      'Radnor',
      'Rarden',
      'Rayland',
      'Reedsville',
      'Reily',
      'Reinersville',
      'Reminderville',
      'Rendville',
      'Reynoldsburg',
      'Richmond Dale',
      'Ridgeville Corners',
      'Risingsun',
      'Rittman',
      'Riverlea',
      'Roads',
      'Roaming Shores',
      'Rocky Fork Point',
      'Rocky Ridge',
      'Rocky River',
      'Rose Farm',
      'Rossburg',
      'Rossford',
      'Rossmoyne',
      'Roundhead',
      'Rowsburg',
      'Rudolph',
      'Rushsylvania',
      'Russells Point',
      'Russia',
      'Sabina',
      'Sagamore Hills',
      'Saint Clairsville',
      'Saint Henry',
      'Saint Louisville',
      'Saint Paris',
      'Salem Heights',
      'Salineville',
      'Sarahsville',
      'Sawyerwood',
      'Scioto Furnace',
      'Sciotodale',
      'Seaman',
      'Senecaville',
      'Seven Mile',
      'Shade',
      'Shadyside',
      'Shaker Heights',
      'Sharonville',
      'Shauck',
      'Shawnee Hills',
      'Sheffield Lake',
      'Sherrodsville',
      'Shinrock',
      'Shreve',
      'Silica',
      'Simons',
      'Sinking Spring',
      'Sixteen Mile Stand',
      'Skyline Acres',
      'Socialville',
      'South Bloomfield',
      'South Bloomingville',
      'South Canal',
      'South Charleston',
      'South Euclid',
      'South Lebanon',
      'South Perry',
      'South Point',
      'South Russell',
      'South Solon',
      'South Vienna',
      'South Webster',
      'South Zanesville',
      'Spargursville',
      'Springboro',
      'Stockdale',
      'Stone Creek',
      'Stony Prairie',
      'Stony Ridge',
      'Stow',
      'Streetsboro',
      'Strongsville',
      'Struthers',
      'Sugar Bush Knolls',
      'Sugar Tree Ridge',
      'Sugarcreek',
      'Summit Station',
      'Sycamore Valley',
      'Tallmadge',
      'Tarlton',
      'Taylors Creek',
      'Tedrow',
      'Terrace Park',
      'The Plains',
      'The Village of Indian Hill',
      'Thornport',
      'Thornville',
      'Tiltonsville',
      'Tipp City',
      'Tippecanoe',
      'Tiro',
      'Toboso',
      'Tontogany',
      'Tremont City',
      'Trinway',
      'Trotwood',
      'Tuppers Plains',
      'Turpin Hills',
      'Tuscarawas',
      'Twinsburg',
      'Twinsburg Heights',
      'Tylersville',
      'Uhrichsville',
      'Union Furnace',
      'Unionvale',
      'Unionville Center',
      'Uniopolis',
      'Upper Arlington',
      'Upper Sandusky',
      'Urbancrest',
      'Valley Hi',
      'Vanlue',
      'Vaughnsville',
      'Venedocia',
      'Vickery',
      'Vienna Center',
      'Waite Hill',
      'Wakeman',
      'Walbridge',
      'Walton Hills',
      'Wapakoneta',
      'Warrensville Heights',
      'Washington Court House',
      'Wauseon',
      'Wayne Lakes Park',
      'Waynesburg',
      'Waynesfield',
      'Welshfield',
      'West Alexandria',
      'West Carrollton',
      'West Elkton',
      'West Farmington',
      'West Hill',
      'West Leipsic',
      'West Manchester',
      'West Mansfield',
      'West Middletown',
      'West Millgrove',
      'West Milton',
      'West Portsmouth',
      'West Richfield',
      'West Rushville',
      'West Unity',
      'West View',
      'Westfield Center',
      'Wetherington',
      'Wheelersburg',
      'Whipple',
      'Whitehouse',
      'Whites Landing',
      'Wightmans Grove',
      'Wilberforce',
      'Wilkesville',
      'Williamsdale',
      'Willoughby',
      'Willoughby Hills',
      'Willowick',
      'Willowville',
      'Willshire',
      'Winesburg',
      'Wintersville',
      'Withamsville',
      'Wolfhurst',
      'Woodsfield',
      'Yankee Lake',
      'Yellow Springs',
      'Zaleski',
      'Zanesfield',
      'Zoar',
    ],
    'US-OK': [
      'Achille',
      'Ahloso',
      'Akins',
      'Alderson',
      'Alex',
      'Alfalfa',
      'Aline',
      'Alluwe',
      'Alsuma',
      'Amorita',
      'Anadarko',
      'Antlers',
      'Apache',
      'Aqua Park',
      'Arapaho',
      'Arkoma',
      'Arnett',
      'Arpelar',
      'Asher',
      'Avant',
      'Avard',
      'Babbs',
      'Balko',
      'Ballou',
      'Barnsdall',
      'Baron',
      'Bartlesville',
      'Beggs',
      'Belfonte',
      'Belva',
      'Bessie',
      'Bethel Acres',
      'Big Cabin',
      'Binger',
      'Blackgum',
      'Blocker',
      'Blue',
      'Bluejacket',
      'Boatman',
      'Boise City',
      'Bokchito',
      'Bokhoma',
      'Bokoshe',
      'Boley',
      'Bowlegs',
      'Bowring',
      'Box',
      'Boynton',
      'Braggs',
      'Braman',
      'Breckinridge',
      'Briartown',
      'Bridge Creek',
      'Briggs',
      'Brinkman',
      'Broken Arrow',
      'Bromide',
      'Brush Creek',
      'Brushy',
      'Bull Hollow',
      'Burmah',
      'Burneyville',
      'Burns Flat',
      'Bushyhead',
      'Byars',
      'Byng',
      'Cache',
      'Caddo',
      'Canadian',
      'Canute',
      'Carlton Landing',
      'Carrier',
      'Castaneda',
      'Castle',
      'Catesby',
      'Catoosa',
      'Cedar Valley',
      'Cement',
      'Centrahoma',
      'Central High',
      'Cestos',
      'Checotah',
      'Cherry Tree',
      'Chewey',
      'Cheyenne',
      'Chickasha',
      'Chilocco',
      'Chouteau',
      'Christie',
      'Cimarron City',
      'Claremore',
      'Clarita',
      'Cleo Springs',
      'Cleora',
      'Cloud Creek',
      'Coalgate',
      'Cogar',
      'Colcord',
      'Cole',
      'Connerville',
      'Cookietown',
      'Cooperton',
      'Copan',
      'Corbett',
      'Cordell',
      'Corn',
      'Corum',
      'Council Hill',
      'Coweta',
      'Cowlington',
      'Cox City',
      'Coyle',
      'Creta',
      'Criner',
      'Custer City',
      'Cyril',
      'Dacoma',
      'Del City',
      'Dempsey',
      'Devol',
      'Dewar',
      'Dibble',
      'Dickson',
      'Dill City',
      'Disney',
      'Dotyville',
      'Driftwood',
      'Dripping Springs',
      'Drumright',
      'Duchess Landing',
      'Duke',
      'Dustin',
      'Dwight Mission',
      'Eagle City',
      'Eagletown',
      'Eakly',
      'Earlsboro',
      'El Reno',
      'Elmore City',
      'Empire City',
      'Erick',
      'Erin Springs',
      'Eucha',
      'Fairvalley',
      'Fallis',
      'Fanshawe',
      'Faxon',
      'Fay',
      'Fittstown',
      'Flint Creek',
      'Flute Springs',
      'Foraker',
      'Forgan',
      'Fort Cobb',
      'Fort Coffee',
      'Fort Gibson',
      'Fort Supply',
      'Fort Towson',
      'Foss',
      'Foyil',
      'Gans',
      'Gate',
      'Geary',
      'Gene Autry',
      'Gerty',
      'Glenpool',
      'Goldsby',
      'Goltry',
      'Goodwell',
      'Gore',
      'Gotebo',
      'Gowen',
      'Gracemont',
      'Grainola',
      'Grand Lake Towne',
      'Grandfield',
      'Gray Horse',
      'Greasy',
      'Guymon',
      'Haileyville',
      'Hammon',
      'Hardesty',
      'Harrah',
      'Hartshorne',
      'Headrick',
      'Healdton',
      'Heavener',
      'Hennessey',
      'Henryetta',
      'Herd',
      'Herring',
      'Hitchcock',
      'Hitchita',
      'Holdenville',
      'Hominy',
      'Honobia',
      'Hooker',
      'Hoot Owl',
      'Hopeton',
      'Horntown',
      'Hough',
      'Hulah',
      'Hydro',
      'IXL',
      'Idabel',
      'Indiahoma',
      'Inola',
      'Iron Post',
      'Jenks',
      'Jet',
      'Katie',
      'Kaw City',
      'Keefton',
      'Kellyville',
      'Kemp',
      'Kenefic',
      'Keys',
      'Kiefer',
      'Kingfisher',
      'Kinta',
      'Knowles',
      'Komalty',
      'Konawa',
      'Krebs',
      'Lahoma',
      'Lake Aluma',
      'Latta',
      'Laverne',
      'Lawrence Creek',
      'Leach',
      'Leedey',
      'Lenapah',
      'Lequire',
      'Loco',
      'Lone Grove',
      'Lone Wolf',
      'Longdale',
      'Lookeba',
      'Lost City',
      'Lotsee',
      'Lovell',
      'Loyal',
      'Lucien',
      'Lugert',
      'Madill',
      'Mangum',
      'Mannford',
      'Maramec',
      'Marble City',
      'Marland',
      'Martha',
      'McAlester',
      'McCord',
      'McCurtain',
      'McKnight',
      'McLoud',
      'McQueen',
      'McWillie',
      'Medicine Park',
      'Meers',
      'Meno',
      'Middleberg',
      'Midwest City',
      'Minco',
      'Mocane',
      'Moffett',
      'Moodys',
      'Moorewood',
      'Mouser',
      'Moyers',
      'Muldrow',
      'Mulhall',
      'Muskogee',
      'Mustang',
      'Narcissa',
      'Nardin',
      'Nashoba',
      'Nelagoney',
      'Nescatunga',
      'New Woodville',
      'Nichols Hills',
      'Nicoma Park',
      'Nicut',
      'Ninnekah',
      'Norge',
      'North Enid',
      'Notchietown',
      'Notiechtown',
      'Nowata',
      'Nuyaka',
      'Ochelata',
      'Oilton',
      'Okarche',
      'Okay',
      'Okeene',
      'Okemah',
      'Oklahoma City',
      'Okmulgee',
      'Oktaha',
      'Old Eucha',
      'Oologah',
      'Optima',
      'Orienta',
      'Owasso',
      'Paradise Hill',
      'Park Hill',
      'Pauls Valley',
      'Pawhuska',
      'Peavine',
      'Peckham',
      'Peggs',
      'Pernell',
      'Pettit',
      'Pin Oak Acres',
      'Pinhook Corner',
      'Pink',
      'Platter',
      'Pocola',
      'Ponca City',
      'Pond Creek',
      'Porum',
      'Poteau',
      'Prue',
      'Quapaw',
      'Quinlan',
      'Randlett',
      'Ratliff City',
      'Rattan',
      'Ravia',
      'Red Bird',
      'Redbird Smith',
      'Redden',
      'Remy',
      'Renfrow',
      'Rentiesville',
      'Retrop',
      'Reydon',
      'Ringold',
      'Rocky',
      'Rocky Mountain',
      'Roff',
      'Rufe',
      'Rush Springs',
      'Sallisaw',
      'Salt Fork',
      'Sand Creek',
      'Sapulpa',
      'Sasakwa',
      'Sayre',
      'Schulter',
      'Scraper',
      'Seiling',
      'Selman',
      'Sequoyah',
      'Shady Point',
      'Shattuck',
      'Shidler',
      'Short',
      'Silo',
      'Skedee',
      'Skiatook',
      'Slapout',
      'Slaughterville',
      'Slick',
      'Smith Village',
      'Snake Creek',
      'Soper',
      'South Coffeyville',
      'Spavinaw',
      'Speer',
      'Sperry',
      'Spiro',
      'Sportsmen Acres',
      'Stecker',
      'Stidham',
      'Stigler',
      'Stoney Point',
      'Sugden',
      'Sunray',
      'Tabler',
      'Tagg Flats',
      'Tahlequah',
      'Talala',
      'Talihina',
      'Taloga',
      'Tamaha',
      'Tatums',
      'Tegarden',
      'Tenkiller',
      'Teresita',
      'Terlton',
      'Terral',
      'Texanna',
      'Texhoma',
      'Texola',
      'Thackerville',
      'The Village',
      'Thomas',
      'Tiawah',
      'Titanic',
      'Tom',
      'Tonkawa',
      'Tribbey',
      'Tullahassee',
      'Tulsa',
      'Turpin',
      'Tushka',
      'Tuskahoma',
      'Uncas',
      'Valley Brook',
      'Valliant',
      'Vanoss',
      'Verden',
      'Verdigris',
      'Vian',
      'Vici',
      'Vinita',
      'Vinson',
      'Wakita',
      'Wanette',
      'Wapanucka',
      'Warr Acres',
      'Watonga',
      'Watova',
      'Watts',
      'Wauhillau',
      'Waukomis',
      'Waurika',
      'Waynoka',
      'Weatherford',
      'Webbers Falls',
      'Welch',
      'Weleetka',
      'Welling',
      'Welty',
      'West Peavine',
      'West Siloam Springs',
      'Wetumka',
      'Wewoka',
      'Wheeless',
      'White Bead',
      'Wilburton',
      'Wister',
      'Woodall',
      'Wynnewood',
      'Wynona',
      'Yanush',
      'Yeager',
      'Yewed',
      'Zeb',
    ],
    'US-OR': [
      'Adair Village',
      'Agate Beach',
      'Agness',
      'Aloha',
      'Alsea',
      'Annex',
      'Arch Cape',
      'Arock',
      'Ashwood',
      'Aumsville',
      'Baker City',
      'Bandon',
      'Barview',
      'Bayside Gardens',
      'Bellfountain',
      'Biggs Junction',
      'Black Butte Ranch',
      'Bly',
      'Boring',
      'Broadbent',
      'Brogan',
      'Brookings',
      'Brothers',
      'Butte Falls',
      'Butteville',
      'Camas Valley',
      'Camp Sherman',
      'Cannon Beach',
      'Canyon City',
      'Canyonville',
      'Cape Meares',
      'Carpenterville',
      'Cascade Locks',
      'Cascadia',
      'Cave Junction',
      'Cayuse',
      'Cedar Hills',
      'Cedar Mill',
      'Central Point',
      'Chemult',
      'Chenoweth',
      'Chiloquin',
      'Clatskanie',
      'Coos Bay',
      'Coquille',
      'Cornucopia',
      'Culp Creek',
      'Curtin',
      'Dairy',
      'Days Creek',
      'Dayville',
      'Deer Island',
      'Depoe Bay',
      'Deschutes River Woods',
      'Disston',
      'Dorena',
      'Drain',
      'Dufur',
      'Dunes City',
      'Eagle Point',
      'Eola',
      'Estacada',
      'Foots Creek',
      'Forest Grove',
      'Fort Hill Census Designated Place',
      'Fort Klamath',
      'Fossil',
      'Frenchglen',
      'Gearhart',
      'Gervais',
      'Gilchrist',
      'Glide',
      'Gold Beach',
      'Government Camp',
      'Grand Ronde',
      'Grants Pass',
      'Grizzly',
      'Harbor',
      'Hebo',
      'Helix',
      'Heppner',
      'Hermiston',
      'Hilgard',
      'Hood River',
      'Idanha',
      'Idleyld Park',
      'Imbler',
      'Ironside',
      'Irrigon',
      'Izee',
      'Jennings Lodge',
      'John Day',
      'Jordan Valley',
      'Joseph',
      'Juntura',
      'Keating',
      'Keizer',
      'Keno',
      'Kerby',
      'Kings Valley',
      'Kirkpatrick',
      'Klamath Agency',
      'Klamath Falls',
      'Knappa',
      'La Grande',
      'La Pine',
      'Labish Village',
      'Lacomb',
      'Lake Creek',
      'Lake Oswego',
      'Langlois',
      'Lawen',
      'Leaburg',
      'Lime',
      'Lincoln Beach',
      'Logsden',
      'Lonerock',
      'Lookingglass',
      'Lostine',
      'Malin',
      'Manzanita',
      'Marcola',
      'Maupin',
      'Maywood Park',
      'McCredie Springs',
      'McKenzie Bridge',
      'McMinnville',
      'Meacham',
      'Mehama',
      'Merlin',
      'Metolius',
      'Metzger',
      'Mikkalo',
      'Milton-Freewater',
      'Milwaukie',
      'Minam',
      'Molalla',
      'Mosier',
      'Mount Angel',
      'Mount Hood',
      'Mount Hood Village',
      'Mulino',
      'Myrtle Creek',
      'Myrtle Point',
      'Neahkahnie',
      'Nehalem',
      'Nesika Beach',
      'Neskowin',
      'Netarts',
      'New Pine Creek',
      'Newberg',
      'North Albany',
      'North Plains',
      'North Powder',
      'North Springfield',
      'Nyssa',
      'Oakridge',
      'Oatfield',
      'Olene',
      'Olex',
      'Oregon City',
      'Pacific City',
      'Perrydale',
      'Pilot Rock',
      'Pine Hollow',
      'Pistol River',
      'Placer',
      'Plush',
      'Port Orford',
      'Post',
      'Powell Butte',
      'Powellhurst',
      'Prineville',
      'Rainier',
      'Raleigh Hills',
      'Reedsport',
      'Rhododendron',
      'Rickreall',
      'Rieth',
      'Rivergrove',
      'Rockcreek',
      'Rogue River',
      'Rose Lodge',
      'Roseburg',
      'Rowena',
      'Ruch',
      'Rufus',
      'Saint Helens',
      'Sandy',
      'Scappoose',
      'Scotts Mills',
      'Seal Rock',
      'Shady Cove',
      'Shaniko',
      'Shedd',
      'Siletz',
      'Siltcoos',
      'Silvies',
      'Simnasho',
      'Sisters',
      'Sixes',
      'Sodaville',
      'Sprague River',
      'Spray',
      'Stayton',
      'Sublimity',
      'Summer Lake',
      'Sumpter',
      'Sunriver',
      'Sutherlin',
      'Swisshome',
      'Takilma',
      'Talent',
      'Tangent',
      'Telocaset',
      'Tenmile',
      'The Dalles',
      'Tidewater',
      'Tigard',
      'Tillamook',
      'Tiller',
      'Timber',
      'Tri-City',
      'Troutdale',
      'Tualatin',
      'Tumalo',
      'Tutuilla',
      'Tygh Valley',
      'Umapine',
      'Umpqua',
      'Union Creek',
      'Vale',
      'Veneta',
      'Vernonia',
      'Wagontire',
      'Waldport',
      'Walterville',
      'Wamic',
      'Wapinitia',
      'West Linn',
      'West Scio',
      'West Slope',
      'Westfir',
      'Whiteson',
      'Wilderville',
      'Willamina',
      'Wimer',
      'Winchester Bay',
      'Wood Village',
      'Yachats',
      'Yamhill',
      'Yoncalla',
    ],
    'US-PA': [
      'Aaronsburg',
      'Abbottstown',
      'Ackermanville',
      'Adamsburg',
      'Aladdin',
      'Albrightsville',
      'Alburtis',
      'Alcoa Center',
      'Aldan',
      'Alfarata',
      'Aliquippa',
      'Alleghenyville',
      'Allenport',
      'Allison Park',
      'Almedia',
      'Alsace Manor',
      'Alum Bank',
      'Ambridge',
      'Ambridge Heights',
      'Amity Gardens',
      'Ancient Oaks',
      'Anselma',
      'Apollo',
      'Applewold',
      'Archbald',
      'Arendtsville',
      'Aristes',
      'Armbrust',
      'Arnold City',
      'Arnot',
      'Aspers',
      'Atglen',
      'Atkinson Mills',
      'Atlasburg',
      'Avon Heights',
      'Avonia',
      'Avonmore',
      'Bacton',
      'Baidland',
      'Bairdford',
      'Bakerstown',
      'Bakerstown Station',
      'Bakerton',
      'Bala-Cynwyd',
      'Bally',
      'Barbours',
      'Bareville',
      'Barkeyville',
      'Barrville',
      'Bauerstown',
      'Baumstown',
      'Beach Lake',
      'Bear Creek Village',
      'Bear Rocks',
      'Beaver Falls',
      'Beaver Meadows',
      'Beaver Springs',
      'Beavertown',
      'Bechtelsville',
      'Beech Creek',
      'Beech Mountain Lakes',
      'Bell Acres',
      'Bell Point',
      'Belle Vernon',
      'Ben Avon',
      'Ben Avon Heights',
      'Bendersville',
      'Bernville',
      'Berrysburg',
      'Bethayres',
      'Bethel Park',
      'Beurys Lake',
      'Big Bass Lake',
      'Big Beaver',
      'Big Run',
      'Bigler',
      'Biglerville',
      'Birchwood Lakes',
      'Bird in Hand',
      'Birdsboro',
      'Black Lick',
      'Blain',
      'Blaine Hill',
      'Blandburg',
      'Blandon',
      'Blawnox',
      'Blooming Valley',
      'Bloomsburg',
      'Blue Bell',
      'Blue Ridge Summit',
      'Boalsburg',
      'Bobtown',
      'Bon Meade',
      'Bonneauville',
      'Boothwyn',
      'Boquet',
      'Bovard',
      'Bower Hill',
      'Bowers',
      'Bowmanstown',
      'Boyers',
      'Boyertown',
      'Brackenridge',
      'Braddock Hills',
      'Bradenville',
      'Bradford Hills',
      'Bradford Woods',
      'Branch Dale',
      'Brandonville',
      'Brandywine Manor',
      'Brave',
      'Breinigsville',
      'Bressler',
      'Briar Creek',
      'Brickerville',
      'Brisbin',
      'Broad Top City',
      'Brodheadsville',
      'Broomall',
      'Bryn Athyn',
      'Buck Run',
      'Buffington',
      'Bulger',
      'Burgettstown',
      'Bushkill',
      'Butler Junction',
      'Byrnedale',
      'Cadogan',
      'Cairnbrook',
      'Callensburg',
      'Callery',
      'Callimont',
      'Caln',
      'Cambridge Springs',
      'Cammal',
      'Camp Jo-Ann',
      'Camptown',
      'Canadensis',
      'Canadohta Lake',
      'Canonsburg',
      'Carmichaels',
      'Carnot',
      'Carroll Valley',
      'Carrolltown',
      'Cashtown',
      'Cassandra',
      'Castanea',
      'Castle Shannon',
      'Catasauqua',
      'Catawissa',
      'Cementon',
      'Center Square',
      'Centre Hall',
      'Cetronia',
      'Chadds Ford',
      'Chalfant',
      'Chalfont',
      'Chalkhill',
      'Charleroi',
      'Chatwood',
      'Chest Springs',
      'Chester Heights',
      'Chester Hill',
      'Chester Springs',
      'Chesterbrook',
      'Cheswick',
      'Chevy Chase Heights',
      'Cheyney',
      'Christy Manor',
      'Churchtown',
      'Clairton',
      'Claridge',
      'Clarks Green',
      'Clarks Summit',
      'Claysburg',
      'Cleona',
      'Clifton Heights',
      'Clintonville',
      'Clymer',
      'Coal Center',
      'Coalport',
      'Coburn',
      'Cochranton',
      'Cochranville',
      'Cokeburg',
      'Collingdale',
      'Collinsburg',
      'Colonial Park',
      'Colony Park',
      'Colver',
      'Colwyn',
      'Commodore',
      'Conashaugh Lakes',
      'Concordville',
      'Conemaugh',
      'Conestoga',
      'Confluence',
      'Congruity',
      'Conneaut Lake',
      'Conneautville',
      'Connellsville',
      'Connoquenessing',
      'Conshohocken',
      'Conyngham',
      'Coopersburg',
      'Coplay',
      'Coral',
      'Coraopolis',
      'Cornwells Heights',
      'Corry',
      'Corsica',
      'Coryville',
      'Coudersport',
      'Courtdale',
      'Cowansburg',
      'Cranesville',
      'Cresson',
      'Cressona',
      'Criders Corners',
      'Cross Creek',
      'Cross Roads',
      'Crucible',
      'Culmerville',
      'Cumbola',
      'Curtisville',
      'Curwensville',
      'Cyclone',
      'Daisytown',
      'Dallastown',
      'Dalmatia',
      'Darragh',
      'Dauberville',
      'Davidson Heights',
      'Davidsville',
      'Deemston',
      'Delaware Water Gap',
      'Delmont',
      'Derrick City',
      'Devault',
      'Dewart',
      'Dickson City',
      'Dicksonville',
      'Dillsburg',
      'Dime',
      'Dingmans Ferry',
      'Donegal',
      'Donora',
      'Dormont',
      'Dorneyville',
      'Dornsife',
      'Dorseyville',
      'Douglassville',
      'Downingtown',
      'Dravosburg',
      'Drexel Hill',
      'Dry Tavern',
      'Dryville',
      'Duboistown',
      'Duncannon',
      'Duncansville',
      'Dunlevy',
      'Dunlo',
      'Dunnstown',
      'Duryea',
      'Dushore',
      'Eagles Mere',
      'Earlston',
      'East Bangor',
      'East Berlin',
      'East Berwick',
      'East Brady',
      'East Butler',
      'East Conemaugh',
      'East Earl',
      'East Freedom',
      'East Greenville',
      'East Lansdowne',
      'East McKeesport',
      'East Petersburg',
      'East Pittsburgh',
      'East Prospect',
      'East Salem',
      'East Side',
      'East Smithfield',
      'East Stroudsburg',
      'East Troy',
      'East Uniontown',
      'East Vandergrift',
      'East Washington',
      'East Waterford',
      'East York',
      'Eastlawn Gardens',
      'Ebensburg',
      'Edenborn',
      'Edenburg',
      'Edgely',
      'Edie',
      'Edinboro',
      'Effort',
      'Ehrenfeld',
      'Eighty Four',
      'Elderton',
      'Elimsport',
      'Elizabethville',
      'Elkins Park',
      'Ellport',
      'Ellwood City',
      'Elrama',
      'Elverson',
      'Elwyn',
      'Elysburg',
      'Embreeville',
      'Emerald Lakes',
      'Emigsville',
      'Emlenton',
      'Emmaus',
      'Emporium',
      'Emsworth',
      'Enhaut',
      'Enlow',
      'Enon Valley',
      'Ephrata',
      'Ernest',
      'Espy',
      'Essington',
      'Evans City',
      'Evansburg',
      'Everson',
      'Export',
      'Eyers Grove',
      'Factoryville',
      'Fairchance',
      'Fairless Hills',
      'Fairoaks',
      'Fairville',
      'Falls',
      'Falls Creek',
      'Fallsington',
      'Fannettsburg',
      'Farrandsville',
      'Fawn Grove',
      'Fawn Lake Forest',
      'Fayette City',
      'Feasterville',
      'Fernville',
      'Fernway',
      'Finleyville',
      'Fivepointville',
      'Fleetwood',
      'Floradale',
      'Flourtown',
      'Flying Hills',
      'Fogelsville',
      'Folcroft',
      'Foot of Ten',
      'Forbes Road',
      'Ford Cliff',
      'Forksville',
      'Fort Indiantown Gap',
      'Fort Loudon',
      'Forty Fort',
      'Foster Brook',
      'Foundryville',
      'Fountain Springs',
      'Fox Chapel',
      'Fox Run',
      'Foxburg',
      'Frackville',
      'Frankfort Springs',
      'Franklintown',
      'Freemansburg',
      'Friedens',
      'Friedensburg',
      'Frizzleburg',
      'Frystown',
      'Gallitzin',
      'Garden View',
      'Gardners',
      'Gastonville',
      'Gayly',
      'Geigertown',
      'Geistown',
      'Gibsonia',
      'Gilberton',
      'Girardville',
      'Girty',
      'Glade Mills',
      'Gladwyne',
      'Glassport',
      'Glen Campbell',
      'Glen Hope',
      'Glen Lyon',
      'Glen Riddle',
      'Glenloch',
      'Glenmoore',
      'Glenolden',
      'Glenshaw',
      'Glenwillard',
      'Gold',
      'Gold Key Lake',
      'Goodville',
      'Goshenville',
      'Gouglersville',
      'Gouldsboro',
      'Grampian',
      'Grantley',
      'Grapeville',
      'Grassflat',
      'Graterford',
      'Grazierville',
      'Green Hills',
      'Green Lane',
      'Green Tree',
      'Greenfields',
      'Grier City',
      'Grill',
      'Grindstone',
      'Gringo',
      'Guthriesville',
      'Guys Mills',
      'Gwynedd Valley',
      'Hahntown',
      'Halfway House',
      'Hallstead',
      'Hammersley Fork',
      'Hamorton',
      'Hannastown',
      'Hannasville',
      'Harleigh',
      'Harleysville',
      'Harmar Heights',
      'Harmarville',
      'Harmonsburg',
      'Harrison City',
      'Harrison Valley',
      'Hartleton',
      'Hartstown',
      'Harveys Lake',
      'Harwick',
      'Hasson Heights',
      'Hatboro',
      'Haverford',
      'Havertown',
      'Hawk Run',
      'Hawthorn',
      'Hazel Hurst',
      'Heckscherville',
      'Hegins',
      'Heidlersburg',
      'Heilwood',
      'Hellertown',
      'Hemlock Farms',
      'Herminie',
      'Highcliff',
      'Highspire',
      'Hilldale',
      'Hiller',
      'Hilliards',
      'Hokendauqua',
      'Holiday Pocono',
      'Hollidaysburg',
      'Holtwood',
      'Homeacre',
      'Homer City',
      'Homeville',
      'Honesdale',
      'Honey Brook',
      'Hookstown',
      'Hooversville',
      'Hop Bottom',
      'Hopeland',
      'Hopwood',
      'Hostetter',
      'Houserville',
      'Houtzdale',
      'Hublersburg',
      'Hughestown',
      'Hulmeville',
      'Hummels Wharf',
      'Hummelstown',
      'Hunker',
      'Hunterstown',
      'Hyde',
      'Hydetown',
      'Hyndman',
      'Ickesburg',
      'Indian Lake',
      'Indian Mountain Lake',
      'Ingram',
      'Inkerman',
      'Intercourse',
      'Irvona',
      'Ivyland',
      'Jacksonwald',
      'Jacobus',
      'Jamison City',
      'Jeannette',
      'Jeddo',
      'Jefferson Hills',
      'Jenkintown',
      'Jenners',
      'Jennerstown',
      'Jennersville',
      'Jermyn',
      'Jersey Shore',
      'Jerseytown',
      'Jim Thorpe',
      'Joanna',
      'Jones Mills',
      'Juniata Terrace',
      'Kaolin',
      'Kapp Heights',
      'Karns City',
      'Karthaus',
      'Kelayres',
      'Kelton',
      'Kemblesville',
      'Kenhorst',
      'Kenmar',
      'Kenmawr',
      'Kennerdell',
      'Kennett Square',
      'Kerrtown',
      'Kimberton',
      'King of Prussia',
      'Kiskimere',
      'Kistler',
      'Kittanning',
      'Klingerstown',
      'Knauertown',
      'Koppel',
      'Kratzerville',
      'Kreamer',
      'Kulpmont',
      'Kulpsville',
      'Kunkletown',
      'Kutztown',
      'Kylertown',
      'Laceyville',
      'Laflin',
      'Lake Ariel',
      'Lake Arthur Estates',
      'Lake Heritage',
      'Lake Latonka',
      'Lake Meade',
      'Lake Winola',
      'Lake Wynonah',
      'Lampeter',
      'Landenberg',
      'Landingville',
      'Landisburg',
      'Landisville',
      'Langeloth',
      'Langhorne',
      'Langhorne Manor',
      'Lansdale',
      'Larimer',
      'Larksville',
      'Lattimer',
      'Laurel Gardens',
      'Laurel Mountain Park',
      'Laurel Run',
      'Laureldale',
      'Laurelton',
      'Laurys Station',
      'Lavelle',
      'Lawnton',
      'Lawrence Park',
      'Lawson Heights',
      'Le Raysville',
      'Leacock',
      'Leechburg',
      'Leesport',
      'Leetsdale',
      'Lehighton',
      'Lemont Furnace',
      'Lenape',
      'Lenape Heights',
      'Lenhartsville',
      'Lenkerville',
      'Lernerville',
      'Level Green',
      'Lewis Run',
      'Lewisberry',
      'Library',
      'Light Street',
      'Lime Ridge',
      'Linesville',
      'Linfield',
      'Linglestown',
      'Linntown',
      'Lionville',
      'Lititz',
      'Little Britain',
      'Little Meadows',
      'Littlestown',
      'Lloydell',
      'Loag',
      'Lock Haven',
      'Locustdale',
      'Loganton',
      'Longfellow',
      'Lorane',
      'Lower Allen',
      'Lower Burrell',
      'Loyalhanna',
      'Loysburg',
      'Loysville',
      'Lucerne Mines',
      'Lucinda',
      'Ludwigs Corner',
      'Luthersburg',
      'Luxor',
      'Lykens',
      'Lyndell',
      'Lyndora',
      'Lynnwood',
      'Macungie',
      'Mahaffey',
      'Mahanoy City',
      'Mainville',
      'Mamont',
      'Manheim',
      'Manifold',
      'Manns Choice',
      'Maple Glen',
      'Mapletown',
      'Marcus Hook',
      'Marguerite',
      'Marianne',
      'Marienville',
      'Marion Center',
      'Marion Heights',
      'Marion Hill',
      'Marklesburg',
      'Markleysburg',
      'Marlin',
      'Mars',
      'Martins Creek',
      'Masontown',
      'Masthope',
      'Matamoras',
      'Mather',
      'Mattawana',
      'Mausdale',
      'McAdoo',
      'McAlisterville',
      'McConnellsburg',
      'McConnellstown',
      'McElhattan',
      'McEwensville',
      'McGovern',
      'McKeansburg',
      'McKees Rocks',
      'McKeesport',
      'McKnightstown',
      'McMurray',
      'McSherrystown',
      'McVeytown',
      'Meadow Lands',
      'Meadowood',
      'Mercersburg',
      'Mertztown',
      'Meshoppen',
      'Meyersdale',
      'Middleboro',
      'Mifflinburg',
      'Mifflintown',
      'Mifflinville',
      'Milesburg',
      'Milford Square',
      'Mill Hall',
      'Mill Village',
      'Millbourne',
      'Millerstown',
      'Millheim',
      'Milligantown',
      'Millvale',
      'Minersville',
      'Mingoville',
      'Mocanaqua',
      'Mohnton',
      'Mohrsville',
      'Monaca',
      'Monessen',
      'Moninger',
      'Monongahela',
      'Monroeton',
      'Mont Alto',
      'Mont Clare',
      'Montandon',
      'Montgomeryville',
      'Montoursville',
      'Montrose Hill',
      'Montrose Manor',
      'Moon Run',
      'Moosic',
      'Morrisdale',
      'Morstein',
      'Moshannon',
      'Mount Carbon',
      'Mount Cobb',
      'Mount Eagle',
      'Mount Gretna',
      'Mount Gretna Heights',
      'Mount Holly Springs',
      'Mount Jewett',
      'Mount Joy',
      'Mount Nebo',
      'Mount Oliver',
      'Mount Penn',
      'Mount Pleasant Mills',
      'Mount Pocono',
      'Mount Wolf',
      'Mountain Top',
      'Mountainhome',
      'Mountville',
      'Moylan',
      'Muhlenberg Park',
      'Muncy',
      'Mundys Corner',
      'Munhall',
      'Murry Hill',
      'Murrysville',
      'Muse',
      'Myerstown',
      'Myoma',
      'Nanty Glo',
      'Naomi',
      'Narberth',
      'Natrona Heights',
      'Nemacolin',
      'Nescopeck',
      'Neshaminy',
      'Nesquehoning',
      'New Beaver',
      'New Berlinville',
      'New Bethlehem',
      'New Centerville',
      'New Columbia',
      'New Columbus',
      'New Cumberland',
      'New Eagle',
      'New Freedom',
      'New Freeport',
      'New Galilee',
      'New Jerusalem',
      'New Kensington',
      'New Kingstown',
      'New Morgan',
      'New Oxford',
      'New Ringgold',
      'New Sheffield',
      'New Stanton',
      'New Tripoli',
      'New Wilmington',
      'Newlonsburg',
      'Newmanstown',
      'Newportville Terrace',
      'Newry',
      'Newton Hamilton',
      'Newtown Grant',
      'Newtown Square',
      'Nittany',
      'Niverton',
      'Noblestown',
      'North Apollo',
      'North Belle Vernon',
      'North Braddock',
      'North Buffalo',
      'North Catasauqua',
      'North Charleroi',
      'North Irwin',
      'North Philipsburg',
      'North Vandergrift',
      'North Wales',
      'North Warren',
      'North York',
      'Northern Cambria',
      'Northvue',
      'Norvelt',
      'Noxen',
      'Nuangola',
      'Numidia',
      'Oakmont',
      'Ohiopyle',
      'Ohioville',
      'Oklahoma',
      'Old Orchard',
      'Oley',
      'Orbisonia',
      'Orchard Hills',
      'Oreland',
      'Orrstown',
      'Orrtanna',
      'Orson',
      'Orviston',
      'Orwigsburg',
      'Orwin',
      'Osceola Mills',
      'Oswayo',
      'Oval',
      'Paint',
      'Paintersville',
      'Paintertown',
      'Palmer Heights',
      'Palmerton',
      'Pardeesville',
      'Park Crest',
      'Park Forest Village',
      'Parker Ford',
      'Parkesburg',
      'Parkside',
      'Parryville',
      'Patterson Heights',
      'Paulton',
      'Paxtang',
      'Paxtonia',
      'Paxtonville',
      'Pen Argyl',
      'Pen Mar',
      'Penbrook',
      'Penn',
      'Penn Estates',
      'Penn Lake Park',
      'Penn Wynne',
      'Penndel',
      'Penns Creek',
      'Pennsburg',
      'Pennsbury Village',
      'Pennside',
      'Pennwyn',
      'Perkasie',
      'Perryopolis',
      'Phoenixville',
      'Pikes Creek',
      'Pillow',
      'Pine Glen',
      'Pine Grove Mills',
      'Piney Fork',
      'Pitcairn',
      'Pittsburgh',
      'Pittston',
      'Platea',
      'Pleasant Unity',
      'Plum',
      'Plumsteadville',
      'Plumville',
      'Plymouth Meeting',
      'Plymptonville',
      'Pocono Mountain Lake Estates',
      'Pocono Pines',
      'Pocono Ranch Lands',
      'Pocono Springs',
      'Pocopson',
      'Point Marion',
      'Port Allegany',
      'Port Carbon',
      'Port Matilda',
      'Port Trevorton',
      'Port Vue',
      'Portland Mills',
      'Pottsgrove',
      'Pottstown',
      'Pringle',
      'Progress',
      'Prompton',
      'Prospectville',
      'Punxsutawney',
      'Quakertown',
      'Quarryville',
      'Queen',
      'Quentin',
      'Railroad',
      'Rainsburg',
      'Ramey',
      'Ranshaw',
      'Raubsville',
      'Rauchtown',
      'Ravine',
      'Reamstown',
      'Rebersburg',
      'Refton',
      'Rehrersburg',
      'Reiffton',
      'Reinerton',
      'Reinholds',
      'Rennerdale',
      'Renningers',
      'Renovo',
      'Revloc',
      'Rew',
      'Reynolds Heights',
      'Rheems',
      'Rices Landing',
      'Richboro',
      'Richlandtown',
      'Riddlesburg',
      'Ridley Park',
      'Riegelsville',
      'Rillton',
      'Rimersburg',
      'Ringtown',
      'River View Park',
      'Rixford',
      'Roaring Spring',
      'Robesonia',
      'Rockhill',
      'Rocky Grove',
      'Rohrsburg',
      'Ronco',
      'Ronks',
      'Rose Tree',
      'Rose Valley',
      'Roseto',
      'Rossiter',
      'Rosslyn Farms',
      'Rote',
      'Rothsville',
      'Roulette',
      'Rouseville',
      'Rouzerville',
      'Rowes Run',
      'Royersford',
      'Rural Ridge',
      'Rural Valley',
      'Russellton',
      'Sabinsville',
      'Sadsburyville',
      'Saegertown',
      'Saint Lawrence',
      'Salladasburg',
      'Saltsburg',
      'Salunga',
      'Sanatoga',
      'Sand Hill',
      'Sandy Lake',
      'Sankertown',
      'Sarver',
      'Sarversville',
      'Saw Creek',
      'Saxonburg',
      'Saylorsburg',
      'Scalp Level',
      'Scarlets Mill',
      'Schaefferstown',
      'Schellsburg',
      'Schenley',
      'Schlusser',
      'Schnecksville',
      'Schoeneck',
      'Schubert',
      'Schuylkill Haven',
      'Schwenksville',
      'Selinsgrove',
      'Sellersville',
      'Seltzer',
      'Seven Fields',
      'Seven Valleys',
      'Sewickley',
      'Sewickley Heights',
      'Sewickley Hills',
      'Shade Gap',
      'Shamokin',
      'Shamokin Dam',
      'Shanksville',
      'Sharon Hill',
      'Shartlesville',
      'Shavertown',
      'Shay',
      'Sheakleyville',
      'Sheatown',
      'Shelocta',
      'Shenandoah Heights',
      'Sheppton',
      'Shickshinny',
      'Shillington',
      'Shinglehouse',
      'Shippensburg',
      'Shippenville',
      'Shippingport',
      'Shiremanstown',
      'Shirleysburg',
      'Shoemakersville',
      'Sidman',
      'Sierra View',
      'Siglerville',
      'Silkworth',
      'Silverville',
      'Skippack',
      'Skyline View',
      'Slabtown',
      'Slate Lick',
      'Slatedale',
      'Slatington',
      'Slickville',
      'Slippery Rock',
      'Slovan',
      'Smethport',
      'Smicksburg',
      'Smock',
      'Smoketown',
      'Snow Shoe',
      'Snydertown',
      'Sonestown',
      'Soudersburg',
      'Souderton',
      'South Bethlehem',
      'South Coatesville',
      'South Connellsville',
      'South Greensburg',
      'South Heights',
      'South Montrose',
      'South New Castle',
      'South Philipsburg',
      'South Pottstown',
      'South Renovo',
      'South Temple',
      'South Uniontown',
      'South Waverly',
      'South Williamsport',
      'Southview',
      'Southwest Greensburg',
      'Spartansburg',
      'Speers',
      'Spinnerstown',
      'Spring Church',
      'Spring City',
      'Spring House',
      'Spring Mills',
      'Spring Mount',
      'Springmont',
      'Spry',
      'Star Junction',
      'Starbrick',
      'Starrucca',
      'State College',
      'Steelton',
      'Sterling Run',
      'Stevens',
      'Stewartstown',
      'Stobo',
      'Stockertown',
      'Stoneboro',
      'Stonerstown',
      'Stony Creek Mills',
      'Stonybrook',
      'Stormstown',
      'Stouchsburg',
      'Stowe',
      'Stoystown',
      'Strabane',
      'Strattanville',
      'Strausstown',
      'Strodes Mills',
      'Stroudsburg',
      'Sugar Notch',
      'Summit Hill',
      'Sunrise Lake',
      'Sunset Valley',
      'Susquehanna',
      'Susquehanna Trails',
      'Sutersville',
      'Swarthmore',
      'Swartzville',
      'Sweden Valley',
      'Sweet Valley',
      'Swiftwater',
      'Swissvale',
      'Swoyersville',
      'Tafton',
      'Talley Cavey',
      'Tamaqua',
      'Tarentum',
      'Tatamy',
      'Taylorstown',
      'Taylorstown Station',
      'Telford',
      'Terre Hill',
      'The Hideout',
      'Thompsontown',
      'Thorndale',
      'Throop',
      'Tidioute',
      'Timber Hills',
      'Timblin',
      'Tobyhanna',
      'Toftrees',
      'Toughkenamon',
      'Towamensing Trails',
      'Townville',
      'Trainer',
      'Treasure Lake',
      'Trees Mills',
      'Tresckow',
      'Treveskyn',
      'Trevorton',
      'Trevose',
      'Trexlertown',
      'Trooper',
      'Trout Run',
      'Troutville',
      'Troxelville',
      'Trucksville',
      'Trumbauersville',
      'Truxall',
      'Tullytown',
      'Tunkhannock',
      'Tunnelhill',
      'Turbotville',
      'Turtle Creek',
      'Twilight',
      'Tylersburg',
      'Ulster',
      'Union Dale',
      'Union Deposit',
      'United',
      'Upper Darby',
      'Upper Exeter',
      'Upper Saint Clair',
      'Ursina',
      'Valley Forge',
      'Valley Green',
      'Valley-Hi',
      'Van Voorhis',
      'Vandergrift',
      'Vandling',
      'Vanport',
      'Village Shires',
      'Vinco',
      'Vintondale',
      'Virginville',
      'Volant',
      'Vowinckel',
      'Walkers Mill',
      'Wall',
      'Wallaceton',
      'Wallenpaupack Lake Estates',
      'Waller',
      'Walnut Bottom',
      'Walnutport',
      'Walnuttown',
      'Wampum',
      'Wanamie',
      'Warminster',
      'Warminster Heights',
      'Warrendale',
      'Warrior Run',
      'Warriors Mark',
      'Washington Boro',
      'Watsontown',
      'Watters',
      'Wattsburg',
      'Waymart',
      'Wayne Heights',
      'Weatherly',
      'Weedville',
      'Weigelstown',
      'Weissport',
      'Wellersburg',
      'Wernersville',
      'Wescosville',
      'Wesleyville',
      'West Alexander',
      'West Bristol',
      'West Brownsville',
      'West Conshohocken',
      'West Decatur',
      'West Easton',
      'West Elizabeth',
      'West Fairview',
      'West Hamburg',
      'West Hazleton',
      'West Hickory',
      'West Homestead',
      'West Kittanning',
      'West Lawn',
      'West Leechburg',
      'West Mayfield',
      'West Middlesex',
      'West Mifflin',
      'West Nanticoke',
      'West Newton',
      'West Pike',
      'West Pittsburg',
      'West Pittston',
      'West Reading',
      'West Sunbury',
      'West Vandergrift',
      'West Waynesburg',
      'West Wyoming',
      'West Wyomissing',
      'Westline',
      'Westmoreland City',
      'Westtown',
      'Wexford',
      'Whitaker',
      'White Mills',
      'Wickerham Manor',
      'Wiconisco',
      'Wilburton Number One',
      'Wilburton Number Two',
      'Wilkes-Barre',
      'Wilkinsburg',
      'Willow Grove',
      'Willow Street',
      'Wilmerding',
      'Wind Gap',
      'Wind Ridge',
      'Windber',
      'Winterstown',
      'Witmer',
      'Wolfdale',
      'Womelsdorf',
      'Woodcock',
      'Woodland Heights',
      'Woodlyn',
      'Wormleysburg',
      'Woxall',
      'Wyalusing',
      'Wyano',
      'Wylandville',
      'Wyncote',
      'Wyndmoor',
      'Wyomissing',
      'Wyomissing Hills',
      'Yardley',
      'Yatesboro',
      'Yeadon',
      'Yeagertown',
      'Yoe',
      'York Haven',
      'York Springs',
      'Yorkana',
      'Youngwood',
      'Zelienople',
    ],
    'US-PR': [
      'Aceitunas',
      'Aceitunas Comunidad',
      'Adjuntas',
      'Adjuntas Zona Urbana',
      'Aguada Zona Urbana',
      'Aguadilla',
      'Aguadilla Zona Urbana',
      'Aguas Buenas',
      'Aguas Buenas Zona Urbana',
      'Aguas Claras Comunidad',
      'Aguilita',
      'Aguilita Comunidad',
      'Aibonito',
      'Aibonito Zona Urbana',
      'Alianza Comunidad',
      'Animas Comunidad',
      'Anon Raices Comunidad',
      'Antón Ruiz',
      'Antón Ruíz Comunidad',
      'Arecibo',
      'Arecibo Zona Urbana',
      'Arroyo',
      'Arroyo Zona Urbana',
      'Añasco',
      'Añasco Zona Urbana',
      'Bairoa',
      'Bairoa La Veinticinco Comunidad',
      'Bajadero',
      'Bajadero Comunidad',
      'Bajandas',
      'Bajandas Comunidad',
      'Barahona',
      'Barahona Comunidad',
      'Barceloneta',
      'Barceloneta Zona Urbana',
      'Barranquitas',
      'Barranquitas Zona Urbana',
      'Bartolo',
      'Bartolo Comunidad',
      'Bayamón',
      'Bayamón Comunidad',
      'Bayamón Zona Urbana',
      'Benitez',
      'Benítez Comunidad',
      'Betances',
      'Betances Comunidad',
      'Boquerón Comunidad',
      'Brenas',
      'Breñas Comunidad',
      'Buena Vista Comunidad',
      'Bufalo',
      'Búfalo Comunidad',
      'Caban',
      'Cabo Rojo',
      'Cabo Rojo Zona Urbana',
      'Cabán Comunidad',
      'Cacao',
      'Cacao Comunidad',
      'Caguas',
      'Caguas Zona Urbana',
      'Calzada',
      'Calzada Comunidad',
      'Campanilla',
      'Campanilla Comunidad',
      'Campo Rico',
      'Campo Rico Comunidad',
      'Camuy',
      'Camuy Zona Urbana',
      'Candelaria Arenas',
      'Candelaria Arenas Comunidad',
      'Candelaria Comunidad',
      'Candelero Abajo Comunidad',
      'Candelero Arriba',
      'Candelero Arriba Comunidad',
      'Canovanas',
      'Canóvanas Zona Urbana',
      'Capitanejo Comunidad',
      'Carolina Zona Urbana',
      'Carrizales',
      'Carrizales Comunidad',
      'Cataño',
      'Cataño Zona Urbana',
      'Cayey',
      'Cayey Zona Urbana',
      'Cayuco',
      'Cayuco Comunidad',
      'Ceiba',
      'Ceiba Comunidad',
      'Ceiba Zona Urbana',
      'Celada',
      'Celada Comunidad',
      'Central Aguirre',
      'Central Aguirre Comunidad',
      'Cerrillos Hoyos Comunidad',
      'Ciales',
      'Ciales Zona Urbana',
      'Cidra',
      'Cidra Zona Urbana',
      'Coamo',
      'Coamo Zona Urbana',
      'Coco Comunidad',
      'Comerío',
      'Comerío Zona Urbana',
      'Comunas',
      'Comunas Comunidad',
      'Coquí',
      'Coquí Comunidad',
      'Corazón',
      'Corazón Comunidad',
      'Corcovado',
      'Corcovado Comunidad',
      'Corozal Zona Urbana',
      'Corral Viejo',
      'Corral Viejo Comunidad',
      'Coto Laurel',
      'Coto Laurel Comunidad',
      'Coto Norte',
      'Coto Norte Comunidad',
      'Culebra',
      'Culebra Zona Urbana',
      'Daguao',
      'Daguao Comunidad',
      'Dorado',
      'Dorado Zona Urbana',
      'Duque',
      'Duque Comunidad',
      'El Combate',
      'El Combate Comunidad',
      'El Mangó',
      'El Mangó Comunidad',
      'El Negro',
      'El Negro Comunidad',
      'El Ojo',
      'El Ojo Comunidad',
      'El Paraiso',
      'El Paraiso Comunidad',
      'El Tumbao',
      'El Tumbao Comunidad',
      'Emajagua',
      'Emajagua Comunidad',
      'Esperanza Comunidad',
      'Espino',
      'Espino Comunidad',
      'Fajardo',
      'Fajardo Zona Urbana',
      'Florida Zona Urbana',
      'Franquez',
      'Fránquez Comunidad',
      'Fuig',
      'Fuig Comunidad',
      'G. L. Garcia',
      'G. L. García Comunidad',
      'Galateo',
      'Galateo Comunidad',
      'Garrochales',
      'Garrochales Comunidad',
      'Guayabal Comunidad',
      'Guayama',
      'Guayama Zona Urbana',
      'Guayanilla',
      'Guayanilla Zona Urbana',
      'Guaynabo',
      'Guaynabo Zona Urbana',
      'Gurabo',
      'Gurabo Zona Urbana',
      'Guánica',
      'Guánica Zona Urbana',
      'H. Rivera Colon',
      'H. Rivera Colón Comunidad',
      'Hacienda San José Comunidad',
      'Hatillo',
      'Hatillo Zona Urbana',
      'Hato Arriba',
      'Hato Arriba Comunidad',
      'Hato Candal',
      'Hato Candal Comunidad',
      'Hormigueros',
      'Hormigueros Zona Urbana',
      'Humacao',
      'Humacao Zona Urbana',
      'Imbery',
      'Imbéry Comunidad',
      'Indios',
      'Indios Comunidad',
      'Ingenio Comunidad',
      'Isabela Zona Urbana',
      'Jagual',
      'Jagual Comunidad',
      'Jauca',
      'Jauca Comunidad',
      'Jayuya',
      'Jayuya Zona Urbana',
      'Jobos',
      'Jobos Comunidad',
      'Juana Díaz',
      'Juana Díaz Zona Urbana',
      'Juncal',
      'Juncal Comunidad',
      'Juncos',
      'Juncos Zona Urbana',
      'La Alianza',
      'La Alianza Comunidad',
      'La Dolores',
      'La Dolores Comunidad',
      'La Fermina',
      'La Fermina Comunidad',
      'La Liga Comunidad',
      'La Luisa',
      'La Luisa Comunidad',
      'La Parguera',
      'La Parguera Comunidad',
      'La Playa Comunidad',
      'La Plena',
      'La Plena Comunidad',
      'La Yuca Comunidad',
      'Lajas',
      'Lajas Zona Urbana',
      'Lamboglia',
      'Lamboglia Comunidad',
      'Lares',
      'Lares Zona Urbana',
      'Las Carolinas',
      'Las Carolinas Comunidad',
      'Las Croabas',
      'Las Croabas Comunidad',
      'Las Marias',
      'Las Marías Comunidad',
      'Las Marías Zona Urbana',
      'Las Ochenta',
      'Las Ochenta Comunidad',
      'Las Ollas',
      'Las Ollas Comunidad',
      'Las Piedras',
      'Las Piedras Zona Urbana',
      'Levittown Comunidad',
      'Liborio Negron Torres',
      'Liborio Negrón Torres Comunidad',
      'Lluveras',
      'Lluveras Comunidad',
      'Lomas Comunidad',
      'Los Llanos Comunidad',
      'Los Panes Comunidad',
      'Los Prados Comunidad',
      'Loíza',
      'Loíza Zona Urbana',
      'Luis Llorens Torres',
      'Luis Lloréns Torres Comunidad',
      'Luis M. Cintron',
      'Luis M. Cintrón Comunidad',
      'Luquillo',
      'Luquillo Zona Urbana',
      'Luyando',
      'Luyando Comunidad',
      'Magas Arriba',
      'Magas Arriba Comunidad',
      'Maguayo',
      'Maguayo Comunidad',
      'Manatí Zona Urbana',
      'Maria Antonia',
      'Mariano Colón',
      'Mariano Colón Comunidad',
      'Maricao',
      'Maricao Zona Urbana',
      'Martorell Comunidad',
      'Marueño',
      'Marueño Comunidad',
      'María Antonia Comunidad',
      'Maunabo',
      'Maunabo Zona Urbana',
      'Mayagüez',
      'Mayagüez Zona Urbana',
      'Miranda Comunidad',
      'Moca Zona Urbana',
      'Monserrate',
      'Monserrate Comunidad',
      'Monte Grande',
      'Monte Grande Comunidad',
      'Monte Verde Comunidad',
      'Mora Comunidad',
      'Morovis',
      'Morovis Zona Urbana',
      'Mucarabones',
      'Mucarabones Comunidad',
      'Naguabo',
      'Naguabo Zona Urbana',
      'Naranjito Zona Urbana',
      'Olimpo',
      'Olimpo Comunidad',
      'Orocovis',
      'Orocovis Zona Urbana',
      'Pajonal',
      'Pajonal Comunidad',
      'Palmarejo',
      'Palmarejo Comunidad',
      'Palmas Comunidad',
      'Palmas del Mar',
      'Palmas del Mar Comunidad',
      'Palmer Comunidad',
      'Palo Seco',
      'Palo Seco Comunidad',
      'Palomas Comunidad',
      'Parcelas La Milagrosa',
      'Parcelas La Milagrosa Comunidad',
      'Parcelas Mandry Comunidad',
      'Parcelas Nuevas',
      'Parcelas Nuevas Comunidad',
      'Parcelas Peñuelas',
      'Parcelas Peñuelas Comunidad',
      'Parcelas Viejas Borinquen Comunidad',
      'Parcelas de Navarro Comunidad',
      'Pastos',
      'Pastos Comunidad',
      'Patillas',
      'Patillas Zona Urbana',
      'Peña Pobre',
      'Peña Pobre Comunidad',
      'Peñuelas',
      'Peñuelas Zona Urbana',
      'Piedra Aguza Comunidad',
      'Piedra Gorda',
      'Piedra Gorda Comunidad',
      'Playa Fortuna',
      'Playa Fortuna Comunidad',
      'Playita',
      'Playita Comunidad',
      'Playita Cortada',
      'Playita Cortada Comunidad',
      'Pole Ojea',
      'Pole Ojea Comunidad',
      'Ponce',
      'Ponce Zona Urbana',
      'Potala Pastillo',
      'Potala Pastillo Comunidad',
      'Pueblito del Carmen Comunidad',
      'Pueblito del Rio',
      'Pueblito del Río Comunidad',
      'Puerto Real Comunidad',
      'Punta Santiago',
      'Punta Santiago Comunidad',
      'Pájaros',
      'Pájaros Comunidad',
      'Quebrada',
      'Quebrada Comunidad',
      'Quebrada del Agua Comunidad',
      'Quebradillas',
      'Quebradillas Zona Urbana',
      'Rafael Capo',
      'Rafael Capó Comunidad',
      'Rafael Gonzalez',
      'Rafael González Comunidad',
      'Rafael Hernandez',
      'Rafael Hernández Comunidad',
      'Ramos',
      'Ramos Comunidad',
      'Rincón',
      'Rincón Zona Urbana',
      'Rodríguez Hevia',
      'Rodríguez Hevia Comunidad',
      'Rosa Sanchez',
      'Rosa Sánchez Comunidad',
      'Río Blanco Comunidad',
      'Río Cañas Abajo',
      'Río Cañas Abajo Comunidad',
      'Río Grande Zona Urbana',
      'Río Lajas',
      'Río Lajas Comunidad',
      'Sabana',
      'Sabana Comunidad',
      'Sabana Eneas',
      'Sabana Eneas Comunidad',
      'Sabana Grande',
      'Sabana Grande Zona Urbana',
      'Sabana Hoyos',
      'Sabana Hoyos Comunidad',
      'Sabana Seca',
      'Sabana Seca Comunidad',
      'Salinas Zona Urbana',
      'San Antonio Comunidad',
      'San Germán',
      'San Germán Zona Urbana',
      'San Isidro Comunidad',
      'San José Comunidad',
      'San Juan Zona Urbana',
      'San Lorenzo Zona Urbana',
      'San Sebastián Zona Urbana',
      'Santa Bárbara Comunidad',
      'Santa Clara Comunidad',
      'Santa Isabel Zona Urbana',
      'Santo Domingo Comunidad',
      'Stella Comunidad',
      'Sumidero',
      'Suárez Comunidad',
      'Tallaboa',
      'Tallaboa Alta',
      'Tallaboa Alta Comunidad',
      'Tallaboa Comunidad',
      'Tibes Comunidad',
      'Tiburones',
      'Tiburones Comunidad',
      'Tierras Nuevas Poniente',
      'Tierras Nuevas Poniente Comunidad',
      'Toa Alta',
      'Toa Alta Zona Urbana',
      'Toa Baja',
      'Toa Baja Zona Urbana',
      'Trujillo Alto',
      'Trujillo Alto Zona Urbana',
      'Utuado',
      'Utuado Zona Urbana',
      'Vayas',
      'Vayas Comunidad',
      'Vega Alta',
      'Vega Alta Zona Urbana',
      'Vega Baja',
      'Vega Baja Zona Urbana',
      'Vieques',
      'Vieques Comunidad',
      'Vieques Zona Urbana',
      'Villalba Zona Urbana',
      'Vázquez',
      'Vázquez Comunidad',
      'Yabucoa',
      'Yabucoa Zona Urbana',
      'Yauco',
      'Yauco Zona Urbana',
      'Yaurel',
      'Yaurel Comunidad',
    ],
    'US-RI': [
      'Ashaway',
      'Centerdale',
      'Central Falls',
      'Chepachet',
      'Cumberland Hill',
      'East Providence',
      'Foster Center',
      'Georgiaville',
      'Hope Valley',
      'Misquamicut',
      'Narragansett Pier',
      'North Foster',
      'Pascoag',
      'Pawtucket',
      'Quonochontaug',
      'Saunderstown',
      'Tiverton',
      'Union Village',
      'Watch Hill',
      'Weekapaug',
      'West Kingston',
      'Westerly',
      'Woonsocket',
    ],
    'US-SC': [
      'Aiken',
      'Alcolu',
      'Antreville',
      'Arcadia Lakes',
      'Arial',
      'Awendaw',
      'Aynor',
      'Ballentine',
      'Batesburg-Leesville',
      'Bennettsville',
      'Bethera',
      'Blacksburg',
      'Blackstock',
      'Blenheim',
      'Blythewood',
      'Bonneau',
      'Bonneau Beach',
      'Boyden Arbor',
      'Briarcliffe Acres',
      'Brunson',
      'Burnettown',
      'Cades',
      'Calhoun Falls',
      'Campobello',
      'Canadys',
      'Cane Savannah',
      'Cassatt',
      'Centenary',
      'Central Pacolet',
      'Chappells',
      'Cherokee Falls',
      'Cherry Grove Beach',
      'Chesnee',
      'City View',
      'Clemson',
      'Cokesbury',
      'Coosawhatchie',
      'Coronaca',
      'Cottageville',
      'Coward',
      'Cowpens',
      'Cross',
      'Cross Anchor',
      'Cross Hill',
      'Daufuskie Landing',
      'Dentsville',
      'Donalds',
      'Due West',
      'Dunean',
      'Early Branch',
      'Easley',
      'East Gaffney',
      'East Sumter',
      'Edisto',
      'Edisto Beach',
      'Edisto Island',
      'Ehrhardt',
      'Elloree',
      'Enoree',
      'Eureka Mill',
      'Eutawville',
      'Fairforest',
      'Fingerville',
      'Five Forks',
      'Floydale',
      'Folly Beach',
      'Forest Acres',
      'Forestbrook',
      'Fort Lawn',
      'Fort Mill',
      'Fort Motte',
      'Fountain Inn',
      'Furman',
      'Gaffney',
      'Galivants Ferry',
      'Gayle Mill',
      'Gloverville',
      'Gluck',
      'Golden Grove',
      'Govan',
      'Gramling',
      'Graves',
      'Gray Court',
      'Grays Hill',
      'Greeleyville',
      'Hanahan',
      'Hardeeville',
      'Harleyville',
      'Heath Springs',
      'Hemingway',
      'Hilda',
      'Hilton Head Island',
      'Homeland Park',
      'Honea Path',
      'Horrel Hill',
      'India Hook',
      'Inman Mills',
      'Irmo',
      'Islandton',
      'Isle of Palms',
      'Iva',
      'Jacksonboro',
      'Jenkinsville',
      'Johns Island',
      'Kershaw',
      'Kiawah Island',
      'Kinards',
      'Kingstree',
      'Ladson',
      'Lake Secession',
      'Lake Wylie',
      'Lando',
      'Landrum',
      'Laurel Bay',
      'Lesslie',
      'Little Mountain',
      'Lobeco',
      'Longs',
      'Loris',
      'Lowndesville',
      'Lowrys',
      'Lugoff',
      'Mauldin',
      'Mayesville',
      'McBee',
      'McClellanville',
      'McColl',
      'McConnells',
      'Meggett',
      'Meriwether',
      'Miley',
      'Millett',
      'Moncks Corner',
      'Monetta',
      'Morgana',
      'Mount Croghan',
      'Mullins',
      'Murphys Estates',
      'Murrells Inlet',
      'Myrtle Beach',
      'Neeses',
      'Nesmith',
      'New Ellenton',
      'New Zion',
      'Ninety Six',
      'Nixons Crossroads',
      'North Augusta',
      'North Charleston',
      'North Hartsville',
      'North Myrtle Beach',
      'Olanta',
      'Olar',
      'Pacolet',
      'Pacolet Mills',
      'Pageland',
      'Pamplico',
      'Pawleys Island',
      'Paxville',
      'Peak',
      'Pee Dee',
      'Pelion',
      'Pelzer',
      'Pinopolis',
      'Plum Branch',
      'Pocalla Springs',
      'Pomaria',
      'Powdersville',
      'Privateer',
      'Quinby',
      'Rains',
      'Ravenel',
      'Rembert',
      'Richtex',
      'Ridge Spring',
      'Rion',
      'Roebuck',
      'Rowesville',
      'Salley',
      'Salters',
      'Sangaree',
      'Sans Souci',
      'Saxon',
      'Seabrook Island',
      'Sellers',
      'Seven Oaks',
      'Shell Point',
      'Shulerville',
      'Silverstreet',
      'Smoaks',
      'Socastee',
      'South Congaree',
      'South Sumter',
      'Southern Shops',
      'Spartanburg',
      'Startex',
      'Stateburg',
      'Stuckey',
      'Sullivans Island',
      'Summerton',
      'Surfside Beach',
      'Taylors',
      'Tega Cay',
      'Tigerville',
      'Timmonsville',
      'Tradesville',
      'Travelers Rest',
      'Turbeville',
      'Ulmer',
      'Van Wyck',
      'Varnville',
      'Vaucluse',
      'Verdery',
      'Wade Hampton',
      'Wagener',
      'Walterboro',
      'Ware Place',
      'Ware Shoals',
      'Wateree',
      'Wellford',
      'West Columbia',
      'West Pelzer',
      'Whitmire',
      'Wilkinson Heights',
      'Willington',
      'Winnsboro Mills',
      'Wisacky',
      'Yemassee',
    ],
    'US-SD': [
      'Academy',
      'Agar',
      'Akaska',
      'Albee',
      'Alcester',
      'Artas',
      'Artesian',
      'Ashland Heights',
      'Aurora Center',
      'Batesland',
      'Bath Corner',
      'Belle Fourche',
      'Big Stone City',
      'Bijou Hills',
      'Blunt',
      'Bon Homme Colony',
      'Bonesteel',
      'Bonilla',
      'Bowdle',
      'Brandt',
      'Brant Lake',
      'Brentford',
      'Broadland',
      'Buffalo Chip',
      'Buffalo Gap',
      'Bullhead',
      'Burdock',
      'Camp Crook',
      'Canistota',
      'Canning',
      'Capa',
      'Caputa',
      'Castlewood',
      'Cedar Butte',
      'Claire City',
      'Colome',
      'Colonial Pine Hills',
      'Conata',
      'Corn Creek',
      'Cresbard',
      'Crooks',
      'Dakota Dunes',
      'Dante',
      'Deadwood',
      'Dell Rapids',
      'Denby',
      'Dimock',
      'Doland',
      'Draper',
      'Dupree',
      'Eagle Butte',
      'Emery',
      'Enning',
      'Estelline',
      'Ethan',
      'Fairpoint',
      'Faulkton',
      'Fedora',
      'Ferney',
      'Firesteel',
      'Flandreau',
      'Fort Pierre',
      'Fort Thompson',
      'Garretson',
      'Gayville',
      'Geddes',
      'Glad Valley',
      'Glencross',
      'Glenham',
      'Goodwill',
      'Green Grass',
      'Hamill',
      'Harrold',
      'Hecla',
      'Hermosa',
      'Herreid',
      'Hetland',
      'Hidden Timber',
      'Highmore',
      'Hilland',
      'Hillsview',
      'Hisle',
      'Holabird',
      'Hosmer',
      'Hoven',
      'Howes',
      'Igloo',
      'Interior',
      'Irene',
      'Iron Lightning',
      'Java',
      'Johnson Siding',
      'Junius',
      'Kadoka',
      'Kaylor',
      'Kenel',
      'Kennebec',
      'Keyapaha',
      'Kirley',
      'Kranzburg',
      'Kyle',
      'La Plant',
      'LaBolt',
      'Ladner',
      'Lake Andes',
      'Lake Norden',
      'Lake Preston',
      'Lantry',
      'Lead',
      'Lemmon',
      'Lily',
      'Little Eagle',
      'Lower Brule',
      'Manderson',
      'Marty',
      'Maurine',
      'McLaughlin',
      'Meadow',
      'Meadow View Addition',
      'Meckling',
      'Mellette',
      'Menno',
      'Milbank',
      'Milesville',
      'Millboro',
      'Mission Hill',
      'Mission Ridge',
      'Mobridge',
      'Mosher',
      'Mud Butte',
      'Murdo',
      'Nemo',
      'New Effington',
      'New Underwood',
      'Nisland',
      'North Eagle Butte',
      'North Sioux City',
      'Nowlin',
      'Oacoma',
      'Oelrichs',
      'Oglala',
      'Okaton',
      'Okreek',
      'Olsonville',
      'Onaka',
      'Onida',
      'Opal',
      'Oral',
      'Ortley',
      'Owanka',
      'Parade',
      'Parkston',
      'Parmelee',
      'Patricia',
      'Pedro',
      'Peever',
      'Philip',
      'Pickstown',
      'Pierre',
      'Pine Lakes Addition',
      'Plankinton',
      'Platte',
      'Potato Creek',
      'Presho',
      'Pukwana',
      'Quinn',
      'Ralph',
      'Rapid Valley',
      'Ravinia',
      'Red Elm',
      'Red Shirt',
      'Redig',
      'Redowl',
      'Ree Heights',
      'Reliance',
      'Renner',
      'Renner Corner',
      'Reva',
      'Revillo',
      'Ridgeview',
      'Rockerville',
      'Rockham',
      'Rosholt',
      'Running Water',
      'Saint Onge',
      'Scenic',
      'Selby',
      'Shadehill',
      'Shindler',
      'Sinai',
      'Sioux Falls',
      'Sisseton',
      'Smithwick',
      'Soldier Creek',
      'Sorum',
      'Spearfish',
      'Spink',
      'Stephan',
      'Storla',
      'Strandburg',
      'Summerset',
      'Tea',
      'Thunder Butte',
      'Thunder Hawk',
      'Tilford',
      'Timber Lake',
      'Tolstoy',
      'Trail City',
      'Tripp',
      'Tschetter Colony',
      'Turton',
      'Tuthill',
      'Twin Brooks',
      'Two Strike',
      'Tyndall',
      'Unityville',
      'Van Metre',
      'Veblen',
      'Vetal',
      'Viborg',
      'Viewfield',
      'Volin',
      'Wakonda',
      'Wakpala',
      'Wanblee',
      'Wasta',
      'Watauga',
      'Waubay',
      'Wendte',
      'Wessington',
      'Wessington Springs',
      'Wetonka',
      'Wewela',
      'White Butte',
      'White Owl',
      'Whitewood',
      'Wicksville',
      'Willow Lake',
      'Winfred',
      'Winner',
      'Wolsey',
      'Wood',
      'Worthing',
      'Wounded Knee',
      'Yankton',
      'Zell',
    ],
    'US-TN': [
      'Alcoa',
      'Algood',
      'Allardt',
      'Allons',
      'Alnwick',
      'Apison',
      'Ashland City',
      'Ashport',
      'Auburntown',
      'Baneberry',
      'Banner Hill',
      'Bean Station',
      'Beech Bluff',
      'Beechgrove',
      'Beersheba Springs',
      'Belinda City',
      'Bell Buckle',
      'Belle Meade',
      'Bells',
      'Bemis',
      'Berry Hill',
      'Bethel Springs',
      'Blountville',
      'Bold Spring',
      'Boma',
      'Bon Aqua Junction',
      'Braden',
      'Bransford',
      'Briceville',
      'Bruceton',
      'Buffalo Valley',
      'Bulls Gap',
      'Bumpus Mills',
      'Burlison',
      'Byrdstown',
      'Campaign',
      'Capleville',
      'Castalian Springs',
      'Chestnut Mound',
      'Chewalla',
      'Clairfield',
      'Clarkrange',
      'Coalfield',
      'College Grove',
      'Collegedale',
      'Collinwood',
      'Colonial Heights',
      'Conasauga',
      'Cookeville',
      'Coopertown',
      'Copperhill',
      'Corryton',
      'Cottontown',
      'Counce',
      'Crump',
      'Culleoka',
      'Cumberland Furnace',
      'Cumberland Gap',
      'Cypress Inn',
      'Dandridge',
      'Darden',
      'Daus',
      'De Rossett',
      'Decherd',
      'Difficult',
      'Dodson Branch',
      'Dowelltown',
      'Dyersburg',
      'Eagleton Village',
      'East Ridge',
      'Eastview',
      'Elizabethton',
      'Elk Valley',
      'Elora',
      'Enville',
      'Estill Springs',
      'Evensville',
      'Fair Garden',
      'Fairfield Glade',
      'Fall Branch',
      'Falling Water',
      'Farner',
      'Finger',
      'Flat Woods',
      'Flintville',
      'Forbus',
      'Fork Mountain',
      'Fowlkes',
      'Frankewing',
      'Gainesboro',
      'Gallaway',
      'Gatlinburg',
      'Gilt Edge',
      'Gladeville',
      'Gleason',
      'Goodlettsville',
      'Gordonsville',
      'Graball',
      'Green Brier',
      'Green Hill',
      'Greenback',
      'Greeneville',
      'Grimsley',
      'Gruetli-Laager',
      'Guys',
      'Halls Crossroads',
      'Hanging Limb',
      'Helenwood',
      'Hermitage Springs',
      'Hickory Valley',
      'Hixson',
      'Hohenwald',
      'Holladay',
      'Hollow Rock',
      'Holts Corner',
      'Hornbeak',
      'Hornsby',
      'Huntland',
      'Indian Mound',
      'Jacksboro',
      'Jellico',
      'Jonesborough',
      'Karns',
      'Kimmins',
      'Kingsport',
      'Kingston Springs',
      'La Vergne',
      'LaFollette',
      'Lake Tansi',
      'Lakesite',
      'Lancing',
      'Leipers Fork',
      'Lenoir City',
      'Leoma',
      'Lobelville',
      'Lone Mountain',
      'Luttrell',
      'Lutts',
      'Lyles',
      'Lynn Garden',
      'Malesus',
      'Marbledale',
      'Maury City',
      'Maynardville',
      'McEwen',
      'McLemoresville',
      'Medon',
      'Michie',
      'Middle Valley',
      'Midtown',
      'Minor Hill',
      'Monteagle',
      'Mooresburg',
      'Mosheim',
      'Moss',
      'Mount Juliet',
      'Neubert',
      'New Deal',
      'New Johnsonville',
      'New Tazewell',
      'New Union',
      'Niota',
      'Nolensville',
      'Nough',
      'Nunnelly',
      'Obion',
      'Oliver Springs',
      'Ooltewah',
      'Orlinda',
      'Orme',
      'Overall',
      'Palmersville',
      'Parker Crossroads',
      'Parrottsville',
      'Petros',
      'Pigeon Forge',
      'Pine Crest',
      'Piperton',
      'Pittman Center',
      'Powells Crossroads',
      'Puryear',
      'Quebeck',
      'Reagan',
      'Red Boiling Springs',
      'Rheatown',
      'Rickman',
      'Ridgeside',
      'Ridgetop',
      'RoEllen',
      'Roan Mountain',
      'Rocky Fork',
      'Rocky Top',
      'Rosemark',
      'Rural Hill',
      'Saint Bethlehem',
      'Sale Creek',
      'Samburg',
      'Saulsbury',
      'Scotts Hill',
      'Selmer',
      'Sevierville',
      'Sewanee',
      'Shackle Island',
      'Shawanee',
      'Shop Springs',
      'Shouns',
      'Signal Mountain',
      'Silerton',
      'Sneedville',
      'Soddy-Daisy',
      'South Carthage',
      'South Cleveland',
      'South Pittsburg',
      'South Tunnel',
      'Stantonville',
      'Strawberry Plains',
      'Sunbright',
      'Surgoinsville',
      'Talbott',
      'Tasso',
      'Tellico Plains',
      'Ten Mile',
      'Tennessee City',
      'Tennessee Ridge',
      'Theta',
      "Thompson's Station",
      'Three Way',
      'Tiptonville',
      'Toone',
      'Tracy City',
      'Trezevant',
      'Tullahoma',
      'Tusculum',
      'Unicoi',
      'Vanleer',
      'Vonore',
      'Walland',
      'Walterhill',
      'Wartburg',
      'Wartrace',
      'West Shiloh',
      'Westel',
      'White Bluff',
      'White House',
      'Whitwell',
      'Wildersville',
      'Wildwood Lake',
      'Willette',
      'Woodland Mills',
      'Wynnburg',
    ],
    'US-TX': [
      'Abell',
      'Abernathy',
      'Abram',
      'Ace',
      'Ackerly',
      'Addicks',
      'Agnes',
      'Agua Nueva',
      'Airport Road Addition',
      'Alamo Alto',
      'Alamo Heights',
      'Alanreed',
      'Aldine',
      'Algerita',
      'Algoa',
      'Alice Acres',
      'Allenfarm',
      'Alleyton',
      'Aloe',
      'Amargosa Colonia',
      'Amarillo',
      'Amaya Colonia',
      'Amistad Acres',
      'Angeles',
      'Angleton',
      'Annetta',
      'Annetta North',
      'Annetta South',
      'Annona',
      'Apple Springs',
      'Appleby',
      'Aransas Pass',
      'Archer City',
      'Arney',
      'Arno',
      'Arp',
      'Arroyo Colorado Estates Colonia',
      'Arroyo Gardens',
      'Art',
      'Artesia Wells',
      'Arthur City',
      'Arvana',
      'Asherton',
      'Ashtola',
      'Aspermont',
      'Atascocita',
      'Augustus',
      'Austonio',
      'Austwell',
      'Avinger',
      'Azle',
      'B and E Colonia',
      'Bacliff',
      'Bagwell',
      'Bailey Prairie',
      'Balch Springs',
      'Balcones Heights',
      'Baldridge',
      'Ballinger',
      'Balmorhea',
      'Bammel',
      'Bandera',
      'Bandera Falls',
      'Bangs',
      'Barksdale',
      'Barton Creek',
      'Batson',
      'Bautista',
      'Bayside',
      'Bayside Terrace',
      'Baytown',
      'Beasley',
      'Beaumont Place',
      'Bebe',
      'Beckville',
      'Becton',
      'Bedias',
      'Bee Cave',
      'Beeville',
      'Belcherville',
      'Belfalls',
      'Bellmead',
      'Ben Arnold',
      'Ben Bolt',
      'Ben Wheeler',
      'Benbrook',
      'Benchley',
      'Benjamin',
      'Benonine',
      'Berclair',
      'Bernecker',
      'Bernstein',
      'Bessmay',
      'Best',
      'Bettie',
      'Bevil Oaks',
      'Big Wells',
      'Bigfoot',
      'Bishop Hills',
      'Bivins',
      'Blanket',
      'Bleakwood',
      'Bledsoe',
      'Blessing',
      'Blewett',
      'Bloomburg',
      'Blooming Grove',
      'Blossom',
      'Blue Berry Hill',
      'Bluetown',
      'Bluetown Colonia',
      'Bluff Dale',
      'Blum',
      'Blumenthal',
      'Boden',
      'Boerne',
      'Bogata',
      'Boling',
      'Bolivar Peninsula',
      'Bomarton',
      'Bon Wier',
      'Bonham',
      'Bonney',
      'Booker',
      'Boquillas Crossing',
      'Borger',
      'Botines',
      'Bovina',
      'Boydston',
      'Boys Ranch',
      'Bozar',
      'Brachfield',
      'Bracken',
      'Brackettville',
      'Brad',
      'Brand',
      'Branton',
      'Brazoria',
      'Brazos Bend',
      'Brazos Country',
      'Bremond',
      'Brenham',
      'Breslau',
      'Briaroaks',
      'Briscoe',
      'Broaddus',
      'Brookeland',
      'Brookesmith',
      'Brookshire',
      'Brookside Village',
      'Browndell',
      'Brownsboro',
      'Bruceville-Eddy',
      'Brundage',
      'Bruni',
      'Brushy Creek',
      'Bryden',
      'Bryson',
      'Buchanan Dam',
      'Buchanan Lake Village',
      'Buckholts',
      'Buena Vista Colonia',
      'Buenos',
      'Buffalo Springs',
      'Bulverde',
      'Buna',
      'Bunavista',
      'Bunker Hill Village',
      'Burkburnett',
      'Burkett',
      'Burkeville',
      'Burleson',
      'Burnet',
      'Burris',
      'Bushland',
      'Cactus',
      'Caddo Mills',
      'Calliham',
      'Callisburg',
      'Cameron Park Colonia',
      'Camp San Saba',
      'Camp Swift',
      'Camp Wood',
      'Caney City',
      'Cantu Addition',
      'Canutillo',
      'Canyon Valley',
      'Cap Rock',
      'Capps Switch',
      'Caps',
      'Cargray',
      'Carls Corner',
      'Carmine',
      'Carrizo Hill',
      'Carrizo Springs',
      'Carta Valley',
      'Casa Piedra',
      'Cashion Community',
      'Cason',
      'Castle Hills',
      'Castolon',
      'Cat Spring',
      'Cedar Park',
      'Cee Vee',
      'Cego',
      'Celeste',
      'Central Gardens',
      'Chalk Mountain',
      'Chamberlin',
      'Channelview',
      'Channing',
      'Chapman Ranch',
      'Chappell Hill',
      'Chateau Woods',
      'Cherry Spring',
      'Childress',
      'China Springs',
      'Chireno',
      'Chispa',
      'Choate',
      'Chriesman',
      'Christoval',
      'Chula Vista Colonia',
      'Cibolo',
      'Cienegas Terrace',
      'Cinco Ranch',
      'Cistern',
      'Citrus City',
      'Clairemont',
      'Clairette',
      'Clarksville City',
      'Claude',
      'Clauene',
      'Clear Lake City',
      'Clear Lake Shores',
      'Cleburne',
      'Cleo',
      'Cleta',
      'Cline',
      'Clint',
      'Cloverleaf',
      'Clute',
      'Coady',
      'Coble',
      'Cockrell Hill',
      'Codman',
      'Coffee City',
      'Coldspring',
      'Colleyville',
      'Colmesneil',
      'Colonia Iglesia Antigua',
      'Comal',
      'Combes',
      'Combine',
      'Comfort',
      'Concan',
      'Concrete',
      'Cone',
      'Conlen',
      'Conroe',
      'Cookville',
      'Cool',
      'Coppell',
      'Copper Canyon',
      'Copperas Cove',
      'Corbet',
      'Cornudas',
      'Corral City',
      'Corrigan',
      'Corsicana',
      'Cost',
      'Cottonwood Shores',
      'Cotulla',
      'Coughran',
      'Coupland',
      'Coyanosa',
      'Coyote Acres',
      'Cranell',
      'Cranfills Gap',
      'Crosbyton',
      'Cross Cut',
      'Cross Mountain',
      'Cross Timber',
      'Crowell',
      'Cuero',
      'Cuevitas',
      'Cumby',
      'Cumings',
      'Cuney',
      'Cut',
      'Cut and Shoot',
      'Cuyler',
      'César Chávez',
      "D'Hanis",
      'DISH',
      'Daingerfield',
      'Daisetta',
      'Dalhart',
      'Dallardsville',
      'Dalworthington Gardens',
      'Damon',
      'Danevang',
      'Darco',
      'Darrouzett',
      'Davilla',
      'Dayton Lakes',
      'De Berry',
      'De Leon',
      'DeCordova',
      'Deanville',
      'Del Mar Heights',
      'Del Sol Colonia',
      'Del Valle',
      'Dell City',
      'Delmita',
      'Democrat',
      'Denver City',
      'Deport',
      'Desdemona',
      'Desert',
      'Devers',
      'Devine',
      'Dew',
      'Dewalt',
      'Deweyville',
      'Dialville',
      'Diana',
      'Diboll',
      'Dickworsham',
      'Dilley',
      'Dime Box',
      'Dimmitt',
      'Dinero',
      'Dirgin',
      'Dittlinger',
      'Dobbin',
      'Dodd City',
      'Doffing',
      'Domino',
      'Donie',
      'Donna',
      'Doole',
      'Double Bayou',
      'Double Oak',
      'Doucette',
      'Douro',
      'Dunlay',
      'Duster',
      'Eagle Flat',
      'Eagle Pass',
      'Earth',
      'East Bernard',
      'East Mountain',
      'East Tawakoni',
      'Easterly',
      'Eastland',
      'Ector',
      'Edcouch',
      'Eddy',
      'Edge',
      'Edgecliff Village',
      'Edgewater Estates',
      'Edith',
      'Edmonson',
      'Edom',
      'Edroy',
      'Eidson Road',
      'El Camino Angosto',
      'El Campo',
      'El Cenizo Colonia',
      'El Indio',
      'El Lago',
      'El Sauz',
      'Electra',
      'Eliasville',
      'Ella',
      'Ellinger',
      'Elm Mott',
      'Elmendorf',
      'Elsa',
      'Emhouse',
      'Enchanted Oaks',
      'Enloe',
      'Enochs',
      'Era',
      'Escobares',
      'Escobas',
      'Eskota',
      'Estes',
      'Etter',
      'Euless',
      'Eustace',
      'Evadale',
      'Evant',
      'Evergreen Colonia',
      'Everman',
      'Exell',
      'Exum',
      'Ezzell',
      'Fabens',
      'Fair Oaks Ranch',
      'Fairchilds',
      'Falcon Lake Estates',
      'Falcon Mesa',
      'Falcon Village',
      'Falfurrias',
      'Falman',
      'Fannett',
      'Fannin',
      'Farmers Branch',
      'Farnsworth',
      'Farrar',
      'Farrsville',
      'Fashing',
      'Fate',
      'Faysville',
      'Fentress',
      'Fifth Street',
      'Finlay',
      'Finney',
      'First Colony',
      'Fischer',
      'Flatonia',
      'Flo',
      'Flomot',
      'Florence Hill',
      'Floresville',
      'Florey',
      'Flowella',
      'Flower Mound',
      'Floydada',
      'Flynn',
      'Foard City',
      'Follett',
      'Forest Glade',
      'Forsan',
      'Fort Chadbourne',
      'Fort Clark Springs',
      'Fort Gates',
      'Fort Griffin',
      'Fort Hancock',
      'Fort Stockton',
      'Fort Worth',
      'Four Points Colonia',
      'Four Way',
      'Francitas',
      'Freer',
      'Friday',
      'Friendswood',
      'Friona',
      'Fritch',
      'Fronton',
      'Fullerville',
      'Fulshear',
      'Gageby',
      'Gail',
      'Galena Park',
      'Garceno',
      'Garciasville',
      'Garden Ridge',
      'Gause',
      'George West',
      'Giddings',
      'Giles',
      'Gilmer',
      'Girvin',
      'Gladewater',
      'Glass',
      'Glazier',
      'Glen Flora',
      'Glen Rose',
      'Glenn Heights',
      'Gober',
      'Goldsmith',
      'Goldthwaite',
      'Goliad',
      'Golinda',
      'Goober Hill',
      'Goodlett',
      'Goodlow Park',
      'Goree',
      'Graford',
      'Granbury',
      'Grand Prairie',
      'Grand Saline',
      'Grandfalls',
      'Granite Shoals',
      'Granjeno',
      'Grape Creek',
      'Grapeland',
      'Grayburg',
      'Grays Prairie',
      'Greatwood',
      'Green Valley Farms',
      'Grey Forest',
      'Grit',
      'Groom',
      'Groves',
      'Gruene',
      'Gruhlkey',
      'Guerra',
      'Gun Barrel City',
      'Gunter',
      'Hale Center',
      'Hallettsville',
      'Hallsburg',
      'Haltom City',
      'Hankamer',
      'Happy',
      'Hargill',
      'Harker Heights',
      'Harkeyville',
      'Harleton',
      'Haslet',
      'Hasse',
      'Hatchel',
      'Hawk Cove',
      'Hawkins',
      'Hearne',
      'Heaton',
      'Hebbronville',
      'Heckville',
      'Hedley',
      'Hedwig Village',
      'Hedwigs Hill',
      'Helotes',
      'Hemphill',
      'Henly',
      'Hermleigh',
      'Herty',
      'Hext',
      'Hickory Creek',
      'Hideaway',
      'Higgins',
      'High Island',
      'Highbank',
      'Highland Haven',
      'Highland Village',
      'Hilburn',
      'Hill Country Village',
      'Hillister',
      'Hills Prairie',
      'Hilltop Colonia',
      'Hilltop Lakes',
      'Hilshire Village',
      'Hitchland',
      'Hoban',
      'Hochheim',
      'Hockley',
      'Holiday Beach',
      'Holiday Lakes',
      'Hollywood Park',
      'Honey Grove',
      'Honey Island',
      'Hooks',
      'Horizon City',
      'Hornsby Bend',
      'Houmont Park',
      'Howardwick',
      'Huckabay',
      'Hudson Bend',
      'Hudson Oaks',
      'Huffman',
      'Hughes Springs',
      'Humble',
      'Hungerford',
      'Hunters Creek Village',
      'Huntoon',
      'Hutto',
      'Hye',
      'Iago',
      'Idalou',
      'Impact',
      'Inadale',
      'India',
      'Ingleside On-the-Bay',
      'Iowa Colony',
      'Iowa Park',
      'Iraan',
      'Iredell',
      'Italy',
      'Jacinto City',
      'Jamaica Beach',
      'Jarrell',
      'Jayton',
      'Jersey Village',
      'Joaquin',
      'Joel',
      'Johnfarris',
      'Johnsons Station',
      'Johnstone',
      'Johntown',
      'Jolly',
      'Jollyville',
      'Jonah',
      'Jones Creek',
      'Josephine',
      'Joshua',
      'Jourdanton',
      'Jubilee Springs',
      'Juilliard',
      'Juliff',
      'Juno',
      'Justiceburg',
      'Justin',
      'K-Bar Ranch',
      'Kadane Corner',
      'Kaffir',
      'Kamey',
      'Karnack',
      'Karnes City',
      'Katemcy',
      'Katy',
      'Kaufman',
      'Keenan',
      'Kellerville',
      'Kelsay',
      'Keltys',
      'Kemah',
      'Kempner',
      'Kendleton',
      'Kenedy',
      'Kenefick',
      'Kennedale',
      'Kerens',
      'Kermit',
      'Kerrville',
      'Key',
      'Killeen',
      'Kingsmill',
      'Kingwood',
      'Kinwood',
      'Kirvin',
      'Kitalou',
      'Knippa',
      'Kohrville',
      'Kopperl',
      'Kosse',
      'Kountze',
      'Kress',
      'Krugerville',
      'Krum',
      'Kurten',
      'La Blanca',
      'La Casita',
      'La Coste',
      'La Feria',
      'La Grulla',
      'La Homa',
      'La Marque',
      'La Paloma Addition Colonia',
      'La Pryor',
      'La Puerta',
      'La Rosita',
      'La Tina Ranch',
      'La Vernia',
      'La Villa',
      'La Ward',
      'Lacy-Lakeview',
      'Lago Vista',
      'Laguna Heights',
      'Laguna Park',
      'Laguna Seca',
      'Laguna Vista',
      'Laird Hill',
      'Lajitas',
      'Lake Bridgeport',
      'Lake Brownwood',
      'Lake Dallas',
      'Lake Dunlap',
      'Lake Jackson',
      'Lake Kiowa',
      'Lake Tanglewood',
      'Lakehills',
      'Lakeland Heights',
      'Lakeside City',
      'Lakeway',
      'Lakewood Heights',
      'Lakewood Village',
      'Lamesa',
      'Lamkin',
      'Lampasas',
      'Laneville',
      'Langtry',
      'Laredo Ranchettes',
      'Lariat',
      'Las Lomitas',
      'Las Quintas Fronterizas',
      'Las Quintas Fronterizas Colonia',
      'Lasana',
      'Lasara',
      'Lassater',
      'Latexo',
      'Lautz',
      'Lavon',
      'Lazare',
      'League City',
      'Leakey',
      'Lefors',
      'Lehman',
      'Lela',
      'Lelia Lake',
      'Leming',
      'Lenorah',
      'Lenz',
      'Leo',
      'Leon Junction',
      'Leon Valley',
      'Lesley',
      'Levelland',
      'Liberty City',
      'Lilbert',
      'Lindberg',
      'Lindenau',
      'Lipan',
      'Lissie',
      'Littig',
      'Little Cypress',
      'Little Elm',
      'Little River-Academy',
      'Llano',
      'Llano Grande',
      'Lockett',
      'Lockney',
      'Loeb',
      'Log Cabin',
      'Lolita',
      'Loma Alta',
      'Loma Grande Colonia',
      'Loma Linda Colonia',
      'Loma Linda East Colonia',
      'Loma Vista Colonia',
      'Lometa',
      'Long Mott',
      'Longworth',
      'Loop',
      'Lopezville',
      'Lopeño',
      'Lord',
      'Los Altos Colonia',
      'Los Alvarez',
      'Los Barreras',
      'Los Ebanos',
      'Los Ebanos Colonia',
      'Los Fresnos',
      'Los Indios',
      'Los Villareales',
      'Los Ybanez',
      'Lott',
      'Lovelady',
      'Lowry Crossing',
      'Loyal Valley',
      'Lozano',
      'Lubbock',
      'Lueders',
      'Lufkin',
      'Lums Chapel',
      'Lutie',
      'Lyford',
      'Lytle',
      'Mabank',
      'Mabelle',
      'Macdona',
      'Machovec',
      'Magasco',
      'Magnolia Beach',
      'Magnolia Gardens',
      'Magoun',
      'Magwalt',
      'Malvado',
      'Manchaca',
      'Mankins',
      'Marble Falls',
      'Marfa',
      'Marquez',
      'Mart',
      'Martindale',
      'Martins Mill',
      'Maryneal',
      'Masterson',
      'Matador',
      'Matagorda',
      'Mathis',
      'Mauriceville',
      'Maverick',
      'Maydelle',
      'Maypearl',
      'Maysfield',
      'McAllen',
      'McCamey',
      'McCaulley',
      'McDade',
      'McFaddin',
      'McKibben',
      'McKinney Acres',
      'McLendon-Chisholm',
      'McQueeney',
      'Meadowlakes',
      'Meadows Place',
      'Medicine Mound',
      'Melody Hills',
      'Menard',
      'Merit',
      'Merkel',
      'Mertens',
      'Mertzon',
      'Metcalf Gap',
      'Mexia',
      'Middle Water',
      'Mila Doce',
      'Milam',
      'Milano',
      'Millers Cove',
      'Millersview',
      'Millican',
      'Millsap',
      'Mineral Wells',
      'Mingus',
      'Minters Chapel',
      'Mirando City',
      'Mission Bend',
      'Mobeetie',
      'Mobile City',
      'Monahans',
      'Monkstown',
      'Mont Belvieu',
      'Montalba',
      'Moonshine Hill',
      'Moore Station',
      'Mooring',
      'Morgan Farm Colonia',
      'Morgan Mill',
      'Morgans Point',
      'Morgans Point Resort',
      'Morita',
      'Morning Glory',
      'Morris Ranch',
      'Morse Junction',
      'Morton Valley',
      'Moss Hill',
      'Mount Calm',
      'Mount Enterprise',
      'Mount Houston',
      'Mount Selman',
      'Muenster',
      'Muldoon',
      'Muleshoe',
      'Mullin',
      'Mumford',
      'Munday',
      'Muniz',
      'Murillo Colonia',
      'Mustang Ridge',
      'Myra',
      'Myrtle Springs',
      'Nacogdoches',
      'Nada',
      'Narcisso',
      'Nassau Bay',
      'Natalia',
      'Navasota',
      'Neches',
      'Needville',
      'Nesbitt',
      'New Braunfels',
      'New Caney',
      'New Chapel Hill',
      'New Fairview',
      'New Falcon',
      'New Home',
      'New Summerfield',
      'New Taiton',
      'New Territory',
      'New Waverly',
      'New Willard',
      'Newlin',
      'Newsome',
      'Neylandville',
      'Nickel Creek Station',
      'Niederwald',
      'Nocona',
      'Nocona Hills',
      'Noelke',
      'Nolanville',
      'Nopal',
      'Nordheim',
      'Norias',
      'Normangee',
      'Normanna',
      'North Alamo',
      'North Cleveland',
      'North Cowden',
      'North Escobares',
      'North Houston',
      'North Pearsall',
      'North Richland Hills',
      'North Roby',
      'North San Pedro',
      'North Zulch',
      'Northcrest',
      'Notrees',
      'Novice',
      'Nursery',
      "O'Donnell",
      'Oak Leaf',
      'Oak Point',
      'Oak Ridge North',
      'Oak Trail Shores',
      'Ochoa',
      'Odem',
      'Ogg',
      'Oklaunion',
      'Old Glory',
      'Old Ocean',
      'Old River-Winfree',
      'Olden',
      'Olivarez',
      'Olmito',
      'Olmos Park',
      'Olton',
      'Onalaska',
      'Opdyke West',
      'Orason Acres Colonia',
      'Ore City',
      'Orla',
      'Otto',
      'Ovalo',
      'Ovilla',
      'Owentown',
      'Owl Ranch',
      'Oyster Creek',
      'Paige',
      'Paisano Park Colonia',
      'Palacios',
      'Palito Blanco',
      'Palmhurst',
      'Palmview',
      'Palo Pinto',
      'Pampa',
      'Panhandle',
      'Panorama Village',
      'Papalote',
      'Parmerton',
      'Patroon',
      'Pattonville',
      'Payne Springs',
      'Peacock',
      'Pearland',
      'Pearsall',
      'Peaster',
      'Pecan Acres',
      'Pecan Gap',
      'Pecan Grove',
      'Pecan Hill',
      'Pecan Plantation',
      'Peden',
      'Penelope',
      'Penitas',
      'Penwell',
      'Percilla',
      'Perezville',
      'Perryton',
      'Petronila',
      'Pettus',
      'Petty',
      'Pflugerville',
      'Pharr',
      'Pickton',
      'Pidcoke',
      'Pine Forest',
      'Pinewood Estates',
      'Piney Point Village',
      'Pipe Creek',
      'Placedo',
      'Placid',
      'Plaska',
      'Plata',
      'Pleak',
      'Pledger',
      'Plum Grove',
      'Point Comfort',
      'Point Venture',
      'Pollok',
      'Ponder',
      'Port Alto',
      'Port Aransas',
      'Port Bolivar',
      'Port Isabel',
      'Port Lavaca',
      'Port Mansfield',
      'Port Neches',
      "Port O'Connor",
      'Porter Heights',
      'Post Oak Bend City',
      'Poteet',
      'Poth',
      'Pottsboro',
      'Poynor',
      'Prado Verde',
      'Premont',
      'Presidio',
      'Priddy',
      'Primera',
      'Progreso Lakes',
      'Prosper',
      'Pueblo Nuevo Colonia',
      'Puente',
      'Pullman',
      'Pumpville',
      'Purdon',
      'Purley',
      'Purves',
      'Pyote',
      'Quail',
      'Quail Creek',
      'Quanah',
      'Quarry',
      'Quebec',
      'Quitaque',
      'Rachal',
      'Raisin',
      'Ralls',
      'Ramireno',
      'Ramirez',
      'Ranchette Estates',
      'Ranchitos Las Lomas',
      'Rancho Banquete',
      'Rancho Chico',
      'Rancho Viejo',
      'Ranchos Penitas West',
      'Randado',
      'Rangerville',
      'Ransom Canyon',
      'Ratamosa',
      'Rayburn',
      'Realitos',
      'Red Gate',
      'Refugio',
      'Reid Hope King Colonia',
      'Reklaw',
      'Relampago',
      'Rendon',
      'Retta',
      'Rhome',
      'Ricardo',
      'Richardson',
      'Richland Hills',
      'Richland Springs',
      'Riesel',
      'Rio Bravo',
      'Rio Grande City',
      'Rio Hondo',
      'Riomedina',
      'Rios',
      'Rising Star',
      'River Oaks',
      'Rivera Colonia',
      'Roane',
      'Roaring Springs',
      'Robert Lee',
      'Robstown',
      'Rocksprings',
      'Rockwall',
      'Rocky Mound',
      'Roganville',
      'Roma Creek',
      'Roma-Los Saenz',
      'Roman Forest',
      'Romayor',
      'Romero',
      'Romney',
      'Ropesville',
      'Rosanky',
      'Rose Hill Acres',
      'Rosenberg',
      'Rosharon',
      'Rosser',
      'Rotan',
      'Round Top',
      'Rowden',
      'Rowlett',
      'Roxton',
      'Royalty',
      'Royse City',
      'Rucker',
      'Ruidosa',
      'Runaway Bay',
      'Runge',
      'Rusk',
      'Rutersville',
      'Sabine',
      'Sabine Pass',
      'Sachse',
      'Sadler',
      'Sagerton',
      'Saint Hedwig',
      'Saint Jo',
      'Salineño',
      'Salt Flat',
      'Salt Gap',
      'Sam Rayburn',
      'Samnorwood',
      'San Angelo',
      'San Carlos Number 1 Colonia',
      'San Elizario',
      'San Juan Colonia',
      'San Leanna',
      'San Leon',
      'San Perlita',
      'San Saba',
      'San Ygnacio',
      'Sanctuary',
      'Sandow',
      'Sandy Oaks',
      'Sansom Park',
      'Santa Anna',
      'Santa Rosa Colonia',
      'Santo',
      'Saragosa',
      'Sarita',
      'Satin',
      'Saturn',
      'Scallorn',
      'Scenic Oaks',
      'Schertz',
      'Schulenburg',
      'Scissors',
      'Scurry',
      'Seadrift',
      'Seagoville',
      'Seagraves',
      'Sealy',
      'Seco Mines',
      'Segno',
      'Selman City',
      'Serenada',
      'Seth Ward',
      'Seven Points',
      'Seven Sisters',
      'Shady Hollow',
      'Shady Shores',
      'Shallowater',
      'Sharp',
      'Shavano Park',
      'Shawville',
      'Shepton',
      'Sherwood Shores',
      'Shiner',
      'Shiro',
      'Shoreacres',
      'Sienna Plantation',
      'Sierra Blanca',
      'Siesta Acres',
      'Siesta Shores',
      'Silsbee',
      'Silver',
      'Silver Valley',
      'Simonton',
      'Sinton',
      'Skellytown',
      'Slaton',
      'Slocum',
      'Smiley',
      'Smith Point',
      'Smyer',
      'Snook',
      'Solis',
      'Sonterra',
      'Sour Lake',
      'South Alamo',
      'South Fork Estates',
      'South Houston',
      'South Mountain',
      'South Padre Island',
      'South Plains',
      'South Toledo Bend',
      'Southlake',
      'Southland',
      'Southmayd',
      'Southside Place',
      'Southton',
      'Spade',
      'Speaks',
      'Spearman',
      'Splendora',
      'Spofford',
      'Spraberry',
      'Spring',
      'Spring Branch',
      'Spring Gardens',
      'Spur',
      'Spurger',
      'Stairtown',
      'Star Harbor',
      'Stephen Creek',
      'Sterley',
      'Sterling City',
      'Stinnett',
      'Stockman',
      'Stoneburg',
      'Stowell',
      'Streetman',
      'String Prairie',
      'Study Butte',
      'Sublime',
      'Sudan',
      'Sugar Land',
      'Sullivan City',
      'Sulphur Bluff',
      'Sunrise Beach Village',
      'Sunset Acres Colonia',
      'Sunset Colonia',
      'Swearingen',
      'Sweeny',
      'Swenson',
      'Swiss Alp',
      'Tahoka',
      'Talco',
      'Talty',
      'Tamina',
      'Tanglewood',
      'Tanglewood Forest',
      'Tankersley',
      'Tarzan',
      'Tascosa',
      'Taylor Lake Village',
      'Taylor Landing',
      'Teague',
      'Tehuacana',
      'Telegraph',
      'Telephone',
      'Telferner',
      'Tenaha',
      'Tennessee Colony',
      'Terlingua',
      'Terrell',
      'Terrell Hills',
      'Tesco',
      'Texas City',
      'Texline',
      'Texon',
      'The Grove',
      'The Hills',
      'The Woodlands',
      'Thelma',
      'Thompsons',
      'Thorntonville',
      'Thrall',
      'Throckmorton',
      'Tierra Bonita',
      'Tierra Grande',
      'Tiki Island',
      'Timbercreek Canyon',
      'Timberwood Park',
      'Timpson',
      'Tinaja',
      'Tira',
      'Titley',
      'Toco',
      'Todd Mission',
      'Tolbert',
      'Tom Bean',
      'Tomball',
      'Tool',
      'Tornillo',
      'Town West',
      'Toyah',
      'Toyahvale',
      'Tradewinds',
      'Trammels',
      'Trawick',
      'Trophy Club',
      'Troup',
      'Truscott',
      'Tuleta',
      'Tulia',
      'Tulip',
      'Tulsita',
      'Tundra',
      'Tunis',
      'Twichell',
      'Twitty',
      'Tye',
      'Tynan',
      'Uhland',
      'Umbarger',
      'Uncertain',
      'Union Valley',
      'Universal City',
      'Utopia',
      'Uvalde',
      'Uvalde Estates',
      'Vair',
      'Val Verde Park',
      'Valera',
      'Valley Mills',
      'Valley Spring',
      'Van Alstyne',
      'Van Horn',
      'Van Vleck',
      'Vancourt',
      'Vanderpool',
      'Vandyke',
      'Vega',
      'Verhalen',
      'Viboras',
      'Vidaurri',
      'View',
      'Vigo Park',
      'Villa',
      'Villa Pancho',
      'Villa del Sol',
      'Village Mills',
      'Voca',
      'Volente',
      'Von Ormy',
      'Votaw',
      'Waelder',
      'Waka',
      'Wake Village',
      'Wallis',
      'Walnut Springs',
      'Waples',
      'Warda',
      'Warren City',
      'Waskom',
      'Wastella',
      'Waxahachie',
      'Weches',
      'Weesatche',
      'Weinert',
      'Wells Branch',
      'Weslaco',
      'West Alto Bonito Colonia',
      'West Lake Hills',
      'West Livingston',
      'West Odessa',
      'West Orange',
      'West Sharyland',
      'West Tawakoni',
      'West University Place',
      'Western Lake',
      'Westhoff',
      'Weston Lakes',
      'Westway',
      'Wheelock',
      'White Deer',
      'White Settlement',
      'Whiteface',
      'Whiteflat',
      'Whitewright',
      'Whitharral',
      'Wichita Falls',
      'Wickett',
      'Wild Peach Village',
      'Wildorado',
      'Willow Park',
      'Wills Point',
      'Wimberley',
      'Winchell',
      'Windcrest',
      'Windemere',
      'Windthorst',
      'Wink',
      'Winnie',
      'Witco',
      'Wixon Valley',
      'Wolfe City',
      'Wolfforth',
      'Woodbranch',
      'Woodcreek',
      'Woodloch',
      'Woodway',
      'Wyldwood',
      'Wylie',
      'Yancey',
      'Yantis',
      'Yoakum',
      'Yznaga',
      'Zapata',
      'Zapata Ranch',
      'Zavalla',
      'Zephyr',
      'Zita',
      'Zuehl',
    ],
    'US-UT': [
      'Abraham',
      'Amalga',
      'American Fork',
      'Aneth',
      'Angle',
      'Annabella',
      'Antimony',
      'Bear River City',
      'Bennion',
      'Beryl',
      'Beryl Junction',
      'Big Water',
      'Blanding',
      'Blue Creek',
      'Bluebell',
      'Bluff',
      'Bluffdale',
      'Boulder Town',
      'Bountiful',
      'Brian Head',
      'Bridgeland',
      'Brigham City',
      'Bryce Canyon',
      'Bryce Canyon City',
      'Burmester',
      'Burrville',
      'Caineville',
      'Cannonville',
      'Carbonville',
      'Castle Dale',
      'Castle Valley',
      'Cedar Fort',
      'Cedar Highlands',
      'Centerfield',
      'Copperton',
      'Corinne',
      'Cottonwood Heights',
      'Dammeron Valley',
      'Daniel',
      'Deseret',
      'Devils Slide',
      'Duchesne',
      'Dugway',
      'Dutch John',
      'Eagle Mountain',
      'Elk Ridge',
      'Elsinore',
      'Enoch',
      'Ephraim',
      'Erda',
      'Farr West',
      'Faust',
      'Ferron',
      'Fielding',
      'Flowell',
      'Fort Duchesne',
      'Fruit Heights',
      'Gilluly',
      'Goshute',
      'Green River',
      'Grouse Creek',
      'Gunlock',
      'Halchita',
      'Halls Crossing',
      'Hamiltons Fort',
      'Hanksville',
      'Heber City',
      'Helper',
      'Henefer',
      'Henrieville',
      'Herriman',
      'Hideout',
      'Hildale',
      'Hoytsville',
      'Hurricane',
      'Hyrum',
      'Ibapah',
      'Ivins',
      'Jensen',
      'Kamas',
      'Kanab',
      'Kanarraville',
      'Kanosh',
      'Kaysville',
      'Kearns',
      'Knolls',
      'Koosharem',
      'La Sal',
      'LaVerkin',
      'Laketown',
      'Lapoint',
      'Lehi',
      'Levan',
      'Loa',
      'Lofgreen',
      'Low',
      'Lucin',
      'Lynndyl',
      'Maeser',
      'Magna',
      'Manderfield',
      'Manti',
      'Marriott-Slaterville',
      'Marysvale',
      'Mexican Hat',
      'Millcreek',
      'Moab',
      'Montezuma Creek',
      'Moroni',
      'Mountain Green',
      'Myton',
      'Navajo Mountain',
      'Nephi',
      'Nibley',
      'North Logan',
      'North Ogden',
      'North Salt Lake',
      'Orderville',
      'Orem',
      'Panguitch',
      'Paragonah',
      'Park Valley',
      'Parowan',
      'Peoa',
      'Pintura',
      'River Heights',
      'Rosette',
      'Rush Valley',
      'Salduro',
      'Salt Lake City',
      'Samak',
      'Sandy City',
      'Santaquin',
      'Scofield',
      'Sevier',
      'Shivwits',
      'Sigurd',
      'Snowville',
      'Snyderville',
      'Soldier Summit',
      'South Jordan',
      'South Ogden',
      'South Salt Lake',
      'South Weber',
      'South Willard',
      'Spanish Fork',
      'Spanish Valley',
      'Spring Glen',
      'Standrod',
      'Stansbury park',
      'Sugarville',
      'Sulphurdale',
      'Summit Park',
      'Tabiona',
      'Teasdale',
      'Thistle',
      'Thompson Springs',
      'Timber Lakes',
      'Timpie',
      'Tooele',
      'Toquerville',
      'Torrey',
      'Tremonton',
      'Tropic',
      'Tselakai Dezza',
      'Ucolo',
      'Uintah',
      'Upalco',
      'Val Verda',
      'Vernal',
      'Veyo',
      'Virgin',
      'Wahsatch',
      'Wallsburg',
      'Wanship',
      'Washington Terrace',
      'Wattis',
      'Wendover',
      'West Bountiful',
      'West Jordan',
      'West Mountain',
      'West Valley City',
      'Westwater',
      'White Mesa',
      'Whiterocks',
      'Woods Cross',
      'Zane',
    ],
    'US-VT': [
      'Alburg',
      'Ascutney',
      'Beecher Falls',
      'Bellows Falls',
      'Brattleboro',
      'Derby Center',
      'Derby Line',
      'East Barre',
      'East Burke',
      'East Middlebury',
      'East Montpelier',
      'Enosburg Falls',
      'Essex Junction',
      'Greensboro Bend',
      'Hinesburg',
      'Irasburg',
      'Island Pond',
      'Manchester Center',
      'Newport Center',
      'North Bennington',
      'North Hartland',
      'North Troy',
      'North Westminster',
      'North Wolcott',
      'Old Bennington',
      'Poultney',
      'Proctorsville',
      'Quechee',
      'Readsboro',
      'Richford',
      'Saint Albans',
      'Saint Johnsbury',
      'Saxtons River',
      'South Barre',
      'South Burlington',
      'South Royalton',
      'South Shaftsbury',
      'Waitsfield',
      'Websterville',
      'Wells River',
      'West Brattleboro',
      'West Burke',
      'West Dover',
      'West Pawlet',
      'West Rutland',
      'West Topsham',
      'White River Junction',
      'Winooski',
    ],
    'US-VI': [],
    'US-VA': [
      'Accomac',
      'Achilles',
      'Acorn',
      'Adwolf',
      'Alberene',
      'Allisonia',
      'Altavista',
      'Amelia Court House',
      'Amonate',
      'Appalachia',
      'Apple Grove',
      'Apple Mountain Lake',
      'Appomattox',
      'Aquia Harbour',
      'Arvonia',
      'Augusta Springs',
      'Austinville',
      'Axton',
      'Bacova',
      'Baileys Crossroads',
      'Barracks',
      'Baskerville',
      'Bastian',
      'Basye',
      'Bealeton',
      'Belle Haven',
      'Belmont Estates',
      'Belspring',
      'Benns Church',
      'Bensley',
      'Bergton',
      'Big Island',
      'Big Stone Gap',
      'Blackstone',
      'Blairs',
      'Bloxom',
      'Blue Ridge Shores',
      'Bluefield',
      'Boones Mill',
      'Boydton',
      'Boykins',
      'Bracey',
      'Brambleton',
      'Brandermill',
      'Brentsville',
      'Brodnax',
      'Brokenburg',
      'Brooke',
      'Brookneal',
      'Brosville',
      'Brucetown',
      'Brumley Gap',
      'Buckhall',
      'Bull Run',
      'Bull Run Mountain Estates',
      'Burkes Garden',
      'Callaghan',
      'Callands',
      'Cana',
      'Cape Charles',
      'Captains Cove',
      'Catlett',
      'Cats Bridge',
      'Caylor',
      'Center Cross',
      'Central Garage',
      'Chamberlayne',
      'Chamberlayne Heights',
      'Chantilly',
      'Charlotte Court House',
      'Charlottesville',
      'Chase City',
      'Chase Crossing',
      'Chatmoss',
      'Cheriton',
      'Chester Gap',
      'Chilhowie',
      'Chincoteague',
      'Claypool Hill',
      'Clifton Forge',
      'Clinchco',
      'Clinchport',
      'Clintwood',
      'Cluster Springs',
      'Coeburn',
      'Colonial Beach',
      'Commonwealth',
      'Covesville',
      'Craigsville',
      'Crewe',
      'Crimora',
      'Crozet',
      'Crystal Hill',
      'Culpeper',
      'Dale City',
      'Deep Creek',
      'Deltaville',
      'Dendron',
      'Dillwyn',
      'Disputanta',
      'Dooms',
      'Drakes Branch',
      'Dranesville',
      'Drewryville',
      'Dry Fork',
      'Duffield',
      'Dulles Town Center',
      'Dumbarton',
      'Dumfries',
      'Dungannon',
      'Dunn Loring',
      'East Highland Park',
      'East Lexington',
      'Eastville',
      'Ebony',
      'Eggleston',
      'Elk Hill',
      'Esmont',
      'Evington',
      'Exmore',
      'Fairfax Station',
      'Fairview Beach',
      'Falling Spring',
      'Falls Church',
      'Fancy Gap',
      'Ferrum',
      'Fieldale',
      'Fishersville',
      'Five Mile Fork',
      'Fork Union',
      'Fort Blackmore',
      'Fort Chiswell',
      'Fort Hunt',
      'Free Union',
      'Fries',
      'Front Royal',
      'Fulks Run',
      'Galax',
      'Gargatha',
      'Gasburg',
      'Gate City',
      'Glade Spring',
      'Gladys',
      'Glen Lyn',
      'Glen Wilton',
      'Glenvar',
      'Gloucester Courthouse',
      'Gloucester Point',
      'Goldvein',
      'Goochland',
      'Goode',
      'Gratton',
      'Greenbackville',
      'Greenbriar',
      'Gressitt',
      'Grottoes',
      'Grundy',
      'Guinea',
      'Gwynn',
      'Hallwood',
      'Hampden Sydney',
      'Harborton',
      'Harman',
      'Hartfield',
      'Haymarket',
      'Haysi',
      'Healing Springs',
      'Heathsville',
      'Henry Fork',
      'Highland Springs',
      'Hillsville',
      'Hoadly',
      'Hollymead',
      'Honaker',
      'Horse Pasture',
      'Hurt',
      'Hybla Valley',
      'Idylwood',
      'Independent Hill',
      'Iron Gate',
      'Ivor',
      'Ivy',
      'Jarratt',
      'Jeffersonton',
      'Jetersville',
      'Jewell Ridge',
      'Jewell Valley',
      'Jolivue',
      'Kenbridge',
      'Keokee',
      'Kilmarnock',
      'King George',
      'King William',
      'King and Queen Court House',
      'Kinsale',
      'Kire',
      'Konnarock',
      'Lake Barcroft',
      'Lake Monticello',
      'Lake Ridge',
      'Laymantown',
      'Lebanon Church',
      'Lee Mont',
      'Lewisetta',
      'Lignum',
      'Lincolnia',
      'Linton Hall',
      'Lively',
      'Loch Lomond',
      'Lovettsville',
      'Lovingston',
      'Lowes Island',
      'Lynch Station',
      'Makemie Park',
      'Manakin',
      'Manassas Park',
      'Mappsburg',
      'Mappsville',
      'Massanetta Springs',
      'Massanutten',
      'Massies Mill',
      'Matoaca',
      'Maurertown',
      'Mavisdale',
      'Max Meadows',
      'McKenney',
      'McMullin',
      'Meadowview',
      'Meherrin',
      'Melfa',
      'Metompkin',
      'Middlebrook',
      'Mitchelltown',
      'Modest Town',
      'Mollusk',
      'Montross',
      'Moseley',
      'Mount Crawford',
      'Mount Jackson',
      'Mount Sidney',
      'Mount Solon',
      'Mountain Road',
      'Mouth of Wilson',
      'Mustoe',
      'Naruna',
      'Nassawadox',
      'Nathalie',
      'Natural Bridge Station',
      'Nellysford',
      'Nelsonia',
      'Nethers',
      'New Church',
      'New Kent',
      'Newport News',
      'Newsoms',
      'Nickelsville',
      'Nokesville',
      'Nottoway Court House',
      'Oak Hall',
      'Oakpark',
      'Occoquan',
      'Onancock',
      'Onley',
      'Paint Bank',
      'Painter',
      'Pamplin',
      'Pantops',
      'Parksley',
      'Passapatanzy',
      'Pastoria',
      'Patrick Springs',
      'Pauls Crossroads',
      'Paytes',
      'Pearisburg',
      'Penhook',
      'Pennington Gap',
      'Phenix',
      'Pimmit Hills',
      'Piney River',
      'Plum Creek',
      'Pohick',
      'Poquoson',
      'Potomac Mills',
      'Pound',
      'Pratts',
      'Prices Fork',
      'Providence Forge',
      'Pungoteague',
      'Purcellville',
      'Radford',
      'Raven',
      'Ravensworth',
      'Red Ash',
      'Reedville',
      'Reston',
      'Rich Creek',
      'Rileyville',
      'Rivanna',
      'Rockdell',
      'Rocky Gap',
      'Rose Hill Farms',
      'Rural Retreat',
      'Rushmere',
      'Rustburg',
      'Ruther Glen',
      'Saltville',
      'Sandston',
      'Sandy Level',
      'Savage Town',
      'Savageville',
      'Saxe',
      'Saxis',
      'Sebrell',
      'Sedley',
      'Seven Corners',
      'Seven Mile Ford',
      'Shadwell',
      'Shawnee Land',
      'Shenandoah Farms',
      'Shenandoah Retreat',
      'Shenandoah Shores',
      'Sherando',
      'Short Pump',
      'Simpsons',
      'Skyland Estates',
      'South Boston',
      'South Chesconessex',
      'South Riding',
      'Sperryville',
      'Spotsylvania',
      'Spotsylvania Courthouse',
      'Stanardsville',
      'Stanleytown',
      'Starkey',
      'Stephens City',
      'Stevens Creek',
      'Stonega',
      'Stuarts Draft',
      'Sudley',
      'Sugarland Run',
      'Surry',
      'Susan',
      'Sweet Briar Station',
      'Syria',
      'Tangier',
      'Tappahannock',
      'Tasley',
      'Temperanceville',
      'Timberville',
      'Tiptop',
      'Toms Brook',
      'Trammel',
      'Triangle',
      'Triplet',
      'Trout Dale',
      'Tysons',
      'Union Hall',
      'Union Level',
      'University Center',
      'Urbanna',
      'Vansant',
      'Vesuvius',
      'Villa Heights',
      'Virgilina',
      'Virginia Beach',
      'Volens',
      'Wachapreague',
      'Weedonville',
      'West Falls Church',
      'Westlake Corner',
      'Weyers Cave',
      'White Stone',
      'Whitetop',
      'Wicomico Church',
      'Wilsons',
      'Wintergreen',
      'Winterpock',
      'Wolf Trap',
      'Woolwine',
      'Wylliesburg',
      'Wytheville',
      'Yogaville',
      'York Haven Anchorage',
      'Zuni',
    ],
    'US-WA': [
      'Aberdeen Gardens',
      'Addy',
      'Adna',
      'Aeneas',
      'Ahtanum',
      'Airway Heights',
      'Alderdale',
      'Alderton',
      'Alderwood Manor',
      'Allyn',
      'Almira',
      'Almota',
      'Alstown',
      'Amanda Park',
      'Ames Lake',
      'Anacortes',
      'Anatone',
      'Ardenvoir',
      'Arletta',
      'Artondale',
      'Asotin',
      'Azwell',
      'Bainbridge Island',
      'Basin City',
      'Bay Center',
      'Bayne',
      'Beaux Arts Village',
      'Beaver Valley',
      'Belfair',
      'Bell Hill',
      'Benge',
      'Bickleton',
      'Birch Bay',
      'Blockhouse',
      'Blyn',
      'Boistfort',
      'Bonney Lake',
      'Boston Harbor',
      'Bothell',
      'Boulevard Park',
      'Bow',
      'Breidablick',
      'Bremerton',
      'Brier',
      'Brinnon',
      'Browns Point',
      'Brush Prairie',
      'Bucoda',
      'Burien',
      'Camano',
      'Canterwood',
      'Canyon Park',
      'Carbonado',
      'Carlsborg',
      'Carnation',
      'Carrolls',
      'Cascade Valley',
      'Cathcart',
      'Cathlamet',
      'Cavalero Corner',
      'Cedonia',
      'Central Park',
      'Chattaroy',
      'Chehalis',
      'Chelan',
      'Chelan Falls',
      'Chelatchie',
      'Chesaw',
      'Chewelah',
      'Chimacum',
      'Cinebar',
      'Clallam Bay',
      'Clarkston Heights',
      'Cle Elum',
      'Cliffdell',
      'Clyde Hill',
      'Cohassett Beach',
      'College Place',
      'Colville',
      'Colvos',
      'Conconully',
      'Connell',
      'Copalis Beach',
      'Copalis Crossing',
      'Cosmopolis',
      'Cottage Lake',
      'Cougar',
      'Coulee City',
      'Coulee Dam',
      'Country Homes',
      'Coupeville',
      'Covada',
      'Cowiche',
      'Cusick',
      'Dalkena',
      'Dallesport',
      'Darrington',
      'Dash Point',
      'Desert Aire',
      'Dieringer',
      'Disautel',
      'Dishman',
      'Dockton',
      'Doris',
      'Doty',
      'DuPont',
      'Dungeness',
      'Dusty',
      'Duvall',
      'Eagledale',
      'East Cathlamet',
      'East Farms',
      'East Olympia',
      'East Port Orchard',
      'East Renton Highlands',
      'East Wenatchee',
      'Eastsound',
      'Edwall',
      'Eglon',
      'Elbe',
      'Electric City',
      'Elk Plain',
      'Ellensburg',
      'Ellisforde',
      'Ellisport',
      'Elmer City',
      'Eltopia',
      'Enetai',
      'Entiat',
      'Enumclaw',
      'Erlands Point',
      'Eschbach',
      'Fairwood',
      'Fall City',
      'Federal Way',
      'Felida',
      'Fern Prairie',
      'Fife Heights',
      'Fircrest',
      'Five Corners',
      'Fobes Hill',
      'Fords Prairie',
      'Forks',
      'Four Lakes',
      'Fox Island',
      'Fragaria',
      'Frederickson',
      'Friday Harbor',
      'Gig Harbor',
      'Glacier',
      'Gleed',
      'Glenoma',
      'Gold Bar',
      'Goldendale',
      'Goodnoe Hills',
      'Goose Prairie',
      'Gorst',
      'Grand Coulee',
      'Grapeview',
      'Grayland',
      'Grays River',
      'Green Bluff',
      'Greenbank',
      'Greenwater',
      'Grisdale',
      'Grotto',
      'Hansville',
      'Harbour Pointe',
      'Hartline',
      'Hayford',
      'Hockinson',
      'Hoodsport',
      'Hoquiam',
      'Humptulips',
      'Hunters',
      'Hunts Point',
      'Hyak',
      'Ilwaco',
      'Inchelium',
      'Index',
      'Irby',
      'Issaquah',
      'Kahlotus',
      'Kalaloch',
      'Kalama',
      'Kanaskat',
      'Kapowsin',
      'Kennard Corner',
      'Kennewick',
      'Kennydale',
      'Ketron',
      'Kettle Falls',
      'Kewa',
      'Key Center',
      'Kitsap Lake',
      'Kittitas',
      'Klickitat',
      'Koontzville',
      'Kummer',
      'La Conner',
      'La Push',
      'Lake Bosworth',
      'Lake Cavanaugh',
      'Lake Forest Park',
      'Lake Goodwin',
      'Lake Ketchum',
      'Lake McMurray',
      'Lake Roesiger',
      'Lake Stevens',
      'Lake Stickney',
      'Lakebay',
      'Lamona',
      'Larimers Corner',
      'Latah',
      'Laurier',
      'Leadpoint',
      'Lebam',
      'Liberty Lake',
      'Lilliwaup',
      'Lind',
      'Lisabeula',
      'Lochsloy',
      'Lofall',
      'Longbranch',
      'Longmire',
      'Longview Heights',
      'Lynden',
      'Mabana',
      'Mabton',
      'Malott',
      'Maple Falls',
      'Maple Valley',
      'Marblemount',
      'Marrowstone',
      'Martha Lake',
      'Maryhill',
      'Marys Corner',
      'Maxwelton',
      'Mazama',
      'McCleary',
      'McKenna',
      'McMillin',
      'Meadow Glade',
      'Meadowdale',
      'Medical Lake',
      'Megler',
      'Mercer Island',
      'Metaline',
      'Metaline Falls',
      'Methow',
      'Midvale Corner',
      'Minnehaha',
      'Mirrormont',
      'Moclips',
      'Mohler',
      'Molson',
      'Mondovi',
      'Monitor',
      'Monse',
      'Montesano',
      'Moses Lake',
      'Mossyrock',
      'Mount Vista',
      'Mountlake Terrace',
      'Moxee City',
      'Mukilteo',
      'Murphys Corner',
      'Naches',
      'Napavine',
      'Naselle',
      'Navy Yard City',
      'Neah Bay',
      'Neilton',
      'Nemah',
      'Nespelem',
      'Newaukum',
      'Newhalem',
      'Newman Lake',
      'Newport Hills',
      'Nighthawk',
      'Nine Mile Falls',
      'Nisqually',
      'Nooksack',
      'Nordland',
      'Normandy Park',
      'North Bonneville',
      'North City',
      'North Hill',
      'North Lynnwood',
      'North Marysville',
      'North Omak',
      'North Puyallup',
      'North Sultan',
      'North Yelm',
      'Oakesdale',
      'Ocean Park',
      'Ocean Shores',
      'Ohop',
      'Okanogan',
      'Olalla',
      'Olympic View',
      'Omak',
      'Orcas',
      'Orchards',
      'Orting',
      'Oso',
      'Othello',
      'Otis Orchards',
      'Oyehut',
      'Oysterville',
      'Pacific Beach',
      'Palouse',
      'Pataha',
      'Pateros',
      'Pe Ell',
      'Peaceful Valley',
      'Peshastin',
      'Picnic Point',
      'Plain',
      'Point Roberts',
      'Port Angeles',
      'Port Blakely',
      'Port Gamble',
      'Port Hadlock',
      'Port Ludlow',
      'Port Madison',
      'Port Orchard',
      'Port Townsend',
      'Possession',
      'Poulsbo',
      'Prairie Ridge',
      'Puyallup',
      'Queets',
      'Quilcene',
      'Quinault',
      'Randle',
      'Ravensdale',
      'Reardan',
      'Renton',
      'Richmond Beach',
      'Richmond Highlands',
      'Ritzville',
      'Rollingbay',
      'Ronald',
      'Rosburg',
      'Royal City',
      'Ruff',
      'Ryderwood',
      'Sahalee',
      'Salkum',
      'Sammamish',
      'San de Fuca',
      'Sappho',
      'Satsop',
      'Schrag',
      'SeaTac',
      'Seabeck',
      'Seahurst',
      'Seattle',
      'Seattle Heights',
      'Sedro-Woolley',
      'Sekiu',
      'Selah',
      'Selleck',
      'Sequim',
      'Shaw Island',
      'Sheridan Beach',
      'Shoreline',
      'Silvana',
      'Silver Firs',
      'Similk Beach',
      'Sisco Heights',
      'Skamokawa',
      'Skokomish',
      'Skykomish',
      'Skyway',
      'Snohomish',
      'Snoqualmie',
      'Snoqualmie Falls',
      'Snoqualmie Pass',
      'Soap Lake',
      'South Broadway',
      'South Cle Elum',
      'South Prairie',
      'South Snohomish',
      'Southworth',
      'Spanaway',
      'Spangle',
      'Spokane Valley',
      'Startup',
      'Stehekin',
      'Steilacoom',
      'Strandell',
      'Sudden Valley',
      'Sultan',
      'Sumas',
      'Summitview',
      'Sunnydale',
      'Suquamish',
      'Swede Heaven',
      'Swinomish Village',
      'Synarep',
      'Taholah',
      'Tahuya',
      'Tanglewilde',
      'Tekoa',
      'Telma',
      'Tenino',
      'Terrace Heights',
      'Thompson Place',
      'Thorp',
      'Tieton',
      'Tillicum',
      'Tokeland',
      'Tonasket',
      'Toppenish',
      'Torboy',
      'Touchet',
      'Tracyton',
      'Trentwood',
      'Tukwila',
      'Tulalip',
      'Tumwater',
      'Turner Corner',
      'Twisp',
      'Union Gap',
      'University Place',
      'Upper Mill',
      'Upper Preston',
      'Urban',
      'Usk',
      'Vader',
      'Van Zandt',
      'Vantage',
      'Vashon',
      'Vashon Heights',
      'Venersborg',
      'Veradale',
      'Verlot',
      'Waitsburg',
      'Wallula',
      'Wapato',
      'Warm Beach',
      'Washougal',
      'Washtucna',
      'Wauna',
      'Wautauga Beach',
      'Wellpinit',
      'Wenatchee',
      'West Lake Sammamish',
      'West Pasco',
      'West Richland',
      'White Center',
      'White Salmon',
      'White Swan',
      'Wickersham',
      'Wilbur',
      'Wilkeson',
      'Willapa',
      'Wilson Creek',
      'Winlock',
      'Wishram',
      'Withrow',
      'Wollochet',
      'Woodinville',
      'Woodmont Beach',
      'Woods Creek',
      'Wymer',
      'Yacolt',
      'Yakima',
      'Yarrow Point',
      'Yelm',
      'Yoman',
      'Zenith',
      'Zillah',
    ],
    'US-WV': [
      'Accoville',
      'Albright',
      'Alum Bridge',
      'Alum Creek',
      'Amherstdale',
      'Anawalt',
      'Anmoore',
      'Annamoriah',
      'Ansted',
      'Arbovale',
      'Arista',
      'Barboursville',
      'Barnabus',
      'Barrackville',
      'Beards Fork',
      'Beckley',
      'Beech Bottom',
      'Belington',
      'Bens Run',
      'Benwood',
      'Bergoo',
      'Berkeley Springs',
      'Berwind',
      'Big Chimney',
      'Birch River',
      'Blacksville',
      'Blennerhassett',
      'Bluewell',
      'Bolair',
      'Bolt',
      'Boomer',
      'Bramwell',
      'Branchland',
      'Brenton',
      'Brohard',
      'Bruceton Mills',
      'Brush Fork',
      'Buckhannon',
      'Bud',
      'Camden on Gauley',
      'Capon Bridge',
      'Captina',
      'Carpendale',
      'Ceredo',
      'Chapmanville',
      'Charles Town',
      'Charlton Heights',
      'Cheat Lake',
      'Chelyan',
      'Clearco',
      'Clendenin',
      'Clifftop',
      'Coal Fork',
      'Coketon',
      'Core',
      'Covel',
      'Cowen',
      'Coxs Mills',
      'Cross Lanes',
      'Crum',
      'Crumpler',
      'Cucumber',
      'Cuzzart',
      'Davy',
      'Deep Water',
      'Delbarton',
      'Dellslow',
      'Delray',
      'Despard',
      'Dorcas',
      'Dunlow',
      'East Bank',
      'East Dailey',
      'East Lynn',
      'Eccles',
      'Edray',
      'Eleanor',
      'Elk Garden',
      'Elkview',
      'Ellamore',
      'Erbacon',
      'Fairlea',
      'Falling Waters',
      'Falls View',
      'Fellowsville',
      'Ferrellsburg',
      'Fireco',
      'Follansbee',
      'Fort Ashby',
      'Fort Gay',
      'Four States',
      'Frank',
      'Frenchton',
      'Gallipolis Ferry',
      'Gandeeville',
      'Gap Mills',
      'Gassaway',
      'Gauley Bridge',
      'Gilbert Creek',
      'Glady',
      'Glen Ferris',
      'Glen Fork',
      'Glen Jean',
      'Glen Rogers',
      'Glen White',
      'Grant Town',
      'Great Cacapon',
      'Green Bank',
      'Griffithsville',
      'Gypsy',
      'Hacker Valley',
      'Hambleton',
      'Handley',
      'Harts',
      'Helvetia',
      'Henlawson',
      'Hepzibah',
      'Hernshaw',
      'Hodgesville',
      'Hooverson Heights',
      'Hundred',
      'Huttonsville',
      'Iaeger',
      'Idamay',
      'Ireland',
      'Itmann',
      'Ivydale',
      'Jane Lew',
      'Jeffrey',
      'Jenkinjones',
      'Jerryville',
      'Junior',
      'Kearneysville',
      'Kenova',
      'Keyser',
      'Kiahsville',
      'Kopperston',
      'Lashmeet',
      'Lavalette',
      'Leewood',
      'Lesage',
      'Lindside',
      'Lizemores',
      'Lorentz',
      'Lowsville',
      'Lubeck',
      'Lumberport',
      'Mabscott',
      'MacArthur',
      'Mallory',
      'Man',
      'Marlinton',
      'Marmet',
      'Matewan',
      'Matheny',
      'Mathias',
      'Matoaka',
      'Maybeury',
      'McConnell',
      'McMechen',
      'McWhorter',
      'Meadow Bridge',
      'Meadow Creek',
      'Mellin',
      'Middlebourne',
      'Middleway',
      'Minnehaha Springs',
      'Mitchell Heights',
      'Monaville',
      'Monongah',
      'Montcalm',
      'Moundsville',
      'Mount Storm',
      'Mullens',
      'Murphytown',
      'Nallen',
      'Neibert',
      'Nestorville',
      'Nettie',
      'New Creek',
      'New Martinsville',
      'New Milton',
      'Nitro',
      'Northfork',
      'Nutter Fort',
      'Oakvale',
      'Oceana',
      'Old Fields',
      'Omar',
      'Onego',
      'Paden City',
      'Pageton',
      'Parcoal',
      'Pax',
      'Peach Creek',
      'Pennsboro',
      'Pentress',
      'Peterstown',
      'Petroleum',
      'Pettry',
      'Philippi',
      'Pinch',
      'Piney View',
      'Poca',
      'Pocatalico',
      'Powellton',
      'Pruntytown',
      'Quinnimont',
      'Quinwood',
      'Rainelle',
      'Ranson',
      'Raysal',
      'Red Jacket',
      'Rhodell',
      'Ridgeley',
      'Rippon',
      'Rivesville',
      'Robertsburg',
      'Robinette',
      'Rock Cave',
      'Roderfield',
      'Ronceverte',
      'Rossmore',
      'Rowlesburg',
      'Salt Rock',
      'Sand Fork',
      'Sarah Ann',
      'Scarbro',
      'Scherr',
      'Schultz',
      'Scott Depot',
      'Shady Spring',
      'Shannondale',
      'Shenandoah Junction',
      'Shepherdstown',
      'Shinnston',
      'Sissonville',
      'Sistersville',
      'Slanesville',
      'Slaty Fork',
      'Spelter',
      'Squire',
      'Stanaford',
      'Stirrat',
      'Stollings',
      'Stonewood',
      'Strange Creek',
      'Swandale',
      'Switzer',
      'Teays Valley',
      'Thurmond',
      'Triadelphia',
      'Trout',
      'Tunnelton',
      'Upper Tract',
      'Valley Bend',
      'Valley Grove',
      'Verdunville',
      'Waiteville',
      'War',
      'Wardensville',
      'Webster Springs',
      'Weirton',
      'West Hamlin',
      'West Logan',
      'West Milford',
      'Wharncliffe',
      'Whitmer',
      'Wick',
      'Wildell',
      'Wiley Ford',
      'Wolf Summit',
      'Zela',
    ],
    'US-WI': [
      'Abrams',
      'Adell',
      'Alderley',
      'Allenton',
      'Allouez',
      'Alma Center',
      'Amherst Junction',
      'Aniwa',
      'Anston',
      'Antigo',
      'Argonne',
      'Arkansaw',
      'Arkdale',
      'Arnott',
      'Arpin',
      'Ashippun',
      'Ashwaubenon',
      'Astico',
      'Auroraville',
      'Babcock',
      'Baileys Harbor',
      'Balsam Lake',
      'Baraboo',
      'Barron',
      'Barronett',
      'Bell Center',
      'Benderville',
      'Birnamwood',
      'Biron',
      'Black Earth',
      'Black River Falls',
      'Blanchardville',
      'Bloom City',
      'Bloomer',
      'Blue Mounds',
      'Blueberry',
      'Bluffview',
      'Bohners Lake',
      'Bonduel',
      'Borth',
      'Boscobel',
      'Boulder Junction',
      'Bowler',
      'Boyceville',
      'Brackett',
      'Brantwood',
      'Brice Prairie',
      'Brill',
      'Brillion',
      'Brokaw',
      'Brown Deer',
      'Browns Lake',
      'Buffalo City',
      'Butte des Morts',
      'Butternut',
      'Cable',
      'Cadott',
      'Calamine',
      'Camp Douglas',
      'Camp Lake',
      'Campbellsport',
      'Campia',
      'Carlsville',
      'Cashton',
      'Cedarburg',
      'Centuria',
      "Chain O' Lakes",
      'Chaseburg',
      'Chenequa',
      'Chetek',
      'Chief Lake',
      'Chippewa Falls',
      'Clam Lake',
      'Clearwater Lake',
      'Clyman',
      'Combined Locks',
      'Connorsville',
      'Conrath',
      'Coon Valley',
      'Couderay',
      'Crandon',
      'Cuba City',
      'Daleyville',
      'Dane',
      'De Forest',
      'De Pere',
      'Deerbrook',
      'Delavan Lake',
      'Dexterville',
      'Diamond Bluff',
      'Dickeyville',
      'Dodgeville',
      'Doering',
      'Dousman',
      'Dresser',
      'Dyckesville',
      'Edmund',
      'Egg Harbor',
      'Eland',
      'Elcho',
      'Elderon',
      'Eleva',
      'Elk Mound',
      'Elkhart Lake',
      'Ellison Bay',
      'Endeavor',
      'Esofea',
      'Euren',
      'Exeland',
      'Fairchild',
      'Fairwater',
      'Fennimore',
      'Fenwood',
      'Ferryville',
      'Fish Creek',
      'Fond du Lac',
      'Footville',
      'Forest Junction',
      'Fox Crossing',
      'Fox Point',
      'Foxboro',
      'Francis Creek',
      'Franksville',
      'Friesland',
      'Gagen',
      'Gays Mills',
      'Genesee Depot',
      'Genoa City',
      'Germania',
      'Gibbsville',
      'Gills Rock',
      'Gilmanton',
      'Glenbeulah',
      'Glenwood City',
      'Gotham',
      'Grand Marsh',
      'Grantsburg',
      'Green Bay',
      'Hager City',
      'Hales Corners',
      'Harshaw',
      'Haugen',
      'Heafford Junction',
      'Helenville',
      'Herbster',
      'Hertel',
      'Hilbert',
      'Hixton',
      'Holmen',
      'Horicon',
      'Howards Grove',
      'Humbird',
      'Hustisford',
      'Hustler',
      'Institute',
      'Iron Belt',
      'Iron Ridge',
      'Ixonia',
      'Jim Falls',
      'Johnson Creek',
      'Johnstown Center',
      'Juda',
      'Jump River',
      'Kaukauna',
      'Kekoskee',
      'Kellner',
      'Kellnersville',
      'Kempster',
      'Kennan',
      'Kenosha',
      'Keshena',
      'Kewaskum',
      'Kewaunee',
      'Kieler',
      'Knapp',
      'Kohler',
      'Krakow',
      'Kronenwetter',
      'La Farge',
      'Lac La Belle',
      'Lac du Flambeau',
      'Lake Beulah',
      'Lake Delton',
      'Lake Five',
      'Lake Geneva',
      'Lake Hallie',
      'Lake Koshkonong',
      'Lake Nebagamon',
      'Lake Ripley',
      'Lake Shangrila',
      'Lake Tomahawk',
      'Lake Wazeecha',
      'Lake Wisconsin',
      'Lake Wissota',
      'Lampson',
      'Langes Corners',
      'Lannon',
      'Laona',
      'Larsen',
      'Legend Lake',
      'Leopolis',
      'Liberty Pole',
      'Little Chute',
      'Little Rapids',
      'Little Round Lake',
      'Little Sturgeon',
      'Lomira',
      'Loyd',
      'Lublin',
      'Lunds',
      'Lyndon Station',
      'Lynxville',
      'Maine',
      'Manawa',
      'Manitowish',
      'Manitowoc',
      'Maple Bluff',
      'Maribel',
      'Marinette',
      'Markesan',
      'Mauston',
      'Mazomanie',
      'McNaughton',
      'Mellen',
      'Melvina',
      'Menasha',
      'Menchalville',
      'Menomonee Falls',
      'Mequon',
      'Meridean',
      'Merrillan',
      'Middle Village',
      'Milladore',
      'Millston',
      'Milwaukee',
      'Mindoro',
      'Minocqua',
      'Minong',
      'Mishicot',
      'Mole Lake',
      'Monches',
      'Montfort',
      'Moquah',
      'Mosinee',
      'Mount Calvary',
      'Mount Horeb',
      'Mount Tabor',
      'Mukwonago',
      'Muscoda',
      'Muskego',
      'Namekagon',
      'Nashotah',
      'Nasonville',
      'Navarino',
      'Necedah',
      'Neenah',
      'Neillsville',
      'Nekoosa',
      'Neopit',
      'Neshkoro',
      'New Franken',
      'New Glarus',
      'New Holstein',
      'New Munster',
      'New Post',
      'Newald',
      'North Cape',
      'North Fond du Lac',
      'North Freedom',
      'North Hudson',
      'North Prairie',
      'Northwoods Beach',
      'Oconomowoc',
      'Oconomowoc Lake',
      'Oconto Falls',
      'Odanah',
      'Okauchee',
      'Okauchee Lake',
      'Omro',
      'Oostburg',
      'Orfordville',
      'Packwaukee',
      'Paddock Lake',
      'Pardeeville',
      'Park Falls',
      'Patch Grove',
      'Patzau',
      'Pelican Lake',
      'Pell Lake',
      'Pembine',
      'Pence',
      'Pepin',
      'Peshtigo',
      'Pewaukee',
      'Phlox',
      'Pickett',
      'Pigeon Falls',
      'Pilsen',
      'Pipe',
      'Plat',
      'Pleasant Prairie',
      'Plum City',
      'Polonia',
      'Port Edwards',
      'Port Wing',
      'Post Lake',
      'Potter Lake',
      'Poy Sippi',
      'Poynette',
      'Prairie Farm',
      'Prairie du Chien',
      'Prairie du Sac',
      'Prentice',
      'Pulcifer',
      'Radisson',
      'Random Lake',
      'Readstown',
      'Redgranite',
      'Reedsburg',
      'Reeseville',
      'Rewey',
      'Rhinelander',
      'Rib Lake',
      'Rib Mountain',
      'Richland Center',
      'Rio Creek',
      'Riplinger',
      'River Hills',
      'Rothschild',
      'Rozellville',
      'Saint Croix Falls',
      'Saint Nazianz',
      'Salem Lakes',
      'Sauk City',
      'Saukville',
      'Sayner',
      'Scandinavia',
      'Schofield',
      'Sextonville',
      'Shawano',
      'Sheboygan',
      'Sheboygan Falls',
      'Shell Lake',
      'Shiocton',
      'Shorewood Hills',
      'Shullsburg',
      'Siren',
      'Sister Bay',
      'Slinger',
      'Soldiers Grove',
      'Solon Springs',
      'South Milwaukee',
      'South Superior',
      'South Wayne',
      'Spooner',
      'Spread Eagle',
      'Spring Green',
      'Star Prairie',
      'Stetsonville',
      'Stevens Point',
      'Stevenstown',
      'Stitzer',
      'Stoddard',
      'Stone Lake',
      'Stonebank',
      'Stoughton',
      'Strum',
      'Sturgeon Bay',
      'Sturtevant',
      'Suamico',
      'Sugar Bush',
      'Summit Corners',
      'Summit Lake',
      'Superior Village',
      'Suring',
      'Symco',
      'Tainter Lake',
      'Taycheedah',
      'Thiensville',
      'Tichigan',
      'Tigerton',
      'Tilleda',
      'Tisch Mills',
      'Tomah',
      'Tonet',
      'Tony',
      'Trempealeau',
      'Tunnel City',
      'Union Center',
      'Upson',
      'Valders',
      'Valton',
      'Van Buskirk',
      'Van Dyne',
      'Vaudreuil',
      'Viroqua',
      'Wabeno',
      'Walworth',
      'Wanderoos',
      'Warrens',
      'Waubeka',
      'Waucousta',
      'Waukau',
      'Waukesha',
      'Waumandee',
      'Waunakee',
      'Waupaca',
      'Waupun',
      'Wausaukee',
      'Wautoma',
      'Wauwatosa',
      'Wauzeka',
      'Werley',
      'West Allis',
      'West Baraboo',
      'West Bloomfield',
      'West Milwaukee',
      'Weyauwega',
      'Weyerhaeuser',
      'White Creek',
      'Whitefish Bay',
      'Whitelaw',
      'Whittlesey',
      'Wild Rose',
      'Williams Bay',
      'Wind Lake',
      'Wind Point',
      'Winneconne',
      'Winter',
      'Wisconsin Dells',
      'Wisconsin Rapids',
      'Withee',
      'Wonewoc',
      'Woodman',
      'Wyeville',
      'Wyocena',
      'Yellow Lake',
      'Yuba',
    ],
    'US-WY': [
      'Alcova',
      'Almy',
      'Antelope Hills',
      'Arminto',
      'Arrowhead Springs',
      'Baggs',
      'Bairoil',
      'Bar Nunn',
      'Bear River',
      'Bessemer Bend',
      'Big Horn',
      'Big Piney',
      'Bill',
      'Bitter Creek',
      'Bonneville',
      'Bosler',
      'Boulder Flats',
      'Boxelder',
      'Boysen',
      'Brookhurst',
      'Burgess Junction',
      'Burntfork',
      'Carlile',
      'Casper',
      'Casper Mountain',
      'Cassa',
      'Chugcreek',
      'Chugwater',
      'Clearview Acres',
      'Cokeville',
      'Cora',
      'Crowheart',
      'Deaver',
      'Devils Tower',
      'Diamondville',
      'East Thermopolis',
      'Echeta',
      'Egbert',
      'Elk Mountain',
      'Elkol',
      'Emblem',
      'Encampment',
      'Esterbrook',
      'Ethete',
      'Farthing',
      'Fontenelle',
      'Fort Bridger',
      'Fort Laramie',
      'Fort Washakie',
      'Foxpark',
      'Frannie',
      'Glendo',
      'Glenrock',
      'Greybull',
      'Grovont',
      'Hamilton Dome',
      'Hartrandt',
      'Hawk Springs',
      'Hiland',
      'Hill View Heights',
      'Hoback',
      'Homa Hills',
      'Horse Creek',
      'Hulett',
      'Hyattville',
      'James Town',
      'Jeffrey City',
      'Jelm',
      'Kaycee',
      'Keeline',
      'Kemmerer',
      'Kinnear',
      'La Barge',
      'Lance Creek',
      'Lander',
      'Laramie',
      'Leiter',
      'Linch',
      'Lingle',
      'Little America',
      'Lonetree',
      'Lost Cabin',
      'Lusk',
      'Lysite',
      'Marbleton',
      'Mayoworth',
      'McFadden',
      'Meadow Acres',
      'Medicine Bow',
      'Meeteetse',
      'Midwest',
      'Monell',
      'Moorcroft',
      'Moose',
      'Moose Wilson Road',
      'Muddy Gap',
      'Natwick',
      'North Rock Springs',
      'Orchard Valley',
      'Orin',
      'Orpha',
      'Oshoto',
      'Owl Creek',
      'Parkerton',
      'Pavillion',
      'Pine Bluffs',
      'Pine Haven',
      'Powder River',
      'Purple Sage',
      'Quealy',
      'Rafter J Ranch',
      'Ranchester',
      'Ranchettes',
      'Rawlins',
      'Recluse',
      'Red Butte',
      'Red Buttes',
      'Redbird',
      'Rock River',
      'Rockypoint',
      'Rozet',
      'Ryan Park',
      'Saddlestring',
      'Sand Draw',
      'Savery',
      'Seminoe Dam',
      'Shoshoni',
      'Sinclair',
      'Smoot',
      'South Greeley',
      'South Park',
      'South Pass City',
      'South Torrington',
      'Spotted Horse',
      'Star Valley Ranch',
      'Sundance',
      'Ten Sleep',
      'Teton Village',
      'Thayer Junction',
      'Thayne',
      'Thermopolis',
      'Tie Siding',
      'Urie',
      'Van Tassell',
      'Verne',
      'Vista West',
      'Waltman',
      'Wamsutter',
      'Wapiti',
      'Washam',
      'West Thumb',
      'Westview Circle',
      'Woods Landing',
      'Wyarno',
      'Wyodak',
      'Y-O Ranch',
    ],
  },
  URY: {
    'UY-AR': [
      'Artigas',
      'Baltasar Brum',
      'Bella Unión',
      'Bernabé Rivera',
      'Cainsa',
      'Cainza Campo 3',
      'Calnu',
      'Camaño',
      'Catalan Grande',
      'Catalan Volcan',
      'Cerro Ejido',
      'Cerro San Eugenio',
      'Cerro Signorelli',
      'Chiflero',
      'Colonia Aparicio Saravia',
      'Colonia España',
      'Colonia Estrella',
      'Colonia José Artigas',
      'Colonia Palma',
      'Colonia Pintado',
      'Colonia Viñar',
      'Cota 205',
      'Cuareim',
      'Cuaró',
      'Estiba',
      'Fagundez',
      'Franquia',
      'Guyubira',
      'Javier de Viana',
      'Lenguazo',
      'Limite Contestado',
      'Menezes',
      'Mones Quintela',
      'Otras',
      'Paguero',
      'Paredon',
      'Paso De La Cruz',
      'Paso De Leon',
      'Paso De Ramos',
      'Paso Farías',
      'Patitas',
      'Piedra Pintada',
      'Pintadito',
      'Pintado',
      'Pintado Grande',
      'Paraje Diego Lamas',
      'Pje. Paso Campamento',
      'Portones De Hierro Y Campodonico',
      'Pueblo Sequeira',
      'Rincon De Pacheco',
      'Sarandi De Cuaro',
      'Sarandi De Yacuy',
      'Tamandua',
      'Taruman',
      'Tomás Gomensoro',
      'Topador',
      'Zanja Aruera',
    ],
    'UY-CA': [
      'Aeropuerto Internacional De Carrasco',
      'Aguas Corrientes',
      'Araminda',
      'Atlántida',
      'B.H.U.',
      'Balneario Argentino',
      'Barra De La Pedrera',
      'Barra Del Tala',
      'Barra de Carrasco',
      'Barrancas Coloradas',
      'Barrio Benzo',
      'Barrio Copola',
      'Barrio Del Libertador',
      'Barrio La Lucha',
      'Barrio Los Panoramas',
      'Barrio Pretti',
      'Barrio Remanso',
      'Barrio Santa Rita',
      'Barrio Traverso',
      'Barrio Villa Murcia',
      'Barros Blancos',
      'Bañado de Medina',
      'Bello Horizonte',
      'Camino De La Cadena',
      'Camino Dodera',
      'Camino Lloveras',
      'Campo Militar',
      'Canelon Chico',
      'Canelon Chico Al Centro',
      'Canelon Chico De Progreso',
      'Canelon Grande',
      'Canelon Grande De Pacheco',
      'Canelon Grande Norte',
      'Canelones',
      'Capilla De Cella',
      'Carrasco Del Sauce',
      'Casarino',
      'Cañada Cardozo',
      'Cañada De Montaño',
      'Cañada Grande',
      'Cañada Prudencio',
      'Cerrillos Al Oeste',
      'Cerrillos Al Sur',
      'City Golf',
      'Ciudad de la Costa',
      'Cochengo',
      'Colinas De Carrasco',
      'Colinas de Carrasco',
      'Colinas de Solymar',
      'Colonia Treinta Y Tres Orientales',
      'Colorado Chico',
      'Colorado Y Brujas',
      'Costa Azul',
      'Costa De Pando',
      'Costa De Pando Olmos',
      'Costa De Pando San Bautista',
      'Costa De Pando San Jacinto',
      'Costa Del Pantanoso',
      'Costa Del Sauce',
      'Costa Del Tala Este',
      'Costa Del Tala Norte',
      'Costa Y Guillamon',
      'Costas De Pedernal',
      'Costas De Santa Lucia',
      'Costas De Solis',
      'Costas Del Colorado',
      'Costas Del Colorado Este',
      'Costas Del Tala',
      'Cruz De Los Caminos',
      'Cuchilla Alta',
      'Cuchilla Alta Y El Galeon',
      'Cuchilla Cabo De Hornos',
      'Cuchilla De Machin',
      'Cuchilla De Rocha',
      'Cuchilla De Sierra',
      'Cuchilla De Zeballos',
      'Cuchilla Verde',
      'Cueva Del Tigre',
      'Cumbres De Carrasco',
      'Echevarria',
      'El Bosque De Solymar',
      'El Colorado',
      'El Colorado De Migues',
      'El Colorado San Bautista',
      'El Cuadro',
      'El Galeon',
      'Empalme Dogliotti',
      'Empalme Nicolich',
      'Empalme Olmos',
      'Empalme Sauce',
      'Esquina Gonzalez',
      'Est. Atlántida',
      'Estacion Migues',
      'Estacion Piedras De Afilar',
      'Estacion Tapia',
      'Estación Pedrera',
      'Estación la Floresta',
      'Estanque De Pando',
      'Fortin de Santa Rosa',
      'Fracc Sobre Ruta 74',
      'Fracc. Cno. Andaluz Y R.84',
      'Fracc. Progreso',
      'General Líber Seregni',
      'Guazuvira Nuevo',
      'Guazú-Virá',
      'Haras Del Lago',
      'Instituto Adventista',
      'Jardines De Pando',
      'Jaureguiberry',
      'Joaquín Suárez',
      'Juan Antonio Artigas',
      'Juanicó',
      'La Asuncion',
      'La Chinchilla',
      'La Montañesa',
      'La Palmita',
      'La Tahona',
      'La Totora',
      'La Tuna',
      'Lago Jardin Del Bosque',
      'Lagomar',
      'Las Brujas',
      'Las Higueritas',
      'Las Ranas',
      'Las Toscas',
      'Las Violetas',
      'Lomas De Carrasco',
      'Lomas De Toledo',
      'Lomas de Solymar',
      'Los Ceibos',
      'Los Cerrillos',
      'Los Hornos',
      'Los Titanes',
      'Macana',
      'Margat',
      'Marindia',
      'Mata Siete',
      'Mataojo',
      'Melgarejo',
      'Melilla',
      'Migues',
      'Montes',
      'Montes de Solymar',
      'Médanos de Solymar',
      'Nataly',
      'Neptunia',
      'Nutrias',
      'Olmos',
      'Pando',
      'Pantanoso',
      'Pantanoso Del Sauce',
      'Parada Cabrera',
      'Parador Tajes',
      'Parque Carrasco',
      'Parque Miramar',
      'Parque de Solymar',
      'Parque del Plata',
      'Paso Arbelo',
      'Paso De Cuello',
      'Paso De La Cadena',
      'Paso De La Paloma',
      'Paso De La Salamanca',
      'Paso De Las Toscas',
      'Paso De Los Alamos',
      'Paso De Los Difuntos',
      'Paso De Los Francos',
      'Paso De Pache',
      'Paso Del Bote',
      'Paso Del Colorado',
      'Paso Del Medio',
      'Paso Del Sordo',
      'Paso Espinosa',
      'Paso Palomeque',
      'Paso Rivero De Vejigas',
      'Paso de Carrasco',
      'Pedernal Chico',
      'Pedernal Grande',
      'Piedra Del Toro',
      'Piedra Sola',
      'Piedras de Afilar',
      'Piedritas',
      'Piedritas De Suarez',
      'Pinamar Y Pinepark',
      'Pinares de Solymar',
      'Ponce Mata Siete',
      'Poquitos',
      'Pueblo Castellanos',
      'Pueblo Suizo',
      'Puente De Brujas',
      'Puntas De Brujas',
      'Puntas De Canelon Chico',
      'Puntas De Cañada Cardozo',
      'Puntas De Cañada Grande',
      'Puntas De Cochengo',
      'Puntas De Las Violetas',
      'Puntas De Mata Siete',
      'Puntas De Pantanoso',
      'Puntas De Pantanoso Este',
      'Puntas De Pedrera',
      'Puntas De Toledo',
      'Puntas De Vejigas',
      'Puntas Del Arenal',
      'Quinta Los Horneros',
      'Quintas Del Bosque',
      'Rancherios De Ponce',
      'Rincon De Carrasco',
      'Rincon De Pando',
      'Rincon De Portezuelo',
      'Rincon De Velazquez',
      'Rincon De Vidal',
      'Rincon Del Colorado',
      'Rincon Del Conde',
      'Rincon Del Gigante',
      'San Bautista',
      'San José de Carrasco',
      'Santa Lucía del Este',
      'Santos Lugares',
      'Sarandi De Migues',
      'Sauce De Solis',
      'Sauce Solo',
      'Sauce Solo De Migues',
      'Sauce Solo De Montes',
      'Seis Hermanos',
      'Shangrilá',
      'Sierra del Mar',
      'Soca',
      'Sofia Santos',
      'Solis Chico De Migues',
      'Solymar',
      'Solís Chico',
      'Sosa Diaz',
      'Talita',
      'Vejigas',
      'Vejigas De San Ramon',
      'Vejigas De Tala',
      'Viejo Molino San Bernardo',
      'Villa Aeroparque',
      'Villa Arejo',
      'Villa Argentina',
      'Villa El Tato',
      'Villa Encantada',
      'Villa Felicidad',
      'Villa Foresti',
      'Villa Fortuna',
      'Villa Hadita',
      'Villa Huertos De Toledo',
      'Villa Juana',
      'Villa Juanita',
      'Villa Los Alpes',
      'Villa Marina',
      'Villa Molfino',
      'Villa Paz S.A.',
      'Villa Prados De Toledo',
      'Villa San Cono',
      'Villa San Felipe',
      'Villa San José',
      'Villa Valverde',
      'Vista Linda',
    ],
    'UY-CL': [
      'Arachania',
      'Arbolito',
      'Arevalo',
      'Arroyo Malo',
      'Arrozal Cesarone',
      'Arrozal Rosales',
      'Asperezas',
      'Barra Del Sauce',
      'Barra Del Tacuari',
      'Barrio La Vinchuca',
      'Barrio Lopez Benitez',
      'Bañado De Las Pajas',
      'Bañado De Medina',
      'Berachi',
      'Calera De Recalde',
      'Casa De Las Cronicas',
      'Caserio Las Cañas',
      'Cañada Brava',
      'Cañada De Santos',
      'Cañada Sarandi',
      'Cañitas',
      'Cementerio',
      'Centurion',
      'Cerro De Las Cuentas',
      'Chacras De Melo',
      'Colonia Ceres',
      'Colonia Maria Teresa',
      'Colonia Orozco',
      'Conventos',
      'Corral De Piedra',
      'Cruz De Piedra',
      'Cuchilla Cambota',
      'Cuchilla De Melo',
      'Cuchilla Del Carmen',
      'Cuchilla Del Paraiso',
      'Cuchilla Peralta',
      'Duraznero',
      'Escuela De Agronomia',
      'Falda De Sierra De Los Rios',
      'Fraile Muerto',
      'Ganen',
      'Garao',
      'Granja De Acegua',
      'Granja Pallero',
      'Guazunambi',
      'Hipodromo',
      'Infiernillo',
      'Isidoro Noblia',
      'La Coronilla',
      'La Micaela',
      'Lago Merín',
      'Laguna Del Junco',
      'Las Limas',
      'Los Cerros',
      'Mangrullo',
      'Mazangano',
      'Minuano De Acegua',
      'Misterio',
      'Nando',
      'Panteon',
      'Paso De Las Tropas',
      'Paso De Las Yeguas',
      'Paso De Los Carros',
      'Paso Melo',
      'Paso Pereira',
      'Peñarol',
      'Picada De Maya',
      'Picada De Salome',
      'Piedra Alta',
      'Piñeiro',
      'Placido Rosas',
      'Poblado Uruguay',
      'Presidente Doctor Getulio Vargas',
      'Puente Negro',
      'Puntas De Amarillo',
      'Puntas De La Mina',
      'Puntas De Molles',
      'Puntas De Palleros',
      'Puntas De Tacuari',
      'Puntas Del Sauce',
      'Ramon Trigo',
      'Rincon De Contreras',
      'Rincon De La Urbana',
      'Rincon De Los Coroneles',
      'Rincon De Los Olivera',
      'Rincon De Paiva',
      'Rincon De Py',
      'Rincon De Suarez',
      'Rincon De Tacuari',
      'Rodriguez',
      'Río Branco',
      'Saldañas',
      'San Servando',
      'Sanchez',
      'Sarandi De Acegua',
      'Sarandi De Barcelo',
      'Sarandi De Yaguaron',
      'Sauce De Conventos',
      'Soto Goro',
      'Tres Boliches',
      'Tres Islas',
      'Tupambaé',
      'Uruguay',
      'Villa Viñoles',
      'Wenceslao Silvera',
      'Ñangapire',
    ],
    'UY-CO': [
      'Agraciada',
      'Arrivillaga',
      'Artilleros',
      'Barker Norte',
      'Barrio Mendaña',
      'Barrio Olimpico',
      'Belgrano Norte',
      'Belgrano Sur',
      'Blanca Arena',
      'Boca Del Rosario Oeste',
      'Boca del Rosario',
      'Bonjour',
      'Brisas Del Plata',
      'Buena Hora',
      'Campamento Artigas',
      'Carmelo',
      'Caserio El Cerro',
      'Cerro Carmelo',
      'Cerro De Las Armas',
      'Cerros De San Juan',
      'Cerros Negros',
      'Chico Torino',
      'Colonia Arrue',
      'Colonia Cosmopolita',
      'Colonia Española',
      'Colonia Miguelete',
      'Colonia Peirano',
      'Colonia Quevedo',
      'Colonia Sarandi',
      'Colonia Talice',
      'Colonia Valdense',
      'Colonia del Sacramento',
      'Conchillas',
      'Costa De Colla Al Este',
      'Costa De Rosario',
      'Costa De Tarariras',
      'Costa De Vacas',
      'Costa Del Navarro',
      'Costas De Juan Gonzalez',
      'Costas De Polonia',
      'Costas De San Juan',
      'Cufre',
      'Curupi',
      'El Bañado',
      'El Caño',
      'El Chileno',
      'El Ensueño',
      'El Faro',
      'El General',
      'El Quinton',
      'El Semillero',
      'Estacion Experimental La Estanzuela',
      'Estancia Anchorena',
      'Florencio Sánchez',
      'Gil',
      'Juan Carlos Caseros',
      'Juan Gonzalez',
      'Juan Jackson',
      'Juan Lacaze',
      'La Estanzuela',
      'La Horqueta',
      'Laguna De Los Patos',
      'Las Chispas',
      'Lomas De Carmelo',
      'Manantiales',
      'Martin Chico',
      'Martin Chico De Conchillas',
      'Media Agua',
      'Miguelete De Conchillas',
      'Minas De Narancio',
      'Minuano Y Sauce',
      'Molles De Miguelete',
      'Nueva Helvecia',
      'Nueva Palmira',
      'Ombues De Lavalle',
      'Paraje Minuano',
      'Paso Antolin',
      'Paso Birriel',
      'Paso De La Quinta',
      'Paso Hospital',
      'Paso Hospital Manantiales',
      'Paso Morlan',
      'Paso Quicho',
      'Pastoreo',
      'Picada De Benitez',
      'Piedra Chata',
      'Piedra De Los Indios',
      'Piedras Blancas',
      'Playa Azul',
      'Playa Britopolis',
      'Playa Fomento',
      'Playa Parant',
      'Polancos',
      'Puerto Ingles',
      'Puerto Platero',
      'Punta Francesa',
      'Puntas De Juan Gonzalez',
      'Puntas De Melo',
      'Puntas De San Juan',
      'Puntas De San Pedro',
      'Puntas Del Riachuelo',
      'Puntas Del Rosario',
      'Radial Hernandez',
      'Radial Rosario',
      'Real De Vera',
      'Reducto',
      'Resguardo Cufre',
      'Rincon Del Rey',
      'Rosario Y Colla',
      'San Luis De Tarariras',
      'San Luis Sanchez',
      'San Pedro De Arriba',
      'San Pedro Norte',
      'Santa Regina',
      'Sarandi Campana',
      'Tarariras',
      'Tomas Bell',
      'Tres Esquinas',
      'Valdenese',
      'Viboras Y Vacas',
      'Villa Pancha',
      'Zagarzazu',
      'Zunin',
    ],
    'UY-DU': [
      'Abella',
      'Arroyo De Los Perros',
      'Barrio Duran',
      'Baygorria',
      'Blanquillo',
      'Blanquillo Al Oeste',
      'Capilla De Farruco',
      'Carlos Reyles',
      'Ceibal',
      'Cerrezuelo',
      'Cerro Convento',
      'Chacras De Durazno',
      'Chileno',
      'Chileno Chico',
      'Chileno Grande (Aguero)',
      'Costa De Cuadra',
      'Cuchilla De Ramirez',
      'Cuchilla Del Rincon',
      'De Dios',
      'Durazno',
      'Elias Regules',
      'Estacion Chileno',
      'Higueras De Carpinteria',
      'La Alegria',
      'La Mazamorra',
      'Las Acacias',
      'Las Cañas',
      'Los Agregados',
      'Los Tapes',
      'Maestre Campo',
      'Malbajar Este',
      'Malbajar Oeste',
      'Maria Cejas',
      'Mariscala',
      'Mariscala Del Carmen',
      'Molles Chico',
      'Molles De Quinteros',
      'Mouriño',
      'Municipio De Durazno',
      'Ombues De Oribe',
      'Palmar De Porrua',
      'Parada Sur',
      'Paso De Aguirre',
      'Paso De Castro',
      'Paso Del Medio Las Palmas',
      'Paso Ramirez',
      'Paso Real De Carpinteria',
      'Paso Tejera',
      'Pueblo Centenario',
      'Pueblo De Alvarez',
      'Puglia',
      'Puntas De Carpinteria',
      'Puntas De Herrera',
      'Puntas De Malbajar',
      'Rincon De Cuadra',
      'Rincon De Los Tapes',
      'Rolon',
      'Rossell Y Rius',
      'Salinas Chico',
      'San Jose De Las Cañas',
      'Sandu Chico',
      'Santa Bernardina',
      'Sarandi De La China',
      'Sarandi De Rio Negro',
      'Sarandí del Yi',
      'Sauce De Herrera',
      'Sauce Del Yi',
      'Tala De Mariscala',
      'Tejera',
      'Villa Del Carmen',
      'Villasboas',
    ],
    'UY-FS': [
      'Ahogados',
      'Andresito',
      'Arenal Chico',
      'Arenal Grande',
      'Cañada Amilivia',
      'Cerro Colorado',
      'Chacras',
      'Chacras De Borghi',
      'Colonia Alemana',
      'Costas De San Jose',
      'Cuchilla De Villasboas',
      'El Coronilla',
      'El Totoral',
      'Ferrizo',
      'Ismael Cortinas',
      'Juan Jose Castro',
      'La Casilla',
      'La Cordobesa',
      'Los Puentes',
      'Marincho',
      'Paso De Lugo',
      'Paso Hondo',
      'Pueblo Pintos',
      'Puntas De Chamanga',
      'Puntas De Marincho',
      'Puntas De San Jose',
      'Puntas De Sarandi',
      'Puntas Del Corral De Piedra',
      'Rincon Del Palacio',
      'San Gregorio De Flores',
      'Santa Adelaida',
      'Talas De Maciel',
      'Villa Pastora',
    ],
    'UY-FD': [
      '25 De Agosto',
      'Alejandro Gallinal',
      'Arrayan',
      'Arroyo Chamizo',
      'Arroyo De Los Negros',
      'Arroyo Latorre',
      'Arroyo Monzon',
      'Arroyo Pelado',
      'Barra Molles Del Timote',
      'Barra Sauce De Mansavillagra',
      'Berrondo',
      'Calleri',
      'Candil',
      'Capilla Del Sauce',
      'Cardal',
      'Caserio La Fundacion',
      'Casupa',
      'Cerro De La Macana',
      'Cerros De Florida',
      'Chacras De Florida',
      'Chacras Del Pintado',
      'Chamizo',
      'Chamizo Chico',
      'Chilcas',
      'Chingolas',
      'Colonia Sanchez',
      'Costa De Arias',
      'Costa De Illescas',
      'Costa De La Cruz',
      'Costa De Parana',
      'Costa Del Tala',
      'Costas De Arias',
      'Costas De Chamizo',
      'Costas De Chamizo Grande',
      'Costas De Maciel',
      'Costas De Santa Lucia Chico',
      'Costas Del Amarillo',
      'Costas Del Pintado',
      'Costas Del Santa Lucia Grande',
      'Cuchilla Santo Domingo',
      'Dr. A. Gallinal',
      'Estacion Capilla Del Sauce',
      'Ferrer',
      'Fray Marcos',
      'La Cimbra',
      'La Escobilla',
      'La Macana',
      'Las Piedritas',
      'Mansavillagra',
      'Mendoza Chico',
      'Mendoza Grande',
      'Molles Del Pescado',
      'Molles Del Timote',
      'Montecoral',
      'Nico Perez',
      'Pantanoso De Castro',
      'Paso Calleros',
      'Paso De Los Novillos',
      'Paso Real De Mansavillagra',
      'Paso Vela',
      'Piedra Campana',
      'Piedras Coloradas',
      'Polanco Del Yi',
      'Pueblo De Los Morochos',
      'Puente De Mendoza',
      'Puntas De Calleros',
      'Puntas De Chamame',
      'Puntas De Chamizo',
      'Puntas De Illescas',
      'Puntas De La Escobilla',
      'Puntas De Maciel',
      'Puntas De Mansavillagra',
      'Puntas De Sauce De Maciel',
      'Puntas Del Arroyo Latorre',
      'Reboledo',
      'Rincon De Los Camilos',
      'Rincon De Vignoli',
      'Rincon Sauce Del Yi',
      'San Pedro De Timote',
      'Sarandí Grande',
      'Sauce De Maciel',
      'Sauce De Villanueva',
      'Tabare',
      'Tala De Castro',
      'Tala De Maciel',
      'Tornero',
      'Urioste',
      'Veinticinco de Mayo',
      'Vignoli',
      'Villa Hipica',
      'Villa Vieja',
    ],
    'UY-LA': [
      '19 De Junio',
      'Abra De Zabaleta',
      'Aguas Blancas',
      'Alonso',
      'Aramendia',
      'Arequita',
      'Arroyo De Los Patos',
      'Arroyo Del Medio',
      'Azucar',
      'Barra De Los Chanchos',
      'Barriga Negra',
      'Barrio La Coronilla - Ancap',
      'Blanes Viale',
      'Campanero',
      'Canteras Del Verdun',
      'Carnales',
      'Casupa Chico',
      'Cerro Pelado',
      'Chamame',
      'Consejo Del Niño',
      'Costa Del Lenguazo',
      'Costas De Corrales',
      'Costas Del Soldado',
      'El Perdido',
      'El Soldado',
      'El Tigre',
      'Espuelitas',
      'Estacion Andreoni',
      'Estacion Ortiz',
      'Estacion Solis',
      'Gaetan (Cuchilla De Carbajal)',
      'Godoy',
      'Gutierrez',
      'Higueritas',
      'José Batlle y Ordoñez',
      'José Pedro Varela',
      'La Cuchilla',
      'Ladrillos',
      'Larrosa',
      'Las Achiras',
      'Manguera Azul',
      'Marco De Los Reyes',
      'Maria Isabel',
      'Marmaraja',
      'Molles De Aigua',
      'Molles De Cañada Grande',
      'Molles Del Sauce',
      'Ombues De Bentancor',
      'Ortiz Castro',
      'Paso De Los Troncos',
      'Paso De Mesa',
      'Piraraja',
      'Polanco Norte',
      'Polanco Sur',
      'Pororo',
      'Puente De Marmaraja',
      'Puntas De Barriga Negra',
      'Puntas De Los Chanchos',
      'Puntas De Polanco',
      'Puntas De San Francisco',
      'Puntas De Santa Lucia',
      'Puntas De Solis',
      'Puntas Del Perdido',
      'Retamosa',
      'Rincon De Cebollati',
      'Rincon De Mariscala',
      'Rincon De Silva',
      'Roldan',
      'San Francisco De Las Sierras',
      'Santa Lucia',
      'Sarandi De Gutierrez',
      'Sauce De Aigua',
      'Sauce De Olimar Chico',
      'Sierras Blancas',
      'Soldado',
      'Solis Grande',
      'Solís de Mataojo',
      'Tapes Chico',
      'Tapes Grande',
      'Valle De Solis',
      'Velazquez',
      'Villa Serrana',
      'Zapican',
    ],
    'UY-MA': [
      'Abra De Castellanos',
      'Abra de Perdomo',
      'Aiguá',
      'Alferez',
      'Arenas De Jose Ignacio',
      'Arroyito De Medina',
      'Balneario Buenos Aires',
      'Balneario Las Flores',
      'Barra De Portezuelo',
      'Barrio Kennedy',
      'Canteras De Marelli',
      'Carape',
      'Carlos Cal',
      'Cañada Bellaca',
      'Cañada De La Cruz',
      'Cerros Azules',
      'Colonia J. Suarez',
      'Coronilla',
      'Corte De La Leña',
      'Costas De Jose Ignacio',
      'Eden Rock',
      'El Chorro',
      'El Quijote',
      'El Tesoro',
      'Faro Jose Ignacio',
      'Faro Jose Ignacio Norte',
      'Garzon',
      'Gerona',
      'Gregorio Aznárez',
      'Guardia Vieja',
      'José Ignacio',
      'La Barra',
      'La Capuera',
      'La Juanita',
      'La Sonrisa',
      'Lago De Los Cisnes',
      'Laguna Del Sauce',
      'Las Cumbres',
      'Las Flores - Estacion',
      'Los Aromos',
      'Los Corchos',
      'Los Talas',
      'Maldonado',
      'Molles De Garzon',
      'Nueva Carrara',
      'P. Ballena',
      'P. Coloradas',
      'Pago De La Paja',
      'Pan de Azúcar',
      'Parque Medina',
      'Partido Norte',
      'Partido Oeste',
      'Paso De La Cantera',
      'Paso De Los Talas',
      'Pinares',
      'Piriápolis',
      'Playa Grande',
      'Playa Hermosa',
      'Playa Verde',
      'Pueblo Edén',
      'Pueblo Solis',
      'Punta Fría',
      'Punta Piedras',
      'Punta del Este',
      'Puntas De Jose Ignacio',
      'Puntas De La Sierra',
      'Puntas De Mataojo',
      'Puntas De Pan De Azucar',
      'Puntas Del Campanera',
      'Rincon De Aparicio',
      'Rincon De Los Sosa',
      'Rincon Del Indio',
      'Ruta 37 Y 9',
      'San Juan Del Este',
      'Sarandi De Aigua',
      'Sarandi Del Mataojo',
      'Sauce de Portezuelo',
      'Solís',
      'Villa Delia',
      'Zanja Del Tigre',
    ],
    'UY-MO': [
      'Abayubá',
      'Aires Puros',
      'Barrio Sur',
      'Bañados de Carrasco',
      'Bella Italia',
      'Brazo Oriental',
      'Buceo',
      'Capurro',
      'Carrasco Norte',
      'Casabo',
      'Casavalle',
      'Cementerio del Norte',
      'Conciliación',
      'Cordón',
      'Cuchilla Pereira',
      'Flor de Maroñas',
      'Goes',
      'Jacinto Vera',
      'Jardines Hipódromo',
      'La Comercial',
      'La Figurita',
      'La Paloma Tomkinson',
      'La Teja',
      'Larrañaga',
      'Las Canteras',
      'Lavalleja',
      'Lezica',
      'Malvin',
      'Malvin Norte',
      'Marconi',
      'Maroñas',
      'Maroñas, Curva',
      'Mercado Modelo',
      'Nuevo París',
      'Pajas Blancas',
      'Parque Batlle',
      'Parque Rodó',
      'Paso Molino',
      'Paso de la Arena',
      'Paso de las Duranas',
      'Perez Castellanos',
      'Pocitos',
      'Pocitos Nuevo',
      'Puerto Buceo',
      'Punta Carretas',
      'Punta Espinillo',
      'Punta Rieles',
      'Pérez Castellanos',
      'Santiago Vázquez',
      'Sayago',
      'Toledo Chico',
      'Tres Cruces',
      'Tres Ombúes',
      'Villa Biarritz',
      'Villa Dolores',
      'Villa Española',
      'Villa Muñoz',
      'Villa del Cerro',
    ],
    'UY-PA': [
      'Al Sur De Arroyo Sacra',
      'Arbolito (Totoral)',
      'Arroyo Negro',
      'Beisso',
      'Cangue',
      'Carumbe',
      'Cañada Del Pueblo',
      'Chacras De Paysandu',
      'Chacras De Paysandu Norte',
      'Chacras De Paysandu Sur',
      'Chapicuy',
      'Colonia Arroyo Malo',
      'Colonia Cangue',
      'Colonia Juncal',
      'Colonia Las Delicias',
      'Colonia Paysandu',
      'Colonia Santa Blanca',
      'Colonia Uruguaya',
      'Constancia',
      'Costa De Sacra',
      'Cuchilla De Buricayupi',
      'Cuchilla De Fuego',
      'Cuchilla San Jose',
      'El Duraznal',
      'El Eucaliptus',
      'El Horno',
      'El Tarugo',
      'Estacion Porvenir',
      'Etchemendi',
      'Gallinal',
      'Guaviyu De Quebracho',
      'Guayabos',
      'Guichón',
      'La Lata Ruta 3 (Km. 375)',
      'La Paz (Ruta 3 Km. 346)',
      'La Tentacion',
      'Lorenzo Geyres',
      'Molles Grande',
      'Morato (Tres Arboles)',
      'Nuevo Paysandu',
      'Orgoroso',
      'Palmar Del Quebracho',
      'Parada Dayman',
      'Parada Pandule',
      'Parada Rivas',
      'Paysandú',
      'Perico Moreno',
      'Piñera',
      'Pueblo Alonzo',
      'Pueblo Esperanza',
      'Pueblo Federacion',
      'Puntas De Arroyo Negro',
      'Puntas De Bacacua',
      'Puntas De Buricayupi',
      'Puntas De Cangue',
      'Puntas De Gualeguay',
      'Puntas De Las Isletas',
      'Queguay Grande',
      'Queguayar',
      'Rabon',
      'San Felix',
      'San Mauricio',
      'Santa Kilda',
      'Sauce De Abajo',
      'Sauce Del Buricayupi',
      'Sauce Del Queguay',
      'Soto',
      'Tambores',
      'Termas De Almiron',
      'Termas De Guaviyu',
      'Tomas Paz',
      'Tres Bocas',
      'Villa Maria (Tiatucura)',
    ],
    'UY-RV': [
      'Abrojal',
      'Alborada',
      'Arroyo Blanco',
      'Arroyo Sauzal',
      'Ataques',
      'Barra De Ataques',
      'Barrio Recreo',
      'Bañado Del Chaja',
      'Berruti',
      'Blanquillos',
      'Buena Orden Al Norte',
      'Buena Union',
      'Capon Alto',
      'Caraguata',
      'Cerrillada',
      'Cerro Alegre',
      'Cerro Blanco De Cuñapiru',
      'Cerro Caqueiro',
      'Cerro Chapeu',
      'Cerro Pelado Al Este',
      'Cerro Solito',
      'Cerros Blancos',
      'Cerros De La Calera',
      'Chirca De Caraguata',
      'Coronilla De Corrales',
      'Costas De Cuñapiru',
      'Cruz De San Pedro',
      'Cuchilla De Tres Cerros',
      'Cuchilla De Yaguari',
      'Cuchilla Mangueras',
      'Curticeiras',
      'Curtume',
      'Cuñapiru',
      'El Ceibo',
      'El Palmito',
      'Guaviyu',
      'Hospital',
      'La Caillava',
      'La Cerrillada',
      'Lagos Del Norte',
      'Lagunon',
      'Los Potreros',
      'Lunarejo',
      'Mandubi',
      'Manuel Diaz',
      'Masoller',
      'Minas De Cuñapiru (Usinas)',
      'Minas De Zapucay',
      'Minas de Corrales',
      'Moirones',
      'Parada Medina',
      'Paso Amarillo',
      'Paso Ataques',
      'Paso Casildo',
      'Paso De Arriera',
      'Paso De Ataques',
      'Paso De Frontera',
      'Paso De Gaire',
      'Paso De La Arena',
      'Paso De La Calera',
      'Paso Del Lagunon',
      'Paso Del Puerto',
      'Paso Del Tapado',
      'Paso Lapuente',
      'Paso Serpa',
      'Platon',
      'Pueblo De Los Santos',
      'Pueblo Socorro',
      'Puntas De Abrojal',
      'Puntas De Corrales',
      'Puntas De Cuñapiru',
      'Puntas Del Sauzal',
      'Puntas Del Yaguari',
      'Rincon De Amarillo',
      'Rincon De Diniz',
      'Rincon De Los Castillos',
      'Rincon De Moraes',
      'Rincon De Rodriguez',
      'Rincon De Roland',
      'Rincon De Tres Cerros',
      'Rincon De Yaguari',
      'Sauce De Batovi',
      'Sauzal',
      'Segarra',
      'Tranqueras',
      'Tres Cerros',
      'Tres Puentes',
      'Vichadero',
      'Villa Indart',
      'Yaguari',
      'Zanja Honda',
      'Zanja Honda De Tranqueras',
    ],
    'UY-RO': [
      '18 De Julio',
      '19 De Abril',
      'Abra De Alferez',
      'Aguas Dulces',
      'Antoniopolis',
      'Balneario La Esmeralda',
      'Balneario Pueblo Nuevo',
      'Barra Isla Negra',
      'Barra de Valizas',
      'Barra del Chuy',
      'Barrancas De La Coronilla',
      'Barrio Cardozo',
      'Barrio Carpacho',
      'Barrio Pereira',
      'Barrio Porvenir',
      'Barrio Torres',
      'Cabo Polonio',
      'Capacho',
      'Castillos',
      'Cebollati',
      'Cerro De Los Rocha',
      'Cerro De Pescadores',
      'Chuy',
      'Colonia Greissing',
      'Costas De Cebollati',
      'Cuchilla De Garzon',
      'Cuchilla Del Arbolito',
      'El Canelon',
      'El Chimango',
      'Fortin De San Miguel',
      'Garzon Abajo',
      'Garzon Al Medio',
      'Garzon Arriba',
      'Kilometro 18',
      'La Aguada Y Costa Azul',
      'La Ribiera',
      'Laguna de Rocha',
      'Las Garzas',
      'Lascano',
      'Los Ajos',
      'Oceania Del Polonio',
      'Palmar De Castillos',
      'Palmares De La Coronilla',
      'Paso De Lopez',
      'Paso Del Bañado',
      'Paso Del Ombu',
      'Paso Doña Rosa',
      'Picada Tolosa',
      'Plano 291',
      'Puente Valizas',
      'Puerto De Los Botes',
      'Puimayen',
      'Punta Cebollati',
      'Punta Palmar',
      'Punta Rubia',
      'Punta del Diablo',
      'Puntas De Don Carlos',
      'Rincon De Valizas',
      'Rocha',
      'Samuel',
      'San Luis Al Medio',
      'San Sebastian De La Pedrera',
      'Sauce De Rocha',
      'Sierra De Los Rocha',
      'Tajamares De La Pedrera',
      'Velázquez',
    ],
    'UY-RN': [
      'Algorta',
      'Barrio Anglo',
      'Bellaco',
      'Caracoles',
      'Colonia El Ombu',
      'Colonia John F. Kennedy',
      'Don Esteban',
      'El Abrojal',
      'El Surco',
      'Estacion Francia',
      'Estancia Vichadero',
      'Fray Bentos',
      'Isla De Arguelles',
      'La Arena',
      'Las Fracciones',
      'Los Arrayanes',
      'Los Mellizos',
      'Los Ranchos',
      'Menafra',
      'Merinos',
      'Molles De Porrua',
      'Nuevo Berlín',
      'Ombucitos',
      'Palmar Grande',
      'Paso De Balbuena',
      'Paso De Leopoldo',
      'Paso De Los Cobres',
      'Paso De Soca',
      'Pauru',
      'Porton Haedo',
      'Pte. San Martin',
      'Pueblo Grecco',
      'Puntas De Averias',
      'Sanchez Chico',
      'Santa Elisa',
      'Sarandi De Navarro',
      'Uleste',
      'Valle De Soba',
      'Villa General Borges',
      'Villa Maria',
      'Yaguarete',
    ],
    'UY-SA': [
      'Arenitas Blancas',
      'Balneario Albisu',
      'Biassini',
      'Bordenave',
      'Campo De Todos',
      'Cerrilladas De Saucedo',
      'Cerros De Vera',
      'Chacras De Belen',
      'Chacras De Constitucion',
      'Colonia 18 De Julio',
      'Colonia Itapebi',
      'Colonia Lavalleja',
      'Colonia Osimani',
      'Colonia Rubio',
      'Cuchilla De Guaviyu',
      'Cuchilla Del Salto',
      'El Espinillar',
      'El Mellado',
      'Guaviyu De Arapey',
      'La Bolsa 02',
      'La Bolsa 03',
      'La Caballada',
      'Los Orientales',
      'Mataojito',
      'Mataojo Grande',
      'Nueva Hesperides',
      'Olivera',
      'Osimani Y Llerena',
      'Parada Herreria',
      'Parque Jose Luis',
      'Paso Cementerio',
      'Paso De Las Piedras De Arerungua',
      'Paso Del Parque Del Dayman',
      'Paso Del Potrero',
      'Paso Fialho',
      'Paso Nuevo Del Arapey',
      'Paso Valega',
      'Pepe Nuñez',
      'Pueblo Cayetano',
      'Pueblo Farias',
      'Pueblo Fernandez',
      'Pueblo Quintana',
      'Pueblo Ramos',
      'Puntas De Valentin',
      'Rincon De Valentin',
      'Russo',
      'Sarandi De Arapey',
      'Sauce Chico',
      'Saucedo',
      'Sopas',
      'Talas De Itapebi',
      'Termas Del Arapey',
      'Termas Del Dayman',
      'Toro Negro',
      'Tropezon',
      'Tropiezo',
      'Valentin Grande',
      'Yacuy',
      'Zanja De Alcain',
    ],
    'UY-SJ': [
      'Villa Olimpica',
      'Arroyo de la Virgen',
      'Autodromo Nacional',
      'Balneario Kiyú',
      'Bañado',
      'Boca Del Cufre',
      'Cagancha',
      'Cagancha Chico',
      'Carreta Quemada',
      'Ceramicas Del Sur',
      'Ciudad del Plata',
      'Cololo Tinosa',
      'Colonia Agraria Delta',
      'Colonia America',
      'Colonia Doctor Bernardo Etchepare',
      'Colonia Fernandez Crespo',
      'Colonia Italia',
      'Colonia Juan Maria Perez',
      'Colonia San Joaquin',
      'Colonia Wilson',
      'Costa Del Mauricio',
      'Costas De Pereira',
      'Costas Del Sauce',
      'Cuchilla De Pereira',
      'Cuchilla Del Vichadero',
      'Cuchilla Seca',
      'Delta El Tigre',
      'Ecilda Paullier',
      'Escudero',
      'Fajina',
      'Guaycuru',
      'Ituzaingo',
      'Jesus Maria',
      'Juan Soler',
      'La Boyada',
      'Mahoma',
      'Mal Abrigo',
      'Mundo Azul',
      'Mundo Azul Aguirre',
      'Orillas Del Plata',
      'Pachina',
      'Panta',
      'Parque Postel',
      'Parque Postel Cnel. Adrian Medina',
      'Paso Belastiqui',
      'Paso De Cames',
      'Paso De Las Piedras',
      'Paso De Mas',
      'Paso Del Carreton',
      'Paso Del Guaycuru',
      'Paso Del Rey',
      'Pavon',
      'Penino',
      'Perico Perez',
      'Picada Gambetta',
      'Playa Pascual',
      'Puntas De Cagancha',
      'Puntas De Gregorio',
      'Puntas De Laurel',
      'Puntas De Tropa Vieja',
      'Puntas De Valdez',
      'Radial Ruta 3',
      'Rafael Perazza',
      'Raigon',
      'Rincon De Albano',
      'Rincon De Arazati',
      'Rincon De Arias',
      'Rincon De Buschental',
      'Rincon De Cufre',
      'Rincon De La Bolsa',
      'Rincon De La Torre',
      'Rincon De Nazareth',
      'Rincon Del Pino',
      'Rocho',
      'Safici',
      'San Fernando Chico',
      'San José de Mayo',
      'Scavino',
      'Tabarez',
      'Tala De Pereira',
      'Tranquera Colorada',
      'Tropas Viejas',
      'Valdez Chico',
      'Villa Rives',
      'Villa Rodriguez',
    ],
    'UY-SO': [
      'Altos Del Perdido',
      'Asencio',
      'Azotea De Vera',
      'Bajos Del Perdido',
      'Bequelo',
      'Bizcocho',
      'Cardona',
      'Cañada Magallanes',
      'Cañada Nieto',
      'Cañada Paraguaya',
      'Cerro Vera',
      'Chacras De Dolores',
      'Chacras De Mercedes',
      'Cololo',
      'Colonia Concordia',
      'Colonia Diaz',
      'Colonia Larrañaga',
      'Colonia Santa Clara',
      'Costa Del Aguila',
      'Costas Del Perdido',
      'Cuatro Bocas De Buena Vista',
      'Cuchilla Del Corralito',
      'Cuchilla Del Perdido',
      'Duraznito',
      'Egaña',
      'El Aguila',
      'Espinillo',
      'Garula',
      'Grito De Asencio',
      'Jose Enrique Rodo',
      'La Tabla',
      'Las Maulas',
      'Lata Del Perdido',
      'Monzon',
      'Palmitas',
      'Palo Solo',
      'Parada Suarez',
      'Pedro Chico',
      'Perseverano',
      'Puntas De Arenales',
      'Puntas De Durazno',
      'Puntas De San Salvador',
      'Puntas Del Tala',
      'Rincon De Cañada Nieto',
      'Rincon De Cololo',
      'Rincon De Ruiz',
      'Risso',
      'San Dios',
      'Santa Blanca',
      'Sarandi Chico',
      'Unidad Cooperaria No 1',
      'Villa Alejandrina',
      'Villa Darwin',
      'Villa Soriano',
    ],
    'UY-TA': [
      'Achar',
      'Ataque',
      'Balneario Ipora',
      'Barrio La Matutina',
      'Barrio Libertad',
      'Barrio Lopez',
      'Barrio Santangelo',
      'Bañado De Cañas',
      'Bañado De Rocha',
      'Caraguata Al Norte',
      'Cardozo Chico',
      'Cañada Del Estado',
      'Cerro Batovi',
      'Cerro De Pastoreo',
      'Cerro De Pereira',
      'Cerro Del Arbolito',
      'Cerros De Clara',
      'Charata',
      'Cinco Sauces',
      'Costas De Caraguata',
      'Costas De Tres Cruces',
      'Coyo Martinez',
      'Cuchilla De La Casa De Piedra',
      'Cuchilla De La Palma',
      'Cuchilla De Laureles',
      'Cuchilla De Peralta',
      'Cuchilla Del Ombu',
      'Curtina',
      'Estacion Menendez',
      'Frigorifico Modelo',
      'Heriberto',
      'La Aldea',
      'La Bolsa 01',
      'La Hilera',
      'Lambare',
      'Larrayos',
      'Las Arenas',
      'Las Chircas',
      'Las Pajas',
      'Las Toscas De Caraguata',
      'Los Coitinhos',
      'Los Cuadrados',
      'Los Feos',
      'Los Furtados',
      'Los Garcia',
      'Los Gomez',
      'Los Malavares',
      'Los Ortices',
      'Los Rodriguez',
      'Los Rosanos',
      'Los Rosas',
      'Los Semper',
      'Los Vazquez',
      'Martinote',
      'Montevideo Chico',
      'Once Cerros',
      'Paso Bonilla',
      'Paso De Ceferino',
      'Paso De Las Carretas',
      'Paso De Las Flores',
      'Paso De Perez',
      'Paso Del Cerro',
      'Paso Livindo',
      'Paso Victor',
      'Paso de los Toros',
      'Picada De Cuello',
      'Pueblo Clavijo',
      'Pueblo De Arriba',
      'Pueblo Del Barro',
      'Punta De Carretera',
      'Puntas De Cinco Sauces',
      'Puntas De Laureles',
      'Rincon De Freitas',
      'Rincon De Giloca',
      'Rincon De La Aldea',
      'Rincon De La Laguna',
      'Rincon De Los Machado',
      'Rincon De Pereira',
      'Rincon De Zamora',
      'Rincon Del Bonete',
      'Rivera Chico',
      'San Gregorio de Polanco',
      'Sauce De Tranqueras',
      'Sauce Solo Del Rio Negro',
      'Tacuarembo Chico',
      'Tacuarembó',
      'Tierras Coloradas',
      'Tres Guitarras',
      'Turupi',
      'Valle Eden',
      'Villa Ansina',
      'Zambullon',
      'Zapara',
      'Zapucay',
    ],
    'UY-TT': [
      'Arrayanes De Cebollati',
      'Arrayanes De Corral De Cebollati',
      'Arrocera Bonomo',
      'Arrocera El Tigre',
      'Arrocera La Catumbera',
      'Arrocera La Querencia',
      'Arrocera Las Palmas',
      'Arrocera Los Ceibos',
      'Arrocera Los Teros',
      'Arrocera Mini',
      'Arrocera Procipa',
      'Arrocera Rincon',
      'Arrocera San Fernando',
      'Arrocera Santa Fe',
      'Arrocera Zapata',
      'Arrozal Treinta Y Tres',
      'Avestruz Chico',
      'Barrio Abreu',
      'Bañado De Oro',
      'Cañada Chica',
      'Cañada De Las Piedras',
      'Cañada Del Sauce',
      'Cerros De Amaro',
      'Cipa Cebollati',
      'Cipa Olimar',
      'Cipa Secador',
      'Corrales De Cebollati',
      'Costas De Tacuari',
      'Costas Del Arroyo Malo',
      'Costas Del Sarandi',
      'Cuchilla De Dionisio',
      'Cuchilla De Olmos',
      'Ejido De Treinta Y Tres',
      'El Bellaco',
      'El Catete',
      'Gral. Enrique Martinez',
      'Higuerones',
      'Julio Maria Sanz',
      'La Calavera',
      'La Lata',
      'Las Chacras',
      'Las Pavas',
      'Lechiguana De Corrales',
      'Maria Albina',
      'Mate Dulce',
      'Mendizabal',
      'Molles De Olimar',
      'Noques De Olimar Chico',
      'Olimar Grande',
      'Palo A Pique',
      'Paso Ancho',
      'Paso De Averias',
      'Paso De La Atahona',
      'Paso De La Laguna',
      'Paso De Piriz',
      'Paso Del Sauce',
      'Poblado Alonzo',
      'Puntas De Leoncho',
      'Puntas De Los Ceibos',
      'Puntas De Quebracho',
      'Puntas Del Oro',
      'Puntas Del Parao',
      'Rincon De Gadea',
      'Rincon De Iguini',
      'Rincon De Los Francos',
      'Rincon De Quintana',
      'Rincon De Urtubey',
      'Santa Clara De Olimar',
      'Sauce De Corrales',
      'Sierra Del Yerbal',
      'Siete Casas',
      'Treinta y Tres',
      'Valentines',
      'Verde Alto',
      'Villa Passano',
      'Villa Sara',
      'Yerbal Chico',
      'Yerbalito',
    ],
  },
  VEN: {
    'VE-Z': [],
    'VE-B': ['Anaco', 'Aragua de Barcelona', 'Lechería', 'Otros Poblados', 'Pto. La Cruz', 'Píritu'],
    'VE-C': [
      'Achaguas (Achaguas)',
      'Biruaca (Biruaca)',
      'Muñoz (Bruzual)',
      'Pedro Camejo (San Juan de Payara)',
      'Páez (Guasdualito)',
      'Rómulo Gallegos (Elorza)',
      'San Fernando (San Fernando de Apure)',
    ],
    'VE-D': [
      'Cagua',
      'Camatagua',
      'Francisco Linares Alcántara',
      'Girardot (Maracay)',
      'José Angel Lamas',
      'José Félix Ribas',
      'José Rafael Revenga',
      'Libertador (Palo Negro)',
      'Mario Briceño Iragorry (El Limón)',
      'Ocumare de La Costa de Oro',
      'San Casimiro',
      'Santiago Mariño',
      'Santos Michelena (Las Tejerías)',
      'Tovar (La Colonia Tovar)',
      'Urdaneta (Barbacoas)',
      'Zamora (Villa de Cura)',
    ],
    'VE-E': [
      'Alberto Arvelo Torrealba (Sabaneta)',
      'Andrés Eloy Blanco (El Canton)',
      'Antonio José de Sucre (Socopo)',
      'Arismendi (Arismendi)',
      'Barinas (Barinas)',
      'Bolívar (Barinitas)',
      'Cruz Paredes (Barrancas)',
      'Ezequiel Zamora (Santa Bárbara)',
      'Obispos (Obispos)',
      'Pedraza (Ciudad Bolivia)',
      'Rojas (Libertad)',
      'Sosa (Ciudad de Nutrias)',
    ],
    'VE-F': ['Pto. Ordaz'],
    'VE-G': [
      'Bejuma (Bejuma)',
      'Carlos Arvelo (Guigue)',
      'Diego Ibarra (Mariara)',
      'Guacara (Guacara)',
      'Juan José Mora (Morón)',
      'Libertador (Tocuyito)',
      'Los Guayos (Los Guayos)',
      'Miranda (Miranda)',
      'Montalbán (Montalbán)',
      'Naguanagua (Naguanagua)',
      'Puerto Cabello (Puerto Cabello)',
      'San Diego (San Diego)',
      'San Joaquín (San Joaquín)',
      'Valencia (Valencia)',
    ],
    'VE-H': [
      'Anzoátegui (Cojedes)',
      'El Pao de San Juan Bautista (El Pao)',
      'Falcón (Tinaquillo)',
      'Girardot (El Baúl)',
      'Lima Blanco (Macapo)',
      'Ricaurte (Libertad)',
      'Rómulo Gallegos (Las Vegas)',
      'San Carlos de Austria (San Carlos)',
      'Tinaco (Tinaco)',
    ],
    'VE-Y': ['Antonio Díaz (Curiapo)', 'Casacoima (Sierra Imataca)', 'Pedernales (Pedernales)', 'Tucupita (Tucupita)'],
    'VE-W': [
      'Archip. Las Aves',
      'Archip. Los Monjes',
      'Archip. Los Roques',
      'Isla de Aves',
      'Isla de Patos',
      'Isla la Blanquilla',
      'Isla la Orchila',
      'Isla la Sola',
      'Isla la Tortuga',
      'Isla los Testigos',
      'Islas los Frailes',
      'Islas los Hermanos',
    ],
    'VE-A': [
      'Mun. Baruta (central)',
      'Mun. Baruta (este)',
      'Mun. Baruta (norte)',
      'Mun. Baruta (sur)',
      'Mun. Baruta (sureste)',
      'Mun. Chacao (norte)',
      'Mun. Chacao (sur)',
      'Mun. El Hatillo (norte)',
      'Mun. El Hatillo (sur)',
      'Mun. Libertador (Centro)',
      'Mun. Libertador (Noreste)',
      'Mun. Libertador (Oeste)',
      'Mun. Libertador (Sur)',
      'Mun. Libertador (Sureste)',
      'Mun. Libertador (Suroeste)',
      'Mun. Sucre (centro)',
      'Mun. Sucre (este)',
      'Mun. Sucre (noreste)',
      'Mun. Sucre (norte)',
      'Mun. Sucre (sur)',
      'Receptoría Grupo Zoom',
      'Receptoría Only Rustic',
      'Receptoría Sambil',
    ],
    'VE-I': [
      'Buchivacoa',
      'Cacique Manaure',
      'Chichiriviche',
      'Dabajuro',
      'Democracia',
      'Falcón',
      'Jacura',
      'Los Taques',
      'Mauroa',
      'Miranda (Coro)',
      'Monseñor Iturriza',
      'Morrocoy',
      'Palmasola',
      'Petit',
      'Punto Fijo',
      'Tocopero',
      'Tucacas',
      'Urumaco',
    ],
    'VE-J': [
      'Altagracia de Orituco',
      'Cabruta',
      'Calabozo',
      'Camaguán',
      'Chaguaramas',
      'El Rastro',
      'El Sombrero',
      'Guardatinajas',
      'Lezama',
      'Libertad de Orituco',
      'Ortíz',
      'Parapara',
      'Paso Real de Macaira',
      'S. J. de Los Morros',
      'S. Rafael de Orituco',
      'Sabana Grande de Orituco',
      'San Francisco de Macaira',
      'San José de Guaribe',
      'San José de Unare',
      'San Rafael de Laya',
      'Santa María de Ipire',
      'Tucupido',
      'Uveral',
      'Valle de la Pascua',
      'Zaraza',
    ],
    'VE-K': [
      'Andrés Eloy Blanco',
      'Barquisimeto',
      'Cabudare',
      'Lomas de Tabure',
      'Morán',
      'Puertas del Sol',
      'Simón Planas',
    ],
    'VE-M': ['Costa Mirandina', 'Guarenas', 'Guatire', 'Los Teques', 'San Diego de los Altos', 'Valles del Tuy'],
    'VE-N': [
      'Aguasay',
      'Aragua de Maturín',
      'Barracas del Orinoco',
      'Caicara de Maturín',
      'Caripe',
      'Caripito',
      'Cedeño',
      'El Corozo',
      'Ezequiel Zamora',
      'Libertador',
      'Maturin',
      'Piar',
      'Punceres',
      'Punta de Mata',
      'Quiriquire',
      'San Antonio de Maturín',
      'Temblador',
      'Uracoa',
    ],
    'VE-L': ['Mun. Libertador (Mérida)', 'Otros Municipios'],
    'VE-O': [
      'Antolín del Campo',
      'Antonio Díaz',
      'Arismendi',
      'Gómez',
      'Islas',
      'Macanao',
      'Maneiro',
      'Marcano',
      'Margarita (este)',
      'Margarita (noreste)',
      'Margarita (noroeste)',
      'Margarita (oeste)',
      'Margarita (sureste)',
      'Margarita (suroeste)',
      'Mariño',
      'Tubores',
    ],
    'VE-P': [
      'Acarigua',
      'Araure',
      'Biscocuy',
      'Boconoíto',
      'Guanare',
      'Guanarito',
      'Ospino',
      'Papelón',
      'Paraiso de Chabasquén',
      'Píritu Portuguesa',
      'San Rafael de Onoto',
      'Villa Bruzual',
      'Vía Barquisimeto-Acarigua',
    ],
    'VE-R': ['Casanay', 'El Pilar', 'San José de Aerocuar', 'Tunapuy', 'Yaguaraparo'],
    'VE-T': [
      'Andrés Bello (Santa Isabel)',
      'Boconó (Boconó)',
      'Bolívar (Sabana Grande)',
      'Candelaria (Chejendé)',
      'Carache (Carache)',
      'Escuque (Escuque)',
      'José Felipe Márquez Cañizales (El Paradero)',
      'José Vicente Campo Elías (Campo Elías)',
      'La Ceiba (Santa Apolonia)',
      'Miranda (El Dividive)',
      'Monte Carmelo (Monte Carmelo)',
      'Motatán (Motatán)',
      'Pampanito (Pampanito)',
      'Pampán (Pampán)',
      'Rafael Rangel (Betijoque)',
      'San Rafael de Carvajal (Carvajal)',
      'Sucre (Sabana de Mendoza)',
      'Trujillo (Trujillo)',
      'Urdaneta (La Quebrada)',
      'Valera (Valera)',
    ],
    'VE-S': ['Táchira'],
    'VE-X': [
      'Caraballeda',
      'Carayaca',
      'Carlos Soublette',
      'Caruao',
      'Catia La Mar',
      'La Guaira',
      'Macuto',
      'Maiquetía',
      'Naiguatá',
      'Parque Nacional El Ávila',
    ],
    'VE-U': [
      'Aroa',
      'Boraure',
      'Chivacoa',
      'Cocorote',
      'Farriar',
      'Guama',
      'Nirgua',
      'Sabana de Parra',
      'Urachiche',
      'Yaritagua',
      'Yumare',
    ],
    'VE-V': [
      'Almirante Padilla',
      'Baralt',
      'Cabimas',
      'Catatumbo',
      'Francisco Javier Pulgar',
      'Jesús Enrique Lossada',
      'Jesús María Semprún',
      'La Cañada de Urdaneta',
      'Machiques de Perijá',
      'Maracaibo',
      'Ojeda',
      'Rosario de Perijá',
      'S. Rafael del Moján',
      'Valmore Rodríguez',
    ],
  },
};

export const StatesByCountryUsingName = {
  ARG: {
    'Buenos Aires': 'AR-B',
    'Capital Federal': 'AR-C',
    'Catamarca': 'AR-K',
    'Chaco': 'AR-H',
    'Chubut': 'AR-U',
    'Corrientes': 'AR-W',
    'Córdoba': 'AR-X',
    'Entre Ríos': 'AR-E',
    'Formosa': 'AR-P',
    'Jujuy': 'AR-Y',
    'La Pampa': 'AR-L',
    'La Rioja': 'AR-F',
    'Mendoza': 'AR-M',
    'Misiones': 'AR-N',
    'Neuquén': 'AR-Q',
    'Río Negro': 'AR-R',
    'Salta': 'AR-A',
    'San Juan': 'AR-J',
    'San Luis': 'AR-D',
    'Santa Cruz': 'AR-Z',
    'Santa Fe': 'AR-S',
    'Santiago del Estero': 'AR-G',
    'Tierra del Fuego': 'AR-V',
    'Tucumán': 'AR-T',
  },
  AUS: {
    'Aust Capit Territory': 'AU-ACT',
    'New South Wales': 'AU-NSW',
    'Northern Territory': 'AU-NT',
    'Queensland': 'AU-QLD',
    'South Australia': 'AU-SA',
    'Tasmania': 'AU-TAS',
    'Victoria': 'AU-VIC',
    'Western Australia': 'AU-WA',
  },
  BOL: {
    'Beni': 'BO-B',
    'Chuquisaca': 'BO-H',
    'Cochabamba': 'BO-C',
    'La Paz': 'BO-L',
    'Oruro': 'BO-O',
    'Pando': 'BO-N',
    'Potosí': 'BO-P',
    'Santa Cruz': 'BO-S',
    'Tarija': 'BO-T',
  },
  BRA: {
    'Acre': 'BR-AC',
    'Alagoas': 'BR-AL',
    'Amapá': 'BR-AP',
    'Amazonas': 'BR-AM',
    'Bahia': 'BR-BA',
    'Ceará': 'BR-CE',
    'Distrito Federal': 'BR-DF',
    'Espírito Santo': 'BR-ES',
    'Goiás': 'BR-GO',
    'Maranhão': 'BR-MA',
    'Mato Grosso': 'BR-MT',
    'Mato Grosso do Sul': 'BR-MS',
    'Minas Gerais': 'BR-MG',
    'Paraná': 'BR-PR',
    'Paraíba': 'BR-PB',
    'Pará': 'BR-PA',
    'Pernambuco': 'BR-PE',
    'Piauí': 'BR-PI',
    'Rio Grande do Norte': 'BR-RN',
    'Rio Grande do Sul': 'BR-RS',
    'Rio de Janeiro': 'BR-RJ',
    'Rondônia': 'BR-RO',
    'Roraima': 'BR-RR',
    'Santa Catarina': 'BR-SC',
    'Sergipe': 'BR-SE',
    'São Paulo': 'BR-SP',
    'Tocantins': 'BR-TO',
  },
  CAN: {
    'Alberta': 'CA-AB',
    'British Columbia': 'CA-BC',
    'Manitoba': 'CA-MB',
    'New Brunswick': 'CA-NB',
    'Newfoundland and Lab': 'CA-NL',
    'Northwest Territorie': 'CA-NT',
    'Nova Scotia': 'CA-NS',
    'Nunavut': 'CA-NU',
    'Ontario': 'CA-ON',
    'Prince Edward Island': 'CA-PE',
    'Quebec': 'CA-QC',
    'Yukon': 'CA-YT',
  },
  CHL: {
    'Aysén': 'CL-AI',
    'Antofagasta': 'CL-AN',
    'Arica y Parinacota': 'CL-AP',
    'Atacama': 'CL-AT',
    'Biobío': 'CL-BI',
    'Coquimbo': 'CL-CO',
    'La Araucanía': 'CL-AR',
    'Libertador B. O\'Higgins': 'CL-LI',
    'Los Lagos': 'CL-LL',
    'Los Ríos': 'CL-LR',
    'Magallanes': 'CL-MA',
    'Maule': 'CL-ML',
    'RM (Metropolitana)': 'CL-RM',
    'Tarapacá': 'CL-TA',
    'Valparaíso': 'CL-VS',
    'Ñuble': 'CL-NB',
  },
  CHN: {
    'Anhui': 'CN-AH',
    'Beijing': 'CN-BJ',
    'Chongqing': 'CN-CQ',
    'Fujian': 'CN-FJ',
    'Gansu': 'CN-GS',
    'Guangdong': 'CN-GD',
    'Guangxi': 'CN-GX',
    'Guizhou': 'CN-GZ',
    'Hainan': 'CN-HI',
    'Hebei': 'CN-HE',
    'Heilongjiang': 'CN-HL',
    'Henan': 'CN-HA',
    'Hubei': 'CN-HB',
    'Hunan': 'CN-HN',
    'Inner Mongolia': 'CN-NM',
    'Jiangsu': 'CN-JS',
    'Jiangxi': 'CN-JX',
    'Jilin': 'CN-JL',
    'Liaoning': 'CN-LN',
    'Ningxia': 'CN-NX',
    'Qinghai': 'CN-QH',
    'Shaanxi': 'CN-SN',
    'Shandong': 'CN-SD',
    'Shanghai': 'CN-SH',
    'Shanxi': 'CN-SX',
    'Sichuan': 'CN-SC',
    'Tianjin': 'CN-TJ',
    'Xinjiang': 'CN-XJ',
    'Xizang': 'CN-XZ',
    'Yunnan': 'CN-YN',
    'Zhejiang': 'CN-ZJ',
  },
  COL: {
    'Amazonas': 'CO-AMA',
    'Antioquia': 'CO-ANT',
    'Arauca': 'CO-ARA',
    'Atlantico': 'CO-ATL',
    'Bogotá D.C.': 'CO-DC',
    'Bolivar': 'CO-BOL',
    'Boyaca': 'CO-BOY',
    'Caldas': 'CO-CAL',
    'Caqueta': 'CO-CAQ',
    'Casanare': 'CO-CAS',
    'Cauca': 'CO-CAU',
    'Cesar': 'CO-CES',
    'Choco': 'CO-CHO',
    'Cordoba': 'CO-COR',
    'Cundinamarca': 'CO-CUN',
    'Guainia': 'CO-GUA',
    'Guaviare': 'CO-GUV',
    'Huila': 'CO-HUI',
    'La Guajira': 'CO-LAG',
    'Magdalena': 'CO-MAG',
    'Meta': 'CO-MET',
    'Nariño': 'CO-NAR',
    'Norte de Santander': 'CO-NSA',
    'Putumayo': 'CO-PUT',
    'Quindio': 'CO-QUI',
    'Risaralda': 'CO-RIS',
    'San Andres y Providencia': 'CO-SAP',
    'Santander': 'CO-SAN',
    'Sucre': 'CO-SUC',
    'Tolima': 'CO-TOL',
    'Valle del Cauca': 'CO-VAC',
    'Vaupes': 'CO-VAU',
    'Vichada': 'CO-VID',
  },
  DEU: {
    'Baden-Württemberg': 'DE-BW',
    'Bayern': 'DE-BY',
    'Berlin': 'DE-BE',
    'Brandenburg': 'DE-BB',
    'Bremen': 'DE-HB',
    'Hamburg': 'DE-HH',
    'Hessen': 'DE-HE',
    'Mecklenburg-Vorpommern': 'DE-MV',
    'Niedersachsen': 'DE-NI',
    'Nordrhein-Westfalen': 'DE-NW',
    'Rheinland-Pfalz': 'DE-RP',
    'Saarland': 'DE-SL',
    'Sachsen': 'DE-SN',
    'Sachsen-Anhalt': 'DE-ST',
    'Schleswig-Holstein': 'DE-SH',
    'Thüringen': 'DE-TH',
  },
  ECU: {
    'Azuay': 'EC-A',
    'Bolívar': 'EC-B',
    'Cañar': 'EC-F',
    'Carchi': 'EC-C',
    'Chimborazo': 'EC-H',
    'Cotopaxi': 'EC-X',
    'El Oro': 'EC-O',
    'Esmeraldas': 'EC-E',
    'Galápagos': 'EC-W',
    'Guayas': 'EC-G',
    'Imbabura': 'EC-I',
    'Loja': 'EC-L',
    'Los Ríos': 'EC-R',
    'Manabí': 'EC-M',
    'Morona Santiago': 'EC-S',
    'Napo': 'EC-N',
    'Orellana': 'EC-D',
    'Pastaza': 'EC-Y',
    'Pichincha': 'EC-P',
    'Santa Elena': 'EC-SE',
    'Santo Domingo de los Tsáchilas': 'EC-SD',
    'Sucumbíos': 'EC-U',
    'Tungurahua': 'EC-T',
    'Zamora Chinchipe': 'EC-Z',
  },
  ESP: {
    'Albacete': 'ES-AB',
    'Alicante': 'ES-A',
    'Almería': 'ES-AL',
    'Asturias': 'ES-O',
    'Álava': 'ES-VI',
    'Badajoz': 'ES-BA',
    'Barcelona': 'ES-B',
    'Burgos': 'ES-BU',
    'Cantabria': 'ES-S',
    'Castellón': 'ES-CS',
    'Ciudad Real': 'ES-CR',
    'Cuenca': 'ES-CU',
    'Cáceres': 'ES-CC',
    'Cádiz': 'ES-CA',
    'Córdoba': 'ES-CO',
    'Gerona': 'ES-GI',
    'Granada': 'ES-GR',
    'Guadalajara': 'ES-GU',
    'Guipúzcoa': 'ES-SS',
    'Huelva': 'ES-H',
    'Huesca': 'ES-HU',
    'Islas Baleares': 'ES-PM',
    'Jaén': 'ES-J',
    'La Coruña': 'ES-C',
    'La Rioja': 'ES-LO',
    'Las Palmas': 'ES-GC',
    'León': 'ES-LE',
    'Lugo': 'ES-LU',
    'Lérida': 'ES-L',
    'Madrid': 'ES-M',
    'Murcia': 'ES-MU',
    'Málaga': 'ES-MA',
    'Navarra': 'ES-NA',
    'Orense': 'ES-OR',
    'Palencia': 'ES-P',
    'Pontevedra': 'ES-PO',
    'Salamanca': 'ES-SA',
    'Santa Cruz de Tenerife': 'ES-TF',
    'Segovia': 'ES-SG',
    'Sevilla': 'ES-SE',
    'Soria': 'ES-SO',
    'Tarragona': 'ES-T',
    'Teruel': 'ES-TE',
    'Toledo': 'ES-TO',
    'Valencia': 'ES-V',
    'Valladolid': 'ES-VA',
    'Vizcaya': 'ES-BI',
    'Zamora': 'ES-ZA',
    'Zaragoza': 'ES-Z',
  },
  FRA: {
    'Ain': 'FR-01',
    'Aisne': 'FR-02',
    'Allier': 'FR-03',
    'Alpes-de-Haute-Provence': 'FR-04',
    'Alpes-Maritimes': 'FR-06',
    'Ardennes': 'FR-08',
    'Ardèche': 'FR-07',
    'Ariège': 'FR-09',
    'Aube': 'FR-10',
    'Aude': 'FR-11',
    'Aveyron': 'FR-12',
    'Bas-Rhin': 'FR-67',
    'Bouches-du-Rhône': 'FR-13',
    'Calvados': 'FR-14',
    'Cantal': 'FR-15',
    'Charente': 'FR-16',
    'Charente-Maritime': 'FR-17',
    'Cher': 'FR-18',
    'Corrèze': 'FR-19',
    'Corse-du-Sud': 'FR-2A',
    'Côte-d\'Or': 'FR-21',
    'Côtes-d\'Armor': 'FR-22',
    'Creuse': 'FR-23',
    'Deux-Sèvres': 'FR-79',
    'Dordogne': 'FR-24',
    'Doubs': 'FR-25',
    'Drôme': 'FR-26',
    'Essonne': 'FR-91',
    'Eure': 'FR-27',
    'Eure-et-Loir': 'FR-28',
    'Finistère': 'FR-29',
    'Gard': 'FR-30',
    'Gers': 'FR-32',
    'Gironde': 'FR-33',
    'Guadeloupe': 'FR-GP',
    'Guyane': 'FR-GF',
    'Haute-Corse': 'FR-2B',
    'Haute-Garonne': 'FR-31',
    'Haute-Loire': 'FR-43',
    'Haute-Marne': 'FR-52',
    'Haute-Saône': 'FR-70',
    'Haute-Savoie': 'FR-74',
    'Haute-Vienne': 'FR-87',
    'Hautes-Alpes': 'FR-05',
    'Hautes-Pyrénées': 'FR-65',
    'Haut-Rhin': 'FR-68',
    'Hauts-de-Seine': 'FR-92',
    'Hérault': 'FR-34',
    'Ille-et-Vilaine': 'FR-35',
    'Indre': 'FR-36',
    'Indre-et-Loire': 'FR-37',
    'Isère': 'FR-38',
    'Jura': 'FR-39',
    'La Réunion': 'FR-RE',
    'Landes': 'FR-40',
    'Loir-et-Cher': 'FR-41',
    'Loire': 'FR-42',
    'Loire-Atlantique': 'FR-44',
    'Loiret': 'FR-45',
    'Lot': 'FR-46',
    'Lot-et-Garonne': 'FR-47',
    'Lozère': 'FR-48',
    'Maine-et-Loire': 'FR-49',
    'Manche': 'FR-50',
    'Marne': 'FR-51',
    'Martinique': 'FR-MQ',
    'Mayenne': 'FR-53',
    'Mayotte': 'FR-YT',
    'Meurthe-et-Moselle': 'FR-54',
    'Meuse': 'FR-55',
    'Morbihan': 'FR-56',
    'Moselle': 'FR-57',
    'Nièvre': 'FR-58',
    'Nord': 'FR-59',
    'Nouvelle-Calédonie': 'FR-NC',
    'Oise': 'FR-60',
    'Orne': 'FR-61',
    'Paris': 'FR-75',
    'Pas-de-Calais': 'FR-62',
    'Polynésie française': 'FR-PF',
    'Puy-de-Dôme': 'FR-63',
    'Pyrénées-Atlantiques': 'FR-64',
    'Pyrénées-Orientales': 'FR-66',
    'Rhône': 'FR-69',
    'Saint-Barthélemy': 'FR-BL',
    'Saint-Martin': 'FR-MF',
    'Saint-Pierre-et-Miquelon': 'FR-PM',
    'Saône-et-Loire': 'FR-71',
    'Sarthe': 'FR-72',
    'Savoie': 'FR-73',
    'Seine-et-Marne': 'FR-77',
    'Seine-Maritime': 'FR-76',
    'Seine-Saint-Denis': 'FR-93',
    'Somme': 'FR-80',
    'Suisse': 'FR-CH',
    'Tarn': 'FR-81',
    'Tarn-et-Garonne': 'FR-82',
    'Territoire de Belfort': 'FR-90',
    'Val-d\'Oise': 'FR-95',
    'Val-de-Marne': 'FR-94',
    'Var': 'FR-83',
    'Vaucluse': 'FR-84',
    'Vendée': 'FR-85',
    'Vienne': 'FR-86',
    'Vosges': 'FR-88',
    'Wallis-et-Futuna': 'FR-WF',
    'Yonne': 'FR-89',
    'Yvelines': 'FR-78',
  },
  GBR: {
    'Aberdeen City': 'GB-ABE',
    'Aberdeenshire': 'GB-ABD',
    'Angus': 'GB-ANS',
    'Antrim and Newtownabbey': 'GB-ANN',
    'Ards and North Down': 'GB-AND',
    'Argyll and Bute': 'GB-AGB',
    'Armagh City, Banbridge and Craigavon': 'GB-ABC',
    'Barking and Dagenham': 'GB-BDG',
    'Barnet': 'GB-BNE',
    'Barnsley': 'GB-BNS',
    'Bath and North East Somerset': 'GB-BAS',
    'Bedford': 'GB-BDF',
    'Belfast': 'GB-BFS',
    'Bexley': 'GB-BEX',
    'Birmingham': 'GB-BIR',
    'Blackburn with Darwen': 'GB-BBD',
    'Blackpool': 'GB-BPL',
    'Blaenau Gwent': 'GB-BGW',
    'Bolton': 'GB-BOL',
    'Bournemouth': 'GB-BOU',
    'Bracknell Forest': 'GB-BRC',
    'Bradford': 'GB-BRD',
    'Brent': 'GB-BEN',
    'Bridgend': 'GB-BGE',
    'Brighton and Hove': 'GB-BNH',
    'Bristol, City of': 'GB-BST',
    'Bromley': 'GB-BRY',
    'Buckinghamshire': 'GB-BKM',
    'Bury': 'GB-BUR',
    'Caerphilly': 'GB-CAY',
    'Calderdale': 'GB-CLD',
    'Cambridgeshire': 'GB-CAM',
    'Camden': 'GB-CMD',
    'Cardiff': 'GB-CRF',
    'Carmarthenshire': 'GB-CMN',
    'Causeway Coast and Glens': 'GB-CCG',
    'Central Bedfordshire': 'GB-CBF',
    'Ceredigion': 'GB-CGN',
    'Cheshire East': 'GB-CHS',
    'Cheshire West and Chester': 'GB-CHW',
    'City of Edinburgh': 'GB-EDH',
    'City of London': 'GB-LND',
    'Clackmannanshire': 'GB-CLK',
    'Conwy': 'GB-CWY',
    'Cornwall': 'GB-CON',
    'County Durham': 'GB-DUR',
    'Coventry': 'GB-COV',
    'Croydon': 'GB-CRY',
    'Cumbria': 'GB-CMA',
    'Darlington': 'GB-DAL',
    'Denbighshire': 'GB-DEN',
    'Derby': 'GB-DER',
    'Derbyshire': 'GB-DBY',
    'Derry City and Strabane': 'GB-DRS',
    'Devon': 'GB-DEV',
    'Doncaster': 'GB-DNC',
    'Dorset': 'GB-DOR',
    'Dudley': 'GB-DUD',
    'Dumfries and Galloway': 'GB-DGY',
    'Dundee City': 'GB-DND',
    'Ealing': 'GB-EAL',
    'East Ayrshire': 'GB-EAY',
    'East Dunbartonshire': 'GB-EDU',
    'East Lothian': 'GB-ELN',
    'East Renfrewshire': 'GB-ERW',
    'East Riding of Yorkshire': 'GB-ERY',
    'East Sussex': 'GB-ESX',
    'Enfield': 'GB-ENF',
    'Essex': 'GB-ESS',
    'Falkirk': 'GB-FAL',
    'Fermanagh and Omagh': 'GB-FMO',
    'Fife': 'GB-FIF',
    'Flintshire': 'GB-FLN',
    'Gateshead': 'GB-GAT',
    'Glasgow City': 'GB-GLG',
    'Gloucestershire': 'GB-GLS',
    'Greenwich': 'GB-GRE',
    'Gwynedd': 'GB-GWN',
    'Hackney': 'GB-HCK',
    'Halton': 'GB-HAL',
    'Hammersmith and Fulham': 'GB-HMF',
    'Hampshire': 'GB-HAM',
    'Haringey': 'GB-HRY',
    'Harrow': 'GB-HRW',
    'Hartlepool': 'GB-HPL',
    'Havering': 'GB-HAV',
    'Herefordshire, County of': 'GB-HEF',
    'Hertfordshire': 'GB-HRT',
    'Highland': 'GB-HLD',
    'Hillingdon': 'GB-HIL',
    'Hounslow': 'GB-HNS',
    'Inverclyde': 'GB-IVC',
    'Isle of Anglesey': 'GB-AGY',
    'Isle of Wight': 'GB-IOW',
    'Isles of Scilly': 'GB-IOS',
    'Islington': 'GB-ISL',
    'Kensington and Chelsea': 'GB-KEC',
    'Kent': 'GB-KEN',
    'Kingston upon Hull, City of': 'GB-KHL',
    'Kingston upon Thames': 'GB-KTT',
    'Kirklees': 'GB-KIR',
    'Knowsley': 'GB-KWL',
    'Lambeth': 'GB-LBH',
    'Lancashire': 'GB-LAN',
    'Leeds': 'GB-LDS',
    'Leicester': 'GB-LCE',
    'Leicestershire': 'GB-LEC',
    'Lewisham': 'GB-LEW',
    'Lincolnshire': 'GB-LIN',
    'Liverpool': 'GB-LIV',
    'Luton': 'GB-LUT',
    'Manchester': 'GB-MAN',
    'Medway': 'GB-MDW',
    'Merthyr Tydfil': 'GB-MTY',
    'Merton': 'GB-MRT',
    'Middlesbrough': 'GB-MDB',
    'Midlothian': 'GB-MLN',
    'Milton Keynes': 'GB-MIK',
    'Monmouthshire': 'GB-MON',
    'Moray': 'GB-MRY',
    'Neath Port Talbot': 'GB-NTL',
    'Newcastle upon Tyne': 'GB-NET',
    'Newham': 'GB-NWM',
    'Newport': 'GB-NWP',
    'Newry, Mourne and Down': 'GB-NMD',
    'Norfolk': 'GB-NFK',
    'North Ayrshire': 'GB-NAY',
    'North East Lincolnshire': 'GB-NEL',
    'North Lanarkshire': 'GB-NLK',
    'North Lincolnshire': 'GB-NLN',
    'North Somerset': 'GB-NSM',
    'North Tyneside': 'GB-NTY',
    'North Yorkshire': 'GB-NYK',
    'Northamptonshire': 'GB-NTH',
    'Northumberland': 'GB-NBL',
    'Nottingham': 'GB-NGM',
    'Nottinghamshire': 'GB-NTT',
    'Oldham': 'GB-OLD',
    'Orkney Islands': 'GB-ORK',
    'Oxfordshire': 'GB-OXF',
    'Pembrokeshire': 'GB-PEM',
    'Perth and Kinross': 'GB-PKN',
    'Peterborough': 'GB-PTE',
    'Plymouth': 'GB-PLY',
    'Poole': 'GB-POL',
    'Portsmouth': 'GB-POR',
    'Powys': 'GB-POW',
    'Reading': 'GB-RDG',
    'Redbridge': 'GB-RDB',
    'Redcar and Cleveland': 'GB-RCC',
    'Renfrewshire': 'GB-RFW',
    'Rhondda Cynon Taf': 'GB-RCT',
    'Richmond upon Thames': 'GB-RIC',
    'Rochdale': 'GB-RCH',
    'Rotherham': 'GB-ROT',
    'Rutland': 'GB-RUT',
    'Saint Helena, Ascension and Tristan da Cunha': 'GB-SHL',
    'Salford': 'GB-SLF',
    'Sandwell': 'GB-SAW',
    'Scottish Borders, The': 'GB-SCB',
    'Sefton': 'GB-SFT',
    'Sheffield': 'GB-SHF',
    'Shetland Islands': 'GB-ZET',
    'Shropshire': 'GB-SHR',
    'Slough': 'GB-SLG',
    'Solihull': 'GB-SOL',
    'Somerset': 'GB-SOM',
    'South Ayrshire': 'GB-AYR',
    'South Gloucestershire': 'GB-SGC',
    'South Lanarkshire': 'GB-SLK',
    'South Tyneside': 'GB-STY',
    'Southampton': 'GB-STH',
    'Southend-on-Sea': 'GB-SOS',
    'Southwark': 'GB-SWK',
    'St. Helens': 'GB-SHN',
    'Staffordshire': 'GB-STS',
    'Stirling': 'GB-STG',
    'Stockport': 'GB-SKP',
    'Stockton-on-Tees': 'GB-STT',
    'Stoke-on-Trent': 'GB-STE',
    'Strabane': 'GB-STB',
    'Suffolk': 'GB-SFK',
    'Sunderland': 'GB-SND',
    'Surrey': 'GB-SRY',
    'Sutton': 'GB-STN',
    'Swansea': 'GB-SWA',
    'Swindon': 'GB-SWD',
    'Tameside': 'GB-TAM',
    'Telford and Wrekin': 'GB-TFW',
    'Thurrock': 'GB-THR',
    'Torbay': 'GB-TOB',
    'Torfaen': 'GB-TOF',
    'Tower Hamlets': 'GB-TWH',
    'Trafford': 'GB-TRF',
    'Vale of Glamorgan, The': 'GB-VGL',
    'Wakefield': 'GB-WKF',
    'Walsall': 'GB-WLL',
    'Waltham Forest': 'GB-WFT',
    'Wandsworth': 'GB-WND',
    'Warrington': 'GB-WRT',
    'Warwickshire': 'GB-WAR',
    'West Berkshire': 'GB-WBK',
    'West Dunbartonshire': 'GB-WDU',
    'West Lothian': 'GB-WLN',
    'West Sussex': 'GB-WSX',
    'Westminster': 'GB-WSM',
    'Wigan': 'GB-WGN',
    'Wiltshire': 'GB-WIL',
    'Windsor and Maidenhead': 'GB-WNM',
    'Wirral': 'GB-WRL',
    'Wokingham': 'GB-WOK',
    'Wolverhampton': 'GB-WLV',
    'Worcestershire': 'GB-WOR',
    'Wrexham': 'GB-WRX',
    'York': 'GB-YOR',
    'Yorkshire': 'GB-YKS',
    'Åland': 'AX',
  },
  GIN: {
    'Boké': 'GN-B',
    'Conakry': 'GN-C',
    'Faranah': 'GN-D',
    'Kankan': 'GN-K',
    'Kindia': 'GN-KD',
    'Labé': 'GN-L',
    'Mamou': 'GN-M',
    'Nzérékoré': 'GN-N',
  },
  GNB: {
    'Bissau': 'GW-BS',
    'Bolama': 'GW-BM',
    'Biombo': 'GW-BL',
    'Cacheu': 'GW-CA',
    'Gabú': 'GW-GA',
    'Oio': 'GW-OI',
    'Quinara': 'GW-QU',
    'Tombali': 'GW-TO',
  },
  GRC: {
    'Attica': 'GR-I',
    'Central Greece': 'GR-H',
    'Central Macedonia': 'GR-B',
    'Crete': 'GR-M',
    'Eastern Macedonia and Thrace': 'GR-A',
    'Epirus': 'GR-D',
    'Ionian Islands': 'GR-F',
    'North Aegean': 'GR-K',
    'Peloponnese': 'GR-J',
    'South Aegean': 'GR-L',
    'Thessaly': 'GR-E',
    'Western Greece': 'GR-G',
    'Western Macedonia': 'GR-C',
  },
  GTM: {
    'Alta Verapaz': 'GT-AV',
    'Baja Verapaz': 'GT-BV',
    'Chimaltenango': 'GT-CM',
    'Chiquimula': 'GT-CQ',
    'El Progreso': 'GT-PR',
    'Escuintla': 'GT-ES',
    'Guatemala': 'GT-GU',
    'Huehuetenango': 'GT-HU',
    'Izabal': 'GT-IZ',
    'Jalapa': 'GT-JA',
    'Jutiapa': 'GT-JU',
    'Petén': 'GT-PE',
    'Quetzaltenango': 'GT-QZ',
    'Quiché': 'GT-QC',
    'Retalhuleu': 'GT-RE',
    'Sacatepéquez': 'GT-SA',
    'San Marcos': 'GT-SM',
    'Santa Rosa': 'GT-SR',
    'Sololá': 'GT-SO',
    'Suchitepéquez': 'GT-SU',
    'Totonicapán': 'GT-TO',
    'Zacapa': 'GT-ZA',
  },
  HND: {
    'Atlántida': 'HN-AT',
    'Choluteca': 'HN-CH',
    'Colón': 'HN-CL',
    'Comayagua': 'HN-CM',
    'Copán': 'HN-CP',
    'Cortés': 'HN-CR',
    'El Paraíso': 'HN-EP',
    'Francisco Morazán': 'HN-FM',
    'Gracias a Dios': 'HN-GD',
    'Intibucá': 'HN-IN',
    'Islas de la Bahía': 'HN-IB',
    'La Paz': 'HN-LP',
    'Lempira': 'HN-LE',
    'Ocotepeque': 'HN-OC',
    'Olancho': 'HN-OL',
    'Santa Bárbara': 'HN-SB',
    'Valle': 'HN-VA',
    'Yoro': 'HN-YO',
  },
  HTI: {
    'Artibonite': 'HT-AR',
    'Centre': 'HT-CE',
    'Grand\'Anse': 'HT-GA',
    'Nippes': 'HT-NI',
    'Nord': 'HT-ND',
    'Nord-Est': 'HT-NE',
    'Nord-Ouest': 'HT-NO',
    'Ouest': 'HT-OU',
    'Sud': 'HT-SD',
    'Sud-Est': 'HT-SE',
  },
  IDN: {
    'Aceh': 'ID-AC',
    'Bali': 'ID-BA',
    'Bangka Belitung Islands': 'ID-BB',
    'Banten': 'ID-BT',
    'Bengkulu': 'ID-BE',
    'Central Java': 'ID-JT',
    'Central Kalimantan': 'ID-KT',
    'Central Sulawesi': 'ID-ST',
    'East Java': 'ID-JI',
    'East Kalimantan': 'ID-KI',
    'East Nusa Tenggara': 'ID-NT',
    'Gorontalo': 'ID-GO',
    'Jakarta': 'ID-JK',
    'Jambi': 'ID-JA',
    'Lampung': 'ID-LA',
    'Maluku': 'ID-MA',
    'North Kalimantan': 'ID-KU',
    'North Maluku': 'ID-MU',
    'North Sulawesi': 'ID-SA',
    'North Sumatra': 'ID-SU',
    'Papua': 'ID-PA',
    'Riau': 'ID-RI',
    'Riau Islands': 'ID-KR',
    'Southeast Sulawesi': 'ID-SG',
    'South Kalimantan': 'ID-KS',
    'South Sulawesi': 'ID-SN',
    'South Sumatra': 'ID-SS',
    'West Java': 'ID-JB',
    'West Kalimantan': 'ID-KB',
    'West Nusa Tenggara': 'ID-NB',
    'West Papua': 'ID-PB',
    'West Sulawesi': 'ID-SR',
    'West Sumatra': 'ID-SB',
    'Yogyakarta': 'ID-YO',
  },
  IMN: {
    'Isle of Man': 'IM',
  },
  IND: {
    'Andaman and Nicobar Islands': 'IN-AN',
    'Andhra Pradesh': 'IN-AP',
    'Arunachal Pradesh': 'IN-AR',
    'Assam': 'IN-AS',
    'Bihar': 'IN-BR',
    'Chandigarh': 'IN-CH',
    'Chhattisgarh': 'IN-CT',
    'Dadra and Nagar Haveli and Daman and Diu': 'IN-DN',
    'Delhi': 'IN-DL',
    'Goa': 'IN-GA',
    'Gujarat': 'IN-GJ',
    'Haryana': 'IN-HR',
    'Himachal Pradesh': 'IN-HP',
    'Jammu and Kashmir': 'IN-JK',
    'Jharkhand': 'IN-JH',
    'Karnataka': 'IN-KA',
    'Kerala': 'IN-KL',
    'Ladakh': 'IN-LA',
    'Lakshadweep': 'IN-LD',
    'Madhya Pradesh': 'IN-MP',
    'Maharashtra': 'IN-MH',
    'Manipur': 'IN-MN',
    'Meghalaya': 'IN-ML',
    'Mizoram': 'IN-MZ',
    'Nagaland': 'IN-NL',
    'Odisha': 'IN-OR',
    'Puducherry': 'IN-PY',
    'Punjab': 'IN-PB',
    'Rajasthan': 'IN-RJ',
    'Sikkim': 'IN-SK',
    'Tamil Nadu': 'IN-TN',
    'Telangana': 'IN-TG',
    'Tripura': 'IN-TR',
    'Uttar Pradesh': 'IN-UP',
    'Uttarakhand': 'IN-UT',
    'West Bengal': 'IN-WB',
  },
  IRL: {
    'Carlow': 'IE-CW',
    'Cavan': 'IE-CN',
    'Clare': 'IE-CE',
    'Cork': 'IE-CO',
    'Donegal': 'IE-DL',
    'Dublin': 'IE-D',
    'Galway': 'IE-G',
    'Kerry': 'IE-KY',
    'Kildare': 'IE-KE',
    'Kilkenny': 'IE-KK',
    'Laois': 'IE-LS',
    'Leitrim': 'IE-LM',
    'Limerick': 'IE-LK',
    'Longford': 'IE-LD',
    'Louth': 'IE-LH',
    'Mayo': 'IE-MO',
    'Meath': 'IE-MH',
    'Monaghan': 'IE-MN',
    'Offaly': 'IE-OY',
    'Roscommon': 'IE-RN',
    'Sligo': 'IE-SO',
    'Tipperary': 'IE-TA',
    'Waterford': 'IE-WD',
    'Westmeath': 'IE-WH',
    'Wexford': 'IE-WX',
    'Wicklow': 'IE-WW',
  },
  IRN: {
    'Alborz': 'IR-32',
    'Ardabil': 'IR-03',
    'Bushehr': 'IR-06',
    'Chaharmahal and Bakhtiari': 'IR-08',
    'East Azerbaijan': 'IR-01',
    'Fars': 'IR-14',
    'Gilan': 'IR-19',
    'Golestan': 'IR-27',
    'Hamadan': 'IR-24',
    'Hormozgan': 'IR-23',
    'Ilam': 'IR-05',
    'Isfahan': 'IR-04',
    'Kerman': 'IR-15',
    'Kermanshah': 'IR-17',
    'Khuzestan': 'IR-10',
    'Kohgiluyeh and Boyer-Ahmad': 'IR-18',
    'Kurdistan': 'IR-16',
    'Lorestan': 'IR-20',
    'Markazi': 'IR-22',
    'Mazandaran': 'IR-21',
    'North Khorasan': 'IR-31',
    'Qazvin': 'IR-28',
    'Qom': 'IR-26',
    'Razavi Khorasan': 'IR-30',
    'Semnan': 'IR-12',
    'Sistan and Baluchestan': 'IR-13',
    'South Khorasan': 'IR-29',
    'Tehran': 'IR-07',
    'West Azerbaijan': 'IR-02',
    'Yazd': 'IR-25',
    'Zanjan': 'IR-11',
  },
  IRQ: {
    'Al-Anbar': 'IQ-AN',
    'Al-Muthanna': 'IQ-MU',
    'Al-Qadisiyyah': 'IQ-QA',
    'An-Najaf': 'IQ-NA',
    'Arbil': 'IQ-AR',
    'As-Sulaymaniyah': 'IQ-SU',
    'Babil': 'IQ-BB',
    'Baghdad': 'IQ-BG',
    'Basra': 'IQ-BA',
    'Dhi Qar': 'IQ-DQ',
    'Diyala': 'IQ-DI',
    'Dohuk': 'IQ-DA',
    'Erbil': 'IQ-AR',
    'Karbala': 'IQ-KA',
    'Kirkuk': 'IQ-KI',
    'Maysan': 'IQ-MA',
    'Najaf': 'IQ-NA',
    'Nineveh': 'IQ-NI',
    'Saladin': 'IQ-SD',
    'Sulaymaniyah': 'IQ-SU',
    'Wasit': 'IQ-WA',
  },
  ISL: {
    'Capital Region': 'IS-1',
    'Northeastern Region': 'IS-6',
    'Northwestern Region': 'IS-5',
    'Southern Peninsula Region': 'IS-8',
    'Southern Region': 'IS-2',
    'Western Region': 'IS-3',
    'Westfjords': 'IS-4',
  },
  ITA: {
    'Abruzzo': 'IT-65',
    'Aosta Valley': 'IT-23',
    'Apulia': 'IT-75',
    'Basilicata': 'IT-77',
    'Calabria': 'IT-78',
    'Campania': 'IT-72',
    'Emilia-Romagna': 'IT-45',
    'Friuli Venezia Giulia': 'IT-36',
    'Lazio': 'IT-62',
    'Liguria': 'IT-42',
    'Lombardy': 'IT-25',
    'Marche': 'IT-57',
    'Molise': 'IT-67',
    'Piedmont': 'IT-21',
    'Sardinia': 'IT-88',
    'Sicily': 'IT-82',
    'Trentino-Alto Adige/Südtirol': 'IT-32',
    'Tuscany': 'IT-52',
    'Umbria': 'IT-55',
    'Veneto': 'IT-34',
  },
  JEY: {
    'Jersey': 'JE',
  },
  JOR: {
    'Ajloun': 'JO-AJ',
    'Amman': 'JO-AM',
    'Aqaba': 'JO-AQ',
    'Balqa': 'JO-BA',
    'Irbid': 'JO-IR',
    'Jerash': 'JO-JA',
    'Karak': 'JO-KA',
    'Ma\'an': 'JO-MN',
    'Madaba': 'JO-MD',
    'Mafraq': 'JO-MA',
    'Tafilah': 'JO-TA',
    'Zarqa': 'JO-AZ',
  },
  JPN: {
    'Aichi': 'JP-23',
    'Akita': 'JP-05',
    'Aomori': 'JP-02',
    'Chiba': 'JP-12',
    'Ehime': 'JP-38',
    'Fukui': 'JP-18',
    'Fukuoka': 'JP-40',
    'Fukushima': 'JP-07',
    'Gifu': 'JP-21',
    'Gunma': 'JP-10',
    'Hiroshima': 'JP-34',
    'Hokkaido': 'JP-01',
    'Hyogo': 'JP-28',
    'Ibaraki': 'JP-08',
    'Ishikawa': 'JP-17',
    'Iwate': 'JP-03',
    'Kagawa': 'JP-37',
    'Kagoshima': 'JP-46',
    'Kanagawa': 'JP-14',
    'Kochi': 'JP-39',
    'Kumamoto': 'JP-43',
    'Kyoto': 'JP-26',
    'Mie': 'JP-24',
    'Miyagi': 'JP-04',
    'Miyazaki': 'JP-45',
    'Nagano': 'JP-20',
    'Nagasaki': 'JP-42',
    'Nara': 'JP-29',
    'Niigata': 'JP-15',
    'Oita': 'JP-44',
    'Okayama': 'JP-33',
    'Okinawa': 'JP-47',
    'Osaka': 'JP-27',
    'Saga': 'JP-41',
    'Saitama': 'JP-11',
    'Shiga': 'JP-25',
    'Shimane': 'JP-32',
    'Shizuoka': 'JP-22',
    'Tochigi': 'JP-09',
    'Tokushima': 'JP-36',
    'Tokyo': 'JP-13',
    'Tottori': 'JP-31',
    'Toyama': 'JP-16',
    'Wakayama': 'JP-30',
    'Yamagata': 'JP-06',
    'Yamaguchi': 'JP-35',
    'Yamanashi': 'JP-19',
  },
  KAZ: {
    'Almaty': 'KZ-ALM',
    'Akmola': 'KZ-AKM',
    'Aktobe': 'KZ-AKT',
    'Almaty Region': 'KZ-ALA',
    'Atyrau': 'KZ-ATY',
    'East Kazakhstan': 'KZ-VOS',
    'Jambyl': 'KZ-ZHA',
    'Karaganda': 'KZ-KAR',
    'Kostanay': 'KZ-KUS',
    'Kyzylorda': 'KZ-KZY',
    'Mangystau': 'KZ-MAN',
    'North Kazakhstan': 'KZ-SEV',
    'Nur-Sultan': 'KZ-NUR',
    'Pavlodar': 'KZ-PAV',
    'Turkistan': 'KZ-YUZ',
    'West Kazakhstan': 'KZ-ZAP',
  },
  KEN: {
    'Baringo': 'KE-01',
    'Bomet': 'KE-02',
    'Bungoma': 'KE-03',
    'Busia': 'KE-04',
    'Central': 'KE-17',
    'Coast': 'KE-05',
    'Eastern': 'KE-06',
    'Elgeyo-Marakwet': 'KE-07',
    'Embu': 'KE-08',
    'Garissa': 'KE-09',
    'Homa Bay': 'KE-10',
    'Isiolo': 'KE-11',
    'Kajiado': 'KE-12',
    'Kakamega': 'KE-13',
    'Kericho': 'KE-14',
    'Kiambu': 'KE-15',
    'Kilifi': 'KE-16',
    'Kirinyaga': 'KE-18',
    'Kisii': 'KE-19',
    'Kisumu': 'KE-20',
    'Kitui': 'KE-21',
    'Kwale': 'KE-22',
    'Laikipia': 'KE-24',
    'Lamu': 'KE-25',
    'Machakos': 'KE-23',
    'Makueni': 'KE-26',
    'Mandera': 'KE-27',
    'Marsabit': 'KE-28',
    'Meru': 'KE-29',
    'Migori': 'KE-30',
    'Mombasa': 'KE-31',
    'Murang\'a': 'KE-32',
    'Nairobi': 'KE-33',
    'Nakuru': 'KE-34',
    'Nandi': 'KE-35',
    'Narok': 'KE-36',
    'Nyamira': 'KE-37',
    'Nyandarua': 'KE-38',
    'Nyeri': 'KE-39',
    'Samburu': 'KE-40',
    'Siaya': 'KE-41',
    'Taita-Taveta': 'KE-42',
    'Tana River': 'KE-44',
    'Tharaka-Nithi': 'KE-45',
    'Trans Nzoia': 'KE-46',
    'Turkana': 'KE-47',
    'Uasin Gishu': 'KE-48',
    'Vihiga': 'KE-49',
    'Wajir': 'KE-50',
    'West Pokot': 'KE-51',
  },
  KGZ: {
    'Batken': 'KG-B',
    'Bishkek': 'KG-GB',
    'Chuy': 'KG-C',
    'Issyk-Kul': 'KG-Y',
    'Jalal-Abad': 'KG-J',
    'Naryn': 'KG-N',
    'Osh': 'KG-O',
    'Talas': 'KG-T',
  },
  KHM: {
    'Banteay Meanchey': 'KH-1',
    'Battambang': 'KH-2',
    'Kampong Cham': 'KH-3',
    'Kampong Chhnang': 'KH-4',
    'Kampong Speu': 'KH-5',
    'Kampong Thom': 'KH-6',
    'Kampot': 'KH-7',
    'Kandal': 'KH-8',
    'Kep': 'KH-23',
    'Koh Kong': 'KH-9',
    'Kratié': 'KH-10',
    'Mondulkiri': 'KH-11',
    'Oddar Meanchey': 'KH-22',
    'Pailin': 'KH-24',
    'Phnom Penh': 'KH-12',
    'Preah Sihanouk': 'KH-18',
    'Preah Vihear': 'KH-13',
    'Prey Veng': 'KH-14',
    'Pursat': 'KH-15',
    'Ratanakiri': 'KH-16',
    'Siem Reap': 'KH-17',
    'Stung Treng': 'KH-19',
    'Svay Rieng': 'KH-20',
    'Takéo': 'KH-21',
    'Tbong Khmum': 'KH-25',
  },
  KIR: {
    'Gilbert Islands': 'KI-G',
    'Line Islands': 'KI-L',
    'Phoenix Islands': 'KI-P',
  },
  KNA: {
    'Christ Church Nichola Town': 'KN-01',
    'Saint Anne Sandy Point': 'KN-02',
    'Saint George Basseterre': 'KN-03',
    'Saint George Gingerland': 'KN-04',
    'Saint James Windward': 'KN-05',
    'Saint John Capisterre': 'KN-06',
    'Saint John Figtree': 'KN-07',
    'Saint Mary Cayon': 'KN-08',
    'Saint Paul Capisterre': 'KN-09',
    'Saint Paul Charlestown': 'KN-10',
    'Saint Peter Basseterre': 'KN-11',
    'Saint Thomas Lowland': 'KN-12',
    'Saint Thomas Middle Island': 'KN-13',
    'Trinity Palmetto Point': 'KN-15',
  },
  KOR: {
    'Busan': 'KR-26',
    'Daegu': 'KR-27',
    'Daejeon': 'KR-30',
    'Gangwon': 'KR-42',
    'Gwangju': 'KR-29',
    'Gyeonggi': 'KR-41',
    'Incheon': 'KR-28',
    'Jeju': 'KR-49',
    'North Chungcheong': 'KR-43',
    'North Gyeongsang': 'KR-47',
    'North Jeolla': 'KR-45',
    'Sejong': 'KR-50',
    'Seoul': 'KR-11',
    'South Chungcheong': 'KR-44',
    'South Gyeongsang': 'KR-48',
    'South Jeolla': 'KR-46',
    'Ulsan': 'KR-31',
  },
  KWT: {
    'Al Ahmadi': 'KW-AH',
    'Al Asimah': 'KW-KU',
    'Al Farwaniyah': 'KW-FA',
    'Al Jahra': 'KW-JA',
    'Hawalli': 'KW-HA',
    'Mubarak Al-Kabeer': 'KW-MU',
  },
  LAO: {
    'Attapeu': 'LA-AT',
    'Bokeo': 'LA-BK',
    'Bolikhamsai': 'LA-BL',
    'Champasak': 'LA-CH',
    'Houaphanh': 'LA-HO',
    'Khammouane': 'LA-KH',
    'Luang Namtha': 'LA-LM',
    'Luang Prabang': 'LA-LP',
    'Oudomxay': 'LA-OU',
    'Phongsaly': 'LA-PH',
    'Sainyabuli': 'LA-XA',
    'Salavan': 'LA-SL',
    'Savannakhet': 'LA-SV',
    'Vientiane': 'LA-VI',
    'Vientiane Province': 'LA-VT',
    'Xaisomboun': 'LA-XN',
    'Xaisômboun': 'LA-XS',
    'Xiangkhoang': 'LA-XI',
  },
  LBN: {
    'Aakkar': 'LB-AK',
    'Baalbek-Hermel': 'LB-BH',
    'Beirut': 'LB-BA',
    'Beqaa': 'LB-BI',
    'Mount Lebanon': 'LB-JL',
    'Nabatieh': 'LB-NA',
    'North Lebanon': 'LB-AS',
    'South Lebanon': 'LB-JA',
  },
  LBR: {
    'Bomi': 'LR-BM',
    'Bong': 'LR-BG',
    'Gbarpolu': 'LR-GP',
    'Grand Bassa': 'LR-GB',
    'Grand Cape Mount': 'LR-CM',
    'Grand Gedeh': 'LR-GG',
    'Grand Kru': 'LR-GK',
    'Lofa': 'LR-LO',
    'Margibi': 'LR-MG',
    'Maryland': 'LR-MY',
    'Montserrado': 'LR-MO',
    'Nimba': 'LR-NI',
    'River Cess': 'LR-RI',
    'River Gee': 'LR-RG',
    'Sinoe': 'LR-SI',
  },
  LBY: {
    'Al Wahat': 'LY-WA',
    'Benghazi': 'LY-BA',
    'Darnah': 'LY-DR',
    'Ghat': 'LY-GT',
    'Jabal al Akhdar': 'LY-JA',
    'Jabal al Gharbi': 'LY-JG',
    'Jafara': 'LY-JI',
    'Jufra': 'LY-JU',
    'Kufra': 'LY-KF',
    'Marj': 'LY-MJ',
    'Misratah': 'LY-MI',
    'Murzuq': 'LY-MQ',
    'Nalut': 'LY-NL',
    'Sabha': 'LY-SB',
    'Sirte': 'LY-SR',
    'Tripoli': 'LY-TB',
    'Wadi al Hayaa': 'LY-WD',
    'Wadi al Shatii': 'LY-WS',
    'Zawiya': 'LY-ZA',
  },
  LCA: {
    'Anse-la-Raye': 'LC-01',
    'Castries': 'LC-02',
    'Choiseul': 'LC-03',
    'Dauphin': 'LC-04',
    'Dennery': 'LC-05',
    'Gros Islet': 'LC-06',
    'Laborie': 'LC-07',
    'Micoud': 'LC-08',
    'Soufrière': 'LC-09',
    'Vieux Fort': 'LC-10',
  },
  LIE: {
    'Balzers': 'LI-01',
    'Eschen': 'LI-02',
    'Gamprin': 'LI-03',
    'Mauren': 'LI-04',
    'Planken': 'LI-05',
    'Ruggell': 'LI-06',
    'Schaan': 'LI-07',
    'Schellenberg': 'LI-08',
    'Triesen': 'LI-09',
    'Triesenberg': 'LI-10',
    'Vaduz': 'LI-11',
  },
  LKA: {
    'Central Province': 'LK-2',
    'Eastern Province': 'LK-5',
    'North Central Province': 'LK-7',
    'Northern Province': 'LK-4',
    'North Western Province': 'LK-6',
    'Sabaragamuwa Province': 'LK-9',
    'Southern Province': 'LK-3',
    'Uva Province': 'LK-8',
    'Western Province': 'LK-1',
  },
  LSO: {
    'Berea': 'LS-D',
    'Butha-Buthe': 'LS-B',
    'Leribe': 'LS-C',
    'Mafeteng': 'LS-E',
    'Maseru': 'LS-A',
    'Mohale\'s Hoek': 'LS-F',
    'Mokhotlong': 'LS-J',
    'Qacha\'s Nek': 'LS-H',
    'Quthing': 'LS-G',
    'Thaba-Tseka': 'LS-K',
  },
  LTU: {
    'Alytus County': 'LT-AL',
    'Kaunas County': 'LT-KU',
    'Klaipėda County': 'LT-KL',
    'Marijampolė County': 'LT-MR',
    'Panevėžys County': 'LT-PA',
    'Šiauliai County': 'LT-SA',
    'Tauragė County': 'LT-TA',
    'Telšiai County': 'LT-TE',
    'Utena County': 'LT-UT',
    'Vilnius County': 'LT-VL',
  },
  LUX: {
    'Capellen': 'LU-CA',
    'Canton of Capellen': 'LU-CA',
    'Canton of Clervaux': 'LU-CL',
    'Canton of Diekirch': 'LU-DI',
    'Canton of Echternach': 'LU-EC',
    'Canton of Esch-sur-Alzette': 'LU-ES',
    'Canton of Grevenmacher': 'LU-GR',
    'Canton of Luxembourg': 'LU-LU',
    'Canton of Mersch': 'LU-ME',
    'Canton of Redange': 'LU-RD',
    'Canton of Remich': 'LU-RM',
    'Canton of Vianden': 'LU-VD',
    'Canton of Wiltz': 'LU-WI',
    'Clervaux': 'LU-CL',
    'Diekirch': 'LU-DI',
    'Echternach': 'LU-EC',
    'Esch-sur-Alzette': 'LU-ES',
    'Grevenmacher': 'LU-GR',
    'Luxembourg': 'LU-LU',
    'Mersch': 'LU-ME',
    'Redange': 'LU-RD',
    'Remich': 'LU-RM',
    'Vianden': 'LU-VD',
    'Wiltz': 'LU-WI',
  },
  LVA: {
    'Aglona Municipality': 'LV-001',
    'Aizkraukle Municipality': 'LV-002',
    'Aizpute Municipality': 'LV-003',
    'Aknīste Municipality': 'LV-004',
    'Aloja Municipality': 'LV-005',
    'Alsunga Municipality': 'LV-006',
    'Amata Municipality': 'LV-007',
    'Ape Municipality': 'LV-008',
    'Auce Municipality': 'LV-009',
    'Babīte Municipality': 'LV-010',
    'Baldone Municipality': 'LV-011',
    'Baltinava Municipality': 'LV-012',
    'Balvi Municipality': 'LV-013',
    'Bauska Municipality': 'LV-014',
    'Beverīna Municipality': 'LV-015',
    'Brocēni Municipality': 'LV-016',
    'Burtnieki Municipality': 'LV-017',
    'Carnikava Municipality': 'LV-018',
    'Cēsis Municipality': 'LV-019',
    'Cesvaine Municipality': 'LV-020',
    'Cibla Municipality': 'LV-021',
    'Dagda Municipality': 'LV-022',
    'Daugavpils': 'LV-DGV',
    'Daugavpils Municipality': 'LV-023',
    'Dobele Municipality': 'LV-024',
    'Dundaga Municipality': 'LV-025',
    'Durbe Municipality': 'LV-026',
    'Engure Municipality': 'LV-027',
    'Ērgļi Municipality': 'LV-028',
    'Garkalne Municipality': 'LV-029',
    'Grobiņa Municipality': 'LV-030',
    'Gulbene Municipality': 'LV-031',
    'Iecava Municipality': 'LV-032',
    'Ikšķile Municipality': 'LV-033',
    'Ilūkste Municipality': 'LV-034',
    'Inčukalns Municipality': 'LV-035',
    'Jaunjelgava Municipality': 'LV-036',
    'Jaunpiebalga Municipality': 'LV-037',
    'Jaunpils Municipality': 'LV-038',
    'Jelgava': 'LV-JEL',
    'Jelgava Municipality': 'LV-039',
    'Jēkabpils': 'LV-JKB',
    'Jēkabpils Municipality': 'LV-040',
    'Kandava Municipality': 'LV-041',
    'Kārsava Municipality': 'LV-042',
    'Ķegums Municipality': 'LV-043',
    'Ķekava Municipality': 'LV-044',
    'Kocēni Municipality': 'LV-045',
    'Koknese Municipality': 'LV-046',
    'Krāslava Municipality': 'LV-047',
    'Krimulda Municipality': 'LV-048',
    'Krustpils Municipality': 'LV-049',
    'Kuldīga Municipality': 'LV-050',
    'Lielvārde Municipality': 'LV-051',
    'Liepāja': 'LV-LPX',
    'Līgatne Municipality': 'LV-052',
    'Limbaži Municipality': 'LV-053',
    'Līvāni Municipality': 'LV-054',
    'Lubāna Municipality': 'LV-055',
    'Ludza Municipality': 'LV-056',
    'Madona Municipality': 'LV-057',
    'Mālpils Municipality': 'LV-058',
    'Mārupe Municipality': 'LV-059',
    'Mazsalaca Municipality': 'LV-060',
    'Mērsrags Municipality': 'LV-061',
    'Naukšēni Municipality': 'LV-062',
    'Nereta Municipality': 'LV-063',
    'Nīca Municipality': 'LV-064',
    'Ogre Municipality': 'LV-065',
    'Olaine Municipality': 'LV-066',
    'Ozolnieki Municipality': 'LV-067',
    'Pārgauja Municipality': 'LV-068',
    'Pāvilosta Municipality': 'LV-069',
    'Pļaviņas Municipality': 'LV-070',
    'Preiļi Municipality': 'LV-071',
    'Priekule Municipality': 'LV-072',
    'Priekuļi Municipality': 'LV-073',
    'Rauna Municipality': 'LV-074',
    'Rēzekne': 'LV-REZ',
    'Rēzekne Municipality': 'LV-075',
    'Riebiņi Municipality': 'LV-076',
    'Riga': 'LV-RIX',
    'Roja Municipality': 'LV-077',
    'Ropaži Municipality': 'LV-078',
    'Rucava Municipality': 'LV-079',
    'Rugāji Municipality': 'LV-080',
    'Rūjiena Municipality': 'LV-081',
    'Rundāle Municipality': 'LV-082',
    'Sala Municipality': 'LV-083',
    'Salacgrīva Municipality': 'LV-084',
    'Salaspils Municipality': 'LV-085',
    'Saldus Municipality': 'LV-086',
    'Saulkrasti Municipality': 'LV-087',
    'Sēja Municipality': 'LV-088',
    'Sigulda Municipality': 'LV-089',
    'Skrīveri Municipality': 'LV-090',
    'Skrunda Municipality': 'LV-091',
    'Smiltene Municipality': 'LV-092',
    'Stopiņi Municipality': 'LV-093',
    'Strenči Municipality': 'LV-094',
    'Talsi Municipality': 'LV-095',
    'Tērvete Municipality': 'LV-096',
    'Vaiņode Municipality': 'LV-097',
    'Valka Municipality': 'LV-098',
    'Valmiera': 'LV-VMR',
    'Varakļāni Municipality': 'LV-099',
    'Vārkava Municipality': 'LV-100',
    'Vecpiebalga Municipality': 'LV-101',
    'Vecumnieki Municipality': 'LV-102',
    'Ventspils': 'LV-VEN',
    'Ventspils Municipality': 'LV-103',
    'Viesīte Municipality': 'LV-104',
    'Viļaka Municipality': 'LV-105',
    'Viļāni Municipality': 'LV-106',
    'Zilupe Municipality': 'LV-107',
    'Carnikava': 'LV-018',
  },
  MAC: {
    'Nossa Senhora de Fátima': 'MO-N',
    'Santo António': 'MO-S',
    'São Lázaro': 'MO-L',
    'Sé': 'MO-C',
    'Taipa': 'MO-T',
  },
  MDA: {
    'Anenii Noi': 'MD-AN',
    'Bălți Municipality': 'MD-BA',
    'Bender Municipality': 'MD-BD',
    'Briceni': 'MD-BR',
    'Cahul': 'MD-CA',
    'Călărași': 'MD-CL',
    'Căușeni': 'MD-CS',
    'Chișinău Municipality': 'MD-CU',
    'Cimișlia': 'MD-CM',
    'Criuleni': 'MD-CR',
    'Dondușeni': 'MD-DO',
    'Drochia': 'MD-DR',
    'Dubăsari': 'MD-DU',
    'Edineț': 'MD-ED',
    'Fălești': 'MD-FA',
    'Florești': 'MD-FL',
    'Glodeni': 'MD-GL',
    'Hîncești': 'MD-HI',
    'Ialoveni': 'MD-IA',
    'Leova': 'MD-LE',
    'Nisporeni': 'MD-NI',
    'Ocnița': 'MD-OC',
    'Orhei': 'MD-OR',
    'Rezina': 'MD-RE',
    'Rîșcani': 'MD-RI',
    'Sîngerei': 'MD-SI',
    'Șoldănești': 'MD-SD',
    'Soroca': 'MD-SO',
    'Stînga Nistrului': 'MD-SN',
    'Strășeni': 'MD-ST',
    'Ștefan Vodă': 'MD-SV',
    'Taraclia': 'MD-TA',
    'Telenești': 'MD-TE',
    'Ungheni': 'MD-UN',
  },
  MDG: {
    'Antananarivo': 'MG-T',
    'Antsiranana': 'MG-D',
    'Fianarantsoa': 'MG-F',
    'Mahajanga': 'MG-M',
    'Toamasina': 'MG-A',
    'Toliara': 'MG-U',
  },
  MDV: {
    'Alifu Alifu': 'MV-02',
    'Alifu Dhaalu': 'MV-00',
    'Baa': 'MV-20',
    'Dhaalu': 'MV-17',
    'Faafu': 'MV-14',
    'Gaafu Alifu': 'MV-27',
    'Gaafu Dhaalu': 'MV-28',
    'Gnaviyani': 'MV-29',
    'Haa Alifu': 'MV-07',
    'Haa Dhaalu': 'MV-23',
    'Kaafu': 'MV-26',
    'Laamu': 'MV-05',
    'Lhaviyani': 'MV-03',
    'Malé': 'MV-MLE',
    'Meemu': 'MV-12',
    'Noonu': 'MV-25',
    'Raa': 'MV-13',
    'Seenu': 'MV-01',
    'Shaviyani': 'MV-24',
    'Thaa': 'MV-08',
    'Vaavu': 'MV-04',
  },
  MEX: {
    'Aguascalientes': 'MX-AGU',
    'Baja California': 'MX-BCN',
    'Baja California Sur': 'MX-BCS',
    'Campeche': 'MX-CAM',
    'Chiapas': 'MX-CHP',
    'Chihuahua': 'MX-CHH',
    'Coahuila': 'MX-COA',
    'Colima': 'MX-COL',
    'Durango': 'MX-DUR',
    'Guanajuato': 'MX-GUA',
    'Guerrero': 'MX-GRO',
    'Hidalgo': 'MX-HID',
    'Jalisco': 'MX-JAL',
    'Mexico City': 'MX-CMX',
    'Mexico State': 'MX-MEX',
    'Michoacán': 'MX-MIC',
    'Morelos': 'MX-MOR',
    'Nayarit': 'MX-NAY',
    'Nuevo León': 'MX-NLE',
    'Oaxaca': 'MX-OAX',
    'Puebla': 'MX-PUE',
    'Querétaro': 'MX-QUE',
    'Quintana Roo': 'MX-ROO',
    'San Luis Potosí': 'MX-SLP',
    'Sinaloa': 'MX-SIN',
    'Sonora': 'MX-SON',
    'Tabasco': 'MX-TAB',
    'Tamaulipas': 'MX-TAM',
    'Tlaxcala': 'MX-TLA',
    'Veracruz': 'MX-VER',
    'Yucatán': 'MX-YUC',
    'Zacatecas': 'MX-ZAC',
  },
  MHL: {
    'Ailinglaplap Atoll': 'MH-ALL',
    'Ailuk Atoll': 'MH-ALK',
    'Arno Atoll': 'MH-ARN',
    'Aur Atoll': 'MH-AUR',
    'Bikar Atoll': 'MH-BIK',
    'Bikini Atoll': 'MH-BIK',
    'Bokak Atoll': 'MH-BOK',
    'Ebon Atoll': 'MH-EBO',
    'Enewetak Atoll': 'MH-ENI',
    'Erikub Atoll': 'MH-ERI',
    'Jabat Island': 'MH-JAB',
    'Jaluit Atoll': 'MH-JAL',
    'Kili Island': 'MH-KIL',
    'Kwajalein Atoll': 'MH-KWA',
    'Lae Atoll': 'MH-LAE',
    'Lib Island': 'MH-LIB',
    'Likiep Atoll': 'MH-LIK',
    'Majuro Atoll': 'MH-MAJ',
    'Maloelap Atoll': 'MH-MAL',
    'Mejit Island': 'MH-MEJ',
    'Mili Atoll': 'MH-MIL',
    'Namorik Atoll': 'MH-NMK',
    'Namu Atoll': 'MH-NMU',
    'Rongelap Atoll': 'MH-RON',
    'Ujae Atoll': 'MH-UJA',
    'Ujelang Atoll': 'MH-UJL',
    'Utrik Atoll': 'MH-UTI',
    'Wotho Atoll': 'MH-WTH',
    'Wotje Atoll': 'MH-WTJ',
  },
  MKD: {
    'Aerodrom Municipality': 'MK-01',
    'Aračinovo Municipality': 'MK-02',
    'Berovo Municipality': 'MK-03',
    'Bitola': 'MK-04',
    'Bogdanci Municipality': 'MK-05',
    'Bogovinje Municipality': 'MK-06',
    'Bosilovo Municipality': 'MK-07',
    'Brvenica Municipality': 'MK-08',
    'Butel Municipality': 'MK-09',
    'Čair Municipality': 'MK-79',
    'Čaška Municipality': 'MK-10',
    'Centar Municipality': 'MK-80',
    'Centar Župa Municipality': 'MK-11',
    'Češinovo-Obleševo Municipality': 'MK-12',
    'Čučer-Sandevo Municipality': 'MK-13',
    'Debar': 'MK-14',
    'Debarca Municipality': 'MK-15',
    'Delčevo Municipality': 'MK-16',
    'Demir Hisar Municipality': 'MK-17',
    'Demir Kapija Municipality': 'MK-18',
    'Dojran Municipality': 'MK-19',
    'Dolneni Municipality': 'MK-20',
    'Drugovo Municipality': 'MK-21',
    'Gazi Baba Municipality': 'MK-22',
    'Gevgelija Municipality': 'MK-23',
    'Gjorče Petrov Municipality': 'MK-85',
    'Gostivar': 'MK-25',
    'Gradsko Municipality': 'MK-26',
    'Greater Skopje': 'MK-85',
    'Ilinden Municipality': 'MK-27',
    'Jegunovce Municipality': 'MK-28',
    'Karbinci': 'MK-29',
    'Karpoš Municipality': 'MK-84',
    'Kavadarci Municipality': 'MK-30',
    'Kičevo': 'MK-32',
    'Kisela Voda Municipality': 'MK-83',
    'Kočani Municipality': 'MK-33',
    'Konče Municipality': 'MK-34',
    'Kratovo Municipality': 'MK-35',
    'Kriva Palanka Municipality': 'MK-36',
    'Krivogaštani Municipality': 'MK-37',
    'Kruševo Municipality': 'MK-38',
    'Kumanovo': 'MK-39',
    'Lipkovo Municipality': 'MK-40',
    'Lozovo Municipality': 'MK-41',
    'Makedonska Kamenica Municipality': 'MK-42',
    'Makedonski Brod Municipality': 'MK-43',
    'Mavrovo and Rostuša Municipality': 'MK-44',
    'Mogila Municipality': 'MK-45',
    'Negotino Municipality': 'MK-46',
    'Novaci Municipality': 'MK-47',
    'Novo Selo Municipality': 'MK-48',
    'Ohrid': 'MK-49',
    'Oslomej Municipality': 'MK-50',
    'Pehčevo Municipality': 'MK-51',
    'Petrovec Municipality': 'MK-87',
    'Plasnica Municipality': 'MK-52',
    'Prilep': 'MK-53',
    'Probištip Municipality': 'MK-54',
    'Radoviš Municipality': 'MK-55',
    'Rankovce Municipality': 'MK-56',
    'Resen Municipality': 'MK-57',
    'Rosoman Municipality': 'MK-58',
    'Saraj Municipality': 'MK-59',
    'Sopište Municipality': 'MK-60',
    'Staro Nagoričane Municipality': 'MK-61',
    'Štip': 'MK-62',
    'Struga': 'MK-63',
    'Strumica': 'MK-64',
    'Studeničani Municipality': 'MK-88',
    'Sveti Nikole Municipality': 'MK-65',
    'Šuto Orizari Municipality': 'MK-86',
    'Tearce Municipality': 'MK-66',
    'Tetovo': 'MK-67',
    'Valandovo Municipality': 'MK-68',
    'Vasilevo Municipality': 'MK-69',
    'Veles': 'MK-70',
    'Vevčani Municipality': 'MK-71',
    'Vinica Municipality': 'MK-72',
    'Vraneštica Municipality': 'MK-73',
    'Vrapčište Municipality': 'MK-74',
    'Zajas Municipality': 'MK-75',
    'Zelenikovo Municipality': 'MK-76',
    'Želino Municipality': 'MK-10',
    'Zrnovci Municipality': 'MK-78',
  },
  MLI: {
    'Bamako': 'ML-BKO',
    'Gao': 'ML-7',
    'Kayes': 'ML-1',
    'Kidal': 'ML-8',
    'Koulikoro': 'ML-2',
    'Mopti': 'ML-5',
    'Ségou': 'ML-4',
    'Sikasso': 'ML-3',
    'Tombouctou': 'ML-6',
  },
  MLT: {
    'Attard': 'MT-01',
    'Balzan': 'MT-02',
    'Birgu': 'MT-03',
    'Birkirkara': 'MT-04',
    'Birżebbuġa': 'MT-05',
    'Cospicua': 'MT-06',
    'Dingli': 'MT-07',
    'Fgura': 'MT-08',
    'Floriana': 'MT-09',
    'Fontana': 'MT-10',
    'Għajnsielem': 'MT-13',
    'Għarb': 'MT-14',
    'Għargħur': 'MT-15',
    'Għasri': 'MT-16',
    'Għaxaq': 'MT-17',
    'Gżira': 'MT-11',
    'Gudja': 'MT-12',
    'Ħamrun': 'MT-18',
    'Iklin': 'MT-19',
    'Isla': 'MT-20',
    'Kalkara': 'MT-21',
    'Kerċem': 'MT-22',
    'Kirkop': 'MT-23',
    'Lija': 'MT-24',
    'Luqa': 'MT-25',
    'Marsa': 'MT-26',
    'Marsaskala': 'MT-27',
    'Marsaxlokk': 'MT-28',
    'Mdina': 'MT-29',
    'Mellieħa': 'MT-30',
    'Mġarr': 'MT-31',
    'Mosta': 'MT-32',
    'Mqabba': 'MT-33',
    'Msida': 'MT-34',
    'Mtarfa': 'MT-35',
    'Munxar': 'MT-36',
    'Nadur': 'MT-37',
    'Naxxar': 'MT-38',
    'Paola': 'MT-39',
    'Pembroke': 'MT-40',
    'Pietà': 'MT-41',
    'Qala': 'MT-42',
    'Qormi': 'MT-43',
    'Qrendi': 'MT-44',
    'Rabat': 'MT-46',
    'Safi': 'MT-50',
    'Saint Julian\'s': 'MT-48',
    'Saint John': 'MT-49',
    'Saint Lawrence': 'MT-47',
    'Saint Paul\'s Bay': 'MT-51',
    'Sannat': 'MT-52',
    'Santa Luċija': 'MT-53',
    'Santa Venera': 'MT-54',
    'Senglea': 'MT-55',
    'Siġġiewi': 'MT-56',
    'Sliema': 'MT-57',
    'Swieqi': 'MT-58',
    'Ta\' Xbiex': 'MT-59',
    'Tarxien': 'MT-60',
    'Valletta': 'MT-61',
    'Victoria': 'MT-62',
    'Xagħra': 'MT-63',
    'Xewkija': 'MT-64',
    'Xgħajra': 'MT-65',
    'Żabbar': 'MT-66',
    'Żebbuġ': 'MT-67',
    'Żejtun': 'MT-68',
    'Żurrieq': 'MT-69',
  },
  MMR: {
    'Ayeyarwady': 'MM-AY',
    'Bago': 'MM-BG',
    'Chin': 'MM-14',
    'Kachin': 'MM-KC',
    'Kayah': 'MM-KH',
    'Kayin': 'MM-KN',
    'Magway': 'MM-MG',
    'Mandalay': 'MM-MD',
    'Mon': 'MM-MO',
    'Naypyidaw Union Territory': 'MM-18',
    'Rakhine': 'MM-RA',
    'Sagaing': 'MM-SA',
    'Shan': 'MM-SH',
    'Tanintharyi': 'MM-TN',
    'Yangon': 'MM-YA',
  },
  MNG: {
    'Arhangay': 'MN-073',
    'Bayan-Ölgiy': 'MN-071',
    'Bayanhongor': 'MN-069',
    'Bulgan': 'MN-067',
    'Darkhan-Uul': 'MN-037',
    'Dornod': 'MN-061',
    'Dornogovi': 'MN-063',
    'Dundgovi': 'MN-059',
    'Govi-Altay': 'MN-065',
    'Govisümber': 'MN-064',
    'Khentii': 'MN-039',
    'Khovd': 'MN-043',
    'Khövsgöl': 'MN-041',
    'Ömnögovĭ': 'MN-053',
    'Orhon': 'MN-035',
    'Selenge': 'MN-049',
    'Sühbaatar': 'MN-051',
    'Töv': 'MN-047',
    'Uvs': 'MN-046',
    'Zavhan': 'MN-057',
  },
  MOZ: {
    'Cabo Delgado': 'MZ-P',
    'Gaza': 'MZ-G',
    'Inhambane': 'MZ-I',
    'Manica': 'MZ-B',
    'Maputo': 'MZ-L',
    'Nampula': 'MZ-N',
    'Niassa': 'MZ-A',
    'Sofala': 'MZ-S',
    'Tete': 'MZ-T',
    'Zambezia': 'MZ-Q',
  },
  MRT: {
    'Adrar': 'MR-07',
    'Assaba': 'MR-03',
    'Brakna': 'MR-05',
    'Dakhlet Nouadhibou': 'MR-08',
    'Gorgol': 'MR-04',
    'Guidimaka': 'MR-10',
    'Hodh Ech Chargui': 'MR-01',
    'Hodh El Gharbi': 'MR-02',
    'Inchiri': 'MR-12',
    'Nouakchott': 'MR-NKC',
    'Tagant': 'MR-09',
    'Tiris Zemmour': 'MR-11',
    'Trarza': 'MR-06',
  },
  MSR: {
    'Saint Anthony': 'MS-01',
    'Saint Georges': 'MS-06',
    'Saint Peter': 'MS-08',
  },
  MTQ: {
    'Fort-de-France': 'MQ-02',
    'Le Marin': 'MQ-03',
    'Saint-Pierre': 'MQ-04',
  },
  MUS: {
    'Black River': 'MU-BL',
    'Flacq': 'MU-FL',
    'Grand Port': 'MU-GP',
    'Moka': 'MU-MO',
    'Pamplemousses': 'MU-PA',
    'Plaines Wilhems': 'MU-PW',
    'Port Louis': 'MU-PL',
    'Rivière du Rempart': 'MU-RR',
    'Rodrigues': 'MU-RO',
    'Savanne': 'MU-SA',
  },
  MWI: {
    'Balaka': 'MW-BA',
    'Blantyre': 'MW-BL',
    'Chikwawa': 'MW-CK',
    'Chiradzulu': 'MW-CR',
    'Chitipa': 'MW-CT',
    'Dedza': 'MW-DE',
    'Dowa': 'MW-DO',
    'Karonga': 'MW-KR',
    'Kasungu': 'MW-KS',
    'Likoma': 'MW-LI',
    'Lilongwe': 'MW-LL',
    'Machinga': 'MW-MC',
    'Mangochi': 'MW-MG',
    'Mchinji': 'MW-MH',
    'Mulanje': 'MW-MU',
    'Mwanza': 'MW-MW',
    'Mzimba': 'MW-MZ',
    'Neno': 'MW-NE',
    'Nkhata Bay': 'MW-NB',
    'Nkhotakota': 'MW-NK',
    'Nsanje': 'MW-NS',
    'Ntcheu': 'MW-NU',
    'Ntchisi': 'MW-NI',
    'Phalombe': 'MW-PH',
    'Rumphi': 'MW-RU',
    'Salima': 'MW-SA',
    'Thyolo': 'MW-TH',
    'Zomba': 'MW-ZO',
  },
  MYS: {
    'Johor': 'MY-01',
    'Kedah': 'MY-02',
    'Kelantan': 'MY-03',
    'Kuala Lumpur': 'MY-14',
    'Labuan': 'MY-15',
    'Melaka': 'MY-04',
    'Negeri Sembilan': 'MY-05',
    'Pahang': 'MY-06',
    'Penang': 'MY-07',
    'Perak': 'MY-08',
    'Perlis': 'MY-09',
    'Putrajaya': 'MY-16',
    'Sabah': 'MY-12',
    'Sarawak': 'MY-13',
    'Selangor': 'MY-10',
    'Terengganu': 'MY-11',
  },
  NAM: {
    'Erongo': 'NA-ER',
    'Hardap': 'NA-HA',
    'Karas': 'NA-KA',
    'Kavango East': 'NA-KE',
    'Kavango West': 'NA-KW',
    'Khomas': 'NA-KH',
    'Kunene': 'NA-KU',
    'Ohangwena': 'NA-OW',
    'Omaheke': 'NA-OH',
    'Omusati': 'NA-OS',
    'Oshana': 'NA-ON',
    'Oshikoto': 'NA-OT',
    'Otjozondjupa': 'NA-OD',
    'Zambezi': 'NA-CA',
  },
  NCL: {
    'Loyalty Islands': 'NC-L',
    'North Province': 'NC-N',
    'South Province': 'NC-S',
  },
  NER: {
    'Agadez': 'NE-1',
    'Diffa': 'NE-2',
    'Dosso': 'NE-3',
    'Maradi': 'NE-4',
    'Tahoua': 'NE-5',
    'Tillabéri': 'NE-6',
    'Zinder': 'NE-7',
  },
  NFK: {
    'Kingston': 'NF-01',
  },
  NGA: {
    'Abia': 'NG-AB',
    'Abuja Federal Capital Territory': 'NG-FC',
    'Adamawa': 'NG-AD',
    'Akwa Ibom': 'NG-AK',
    'Anambra': 'NG-AN',
    'Bauchi': 'NG-BA',
    'Bayelsa': 'NG-BY',
    'Benue': 'NG-BE',
    'Borno': 'NG-BO',
    'Cross River': 'NG-CR',
    'Delta': 'NG-DE',
    'Ebonyi': 'NG-EB',
    'Edo': 'NG-ED',
    'Ekiti': 'NG-EK',
    'Enugu': 'NG-EN',
    'Gombe': 'NG-GO',
    'Imo': 'NG-IM',
    'Jigawa': 'NG-JI',
    'Kaduna': 'NG-KD',
    'Kano': 'NG-KN',
    'Katsina': 'NG-KT',
    'Kebbi': 'NG-KE',
    'Kogi': 'NG-KO',
    'Kwara': 'NG-KW',
    'Lagos': 'NG-LA',
    'Nasarawa': 'NG-NA',
    'Niger': 'NG-NI',
    'Ogun': 'NG-OG',
    'Ondo': 'NG-ON',
    'Osun': 'NG-OS',
    'Oyo': 'NG-OY',
    'Plateau': 'NG-PL',
    'Rivers': 'NG-RI',
    'Sokoto': 'NG-SO',
    'Taraba': 'NG-TA',
    'Yobe': 'NG-YO',
    'Zamfara': 'NG-ZA',
  },
  NIC: {
    'Atlántico Norte': 'NI-AN',
    'Atlántico Sur': 'NI-AS',
    'Boaco': 'NI-BO',
    'Carazo': 'NI-CA',
    'Chinandega': 'NI-CI',
    'Chontales': 'NI-CO',
    'Estelí': 'NI-ES',
    'Granada': 'NI-GR',
    'Jinotega': 'NI-JI',
    'León': 'NI-LE',
    'Madriz': 'NI-MD',
    'Managua': 'NI-MN',
    'Masaya': 'NI-MS',
    'Matagalpa': 'NI-MT',
    'Nueva Segovia': 'NI-NS',
    'Río San Juan': 'NI-SJ',
    'Rivas': 'NI-RI',
  },
  NIU: {
    'Alofi North': 'NU-AL',
    'Alofi South': 'NU-AS',
  },
  NLD: {
    'Drenthe': 'NL-DR',
    'Flevoland': 'NL-FL',
    'Friesland': 'NL-FR',
    'Gelderland': 'NL-GE',
    'Groningen': 'NL-GR',
    'Limburg': 'NL-LI',
    'North Brabant': 'NL-NB',
    'North Holland': 'NL-NH',
    'Overijssel': 'NL-OV',
    'South Holland': 'NL-ZH',
    'Utrecht': 'NL-UT',
    'Zeeland': 'NL-ZE',
  },
  NOR: {
    'Agder': 'NO-42',
    'Innlandet': 'NO-34',
    'Møre og Romsdal': 'NO-15',
    'Nordland': 'NO-18',
    'Oslo': 'NO-03',
    'Rogaland': 'NO-11',
    'Svalbard': 'NO-21',
    'Troms og Finnmark': 'NO-54',
    'Trøndelag': 'NO-50',
    'Vestfold og Telemark': 'NO-38',
    'Vestland': 'NO-46',
    'Viken': 'NO-30',
  },
  NPL: {
    'Bagmati': 'NP-BA',
    'Bheri': 'NP-BH',
    'Dhawalagiri': 'NP-DH',
    'Gandaki': 'NP-GA',
    'Janakpur': 'NP-JA',
    'Karnali': 'NP-KA',
    'Kosi': 'NP-KO',
    'Lumbini': 'NP-LU',
    'Mahakali': 'NP-MA',
    'Mechi': 'NP-ME',
    'Narayani': 'NP-NA',
    'Rapti': 'NP-RA',
    'Sagarmatha': 'NP-SA',
    'Seti': 'NP-SE',
  },
  NRU: {
    'Aiwo': 'NR-01',
    'Anabar': 'NR-02',
    'Anetan': 'NR-03',
    'Anibare': 'NR-04',
    'Baiti': 'NR-05',
    'Boe': 'NR-06',
    'Buada': 'NR-07',
    'Denigomodu': 'NR-08',
    'Ewa': 'NR-09',
    'Ijuw': 'NR-10',
    'Meneng': 'NR-11',
    'Nibok': 'NR-12',
    'Uaboe': 'NR-13',
    'Yaren': 'NR-14',
  },
  NZL: {
    'Auckland': 'NZ-AUK',
    'Bay of Plenty': 'NZ-BOP',
    'Canterbury': 'NZ-CAN',
    'Chatham Islands': 'NZ-CIT',
    'Gisborne': 'NZ-GIS',
    'Hawke\'s Bay': 'NZ-HKB',
    'Manawatu-Wanganui': 'NZ-MWT',
    'Marlborough': 'NZ-MBH',
    'Nelson': 'NZ-NSN',
    'Northland': 'NZ-NTL',
    'Otago': 'NZ-OTA',
    'Southland': 'NZ-STL',
    'Taranaki': 'NZ-TKI',
    'Tasman': 'NZ-TAS',
    'Waikato': 'NZ-WKO',
    'Wellington': 'NZ-WGN',
    'West Coast': 'NZ-WTC',
  },
  OMN: {
    'Ad Dakhiliyah': 'OM-DA',
    'Ad Dhahirah': 'OM-ZA',
    'Al Batinah North': 'OM-BS',
    'Al Batinah South': 'OM-BJ',
    'Al Buraymi': 'OM-BU',
    'Al Wusta': 'OM-WU',
    'Ash Sharqiyah North': 'OM-SS',
    'Ash Sharqiyah South': 'OM-SJ',
    'Dhofar': 'OM-ZU',
    'Musandam': 'OM-MU',
    'Muscat': 'OM-MA',
  },
  PAK: {
    'Azad Kashmir': 'PK-JK',
    'Balochistan': 'PK-BA',
    'Gilgit-Baltistan': 'PK-GB',
    'Islamabad': 'PK-IS',
    'Khyber Pakhtunkhwa': 'PK-KP',
    'Punjab': 'PK-PB',
    'Sindh': 'PK-SD',
  },
  PAN: {
    'Bocas del Toro': 'PA-1',
    'Chiriquí': 'PA-4',
    'Coclé': 'PA-2',
    'Colón': 'PA-3',
    'Darién': 'PA-5',
    'Emberá': 'PA-EM',
    'Guna Yala': 'PA-KY',
    'Herrera': 'PA-6',
    'Los Santos': 'PA-7',
    'Ngäbe-Buglé': 'PA-NB',
    'Panamá': 'PA-8',
    'Panamá Oeste': 'PA-10',
    'Veraguas': 'PA-9',
  },
  PCN: {
    'Adamstown': 'PN-01',
  },
  PER: {
    'Amazonas': 'PE-AMA',
    'Ancash': 'PE-ANC',
    'Apurímac': 'PE-APU',
    'Arequipa': 'PE-ARE',
    'Ayacucho': 'PE-AYA',
    'Cajamarca': 'PE-CAJ',
    'Callao': 'PE-CAL',
    'Cusco': 'PE-CUS',
    'Huancavelica': 'PE-HUV',
    'Huánuco': 'PE-HUC',
    'Ica': 'PE-ICA',
    'Junín': 'PE-JUN',
    'La Libertad': 'PE-LAL',
    'Lambayeque': 'PE-LAM',
    'Lima': 'PE-LIM',
    'Loreto': 'PE-LOR',
    'Madre de Dios': 'PE-MDD',
    'Moquegua': 'PE-MOQ',
    'Pasco': 'PE-PAS',
    'Piura': 'PE-PIU',
    'Puno': 'PE-PUN',
    'San Martín': 'PE-SAM',
    'Tacna': 'PE-TAC',
    'Tumbes': 'PE-TUM',
    'Ucayali': 'PE-UCA',
  },
  PHL: {
    'Abra': 'PH-ABR',
    'Agusan del Norte': 'PH-AGN',
    'Agusan del Sur': 'PH-AGS',
    'Aklan': 'PH-AKL',
    'Albay': 'PH-ALB',
    'Antique': 'PH-ANT',
    'Apayao': 'PH-APA',
    'Aurora': 'PH-AUR',
    'Basilan': 'PH-BAS',
    'Bataan': 'PH-BAN',
    'Batanes': 'PH-BTN',
    'Batangas': 'PH-BTG',
    'Benguet': 'PH-BEN',
    'Biliran': 'PH-BIL',
    'Bohol': 'PH-BOH',
    'Bukidnon': 'PH-BUK',
    'Bulacan': 'PH-BUL',
    'Cagayan': 'PH-CAG',
    'Camarines Norte': 'PH-CAN',
    'Camarines Sur': 'PH-CAS',
    'Camiguin': 'PH-CAM',
    'Capiz': 'PH-CAP',
    'Catanduanes': 'PH-CAT',
    'Cavite': 'PH-CAV',
    'Cebu': 'PH-CEB',
    'Compostela Valley': 'PH-COM',
    'Cotabato': 'PH-NCO',
    'Davao del Norte': 'PH-DAV',
    'Davao del Sur': 'PH-DAS',
    'Davao Occidental': 'PH-DVO',
    'Davao Oriental': 'PH-DAO',
    'Dinagat Islands': 'PH-DIN',
    'Eastern Samar': 'PH-EAS',
    'Guimaras': 'PH-GUI',
    'Ifugao': 'PH-IFU',
    'Ilocos Norte': 'PH-ILN',
    'Ilocos Sur': 'PH-ILS',
    'Iloilo': 'PH-ILI',
    'Isabela': 'PH-ISA',
    'Kalinga': 'PH-KAL',
    'La Union': 'PH-LUN',
    'Laguna': 'PH-LAG',
    'Lanao del Norte': 'PH-LAN',
    'Lanao del Sur': 'PH-LAS',
    'Leyte': 'PH-LEY',
    'Maguindanao': 'PH-MAG',
    'Marinduque': 'PH-MAD',
    'Masbate': 'PH-MAS',
    'Metro Manila': 'PH-00',
    'Misamis Occidental': 'PH-MSC',
    'Misamis Oriental': 'PH-MSR',
    'Mountain Province': 'PH-MOU',
    'Negros Occidental': 'PH-NEC',
    'Negros Oriental': 'PH-NER',
    'Northern Samar': 'PH-NSA',
    'Nueva Ecija': 'PH-NUE',
    'Nueva Vizcaya': 'PH-NUV',
    'Occidental Mindoro': 'PH-MDC',
    'Oriental Mindoro': 'PH-MDR',
    'Palawan': 'PH-PLW',
    'Pampanga': 'PH-PAM',
    'Pangasinan': 'PH-PAN',
    'Quezon': 'PH-QUE',
    'Quirino': 'PH-QUI',
    'Rizal': 'PH-RIZ',
    'Romblon': 'PH-ROM',
    'Samar': 'PH-WSA',
    'Sarangani': 'PH-SAR',
    'Siquijor': 'PH-SIG',
    'Sorsogon': 'PH-SOR',
    'South Cotabato': 'PH-SCO',
    'Southern Leyte': 'PH-SLE',
    'Sultan Kudarat': 'PH-SUK',
    'Sulu': 'PH-SLU',
    'Surigao del Norte': 'PH-SUN',
    'Surigao del Sur': 'PH-SUR',
    'Tarlac': 'PH-TAR',
    'Tawi-Tawi': 'PH-TAW',
    'Zambales': 'PH-ZMB',
    'Zamboanga del Norte': 'PH-ZAN',
    'Zamboanga del Sur': 'PH-ZAS',
    'Zamboanga Sibugay': 'PH-ZSI',
  },
  PLW: {
    'Aimeliik': 'PW-002',
    'Airai': 'PW-004',
    'Angaur': 'PW-010',
    'Hatohobei': 'PW-050',
    'Kayangel': 'PW-100',
    'Koror': 'PW-150',
    'Melekeok': 'PW-212',
    'Ngaraard': 'PW-214',
    'Ngarchelong': 'PW-218',
    'Ngardmau': 'PW-222',
    'Ngatpang': 'PW-224',
    'Ngchesar': 'PW-226',
    'Ngeremlengui': 'PW-227',
    'Ngiwal': 'PW-228',
    'Peleliu': 'PW-350',
    'Sonsorol': 'PW-370',
  },
  PNG: {
    'Bougainville': 'PG-NSB',
    'Central': 'PG-CPM',
    'Chimbu': 'PG-CPK',
    'East New Britain': 'PG-EBR',
    'East Sepik': 'PG-ESW',
    'Eastern Highlands': 'PG-EHG',
    'Enga': 'PG-EPW',
    'Gulf': 'PG-GPK',
    'Hela': 'PG-HLA',
    'Jiwaka': 'PG-JWK',
    'Madang': 'PG-MPM',
    'Manus': 'PG-MRL',
    'Milne Bay': 'PG-MBA',
    'Morobe': 'PG-MPL',
    'National Capital District': 'PG-NCD',
    'New Ireland': 'PG-NIK',
    'Northern': 'PG-NPP',
    'Southern Highlands': 'PG-SHM',
    'West New Britain': 'PG-WBK',
    'Western': 'PG-WPD',
    'Western Highlands': 'PG-WHM',
    'West Sepik': 'PG-SAN',
  },
  POL: {
    'Greater Poland': 'PL-30',
    'Kuyavian-Pomeranian': 'PL-04',
    'Lesser Poland': 'PL-12',
    'Łódź': 'PL-10',
    'Lower Silesian': 'PL-02',
    'Lubusz': 'PL-08',
    'Masovian': 'PL-14',
    'Opole': 'PL-16',
    'Podkarpackie': 'PL-18',
    'Podlaskie': 'PL-20',
    'Pomeranian': 'PL-22',
    'Silesian': 'PL-24',
    'Świętokrzyskie': 'PL-26',
    'Warmian-Masurian': 'PL-28',
    'West Pomeranian': 'PL-32',
  },
  PRI: {
    'Adjuntas': 'PR-001',
    'Aguada': 'PR-003',
    'Aguadilla': 'PR-005',
    'Aguas Buenas': 'PR-007',
    'Aibonito': 'PR-009',
    'Anasco': 'PR-011',
    'Arecibo': 'PR-013',
    'Arroyo': 'PR-015',
    'Barceloneta': 'PR-017',
    'Barranquitas': 'PR-019',
    'Bayamon': 'PR-021',
    'Cabo Rojo': 'PR-023',
    'Caguas': 'PR-025',
    'Camuy': 'PR-027',
    'Canovanas': 'PR-029',
    'Carolina': 'PR-031',
    'Catano': 'PR-033',
    'Cayey': 'PR-035',
    'Ceiba': 'PR-037',
    'Ciales': 'PR-039',
    'Cidra': 'PR-041',
    'Coamo': 'PR-043',
    'Comerio': 'PR-045',
    'Corozal': 'PR-047',
    'Culebra': 'PR-049',
    'Dorado': 'PR-051',
    'Fajardo': 'PR-053',
    'Florida': 'PR-054',
    'Guanica': 'PR-055',
    'Guayama': 'PR-057',
    'Guayanilla': 'PR-059',
    'Guaynabo': 'PR-061',
    'Gurabo': 'PR-063',
    'Hatillo': 'PR-065',
    'Hormigueros': 'PR-067',
    'Humacao': 'PR-069',
    'Isabela': 'PR-071',
    'Jayuya': 'PR-073',
    'Juana Diaz': 'PR-075',
    'Juncos': 'PR-077',
    'Lajas': 'PR-079',
    'Lares': 'PR-081',
    'Las Marias': 'PR-083',
    'Las Piedras': 'PR-085',
    'Loiza': 'PR-087',
    'Luquillo': 'PR-089',
    'Manati': 'PR-091',
    'Maricao': 'PR-093',
    'Maunabo': 'PR-095',
    'Mayaguez': 'PR-097',
    'Moca': 'PR-099',
    'Morovis': 'PR-101',
    'Naguabo': 'PR-103',
    'Naranjito': 'PR-105',
    'Orocovis': 'PR-107',
    'Patillas': 'PR-109',
    'Penuelas': 'PR-111',
    'Ponce': 'PR-113',
    'Quebradillas': 'PR-115',
    'Rincon': 'PR-117',
    'Rio Grande': 'PR-119',
    'Sabana Grande': 'PR-121',
    'Salinas': 'PR-123',
    'San German': 'PR-125',
    'San Juan': 'PR-127',
    'San Lorenzo': 'PR-129',
    'San Sebastian': 'PR-131',
    'Santa Isabel': 'PR-133',
    'Toa Alta': 'PR-135',
    'Toa Baja': 'PR-137',
    'Trujillo Alto': 'PR-139',
    'Utuado': 'PR-141',
    'Vega Alta': 'PR-143',
    'Vega Baja': 'PR-145',
    'Vieques': 'PR-147',
    'Villalba': 'PR-149',
    'Yabucoa': 'PR-151',
    'Yauco': 'PR-153',
  },
  PRK: {
    'Chagang-do (Chagang)': 'KP-04',
    'Hamgyong-bukto (North Hamgyong)': 'KP-09',
    'Hamgyong-namdo (South Hamgyong)': 'KP-08',
    'Hwanghae-bukto (North Hwanghae)': 'KP-06',
    'Hwanghae-namdo (South Hwanghae)': 'KP-05',
    'Kangwon-do (Kangwon)': 'KP-07',
    'Nason (Rason)': 'KP-13',
    'Namp\'o-si (Namp\'o)': 'KP-02',
    'Pyongan-bukto (North Pyongan)': 'KP-03',
    'Pyongan-namdo (South Pyongan)': 'KP-01',
    'Pyongyang-si (Pyongyang)': 'KP-01',
  },
  PRT: {
    'Aveiro': 'PT-01',
    'Açores (Azores)': 'PT-20',
    'Beja': 'PT-02',
    'Braga': 'PT-03',
    'Bragança': 'PT-04',
    'Castelo Branco': 'PT-05',
    'Coimbra': 'PT-06',
    'Evora': 'PT-07',
    'Faro': 'PT-08',
    'Guarda': 'PT-09',
    'Leiria': 'PT-10',
    'Lisboa (Lisbon)': 'PT-11',
    'Madeira': 'PT-30',
    'Portalegre': 'PT-12',
    'Porto': 'PT-13',
    'Santarem': 'PT-14',
    'Setúbal': 'PT-15',
    'Viana do Castelo': 'PT-16',
    'Vila Real': 'PT-17',
    'Viseu': 'PT-18',
  },
  PRY: {
    'Alto Paraguay': 'PY-16',
    'Alto Paraná': 'PY-10',
    'Amambay': 'PY-13',
    'Asunción': 'PY-ASU',
    'Boquerón': 'PY-19',
    'Caaguazú': 'PY-05',
    'Caazapá': 'PY-06',
    'Canindeyú': 'PY-14',
    'Central': 'PY-11',
    'Concepción': 'PY-1',
    'Cordillera': 'PY-3',
    'Guairá': 'PY-4',
    'Itapúa': 'PY-7',
    'Misiones': 'PY-8',
    'Ñeembucú': 'PY-12',
    'Paraguarí': 'PY-9',
    'Presidente Hayes': 'PY-15',
    'San Pedro': 'PY-2',
  },
  PSE: {
    'Bethlehem': 'PS-BTH',
    'Deir al-Balah': 'PS-DEB',
    'Gaza': 'PS-GZA',
    'Hebron': 'PS-HBN',
    'Jenin': 'PS-JEN',
    'Jericho': 'PS-JRH',
    'Jerusalem': 'PS-JEM',
    'Khan Yunis': 'PS-KYS',
    'Nablus': 'PS-NBS',
    'North Gaza': 'PS-NGZ',
    'Qalqilya': 'PS-QQA',
    'Rafah': 'PS-RFH',
    'Ramallah': 'PS-RBH',
    'Salfit': 'PS-SLT',
    'Tubas': 'PS-TBS',
    'Tulkarm': 'PS-TKM',
  },
  PYF: {
    'Îles Australes': 'PF-X02',
    'Îles du Vent': 'PF-X01',
    'Îles Marquises': 'PF-X03',
    'Îles Sous-le-Vent': 'PF-X04',
    'Tuamotu-Gambier': 'PF-X05',
  },
  QAT: {
    'Ad Dawhah': 'QA-DA',
    'Al Daayen': 'QA-ZA',
    'Al Khawr wa adh Dhakhīrah': 'QA-KH',
    'Al Wakrah': 'QA-WA',
    'Ar Rayyan': 'QA-RA',
    'Ash Shamal': 'QA-MS',
  },
  REU: {
    'Réunion': 'RE-RE',
  },
  ROU: {
    'Alba': 'RO-AB',
    'Arad': 'RO-AR',
    'Argeș': 'RO-AG',
    'Bacău': 'RO-BC',
    'Bihor': 'RO-BH',
    'Bistrița-Năsăud': 'RO-BN',
    'Botoșani': 'RO-BT',
    'Brăila': 'RO-BR',
    'Brașov': 'RO-BV',
    'București (Bucharest)': 'RO-B',
    'Buzău': 'RO-BZ',
    'Călărași': 'RO-CL',
    'Caraș-Severin': 'RO-CS',
    'Cluj': 'RO-CJ',
    'Constanța': 'RO-CT',
    'Covasna': 'RO-CV',
    'Dâmbovița': 'RO-DB',
    'Dolj': 'RO-DJ',
    'Galați': 'RO-GL',
    'Giurgiu': 'RO-GR',
    'Gorj': 'RO-GJ',
    'Harghita': 'RO-HR',
    'Hunedoara': 'RO-HD',
    'Ialomița': 'RO-IL',
    'Iași': 'RO-IS',
    'Ilfov': 'RO-IF',
    'Maramureș': 'RO-MM',
    'Mehedinți': 'RO-MH',
    'Mureș': 'RO-MS',
    'Neamț': 'RO-NT',
    'Olt': 'RO-OT',
    'Prahova': 'RO-PH',
    'Sălaj': 'RO-SJ',
    'Satu Mare': 'RO-SM',
    'Sibiu': 'RO-SB',
    'Suceava': 'RO-SV',
    'Teleorman': 'RO-TR',
    'Timiș': 'RO-TM',
    'Tulcea': 'RO-TL',
    'Vâlcea': 'RO-VL',
    'Vaslui': 'RO-VS',
    'Vrancea': 'RO-VN',
  },
  RUS: {
    'Adygea': 'RU-AD',
    'Altai': 'RU-ALT',
    'Altai Krai': 'RU-ALT',
    'Amur': 'RU-AMU',
    'Arkhangelsk': 'RU-ARK',
    'Astrakhan': 'RU-AST',
    'Bashkortostan': 'RU-BA',
    'Belgorod': 'RU-BEL',
    'Bryansk': 'RU-BRY',
    'Buryatia': 'RU-BU',
    'Chechnya': 'RU-CE',
    'Chelyabinsk': 'RU-CHE',
    'Chukotka': 'RU-CHU',
    'Chuvashia': 'RU-CU',
    'Crimea': 'RU-CR',
    'Dagestan': 'RU-DA',
    'Ingushetia': 'RU-IN',
    'Irkutsk': 'RU-IRK',
    'Ivanovo': 'RU-IVA',
    'Jewish Autonomous Oblast': 'RU-YEV',
    'Kabardino-Balkaria': 'RU-KB',
    'Kaliningrad': 'RU-KGD',
    'Kalmykia': 'RU-KL',
    'Kaluga': 'RU-KLU',
    'Kamchatka Krai': 'RU-KAM',
    'Karachay-Cherkessia': 'RU-KC',
    'Karelia': 'RU-KR',
    'Kemerovo': 'RU-KEM',
    'Khabarovsk Krai': 'RU-KHA',
    'Khakassia': 'RU-KK',
    'Khanty-Mansi': 'RU-KHM',
    'Kirov': 'RU-KIR',
    'Komi': 'RU-KO',
    'Kostroma': 'RU-KOS',
    'Krasnodar': 'RU-KDA',
    'Krasnoyarsk Krai': 'RU-KYA',
    'Kurgan': 'RU-KGN',
    'Kursk': 'RU-KRS',
    'Leningrad': 'RU-LEN',
    'Lipetsk': 'RU-LIP',
    'Magadan': 'RU-MAG',
    'Mari El': 'RU-ME',
    'Mordovia': 'RU-MO',
    'Moscow': 'RU-MOS',
    'Moscow Oblast': 'RU-MOS',
    'Murmansk': 'RU-MUR',
    'Nenets': 'RU-NEN',
    'Nizhny Novgorod': 'RU-NIZ',
    'North Ossetia-Alania': 'RU-SE',
    'Novgorod': 'RU-NGR',
    'Novosibirsk': 'RU-NVS',
    'Omsk': 'RU-OMS',
    'Orenburg': 'RU-ORE',
    'Oryol': 'RU-ORL',
    'Penza': 'RU-PNZ',
    'Perm Krai': 'RU-PER',
    'Primorsky Krai': 'RU-PRI',
    'Pskov': 'RU-PSK',
    'Rostov': 'RU-ROS',
    'Ryazan': 'RU-RYA',
    'Sakha': 'RU-SA',
    'Sakhalin': 'RU-SAK',
    'Samara': 'RU-SAM',
    'Saratov': 'RU-SAR',
    'Sevastopol': 'RU-40',
    'Smolensk': 'RU-SMO',
    'Stavropol': 'RU-STA',
    'Sverdlovsk': 'RU-SVE',
    'Tambov': 'RU-TAM',
    'Tatarstan': 'RU-TA',
    'Tomsk': 'RU-TOM',
    'Tula': 'RU-TUL',
    'Tuva': 'RU-TY',
    'Tver': 'RU-TVE',
    'Tyumen': 'RU-TYU',
    'Udmurtia': 'RU-UD',
    'Ulyanovsk': 'RU-ULY',
    'Vladimir': 'RU-VLA',
    'Volgograd': 'RU-VGG',
    'Vologda': 'RU-VLG',
    'Voronezh': 'RU-VOR',
    'Yamalo-Nenets': 'RU-YAN',
    'Yaroslavl': 'RU-YAR',
    'Zabaykalsky Krai': 'RU-ZAB',
  },
  RWA: {
    'Eastern Province': 'RW-02',
    'Kigali': 'RW-01',
    'Northern Province': 'RW-03',
    'Southern Province': 'RW-05',
    'Western Province': 'RW-04',
  },
  SAU: {
    'Al Bahah': 'SA-11',
    'Al Hudud ash Shamaliyah': 'SA-08',
    'Al Jawf': 'SA-12',
    'Al Madinah': 'SA-03',
    'Al Qasim': 'SA-05',
    'Ar Riyad': 'SA-01',
    'Ash Sharqiyah': 'SA-04',
    'Asir': 'SA-14',
    'Ha\'il': 'SA-06',
    'Jizan': 'SA-09',
    'Makkah': 'SA-02',
    'Najran': 'SA-10',
    'Tabuk': 'SA-07',
  },
  SDN: {
    'Central Darfur': 'SD-DC',
    'East Darfur': 'SD-DE',
    'Kassala': 'SD-KA',
    'Khartoum': 'SD-KH',
    'North Darfur': 'SD-DN',
    'North Kordofan': 'SD-KN',
    'Northern': 'SD-NO',
    'Red Sea': 'SD-RS',
    'River Nile': 'SD-NR',
    'Sennar': 'SD-SI',
    'South Darfur': 'SD-DS',
    'South Kordofan': 'SD-KS',
    'West Darfur': 'SD-DW',
    'West Kordofan': 'SD-GD',
    'White Nile': 'SD-NW',
  },
  SEN: {
    'Dakar': 'SN-DK',
    'Diourbel': 'SN-DB',
    'Fatick': 'SN-FK',
    'Kaffrine': 'SN-KA',
    'Kaolack': 'SN-KL',
    'Kedougou': 'SN-KE',
    'Kolda': 'SN-KD',
    'Louga': 'SN-LG',
    'Matam': 'SN-MT',
    'Saint-Louis': 'SN-SL',
    'Sedhiou': 'SN-SE',
    'Tambacounda': 'SN-TC',
    'Thies': 'SN-TH',
    'Ziguinchor': 'SN-ZG',
  },
  SGP: {
    'Singapore': 'SG-01',
  },
  SGS: {
    'South Georgia and the South Sandwich Islands': 'GS-X01',
  },
  SHN: {
    'Ascension': 'SH-AC',
    'Saint Helena': 'SH-HL',
    'Tristan da Cunha': 'SH-TA',
  },
  SJM: {
    'Svalbard': 'SJ-SV',
  },
  SLB: {
    'Central Province': 'SB-CE',
    'Choiseul': 'SB-CH',
    'Guadalcanal': 'SB-GU',
    'Honiara': 'SB-CT',
    'Isabel': 'SB-IS',
    'Makira-Ulawa': 'SB-MK',
    'Malaita': 'SB-ML',
    'Rennell and Bellona': 'SB-RB',
    'Temotu': 'SB-TE',
    'Western Province': 'SB-WE',
  },
  SLE: {
    'Eastern Province': 'SL-E',
    'Northern Province': 'SL-N',
    'Southern Province': 'SL-S',
    'Western Area': 'SL-W',
  },
  SLV: {
    'Ahuachapán': 'SV-AH',
    'Cabañas': 'SV-CA',
    'Chalatenango': 'SV-CH',
    'Cuscatlán': 'SV-CU',
    'La Libertad': 'SV-LI',
    'La Paz': 'SV-PA',
    'La Unión': 'SV-UN',
    'Morazán': 'SV-MO',
    'San Miguel': 'SV-SM',
    'San Salvador': 'SV-SS',
    'San Vicente': 'SV-SV',
    'Santa Ana': 'SV-SA',
    'Sonsonate': 'SV-SO',
    'Usulután': 'SV-US',
  },
  SMR: {
    'Acquaviva': 'SM-01',
    'Borgo Maggiore': 'SM-06',
    'Chiesanuova': 'SM-02',
    'Domagnano': 'SM-03',
    'Faetano': 'SM-04',
    'Fiorentino': 'SM-05',
    'Montegiardino': 'SM-08',
    'San Marino': 'SM-07',
    'Serravalle': 'SM-09',
  },
  SOM: {
    'Awdal': 'SO-AW',
    'Bakool': 'SO-BK',
    'Banaadir': 'SO-BN',
    'Bari': 'SO-BR',
    'Bay': 'SO-BY',
    'Galguduud': 'SO-GA',
    'Gedo': 'SO-GE',
    'Hiiraan': 'SO-HI',
    'Jubbada Dhexe': 'SO-JD',
    'Jubbada Hoose': 'SO-JH',
    'Mudug': 'SO-MU',
    'Nugaal': 'SO-NU',
    'Sanaag': 'SO-SA',
    'Shabeellaha Dhexe': 'SO-SD',
    'Shabeellaha Hoose': 'SO-SH',
    'Sool': 'SO-SO',
    'Togdheer': 'SO-TO',
    'Woqooyi Galbeed': 'SO-WO',
  },
  SRB: {
    'Belgrade': 'RS-00',
    'Borski okrug (Bor)': 'RS-14',
    'Braničevski okrug (Šabac)': 'RS-11',
    'Jablanica': 'RS-23',
    'Južnobački okrug (Novi Sad)': 'RS-02',
    'Južnobanatski okrug (Pančevo)': 'RS-03',
    'Kolubarski okrug (Valjevo)': 'RS-09',
    'Mačvanski okrug (Šabac)': 'RS-08',
    'Moravički okrug (Čačak)': 'RS-12',
    'Nišavski okrug (Niš)': 'RS-20',
    'Pčinjski okrug (Vranje)': 'RS-24',
    'Pećki okrug (Peć)': 'RS-26',
    'Pirotski okrug (Pirot)': 'RS-22',
    'Podunavski okrug (Smederevo)': 'RS-10',
    'Pomoravski okrug (Jagodina)': 'RS-13',
    'Prizrenski okrug (Prizren)': 'RS-27',
    'Rasinski okrug (Kruševac)': 'RS-19',
    'Severnobanatski okrug (Kikinda)': 'RS-01',
    'Severnobanatski okrug (Subotica)': 'RS-01',
    'Srednjobanatski okrug (Zrenjanin)': 'RS-04',
    'Sremski okrug (Sremska Mitrovica)': 'RS-07',
    'Šumadijski okrug (Kragujevac)': 'RS-12',
    'Toplički okrug (Prokuplje)': 'RS-21',
    'Zaječarski okrug (Zaječar)': 'RS-15',
    'Zapadnobački okrug (Sombor)': 'RS-05',
    'Zlatiborski okrug (Užice)': 'RS-16',
  },
  SSD: {
    'Central Equatoria': 'SS-EC',
    'Eastern Equatoria': 'SS-EE',
    'Jonglei': 'SS-JG',
    'Lakes': 'SS-LK',
    'Northern Bahr el Ghazal': 'SS-BN',
    'Unity': 'SS-UY',
    'Upper Nile': 'SS-NU',
    'Western Bahr el Ghazal': 'SS-BW',
    'Western Equatoria': 'SS-EW',
  },
  STP: {
    'Príncipe': 'ST-P',
    'São Tomé': 'ST-S',
  },
  SUR: {
    'Brokopondo': 'SR-BR',
    'Commewijne': 'SR-CM',
    'Coronie': 'SR-CR',
    'Marowijne': 'SR-MA',
    'Nickerie': 'SR-NI',
    'Paramaribo': 'SR-PM',
    'Saramacca': 'SR-SA',
    'Sipaliwini': 'SR-SI',
    'Wanica': 'SR-WA',
  },
  SVK: {
    'Banská Bystrica': 'SK-BC',
    'Bratislava': 'SK-BL',
    'Košice': 'SK-KI',
    'Nitra': 'SK-NI',
    'Prešov': 'SK-PV',
    'Trenčín': 'SK-TC',
    'Trnava': 'SK-TA',
    'Žilina': 'SK-ZI',
  },
  SVN: {
    'Ajdovščina': 'SI-001',
    'Beltinci': 'SI-195',
    'Benedikt': 'SI-002',
    'Bistrica ob Sotli': 'SI-148',
    'Bled': 'SI-149',
    'Bloke': 'SI-003',
    'Bohinj': 'SI-150',
    'Borovnica': 'SI-004',
    'Bovec': 'SI-005',
    'Braslovče': 'SI-006',
    'Brda': 'SI-151',
    'Brezovica': 'SI-007',
    'Brežice': 'SI-008',
    'Cankova': 'SI-009',
    'Celje': 'SI-011',
    'Cerklje na Gorenjskem': 'SI-012',
    'Cerknica': 'SI-013',
    'Cerkno': 'SI-014',
    'Cerkvenjak': 'SI-015',
    'Cirkulane': 'SI-016',
    'Črenšovci': 'SI-017',
    'Črna na Koroškem': 'SI-018',
    'Črnomelj': 'SI-019',
    'Destrnik': 'SI-152',
    'Divača': 'SI-020',
    'Dobje': 'SI-154',
    'Dobrepolje': 'SI-021',
    'Dobrna': 'SI-155',
    'Dobrova–Polhov Gradec': 'SI-022',
    'Dobrovnik': 'SI-157',
    'Dol pri Ljubljani': 'SI-024',
    'Dolenjske Toplice': 'SI-025',
    'Domžale': 'SI-026',
    'Dornava': 'SI-027',
    'Dravograd': 'SI-028',
    'Duplek': 'SI-207',
    'Gorenja vas–Poljane': 'SI-029',
    'Gorišnica': 'SI-030',
    'Gorje': 'SI-031',
    'Gornja Radgona': 'SI-032',
    'Gornji Grad': 'SI-033',
    'Gornji Petrovci': 'SI-034',
    'Grad': 'SI-035',
    'Grosuplje': 'SI-036',
    'Hajdina': 'SI-037',
    'Hoče–Slivnica': 'SI-038',
    'Hodoš': 'SI-039',
    'Horjul': 'SI-040',
    'Hrastnik': 'SI-041',
    'Hrpelje–Kozina': 'SI-042',
    'Idrija': 'SI-043',
    'Ig': 'SI-044',
    'Ilirska Bistrica': 'SI-045',
    'Ivančna Gorica': 'SI-046',
    'Izola': 'SI-047',
    'Jesenice': 'SI-048',
    'Jezersko': 'SI-049',
    'Juršinci': 'SI-164',
    'Kamnik': 'SI-050',
    'Kanal': 'SI-051',
    'Kidričevo': 'SI-052',
    'Kobarid': 'SI-053',
    'Kobilje': 'SI-054',
    'Kočevje': 'SI-055',
    'Komen': 'SI-056',
    'Komenda': 'SI-057',
    'Koper': 'SI-058',
    'Kostanjevica na Krki': 'SI-059',
    'Kostel': 'SI-060',
    'Kozje': 'SI-061',
    'Kranj': 'SI-062',
    'Kranjska Gora': 'SI-063',
    'Križevci': 'SI-064',
    'Krško': 'SI-065',
    'Kungota': 'SI-066',
    'Kuzma': 'SI-167',
    'Laško': 'SI-067',
    'Lenart': 'SI-068',
    'Lendava': 'SI-069',
    'Litija': 'SI-070',
    'Ljubljana': 'SI-071',
    'Ljubno': 'SI-072',
    'Ljutomer': 'SI-073',
    'Logatec': 'SI-074',
    'Loška Dolina': 'SI-075',
    'Loški Potok': 'SI-076',
    'Luče': 'SI-077',
    'Lukovica': 'SI-078',
    'Majšperk': 'SI-079',
    'Makole': 'SI-080',
    'Maribor': 'SI-081',
    'Markovci': 'SI-082',
    'Medvode': 'SI-083',
    'Mengeš': 'SI-084',
    'Metlika': 'SI-085',
    'Mežica': 'SI-086',
    'Miklavž na Dravskem Polju': 'SI-088',
    'Miren–Kostanjevica': 'SI-089',
    'Mirna Peč': 'SI-090',
    'Mislinja': 'SI-091',
    'Mokronog–Trebelno': 'SI-092',
    'Moravče': 'SI-093',
    'Moravske Toplice': 'SI-094',
    'Mozirje': 'SI-095',
    'Murska Sobota': 'SI-096',
    'Muta': 'SI-097',
    'Naklo': 'SI-098',
    'Nazarje': 'SI-099',
    'Nova Gorica': 'SI-100',
    'Novo Mesto': 'SI-101',
    'Odranci': 'SI-102',
    'Oplotnica': 'SI-103',
    'Ormož': 'SI-104',
    'Osilnica': 'SI-106',
    'Pesnica': 'SI-107',
    'Piran': 'SI-108',
    'Pivka': 'SI-109',
    'Podčetrtek': 'SI-158',
    'Podlehnik': 'SI-110',
    'Podvelka': 'SI-111',
    'Poljčane': 'SI-112',
    'Polzela': 'SI-113',
    'Postojna': 'SI-114',
    'Prebold': 'SI-115',
    'Preddvor': 'SI-116',
    'Prevalje': 'SI-117',
    'Ptuj': 'SI-118',
    'Puconci': 'SI-119',
    'Rače–Fram': 'SI-120',
    'Radeče': 'SI-121',
    'Radenci': 'SI-122',
    'Radlje ob Dravi': 'SI-123',
    'Radovljica': 'SI-124',
    'Ravne na Koroškem': 'SI-125',
    'Razkrižje': 'SI-126',
    'Renče–Vogrsko': 'SI-127',
    'Ribnica': 'SI-128',
    'Ribnica na Pohorju': 'SI-129',
    'Rogašovci': 'SI-130',
    'Rogaška Slatina': 'SI-131',
    'Rogatec': 'SI-132',
    'Ruše': 'SI-133',
    'Semič': 'SI-134',
    'Sevnica': 'SI-135',
    'Sežana': 'SI-136',
    'Slovenj Gradec': 'SI-137',
    'Slovenska Bistrica': 'SI-138',
    'Slovenske Konjice': 'SI-139',
    'Šalovci': 'SI-201',
    'Šempeter–Vrtojba': 'SI-140',
    'Šencur': 'SI-141',
    'Šentilj': 'SI-142',
    'Šentjernej': 'SI-143',
    'Šentjur': 'SI-144',
    'Šentrupert': 'SI-146',
    'Sevnica': 'SI-147',
    'Škocjan': 'SI-192',
    'Škofja Loka': 'SI-193',
    'Škofljica': 'SI-194',
    'Šmartno ob Paki': 'SI-196',
    'Šmartno pri Litiji': 'SI-197',
    'Šoštanj': 'SI-198',
    'Štore': 'SI-199',
    'Tabor': 'SI-200',
    'Tolmin': 'SI-202',
    'Trbovlje': 'SI-203',
    'Trebnje': 'SI-205',
    'Trnovska Vas': 'SI-204',
    'Tržič': 'SI-206',
    'Turnišče': 'SI-208',
    'Velenje': 'SI-209',
    'Velika Polana': 'SI-210',
    'Velike Lašče': 'SI-211',
    'Veržej': 'SI-212',
    'Videm': 'SI-213',
    'Vipava': 'SI-214',
    'Vitanje': 'SI-216',
    'Vodice': 'SI-217',
    'Vojnik': 'SI-218',
    'Vransko': 'SI-219',
    'Vrhnika': 'SI-220',
    'Vuzenica': 'SI-221',
    'Zagorje ob Savi': 'SI-222',
    'Zavrč': 'SI-223',
    'Zreče': 'SI-224',
    'Žalec': 'SI-225',
    'Železniki': 'SI-226',
    'Žetale': 'SI-227',
    'Žiri': 'SI-228',
    'Središče ob Dravi': 'SI-225',
  },
  SWE: {
    'Blekinge': 'SE-K',
    'Dalarna': 'SE-W',
    'Gävleborg': 'SE-X',
    'Gotland': 'SE-I',
    'Halland': 'SE-N',
    'Jämtland': 'SE-Z',
    'Jönköping': 'SE-F',
    'Kalmar': 'SE-H',
    'Kronoberg': 'SE-G',
    'Norrbotten': 'SE-BD',
    'Örebro': 'SE-T',
    'Östergötland': 'SE-E',
    'Skåne': 'SE-M',
    'Södermanland': 'SE-D',
    'Stockholm': 'SE-AB',
    'Uppsala': 'SE-C',
    'Värmland': 'SE-S',
    'Västerbotten': 'SE-AC',
    'Västernorrland': 'SE-Y',
    'Västmanland': 'SE-U',
    'Västra Götaland': 'SE-O',
  },
  SWZ: {
    'Hhohho': 'SZ-HH',
    'Lubombo': 'SZ-LU',
    'Manzini': 'SZ-MA',
    'Shiselweni': 'SZ-SH',
  },
  SXM: {
    'Sint Maarten': 'SX-SX',
  },
  SYC: {
    'Anse aux Pins': 'SC-01',
    'Anse Boileau': 'SC-02',
    'Anse Etoile': 'SC-03',
    'Anse Royale': 'SC-05',
    'Au Cap': 'SC-04',
    'Baie Lazare': 'SC-06',
    'Baie Sainte Anne': 'SC-07',
    'Beau Vallon': 'SC-08',
    'Bel Air': 'SC-09',
    'Bel Ombre': 'SC-10',
    'Cascade': 'SC-11',
    'Glacis': 'SC-12',
    'Grand Anse Mahe': 'SC-13',
    'Grand Anse Praslin': 'SC-14',
    'La Digue': 'SC-15',
    'La Riviere Anglaise': 'SC-16',
    'Mont Buxton': 'SC-17',
    'Mont Fleuri': 'SC-18',
    'Plaisance': 'SC-19',
    'Pointe La Rue': 'SC-20',
    'Port Glaud': 'SC-21',
    'Roche Caiman': 'SC-24',
    'Saint Louis': 'SC-22',
    'Takamaka': 'SC-25',
  },
  SYR: {
    'Aleppo': 'SY-HL',
    'As-Suwayda': 'SY-SU',
    'Damascus': 'SY-DI',
    'Daraa': 'SY-DR',
    'Deir ez-Zor': 'SY-DY',
    'Hama': 'SY-HM',
    'Homs': 'SY-HI',
    'Idlib': 'SY-ID',
    'Latakia': 'SY-LA',
    'Quneitra': 'SY-QU',
    'Raqqa': 'SY-RA',
    'Rif Dimashq': 'SY-RD',
    'Tartus': 'SY-TA',
  },
  TCA: {
    'Grand Turk': 'TC-T',
    'South Caicos and East Caicos': 'TC-DC',
    'Middle Caicos': 'TC-M',
    'North Caicos': 'TC-N',
    'Providenciales and West Caicos': 'TC-P',
  },
  TCD: {
    'Bahr el Gazel': 'TD-BG',
    'Batha': 'TD-BA',
    'Borkou': 'TD-BO',
    'Chari-Baguirmi': 'TD-CB',
    'Ennedi': 'TD-EN',
    'Guéra': 'TD-GR',
    'Hadjer-Lamis': 'TD-HL',
    'Kanem': 'TD-KA',
    'Lac': 'TD-LC',
    'Logone Occidental': 'TD-LO',
    'Logone Oriental': 'TD-LR',
    'Mayo-Kebbi Est': 'TD-ME',
    'Mayo-Kebbi Ouest': 'TD-MO',
    'Moyen-Chari': 'TD-MC',
    'N’Djamena': 'TD-ND',
    'Ouaddaï': 'TD-OD',
    'Salamat': 'TD-SA',
    'Sila': 'TD-SI',
    'Tandjilé': 'TD-TA',
    'Tibesti': 'TD-TI',
    'Wadi Fira': 'TD-WF',
  },
  TGO: {
    'Centrale': 'TG-C',
    'Kara': 'TG-K',
    'Maritime': 'TG-M',
    'Plateaux': 'TG-P',
    'Savanes': 'TG-S',
  },
  THA: {
    'Amnat Charoen': 'TH-37',
    'Ang Thong': 'TH-15',
    'Bangkok': 'TH-10',
    'Bueng Kan': 'TH-38',
    'Buri Ram': 'TH-31',
    'Chachoengsao': 'TH-24',
    'Chai Nat': 'TH-18',
    'Chaiyaphum': 'TH-36',
    'Chanthaburi': 'TH-22',
    'Chiang Mai': 'TH-50',
    'Chiang Rai': 'TH-57',
    'Chon Buri': 'TH-20',
    'Chumphon': 'TH-86',
    'Kalasin': 'TH-46',
    'Kamphaeng Phet': 'TH-62',
    'Kanchanaburi': 'TH-71',
    'Khon Kaen': 'TH-40',
    'Krabi': 'TH-81',
    'Krung Thep Maha Nakhon': 'TH-10',
    'Lampang': 'TH-52',
    'Lamphun': 'TH-51',
    'Loei': 'TH-42',
    'Lop Buri': 'TH-16',
    'Mae Hong Son': 'TH-58',
    'Maha Sarakham': 'TH-44',
    'Mukdahan': 'TH-49',
    'Nakhon Nayok': 'TH-26',
    'Nakhon Pathom': 'TH-73',
    'Nakhon Phanom': 'TH-48',
    'Nakhon Ratchasima': 'TH-30',
    'Nakhon Sawan': 'TH-60',
    'Nakhon Si Thammarat': 'TH-80',
    'Nan': 'TH-55',
    'Narathiwat': 'TH-96',
    'Nong Bua Lam Phu': 'TH-39',
    'Nong Khai': 'TH-43',
    'Nonthaburi': 'TH-12',
    'Pathum Thani': 'TH-13',
    'Pattani': 'TH-94',
    'Phangnga': 'TH-82',
    'Phatthalung': 'TH-93',
    'Phayao': 'TH-56',
    'Phetchabun': 'TH-67',
    'Phetchaburi': 'TH-76',
    'Phichit': 'TH-66',
    'Phitsanulok': 'TH-65',
    'Phra Nakhon Si Ayutthaya': 'TH-14',
    'Phrae': 'TH-54',
    'Phuket': 'TH-83',
    'Prachin Buri': 'TH-25',
    'Prachuap Khiri Khan': 'TH-77',
    'Ranong': 'TH-85',
    'Ratchaburi': 'TH-70',
    'Rayong': 'TH-21',
    'Roi Et': 'TH-45',
    'Sa Kaeo': 'TH-27',
    'Sakon Nakhon': 'TH-47',
    'Samut Prakan': 'TH-11',
    'Samut Sakhon': 'TH-74',
    'Samut Songkhram': 'TH-75',
    'Saraburi': 'TH-19',
    'Satun': 'TH-91',
    'Sing Buri': 'TH-17',
    'Si Sa Ket': 'TH-33',
    'Songkhla': 'TH-90',
    'Sukhothai': 'TH-64',
    'Suphan Buri': 'TH-72',
    'Surat Thani': 'TH-84',
    'Surin': 'TH-32',
    'Tak': 'TH-63',
    'Trang': 'TH-92',
    'Trat': 'TH-23',
    'Ubon Ratchathani': 'TH-34',
    'Udon Thani': 'TH-41',
    'Uthai Thani': 'TH-61',
    'Uttaradit': 'TH-53',
    'Yala': 'TH-95',
    'Yasothon': 'TH-35',
  },
  TJK: {
    'Dushanbe': 'TJ-DU',
    'Gorno-Badakhshan': 'TJ-GB',
    'Khatlon': 'TJ-KT',
    'Region of Republican Subordination': 'TJ-RA',
  },
  TKL: {
    'Tokelau': 'TK-TK',
  },
  TKM: {
    'Ahal': 'TM-A',
    'Ashgabat': 'TM-S',
    'Balkan': 'TM-B',
    'Daşoguz': 'TM-D',
    'Lebap': 'TM-L',
    'Mary': 'TM-M',
  },
  TLS: {
    'Aileu': 'TL-AL',
    'Ainaro': 'TL-AN',
    'Baucau': 'TL-BA',
    'Bobonaro': 'TL-BO',
    'Cova Lima': 'TL-CO',
    'Dili': 'TL-DI',
    'Ermera': 'TL-ER',
    'Lautem': 'TL-LA',
    'Liquiça': 'TL-LI',
    'Manatuto': 'TL-MT',
    'Manufahi': 'TL-MF',
    'Oecusse': 'TL-OE',
    'Viqueque': 'TL-VI',
  },
  TON: {
    'Eua': 'TO-01',
    'Ha‘apai': 'TO-02',
    'Niuas': 'TO-03',
    'Tongatapu': 'TO-04',
    'Vava‘u': 'TO-05',
  },
  TTO: {
    'Arima': 'TT-ARI',
    'Chaguanas': 'TT-CHA',
    'Couva-Tabaquite-Talparo': 'TT-CTT',
    'Diego Martin': 'TT-DMN',
    'Eastern Tobago': 'TT-ETO',
    'Penal-Debe': 'TT-PED',
    'Point Fortin': 'TT-PTF',
    'Port of Spain': 'TT-POS',
    'Princes Town': 'TT-PRT',
    'Rio Claro-Mayaro': 'TT-RCM',
    'San Fernando': 'TT-SFO',
    'San Juan-Laventille': 'TT-SJL',
    'Sangre Grande': 'TT-SGE',
    'Siparia': 'TT-SIP',
    'Tobago': 'TT-TOB',
    'Tunapuna-Piarco': 'TT-TUP',
    'Western Tobago': 'TT-WTO',
  },
  TUN: {
    'Ariana': 'TN-12',
    'Ben Arous': 'TN-13',
    'Bizerte': 'TN-23',
    'Béja': 'TN-31',
    'Gabès': 'TN-81',
    'Gafsa': 'TN-71',
    'Jendouba': 'TN-32',
    'Kairouan': 'TN-41',
    'Kasserine': 'TN-42',
    'Kebili': 'TN-73',
    'Kef': 'TN-33',
    'Mahdia': 'TN-53',
    'Manouba': 'TN-14',
    'Medenine': 'TN-82',
    'Monastir': 'TN-52',
    'Nabeul': 'TN-21',
    'Sfax': 'TN-61',
    'Sidi Bouzid': 'TN-43',
    'Siliana': 'TN-34',
    'Sousse': 'TN-51',
    'Tataouine': 'TN-83',
    'Tozeur': 'TN-72',
    'Tunis': 'TN-11',
    'Zaghouan': 'TN-22',
  },
  TUR: {
    'Adana': 'TR-01',
    'Adıyaman': 'TR-02',
    'Afyonkarahisar': 'TR-03',
    'Ağrı': 'TR-04',
    'Aksaray': 'TR-68',
    'Amasya': 'TR-05',
    'Ankara': 'TR-06',
    'Antalya': 'TR-07',
    'Ardahan': 'TR-75',
    'Artvin': 'TR-08',
    'Aydın': 'TR-09',
    'Balıkesir': 'TR-10',
    'Bartın': 'TR-74',
    'Batman': 'TR-72',
    'Bayburt': 'TR-69',
    'Bilecik': 'TR-11',
    'Bingöl': 'TR-12',
    'Bitlis': 'TR-13',
    'Bolu': 'TR-14',
    'Burdur': 'TR-15',
    'Bursa': 'TR-16',
    'Çanakkale': 'TR-17',
    'Çankırı': 'TR-18',
    'Çorum': 'TR-19',
    'Denizli': 'TR-20',
    'Diyarbakır': 'TR-21',
    'Düzce': 'TR-81',
    'Edirne': 'TR-22',
    'Elazığ': 'TR-23',
    'Erzincan': 'TR-24',
    'Erzurum': 'TR-25',
    'Eskişehir': 'TR-26',
    'Gaziantep': 'TR-27',
    'Giresun': 'TR-28',
    'Gümüşhane': 'TR-29',
    'Hakkari': 'TR-30',
    'Hatay': 'TR-31',
    'Iğdır': 'TR-76',
    'Isparta': 'TR-32',
    'İstanbul': 'TR-34',
    'İzmir': 'TR-35',
    'Kahramanmaraş': 'TR-46',
    'Karabük': 'TR-78',
    'Karaman': 'TR-70',
    'Kars': 'TR-36',
    'Kastamonu': 'TR-37',
    'Kayseri': 'TR-38',
    'Kırıkkale': 'TR-71',
    'Kırklareli': 'TR-39',
    'Kırşehir': 'TR-40',
    'Kilis': 'TR-79',
    'Kocaeli': 'TR-41',
    'Konya': 'TR-42',
    'Kütahya': 'TR-43',
    'Malatya': 'TR-44',
    'Manisa': 'TR-45',
    'Mardin': 'TR-72',
    'Mersin': 'TR-33',
    'Muğla': 'TR-48',
    'Muş': 'TR-49',
    'Nevşehir': 'TR-50',
    'Niğde': 'TR-51',
    'Ordu': 'TR-52',
    'Osmaniye': 'TR-80',
    'Rize': 'TR-53',
    'Sakarya': 'TR-54',
    'Samsun': 'TR-55',
    'Siirt': 'TR-56',
    'Sinop': 'TR-57',
    'Sivas': 'TR-58',
    'Şanlıurfa': 'TR-63',
    'Şırnak': 'TR-73',
    'Tekirdağ': 'TR-59',
    'Tokat': 'TR-60',
    'Trabzon': 'TR-61',
    'Tunceli': 'TR-62',
    'Uşak': 'TR-64',
    'Van': 'TR-65',
    'Yalova': 'TR-77',
    'Yozgat': 'TR-66',
    'Zonguldak': 'TR-67',
  },
  TUV: {
    'Funafuti': 'TV-FUN',
    'Nanumanga': 'TV-NMG',
    'Nanumea': 'TV-NIU',
    'Niutao': 'TV-NIT',
    'Nui': 'TV-NIU',
    'Nukufetau': 'TV-NKF',
    'Nukulaelae': 'TV-NKL',
    'Vaitupu': 'TV-VAI',
  },
  TWN: {
    'Changhua': 'TW-CHA',
    'Chiayi': 'TW-CYQ',
    'Hsinchu': 'TW-HSQ',
    'Hualien': 'TW-HUA',
    'Kaohsiung': 'TW-KHH',
    'Keelung': 'TW-KEE',
    'Miaoli': 'TW-MIA',
    'Nantou': 'TW-NAN',
    'New Taipei': 'TW-NWT',
    'Penghu': 'TW-PEN',
    'Pingtung': 'TW-PIF',
    'Taichung': 'TW-TXG',
    'Tainan': 'TW-TNN',
    'Taipei': 'TW-TPE',
    'Taitung': 'TW-TTT',
    'Taoyuan': 'TW-TAO',
    'Yilan': 'TW-ILA',
    'Yunlin': 'TW-YUN',
  },
  TZA: {
    'Arusha': 'TZ-01',
    'Dar es Salaam': 'TZ-02',
    'Dodoma': 'TZ-03',
    'Geita': 'TZ-27',
    'Iringa': 'TZ-04',
    'Kagera': 'TZ-05',
    'Katavi': 'TZ-28',
    'Kigoma': 'TZ-08',
    'Kilimanjaro': 'TZ-09',
    'Lindi': 'TZ-12',
    'Manyara': 'TZ-26',
    'Mara': 'TZ-13',
    'Mbeya': 'TZ-14',
    'Morogoro': 'TZ-16',
    'Mtwara': 'TZ-17',
    'Mwanza': 'TZ-18',
    'Njombe': 'TZ-29',
    'Pemba North': 'TZ-06',
    'Pemba South': 'TZ-10',
    'Pwani': 'TZ-19',
    'Rukwa': 'TZ-20',
    'Ruvuma': 'TZ-21',
    'Shinyanga': 'TZ-22',
    'Simiyu': 'TZ-30',
    'Singida': 'TZ-23',
    'Songwe': 'TZ-31',
    'Tabora': 'TZ-24',
    'Tanga': 'TZ-25',
    'Zanzibar North': 'TZ-07',
    'Zanzibar South and Central': 'TZ-11',
    'Zanzibar Urban/West': 'TZ-15',
  },
  UGA: {
    'Abim': 'UG-314',
    'Adjumani': 'UG-301',
    'Agago': 'UG-322',
    'Alebtong': 'UG-323',
    'Amolatar': 'UG-315',
    'Amudat': 'UG-324',
    'Amuria': 'UG-216',
    'Amuru': 'UG-316',
    'Apac': 'UG-302',
    'Arua': 'UG-303',
    'Budaka': 'UG-217',
    'Bududa': 'UG-223',
    'Bugiri': 'UG-201',
    'Buhweju': 'UG-420',
    'Buikwe': 'UG-117',
    'Bukedea': 'UG-224',
    'Bukomansimbi': 'UG-418',
    'Bukwo': 'UG-320',
    'Bulambuli': 'UG-218',
    'Buliisa': 'UG-401',
    'Bundibugyo': 'UG-401',
    'Bushenyi': 'UG-402',
    'Busia': 'UG-202',
    'Butaleja': 'UG-219',
    'Butambala': 'UG-419',
    'Buvuma': 'UG-118',
    'Buyende': 'UG-225',
    'Central Region': 'UG-C',
    'Dokolo': 'UG-317',
    'Eastern Region': 'UG-E',
    'Gomba': 'UG-421',
    'Gulu': 'UG-304',
    'Hoima': 'UG-403',
    'Ibanda': 'UG-417',
    'Iganga': 'UG-203',
    'Isingiro': 'UG-418',
    'Jinja': 'UG-204',
    'Kaabong': 'UG-325',
    'Kabale': 'UG-404',
    'Kabarole': 'UG-405',
    'Kaberamaido': 'UG-213',
    'Kalangala': 'UG-119',
    'Kaliro': 'UG-220',
    'Kalungu': 'UG-422',
    'Kampala': 'UG-101',
    'Kamuli': 'UG-205',
    'Kamwenge': 'UG-413',
    'Kanungu': 'UG-414',
    'Kapchorwa': 'UG-206',
    'Kasese': 'UG-406',
    'Katakwi': 'UG-207',
    'Kayunga': 'UG-112',
    'Kibale': 'UG-407',
    'Kiboga': 'UG-103',
    'Kibuku': 'UG-227',
    'Kiruhura': 'UG-423',
    'Kiryandongo': 'UG-421',
    'Kisoro': 'UG-408',
    'Kitgum': 'UG-305',
    'Koboko': 'UG-326',
    'Kole': 'UG-318',
    'Kotido': 'UG-327',
    'Kumi': 'UG-208',
    'Kween': 'UG-228',
    'Kyankwanzi': 'UG-429',
    'Kyegegwa': 'UG-415',
    'Kyenjojo': 'UG-409',
    'Lamwo': 'UG-319',
    'Lira': 'UG-306',
    'Luuka': 'UG-229',
    'Luwero': 'UG-104',
    'Lwengo': 'UG-425',
    'Lyantonde': 'UG-426',
    'Manafwa': 'UG-230',
    'Maracha': 'UG-328',
    'Masaka': 'UG-105',
    'Masindi': 'UG-410',
    'Mayuge': 'UG-209',
    'Mbale': 'UG-210',
    'Mbarara': 'UG-411',
    'Mitooma': 'UG-431',
    'Mityana': 'UG-114',
    'Moroto': 'UG-329',
    'Moyo': 'UG-307',
    'Mpigi': 'UG-115',
    'Mubende': 'UG-106',
    'Mukono': 'UG-108',
    'Nakapiripirit': 'UG-331',
    'Nakaseke': 'UG-116',
    'Nakasongola': 'UG-109',
    'Namayingo': 'UG-222',
    'Namisindwa': 'UG-232',
    'Namutumba': 'UG-211',
    'Napak': 'UG-332',
    'Nebbi': 'UG-308',
    'Ngora': 'UG-212',
    'Northern Region': 'UG-N',
    'Ntoroko': 'UG-412',
    'Ntungamo': 'UG-413',
    'Nwoya': 'UG-333',
    'Omoro': 'UG-334',
    'Otuke': 'UG-323',
    'Oyam': 'UG-309',
    'Pader': 'UG-310',
    'Pakwach': 'UG-431',
    'Pallisa': 'UG-213',
    'Rakai': 'UG-107',
    'Rubanda': 'UG-432',
    'Rubirizi': 'UG-429',
    'Rukiga': 'UG-433',
    'Rukungiri': 'UG-414',
    'Sembabule': 'UG-110',
    'Serere': 'UG-214',
    'Sheema': 'UG-415',
    'Sironko': 'UG-215',
    'Soroti': 'UG-216',
    'Ssembabule': 'UG-415',
    'Tororo': 'UG-217',
    'Wakiso': 'UG-111',
    'Western Region': 'UG-W',
    'Yumbe': 'UG-330',
    'Zombo': 'UG-411',
  },
  UKR: {
    'Autonomous Republic of Crimea': 'UA-43',
    'Cherkasy': 'UA-71',
    'Chernihiv': 'UA-74',
    'Chernivtsi': 'UA-77',
    'Dnipropetrovsk': 'UA-12',
    'Donetsk': 'UA-14',
    'Ivano-Frankivsk': 'UA-26',
    'Kharkiv': 'UA-63',
    'Kherson': 'UA-65',
    'Khmelnytskyi': 'UA-68',
    'Kiev': 'UA-30',
    'Kirovohrad': 'UA-35',
    'Kyiv City': 'UA-32',
    'Luhansk': 'UA-09',
    'Lviv': 'UA-46',
    'Mykolaiv': 'UA-48',
    'Odessa': 'UA-51',
    'Poltava': 'UA-53',
    'Rivne': 'UA-56',
    'Sumy': 'UA-59',
    'Ternopil': 'UA-61',
    'Vinnytsia': 'UA-05',
    'Volyn': 'UA-07',
    'Zakarpattia': 'UA-21',
    'Zaporizhia': 'UA-23',
    'Zhytomyr': 'UA-18',
  },
  UMI: {
    'Navassa Island': 'UM-76',
    'Wake Island': 'UM-79',
  },
  URY: {
    'Artigas': 'UY-AR',
    'Canelones': 'UY-CA',
    'Cerro Largo': 'UY-CL',
    'Colonia': 'UY-CO',
    'Durazno': 'UY-DU',
    'Flores': 'UY-FS',
    'Florida': 'UY-FD',
    'Lavalleja': 'UY-LA',
    'Maldonado': 'UY-MA',
    'Montevideo': 'UY-MO',
    'Paysandú': 'UY-PA',
    'Río Negro': 'UY-RN',
    'Rivera': 'UY-RV',
    'Rocha': 'UY-RO',
    'Salto': 'UY-SA',
    'San José': 'UY-SJ',
    'Soriano': 'UY-SO',
    'Tacuarembó': 'UY-TA',
    'Treinta y Tres': 'UY-TT',
  },
  USA: {
    'Alabama': 'US-AL',
    'Alaska': 'US-AK',
    'American Samoa': 'US-AS',
    'Arizona': 'US-AZ',
    'Arkansas': 'US-AR',
    'California': 'US-CA',
    'Colorado': 'US-CO',
    'Connecticut': 'US-CT',
    'Delaware': 'US-DE',
    'District of Columbia': 'US-DC',
    'Florida': 'US-FL',
    'Georgia': 'US-GA',
    'Guam': 'US-GU',
    'Hawaii': 'US-HI',
    'Idaho': 'US-ID',
    'Illinois': 'US-IL',
    'Indiana': 'US-IN',
    'Iowa': 'US-IA',
    'Kansas': 'US-KS',
    'Kentucky': 'US-KY',
    'Louisiana': 'US-LA',
    'Maine': 'US-ME',
    'Maryland': 'US-MD',
    'Massachusetts': 'US-MA',
    'Michigan': 'US-MI',
    'Minnesota': 'US-MN',
    'Mississippi': 'US-MS',
    'Missouri': 'US-MO',
    'Montana': 'US-MT',
    'Nebraska': 'US-NE',
    'Nevada': 'US-NV',
    'New Hampshire': 'US-NH',
    'New Jersey': 'US-NJ',
    'New Mexico': 'US-NM',
    'New York': 'US-NY',
    'North Carolina': 'US-NC',
    'North Dakota': 'US-ND',
    'Northern Mariana Islands': 'US-MP',
    'Ohio': 'US-OH',
    'Oklahoma': 'US-OK',
    'Oregon': 'US-OR',
    'Pennsylvania': 'US-PA',
    'Puerto Rico': 'US-PR',
    'Rhode Island': 'US-RI',
    'South Carolina': 'US-SC',
    'South Dakota': 'US-SD',
    'Tennessee': 'US-TN',
    'Texas': 'US-TX',
    'U.S. Minor Outlying Islands': 'UM-UM',
    'Utah': 'US-UT',
    'Vermont': 'US-VT',
    'Virgin Islands of the U.S.': 'US-VI',
    'Virginia': 'US-VA',
    'Washington': 'US-WA',
    'West Virginia': 'US-WV',
    'Wisconsin': 'US-WI',
    'Wyoming': 'US-WY',
  },
  UZB: {
    'Andijan': 'UZ-AN',
    'Bukhara': 'UZ-BU',
    'Fergana': 'UZ-FA',
    'Jizzakh': 'UZ-JI',
    'Karakalpakstan': 'UZ-QR',
    'Namangan': 'UZ-NG',
    'Navoiy': 'UZ-NW',
    'Qashqadaryo': 'UZ-QA',
    'Samarkand': 'UZ-SA',
    'Sirdaryo': 'UZ-SI',
    'Surxondaryo': 'UZ-SU',
    'Tashkent': 'UZ-TK',
    'Xorazm': 'UZ-XO',
  },
  VAT: {
    'Holy See (Vatican City State)': 'VA-62',
  },
  VCT: {
    'Charlotte': 'VC-01',
    'Grenadines': 'VC-06',
    'Saint Andrew': 'VC-02',
    'Saint David': 'VC-03',
    'Saint George': 'VC-04',
    'Saint Patrick': 'VC-05',
  },
  VEN: {
    'Amazonas': 'VE-Z',
    'Anzoátegui': 'VE-B',
    'Apure': 'VE-C',
    'Aragua': 'VE-D',
    'Barinas': 'VE-E',
    'Bolívar': 'VE-F',
    'Carabobo': 'VE-G',
    'Cojedes': 'VE-H',
    'Delta Amacuro': 'VE-Y',
    'Falcón': 'VE-I',
    'Federal Dependencies': 'VE-W',
    'Guárico': 'VE-J',
    'Lara': 'VE-K',
    'Mérida': 'VE-L',
    'Miranda': 'VE-M',
    'Monagas': 'VE-N',
    'Nueva Esparta': 'VE-O',
    'Portuguesa': 'VE-P',
    'Sucre': 'VE-R',
    'Táchira': 'VE-S',
    'Trujillo': 'VE-T',
    'Vargas': 'VE-X',
    'Yaracuy': 'VE-U',
    'Zulia': 'VE-V',
  },
  VGB: {
    'British Virgin Islands': 'VG-VG',
  },
  VIR: {
    'Saint Croix': 'VI-STX',
    'Saint John': 'VI-STJ',
    'Saint Thomas': 'VI-STM',
  },
  VNM: {
    'An Giang': 'VN-44',
    'Bắc Giang': 'VN-54',
    'Bắc Kạn': 'VN-53',
    'Bạc Liêu': 'VN-55',
    'Bắc Ninh': 'VN-56',
    'Bến Tre': 'VN-50',
    'Bình Định': 'VN-31',
    'Bình Dương': 'VN-57',
    'Bình Phước': 'VN-58',
    'Bình Thuận': 'VN-40',
    'Cà Mau': 'VN-59',
    'Cao Bằng': 'VN-04',
    'Central Highlands': 'VN-26',
    'Da Nang': 'VN-DN',
    'Đắk Lắk': 'VN-33',
    'Đắk Nông': 'VN-72',
    'Điện Biên': 'VN-71',
    'Đồng Nai': 'VN-39',
    'Đồng Tháp': 'VN-45',
    'Gia Lai': 'VN-30',
    'Hà Giang': 'VN-03',
    'Hà Nam': 'VN-63',
    'Hà Nội': 'VN-HN',
    'Hà Tĩnh': 'VN-23',
    'Hải Dương': 'VN-61',
    'Hải Phòng': 'VN-HP',
    'Hậu Giang': 'VN-73',
    'Hòa Bình': 'VN-14',
    'Hưng Yên': 'VN-66',
    'Khánh Hòa': 'VN-34',
    'Kiên Giang': 'VN-47',
    'Kon Tum': 'VN-28',
    'Lai Châu': 'VN-01',
    'Lâm Đồng': 'VN-35',
    'Lạng Sơn': 'VN-09',
    'Lào Cai': 'VN-02',
    'Long An': 'VN-41',
    'Nam Định': 'VN-67',
    'Nghệ An': 'VN-22',
    'Ninh Bình': 'VN-18',
    'Ninh Thuận': 'VN-36',
    'Northwest': 'VN-70',
    'Phú Thọ': 'VN-68',
    'Phú Yên': 'VN-32',
    'Quảng Bình': 'VN-24',
    'Quảng Nam': 'VN-27',
    'Quảng Ngãi': 'VN-29',
    'Quảng Ninh': 'VN-13',
    'Quảng Trị': 'VN-25',
    'Sóc Trăng': 'VN-52',
    'Sơn La': 'VN-05',
    'South Central Coast': 'VN-51',
    'Tây Ninh': 'VN-37',
    'Thái Bình': 'VN-20',
    'Thái Nguyên': 'VN-69',
    'Thanh Hóa': 'VN-21',
    'Thừa Thiên-Huế': 'VN-26',
    'Tiền Giang': 'VN-46',
    'Trà Vinh': 'VN-51',
    'Tuyên Quang': 'VN-07',
    'Vĩnh Long': 'VN-49',
    'Vĩnh Phúc': 'VN-70',
    'Yên Bái': 'VN-06',
  },
  VUT: {
    'Malampa': 'VU-MAP',
    'Penama': 'VU-PAM',
    'Sanma': 'VU-SAM',
    'Shefa': 'VU-SEE',
    'Tafea': 'VU-TAE',
    'Torba': 'VU-TOB',
  },
  WLF: {
    'Wallis and Futuna Islands': 'WF-AL',
  },
  WSM: {
    'A\'ana': 'WS-AA',
    'Aiga-i-le-Tai': 'WS-AL',
    'Atua': 'WS-AT',
    'Fa\'asaleleaga': 'WS-FA',
    'Gaga\'emauga': 'WS-GE',
    'Gagaifomauga': 'WS-GI',
    'Palauli': 'WS-PA',
    'Satupa\'itea': 'WS-SA',
    'Tuamasaga': 'WS-TU',
    'Va\'a-o-Fonoti': 'WS-VF',
    'Vaisigano': 'WS-VS',
  },
  YEM: {
    "'Adan": 'YE-AD',
    "Abyan": 'YE-AB',
    "Ad Dali'": 'YE-DA',
    'Aden': 'YE-AD',
    'Al Bayda': 'YE-BA',
    'Al Hudaydah': 'YE-HU',
    'Al Jawf': 'YE-JA',
    'Al Mahrah': 'YE-MR',
    'Al Mahwit': 'YE-MW',
    'Amran': 'YE-AM',
    'Dhamar': 'YE-DH',
    'Hadhramaut': 'YE-HD',
    'Hajjah': 'YE-HJ',
    'Ibb': 'YE-IB',
    'Lahij': 'YE-LA',
    'Ma\'rib': 'YE-MA',
    'Raymah': 'YE-RA',
    'Sa\'dah': 'YE-SD',
    'Sana\'a': 'YE-SA',
    'Shabwah': 'YE-SH',
    'Ta\'izz': 'YE-TA',
  },
  ZAF: {
    'Eastern Cape': 'ZA-EC',
    'Free State': 'ZA-FS',
    'Gauteng': 'ZA-GT',
    'KwaZulu-Natal': 'ZA-NL',
    'Limpopo': 'ZA-LP',
    'Mpumalanga': 'ZA-MP',
    'North West': 'ZA-NW',
    'Northern Cape': 'ZA-NC',
    'Western Cape': 'ZA-WC',
  },
  ZMB: {
    'Central': 'ZM-02',
    'Copperbelt': 'ZM-08',
    'Eastern': 'ZM-03',
    'Luapula': 'ZM-04',
    'Lusaka': 'ZM-09',
    'Muchinga': 'ZM-10',
    'Northern': 'ZM-05',
    'North-Western': 'ZM-06',
    'Southern': 'ZM-07',
    'Western': 'ZM-01',
  },
  ZWE: {
    'Bulawayo': 'ZW-BU',
    'Harare': 'ZW-HA',
    'Manicaland': 'ZW-MA',
    'Mashonaland Central': 'ZW-MC',
    'Mashonaland East': 'ZW-ME',
    'Mashonaland West': 'ZW-MW',
    'Masvingo': 'ZW-MV',
    'Matabeleland North': 'ZW-MN',
    'Matabeleland South': 'ZW-MS',
    'Midlands': 'ZW-MI',
  },
};



// Countries in alpha-3 code
export enum Countries {
  AFG = 'Afghanistan',
  ALA = 'Aland Islands',
  ALB = 'Albania',
  DZA = 'Algeria',
  ASM = 'American Samoa',
  AND = 'Andorra',
  AGO = 'Angola',
  AIA = 'Anguilla',
  ATA = 'Antarctica',
  ATG = 'Antigua and Barbuda',
  ARG = 'Argentina',
  ARM = 'Armenia',
  ABW = 'Aruba',
  AUS = 'Australia',
  AUT = 'Austria',
  AZE = 'Azerbaijan',
  BHS = 'Bahamas',
  BHR = 'Bahrain',
  BGD = 'Bangladesh',
  BRB = 'Barbados',
  BLR = 'Belarus',
  BEL = 'Belgium',
  BLZ = 'Belize',
  BEN = 'Benin',
  BMU = 'Bermuda',
  BTN = 'Bhutan',
  BOL = 'Bolivia',
  BIH = 'Bosnia and Herzegovina',
  BWA = 'Botswana',
  BVT = 'Bouvet Island',
  BRA = 'Brazil',
  IOT = 'British Indian Ocean Territory',
  BRN = 'Brunei Darussalam',
  BGR = 'Bulgaria',
  BFA = 'Burkina Faso',
  BDI = 'Burundi',
  KHM = 'Cambodia',
  CMR = 'Cameroon',
  CAN = 'Canada',
  CPV = 'Cape Verde',
  CYM = 'Cayman Islands',
  CAF = 'Central African Republic',
  TCD = 'Chad',
  CHL = 'Chile',
  CHN = 'China',
  CXR = 'Christmas Island',
  CCK = 'Cocos Keeling Islands',
  COL = 'Colombia',
  COM = 'Comoros',
  COG = 'Congo',
  COD = 'Congo Democratic Republic',
  COK = 'Cook Islands',
  CRI = 'Costa Rica',
  CIV = "Cote D'Ivoire",
  HRV = 'Croatia',
  CUB = 'Cuba',
  CYP = 'Cyprus',
  CZE = 'CzechRepublic',
  DNK = 'Denmark',
  DJI = 'Djibouti',
  DMA = 'Dominica',
  DOM = 'Dominican Republic',
  ECU = 'Ecuador',
  EGY = 'Egypt',
  SLV = 'El Salvador',
  GNQ = 'Equatorial Guinea',
  ERI = 'Eritrea',
  EST = 'Estonia',
  ETH = 'Ethiopia',
  FLK = 'Falkland Islands',
  FRO = 'Faroe Islands',
  FJI = 'Fiji',
  FIN = 'Finland',
  FRA = 'France',
  GUF = 'French Guiana',
  PYF = 'French Polynesia',
  ATF = 'French Southern Territories',
  GAB = 'Gabon',
  GMB = 'Gambia',
  GEO = 'Georgia',
  DEU = 'Germany',
  GHA = 'Ghana',
  GIB = 'Gibraltar',
  GRC = 'Greece',
  GRL = 'Greenland',
  GRD = 'Grenada',
  GLP = 'Guadeloupe',
  GUM = 'Guam',
  GTM = 'Guatemala',
  GGY = 'Guernsey',
  GIN = 'Guinea',
  GNB = 'Guinea Bissau',
  GUY = 'Guyana',
  HTI = 'Haiti',
  HMD = 'Heard Island Mcdonald Islands',
  VAT = 'Holy See Vatican City State',
  HND = 'Honduras',
  HKG = 'HongKong',
  HUN = 'Hungary',
  ISL = 'Iceland',
  IND = 'India',
  IDN = 'Indonesia',
  IRN = 'Iran',
  IRQ = 'Iraq',
  IRL = 'Ireland',
  IMN = 'Isle Of Man',
  ISR = 'Israel',
  ITA = 'Italy',
  JAM = 'Jamaica',
  JPN = 'Japan',
  JEY = 'Jersey',
  JOR = 'Jordan',
  KAZ = 'Kazakhstan',
  KEN = 'Kenya',
  KIR = 'Kiribati',
  KOR = 'Korea, Republic of',
  PRK = "Korea, Democratic People's Republic of",
  KWT = 'Kuwait',
  KGZ = 'Kyrgyzstan',
  LAO = 'Lao Peoples Democratic Republic',
  LVA = 'Latvia',
  LBN = 'Lebanon',
  LSO = 'Lesotho',
  LBR = 'Liberia',
  LBY = 'Libyan Arab Jamahiriya',
  LIE = 'Liechtenstein',
  LTU = 'Lithuania',
  LUX = 'Luxembourg',
  MAC = 'Macao',
  MDG = 'Madagascar',
  MWI = 'Malawi',
  MYS = 'Malaysia',
  MDV = 'Maldives',
  MLI = 'Mali',
  MLT = 'Malta',
  MHL = 'Marshall Islands',
  MTQ = 'Martinique',
  MRT = 'Mauritania',
  MUS = 'Mauritius',
  MYT = 'Mayotte',
  MEX = 'Mexico',
  FSM = 'Micronesia',
  MDA = 'Moldova',
  MCO = 'Monaco',
  MNG = 'Mongolia',
  MNE = 'Montenegro',
  MSR = 'Montserrat',
  MAR = 'Morocco',
  MOZ = 'Mozambique',
  MMR = 'Myanmar',
  NAM = 'Namibia',
  NRU = 'Nauru',
  NPL = 'Nepal',
  NLD = 'Netherlands',
  NCL = 'New Caledonia',
  NZL = 'New Zealand',
  NIC = 'Nicaragua',
  NER = 'Niger',
  NGA = 'Nigeria',
  NIU = 'Niue',
  NFK = 'Norfolk Island',
  MNP = 'Northern Mariana Islands',
  NOR = 'Norway',
  OMN = 'Oman',
  PAK = 'Pakistan',
  PLW = 'Palau',
  PSE = 'Palestinian Territory',
  PAN = 'Panama',
  PNG = 'Papua New Guinea',
  PRY = 'Paraguay',
  PER = 'Peru',
  PHL = 'Philippines',
  PCN = 'Pitcairn',
  POL = 'Poland',
  PRT = 'Portugal',
  PRI = 'Puerto Rico',
  QAT = 'Qatar',
  MKD = 'Republic of North Macedonia',
  REU = 'Réunion',
  ROU = 'Romania',
  RUS = 'Russian Federation',
  RWA = 'Rwanda',
  BLM = 'Saint Barthelemy',
  SHN = 'Saint Helena',
  KNA = 'Saint Kitts And Nevis',
  LCA = 'Saint Lucia',
  MAF = 'Saint Martin',
  SPM = 'Saint Pierre And Miquelon',
  VCT = 'Saint Vincent And Grenadines',
  WSM = 'Samoa',
  SMR = 'San Marino',
  STP = 'Sao Tome And Principe',
  SAU = 'Saudi Arabia',
  SEN = 'Senegal',
  SRB = 'Serbia',
  SYC = 'Seychelles',
  SLE = 'Sierra Leone',
  SGP = 'Singapore',
  SXM = 'Sint Maarten (Dutch part)',
  SVK = 'Slovakia',
  SVN = 'Slovenia',
  SLB = 'Solomon Islands',
  SOM = 'Somalia',
  ZAF = 'South Africa',
  SGS = 'South Georgia And Sandwich Island',
  SSD = 'South Sudan',
  ESP = 'Spain',
  LKA = 'Sri Lanka',
  SDN = 'Sudan',
  SUR = 'Suriname',
  SJM = 'Svalbard And Jan Mayen',
  SWZ = 'Swaziland',
  SWE = 'Sweden',
  CHE = 'Switzerland',
  SYR = 'Syrian Arab Republic',
  TWN = 'Taiwan',
  TJK = 'Tajikistan',
  TZA = 'Tanzania',
  THA = 'Thailand',
  TLS = 'Timor-Leste',
  TGO = 'Togo',
  TKL = 'Tokelau',
  TON = 'Tonga',
  TTO = 'Trinidad And Tobago',
  TUN = 'Tunisia',
  TUR = 'Turkey',
  TKM = 'Turkmenistan',
  TCA = 'Turks And Caicos Islands',
  TUV = 'Tuvalu',
  UGA = 'Uganda',
  UKR = 'Ukraine',
  ARE = 'United Arab Emirates',
  GBR = 'United Kingdom',
  UMI = 'United States Outlying Islands',
  USA = 'United States',
  URY = 'Uruguay',
  UZB = 'Uzbekistan',
  VUT = 'Vanuatu',
  VEN = 'Venezuela',
  VNM = 'Vietnam',
  VGB = 'Virgin Islands British',
  VIR = 'Virgin Islands US',
  WLF = 'Wallis And Futuna',
  ESH = 'Western Sahara',
  YEM = 'Yemen',
  ZMB = 'Zambia',
  ZWE = 'Zimbabwe',
}

export enum CountriesAlphaTwo {
  AF = 'Afghanistan',
  AX = 'Aland Islands',
  AL = 'Albania',
  DZ = 'Algeria',
  AS = 'American Samoa',
  AD = 'Andorra',
  AO = 'Angola',
  AI = 'Anguilla',
  AQ = 'Antarctica',
  AG = 'Antigua and Barbuda',
  AR = 'Argentina',
  AM = 'Armenia',
  AW = 'Aruba',
  AU = 'Australia',
  AT = 'Austria',
  AZ = 'Azerbaijan',
  BS = 'Bahamas',
  BH = 'Bahrain',
  BD = 'Bangladesh',
  BB = 'Barbados',
  BY = 'Belarus',
  BE = 'Belgium',
  BZ = 'Belize',
  BJ = 'Benin',
  BM = 'Bermuda',
  BT = 'Bhutan',
  BO = 'Bolivia',
  BA = 'Bosnia and Herzegovina',
  BW = 'Botswana',
  BV = 'Bouvet Island',
  BR = 'Brazil',
  IO = 'British Indian Ocean Territory',
  BN = 'Brunei Darussalam',
  BG = 'Bulgaria',
  BF = 'Burkina Faso',
  BI = 'Burundi',
  KH = 'Cambodia',
  CM = 'Cameroon',
  CA = 'Canada',
  CV = 'Cape Verde',
  KY = 'Cayman Islands',
  CF = 'Central African Republic',
  TD = 'Chad',
  CL = 'Chile',
  CN = 'China',
  CX = 'Christmas Island',
  CC = 'Cocos Keeling Islands',
  CO = 'Colombia',
  KM = 'Comoros',
  CG = 'Congo',
  CD = 'Congo Democratic Republic',
  CK = 'Cook Islands',
  CR = 'Costa Rica',
  CI = "Cote D'Ivoire",
  HR = 'Croatia',
  CU = 'Cuba',
  CY = 'Cyprus',
  CZ = 'Czech Republic',
  DK = 'Denmark',
  DJ = 'Djibouti',
  DM = 'Dominica',
  DO = 'Dominican Republic',
  EC = 'Ecuador',
  EG = 'Egypt',
  SV = 'El Salvador',
  GQ = 'Equatorial Guinea',
  ER = 'Eritrea',
  EE = 'Estonia',
  ET = 'Ethiopia',
  FK = 'Falkland Islands',
  FO = 'Faroe Islands',
  FJ = 'Fiji',
  FI = 'Finland',
  FR = 'France',
  GF = 'French Guiana',
  PF = 'French Polynesia',
  TF = 'French Southern Territories',
  GA = 'Gabon',
  GM = 'Gambia',
  GE = 'Georgia',
  DE = 'Germany',
  GH = 'Ghana',
  GI = 'Gibraltar',
  GR = 'Greece',
  GL = 'Greenland',
  GD = 'Grenada',
  GP = 'Guadeloupe',
  GU = 'Guam',
  GT = 'Guatemala',
  GG = 'Guernsey',
  GN = 'Guinea',
  GW = 'Guinea Bissau',
  GY = 'Guyana',
  HT = 'Haiti',
  HM = 'Heard Island Mcdonald Islands',
  VA = 'Holy See Vatican City State',
  HN = 'Honduras',
  HK = 'HongKong',
  HU = 'Hungary',
  IS = 'Iceland',
  IN = 'India',
  ID = 'Indonesia',
  IR = 'Iran',
  IQ = 'Iraq',
  IE = 'Ireland',
  IM = 'Isle Of Man',
  IL = 'Israel',
  IT = 'Italy',
  JM = 'Jamaica',
  JP = 'Japan',
  JE = 'Jersey',
  JO = 'Jordan',
  KZ = 'Kazakhstan',
  KE = 'Kenya',
  KI = 'Kiribati',
  KR = 'Korea, Republic of',
  KP = "Korea, Democratic People's Republic of",
  KW = 'Kuwait',
  KG = 'Kyrgyzstan',
  LA = 'Lao Peoples Democratic Republic',
  LV = 'Latvia',
  LB = 'Lebanon',
  LS = 'Lesotho',
  LR = 'Liberia',
  LY = 'Libyan Arab Jamahiriya',
  LI = 'Liechtenstein',
  LT = 'Lithuania',
  LU = 'Luxembourg',
  MO = 'Macao',
  MG = 'Madagascar',
  MW = 'Malawi',
  MY = 'Malaysia',
  MV = 'Maldives',
  ML = 'Mali',
  MT = 'Malta',
  MH = 'Marshall Islands',
  MQ = 'Martinique',
  MR = 'Mauritania',
  MU = 'Mauritius',
  YT = 'Mayotte',
  MX = 'Mexico',
  FM = 'Micronesia',
  MD = 'Moldova',
  MC = 'Monaco',
  MN = 'Mongolia',
  ME = 'Montenegro',
  MS = 'Montserrat',
  MA = 'Morocco',
  MZ = 'Mozambique',
  MM = 'Myanmar',
  NA = 'Namibia',
  NR = 'Nauru',
  NP = 'Nepal',
  NL = 'Netherlands',
  NC = 'New Caledonia',
  NZ = 'New Zealand',
  NI = 'Nicaragua',
  NE = 'Niger',
  NG = 'Nigeria',
  NU = 'Niue',
  NF = 'Norfolk Island',
  MP = 'Northern Mariana Islands',
  NO = 'Norway',
  OM = 'Oman',
  PK = 'Pakistan',
  PW = 'Palau',
  PS = 'Palestinian Territory',
  PA = 'Panama',
  PG = 'Papua New Guinea',
  PY = 'Paraguay',
  PE = 'Peru',
  PH = 'Philippines',
  PN = 'Pitcairn',
  PL = 'Poland',
  PT = 'Portugal',
  PR = 'Puerto Rico',
  QA = 'Qatar',
  MK = 'Republic of North Macedonia',
  RE = 'Réunion',
  RO = 'Romania',
  RU = 'Russian Federation',
  RW = 'Rwanda',
  BL = 'Saint Barthelemy',
  SH = 'Saint Helena',
  KN = 'Saint Kitts And Nevis',
  LC = 'Saint Lucia',
  MF = 'Saint Martin',
  PM = 'Saint Pierre And Miquelon',
  VC = 'Saint Vincent And Grenadines',
  WS = 'Samoa',
  SM = 'San Marino',
  ST = 'Sao Tome And Principe',
  SA = 'Saudi Arabia',
  SN = 'Senegal',
  RS = 'Serbia',
  SC = 'Seychelles',
  SL = 'Sierra Leone',
  SG = 'Singapore',
  SX = 'Sint Maarten (Dutch part)',
  SK = 'Slovakia',
  SI = 'Slovenia',
  SB = 'Solomon Islands',
  SO = 'Somalia',
  ZA = 'South Africa',
  GS = 'South Georgia And Sandwich Island',
  SS = 'South Sudan',
  ES = 'Spain',
  LK = 'Sri Lanka',
  SD = 'Sudan',
  SR = 'Suriname',
  SJ = 'Svalbard And Jan Mayen',
  SZ = 'Swaziland',
  SE = 'Sweden',
  CH = 'Switzerland',
  SY = 'Syrian Arab Republic',
  TW = 'Taiwan',
  TJ = 'Tajikistan',
  TZ = 'Tanzania',
  TH = 'Thailand',
  TL = 'Timor-Leste',
  TG = 'Togo',
  TK = 'Tokelau',
  TO = 'Tonga',
  TT = 'Trinidad And Tobago',
  TN = 'Tunisia',
  TR = 'Turkey',
  TM = 'Turkmenistan',
  TC = 'Turks And Caicos Islands',
  TV = 'Tuvalu',
  UG = 'Uganda',
  UA = 'Ukraine',
  AE = 'United Arab Emirates',
  GB = 'United Kingdom',
  UM = 'United States Outlying Islands',
  US = 'United States',
  UY = 'Uruguay',
  UZ = 'Uzbekistan',
  VU = 'Vanuatu',
  VE = 'Venezuela',
  VN = 'Vietnam',
  VG = 'Virgin Islands British',
  VI = 'Virgin Islands US',
  WF = 'Wallis And Futuna',
  EH = 'Western Sahara',
  YE = 'Yemen',
  ZM = 'Zambia',
  ZW = 'Zimbabwe',
}

//Countries in alpha-3 code using name as the key (for addresses that come from the back using name instead of code)
// Enum de países con clave como nombre del país y valor como código alpha-3
export enum CountriesByName {
  'Afghanistan' = 'AFG',
  'Aland Islands' = 'ALA',
  'Albania' = 'ALB',
  'Algeria' = 'DZA',
  'American Samoa' = 'ASM',
  'Andorra' = 'AND',
  'Angola' = 'AGO',
  'Anguilla' = 'AIA',
  'Antarctica' = 'ATA',
  'Antigua and Barbuda' = 'ATG',
  'Argentina' = 'ARG',
  'Armenia' = 'ARM',
  'Aruba' = 'ABW',
  'Australia' = 'AUS',
  'Austria' = 'AUT',
  'Azerbaijan' = 'AZE',
  'Bahamas' = 'BHS',
  'Bahrain' = 'BHR',
  'Bangladesh' = 'BGD',
  'Barbados' = 'BRB',
  'Belarus' = 'BLR',
  'Belgium' = 'BEL',
  'Belize' = 'BLZ',
  'Benin' = 'BEN',
  'Bermuda' = 'BMU',
  'Bhutan' = 'BTN',
  'Bolivia' = 'BOL',
  'Bosnia and Herzegovina' = 'BIH',
  'Botswana' = 'BWA',
  'Bouvet Island' = 'BVT',
  'Brazil' = 'BRA',
  'British Indian Ocean Territory' = 'IOT',
  'Brunei Darussalam' = 'BRN',
  'Bulgaria' = 'BGR',
  'Burkina Faso' = 'BFA',
  'Burundi' = 'BDI',
  'Cambodia' = 'KHM',
  'Cameroon' = 'CMR',
  'Canada' = 'CAN',
  'Cape Verde' = 'CPV',
  'Cayman Islands' = 'CYM',
  'Central African Republic' = 'CAF',
  'Chad' = 'TCD',
  'Chile' = 'CHL',
  'China' = 'CHN',
  'Christmas Island' = 'CXR',
  'Cocos Keeling Islands' = 'CCK',
  'Colombia' = 'COL',
  'Comoros' = 'COM',
  'Congo' = 'COG',
  'Congo Democratic Republic' = 'COD',
  'Cook Islands' = 'COK',
  'Costa Rica' = 'CRI',
  'Cote D\'Ivoire' = 'CIV',
  'Croatia' = 'HRV',
  'Cuba' = 'CUB',
  'Cyprus' = 'CYP',
  'Czech Republic' = 'CZE',
  'Denmark' = 'DNK',
  'Djibouti' = 'DJI',
  'Dominica' = 'DMA',
  'Dominican Republic' = 'DOM',
  'Ecuador' = 'ECU',
  'Egypt' = 'EGY',
  'El Salvador' = 'SLV',
  'Equatorial Guinea' = 'GNQ',
  'Eritrea' = 'ERI',
  'Estonia' = 'EST',
  'Ethiopia' = 'ETH',
  'Falkland Islands' = 'FLK',
  'Faroe Islands' = 'FRO',
  'Fiji' = 'FJI',
  'Finland' = 'FIN',
  'France' = 'FRA',
  'French Guiana' = 'GUF',
  'French Polynesia' = 'PYF',
  'French Southern Territories' = 'ATF',
  'Gabon' = 'GAB',
  'Gambia' = 'GMB',
  'Georgia' = 'GEO',
  'Germany' = 'DEU',
  'Ghana' = 'GHA',
  'Gibraltar' = 'GIB',
  'Greece' = 'GRC',
  'Greenland' = 'GRL',
  'Grenada' = 'GRD',
  'Guadeloupe' = 'GLP',
  'Guam' = 'GUM',
  'Guatemala' = 'GTM',
  'Guernsey' = 'GGY',
  'Guinea' = 'GIN',
  'Guinea Bissau' = 'GNB',
  'Guyana' = 'GUY',
  'Haiti' = 'HTI',
  'Heard Island Mcdonald Islands' = 'HMD',
  'Holy See Vatican City State' = 'VAT',
  'Honduras' = 'HND',
  'Hong Kong' = 'HKG',
  'Hungary' = 'HUN',
  'Iceland' = 'ISL',
  'India' = 'IND',
  'Indonesia' = 'IDN',
  'Iran' = 'IRN',
  'Iraq' = 'IRQ',
  'Ireland' = 'IRL',
  'Isle Of Man' = 'IMN',
  'Israel' = 'ISR',
  'Italy' = 'ITA',
  'Jamaica' = 'JAM',
  'Japan' = 'JPN',
  'Jersey' = 'JEY',
  'Jordan' = 'JOR',
  'Kazakhstan' = 'KAZ',
  'Kenya' = 'KEN',
  'Kiribati' = 'KIR',
  'Korea, Republic of' = 'KOR',
  'Korea, Democratic People\'s Republic of' = 'PRK',
  'Kuwait' = 'KWT',
  'Kyrgyzstan' = 'KGZ',
  'Lao People\'s Democratic Republic' = 'LAO',
  'Latvia' = 'LVA',
  'Lebanon' = 'LBN',
  'Lesotho' = 'LSO',
  'Liberia' = 'LBR',
  'Libyan Arab Jamahiriya' = 'LBY',
  'Liechtenstein' = 'LIE',
  'Lithuania' = 'LTU',
  'Luxembourg' = 'LUX',
  'Macao' = 'MAC',
  'Madagascar' = 'MDG',
  'Malawi' = 'MWI',
  'Malaysia' = 'MYS',
  'Maldives' = 'MDV',
  'Mali' = 'MLI',
  'Malta' = 'MLT',
  'Marshall Islands' = 'MHL',
  'Martinique' = 'MTQ',
  'Mauritania' = 'MRT',
  'Mauritius' = 'MUS',
  'Mayotte' = 'MYT',
  'Mexico' = 'MEX',
  'Micronesia' = 'FSM',
  'Moldova' = 'MDA',
  'Monaco' = 'MCO',
  'Mongolia' = 'MNG',
  'Montenegro' = 'MNE',
  'Montserrat' = 'MSR',
  'Morocco' = 'MAR',
  'Mozambique' = 'MOZ',
  'Myanmar' = 'MMR',
  'Namibia' = 'NAM',
  'Nauru' = 'NRU',
  'Nepal' = 'NPL',
  'Netherlands' = 'NLD',
  'New Caledonia' = 'NCL',
  'New Zealand' = 'NZL',
  'Nicaragua' = 'NIC',
  'Niger' = 'NER',
  'Nigeria' = 'NGA',
  'Niue' = 'NIU',
  'Norfolk Island' = 'NFK',
  'Northern Mariana Islands' = 'MNP',
  'Norway' = 'NOR',
  'Oman' = 'OMN',
  'Pakistan' = 'PAK',
  'Palau' = 'PLW',
  'Palestinian Territory' = 'PSE',
  'Panama' = 'PAN',
  'Papua New Guinea' = 'PNG',
  'Paraguay' = 'PRY',
  'Peru' = 'PER',
  'Philippines' = 'PHL',
  'Pitcairn' = 'PCN',
  'Poland' = 'POL',
  'Portugal' = 'PRT',
  'Puerto Rico' = 'PRI',
  'Qatar' = 'QAT',
  'Republic of North Macedonia' = 'MKD',
  'Reunion' = 'REU',
  'Romania' = 'ROU',
  'Russian Federation' = 'RUS',
  'Rwanda' = 'RWA',
  'Saint Barthelemy' = 'BLM',
  'Saint Helena' = 'SHN',
  'Saint Kitts And Nevis' = 'KNA',
  'Saint Lucia' = 'LCA',
  'Saint Martin' = 'MAF',
  'Saint Pierre And Miquelon' = 'SPM',
  'Saint Vincent And Grenadines' = 'VCT',
  'Samoa' = 'WSM',
  'San Marino' = 'SMR',
  'Sao Tome And Principe' = 'STP',
  'Saudi Arabia' = 'SAU',
  'Senegal' = 'SEN',
  'Serbia' = 'SRB',
  'Seychelles' = 'SYC',
  'Sierra Leone' = 'SLE',
  'Singapore' = 'SGP',
  'Sint Maarten (Dutch part)' = 'SXM',
  'Slovakia' = 'SVK',
  'Slovenia' = 'SVN',
  'Solomon Islands' = 'SLB',
  'Somalia' = 'SOM',
  'South Africa' = 'ZAF',
  'South Georgia And Sandwich Island' = 'SGS',
  'South Sudan' = 'SSD',
  'Spain' = 'ESP',
  'Sri Lanka' = 'LKA',
  'Sudan' = 'SDN',
  'Suriname' = 'SUR',
  'Svalbard And Jan Mayen' = 'SJM',
  'Swaziland' = 'SWZ',
  'Sweden' = 'SWE',
  'Switzerland' = 'CHE',
  'Syrian Arab Republic' = 'SYR',
  'Taiwan' = 'TWN',
  'Tajikistan' = 'TJK',
  'Tanzania' = 'TZA',
  'Thailand' = 'THA',
  'Timor-Leste' = 'TLS',
  'Togo' = 'TGO',
  'Tokelau' = 'TKL',
  'Tonga' = 'TON',
  'Trinidad And Tobago' = 'TTO',
  'Tunisia' = 'TUN',
  'Turkey' = 'TUR',
  'Turkmenistan' = 'TKM',
  'Turks And Caicos Islands' = 'TCA',
  'Tuvalu' = 'TUV',
  'Uganda' = 'UGA',
  'Ukraine' = 'UKR',
  'United Arab Emirates' = 'ARE',
  'United Kingdom' = 'GBR',
  'United States Outlying Islands' = 'UMI',
  'United States' = 'USA',
  'Uruguay' = 'URY',
  'Uzbekistan' = 'UZB',
  'Vanuatu' = 'VUT',
  'Venezuela' = 'VEN',
  'Vietnam' = 'VNM',
  'Virgin Islands British' = 'VGB',
  'Virgin Islands US' = 'VIR',
  'Wallis And Futuna' = 'WLF',
  'Western Sahara' = 'ESH',
  'Yemen' = 'YEM',
  'Zambia' = 'ZMB',
  'Zimbabwe' = 'ZWE',
}


// https://datatracker.ietf.org/doc/html/rfc7231#section-6
export enum HttpStatusCode {
  Ok = 200,
  Created = 201,
  NoContent = 204,
  NotFound = 404,
}


export enum CardsQueryParamsHeaders {
  CARDHOLDER_ID = 'cardholder',
  CARDHOLDER_PARENT_ID = 'cardholder_parent',
  OWNERSHIP_LEVEL = 'ownership_level',
  CARD_PARENT= 'card_parent'
}

export enum SettlementType {
  INTERNATIONAL, DOMESTIC
}

export const CONTACT_CENTER_REASONS = [
  "Balance",
  "Transacciones",
  "Cambios de estado",
  "Otros"
]